/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223);
	module.exports = __webpack_require__(270);


/***/ },
/* 1 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @module FactoryMaker
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});var FactoryMaker=(function(){var instance=undefined;var extensions=[];var singletonContexts=[];var singletonFactories={};var classFactories={};function extend(name,childInstance,override,context){var extensionContext=getExtensionContext(context);if(!extensionContext[name] && childInstance){extensionContext[name] = {instance:childInstance,override:override};}} /**
	     * Use this method from your extended object.  this.factory is injected into your object.
	     * this.factory.getSingletonInstance(this.context, 'VideoModel')
	     * will return the video model for use in the extended object.
	     *
	     * @param {Object} context - injected into extended object as this.context
	     * @param {string} className - string name found in all dash.js objects
	     * with name __dashjs_factory_name Will be at the bottom. Will be the same as the object's name.
	     * @returns {*} Context aware instance of specified singleton name.
	     * @memberof module:FactoryMaker
	     * @instance
	     */function getSingletonInstance(context,className){for(var i in singletonContexts) {var obj=singletonContexts[i];if(obj.context === context && obj.name === className){return obj.instance;}}return null;} /**
	     * Use this method to add an singleton instance to the system.  Useful for unit testing to mock objects etc.
	     *
	     * @param {Object} context
	     * @param {string} className
	     * @param {Object} instance
	     * @memberof module:FactoryMaker
	     * @instance
	     */function setSingletonInstance(context,className,instance){for(var i in singletonContexts) {var obj=singletonContexts[i];if(obj.context === context && obj.name === className){singletonContexts[i].instance = instance;return;}}singletonContexts.push({name:className,context:context,instance:instance});} /*------------------------------------------------------------------------------------------*/ // Factories storage Management
	/*------------------------------------------------------------------------------------------*/function getFactoryByName(name,factoriesArray){return factoriesArray[name];}function updateFactory(name,factory,factoriesArray){if(name in factoriesArray){factoriesArray[name] = factory;}} /*------------------------------------------------------------------------------------------*/ // Class Factories Management
	/*------------------------------------------------------------------------------------------*/function updateClassFactory(name,factory){updateFactory(name,factory,classFactories);}function getClassFactoryByName(name){return getFactoryByName(name,classFactories);}function getClassFactory(classConstructor){var factory=getFactoryByName(classConstructor.__dashjs_factory_name,classFactories);if(!factory){factory = function(context){if(context === undefined){context = {};}return {create:function create(){return merge(classConstructor.__dashjs_factory_name,classConstructor.apply({context:context},arguments),context,arguments);}};};classFactories[classConstructor.__dashjs_factory_name] = factory; // store factory
	}return factory;} /*------------------------------------------------------------------------------------------*/ // Singleton Factory MAangement
	/*------------------------------------------------------------------------------------------*/function updateSingletonFactory(name,factory){updateFactory(name,factory,singletonFactories);}function getSingletonFactoryByName(name){return getFactoryByName(name,singletonFactories);}function getSingletonFactory(classConstructor){var factory=getFactoryByName(classConstructor.__dashjs_factory_name,singletonFactories);if(!factory){factory = function(context){var instance=undefined;if(context === undefined){context = {};}return {getInstance:function getInstance(){ // If we don't have an instance yet check for one on the context
	if(!instance){instance = getSingletonInstance(context,classConstructor.__dashjs_factory_name);} // If there's no instance on the context then create one
	if(!instance){instance = merge(classConstructor.__dashjs_factory_name,classConstructor.apply({context:context},arguments),context,arguments);singletonContexts.push({name:classConstructor.__dashjs_factory_name,context:context,instance:instance});}return instance;}};};singletonFactories[classConstructor.__dashjs_factory_name] = factory; // store factory
	}return factory;}function merge(name,classConstructor,context,args){ // Add getClassName function to class instance prototype (used by Debug)
	classConstructor.getClassName = function(){return name;};var extensionContext=getExtensionContext(context);var extensionObject=extensionContext[name];if(extensionObject){var extension=extensionObject.instance;if(extensionObject.override){ //Override public methods in parent but keep parent.
	extension = extension.apply({context:context,factory:instance,parent:classConstructor},args);for(var prop in extension) {if(classConstructor.hasOwnProperty(prop)){classConstructor[prop] = extension[prop];}}}else { //replace parent object completely with new object. Same as dijon.
	return extension.apply({context:context,factory:instance},args);}}return classConstructor;}function getExtensionContext(context){var extensionContext=undefined;extensions.forEach(function(obj){if(obj === context){extensionContext = obj;}});if(!extensionContext){extensions.push(context);extensionContext = context;}return extensionContext;}instance = {extend:extend,getSingletonInstance:getSingletonInstance,setSingletonInstance:setSingletonInstance,getSingletonFactory:getSingletonFactory,getSingletonFactoryByName:getSingletonFactoryByName,updateSingletonFactory:updateSingletonFactory,getClassFactory:getClassFactory,getClassFactoryByName:getClassFactoryByName,updateClassFactory:updateClassFactory};return instance;})();exports["default"] = FactoryMaker;module.exports = exports["default"];
	//# sourceMappingURL=FactoryMaker.js.map


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(51);


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _FactoryMaker=__webpack_require__(1);var _FactoryMaker2=_interopRequireDefault(_FactoryMaker);var EVENT_PRIORITY_LOW=0;var EVENT_PRIORITY_HIGH=5000;function EventBus(){var handlers={};function on(type,listener,scope){var priority=arguments.length <= 3 || arguments[3] === undefined?EVENT_PRIORITY_LOW:arguments[3];if(!type){throw new Error('event type cannot be null or undefined');}if(!listener || typeof listener !== 'function'){throw new Error('listener must be a function: ' + listener);}if(getHandlerIdx(type,listener,scope) >= 0)return;handlers[type] = handlers[type] || [];var handler={callback:listener,scope:scope,priority:priority};var inserted=handlers[type].some(function(item,idx){if(item && priority > item.priority){handlers[type].splice(idx,0,handler);return true;}});if(!inserted){handlers[type].push(handler);}}function off(type,listener,scope){if(!type || !listener || !handlers[type])return;var idx=getHandlerIdx(type,listener,scope);if(idx < 0)return;handlers[type][idx] = null;}function trigger(type,payload){if(!type || !handlers[type])return;payload = payload || {};if(payload.hasOwnProperty('type'))throw new Error('\'type\' is a reserved word for event dispatching');payload.type = type;handlers[type] = handlers[type].filter(function(item){return item;});handlers[type].forEach(function(handler){return handler && handler.callback.call(handler.scope,payload);});}function getHandlerIdx(type,listener,scope){var idx=-1;if(!handlers[type])return idx;handlers[type].some(function(item,index){if(item && item.callback === listener && (!scope || scope === item.scope)){idx = index;return true;}});return idx;}function reset(){handlers = {};}var instance={on:on,off:off,trigger:trigger,reset:reset};return instance;}EventBus.__dashjs_factory_name = 'EventBus';var factory=_FactoryMaker2['default'].getSingletonFactory(EventBus);factory.EVENT_PRIORITY_LOW = EVENT_PRIORITY_LOW;factory.EVENT_PRIORITY_HIGH = EVENT_PRIORITY_HIGH;_FactoryMaker2['default'].updateSingletonFactory(EventBus.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=EventBus.js.map


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _CoreEvents2=__webpack_require__(303);var _CoreEvents3=_interopRequireDefault(_CoreEvents2);var Events=(function(_CoreEvents){_inherits(Events,_CoreEvents);function Events(){_classCallCheck(this,Events);_get(Object.getPrototypeOf(Events.prototype),'constructor',this).apply(this,arguments);}return Events;})(_CoreEvents3['default']);var events=new Events();exports['default'] = events;module.exports = exports['default'];
	//# sourceMappingURL=Events.js.map


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _EventBus=__webpack_require__(4);var _EventBus2=_interopRequireDefault(_EventBus);var _eventsEvents=__webpack_require__(5);var _eventsEvents2=_interopRequireDefault(_eventsEvents);var _FactoryMaker=__webpack_require__(1);var _FactoryMaker2=_interopRequireDefault(_FactoryMaker); /**
	 * @module Debug
	 */function Debug(){var context=this.context;var eventBus=(0,_EventBus2['default'])(context).getInstance();var instance=undefined,logToBrowserConsole=undefined,showLogTimestamp=undefined,showCalleeName=undefined,startTime=undefined;function setup(){logToBrowserConsole = true;showLogTimestamp = true;showCalleeName = false;startTime = new Date().getTime();} /**
	     * Prepends a timestamp in milliseconds to each log message.
	     * @param {boolean} value Set to true if you want to see a timestamp in each log message.
	     * @default false
	     * @memberof module:Debug
	     * @instance
	     */function setLogTimestampVisible(value){showLogTimestamp = value;} /**
	     * Prepends the callee object name, and media type if available, to each log message.
	     * @param {boolean} value Set to true if you want to see the callee object name and media type in each log message.
	     * @default false
	     * @memberof module:Debug
	     * @instance
	     */function setCalleeNameVisible(value){showCalleeName = value;} /**
	     * Toggles logging to the browser's javascript console.  If you set to false you will still receive a log event with the same message.
	     * @param {boolean} value Set to false if you want to turn off logging to the browser's console.
	     * @default true
	     * @memberof module:Debug
	     * @instance
	     */function setLogToBrowserConsole(value){logToBrowserConsole = value;} /**
	     * Use this method to get the state of logToBrowserConsole.
	     * @returns {boolean} The current value of logToBrowserConsole
	     * @memberof module:Debug
	     * @instance
	     */function getLogToBrowserConsole(){return logToBrowserConsole;} /**
	     * This method will allow you send log messages to either the browser's console and/or dispatch an event to capture at the media player level.
	     * @param {...*} arguments The message you want to log. The Arguments object is supported for this method so you can send in comma separated logging items.
	     * @memberof module:Debug
	     * @instance
	     */function log(){var message='';var logTime=null;if(showLogTimestamp){logTime = new Date().getTime();message += '[' + (logTime - startTime) + ']';}if(showCalleeName && this && this.getClassName){message += '[' + this.getClassName() + ']';if(this.getType){message += '[' + this.getType() + ']';}}if(message.length > 0){message += ' ';}Array.apply(null,arguments).forEach(function(item){message += item + ' ';});if(logToBrowserConsole){console.log(message);}eventBus.trigger(_eventsEvents2['default'].LOG,{message:message});}instance = {log:log,setLogTimestampVisible:setLogTimestampVisible,setCalleeNameVisible:setCalleeNameVisible,setLogToBrowserConsole:setLogToBrowserConsole,getLogToBrowserConsole:getLogToBrowserConsole};setup();return instance;}Debug.__dashjs_factory_name = 'Debug';exports['default'] = _FactoryMaker2['default'].getSingletonFactory(Debug);module.exports = exports['default'];
	//# sourceMappingURL=Debug.js.map


/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 8 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * Constants declaration
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var Constants=(function(){_createClass(Constants,[{key:'init',value:function init(){this.STREAM = 'stream';this.VIDEO = 'video';this.AUDIO = 'audio';this.TEXT = 'text';this.FRAGMENTED_TEXT = 'fragmentedText';this.EMBEDDED_TEXT = 'embeddedText';this.MUXED = 'muxed';this.IMAGE = 'image';this.LOCATION = 'Location';this.INITIALIZE = 'initialize';this.TEXT_SHOWING = 'showing';this.TEXT_HIDDEN = 'hidden';this.CC1 = 'CC1';this.CC3 = 'CC3';this.STPP = 'stpp';this.TTML = 'ttml';this.VTT = 'vtt';this.WVTT = 'wvtt';this.UTF8 = 'utf-8';this.SUGGESTED_PRESENTATION_DELAY = 'suggestedPresentationDelay';this.SCHEME_ID_URI = 'schemeIdUri';this.START_TIME = 'starttime';this.ABR_STRATEGY_DYNAMIC = 'abrDynamic';this.ABR_STRATEGY_BOLA = 'abrBola';this.ABR_STRATEGY_THROUGHPUT = 'abrThroughput';this.MOVING_AVERAGE_SLIDING_WINDOW = 'slidingWindow';this.MOVING_AVERAGE_EWMA = 'ewma';}}]);function Constants(){_classCallCheck(this,Constants);this.init();}return Constants;})();var constants=new Constants();exports['default'] = constants;module.exports = exports['default'];
	//# sourceMappingURL=Constants.js.map


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(21);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 10 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var DOMProperty = __webpack_require__(47);
	var ReactDOMComponentFlags = __webpack_require__(175);
	
	var invariant = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 12 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(485)();
	}


/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    DOMAIN: 'https://www.theholyroad.org',
	    IMAGE_FOLDER: '/images/',
	    STORY_URL: '/artikel/'
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 16 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc This Object holds reference to the HTTPRequest for manifest, fragment and xlink loading.
	 * Members which are not defined in ISO23009-1 Annex D should be prefixed by a _ so that they are ignored
	 * by Metrics Reporting code.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var HTTPRequest= /**
	     * @class
	     */function HTTPRequest(){_classCallCheck(this,HTTPRequest); /**
	         * Identifier of the TCP connection on which the HTTP request was sent.
	         * @public
	         */this.tcpid = null; /**
	         * This is an optional parameter and should not be included in HTTP request/response transactions for progressive download.
	         * The type of the request:
	         * - MPD
	         * - XLink expansion
	         * - Initialization Fragment
	         * - Index Fragment
	         * - Media Fragment
	         * - Bitstream Switching Fragment
	         * - other
	         * @public
	         */this.type = null; /**
	         * The original URL (before any redirects or failures)
	         * @public
	         */this.url = null; /**
	         * The actual URL requested, if different from above
	         * @public
	         */this.actualurl = null; /**
	         * The contents of the byte-range-spec part of the HTTP Range header.
	         * @public
	         */this.range = null; /**
	         * Real-Time | The real time at which the request was sent.
	         * @public
	         */this.trequest = null; /**
	         * Real-Time | The real time at which the first byte of the response was received.
	         * @public
	         */this.tresponse = null; /**
	         * The HTTP response code.
	         * @public
	         */this.responsecode = null; /**
	         * The duration of the throughput trace intervals (ms), for successful requests only.
	         * @public
	         */this.interval = null; /**
	         * Throughput traces, for successful requests only.
	         * @public
	         */this.trace = []; /**
	         * Type of stream ("audio" | "video" etc..)
	         * @public
	         */this._stream = null; /**
	         * Real-Time | The real time at which the request finished.
	         * @public
	         */this._tfinish = null; /**
	         * The duration of the media requests, if available, in milliseconds.
	         * @public
	         */this._mediaduration = null; /**
	         * all the response headers from request.
	         * @public
	         */this._responseHeaders = null; /**
	         * The selected service location for the request. string.
	         * @public
	         */this._serviceLocation = null;} /**
	 * @classdesc This Object holds reference to the progress of the HTTPRequest.
	 */;var HTTPRequestTrace= /**
	    * @class
	    */function HTTPRequestTrace(){_classCallCheck(this,HTTPRequestTrace); /**
	         * Real-Time | Measurement stream start.
	         * @public
	         */this.s = null; /**
	         * Measurement stream duration (ms).
	         * @public
	         */this.d = null; /**
	         * List of integers counting the bytes received in each trace interval within the measurement stream.
	         * @public
	         */this.b = [];};HTTPRequest.GET = 'GET';HTTPRequest.HEAD = 'HEAD';HTTPRequest.MPD_TYPE = 'MPD';HTTPRequest.XLINK_EXPANSION_TYPE = 'XLinkExpansion';HTTPRequest.INIT_SEGMENT_TYPE = 'InitializationSegment';HTTPRequest.INDEX_SEGMENT_TYPE = 'IndexSegment';HTTPRequest.MEDIA_SEGMENT_TYPE = 'MediaSegment';HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE = 'BitstreamSwitchingSegment';HTTPRequest.OTHER_TYPE = 'other';exports.HTTPRequest = HTTPRequest;exports.HTTPRequestTrace = HTTPRequestTrace;
	//# sourceMappingURL=HTTPRequest.js.map


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 18 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateCurrentTime = updateCurrentTime;
	exports.setVideoDuration = setVideoDuration;
	exports.openStory = openStory;
	exports.closeStory = closeStory;
	exports.startTrip = startTrip;
	exports.startOver = startOver;
	exports.goToStory = goToStory;
	exports.goToStoryBySlug = goToStoryBySlug;
	exports.setSeekVideo = setSeekVideo;
	exports.startDriving = startDriving;
	exports.pauseDriving = pauseDriving;
	exports.openMenu = openMenu;
	exports.muteAudio = muteAudio;
	exports.setLanguage = setLanguage;
	var FIND_STORY = exports.FIND_STORY = 'FIND_STORY';
	var GO_TO_STORY = exports.GO_TO_STORY = 'GO_TO_STORY';
	var OPEN_STORY = exports.OPEN_STORY = 'OPEN_STORY';
	var START_OVER = exports.START_OVER = 'START_OVER';
	var START_TRIP = exports.START_TRIP = 'START_TRIP';
	
	var UPDATE_CURRENT_TIME = exports.UPDATE_CURRENT_TIME = 'UPDATE_CURRENT_TIME';
	var SET_VIDEO_DURATION = exports.SET_VIDEO_DURATION = 'SET_VIDEO_DURATION';
	var SEEK_VIDEO = exports.SEEK_VIDEO = 'SEEK_VIDEO';
	
	var START_DRIVING = exports.START_DRIVING = 'START_DRIVING';
	var PAUSE_DRIVING = exports.PAUSE_DRIVING = 'PAUSE_DRIVING';
	var OPEN_MENU = exports.OPEN_MENU = 'OPEN_MENU';
	
	var MUTE_AUDIO = exports.MUTE_AUDIO = 'MUTE_AUDIO';
	
	var SET_LANGUAGE = exports.SET_LANGUAGE = 'SET_LANGUAGE';
	
	function updateCurrentTime(time) {
	    return function (dispatch) {
	        dispatch({
	            payload: time,
	            type: FIND_STORY
	        });
	        dispatch({
	            payload: time,
	            type: UPDATE_CURRENT_TIME
	        });
	    };
	}
	
	function setVideoDuration(time) {
	    return {
	        payload: time,
	        type: SET_VIDEO_DURATION
	    };
	}
	
	function openStory() {
	    return {
	        type: OPEN_STORY,
	        payload: true
	    };
	}
	
	function closeStory() {
	    return {
	        type: OPEN_STORY,
	        payload: false
	    };
	}
	
	function startTrip() {
	    return {
	        type: START_TRIP
	    };
	}
	
	function startOver() {
	    return {
	        type: START_OVER
	    };
	}
	
	function goToStory(story) {
	    return function (dispatch) {
	        dispatch({
	            payload: story.time,
	            type: SEEK_VIDEO
	        });
	        dispatch({
	            payload: story,
	            type: GO_TO_STORY
	        });
	    };
	}
	
	function goToStoryBySlug(slug) {
	    var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    return function (dispatch, getState) {
	        var _getState = getState(),
	            timeline = _getState.timeline;
	
	        var story = timeline.data.find(function (story) {
	            return story.type === "story" && story.link.url.split('/').pop() === slug;
	        });
	
	        if (story) {
	            if (timeline.tripStarted === false) dispatch(startTrip());
	            dispatch(goToStory(story));
	            if (open) dispatch(openStory());
	        } else {
	            dispatch(closeStory());
	        }
	    };
	}
	
	function setSeekVideo(time) {
	    return {
	        payload: time,
	        type: SEEK_VIDEO
	    };
	}
	
	function startDriving() {
	    return {
	        type: START_DRIVING
	    };
	}
	
	function pauseDriving() {
	    return {
	        type: PAUSE_DRIVING
	    };
	}
	
	function openMenu(openOrClose) {
	    return {
	        payload: openOrClose,
	        type: OPEN_MENU
	    };
	}
	
	function muteAudio(onOrOff) {
	    return {
	        payload: onOrOff,
	        type: MUTE_AUDIO
	    };
	}
	
	function setLanguage(language) {
	    return function (dispatch, getState) {
	        var _getState2 = getState(),
	            timeline = _getState2.timeline;
	
	        var videoCurrentTime = timeline.currentTime;
	
	        dispatch({
	            payload: language,
	            type: SET_LANGUAGE
	        });
	
	        if (videoCurrentTime) dispatch(setSeekVideo(videoCurrentTime));
	    };
	}

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(553);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(194);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(554);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 21 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(2);
	var factory = __webpack_require__(135);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 25 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * Dash constants declaration
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var DashConstants=(function(){_createClass(DashConstants,[{key:'init',value:function init(){this.BASE_URL = 'BaseURL';this.SEGMENT_BASE = 'SegmentBase';this.SEGMENT_TEMPLATE = 'SegmentTemplate';this.SEGMENT_LIST = 'SegmentList';this.SEGMENT_URL = 'SegmentURL';this.SEGMENT_TIMELINE = 'SegmentTimeline';this.SEGMENT_PROFILES = 'segmentProfiles';this.ADAPTATION_SET = 'AdaptationSet';this.REPRESENTATION = 'Representation';this.REPRESENTATION_INDEX = 'RepresentationIndex';this.SUB_REPRESENTATION = 'SubRepresentation';this.INITIALIZATION = 'Initialization';this.INITIALIZATION_MINUS = 'initialization';this.MPD = 'MPD';this.PERIOD = 'Period';this.ASSET_IDENTIFIER = 'AssetIdentifier';this.EVENT_STREAM = 'EventStream';this.ID = 'id';this.PROFILES = 'profiles';this.SERVICE_LOCATION = 'serviceLocation';this.RANGE = 'range';this.INDEX = 'index';this.MEDIA = 'media';this.BYTE_RANGE = 'byteRange';this.INDEX_RANGE = 'indexRange';this.MEDIA_RANGE = 'mediaRange';this.VALUE = 'value';this.CONTENT_TYPE = 'contentType';this.MIME_TYPE = 'mimeType';this.BITSTREAM_SWITCHING = 'BitstreamSwitching';this.BITSTREAM_SWITCHING_MINUS = 'bitstreamSwitching';this.CODECS = 'codecs';this.DEPENDENCY_ID = 'dependencyId';this.MEDIA_STREAM_STRUCTURE_ID = 'mediaStreamStructureId';this.METRICS = 'Metrics';this.METRICS_MINUS = 'metrics';this.REPORTING = 'Reporting';this.WIDTH = 'width';this.HEIGHT = 'height';this.SAR = 'sar';this.FRAMERATE = 'frameRate';this.AUDIO_SAMPLING_RATE = 'audioSamplingRate';this.MAXIMUM_SAP_PERIOD = 'maximumSAPPeriod';this.START_WITH_SAP = 'startWithSAP';this.MAX_PLAYOUT_RATE = 'maxPlayoutRate';this.CODING_DEPENDENCY = 'codingDependency';this.SCAN_TYPE = 'scanType';this.FRAME_PACKING = 'FramePacking';this.AUDIO_CHANNEL_CONFIGURATION = 'AudioChannelConfiguration';this.CONTENT_PROTECTION = 'ContentProtection';this.ESSENTIAL_PROPERTY = 'EssentialProperty';this.SUPPLEMENTAL_PROPERTY = 'SupplementalProperty';this.INBAND_EVENT_STREAM = 'InbandEventStream';this.ACCESSIBILITY = 'Accessibility';this.ROLE = 'Role';this.RATING = 'Rating';this.CONTENT_COMPONENT = 'ContentComponent';this.SUBSET = 'Subset';this.LANG = 'lang';this.VIEWPOINT = 'Viewpoint';this.ROLE_ASARRAY = 'Role_asArray';this.ACCESSIBILITY_ASARRAY = 'Accessibility_asArray';this.AUDIOCHANNELCONFIGURATION_ASARRAY = 'AudioChannelConfiguration_asArray';this.CONTENTPROTECTION_ASARRAY = 'ContentProtection_asArray';this.MAIN = 'main';this.DYNAMIC = 'dynamic';this.MEDIA_PRESENTATION_DURATION = 'mediaPresentationDuration';this.MINIMUM_UPDATE_PERIOD = 'minimumUpdatePeriod';this.CODEC_PRIVATE_DATA = 'codecPrivateData';this.BANDWITH = 'bandwidth';this.SOURCE_URL = 'sourceURL';this.TIMESCALE = 'timescale';this.DURATION = 'duration';this.START_NUMBER = 'startNumber';this.PRESENTATION_TIME_OFFSET = 'presentationTimeOffset';this.AVAILABILITY_START_TIME = 'availabilityStartTime';this.AVAILABILITY_END_TIME = 'availabilityEndTime';this.TIMESHIFT_BUFFER_DEPTH = 'timeShiftBufferDepth';this.MAX_SEGMENT_DURATION = 'maxSegmentDuration';this.PRESENTATION_TIME = 'presentationTime';this.MIN_BUFFER_TIME = 'minBufferTime';this.MAX_SUBSEGMENT_DURATION = 'maxSubsegmentDuration';this.START = 'start';this.AVAILABILITY_TIME_OFFSET = 'availabilityTimeOffset';this.AVAILABILITY_TIME_COMPLETE = 'availabilityTimeComplete';this.CENC_DEFAULT_KID = 'cenc:default_KID';this.DVB_PRIORITY = 'dvb:priority';this.DVB_WEIGHT = 'dvb:weight';}}]);function DashConstants(){_classCallCheck(this,DashConstants);this.init();}return DashConstants;})();var constants=new DashConstants();exports['default'] = constants;module.exports = exports['default'];
	//# sourceMappingURL=DashConstants.js.map


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10),
	    _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(173);
	var PooledClass = __webpack_require__(38);
	var ReactFeatureFlags = __webpack_require__(178);
	var ReactReconciler = __webpack_require__(48);
	var Transaction = __webpack_require__(78);
	
	var invariant = __webpack_require__(3);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var NO_CHANGE=-1;var PRIORITY={DEFAULT:0.5,STRONG:1,WEAK:0};function SwitchRequest(q,r,p){ //TODO refactor all the calls to this to use config to be like everything else.
	var instance=undefined;var quality=undefined;var priority=undefined;var reason=undefined; // check priority value
	function getPriority(p){var ret=PRIORITY.DEFAULT; // check that p is one of declared priority value
	if(p === PRIORITY.DEFAULT || p === PRIORITY.STRONG || p === PRIORITY.WEAK){ret = p;}return ret;} // init attributes
	quality = q === undefined?NO_CHANGE:q;priority = getPriority(p);reason = r === undefined?null:r;instance = {quality:quality,reason:reason,priority:priority};return instance;}SwitchRequest.__dashjs_factory_name = 'SwitchRequest';var factory=_coreFactoryMaker2['default'].getClassFactory(SwitchRequest);factory.NO_CHANGE = NO_CHANGE;factory.PRIORITY = PRIORITY;_coreFactoryMaker2['default'].updateClassFactory(SwitchRequest.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=SwitchRequest.js.map


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(38);
	
	var emptyFunction = __webpack_require__(21);
	var warning = __webpack_require__(9);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 29 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker); /**
	 * @module URLUtils
	 * @description Provides utility functions for operating on URLs.
	 * Initially this is simply a method to determine the Base URL of a URL, but
	 * should probably include other things provided all over the place such as
	 * determining whether a URL is relative/absolute, resolving two paths etc.
	 */function URLUtils(){var resolveFunction=undefined;var schemeRegex=/^[a-z][a-z0-9+\-.]*:/i;var httpUrlRegex=/^https?:\/\//i;var httpsUrlRegex=/^https:\/\//i;var originRegex=/^([a-z][a-z0-9+\-.]*:\/\/[^\/]+)\/?/i; /**
	     * Resolves a url given an optional base url
	     * Uses window.URL to do the resolution.
	     *
	     * @param {string} url
	     * @param {string} [baseUrl]
	     * @return {string}
	     * @memberof module:URLUtils
	     * @instance
	     * @private
	     */var nativeURLResolver=function nativeURLResolver(url,baseUrl){try{ // this will throw if baseurl is undefined, invalid etc
	return new window.URL(url,baseUrl).toString();}catch(e) {return url;}}; /**
	     * Resolves a url given an optional base url
	     * Does not resolve ./, ../ etc but will do enough to construct something
	     * which will satisfy XHR etc when window.URL is not available ie
	     * IE11/node etc.
	     *
	     * @param {string} url
	     * @param {string} [baseUrl]
	     * @return {string}
	     * @memberof module:URLUtils
	     * @instance
	     * @private
	     */var dumbURLResolver=function dumbURLResolver(url,baseUrl){var baseUrlParseFunc=parseBaseUrl;if(!baseUrl){return url;}if(!isRelative(url)){return url;}if(isPathAbsolute(url)){baseUrlParseFunc = parseOrigin;}if(isSchemeRelative(url)){baseUrlParseFunc = parseScheme;}var base=baseUrlParseFunc(baseUrl);var joinChar=base.charAt(base.length - 1) !== '/' && url.charAt(0) !== '/'?'/':'';return [base,url].join(joinChar);};function setup(){try{var u=new window.URL('x','http://y'); //jshint ignore:line
	resolveFunction = nativeURLResolver;}catch(e) { // must be IE11/Node etc
	}finally {resolveFunction = resolveFunction || dumbURLResolver;}} /**
	     * Returns a string that contains the Base URL of a URL, if determinable.
	     * @param {string} url - full url
	     * @return {string}
	     * @memberof module:URLUtils
	     * @instance
	     */function parseBaseUrl(url){var slashIndex=url.indexOf('/');var lastSlashIndex=url.lastIndexOf('/');if(slashIndex !== -1){ // if there is only '//'
	if(lastSlashIndex === slashIndex + 1){return url;}if(url.indexOf('?') !== -1){url = url.substring(0,url.indexOf('?'));}return url.substring(0,lastSlashIndex + 1);}return '';} /**
	     * Returns a string that contains the scheme and origin of a URL,
	     * if determinable.
	     * @param {string} url - full url
	     * @return {string}
	     * @memberof module:URLUtils
	     * @instance
	     */function parseOrigin(url){var matches=url.match(originRegex);if(matches){return matches[1];}return '';} /**
	     * Returns a string that contains the scheme of a URL, if determinable.
	     * @param {string} url - full url
	     * @return {string}
	     * @memberof module:URLUtils
	     * @instance
	     */function parseScheme(url){var matches=url.match(schemeRegex);if(matches){return matches[0];}return '';} /**
	     * Determines whether the url is relative.
	     * @return {bool}
	     * @param {string} url
	     * @memberof module:URLUtils
	     * @instance
	     */function isRelative(url){return !schemeRegex.test(url);} /**
	     * Determines whether the url is path-absolute.
	     * @return {bool}
	     * @param {string} url
	     * @memberof module:URLUtils
	     * @instance
	     */function isPathAbsolute(url){return isRelative(url) && url.charAt(0) === '/';} /**
	     * Determines whether the url is scheme-relative.
	     * @return {bool}
	     * @param {string} url
	     * @memberof module:URLUtils
	     * @instance
	     */function isSchemeRelative(url){return url.indexOf('//') === 0;} /**
	     * Determines whether the url is an HTTP-URL as defined in ISO/IEC
	     * 23009-1:2014 3.1.15. ie URL with a fixed scheme of http or https
	     * @return {bool}
	     * @param {string} url
	     * @memberof module:URLUtils
	     * @instance
	     */function isHTTPURL(url){return httpUrlRegex.test(url);} /**
	     * Determines whether the supplied url has https scheme
	     * @return {bool}
	     * @param {string} url
	     * @memberof module:URLUtils
	     * @instance
	     */function isHTTPS(url){return httpsUrlRegex.test(url);} /**
	     * Resolves a url given an optional base url
	     * @return {string}
	     * @param {string} url
	     * @param {string} [baseUrl]
	     * @memberof module:URLUtils
	     * @instance
	     */function resolve(url,baseUrl){return resolveFunction(url,baseUrl);}setup();var instance={parseBaseUrl:parseBaseUrl,parseOrigin:parseOrigin,parseScheme:parseScheme,isRelative:isRelative,isPathAbsolute:isPathAbsolute,isSchemeRelative:isSchemeRelative,isHTTPURL:isHTTPURL,isHTTPS:isHTTPS,resolve:resolve};return instance;}URLUtils.__dashjs_factory_name = 'URLUtils';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(URLUtils);module.exports = exports['default'];
	//# sourceMappingURL=URLUtils.js.map


/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DashJSError=function DashJSError(code,message,data){_classCallCheck(this,DashJSError);this.code = code || null;this.message = message || null;this.data = data || null;};exports["default"] = DashJSError;module.exports = exports["default"];
	//# sourceMappingURL=DashJSError.js.map


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * Protection Constants declaration
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var ProtectionConstants=(function(){_createClass(ProtectionConstants,[{key:'init',value:function init(){this.CLEARKEY_KEYSTEM_STRING = 'org.w3.clearkey';this.WIDEVINE_KEYSTEM_STRING = 'com.widevine.alpha';this.PLAYREADY_KEYSTEM_STRING = 'com.microsoft.playready';}}]);function ProtectionConstants(){_classCallCheck(this,ProtectionConstants);this.init();}return ProtectionConstants;})();var constants=new ProtectionConstants();exports['default'] = constants;module.exports = exports['default'];
	//# sourceMappingURL=ProtectionConstants.js.map


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _modelsFragmentModel=__webpack_require__(66);var _modelsFragmentModel2=_interopRequireDefault(_modelsFragmentModel);var _SourceBufferSink=__webpack_require__(145);var _SourceBufferSink2=_interopRequireDefault(_SourceBufferSink);var _PreBufferSink=__webpack_require__(334);var _PreBufferSink2=_interopRequireDefault(_PreBufferSink);var _AbrController=__webpack_require__(64);var _AbrController2=_interopRequireDefault(_AbrController);var _MediaController=__webpack_require__(87);var _MediaController2=_interopRequireDefault(_MediaController);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _utilsBoxParser=__webpack_require__(68);var _utilsBoxParser2=_interopRequireDefault(_utilsBoxParser);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _utilsInitCache=__webpack_require__(97);var _utilsInitCache2=_interopRequireDefault(_utilsInitCache);var _voMetricsHTTPRequest=__webpack_require__(16);var BUFFER_LOADED='bufferLoaded';var BUFFER_EMPTY='bufferStalled';var STALL_THRESHOLD=0.5;var BUFFER_END_THRESHOLD=0.5;var BUFFER_RANGE_CALCULATION_THRESHOLD=0.01;var QUOTA_EXCEEDED_ERROR_CODE=22;var BUFFER_CONTROLLER_TYPE='BufferController';function BufferController(config){config = config || {};var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var metricsModel=config.metricsModel;var mediaPlayerModel=config.mediaPlayerModel;var errHandler=config.errHandler;var streamController=config.streamController;var mediaController=config.mediaController;var adapter=config.adapter;var textController=config.textController;var abrController=config.abrController;var playbackController=config.playbackController;var type=config.type;var streamProcessor=config.streamProcessor;var instance=undefined,log=undefined,requiredQuality=undefined,isBufferingCompleted=undefined,bufferLevel=undefined,criticalBufferLevel=undefined,mediaSource=undefined,maxAppendedIndex=undefined,lastIndex=undefined,buffer=undefined,dischargeBuffer=undefined,bufferState=undefined,appendedBytesInfo=undefined,wallclockTicked=undefined,isAppendingInProgress=undefined,isPruningInProgress=undefined,initCache=undefined,seekStartTime=undefined,seekClearedBufferingCompleted=undefined,pendingPruningRanges=undefined,chunksToAppend=undefined,bufferResetInProgress=undefined,mediaChunk=undefined;function setup(){log = (0,_coreDebug2['default'])(context).getInstance().log.bind(instance);initCache = (0,_utilsInitCache2['default'])(context).getInstance();chunksToAppend = [];resetInitialSettings();}function getBufferControllerType(){return BUFFER_CONTROLLER_TYPE;}function initialize(Source){setMediaSource(Source);requiredQuality = abrController.getQualityFor(type,streamProcessor.getStreamInfo());eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,onDataUpdateCompleted,this);eventBus.on(_coreEventsEvents2['default'].INIT_FRAGMENT_LOADED,onInitFragmentLoaded,this);eventBus.on(_coreEventsEvents2['default'].MEDIA_FRAGMENT_LOADED,onMediaFragmentLoaded,this);eventBus.on(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED,onQualityChanged,this);eventBus.on(_coreEventsEvents2['default'].STREAM_COMPLETED,onStreamCompleted,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_PROGRESS,onPlaybackProgression,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED,onPlaybackProgression,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_RATE_CHANGED,onPlaybackRateChanged,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_SEEKING,onPlaybackSeeking,this);eventBus.on(_coreEventsEvents2['default'].WALLCLOCK_TIME_UPDATED,onWallclockTimeUpdated,this);eventBus.on(_coreEventsEvents2['default'].CURRENT_TRACK_CHANGED,onCurrentTrackChanged,this,_coreEventBus2['default'].EVENT_PRIORITY_HIGH);eventBus.on(_coreEventsEvents2['default'].SOURCEBUFFER_REMOVE_COMPLETED,onRemoved,this);}function createBuffer(mediaInfo){if(!initCache || !mediaInfo || !streamProcessor)return null;if(mediaSource){try{buffer = (0,_SourceBufferSink2['default'])(context).create(mediaSource,mediaInfo,onAppended.bind(this));if(typeof buffer.getBuffer().initialize === 'function'){buffer.getBuffer().initialize(type,streamProcessor);}}catch(e) {log('Caught error on create SourceBuffer: ' + e);errHandler.mediaSourceError('Error creating ' + type + ' source buffer.');}}else {buffer = (0,_PreBufferSink2['default'])(context).create(onAppended.bind(this));}updateBufferTimestampOffset(streamProcessor.getRepresentationInfoForQuality(requiredQuality).MSETimeOffset);}function dischargePreBuffer(){if(buffer && dischargeBuffer && typeof dischargeBuffer.discharge === 'function'){var ranges=dischargeBuffer.getAllBufferRanges();if(ranges.length > 0){var rangeStr='Beginning ' + type + 'PreBuffer discharge, adding buffer for:';for(var i=0;i < ranges.length;i++) {rangeStr += ' start: ' + ranges.start(i) + ', end: ' + ranges.end(i) + ';';}log(rangeStr);}else {log('PreBuffer discharge requested, but there were no media segments in the PreBuffer.');}var chunks=dischargeBuffer.discharge();var lastInit=null;for(var j=0;j < chunks.length;j++) {var chunk=chunks[j];var initChunk=initCache.extract(chunk.streamId,chunk.representationId);if(initChunk){if(lastInit !== initChunk){buffer.append(initChunk);lastInit = initChunk;}buffer.append(chunk); //TODO Think about supressing buffer events the second time round after a discharge?
	}}dischargeBuffer.reset();dischargeBuffer = null;}}function isActive(){return streamProcessor && streamController?streamProcessor.getStreamInfo().id === streamController.getActiveStreamInfo().id:false;}function onInitFragmentLoaded(e){if(e.fragmentModel !== streamProcessor.getFragmentModel())return;log('Init fragment finished loading saving to',type + '\'s init cache');initCache.save(e.chunk);log('Append Init fragment',type,' with representationId:',e.chunk.representationId,' and quality:',e.chunk.quality);appendToBuffer(e.chunk);}function switchInitData(streamId,representationId,bufferResetEnabled){var chunk=initCache.extract(streamId,representationId);bufferResetInProgress = bufferResetEnabled === true?bufferResetEnabled:false;if(chunk){log('Append Init fragment',type,' with representationId:',chunk.representationId,' and quality:',chunk.quality);appendToBuffer(chunk);}else {eventBus.trigger(_coreEventsEvents2['default'].INIT_REQUESTED,{sender:instance});}}function onMediaFragmentLoaded(e){if(e.fragmentModel !== streamProcessor.getFragmentModel())return;var chunk=e.chunk;var bytes=chunk.bytes;var quality=chunk.quality;var currentRepresentation=streamProcessor.getRepresentationInfoForQuality(quality);var eventStreamMedia=adapter.getEventsFor(currentRepresentation.mediaInfo,streamProcessor);var eventStreamTrack=adapter.getEventsFor(currentRepresentation,streamProcessor);if(eventStreamMedia && eventStreamMedia.length > 0 || eventStreamTrack && eventStreamTrack.length > 0){var request=streamProcessor.getFragmentModel().getRequests({state:_modelsFragmentModel2['default'].FRAGMENT_MODEL_EXECUTED,quality:quality,index:chunk.index})[0];var events=handleInbandEvents(bytes,request,eventStreamMedia,eventStreamTrack);streamProcessor.getEventController().addInbandEvents(events);}if(bufferResetInProgress){mediaChunk = chunk;var ranges=buffer && buffer.getAllBufferRanges();if(ranges && ranges.length > 0 && playbackController.getTimeToStreamEnd() > STALL_THRESHOLD){log('Clearing buffer because track changed - ' + (ranges.end(ranges.length - 1) + BUFFER_END_THRESHOLD));clearBuffers([{start:0,end:ranges.end(ranges.length - 1) + BUFFER_END_THRESHOLD,force:true // Force buffer removal even when buffering is completed and MediaSource is ended
	}]);}}else {appendToBuffer(chunk);}}function appendToBuffer(chunk,forceAppend){if(!isAppendingInProgress || forceAppend){isAppendingInProgress = true;appendedBytesInfo = chunk;buffer.append(chunk);if(chunk.mediaInfo.type === _constantsConstants2['default'].VIDEO){eventBus.trigger(_coreEventsEvents2['default'].VIDEO_CHUNK_RECEIVED,{chunk:chunk});}}else {chunksToAppend.push(chunk);}} /*
	    function showBufferRanges(ranges) {
	        if (ranges && ranges.length > 0) {
	            for (let i = 0, len = ranges.length; i < len; i++) {
	                log('Buffered Range for type:', type, ':', ranges.start(i), ' - ', ranges.end(i), ' currentTime = ', playbackController.getTime());
	            }
	        }
	    }
	    */function onAppended(e){if(e.error){if(e.error.code === QUOTA_EXCEEDED_ERROR_CODE){criticalBufferLevel = getTotalBufferedTime() * 0.8;log('Quota exceeded for type: ' + type + ', Critical Buffer: ' + criticalBufferLevel);if(criticalBufferLevel > 0){ // recalculate buffer lengths to keep (bufferToKeep, bufferAheadToKeep, bufferTimeAtTopQuality) according to criticalBufferLevel
	var bufferToKeep=Math.max(0.2 * criticalBufferLevel,1);var bufferAhead=criticalBufferLevel - bufferToKeep;mediaPlayerModel.setBufferToKeep(parseFloat(bufferToKeep).toFixed(5));mediaPlayerModel.setBufferAheadToKeep(parseFloat(bufferAhead).toFixed(5));}}if(e.error.code === QUOTA_EXCEEDED_ERROR_CODE || !hasEnoughSpaceToAppend()){log('Clearing playback buffer to overcome quota exceed situation for type: ' + type);eventBus.trigger(_coreEventsEvents2['default'].QUOTA_EXCEEDED,{sender:instance,criticalBufferLevel:criticalBufferLevel}); //Tells ScheduleController to stop scheduling.
	pruneAllSafely(); // Then we clear the buffer and onCleared event will tell ScheduleController to start scheduling again.
	}return;}appendedBytesInfo = e.chunk;if(appendedBytesInfo && !isNaN(appendedBytesInfo.index)){maxAppendedIndex = Math.max(appendedBytesInfo.index,maxAppendedIndex);checkIfBufferingCompleted();}var ranges=buffer.getAllBufferRanges();if(appendedBytesInfo.segmentType === _voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE){ // showBufferRanges(ranges);
	onPlaybackProgression();}else {if(bufferResetInProgress){var currentTime=playbackController.getTime();log('[BufferController][',type,'] appendToBuffer seek target should be ' + currentTime);streamProcessor.getScheduleController().setSeekTarget(currentTime);adapter.setIndexHandlerTime(streamProcessor,currentTime);}}var dataEvent={sender:instance,quality:appendedBytesInfo.quality,startTime:appendedBytesInfo.start,index:appendedBytesInfo.index,bufferedRanges:ranges};if(appendedBytesInfo && !appendedBytesInfo.endFragment){eventBus.trigger(_coreEventsEvents2['default'].BYTES_APPENDED,dataEvent);}else if(appendedBytesInfo){eventBus.trigger(_coreEventsEvents2['default'].BYTES_APPENDED_END_FRAGMENT,dataEvent);}if(chunksToAppend.length === 0){isAppendingInProgress = false;}else {var chunk=chunksToAppend.shift();appendToBuffer(chunk,true);}}function onQualityChanged(e){if(requiredQuality === e.newQuality || type !== e.mediaType || streamProcessor.getStreamInfo().id !== e.streamInfo.id)return;updateBufferTimestampOffset(streamProcessor.getRepresentationInfoForQuality(e.newQuality).MSETimeOffset);requiredQuality = e.newQuality;} //**********************************************************************
	// START Buffer Level, State & Sufficiency Handling.
	//**********************************************************************
	function onPlaybackSeeking(){if(isBufferingCompleted){seekClearedBufferingCompleted = true;isBufferingCompleted = false; //a seek command has occured, reset lastIndex value, it will be set next time that onStreamCompleted will be called.
	lastIndex = Number.POSITIVE_INFINITY;}chunksToAppend = [];isAppendingInProgress = false;if(type !== _constantsConstants2['default'].FRAGMENTED_TEXT){ // remove buffer after seeking operations
	pruneAllSafely();}else {onPlaybackProgression();}seekStartTime = undefined;} // Prune full buffer but what is around current time position
	function pruneAllSafely(){var ranges=getAllRangesWithSafetyFactor();if(!ranges || ranges.length === 0){onPlaybackProgression();}clearBuffers(ranges);} // Get all buffer ranges but a range around current time position
	function getAllRangesWithSafetyFactor(){var clearRanges=[];var ranges=buffer.getAllBufferRanges();if(!ranges || ranges.length === 0){return clearRanges;}var currentTime=playbackController.getTime();var endOfBuffer=ranges.end(ranges.length - 1) + BUFFER_END_THRESHOLD;var currentTimeRequest=streamProcessor.getFragmentModel().getRequests({state:_modelsFragmentModel2['default'].FRAGMENT_MODEL_EXECUTED,time:currentTime,threshold:BUFFER_RANGE_CALCULATION_THRESHOLD})[0]; // There is no request in current time position yet. Let's remove everything
	if(!currentTimeRequest){log('getAllRangesWithSafetyFactor for',type,'- No request found in current time position, removing full buffer 0 -',endOfBuffer);clearRanges.push({start:0,end:endOfBuffer});}else { // Build buffer behind range. To avoid pruning time around current time position,
	// we include fragment right behind the one in current time position
	var behindRange={start:0,end:currentTimeRequest.startTime - STALL_THRESHOLD};var prevReq=streamProcessor.getFragmentModel().getRequests({state:_modelsFragmentModel2['default'].FRAGMENT_MODEL_EXECUTED,time:currentTimeRequest.startTime - currentTimeRequest.duration / 2,threshold:BUFFER_RANGE_CALCULATION_THRESHOLD})[0];if(prevReq && prevReq.startTime != currentTimeRequest.startTime){behindRange.end = prevReq.startTime;}if(behindRange.start < behindRange.end && behindRange.end > ranges.start(0)){clearRanges.push(behindRange);} // Build buffer ahead range. To avoid pruning time around current time position,
	// we include fragment right after the one in current time position
	var aheadRange={start:currentTimeRequest.startTime + currentTimeRequest.duration + STALL_THRESHOLD,end:endOfBuffer};var nextReq=streamProcessor.getFragmentModel().getRequests({state:_modelsFragmentModel2['default'].FRAGMENT_MODEL_EXECUTED,time:currentTimeRequest.startTime + currentTimeRequest.duration + STALL_THRESHOLD,threshold:BUFFER_RANGE_CALCULATION_THRESHOLD})[0];if(nextReq && nextReq.startTime !== currentTimeRequest.startTime){aheadRange.start = nextReq.startTime + nextReq.duration + STALL_THRESHOLD;}if(aheadRange.start < aheadRange.end && aheadRange.start < endOfBuffer){clearRanges.push(aheadRange);}}return clearRanges;}function getWorkingTime(){ // This function returns current working time for buffer (either start time or current time if playback has started)
	var ret=playbackController.getTime();if(seekStartTime){ // if there is a seek start time, the first buffer data will be available on maximum value between first buffer range value and seek start time.
	var ranges=buffer.getAllBufferRanges();if(ranges && ranges.length){ret = Math.max(ranges.start(0),seekStartTime);}}return ret;}function onPlaybackProgression(){if(!bufferResetInProgress){updateBufferLevel();addBufferMetrics();}}function getRangeAt(time,tolerance){var ranges=buffer.getAllBufferRanges();var start=0;var end=0;var firstStart=null;var lastEnd=null;var gap=0;var len=undefined,i=undefined;var toler=tolerance || 0.15;if(ranges !== null && ranges !== undefined){for(i = 0,len = ranges.length;i < len;i++) {start = ranges.start(i);end = ranges.end(i);if(firstStart === null){gap = Math.abs(start - time);if(time >= start && time < end){ // start the range
	firstStart = start;lastEnd = end;}else if(gap <= toler){ // start the range even though the buffer does not contain time 0
	firstStart = start;lastEnd = end;}}else {gap = start - lastEnd;if(gap <= toler){ // the discontinuity is smaller than the tolerance, combine the ranges
	lastEnd = end;}else {break;}}}if(firstStart !== null){return {start:firstStart,end:lastEnd};}}return null;}function getBufferLength(time,tolerance){var range=undefined,length=undefined;range = getRangeAt(time,tolerance);if(range === null){length = 0;}else {length = range.end - time;}return length;}function updateBufferLevel(){if(playbackController){bufferLevel = getBufferLength(getWorkingTime() || 0);eventBus.trigger(_coreEventsEvents2['default'].BUFFER_LEVEL_UPDATED,{sender:instance,bufferLevel:bufferLevel});checkIfSufficientBuffer();}}function addBufferMetrics(){if(!isActive())return;metricsModel.addBufferState(type,bufferState,streamProcessor.getScheduleController().getBufferTarget());metricsModel.addBufferLevel(type,new Date(),bufferLevel * 1000);}function checkIfBufferingCompleted(){var isLastIdxAppended=maxAppendedIndex >= lastIndex - 1; // Handles 0 and non 0 based request index
	if(isLastIdxAppended && !isBufferingCompleted && buffer.discharge === undefined){isBufferingCompleted = true;log('[BufferController][' + type + '] checkIfBufferingCompleted trigger BUFFERING_COMPLETED');eventBus.trigger(_coreEventsEvents2['default'].BUFFERING_COMPLETED,{sender:instance,streamInfo:streamProcessor.getStreamInfo()});}}function checkIfSufficientBuffer(){ // No need to check buffer if type is not audio or video (for example if several errors occur during text parsing, so that the buffer cannot be filled, no error must occur on video playback)
	if(type !== 'audio' && type !== 'video')return;if(seekClearedBufferingCompleted && !isBufferingCompleted && playbackController && playbackController.getTimeToStreamEnd() - bufferLevel < STALL_THRESHOLD){seekClearedBufferingCompleted = false;isBufferingCompleted = true;log('[BufferController][' + type + '] checkIfSufficientBuffer trigger BUFFERING_COMPLETED');eventBus.trigger(_coreEventsEvents2['default'].BUFFERING_COMPLETED,{sender:instance,streamInfo:streamProcessor.getStreamInfo()});}if(bufferLevel < STALL_THRESHOLD && !isBufferingCompleted){notifyBufferStateChanged(BUFFER_EMPTY);}else {if(isBufferingCompleted || bufferLevel >= mediaPlayerModel.getStableBufferTime()){notifyBufferStateChanged(BUFFER_LOADED);}}}function notifyBufferStateChanged(state){if(bufferState === state || type === _constantsConstants2['default'].FRAGMENTED_TEXT && textController.getAllTracksAreDisabled())return;bufferState = state;addBufferMetrics();eventBus.trigger(_coreEventsEvents2['default'].BUFFER_LEVEL_STATE_CHANGED,{sender:instance,state:state,mediaType:type,streamInfo:streamProcessor.getStreamInfo()});eventBus.trigger(state === BUFFER_LOADED?_coreEventsEvents2['default'].BUFFER_LOADED:_coreEventsEvents2['default'].BUFFER_EMPTY,{mediaType:type});log(state === BUFFER_LOADED?'Got enough buffer to start for ' + type:'Waiting for more buffer before starting playback for ' + type);}function handleInbandEvents(data,request,mediaInbandEvents,trackInbandEvents){var fragmentStartTime=Math.max(!request || isNaN(request.startTime)?0:request.startTime,0);var eventStreams=[];var events=[]; /* Extract the possible schemeIdUri : If a DASH client detects an event message box with a scheme that is not defined in MPD, the client is expected to ignore it */var inbandEvents=mediaInbandEvents.concat(trackInbandEvents);for(var i=0,ln=inbandEvents.length;i < ln;i++) {eventStreams[inbandEvents[i].schemeIdUri] = inbandEvents[i];}var isoFile=(0,_utilsBoxParser2['default'])(context).getInstance().parse(data);var eventBoxes=isoFile.getBoxes('emsg');for(var i=0,ln=eventBoxes.length;i < ln;i++) {var _event=adapter.getEvent(eventBoxes[i],eventStreams,fragmentStartTime);if(_event){events.push(_event);}}return events;} /* prune buffer on our own in background to avoid browsers pruning buffer silently */function pruneBuffer(){if(!buffer)return;if(type === _constantsConstants2['default'].FRAGMENTED_TEXT)return;if(!isBufferingCompleted){clearBuffers(getClearRanges());}}function getClearRanges(){var clearRanges=[];var ranges=buffer.getAllBufferRanges();if(!ranges || ranges.length === 0){return clearRanges;}var currentTime=playbackController.getTime();var rangeToKeep={start:Math.max(0,currentTime - mediaPlayerModel.getBufferToKeep()),end:currentTime + mediaPlayerModel.getBufferAheadToKeep()};var currentTimeRequest=streamProcessor.getFragmentModel().getRequests({state:_modelsFragmentModel2['default'].FRAGMENT_MODEL_EXECUTED,time:currentTime,threshold:BUFFER_RANGE_CALCULATION_THRESHOLD})[0]; // Ensure we keep full range of current fragment
	if(currentTimeRequest){rangeToKeep.start = Math.min(currentTimeRequest.startTime,rangeToKeep.start);rangeToKeep.end = Math.max(currentTimeRequest.startTime + currentTimeRequest.duration,rangeToKeep.end);}if(ranges.start(0) <= rangeToKeep.start){var behindRange={start:0,end:rangeToKeep.start};for(var i=0;i < ranges.length && ranges.end(i) <= rangeToKeep.start;i++) {behindRange.end = ranges.end(i);}if(behindRange.start < behindRange.end){clearRanges.push(behindRange);}}if(ranges.end(ranges.length - 1) >= rangeToKeep.end){var aheadRange={start:rangeToKeep.end,end:ranges.end(ranges.length - 1) + BUFFER_RANGE_CALCULATION_THRESHOLD};if(aheadRange.start < aheadRange.end){clearRanges.push(aheadRange);}}return clearRanges;}function clearBuffers(ranges){if(!ranges || !buffer || ranges.length === 0)return;pendingPruningRanges.push.apply(pendingPruningRanges,ranges);if(isPruningInProgress){return;}clearNextRange();}function clearNextRange(){if(pendingPruningRanges.length === 0 || !buffer){return;}var sourceBuffer=buffer.getBuffer();if(!sourceBuffer || !sourceBuffer.buffered || sourceBuffer.buffered.length === 0){return;}var range=pendingPruningRanges.shift();log('Removing',type,'buffer from:',range.start,'to',range.end);isPruningInProgress = true; // If removing buffer ahead current playback position, update maxAppendedIndex
	var currentTime=playbackController.getTime();if(currentTime < range.end){isBufferingCompleted = false;maxAppendedIndex = 0;if(!bufferResetInProgress){streamProcessor.getScheduleController().setSeekTarget(currentTime);adapter.setIndexHandlerTime(streamProcessor,currentTime);}}buffer.remove(range.start,range.end,range.force);}function onRemoved(e){if(buffer !== e.buffer)return;log('[BufferController][',type,'] onRemoved buffer from:',e.from,'to',e.to); // const ranges = buffer.getAllBufferRanges();
	// showBufferRanges(ranges);
	if(pendingPruningRanges.length === 0){isPruningInProgress = false;}if(isPruningInProgress){clearNextRange();}else {if(!bufferResetInProgress){log('onRemoved : call updateBufferLevel');updateBufferLevel();}else {bufferResetInProgress = false;if(mediaChunk){appendToBuffer(mediaChunk);}}eventBus.trigger(_coreEventsEvents2['default'].BUFFER_CLEARED,{sender:instance,from:e.from,to:e.to,hasEnoughSpaceToAppend:hasEnoughSpaceToAppend()});} //TODO - REMEMBER removed a timerout hack calling clearBuffer after manifestInfo.minBufferTime * 1000 if !hasEnoughSpaceToAppend() Aug 04 2016
	}function updateBufferTimestampOffset(MSETimeOffset){ // Each track can have its own @presentationTimeOffset, so we should set the offset
	// if it has changed after switching the quality or updating an mpd
	var sourceBuffer=buffer && buffer.getBuffer?buffer.getBuffer():null;if(sourceBuffer && sourceBuffer.timestampOffset !== MSETimeOffset && !isNaN(MSETimeOffset)){sourceBuffer.timestampOffset = MSETimeOffset;}}function onDataUpdateCompleted(e){if(e.sender.getStreamProcessor() !== streamProcessor || e.error)return;updateBufferTimestampOffset(e.currentRepresentation.MSETimeOffset);}function onStreamCompleted(e){if(e.fragmentModel !== streamProcessor.getFragmentModel())return;lastIndex = e.request.index;checkIfBufferingCompleted();}function onCurrentTrackChanged(e){var ranges=buffer && buffer.getAllBufferRanges();if(!ranges || e.newMediaInfo.type !== type || e.newMediaInfo.streamInfo.id !== streamProcessor.getStreamInfo().id)return;log('[BufferController][' + type + '] track change asked');if(mediaController.getSwitchMode(type) === _MediaController2['default'].TRACK_SWITCH_MODE_ALWAYS_REPLACE){if(ranges && ranges.length > 0 && playbackController.getTimeToStreamEnd() > STALL_THRESHOLD){isBufferingCompleted = false;lastIndex = Number.POSITIVE_INFINITY;}}}function onWallclockTimeUpdated(){wallclockTicked++;var secondsElapsed=wallclockTicked * (mediaPlayerModel.getWallclockTimeUpdateInterval() / 1000);if(secondsElapsed >= mediaPlayerModel.getBufferPruningInterval()){wallclockTicked = 0;pruneBuffer();}}function onPlaybackRateChanged(){checkIfSufficientBuffer();}function getType(){return type;}function getStreamProcessor(){return streamProcessor;}function setSeekStartTime(value){seekStartTime = value;}function getBuffer(){return buffer;}function getBufferLevel(){return bufferLevel;}function setMediaSource(value,mediaInfo){mediaSource = value;if(buffer && mediaInfo){ //if we have a prebuffer, we should prepare to discharge it, and make a new sourceBuffer ready
	if(typeof buffer.discharge === 'function'){dischargeBuffer = buffer;createBuffer(mediaInfo);}}}function getMediaSource(){return mediaSource;}function getIsBufferingCompleted(){return isBufferingCompleted;}function getIsPruningInProgress(){return isPruningInProgress;}function getTotalBufferedTime(){var ranges=buffer.getAllBufferRanges();var totalBufferedTime=0;var ln=undefined,i=undefined;if(!ranges)return totalBufferedTime;for(i = 0,ln = ranges.length;i < ln;i++) {totalBufferedTime += ranges.end(i) - ranges.start(i);}return totalBufferedTime;}function hasEnoughSpaceToAppend(){var totalBufferedTime=getTotalBufferedTime();return totalBufferedTime < criticalBufferLevel;}function resetInitialSettings(errored){criticalBufferLevel = Number.POSITIVE_INFINITY;bufferState = BUFFER_EMPTY;requiredQuality = _AbrController2['default'].QUALITY_DEFAULT;lastIndex = Number.POSITIVE_INFINITY;maxAppendedIndex = 0;appendedBytesInfo = null;isBufferingCompleted = false;isAppendingInProgress = false;isPruningInProgress = false;seekClearedBufferingCompleted = false;bufferLevel = 0;wallclockTicked = 0;pendingPruningRanges = [];if(buffer){if(!errored){buffer.abort();}buffer.reset();buffer = null;}bufferResetInProgress = false;}function reset(errored){eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,onDataUpdateCompleted,this);eventBus.off(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED,onQualityChanged,this);eventBus.off(_coreEventsEvents2['default'].INIT_FRAGMENT_LOADED,onInitFragmentLoaded,this);eventBus.off(_coreEventsEvents2['default'].MEDIA_FRAGMENT_LOADED,onMediaFragmentLoaded,this);eventBus.off(_coreEventsEvents2['default'].STREAM_COMPLETED,onStreamCompleted,this);eventBus.off(_coreEventsEvents2['default'].CURRENT_TRACK_CHANGED,onCurrentTrackChanged,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_PROGRESS,onPlaybackProgression,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED,onPlaybackProgression,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_RATE_CHANGED,onPlaybackRateChanged,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_SEEKING,onPlaybackSeeking,this);eventBus.off(_coreEventsEvents2['default'].WALLCLOCK_TIME_UPDATED,onWallclockTimeUpdated,this);eventBus.off(_coreEventsEvents2['default'].SOURCEBUFFER_REMOVE_COMPLETED,onRemoved,this);resetInitialSettings(errored);}instance = {getBufferControllerType:getBufferControllerType,initialize:initialize,createBuffer:createBuffer,dischargePreBuffer:dischargePreBuffer,getType:getType,getStreamProcessor:getStreamProcessor,setSeekStartTime:setSeekStartTime,getBuffer:getBuffer,getBufferLevel:getBufferLevel,getRangeAt:getRangeAt,setMediaSource:setMediaSource,getMediaSource:getMediaSource,getIsBufferingCompleted:getIsBufferingCompleted,switchInitData:switchInitData,getIsPruningInProgress:getIsPruningInProgress,reset:reset};setup();return instance;}BufferController.__dashjs_factory_name = BUFFER_CONTROLLER_TYPE;var factory=_coreFactoryMaker2['default'].getClassFactory(BufferController);factory.BUFFER_LOADED = BUFFER_LOADED;factory.BUFFER_EMPTY = BUFFER_EMPTY;_coreFactoryMaker2['default'].updateClassFactory(BufferController.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=BufferController.js.map


/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var FragmentRequest=function FragmentRequest(){_classCallCheck(this,FragmentRequest);this.action = FragmentRequest.ACTION_DOWNLOAD;this.startTime = NaN;this.mediaType = null;this.mediaInfo = null;this.type = null;this.duration = NaN;this.timescale = NaN;this.range = null;this.url = null;this.serviceLocation = null;this.requestStartDate = null;this.firstByteDate = null;this.requestEndDate = null;this.quality = NaN;this.index = NaN;this.availabilityStartTime = null;this.availabilityEndTime = null;this.wallStartTime = null;this.bytesLoaded = NaN;this.bytesTotal = NaN;this.delayLoadingTime = NaN;this.responseType = 'arraybuffer';this.representationId = null;};FragmentRequest.ACTION_DOWNLOAD = 'download';FragmentRequest.ACTION_COMPLETE = 'complete';exports['default'] = FragmentRequest;module.exports = exports['default'];
	//# sourceMappingURL=FragmentRequest.js.map


/***/ },
/* 38 */
[643, 10],
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(74);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(54);
	util.inherits = __webpack_require__(44);
	/*</replacement>*/
	
	var Readable = __webpack_require__(214);
	var Writable = __webpack_require__(128);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});exports.unescapeDollarsInTemplate = unescapeDollarsInTemplate;exports.replaceIDForTemplate = replaceIDForTemplate;exports.replaceTokenForTemplate = replaceTokenForTemplate;exports.getIndexBasedSegment = getIndexBasedSegment;exports.getTimeBasedSegment = getTimeBasedSegment;exports.getSegmentByIndex = getSegmentByIndex;exports.decideSegmentListRangeForTemplate = decideSegmentListRangeForTemplate;function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _voSegment=__webpack_require__(86);var _voSegment2=_interopRequireDefault(_voSegment);function zeroPadToLength(numStr,minStrLength){while(numStr.length < minStrLength) {numStr = '0' + numStr;}return numStr;}function getNumberForSegment(segment,segmentIndex){return segment.representation.startNumber + segmentIndex;}function unescapeDollarsInTemplate(url){return url?url.split('$$').join('$'):url;}function replaceIDForTemplate(url,value){if(!value || !url || url.indexOf('$RepresentationID$') === -1){return url;}var v=value.toString();return url.split('$RepresentationID$').join(v);}function replaceTokenForTemplate(url,token,value){var formatTag='%0';var startPos=undefined,endPos=undefined,formatTagPos=undefined,specifier=undefined,width=undefined,paddedValue=undefined;var tokenLen=token.length;var formatTagLen=formatTag.length;if(!url){return url;} // keep looping round until all instances of <token> have been
	// replaced. once that has happened, startPos below will be -1
	// and the completed url will be returned.
	while(true) { // check if there is a valid $<token>...$ identifier
	// if not, return the url as is.
	startPos = url.indexOf('$' + token);if(startPos < 0){return url;} // the next '$' must be the end of the identifier
	// if there isn't one, return the url as is.
	endPos = url.indexOf('$',startPos + tokenLen);if(endPos < 0){return url;} // now see if there is an additional format tag suffixed to
	// the identifier within the enclosing '$' characters
	formatTagPos = url.indexOf(formatTag,startPos + tokenLen);if(formatTagPos > startPos && formatTagPos < endPos){specifier = url.charAt(endPos - 1);width = parseInt(url.substring(formatTagPos + formatTagLen,endPos - 1),10); // support the minimum specifiers required by IEEE 1003.1
	// (d, i , o, u, x, and X) for completeness
	switch(specifier){ // treat all int types as uint,
	// hence deliberate fallthrough
	case 'd':case 'i':case 'u':paddedValue = zeroPadToLength(value.toString(),width);break;case 'x':paddedValue = zeroPadToLength(value.toString(16),width);break;case 'X':paddedValue = zeroPadToLength(value.toString(16),width).toUpperCase();break;case 'o':paddedValue = zeroPadToLength(value.toString(8),width);break;default: //TODO: commented out logging to supress jshint warning -- `log` is undefined here
	//log('Unsupported/invalid IEEE 1003.1 format identifier string in URL');
	return url;}}else {paddedValue = value;}url = url.substring(0,startPos) + paddedValue + url.substring(endPos + 1);}}function getIndexBasedSegment(timelineConverter,isDynamic,representation,index){var seg=undefined,duration=undefined,presentationStartTime=undefined,presentationEndTime=undefined;duration = representation.segmentDuration; /*
	     * From spec - If neither @duration attribute nor SegmentTimeline element is present, then the Representation
	     * shall contain exactly one Media Segment. The MPD start time is 0 and the MPD duration is obtained
	     * in the same way as for the last Media Segment in the Representation.
	     */if(isNaN(duration)){duration = representation.adaptation.period.duration;}presentationStartTime = parseFloat((representation.adaptation.period.start + index * duration).toFixed(5));presentationEndTime = parseFloat((presentationStartTime + duration).toFixed(5));seg = new _voSegment2['default']();seg.representation = representation;seg.duration = duration;seg.presentationStartTime = presentationStartTime;seg.mediaStartTime = timelineConverter.calcMediaTimeFromPresentationTime(seg.presentationStartTime,representation);seg.availabilityStartTime = timelineConverter.calcAvailabilityStartTimeFromPresentationTime(seg.presentationStartTime,representation.adaptation.period.mpd,isDynamic);seg.availabilityEndTime = timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationEndTime,representation.adaptation.period.mpd,isDynamic); // at this wall clock time, the video element currentTime should be seg.presentationStartTime
	seg.wallStartTime = timelineConverter.calcWallTimeForSegment(seg,isDynamic);seg.replacementNumber = getNumberForSegment(seg,index);seg.availabilityIdx = index;return seg;}function getTimeBasedSegment(timelineConverter,isDynamic,representation,time,duration,fTimescale,url,range,index,tManifest){var scaledTime=time / fTimescale;var scaledDuration=Math.min(duration / fTimescale,representation.adaptation.period.mpd.maxSegmentDuration);var presentationStartTime=undefined,presentationEndTime=undefined,seg=undefined;presentationStartTime = timelineConverter.calcPresentationTimeFromMediaTime(scaledTime,representation);presentationEndTime = presentationStartTime + scaledDuration;seg = new _voSegment2['default']();seg.representation = representation;seg.duration = scaledDuration;seg.mediaStartTime = scaledTime;seg.presentationStartTime = presentationStartTime; // For SegmentTimeline every segment is available at loadedTime
	seg.availabilityStartTime = representation.adaptation.period.mpd.manifest.loadedTime;seg.availabilityEndTime = timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationEndTime,representation.adaptation.period.mpd,isDynamic); // at this wall clock time, the video element currentTime should be seg.presentationStartTime
	seg.wallStartTime = timelineConverter.calcWallTimeForSegment(seg,isDynamic);seg.replacementTime = tManifest?tManifest:time;seg.replacementNumber = getNumberForSegment(seg,index);url = replaceTokenForTemplate(url,'Number',seg.replacementNumber);url = replaceTokenForTemplate(url,'Time',seg.replacementTime);seg.media = url;seg.mediaRange = range;seg.availabilityIdx = index;return seg;}function getSegmentByIndex(index,representation){if(!representation || !representation.segments)return null;var ln=representation.segments.length;var seg=undefined,i=undefined;if(index < ln){seg = representation.segments[index];if(seg && seg.availabilityIdx === index){return seg;}}for(i = 0;i < ln;i++) {seg = representation.segments[i];if(seg && seg.availabilityIdx === index){return seg;}}return null;}function decideSegmentListRangeForTemplate(timelineConverter,isDynamic,representation,requestedTime,index,givenAvailabilityUpperLimit){var duration=representation.segmentDuration;var minBufferTime=representation.adaptation.period.mpd.manifest.minBufferTime;var availabilityWindow=representation.segmentAvailabilityRange;var periodRelativeRange={start:timelineConverter.calcPeriodRelativeTimeFromMpdRelativeTime(representation,availabilityWindow.start),end:timelineConverter.calcPeriodRelativeTimeFromMpdRelativeTime(representation,availabilityWindow.end)};var currentSegmentList=representation.segments;var availabilityLowerLimit=2 * duration;var availabilityUpperLimit=givenAvailabilityUpperLimit || Math.max(2 * minBufferTime,10 * duration);var originAvailabilityTime=NaN;var originSegment=null;var start=undefined,end=undefined,range=undefined;periodRelativeRange.start = Math.max(periodRelativeRange.start,0);if(isDynamic && !timelineConverter.isTimeSyncCompleted()){start = Math.floor(periodRelativeRange.start / duration);end = Math.floor(periodRelativeRange.end / duration);range = {start:start,end:end};return range;} // if segments exist we should try to find the latest buffered time, which is the presentation time of the
	// segment for the current index
	if(currentSegmentList && currentSegmentList.length > 0){originSegment = getSegmentByIndex(index,representation);if(originSegment){originAvailabilityTime = timelineConverter.calcPeriodRelativeTimeFromMpdRelativeTime(representation,originSegment.presentationStartTime);}else {originAvailabilityTime = index > 0?index * duration:timelineConverter.calcPeriodRelativeTimeFromMpdRelativeTime(representation,requestedTime);}}else { // If no segments exist, but index > 0, it means that we switch to the other representation, so
	// we should proceed from this time.
	// Otherwise we should start from the beginning for static mpds or from the end (live edge) for dynamic mpds
	originAvailabilityTime = index > 0?index * duration:isDynamic?periodRelativeRange.end:periodRelativeRange.start;} // segment list should not be out of the availability window range
	start = Math.floor(Math.max(originAvailabilityTime - availabilityLowerLimit,periodRelativeRange.start) / duration);end = Math.floor(Math.min(start + availabilityUpperLimit / duration,periodRelativeRange.end / duration));range = {start:start,end:end};return range;}
	//# sourceMappingURL=SegmentsUtils.js.map


/***/ },
/* 41 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * Metrics Constants declaration
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var MetricsConstants=(function(){_createClass(MetricsConstants,[{key:'init',value:function init(){this.TCP_CONNECTION = 'TcpList';this.HTTP_REQUEST = 'HttpList';this.TRACK_SWITCH = 'RepSwitchList';this.BUFFER_LEVEL = 'BufferLevel';this.BUFFER_STATE = 'BufferState';this.DVR_INFO = 'DVRInfo';this.DROPPED_FRAMES = 'DroppedFrames';this.SCHEDULING_INFO = 'SchedulingInfo';this.REQUESTS_QUEUE = 'RequestsQueue';this.MANIFEST_UPDATE = 'ManifestUpdate';this.MANIFEST_UPDATE_STREAM_INFO = 'ManifestUpdatePeriodInfo';this.MANIFEST_UPDATE_TRACK_INFO = 'ManifestUpdateRepresentationInfo';this.PLAY_LIST = 'PlayList';this.DVB_ERRORS = 'DVBErrors';}}]);function MetricsConstants(){_classCallCheck(this,MetricsConstants);this.init();}return MetricsConstants;})();var constants=new MetricsConstants();exports['default'] = constants;module.exports = exports['default'];
	//# sourceMappingURL=MetricsConstants.js.map


/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var CommonEncryption=(function(){function CommonEncryption(){_classCallCheck(this,CommonEncryption);}_createClass(CommonEncryption,null,[{key:'findCencContentProtection', /**
	     * Find and return the ContentProtection element in the given array
	     * that indicates support for MPEG Common Encryption
	     *
	     * @param {Array} cpArray array of content protection elements
	     * @returns {Object|null} the Common Encryption content protection element or
	     * null if one was not found
	     */value:function findCencContentProtection(cpArray){var retVal=null;for(var i=0;i < cpArray.length;++i) {var cp=cpArray[i];if(cp.schemeIdUri.toLowerCase() === 'urn:mpeg:dash:mp4protection:2011' && cp.value.toLowerCase() === 'cenc')retVal = cp;}return retVal;} /**
	     * Returns just the data portion of a single PSSH
	     *
	     * @param {ArrayBuffer} pssh - the PSSH
	     * @return {ArrayBuffer} data portion of the PSSH
	     */},{key:'getPSSHData',value:function getPSSHData(pssh){var offset=8; // Box size and type fields
	var view=new DataView(pssh); // Read version
	var version=view.getUint8(offset);offset += 20; // Version (1), flags (3), system ID (16)
	if(version > 0){offset += 4 + 16 * view.getUint32(offset); // Key ID count (4) and All key IDs (16*count)
	}offset += 4; // Data size
	return pssh.slice(offset);} /**
	     * Returns the PSSH associated with the given key system from the concatenated
	     * list of PSSH boxes in the given initData
	     *
	     * @param {KeySystem} keySystem the desired
	     * key system
	     * @param {ArrayBuffer} initData 'cenc' initialization data.  Concatenated list of PSSH.
	     * @returns {ArrayBuffer|null} The PSSH box data corresponding to the given key system, null if not found
	     * or null if a valid association could not be found.
	     */},{key:'getPSSHForKeySystem',value:function getPSSHForKeySystem(keySystem,initData){var psshList=CommonEncryption.parsePSSHList(initData);if(psshList.hasOwnProperty(keySystem.uuid.toLowerCase())){return psshList[keySystem.uuid.toLowerCase()];}return null;} /**
	     * Parse a standard common encryption PSSH which contains a simple
	     * base64-encoding of the init data
	     *
	     * @param {Object} cpData the ContentProtection element
	     * @param {BASE64} BASE64 reference
	     * @returns {ArrayBuffer|null} the init data or null if not found
	     */},{key:'parseInitDataFromContentProtection',value:function parseInitDataFromContentProtection(cpData,BASE64){if('pssh' in cpData){return BASE64.decodeArray(cpData.pssh.__text).buffer;}return null;} /**
	     * Parses list of PSSH boxes into keysystem-specific PSSH data
	     *
	     * @param {ArrayBuffer} data - the concatenated list of PSSH boxes as provided by
	     * CDM as initialization data when CommonEncryption content is detected
	     * @returns {Object|Array} an object that has a property named according to each of
	     * the detected key system UUIDs (e.g. 00000000-0000-0000-0000-0000000000)
	     * and a ArrayBuffer (the entire PSSH box) as the property value
	     */},{key:'parsePSSHList',value:function parsePSSHList(data){if(data === null)return [];var dv=new DataView(data.buffer || data); // data.buffer first for Uint8Array support
	var done=false;var pssh={}; // TODO: Need to check every data read for end of buffer
	var byteCursor=0;while(!done) {var size=undefined,nextBox=undefined,version=undefined,systemID=undefined,psshDataSize=undefined;var boxStart=byteCursor;if(byteCursor >= dv.buffer.byteLength)break; /* Box size */size = dv.getUint32(byteCursor);nextBox = byteCursor + size;byteCursor += 4; /* Verify PSSH */if(dv.getUint32(byteCursor) !== 0x70737368){byteCursor = nextBox;continue;}byteCursor += 4; /* Version must be 0 or 1 */version = dv.getUint8(byteCursor);if(version !== 0 && version !== 1){byteCursor = nextBox;continue;}byteCursor++;byteCursor += 3; /* skip flags */ // 16-byte UUID/SystemID
	systemID = '';var i=undefined,val=undefined;for(i = 0;i < 4;i++) {val = dv.getUint8(byteCursor + i).toString(16);systemID += val.length === 1?'0' + val:val;}byteCursor += 4;systemID += '-';for(i = 0;i < 2;i++) {val = dv.getUint8(byteCursor + i).toString(16);systemID += val.length === 1?'0' + val:val;}byteCursor += 2;systemID += '-';for(i = 0;i < 2;i++) {val = dv.getUint8(byteCursor + i).toString(16);systemID += val.length === 1?'0' + val:val;}byteCursor += 2;systemID += '-';for(i = 0;i < 2;i++) {val = dv.getUint8(byteCursor + i).toString(16);systemID += val.length === 1?'0' + val:val;}byteCursor += 2;systemID += '-';for(i = 0;i < 6;i++) {val = dv.getUint8(byteCursor + i).toString(16);systemID += val.length === 1?'0' + val:val;}byteCursor += 6;systemID = systemID.toLowerCase(); /* PSSH Data Size */psshDataSize = dv.getUint32(byteCursor);byteCursor += 4; /* PSSH Data */pssh[systemID] = dv.buffer.slice(boxStart,nextBox);byteCursor = nextBox;}return pssh;}}]);return CommonEncryption;})();exports['default'] = CommonEncryption;module.exports = exports['default'];
	//# sourceMappingURL=CommonEncryption.js.map


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(32);
	
	var _Actions = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 44 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 45 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(107);
	var setInnerHTML = __webpack_require__(80);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(115);
	var setTextContent = __webpack_require__(191);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var invariant = __webpack_require__(3);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(524);
	var ReactInstrumentation = __webpack_require__(23);
	
	var warning = __webpack_require__(9);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactBaseClasses = __webpack_require__(209);
	var ReactChildren = __webpack_require__(588);
	var ReactDOMFactories = __webpack_require__(589);
	var ReactElement = __webpack_require__(52);
	var ReactPropTypes = __webpack_require__(590);
	var ReactVersion = __webpack_require__(591);
	
	var createReactClass = __webpack_require__(592);
	var onlyChild = __webpack_require__(596);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactCurrentOwner = __webpack_require__(29);
	
	var warning = __webpack_require__(9);
	var canDefineProperty = __webpack_require__(213);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(211);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Icons = function (_Component) {
	    _inherits(Icons, _Component);
	
	    function Icons() {
	        _classCallCheck(this, Icons);
	
	        return _possibleConstructorReturn(this, (Icons.__proto__ || Object.getPrototypeOf(Icons)).apply(this, arguments));
	    }
	
	    _createClass(Icons, [{
	        key: "render",
	        value: function render() {
	
	            var blackOrWhite = this.props.flipColor ? "#393939" : "#fff";
	            var green = "#00FF40";
	
	            switch (this.props.type) {
	                case "logo":
	                    return _react2.default.createElement(
	                        "svg",
	                        { xmlns: "http://www.w3.org/2000/svg", width: "144", height: "17", viewBox: "0 0 144 17" },
	                        _react2.default.createElement(
	                            "g",
	                            { fill: blackOrWhite },
	                            _react2.default.createElement("path", { d: "M143.9 8.6C143.9 4 141.4 0.9 135.9 0.9L129 0.9 130.8 2.7 130.8 14.9 129 16.7 135.9 16.7C140.1 16.7 143.9 13.2 143.9 8.6L143.9 8.6ZM139.2 9.4C139.2 13.4 138.4 15.1 135.3 15.1L134.9 15.1 134.9 2.2 135.1 2.2C138 2.2 139.2 5.2 139.2 9.4L139.2 9.4ZM121.8 16.7L128.8 16.7 127.9 15.3 122.1 0 119.8 0.9 114.9 14.5 113.3 16.7 118.6 16.7 116.4 14.5 117.4 11.8 122.5 11.8 123.9 15.3 121.8 16.7ZM122.1 10.4L117.8 10.4 119.9 4.6 122.1 10.4ZM114.4 8.8C114.4 4.3 111.3 0.6 106.6 0.6 101.9 0.6 98.9 4.3 98.9 8.8 98.9 13.3 102 17 106.6 17 111.4 17 114.4 13.3 114.4 8.8L114.4 8.8ZM110.1 10.4C110.1 13.4 109.2 15.2 107.5 15.2 104.8 15.2 103.2 11.4 103.2 7.2 103.2 4.2 104.2 2.4 105.9 2.4 108.6 2.4 110.1 6.3 110.1 10.4L110.1 10.4ZM92.9 8.7L92.9 8.7C96 8.2 97.7 7 97.7 5 97.7 2.5 95.8 0.9 92.5 0.9L84.3 0.9 86 2.7 86 14.9 84.3 16.7 92.2 16.7 90.1 14.9 90.1 9.1 94.5 16.7 99.7 16.7 98.1 15.2 94.5 9.2 92.9 8.7ZM90.8 8.3L90.1 8.3 90.1 2.5 91 2.5C92.3 2.5 93.7 2.9 93.7 5.3 93.7 7.6 92.6 8.3 90.8 8.3L90.8 8.3ZM75.4 9.4L80.2 0.9 75 0.9 76.7 4.2 74.7 7.4 74.7 7.4 71.8 2.7 72.8 0.9 65.9 0.9 71.3 9.9 71.3 14.9 69.1 16.7 77.5 16.7 75.4 14.9 75.4 9.4ZM61.4 2.7L64 0.9 55.5 0.9 57.3 2.7 57.3 14.9 55.5 16.7 67.3 16.7 68.3 11.4 63.7 15.4 61.4 15.4 61.4 2.7ZM55.3 8.8C55.3 4.3 52.2 0.6 47.5 0.6 42.8 0.6 39.8 4.3 39.8 8.8 39.8 13.3 42.8 17 47.5 17 52.2 17 55.3 13.3 55.3 8.8L55.3 8.8ZM51 7.2C51 11.4 49.4 15.2 46.6 15.2 44.9 15.2 44.1 13.4 44.1 10.4 44.1 6.3 45.5 2.4 48.3 2.4 50 2.4 51 4.2 51 7.2L51 7.2ZM37.7 14.9L37.7 2.7 39.5 0.9 31.8 0.9 33.6 2.7 33.6 7.7 28.6 7.7 28.6 2.7 30.5 0.9 22.8 0.9 24.6 2.7 24.6 14.9 22.8 16.7 30.5 16.7 28.6 14.9 28.6 9.1 33.6 9.1 33.6 14.9 31.8 16.7 39.5 16.7 37.7 14.9ZM14.1 9.7L17.9 9.7 17.9 9C17.9 7.8 16.9 6.7 15.2 6.7 13.4 6.7 12.2 8.4 12.2 10.3 12.2 12.1 13.2 13.7 15.2 13.7 16.6 13.7 17.5 12.8 18 11.2L17.7 11.1C17.2 11.5 16.8 11.9 16 11.9 15.1 11.9 14.1 11.2 14.1 9.7L14.1 9.7ZM14.1 8.9C14.3 8.1 14.7 7.7 15.1 7.7 15.7 7.7 15.9 8 15.9 8.7L15.9 8.9 14.1 8.9ZM8.4 13.5L12.2 13.5 11.4 12.6 11.4 8.8C11.4 7.5 10.4 6.7 9.1 6.7 8.2 6.7 7.5 7.1 7.1 7.6L7.1 7.6 7.1 3.7 4.2 3.8 4.9 4.8 4.9 12.6 4.2 13.5 7.9 13.5 7.2 12.6 7.2 8.4 9.2 8.4 9.2 12.6 8.4 13.5ZM4.2 6.8L3 6.8 3 4.5 0 6.8 0 7.4 0.7 7.6 0.7 12.1C0.7 13.1 1.4 13.7 2.3 13.7 3.1 13.7 4 13.2 4.4 12.2L3 12.2 3 7.8 4.2 7.8 4.2 6.8Z" })
	                        )
	                    );
	                case "share":
	                    return _react2.default.createElement(
	                        "svg",
	                        { xmlns: "http://www.w3.org/2000/svg", width: "21", height: "16", viewBox: "0 0 21 16" },
	                        _react2.default.createElement(
	                            "g",
	                            { fill: blackOrWhite },
	                            _react2.default.createElement("path", { d: "M13.1 5.2C7 5.2 1.6 9.3 0.1 15.2L0 15.5C3.4 12.2 7.9 10.3 12.7 10.3L13.1 10.3 13.1 15.5 21 7.8 13.1 0 13.1 5.2Z" })
	                        )
	                    );
	                case "clock":
	                    return _react2.default.createElement(
	                        "svg",
	                        { xmlns: "http://www.w3.org/2000/svg", width: "9", height: "9", viewBox: "0 0 9 9" },
	                        _react2.default.createElement(
	                            "g",
	                            { fill: green },
	                            _react2.default.createElement("path", { d: "M4.5 9C2 9 0 7 0 4.5 0 2 2 0 4.5 0 7 0 9 2 9 4.5 9 7 7 9 4.5 9ZM4.7 4.4L4.7 2.4C4.7 2.3 4.6 2.2 4.4 2.2 4.3 2.2 4.2 2.3 4.2 2.4L4.2 4.6 5.6 6C5.6 6.1 5.7 6.1 5.8 6.1 5.8 6.1 5.9 6.1 6 6 6.1 5.9 6.1 5.8 6 5.7L4.7 4.4Z", fill: "#00FF40" }),
	                            _react2.default.createElement("path", { d: "M4.5 2.5L4.5 4.5" }),
	                            _react2.default.createElement("path", { d: "M5.4 4.4L5.4 6.4" })
	                        )
	                    );
	                case "pin":
	                    return _react2.default.createElement(
	                        "svg",
	                        { xmlns: "http://www.w3.org/2000/svg", width: "7", height: "11", viewBox: "0 0 7 11" },
	                        _react2.default.createElement(
	                            "g",
	                            { fill: green },
	                            _react2.default.createElement("path", { d: "M3.5 0C1.6 0 0 1.6 0 3.5 0 5.4 3.5 10.2 3.5 10.2 3.5 10.2 7 5.4 7 3.5 7 1.6 5.4 0 3.5 0ZM3.5 4.5C3 4.5 2.5 4 2.5 3.5 2.5 3 3 2.5 3.5 2.5 4 2.5 4.5 3 4.5 3.5 4.5 4 4 4.5 3.5 4.5Z" })
	                        )
	                    );
	                case "play":
	                    return _react2.default.createElement(
	                        "svg",
	                        { width: "100%", height: "100%", viewBox: "0 0 9 18", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Symbols", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "square" },
	                            _react2.default.createElement(
	                                "g",
	                                { id: "Play-Button", transform: "translate(-13.000000, -9.000000)", stroke: "#393939" },
	                                _react2.default.createElement(
	                                    "g",
	                                    { id: "Group-2", transform: "translate(13.000000, 9.000000)" },
	                                    _react2.default.createElement("path", { d: "M0,0.5 L9,8.98528137", id: "Line" }),
	                                    _react2.default.createElement("path", { d: "M0,17.4852814 L8.7312825,9.25334929", id: "Line" })
	                                )
	                            )
	                        )
	                    );
	                case "audio":
	                    return _react2.default.createElement(
	                        "svg",
	                        { width: "12px", height: "16px", viewBox: "0 0 12 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Mobiel", stroke: "none", strokeWidth: "1", fill: this.props.flipColor ? "none" : "#fff", fillRule: "evenodd" },
	                            _react2.default.createElement(
	                                "g",
	                                { id: "Roadmovie", transform: "translate(-15.000000, -13.000000)", stroke: "#fff" },
	                                _react2.default.createElement(
	                                    "g",
	                                    { id: "Sound-Off-\u2013-Wit", transform: "translate(15.000000, 14.000000)" },
	                                    _react2.default.createElement("polyline", { id: "Line", strokeLinecap: "square", points: "5 9.5 11.5 14 11.5 0 5 4.5" }),
	                                    _react2.default.createElement("rect", { id: "Rectangle-2", x: "0.5", y: "4.5", width: "4", height: "5" })
	                                )
	                            )
	                        )
	                    );
	                case "fullscreen":
	                    return _react2.default.createElement(
	                        "svg",
	                        { width: "19px", height: "19px", viewBox: "0 0 19 19", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Symbols", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	                            _react2.default.createElement(
	                                "g",
	                                { id: "Fullscreen-View-Button-B", transform: "translate(-8.000000, -8.000000)", fill: "#fff" },
	                                _react2.default.createElement(
	                                    "g",
	                                    { id: "Fullscreen-View", transform: "translate(8.000000, 8.000000)" },
	                                    _react2.default.createElement(
	                                        "g",
	                                        { id: "Group" },
	                                        _react2.default.createElement("polygon", { id: "Shape", points: "1 7.41860465 0 7.41860465 0 0 6.75 0 6.75 1.02325581 1 1.02325581" }),
	                                        _react2.default.createElement("polygon", { id: "Shape", points: "19 7.41860465 18 7.41860465 18.025 1.02325581 12.25 1.02325581 12.25 0 19 0" }),
	                                        _react2.default.createElement("polygon", { id: "Shape", points: "6.75 19 0 19 0 11.5813953 1 11.5813953 1 17.9767442 6.75 17.9767442" }),
	                                        _react2.default.createElement("polygon", { id: "Shape", points: "19 19 12.25 19 12.25 17.9767442 18.025 17.9767442 18.025 11.5813953 19 11.5813953" })
	                                    )
	                                )
	                            )
	                        )
	                    );
	                case "endOfStoryArrow":
	                    return _react2.default.createElement(
	                        "svg",
	                        { width: "18px", height: "36px", viewBox: "0 0 18 36", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	                        _react2.default.createElement(
	                            "g",
	                            { id: "Mobiel", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "square" },
	                            _react2.default.createElement(
	                                "g",
	                                { id: "Verhaal-Long-Read", transform: "translate(-152.000000, -5763.000000)", stroke: "#00FF40" },
	                                _react2.default.createElement(
	                                    "g",
	                                    { id: "Footer", transform: "translate(86.000000, 5763.000000)" },
	                                    _react2.default.createElement(
	                                        "g",
	                                        { id: "Einde-verhaal", transform: "translate(62.000000, 0.000000)" },
	                                        _react2.default.createElement("path", { d: "M13.1340361,0.5 L13.1340361,34.5147027", id: "Line-Copy-3" }),
	                                        _react2.default.createElement(
	                                            "g",
	                                            { id: "Group-2", transform: "translate(13.169015, 29.855205) rotate(92.000000) translate(-13.169015, -29.855205) translate(8.169015, 20.855205)" },
	                                            _react2.default.createElement("path", { d: "M0.963449621,0.406030198 L9.96344962,8.89131157", id: "Line" }),
	                                            _react2.default.createElement("path", { d: "M0.963449621,17.3913116 L9.69473212,9.15937949", id: "Line" })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    );
	                default:
	                    return null;
	            }
	        }
	    }]);
	
	    return Icons;
	}(_react.Component);
	
	exports.default = Icons;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83).Buffer))

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key] = value;}return obj;}var _XHRLoader=__webpack_require__(372);var _XHRLoader2=_interopRequireDefault(_XHRLoader);var _FetchLoader=__webpack_require__(371);var _FetchLoader2=_interopRequireDefault(_FetchLoader);var _voMetricsHTTPRequest=__webpack_require__(16);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _utilsErrorHandler=__webpack_require__(152);var _utilsErrorHandler2=_interopRequireDefault(_utilsErrorHandler); /**
	 * @module HTTPLoader
	 * @description Manages download of resources via HTTP.
	 * @param {Object} cfg - dependancies from parent
	 */function HTTPLoader(cfg){cfg = cfg || {};var context=this.context;var errHandler=cfg.errHandler;var metricsModel=cfg.metricsModel;var mediaPlayerModel=cfg.mediaPlayerModel;var requestModifier=cfg.requestModifier;var useFetch=cfg.useFetch || false;var instance=undefined;var requests=undefined;var delayedRequests=undefined;var retryTimers=undefined;var downloadErrorToRequestTypeMap=undefined;function setup(){var _downloadErrorToRequestTypeMap;requests = [];delayedRequests = [];retryTimers = [];downloadErrorToRequestTypeMap = (_downloadErrorToRequestTypeMap = {},_defineProperty(_downloadErrorToRequestTypeMap,_voMetricsHTTPRequest.HTTPRequest.MPD_TYPE,_utilsErrorHandler2['default'].DOWNLOAD_ERROR_ID_MANIFEST),_defineProperty(_downloadErrorToRequestTypeMap,_voMetricsHTTPRequest.HTTPRequest.XLINK_EXPANSION_TYPE,_utilsErrorHandler2['default'].DOWNLOAD_ERROR_ID_XLINK),_defineProperty(_downloadErrorToRequestTypeMap,_voMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE,_utilsErrorHandler2['default'].DOWNLOAD_ERROR_ID_INITIALIZATION),_defineProperty(_downloadErrorToRequestTypeMap,_voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE,_utilsErrorHandler2['default'].DOWNLOAD_ERROR_ID_CONTENT),_defineProperty(_downloadErrorToRequestTypeMap,_voMetricsHTTPRequest.HTTPRequest.INDEX_SEGMENT_TYPE,_utilsErrorHandler2['default'].DOWNLOAD_ERROR_ID_CONTENT),_defineProperty(_downloadErrorToRequestTypeMap,_voMetricsHTTPRequest.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE,_utilsErrorHandler2['default'].DOWNLOAD_ERROR_ID_CONTENT),_defineProperty(_downloadErrorToRequestTypeMap,_voMetricsHTTPRequest.HTTPRequest.OTHER_TYPE,_utilsErrorHandler2['default'].DOWNLOAD_ERROR_ID_CONTENT),_downloadErrorToRequestTypeMap);}function internalLoad(config,remainingAttempts){var request=config.request;var traces=[];var firstProgress=true;var needFailureReport=true;var requestStartTime=new Date();var lastTraceTime=requestStartTime;var lastTraceReceivedCount=0;var httpRequest=undefined;if(!requestModifier || !metricsModel || !errHandler){throw new Error('config object is not correct or missing');}var handleLoaded=function handleLoaded(success){needFailureReport = false;request.requestStartDate = requestStartTime;request.requestEndDate = new Date();request.firstByteDate = request.firstByteDate || requestStartTime;if(!request.checkExistenceOnly){metricsModel.addHttpRequest(request.mediaType,null,request.type,request.url,httpRequest.response?httpRequest.response.responseURL:null,request.serviceLocation || null,request.range || null,request.requestStartDate,request.firstByteDate,request.requestEndDate,httpRequest.response?httpRequest.response.status:null,request.duration,httpRequest.response && httpRequest.response.getAllResponseHeaders?httpRequest.response.getAllResponseHeaders():httpRequest.response.responseHeaders,success?traces:null);}};var onloadend=function onloadend(){if(requests.indexOf(httpRequest) === -1){return;}else {requests.splice(requests.indexOf(httpRequest),1);}if(needFailureReport){handleLoaded(false);if(remainingAttempts > 0){remainingAttempts--;retryTimers.push(setTimeout(function(){internalLoad(config,remainingAttempts);},mediaPlayerModel.getRetryIntervalForType(request.type)));}else {errHandler.downloadError(downloadErrorToRequestTypeMap[request.type],request.url,request);if(config.error){config.error(request,'error',httpRequest.response.statusText);}if(config.complete){config.complete(request,httpRequest.response.statusText);}}}};var progress=function progress(event){var currentTime=new Date();if(firstProgress){firstProgress = false;if(!event.lengthComputable || event.lengthComputable && event.total !== event.loaded){request.firstByteDate = currentTime;}}if(event.lengthComputable){request.bytesLoaded = event.loaded;request.bytesTotal = event.total;}if(!event.noTrace){traces.push({s:lastTraceTime,d:currentTime.getTime() - lastTraceTime.getTime(),b:[event.loaded?event.loaded - lastTraceReceivedCount:0]});lastTraceTime = currentTime;lastTraceReceivedCount = event.loaded;}if(config.progress && event.data){config.progress(event.data);}};var onload=function onload(){if(httpRequest.response.status >= 200 && httpRequest.response.status <= 299){handleLoaded(true);if(config.success){config.success(httpRequest.response.response,httpRequest.response.statusText,httpRequest.response.responseURL);}if(config.complete){config.complete(request,httpRequest.response.statusText);}}};var onabort=function onabort(){if(config.abort){config.abort(request);}};var loader=undefined;if(useFetch && window.fetch && request.responseType === 'arraybuffer'){loader = (0,_FetchLoader2['default'])(context).create({requestModifier:requestModifier});}else {loader = (0,_XHRLoader2['default'])(context).create({requestModifier:requestModifier});}var modifiedUrl=requestModifier.modifyRequestURL(request.url);var verb=request.checkExistenceOnly?_voMetricsHTTPRequest.HTTPRequest.HEAD:_voMetricsHTTPRequest.HTTPRequest.GET;var withCredentials=mediaPlayerModel.getXHRWithCredentialsForType(request.type);httpRequest = {url:modifiedUrl,method:verb,withCredentials:withCredentials,request:request,onload:onload,onend:onloadend,onerror:onloadend,progress:progress,onabort:onabort,loader:loader}; // Adds the ability to delay single fragment loading time to control buffer.
	var now=new Date().getTime();if(isNaN(request.delayLoadingTime) || now >= request.delayLoadingTime){ // no delay - just send
	requests.push(httpRequest);loader.load(httpRequest);}else {(function(){ // delay
	var delayedRequest={httpRequest:httpRequest};delayedRequests.push(delayedRequest);delayedRequest.delayTimeout = setTimeout(function(){if(delayedRequests.indexOf(delayedRequest) === -1){return;}else {delayedRequests.splice(delayedRequests.indexOf(delayedRequest),1);}try{requestStartTime = new Date();lastTraceTime = requestStartTime;requests.push(delayedRequest.httpRequest);loader.load(delayedRequest.httpRequest);}catch(e) {delayedRequest.httpRequest.onerror();}},request.delayLoadingTime - now);})();}} /**
	     * Initiates a download of the resource described by config.request
	     * @param {Object} config - contains request (FragmentRequest or derived type), and callbacks
	     * @memberof module:HTTPLoader
	     * @instance
	     */function load(config){if(config.request){internalLoad(config,mediaPlayerModel.getRetryAttemptsForType(config.request.type));}} /**
	     * Aborts any inflight downloads
	     * @memberof module:HTTPLoader
	     * @instance
	     */function abort(){retryTimers.forEach(function(t){return clearTimeout(t);});retryTimers = [];delayedRequests.forEach(function(x){return clearTimeout(x.delayTimeout);});delayedRequests = [];requests.forEach(function(x){ // abort will trigger onloadend which we don't want
	// when deliberately aborting inflight requests -
	// set them to undefined so they are not called
	x.onloadend = x.onerror = x.onprogress = undefined;x.loader.abort(x);x.onabort();});requests = [];}instance = {load:load,abort:abort};setup();return instance;}HTTPLoader.__dashjs_factory_name = 'HTTPLoader';var factory=_coreFactoryMaker2['default'].getClassFactory(HTTPLoader);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=HTTPLoader.js.map


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var EventPluginRegistry = __webpack_require__(108);
	var EventPluginUtils = __webpack_require__(109);
	var ReactErrorUtils = __webpack_require__(113);
	
	var accumulateInto = __webpack_require__(184);
	var forEachAccumulated = __webpack_require__(185);
	var invariant = __webpack_require__(3);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(56);
	var EventPluginUtils = __webpack_require__(109);
	
	var accumulateInto = __webpack_require__(184);
	var forEachAccumulated = __webpack_require__(185);
	var warning = __webpack_require__(9);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 58 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	var getEventTarget = __webpack_require__(118);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(13);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 61 */
10,
/* 62 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var EventsBase=(function(){function EventsBase(){_classCallCheck(this,EventsBase);}_createClass(EventsBase,[{key:'extend',value:function extend(events,config){if(!events)return;var override=config?config.override:false;var publicOnly=config?config.publicOnly:false;for(var evt in events) {if(!events.hasOwnProperty(evt) || this[evt] && !override)continue;if(publicOnly && events[evt].indexOf('public_') === -1)continue;this[evt] = events[evt];}}}]);return EventsBase;})();exports['default'] = EventsBase;module.exports = exports['default'];
	//# sourceMappingURL=EventsBase.js.map


/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc a base type for matching and converting types in manifest to
	 * something more useful
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var BaseMatcher=(function(){function BaseMatcher(test,converter){_classCallCheck(this,BaseMatcher);this._test = test;this._converter = converter;}_createClass(BaseMatcher,[{key:"test",get:function get(){return this._test;}},{key:"converter",get:function get(){return this._converter;}}]);return BaseMatcher;})();exports["default"] = BaseMatcher;module.exports = exports["default"];
	//# sourceMappingURL=BaseMatcher.js.map


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _rulesAbrABRRulesCollection=__webpack_require__(392);var _rulesAbrABRRulesCollection2=_interopRequireDefault(_rulesAbrABRRulesCollection);var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _constantsMetricsConstants=__webpack_require__(41);var _constantsMetricsConstants2=_interopRequireDefault(_constantsMetricsConstants);var _voBitrateInfo=__webpack_require__(154);var _voBitrateInfo2=_interopRequireDefault(_voBitrateInfo);var _modelsFragmentModel=__webpack_require__(66);var _modelsFragmentModel2=_interopRequireDefault(_modelsFragmentModel);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _rulesRulesContext=__webpack_require__(389);var _rulesRulesContext2=_interopRequireDefault(_rulesRulesContext);var _rulesSwitchRequest=__webpack_require__(27);var _rulesSwitchRequest2=_interopRequireDefault(_rulesSwitchRequest);var _rulesSwitchRequestHistory=__webpack_require__(390);var _rulesSwitchRequestHistory2=_interopRequireDefault(_rulesSwitchRequestHistory);var _rulesDroppedFramesHistory=__webpack_require__(388);var _rulesDroppedFramesHistory2=_interopRequireDefault(_rulesDroppedFramesHistory);var _rulesThroughputHistory=__webpack_require__(391);var _rulesThroughputHistory2=_interopRequireDefault(_rulesThroughputHistory);var _voMetricsHTTPRequest=__webpack_require__(16);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var ABANDON_LOAD='abandonload';var ALLOW_LOAD='allowload';var DEFAULT_VIDEO_BITRATE=1000;var DEFAULT_AUDIO_BITRATE=100;var QUALITY_DEFAULT=0;function AbrController(){var context=this.context;var debug=(0,_coreDebug2['default'])(context).getInstance();var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,log=undefined,abrRulesCollection=undefined,streamController=undefined,autoSwitchBitrate=undefined,topQualities=undefined,qualityDict=undefined,bitrateDict=undefined,ratioDict=undefined,streamProcessorDict=undefined,abandonmentStateDict=undefined,abandonmentTimeout=undefined,limitBitrateByPortal=undefined,usePixelRatioInLimitBitrateByPortal=undefined,windowResizeEventCalled=undefined,elementWidth=undefined,elementHeight=undefined,manifestModel=undefined,dashManifestModel=undefined,adapter=undefined,videoModel=undefined,mediaPlayerModel=undefined,domStorage=undefined,playbackIndex=undefined,switchHistoryDict=undefined,droppedFramesHistory=undefined,throughputHistory=undefined,isUsingBufferOccupancyABRDict=undefined,metricsModel=undefined,dashMetrics=undefined,useDeadTimeLatency=undefined;function setup(){log = debug.log.bind(instance);resetInitialSettings();}function registerStreamType(type,streamProcessor){switchHistoryDict[type] = (0,_rulesSwitchRequestHistory2['default'])(context).create();streamProcessorDict[type] = streamProcessor;abandonmentStateDict[type] = abandonmentStateDict[type] || {};abandonmentStateDict[type].state = ALLOW_LOAD;isUsingBufferOccupancyABRDict[type] = false;eventBus.on(_coreEventsEvents2['default'].LOADING_PROGRESS,onFragmentLoadProgress,this);if(type == _constantsConstants2['default'].VIDEO){eventBus.on(_coreEventsEvents2['default'].QUALITY_CHANGE_RENDERED,onQualityChangeRendered,this);droppedFramesHistory = (0,_rulesDroppedFramesHistory2['default'])(context).create();setElementSize();}eventBus.on(_coreEventsEvents2['default'].METRIC_ADDED,onMetricAdded,this);throughputHistory = (0,_rulesThroughputHistory2['default'])(context).create({mediaPlayerModel:mediaPlayerModel});}function unRegisterStreamType(type){delete streamProcessorDict[type];}function createAbrRulesCollection(){abrRulesCollection = (0,_rulesAbrABRRulesCollection2['default'])(context).create({metricsModel:metricsModel,dashMetrics:dashMetrics,mediaPlayerModel:mediaPlayerModel,adapter:adapter});abrRulesCollection.initialize();}function resetInitialSettings(){autoSwitchBitrate = {video:true,audio:true};topQualities = {};qualityDict = {};bitrateDict = {};ratioDict = {};abandonmentStateDict = {};streamProcessorDict = {};switchHistoryDict = {};isUsingBufferOccupancyABRDict = {};limitBitrateByPortal = false;useDeadTimeLatency = true;usePixelRatioInLimitBitrateByPortal = false;if(windowResizeEventCalled === undefined){windowResizeEventCalled = false;}playbackIndex = undefined;droppedFramesHistory = undefined;throughputHistory = undefined;clearTimeout(abandonmentTimeout);abandonmentTimeout = null;}function reset(){resetInitialSettings();eventBus.off(_coreEventsEvents2['default'].LOADING_PROGRESS,onFragmentLoadProgress,this);eventBus.off(_coreEventsEvents2['default'].QUALITY_CHANGE_RENDERED,onQualityChangeRendered,this);eventBus.off(_coreEventsEvents2['default'].METRIC_ADDED,onMetricAdded,this);if(abrRulesCollection){abrRulesCollection.reset();}}function setConfig(config){if(!config)return;if(config.streamController){streamController = config.streamController;}if(config.domStorage){domStorage = config.domStorage;}if(config.mediaPlayerModel){mediaPlayerModel = config.mediaPlayerModel;}if(config.metricsModel){metricsModel = config.metricsModel;}if(config.dashMetrics){dashMetrics = config.dashMetrics;}if(config.dashManifestModel){dashManifestModel = config.dashManifestModel;}if(config.adapter){adapter = config.adapter;}if(config.manifestModel){manifestModel = config.manifestModel;}if(config.videoModel){videoModel = config.videoModel;}}function onQualityChangeRendered(e){if(e.mediaType === _constantsConstants2['default'].VIDEO){playbackIndex = e.oldQuality;droppedFramesHistory.push(playbackIndex,videoModel.getPlaybackQuality());}}function onMetricAdded(e){if(e.metric === _constantsMetricsConstants2['default'].HTTP_REQUEST && e.value && e.value.type === _voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE && (e.mediaType === _constantsConstants2['default'].AUDIO || e.mediaType === _constantsConstants2['default'].VIDEO)){throughputHistory.push(e.mediaType,e.value,useDeadTimeLatency);}if(e.metric === _constantsMetricsConstants2['default'].BUFFER_LEVEL && (e.mediaType === _constantsConstants2['default'].AUDIO || e.mediaType === _constantsConstants2['default'].VIDEO)){updateIsUsingBufferOccupancyABR(e.mediaType,0.001 * e.value.level);}}function getTopQualityIndexFor(type,id){var idx=undefined;topQualities[id] = topQualities[id] || {};if(!topQualities[id].hasOwnProperty(type)){topQualities[id][type] = 0;}idx = checkMaxBitrate(topQualities[id][type],type);idx = checkMaxRepresentationRatio(idx,type,topQualities[id][type]);idx = checkPortalSize(idx,type);return idx;} /**
	     * @param {string} type
	     * @returns {number} A value of the initial bitrate, kbps
	     * @memberof AbrController#
	     */function getInitialBitrateFor(type){var savedBitrate=domStorage.getSavedBitrateSettings(type);if(!bitrateDict.hasOwnProperty(type)){if(ratioDict.hasOwnProperty(type)){var manifest=manifestModel.getValue();var representation=dashManifestModel.getAdaptationForType(manifest,0,type).Representation;if(Array.isArray(representation)){var repIdx=Math.max(Math.round(representation.length * ratioDict[type]) - 1,0);bitrateDict[type] = representation[repIdx].bandwidth;}else {bitrateDict[type] = 0;}}else if(!isNaN(savedBitrate)){bitrateDict[type] = savedBitrate;}else {bitrateDict[type] = type === _constantsConstants2['default'].VIDEO?DEFAULT_VIDEO_BITRATE:DEFAULT_AUDIO_BITRATE;}}return bitrateDict[type];} /**
	     * @param {string} type
	     * @param {number} value A value of the initial bitrate, kbps
	     * @memberof AbrController#
	     */function setInitialBitrateFor(type,value){bitrateDict[type] = value;}function getInitialRepresentationRatioFor(type){if(!ratioDict.hasOwnProperty(type)){return null;}return ratioDict[type];}function setInitialRepresentationRatioFor(type,value){ratioDict[type] = value;}function getMaxAllowedBitrateFor(type){if(bitrateDict.hasOwnProperty('max') && bitrateDict.max.hasOwnProperty(type)){return bitrateDict.max[type];}return NaN;}function getMinAllowedBitrateFor(type){if(bitrateDict.hasOwnProperty('min') && bitrateDict.min.hasOwnProperty(type)){return bitrateDict.min[type];}return NaN;} //TODO  change bitrateDict structure to hold one object for video and audio with initial and max values internal.
	// This means you need to update all the logic around initial bitrate DOMStorage, RebController etc...
	function setMaxAllowedBitrateFor(type,value){bitrateDict.max = bitrateDict.max || {};bitrateDict.max[type] = value;}function setMinAllowedBitrateFor(type,value){bitrateDict.min = bitrateDict.min || {};bitrateDict.min[type] = value;}function getMaxAllowedIndexFor(type){var maxBitrate=getMaxAllowedBitrateFor(type);if(maxBitrate){return getQualityForBitrate(streamProcessorDict[type].getMediaInfo(),maxBitrate);}else {return undefined;}}function getMinAllowedIndexFor(type){var minBitrate=getMinAllowedBitrateFor(type);if(minBitrate){var bitrateList=getBitrateList(streamProcessorDict[type].getMediaInfo()); // This returns the quality index <= for the given bitrate
	var minIdx=getQualityForBitrate(streamProcessorDict[type].getMediaInfo(),minBitrate);if(bitrateList[minIdx] && minIdx < bitrateList.length - 1 && bitrateList[minIdx].bitrate < minBitrate * 1000){minIdx++; // Go to the next bitrate
	}return minIdx;}else {return undefined;}}function getMaxAllowedRepresentationRatioFor(type){if(ratioDict.hasOwnProperty('max') && ratioDict.max.hasOwnProperty(type)){return ratioDict.max[type];}return 1;}function setMaxAllowedRepresentationRatioFor(type,value){ratioDict.max = ratioDict.max || {};ratioDict.max[type] = value;}function getAutoSwitchBitrateFor(type){return autoSwitchBitrate[type];}function setAutoSwitchBitrateFor(type,value){autoSwitchBitrate[type] = value;}function getLimitBitrateByPortal(){return limitBitrateByPortal;}function setLimitBitrateByPortal(value){limitBitrateByPortal = value;}function getUsePixelRatioInLimitBitrateByPortal(){return usePixelRatioInLimitBitrateByPortal;}function setUsePixelRatioInLimitBitrateByPortal(value){usePixelRatioInLimitBitrateByPortal = value;}function getUseDeadTimeLatency(){return useDeadTimeLatency;}function setUseDeadTimeLatency(value){useDeadTimeLatency = value;}function checkPlaybackQuality(type){if(type && streamProcessorDict && streamProcessorDict[type]){var streamInfo=streamProcessorDict[type].getStreamInfo();var streamId=streamInfo?streamInfo.id:null;var oldQuality=getQualityFor(type);var rulesContext=(0,_rulesRulesContext2['default'])(context).create({abrController:instance,streamProcessor:streamProcessorDict[type],currentValue:oldQuality,switchHistory:switchHistoryDict[type],droppedFramesHistory:droppedFramesHistory,useBufferOccupancyABR:useBufferOccupancyABR(type)});if(droppedFramesHistory){var playbackQuality=videoModel.getPlaybackQuality();if(playbackQuality){droppedFramesHistory.push(playbackIndex,playbackQuality);}}if(getAutoSwitchBitrateFor(type)){var minIdx=getMinAllowedIndexFor(type);var topQualityIdx=getTopQualityIndexFor(type,streamId);var switchRequest=abrRulesCollection.getMaxQuality(rulesContext);var newQuality=switchRequest.quality;if(minIdx !== undefined && newQuality < minIdx){newQuality = minIdx;}if(newQuality > topQualityIdx){newQuality = topQualityIdx;}switchHistoryDict[type].push({oldValue:oldQuality,newValue:newQuality});if(newQuality > _rulesSwitchRequest2['default'].NO_CHANGE && newQuality != oldQuality){if(abandonmentStateDict[type].state === ALLOW_LOAD || newQuality > oldQuality){changeQuality(type,oldQuality,newQuality,topQualityIdx,switchRequest.reason);}}else if(debug.getLogToBrowserConsole()){var bufferLevel=dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(type));log('AbrController (' + type + ') stay on ' + oldQuality + '/' + topQualityIdx + ' (buffer: ' + bufferLevel + ')');}}}}function setPlaybackQuality(type,streamInfo,newQuality,reason){var id=streamInfo.id;var oldQuality=getQualityFor(type);var isInt=newQuality !== null && !isNaN(newQuality) && newQuality % 1 === 0;if(!isInt)throw new Error('argument is not an integer');var topQualityIdx=getTopQualityIndexFor(type,id);if(newQuality !== oldQuality && newQuality >= 0 && newQuality <= topQualityIdx){changeQuality(type,oldQuality,newQuality,topQualityIdx,reason);}}function changeQuality(type,oldQuality,newQuality,topQualityIdx,reason){if(type && streamProcessorDict[type]){var streamInfo=streamProcessorDict[type].getStreamInfo();var id=streamInfo?streamInfo.id:null;if(debug.getLogToBrowserConsole()){var bufferLevel=dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(type));log('AbrController (' + type + ') switch from ' + oldQuality + ' to ' + newQuality + '/' + topQualityIdx + ' (buffer: ' + bufferLevel + ') ' + (reason?JSON.stringify(reason):'.'));}setQualityFor(type,id,newQuality);eventBus.trigger(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED,{mediaType:type,streamInfo:streamInfo,oldQuality:oldQuality,newQuality:newQuality,reason:reason});}}function setAbandonmentStateFor(type,state){abandonmentStateDict[type].state = state;}function getAbandonmentStateFor(type){return abandonmentStateDict[type]?abandonmentStateDict[type].state:null;} /**
	     * @param {MediaInfo} mediaInfo
	     * @param {number} bitrate A bitrate value, kbps
	     * @param {number} latency Expected latency of connection, ms
	     * @returns {number} A quality index <= for the given bitrate
	     * @memberof AbrController#
	     */function getQualityForBitrate(mediaInfo,bitrate,latency){if(useDeadTimeLatency && latency && streamProcessorDict[mediaInfo.type].getCurrentRepresentationInfo() && streamProcessorDict[mediaInfo.type].getCurrentRepresentationInfo().fragmentDuration){latency = latency / 1000;var fragmentDuration=streamProcessorDict[mediaInfo.type].getCurrentRepresentationInfo().fragmentDuration;if(latency > fragmentDuration){return 0;}else {var deadTimeRatio=latency / fragmentDuration;bitrate = bitrate * (1 - deadTimeRatio);}}var bitrateList=getBitrateList(mediaInfo);if(!bitrateList || bitrateList.length === 0){return QUALITY_DEFAULT;}for(var i=bitrateList.length - 1;i >= 0;i--) {var bitrateInfo=bitrateList[i];if(bitrate * 1000 >= bitrateInfo.bitrate){return i;}}return 0;} /**
	     * @param {MediaInfo} mediaInfo
	     * @returns {Array|null} A list of {@link BitrateInfo} objects
	     * @memberof AbrController#
	     */function getBitrateList(mediaInfo){if(!mediaInfo || !mediaInfo.bitrateList)return null;var bitrateList=mediaInfo.bitrateList;var type=mediaInfo.type;var infoList=[];var bitrateInfo=undefined;for(var i=0,ln=bitrateList.length;i < ln;i++) {bitrateInfo = new _voBitrateInfo2['default']();bitrateInfo.mediaType = type;bitrateInfo.qualityIndex = i;bitrateInfo.bitrate = bitrateList[i].bandwidth;bitrateInfo.width = bitrateList[i].width;bitrateInfo.height = bitrateList[i].height;bitrateInfo.scanType = bitrateList[i].scanType;infoList.push(bitrateInfo);}return infoList;}function updateIsUsingBufferOccupancyABR(mediaType,bufferLevel){var strategy=mediaPlayerModel.getABRStrategy();if(strategy === _constantsConstants2['default'].ABR_STRATEGY_BOLA){isUsingBufferOccupancyABRDict[mediaType] = true;return;}else if(strategy === _constantsConstants2['default'].ABR_STRATEGY_THROUGHPUT){isUsingBufferOccupancyABRDict[mediaType] = false;return;} // else ABR_STRATEGY_DYNAMIC
	var stableBufferTime=mediaPlayerModel.getStableBufferTime();var switchOnThreshold=stableBufferTime;var switchOffThreshold=0.5 * stableBufferTime;var useBufferABR=isUsingBufferOccupancyABRDict[mediaType];var newUseBufferABR=bufferLevel > (useBufferABR?switchOffThreshold:switchOnThreshold); // use hysteresis to avoid oscillating rules
	isUsingBufferOccupancyABRDict[mediaType] = newUseBufferABR;if(newUseBufferABR !== useBufferABR){if(newUseBufferABR){log('AbrController (' + mediaType + ') switching from throughput to buffer occupancy ABR rule (buffer: ' + bufferLevel.toFixed(3) + ').');}else {log('AbrController (' + mediaType + ') switching from buffer occupancy to throughput ABR rule (buffer: ' + bufferLevel.toFixed(3) + ').');}}}function useBufferOccupancyABR(mediaType){return isUsingBufferOccupancyABRDict[mediaType];}function getThroughputHistory(){return throughputHistory;}function updateTopQualityIndex(mediaInfo){var type=mediaInfo.type;var streamId=mediaInfo.streamInfo.id;var max=mediaInfo.representationCount - 1;setTopQualityIndex(type,streamId,max);return max;}function isPlayingAtTopQuality(streamInfo){var streamId=streamInfo.id;var audioQuality=getQualityFor(_constantsConstants2['default'].AUDIO);var videoQuality=getQualityFor(_constantsConstants2['default'].VIDEO);var isAtTop=audioQuality === getTopQualityIndexFor(_constantsConstants2['default'].AUDIO,streamId) && videoQuality === getTopQualityIndexFor(_constantsConstants2['default'].VIDEO,streamId);return isAtTop;}function getQualityFor(type){if(type && streamProcessorDict[type]){var streamInfo=streamProcessorDict[type].getStreamInfo();var id=streamInfo?streamInfo.id:null;var quality=undefined;if(id){qualityDict[id] = qualityDict[id] || {};if(!qualityDict[id].hasOwnProperty(type)){qualityDict[id][type] = QUALITY_DEFAULT;}quality = qualityDict[id][type];return quality;}}return QUALITY_DEFAULT;}function setQualityFor(type,id,value){qualityDict[id] = qualityDict[id] || {};qualityDict[id][type] = value;}function setTopQualityIndex(type,id,value){topQualities[id] = topQualities[id] || {};topQualities[id][type] = value;}function checkMaxBitrate(idx,type){var newIdx=idx;if(!streamProcessorDict[type]){return newIdx;}var minIdx=getMinAllowedIndexFor(type);if(minIdx !== undefined){newIdx = Math.max(idx,minIdx);}var maxIdx=getMaxAllowedIndexFor(type);if(maxIdx !== undefined){newIdx = Math.min(newIdx,maxIdx);}return newIdx;}function checkMaxRepresentationRatio(idx,type,maxIdx){var maxRepresentationRatio=getMaxAllowedRepresentationRatioFor(type);if(isNaN(maxRepresentationRatio) || maxRepresentationRatio >= 1 || maxRepresentationRatio < 0){return idx;}return Math.min(idx,Math.round(maxIdx * maxRepresentationRatio));}function setWindowResizeEventCalled(value){windowResizeEventCalled = value;}function setElementSize(){if(videoModel){var hasPixelRatio=usePixelRatioInLimitBitrateByPortal && window.hasOwnProperty('devicePixelRatio');var pixelRatio=hasPixelRatio?window.devicePixelRatio:1;elementWidth = videoModel.getClientWidth() * pixelRatio;elementHeight = videoModel.getClientHeight() * pixelRatio;}}function checkPortalSize(idx,type){if(type !== _constantsConstants2['default'].VIDEO || !limitBitrateByPortal || !streamProcessorDict[type]){return idx;}if(!windowResizeEventCalled){setElementSize();}var manifest=manifestModel.getValue();var representation=dashManifestModel.getAdaptationForType(manifest,0,type).Representation;var newIdx=idx;if(elementWidth > 0 && elementHeight > 0){while(newIdx > 0 && representation[newIdx] && elementWidth < representation[newIdx].width && elementWidth - representation[newIdx - 1].width < representation[newIdx].width - elementWidth) {newIdx = newIdx - 1;}if(representation.length - 2 >= newIdx && representation[newIdx].width === representation[newIdx + 1].width){newIdx = Math.min(idx,newIdx + 1);}}return newIdx;}function onFragmentLoadProgress(e){var type=e.request.mediaType;if(getAutoSwitchBitrateFor(type)){var streamProcessor=streamProcessorDict[type];if(!streamProcessor)return; // There may be a fragment load in progress when we switch periods and recreated some controllers.
	var rulesContext=(0,_rulesRulesContext2['default'])(context).create({abrController:instance,streamProcessor:streamProcessor,currentRequest:e.request,useBufferOccupancyABR:useBufferOccupancyABR(type)});var switchRequest=abrRulesCollection.shouldAbandonFragment(rulesContext);if(switchRequest.quality > _rulesSwitchRequest2['default'].NO_CHANGE){var fragmentModel=streamProcessor.getFragmentModel();var request=fragmentModel.getRequests({state:_modelsFragmentModel2['default'].FRAGMENT_MODEL_LOADING,index:e.request.index})[0];if(request){ //TODO Check if we should abort or if better to finish download. check bytesLoaded/Total
	fragmentModel.abortRequests();setAbandonmentStateFor(type,ABANDON_LOAD);switchHistoryDict[type].reset();switchHistoryDict[type].push({oldValue:getQualityFor(type,streamController.getActiveStreamInfo()),newValue:switchRequest.quality,confidence:1,reason:switchRequest.reason});setPlaybackQuality(type,streamController.getActiveStreamInfo(),switchRequest.quality,switchRequest.reason);clearTimeout(abandonmentTimeout);abandonmentTimeout = setTimeout(function(){setAbandonmentStateFor(type,ALLOW_LOAD);abandonmentTimeout = null;},mediaPlayerModel.getAbandonLoadTimeout());}}}}instance = {isPlayingAtTopQuality:isPlayingAtTopQuality,updateTopQualityIndex:updateTopQualityIndex,getThroughputHistory:getThroughputHistory,getBitrateList:getBitrateList,getQualityForBitrate:getQualityForBitrate,getMaxAllowedBitrateFor:getMaxAllowedBitrateFor,getMinAllowedBitrateFor:getMinAllowedBitrateFor,setMaxAllowedBitrateFor:setMaxAllowedBitrateFor,setMinAllowedBitrateFor:setMinAllowedBitrateFor,getMaxAllowedIndexFor:getMaxAllowedIndexFor,getMinAllowedIndexFor:getMinAllowedIndexFor,getMaxAllowedRepresentationRatioFor:getMaxAllowedRepresentationRatioFor,setMaxAllowedRepresentationRatioFor:setMaxAllowedRepresentationRatioFor,getInitialBitrateFor:getInitialBitrateFor,setInitialBitrateFor:setInitialBitrateFor,getInitialRepresentationRatioFor:getInitialRepresentationRatioFor,setInitialRepresentationRatioFor:setInitialRepresentationRatioFor,setAutoSwitchBitrateFor:setAutoSwitchBitrateFor,getAutoSwitchBitrateFor:getAutoSwitchBitrateFor,getUseDeadTimeLatency:getUseDeadTimeLatency,setUseDeadTimeLatency:setUseDeadTimeLatency,setLimitBitrateByPortal:setLimitBitrateByPortal,getLimitBitrateByPortal:getLimitBitrateByPortal,getUsePixelRatioInLimitBitrateByPortal:getUsePixelRatioInLimitBitrateByPortal,setUsePixelRatioInLimitBitrateByPortal:setUsePixelRatioInLimitBitrateByPortal,getQualityFor:getQualityFor,getAbandonmentStateFor:getAbandonmentStateFor,setPlaybackQuality:setPlaybackQuality,checkPlaybackQuality:checkPlaybackQuality,getTopQualityIndexFor:getTopQualityIndexFor,setElementSize:setElementSize,setWindowResizeEventCalled:setWindowResizeEventCalled,createAbrRulesCollection:createAbrRulesCollection,registerStreamType:registerStreamType,unRegisterStreamType:unRegisterStreamType,setConfig:setConfig,reset:reset};setup();return instance;}AbrController.__dashjs_factory_name = 'AbrController';var factory=_coreFactoryMaker2['default'].getSingletonFactory(AbrController);factory.ABANDON_LOAD = ABANDON_LOAD;factory.QUALITY_DEFAULT = QUALITY_DEFAULT;_coreFactoryMaker2['default'].updateSingletonFactory(AbrController.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=AbrController.js.map


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _coreEventsEventsBase=__webpack_require__(62);var _coreEventsEventsBase2=_interopRequireDefault(_coreEventsEventsBase);var MetricsReportingEvents=(function(_EventsBase){_inherits(MetricsReportingEvents,_EventsBase);function MetricsReportingEvents(){_classCallCheck(this,MetricsReportingEvents);_get(Object.getPrototypeOf(MetricsReportingEvents.prototype),'constructor',this).call(this);this.METRICS_INITIALISATION_COMPLETE = 'internal_metricsReportingInitialized';this.BECAME_REPORTING_PLAYER = 'internal_becameReportingPlayer';}return MetricsReportingEvents;})(_coreEventsEventsBase2['default']);var metricsReportingEvents=new MetricsReportingEvents();exports['default'] = metricsReportingEvents;module.exports = exports['default'];
	//# sourceMappingURL=MetricsReportingEvents.js.map


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _voFragmentRequest=__webpack_require__(37);var _voFragmentRequest2=_interopRequireDefault(_voFragmentRequest);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var FRAGMENT_MODEL_LOADING='loading';var FRAGMENT_MODEL_EXECUTED='executed';var FRAGMENT_MODEL_CANCELED='canceled';var FRAGMENT_MODEL_FAILED='failed';function FragmentModel(config){config = config || {};var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var metricsModel=config.metricsModel;var fragmentLoader=config.fragmentLoader;var instance=undefined,streamProcessor=undefined,executedRequests=undefined,loadingRequests=undefined;function setup(){resetInitialSettings();eventBus.on(_coreEventsEvents2['default'].LOADING_COMPLETED,onLoadingCompleted,instance);eventBus.on(_coreEventsEvents2['default'].LOADING_DATA_PROGRESS,onLoadingInProgress,instance);eventBus.on(_coreEventsEvents2['default'].LOADING_ABANDONED,onLoadingAborted,instance);}function setStreamProcessor(value){streamProcessor = value;}function getStreamProcessor(){return streamProcessor;}function isFragmentLoaded(request){var isEqualUrl=function isEqualUrl(req1,req2){return req1.url === req2.url;};var isEqualComplete=function isEqualComplete(req1,req2){return req1.action === _voFragmentRequest2['default'].ACTION_COMPLETE && req1.action === req2.action;};var isEqualMedia=function isEqualMedia(req1,req2){return !isNaN(req1.index) && req1.startTime === req2.startTime && req1.adaptationIndex === req2.adaptationIndex;};var isEqualInit=function isEqualInit(req1,req2){return isNaN(req1.index) && isNaN(req2.index) && req1.quality === req2.quality;};var check=function check(requests){var isLoaded=false;requests.some(function(req){if(isEqualUrl(request,req) && (isEqualMedia(request,req) || isEqualInit(request,req) || isEqualComplete(request,req))){isLoaded = true;return isLoaded;}});return isLoaded;};if(!request){return false;}return check(executedRequests);}function isFragmentLoadedOrPending(request){var isLoaded=false;var i=0;var req=undefined; // First, check if the fragment has already been loaded
	isLoaded = isFragmentLoaded(request); // Then, check if the fragment is about to be loeaded
	if(!isLoaded){for(i = 0;i < loadingRequests.length;i++) {req = loadingRequests[i];if(request.url === req.url && request.startTime === req.startTime){isLoaded = true;}}}return isLoaded;} /**
	     *
	     * Gets an array of {@link FragmentRequest} objects
	     *
	     * @param {Object} filter The object with properties by which the method filters the requests to be returned.
	     *  the only mandatory property is state, which must be a value from
	     *  other properties should match the properties of {@link FragmentRequest}. E.g.:
	     *  getRequests({state: FragmentModel.FRAGMENT_MODEL_EXECUTED, quality: 0}) - returns
	     *  all the requests from executedRequests array where requests.quality = filter.quality
	     *
	     * @returns {Array}
	     * @memberof FragmentModel#
	     */function getRequests(filter){var states=filter?filter.state instanceof Array?filter.state:[filter.state]:[];var filteredRequests=[];states.forEach(function(state){var requests=getRequestsForState(state);filteredRequests = filteredRequests.concat(filterRequests(requests,filter));});return filteredRequests;}function getRequestThreshold(req){return isNaN(req.duration)?0.25:req.duration / 8;}function removeExecutedRequestsBeforeTime(time){executedRequests = executedRequests.filter(function(req){var threshold=getRequestThreshold(req);return isNaN(req.startTime) || (time !== undefined?req.startTime >= time - threshold:false);});}function removeExecutedRequestsInTimeRange(start,end){if(end <= start + 0.5){return;}executedRequests = executedRequests.filter(function(req){var threshold=getRequestThreshold(req);return isNaN(req.startTime) || req.startTime >= end - threshold || isNaN(req.duration) || req.startTime + req.duration <= start + threshold;});} // Remove requests that are not "represented" by any of buffered ranges
	function syncExecutedRequestsWithBufferedRange(bufferedRanges,streamDuration){if(!bufferedRanges || bufferedRanges.length === 0){removeExecutedRequestsBeforeTime();return;}var start=0;for(var i=0,ln=bufferedRanges.length;i < ln;i++) {removeExecutedRequestsInTimeRange(start,bufferedRanges.start(i));start = bufferedRanges.end(i);}if(streamDuration > 0){removeExecutedRequestsInTimeRange(start,streamDuration);}}function abortRequests(){fragmentLoader.abort();loadingRequests = [];}function executeRequest(request){switch(request.action){case _voFragmentRequest2['default'].ACTION_COMPLETE:executedRequests.push(request);addSchedulingInfoMetrics(request,FRAGMENT_MODEL_EXECUTED);log('[FragmentModel] executeRequest trigger STREAM_COMPLETED');eventBus.trigger(_coreEventsEvents2['default'].STREAM_COMPLETED,{request:request,fragmentModel:this});break;case _voFragmentRequest2['default'].ACTION_DOWNLOAD:addSchedulingInfoMetrics(request,FRAGMENT_MODEL_LOADING);loadingRequests.push(request);loadCurrentFragment(request);break;default:log('Unknown request action.');}}function loadCurrentFragment(request){eventBus.trigger(_coreEventsEvents2['default'].FRAGMENT_LOADING_STARTED,{sender:instance,request:request});fragmentLoader.load(request);}function getRequestForTime(arr,time,threshold){ // loop through the executed requests and pick the one for which the playback interval matches the given time
	var lastIdx=arr.length - 1;for(var i=lastIdx;i >= 0;i--) {var req=arr[i];var start=req.startTime;var end=start + req.duration;threshold = !isNaN(threshold)?threshold:getRequestThreshold(req);if(!isNaN(start) && !isNaN(end) && time + threshold >= start && time - threshold < end || isNaN(start) && isNaN(time)){return req;}}return null;}function filterRequests(arr,filter){ // for time use a specific filtration function
	if(filter.hasOwnProperty('time')){return [getRequestForTime(arr,filter.time,filter.threshold)];}return arr.filter(function(request){for(var prop in filter) {if(prop === 'state')continue;if(filter.hasOwnProperty(prop) && request[prop] != filter[prop])return false;}return true;});}function getRequestsForState(state){var requests=undefined;switch(state){case FRAGMENT_MODEL_LOADING:requests = loadingRequests;break;case FRAGMENT_MODEL_EXECUTED:requests = executedRequests;break;default:requests = [];}return requests;}function addSchedulingInfoMetrics(request,state){metricsModel.addSchedulingInfo(request.mediaType,new Date(),request.type,request.startTime,request.availabilityStartTime,request.duration,request.quality,request.range,state);metricsModel.addRequestsQueue(request.mediaType,loadingRequests,executedRequests);}function onLoadingCompleted(e){if(e.sender !== fragmentLoader)return;loadingRequests.splice(loadingRequests.indexOf(e.request),1);if(e.response && !e.error){executedRequests.push(e.request);}addSchedulingInfoMetrics(e.request,e.error?FRAGMENT_MODEL_FAILED:FRAGMENT_MODEL_EXECUTED);eventBus.trigger(_coreEventsEvents2['default'].FRAGMENT_LOADING_COMPLETED,{request:e.request,response:e.response,error:e.error,sender:this});}function onLoadingInProgress(e){if(e.sender !== fragmentLoader)return;eventBus.trigger(_coreEventsEvents2['default'].FRAGMENT_LOADING_PROGRESS,{request:e.request,response:e.response,error:e.error,sender:this});}function onLoadingAborted(e){if(e.sender !== fragmentLoader)return;eventBus.trigger(_coreEventsEvents2['default'].FRAGMENT_LOADING_ABANDONED,{streamProcessor:this.getStreamProcessor(),request:e.request,mediaType:e.mediaType});}function resetInitialSettings(){executedRequests = [];loadingRequests = [];}function reset(){eventBus.off(_coreEventsEvents2['default'].LOADING_COMPLETED,onLoadingCompleted,this);eventBus.off(_coreEventsEvents2['default'].LOADING_DATA_PROGRESS,onLoadingInProgress,this);eventBus.off(_coreEventsEvents2['default'].LOADING_ABANDONED,onLoadingAborted,this);if(fragmentLoader){fragmentLoader.reset();}resetInitialSettings();}function addExecutedRequest(request){executedRequests.push(request);}instance = {setStreamProcessor:setStreamProcessor,getStreamProcessor:getStreamProcessor,getRequests:getRequests,isFragmentLoaded:isFragmentLoaded,isFragmentLoadedOrPending:isFragmentLoadedOrPending,removeExecutedRequestsBeforeTime:removeExecutedRequestsBeforeTime,syncExecutedRequestsWithBufferedRange:syncExecutedRequestsWithBufferedRange,abortRequests:abortRequests,executeRequest:executeRequest,reset:reset,addExecutedRequest:addExecutedRequest};setup();return instance;}FragmentModel.__dashjs_factory_name = 'FragmentModel';var factory=_coreFactoryMaker2['default'].getClassFactory(FragmentModel);factory.FRAGMENT_MODEL_LOADING = FRAGMENT_MODEL_LOADING;factory.FRAGMENT_MODEL_EXECUTED = FRAGMENT_MODEL_EXECUTED;factory.FRAGMENT_MODEL_CANCELED = FRAGMENT_MODEL_CANCELED;factory.FRAGMENT_MODEL_FAILED = FRAGMENT_MODEL_FAILED;_coreFactoryMaker2['default'].updateClassFactory(FragmentModel.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=FragmentModel.js.map


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _CommonEncryption=__webpack_require__(42);var _CommonEncryption2=_interopRequireDefault(_CommonEncryption);var _drmKeySystemClearKey=__webpack_require__(376);var _drmKeySystemClearKey2=_interopRequireDefault(_drmKeySystemClearKey);var _drmKeySystemW3CClearKey=__webpack_require__(378);var _drmKeySystemW3CClearKey2=_interopRequireDefault(_drmKeySystemW3CClearKey);var _drmKeySystemWidevine=__webpack_require__(379);var _drmKeySystemWidevine2=_interopRequireDefault(_drmKeySystemWidevine);var _drmKeySystemPlayReady=__webpack_require__(377);var _drmKeySystemPlayReady2=_interopRequireDefault(_drmKeySystemPlayReady);var _serversDRMToday=__webpack_require__(384);var _serversDRMToday2=_interopRequireDefault(_serversDRMToday);var _serversPlayReady=__webpack_require__(385);var _serversPlayReady2=_interopRequireDefault(_serversPlayReady);var _serversWidevine=__webpack_require__(386);var _serversWidevine2=_interopRequireDefault(_serversWidevine);var _serversClearKey=__webpack_require__(383);var _serversClearKey2=_interopRequireDefault(_serversClearKey);var _constantsProtectionConstants=__webpack_require__(35);var _constantsProtectionConstants2=_interopRequireDefault(_constantsProtectionConstants); /**
	 * @module ProtectionKeyController
	 * @description Media protection key system functionality that can be modified/overridden by applications
	 */function ProtectionKeyController(){var context=this.context;var instance=undefined,log=undefined,keySystems=undefined,BASE64=undefined,clearkeyKeySystem=undefined,clearkeyW3CKeySystem=undefined;function setConfig(config){if(!config)return;if(config.log){log = config.log;}if(config.BASE64){BASE64 = config.BASE64;}}function initialize(){keySystems = [];var keySystem=undefined; // PlayReady
	keySystem = (0,_drmKeySystemPlayReady2['default'])(context).getInstance({BASE64:BASE64});keySystems.push(keySystem); // Widevine
	keySystem = (0,_drmKeySystemWidevine2['default'])(context).getInstance({BASE64:BASE64});keySystems.push(keySystem); // ClearKey
	keySystem = (0,_drmKeySystemClearKey2['default'])(context).getInstance({BASE64:BASE64});keySystems.push(keySystem);clearkeyKeySystem = keySystem; // W3C ClearKey
	keySystem = (0,_drmKeySystemW3CClearKey2['default'])(context).getInstance({BASE64:BASE64,log:log});keySystems.push(keySystem);clearkeyW3CKeySystem = keySystem;} /**
	     * Returns a prioritized list of key systems supported
	     * by this player (not necessarily those supported by the
	     * user agent)
	     *
	     * @returns {Array.<KeySystem>} a prioritized
	     * list of key systems
	     * @memberof module:ProtectionKeyController
	     * @instance
	     */function getKeySystems(){return keySystems;} /**
	     * Returns the key system associated with the given key system string
	     * name (i.e. 'org.w3.clearkey')
	     *
	     * @param {string} systemString the system string
	     * @returns {KeySystem|null} the key system
	     * or null if no supported key system is associated with the given key
	     * system string
	     * @memberof module:ProtectionKeyController
	     * @instance
	     */function getKeySystemBySystemString(systemString){for(var i=0;i < keySystems.length;i++) {if(keySystems[i].systemString === systemString){return keySystems[i];}}return null;} /**
	     * Determines whether the given key system is ClearKey.  This is
	     * necessary because the EME spec defines ClearKey and its method
	     * for providing keys to the key session; and this method has changed
	     * between the various API versions.  Our EME-specific ProtectionModels
	     * must know if the system is ClearKey so that it can format the keys
	     * according to the particular spec version.
	     *
	     * @param {Object} keySystem the key
	     * @returns {boolean} true if this is the ClearKey key system, false
	     * otherwise
	     * @memberof module:ProtectionKeyController
	     * @instance
	     */function isClearKey(keySystem){return keySystem === clearkeyKeySystem || keySystem === clearkeyW3CKeySystem;} /**
	     * Check equality of initData array buffers.
	     *
	     * @param {ArrayBuffer} initData1 - first initData
	     * @param {ArrayBuffer} initData2 - second initData
	     * @returns {boolean} true if the initData arrays are equal in size and
	     * contents, false otherwise
	     * @memberof module:ProtectionKeyController
	     * @instance
	     */function initDataEquals(initData1,initData2){if(initData1.byteLength === initData2.byteLength){var data1=new Uint8Array(initData1);var data2=new Uint8Array(initData2);for(var j=0;j < data1.length;j++) {if(data1[j] !== data2[j]){return false;}}return true;}return false;} /**
	     * Returns a set of supported key systems and CENC initialization data
	     * from the given array of ContentProtection elements.  Only
	     * key systems that are supported by this player will be returned.
	     * Key systems are returned in priority order (highest first).
	     *
	     * @param {Array.<Object>} cps - array of content protection elements parsed
	     * from the manifest
	     * @returns {Array.<Object>} array of objects indicating which supported key
	     * systems were found.  Empty array is returned if no
	     * supported key systems were found
	     * @memberof module:ProtectionKeyController
	     * @instance
	     */function getSupportedKeySystemsFromContentProtection(cps){var cp=undefined,ks=undefined,ksIdx=undefined,cpIdx=undefined;var supportedKS=[];if(cps){for(ksIdx = 0;ksIdx < keySystems.length;++ksIdx) {ks = keySystems[ksIdx];for(cpIdx = 0;cpIdx < cps.length;++cpIdx) {cp = cps[cpIdx];if(cp.schemeIdUri.toLowerCase() === ks.schemeIdURI){ // Look for DRM-specific ContentProtection
	supportedKS.push({ks:ks,initData:ks.getInitData(cp),cdmData:ks.getCDMData(),sessionId:ks.getSessionId(cp)});}}}}return supportedKS;} /**
	     * Returns key systems supported by this player for the given PSSH
	     * initializationData. Only key systems supported by this player
	     * that have protection data present will be returned.  Key systems are returned in priority order
	     * (highest priority first)
	     *
	     * @param {ArrayBuffer} initData Concatenated PSSH data for all DRMs
	     * supported by the content
	     * @param {ProtectionData} protDataSet user specified protection data - license server url etc
	     * supported by the content
	     * @returns {Array.<Object>} array of objects indicating which supported key
	     * systems were found.  Empty array is returned if no
	     * supported key systems were found
	     * @memberof module:ProtectionKeyController
	     * @instance
	     */function getSupportedKeySystems(initData,protDataSet){var supportedKS=[];var pssh=_CommonEncryption2['default'].parsePSSHList(initData);var ks=undefined,keySystemString=undefined,shouldNotFilterOutKeySystem=undefined;for(var ksIdx=0;ksIdx < keySystems.length;++ksIdx) {ks = keySystems[ksIdx];keySystemString = ks.systemString;shouldNotFilterOutKeySystem = protDataSet?keySystemString in protDataSet:true;if(ks.uuid in pssh && shouldNotFilterOutKeySystem){supportedKS.push({ks:ks,initData:pssh[ks.uuid],cdmData:ks.getCDMData(),sessionId:ks.getSessionId()});}}return supportedKS;} /**
	     * Returns the license server implementation data that should be used for this request.
	     *
	     * @param {KeySystem} keySystem the key system
	     * associated with this license request
	     * @param {ProtectionData} protData protection data to use for the
	     * request
	     * @param {string} [messageType="license-request"] the message type associated with this
	     * request.  Supported message types can be found
	     * {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
	     * @returns {LicenseServer|null} the license server
	     * implementation that should be used for this request or null if the player should not
	     * pass messages of the given type to a license server
	     * @memberof module:ProtectionKeyController
	     * @instance
	     *
	     */function getLicenseServer(keySystem,protData,messageType){ // Our default server implementations do not do anything with "license-release" or
	// "individualization-request" messages, so we just send a success event
	if(messageType === 'license-release' || messageType === 'individualization-request'){return null;}var licenseServerData=null;if(protData && protData.hasOwnProperty('drmtoday')){licenseServerData = (0,_serversDRMToday2['default'])(context).getInstance({BASE64:BASE64});}else if(keySystem.systemString === _constantsProtectionConstants2['default'].WIDEVINE_KEYSTEM_STRING){licenseServerData = (0,_serversWidevine2['default'])(context).getInstance();}else if(keySystem.systemString === _constantsProtectionConstants2['default'].PLAYREADY_KEYSTEM_STRING){licenseServerData = (0,_serversPlayReady2['default'])(context).getInstance();}else if(keySystem.systemString === _constantsProtectionConstants2['default'].CLEARKEY_KEYSTEM_STRING){licenseServerData = (0,_serversClearKey2['default'])(context).getInstance();}return licenseServerData;} /**
	     * Allows application-specific retrieval of ClearKey keys.
	     *
	     * @param {KeySystem} clearkeyKeySystem They exact ClearKey System to be used
	     * @param {ProtectionData} protData protection data to use for the
	     * request
	     * @param {ArrayBuffer} message the key message from the CDM
	     * @return {ClearKeyKeySet|null} the clear keys associated with
	     * the request or null if no keys can be returned by this function
	     * @memberof module:ProtectionKeyController
	     * @instance
	     */function processClearKeyLicenseRequest(clearkeyKeySystem,protData,message){try{return clearkeyKeySystem.getClearKeysFromProtectionData(protData,message);}catch(error) {log('Failed to retrieve clearkeys from ProtectionData');return null;}}function setProtectionData(protectionDataSet){var getProtectionData=function getProtectionData(keySystemString){var protData=null;if(protectionDataSet){protData = keySystemString in protectionDataSet?protectionDataSet[keySystemString]:null;}return protData;};for(var i=0;i < keySystems.length;i++) {var keySystem=keySystems[i];if(keySystem.hasOwnProperty('init')){keySystem.init(getProtectionData(keySystem.systemString));}}}instance = {initialize:initialize,setProtectionData:setProtectionData,isClearKey:isClearKey,initDataEquals:initDataEquals,getKeySystems:getKeySystems,getKeySystemBySystemString:getKeySystemBySystemString,getSupportedKeySystemsFromContentProtection:getSupportedKeySystemsFromContentProtection,getSupportedKeySystems:getSupportedKeySystems,getLicenseServer:getLicenseServer,processClearKeyLicenseRequest:processClearKeyLicenseRequest,setConfig:setConfig};return instance;}ProtectionKeyController.__dashjs_factory_name = 'ProtectionKeyController';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(ProtectionKeyController); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=ProtectionKeyController.js.map


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _IsoFile=__webpack_require__(411);var _IsoFile2=_interopRequireDefault(_IsoFile);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _codemIsoboxer=__webpack_require__(84);var _codemIsoboxer2=_interopRequireDefault(_codemIsoboxer);var _voIsoBoxSearchInfo=__webpack_require__(420);var _voIsoBoxSearchInfo2=_interopRequireDefault(_voIsoBoxSearchInfo);function BoxParser() /*config*/{var instance=undefined;var context=this.context; /**
	     * @param {ArrayBuffer} data
	     * @returns {IsoFile|null}
	     * @memberof BoxParser#
	     */function parse(data){if(!data)return null;if(data.fileStart === undefined){data.fileStart = 0;}var parsedFile=_codemIsoboxer2['default'].parseBuffer(data);var dashIsoFile=(0,_IsoFile2['default'])(context).create();dashIsoFile.setData(parsedFile);return dashIsoFile;} /**
	     * From the list of type boxes to look for, returns the latest one that is fully completed (header + payload). This
	     * method only looks into the list of top boxes and doesn't analyze nested boxes.
	     * @param {string[]} types
	     * @param {ArrayBuffer|uint8Array} buffer
	     * @param {number} offset
	     * @returns {IsoBoxSearchInfo}
	     * @memberof BoxParser#
	     */function findLastTopIsoBoxCompleted(types,buffer,offset){if(offset === undefined){offset = 0;} // 8 = size (uint32) + type (4 characters)
	if(!buffer || offset + 8 >= buffer.byteLength){return new _voIsoBoxSearchInfo2['default'](0,false);}var data=buffer instanceof ArrayBuffer?new Uint8Array(buffer):buffer;var boxInfo=undefined;var lastCompletedOffset=0;while(offset < data.byteLength) {var boxSize=parseUint32(data,offset);var boxType=parseIsoBoxType(data,offset + 4);if(boxSize === 0){break;}if(offset + boxSize <= data.byteLength){if(types.indexOf(boxType) >= 0){boxInfo = new _voIsoBoxSearchInfo2['default'](offset,true,boxSize);}else {lastCompletedOffset = offset + boxSize;}}offset += boxSize;}if(!boxInfo){return new _voIsoBoxSearchInfo2['default'](lastCompletedOffset,false);}return boxInfo;}function parseUint32(data,offset){return data[offset + 3] >>> 0 | data[offset + 2] << 8 >>> 0 | data[offset + 1] << 16 >>> 0 | data[offset] << 24 >>> 0;}function parseIsoBoxType(data,offset){return String.fromCharCode(data[offset++]) + String.fromCharCode(data[offset++]) + String.fromCharCode(data[offset++]) + String.fromCharCode(data[offset]);}instance = {parse:parse,findLastTopIsoBoxCompleted:findLastTopIsoBoxCompleted};return instance;}BoxParser.__dashjs_factory_name = 'BoxParser';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(BoxParser);module.exports = exports['default'];
	//# sourceMappingURL=BoxParser.js.map


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function RequestModifier(){var instance=undefined;function modifyRequestURL(url){return url;}function modifyRequestHeader(request){return request;}instance = {modifyRequestURL:modifyRequestURL,modifyRequestHeader:modifyRequestHeader};return instance;}RequestModifier.__dashjs_factory_name = 'RequestModifier';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(RequestModifier);module.exports = exports['default'];
	//# sourceMappingURL=RequestModifier.js.map


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 71 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/* 
	 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *
	 * * Redistributions of source code must retain the above copyright notice, this
	 *   list of conditions and the following disclaimer.
	 * * Redistributions in binary form must reproduce the above copyright notice,
	 *   this list of conditions and the following disclaimer in the documentation
	 *   and/or other materials provided with the distribution.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
	 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
	 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
	 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 * POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/**
	 * @module imscNames
	 */
	
	;
	(function (imscNames) { // wrapper for non-node envs
	
	    imscNames.ns_tt = "http://www.w3.org/ns/ttml";
	    imscNames.ns_tts = "http://www.w3.org/ns/ttml#styling";
	    imscNames.ns_ttp = "http://www.w3.org/ns/ttml#parameter";
	    imscNames.ns_xml = "http://www.w3.org/XML/1998/namespace";
	    imscNames.ns_itts = "http://www.w3.org/ns/ttml/profile/imsc1#styling";
	    imscNames.ns_ittp = "http://www.w3.org/ns/ttml/profile/imsc1#parameter";
	    imscNames.ns_smpte = "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt";
	    imscNames.ns_ebutts = "urn:ebu:tt:style";
	    
	})( false ? this.imscNames = {} : exports);
	
	
	
	


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(501);


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventPluginRegistry = __webpack_require__(108);
	var ReactEventEmitterMixin = __webpack_require__(516);
	var ViewportMetrics = __webpack_require__(183);
	
	var getVendorPrefixedEventName = __webpack_require__(548);
	var isEventSupported = __webpack_require__(119);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(59);
	var ViewportMetrics = __webpack_require__(183);
	
	var getEventModifierState = __webpack_require__(117);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var invariant = __webpack_require__(3);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	var DOMNamespaces = __webpack_require__(107);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(115);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(33);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(125);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(49);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(566);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(198);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(562);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(577);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(563);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(564);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(200);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(565);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(126);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(575);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(205);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(568);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(569);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(573);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(202);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(83)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(277)
	var ieee754 = __webpack_require__(469)
	var isArray = __webpack_require__(167)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/*! codem-isoboxer v0.3.5 https://github.com/madebyhiro/codem-isoboxer/blob/master/LICENSE.txt */
	var ISOBoxer = {};
	
	ISOBoxer.parseBuffer = function(arrayBuffer) {
	  return new ISOFile(arrayBuffer).parse();
	};
	
	ISOBoxer.addBoxProcessor = function(type, parser) {
	  if (typeof type !== 'string' || typeof parser !== 'function') {
	    return;
	  }
	  ISOBox.prototype._boxProcessors[type] = parser;
	};
	
	ISOBoxer.createFile = function() {
	  return new ISOFile();
	};
	
	// See ISOBoxer.append() for 'pos' parameter syntax
	ISOBoxer.createBox = function(type, parent, pos) {
	  var newBox = ISOBox.create(type);
	  if (parent) {
	    parent.append(newBox, pos);
	  }
	  return newBox;
	};
	
	// See ISOBoxer.append() for 'pos' parameter syntax
	ISOBoxer.createFullBox = function(type, parent, pos) {
	  var newBox = ISOBoxer.createBox(type, parent, pos);
	  newBox.version = 0;
	  newBox.flags = 0;
	  return newBox;
	};
	
	ISOBoxer.Utils = {};
	ISOBoxer.Utils.dataViewToString = function(dataView, encoding) {
	  var impliedEncoding = encoding || 'utf-8';
	  if (typeof TextDecoder !== 'undefined') {
	    return new TextDecoder(impliedEncoding).decode(dataView);
	  }
	  var a = [];
	  var i = 0;
	
	  if (impliedEncoding === 'utf-8') {
	    /* The following algorithm is essentially a rewrite of the UTF8.decode at
	    http://bannister.us/weblog/2007/simple-base64-encodedecode-javascript/
	    */
	
	    while (i < dataView.byteLength) {
	      var c = dataView.getUint8(i++);
	      if (c < 0x80) {
	        // 1-byte character (7 bits)
	      } else if (c < 0xe0) {
	        // 2-byte character (11 bits)
	        c = (c & 0x1f) << 6;
	        c |= (dataView.getUint8(i++) & 0x3f);
	      } else if (c < 0xf0) {
	        // 3-byte character (16 bits)
	        c = (c & 0xf) << 12;
	        c |= (dataView.getUint8(i++) & 0x3f) << 6;
	        c |= (dataView.getUint8(i++) & 0x3f);
	      } else {
	        // 4-byte character (21 bits)
	        c = (c & 0x7) << 18;
	        c |= (dataView.getUint8(i++) & 0x3f) << 12;
	        c |= (dataView.getUint8(i++) & 0x3f) << 6;
	        c |= (dataView.getUint8(i++) & 0x3f);
	      }
	      a.push(String.fromCharCode(c));
	    }
	  } else { // Just map byte-by-byte (probably wrong)
	    while (i < dataView.byteLength) {
	      a.push(String.fromCharCode(dataView.getUint8(i++)));
	    }
	  }
	  return a.join('');
	};
	
	ISOBoxer.Utils.utf8ToByteArray = function(string) {
	  // Only UTF-8 encoding is supported by TextEncoder
	  var u, i;
	  if (typeof TextEncoder !== 'undefined') {
	    u = new TextEncoder().encode(string);
	  } else {
	    u = [];
	    for (i = 0; i < string.length; ++i) {
	      var c = string.charCodeAt(i);
	      if (c < 0x80) {
	        u.push(c);
	      } else if (c < 0x800) {
	        u.push(0xC0 | (c >> 6));
	        u.push(0x80 | (63 & c));
	      } else if (c < 0x10000) {
	        u.push(0xE0 | (c >> 12));
	        u.push(0x80 | (63 & (c >> 6)));
	        u.push(0x80 | (63 & c));
	      } else {
	        u.push(0xF0 | (c >> 18));
	        u.push(0x80 | (63 & (c >> 12)));
	        u.push(0x80 | (63 & (c >> 6)));
	        u.push(0x80 | (63 & c));
	      }
	    }
	  }
	  return u;
	};
	
	// Method to append a box in the list of child boxes
	// The 'pos' parameter can be either:
	//   - (number) a position index at which to insert the new box
	//   - (string) the type of the box after which to insert the new box
	//   - (object) the box after which to insert the new box
	ISOBoxer.Utils.appendBox = function(parent, box, pos) {
	  box._offset = parent._cursor.offset;
	  box._root = (parent._root ? parent._root : parent);
	  box._raw = parent._raw;
	  box._parent = parent;
	
	  if (pos === -1) {
	    // The new box is a sub-box of the parent but not added in boxes array,
	    // for example when the new box is set as an entry (see dref and stsd for example)
	    return;
	  }
	
	  if (pos === undefined || pos === null) {
	    parent.boxes.push(box);
	    return;
	  }
	
	  var index = -1,
	      type;
	
	  if (typeof pos === "number") {
	    index = pos;
	  } else {
	    if (typeof pos === "string") {
	      type = pos;
	    } else if (typeof pos === "object" && pos.type) {
	      type = pos.type;
	    } else {
	      parent.boxes.push(box);
	      return;
	    }
	
	    for (var i = 0; i < parent.boxes.length; i++) {
	      if (type === parent.boxes[i].type) {
	        index = i + 1;
	        break;
	      }
	    }
	  }
	  parent.boxes.splice(index, 0, box);
	};
	
	if (true) {
	  exports.parseBuffer     = ISOBoxer.parseBuffer;
	  exports.addBoxProcessor = ISOBoxer.addBoxProcessor;
	  exports.createFile      = ISOBoxer.createFile;
	  exports.createBox       = ISOBoxer.createBox;
	  exports.createFullBox   = ISOBoxer.createFullBox;
	  exports.Utils           = ISOBoxer.Utils;
	}
	
	ISOBoxer.Cursor = function(initialOffset) {
	  this.offset = (typeof initialOffset == 'undefined' ? 0 : initialOffset);
	};
	
	var ISOFile = function(arrayBuffer) {
	  this._cursor = new ISOBoxer.Cursor();
	  this.boxes = [];
	  if (arrayBuffer) {
	    this._raw = new DataView(arrayBuffer);
	  }
	};
	
	ISOFile.prototype.fetch = function(type) {
	  var result = this.fetchAll(type, true);
	  return (result.length ? result[0] : null);
	};
	
	ISOFile.prototype.fetchAll = function(type, returnEarly) {
	  var result = [];
	  ISOFile._sweep.call(this, type, result, returnEarly);
	  return result;
	};
	
	ISOFile.prototype.parse = function() {
	  this._cursor.offset = 0;
	  this.boxes = [];
	  while (this._cursor.offset < this._raw.byteLength) {
	    var box = ISOBox.parse(this);
	
	    // Box could not be parsed
	    if (typeof box.type === 'undefined') break;
	
	    this.boxes.push(box);
	  }
	  return this;
	};
	
	ISOFile._sweep = function(type, result, returnEarly) {
	  if (this.type && this.type == type) result.push(this);
	  for (var box in this.boxes) {
	    if (result.length && returnEarly) return;
	    ISOFile._sweep.call(this.boxes[box], type, result, returnEarly);
	  }
	};
	
	ISOFile.prototype.write = function() {
	
	  var length = 0,
	      i;
	
	  for (i = 0; i < this.boxes.length; i++) {
	    length += this.boxes[i].getLength(false);
	  }
	
	  var bytes = new Uint8Array(length);
	  this._rawo = new DataView(bytes.buffer);
	  this.bytes = bytes;
	  this._cursor.offset = 0;
	
	  for (i = 0; i < this.boxes.length; i++) {
	    this.boxes[i].write();
	  }
	
	  return bytes.buffer;
	};
	
	ISOFile.prototype.append = function(box, pos) {
	  ISOBoxer.Utils.appendBox(this, box, pos);
	};
	var ISOBox = function() {
	  this._cursor = new ISOBoxer.Cursor();
	};
	
	ISOBox.parse = function(parent) {
	  var newBox = new ISOBox();
	  newBox._offset = parent._cursor.offset;
	  newBox._root = (parent._root ? parent._root : parent);
	  newBox._raw = parent._raw;
	  newBox._parent = parent;
	  newBox._parseBox();
	  parent._cursor.offset = newBox._raw.byteOffset + newBox._raw.byteLength;
	  return newBox;
	};
	
	ISOBox.create = function(type) {
	  var newBox = new ISOBox();
	  newBox.type = type;
	  newBox.boxes = [];
	  return newBox;
	};
	
	ISOBox.prototype._boxContainers = ['dinf', 'edts', 'mdia', 'meco', 'mfra', 'minf', 'moof', 'moov', 'mvex', 'stbl', 'strk', 'traf', 'trak', 'tref', 'udta', 'vttc', 'sinf', 'schi', 'encv', 'enca'];
	
	ISOBox.prototype._boxProcessors = {};
	
	///////////////////////////////////////////////////////////////////////////////////////////////////
	// Generic read/write functions
	
	ISOBox.prototype._procField = function (name, type, size) {
	  if (this._parsing) {
	    this[name] = this._readField(type, size);
	  }
	  else {
	    this._writeField(type, size, this[name]);
	  }
	};
	
	ISOBox.prototype._procFieldArray = function (name, length, type, size) {
	  var i;
	  if (this._parsing) {
	    this[name] = [];
	    for (i = 0; i < length; i++) {
	      this[name][i] = this._readField(type, size);
	    }
	  }
	  else {
	    for (i = 0; i < this[name].length; i++) {
	      this._writeField(type, size, this[name][i]);
	    }
	  }
	};
	
	ISOBox.prototype._procFullBox = function() {
	  this._procField('version', 'uint', 8);
	  this._procField('flags', 'uint', 24);
	};
	
	ISOBox.prototype._procEntries = function(name, length, fn) {
	  var i;
	  if (this._parsing) {
	    this[name] = [];
	    for (i = 0; i < length; i++) {
	      this[name].push({});
	      fn.call(this, this[name][i]);
	    }
	  }
	  else {
	    for (i = 0; i < length; i++) {
	      fn.call(this, this[name][i]);
	    }
	  }
	};
	
	ISOBox.prototype._procSubEntries = function(entry, name, length, fn) {
	  var i;
	  if (this._parsing) {
	    entry[name] = [];
	    for (i = 0; i < length; i++) {
	      entry[name].push({});
	      fn.call(this, entry[name][i]);
	    }
	  }
	  else {
	    for (i = 0; i < length; i++) {
	      fn.call(this, entry[name][i]);
	    }
	  }
	};
	
	ISOBox.prototype._procEntryField = function (entry, name, type, size) {
	  if (this._parsing) {
	    entry[name] = this._readField(type, size);
	  }
	  else {
	    this._writeField(type, size, entry[name]);
	  }
	};
	
	ISOBox.prototype._procSubBoxes = function(name, length) {
	  var i;
	  if (this._parsing) {
	    this[name] = [];
	    for (i = 0; i < length; i++) {
	      this[name].push(ISOBox.parse(this));
	    }
	  }
	  else {
	    for (i = 0; i < length; i++) {
	      if (this._rawo) {
	        this[name][i].write();
	      } else {
	        this.size += this[name][i].getLength();
	      }
	    }
	  }
	};
	
	///////////////////////////////////////////////////////////////////////////////////////////////////
	// Read/parse functions
	
	ISOBox.prototype._readField = function(type, size) {
	  switch (type) {
	    case 'uint':
	      return this._readUint(size);
	    case 'int':
	      return this._readInt(size);
	    case 'template':
	      return this._readTemplate(size);
	    case 'string':
	      return (size === -1) ? this._readTerminatedString() : this._readString(size);
	    case 'data':
	      return this._readData(size);
	    case 'utf8':
	      return this._readUTF8String();
	    default:
	      return -1;
	  }
	};
	
	ISOBox.prototype._readInt = function(size) {
	  var result = null,
	      offset = this._cursor.offset - this._raw.byteOffset;
	  switch(size) {
	  case 8:
	    result = this._raw.getInt8(offset);
	    break;
	  case 16:
	    result = this._raw.getInt16(offset);
	    break;
	  case 32:
	    result = this._raw.getInt32(offset);
	    break;
	  case 64:
	    // Warning: JavaScript cannot handle 64-bit integers natively.
	    // This will give unexpected results for integers >= 2^53
	    var s1 = this._raw.getInt32(offset);
	    var s2 = this._raw.getInt32(offset + 4);
	    result = (s1 * Math.pow(2,32)) + s2;
	    break;
	  }
	  this._cursor.offset += (size >> 3);
	  return result;
	};
	
	ISOBox.prototype._readUint = function(size) {
	  var result = null,
	      offset = this._cursor.offset - this._raw.byteOffset,
	      s1, s2;
	  switch(size) {
	  case 8:
	    result = this._raw.getUint8(offset);
	    break;
	  case 16:
	    result = this._raw.getUint16(offset);
	    break;
	  case 24:
	    s1 = this._raw.getUint16(offset);
	    s2 = this._raw.getUint8(offset + 2);
	    result = (s1 << 8) + s2;
	    break;
	  case 32:
	    result = this._raw.getUint32(offset);
	    break;
	  case 64:
	    // Warning: JavaScript cannot handle 64-bit integers natively.
	    // This will give unexpected results for integers >= 2^53
	    s1 = this._raw.getUint32(offset);
	    s2 = this._raw.getUint32(offset + 4);
	    result = (s1 * Math.pow(2,32)) + s2;
	    break;
	  }
	  this._cursor.offset += (size >> 3);
	  return result;
	};
	
	ISOBox.prototype._readString = function(length) {
	  var str = '';
	  for (var c = 0; c < length; c++) {
	    var char = this._readUint(8);
	    str += String.fromCharCode(char);
	  }
	  return str;
	};
	
	ISOBox.prototype._readTemplate = function(size) {
	  var pre = this._readUint(size / 2);
	  var post = this._readUint(size / 2);
	  return pre + (post / Math.pow(2, size / 2));
	};
	
	ISOBox.prototype._readTerminatedString = function() {
	  var str = '';
	  while (this._cursor.offset - this._offset < this._raw.byteLength) {
	    var char = this._readUint(8);
	    if (char === 0) break;
	    str += String.fromCharCode(char);
	  }
	  return str;
	};
	
	ISOBox.prototype._readData = function(size) {
	  var length = (size > 0) ? size : (this._raw.byteLength - (this._cursor.offset - this._offset));
	  if (length > 0) {
	    var data = new Uint8Array(this._raw.buffer, this._cursor.offset, length);
	
	    this._cursor.offset += length;
	    return data;
	  }
	  else {
	    return null;
	  }
	};
	
	ISOBox.prototype._readUTF8String = function() {
	  var length = this._raw.byteLength - (this._cursor.offset - this._offset);
	  var data = null;
	  if (length > 0) {
	    data = new DataView(this._raw.buffer, this._cursor.offset, length);
	    this._cursor.offset += length;
	  }
	 
	  return data ? ISOBoxer.Utils.dataViewToString(data) : data;
	};
	
	ISOBox.prototype._parseBox = function() {
	  this._parsing = true;
	  this._cursor.offset = this._offset;
	
	  // return immediately if there are not enough bytes to read the header
	  if (this._offset + 8 > this._raw.buffer.byteLength) {
	    this._root._incomplete = true;
	    return;
	  }
	
	  this._procField('size', 'uint', 32);
	  this._procField('type', 'string', 4);
	
	  if (this.size === 1)      { this._procField('largesize', 'uint', 64); }
	  if (this.type === 'uuid') { this._procFieldArray('usertype', 16, 'uint', 8); }
	
	  switch(this.size) {
	  case 0:
	    this._raw = new DataView(this._raw.buffer, this._offset, (this._raw.byteLength - this._cursor.offset + 8));
	    break;
	  case 1:
	    if (this._offset + this.size > this._raw.buffer.byteLength) {
	      this._incomplete = true;
	      this._root._incomplete = true;
	    } else {
	      this._raw = new DataView(this._raw.buffer, this._offset, this.largesize);
	    }
	    break;
	  default:
	    if (this._offset + this.size > this._raw.buffer.byteLength) {
	      this._incomplete = true;
	      this._root._incomplete = true;
	    } else {
	      this._raw = new DataView(this._raw.buffer, this._offset, this.size);
	    }
	  }
	
	  // additional parsing
	  if (!this._incomplete) {
	    if (this._boxProcessors[this.type]) {
	      this._boxProcessors[this.type].call(this);
	    }
	    if (this._boxContainers.indexOf(this.type) !== -1) {
	      this._parseContainerBox();
	    } else{
	      // Unknown box => read and store box content
	      this._data = this._readData();
	    }
	  }
	};
	
	ISOBox.prototype._parseFullBox = function() {
	  this.version = this._readUint(8);
	  this.flags = this._readUint(24);
	};
	
	ISOBox.prototype._parseContainerBox = function() {
	  this.boxes = [];
	  while (this._cursor.offset - this._raw.byteOffset < this._raw.byteLength) {
	    this.boxes.push(ISOBox.parse(this));
	  }
	};
	
	///////////////////////////////////////////////////////////////////////////////////////////////////
	// Write functions
	
	ISOBox.prototype.append = function(box, pos) {
	  ISOBoxer.Utils.appendBox(this, box, pos);
	};
	
	ISOBox.prototype.getLength = function() {
	  this._parsing = false;
	  this._rawo = null;
	
	  this.size = 0;
	  this._procField('size', 'uint', 32);
	  this._procField('type', 'string', 4);
	
	  if (this.size === 1)      { this._procField('largesize', 'uint', 64); }
	  if (this.type === 'uuid') { this._procFieldArray('usertype', 16, 'uint', 8); }
	
	  if (this._boxProcessors[this.type]) {
	    this._boxProcessors[this.type].call(this);
	  }
	
	  if (this._boxContainers.indexOf(this.type) !== -1) {
	    for (var i = 0; i < this.boxes.length; i++) {
	      this.size += this.boxes[i].getLength();
	    }
	  } 
	
	  if (this._data) {
	    this._writeData(this._data);
	  }
	
	  return this.size;
	};
	
	ISOBox.prototype.write = function() {
	  this._parsing = false;
	  this._cursor.offset = this._parent._cursor.offset;
	
	  switch(this.size) {
	  case 0:
	    this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, (this.parent._rawo.byteLength - this._cursor.offset));
	    break;
	  case 1:
	      this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.largesize);
	    break;
	  default:
	      this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.size);
	  }
	
	  this._procField('size', 'uint', 32);
	  this._procField('type', 'string', 4);
	
	  if (this.size === 1)      { this._procField('largesize', 'uint', 64); }
	  if (this.type === 'uuid') { this._procFieldArray('usertype', 16, 'uint', 8); }
	
	  if (this._boxProcessors[this.type]) {
	    this._boxProcessors[this.type].call(this);
	  }
	
	  if (this._boxContainers.indexOf(this.type) !== -1) {
	    for (var i = 0; i < this.boxes.length; i++) {
	      this.boxes[i].write();
	    }
	  } 
	
	  if (this._data) {
	    this._writeData(this._data);
	  }
	
	  this._parent._cursor.offset += this.size;
	
	  return this.size;
	};
	
	ISOBox.prototype._writeInt = function(size, value) {
	  if (this._rawo) {
	    var offset = this._cursor.offset - this._rawo.byteOffset;
	    switch(size) {
	    case 8:
	      this._rawo.setInt8(offset, value);
	      break;
	    case 16:
	      this._rawo.setInt16(offset, value);
	      break;
	    case 32:
	      this._rawo.setInt32(offset, value);
	      break;
	    case 64:
	      // Warning: JavaScript cannot handle 64-bit integers natively.
	      // This will give unexpected results for integers >= 2^53
	      var s1 = Math.floor(value / Math.pow(2,32));
	      var s2 = value - (s1 * Math.pow(2,32));
	      this._rawo.setUint32(offset, s1);
	      this._rawo.setUint32(offset + 4, s2);
	      break;
	    }
	    this._cursor.offset += (size >> 3);
	  } else {
	    this.size += (size >> 3);
	  }
	};
	
	ISOBox.prototype._writeUint = function(size, value) {
	
	  if (this._rawo) {
	    var offset = this._cursor.offset - this._rawo.byteOffset,
	        s1, s2;
	    switch(size) {
	    case 8:
	      this._rawo.setUint8(offset, value);
	      break;
	    case 16:
	      this._rawo.setUint16(offset, value);
	      break;
	    case 24:
	      s1 = (value & 0xFFFF00) >> 8;
	      s2 = (value & 0x0000FF);
	      this._rawo.setUint16(offset, s1);
	      this._rawo.setUint8(offset + 2, s2);
	      break;
	    case 32:
	      this._rawo.setUint32(offset, value);
	      break;
	    case 64:
	      // Warning: JavaScript cannot handle 64-bit integers natively.
	      // This will give unexpected results for integers >= 2^53
	      s1 = Math.floor(value / Math.pow(2,32));
	      s2 = value - (s1 * Math.pow(2,32));
	      this._rawo.setUint32(offset, s1);
	      this._rawo.setUint32(offset + 4, s2);
	      break;
	    }
	    this._cursor.offset += (size >> 3);
	  } else {
	    this.size += (size >> 3);
	  }
	};
	
	ISOBox.prototype._writeString = function(size, str) {
	  for (var c = 0; c < size; c++) {
	    this._writeUint(8, str.charCodeAt(c));
	  }
	};
	
	ISOBox.prototype._writeTerminatedString = function(str) {
	  if (str.length === 0) {
	    return;
	  }
	  for (var c = 0; c < str.length; c++) {
	    this._writeUint(8, str.charCodeAt(c));
	  }
	  this._writeUint(8, 0);
	};
	
	ISOBox.prototype._writeTemplate = function(size, value) {
	  var pre = Math.floor(value);
	  var post = (value - pre) * Math.pow(2, size / 2);
	  this._writeUint(size / 2, pre);
	  this._writeUint(size / 2, post);
	};
	
	ISOBox.prototype._writeData = function(data) {
	  var i;
	  //data to copy
	  if (data) {
	    if (this._rawo) {
	      //Array and Uint8Array has also to be managed
	      if (data instanceof Array) {
	        var offset = this._cursor.offset - this._rawo.byteOffset;
	        for (var i = 0; i < data.length; i++) {
	          this._rawo.setInt8(offset + i, data[i]);
	        }
	        this._cursor.offset += data.length;
	      } 
	
	      if (data instanceof Uint8Array) {
	        this._root.bytes.set(data, this._cursor.offset);
	        this._cursor.offset += data.length;
	      }
	
	    } else {
	      //nothing to copy only size to compute
	      this.size += data.length;
	    }
	  }
	};
	
	ISOBox.prototype._writeUTF8String = function(string) {
	  var u = ISOBoxer.Utils.utf8ToByteArray(string);
	  if (this._rawo) {
	    var dataView = new DataView(this._rawo.buffer, this._cursor.offset, u.length);
	    for (var i = 0; i < u.length; i++) {
	      dataView.setUint8(i, u[i]);
	    }
	  } else {
	    this.size += u.length;
	  }
	};
	
	ISOBox.prototype._writeField = function(type, size, value) {
	  switch (type) {
	  case 'uint':
	    this._writeUint(size, value);
	    break;
	  case 'int':
	    this._writeInt(size, value);
	    break;
	  case 'template':
	    this._writeTemplate(size, value);
	    break;
	  case 'string':
	      if (size == -1) {
	        this._writeTerminatedString(value);
	      } else {
	        this._writeString(size, value);
	      }
	      break;
	  case 'data':
	    this._writeData(value);
	    break;
	  case 'utf8':
	    this._writeUTF8String(value);
	    break;
	  default:
	    break;
	  }
	};
	
	// ISO/IEC 14496-15:2014 - avc1 box
	ISOBox.prototype._boxProcessors['avc1'] = ISOBox.prototype._boxProcessors['encv'] = function() {
	  // SampleEntry fields
	  this._procFieldArray('reserved1', 6,    'uint', 8);
	  this._procField('data_reference_index', 'uint', 16);
	  // VisualSampleEntry fields
	  this._procField('pre_defined1',         'uint',     16);
	  this._procField('reserved2',            'uint',     16);
	  this._procFieldArray('pre_defined2', 3, 'uint',     32);
	  this._procField('width',                'uint',     16);
	  this._procField('height',               'uint',     16);
	  this._procField('horizresolution',      'template', 32);
	  this._procField('vertresolution',       'template', 32);
	  this._procField('reserved3',            'uint',     32);
	  this._procField('frame_count',          'uint',     16);
	  this._procFieldArray('compressorname', 32,'uint',    8);
	  this._procField('depth',                'uint',     16);
	  this._procField('pre_defined3',         'int',      16);
	  // AVCSampleEntry fields
	  this._procField('config', 'data', -1);
	};
	
	// ISO/IEC 14496-12:2012 - 8.7.2 Data Reference Box
	ISOBox.prototype._boxProcessors['dref'] = function() {
	  this._procFullBox();
	  this._procField('entry_count', 'uint', 32);
	  this._procSubBoxes('entries', this.entry_count);
	};
	
	// ISO/IEC 14496-12:2012 - 8.6.6 Edit List Box
	ISOBox.prototype._boxProcessors['elst'] = function() {
	  this._procFullBox();
	  this._procField('entry_count', 'uint', 32);
	  this._procEntries('entries', this.entry_count, function(entry) {
	    this._procEntryField(entry, 'segment_duration',     'uint', (this.version === 1) ? 64 : 32);
	    this._procEntryField(entry, 'media_time',           'int',  (this.version === 1) ? 64 : 32);
	    this._procEntryField(entry, 'media_rate_integer',   'int',  16);
	    this._procEntryField(entry, 'media_rate_fraction',  'int',  16);
	  });
	};
	
	// ISO/IEC 23009-1:2014 - 5.10.3.3 Event Message Box
	ISOBox.prototype._boxProcessors['emsg'] = function() {
	  this._procFullBox();
	  this._procField('scheme_id_uri',            'string', -1);
	  this._procField('value',                    'string', -1);
	  this._procField('timescale',                'uint',   32);
	  this._procField('presentation_time_delta',  'uint',   32);
	  this._procField('event_duration',           'uint',   32);
	  this._procField('id',                       'uint',   32);
	  this._procField('message_data',             'data',   -1);
	};
	
	// ISO/IEC 14496-12:2012 - 8.1.2 Free Space Box
	ISOBox.prototype._boxProcessors['free'] = ISOBox.prototype._boxProcessors['skip'] = function() {
	  this._procField('data', 'data', -1);
	};
	
	// ISO/IEC 14496-12:2012 - 8.12.2 Original Format Box
	ISOBox.prototype._boxProcessors['frma'] = function() {
	  this._procField('data_format', 'uint', 32);
	};
	// ISO/IEC 14496-12:2012 - 4.3 File Type Box / 8.16.2 Segment Type Box
	ISOBox.prototype._boxProcessors['ftyp'] =
	ISOBox.prototype._boxProcessors['styp'] = function() {
	  this._procField('major_brand', 'string', 4);
	  this._procField('minor_version', 'uint', 32);
	  var nbCompatibleBrands = -1;
	  if (this._parsing) {
	    nbCompatibleBrands = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)) / 4;
	  }
	  this._procFieldArray('compatible_brands', nbCompatibleBrands, 'string', 4);
	};
	
	// ISO/IEC 14496-12:2012 - 8.4.3 Handler Reference Box
	ISOBox.prototype._boxProcessors['hdlr'] = function() {
	  this._procFullBox();
	  this._procField('pre_defined',      'uint',   32);
	  this._procField('handler_type',     'string', 4);
	  this._procFieldArray('reserved', 3, 'uint', 32);
	  this._procField('name',             'string', -1);
	};
	
	// ISO/IEC 14496-12:2012 - 8.1.1 Media Data Box
	ISOBox.prototype._boxProcessors['mdat'] = function() {
	  this._procField('data', 'data', -1);
	};
	
	// ISO/IEC 14496-12:2012 - 8.4.2 Media Header Box
	ISOBox.prototype._boxProcessors['mdhd'] = function() {
	  this._procFullBox();
	  this._procField('creation_time',      'uint', (this.version == 1) ? 64 : 32);
	  this._procField('modification_time',  'uint', (this.version == 1) ? 64 : 32);
	  this._procField('timescale',          'uint', 32);
	  this._procField('duration',           'uint', (this.version == 1) ? 64 : 32);
	  if (!this._parsing && typeof this.language === 'string') {
	    // In case of writing and language has been set as a string, then convert it into char codes array
	    this.language = ((this.language.charCodeAt(0) - 0x60) << 10) |
	                    ((this.language.charCodeAt(1) - 0x60) << 5) |
	                    ((this.language.charCodeAt(2) - 0x60));
	  }
	  this._procField('language',           'uint', 16);
	  if (this._parsing) {
	    this.language = String.fromCharCode(((this.language >> 10) & 0x1F) + 0x60,
	                                        ((this.language >> 5) & 0x1F) + 0x60,
	                                        (this.language & 0x1F) + 0x60);
	  }
	  this._procField('pre_defined',        'uint', 16);
	};
	
	// ISO/IEC 14496-12:2012 - 8.8.2 Movie Extends Header Box
	ISOBox.prototype._boxProcessors['mehd'] = function() {
	  this._procFullBox();
	  this._procField('fragment_duration', 'uint', (this.version == 1) ? 64 : 32);
	};
	
	// ISO/IEC 14496-12:2012 - 8.8.5 Movie Fragment Header Box
	ISOBox.prototype._boxProcessors['mfhd'] = function() {
	  this._procFullBox();
	  this._procField('sequence_number', 'uint', 32);
	};
	
	// ISO/IEC 14496-12:2012 - 8.8.11 Movie Fragment Random Access Box
	ISOBox.prototype._boxProcessors['mfro'] = function() {
	  this._procFullBox();
	  this._procField('mfra_size', 'uint', 32); // Called mfra_size to distinguish from the normal "size" attribute of a box
	};
	
	
	// ISO/IEC 14496-12:2012 - 8.5.2.2 mp4a box (use AudioSampleEntry definition and naming)
	ISOBox.prototype._boxProcessors['mp4a'] = ISOBox.prototype._boxProcessors['enca'] = function() {
	  // SampleEntry fields
	  this._procFieldArray('reserved1', 6,    'uint', 8);
	  this._procField('data_reference_index', 'uint', 16);
	  // AudioSampleEntry fields
	  this._procFieldArray('reserved2', 2,    'uint', 32);
	  this._procField('channelcount',         'uint', 16);
	  this._procField('samplesize',           'uint', 16);
	  this._procField('pre_defined',          'uint', 16);
	  this._procField('reserved3',            'uint', 16);
	  this._procField('samplerate',           'template', 32);
	  // ESDescriptor fields
	  this._procField('esds',                 'data', -1);
	};
	
	// ISO/IEC 14496-12:2012 - 8.2.2 Movie Header Box
	ISOBox.prototype._boxProcessors['mvhd'] = function() {
	  this._procFullBox();
	  this._procField('creation_time',      'uint',     (this.version == 1) ? 64 : 32);
	  this._procField('modification_time',  'uint',     (this.version == 1) ? 64 : 32);
	  this._procField('timescale',          'uint',     32);
	  this._procField('duration',           'uint',     (this.version == 1) ? 64 : 32);
	  this._procField('rate',               'template', 32);
	  this._procField('volume',             'template', 16);
	  this._procField('reserved1',          'uint',  16);
	  this._procFieldArray('reserved2', 2,  'uint',     32);
	  this._procFieldArray('matrix', 9,     'template', 32);
	  this._procFieldArray('pre_defined', 6,'uint',   32);
	  this._procField('next_track_ID',      'uint',     32);
	};
	
	// ISO/IEC 14496-30:2014 - WebVTT Cue Payload Box.
	ISOBox.prototype._boxProcessors['payl'] = function() {
	  this._procField('cue_text', 'utf8');
	};
	
	//ISO/IEC 23001-7:2011 - 8.1 Protection System Specific Header Box
	ISOBox.prototype._boxProcessors['pssh'] = function() {
	  this._procFullBox();
	  
	  this._procFieldArray('SystemID', 16, 'uint', 8);
	  this._procField('DataSize', 'uint', 32);
	  this._procFieldArray('Data', this.DataSize, 'uint', 8);
	};
	// ISO/IEC 14496-12:2012 - 8.12.5 Scheme Type Box
	ISOBox.prototype._boxProcessors['schm'] = function() {
	    this._procFullBox();
	    
	    this._procField('scheme_type', 'uint', 32);
	    this._procField('scheme_version', 'uint', 32);
	
	    if (this.flags & 0x000001) {
	        this._procField('scheme_uri', 'string', -1);
	    }
	};
	// ISO/IEC 14496-12:2012 - 8.6.4.1 sdtp box 
	ISOBox.prototype._boxProcessors['sdtp'] = function() {
	  this._procFullBox();
	
	  var sample_count = -1;
	  if (this._parsing) {
	    sample_count = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset));
	  }
	
	  this._procFieldArray('sample_dependency_table', sample_count, 'uint', 8);
	};
	
	// ISO/IEC 14496-12:2012 - 8.16.3 Segment Index Box
	ISOBox.prototype._boxProcessors['sidx'] = function() {
	  this._procFullBox();
	  this._procField('reference_ID', 'uint', 32);
	  this._procField('timescale', 'uint', 32);
	  this._procField('earliest_presentation_time', 'uint', (this.version == 1) ? 64 : 32);
	  this._procField('first_offset', 'uint', (this.version == 1) ? 64 : 32);
	  this._procField('reserved', 'uint', 16);
	  this._procField('reference_count', 'uint', 16);
	  this._procEntries('references', this.reference_count, function(entry) {
	    if (!this._parsing) {
	      entry.reference  = (entry.reference_type  & 0x00000001) << 31;
	      entry.reference |= (entry.referenced_size & 0x7FFFFFFF);
	      entry.sap  = (entry.starts_with_SAP & 0x00000001) << 31;
	      entry.sap |= (entry.SAP_type        & 0x00000003) << 28;
	      entry.sap |= (entry.SAP_delta_time  & 0x0FFFFFFF);
	    }
	    this._procEntryField(entry, 'reference', 'uint', 32);
	    this._procEntryField(entry, 'subsegment_duration', 'uint', 32);
	    this._procEntryField(entry, 'sap', 'uint', 32);
	    if (this._parsing) {
	      entry.reference_type = (entry.reference >> 31) & 0x00000001;
	      entry.referenced_size = entry.reference & 0x7FFFFFFF;
	      entry.starts_with_SAP  = (entry.sap >> 31) & 0x00000001;
	      entry.SAP_type = (entry.sap >> 28) & 0x00000007;
	      entry.SAP_delta_time = (entry.sap  & 0x0FFFFFFF);
	    }
	  });
	};
	
	// ISO/IEC 14496-12:2012 - 8.4.5.3 Sound Media Header Box
	ISOBox.prototype._boxProcessors['smhd'] = function() {
	  this._procFullBox();
	  this._procField('balance',  'uint', 16);
	  this._procField('reserved', 'uint', 16);
	};
	
	// ISO/IEC 14496-12:2012 - 8.16.4 Subsegment Index Box
	ISOBox.prototype._boxProcessors['ssix'] = function() {
	  this._procFullBox();
	  this._procField('subsegment_count', 'uint', 32);
	  this._procEntries('subsegments', this.subsegment_count, function(subsegment) {
	    this._procEntryField(subsegment, 'ranges_count', 'uint', 32);
	    this._procSubEntries(subsegment, 'ranges', subsegment.ranges_count, function(range) {
	      this._procEntryField(range, 'level', 'uint', 8);
	      this._procEntryField(range, 'range_size', 'uint', 24);
	    });
	  });
	};
	
	// ISO/IEC 14496-12:2012 - 8.5.2 Sample Description Box
	ISOBox.prototype._boxProcessors['stsd'] = function() {
	  this._procFullBox();
	  this._procField('entry_count', 'uint', 32);
	  this._procSubBoxes('entries', this.entry_count);
	};
	
	// ISO/IEC 14496-12:2015 - 8.7.7 Sub-Sample Information Box
	ISOBox.prototype._boxProcessors['subs'] = function () {
	  this._procFullBox();
	  this._procField('entry_count', 'uint', 32);
	  this._procEntries('entries', this.entry_count, function(entry) {
	    this._procEntryField(entry, 'sample_delta', 'uint', 32);
	    this._procEntryField(entry, 'subsample_count', 'uint', 16);
	    this._procSubEntries(entry, 'subsamples', entry.subsample_count, function(subsample) {
	      this._procEntryField(subsample, 'subsample_size', 'uint', (this.version === 1) ? 32 : 16);
	      this._procEntryField(subsample, 'subsample_priority', 'uint', 8);
	      this._procEntryField(subsample, 'discardable', 'uint', 8);
	      this._procEntryField(subsample, 'codec_specific_parameters', 'uint', 32);
	    });
	  });
	};
	
	//ISO/IEC 23001-7:2011 - 8.2 Track Encryption Box
	ISOBox.prototype._boxProcessors['tenc'] = function() {
	    this._procFullBox();
	
	    this._procField('default_IsEncrypted', 'uint', 24);
	    this._procField('default_IV_size', 'uint', 8);
	    this._procFieldArray('default_KID', 16,    'uint', 8);
	 };
	
	// ISO/IEC 14496-12:2012 - 8.8.12 Track Fragmnent Decode Time
	ISOBox.prototype._boxProcessors['tfdt'] = function() {
	  this._procFullBox();
	  this._procField('baseMediaDecodeTime', 'uint', (this.version == 1) ? 64 : 32);
	};
	
	// ISO/IEC 14496-12:2012 - 8.8.7 Track Fragment Header Box
	ISOBox.prototype._boxProcessors['tfhd'] = function() {
	  this._procFullBox();
	  this._procField('track_ID', 'uint', 32);
	  if (this.flags & 0x01) this._procField('base_data_offset',          'uint', 64);
	  if (this.flags & 0x02) this._procField('sample_description_offset', 'uint', 32);
	  if (this.flags & 0x08) this._procField('default_sample_duration',   'uint', 32);
	  if (this.flags & 0x10) this._procField('default_sample_size',       'uint', 32);
	  if (this.flags & 0x20) this._procField('default_sample_flags',      'uint', 32);
	};
	
	// ISO/IEC 14496-12:2012 - 8.8.10 Track Fragment Random Access Box
	ISOBox.prototype._boxProcessors['tfra'] = function() {
	  this._procFullBox();
	  this._procField('track_ID', 'uint', 32);
	  if (!this._parsing) {
	    this.reserved = 0;
	    this.reserved |= (this.length_size_of_traf_num  & 0x00000030) << 4;
	    this.reserved |= (this.length_size_of_trun_num  & 0x0000000C) << 2;
	    this.reserved |= (this.length_size_of_sample_num  & 0x00000003);
	  }
	  this._procField('reserved', 'uint', 32);
	  if (this._parsing) {
	    this.length_size_of_traf_num = (this.reserved & 0x00000030) >> 4;
	    this.length_size_of_trun_num = (this.reserved & 0x0000000C) >> 2;
	    this.length_size_of_sample_num = (this.reserved & 0x00000003);
	  }
	  this._procField('number_of_entry', 'uint', 32);
	  this._procEntries('entries', this.number_of_entry, function(entry) {
	    this._procEntryField(entry, 'time', 'uint', (this.version === 1) ? 64 : 32);
	    this._procEntryField(entry, 'moof_offset', 'uint', (this.version === 1) ? 64 : 32);
	    this._procEntryField(entry, 'traf_number', 'uint', (this.length_size_of_traf_num + 1) * 8);
	    this._procEntryField(entry, 'trun_number', 'uint', (this.length_size_of_trun_num + 1) * 8);
	    this._procEntryField(entry, 'sample_number', 'uint', (this.length_size_of_sample_num + 1) * 8);
	  });
	};
	
	// ISO/IEC 14496-12:2012 - 8.3.2 Track Header Box
	ISOBox.prototype._boxProcessors['tkhd'] = function() {
	  this._procFullBox();
	  this._procField('creation_time',      'uint',     (this.version == 1) ? 64 : 32);
	  this._procField('modification_time',  'uint',     (this.version == 1) ? 64 : 32);
	  this._procField('track_ID',           'uint',     32);
	  this._procField('reserved1',          'uint',     32);
	  this._procField('duration',           'uint',     (this.version == 1) ? 64 : 32);
	  this._procFieldArray('reserved2', 2,  'uint',     32);
	  this._procField('layer',              'uint',     16);
	  this._procField('alternate_group',    'uint',     16);
	  this._procField('volume',             'template', 16);
	  this._procField('reserved3',          'uint',     16);
	  this._procFieldArray('matrix', 9,     'template', 32);
	  this._procField('width',              'template', 32);
	  this._procField('height',             'template', 32);
	};
	
	// ISO/IEC 14496-12:2012 - 8.8.3 Track Extends Box
	ISOBox.prototype._boxProcessors['trex'] = function() {
	  this._procFullBox();
	  this._procField('track_ID',                         'uint', 32);
	  this._procField('default_sample_description_index', 'uint', 32);
	  this._procField('default_sample_duration',          'uint', 32);
	  this._procField('default_sample_size',              'uint', 32);
	  this._procField('default_sample_flags',             'uint', 32);
	};
	
	// ISO/IEC 14496-12:2012 - 8.8.8 Track Run Box
	// Note: the 'trun' box has a direct relation to the 'tfhd' box for defaults.
	// These defaults are not set explicitly here, but are left to resolve for the user.
	ISOBox.prototype._boxProcessors['trun'] = function() {
	  this._procFullBox();
	  this._procField('sample_count', 'uint', 32);
	  if (this.flags & 0x1) this._procField('data_offset', 'int', 32);
	  if (this.flags & 0x4) this._procField('first_sample_flags', 'uint', 32);
	  this._procEntries('samples', this.sample_count, function(sample) {
	    if (this.flags & 0x100) this._procEntryField(sample, 'sample_duration', 'uint', 32);
	    if (this.flags & 0x200) this._procEntryField(sample, 'sample_size', 'uint', 32);
	    if (this.flags & 0x400) this._procEntryField(sample, 'sample_flags', 'uint', 32);
	    if (this.flags & 0x800) this._procEntryField(sample, 'sample_composition_time_offset', (this.version === 1) ? 'int' : 'uint',  32);
	  });
	};
	
	// ISO/IEC 14496-12:2012 - 8.7.2 Data Reference Box
	ISOBox.prototype._boxProcessors['url '] = ISOBox.prototype._boxProcessors['urn '] = function() {
	  this._procFullBox();
	  if (this.type === 'urn ') {
	    this._procField('name', 'string', -1);
	  }
	  this._procField('location', 'string', -1);
	};
	
	// ISO/IEC 14496-30:2014 - WebVTT Source Label Box
	ISOBox.prototype._boxProcessors['vlab'] = function() {
	  this._procField('source_label', 'utf8');
	};
	
	// ISO/IEC 14496-12:2012 - 8.4.5.2 Video Media Header Box
	ISOBox.prototype._boxProcessors['vmhd'] = function() {
	  this._procFullBox();
	  this._procField('graphicsmode', 'uint', 16);
	  this._procFieldArray('opcolor', 3, 'uint', 16);
	};
	
	// ISO/IEC 14496-30:2014 - WebVTT Configuration Box
	ISOBox.prototype._boxProcessors['vttC'] = function() {
	  this._procField('config', 'utf8');
	};
	
	// ISO/IEC 14496-30:2014 - WebVTT Empty Sample Box
	ISOBox.prototype._boxProcessors['vtte'] = function() {
	  // Nothing should happen here.
	};


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var _constantsDashConstants=__webpack_require__(25);var _constantsDashConstants2=_interopRequireDefault(_constantsDashConstants);var Representation=(function(){function Representation(){_classCallCheck(this,Representation);this.id = null;this.index = -1;this.adaptation = null;this.segmentInfoType = null;this.initialization = null;this.codecs = null;this.codecPrivateData = null;this.segmentDuration = NaN;this.timescale = 1;this.startNumber = 1;this.indexRange = null;this.range = null;this.presentationTimeOffset = 0; // Set the source buffer timeOffset to this
	this.MSETimeOffset = NaN;this.segmentAvailabilityRange = null;this.availableSegmentsNumber = 0;this.bandwidth = NaN;this.width = NaN;this.height = NaN;this.scanType = null;this.maxPlayoutRate = NaN;this.availabilityTimeOffset = 0;this.availabilityTimeComplete = true;}_createClass(Representation,null,[{key:'hasInitialization',value:function hasInitialization(r){return r.initialization !== null || r.range !== null;}},{key:'hasSegments',value:function hasSegments(r){return r.segmentInfoType !== _constantsDashConstants2['default'].BASE_URL && r.segmentInfoType !== _constantsDashConstants2['default'].SEGMENT_BASE && !r.indexRange;}}]);return Representation;})();exports['default'] = Representation;module.exports = exports['default'];
	//# sourceMappingURL=Representation.js.map


/***/ },
/* 86 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Segment=function Segment(){_classCallCheck(this,Segment);this.indexRange = null;this.index = null;this.mediaRange = null;this.media = null;this.duration = NaN; // this is the time that should be inserted into the media url
	this.replacementTime = null; // this is the number that should be inserted into the media url
	this.replacementNumber = NaN; // This is supposed to match the time encoded in the media Segment
	this.mediaStartTime = NaN; // When the source buffer timeOffset is set to MSETimeOffset this is the
	// time that will match the seekTarget and video.currentTime
	this.presentationStartTime = NaN; // Do not schedule this segment until
	this.availabilityStartTime = NaN; // Ignore and  discard this segment after
	this.availabilityEndTime = NaN; // The index of the segment inside the availability window
	this.availabilityIdx = NaN; // For dynamic mpd's, this is the wall clock time that the video
	// element currentTime should be presentationStartTime
	this.wallStartTime = NaN;this.representation = null;};exports["default"] = Segment;module.exports = exports["default"];
	//# sourceMappingURL=Segment.js.map


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var TRACK_SWITCH_MODE_NEVER_REPLACE='neverReplace';var TRACK_SWITCH_MODE_ALWAYS_REPLACE='alwaysReplace';var TRACK_SELECTION_MODE_HIGHEST_BITRATE='highestBitrate';var TRACK_SELECTION_MODE_WIDEST_RANGE='widestRange';var DEFAULT_INIT_TRACK_SELECTION_MODE=TRACK_SELECTION_MODE_HIGHEST_BITRATE;function MediaController(){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,tracks=undefined,initialSettings=undefined,selectionMode=undefined,switchMode=undefined,errHandler=undefined,domStorage=undefined;var validTrackSwitchModes=[TRACK_SWITCH_MODE_ALWAYS_REPLACE,TRACK_SWITCH_MODE_NEVER_REPLACE];var validTrackSelectionModes=[TRACK_SELECTION_MODE_HIGHEST_BITRATE,TRACK_SELECTION_MODE_WIDEST_RANGE];function setup(){reset();} /**
	     * @param {string} type
	     * @param {StreamInfo} streamInfo
	     * @memberof MediaController#
	     */function checkInitialMediaSettingsForType(type,streamInfo){var settings=getInitialSettings(type);var tracksForType=getTracksFor(type,streamInfo);var tracks=[];if(type === _constantsConstants2['default'].FRAGMENTED_TEXT){ // Choose the first track
	setTrack(tracksForType[0]);return;}if(!settings){settings = domStorage.getSavedMediaSettings(type);setInitialSettings(type,settings);}if(!tracksForType || tracksForType.length === 0)return;if(settings){tracksForType.forEach(function(track){if(matchSettings(settings,track)){tracks.push(track);}});}if(tracks.length === 0){setTrack(selectInitialTrack(tracksForType));}else {if(tracks.length > 1){setTrack(selectInitialTrack(tracks));}else {setTrack(tracks[0]);}}} /**
	     * @param {MediaInfo} track
	     * @memberof MediaController#
	     */function addTrack(track){if(!track)return;var mediaType=track.type;if(!isMultiTrackSupportedByType(mediaType))return;var streamId=track.streamInfo.id;if(!tracks[streamId]){tracks[streamId] = createTrackInfo();}var mediaTracks=tracks[streamId][mediaType].list;for(var i=0,len=mediaTracks.length;i < len;++i) { //track is already set.
	if(isTracksEqual(mediaTracks[i],track)){return;}}mediaTracks.push(track);var initSettings=getInitialSettings(mediaType);if(initSettings && matchSettings(initSettings,track) && !getCurrentTrackFor(mediaType,track.streamInfo)){setTrack(track);}} /**
	     * @param {string} type
	     * @param {StreamInfo} streamInfo
	     * @returns {Array}
	     * @memberof MediaController#
	     */function getTracksFor(type,streamInfo){if(!type || !streamInfo)return [];var id=streamInfo.id;if(!tracks[id] || !tracks[id][type])return [];return tracks[id][type].list;} /**
	     * @param {string} type
	     * @param {StreamInfo} streamInfo
	     * @returns {Object|null}
	     * @memberof MediaController#
	     */function getCurrentTrackFor(type,streamInfo){if(!type || !streamInfo || streamInfo && !tracks[streamInfo.id])return null;return tracks[streamInfo.id][type].current;} /**
	     * @param {MediaInfo} track
	     * @returns {boolean}
	     * @memberof MediaController#
	     */function isCurrentTrack(track){var type=track.type;var id=track.streamInfo.id;return tracks[id] && tracks[id][type] && isTracksEqual(tracks[id][type].current,track);} /**
	     * @param {MediaInfo} track
	     * @memberof MediaController#
	     */function setTrack(track){if(!track)return;var type=track.type;var streamInfo=track.streamInfo;var id=streamInfo.id;var current=getCurrentTrackFor(type,streamInfo);if(!tracks[id] || !tracks[id][type] || current && isTracksEqual(track,current))return;tracks[id][type].current = track;if(current){eventBus.trigger(_coreEventsEvents2['default'].CURRENT_TRACK_CHANGED,{oldMediaInfo:current,newMediaInfo:track,switchMode:switchMode[type]});}var settings=extractSettings(track);if(!settings || !tracks[id][type].storeLastSettings)return;if(settings.roles){settings.role = settings.roles[0];delete settings.roles;}if(settings.accessibility){settings.accessibility = settings.accessibility[0];}if(settings.audioChannelConfiguration){settings.audioChannelConfiguration = settings.audioChannelConfiguration[0];}domStorage.setSavedMediaSettings(type,settings);} /**
	     * @param {string} type
	     * @param {Object} value
	     * @memberof MediaController#
	     */function setInitialSettings(type,value){if(!type || !value)return;initialSettings[type] = value;} /**
	     * @param {string} type
	     * @returns {Object|null}
	     * @memberof MediaController#
	     */function getInitialSettings(type){if(!type)return null;return initialSettings[type];} /**
	     * @param {string} type
	     * @param {string} mode
	     * @memberof MediaController#
	     */function setSwitchMode(type,mode){var isModeSupported=validTrackSwitchModes.indexOf(mode) !== -1;if(!isModeSupported){log('track switch mode is not supported: ' + mode);return;}switchMode[type] = mode;} /**
	     * @param {string} type
	     * @returns {string} mode
	     * @memberof MediaController#
	     */function getSwitchMode(type){return switchMode[type];} /**
	     * @param {string} mode
	     * @memberof MediaController#
	     */function setSelectionModeForInitialTrack(mode){var isModeSupported=validTrackSelectionModes.indexOf(mode) !== -1;if(!isModeSupported){log('track selection mode is not supported: ' + mode);return;}selectionMode = mode;} /**
	     * @returns {string} mode
	     * @memberof MediaController#
	     */function getSelectionModeForInitialTrack(){return selectionMode || DEFAULT_INIT_TRACK_SELECTION_MODE;} /**
	     * @param {string} type
	     * @returns {boolean}
	     * @memberof MediaController#
	     */function isMultiTrackSupportedByType(type){return type === _constantsConstants2['default'].AUDIO || type === _constantsConstants2['default'].VIDEO || type === _constantsConstants2['default'].TEXT || type === _constantsConstants2['default'].FRAGMENTED_TEXT || type === _constantsConstants2['default'].IMAGE;} /**
	     * @param {MediaInfo} t1 - first track to compare
	     * @param {MediaInfo} t2 - second track to compare
	     * @returns {boolean}
	     * @memberof MediaController#
	     */function isTracksEqual(t1,t2){var sameId=t1.id === t2.id;var sameViewpoint=t1.viewpoint === t2.viewpoint;var sameLang=t1.lang === t2.lang;var sameRoles=t1.roles.toString() === t2.roles.toString();var sameAccessibility=t1.accessibility.toString() === t2.accessibility.toString();var sameAudioChannelConfiguration=t1.audioChannelConfiguration.toString() === t2.audioChannelConfiguration.toString();return sameId && sameViewpoint && sameLang && sameRoles && sameAccessibility && sameAudioChannelConfiguration;}function setConfig(config){if(!config)return;if(config.errHandler){errHandler = config.errHandler;}if(config.domStorage){domStorage = config.domStorage;}} /**
	     * @memberof MediaController#
	     */function reset(){tracks = {};resetInitialSettings();resetSwitchMode();}function extractSettings(mediaInfo){var settings={lang:mediaInfo.lang,viewpoint:mediaInfo.viewpoint,roles:mediaInfo.roles,accessibility:mediaInfo.accessibility,audioChannelConfiguration:mediaInfo.audioChannelConfiguration};var notEmpty=settings.lang || settings.viewpoint || settings.role && settings.role.length > 0 || settings.accessibility && settings.accessibility.length > 0 || settings.audioChannelConfiguration && settings.audioChannelConfiguration.length > 0;return notEmpty?settings:null;}function matchSettings(settings,track){var matchLang=!settings.lang || settings.lang === track.lang;var matchViewPoint=!settings.viewpoint || settings.viewpoint === track.viewpoint;var matchRole=!settings.role || !!track.roles.filter(function(item){return item === settings.role;})[0];var matchAccessibility=!settings.accessibility || !!track.accessibility.filter(function(item){return item === settings.accessibility;})[0];var matchAudioChannelConfiguration=!settings.audioChannelConfiguration || !!track.audioChannelConfiguration.filter(function(item){return item === settings.audioChannelConfiguration;})[0];return matchLang && matchViewPoint && matchRole && matchAccessibility && matchAudioChannelConfiguration;}function resetSwitchMode(){switchMode = {audio:TRACK_SWITCH_MODE_ALWAYS_REPLACE,video:TRACK_SWITCH_MODE_NEVER_REPLACE};}function resetInitialSettings(){initialSettings = {audio:null,video:null};}function selectInitialTrack(tracks){var mode=getSelectionModeForInitialTrack();var tmpArr=[];var getTracksWithHighestBitrate=function getTracksWithHighestBitrate(trackArr){var max=0;var result=[];var tmp=undefined;trackArr.forEach(function(track){tmp = Math.max.apply(Math,track.bitrateList.map(function(obj){return obj.bandwidth;}));if(tmp > max){max = tmp;result = [track];}else if(tmp === max){result.push(track);}});return result;};var getTracksWithWidestRange=function getTracksWithWidestRange(trackArr){var max=0;var result=[];var tmp=undefined;trackArr.forEach(function(track){tmp = track.representationCount;if(tmp > max){max = tmp;result = [track];}else if(tmp === max){result.push(track);}});return result;};switch(mode){case TRACK_SELECTION_MODE_HIGHEST_BITRATE:tmpArr = getTracksWithHighestBitrate(tracks);if(tmpArr.length > 1){tmpArr = getTracksWithWidestRange(tmpArr);}break;case TRACK_SELECTION_MODE_WIDEST_RANGE:tmpArr = getTracksWithWidestRange(tracks);if(tmpArr.length > 1){tmpArr = getTracksWithHighestBitrate(tracks);}break;default:log('track selection mode is not supported: ' + mode);break;}return tmpArr[0];}function createTrackInfo(){return {audio:{list:[],storeLastSettings:true,current:null},video:{list:[],storeLastSettings:true,current:null},text:{list:[],storeLastSettings:true,current:null},fragmentedText:{list:[],storeLastSettings:true,current:null},image:{list:[],storeLastSettings:true,current:null}};}instance = {checkInitialMediaSettingsForType:checkInitialMediaSettingsForType,addTrack:addTrack,getTracksFor:getTracksFor,getCurrentTrackFor:getCurrentTrackFor,isCurrentTrack:isCurrentTrack,setTrack:setTrack,setInitialSettings:setInitialSettings,getInitialSettings:getInitialSettings,setSwitchMode:setSwitchMode,getSwitchMode:getSwitchMode,setSelectionModeForInitialTrack:setSelectionModeForInitialTrack,getSelectionModeForInitialTrack:getSelectionModeForInitialTrack,isMultiTrackSupportedByType:isMultiTrackSupportedByType,isTracksEqual:isTracksEqual,setConfig:setConfig,reset:reset};setup();return instance;}MediaController.__dashjs_factory_name = 'MediaController';var factory=_coreFactoryMaker2['default'].getSingletonFactory(MediaController);factory.TRACK_SWITCH_MODE_NEVER_REPLACE = TRACK_SWITCH_MODE_NEVER_REPLACE;factory.TRACK_SWITCH_MODE_ALWAYS_REPLACE = TRACK_SWITCH_MODE_ALWAYS_REPLACE;factory.TRACK_SELECTION_MODE_HIGHEST_BITRATE = TRACK_SELECTION_MODE_HIGHEST_BITRATE;factory.TRACK_SELECTION_MODE_WIDEST_RANGE = TRACK_SELECTION_MODE_WIDEST_RANGE;factory.DEFAULT_INIT_TRACK_SELECTION_MODE = DEFAULT_INIT_TRACK_SELECTION_MODE;_coreFactoryMaker2['default'].updateSingletonFactory(MediaController.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=MediaController.js.map


/***/ },
/* 88 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc A collection of ClearKey encryption keys with an (optional) associated
	 *  type
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var ClearKeyKeySet=(function(){ /**
	     * @param {Array.<KeyPair>} keyPairs
	     * @param {string} type the type of keys in this set.  One of either 'persistent'
	     * or 'temporary'.  Can also be null or undefined.
	     * @class
	     * @ignore
	     */function ClearKeyKeySet(keyPairs,type){_classCallCheck(this,ClearKeyKeySet);if(type && type !== 'persistent' && type !== 'temporary')throw new Error('Invalid ClearKey key set type!  Must be one of \'persistent\' or \'temporary\'');this.keyPairs = keyPairs;this.type = type;} /**
	     * Convert this key set to its JSON Web Key (JWK) representation
	     *
	     * @return {ArrayBuffer} JWK object UTF-8 encoded as ArrayBuffer
	     */_createClass(ClearKeyKeySet,[{key:'toJWK',value:function toJWK(){var i=undefined;var numKeys=this.keyPairs.length;var jwk={keys:[]};for(i = 0;i < numKeys;i++) {var key={kty:'oct',alg:'A128KW',kid:this.keyPairs[i].keyID,k:this.keyPairs[i].key};jwk.keys.push(key);}if(this.type){jwk.type = this.type;}var jwkString=JSON.stringify(jwk);var len=jwkString.length; // Convert JSON string to ArrayBuffer
	var buf=new ArrayBuffer(len);var bView=new Uint8Array(buf);for(i = 0;i < len;i++) bView[i] = jwkString.charCodeAt(i);return buf;}}]);return ClearKeyKeySet;})();exports['default'] = ClearKeyKeySet;module.exports = exports['default'];
	//# sourceMappingURL=ClearKeyKeySet.js.map


/***/ },
/* 89 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc EME-independent KeyError
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var KeyError= /**
	     * @param {Object} sessionToken the key session to which this error is associated
	     * @param {string} errorString an informational error message
	     * @class
	     * @deprecated Newest versions of EME APIs will not use this error object
	     */function KeyError(sessionToken,errorString){_classCallCheck(this,KeyError);this.sessionToken = sessionToken;this.error = errorString;};exports["default"] = KeyError;module.exports = exports["default"];
	//# sourceMappingURL=KeyError.js.map


/***/ },
/* 90 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc EME-independent KeyMessage
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var KeyMessage= /**
	     * @param {SessionToken} sessionToken the session
	     * to which the key message is associated
	     * @param {ArrayBuffer} message the key message
	     * @param {string} defaultURL license acquisition URL provided by the CDM
	     * @param {string} messageType Supported message types can be found
	     * {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
	     * @class
	     */function KeyMessage(sessionToken,message,defaultURL,messageType){_classCallCheck(this,KeyMessage);this.sessionToken = sessionToken;this.message = message;this.defaultURL = defaultURL;this.messageType = messageType?messageType:'license-request';};exports['default'] = KeyMessage;module.exports = exports['default'];
	//# sourceMappingURL=KeyMessage.js.map


/***/ },
/* 91 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc Represents a 128-bit keyID and 128-bit encryption key
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var KeyPair= /**
	     * @param {string} keyID 128-bit key ID, base64 encoded, with no padding
	     * @param {string} key 128-bit encryption key, base64 encoded, with no padding
	     * @class
	     * @ignore
	     */function KeyPair(keyID,key){_classCallCheck(this,KeyPair);this.keyID = keyID;this.key = key;};exports["default"] = KeyPair;module.exports = exports["default"];
	//# sourceMappingURL=KeyPair.js.map


/***/ },
/* 92 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc Creates a new key system access token.  Represents a valid key system for
	 * given piece of content and key system requirements.  Used to initialize license
	 * acquisition operations.
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var KeySystemAccess= /**
	     * @param {MediaPlayer.dependencies.protection.KeySystem} keySystem the key system
	     * @param {KeySystemConfiguration} ksConfiguration the
	     * subset of configurations passed to the key system access request that are supported
	     * by this user agent
	     * @class
	     * @ignore
	     */function KeySystemAccess(keySystem,ksConfiguration){_classCallCheck(this,KeySystemAccess);this.keySystem = keySystem;this.ksConfiguration = ksConfiguration;};exports["default"] = KeySystemAccess;module.exports = exports["default"];
	//# sourceMappingURL=KeySystemAccess.js.map


/***/ },
/* 93 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc Represents a set of configurations that describe the capabilities desired for
	 *  support by a given CDM
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var KeySystemConfiguration= /**
	     * @param {Array.<MediaCapability>} audioCapabilities array of
	     * desired audio capabilities.  Higher preference capabilities should be placed earlier
	     * in the array.
	     * @param {Array.<MediaCapability>} videoCapabilities array of
	     * desired video capabilities.  Higher preference capabilities should be placed earlier
	     * in the array.
	     * @param {string} distinctiveIdentifier desired use of distinctive identifiers.
	     * One of "required", "optional", or "not-allowed"
	     * @param {string} persistentState desired support for persistent storage of
	     * key systems.  One of "required", "optional", or "not-allowed"
	     * @param {Array.<string>} sessionTypes List of session types that must
	     * be supported by the key system
	     * @class
	     */function KeySystemConfiguration(audioCapabilities,videoCapabilities,distinctiveIdentifier,persistentState,sessionTypes){_classCallCheck(this,KeySystemConfiguration);this.initDataTypes = ['cenc'];if(audioCapabilities && audioCapabilities.length){this.audioCapabilities = audioCapabilities;}if(videoCapabilities && videoCapabilities.length){this.videoCapabilities = videoCapabilities;}this.distinctiveIdentifier = distinctiveIdentifier;this.persistentState = persistentState;this.sessionTypes = sessionTypes;};exports['default'] = KeySystemConfiguration;module.exports = exports['default'];
	//# sourceMappingURL=KeySystemConfiguration.js.map


/***/ },
/* 94 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc NeedKey
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var NeedKey= /**
	     * @param {ArrayBuffer} initData the initialization data
	     * @param {string} initDataType initialization data type
	     * @class
	     */function NeedKey(initData,initDataType){_classCallCheck(this,NeedKey);this.initData = initData;this.initDataType = initDataType;};exports["default"] = NeedKey;module.exports = exports["default"];
	//# sourceMappingURL=NeedKey.js.map


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _TextSourceBuffer=__webpack_require__(404);var _TextSourceBuffer2=_interopRequireDefault(_TextSourceBuffer);var _TextTracks=__webpack_require__(96);var _TextTracks2=_interopRequireDefault(_TextTracks);var _utilsVTTParser=__webpack_require__(414);var _utilsVTTParser2=_interopRequireDefault(_utilsVTTParser);var _utilsTTMLParser=__webpack_require__(413);var _utilsTTMLParser2=_interopRequireDefault(_utilsTTMLParser);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);function TextController(){var context=this.context;var instance=undefined;var textSourceBuffer=undefined;var errHandler=undefined,dashManifestModel=undefined,manifestModel=undefined,mediaController=undefined,videoModel=undefined,streamController=undefined,textTracks=undefined,vttParser=undefined,ttmlParser=undefined,eventBus=undefined,defaultLanguage=undefined,lastEnabledIndex=undefined,textDefaultEnabled=undefined, // this is used for default settings (each time a file is loaded, we check value of this settings )
	allTracksAreDisabled=undefined; // this is used for one session (when a file has been loaded, we use this settings to enable/disable text)
	function setup(){defaultLanguage = '';lastEnabledIndex = -1;textDefaultEnabled = true;textTracks = (0,_TextTracks2['default'])(context).getInstance();vttParser = (0,_utilsVTTParser2['default'])(context).getInstance();ttmlParser = (0,_utilsTTMLParser2['default'])(context).getInstance();textSourceBuffer = (0,_TextSourceBuffer2['default'])(context).getInstance();eventBus = (0,_coreEventBus2['default'])(context).getInstance();textTracks.initialize();eventBus.on(_coreEventsEvents2['default'].TEXT_TRACKS_QUEUE_INITIALIZED,onTextTracksAdded,instance);resetInitialSettings();}function setConfig(config){if(!config){return;}if(config.errHandler){errHandler = config.errHandler;}if(config.dashManifestModel){dashManifestModel = config.dashManifestModel;}if(config.manifestModel){manifestModel = config.manifestModel;}if(config.mediaController){mediaController = config.mediaController;}if(config.videoModel){videoModel = config.videoModel;}if(config.streamController){streamController = config.streamController;}if(config.textTracks){textTracks = config.textTracks;}if(config.vttParser){vttParser = config.vttParser;}if(config.ttmlParser){ttmlParser = config.ttmlParser;} // create config for source buffer
	textSourceBuffer.setConfig({errHandler:errHandler,dashManifestModel:dashManifestModel,manifestModel:manifestModel,mediaController:mediaController,videoModel:videoModel,streamController:streamController,textTracks:textTracks,vttParser:vttParser,ttmlParser:ttmlParser});}function getTextSourceBuffer(){return textSourceBuffer;}function getAllTracksAreDisabled(){return allTracksAreDisabled;}function addEmbeddedTrack(mediaInfo){textSourceBuffer.addEmbeddedTrack(mediaInfo);}function setTextDefaultLanguage(lang){if(typeof lang !== 'string'){return;}defaultLanguage = lang;}function getTextDefaultLanguage(){return defaultLanguage;}function onTextTracksAdded(e){var _this=this;var tracks=e.tracks;var index=e.index;tracks.some(function(item,idx){if(item.lang === defaultLanguage){_this.setTextTrack(idx);index = idx;return true;}});if(!textDefaultEnabled){ // disable text at startup
	this.setTextTrack(-1);}lastEnabledIndex = index;eventBus.trigger(_coreEventsEvents2['default'].TEXT_TRACKS_ADDED,{enabled:!allTracksAreDisabled,index:index,tracks:tracks});}function setTextDefaultEnabled(enable){if(typeof enable !== 'boolean'){return;}textDefaultEnabled = enable;}function getTextDefaultEnabled(){return textDefaultEnabled;}function enableText(enable){if(typeof enable !== 'boolean'){return;}var isTextEnabled=!allTracksAreDisabled;if(isTextEnabled !== enable){ // change track selection
	if(enable){ // apply last enabled tractk
	this.setTextTrack(lastEnabledIndex);}if(!enable){ // keep last index and disable text track
	lastEnabledIndex = this.getCurrentTrackIdx();this.setTextTrack(-1);}}}function isTextEnabled(){return !allTracksAreDisabled;}function setTextTrack(idx){ //For external time text file,  the only action needed to change a track is marking the track mode to showing.
	// Fragmented text tracks need the additional step of calling TextController.setTextTrack();
	var config=textSourceBuffer.getConfig();var fragmentModel=config.fragmentModel;var fragmentedTracks=config.fragmentedTracks;var oldTrackIdx=textTracks.getCurrentTrackIdx();if(oldTrackIdx !== idx){textTracks.setModeForTrackIdx(oldTrackIdx,_constantsConstants2['default'].TEXT_HIDDEN);textTracks.setCurrentTrackIdx(idx);textTracks.setModeForTrackIdx(idx,_constantsConstants2['default'].TEXT_SHOWING);var currentTrackInfo=textTracks.getCurrentTrackInfo();if(currentTrackInfo && currentTrackInfo.isFragmented && !currentTrackInfo.isEmbedded){for(var i=0;i < fragmentedTracks.length;i++) {var mediaInfo=fragmentedTracks[i];if(currentTrackInfo.lang === mediaInfo.lang && currentTrackInfo.index === mediaInfo.index && (currentTrackInfo.label?currentTrackInfo.label === mediaInfo.id:true)){var currentFragTrack=mediaController.getCurrentTrackFor(_constantsConstants2['default'].FRAGMENTED_TEXT,streamController.getActiveStreamInfo());if(mediaInfo !== currentFragTrack){fragmentModel.abortRequests();fragmentModel.removeExecutedRequestsBeforeTime();textSourceBuffer.remove();textTracks.deleteCuesFromTrackIdx(oldTrackIdx);mediaController.setTrack(mediaInfo);textSourceBuffer.setCurrentFragmentedTrackIdx(i);}}}}}allTracksAreDisabled = idx === -1?true:false;}function getCurrentTrackIdx(){return textTracks.getCurrentTrackIdx();}function resetInitialSettings(){allTracksAreDisabled = false;}function reset(){resetInitialSettings();textSourceBuffer.resetEmbedded();}instance = {setConfig:setConfig,getTextSourceBuffer:getTextSourceBuffer,getAllTracksAreDisabled:getAllTracksAreDisabled,addEmbeddedTrack:addEmbeddedTrack,getTextDefaultLanguage:getTextDefaultLanguage,setTextDefaultLanguage:setTextDefaultLanguage,setTextDefaultEnabled:setTextDefaultEnabled,getTextDefaultEnabled:getTextDefaultEnabled,enableText:enableText,isTextEnabled:isTextEnabled,setTextTrack:setTextTrack,getCurrentTrackIdx:getCurrentTrackIdx,reset:reset};setup();return instance;}TextController.__dashjs_factory_name = 'TextController';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(TextController);module.exports = exports['default'];
	//# sourceMappingURL=TextController.js.map


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _imsc=__webpack_require__(165);function TextTracks(){var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var log=(0,_coreDebug2['default'])(context).getInstance().log;var instance=undefined,Cue=undefined,videoModel=undefined,textTrackQueue=undefined,trackElementArr=undefined,currentTrackIdx=undefined,actualVideoLeft=undefined,actualVideoTop=undefined,actualVideoWidth=undefined,actualVideoHeight=undefined,captionContainer=undefined,videoSizeCheckInterval=undefined,isChrome=undefined,fullscreenAttribute=undefined,displayCCOnTop=undefined,previousISDState=undefined,topZIndex=undefined;function initialize(){if(typeof window === 'undefined' || typeof navigator === 'undefined'){return;}Cue = window.VTTCue || window.TextTrackCue;textTrackQueue = [];trackElementArr = [];currentTrackIdx = -1;actualVideoLeft = 0;actualVideoTop = 0;actualVideoWidth = 0;actualVideoHeight = 0;captionContainer = null;videoSizeCheckInterval = null;displayCCOnTop = false;topZIndex = 2147483647;previousISDState = null; //TODO Check if IE has resolved issues: Then revert to not using the addTextTrack API for all browsers.
	// https://connect.microsoft.com/IE/feedbackdetail/view/1660701/text-tracks-do-not-fire-change-addtrack-or-removetrack-events
	// https://connect.microsoft.com/IE/feedback/details/1573380/htmltrackelement-track-addcue-throws-invalidstateerror-when-adding-new-cue
	// Same issue with Firefox.
	//isIE11orEdge = !!navigator.userAgent.match(/Trident.*rv[ :]*11\./) || navigator.userAgent.match(/Edge/);
	//isFirefox = !!navigator.userAgent.match(/Firefox/);
	isChrome = !!navigator.userAgent.match(/Chrome/) && !navigator.userAgent.match(/Edge/);if(document.fullscreenElement !== undefined){fullscreenAttribute = 'fullscreenElement'; // Standard and Edge
	}else if(document.webkitIsFullScreen !== undefined){fullscreenAttribute = 'webkitIsFullScreen'; // Chrome and Safari (and Edge)
	}else if(document.msFullscreenElement){ // IE11
	fullscreenAttribute = 'msFullscreenElement';}else if(document.mozFullScreen){ // Firefox
	fullscreenAttribute = 'mozFullScreen';}}function createTrackForUserAgent(i){var kind=textTrackQueue[i].kind;var label=textTrackQueue[i].label !== undefined?textTrackQueue[i].label:textTrackQueue[i].lang;var lang=textTrackQueue[i].lang;var isTTML=textTrackQueue[i].isTTML;var isEmbedded=textTrackQueue[i].isEmbedded;var track=isChrome?document.createElement('track'):videoModel.addTextTrack(kind,label,lang);if(isChrome){track.kind = kind;track.label = label;track.srclang = lang;}track.isEmbedded = isEmbedded;track.isTTML = isTTML;return track;}function displayCConTop(value){displayCCOnTop = value;if(!captionContainer || document[fullscreenAttribute]){return;}captionContainer.style.zIndex = value?topZIndex:null;}function addTextTrack(textTrackInfoVO,totalTextTracks){if(textTrackQueue.length === totalTextTracks){log('Trying to add too many tracks.');return;}textTrackQueue.push(textTrackInfoVO);if(textTrackQueue.length === totalTextTracks){textTrackQueue.sort(function(a,b){ //Sort in same order as in manifest
	return a.index - b.index;});captionContainer = videoModel.getTTMLRenderingDiv();var defaultIndex=-1;for(var i=0;i < textTrackQueue.length;i++) {var track=createTrackForUserAgent.call(this,i);trackElementArr.push(track); //used to remove tracks from video element when added manually
	if(textTrackQueue[i].defaultTrack){ // track.default is an object property identifier that is a reserved word
	// The following jshint directive is used to suppressed the warning "Expected an identifier and instead saw 'default' (a reserved word)"
	/*jshint -W024 */track['default'] = true;defaultIndex = i;}if(isChrome){videoModel.appendChild(track);}var textTrack=getTrackByIdx(i);if(textTrack){ //each time a track is created, its mode should be showing by default
	//sometime, it's not on Chrome
	textTrack.mode = _constantsConstants2['default'].TEXT_SHOWING;if(captionContainer && (textTrackQueue[i].isTTML || textTrackQueue[i].isEmbedded)){textTrack.renderingType = 'html';}else {textTrack.renderingType = 'default';}}this.addCaptions(i,0,textTrackQueue[i].captionData);eventBus.trigger(_coreEventsEvents2['default'].TEXT_TRACK_ADDED);} //set current track index in textTrackQueue array
	setCurrentTrackIdx.call(this,defaultIndex);if(defaultIndex >= 0){for(var idx=0;idx < textTrackQueue.length;idx++) {var videoTextTrack=getTrackByIdx(idx);if(videoTextTrack){videoTextTrack.mode = idx === defaultIndex?_constantsConstants2['default'].TEXT_SHOWING:_constantsConstants2['default'].TEXT_HIDDEN;}}}eventBus.trigger(_coreEventsEvents2['default'].TEXT_TRACKS_QUEUE_INITIALIZED,{index:currentTrackIdx,tracks:textTrackQueue}); //send default idx.
	}}function getVideoVisibleVideoSize(viewWidth,viewHeight,videoWidth,videoHeight,aspectRatio,use80Percent){var viewAspectRatio=viewWidth / viewHeight;var videoAspectRatio=videoWidth / videoHeight;var videoPictureWidth=0;var videoPictureHeight=0;if(viewAspectRatio > videoAspectRatio){videoPictureHeight = viewHeight;videoPictureWidth = videoPictureHeight / videoHeight * videoWidth;}else {videoPictureWidth = viewWidth;videoPictureHeight = videoPictureWidth / videoWidth * videoHeight;}var videoPictureXAspect=0;var videoPictureYAspect=0;var videoPictureWidthAspect=0;var videoPictureHeightAspect=0;var videoPictureAspect=videoPictureWidth / videoPictureHeight;if(videoPictureAspect > aspectRatio){videoPictureHeightAspect = videoPictureHeight;videoPictureWidthAspect = videoPictureHeight * aspectRatio;}else {videoPictureWidthAspect = videoPictureWidth;videoPictureHeightAspect = videoPictureWidth / aspectRatio;}videoPictureXAspect = (viewWidth - videoPictureWidthAspect) / 2;videoPictureYAspect = (viewHeight - videoPictureHeightAspect) / 2;if(use80Percent){return {x:videoPictureXAspect + videoPictureWidthAspect * 0.1,y:videoPictureYAspect + videoPictureHeightAspect * 0.1,w:videoPictureWidthAspect * 0.8,h:videoPictureHeightAspect * 0.8}; /* Maximal picture size in videos aspect ratio */}else {return {x:videoPictureXAspect,y:videoPictureYAspect,w:videoPictureWidthAspect,h:videoPictureHeightAspect}; /* Maximal picture size in videos aspect ratio */}}function checkVideoSize(track,forceDrawing){var clientWidth=videoModel.getClientWidth();var clientHeight=videoModel.getClientHeight();var videoWidth=videoModel.getVideoWidth();var videoHeight=videoModel.getVideoHeight();var videoOffsetTop=videoModel.getVideoRelativeOffsetTop();var videoOffsetLeft=videoModel.getVideoRelativeOffsetLeft();var aspectRatio=videoWidth / videoHeight;var use80Percent=false;if(track.isFromCEA608){ // If this is CEA608 then use predefined aspect ratio
	aspectRatio = 3.5 / 3.0;use80Percent = true;}var realVideoSize=getVideoVisibleVideoSize.call(this,clientWidth,clientHeight,videoWidth,videoHeight,aspectRatio,use80Percent);var newVideoWidth=realVideoSize.w;var newVideoHeight=realVideoSize.h;var newVideoLeft=realVideoSize.x;var newVideoTop=realVideoSize.y;if(newVideoWidth != actualVideoWidth || newVideoHeight != actualVideoHeight || newVideoLeft != actualVideoLeft || newVideoTop != actualVideoTop || forceDrawing){actualVideoLeft = newVideoLeft + videoOffsetLeft;actualVideoTop = newVideoTop + videoOffsetTop;actualVideoWidth = newVideoWidth;actualVideoHeight = newVideoHeight;captionContainer.style.left = actualVideoLeft + 'px';captionContainer.style.top = actualVideoTop + 'px';captionContainer.style.width = actualVideoWidth + 'px';captionContainer.style.height = actualVideoHeight + 'px'; // Video view has changed size, so resize any active cues
	for(var i=0;track.activeCues && i < track.activeCues.length;++i) {var cue=track.activeCues[i];cue.scaleCue(cue);}if(fullscreenAttribute && document[fullscreenAttribute] || displayCCOnTop){captionContainer.style.zIndex = topZIndex;}else {captionContainer.style.zIndex = null;}}}function scaleCue(activeCue){var videoWidth=actualVideoWidth;var videoHeight=actualVideoHeight;var key=undefined,replaceValue=undefined,valueFontSize=undefined,valueLineHeight=undefined,elements=undefined;if(activeCue.cellResolution){var cellUnit=[videoWidth / activeCue.cellResolution[0],videoHeight / activeCue.cellResolution[1]];if(activeCue.linePadding){for(key in activeCue.linePadding) {if(activeCue.linePadding.hasOwnProperty(key)){var valueLinePadding=activeCue.linePadding[key];replaceValue = (valueLinePadding * cellUnit[0]).toString(); // Compute the CellResolution unit in order to process properties using sizing (fontSize, linePadding, etc).
	var elementsSpan=document.getElementsByClassName('spanPadding');for(var i=0;i < elementsSpan.length;i++) {elementsSpan[i].style.cssText = elementsSpan[i].style.cssText.replace(/(padding-left\s*:\s*)[\d.,]+(?=\s*px)/gi,'$1' + replaceValue);elementsSpan[i].style.cssText = elementsSpan[i].style.cssText.replace(/(padding-right\s*:\s*)[\d.,]+(?=\s*px)/gi,'$1' + replaceValue);}}}}if(activeCue.fontSize){for(key in activeCue.fontSize) {if(activeCue.fontSize.hasOwnProperty(key)){if(activeCue.fontSize[key][0] === '%'){valueFontSize = activeCue.fontSize[key][1] / 100;}else if(activeCue.fontSize[key][0] === 'c'){valueFontSize = activeCue.fontSize[key][1];}replaceValue = (valueFontSize * cellUnit[1]).toString();if(key !== 'defaultFontSize'){elements = document.getElementsByClassName(key);}else {elements = document.getElementsByClassName('paragraph');}for(var j=0;j < elements.length;j++) {elements[j].style.cssText = elements[j].style.cssText.replace(/(font-size\s*:\s*)[\d.,]+(?=\s*px)/gi,'$1' + replaceValue);}}}if(activeCue.lineHeight){for(key in activeCue.lineHeight) {if(activeCue.lineHeight.hasOwnProperty(key)){if(activeCue.lineHeight[key][0] === '%'){valueLineHeight = activeCue.lineHeight[key][1] / 100;}else if(activeCue.fontSize[key][0] === 'c'){valueLineHeight = activeCue.lineHeight[key][1];}replaceValue = (valueLineHeight * cellUnit[1]).toString();elements = document.getElementsByClassName(key);for(var k=0;k < elements.length;k++) {elements[k].style.cssText = elements[k].style.cssText.replace(/(line-height\s*:\s*)[\d.,]+(?=\s*px)/gi,'$1' + replaceValue);}}}}}}if(activeCue.isd){var htmlCaptionDiv=document.getElementById(activeCue.cueID);if(htmlCaptionDiv){captionContainer.removeChild(htmlCaptionDiv);}renderCaption(activeCue);}}function renderCaption(cue){var finalCue=document.createElement('div');captionContainer.appendChild(finalCue);previousISDState = (0,_imsc.renderHTML)(cue.isd,finalCue,function(uri){var imsc1ImgUrnTester=/^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/;var smpteImgUrnTester=/^#(.*)$/;if(imsc1ImgUrnTester.test(uri)){var match=imsc1ImgUrnTester.exec(uri);var imageId=parseInt(match[4],10) - 1;var imageData=btoa(cue.images[imageId]);var dataUrl='data:image/png;base64,' + imageData;return dataUrl;}else if(smpteImgUrnTester.test(uri)){var match=smpteImgUrnTester.exec(uri);var imageId=match[1];var dataUrl='data:image/png;base64,' + cue.embeddedImages[imageId];return dataUrl;}else {return null;}},captionContainer.clientHeight,captionContainer.clientWidth,false, /*displayForcedOnlyMode*/function(err){log('[TextTracks][renderCaption]',err); //TODO add ErrorHandler management
	},previousISDState,true /*enableRollUp*/);finalCue.id = cue.cueID;} /*
	     * Add captions to track, store for later adding, or add captions added before
	     */function addCaptions(trackIdx,timeOffset,captionData){var track=getTrackByIdx(trackIdx);var self=this;if(!track){return;}if(!captionData || captionData.length === 0){return;}for(var item=0;item < captionData.length;item++) {var cue=undefined;var currentItem=captionData[item];track.cellResolution = currentItem.cellResolution;track.isFromCEA608 = currentItem.isFromCEA608;if(currentItem.type === 'html'){cue = new Cue(currentItem.start - timeOffset,currentItem.end - timeOffset,'');cue.cueHTMLElement = currentItem.cueHTMLElement;cue.isd = currentItem.isd;cue.images = currentItem.images;cue.embeddedImages = currentItem.embeddedImages;cue.cueID = currentItem.cueID;cue.scaleCue = scaleCue.bind(self); //useful parameters for cea608 subtitles, not for TTML one.
	cue.cellResolution = currentItem.cellResolution;cue.lineHeight = currentItem.lineHeight;cue.linePadding = currentItem.linePadding;cue.fontSize = currentItem.fontSize;captionContainer.style.left = actualVideoLeft + 'px';captionContainer.style.top = actualVideoTop + 'px';captionContainer.style.width = actualVideoWidth + 'px';captionContainer.style.height = actualVideoHeight + 'px';cue.onenter = function(){if(track.mode === _constantsConstants2['default'].TEXT_SHOWING){if(this.isd){renderCaption(this);log('Cue enter id:' + this.cueID);}else {captionContainer.appendChild(this.cueHTMLElement);scaleCue.call(self,this);}}};cue.onexit = function(){var divs=captionContainer.childNodes;for(var i=0;i < divs.length;++i) {if(divs[i].id === this.cueID){log('Cue exit id:' + divs[i].id);captionContainer.removeChild(divs[i]);}}};}else {cue = new Cue(currentItem.start - timeOffset,currentItem.end - timeOffset,currentItem.data);if(currentItem.styles){if(currentItem.styles.align !== undefined && 'align' in cue){cue.align = currentItem.styles.align;}if(currentItem.styles.line !== undefined && 'line' in cue){cue.line = currentItem.styles.line;}if(currentItem.styles.position !== undefined && 'position' in cue){cue.position = currentItem.styles.position;}if(currentItem.styles.size !== undefined && 'size' in cue){cue.size = currentItem.styles.size;}}}try{track.addCue(cue);}catch(e) { // Edge crash, delete everything and start adding again
	// @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/11979877/
	deleteTrackCues(track);track.addCue(cue);throw e;}}}function getTrackByIdx(idx){return idx >= 0 && textTrackQueue[idx]?videoModel.getTextTrack(textTrackQueue[idx].kind,textTrackQueue[idx].label,textTrackQueue[idx].lang,textTrackQueue[idx].isTTML,textTrackQueue[idx].isEmbedded):null;}function getCurrentTrackIdx(){return currentTrackIdx;}function getTrackIdxForId(trackId){var idx=-1;for(var i=0;i < textTrackQueue.length;i++) {if(textTrackQueue[i].label === trackId){idx = i;break;}}return idx;}function setCurrentTrackIdx(idx){if(idx === currentTrackIdx){return;}currentTrackIdx = idx;var track=getTrackByIdx(currentTrackIdx);setCueStyleOnTrack.call(this,track);if(videoSizeCheckInterval){clearInterval(videoSizeCheckInterval);videoSizeCheckInterval = null;}if(track && track.renderingType === 'html'){checkVideoSize.call(this,track,true);videoSizeCheckInterval = setInterval(checkVideoSize.bind(this,track),500);}}function setCueStyleOnTrack(track){clearCaptionContainer.call(this);if(track){if(track.renderingType === 'html'){setNativeCueStyle.call(this);}else {removeNativeCueStyle.call(this);}}else {removeNativeCueStyle.call(this);}}function deleteTrackCues(track){if(track.cues){var cues=track.cues;var lastIdx=cues.length - 1;for(var r=lastIdx;r >= 0;r--) {track.removeCue(cues[r]);}}}function deleteCuesFromTrackIdx(trackIdx){var track=getTrackByIdx(trackIdx);if(track){deleteTrackCues(track);}}function deleteAllTextTracks(){var ln=trackElementArr?trackElementArr.length:0;for(var i=0;i < ln;i++) {if(isChrome){videoModel.removeChild(trackElementArr[i]);}else {var track=getTrackByIdx(i);if(track){deleteTrackCues.call(this,track);track.mode = 'disabled';}}}trackElementArr = [];textTrackQueue = [];if(videoSizeCheckInterval){clearInterval(videoSizeCheckInterval);videoSizeCheckInterval = null;}currentTrackIdx = -1;clearCaptionContainer.call(this);}function deleteTextTrack(idx){videoModel.removeChild(trackElementArr[idx]);trackElementArr.splice(idx,1);} /* Set native cue style to transparent background to avoid it being displayed. */function setNativeCueStyle(){if(!isChrome){return;}var styleElement=document.getElementById('native-cue-style');if(styleElement){return; //Already set
	}styleElement = document.createElement('style');styleElement.id = 'native-cue-style';document.head.appendChild(styleElement);var stylesheet=styleElement.sheet;var video=videoModel.getElement();if(video){if(video.id){stylesheet.insertRule('#' + video.id + '::cue {background: transparent}',0);}else if(video.classList.length !== 0){stylesheet.insertRule('.' + video.className + '::cue {background: transparent}',0);}else {stylesheet.insertRule('video::cue {background: transparent}',0);}}} /* Remove the extra cue style with transparent background for native cues. */function removeNativeCueStyle(){if(!isChrome){return;}var styleElement=document.getElementById('native-cue-style');if(styleElement){document.head.removeChild(styleElement);}}function clearCaptionContainer(){if(captionContainer){while(captionContainer.firstChild) {captionContainer.removeChild(captionContainer.firstChild);}}}function setConfig(config){if(!config){return;}if(config.videoModel){videoModel = config.videoModel;}}function setModeForTrackIdx(idx,mode){var track=getTrackByIdx(idx);if(track && track.mode !== mode){track.mode = mode;}}function getCurrentTrackInfo(){return textTrackQueue[currentTrackIdx];}instance = {initialize:initialize,displayCConTop:displayCConTop,addTextTrack:addTextTrack,addCaptions:addCaptions,getCurrentTrackIdx:getCurrentTrackIdx,setCurrentTrackIdx:setCurrentTrackIdx,getTrackIdxForId:getTrackIdxForId,getCurrentTrackInfo:getCurrentTrackInfo,setModeForTrackIdx:setModeForTrackIdx,deleteCuesFromTrackIdx:deleteCuesFromTrackIdx,deleteAllTextTracks:deleteAllTextTracks,deleteTextTrack:deleteTextTrack,setConfig:setConfig};return instance;}TextTracks.__dashjs_factory_name = 'TextTracks';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(TextTracks);module.exports = exports['default'];
	//# sourceMappingURL=TextTracks.js.map


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * Represents data structure to keep and drive {DataChunk}
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function InitCache(){var data={};function save(chunk){var id=chunk.streamId;var representationId=chunk.representationId;data[id] = data[id] || {};data[id][representationId] = chunk;}function extract(streamId,representationId){if(data && data[streamId] && data[streamId][representationId]){return data[streamId][representationId];}else {return null;}}function reset(){data = {};}var instance={save:save,extract:extract,reset:reset};return instance;}InitCache.__dashjs_factory_name = 'InitCache';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(InitCache);module.exports = exports['default'];
	//# sourceMappingURL=InitCache.js.map


/***/ },
/* 98 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 99 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(43);
	
	var _DOMUtils = __webpack_require__(72);
	
	var _DOMStateStorage = __webpack_require__(161);
	
	var _PathUtils = __webpack_require__(32);
	
	var _ExecutionEnvironment = __webpack_require__(101);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 101 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(463);
	
	var _PathUtils = __webpack_require__(32);
	
	var _runTransitionHook = __webpack_require__(103);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(71);
	
	var _LocationUtils = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/* 
	 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *
	 * * Redistributions of source code must retain the above copyright notice, this
	 *   list of conditions and the following disclaimer.
	 * * Redistributions in binary form must reproduce the above copyright notice,
	 *   this list of conditions and the following disclaimer in the documentation
	 *   and/or other materials provided with the distribution.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
	 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
	 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
	 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 * POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/**
	 * @module imscStyles
	 */
	
	;
	(function (imscStyles, imscNames, imscUtils) { // wrapper for non-node envs
	
	    function StylingAttributeDefinition(ns, name, initialValue, appliesTo, isInherit, isAnimatable, parseFunc, computeFunc) {
	        this.name = name;
	        this.ns = ns;
	        this.qname = ns + " " + name;
	        this.inherit = isInherit;
	        this.animatable = isAnimatable;
	        this.initial = initialValue;
	        this.applies = appliesTo;
	        this.parse = parseFunc;
	        this.compute = computeFunc;
	    }
	
	    imscStyles.all = [
	
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "backgroundColor",
	                "transparent",
	                ['body', 'div', 'p', 'region', 'span'],
	                false,
	                true,
	                imscUtils.parseColor,
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "color",
	                "white",
	                ['span'],
	                true,
	                true,
	                imscUtils.parseColor,
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "direction",
	                "ltr",
	                ['p', 'span'],
	                true,
	                true,
	                function (str) {
	                    return str;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "display",
	                "auto",
	                ['body', 'div', 'p', 'region', 'span'],
	                false,
	                true,
	                function (str) {
	                    return str;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "displayAlign",
	                "before",
	                ['region'],
	                false,
	                true,
	                function (str) {
	                    return str;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "extent",
	                "auto",
	                ['tt', 'region'],
	                false,
	                true,
	                function (str) {
	
	                    if (str === "auto") {
	
	                        return str;
	
	                    } else {
	
	                        var s = str.split(" ");
	                        if (s.length !== 2) return null;
	                        var w = imscUtils.parseLength(s[0]);
	                        var h = imscUtils.parseLength(s[1]);
	                        if (!h || !w) return null;
	                        return {'h': h, 'w': w};
	                    }
	
	                },
	                function (doc, parent, element, attr) {
	
	                    var h;
	                    var w;
	
	                    if (attr === "auto") {
	
	                        h = 1;
	
	                    } else if (attr.h.unit === "%") {
	
	                        h = attr.h.value / 100;
	
	                    } else if (attr.h.unit === "px") {
	
	                        h = attr.h.value / doc.pxDimensions.h;
	
	                    } else {
	
	                        return null;
	
	                    }
	
	                    if (attr === "auto") {
	
	                        w = 1;
	
	                    } else if (attr.w.unit === "%") {
	
	                        w = attr.w.value / 100;
	
	                    } else if (attr.w.unit === "px") {
	
	                        w = attr.w.value / doc.pxDimensions.w;
	
	                    } else {
	
	                        return null;
	
	                    }
	
	                    return {'h': h, 'w': w};
	                }
	        ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "fontFamily",
	                "default",
	                ['span'],
	                true,
	                true,
	                function (str) {
	                    var ffs = str.split(",");
	                    var rslt = [];
	
	                    for (var i in ffs) {
	
	                        if (ffs[i].charAt(0) !== "'" && ffs[i].charAt(0) !== '"') {
	
	                            if (ffs[i] === "default") {
	
	                                /* per IMSC1 */
	
	                                rslt.push("monospaceSerif");
	
	                            } else {
	
	                                rslt.push(ffs[i]);
	
	                            }
	
	                        } else {
	
	                            rslt.push(ffs[i]);
	
	                        }
	
	                    }
	
	                    return rslt;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "fontSize",
	                "1c",
	                ['span'],
	                true,
	                true,
	                imscUtils.parseLength,
	                function (doc, parent, element, attr) {
	
	                    var fs;
	
	                    if (attr.unit === "%") {
	
	                        if (parent !== null) {
	
	                            fs = parent.styleAttrs[imscStyles.byName.fontSize.qname] * attr.value / 100;
	
	                        } else {
	
	                            /* region, so percent of 1c */
	
	                            fs = attr.value / 100 / doc.cellResolution.h;
	
	                        }
	
	                    } else if (attr.unit === "em") {
	
	                        if (parent !== null) {
	
	                            fs = parent.styleAttrs[imscStyles.byName.fontSize.qname] * attr.value;
	
	                        } else {
	
	                            /* region, so percent of 1c */
	
	                            fs = attr.value / doc.cellResolution.h;
	
	                        }
	
	                    } else if (attr.unit === "c") {
	
	                        fs = attr.value / doc.cellResolution.h;
	
	                    } else if (attr.unit === "px") {
	
	                        fs = attr.value / doc.pxDimensions.h;
	
	                    } else {
	
	                        return null;
	
	                    }
	
	                    return fs;
	                }
	        ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "fontStyle",
	                "normal",
	                ['span'],
	                true,
	                true,
	                function (str) {
	                    /* TODO: handle font style */
	
	                    return str;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "fontWeight",
	                "normal",
	                ['span'],
	                true,
	                true,
	                function (str) {
	                    /* TODO: handle font weight */
	
	                    return str;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "lineHeight",
	                "normal",
	                ['p'],
	                true,
	                true,
	                function (str) {
	                    if (str === "normal") {
	                        return str;
	                    } else {
	                        return imscUtils.parseLength(str);
	                    }
	                },
	                function (doc, parent, element, attr) {
	
	                    var lh;
	
	                    if (attr === "normal") {
	
	                        /* inherit normal per https://github.com/w3c/ttml1/issues/220 */
	
	                        lh = attr;
	
	                    } else if (attr.unit === "%") {
	
	                        lh = element.styleAttrs[imscStyles.byName.fontSize.qname] * attr.value / 100;
	
	                    } else if (attr.unit === "em") {
	
	                        lh = element.styleAttrs[imscStyles.byName.fontSize.qname] * attr.value;
	
	                    } else if (attr.unit === "c") {
	
	                        lh = attr.value / doc.cellResolution.h;
	
	                    } else if (attr.unit === "px") {
	
	                        /* TODO: handle error if no px dimensions are provided */
	
	                        lh = attr.value / doc.pxDimensions.h;
	
	                    } else {
	
	                        return null;
	
	                    }
	
	                    /* TODO: create a Length constructor */
	
	                    return lh;
	                }
	        ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "opacity",
	                1.0,
	                ['region'],
	                false,
	                true,
	                parseFloat,
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "origin",
	                "auto",
	                ['region'],
	                false,
	                true,
	                function (str) {
	
	                    if (str === "auto") {
	
	                        return str;
	
	                    } else {
	
	                        var s = str.split(" ");
	                        if (s.length !== 2) return null;
	                        var w = imscUtils.parseLength(s[0]);
	                        var h = imscUtils.parseLength(s[1]);
	                        if (!h || !w) return null;
	                        return {'h': h, 'w': w};
	                    }
	
	                },
	                function (doc, parent, element, attr) {
	
	                    var h;
	                    var w;
	
	                    if (attr === "auto") {
	
	                        h = 0;
	
	                    } else if (attr.h.unit === "%") {
	
	                        h = attr.h.value / 100;
	
	                    } else if (attr.h.unit === "px") {
	
	                        h = attr.h.value / doc.pxDimensions.h;
	
	                    } else {
	
	                        return null;
	
	                    }
	
	                    if (attr === "auto") {
	
	                        w = 0;
	
	                    } else if (attr.w.unit === "%") {
	
	                        w = attr.w.value / 100;
	
	                    } else if (attr.w.unit === "px") {
	
	                        w = attr.w.value / doc.pxDimensions.w;
	
	                    } else {
	
	                        return null;
	
	                    }
	
	                    return {'h': h, 'w': w};
	                }
	        ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "overflow",
	                "hidden",
	                ['region'],
	                false,
	                true,
	                function (str) {
	                    return str;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "padding",
	                "0px",
	                ['region'],
	                false,
	                true,
	                function (str) {
	
	                    var s = str.split(" ");
	                    if (s.length > 4) return null;
	                    var r = [];
	                    for (var i in s) {
	
	                        var l = imscUtils.parseLength(s[i]);
	                        if (!l) return null;
	                        r.push(l);
	                    }
	
	                    return r;
	                },
	                function (doc, parent, element, attr) {
	
	                    var padding;
	
	                    /* TODO: make sure we are in region */
	
	                    /*
	                     * expand padding shortcuts to 
	                     * [before, end, after, start]
	                     * 
	                     */
	
	                    if (attr.length === 1) {
	
	                        padding = [attr[0], attr[0], attr[0], attr[0]];
	
	                    } else if (attr.length === 2) {
	
	                        padding = [attr[0], attr[1], attr[0], attr[1]];
	
	                    } else if (attr.length === 3) {
	
	                        padding = [attr[0], attr[1], attr[2], attr[1]];
	
	                    } else if (attr.length === 4) {
	
	                        padding = [attr[0], attr[1], attr[2], attr[3]];
	
	                    } else {
	
	                        return null;
	
	                    }
	
	                    /* TODO: take into account tts:direction */
	
	                    /* 
	                     * transform [before, end, after, start] according to writingMode to 
	                     * [top,left,bottom,right]
	                     * 
	                     */
	
	                    var dir = element.styleAttrs[imscStyles.byName.writingMode.qname];
	
	                    if (dir === "lrtb" || dir === "lr") {
	
	                        padding = [padding[0], padding[3], padding[2], padding[1]];
	
	                    } else if (dir === "rltb" || dir === "rl") {
	
	                        padding = [padding[0], padding[1], padding[2], padding[3]];
	
	                    } else if (dir === "tblr") {
	
	                        padding = [padding[3], padding[0], padding[1], padding[2]];
	
	                    } else if (dir === "tbrl" || dir === "tb") {
	
	                        padding = [padding[3], padding[2], padding[1], padding[0]];
	
	                    } else {
	
	                        return null;
	
	                    }
	
	                    var out = [];
	
	                    for (var i in padding) {
	
	                        if (padding[i].value === 0) {
	
	                            out[i] = 0;
	
	                        } else if (padding[i].unit === "%") {
	
	                            if (i === "0" || i === "2") {
	
	                                out[i] = element.styleAttrs[imscStyles.byName.extent.qname].h * padding[i].value / 100;
	
	                            } else {
	
	                                out[i] = element.styleAttrs[imscStyles.byName.extent.qname].w * padding[i].value / 100;
	                            }
	
	                        } else if (padding[i].unit === "em") {
	
	                            out[i] = element.styleAttrs[imscStyles.byName.fontSize.qname] * padding[i].value;
	
	                        } else if (padding[i].unit === "c") {
	
	                            out[i] = padding[i].value / doc.cellResolution.h;
	
	                        } else if (padding[i].unit === "px") {
	
	                            out[i] = padding[i].value / doc.pxDimensions.h;
	
	                        } else {
	
	                            return null;
	
	                        }
	                    }
	
	
	                    return out;
	                }
	        ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "showBackground",
	                "always",
	                ['region'],
	                false,
	                true,
	                function (str) {
	                    return str;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "textAlign",
	                "start",
	                ['p'],
	                true,
	                true,
	                function (str) {
	                    return str;
	                },
	                function (doc, parent, element, attr) {
	                    
	                    /* Section 7.16.9 of XSL */
	                    
	                    if (attr === "left") {
	                        
	                        return "start";
	                        
	                    } else if (attr === "right") {
	                        
	                        return "end";
	                        
	                    } else {
	                        
	                        return attr;
	                        
	                    }
	                }
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "textDecoration",
	                "none",
	                ['span'],
	                true,
	                true,
	                function (str) {
	                    return str.split(" ");
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "textOutline",
	                "none",
	                ['span'],
	                true,
	                true,
	                function (str) {
	
	                    /*
	                     * returns {c: <color>?, thichness: <length>} | "none"
	                     * 
	                     */
	
	                    if (str === "none") {
	
	                        return str;
	
	                    } else {
	
	                        var r = {};
	                        var s = str.split(" ");
	                        if (s.length === 0 || s.length > 2) return null;
	                        var c = imscUtils.parseColor(s[0]);
	                       
	                        r.color = c;
	                        
	                        if (c !== null) s.shift();
	
	                        if (s.length !== 1) return null;
	
	                        var l = imscUtils.parseLength(s[0]);
	
	                        if (!l) return null;
	
	                        r.thickness = l;
	
	                        return r;
	                    }
	
	                },
	                function (doc, parent, element, attr) {
	
	                    /*
	                     * returns {color: <color>, thickness: <norm length>}
	                     * 
	                     */
	
	                    if (attr === "none") return attr;
	
	                    var rslt = {};
	
	                    if (attr.color === null) {
	                        
	                        rslt.color = element.styleAttrs[imscStyles.byName.color.qname];
	                        
	                    } else {
	                        
	                        rslt.color = attr.color;
	
	                    }
	
	                    if (attr.thickness.unit === "%") {
	
	                        rslt.thickness = element.styleAttrs[imscStyles.byName.fontSize.qname] * attr.thickness.value / 100;
	
	                    } else if (attr.thickness.unit === "em") {
	
	                        rslt.thickness = element.styleAttrs[imscStyles.byName.fontSize.qname] * attr.thickness.value;
	
	                    } else if (attr.thickness.unit === "c") {
	
	                        rslt.thickness = attr.thickness.value / doc.cellResolution.h;
	
	                    } else if (attr.thickness.unit === "px") {
	
	                        rslt.thickness = attr.thickness.value / doc.pxDimensions.h;
	
	                    } else {
	
	                        return null;
	
	                    }
	
	
	                    return rslt;
	                }
	        ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "unicodeBidi",
	                "normal",
	                ['span', 'p'],
	                false,
	                true,
	                function (str) {
	                    return str;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "visibility",
	                "visible",
	                ['body', 'div', 'p', 'region', 'span'],
	                true,
	                true,
	                function (str) {
	                    return str;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "wrapOption",
	                "wrap",
	                ['span'],
	                true,
	                true,
	                function (str) {
	                    return str;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "writingMode",
	                "lrtb",
	                ['region'],
	                false,
	                true,
	                function (str) {
	                    return str;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_tts,
	                "zIndex",
	                "auto",
	                ['region'],
	                false,
	                true,
	                function (str) {
	                    
	                    var rslt;
	                    
	                    if (str === 'auto') {
	                        
	                        rslt = str;
	                        
	                    } else {
	                        
	                        rslt = parseInt(str);
	                        
	                        if (isNaN(rslt)) {
	                            rslt = null;
	                        }
	                        
	                    }
	                    
	                    return rslt;
	                },
	                null
	                ),
	        new StylingAttributeDefinition(
	                imscNames.ns_ebutts,
	                "linePadding",
	                "0c",
	                ['p'],
	                true,
	                false,
	                imscUtils.parseLength,
	                function (doc, parent, element, attr) {
	                    if (attr.unit === "c") {
	
	                        return attr.value / doc.cellResolution.h;
	
	                    } else {
	
	                        return null;
	
	                    }
	                }
	        ),
	        new StylingAttributeDefinition(
	                imscNames.ns_ebutts,
	                "multiRowAlign",
	                "auto",
	                ['p'],
	                true,
	                false,
	                function (str) {
	                    return str;
	                },
	                null
	                ),
	
	        new StylingAttributeDefinition(
	                imscNames.ns_smpte,
	                "backgroundImage",
	                null,
	                ['div'],
	                false,
	                false,
	                function (str) {
	                    return str;
	                },
	                null
	                ),
	
	        new StylingAttributeDefinition(
	                imscNames.ns_itts,
	                "forcedDisplay",
	                "false",
	                ['body', 'div', 'p', 'region', 'span'],
	                true,
	                true,
	                function (str) {
	                    return str === 'true' ? true : false;
	                },
	                null
	                )
	    ];
	
	    /* TODO: allow null parse function */
	
	    imscStyles.byQName = {};
	    for (var i in imscStyles.all) {
	
	        imscStyles.byQName[imscStyles.all[i].qname] = imscStyles.all[i];
	    }
	
	    imscStyles.byName = {};
	    for (var j in imscStyles.all) {
	
	        imscStyles.byName[imscStyles.all[j].name] = imscStyles.all[j];
	    }
	
	})( false ? this.imscStyles = {} : exports,
	        typeof imscNames === 'undefined' ? __webpack_require__(73) : imscNames,
	        typeof imscUtils === 'undefined' ? __webpack_require__(166) : imscUtils);


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(474),
	    getPrototype = __webpack_require__(476),
	    isObjectLike = __webpack_require__(481);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(46);
	var Danger = __webpack_require__(493);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInstrumentation = __webpack_require__(23);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(115);
	var setInnerHTML = __webpack_require__(80);
	var setTextContent = __webpack_require__(191);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 107 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var ReactErrorUtils = __webpack_require__(113);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(9);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var ReactPropTypesSecret = __webpack_require__(522);
	var propTypesFactory = __webpack_require__(170);
	
	var React = __webpack_require__(51);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(9);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var invariant = __webpack_require__(3);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactInstanceMap = __webpack_require__(58);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(26);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(9);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var emptyFunction = __webpack_require__(21);
	var warning = __webpack_require__(9);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 122 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 123 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(13);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(13);
	
	var _getRouteParams = __webpack_require__(572);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(124);
	
	var _RouteUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(75);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(208);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem.getBoundingClientRect().width || elem.offsetWidth || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem.getBoundingClientRect().height || elem.offsetHeight || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(74);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(54);
	util.inherits = __webpack_require__(44);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(637)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(217);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(82).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(216);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(39);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(39);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45), __webpack_require__(634).setImmediate, (function() { return this; }())))

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(214);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(128);
	exports.Duplex = __webpack_require__(39);
	exports.Transform = __webpack_require__(215);
	exports.PassThrough = __webpack_require__(599);


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(220);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(607);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(606);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(605);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(219);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(221);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(82).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(551);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Paragraph = __webpack_require__(231);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Quote = __webpack_require__(232);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _Image = __webpack_require__(133);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Iframe = __webpack_require__(230);
	
	var _Iframe2 = _interopRequireDefault(_Iframe);
	
	var _Slider = __webpack_require__(233);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Body = function (_Component) {
	    _inherits(Body, _Component);
	
	    function Body() {
	        _classCallCheck(this, Body);
	
	        return _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).apply(this, arguments));
	    }
	
	    _createClass(Body, [{
	        key: 'render',
	        value: function render() {
	            var bodySections = this.buildBody(this.props.body);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Body' },
	                bodySections
	            );
	        }
	    }, {
	        key: 'buildBody',
	        value: function buildBody(body) {
	            var _this2 = this;
	
	            return body.map(function (data, index) {
	                return _this2.buildSection(data, index);
	            });
	        }
	    }, {
	        key: 'buildSection',
	        value: function buildSection(data, index) {
	            switch (data.type) {
	                case "Meta":
	                    return _react2.default.createElement(_reactHelmet2.default, Object.assign({ key: index, htmlAttributes: { lang: "nl" } }, data));
	                case "Quote":
	                    return _react2.default.createElement(_Quote2.default, Object.assign({ key: index }, data));
	                case "Paragraph":
	                    return _react2.default.createElement(_Paragraph2.default, Object.assign({ key: index }, data));
	                case "Image":
	                    return _react2.default.createElement(_Image2.default, Object.assign({ key: index }, data));
	                case "Iframe":
	                    return _react2.default.createElement(_Iframe2.default, Object.assign({ key: index }, data));
	                case "Slider":
	                    return _react2.default.createElement(_Slider2.default, Object.assign({ key: index }, data));
	                default:
	                    return null;
	            }
	        }
	    }]);
	
	    return Body;
	}(_react.Component);
	
	exports.default = Body;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImageSrcSet = __webpack_require__(134);
	
	var _ImageSrcSet2 = _interopRequireDefault(_ImageSrcSet);
	
	__webpack_require__(620);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Image = function (_Component) {
	    _inherits(Image, _Component);
	
	    function Image() {
	        _classCallCheck(this, Image);
	
	        return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	    }
	
	    _createClass(Image, [{
	        key: 'render',
	        value: function render() {
	            var image = this.props.image;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Image' },
	                _react2.default.createElement(_ImageSrcSet2.default, image),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'Image__inner' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'Image__text' },
	                        image.text
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Image;
	}(_react.Component);
	
	exports.default = Image;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(20);
	
	var _ImageSrcSet = __webpack_require__(624);
	
	var _ImageSrcSet2 = _interopRequireDefault(_ImageSrcSet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageSrcSet = function (_Component) {
	    _inherits(ImageSrcSet, _Component);
	
	    function ImageSrcSet() {
	        _classCallCheck(this, ImageSrcSet);
	
	        return _possibleConstructorReturn(this, (ImageSrcSet.__proto__ || Object.getPrototypeOf(ImageSrcSet)).apply(this, arguments));
	    }
	
	    _createClass(ImageSrcSet, [{
	        key: 'render',
	        value: function render() {
	            var src = {
	                mobile: this.props.mobile,
	                tablet: this.props.tablet,
	                desktop: this.props.desktop
	            };
	
	            var _props$responsive = this.props.responsive,
	                breakpoints = _props$responsive.breakpoints,
	                greaterThan = _props$responsive.greaterThan;
	
	            var fallbackImage = this.fallbackImage(greaterThan, src);
	
	            return _react2.default.createElement(
	                'picture',
	                { className: _ImageSrcSet2.default.picture },
	                _react2.default.createElement('source', { srcSet: src.mobile, media: '(max-width: ' + breakpoints.mobile + 'px)' }),
	                _react2.default.createElement('source', { srcSet: src.tablet, media: '(min-width: ' + breakpoints.mobile + 'px) and (max-width: ' + breakpoints.tablet + 'px)' }),
	                _react2.default.createElement('source', { srcSet: src.desktop, media: '(min-width: ' + breakpoints.tablet + 'px)' }),
	                _react2.default.createElement('img', { src: fallbackImage, alt: this.props.alt, title: this.props.title })
	            );
	        }
	    }, {
	        key: 'fallbackImage',
	        value: function fallbackImage(greaterThan, src) {
	            if (greaterThan.tablet) {
	                return src.desktop;
	            }
	
	            if (greaterThan.mobile) {
	                return src.tablet;
	            }
	
	            return src.mobile;
	        }
	    }]);
	
	    return ImageSrcSet;
	}(_react.Component);
	
	function mapStateToProps(state) {
	    return {
	        responsive: state.responsive
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ImageSrcSet);

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var emptyObject = __webpack_require__(70);
	var _invariant = __webpack_require__(3);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2015-2016, DASH Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  1. Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  2. Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';(function(exports){"use strict"; /**
	     *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
	     */var specialCea608CharsCodes={0x2a:0xe1, // lowercase a, acute accent
	0x5c:0xe9, // lowercase e, acute accent
	0x5e:0xed, // lowercase i, acute accent
	0x5f:0xf3, // lowercase o, acute accent
	0x60:0xfa, // lowercase u, acute accent
	0x7b:0xe7, // lowercase c with cedilla
	0x7c:0xf7, // division symbol
	0x7d:0xd1, // uppercase N tilde
	0x7e:0xf1, // lowercase n tilde
	0x7f:0x2588, // Full block
	// THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
	// THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
	// THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
	0x80:0xae, // Registered symbol (R)
	0x81:0xb0, // degree sign
	0x82:0xbd, // 1/2 symbol
	0x83:0xbf, // Inverted (open) question mark
	0x84:0x2122, // Trademark symbol (TM)
	0x85:0xa2, // Cents symbol
	0x86:0xa3, // Pounds sterling
	0x87:0x266a, // Music 8'th note
	0x88:0xe0, // lowercase a, grave accent
	0x89:0x20, // transparent space (regular)
	0x8a:0xe8, // lowercase e, grave accent
	0x8b:0xe2, // lowercase a, circumflex accent
	0x8c:0xea, // lowercase e, circumflex accent
	0x8d:0xee, // lowercase i, circumflex accent
	0x8e:0xf4, // lowercase o, circumflex accent
	0x8f:0xfb, // lowercase u, circumflex accent
	// THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
	// THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
	0x90:0xc1, // capital letter A with acute
	0x91:0xc9, // capital letter E with acute
	0x92:0xd3, // capital letter O with acute
	0x93:0xda, // capital letter U with acute
	0x94:0xdc, // capital letter U with diaresis
	0x95:0xfc, // lowercase letter U with diaeresis
	0x96:0x2018, // opening single quote
	0x97:0xa1, // inverted exclamation mark
	0x98:0x2a, // asterisk
	0x99:0x2019, // closing single quote
	0x9a:0x2501, // box drawings heavy horizontal
	0x9b:0xa9, // copyright sign
	0x9c:0x2120, // Service mark
	0x9d:0x2022, // (round) bullet
	0x9e:0x201c, // Left double quotation mark
	0x9f:0x201d, // Right double quotation mark
	0xa0:0xc0, // uppercase A, grave accent
	0xa1:0xc2, // uppercase A, circumflex
	0xa2:0xc7, // uppercase C with cedilla
	0xa3:0xc8, // uppercase E, grave accent
	0xa4:0xca, // uppercase E, circumflex
	0xa5:0xcb, // capital letter E with diaresis
	0xa6:0xeb, // lowercase letter e with diaresis
	0xa7:0xce, // uppercase I, circumflex
	0xa8:0xcf, // uppercase I, with diaresis
	0xa9:0xef, // lowercase i, with diaresis
	0xaa:0xd4, // uppercase O, circumflex
	0xab:0xd9, // uppercase U, grave accent
	0xac:0xf9, // lowercase u, grave accent
	0xad:0xdb, // uppercase U, circumflex
	0xae:0xab, // left-pointing double angle quotation mark
	0xaf:0xbb, // right-pointing double angle quotation mark
	// THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
	// THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
	0xb0:0xc3, // Uppercase A, tilde
	0xb1:0xe3, // Lowercase a, tilde
	0xb2:0xcd, // Uppercase I, acute accent
	0xb3:0xcc, // Uppercase I, grave accent
	0xb4:0xec, // Lowercase i, grave accent
	0xb5:0xd2, // Uppercase O, grave accent
	0xb6:0xf2, // Lowercase o, grave accent
	0xb7:0xd5, // Uppercase O, tilde
	0xb8:0xf5, // Lowercase o, tilde
	0xb9:0x7b, // Open curly brace
	0xba:0x7d, // Closing curly brace
	0xbb:0x5c, // Backslash
	0xbc:0x5e, // Caret
	0xbd:0x5f, // Underscore
	0xbe:0x7c, // Pipe (vertical line)
	0xbf:0x223c, // Tilde operator
	0xc0:0xc4, // Uppercase A, umlaut
	0xc1:0xe4, // Lowercase A, umlaut
	0xc2:0xd6, // Uppercase O, umlaut
	0xc3:0xf6, // Lowercase o, umlaut
	0xc4:0xdf, // Esszett (sharp S)
	0xc5:0xa5, // Yen symbol
	0xc6:0xa4, // Generic currency sign
	0xc7:0x2503, // Box drawings heavy vertical
	0xc8:0xc5, // Uppercase A, ring
	0xc9:0xe5, // Lowercase A, ring
	0xca:0xd8, // Uppercase O, stroke
	0xcb:0xf8, // Lowercase o, strok
	0xcc:0x250f, // Box drawings heavy down and right
	0xcd:0x2513, // Box drawings heavy down and left
	0xce:0x2517, // Box drawings heavy up and right
	0xcf:0x251b // Box drawings heavy up and left
	}; /**
	     * Get Unicode Character from CEA-608 byte code
	     */var getCharForByte=function getCharForByte(byte){var charCode=byte;if(specialCea608CharsCodes.hasOwnProperty(byte)){charCode = specialCea608CharsCodes[byte];}return String.fromCharCode(charCode);};var NR_ROWS=15,NR_COLS=32; // Tables to look up row from PAC data
	var rowsLowCh1={0x11:1,0x12:3,0x15:5,0x16:7,0x17:9,0x10:11,0x13:12,0x14:14};var rowsHighCh1={0x11:2,0x12:4,0x15:6,0x16:8,0x17:10,0x13:13,0x14:15};var rowsLowCh2={0x19:1,0x1A:3,0x1D:5,0x1E:7,0x1F:9,0x18:11,0x1B:12,0x1C:14};var rowsHighCh2={0x19:2,0x1A:4,0x1D:6,0x1E:8,0x1F:10,0x1B:13,0x1C:15};var backgroundColors=['white','green','blue','cyan','red','yellow','magenta','black','transparent']; /**
	     * Simple logger class to be able to write with time-stamps and filter on level.
	     */var logger={verboseFilter:{'DATA':3,'DEBUG':3,'INFO':2,'WARNING':2,'TEXT':1,'ERROR':0},time:null,verboseLevel:0, // Only write errors
	setTime:function setTime(newTime){this.time = newTime;},log:function log(severity,msg){var minLevel=this.verboseFilter[severity];if(this.verboseLevel >= minLevel){console.log(this.time + " [" + severity + "] " + msg);}}};var numArrayToHexArray=function numArrayToHexArray(numArray){var hexArray=[];for(var j=0;j < numArray.length;j++) {hexArray.push(numArray[j].toString(16));}return hexArray;}; /**
	     * State of CEA-608 pen or character
	     * @constructor
	     */var PenState=function PenState(foreground,underline,italics,background,flash){this.foreground = foreground || "white";this.underline = underline || false;this.italics = italics || false;this.background = background || "black";this.flash = flash || false;};PenState.prototype = {reset:function reset(){this.foreground = "white";this.underline = false;this.italics = false;this.background = "black";this.flash = false;},setStyles:function setStyles(styles){var attribs=["foreground","underline","italics","background","flash"];for(var i=0;i < attribs.length;i++) {var style=attribs[i];if(styles.hasOwnProperty(style)){this[style] = styles[style];}}},isDefault:function isDefault(){return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;},equals:function equals(other){return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;},copy:function copy(newPenState){this.foreground = newPenState.foreground;this.underline = newPenState.underline;this.italics = newPenState.italics;this.background = newPenState.background;this.flash = newPenState.flash;},toString:function toString(){return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;}}; /**
	     * Unicode character with styling and background.
	     * @constructor
	     */var StyledUnicodeChar=function StyledUnicodeChar(uchar,foreground,underline,italics,background,flash){this.uchar = uchar || ' '; // unicode character
	this.penState = new PenState(foreground,underline,italics,background,flash);};StyledUnicodeChar.prototype = {reset:function reset(){this.uchar = ' ';this.penState.reset();},setChar:function setChar(uchar,newPenState){this.uchar = uchar;this.penState.copy(newPenState);},setPenState:function setPenState(newPenState){this.penState.copy(newPenState);},equals:function equals(other){return this.uchar === other.uchar && this.penState.equals(other.penState);},copy:function copy(newChar){this.uchar = newChar.uchar;this.penState.copy(newChar.penState);},isEmpty:function isEmpty(){return this.uchar === ' ' && this.penState.isDefault();}}; /**
	     * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
	     * @constructor
	     */var Row=function Row(){this.chars = [];for(var i=0;i < NR_COLS;i++) {this.chars.push(new StyledUnicodeChar());}this.pos = 0;this.currPenState = new PenState();};Row.prototype = {equals:function equals(other){var equal=true;for(var i=0;i < NR_COLS;i++) {if(!this.chars[i].equals(other.chars[i])){equal = false;break;}}return equal;},copy:function copy(other){for(var i=0;i < NR_COLS;i++) {this.chars[i].copy(other.chars[i]);}},isEmpty:function isEmpty(){var empty=true;for(var i=0;i < NR_COLS;i++) {if(!this.chars[i].isEmpty()){empty = false;break;}}return empty;}, /**
	         *  Set the cursor to a valid column.
	         */setCursor:function setCursor(absPos){if(this.pos !== absPos){this.pos = absPos;}if(this.pos < 0){logger.log("ERROR","Negative cursor position " + this.pos);this.pos = 0;}else if(this.pos > NR_COLS){logger.log("ERROR","Too large cursor position " + this.pos);this.pos = NR_COLS;}}, /** 
	         * Move the cursor relative to current position.
	         */moveCursor:function moveCursor(relPos){var newPos=this.pos + relPos;if(relPos > 1){for(var i=this.pos + 1;i < newPos + 1;i++) {this.chars[i].setPenState(this.currPenState);}}this.setCursor(newPos);}, /**
	         * Backspace, move one step back and clear character.
	         */backSpace:function backSpace(){this.moveCursor(-1);this.chars[this.pos].setChar(' ',this.currPenState);},insertChar:function insertChar(byte){if(byte >= 0x90){ //Extended char
	this.backSpace();}var char=getCharForByte(byte);if(this.pos >= NR_COLS){logger.log("ERROR","Cannot insert " + byte.toString(16) + " (" + char + ") at position " + this.pos + ". Skipping it!");return;}this.chars[this.pos].setChar(char,this.currPenState);this.moveCursor(1);},clearFromPos:function clearFromPos(startPos){var i;for(i = startPos;i < NR_COLS;i++) {this.chars[i].reset();}},clear:function clear(){this.clearFromPos(0);this.pos = 0;this.currPenState.reset();},clearToEndOfRow:function clearToEndOfRow(){this.clearFromPos(this.pos);},getTextString:function getTextString(){var chars=[];var empty=true;for(var i=0;i < NR_COLS;i++) {var char=this.chars[i].uchar;if(char !== " "){empty = false;}chars.push(char);}if(empty){return "";}else {return chars.join("");}},setPenStyles:function setPenStyles(styles){this.currPenState.setStyles(styles);var currChar=this.chars[this.pos];currChar.setPenState(this.currPenState);}}; /**
	     * Keep a CEA-608 screen of 32x15 styled characters
	     * @constructor
	    */var CaptionScreen=function CaptionScreen(){this.rows = [];for(var i=0;i < NR_ROWS;i++) {this.rows.push(new Row()); // Note that we use zero-based numbering (0-14)
	}this.currRow = NR_ROWS - 1;this.nrRollUpRows = null;this.reset();};CaptionScreen.prototype = {reset:function reset(){for(var i=0;i < NR_ROWS;i++) {this.rows[i].clear();}this.currRow = NR_ROWS - 1;},equals:function equals(other){var equal=true;for(var i=0;i < NR_ROWS;i++) {if(!this.rows[i].equals(other.rows[i])){equal = false;break;}}return equal;},copy:function copy(other){for(var i=0;i < NR_ROWS;i++) {this.rows[i].copy(other.rows[i]);}},isEmpty:function isEmpty(){var empty=true;for(var i=0;i < NR_ROWS;i++) {if(!this.rows[i].isEmpty()){empty = false;break;}}return empty;},backSpace:function backSpace(){var row=this.rows[this.currRow];row.backSpace();},clearToEndOfRow:function clearToEndOfRow(){var row=this.rows[this.currRow];row.clearToEndOfRow();}, /**
	         * Insert a character (without styling) in the current row.
	         */insertChar:function insertChar(char){var row=this.rows[this.currRow];row.insertChar(char);},setPen:function setPen(styles){var row=this.rows[this.currRow];row.setPenStyles(styles);},moveCursor:function moveCursor(relPos){var row=this.rows[this.currRow];row.moveCursor(relPos);},setCursor:function setCursor(absPos){logger.log("INFO","setCursor: " + absPos);var row=this.rows[this.currRow];row.setCursor(absPos);},setPAC:function setPAC(pacData){logger.log("INFO","pacData = " + JSON.stringify(pacData));var newRow=pacData.row - 1;if(this.nrRollUpRows && newRow < this.nrRollUpRows - 1){newRow = this.nrRollUpRows - 1;}this.currRow = newRow;var row=this.rows[this.currRow];if(pacData.indent !== null){var indent=pacData.indent;var prevPos=Math.max(indent - 1,0);row.setCursor(pacData.indent);pacData.color = row.chars[prevPos].penState.foreground;}var styles={foreground:pacData.color,underline:pacData.underline,italics:pacData.italics,background:'black',flash:false};this.setPen(styles);}, /**
	         * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
	         */setBkgData:function setBkgData(bkgData){logger.log("INFO","bkgData = " + JSON.stringify(bkgData));this.backSpace();this.setPen(bkgData);this.insertChar(0x20); //Space
	},setRollUpRows:function setRollUpRows(nrRows){this.nrRollUpRows = nrRows;},rollUp:function rollUp(){if(this.nrRollUpRows === null){logger.log("DEBUG","roll_up but nrRollUpRows not set yet");return; //Not properly setup
	}logger.log("TEXT",this.getDisplayText());var topRowIndex=this.currRow + 1 - this.nrRollUpRows;var topRow=this.rows.splice(topRowIndex,1)[0];topRow.clear();this.rows.splice(this.currRow,0,topRow);logger.log("INFO","Rolling up"); //logger.log("TEXT", this.get_display_text())
	}, /**
	        * Get all non-empty rows with as unicode text. 
	        */getDisplayText:function getDisplayText(asOneRow){asOneRow = asOneRow || false;var displayText=[];var text="";var rowNr=-1;for(var i=0;i < NR_ROWS;i++) {var rowText=this.rows[i].getTextString();if(rowText){rowNr = i + 1;if(asOneRow){displayText.push("Row " + rowNr + ': "' + rowText + '"');}else {displayText.push(rowText.trim());}}}if(displayText.length > 0){if(asOneRow){text = "[" + displayText.join(" | ") + "]";}else {text = displayText.join("\n");}}return text;},getTextAndFormat:function getTextAndFormat(){return this.rows;}}; /**
	     * Handle a CEA-608 channel and send decoded data to outputFilter
	     * @constructor
	     * @param {Number} channelNumber (1 or 2)
	     * @param {CueHandler} outputFilter Output from channel1 newCue(startTime, endTime, captionScreen)
	    */var Cea608Channel=function Cea608Channel(channelNumber,outputFilter){this.chNr = channelNumber;this.outputFilter = outputFilter;this.mode = null;this.verbose = 0;this.displayedMemory = new CaptionScreen();this.nonDisplayedMemory = new CaptionScreen();this.lastOutputScreen = new CaptionScreen();this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];this.writeScreen = this.displayedMemory;this.mode = null;this.cueStartTime = null; // Keeps track of where a cue started.
	};Cea608Channel.prototype = {modes:["MODE_ROLL-UP","MODE_POP-ON","MODE_PAINT-ON","MODE_TEXT"],reset:function reset(){this.mode = null;this.displayedMemory.reset();this.nonDisplayedMemory.reset();this.lastOutputScreen.reset();this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];this.writeScreen = this.displayedMemory;this.mode = null;this.cueStartTime = null;this.lastCueEndTime = null;},getHandler:function getHandler(){return this.outputFilter;},setHandler:function setHandler(newHandler){this.outputFilter = newHandler;},setPAC:function setPAC(pacData){this.writeScreen.setPAC(pacData);},setBkgData:function setBkgData(bkgData){this.writeScreen.setBkgData(bkgData);},setMode:function setMode(newMode){if(newMode === this.mode){return;}this.mode = newMode;logger.log("INFO","MODE=" + newMode);if(this.mode == "MODE_POP-ON"){this.writeScreen = this.nonDisplayedMemory;}else {this.writeScreen = this.displayedMemory;this.writeScreen.reset();}if(this.mode !== "MODE_ROLL-UP"){this.displayedMemory.nrRollUpRows = null;this.nonDisplayedMemory.nrRollUpRows = null;}this.mode = newMode;},insertChars:function insertChars(chars){for(var i=0;i < chars.length;i++) {this.writeScreen.insertChar(chars[i]);}var screen=this.writeScreen === this.displayedMemory?"DISP":"NON_DISP";logger.log("INFO",screen + ": " + this.writeScreen.getDisplayText(true));if(this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP"){logger.log("TEXT","DISPLAYED: " + this.displayedMemory.getDisplayText(true));this.outputDataUpdate();}},cc_RCL:function cc_RCL(){ // Resume Caption Loading (switch mode to Pop On)
	logger.log("INFO","RCL - Resume Caption Loading");this.setMode("MODE_POP-ON");},cc_BS:function cc_BS(){ // BackSpace
	logger.log("INFO","BS - BackSpace");if(this.mode === "MODE_TEXT"){return;}this.writeScreen.backSpace();if(this.writeScreen === this.displayedMemory){this.outputDataUpdate();}},cc_AOF:function cc_AOF(){ // Reserved (formerly Alarm Off)
	return;},cc_AON:function cc_AON(){ // Reserved (formerly Alarm On)
	return;},cc_DER:function cc_DER(){ // Delete to End of Row
	logger.log("INFO","DER- Delete to End of Row");this.writeScreen.clearToEndOfRow();this.outputDataUpdate();},cc_RU:function cc_RU(nrRows){ //Roll-Up Captions-2,3,or 4 Rows
	logger.log("INFO","RU(" + nrRows + ") - Roll Up");this.writeScreen = this.displayedMemory;this.setMode("MODE_ROLL-UP");this.writeScreen.setRollUpRows(nrRows);},cc_FON:function cc_FON(){ //Flash On
	logger.log("INFO","FON - Flash On");this.writeScreen.setPen({flash:true});},cc_RDC:function cc_RDC(){ // Resume Direct Captioning (switch mode to PaintOn)
	logger.log("INFO","RDC - Resume Direct Captioning");this.setMode("MODE_PAINT-ON");},cc_TR:function cc_TR(){ // Text Restart in text mode (not supported, however)
	logger.log("INFO","TR");this.setMode("MODE_TEXT");},cc_RTD:function cc_RTD(){ // Resume Text Display in Text mode (not supported, however)
	logger.log("INFO","RTD");this.setMode("MODE_TEXT");},cc_EDM:function cc_EDM(){ // Erase Displayed Memory
	logger.log("INFO","EDM - Erase Displayed Memory");this.displayedMemory.reset();this.outputDataUpdate();},cc_CR:function cc_CR(){ // Carriage Return
	logger.log("CR - Carriage Return");this.writeScreen.rollUp();this.outputDataUpdate();},cc_ENM:function cc_ENM(){ //Erase Non-Displayed Memory
	logger.log("INFO","ENM - Erase Non-displayed Memory");this.nonDisplayedMemory.reset();},cc_EOC:function cc_EOC(){ //End of Caption (Flip Memories)
	logger.log("INFO","EOC - End Of Caption");if(this.mode === "MODE_POP-ON"){var tmp=this.displayedMemory;this.displayedMemory = this.nonDisplayedMemory;this.nonDisplayedMemory = tmp;this.writeScreen = this.nonDisplayedMemory;logger.log("TEXT","DISP: " + this.displayedMemory.getDisplayText());}this.outputDataUpdate();},cc_TO:function cc_TO(nrCols){ // Tab Offset 1,2, or 3 columns
	logger.log("INFO","TO(" + nrCols + ") - Tab Offset");this.writeScreen.moveCursor(nrCols);},cc_MIDROW:function cc_MIDROW(secondByte){ // Parse MIDROW command
	var styles={flash:false};styles.underline = secondByte % 2 === 1;styles.italics = secondByte >= 0x2e;if(!styles.italics){var colorIndex=Math.floor(secondByte / 2) - 0x10;var colors=["white","green","blue","cyan","red","yellow","magenta"];styles.foreground = colors[colorIndex];}else {styles.foreground = "white";}logger.log("INFO","MIDROW: " + JSON.stringify(styles));this.writeScreen.setPen(styles);},outputDataUpdate:function outputDataUpdate(){var t=logger.time;if(t === null){return;}if(this.outputFilter){if(this.outputFilter.updateData){this.outputFilter.updateData(t,this.displayedMemory);}if(this.cueStartTime === null && !this.displayedMemory.isEmpty()){ // Start of a new cue
	this.cueStartTime = t;}else {if(!this.displayedMemory.equals(this.lastOutputScreen)){if(this.outputFilter.newCue){this.outputFilter.newCue(this.cueStartTime,t,this.lastOutputScreen);}this.cueStartTime = this.displayedMemory.isEmpty()?null:t;}}this.lastOutputScreen.copy(this.displayedMemory);}},cueSplitAtTime:function cueSplitAtTime(t){if(this.outputFilter){if(!this.displayedMemory.isEmpty()){if(this.outputFilter.newCue){this.outputFilter.newCue(this.cueStartTime,t,this.displayedMemory);}this.cueStartTime = t;}}}}; /**
	     * Parse CEA-608 data and send decoded data to out1 and out2.
	     * @constructor
	     * @param {Number} field  CEA-608 field (1 or 2)
	     * @param {CueHandler} out1 Output from channel1 newCue(startTime, endTime, captionScreen)
	     * @param {CueHandler} out2 Output from channel2 newCue(startTime, endTime, captionScreen)
	     */var Cea608Parser=function Cea608Parser(field,out1,out2){this.field = field || 1;this.outputs = [out1,out2];this.channels = [new Cea608Channel(1,out1),new Cea608Channel(2,out2)];this.currChNr = -1; // Will be 1 or 2
	this.lastCmdA = null; // First byte of last command
	this.lastCmdB = null; // Second byte of last command
	this.bufferedData = [];this.startTime = null;this.lastTime = null;this.dataCounters = {'padding':0,'char':0,'cmd':0,'other':0};};Cea608Parser.prototype = {getHandler:function getHandler(index){return this.channels[index].getHandler();},setHandler:function setHandler(index,newHandler){this.channels[index].setHandler(newHandler);}, /**
	         * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
	         */addData:function addData(t,byteList){var cmdFound,a,b,charsFound=false;this.lastTime = t;logger.setTime(t);for(var i=0;i < byteList.length;i += 2) {a = byteList[i] & 0x7f;b = byteList[i + 1] & 0x7f;if(a >= 0x10 && a <= 0x1f && a === this.lastCmdA && b === this.lastCmdB){this.lastCmdA = null;this.lastCmdB = null;logger.log("DEBUG","Repeated command (" + numArrayToHexArray([a,b]) + ") is dropped");continue; // Repeated commands are dropped (once)
	}if(a === 0 && b === 0){this.dataCounters.padding += 2;continue;}else {logger.log("DATA","[" + numArrayToHexArray([byteList[i],byteList[i + 1]]) + "] -> (" + numArrayToHexArray([a,b]) + ")");}cmdFound = this.parseCmd(a,b);if(!cmdFound){cmdFound = this.parseMidrow(a,b);}if(!cmdFound){cmdFound = this.parsePAC(a,b);}if(!cmdFound){cmdFound = this.parseBackgroundAttributes(a,b);}if(!cmdFound){charsFound = this.parseChars(a,b);if(charsFound){if(this.currChNr && this.currChNr >= 0){var channel=this.channels[this.currChNr - 1];channel.insertChars(charsFound);}else {logger.log("WARNING","No channel found yet. TEXT-MODE?");}}}if(cmdFound){this.dataCounters.cmd += 2;}else if(charsFound){this.dataCounters.char += 2;}else {this.dataCounters.other += 2;logger.log("WARNING","Couldn't parse cleaned data " + numArrayToHexArray([a,b]) + " orig: " + numArrayToHexArray([byteList[i],byteList[i + 1]]));}}}, /**
	         * Parse Command.
	         * @returns {Boolean} Tells if a command was found
	         */parseCmd:function parseCmd(a,b){var chNr=null;var cond1=(a === 0x14 || a === 0x15 || a === 0x1C || a === 0x1D) && 0x20 <= b && b <= 0x2F;var cond2=(a === 0x17 || a === 0x1F) && 0x21 <= b && b <= 0x23;if(!(cond1 || cond2)){return false;}if(a === 0x14 || a === 0x15 || a === 0x17){chNr = 1;}else {chNr = 2; // (a === 0x1C || a === 0x1D || a=== 0x1f)
	}var channel=this.channels[chNr - 1];if(a === 0x14 || a === 0x15 || a === 0x1C || a === 0x1D){if(b === 0x20){channel.cc_RCL();}else if(b === 0x21){channel.cc_BS();}else if(b === 0x22){channel.cc_AOF();}else if(b === 0x23){channel.cc_AON();}else if(b === 0x24){channel.cc_DER();}else if(b === 0x25){channel.cc_RU(2);}else if(b === 0x26){channel.cc_RU(3);}else if(b === 0x27){channel.cc_RU(4);}else if(b === 0x28){channel.cc_FON();}else if(b === 0x29){channel.cc_RDC();}else if(b === 0x2A){channel.cc_TR();}else if(b === 0x2B){channel.cc_RTD();}else if(b === 0x2C){channel.cc_EDM();}else if(b === 0x2D){channel.cc_CR();}else if(b === 0x2E){channel.cc_ENM();}else if(b === 0x2F){channel.cc_EOC();}}else { //a == 0x17 || a == 0x1F
	channel.cc_TO(b - 0x20);}this.lastCmdA = a;this.lastCmdB = b;this.currChNr = chNr;return true;}, /**
	         * Parse midrow styling command
	         * @returns {Boolean}
	         */parseMidrow:function parseMidrow(a,b){var chNr=null;if((a === 0x11 || a === 0x19) && 0x20 <= b && b <= 0x2f){if(a === 0x11){chNr = 1;}else {chNr = 2;}if(chNr !== this.currChNr){logger.log("ERROR","Mismatch channel in midrow parsing");return false;}var channel=this.channels[chNr - 1]; // cea608 spec says midrow codes should inject a space
	channel.insertChars([0x20]);channel.cc_MIDROW(b);logger.log("DEBUG","MIDROW (" + numArrayToHexArray([a,b]) + ")");this.lastCmdA = a;this.lastCmdB = b;return true;}return false;}, /**
	         * Parse Preable Access Codes (Table 53).
	         * @returns {Boolean} Tells if PAC found
	         */parsePAC:function parsePAC(a,b){var chNr=null;var row=null;var case1=(0x11 <= a && a <= 0x17 || 0x19 <= a && a <= 0x1F) && 0x40 <= b && b <= 0x7F;var case2=(a === 0x10 || a === 0x18) && 0x40 <= b && b <= 0x5F;if(!(case1 || case2)){return false;}chNr = a <= 0x17?1:2;if(0x40 <= b && b <= 0x5F){row = chNr === 1?rowsLowCh1[a]:rowsLowCh2[a];}else { // 0x60 <= b <= 0x7F
	row = chNr === 1?rowsHighCh1[a]:rowsHighCh2[a];}var pacData=this.interpretPAC(row,b);var channel=this.channels[chNr - 1];channel.setPAC(pacData);this.lastCmdA = a;this.lastCmdB = b;this.currChNr = chNr;return true;}, /**
	         * Interpret the second byte of the pac, and return the information.
	         * @returns {Object} pacData with style parameters.
	         */interpretPAC:function interpretPAC(row,byte){var pacIndex=byte;var pacData={color:null,italics:false,indent:null,underline:false,row:row};if(byte > 0x5F){pacIndex = byte - 0x60;}else {pacIndex = byte - 0x40;}pacData.underline = (pacIndex & 1) === 1;if(pacIndex <= 0xd){pacData.color = ['white','green','blue','cyan','red','yellow','magenta','white'][Math.floor(pacIndex / 2)];}else if(pacIndex <= 0xf){pacData.italics = true;pacData.color = 'white';}else {pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;}return pacData; // Note that row has zero offset. The spec uses 1.
	}, /**
	         * Parse characters.
	         * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
	         */parseChars:function parseChars(a,b){var channelNr=null,charCodes=null,charCode1=null,charCode2=null;if(a >= 0x19){channelNr = 2;charCode1 = a - 8;}else {channelNr = 1;charCode1 = a;}if(0x11 <= charCode1 && charCode1 <= 0x13){ // Special character
	var oneCode=b;if(charCode1 === 0x11){oneCode = b + 0x50;}else if(charCode1 === 0x12){oneCode = b + 0x70;}else {oneCode = b + 0x90;}logger.log("INFO","Special char '" + getCharForByte(oneCode) + "' in channel " + channelNr);charCodes = [oneCode];this.lastCmdA = a;this.lastCmdB = b;}else if(0x20 <= a && a <= 0x7f){charCodes = b === 0?[a]:[a,b];this.lastCmdA = null;this.lastCmdB = null;}if(charCodes){var hexCodes=numArrayToHexArray(charCodes);logger.log("DEBUG","Char codes =  " + hexCodes.join(","));}return charCodes;}, /**
	        * Parse extended background attributes as well as new foreground color black.
	        * @returns{Boolean} Tells if background attributes are found
	        */parseBackgroundAttributes:function parseBackgroundAttributes(a,b){var bkgData,index,chNr,channel;var case1=(a === 0x10 || a === 0x18) && 0x20 <= b && b <= 0x2f;var case2=(a === 0x17 || a === 0x1f) && 0x2d <= b && b <= 0x2f;if(!(case1 || case2)){return false;}bkgData = {};if(a === 0x10 || a === 0x18){index = Math.floor((b - 0x20) / 2);bkgData.background = backgroundColors[index];if(b % 2 === 1){bkgData.background = bkgData.background + "_semi";}}else if(b === 0x2d){bkgData.background = "transparent";}else {bkgData.foreground = "black";if(b === 0x2f){bkgData.underline = true;}}chNr = a < 0x18?1:2;channel = this.channels[chNr - 1];channel.setBkgData(bkgData);this.lastCmdA = a;this.lastCmdB = b;return true;}, /**
	         * Reset state of parser and its channels.
	         */reset:function reset(){for(var i=0;i < this.channels.length;i++) {if(this.channels[i]){this.channels[i].reset();}}this.lastCmdA = null;this.lastCmdB = null;}, /**
	         * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
	         */cueSplitAtTime:function cueSplitAtTime(t){for(var i=0;i < this.channels.length;i++) {if(this.channels[i]){this.channels[i].cueSplitAtTime(t);}}}}; /**
	     * Find ranges corresponding to SEA CEA-608 NALUS in sizeprepended NALU array.
	     * @param {raw} dataView of binary data
	     * @param {startPos} start position in raw
	     * @param {size} total size of data in raw to consider
	     * @returns 
	     */var findCea608Nalus=function findCea608Nalus(raw,startPos,size){var nalSize=0,cursor=startPos,nalType=0,cea608NaluRanges=[], // Check SEI data according to ANSI-SCTE 128
	isCEA608SEI=function isCEA608SEI(payloadType,payloadSize,raw,pos){if(payloadType !== 4 || payloadSize < 8){return null;}var countryCode=raw.getUint8(pos);var providerCode=raw.getUint16(pos + 1);var userIdentifier=raw.getUint32(pos + 3);var userDataTypeCode=raw.getUint8(pos + 7);return countryCode == 0xB5 && providerCode == 0x31 && userIdentifier == 0x47413934 && userDataTypeCode == 0x3;};while(cursor < startPos + size) {nalSize = raw.getUint32(cursor);nalType = raw.getUint8(cursor + 4) & 0x1F; //console.log(time + "  NAL " + nalType);
	if(nalType === 6){ // SEI NAL Unit. The NAL header is the first byte
	//console.log("SEI NALU of size " + nalSize + " at time " + time);
	var pos=cursor + 5;var payloadType=-1;while(pos < cursor + 4 + nalSize - 1) { // The last byte should be rbsp_trailing_bits
	payloadType = 0;var b=0xFF;while(b === 0xFF) {b = raw.getUint8(pos);payloadType += b;pos++;}var payloadSize=0;b = 0xFF;while(b === 0xFF) {b = raw.getUint8(pos);payloadSize += b;pos++;}if(isCEA608SEI(payloadType,payloadSize,raw,pos)){ //console.log("CEA608 SEI " + time + " " + payloadSize);
	cea608NaluRanges.push([pos,payloadSize]);}pos += payloadSize;}}cursor += nalSize + 4;}return cea608NaluRanges;};var extractCea608DataFromRange=function extractCea608DataFromRange(raw,cea608Range){var pos=cea608Range[0];var fieldData=[[],[]];pos += 8; // Skip the identifier up to userDataTypeCode
	var ccCount=raw.getUint8(pos) & 0x1f;pos += 2; // Advance 1 and skip reserved byte
	for(var i=0;i < ccCount;i++) {var byte=raw.getUint8(pos);var ccValid=byte & 0x4;var ccType=byte & 0x3;pos++;var ccData1=raw.getUint8(pos); // Keep parity bit
	pos++;var ccData2=raw.getUint8(pos); // Keep parity bit
	pos++;if(ccValid && (ccData1 & 0x7f) + (ccData2 & 0x7f) !== 0){ //Check validity and non-empty data
	if(ccType === 0){fieldData[0].push(ccData1);fieldData[0].push(ccData2);}else if(ccType === 1){fieldData[1].push(ccData1);fieldData[1].push(ccData2);}}}return fieldData;};exports.logger = logger;exports.PenState = PenState;exports.CaptionScreen = CaptionScreen;exports.Cea608Parser = Cea608Parser;exports.findCea608Nalus = findCea608Nalus;exports.extractCea608DataFromRange = extractCea608DataFromRange;})( false?undefined.cea608parser = {}:exports);
	//# sourceMappingURL=cea608-parser.js.map


/***/ },
/* 137 */
/***/ function(module, exports) {

	/*
	 Copyright 2011-2013 Abdulla Abdurakhmanov
	 Original sources are available at https://code.google.com/p/x2js/
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	 */ /*
	  Further modified for dashjs to:
	  - keep track of children nodes in order in attribute __children.
	  - add type conversion matchers
	  - re-add ignoreRoot
	  - allow zero-length attributePrefix
	  - don't add white-space text nodes
	  - remove explicit RequireJS support
	*/"use strict";Object.defineProperty(exports,"__esModule",{value:true});function X2JS(config){'use strict';var VERSION="1.2.0";config = config || {};initConfigDefaults();initRequiredPolyfills();function initConfigDefaults(){if(config.escapeMode === undefined){config.escapeMode = true;}if(config.attributePrefix === undefined){config.attributePrefix = "_";}config.arrayAccessForm = config.arrayAccessForm || "none";config.emptyNodeForm = config.emptyNodeForm || "text";if(config.enableToStringFunc === undefined){config.enableToStringFunc = true;}config.arrayAccessFormPaths = config.arrayAccessFormPaths || [];if(config.skipEmptyTextNodesForObj === undefined){config.skipEmptyTextNodesForObj = true;}if(config.stripWhitespaces === undefined){config.stripWhitespaces = true;}config.datetimeAccessFormPaths = config.datetimeAccessFormPaths || [];if(config.useDoubleQuotes === undefined){config.useDoubleQuotes = false;}config.xmlElementsFilter = config.xmlElementsFilter || [];config.jsonPropertiesFilter = config.jsonPropertiesFilter || [];if(config.keepCData === undefined){config.keepCData = false;}if(config.ignoreRoot === undefined){config.ignoreRoot = false;}}var DOMNodeTypes={ELEMENT_NODE:1,TEXT_NODE:3,CDATA_SECTION_NODE:4,COMMENT_NODE:8,DOCUMENT_NODE:9};function initRequiredPolyfills(){}function getNodeLocalName(node){var nodeLocalName=node.localName;if(nodeLocalName == null) // Yeah, this is IE!!
	nodeLocalName = node.baseName;if(nodeLocalName == null || nodeLocalName == "") // =="" is IE too
	nodeLocalName = node.nodeName;return nodeLocalName;}function getNodePrefix(node){return node.prefix;}function escapeXmlChars(str){if(typeof str == "string")return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&apos;');else return str;}function unescapeXmlChars(str){return str.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&quot;/g,'"').replace(/&apos;/g,"'").replace(/&amp;/g,'&');}function checkInStdFiltersArrayForm(stdFiltersArrayForm,obj,name,path){var idx=0;for(;idx < stdFiltersArrayForm.length;idx++) {var filterPath=stdFiltersArrayForm[idx];if(typeof filterPath === "string"){if(filterPath == path)break;}else if(filterPath instanceof RegExp){if(filterPath.test(path))break;}else if(typeof filterPath === "function"){if(filterPath(obj,name,path))break;}}return idx != stdFiltersArrayForm.length;}function toArrayAccessForm(obj,childName,path){switch(config.arrayAccessForm){case "property":if(!(obj[childName] instanceof Array))obj[childName + "_asArray"] = [obj[childName]];else obj[childName + "_asArray"] = obj[childName];break; /*case "none":
	                break;*/}if(!(obj[childName] instanceof Array) && config.arrayAccessFormPaths.length > 0){if(checkInStdFiltersArrayForm(config.arrayAccessFormPaths,obj,childName,path)){obj[childName] = [obj[childName]];}}}function fromXmlDateTime(prop){ // Implementation based up on http://stackoverflow.com/questions/8178598/xml-datetime-to-javascript-date-object
	// Improved to support full spec and optional parts
	var bits=prop.split(/[-T:+Z]/g);var d=new Date(bits[0],bits[1] - 1,bits[2]);var secondBits=bits[5].split("\.");d.setHours(bits[3],bits[4],secondBits[0]);if(secondBits.length > 1)d.setMilliseconds(secondBits[1]); // Get supplied time zone offset in minutes
	if(bits[6] && bits[7]){var offsetMinutes=bits[6] * 60 + Number(bits[7]);var sign=/\d\d-\d\d:\d\d$/.test(prop)?'-':'+'; // Apply the sign
	offsetMinutes = 0 + (sign == '-'?-1 * offsetMinutes:offsetMinutes); // Apply offset and local timezone
	d.setMinutes(d.getMinutes() - offsetMinutes - d.getTimezoneOffset());}else if(prop.indexOf("Z",prop.length - 1) !== -1){d = new Date(Date.UTC(d.getFullYear(),d.getMonth(),d.getDate(),d.getHours(),d.getMinutes(),d.getSeconds(),d.getMilliseconds()));} // d is now a local time equivalent to the supplied time
	return d;}function checkFromXmlDateTimePaths(value,childName,fullPath){if(config.datetimeAccessFormPaths.length > 0){var path=fullPath.split("\.#")[0];if(checkInStdFiltersArrayForm(config.datetimeAccessFormPaths,value,childName,path)){return fromXmlDateTime(value);}else return value;}else return value;}function checkXmlElementsFilter(obj,childType,childName,childPath){if(childType == DOMNodeTypes.ELEMENT_NODE && config.xmlElementsFilter.length > 0){return checkInStdFiltersArrayForm(config.xmlElementsFilter,obj,childName,childPath);}else return true;}function parseDOMChildren(node,path){if(node.nodeType == DOMNodeTypes.DOCUMENT_NODE){var result=new Object();var nodeChildren=node.childNodes; // Alternative for firstElementChild which is not supported in some environments
	for(var cidx=0;cidx < nodeChildren.length;cidx++) {var child=nodeChildren[cidx];if(child.nodeType == DOMNodeTypes.ELEMENT_NODE){if(config.ignoreRoot){result = parseDOMChildren(child);}else {result = {};var childName=getNodeLocalName(child);result[childName] = parseDOMChildren(child);}}}return result;}else if(node.nodeType == DOMNodeTypes.ELEMENT_NODE){var result=new Object();result.__cnt = 0;var children=[];var nodeChildren=node.childNodes; // Children nodes
	for(var cidx=0;cidx < nodeChildren.length;cidx++) {var child=nodeChildren[cidx];var childName=getNodeLocalName(child);if(child.nodeType != DOMNodeTypes.COMMENT_NODE){var childPath=path + "." + childName;if(checkXmlElementsFilter(result,child.nodeType,childName,childPath)){result.__cnt++;if(result[childName] == null){var c=parseDOMChildren(child,childPath);if(childName != "#text" || /[^\s]/.test(c)){var o={};o[childName] = c;children.push(o);}result[childName] = c;toArrayAccessForm(result,childName,childPath);}else {if(result[childName] != null){if(!(result[childName] instanceof Array)){result[childName] = [result[childName]];toArrayAccessForm(result,childName,childPath);}}var c=parseDOMChildren(child,childPath);if(childName != "#text" || /[^\s]/.test(c)){ // Don't add white-space text nodes
	var o={};o[childName] = c;children.push(o);}result[childName][result[childName].length] = c;}}}}result.__children = children; // Attributes
	var nodeLocalName=getNodeLocalName(node);for(var aidx=0;aidx < node.attributes.length;aidx++) {var attr=node.attributes[aidx];result.__cnt++;var value2=attr.value;for(var m=0,ml=config.matchers.length;m < ml;m++) {var matchobj=config.matchers[m];if(matchobj.test(attr,nodeLocalName))value2 = matchobj.converter(attr.value);}result[config.attributePrefix + attr.name] = value2;} // Node namespace prefix
	var nodePrefix=getNodePrefix(node);if(nodePrefix != null && nodePrefix != ""){result.__cnt++;result.__prefix = nodePrefix;}if(result["#text"] != null){result.__text = result["#text"];if(result.__text instanceof Array){result.__text = result.__text.join("\n");} //if(config.escapeMode)
	//	result.__text = unescapeXmlChars(result.__text);
	if(config.stripWhitespaces)result.__text = result.__text.trim();delete result["#text"];if(config.arrayAccessForm == "property")delete result["#text_asArray"];result.__text = checkFromXmlDateTimePaths(result.__text,childName,path + "." + childName);}if(result["#cdata-section"] != null){result.__cdata = result["#cdata-section"];delete result["#cdata-section"];if(config.arrayAccessForm == "property")delete result["#cdata-section_asArray"];}if(result.__cnt == 0 && config.emptyNodeForm == "text"){result = '';}else if(result.__cnt == 1 && result.__text != null){result = result.__text;}else if(result.__cnt == 1 && result.__cdata != null && !config.keepCData){result = result.__cdata;}else if(result.__cnt > 1 && result.__text != null && config.skipEmptyTextNodesForObj){if(config.stripWhitespaces && result.__text == "" || result.__text.trim() == ""){delete result.__text;}}delete result.__cnt;if(config.enableToStringFunc && (result.__text != null || result.__cdata != null)){result.toString = function(){return (this.__text != null?this.__text:'') + (this.__cdata != null?this.__cdata:'');};}return result;}else if(node.nodeType == DOMNodeTypes.TEXT_NODE || node.nodeType == DOMNodeTypes.CDATA_SECTION_NODE){return node.nodeValue;}}function startTag(jsonObj,element,attrList,closed){var resultStr="<" + (jsonObj != null && jsonObj.__prefix != null?jsonObj.__prefix + ":":"") + element;if(attrList != null){for(var aidx=0;aidx < attrList.length;aidx++) {var attrName=attrList[aidx];var attrVal=jsonObj[attrName];if(config.escapeMode)attrVal = escapeXmlChars(attrVal);resultStr += " " + attrName.substr(config.attributePrefix.length) + "=";if(config.useDoubleQuotes)resultStr += '"' + attrVal + '"';else resultStr += "'" + attrVal + "'";}}if(!closed)resultStr += ">";else resultStr += "/>";return resultStr;}function endTag(jsonObj,elementName){return "</" + (jsonObj.__prefix != null?jsonObj.__prefix + ":":"") + elementName + ">";}function endsWith(str,suffix){return str.indexOf(suffix,str.length - suffix.length) !== -1;}function jsonXmlSpecialElem(jsonObj,jsonObjField){if(config.arrayAccessForm == "property" && endsWith(jsonObjField.toString(),"_asArray") || jsonObjField.toString().indexOf(config.attributePrefix) == 0 || jsonObjField.toString().indexOf("__") == 0 || jsonObj[jsonObjField] instanceof Function)return true;else return false;}function jsonXmlElemCount(jsonObj){var elementsCnt=0;if(jsonObj instanceof Object){for(var it in jsonObj) {if(jsonXmlSpecialElem(jsonObj,it))continue;elementsCnt++;}}return elementsCnt;}function checkJsonObjPropertiesFilter(jsonObj,propertyName,jsonObjPath){return config.jsonPropertiesFilter.length == 0 || jsonObjPath == "" || checkInStdFiltersArrayForm(config.jsonPropertiesFilter,jsonObj,propertyName,jsonObjPath);}function parseJSONAttributes(jsonObj){var attrList=[];if(jsonObj instanceof Object){for(var ait in jsonObj) {if(ait.toString().indexOf("__") == -1 && ait.toString().indexOf(config.attributePrefix) == 0){attrList.push(ait);}}}return attrList;}function parseJSONTextAttrs(jsonTxtObj){var result="";if(jsonTxtObj.__cdata != null){result += "<![CDATA[" + jsonTxtObj.__cdata + "]]>";}if(jsonTxtObj.__text != null){if(config.escapeMode)result += escapeXmlChars(jsonTxtObj.__text);else result += jsonTxtObj.__text;}return result;}function parseJSONTextObject(jsonTxtObj){var result="";if(jsonTxtObj instanceof Object){result += parseJSONTextAttrs(jsonTxtObj);}else if(jsonTxtObj != null){if(config.escapeMode)result += escapeXmlChars(jsonTxtObj);else result += jsonTxtObj;}return result;}function getJsonPropertyPath(jsonObjPath,jsonPropName){if(jsonObjPath === ""){return jsonPropName;}else return jsonObjPath + "." + jsonPropName;}function parseJSONArray(jsonArrRoot,jsonArrObj,attrList,jsonObjPath){var result="";if(jsonArrRoot.length == 0){result += startTag(jsonArrRoot,jsonArrObj,attrList,true);}else {for(var arIdx=0;arIdx < jsonArrRoot.length;arIdx++) {result += startTag(jsonArrRoot[arIdx],jsonArrObj,parseJSONAttributes(jsonArrRoot[arIdx]),false);result += parseJSONObject(jsonArrRoot[arIdx],getJsonPropertyPath(jsonObjPath,jsonArrObj));result += endTag(jsonArrRoot[arIdx],jsonArrObj);}}return result;}function parseJSONObject(jsonObj,jsonObjPath){var result="";var elementsCnt=jsonXmlElemCount(jsonObj);if(elementsCnt > 0){for(var it in jsonObj) {if(jsonXmlSpecialElem(jsonObj,it) || jsonObjPath != "" && !checkJsonObjPropertiesFilter(jsonObj,it,getJsonPropertyPath(jsonObjPath,it)))continue;var subObj=jsonObj[it];var attrList=parseJSONAttributes(subObj);if(subObj == null || subObj == undefined){result += startTag(subObj,it,attrList,true);}else if(subObj instanceof Object){if(subObj instanceof Array){result += parseJSONArray(subObj,it,attrList,jsonObjPath);}else if(subObj instanceof Date){result += startTag(subObj,it,attrList,false);result += subObj.toISOString();result += endTag(subObj,it);}else {var subObjElementsCnt=jsonXmlElemCount(subObj);if(subObjElementsCnt > 0 || subObj.__text != null || subObj.__cdata != null){result += startTag(subObj,it,attrList,false);result += parseJSONObject(subObj,getJsonPropertyPath(jsonObjPath,it));result += endTag(subObj,it);}else {result += startTag(subObj,it,attrList,true);}}}else {result += startTag(subObj,it,attrList,false);result += parseJSONTextObject(subObj);result += endTag(subObj,it);}}}result += parseJSONTextObject(jsonObj);return result;}this.parseXmlString = function(xmlDocStr){var isIEParser=window.ActiveXObject || "ActiveXObject" in window;if(xmlDocStr === undefined){return null;}var xmlDoc;if(window.DOMParser){var parser=new window.DOMParser();var parsererrorNS=null;try{xmlDoc = parser.parseFromString(xmlDocStr,"text/xml");if(xmlDoc.getElementsByTagNameNS("*","parsererror").length > 0){xmlDoc = null;}}catch(err) {xmlDoc = null;}}else { // IE :(
	if(xmlDocStr.indexOf("<?") == 0){xmlDocStr = xmlDocStr.substr(xmlDocStr.indexOf("?>") + 2);}xmlDoc = new ActiveXObject("Microsoft.XMLDOM");xmlDoc.async = "false";xmlDoc.loadXML(xmlDocStr);}return xmlDoc;};this.asArray = function(prop){if(prop === undefined || prop == null)return [];else if(prop instanceof Array)return prop;else return [prop];};this.toXmlDateTime = function(dt){if(dt instanceof Date)return dt.toISOString();else if(typeof dt === 'number')return new Date(dt).toISOString();else return null;};this.asDateTime = function(prop){if(typeof prop == "string"){return fromXmlDateTime(prop);}else return prop;};this.xml2json = function(xmlDoc){return parseDOMChildren(xmlDoc);};this.xml_str2json = function(xmlDocStr){var xmlDoc=this.parseXmlString(xmlDocStr);if(xmlDoc != null)return this.xml2json(xmlDoc);else return null;};this.json2xml_str = function(jsonObj){return parseJSONObject(jsonObj,"");};this.json2xml = function(jsonObj){var xmlDocStr=this.json2xml_str(jsonObj);return this.parseXmlString(xmlDocStr);};this.getVersion = function(){return VERSION;};}exports["default"] = X2JS;module.exports = exports["default"];
	//# sourceMappingURL=xml2json.js.map


/***/ },
/* 138 */
/***/ function(module, exports) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});exports.getVersionString = getVersionString;var VERSION='2.6.8';function getVersionString(){return VERSION;}
	//# sourceMappingURL=Version.js.map


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc a node at some level in a ValueMap
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var _CommonProperty=__webpack_require__(312);var _CommonProperty2=_interopRequireDefault(_CommonProperty);var MapNode=(function(){function MapNode(name,properties,children,isRoot,isArray){var _this=this;_classCallCheck(this,MapNode);this._name = name || '';this._properties = [];this._children = children || [];this._isRoot = isRoot || false;this._isArray = isArray || true;if(Array.isArray(properties)){properties.forEach(function(p){_this._properties.push(new _CommonProperty2['default'](p));});}}_createClass(MapNode,[{key:'name',get:function get(){return this._name;}},{key:'isRoot',get:function get(){return this._isRoot;}},{key:'isArray',get:function get(){return this._isArray;}},{key:'children',get:function get(){return this._children;}},{key:'properties',get:function get(){return this._properties;}}]);return MapNode;})();exports['default'] = MapNode;module.exports = exports['default'];
	//# sourceMappingURL=MapNode.js.map


/***/ },
/* 140 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var DEFAULT_DVB_PRIORITY=1;var DEFAULT_DVB_WEIGHT=1;var BaseURL=function BaseURL(url,serviceLocation,priority,weight){_classCallCheck(this,BaseURL);this.url = url || '';this.serviceLocation = serviceLocation || url || ''; // DVB extensions
	this.dvb_priority = priority || DEFAULT_DVB_PRIORITY;this.dvb_weight = weight || DEFAULT_DVB_WEIGHT;this.availabilityTimeOffset = 0;this.availabilityTimeComplete = true; /* currently unused:
	         * byteRange,
	         */};BaseURL.DEFAULT_DVB_PRIORITY = DEFAULT_DVB_PRIORITY;BaseURL.DEFAULT_DVB_WEIGHT = DEFAULT_DVB_WEIGHT;exports['default'] = BaseURL;module.exports = exports['default'];
	//# sourceMappingURL=BaseURL.js.map


/***/ },
/* 141 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var Event=function Event(){_classCallCheck(this,Event);this.duration = NaN;this.presentationTime = NaN;this.id = NaN;this.messageData = '';this.eventStream = null;this.presentationTimeDelta = NaN; // Specific EMSG Box parameter
	};exports['default'] = Event;module.exports = exports['default'];
	//# sourceMappingURL=Event.js.map


/***/ },
/* 142 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var UTCTiming=function UTCTiming(){_classCallCheck(this,UTCTiming); // UTCTiming is a DescriptorType and doesn't have any additional fields
	this.schemeIdUri = '';this.value = '';};exports['default'] = UTCTiming;module.exports = exports['default'];
	//# sourceMappingURL=UTCTiming.js.map


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _constantsMetricsConstants=__webpack_require__(41);var _constantsMetricsConstants2=_interopRequireDefault(_constantsMetricsConstants);var _dashVoUTCTiming=__webpack_require__(142);var _dashVoUTCTiming2=_interopRequireDefault(_dashVoUTCTiming);var _controllersPlaybackController=__webpack_require__(343);var _controllersPlaybackController2=_interopRequireDefault(_controllersPlaybackController);var _controllersStreamController=__webpack_require__(345);var _controllersStreamController2=_interopRequireDefault(_controllersStreamController);var _controllersMediaController=__webpack_require__(87);var _controllersMediaController2=_interopRequireDefault(_controllersMediaController);var _ManifestLoader=__webpack_require__(331);var _ManifestLoader2=_interopRequireDefault(_ManifestLoader);var _utilsErrorHandler=__webpack_require__(152);var _utilsErrorHandler2=_interopRequireDefault(_utilsErrorHandler);var _utilsCapabilities=__webpack_require__(408);var _utilsCapabilities2=_interopRequireDefault(_utilsCapabilities);var _textTextTracks=__webpack_require__(96);var _textTextTracks2=_interopRequireDefault(_textTextTracks);var _utilsRequestModifier=__webpack_require__(69);var _utilsRequestModifier2=_interopRequireDefault(_utilsRequestModifier);var _textTextController=__webpack_require__(95);var _textTextController2=_interopRequireDefault(_textTextController);var _modelsURIQueryAndFragmentModel=__webpack_require__(150);var _modelsURIQueryAndFragmentModel2=_interopRequireDefault(_modelsURIQueryAndFragmentModel);var _modelsManifestModel=__webpack_require__(368);var _modelsManifestModel2=_interopRequireDefault(_modelsManifestModel);var _modelsMediaPlayerModel=__webpack_require__(149);var _modelsMediaPlayerModel2=_interopRequireDefault(_modelsMediaPlayerModel);var _modelsMetricsModel=__webpack_require__(369);var _modelsMetricsModel2=_interopRequireDefault(_modelsMetricsModel);var _controllersAbrController=__webpack_require__(64);var _controllersAbrController2=_interopRequireDefault(_controllersAbrController);var _modelsVideoModel=__webpack_require__(370);var _modelsVideoModel2=_interopRequireDefault(_modelsVideoModel);var _utilsDOMStorage=__webpack_require__(409);var _utilsDOMStorage2=_interopRequireDefault(_utilsDOMStorage);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _MediaPlayerEvents=__webpack_require__(144);var _MediaPlayerEvents2=_interopRequireDefault(_MediaPlayerEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreVersion=__webpack_require__(138); //Dash
	var _dashDashAdapter=__webpack_require__(304);var _dashDashAdapter2=_interopRequireDefault(_dashDashAdapter);var _dashModelsDashManifestModel=__webpack_require__(310);var _dashModelsDashManifestModel2=_interopRequireDefault(_dashModelsDashManifestModel);var _dashDashMetrics=__webpack_require__(306);var _dashDashMetrics2=_interopRequireDefault(_dashDashMetrics);var _dashUtilsTimelineConverter=__webpack_require__(324);var _dashUtilsTimelineConverter2=_interopRequireDefault(_dashUtilsTimelineConverter);var _voMetricsHTTPRequest=__webpack_require__(16);var _externalsBase64=__webpack_require__(299);var _externalsBase642=_interopRequireDefault(_externalsBase64);var _codemIsoboxer=__webpack_require__(84);var _codemIsoboxer2=_interopRequireDefault(_codemIsoboxer); /**
	 * @module MediaPlayer
	 * @description The MediaPlayer is the primary dash.js Module and a Facade to build your player around.
	 * It will allow you access to all the important dash.js properties/methods via the public API and all the
	 * events to build a robust DASH media player.
	 */function MediaPlayer(){var STREAMING_NOT_INITIALIZED_ERROR='You must first call initialize() and set a source before calling this method';var PLAYBACK_NOT_INITIALIZED_ERROR='You must first call initialize() and set a valid source and view before calling this method';var ELEMENT_NOT_ATTACHED_ERROR='You must first call attachView() to set the video element before calling this method';var SOURCE_NOT_ATTACHED_ERROR='You must first call attachSource() with a valid source before calling this method';var MEDIA_PLAYER_NOT_INITIALIZED_ERROR='MediaPlayer not initialized!';var MEDIA_PLAYER_BAD_ARGUMENT_ERROR='MediaPlayer Invalid Arguments!';var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var debug=(0,_coreDebug2['default'])(context).getInstance();var log=debug.log;var instance=undefined,source=undefined,protectionData=undefined,mediaPlayerInitialized=undefined,streamingInitialized=undefined,playbackInitialized=undefined,autoPlay=undefined,abrController=undefined,timelineConverter=undefined,mediaController=undefined,protectionController=undefined,metricsReportingController=undefined,mssHandler=undefined,adapter=undefined,metricsModel=undefined,mediaPlayerModel=undefined,errHandler=undefined,capabilities=undefined,streamController=undefined,playbackController=undefined,dashMetrics=undefined,dashManifestModel=undefined,manifestModel=undefined,videoModel=undefined,textController=undefined,domStorage=undefined; /*
	    ---------------------------------------------------------------------------
	
	        INIT FUNCTIONS
	
	    ---------------------------------------------------------------------------
	    */function setup(){mediaPlayerInitialized = false;playbackInitialized = false;streamingInitialized = false;autoPlay = true;protectionController = null;protectionData = null;adapter = null;_coreEventsEvents2['default'].extend(_MediaPlayerEvents2['default']);mediaPlayerModel = (0,_modelsMediaPlayerModel2['default'])(context).getInstance();videoModel = (0,_modelsVideoModel2['default'])(context).getInstance();} /**
	     * Configure media player with customs controllers. Helpful for tests
	     *
	     * @param {object=} config controllers configuration
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setConfig(config){if(!config){return;}if(config.capabilities){capabilities = config.capabilities;}if(config.streamController){streamController = config.streamController;}if(config.playbackController){playbackController = config.playbackController;}if(config.mediaPlayerModel){mediaPlayerModel = config.mediaPlayerModel;}if(config.abrController){abrController = config.abrController;}if(config.mediaController){mediaController = config.mediaController;}} /**
	     * Upon creating the MediaPlayer you must call initialize before you call anything else.
	     * There is one exception to this rule. It is crucial to call {@link module:MediaPlayer#extend extend()}
	     * with all your extensions prior to calling initialize.
	     *
	     * ALL arguments are optional and there are individual methods to set each argument later on.
	     * The args in this method are just for convenience and should only be used for a simple player setup.
	     *
	     * @param {HTML5MediaElement=} view - Optional arg to set the video element. {@link module:MediaPlayer#attachView attachView()}
	     * @param {string=} source - Optional arg to set the media source. {@link module:MediaPlayer#attachSource attachSource()}
	     * @param {boolean=} AutoPlay - Optional arg to set auto play. {@link module:MediaPlayer#setAutoPlay setAutoPlay()}
	     * @see {@link module:MediaPlayer#attachView attachView()}
	     * @see {@link module:MediaPlayer#attachSource attachSource()}
	     * @see {@link module:MediaPlayer#setAutoPlay setAutoPlay()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function initialize(view,source,AutoPlay){if(!capabilities){capabilities = (0,_utilsCapabilities2['default'])(context).getInstance();}errHandler = (0,_utilsErrorHandler2['default'])(context).getInstance();if(!capabilities.supportsMediaSource()){errHandler.capabilityError('mediasource');return;}if(mediaPlayerInitialized)return;mediaPlayerInitialized = true; // init some controllers and models
	timelineConverter = (0,_dashUtilsTimelineConverter2['default'])(context).getInstance();if(!abrController){abrController = (0,_controllersAbrController2['default'])(context).getInstance();}if(!playbackController){playbackController = (0,_controllersPlaybackController2['default'])(context).getInstance();}if(!mediaController){mediaController = (0,_controllersMediaController2['default'])(context).getInstance();}adapter = (0,_dashDashAdapter2['default'])(context).getInstance();dashManifestModel = (0,_dashModelsDashManifestModel2['default'])(context).getInstance({mediaController:mediaController,timelineConverter:timelineConverter,adapter:adapter});manifestModel = (0,_modelsManifestModel2['default'])(context).getInstance();dashMetrics = (0,_dashDashMetrics2['default'])(context).getInstance({manifestModel:manifestModel,dashManifestModel:dashManifestModel});metricsModel = (0,_modelsMetricsModel2['default'])(context).getInstance();textController = (0,_textTextController2['default'])(context).getInstance();domStorage = (0,_utilsDOMStorage2['default'])(context).getInstance({mediaPlayerModel:mediaPlayerModel});adapter.setConfig({dashManifestModel:dashManifestModel});metricsModel.setConfig({adapter:adapter});restoreDefaultUTCTimingSources();setAutoPlay(AutoPlay !== undefined?AutoPlay:true);if(view){attachView(view);}if(source){attachSource(source);}log('[dash.js ' + getVersion() + '] ' + 'MediaPlayer has been initialized');} /**
	     * Sets the MPD source and the video element to null. You can also reset the MediaPlayer by
	     * calling attachSource with a new source file.
	     *
	     * Calling this method is all that is necessary to destroy a MediaPlayer instance.
	     *
	     * @memberof module:MediaPlayer
	     * @instance
	     */function reset(){attachSource(null);attachView(null);protectionData = null;if(protectionController){protectionController.reset();protectionController = null;}if(metricsReportingController){metricsReportingController.reset();metricsReportingController = null;}} /**
	     * The ready state of the MediaPlayer based on both the video element and MPD source being defined.
	     *
	     * @returns {boolean} The current ready state of the MediaPlayer
	     * @see {@link module:MediaPlayer#attachView attachView()}
	     * @see {@link module:MediaPlayer#attachSource attachSource()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function isReady(){return !!source && !!videoModel.getElement();} /**
	     * Use the on method to listen for public events found in MediaPlayer.events. {@link MediaPlayerEvents}
	     *
	     * @param {string} type - {@link MediaPlayerEvents}
	     * @param {Function} listener - callback method when the event fires.
	     * @param {Object} scope - context of the listener so it can be removed properly.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function on(type,listener,scope){eventBus.on(type,listener,scope);} /**
	     * Use the off method to remove listeners for public events found in MediaPlayer.events. {@link MediaPlayerEvents}
	     *
	     * @param {string} type - {@link MediaPlayerEvents}
	     * @param {Function} listener - callback method when the event fires.
	     * @param {Object} scope - context of the listener so it can be removed properly.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function off(type,listener,scope){eventBus.off(type,listener,scope);} /**
	     * Current version of Dash.js
	     * @returns {string} the current dash.js version string.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getVersion(){return (0,_coreVersion.getVersionString)();} /**
	     * Use this method to access the dash.js logging class.
	     *
	     * @returns {Debug}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getDebug(){return debug;} /*
	    ---------------------------------------------------------------------------
	
	        PLAYBACK FUNCTIONS
	
	    ---------------------------------------------------------------------------
	    */ /**
	     * Causes the player to begin streaming the media as set by the {@link module:MediaPlayer#attachSource attachSource()}
	     * method in preparation for playing. It specifically does not require a view to be attached with {@link module:MediaPlayer#attachSource attachView()} to begin preloading.
	     * When a view is attached after preloading, the buffered data is transferred to the attached mediaSource buffers.
	     *
	     * @see {@link module:MediaPlayer#attachSource attachSource()}
	     * @see {@link module:MediaPlayer#attachView attachView()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function preload(){if(videoModel.getElement() || streamingInitialized){return false;}if(source){initializePlayback();}else {throw SOURCE_NOT_ATTACHED_ERROR;}} /**
	     * The play method initiates playback of the media defined by the {@link module:MediaPlayer#attachSource attachSource()} method.
	     * This method will call play on the native Video Element.
	     *
	     * @see {@link module:MediaPlayer#attachSource attachSource()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function play(){if(!playbackInitialized){throw PLAYBACK_NOT_INITIALIZED_ERROR;}if(!autoPlay || isPaused() && playbackInitialized){playbackController.play();}} /**
	     * This method will call pause on the native Video Element.
	     *
	     * @memberof module:MediaPlayer
	     * @instance
	     */function pause(){if(!playbackInitialized){throw PLAYBACK_NOT_INITIALIZED_ERROR;}playbackController.pause();} /**
	     * Returns a Boolean that indicates whether the Video Element is paused.
	     * @return {boolean}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function isPaused(){if(!playbackInitialized){throw PLAYBACK_NOT_INITIALIZED_ERROR;}return playbackController.isPaused();} /**
	     * Sets the currentTime property of the attached video element.  If it is a live stream with a
	     * timeShiftBufferLength, then the DVR window offset will be automatically calculated.
	     *
	     * @param {number} value - A relative time, in seconds, based on the return value of the {@link module:MediaPlayer#duration duration()} method is expected
	     * @see {@link module:MediaPlayer#getDVRSeekOffset getDVRSeekOffset()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function seek(value){if(!playbackInitialized){throw PLAYBACK_NOT_INITIALIZED_ERROR;}if(typeof value !== 'number' || isNaN(value)){throw MEDIA_PLAYER_BAD_ARGUMENT_ERROR;}var s=playbackController.getIsDynamic()?getDVRSeekOffset(value):value;playbackController.seek(s);} /**
	     * Returns a Boolean that indicates whether the media is in the process of seeking to a new position.
	     * @return {boolean}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function isSeeking(){if(!playbackInitialized){throw PLAYBACK_NOT_INITIALIZED_ERROR;}return playbackController.isSeeking();} /**
	     * Returns a Boolean that indicates whether the media is in the process of dynamic.
	     * @return {boolean}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function isDynamic(){if(!playbackInitialized){throw PLAYBACK_NOT_INITIALIZED_ERROR;}return playbackController.getIsDynamic();} /**
	     * Use this method to set the native Video Element's playback rate.
	     * @param {number} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setPlaybackRate(value){if(!videoModel.getElement()){throw ELEMENT_NOT_ATTACHED_ERROR;}getVideoElement().playbackRate = value;} /**
	     * Returns the current playback rate.
	     * @returns {number}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getPlaybackRate(){if(!videoModel.getElement()){throw ELEMENT_NOT_ATTACHED_ERROR;}return getVideoElement().playbackRate;} /**
	     * Use this method to set the native Video Element's muted state. Takes a Boolean that determines whether audio is muted. true if the audio is muted and false otherwise.
	     * @param {boolean} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setMute(value){if(!videoModel.getElement()){throw ELEMENT_NOT_ATTACHED_ERROR;}getVideoElement().muted = value;} /**
	     * A Boolean that determines whether audio is muted.
	     * @returns {boolean}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function isMuted(){if(!videoModel.getElement()){throw ELEMENT_NOT_ATTACHED_ERROR;}return getVideoElement().muted;} /**
	     * A double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
	     * @param {number} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setVolume(value){if(!videoModel.getElement()){throw ELEMENT_NOT_ATTACHED_ERROR;}getVideoElement().volume = value;} /**
	     * Returns the current audio volume, from 0.0 (silent) to 1.0 (loudest).
	     * @returns {number}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getVolume(){if(!videoModel.getElement()){throw ELEMENT_NOT_ATTACHED_ERROR;}return getVideoElement().volume;} /**
	     * The length of the buffer for a given media type, in seconds. Valid media
	     * types are "video", "audio" and "fragmentedText". If no type is passed
	     * in, then the minimum of video, audio and fragmentedText buffer length is
	     * returned. NaN is returned if an invalid type is requested, the
	     * presentation does not contain that type, or if no arguments are passed
	     * and the presentation does not include any adaption sets of valid media
	     * type.
	     *
	     * @param {string} type - the media type of the buffer
	     * @returns {number} The length of the buffer for the given media type, in
	     *  seconds, or NaN
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getBufferLength(type){var types=[_constantsConstants2['default'].VIDEO,_constantsConstants2['default'].AUDIO,_constantsConstants2['default'].FRAGMENTED_TEXT];if(!type){var buffer=types.map(function(t){return getTracksFor(t).length > 0?getDashMetrics().getCurrentBufferLevel(getMetricsFor(t)):Number.MAX_VALUE;}).reduce(function(p,c){return Math.min(p,c);});return buffer === Number.MAX_VALUE?NaN:buffer;}else {if(types.indexOf(type) !== -1){var buffer=getDashMetrics().getCurrentBufferLevel(getMetricsFor(type));return buffer?buffer:NaN;}else {log('Warning  - getBufferLength requested for invalid type');return NaN;}}} /**
	     * The timeShiftBufferLength (DVR Window), in seconds.
	     *
	     * @returns {number} The window of allowable play time behind the live point of a live stream.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getDVRWindowSize(){var metric=getDVRInfoMetric();if(!metric){return 0;}return metric.manifestInfo.DVRWindowSize;} /**
	     * This method should only be used with a live stream that has a valid timeShiftBufferLength (DVR Window).
	     * NOTE - If you do not need the raw offset value (i.e. media analytics, tracking, etc) consider using the {@link module:MediaPlayer#seek seek()} method
	     * which will calculate this value for you and set the video element's currentTime property all in one simple call.
	     *
	     * @param {number} value - A relative time, in seconds, based on the return value of the {@link module:MediaPlayer#duration duration()} method is expected.
	     * @returns {number} A value that is relative the available range within the timeShiftBufferLength (DVR Window).
	     * @see {@link module:MediaPlayer#seek seek()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getDVRSeekOffset(value){var metric=getDVRInfoMetric();var liveDelay=playbackController.getLiveDelay();if(!metric){return 0;}var val=metric.range.start + value;if(val > metric.range.end - liveDelay){val = metric.range.end - liveDelay;}return val;} /**
	     * Current time of the playhead, in seconds.
	     *
	     * If called with no arguments then the returned time value is time elapsed since the start point of the first stream, or if it is a live stream, then the time will be based on the return value of the {@link module:MediaPlayer#duration duration()} method.
	     * However if a stream ID is supplied then time is relative to the start of that stream, or is null if there is no such stream id in the manifest.
	     *
	     * @param {string} streamId - The ID of a stream that the returned playhead time must be relative to the start of. If undefined, then playhead time is relative to the first stream.
	     * @returns {number} The current playhead time of the media, or null.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function time(streamId){if(!playbackInitialized){throw PLAYBACK_NOT_INITIALIZED_ERROR;}var t=getVideoElement().currentTime;if(streamId !== undefined){t = streamController.getTimeRelativeToStreamId(t,streamId);}else if(playbackController.getIsDynamic()){var metric=getDVRInfoMetric();t = metric === null?0:duration() - (metric.range.end - metric.time);}return t;} /**
	     * Duration of the media's playback, in seconds.
	     *
	     * @returns {number} The current duration of the media.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function duration(){if(!playbackInitialized){throw PLAYBACK_NOT_INITIALIZED_ERROR;}var d=getVideoElement().duration;if(playbackController.getIsDynamic()){var metric=getDVRInfoMetric();var range=undefined;if(!metric){return 0;}range = metric.range.end - metric.range.start;d = range < metric.manifestInfo.DVRWindowSize?range:metric.manifestInfo.DVRWindowSize;}return d;} /**
	     * Use this method to get the current playhead time as an absolute value, the time in seconds since midnight UTC, Jan 1 1970.
	     * Note - this property only has meaning for live streams. If called before play() has begun, it will return a value of NaN.
	     *
	     * @returns {number} The current playhead time as UTC timestamp.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function timeAsUTC(){if(!playbackInitialized){throw PLAYBACK_NOT_INITIALIZED_ERROR;}if(time() < 0){return NaN;}return getAsUTC(time());} /**
	     * Use this method to get the current duration as an absolute value, the time in seconds since midnight UTC, Jan 1 1970.
	     * Note - this property only has meaning for live streams.
	     *
	     * @returns {number} The current duration as UTC timestamp.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function durationAsUTC(){if(!playbackInitialized){throw PLAYBACK_NOT_INITIALIZED_ERROR;}return getAsUTC(duration());} /*
	    ---------------------------------------------------------------------------
	
	        AUTO BITRATE
	
	    ---------------------------------------------------------------------------
	    */ /**
	     * When switching multi-bitrate content (auto or manual mode) this property specifies the maximum bitrate allowed.
	     * If you set this property to a value lower than that currently playing, the switching engine will switch down to
	     * satisfy this requirement. If you set it to a value that is lower than the lowest bitrate, it will still play
	     * that lowest bitrate.
	     *
	     * You can set or remove this bitrate cap at anytime before or during playback.  To clear this setting you must use the API
	     * and set the value param to NaN.
	     *
	     * This feature is typically used to reserve higher bitrates for playback only when the player is in large or full-screen format.
	     *
	     * @param {string} type - 'video' or 'audio' are the type options.
	     * @param {number} value - Value in kbps representing the maximum bitrate allowed.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setMaxAllowedBitrateFor(type,value){abrController.setMaxAllowedBitrateFor(type,value);} /**
	     * When switching multi-bitrate content (auto or manual mode) this property specifies the minimum bitrate allowed.
	     * If you set this property to a value higher than that currently playing, the switching engine will switch up to
	     * satisfy this requirement. If you set it to a value that is lower than the lowest bitrate, it will still play
	     * that lowest bitrate.
	     *
	     * You can set or remove this bitrate limit at anytime before or during playback. To clear this setting you must use the API
	     * and set the value param to NaN.
	     *
	     * This feature is used to force higher quality playback.
	     *
	     * @param {string} type - 'video' or 'audio' are the type options.
	     * @param {number} value - Value in kbps representing the minimum bitrate allowed.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setMinAllowedBitrateFor(type,value){abrController.setMinAllowedBitrateFor(type,value);} /**
	     * @param {string} type - 'video' or 'audio' are the type options.
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#setMaxAllowedBitrateFor setMaxAllowedBitrateFor()}
	     * @instance
	     */function getMaxAllowedBitrateFor(type){return abrController.getMaxAllowedBitrateFor(type);} /**
	     * @param {string} type - 'video' or 'audio' are the type options.
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#setMinAllowedBitrateFor setMinAllowedBitrateFor()}
	     * @instance
	     */function getMinAllowedBitrateFor(type){return abrController.getMinAllowedBitrateFor(type);} /**
	     * When switching multi-bitrate content (auto or manual mode) this property specifies the maximum representation allowed,
	     * as a proportion of the size of the representation set.
	     *
	     * You can set or remove this cap at anytime before or during playback. To clear this setting you must use the API
	     * and set the value param to NaN.
	     *
	     * If both this and maxAllowedBitrate are defined, maxAllowedBitrate is evaluated first, then maxAllowedRepresentation,
	     * i.e. the lowest value from executing these rules is used.
	     *
	     * This feature is typically used to reserve higher representations for playback only when connected over a fast connection.
	     *
	     * @param {string} type - 'video' or 'audio' are the type options.
	     * @param {number} value - number between 0 and 1, where 1 is allow all representations, and 0 is allow only the lowest.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setMaxAllowedRepresentationRatioFor(type,value){abrController.setMaxAllowedRepresentationRatioFor(type,value);} /**
	     * @param {string} type - 'video' or 'audio' are the type options.
	     * @returns {number} The current representation ratio cap.
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#setMaxAllowedRepresentationRatioFor setMaxAllowedRepresentationRatioFor()}
	     * @instance
	     */function getMaxAllowedRepresentationRatioFor(type){return abrController.getMaxAllowedRepresentationRatioFor(type);} /**
	     * Gets the current download quality for media type video, audio or images. For video and audio types the ABR
	     * rules update this value before every new download unless setAutoSwitchQualityFor(type, false) is called. For 'image'
	     * type, thumbnails, there is no ABR algorithm and quality is set manually.
	     *
	     * @param {string} type - 'video', 'audio' or 'image' (thumbnails)
	     * @returns {number} the quality index, 0 corresponding to the lowest bitrate
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#setAutoSwitchQualityFor setAutoSwitchQualityFor()}
	     * @see {@link module:MediaPlayer#setQualityFor setQualityFor()}
	     * @instance
	     */function getQualityFor(type){if(!streamingInitialized){throw STREAMING_NOT_INITIALIZED_ERROR;}if(type === _constantsConstants2['default'].IMAGE){var activeStream=getActiveStream();if(!activeStream){return -1;}var thumbnailController=activeStream.getThumbnailController();if(!thumbnailController){return -1;}return thumbnailController.getCurrentTrackIndex();}return abrController.getQualityFor(type,streamController.getActiveStreamInfo());} /**
	     * Sets the current quality for media type instead of letting the ABR Heuristics automatically selecting it.
	     * This value will be overwritten by the ABR rules unless setAutoSwitchQualityFor(type, false) is called.
	     *
	     * @param {string} type - 'video', 'audio' or 'image'
	     * @param {number} value - the quality index, 0 corresponding to the lowest bitrate
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#setAutoSwitchQualityFor setAutoSwitchQualityFor()}
	     * @see {@link module:MediaPlayer#getQualityFor getQualityFor()}
	     * @instance
	     */function setQualityFor(type,value){if(!streamingInitialized){throw STREAMING_NOT_INITIALIZED_ERROR;}if(type === _constantsConstants2['default'].IMAGE){var activeStream=getActiveStream();if(!activeStream){return;}var thumbnailController=activeStream.getThumbnailController();if(thumbnailController){thumbnailController.setTrackByIndex(value);}}abrController.setPlaybackQuality(type,streamController.getActiveStreamInfo(),value);} /**
	     * Update the video element size variables
	     * Should be called on window resize (or any other time player is resized). Fullscreen does trigger a window resize event.
	     *
	     * Once windowResizeEventCalled = true, abrController.checkPortalSize() will use element size variables rather than querying clientWidth every time.
	     *
	     * @memberof module:MediaPlayer
	     * @instance
	     */function updatePortalSize(){abrController.setElementSize();abrController.setWindowResizeEventCalled(true);} /**
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getLimitBitrateByPortal(){return abrController.getLimitBitrateByPortal();} /**
	     * Sets whether to limit the representation used based on the size of the playback area
	     *
	     * @param {boolean} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setLimitBitrateByPortal(value){abrController.setLimitBitrateByPortal(value);} /**
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getUsePixelRatioInLimitBitrateByPortal(){return abrController.getUsePixelRatioInLimitBitrateByPortal();} /**
	     * Sets whether to take into account the device's pixel ratio when defining the portal dimensions.
	     * Useful on, for example, retina displays.
	     *
	     * @param {boolean} value
	     * @memberof module:MediaPlayer
	     * @instance
	     * @default {boolean} false
	     */function setUsePixelRatioInLimitBitrateByPortal(value){abrController.setUsePixelRatioInLimitBitrateByPortal(value);} /**
	     * Use this method to explicitly set the starting bitrate for audio | video
	     *
	     * @param {string} type
	     * @param {number} value - A value of the initial bitrate, kbps
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setInitialBitrateFor(type,value){abrController.setInitialBitrateFor(type,value);} /**
	     * @param {string} type
	     * @returns {number} A value of the initial bitrate, kbps
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getInitialBitrateFor(type){if(!streamingInitialized){throw STREAMING_NOT_INITIALIZED_ERROR; //abrController.getInitialBitrateFor is overloaded with ratioDict logic that needs manifest force it to not be callable pre play.
	}return abrController.getInitialBitrateFor(type);} /**
	     * @param {string} type
	     * @param {number} value - A value of the initial Representation Ratio
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setInitialRepresentationRatioFor(type,value){abrController.setInitialRepresentationRatioFor(type,value);} /**
	     * @param {string} type
	     * @returns {number} A value of the initial Representation Ratio
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getInitialRepresentationRatioFor(type){return abrController.getInitialRepresentationRatioFor(type);} /**
	     * @param {string} type - 'audio' | 'video'
	     * @returns {boolean} Current state of adaptive bitrate switching
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getAutoSwitchQualityFor(type){return abrController.getAutoSwitchBitrateFor(type);} /**
	     * Set to false to switch off adaptive bitrate switching.
	     *
	     * @param {string} type - 'audio' | 'video'
	     * @param {boolean} value
	     * @default true
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setAutoSwitchQualityFor(type,value){abrController.setAutoSwitchBitrateFor(type,value);} /**
	     * Get the value of useDeadTimeLatency in AbrController. @see setUseDeadTimeLatencyForAbr
	     *
	     * @returns {boolean}
	     *
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getUseDeadTimeLatencyForAbr(){return abrController.getUseDeadTimeLatency();} /**
	     * Set the value of useDeadTimeLatency in AbrController. If true, only the download
	     * portion will be considered part of the download bitrate and latency will be
	     * regarded as static. If false, the reciprocal of the whole transfer time will be used.
	     * Defaults to true.
	     *
	     * @param {boolean=} useDeadTimeLatency - True or false flag.
	     *
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setUseDeadTimeLatencyForAbr(useDeadTimeLatency){abrController.setUseDeadTimeLatency(useDeadTimeLatency);} /*
	    ---------------------------------------------------------------------------
	
	        MEDIA PLAYER CONFIGURATION
	
	    ---------------------------------------------------------------------------
	    */ /**
	     * <p>Set to false to prevent stream from auto-playing when the view is attached.</p>
	     *
	     * @param {boolean} value
	     * @default true
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#attachView attachView()}
	     * @instance
	     *
	     */function setAutoPlay(value){autoPlay = value;} /**
	     * @returns {boolean} The current autoPlay state.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getAutoPlay(){return autoPlay;} /**
	     * <p>Changing this value will lower or increase live stream latency.  The detected segment duration will be multiplied by this value
	     * to define a time in seconds to delay a live stream from the live edge.</p>
	     * <p>Lowering this value will lower latency but may decrease the player's ability to build a stable buffer.</p>
	     *
	     * @param {number} value - Represents how many segment durations to delay the live stream.
	     * @default 4
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#useSuggestedPresentationDelay useSuggestedPresentationDelay()}
	     * @instance
	     */function setLiveDelayFragmentCount(value){mediaPlayerModel.setLiveDelayFragmentCount(value);} /**
	     * <p>Equivalent in seconds of setLiveDelayFragmentCount</p>
	     * <p>Lowering this value will lower latency but may decrease the player's ability to build a stable buffer.</p>
	     * <p>This value should be less than the manifest duration by a couple of segment durations to avoid playback issues</p>
	     * <p>If set, this parameter will take precedence over setLiveDelayFragmentCount and manifest info</p>
	     *
	     * @param {number} value - Represents how many seconds to delay the live stream.
	     * @default undefined
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#useSuggestedPresentationDelay useSuggestedPresentationDelay()}
	     * @instance
	     */function setLiveDelay(value){mediaPlayerModel.setLiveDelay(value);} /**
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#setLiveDelay setLiveDelay()}
	     * @instance
	     * @returns {number|undefined} Current live stream delay in seconds when previously set, or `undefined`
	     */function getLiveDelay(){return mediaPlayerModel.getLiveDelay();} /**
	     * @memberof module:MediaPlayer
	     * @instance
	     * @returns {number|NaN} Current live stream latency in seconds. It is the difference between current time and time position at the playback head.
	     */function getCurrentLiveLatency(){if(!mediaPlayerInitialized){throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;}if(!playbackInitialized){return NaN;}return playbackController.getCurrentLiveLatency();} /**
	     * <p>Set to true if you would like to override the default live delay and honor the SuggestedPresentationDelay attribute in by the manifest.</p>
	     * @param {boolean} value
	     * @default false
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#setLiveDelayFragmentCount setLiveDelayFragmentCount()}
	     * @instance
	     */function useSuggestedPresentationDelay(value){mediaPlayerModel.setUseSuggestedPresentationDelay(value);} /**
	     * Set to false if you would like to disable the last known bit rate from being stored during playback and used
	     * to set the initial bit rate for subsequent playback within the expiration window.
	     *
	     * The default expiration is one hour, defined in milliseconds. If expired, the default initial bit rate (closest to 1000 kbps) will be used
	     * for that session and a new bit rate will be stored during that session.
	     *
	     * @param {boolean} enable - Will toggle if feature is enabled. True to enable, False to disable.
	     * @param {number=} ttl - (Optional) A value defined in milliseconds representing how long to cache the bit rate for. Time to live.
	     * @default enable = True, ttl = 360000 (1 hour)
	     * @memberof module:MediaPlayer
	     * @instance
	     *
	     */function enableLastBitrateCaching(enable,ttl){mediaPlayerModel.setLastBitrateCachingInfo(enable,ttl);} /**
	     * Set to false if you would like to disable the last known lang for audio (or camera angle for video) from being stored during playback and used
	     * to set the initial settings for subsequent playback within the expiration window.
	     *
	     * The default expiration is one hour, defined in milliseconds. If expired, the default settings will be used
	     * for that session and a new settings will be stored during that session.
	     *
	     * @param {boolean} enable - Will toggle if feature is enabled. True to enable, False to disable.
	     * @param {number=} [ttl] - (Optional) A value defined in milliseconds representing how long to cache the settings for. Time to live.
	     * @default enable = True, ttl = 360000 (1 hour)
	     * @memberof module:MediaPlayer
	     * @instance
	     *
	     */function enableLastMediaSettingsCaching(enable,ttl){mediaPlayerModel.setLastMediaSettingsCachingInfo(enable,ttl);} /**
	     * Set to true if you would like dash.js to keep downloading fragments in the background
	     * when the video element is paused.
	     *
	     * @default true
	     * @param {boolean} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setScheduleWhilePaused(value){mediaPlayerModel.setScheduleWhilePaused(value);} /**
	     * Returns a boolean of the current state of ScheduleWhilePaused.
	     * @returns {boolean}
	     * @see {@link module:MediaPlayer#setScheduleWhilePaused setScheduleWhilePaused()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getScheduleWhilePaused(){return mediaPlayerModel.getScheduleWhilePaused();} /**
	     * When enabled, after an ABR up-switch in quality, instead of requesting and appending the next fragment
	     * at the end of the current buffer range it is requested and appended closer to the current time
	     * When enabled, The maximum time to render a higher quality is current time + (1.5 * fragment duration).
	     *
	     * Note, When ABR down-switch is detected, we appended the lower quality at the end of the buffer range to preserve the
	     * higher quality media for as long as possible.
	     *
	     * If enabled, it should be noted there are a few cases when the client will not replace inside buffer range but rather
	     * just append at the end.  1. When the buffer level is less than one fragment duration 2.  The client
	     * is in an Abandonment State due to recent fragment abandonment event.
	     *
	     * Known issues:
	     * 1. In IE11 with auto switching off, if a user switches to a quality they can not download in time the
	     * fragment may be appended in the same range as the playhead or even in the past, in IE11 it may cause a stutter
	     * or stall in playback.
	     *
	     *
	     * @param {boolean} value
	     * @default {boolean} false
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setFastSwitchEnabled(value){ //TODO we need to look at track switches for adaptation sets.  If always replace it works much like this but clears buffer. Maybe too many ways to do same thing.
	mediaPlayerModel.setFastSwitchEnabled(value);} /**
	     * Enabled by default. Will return the current state of Fast Switch.
	     * @return {boolean} Returns true if FastSwitch ABR is enabled.
	     * @see {@link module:MediaPlayer#setFastSwitchEnabled setFastSwitchEnabled()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getFastSwitchEnabled(){return mediaPlayerModel.getFastSwitchEnabled();} /**
	     * Sets the ABR strategy. Valid strategies are "abrDynamic", "abrBola" and "abrThroughput".
	     * The ABR strategy can also be changed during a streaming session.
	     * The call has no effect if an invalid method is passed.
	     *
	     * The BOLA strategy chooses bitrate based on current buffer level, with higher bitrates for higher buffer levels.
	     * The Throughput strategy chooses bitrate based on the recent throughput history.
	     * The Dynamic strategy switches smoothly between BOLA and Throughput in real time, playing to the strengths of both.
	     *
	     * @param {string} value
	     * @default "abrDynamic"
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setABRStrategy(value){if(value === _constantsConstants2['default'].ABR_STRATEGY_DYNAMIC || value === _constantsConstants2['default'].ABR_STRATEGY_BOLA || value === _constantsConstants2['default'].ABR_STRATEGY_THROUGHPUT){mediaPlayerModel.setABRStrategy(value);}else {log('Warning: Ignoring setABRStrategy(' + value + ') - unknown value.');}} /**
	     * Returns the current ABR strategy being used.
	     * @return {string} "abrDynamic", "abrBola" or "abrThroughput"
	     * @see {@link module:MediaPlayer#setABRStrategy setABRStrategy()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getABRStrategy(){return mediaPlayerModel.getABRStrategy();} /**
	     * Enable/disable builtin dashjs ABR rules
	     * @param {boolean} value
	     * @default true
	     * @memberof module:MediaPlayer
	     * @instance
	     */function useDefaultABRRules(value){mediaPlayerModel.setUseDefaultABRRules(value);} /**
	     * Add a custom ABR Rule
	     * Rule will be apply on next stream if a stream is being played
	     *
	     * @param {string} type - rule type (one of ['qualitySwitchRules','abandonFragmentRules'])
	     * @param {string} rulename - name of rule (used to identify custom rule). If one rule of same name has been added, then existing rule will be updated
	     * @param {object} rule - the rule object instance
	     * @memberof module:MediaPlayer
	     * @instance
	     */function addABRCustomRule(type,rulename,rule){mediaPlayerModel.addABRCustomRule(type,rulename,rule);} /**
	     * Remove a custom ABR Rule
	     *
	     * @param {string} rulename - name of the rule to be removed
	     * @memberof module:MediaPlayer
	     * @instance
	     */function removeABRCustomRule(rulename){mediaPlayerModel.removeABRCustomRule(rulename);} /**
	     * Remove all custom rules
	     * @memberof module:MediaPlayer
	     * @instance
	     */function removeAllABRCustomRule(){mediaPlayerModel.removeAllABRCustomRule();} /**
	     * Sets the moving average method used for smoothing throughput estimates. Valid methods are
	     * "slidingWindow" and "ewma". The call has no effect if an invalid method is passed.
	     *
	     * The sliding window moving average method computes the average throughput using the last four segments downloaded.
	     * If the stream is live (as opposed to VOD), then only the last three segments are used.
	     * If wide variations in throughput are detected, the number of segments can be dynamically increased to avoid oscillations.
	     *
	     * The exponentially weighted moving average (EWMA) method computes the average using exponential smoothing.
	     * Two separate estimates are maintained, a fast one with a three-second half life and a slow one with an eight-second half life.
	     * The throughput estimate at any time is the minimum of the fast and slow estimates.
	     * This allows a fast reaction to a bandwidth drop and prevents oscillations on bandwidth spikes.
	     *
	     * @param {string} value
	     * @default {string} 'slidingWindow'
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setMovingAverageMethod(value){if(value === _constantsConstants2['default'].MOVING_AVERAGE_SLIDING_WINDOW || value === _constantsConstants2['default'].MOVING_AVERAGE_EWMA){mediaPlayerModel.setMovingAverageMethod(value);}else {log('Warning: Ignoring setMovingAverageMethod(' + value + ') - unknown value.');}} /**
	     * Return the current moving average method used for smoothing throughput estimates.
	     * @return {string} Returns "slidingWindow" or "ewma".
	     * @see {@link module:MediaPlayer#setMovingAverageMethod setMovingAverageMethod()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getMovingAverageMethod(){return mediaPlayerModel.getMovingAverageMethod();} /**
	     * Returns if low latency mode is enabled. Disabled by default.
	     * @return {boolean} true - if enabled
	     * @see {@link module:MediaPlayer#setLowLatencyEnabled setLowLatencyEnabled()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getLowLatencyEnabled(){return mediaPlayerModel.getLowLatencyEnabled();} /**
	     * Enables low latency mode for dynamic streams. If not specified, liveDelay is set to 3s of buffer.
	     * Browser compatibility (Check row 'ReadableStream response body'): https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
	     * @param {boolean} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setLowLatencyEnabled(value){return mediaPlayerModel.setLowLatencyEnabled(value);} /**
	     * <p>Allows you to set a scheme and server source for UTC live edge detection for dynamic streams.
	     * If UTCTiming is defined in the manifest, it will take precedence over any time source manually added.</p>
	     * <p>If you have exposed the Date header, use the method {@link module:MediaPlayer#clearDefaultUTCTimingSources clearDefaultUTCTimingSources()}.
	     * This will allow the date header on the manifest to be used instead of a time server</p>
	     * @param {string} schemeIdUri - <ul>
	     * <li>urn:mpeg:dash:utc:http-head:2014</li>
	     * <li>urn:mpeg:dash:utc:http-xsdate:2014</li>
	     * <li>urn:mpeg:dash:utc:http-iso:2014</li>
	     * <li>urn:mpeg:dash:utc:direct:2014</li>
	     * </ul>
	     * <p>Some specs referencing early ISO23009-1 drafts incorrectly use
	     * 2012 in the URI, rather than 2014. support these for now.</p>
	     * <ul>
	     * <li>urn:mpeg:dash:utc:http-head:2012</li>
	     * <li>urn:mpeg:dash:utc:http-xsdate:2012</li>
	     * <li>urn:mpeg:dash:utc:http-iso:2012</li>
	     * <li>urn:mpeg:dash:utc:direct:2012</li>
	     * </ul>
	     * @param {string} value - Path to a time source.
	     * @default
	     * <ul>
	     *     <li>schemeIdUri:urn:mpeg:dash:utc:http-xsdate:2014</li>
	     *     <li>value:http://time.akamai.com</li>
	     * </ul>
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#removeUTCTimingSource removeUTCTimingSource()}
	     * @instance
	     */function addUTCTimingSource(schemeIdUri,value){removeUTCTimingSource(schemeIdUri,value); //check if it already exists and remove if so.
	var vo=new _dashVoUTCTiming2['default']();vo.schemeIdUri = schemeIdUri;vo.value = value;mediaPlayerModel.getUTCTimingSources().push(vo);} /**
	     * <p>Allows you to remove a UTC time source. Both schemeIdUri and value need to match the Dash.vo.UTCTiming properties in order for the
	     * entry to be removed from the array</p>
	     * @param {string} schemeIdUri - see {@link module:MediaPlayer#addUTCTimingSource addUTCTimingSource()}
	     * @param {string} value - see {@link module:MediaPlayer#addUTCTimingSource addUTCTimingSource()}
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#clearDefaultUTCTimingSources clearDefaultUTCTimingSources()}
	     * @instance
	     */function removeUTCTimingSource(schemeIdUri,value){var UTCTimingSources=mediaPlayerModel.getUTCTimingSources();UTCTimingSources.forEach(function(obj,idx){if(obj.schemeIdUri === schemeIdUri && obj.value === value){UTCTimingSources.splice(idx,1);}});} /**
	     * <p>Allows you to clear the stored array of time sources.</p>
	     * <p>Example use: If you have exposed the Date header, calling this method
	     * will allow the date header on the manifest to be used instead of the time server.</p>
	     * <p>Example use: Calling this method, assuming there is not an exposed date header on the manifest,  will default back
	     * to using a binary search to discover the live edge</p>
	     *
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#restoreDefaultUTCTimingSources restoreDefaultUTCTimingSources()}
	     * @instance
	     */function clearDefaultUTCTimingSources(){mediaPlayerModel.setUTCTimingSources([]);} /**
	     * <p>Allows you to restore the default time sources after calling {@link module:MediaPlayer#clearDefaultUTCTimingSources clearDefaultUTCTimingSources()}</p>
	     *
	     * @default
	     * <ul>
	     *     <li>schemeIdUri:urn:mpeg:dash:utc:http-xsdate:2014</li>
	     *     <li>value:http://time.akamai.com</li>
	     * </ul>
	     *
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#addUTCTimingSource addUTCTimingSource()}
	     * @instance
	     */function restoreDefaultUTCTimingSources(){addUTCTimingSource(_modelsMediaPlayerModel2['default'].DEFAULT_UTC_TIMING_SOURCE.scheme,_modelsMediaPlayerModel2['default'].DEFAULT_UTC_TIMING_SOURCE.value);} /**
	     * <p>Allows you to enable the use of the Date Header, if exposed with CORS, as a timing source for live edge detection. The
	     * use of the date header will happen only after the other timing source that take precedence fail or are omitted as described.
	     * {@link module:MediaPlayer#clearDefaultUTCTimingSources clearDefaultUTCTimingSources()} </p>
	     *
	     * @param {boolean} value - true to enable
	     * @default {boolean} True
	     * @memberof module:MediaPlayer
	     * @see {@link module:MediaPlayer#addUTCTimingSource addUTCTimingSource()}
	     * @instance
	     */function enableManifestDateHeaderTimeSource(value){mediaPlayerModel.setUseManifestDateHeaderTimeSource(value);} /**
	     * This value influences the buffer pruning logic.
	     * Allows you to modify the buffer that is kept in source buffer in seconds.
	     * <pre>0|-----------bufferToPrune-----------|-----bufferToKeep-----|currentTime|</pre>
	     *
	     * @default 20 seconds
	     * @param {int} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setBufferToKeep(value){mediaPlayerModel.setBufferToKeep(value);} /**
	     * This value influences the buffer pruning logic.
	     * Allows you to modify the buffer ahead of current time position that is kept in source buffer in seconds.
	     * <pre>0|--------|currentTime|-----bufferAheadToKeep----|----bufferToPrune-----------|end|</pre>
	     *
	     * @default 80 seconds
	     * @param {int} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setBufferAheadToKeep(value){mediaPlayerModel.setBufferAheadToKeep(value);} /**
	     * This value influences the buffer pruning logic.
	     * Allows you to modify the interval of pruning buffer in seconds.
	     *
	     * @default 10 seconds
	     * @param {int} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setBufferPruningInterval(value){mediaPlayerModel.setBufferPruningInterval(value);} /**
	     * The time that the internal buffer target will be set to post startup/seeks (NOT top quality).
	     *
	     * When the time is set higher than the default you will have to wait longer
	     * to see automatic bitrate switches but will have a larger buffer which
	     * will increase stability.
	     *
	     * @default 12 seconds.
	     * @param {int} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setStableBufferTime(value){mediaPlayerModel.setStableBufferTime(value);} /**
	     * The time that the internal buffer target will be set to post startup/seeks (NOT top quality).
	     *
	     * When the time is set higher than the default you will have to wait longer
	     * to see automatic bitrate switches but will have a larger buffer which
	     * will increase stability.
	     *
	     * @default 12 seconds.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getStableBufferTime(){return mediaPlayerModel.getStableBufferTime();} /**
	     * The time that the internal buffer target will be set to once playing the top quality.
	     * If there are multiple bitrates in your adaptation, and the media is playing at the highest
	     * bitrate, then we try to build a larger buffer at the top quality to increase stability
	     * and to maintain media quality.
	     *
	     * @default 30 seconds.
	     * @param {int} value
	    /**
	     * The time that the internal buffer target will be set to once playing the top quality.
	     * If there are multiple bitrates in your adaptation, and the media is playing at the highest
	     * bitrate, then we try to build a larger buffer at the top quality to increase stability
	     * and to maintain media quality.
	     *
	     * @default 30 seconds.
	     * @param {int} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setBufferTimeAtTopQuality(value){mediaPlayerModel.setBufferTimeAtTopQuality(value);} /**
	     * The time that the internal buffer target will be set to once playing the top quality.
	     * If there are multiple bitrates in your adaptation, and the media is playing at the highest
	     * bitrate, then we try to build a larger buffer at the top quality to increase stability
	     * and to maintain media quality.
	     *
	     * @default 30 seconds.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getBufferTimeAtTopQuality(){return mediaPlayerModel.getBufferTimeAtTopQuality();} /**
	     * The time that the internal buffer target will be set to once playing the top quality for long form content.
	     *
	     * @default 60 seconds.
	     * @see {@link module:MediaPlayer#setLongFormContentDurationThreshold setLongFormContentDurationThreshold()}
	     * @see {@link module:MediaPlayer#setBufferTimeAtTopQuality setBufferTimeAtTopQuality()}
	     * @param {int} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setBufferTimeAtTopQualityLongForm(value){mediaPlayerModel.setBufferTimeAtTopQualityLongForm(value);} /**
	     * The time that the internal buffer target will be set to once playing the top quality for long form content.
	     *
	     * @default 60 seconds.
	     * @see {@link module:MediaPlayer#setLongFormContentDurationThreshold setLongFormContentDurationThreshold()}
	     * @see {@link module:MediaPlayer#setBufferTimeAtTopQuality setBufferTimeAtTopQuality()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getBufferTimeAtTopQualityLongForm(){return mediaPlayerModel.getBufferTimeAtTopQualityLongForm();} /**
	     * The threshold which defines if the media is considered long form content.
	     * This will directly affect the buffer targets when playing back at the top quality.
	     *
	     * @see {@link module:MediaPlayer#setBufferTimeAtTopQualityLongForm setBufferTimeAtTopQualityLongForm()}
	     * @default 600 seconds (10 minutes).
	     * @param {number} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setLongFormContentDurationThreshold(value){mediaPlayerModel.setLongFormContentDurationThreshold(value);} /**
	     * The overlap tolerance time, at both the head and the tail of segments, considered when doing time to segment conversions.
	     *
	     * This is used when calculating which of the loaded segments of a representation corresponds with a given time position.
	     * Its value is never used for calculating the segment index in seeking operations in which it assumes overlap time threshold is zero.
	     *
	     * <pre>
	     * |-o-|--- segment X ----|-o-|
	     *                        |-o-|---- segment X+1 -----|-o-|
	     *                                                   |-o-|---- segment X+2 -----|-o-|
	     * </pre>
	     * @default 0.05 seconds.
	     * @param {number} value
	     * @memberof module:MediaPlayer
	     * @instance
	    */function setSegmentOverlapToleranceTime(value){mediaPlayerModel.setSegmentOverlapToleranceTime(value);} /**
	     * For a given media type, the threshold which defines if the response to a fragment
	     * request is coming from browser cache or not.
	     * Valid media types are "video", "audio"
	     *
	     * @default 50 milliseconds for video fragment requests; 5 milliseconds for audio fragment requests.
	     * @param {string} type 'video' or 'audio' are the type options.
	     * @param {number} value Threshold value in milliseconds.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setCacheLoadThresholdForType(type,value){mediaPlayerModel.setCacheLoadThresholdForType(type,value);} /**
	     * A percentage between 0.0 and 1 to reduce the measured throughput calculations.
	     * The default is 0.9. The lower the value the more conservative and restricted the
	     * measured throughput calculations will be. please use carefully. This will directly
	     * affect the ABR logic in dash.js
	     *
	     * @param {number} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setBandwidthSafetyFactor(value){mediaPlayerModel.setBandwidthSafetyFactor(value);} /**
	     * Returns the number of the current BandwidthSafetyFactor
	     *
	     * @return {number} value
	     * @see {@link module:MediaPlayer#setBandwidthSafetyFactor setBandwidthSafetyFactor()}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getBandwidthSafetyFactor(){return mediaPlayerModel.getBandwidthSafetyFactor();} /**
	     * Returns the average throughput computed in the ABR logic
	     *
	     * @param {string} type
	     * @return {number} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getAverageThroughput(type){var throughputHistory=abrController.getThroughputHistory();return throughputHistory?throughputHistory.getAverageThroughput(type):0;} /**
	     * A timeout value in seconds, which during the ABRController will block switch-up events.
	     * This will only take effect after an abandoned fragment event occurs.
	     *
	     * @default 10 seconds
	     * @param {int} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setAbandonLoadTimeout(value){mediaPlayerModel.setAbandonLoadTimeout(value);} /**
	     * Total number of retry attempts that will occur on a fragment load before it fails.
	     * Increase this value to a maximum in order to achieve an automatic playback resume
	     * in case of completely lost internet connection.
	     *
	     * @default 3
	     * @param {int} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setFragmentLoaderRetryAttempts(value){mediaPlayerModel.setFragmentRetryAttempts(value);} /**
	     * Time in milliseconds of which to reload a failed fragment load attempt.
	     *
	     * @default 1000 milliseconds
	     * @param {int} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setFragmentLoaderRetryInterval(value){mediaPlayerModel.setFragmentRetryInterval(value);} /**
	     * Total number of retry attempts that will occur on a manifest load before it fails.
	     *
	     * @default 4
	     * @param {int} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setManifestLoaderRetryAttempts(value){mediaPlayerModel.setManifestRetryAttempts(value);} /**
	     * Time in milliseconds of which to reload a failed manifest load attempt.
	     *
	     * @default 1000 milliseconds
	     * @param {int} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setManifestLoaderRetryInterval(value){mediaPlayerModel.setManifestRetryInterval(value);} /**
	     * Sets whether withCredentials on XHR requests for a particular request
	     * type is true or false
	     *
	     * @default false
	     * @param {string} type - one of HTTPRequest.*_TYPE
	     * @param {boolean} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setXHRWithCredentialsForType(type,value){mediaPlayerModel.setXHRWithCredentialsForType(type,value);} /**
	     * Gets whether withCredentials on XHR requests for a particular request
	     * type is true or false
	     *
	     * @param {string} type - one of HTTPRequest.*_TYPE
	     * @return {boolean}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getXHRWithCredentialsForType(type){return mediaPlayerModel.getXHRWithCredentialsForType(type);} /**
	     * Sets whether player should jump small gaps (discontinuities) in the buffer.
	     *
	     * @param {boolean} value
	     * @default false
	     * @memberof module:MediaPlayer
	     * @instance
	     *
	     */function setJumpGaps(value){mediaPlayerModel.setJumpGaps(value);} /**
	     * Gets current status of jump gaps feature.
	     * @returns {boolean} The current jump gaps state.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getJumpGaps(){return mediaPlayerModel.getJumpGaps();} /**
	     * Time in seconds for a gap to be considered small.
	     *
	     * @param {boolean} value
	     * @default 0.8
	     * @memberof module:MediaPlayer
	     * @instance
	     *
	     */function setSmallGapLimit(value){mediaPlayerModel.setSmallGapLimit(value);} /**
	     * Time in seconds for a gap to be considered small.
	     * @returns {boolean} Current small gap limit
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getSmallGapLimit(){return mediaPlayerModel.getSmallGapLimit();} /**
	     * For live streams, set the interval-frequency in milliseconds at which
	     * dash.js will check if the current manifest is still processed before
	     * downloading the next manifest once the minimumUpdatePeriod time has
	     * expired.
	     * @param {int} value
	     * @default 100
	     * @memberof module:MediaPlayer
	     * @instance
	     * @see {@link module:MediaPlayer#getManifestUpdateRetryInterval getManifestUpdateRetryInterval()}
	     *
	     */function setManifestUpdateRetryInterval(value){mediaPlayerModel.setManifestUpdateRetryInterval(value);} /**
	     * For live streams, get the interval-frequency in milliseconds at which
	     * dash.js will check if the current manifest is still processed before
	     * downloading the next manifest once the minimumUpdatePeriod time has
	     * expired.
	     * @returns {int} Current retry delay for manifest update
	     * @memberof module:MediaPlayer
	     * @instance
	     * @see {@link module:MediaPlayer#setManifestUpdateRetryInterval setManifestUpdateRetryInterval()}
	     */function getManifestUpdateRetryInterval(){return mediaPlayerModel.getManifestUpdateRetryInterval();} /*
	    ---------------------------------------------------------------------------
	
	        METRICS
	
	    ---------------------------------------------------------------------------
	    */ /**
	     * Returns the DashMetrics.js Module. You use this Module to get access to all the public metrics
	     * stored in dash.js
	     *
	     * @see {@link module:DashMetrics}
	     * @returns {Object}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getDashMetrics(){return dashMetrics;} /**
	     *
	     * @param {string} type
	     * @returns {Object}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getMetricsFor(type){return metricsModel.getReadOnlyMetricsFor(type);} /*
	    ---------------------------------------------------------------------------
	
	        TEXT MANAGEMENT
	
	    ---------------------------------------------------------------------------
	    */ /**
	     * Set default language for text. If default language is not one of text tracks, dash will choose the first one.
	     *
	     * @param {string} lang - default language
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setTextDefaultLanguage(lang){if(textController === undefined){textController = (0,_textTextController2['default'])(context).getInstance();}textController.setTextDefaultLanguage(lang);} /**
	     * Get default language for text.
	     *
	     * @return {string} the default language if it has been set using setTextDefaultLanguage
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getTextDefaultLanguage(){if(textController === undefined){textController = (0,_textTextController2['default'])(context).getInstance();}return textController.getTextDefaultLanguage();} /**
	     * Set enabled default state.
	     * This is used to enable/disable text when a file is loaded.
	     * During playback, use enableText to enable text for the file
	     *
	     * @param {boolean} enable - true to enable text, false otherwise
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setTextDefaultEnabled(enable){if(textController === undefined){textController = (0,_textTextController2['default'])(context).getInstance();}textController.setTextDefaultEnabled(enable);} /**
	     * Get enabled default state.
	     *
	     * @return {boolean}  default enable state
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getTextDefaultEnabled(){if(textController === undefined){textController = (0,_textTextController2['default'])(context).getInstance();}return textController.getTextDefaultEnabled();} /**
	     * Enable/disable text
	     * When enabling text, dash will choose the previous selected text track
	     *
	     * @param {boolean} enable - true to enable text, false otherwise (same as setTextTrack(-1))
	     * @memberof module:MediaPlayer
	     * @instance
	     */function enableText(enable){if(textController === undefined){textController = (0,_textTextController2['default'])(context).getInstance();}textController.enableText(enable);} /**
	     * Return if text is enabled
	     *
	     * @return {boolean} return true if text is enabled, false otherwise
	     * @memberof module:MediaPlayer
	     * @instance
	     */function isTextEnabled(){if(textController === undefined){textController = (0,_textTextController2['default'])(context).getInstance();}return textController.isTextEnabled();} /**
	     * Use this method to change the current text track for both external time text files and fragmented text tracks. There is no need to
	     * set the track mode on the video object to switch a track when using this method.
	     * @param {number} idx - Index of track based on the order of the order the tracks are added Use -1 to disable all tracks. (turn captions off).  Use module:MediaPlayer#dashjs.MediaPlayer.events.TEXT_TRACK_ADDED.
	     * @see {@link MediaPlayerEvents#event:TEXT_TRACK_ADDED dashjs.MediaPlayer.events.TEXT_TRACK_ADDED}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setTextTrack(idx){if(!playbackInitialized){throw PLAYBACK_NOT_INITIALIZED_ERROR;}if(textController === undefined){textController = (0,_textTextController2['default'])(context).getInstance();}textController.setTextTrack(idx);}function getCurrentTextTrackIndex(){var idx=NaN;if(textController){idx = textController.getCurrentTrackIdx();}return idx;} /**
	     * This method serves to control captions z-index value. If 'true' is passed, the captions will have the highest z-index and be
	     * displayed on top of other html elements. Default value is 'false' (z-index is not set).
	     * @param {boolean} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function displayCaptionsOnTop(value){var textTracks=(0,_textTextTracks2['default'])(context).getInstance();textTracks.setConfig({videoModel:videoModel});textTracks.initialize();textTracks.displayCConTop(value);} /*
	    ---------------------------------------------------------------------------
	
	        VIDEO ELEMENT MANAGEMENT
	
	    ---------------------------------------------------------------------------
	    */ /**
	     * Returns instance of Video Element that was attached by calling attachView()
	     * @returns {Object}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getVideoElement(){if(!videoModel.getElement()){throw ELEMENT_NOT_ATTACHED_ERROR;}return videoModel.getElement();} /**
	     * Returns instance of Video Container that was attached by calling attachVideoContainer()
	     * @returns {Object}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getVideoContainer(){return videoModel?videoModel.getVideoContainer():null;} /**
	     * Use this method to attach an HTML5 element that wraps the video element.
	     *
	     * @param {HTMLElement} container - The HTML5 element containing the video element.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function attachVideoContainer(container){if(!videoModel.getElement()){throw ELEMENT_NOT_ATTACHED_ERROR;}videoModel.setVideoContainer(container);} /**
	     * Use this method to attach an HTML5 VideoElement for dash.js to operate upon.
	     *
	     * @param {Object} element - An HTMLMediaElement that has already been defined in the DOM (or equivalent stub).
	     * @memberof module:MediaPlayer
	     * @instance
	     */function attachView(element){if(!mediaPlayerInitialized){throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;}if(element){videoModel.setElement(element);detectProtection();detectMetricsReporting();detectMss();if(streamController){streamController.switchToVideoElement();}}if(playbackInitialized){ //Reset if we have been playing before, so this is a new element.
	resetPlaybackControllers();}initializePlayback();} /**
	     * Returns instance of Div that was attached by calling attachTTMLRenderingDiv()
	     * @returns {Object}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getTTMLRenderingDiv(){return videoModel?videoModel.getTTMLRenderingDiv():null;} /**
	     * Use this method to attach an HTML5 div for dash.js to render rich TTML subtitles.
	     *
	     * @param {HTMLDivElement} div - An unstyled div placed after the video element. It will be styled to match the video size and overlay z-order.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function attachTTMLRenderingDiv(div){if(!videoModel.getElement()){throw ELEMENT_NOT_ATTACHED_ERROR;}videoModel.setTTMLRenderingDiv(div);} /*
	    ---------------------------------------------------------------------------
	
	        STREAM AND TRACK MANAGEMENT
	
	    ---------------------------------------------------------------------------
	    */ /**
	     * @param {string} type
	     * @returns {Array}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getBitrateInfoListFor(type){if(!streamingInitialized){throw STREAMING_NOT_INITIALIZED_ERROR;}var stream=getActiveStream();return stream?stream.getBitrateListFor(type):[];} /**
	     * This method returns the list of all available streams from a given manifest
	     * @param {Object} manifest
	     * @returns {Array} list of {@link StreamInfo}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getStreamsFromManifest(manifest){if(!streamingInitialized){throw STREAMING_NOT_INITIALIZED_ERROR;}return adapter.getStreamsInfo(manifest);} /**
	     * This method returns the list of all available tracks for a given media type
	     * @param {string} type
	     * @returns {Array} list of {@link MediaInfo}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getTracksFor(type){if(!streamingInitialized){throw STREAMING_NOT_INITIALIZED_ERROR;}var streamInfo=streamController.getActiveStreamInfo();if(!streamInfo)return [];return mediaController.getTracksFor(type,streamInfo);} /**
	     * This method returns the list of all available tracks for a given media type and streamInfo from a given manifest
	     * @param {string} type
	     * @param {Object} manifest
	     * @param {Object} streamInfo
	     * @returns {Array}  list of {@link MediaInfo}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getTracksForTypeFromManifest(type,manifest,streamInfo){if(!streamingInitialized){throw STREAMING_NOT_INITIALIZED_ERROR;}streamInfo = streamInfo || adapter.getStreamsInfo(manifest,1)[0];return streamInfo?adapter.getAllMediaInfoForType(streamInfo,type,manifest):[];} /**
	     * @param {string} type
	     * @returns {Object|null} {@link MediaInfo}
	     *
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getCurrentTrackFor(type){if(!streamingInitialized){throw STREAMING_NOT_INITIALIZED_ERROR;}var streamInfo=streamController.getActiveStreamInfo();if(!streamInfo)return null;return mediaController.getCurrentTrackFor(type,streamInfo);} /**
	     * This method allows to set media settings that will be used to pick the initial track. Format of the settings
	     * is following:
	     * {lang: langValue,
	     *  viewpoint: viewpointValue,
	     *  audioChannelConfiguration: audioChannelConfigurationValue,
	     *  accessibility: accessibilityValue,
	     *  role: roleValue}
	     *
	     *
	     * @param {string} type
	     * @param {Object} value
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setInitialMediaSettingsFor(type,value){if(!mediaPlayerInitialized){throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;}mediaController.setInitialSettings(type,value);} /**
	     * This method returns media settings that is used to pick the initial track. Format of the settings
	     * is following:
	     * {lang: langValue,
	     *  viewpoint: viewpointValue,
	     *  audioChannelConfiguration: audioChannelConfigurationValue,
	     *  accessibility: accessibilityValue,
	     *  role: roleValue}
	     * @param {string} type
	     * @returns {Object}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getInitialMediaSettingsFor(type){if(!mediaPlayerInitialized){throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;}return mediaController.getInitialSettings(type);} /**
	     * @param {MediaInfo} track - instance of {@link MediaInfo}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setCurrentTrack(track){if(!streamingInitialized){throw STREAMING_NOT_INITIALIZED_ERROR;}mediaController.setTrack(track);} /**
	     * This method returns the current track switch mode.
	     *
	     * @param {string} type
	     * @returns {string} mode
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getTrackSwitchModeFor(type){if(!mediaPlayerInitialized){throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;}return mediaController.getSwitchMode(type);} /**
	     * This method sets the current track switch mode. Available options are:
	     *
	     * MediaController.TRACK_SWITCH_MODE_NEVER_REPLACE
	     * (used to forbid clearing the buffered data (prior to current playback position) after track switch. Default for video)
	     *
	     * MediaController.TRACK_SWITCH_MODE_ALWAYS_REPLACE
	     * (used to clear the buffered data (prior to current playback position) after track switch. Default for audio)
	     *
	     * @param {string} type
	     * @param {string} mode
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setTrackSwitchModeFor(type,mode){if(!mediaPlayerInitialized){throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;}mediaController.setSwitchMode(type,mode);} /**
	     * This method sets the selection mode for the initial track. This mode defines how the initial track will be selected
	     * if no initial media settings are set. If initial media settings are set this parameter will be ignored. Available options are:
	     *
	     * MediaController.TRACK_SELECTION_MODE_HIGHEST_BITRATE
	     * this mode makes the player select the track with a highest bitrate. This mode is a default mode.
	     *
	     * MediaController.TRACK_SELECTION_MODE_WIDEST_RANGE
	     * this mode makes the player select the track with a widest range of bitrates
	     *
	     * @param {string} mode
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setSelectionModeForInitialTrack(mode){if(!mediaPlayerInitialized){throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;}mediaController.setSelectionModeForInitialTrack(mode);} /**
	     * This method returns the track selection mode.
	     *
	     * @returns {string} mode
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getSelectionModeForInitialTrack(){if(!mediaPlayerInitialized){throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;}return mediaController.getSelectionModeForInitialTrack();} /*
	    ---------------------------------------------------------------------------
	
	        PROTECTION MANAGEMENT
	
	    ---------------------------------------------------------------------------
	    /**
	     * Detects if Protection is included and returns an instance of ProtectionController.js
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getProtectionController(){return detectProtection();} /**
	     * Will override dash.js protection controller.
	     * @param {ProtectionController} value - valid protection controller instance.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function attachProtectionController(value){protectionController = value;} /**
	     * Sets Protection Data required to setup the Protection Module (DRM). Protection Data must
	     * be set before initializing MediaPlayer or, once initialized, before PROTECTION_CREATED event is fired.
	     * @see {@link module:MediaPlayer#initialize initialize()}
	     * @see {@link ProtectionEvents#event:PROTECTION_CREATED dashjs.Protection.events.PROTECTION_CREATED}
	     * @param {ProtectionData} value - object containing
	     * property names corresponding to key system name strings and associated
	     * values being instances of.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function setProtectionData(value){protectionData = value; // Propagate changes in case StreamController is already created
	if(streamController){streamController.setProtectionData(protectionData);}} /*
	    ---------------------------------------------------------------------------
	
	        THUMBNAILS MANAGEMENT
	
	    ---------------------------------------------------------------------------
	    */ /**
	     * Return the thumbnail at time position.
	     * @returns {Thumbnail|null} - Thumbnail for the given time position. It returns null in case there are is not a thumbnails representation or
	     * if it doesn't contain a thumbnail for the given time position.
	     * @param {number} time - A relative time, in seconds, based on the return value of the {@link module:MediaPlayer#duration duration()} method is expected
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getThumbnail(time){if(time < 0){return null;}var s=playbackController.getIsDynamic()?getDVRSeekOffset(time):time;var stream=streamController.getStreamForTime(s);if(stream === null){return null;}var thumbnailController=stream.getThumbnailController();var streamInfo=stream.getStreamInfo();if(!thumbnailController || !streamInfo){return null;}var timeInPeriod=streamController.getTimeRelativeToStreamId(s,stream.getId());return thumbnailController.get(timeInPeriod);} /*
	    ---------------------------------------------------------------------------
	
	        TOOLS AND OTHERS FUNCTIONS
	
	    ---------------------------------------------------------------------------
	    */ /**
	     * Allows application to retrieve a manifest.  Manifest loading is asynchro
	     * nous and
	     * requires the app-provided callback function
	     *
	     * @param {string} url - url the manifest url
	     * @param {function} callback - A Callback function provided when retrieving manifests
	     * @memberof module:MediaPlayer
	     * @instance
	     */function retrieveManifest(url,callback){var manifestLoader=createManifestLoader();var self=this;var handler=function handler(e){if(!e.error){callback(e.manifest);}else {callback(null,e.error);}eventBus.off(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED,handler,self);manifestLoader.reset();};eventBus.on(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED,handler,self);var uriQueryFragModel=(0,_modelsURIQueryAndFragmentModel2['default'])(context).getInstance();uriQueryFragModel.initialize();manifestLoader.load(uriQueryFragModel.parseURI(url));} /**
	     * Returns the source string or manifest that was attached by calling attachSource()
	     * @returns {string | manifest}
	     * @memberof module:MediaPlayer
	     * @instance
	     */function getSource(){if(!source){throw SOURCE_NOT_ATTACHED_ERROR;}return source;} /**
	     * Use this method to set a source URL to a valid MPD manifest file OR
	     * a previously downloaded and parsed manifest object.  Optionally, can
	     * also provide protection information
	     *
	     * @param {string|Object} urlOrManifest - A URL to a valid MPD manifest file, or a
	     * parsed manifest object.
	     *
	     *
	     * @throws "MediaPlayer not initialized!"
	     *
	     * @memberof module:MediaPlayer
	     * @instance
	     */function attachSource(urlOrManifest){if(!mediaPlayerInitialized){throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;}if(typeof urlOrManifest === 'string'){var uriQueryFragModel=(0,_modelsURIQueryAndFragmentModel2['default'])(context).getInstance();uriQueryFragModel.initialize();source = uriQueryFragModel.parseURI(urlOrManifest);}else {source = urlOrManifest;}if(streamingInitialized || playbackInitialized){resetPlaybackControllers();}if(isReady()){initializePlayback();}} /**
	     * A utility methods which converts UTC timestamp value into a valid time and date string.
	     *
	     * @param {number} time - UTC timestamp to be converted into date and time.
	     * @param {string} locales - a region identifier (i.e. en_US).
	     * @param {boolean} hour12 - 12 vs 24 hour. Set to true for 12 hour time formatting.
	     * @param {boolean} withDate - default is false. Set to true to append current date to UTC time format.
	     * @returns {string} A formatted time and date string.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function formatUTC(time,locales,hour12){var withDate=arguments.length <= 3 || arguments[3] === undefined?false:arguments[3];var dt=new Date(time * 1000);var d=dt.toLocaleDateString(locales);var t=dt.toLocaleTimeString(locales,{hour12:hour12});return withDate?t + ' ' + d:t;} /**
	     * A utility method which converts seconds into TimeCode (i.e. 300 --> 05:00).
	     *
	     * @param {number} value - A number in seconds to be converted into a formatted time code.
	     * @returns {string} A formatted time code string.
	     * @memberof module:MediaPlayer
	     * @instance
	     */function convertToTimeCode(value){value = Math.max(value,0);var h=Math.floor(value / 3600);var m=Math.floor(value % 3600 / 60);var s=Math.floor(value % 3600 % 60);return (h === 0?'':h < 10?'0' + h.toString() + ':':h.toString() + ':') + (m < 10?'0' + m.toString():m.toString()) + ':' + (s < 10?'0' + s.toString():s.toString());} /**
	     * This method should be used to extend or replace internal dash.js objects.
	     * There are two ways to extend dash.js (determined by the override argument):
	     * <ol>
	     * <li>If you set override to true any public method or property in your custom object will
	     * override the dash.js parent object's property(ies) and will be used instead but the
	     * dash.js parent module will still be created.</li>
	     *
	     * <li>If you set override to false your object will completely replace the dash.js object.
	     * (Note: This is how it was in 1.x of Dash.js with Dijon).</li>
	     * </ol>
	     * <b>When you extend you get access to this.context, this.factory and this.parent to operate with in your custom object.</b>
	     * <ul>
	     * <li><b>this.context</b> - can be used to pass context for singleton access.</li>
	     * <li><b>this.factory</b> - can be used to call factory.getSingletonInstance().</li>
	     * <li><b>this.parent</b> - is the reference of the parent object to call other public methods. (this.parent is excluded if you extend with override set to false or option 2)</li>
	     * </ul>
	     * <b>You must call extend before you call initialize</b>
	     * @see {@link module:MediaPlayer#initialize initialize()}
	     * @param {string} parentNameString - name of parent module
	     * @param {Object} childInstance - overriding object
	     * @param {boolean} override - replace only some methods (true) or the whole object (false)
	     * @memberof module:MediaPlayer
	     * @instance
	     */function extend(parentNameString,childInstance,override){_coreFactoryMaker2['default'].extend(parentNameString,childInstance,override,context);} //***********************************
	// PRIVATE METHODS
	//***********************************
	function resetPlaybackControllers(){playbackInitialized = false;streamingInitialized = false;adapter.reset();streamController.reset();playbackController.reset();abrController.reset();mediaController.reset();textController.reset();if(protectionController){protectionController.reset();protectionController = null;detectProtection();}}function createPlaybackControllers(){ // creates or get objects instances
	var manifestLoader=createManifestLoader();if(!streamController){streamController = (0,_controllersStreamController2['default'])(context).getInstance();} // configure controllers
	mediaController.setConfig({errHandler:errHandler,domStorage:domStorage});streamController.setConfig({capabilities:capabilities,manifestLoader:manifestLoader,manifestModel:manifestModel,dashManifestModel:dashManifestModel,mediaPlayerModel:mediaPlayerModel,protectionController:protectionController,adapter:adapter,metricsModel:metricsModel,dashMetrics:dashMetrics,errHandler:errHandler,timelineConverter:timelineConverter,videoModel:videoModel,playbackController:playbackController,domStorage:domStorage,abrController:abrController,mediaController:mediaController,textController:textController});playbackController.setConfig({streamController:streamController,metricsModel:metricsModel,dashMetrics:dashMetrics,manifestModel:manifestModel,mediaPlayerModel:mediaPlayerModel,dashManifestModel:dashManifestModel,adapter:adapter,videoModel:videoModel});abrController.setConfig({streamController:streamController,domStorage:domStorage,mediaPlayerModel:mediaPlayerModel,metricsModel:metricsModel,dashMetrics:dashMetrics,dashManifestModel:dashManifestModel,manifestModel:manifestModel,videoModel:videoModel,adapter:adapter});abrController.createAbrRulesCollection();textController.setConfig({errHandler:errHandler,manifestModel:manifestModel,dashManifestModel:dashManifestModel,mediaController:mediaController,streamController:streamController,videoModel:videoModel}); // initialises controller
	streamController.initialize(autoPlay,protectionData);}function createManifestLoader(){return (0,_ManifestLoader2['default'])(context).create({errHandler:errHandler,metricsModel:metricsModel,mediaPlayerModel:mediaPlayerModel,requestModifier:(0,_utilsRequestModifier2['default'])(context).getInstance(),mssHandler:mssHandler});}function detectProtection(){if(protectionController){return protectionController;} // do not require Protection as dependencies as this is optional and intended to be loaded separately
	var Protection=dashjs.Protection; /* jshint ignore:line */if(typeof Protection === 'function'){ //TODO need a better way to register/detect plugin components
	var protection=Protection(context).create();_coreEventsEvents2['default'].extend(Protection.events);_MediaPlayerEvents2['default'].extend(Protection.events,{publicOnly:true});if(!capabilities){capabilities = (0,_utilsCapabilities2['default'])(context).getInstance();}protectionController = protection.createProtectionSystem({log:log,errHandler:errHandler,videoModel:videoModel,capabilities:capabilities,eventBus:eventBus,events:_coreEventsEvents2['default'],BASE64:_externalsBase642['default'],constants:_constantsConstants2['default']});return protectionController;}return null;}function detectMetricsReporting(){if(metricsReportingController){return;} // do not require MetricsReporting as dependencies as this is optional and intended to be loaded separately
	var MetricsReporting=dashjs.MetricsReporting; /* jshint ignore:line */if(typeof MetricsReporting === 'function'){ //TODO need a better way to register/detect plugin components
	var metricsReporting=MetricsReporting(context).create();metricsReportingController = metricsReporting.createMetricsReporting({log:log,eventBus:eventBus,mediaElement:getVideoElement(),dashManifestModel:dashManifestModel,metricsModel:metricsModel,events:_coreEventsEvents2['default'],constants:_constantsConstants2['default'],metricsConstants:_constantsMetricsConstants2['default']});}}function detectMss(){if(mssHandler){return;} // do not require MssHandler as dependencies as this is optional and intended to be loaded separately
	var MssHandler=dashjs.MssHandler; /* jshint ignore:line */if(typeof MssHandler === 'function'){ //TODO need a better way to register/detect plugin components
	mssHandler = MssHandler(context).create({eventBus:eventBus,mediaPlayerModel:mediaPlayerModel,metricsModel:metricsModel,playbackController:playbackController,protectionController:protectionController,errHandler:errHandler,events:_coreEventsEvents2['default'],constants:_constantsConstants2['default'],log:log,initSegmentType:_voMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE,BASE64:_externalsBase642['default'],ISOBoxer:_codemIsoboxer2['default']});}}function getDVRInfoMetric(){var metric=metricsModel.getReadOnlyMetricsFor(_constantsConstants2['default'].VIDEO) || metricsModel.getReadOnlyMetricsFor(_constantsConstants2['default'].AUDIO);return dashMetrics.getCurrentDVRInfo(metric);}function getAsUTC(valToConvert){var metric=getDVRInfoMetric();var availableFrom=undefined,utcValue=undefined;if(!metric){return 0;}availableFrom = metric.manifestInfo.availableFrom.getTime() / 1000;utcValue = valToConvert + (availableFrom + metric.range.start);return utcValue;}function getActiveStream(){if(!streamingInitialized){throw STREAMING_NOT_INITIALIZED_ERROR;}var streamInfo=streamController.getActiveStreamInfo();return streamInfo?streamController.getStreamById(streamInfo.id):null;}function initializePlayback(){if(!streamingInitialized && source){streamingInitialized = true;log('Streaming Initialized');createPlaybackControllers();if(typeof source === 'string'){streamController.load(source);}else {streamController.loadWithManifest(source);}}if(!playbackInitialized && isReady()){playbackInitialized = true;log('Playback Initialized');}}instance = {initialize:initialize,setConfig:setConfig,on:on,off:off,extend:extend,attachView:attachView,attachSource:attachSource,isReady:isReady,preload:preload,play:play,isPaused:isPaused,pause:pause,isSeeking:isSeeking,isDynamic:isDynamic,seek:seek,setPlaybackRate:setPlaybackRate,getPlaybackRate:getPlaybackRate,setMute:setMute,isMuted:isMuted,setVolume:setVolume,getVolume:getVolume,time:time,duration:duration,timeAsUTC:timeAsUTC,durationAsUTC:durationAsUTC,getActiveStream:getActiveStream,getDVRWindowSize:getDVRWindowSize,getDVRSeekOffset:getDVRSeekOffset,convertToTimeCode:convertToTimeCode,formatUTC:formatUTC,getVersion:getVersion,getDebug:getDebug,getBufferLength:getBufferLength,getVideoContainer:getVideoContainer,getTTMLRenderingDiv:getTTMLRenderingDiv,getVideoElement:getVideoElement,getSource:getSource,setLiveDelayFragmentCount:setLiveDelayFragmentCount,setLiveDelay:setLiveDelay,getLiveDelay:getLiveDelay,getCurrentLiveLatency:getCurrentLiveLatency,useSuggestedPresentationDelay:useSuggestedPresentationDelay,enableLastBitrateCaching:enableLastBitrateCaching,enableLastMediaSettingsCaching:enableLastMediaSettingsCaching,setMaxAllowedBitrateFor:setMaxAllowedBitrateFor,getMaxAllowedBitrateFor:getMaxAllowedBitrateFor,setMinAllowedBitrateFor:setMinAllowedBitrateFor,getMinAllowedBitrateFor:getMinAllowedBitrateFor,setMaxAllowedRepresentationRatioFor:setMaxAllowedRepresentationRatioFor,getMaxAllowedRepresentationRatioFor:getMaxAllowedRepresentationRatioFor,setAutoPlay:setAutoPlay,getAutoPlay:getAutoPlay,setScheduleWhilePaused:setScheduleWhilePaused,getScheduleWhilePaused:getScheduleWhilePaused,getDashMetrics:getDashMetrics,getMetricsFor:getMetricsFor,getQualityFor:getQualityFor,setQualityFor:setQualityFor,updatePortalSize:updatePortalSize,getLimitBitrateByPortal:getLimitBitrateByPortal,setLimitBitrateByPortal:setLimitBitrateByPortal,getUsePixelRatioInLimitBitrateByPortal:getUsePixelRatioInLimitBitrateByPortal,setUsePixelRatioInLimitBitrateByPortal:setUsePixelRatioInLimitBitrateByPortal,setTextDefaultLanguage:setTextDefaultLanguage,getTextDefaultLanguage:getTextDefaultLanguage,setTextDefaultEnabled:setTextDefaultEnabled,getTextDefaultEnabled:getTextDefaultEnabled,enableText:enableText,isTextEnabled:isTextEnabled,setTextTrack:setTextTrack,getBitrateInfoListFor:getBitrateInfoListFor,setInitialBitrateFor:setInitialBitrateFor,getInitialBitrateFor:getInitialBitrateFor,setInitialRepresentationRatioFor:setInitialRepresentationRatioFor,getInitialRepresentationRatioFor:getInitialRepresentationRatioFor,getStreamsFromManifest:getStreamsFromManifest,getTracksFor:getTracksFor,getTracksForTypeFromManifest:getTracksForTypeFromManifest,getCurrentTrackFor:getCurrentTrackFor,setInitialMediaSettingsFor:setInitialMediaSettingsFor,getInitialMediaSettingsFor:getInitialMediaSettingsFor,setCurrentTrack:setCurrentTrack,getTrackSwitchModeFor:getTrackSwitchModeFor,setTrackSwitchModeFor:setTrackSwitchModeFor,setSelectionModeForInitialTrack:setSelectionModeForInitialTrack,getSelectionModeForInitialTrack:getSelectionModeForInitialTrack,setFastSwitchEnabled:setFastSwitchEnabled,getFastSwitchEnabled:getFastSwitchEnabled,setMovingAverageMethod:setMovingAverageMethod,getMovingAverageMethod:getMovingAverageMethod,getAutoSwitchQualityFor:getAutoSwitchQualityFor,setAutoSwitchQualityFor:setAutoSwitchQualityFor,setABRStrategy:setABRStrategy,getABRStrategy:getABRStrategy,useDefaultABRRules:useDefaultABRRules,addABRCustomRule:addABRCustomRule,removeABRCustomRule:removeABRCustomRule,removeAllABRCustomRule:removeAllABRCustomRule,setBandwidthSafetyFactor:setBandwidthSafetyFactor,getBandwidthSafetyFactor:getBandwidthSafetyFactor,getAverageThroughput:getAverageThroughput,setAbandonLoadTimeout:setAbandonLoadTimeout,retrieveManifest:retrieveManifest,addUTCTimingSource:addUTCTimingSource,removeUTCTimingSource:removeUTCTimingSource,clearDefaultUTCTimingSources:clearDefaultUTCTimingSources,restoreDefaultUTCTimingSources:restoreDefaultUTCTimingSources,setBufferToKeep:setBufferToKeep,setBufferAheadToKeep:setBufferAheadToKeep,setBufferPruningInterval:setBufferPruningInterval,setStableBufferTime:setStableBufferTime,getStableBufferTime:getStableBufferTime,setBufferTimeAtTopQuality:setBufferTimeAtTopQuality,getBufferTimeAtTopQuality:getBufferTimeAtTopQuality,setBufferTimeAtTopQualityLongForm:setBufferTimeAtTopQualityLongForm,getBufferTimeAtTopQualityLongForm:getBufferTimeAtTopQualityLongForm,setFragmentLoaderRetryAttempts:setFragmentLoaderRetryAttempts,setFragmentLoaderRetryInterval:setFragmentLoaderRetryInterval,setManifestLoaderRetryAttempts:setManifestLoaderRetryAttempts,setManifestLoaderRetryInterval:setManifestLoaderRetryInterval,setXHRWithCredentialsForType:setXHRWithCredentialsForType,getXHRWithCredentialsForType:getXHRWithCredentialsForType,setJumpGaps:setJumpGaps,getJumpGaps:getJumpGaps,setSmallGapLimit:setSmallGapLimit,getSmallGapLimit:getSmallGapLimit,getLowLatencyEnabled:getLowLatencyEnabled,setLowLatencyEnabled:setLowLatencyEnabled,setManifestUpdateRetryInterval:setManifestUpdateRetryInterval,getManifestUpdateRetryInterval:getManifestUpdateRetryInterval,setLongFormContentDurationThreshold:setLongFormContentDurationThreshold,setSegmentOverlapToleranceTime:setSegmentOverlapToleranceTime,setCacheLoadThresholdForType:setCacheLoadThresholdForType,getProtectionController:getProtectionController,attachProtectionController:attachProtectionController,setProtectionData:setProtectionData,enableManifestDateHeaderTimeSource:enableManifestDateHeaderTimeSource,displayCaptionsOnTop:displayCaptionsOnTop,attachVideoContainer:attachVideoContainer,attachTTMLRenderingDiv:attachTTMLRenderingDiv,getCurrentTextTrackIndex:getCurrentTextTrackIndex,getUseDeadTimeLatencyForAbr:getUseDeadTimeLatencyForAbr,setUseDeadTimeLatencyForAbr:setUseDeadTimeLatencyForAbr,getThumbnail:getThumbnail,reset:reset};setup();return instance;}MediaPlayer.__dashjs_factory_name = 'MediaPlayer';var factory=_coreFactoryMaker2['default'].getClassFactory(MediaPlayer);factory.events = _MediaPlayerEvents2['default'];_coreFactoryMaker2['default'].updateClassFactory(MediaPlayer.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=MediaPlayer.js.map


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _coreEventsEventsBase=__webpack_require__(62);var _coreEventsEventsBase2=_interopRequireDefault(_coreEventsEventsBase); /**
	 * @class
	 *
	 */var MediaPlayerEvents=(function(_EventsBase){_inherits(MediaPlayerEvents,_EventsBase); /**
	     * @description Public facing external events to be used when developing a player that implements dash.js.
	     */function MediaPlayerEvents(){_classCallCheck(this,MediaPlayerEvents);_get(Object.getPrototypeOf(MediaPlayerEvents.prototype),'constructor',this).call(this); /**
	         * Triggered when playback will not start yet
	         * as the MPD's availabilityStartTime is in the future.
	         * Check delay property in payload to determine time before playback will start.
	         */this.AST_IN_FUTURE = 'astInFuture'; /**
	         * Triggered when the video element's buffer state changes to stalled.
	         * Check mediaType in payload to determine type (Video, Audio, FragmentedText).
	         * @event MediaPlayerEvents#BUFFER_EMPTY
	         */this.BUFFER_EMPTY = 'bufferStalled'; /**
	         * Triggered when the video element's buffer state changes to loaded.
	         * Check mediaType in payload to determine type (Video, Audio, FragmentedText).
	         * @event MediaPlayerEvents#BUFFER_LOADED
	         */this.BUFFER_LOADED = 'bufferLoaded'; /**
	         * Triggered when the video element's buffer state changes, either stalled or loaded. Check payload for state.
	         * @event MediaPlayerEvents#BUFFER_LEVEL_STATE_CHANGED
	         */this.BUFFER_LEVEL_STATE_CHANGED = 'bufferStateChanged'; /**
	         * Triggered when there is an error from the element or MSE source buffer.
	         * @event MediaPlayerEvents#ERROR
	         */this.ERROR = 'error'; /**
	         * Triggered when a fragment download has completed.
	         * @event MediaPlayerEvents#FRAGMENT_LOADING_COMPLETED
	         */this.FRAGMENT_LOADING_COMPLETED = 'fragmentLoadingCompleted'; /**
	         * Triggered when a partial fragment download has completed.
	         * @event MediaPlayerEvents#FRAGMENT_LOADING_PROGRESS
	         */this.FRAGMENT_LOADING_PROGRESS = 'fragmentLoadingProgress'; /**
	         * Triggered when a fragment download has started.
	         * @event MediaPlayerEvents#FRAGMENT_LOADING_STARTED
	         */this.FRAGMENT_LOADING_STARTED = 'fragmentLoadingStarted'; /**
	         * Triggered when a fragment download is abandoned due to detection of slow download base on the ABR abandon rule..
	         * @event MediaPlayerEvents#FRAGMENT_LOADING_ABANDONED
	         */this.FRAGMENT_LOADING_ABANDONED = 'fragmentLoadingAbandoned'; /**
	         * Triggered when {@link module:Debug} log method is called.
	         * @event MediaPlayerEvents#LOG
	         */this.LOG = 'log'; //TODO refactor with internal event
	/**
	         * Triggered when the manifest load is complete
	         * @event MediaPlayerEvents#MANIFEST_LOADED
	         */this.MANIFEST_LOADED = 'manifestLoaded'; /**
	         * Triggered anytime there is a change to the overall metrics.
	         * @event MediaPlayerEvents#METRICS_CHANGED
	         */this.METRICS_CHANGED = 'metricsChanged'; /**
	         * Triggered when an individual metric is added, updated or cleared.
	         * @event MediaPlayerEvents#METRIC_CHANGED
	         */this.METRIC_CHANGED = 'metricChanged'; /**
	         * Triggered every time a new metric is added.
	         * @event MediaPlayerEvents#METRIC_ADDED
	         */this.METRIC_ADDED = 'metricAdded'; /**
	         * Triggered every time a metric is updated.
	         * @event MediaPlayerEvents#METRIC_UPDATED
	         */this.METRIC_UPDATED = 'metricUpdated'; /**
	         * Triggered at the stream end of a period.
	         * @event MediaPlayerEvents#PERIOD_SWITCH_COMPLETED
	         */this.PERIOD_SWITCH_COMPLETED = 'periodSwitchCompleted'; /**
	         * Triggered when a new period starts.
	         * @event MediaPlayerEvents#PERIOD_SWITCH_STARTED
	         */this.PERIOD_SWITCH_STARTED = 'periodSwitchStarted'; /**
	         * Triggered when an ABR up /down switch is initiated; either by user in manual mode or auto mode via ABR rules.
	         * @event MediaPlayerEvents#QUALITY_CHANGE_REQUESTED
	         */this.QUALITY_CHANGE_REQUESTED = 'qualityChangeRequested'; /**
	         * Triggered when the new ABR quality is being rendered on-screen.
	         * @event MediaPlayerEvents#QUALITY_CHANGE_RENDERED
	         */this.QUALITY_CHANGE_RENDERED = 'qualityChangeRendered'; /**
	         * Triggered when the new track is being rendered.
	         * @event MediaPlayerEvents#TRACK_CHANGE_RENDERED
	         */this.TRACK_CHANGE_RENDERED = 'trackChangeRendered'; /**
	         * Triggered when the source is setup and ready.
	         * @event MediaPlayerEvents#SOURCE_INITIALIZED
	         */this.SOURCE_INITIALIZED = 'sourceInitialized'; /**
	         * Triggered when a stream (period) is loaded
	         * @event MediaPlayerEvents#STREAM_INITIALIZED
	         */this.STREAM_INITIALIZED = 'streamInitialized'; /**
	         * Triggered when the player has been reset.
	         * @event MediaPlayerEvents#STREAM_TEARDOWN_COMPLETE
	         */this.STREAM_TEARDOWN_COMPLETE = 'streamTeardownComplete'; /**
	         * Triggered once all text tracks detected in the MPD are added to the video element.
	         * @event MediaPlayerEvents#TEXT_TRACKS_ADDED
	         */this.TEXT_TRACKS_ADDED = 'allTextTracksAdded'; /**
	         * Triggered when a text track is added to the video element's TextTrackList
	         * @event MediaPlayerEvents#TEXT_TRACK_ADDED
	         */this.TEXT_TRACK_ADDED = 'textTrackAdded'; /**
	         * Triggered when a ttml chunk is parsed.
	         * @event MediaPlayerEvents#TTML_PARSED
	         */this.TTML_PARSED = 'ttmlParsed'; /**
	         * Triggered when a ttml chunk has to be parsed.
	         * @event MediaPlayerEvents#TTML_PARSED
	         */this.TTML_TO_PARSE = 'ttmlToParse'; /**
	         * Sent when enough data is available that the media can be played,
	         * at least for a couple of frames.  This corresponds to the
	         * HAVE_ENOUGH_DATA readyState.
	         * @event MediaPlayerEvents#CAN_PLAY
	         */this.CAN_PLAY = 'canPlay'; /**
	         * Sent when playback completes.
	         * @event MediaPlayerEvents#PLAYBACK_ENDED
	         */this.PLAYBACK_ENDED = 'playbackEnded'; /**
	         * Sent when an error occurs.  The element's error
	         * attribute contains more information.
	         * @event MediaPlayerEvents#PLAYBACK_ERROR
	         */this.PLAYBACK_ERROR = 'playbackError'; /**
	         * Sent when playback is not allowed (for example if user gesture is needed).
	         * @event MediaPlayerEvents#PLAYBACK_NOT_ALLOWED
	         */this.PLAYBACK_NOT_ALLOWED = 'playbackNotAllowed'; /**
	         * The media's metadata has finished loading; all attributes now
	         * contain as much useful information as they're going to.
	         * @event MediaPlayerEvents#PLAYBACK_METADATA_LOADED
	         */this.PLAYBACK_METADATA_LOADED = 'playbackMetaDataLoaded'; /**
	         * Sent when playback is paused.
	         * @event MediaPlayerEvents#PLAYBACK_PAUSED
	         */this.PLAYBACK_PAUSED = 'playbackPaused'; /**
	         * Sent when the media begins to play (either for the first time, after having been paused,
	         * or after ending and then restarting).
	         *
	         * @event MediaPlayerEvents#PLAYBACK_PLAYING
	         */this.PLAYBACK_PLAYING = 'playbackPlaying'; /**
	         * Sent periodically to inform interested parties of progress downloading
	         * the media. Information about the current amount of the media that has
	         * been downloaded is available in the media element's buffered attribute.
	         * @event MediaPlayerEvents#PLAYBACK_PROGRESS
	         */this.PLAYBACK_PROGRESS = 'playbackProgress'; /**
	         * Sent when the playback speed changes.
	         * @event MediaPlayerEvents#PLAYBACK_RATE_CHANGED
	         */this.PLAYBACK_RATE_CHANGED = 'playbackRateChanged'; /**
	         * Sent when a seek operation completes.
	         * @event MediaPlayerEvents#PLAYBACK_SEEKED
	         */this.PLAYBACK_SEEKED = 'playbackSeeked'; /**
	         * Sent when a seek operation begins.
	         * @event MediaPlayerEvents#PLAYBACK_SEEKING
	         */this.PLAYBACK_SEEKING = 'playbackSeeking'; /**
	         * Sent when a seek operation has been asked.
	         * @event MediaPlayerEvents#PLAYBACK_SEEK_ASKED
	         */this.PLAYBACK_SEEK_ASKED = 'playbackSeekAsked'; /**
	         * Sent when playback of the media starts after having been paused;
	         * that is, when playback is resumed after a prior pause event.
	         *
	         * @event MediaPlayerEvents#PLAYBACK_STARTED
	         */this.PLAYBACK_STARTED = 'playbackStarted'; /**
	         * The time indicated by the element's currentTime attribute has changed.
	         * @event MediaPlayerEvents#PLAYBACK_TIME_UPDATED
	         */this.PLAYBACK_TIME_UPDATED = 'playbackTimeUpdated'; /**
	         * Sent when the media playback has stopped because of a temporary lack of data.
	         *
	         * @event MediaPlayerEvents#PLAYBACK_WAITING
	         */this.PLAYBACK_WAITING = 'playbackWaiting'; /**
	         * Manifest validity changed - As a result of an MPD validity expiration event.
	         * @event MediaPlayerEvents#MANIFEST_VALIDITY_CHANGED
	         */this.MANIFEST_VALIDITY_CHANGED = 'manifestValidityChanged';}return MediaPlayerEvents;})(_coreEventsEventsBase2['default']);var mediaPlayerEvents=new MediaPlayerEvents();exports['default'] = mediaPlayerEvents;module.exports = exports['default'];
	//# sourceMappingURL=MediaPlayerEvents.js.map


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _voDashJSError=__webpack_require__(31);var _voDashJSError2=_interopRequireDefault(_voDashJSError);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _textTextController=__webpack_require__(95);var _textTextController2=_interopRequireDefault(_textTextController); /**
	 * @class SourceBufferSink
	 * @implements FragmentSink
	 */function SourceBufferSink(mediaSource,mediaInfo,onAppendedCallback){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var buffer=undefined,isAppendingInProgress=undefined;var appendQueue=[];var onAppended=onAppendedCallback;function setup(){isAppendingInProgress = false;var codec=mediaInfo.codec;try{ // Safari claims to support anything starting 'application/mp4'.
	// it definitely doesn't understand 'application/mp4;codecs="stpp"'
	// - currently no browser does, so check for it and use our own
	// implementation. The same is true for codecs="wvtt".
	if(codec.match(/application\/mp4;\s*codecs="(stpp|wvtt).*"/i)){throw new Error('not really supported');}buffer = mediaSource.addSourceBuffer(codec);}catch(ex) { // Note that in the following, the quotes are open to allow for extra text after stpp and wvtt
	if(mediaInfo.isText || codec.indexOf('codecs="stpp') !== -1 || codec.indexOf('codecs="wvtt') !== -1){var textController=(0,_textTextController2['default'])(context).getInstance();buffer = textController.getTextSourceBuffer();}else {throw ex;}}}function reset(){if(buffer){try{mediaSource.removeSourceBuffer(buffer);}catch(e) {log('Failed to remove source buffer from media source.');}isAppendingInProgress = false;buffer = null;}appendQueue = [];onAppended = null;}function getBuffer(){return buffer;}function getAllBufferRanges(){return buffer.buffered;}function append(chunk){appendQueue.push(chunk);if(!isAppendingInProgress){waitForUpdateEnd(buffer,appendNextInQueue.bind(this));}}function remove(start,end,forceRemoval){var sourceBufferSink=this; // make sure that the given time range is correct. Otherwise we will get InvalidAccessError
	waitForUpdateEnd(buffer,function(){try{if(start >= 0 && end > start && (forceRemoval || mediaSource.readyState !== 'ended')){buffer.remove(start,end);} // updating is in progress, we should wait for it to complete before signaling that this operation is done
	waitForUpdateEnd(buffer,function(){eventBus.trigger(_coreEventsEvents2['default'].SOURCEBUFFER_REMOVE_COMPLETED,{buffer:sourceBufferSink,from:start,to:end});});}catch(err) {eventBus.trigger(_coreEventsEvents2['default'].SOURCEBUFFER_REMOVE_COMPLETED,{buffer:sourceBufferSink,from:start,to:end,error:new _voDashJSError2['default'](err.code,err.message,null)});}});}function appendNextInQueue(){var _this=this;if(appendQueue.length > 0){(function(){isAppendingInProgress = true;var nextChunk=appendQueue[0];appendQueue.splice(0,1);var afterSuccess=function afterSuccess(){if(appendQueue.length > 0){appendNextInQueue.call(this);}else {isAppendingInProgress = false;if(onAppended){onAppended({chunk:nextChunk});}}};try{if(nextChunk.bytes.length === 0){afterSuccess.call(_this);}else {if(buffer.appendBuffer){buffer.appendBuffer(nextChunk.bytes);}else {buffer.append(nextChunk.bytes,nextChunk);} // updating is in progress, we should wait for it to complete before signaling that this operation is done
	waitForUpdateEnd(buffer,afterSuccess.bind(_this));}}catch(err) {log('SourceBuffer append failed "' + err + '"');if(appendQueue.length > 0){appendNextInQueue();}else {isAppendingInProgress = false;}if(onAppended){onAppended({chunk:nextChunk,error:new _voDashJSError2['default'](err.code,err.message,null)});}}})();}}function abort(){try{if(mediaSource.readyState === 'open'){buffer.abort();}else if(buffer.setTextTrack && mediaSource.readyState === 'ended'){buffer.abort(); //The cues need to be removed from the TextSourceBuffer via a call to abort()
	}}catch(ex) {log('SourceBuffer append abort failed: "' + ex + '"');}appendQueue = [];}function waitForUpdateEnd(buffer,callback){var intervalId=undefined;var CHECK_INTERVAL=50;var checkIsUpdateEnded=function checkIsUpdateEnded(){ // if updating is still in progress do nothing and wait for the next check again.
	if(buffer.updating)return; // updating is completed, now we can stop checking and resolve the promise
	clearInterval(intervalId);callback();};var updateEndHandler=function updateEndHandler(){if(buffer.updating)return;buffer.removeEventListener('updateend',updateEndHandler,false);callback();};if(!buffer.updating){callback();return;} // use updateend event if possible
	if(typeof buffer.addEventListener === 'function'){try{buffer.addEventListener('updateend',updateEndHandler,false);}catch(err) { // use setInterval to periodically check if updating has been completed
	intervalId = setInterval(checkIsUpdateEnded,CHECK_INTERVAL);}}else { // use setInterval to periodically check if updating has been completed
	intervalId = setInterval(checkIsUpdateEnded,CHECK_INTERVAL);}}var instance={getAllBufferRanges:getAllBufferRanges,getBuffer:getBuffer,append:append,remove:remove,abort:abort,reset:reset};setup();return instance;}SourceBufferSink.__dashjs_factory_name = 'SourceBufferSink';var factory=_coreFactoryMaker2['default'].getClassFactory(SourceBufferSink);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=SourceBufferSink.js.map


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _handlersBufferLevelHandler=__webpack_require__(354);var _handlersBufferLevelHandler2=_interopRequireDefault(_handlersBufferLevelHandler);var _handlersDVBErrorsHandler=__webpack_require__(355);var _handlersDVBErrorsHandler2=_interopRequireDefault(_handlersDVBErrorsHandler);var _handlersHttpListHandler=__webpack_require__(357);var _handlersHttpListHandler2=_interopRequireDefault(_handlersHttpListHandler);var _handlersGenericMetricHandler=__webpack_require__(356);var _handlersGenericMetricHandler2=_interopRequireDefault(_handlersGenericMetricHandler);function MetricsHandlerFactory(config){config = config || {};var instance=undefined;var log=config.log; // group 1: key, [group 3: n [, group 5: type]]
	var keyRegex=/([a-zA-Z]*)(\(([0-9]*)(\,\s*([a-zA-Z]*))?\))?/;var context=this.context;var knownFactoryProducts={BufferLevel:_handlersBufferLevelHandler2['default'],DVBErrors:_handlersDVBErrorsHandler2['default'],HttpList:_handlersHttpListHandler2['default'],PlayList:_handlersGenericMetricHandler2['default'],RepSwitchList:_handlersGenericMetricHandler2['default'],TcpList:_handlersGenericMetricHandler2['default']};function create(listType,reportingController){var matches=listType.match(keyRegex);var handler;if(!matches){return;}try{handler = knownFactoryProducts[matches[1]](context).create({eventBus:config.eventBus,metricsConstants:config.metricsConstants});handler.initialize(matches[1],reportingController,matches[3],matches[5]);}catch(e) {handler = null;log('MetricsHandlerFactory: Could not create handler for type ' + matches[1] + ' with args ' + matches[3] + ', ' + matches[5] + ' (' + e.message + ')');}return handler;}function register(key,handler){knownFactoryProducts[key] = handler;}function unregister(key){delete knownFactoryProducts[key];}instance = {create:create,register:register,unregister:unregister};return instance;}MetricsHandlerFactory.__dashjs_factory_name = 'MetricsHandlerFactory';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(MetricsHandlerFactory); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=MetricsHandlerFactory.js.map


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _reportersDVBReporting=__webpack_require__(358);var _reportersDVBReporting2=_interopRequireDefault(_reportersDVBReporting);function ReportingFactory(config){config = config || {};var knownReportingSchemeIdUris={'urn:dvb:dash:reporting:2014':_reportersDVBReporting2['default']};var context=this.context;var log=config.log;var metricsConstants=config.metricsConstants;var instance=undefined;function create(entry,rangeController){var reporting=undefined;try{reporting = knownReportingSchemeIdUris[entry.schemeIdUri](context).create({metricsConstants:metricsConstants});reporting.initialize(entry,rangeController);}catch(e) {reporting = null;log('ReportingFactory: could not create Reporting with schemeIdUri ' + entry.schemeIdUri + ' (' + e.message + ')');}return reporting;}function register(schemeIdUri,moduleName){knownReportingSchemeIdUris[schemeIdUri] = moduleName;}function unregister(schemeIdUri){delete knownReportingSchemeIdUris[schemeIdUri];}instance = {create:create,register:register,unregister:unregister};return instance;}ReportingFactory.__dashjs_factory_name = 'ReportingFactory';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(ReportingFactory); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=ReportingFactory.js.map


/***/ },
/* 148 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function HandlerHelpers(){return {reconstructFullMetricName:function reconstructFullMetricName(key,n,type){var mn=key;if(n){mn += '(' + n;if(type && type.length){mn += ',' + type;}mn += ')';}return mn;},validateN:function validateN(n_ms){if(!n_ms){throw new Error('missing n');}if(isNaN(n_ms)){throw new Error('n is NaN');} // n is a positive integer is defined to refer to the metric
	// in which the buffer level is recorded every n ms.
	if(n_ms < 0){throw new Error('n must be positive');}return n_ms;}};}HandlerHelpers.__dashjs_factory_name = 'HandlerHelpers';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(HandlerHelpers); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=HandlerHelpers.js.map


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key] = value;}return obj;}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _voMetricsHTTPRequest=__webpack_require__(16);var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var DEFAULT_UTC_TIMING_SOURCE={scheme:'urn:mpeg:dash:utc:http-xsdate:2014',value:'http://time.akamai.com/?iso'};var LIVE_DELAY_FRAGMENT_COUNT=4;var DEFAULT_LOCAL_STORAGE_BITRATE_EXPIRATION=360000;var DEFAULT_LOCAL_STORAGE_MEDIA_SETTINGS_EXPIRATION=360000;var BANDWIDTH_SAFETY_FACTOR=0.9;var ABANDON_LOAD_TIMEOUT=10000;var BUFFER_TO_KEEP=20;var BUFFER_AHEAD_TO_KEEP=80;var BUFFER_PRUNING_INTERVAL=10;var DEFAULT_MIN_BUFFER_TIME=12;var DEFAULT_MIN_BUFFER_TIME_FAST_SWITCH=20;var BUFFER_TIME_AT_TOP_QUALITY=30;var BUFFER_TIME_AT_TOP_QUALITY_LONG_FORM=60;var LONG_FORM_CONTENT_DURATION_THRESHOLD=600;var SEGMENT_OVERLAP_TOLERANCE_TIME=0.2;var SMALL_GAP_LIMIT=0.8;var MANIFEST_UPDATE_RETRY_INTERVAL=100;var CACHE_LOAD_THRESHOLD_VIDEO=50;var CACHE_LOAD_THRESHOLD_AUDIO=5;var FRAGMENT_RETRY_ATTEMPTS=3;var FRAGMENT_RETRY_INTERVAL=1000;var MANIFEST_RETRY_ATTEMPTS=3;var MANIFEST_RETRY_INTERVAL=500;var XLINK_RETRY_ATTEMPTS=1;var XLINK_RETRY_INTERVAL=500;var DEFAULT_LOW_LATENCY_LIVE_DELAY=3; //This value influences the startup time for live (in ms).
	var WALLCLOCK_TIME_UPDATE_INTERVAL=50;var DEFAULT_XHR_WITH_CREDENTIALS=false;function MediaPlayerModel(){var instance=undefined,useManifestDateHeaderTimeSource=undefined,useSuggestedPresentationDelay=undefined,UTCTimingSources=undefined,liveDelayFragmentCount=undefined,liveDelay=undefined,scheduleWhilePaused=undefined,bufferToKeep=undefined,bufferAheadToKeep=undefined,bufferPruningInterval=undefined,lastBitrateCachingInfo=undefined,lastMediaSettingsCachingInfo=undefined,stableBufferTime=undefined,bufferTimeAtTopQuality=undefined,bufferTimeAtTopQualityLongForm=undefined,longFormContentDurationThreshold=undefined,segmentOverlapToleranceTime=undefined,bandwidthSafetyFactor=undefined,abandonLoadTimeout=undefined,retryAttempts=undefined,retryIntervals=undefined,wallclockTimeUpdateInterval=undefined,ABRStrategy=undefined,useDefaultABRRules=undefined,xhrWithCredentials=undefined,fastSwitchEnabled=undefined,customABRRule=undefined,movingAverageMethod=undefined,cacheLoadThresholds=undefined,jumpGaps=undefined,smallGapLimit=undefined,lowLatencyEnabled=undefined,manifestUpdateRetryInterval=undefined;function setup(){var _retryAttempts,_retryIntervals;UTCTimingSources = [];useSuggestedPresentationDelay = false;useManifestDateHeaderTimeSource = true;scheduleWhilePaused = true;ABRStrategy = _constantsConstants2['default'].ABR_STRATEGY_DYNAMIC;useDefaultABRRules = true;fastSwitchEnabled = false;lastBitrateCachingInfo = {enabled:true,ttl:DEFAULT_LOCAL_STORAGE_BITRATE_EXPIRATION};lastMediaSettingsCachingInfo = {enabled:true,ttl:DEFAULT_LOCAL_STORAGE_MEDIA_SETTINGS_EXPIRATION};liveDelayFragmentCount = LIVE_DELAY_FRAGMENT_COUNT;liveDelay = undefined; // Explicitly state that default is undefined
	bufferToKeep = BUFFER_TO_KEEP;bufferAheadToKeep = BUFFER_AHEAD_TO_KEEP;bufferPruningInterval = BUFFER_PRUNING_INTERVAL;stableBufferTime = NaN;bufferTimeAtTopQuality = BUFFER_TIME_AT_TOP_QUALITY;bufferTimeAtTopQualityLongForm = BUFFER_TIME_AT_TOP_QUALITY_LONG_FORM;longFormContentDurationThreshold = LONG_FORM_CONTENT_DURATION_THRESHOLD;segmentOverlapToleranceTime = SEGMENT_OVERLAP_TOLERANCE_TIME;bandwidthSafetyFactor = BANDWIDTH_SAFETY_FACTOR;abandonLoadTimeout = ABANDON_LOAD_TIMEOUT;wallclockTimeUpdateInterval = WALLCLOCK_TIME_UPDATE_INTERVAL;jumpGaps = false;smallGapLimit = SMALL_GAP_LIMIT;manifestUpdateRetryInterval = MANIFEST_UPDATE_RETRY_INTERVAL;xhrWithCredentials = {'default':DEFAULT_XHR_WITH_CREDENTIALS};customABRRule = [];movingAverageMethod = _constantsConstants2['default'].MOVING_AVERAGE_SLIDING_WINDOW;lowLatencyEnabled = false;retryAttempts = (_retryAttempts = {},_defineProperty(_retryAttempts,_voMetricsHTTPRequest.HTTPRequest.MPD_TYPE,MANIFEST_RETRY_ATTEMPTS),_defineProperty(_retryAttempts,_voMetricsHTTPRequest.HTTPRequest.XLINK_EXPANSION_TYPE,XLINK_RETRY_ATTEMPTS),_defineProperty(_retryAttempts,_voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE,FRAGMENT_RETRY_ATTEMPTS),_defineProperty(_retryAttempts,_voMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE,FRAGMENT_RETRY_ATTEMPTS),_defineProperty(_retryAttempts,_voMetricsHTTPRequest.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE,FRAGMENT_RETRY_ATTEMPTS),_defineProperty(_retryAttempts,_voMetricsHTTPRequest.HTTPRequest.INDEX_SEGMENT_TYPE,FRAGMENT_RETRY_ATTEMPTS),_defineProperty(_retryAttempts,_voMetricsHTTPRequest.HTTPRequest.OTHER_TYPE,FRAGMENT_RETRY_ATTEMPTS),_retryAttempts);retryIntervals = (_retryIntervals = {},_defineProperty(_retryIntervals,_voMetricsHTTPRequest.HTTPRequest.MPD_TYPE,MANIFEST_RETRY_INTERVAL),_defineProperty(_retryIntervals,_voMetricsHTTPRequest.HTTPRequest.XLINK_EXPANSION_TYPE,XLINK_RETRY_INTERVAL),_defineProperty(_retryIntervals,_voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE,FRAGMENT_RETRY_INTERVAL),_defineProperty(_retryIntervals,_voMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE,FRAGMENT_RETRY_INTERVAL),_defineProperty(_retryIntervals,_voMetricsHTTPRequest.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE,FRAGMENT_RETRY_INTERVAL),_defineProperty(_retryIntervals,_voMetricsHTTPRequest.HTTPRequest.INDEX_SEGMENT_TYPE,FRAGMENT_RETRY_INTERVAL),_defineProperty(_retryIntervals,_voMetricsHTTPRequest.HTTPRequest.OTHER_TYPE,FRAGMENT_RETRY_INTERVAL),_retryIntervals);cacheLoadThresholds = {};cacheLoadThresholds[_constantsConstants2['default'].VIDEO] = CACHE_LOAD_THRESHOLD_VIDEO;cacheLoadThresholds[_constantsConstants2['default'].AUDIO] = CACHE_LOAD_THRESHOLD_AUDIO;} //TODO Should we use Object.define to have setters/getters? makes more readable code on other side.
	function setABRStrategy(value){ABRStrategy = value;}function getABRStrategy(){return ABRStrategy;}function setUseDefaultABRRules(value){useDefaultABRRules = value;}function getUseDefaultABRRules(){return useDefaultABRRules;}function findABRCustomRule(rulename){var i=undefined;for(i = 0;i < customABRRule.length;i++) {if(customABRRule[i].rulename === rulename){return i;}}return -1;}function getABRCustomRules(){return customABRRule;}function addABRCustomRule(type,rulename,rule){var index=findABRCustomRule(rulename);if(index === -1){ // add rule
	customABRRule.push({type:type,rulename:rulename,rule:rule});}else { // update rule
	customABRRule[index].type = type;customABRRule[index].rule = rule;}}function removeABRCustomRule(rulename){var index=findABRCustomRule(rulename);if(index !== -1){ // remove rule
	customABRRule.splice(index,1);}}function removeAllABRCustomRule(){customABRRule = [];}function setBandwidthSafetyFactor(value){bandwidthSafetyFactor = value;}function getBandwidthSafetyFactor(){return bandwidthSafetyFactor;}function setAbandonLoadTimeout(value){abandonLoadTimeout = value;}function getAbandonLoadTimeout(){return abandonLoadTimeout;}function setStableBufferTime(value){stableBufferTime = value;}function getStableBufferTime(){return !isNaN(stableBufferTime)?stableBufferTime:fastSwitchEnabled?DEFAULT_MIN_BUFFER_TIME_FAST_SWITCH:DEFAULT_MIN_BUFFER_TIME;}function setBufferTimeAtTopQuality(value){bufferTimeAtTopQuality = value;}function getBufferTimeAtTopQuality(){return bufferTimeAtTopQuality;}function setBufferTimeAtTopQualityLongForm(value){bufferTimeAtTopQualityLongForm = value;}function getBufferTimeAtTopQualityLongForm(){return bufferTimeAtTopQualityLongForm;}function setLongFormContentDurationThreshold(value){longFormContentDurationThreshold = value;}function getLongFormContentDurationThreshold(){return longFormContentDurationThreshold;}function setSegmentOverlapToleranceTime(value){segmentOverlapToleranceTime = value;}function getSegmentOverlapToleranceTime(){return segmentOverlapToleranceTime;}function setCacheLoadThresholdForType(type,value){cacheLoadThresholds[type] = value;}function getCacheLoadThresholdForType(type){return cacheLoadThresholds[type];}function setBufferToKeep(value){bufferToKeep = value;}function getBufferToKeep(){return bufferToKeep;}function setBufferAheadToKeep(value){bufferAheadToKeep = value;}function getBufferAheadToKeep(){return bufferAheadToKeep;}function setLastBitrateCachingInfo(enable,ttl){lastBitrateCachingInfo.enabled = enable;if(ttl !== undefined && !isNaN(ttl) && typeof ttl === 'number'){lastBitrateCachingInfo.ttl = ttl;}}function getLastBitrateCachingInfo(){return lastBitrateCachingInfo;}function setLastMediaSettingsCachingInfo(enable,ttl){lastMediaSettingsCachingInfo.enabled = enable;if(ttl !== undefined && !isNaN(ttl) && typeof ttl === 'number'){lastMediaSettingsCachingInfo.ttl = ttl;}}function getLastMediaSettingsCachingInfo(){return lastMediaSettingsCachingInfo;}function setBufferPruningInterval(value){bufferPruningInterval = value;}function getBufferPruningInterval(){return bufferPruningInterval;}function setFragmentRetryAttempts(value){retryAttempts[_voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE] = value;}function setManifestRetryAttempts(value){retryAttempts[_voMetricsHTTPRequest.HTTPRequest.MPD_TYPE] = value;}function setRetryAttemptsForType(type,value){retryAttempts[type] = value;}function getFragmentRetryAttempts(){return retryAttempts[_voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE];}function getManifestRetryAttempts(){return retryAttempts[_voMetricsHTTPRequest.HTTPRequest.MPD_TYPE];}function getRetryAttemptsForType(type){return retryAttempts[type];}function setFragmentRetryInterval(value){retryIntervals[_voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE] = value;}function setManifestRetryInterval(value){retryIntervals[_voMetricsHTTPRequest.HTTPRequest.MPD_TYPE] = value;}function setRetryIntervalForType(type,value){retryIntervals[type] = value;}function getFragmentRetryInterval(){return retryIntervals[_voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE];}function getManifestRetryInterval(){return retryIntervals[_voMetricsHTTPRequest.HTTPRequest.MPD_TYPE];}function getRetryIntervalForType(type){return retryIntervals[type];}function setWallclockTimeUpdateInterval(value){wallclockTimeUpdateInterval = value;}function getWallclockTimeUpdateInterval(){return wallclockTimeUpdateInterval;}function setScheduleWhilePaused(value){scheduleWhilePaused = value;}function getScheduleWhilePaused(){return scheduleWhilePaused;}function setLiveDelayFragmentCount(value){liveDelayFragmentCount = value;}function setLiveDelay(value){liveDelay = value;}function getLiveDelayFragmentCount(){return liveDelayFragmentCount;}function getLiveDelay(){if(lowLatencyEnabled){return liveDelay || DEFAULT_LOW_LATENCY_LIVE_DELAY;}return liveDelay;}function setUseManifestDateHeaderTimeSource(value){useManifestDateHeaderTimeSource = value;}function getUseManifestDateHeaderTimeSource(){return useManifestDateHeaderTimeSource;}function setUseSuggestedPresentationDelay(value){useSuggestedPresentationDelay = value;}function getUseSuggestedPresentationDelay(){return useSuggestedPresentationDelay;}function setUTCTimingSources(value){UTCTimingSources = value;}function getUTCTimingSources(){return UTCTimingSources;}function setXHRWithCredentialsForType(type,value){if(!type){Object.keys(xhrWithCredentials).forEach(function(key){setXHRWithCredentialsForType(key,value);});}else {xhrWithCredentials[type] = !!value;}}function getXHRWithCredentialsForType(type){var useCreds=xhrWithCredentials[type];if(useCreds === undefined){return xhrWithCredentials['default'];}return useCreds;}function getFastSwitchEnabled(){return fastSwitchEnabled;}function setFastSwitchEnabled(value){fastSwitchEnabled = value;}function setMovingAverageMethod(value){movingAverageMethod = value;}function getMovingAverageMethod(){return movingAverageMethod;}function setJumpGaps(value){jumpGaps = value;}function getJumpGaps(){return jumpGaps;}function setSmallGapLimit(value){smallGapLimit = value;}function getSmallGapLimit(){return smallGapLimit;}function getLowLatencyEnabled(){return lowLatencyEnabled;}function setLowLatencyEnabled(value){lowLatencyEnabled = value;}function setManifestUpdateRetryInterval(value){manifestUpdateRetryInterval = value;}function getManifestUpdateRetryInterval(){return manifestUpdateRetryInterval;}function reset(){ //TODO need to figure out what props to persist across sessions and which to reset if any.
	//setup();
	}instance = {setABRStrategy:setABRStrategy,getABRStrategy:getABRStrategy,setUseDefaultABRRules:setUseDefaultABRRules,getUseDefaultABRRules:getUseDefaultABRRules,getABRCustomRules:getABRCustomRules,addABRCustomRule:addABRCustomRule,removeABRCustomRule:removeABRCustomRule,removeAllABRCustomRule:removeAllABRCustomRule,setBandwidthSafetyFactor:setBandwidthSafetyFactor,getBandwidthSafetyFactor:getBandwidthSafetyFactor,setAbandonLoadTimeout:setAbandonLoadTimeout,getAbandonLoadTimeout:getAbandonLoadTimeout,setLastBitrateCachingInfo:setLastBitrateCachingInfo,getLastBitrateCachingInfo:getLastBitrateCachingInfo,setLastMediaSettingsCachingInfo:setLastMediaSettingsCachingInfo,getLastMediaSettingsCachingInfo:getLastMediaSettingsCachingInfo,setStableBufferTime:setStableBufferTime,getStableBufferTime:getStableBufferTime,setBufferTimeAtTopQuality:setBufferTimeAtTopQuality,getBufferTimeAtTopQuality:getBufferTimeAtTopQuality,setBufferTimeAtTopQualityLongForm:setBufferTimeAtTopQualityLongForm,getBufferTimeAtTopQualityLongForm:getBufferTimeAtTopQualityLongForm,setLongFormContentDurationThreshold:setLongFormContentDurationThreshold,getLongFormContentDurationThreshold:getLongFormContentDurationThreshold,setSegmentOverlapToleranceTime:setSegmentOverlapToleranceTime,getSegmentOverlapToleranceTime:getSegmentOverlapToleranceTime,getCacheLoadThresholdForType:getCacheLoadThresholdForType,setCacheLoadThresholdForType:setCacheLoadThresholdForType,setBufferToKeep:setBufferToKeep,getBufferToKeep:getBufferToKeep,setBufferAheadToKeep:setBufferAheadToKeep,getBufferAheadToKeep:getBufferAheadToKeep,setBufferPruningInterval:setBufferPruningInterval,getBufferPruningInterval:getBufferPruningInterval,setFragmentRetryAttempts:setFragmentRetryAttempts,getFragmentRetryAttempts:getFragmentRetryAttempts,setManifestRetryAttempts:setManifestRetryAttempts,getManifestRetryAttempts:getManifestRetryAttempts,setRetryAttemptsForType:setRetryAttemptsForType,getRetryAttemptsForType:getRetryAttemptsForType,setFragmentRetryInterval:setFragmentRetryInterval,getFragmentRetryInterval:getFragmentRetryInterval,setManifestRetryInterval:setManifestRetryInterval,getManifestRetryInterval:getManifestRetryInterval,setRetryIntervalForType:setRetryIntervalForType,getRetryIntervalForType:getRetryIntervalForType,setWallclockTimeUpdateInterval:setWallclockTimeUpdateInterval,getWallclockTimeUpdateInterval:getWallclockTimeUpdateInterval,setScheduleWhilePaused:setScheduleWhilePaused,getScheduleWhilePaused:getScheduleWhilePaused,getUseSuggestedPresentationDelay:getUseSuggestedPresentationDelay,setUseSuggestedPresentationDelay:setUseSuggestedPresentationDelay,setLiveDelayFragmentCount:setLiveDelayFragmentCount,getLiveDelayFragmentCount:getLiveDelayFragmentCount,getLiveDelay:getLiveDelay,setLiveDelay:setLiveDelay,setUseManifestDateHeaderTimeSource:setUseManifestDateHeaderTimeSource,getUseManifestDateHeaderTimeSource:getUseManifestDateHeaderTimeSource,setUTCTimingSources:setUTCTimingSources,getUTCTimingSources:getUTCTimingSources,setXHRWithCredentialsForType:setXHRWithCredentialsForType,getXHRWithCredentialsForType:getXHRWithCredentialsForType,setFastSwitchEnabled:setFastSwitchEnabled,getFastSwitchEnabled:getFastSwitchEnabled,setMovingAverageMethod:setMovingAverageMethod,getMovingAverageMethod:getMovingAverageMethod,setJumpGaps:setJumpGaps,getJumpGaps:getJumpGaps,setSmallGapLimit:setSmallGapLimit,getSmallGapLimit:getSmallGapLimit,getLowLatencyEnabled:getLowLatencyEnabled,setLowLatencyEnabled:setLowLatencyEnabled,setManifestUpdateRetryInterval:setManifestUpdateRetryInterval,getManifestUpdateRetryInterval:getManifestUpdateRetryInterval,reset:reset};setup();return instance;} //TODO see if you can move this and not export and just getter to get default value.
	MediaPlayerModel.__dashjs_factory_name = 'MediaPlayerModel';var factory=_coreFactoryMaker2['default'].getSingletonFactory(MediaPlayerModel);factory.DEFAULT_UTC_TIMING_SOURCE = DEFAULT_UTC_TIMING_SOURCE;_coreFactoryMaker2['default'].updateSingletonFactory(MediaPlayerModel.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=MediaPlayerModel.js.map


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _voURIFragmentData=__webpack_require__(429);var _voURIFragmentData2=_interopRequireDefault(_voURIFragmentData);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function URIQueryAndFragmentModel(){var instance=undefined,URIFragmentDataVO=undefined,URIQueryData=undefined,isHTTPS=undefined;function initialize(){URIFragmentDataVO = new _voURIFragmentData2['default']();URIQueryData = [];isHTTPS = false;}function getURIFragmentData(){return URIFragmentDataVO;}function getURIQueryData(){return URIQueryData;}function isManifestHTTPS(){return isHTTPS;}function parseURI(uri){if(!uri)return null;var URIFragmentData=[];var mappedArr=undefined;var testQuery=new RegExp(/[?]/);var testFragment=new RegExp(/[#]/);var testHTTPS=new RegExp(/^(https:)?\/\//i);var isQuery=testQuery.test(uri);var isFragment=testFragment.test(uri);isHTTPS = testHTTPS.test(uri);function reduceArray(previousValue,currentValue,index,array){var arr=array[0].split(/[=]/);array.push({key:arr[0],value:arr[1]});array.shift();return array;}function mapArray(currentValue,index,array){if(index > 0){if(isQuery && URIQueryData.length === 0){URIQueryData = array[index].split(/[&]/);}else if(isFragment){URIFragmentData = array[index].split(/[&]/);}}return array;}mappedArr = uri.split(/[?#]/).map(mapArray);if(URIQueryData.length > 0){URIQueryData = URIQueryData.reduce(reduceArray,null);}if(URIFragmentData.length > 0){URIFragmentData = URIFragmentData.reduce(reduceArray,null);URIFragmentData.forEach(function(object){URIFragmentDataVO[object.key] = object.value;});}return uri;}instance = {initialize:initialize,parseURI:parseURI,getURIFragmentData:getURIFragmentData,getURIQueryData:getURIQueryData,isManifestHTTPS:isManifestHTTPS};return instance;}URIQueryAndFragmentModel.__dashjs_factory_name = 'URIQueryAndFragmentModel';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(URIQueryAndFragmentModel);module.exports = exports['default'];
	//# sourceMappingURL=URIQueryAndFragmentModel.js.map


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	* The copyright in this software is being made available under the BSD License,
	* included below. This software may be subject to other third party and contributor
	* rights, including patent rights, and no such rights are granted under this license.
	*
	* Copyright (c) 2013, Dash Industry Forum.
	* All rights reserved.
	*
	* Redistribution and use in source and binary forms, with or without modification,
	* are permitted provided that the following conditions are met:
	*  * Redistributions of source code must retain the above copyright notice, this
	*  list of conditions and the following disclaimer.
	*  * Redistributions in binary form must reproduce the above copyright notice,
	*  this list of conditions and the following disclaimer in the documentation and/or
	*  other materials provided with the distribution.
	*  * Neither the name of Dash Industry Forum nor the names of its
	*  contributors may be used to endorse or promote products derived from this software
	*  without specific prior written permission.
	*
	*  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	*  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	*  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	*  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	*  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	*  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	*  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	*  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	*  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	*  POSSIBILITY OF SUCH DAMAGE.
	*/'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function CustomTimeRanges() /*config*/{var customTimeRangeArray=[];var length=0;function add(start,end){var i=0;for(i = 0;i < this.customTimeRangeArray.length && start > this.customTimeRangeArray[i].start;i++);this.customTimeRangeArray.splice(i,0,{start:start,end:end});for(i = 0;i < this.customTimeRangeArray.length - 1;i++) {if(this.mergeRanges(i,i + 1)){i--;}}this.length = this.customTimeRangeArray.length;}function clear(){this.customTimeRangeArray = [];this.length = 0;}function remove(start,end){for(var i=0;i < this.customTimeRangeArray.length;i++) {if(start <= this.customTimeRangeArray[i].start && end >= this.customTimeRangeArray[i].end){ //      |--------------Range i-------|
	//|---------------Range to remove ---------------|
	//    or
	//|--------------Range i-------|
	//|--------------Range to remove ---------------|
	//    or
	//                 |--------------Range i-------|
	//|--------------Range to remove ---------------|
	this.customTimeRangeArray.splice(i,1);i--;}else if(start > this.customTimeRangeArray[i].start && end < this.customTimeRangeArray[i].end){ //|-----------------Range i----------------|
	//        |-------Range to remove -----|
	this.customTimeRangeArray.splice(i + 1,0,{start:end,end:this.customTimeRangeArray[i].end});this.customTimeRangeArray[i].end = start;break;}else if(start > this.customTimeRangeArray[i].start && start < this.customTimeRangeArray[i].end){ //|-----------Range i----------|
	//                    |---------Range to remove --------|
	//    or
	//|-----------------Range i----------------|
	//            |-------Range to remove -----|
	this.customTimeRangeArray[i].end = start;}else if(end > this.customTimeRangeArray[i].start && end < this.customTimeRangeArray[i].end){ //                     |-----------Range i----------|
	//|---------Range to remove --------|
	//            or
	//|-----------------Range i----------------|
	//|-------Range to remove -----|
	this.customTimeRangeArray[i].start = end;}}this.length = this.customTimeRangeArray.length;}function mergeRanges(rangeIndex1,rangeIndex2){var range1=this.customTimeRangeArray[rangeIndex1];var range2=this.customTimeRangeArray[rangeIndex2];if(range1.start <= range2.start && range2.start <= range1.end && range1.end <= range2.end){ //|-----------Range1----------|
	//                    |-----------Range2----------|
	range1.end = range2.end;this.customTimeRangeArray.splice(rangeIndex2,1);return true;}else if(range2.start <= range1.start && range1.start <= range2.end && range2.end <= range1.end){ //                |-----------Range1----------|
	//|-----------Range2----------|
	range1.start = range2.start;this.customTimeRangeArray.splice(rangeIndex2,1);return true;}else if(range2.start <= range1.start && range1.start <= range2.end && range1.end <= range2.end){ //      |--------Range1-------|
	//|---------------Range2--------------|
	this.customTimeRangeArray.splice(rangeIndex1,1);return true;}else if(range1.start <= range2.start && range2.start <= range1.end && range2.end <= range1.end){ //|-----------------Range1--------------|
	//        |-----------Range2----------|
	this.customTimeRangeArray.splice(rangeIndex2,1);return true;}return false;}function checkIndex(index){var isInt=index !== null && !isNaN(index) && index % 1 === 0;if(!isInt){throw new Error('index argument is not an integer');}}function start(index){checkIndex(index);if(index >= this.customTimeRangeArray.length || index < 0){return NaN;}return this.customTimeRangeArray[index].start;}function end(index){checkIndex(index);if(index >= this.customTimeRangeArray.length || index < 0){return NaN;}return this.customTimeRangeArray[index].end;}return {customTimeRangeArray:customTimeRangeArray,length:length,add:add,clear:clear,remove:remove,mergeRanges:mergeRanges,start:start,end:end};}CustomTimeRanges.__dashjs_factory_name = 'CustomTimeRanges';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(CustomTimeRanges);module.exports = exports['default'];
	//# sourceMappingURL=CustomTimeRanges.js.map


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var CAPABILITY_ERROR_MEDIASOURCE='mediasource';var CAPABILITY_ERROR_MEDIAKEYS='mediakeys';var DOWNLOAD_ERROR_ID_MANIFEST='manifest';var DOWNLOAD_ERROR_ID_SIDX='SIDX';var DOWNLOAD_ERROR_ID_CONTENT='content';var DOWNLOAD_ERROR_ID_INITIALIZATION='initialization';var DOWNLOAD_ERROR_ID_XLINK='xlink';var MANIFEST_ERROR_ID_CODEC='codec';var MANIFEST_ERROR_ID_PARSE='parse';var MANIFEST_ERROR_ID_NOSTREAMS='nostreams';var TIMED_TEXT_ERROR_ID_PARSE='parse';function ErrorHandler(){var instance=undefined;var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance(); // "mediasource"|"mediakeys"
	function capabilityError(err){eventBus.trigger(_coreEventsEvents2['default'].ERROR,{error:'capability',event:err});} // {id: "manifest"|"SIDX"|"content"|"initialization"|"xlink", url: "", request: {XMLHttpRequest instance}}
	function downloadError(id,url,request){eventBus.trigger(_coreEventsEvents2['default'].ERROR,{error:'download',event:{id:id,url:url,request:request}});} // {message: "", id: "parse"|"nostreams", manifest: {parsed manifest}}
	function manifestError(message,id,manifest,err){eventBus.trigger(_coreEventsEvents2['default'].ERROR,{error:'manifestError',event:{message:message,id:id,manifest:manifest,event:err}});} // {message: '', id: 'parse', cc: ''}
	function timedTextError(message,id,ccContent){eventBus.trigger(_coreEventsEvents2['default'].ERROR,{error:'cc',event:{message:message,id:id,cc:ccContent}});}function mediaSourceError(err){eventBus.trigger(_coreEventsEvents2['default'].ERROR,{error:'mediasource',event:err});}function mediaKeySessionError(err){eventBus.trigger(_coreEventsEvents2['default'].ERROR,{error:'key_session',event:err});}function mediaKeyMessageError(err){eventBus.trigger(_coreEventsEvents2['default'].ERROR,{error:'key_message',event:err});}function mssError(err){eventBus.trigger(_coreEventsEvents2['default'].ERROR,{error:'mssError',event:err});}instance = {capabilityError:capabilityError,downloadError:downloadError,manifestError:manifestError,timedTextError:timedTextError,mediaSourceError:mediaSourceError,mediaKeySessionError:mediaKeySessionError,mediaKeyMessageError:mediaKeyMessageError,mssError:mssError};return instance;}ErrorHandler.__dashjs_factory_name = 'ErrorHandler';var factory=_coreFactoryMaker2['default'].getSingletonFactory(ErrorHandler);factory.CAPABILITY_ERROR_MEDIASOURCE = CAPABILITY_ERROR_MEDIASOURCE;factory.CAPABILITY_ERROR_MEDIAKEYS = CAPABILITY_ERROR_MEDIAKEYS;factory.DOWNLOAD_ERROR_ID_MANIFEST = DOWNLOAD_ERROR_ID_MANIFEST;factory.DOWNLOAD_ERROR_ID_SIDX = DOWNLOAD_ERROR_ID_SIDX;factory.DOWNLOAD_ERROR_ID_CONTENT = DOWNLOAD_ERROR_ID_CONTENT;factory.DOWNLOAD_ERROR_ID_INITIALIZATION = DOWNLOAD_ERROR_ID_INITIALIZATION;factory.DOWNLOAD_ERROR_ID_XLINK = DOWNLOAD_ERROR_ID_XLINK;factory.MANIFEST_ERROR_ID_CODEC = MANIFEST_ERROR_ID_CODEC;factory.MANIFEST_ERROR_ID_PARSE = MANIFEST_ERROR_ID_PARSE;factory.MANIFEST_ERROR_ID_NOSTREAMS = MANIFEST_ERROR_ID_NOSTREAMS;factory.TIMED_TEXT_ERROR_ID_PARSE = TIMED_TEXT_ERROR_ID_PARSE;_coreFactoryMaker2['default'].updateSingletonFactory(ErrorHandler.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=ErrorHandler.js.map


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _fastDeepEqual=__webpack_require__(447);var _fastDeepEqual2=_interopRequireDefault(_fastDeepEqual); /**
	 * @module ObjectUtils
	 * @description Provides utility functions for objects
	 */function ObjectUtils(){var instance=undefined; /**
	     * Returns true if objects are equal
	     * @return {boolean}
	     * @param {object} obj1
	     * @param {object} obj2
	     * @memberof module:ObjectUtils
	     * @instance
	     */function areEqual(obj1,obj2){return (0,_fastDeepEqual2['default'])(obj1,obj2);}instance = {areEqual:areEqual};return instance;}ObjectUtils.__dashjs_factory_name = 'ObjectUtils';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(ObjectUtils);module.exports = exports['default'];
	//# sourceMappingURL=ObjectUtils.js.map


/***/ },
/* 154 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var BitrateInfo=function BitrateInfo(){_classCallCheck(this,BitrateInfo);this.mediaType = null;this.bitrate = null;this.width = null;this.height = null;this.scanType = null;this.qualityIndex = NaN;};exports["default"] = BitrateInfo;module.exports = exports["default"];
	//# sourceMappingURL=BitrateInfo.js.map


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _FragmentRequest2=__webpack_require__(37);var _FragmentRequest3=_interopRequireDefault(_FragmentRequest2);var TextRequest=(function(_FragmentRequest){_inherits(TextRequest,_FragmentRequest);function TextRequest(url,type){_classCallCheck(this,TextRequest);_get(Object.getPrototypeOf(TextRequest.prototype),'constructor',this).call(this);this.url = url || null;this.type = type || null;this.mediaType = _constantsConstants2['default'].STREAM;this.responseType = ''; //'text' value returns a bad encoding response in Firefox
	}return TextRequest;})(_FragmentRequest3['default']);exports['default'] = TextRequest;module.exports = exports['default'];
	//# sourceMappingURL=TextRequest.js.map


/***/ },
/* 156 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc a PlayList from ISO23009-1 Annex D, this Object holds reference to the playback session information
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var PlayList= /**
	     * @class
	     */function PlayList(){_classCallCheck(this,PlayList); /**
	         * Timestamp of the user action that starts the playback stream...
	         * @public
	         */this.start = null; /**
	         * Presentation time at which playout was requested by the user...
	         * @public
	         */this.mstart = null; /**
	         * Type of user action which triggered playout
	         * - New playout request (e.g. initial playout or seeking)
	         * - Resume from pause
	         * - Other user request (e.g. user-requested quality change)
	         * - Start of a metrics collection stream (hence earlier entries in the play list not collected)
	         * @public
	         */this.starttype = null; /**
	         * List of streams of continuous rendering of decoded samples.
	         * @public
	         */this.trace = [];} /* Public Static Constants */;PlayList.INITIAL_PLAYOUT_START_REASON = 'initial_playout';PlayList.SEEK_START_REASON = 'seek';PlayList.RESUME_FROM_PAUSE_START_REASON = 'resume';PlayList.METRICS_COLLECTION_START_REASON = 'metrics_collection_start'; /**
	 * @classdesc a PlayList.Trace from ISO23009-1 Annex D
	 */var PlayListTrace= /**
	     * @class
	     */function PlayListTrace(){_classCallCheck(this,PlayListTrace); /**
	         * The value of the Representation@id of the Representation from which the samples were taken.
	         * @type {string}
	         * @public
	         */this.representationid = null; /**
	         * If not present, this metrics concerns the Representation as a whole.
	         * If present, subreplevel indicates the greatest value of any
	         * Subrepresentation@level being rendered.
	         * @type {number}
	         * @public
	         */this.subreplevel = null; /**
	         * The time at which the first sample was rendered
	         * @type {number}
	         * @public
	         */this.start = null; /**
	         * The presentation time of the first sample rendered.
	         * @type {number}
	         * @public
	         */this.mstart = null; /**
	         * The duration of the continuously presented samples (which is the same in real time and media time). "Continuously presented" means that the media clock continued to advance at the playout speed throughout the interval. NOTE: the spec does not call out the units, but all other durations etc are in ms, and we use ms too.
	         * @type {number}
	         * @public
	         */this.duration = null; /**
	         * The playback speed relative to normal playback speed (i.e.normal forward playback speed is 1.0).
	         * @type {number}
	         * @public
	         */this.playbackspeed = null; /**
	         * The reason why continuous presentation of this Representation was stopped.
	         * representation switch
	         * rebuffering
	         * user request
	         * end of Period
	         * end of Stream
	         * end of content
	         * end of a metrics collection period
	         *
	         * @type {string}
	         * @public
	         */this.stopreason = null;};PlayListTrace.REPRESENTATION_SWITCH_STOP_REASON = 'representation_switch';PlayListTrace.REBUFFERING_REASON = 'rebuffering';PlayListTrace.USER_REQUEST_STOP_REASON = 'user_request';PlayListTrace.END_OF_PERIOD_STOP_REASON = 'end_of_period';PlayListTrace.END_OF_CONTENT_STOP_REASON = 'end_of_content';PlayListTrace.METRICS_COLLECTION_STOP_REASON = 'metrics_collection_end';PlayListTrace.FAILURE_STOP_REASON = 'failure';exports.PlayList = PlayList;exports.PlayListTrace = PlayListTrace;
	//# sourceMappingURL=PlayList.js.map


/***/ },
/* 157 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(21);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 159 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(103);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(487);
	
	var _runTransitionHook = __webpack_require__(103);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(43);
	
	var _PathUtils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/* 
	 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *
	 * * Redistributions of source code must retain the above copyright notice, this
	 *   list of conditions and the following disclaimer.
	 * * Redistributions in binary form must reproduce the above copyright notice,
	 *   this list of conditions and the following disclaimer in the documentation
	 *   and/or other materials provided with the distribution.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
	 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
	 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
	 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 * POSSIBILITY OF SUCH DAMAGE.
	 */
	
	exports.generateISD = __webpack_require__(472).generateISD;
	exports.fromXML = __webpack_require__(470).fromXML;
	exports.renderHTML = __webpack_require__(471).render;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/* 
	 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *
	 * * Redistributions of source code must retain the above copyright notice, this
	 *   list of conditions and the following disclaimer.
	 * * Redistributions in binary form must reproduce the above copyright notice,
	 *   this list of conditions and the following disclaimer in the documentation
	 *   and/or other materials provided with the distribution.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
	 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
	 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
	 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 * POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/**
	 * @module imscUtils
	 */
	
	;
	(function (imscUtils) { // wrapper for non-node envs
	    
	    /* Documents the error handler interface */
	    
	    /**
	     * @classdesc Generic interface for handling events. The interface exposes four
	     * methods:
	     * * <pre>info</pre>: unusual event that does not result in an inconsistent state
	     * * <pre>warn</pre>: unexpected event that should not result in an inconsistent state
	     * * <pre>error</pre>: unexpected event that may result in an inconsistent state
	     * * <pre>fatal</pre>: unexpected event that results in an inconsistent state
	     *   and termination of processing
	     * Each method takes a single <pre>string</pre> describing the event as argument,
	     * and returns a single <pre>boolean</pre>, which terminates processing if <pre>true</pre>.
	     *
	     * @name ErrorHandler
	     * @class
	     */
	
	
	    /*
	     * Parses a TTML color expression
	     * 
	     */
	
	    var HEX_COLOR_RE = /#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?/;
	    var DEC_COLOR_RE = /rgb\((\d+),(\d+),(\d+)\)/;
	    var DEC_COLORA_RE = /rgba\((\d+),(\d+),(\d+),(\d+)\)/;
	    var NAMED_COLOR = {
	        transparent: [0, 0, 0, 0],
	        black: [0, 0, 0, 255],
	        silver: [192, 192, 192, 255],
	        gray: [128, 128, 128, 255],
	        white: [255, 255, 255, 255],
	        maroon: [128, 0, 0, 255],
	        red: [255, 0, 0, 255],
	        purple: [128, 0, 128, 255],
	        fuchsia: [255, 0, 255, 255],
	        magenta: [255, 0, 255, 255],
	        green: [0, 128, 0, 255],
	        lime: [0, 255, 0, 255],
	        olive: [128, 128, 0, 255],
	        yellow: [255, 255, 0, 255],
	        navy: [0, 0, 128, 255],
	        blue: [0, 0, 255, 255],
	        teal: [0, 128, 128, 255],
	        aqua: [0, 255, 255, 255],
	        cyan: [0, 255, 255, 255]
	    };
	
	    imscUtils.parseColor = function (str) {
	
	        var m;
	        var r = null;
	        if (str in NAMED_COLOR) {
	
	            r = NAMED_COLOR[str];
	
	        } else if ((m = HEX_COLOR_RE.exec(str)) !== null) {
	
	            r = [parseInt(m[1], 16),
	                parseInt(m[2], 16),
	                parseInt(m[3], 16),
	                (m[4] !== undefined ? parseInt(m[4], 16) : 255)];
	        } else if ((m = DEC_COLOR_RE.exec(str)) !== null) {
	
	            r = [parseInt(m[1]),
	                parseInt(m[2]),
	                parseInt(m[3]),
	                255];
	        } else if ((m = DEC_COLORA_RE.exec(str)) !== null) {
	
	            r = [parseInt(m[1]),
	                parseInt(m[2]),
	                parseInt(m[3]),
	                parseInt(m[4])];
	        }
	
	        return r;
	    };
	
	    var LENGTH_RE = /^((?:\+|\-)?\d*(?:\.\d+)?)(px|em|c|%)$/;
	
	    imscUtils.parseLength = function (str) {
	
	        var m;
	
	        var r = null;
	
	        if ((m = LENGTH_RE.exec(str)) !== null) {
	
	            r = {value: parseFloat(m[1]), unit: m[2]};
	        }
	
	        return r;
	    };
	
	})( false ? this.imscUtils = {} : exports);


/***/ },
/* 167 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(480);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(224);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(486);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 171 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 172 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(38);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInstrumentation = __webpack_require__(23);
	
	var quoteAttributeValueForBrowser = __webpack_require__(549);
	var warning = __webpack_require__(9);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 175 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var LinkedValueUtils = __webpack_require__(111);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(26);
	
	var warning = __webpack_require__(9);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 177 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 178 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var invariant = __webpack_require__(3);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(509);
	
	var containsNode = __webpack_require__(450);
	var focusNode = __webpack_require__(159);
	var getActiveElement = __webpack_require__(160);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var DOMLazyTree = __webpack_require__(46);
	var DOMProperty = __webpack_require__(47);
	var React = __webpack_require__(51);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMContainerInfo = __webpack_require__(503);
	var ReactDOMFeatureFlags = __webpack_require__(505);
	var ReactFeatureFlags = __webpack_require__(178);
	var ReactInstanceMap = __webpack_require__(58);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactMarkupChecksum = __webpack_require__(519);
	var ReactReconciler = __webpack_require__(48);
	var ReactUpdateQueue = __webpack_require__(114);
	var ReactUpdates = __webpack_require__(26);
	
	var emptyObject = __webpack_require__(70);
	var instantiateReactComponent = __webpack_require__(189);
	var invariant = __webpack_require__(3);
	var setInnerHTML = __webpack_require__(80);
	var shouldUpdateReactComponent = __webpack_require__(120);
	var warning = __webpack_require__(9);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var React = __webpack_require__(51);
	
	var invariant = __webpack_require__(3);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 183 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 185 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(182);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(11);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10),
	    _assign = __webpack_require__(7);
	
	var ReactCompositeComponent = __webpack_require__(500);
	var ReactEmptyComponent = __webpack_require__(177);
	var ReactHostComponent = __webpack_require__(179);
	
	var getNextDebugID = __webpack_require__(594);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(9);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 190 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	var escapeTextContentForBrowser = __webpack_require__(79);
	var setInnerHTML = __webpack_require__(80);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var REACT_ELEMENT_TYPE = __webpack_require__(515);
	
	var getIteratorFn = __webpack_require__(546);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(110);
	var warning = __webpack_require__(9);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 193 */
/***/ function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(164);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _Subscription = __webpack_require__(560);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(197);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(105);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(122);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(13);
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(125);
	
	var _ContextUtils = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 199 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(13);
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(33);
	
	var _PatternUtils = __webpack_require__(49);
	
	var _InternalPropTypes = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 201 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(163);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(162);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(468);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(205);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(50);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(570);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(567);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(574);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(571);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(576);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(163);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(162);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(584);

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
	var _reactDom = __webpack_require__(75);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {
	
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	  }
	
	  return targetLeft;
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(61),
	    _assign = __webpack_require__(7);
	
	var ReactNoopUpdateQueue = __webpack_require__(212);
	
	var canDefineProperty = __webpack_require__(213);
	var emptyObject = __webpack_require__(70);
	var invariant = __webpack_require__(3);
	var lowPriorityWarning = __webpack_require__(595);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(61);
	
	var ReactCurrentOwner = __webpack_require__(29);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(9);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 211 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(9);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(74);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(167);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(98).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(217);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(82).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(54);
	util.inherits = __webpack_require__(44);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(640);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(600);
	var destroyImpl = __webpack_require__(216);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(39);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(131).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(39);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(131).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(45)))

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(39);
	
	/*<replacement>*/
	var util = __webpack_require__(54);
	util.inherits = __webpack_require__(44);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(74);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(98).EventEmitter;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["redux-responsive"] = factory();
		else
			root["redux-responsive"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 8);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calculateResponsiveState__ = __webpack_require__(7);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__calculateResponsiveState__["a"]; });
	
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CALCULATE_RESPONSIVE_STATE__ = __webpack_require__(2);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CALCULATE_RESPONSIVE_STATE__["a"]; });
	
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony default export */ __webpack_exports__["a"] = ('redux-responsive/CALCULATE_RESPONSIVE_STATE');
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports =  __webpack_require__(12);
	
	
	
	/***/ }),
	/* 4 */,
	/* 5 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__handlers__ = __webpack_require__(11);
	// local imports
	
	
	/**
	 * Creates a store enhancer based off an (optional) throttle time.
	 * @arg {object} [options={calculateInitialState}] - Options object.
	 * @arg {boolean} [options.calculateInitialState=true] - True if the responsive
	 * state must be calculated initially, false otherwise.
	 * @returns {function} - The store enhancer (which adds event listeners to
	 * dispatch actions on window resize).
	 */
	/* harmony default export */ __webpack_exports__["a"] = (function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$calculateInitial = _ref.calculateInitialState,
	        calculateInitialState = _ref$calculateInitial === undefined ? true : _ref$calculateInitial;
	
	    // return the store enhancer (an enhanced version of `createStore`)
	    return function (createStore) {
	        return function () {
	            // create the store
	            var store = createStore.apply(undefined, arguments);
	            // if there is a `window`
	            if (typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined') {
	                // add the handlers that only fire when the responsive state changes
	                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__handlers__["a" /* default */])({ store: store, window: window, calculateInitialState: calculateInitialState });
	            }
	
	            // return the store so that the call is transparent
	            return store;
	        };
	    };
	});
	
	/***/ }),
	/* 6 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export defaultBreakpoints */
	/* unused harmony export getOrderMap */
	/* unused harmony export getLessThan */
	/* unused harmony export getIs */
	/* unused harmony export getGreaterThan */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mediaquery__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mediaquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mediaquery__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_types_CALCULATE_RESPONSIVE_STATE__ = __webpack_require__(2);
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// third party imports
	
	// local imports
	
	
	// default breakpoints
	var defaultBreakpoints = {
	    extraSmall: 480,
	    small: 768,
	    medium: 992,
	    large: 1200
	    // media type to default to when no `window` present
	};var defaultMediaType = 'infinity';
	// orientation to default to when no `window` present
	var defaultOrientation = null;
	
	// a lightweight version of lodash.transform
	var transform = function transform(obj, f) {
	    // a place to mutate
	    var internal = {};
	    // basically we have to reduce the keys down to an object and pass the k/v pairs to each f
	    Object.keys(obj).forEach(function (key) {
	        return f(internal, obj[key], key);
	    });
	    // return the object we've been building up
	    return internal;
	};
	
	/**
	 * Compute a mapping of media type to its ordering where ordering is defined
	 * such that large > medium > small.
	 * @args (object) breakpoints - the breakpoint object
	 */
	function getOrderMap(bps) {
	    // grab the keys in the appropriate order
	    var keys = Object.keys(bps).sort(function (a, b) {
	        // get the associated values
	        var valueA = bps[a];
	        var valueB = bps[b];
	
	        // if a is a number and b is a string
	        if (typeof valueA === 'number' && typeof valueB === 'string') {
	            // put the number first
	            return -1;
	        } else if (typeof valueB === 'number' && typeof valueA === 'string') {
	            // return the number first
	            return 1;
	        }
	
	        // otherwise treat it like normal
	        return valueA >= valueB ? 1 : -1;
	    });
	
	    // map the original breakpoint object
	    return transform(bps, function (result, breakpoint, mediaType) {
	        // figure out the index of the mediatype
	        var index = keys.indexOf(mediaType);
	
	        // if there is an entry in the sort for this
	        if (index !== -1) {
	            // to its index in the sorted list
	            result[mediaType] = index;
	        }
	    });
	}
	
	/**
	 * Compute the `lessThan` object based on the browser width.
	 * @arg {number} browserWidth - Width of the browser.
	 * @arg {object} breakpoints - The breakpoints object.
	 * @arg {currentMediaType} breakpoints - The curent media type.
	 * @returns {object} The `lessThan` object.  Its keys are the same as the
	 * keys of the breakpoints object.  The value for each key indicates whether
	 * or not the browser width is less than the breakpoint.
	 */
	function getLessThan(currentMediaType, breakpointOrder) {
	    // get the ordering of the current media type
	    var currentOrder = breakpointOrder[currentMediaType];
	
	    return transform(breakpointOrder, function (result, breakpoint, mediaType) {
	        // if the breakpoint is a number
	        if (typeof breakpoint === 'number' && breakpointOrder[mediaType]) {
	            // store wether or not it is less than the breakpoint
	            result[mediaType] = currentOrder < breakpointOrder[mediaType];
	            // handle non numerical breakpoints specially
	        } else {
	            result[mediaType] = false;
	        }
	    });
	}
	
	/**
	 * Compute the `lessThan` object based on the browser width.
	 * @arg {object} breakpoints - The breakpoints object.
	 * @arg {currentMediaType} breakpoints - The curent media type.
	 * @returns {object} The `lessThan` object.  Its keys are the same as the
	 * keys of the breakpoints object.  The value for each key indicates whether
	 * or not the browser width is less than the breakpoint.
	 */
	function getIs(currentMediaType, breakpoints) {
	    return transform(breakpoints, function (result, breakpoint, mediaType) {
	        // if the breakpoint is a number
	        if (typeof breakpoint === 'number' && breakpoints[mediaType]) {
	            // store wether or not it is less than the breakpoint
	            result[mediaType] = mediaType === currentMediaType;
	            // handle non numerical breakpoints specially
	        } else {
	            result[mediaType] = false;
	        }
	    });
	}
	
	/**
	 * Compute the `greaterThan` object based on the browser width.
	 * @arg {number} browserWidth - Width of the browser.
	 * @arg {object} breakpoints - The breakpoints object.
	 * @returns {object} The `greaterThan` object.  Its keys are the same as the
	 * keys of the breakpoints object.  The value for each key indicates whether
	 * or not the browser width is greater than the breakpoint.
	 */
	function getGreaterThan(currentMediaType, breakpointOrder) {
	    // get the ordering of the current media type
	    var currentOrder = breakpointOrder[currentMediaType];
	
	    return transform(breakpointOrder, function (result, breakpoint, mediaType) {
	        // if the breakpoint is a number
	        if (typeof breakpoint === 'number') {
	            // store wether or not it is less than the breakpoint
	            result[mediaType] = currentOrder > breakpointOrder[mediaType];
	            // handle non numerical breakpoints specially
	        } else {
	            result[mediaType] = false;
	        }
	    });
	}
	
	/**
	 * Gets the current media type from the global `window`.
	 * @arg {object} mediaQueries - The media queries object.
	 * @arg {string} infinityMediaType - The infinity media type.
	 * @returns {string} The window's current media type.  This is the key of the
	 * breakpoint that is the next breakpoint larger than the window.
	 */
	function getMediaType(matchMedia, mediaQueries, infinityMediaType) {
	    // if there's no window
	    if (typeof matchMedia === 'undefined') {
	        // return the infinity media type
	        return infinityMediaType;
	    }
	
	    // there is a window, so compute the true media type
	    return Object.keys(mediaQueries).reduce(function (result, query) {
	        // return the new type if the query matches otherwise the previous one
	        return matchMedia(mediaQueries[query]).matches ? query : result;
	        // use the infinity media type
	    }, infinityMediaType);
	}
	
	/**
	 * Gets the current media type from the global `window`.
	 * @arg {object} mediaQueries - The media queries object.
	 * @returns {string} The window's current media type.  This is the key of the
	 * breakpoint that is the next breakpoint larger than the window.
	 */
	function getOrientation(matchMedia) {
	    // if there's no window
	    if (typeof matchMedia === 'undefined') {
	        // return the default
	        return defaultOrientation;
	    }
	
	    var mediaQueries = {
	        portrait: '(orientation: portrait)',
	        landscape: '(orientation: landscape)'
	
	        // there is a window, so compute the true orientation
	    };return Object.keys(mediaQueries).reduce(function (result, query) {
	        // return the new type if the query matches otherwise the previous one
	        return matchMedia(mediaQueries[query]).matches ? query : result;
	        // use the default orientation
	    }, defaultOrientation);
	}
	
	// export the reducer factory
	/* harmony default export */ __webpack_exports__["a"] = (function (breakpoints) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        initialMediaType = _ref.initialMediaType,
	        _ref$infinity = _ref.infinity,
	        infinity = _ref$infinity === undefined ? defaultMediaType : _ref$infinity,
	        _ref$extraFields = _ref.extraFields,
	        extraFields = _ref$extraFields === undefined ? function () {
	        return {};
	    } : _ref$extraFields;
	
	    // accept null values
	    if (!breakpoints) {
	        breakpoints = defaultBreakpoints; // eslint-disable-line
	    }
	
	    // add `infinity` breakpoint for upper bound
	    breakpoints[infinity] = Infinity;
	    // media queries associated with the breakpoints
	    var mediaQueries = __WEBPACK_IMPORTED_MODULE_0_mediaquery___default.a.asObject(breakpoints);
	    // figure out the ordering
	    var mediaOrdering = getOrderMap(breakpoints);
	
	    // return reducer for handling the responsive state
	    return function (state, _ref2) {
	        var type = _ref2.type,
	            matchMedia = _ref2.matchMedia;
	
	        // if told to recalculate state or state has not yet been initialized
	        if (type === __WEBPACK_IMPORTED_MODULE_1__actions_types_CALCULATE_RESPONSIVE_STATE__["a" /* default */] || typeof state === 'undefined') {
	            // if the state has never been set before and we have an initial type
	            var mediaType = !state && initialMediaType
	            // use it
	            ? initialMediaType
	            // otherwise figure out the media type from the browser
	            : getMediaType(matchMedia, mediaQueries, infinity);
	            // the current orientation
	            var orientation = getOrientation(matchMedia);
	            // build the responsive state
	            var responsiveState = {
	                _responsiveState: true,
	                lessThan: getLessThan(mediaType, mediaOrdering),
	                greaterThan: getGreaterThan(mediaType, mediaOrdering),
	                is: getIs(mediaType, breakpoints),
	                mediaType: mediaType,
	                orientation: orientation,
	                breakpoints: breakpoints
	
	                // return calculated state
	            };return _extends({}, responsiveState, extraFields(responsiveState));
	        }
	        // otherwise return the previous state
	        return state;
	    };
	});
	
	/***/ }),
	/* 7 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(1);
	// action type
	
	
	/**
	 * Action creator taking window-like object and returning action to calculate
	 * responsive state.
	 * @arg {object} window - Any window-like object (has keys `innerWidth` and
	 * `matchMedia`).
	 * @arg {number} window.innerWidth - The value for the browser width (to pass to
	 * the responsive state reducer logic).  See browser global `window.innerWidth`.
	 * @arg {function} window.matchMedia - The method with which to match media
	 * queries (to pass to the responsive sate reducer logic).  See global
	 * `window.matchMedia`.
	 * @returns {object} The resulting action.  Action will have type
	 * `CALCULATE_RESPONSIVE_STATE`, and will be directly given the two keys taken
	 * from the `window` argument.
	 */
	/* harmony default export */ __webpack_exports__["a"] = (function () {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      innerWidth = _ref.innerWidth,
	      innerHeight = _ref.innerHeight,
	      matchMedia = _ref.matchMedia;
	
	  return {
	    type: __WEBPACK_IMPORTED_MODULE_0__types__["a" /* CALCULATE_RESPONSIVE_STATE */],
	    innerWidth: innerWidth,
	    innerHeight: innerHeight,
	    matchMedia: matchMedia
	  };
	});
	
	/***/ }),
	/* 8 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createResponsiveStateReducer", function() { return createResponsiveStateReducer; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createResponsiveStoreEnhancer", function() { return createResponsiveStoreEnhancer; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "responsiveStateReducer", function() { return responsiveStateReducer; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "responsiveStoreEnhancer", function() { return responsiveStoreEnhancer; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_createReducer__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_createEnhancer__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_types__ = __webpack_require__(1);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CALCULATE_RESPONSIVE_STATE", function() { return __WEBPACK_IMPORTED_MODULE_2__actions_types__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_creators__ = __webpack_require__(0);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "calculateResponsiveState", function() { return __WEBPACK_IMPORTED_MODULE_3__actions_creators__["a"]; });
	// local imports
	
	
	
	
	
	// external API
	var createResponsiveStateReducer = __WEBPACK_IMPORTED_MODULE_0__util_createReducer__["a" /* default */];
	var createResponsiveStoreEnhancer = __WEBPACK_IMPORTED_MODULE_1__util_createEnhancer__["a" /* default */];
	// provide default responsive state reducer/enhancers
	var responsiveStateReducer = createResponsiveStateReducer();
	var responsiveStoreEnhancer = createResponsiveStoreEnhancer();
	
	/***/ }),
	/* 9 */,
	/* 10 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Returns the value found in obj at path. Delegates to obj.getIn if available.
	 * @param obj
	 * @param path
	 * @returns {*}
	 */
	function getIn(obj, path) {
	    if (typeof obj.getIn === 'function') {
	        return obj.getIn(path);
	    }
	    return path.reduce(function (accum, next) {
	        return accum[next];
	    }, obj);
	}
	
	/**
	 * Returns all keys of an object. Delegates to either obj.keys or Object.keys.
	 * @param obj
	 * @returns {*}
	 */
	
	function keys(obj) {
	    if (typeof obj.keys === 'function') {
	        return Array.from(obj.keys());
	    }
	    return Object.keys(obj);
	}
	
	/**
	 * An implementation of breadth-first search. Looks for marker key in the tree.
	 * @param tree
	 * @param marker
	 * @param [maxDepth]
	 * @returns {*}
	 */
	function findMarker(tree, marker) {
	    var maxDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
	
	    var rootPath = [];
	    var queue = [rootPath];
	
	    var _loop = function _loop() {
	        var currentPath = queue.shift();
	        if (currentPath.length > maxDepth) {
	            return 'continue';
	        }
	        var currentObj = getIn(tree, currentPath);
	        if (currentObj) {
	            if (currentObj[marker]) {
	                return {
	                    v: currentPath
	                };
	            }
	            queue.push.apply(queue, _toConsumableArray(keys(currentObj).map(function (k) {
	                return currentPath.concat(k);
	            })));
	        }
	    };
	
	    while (queue.length > 0) {
	        var _ret = _loop();
	
	        switch (_ret) {
	            case 'continue':
	                continue;
	
	            default:
	                if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	        }
	    }
	    return false;
	}
	
	/**
	 * Searches through the given redux store and returns the breakpoints found inside.
	 * @arg {object} - The redux state.
	 * @returns {object} - The breakpoints associated with the responsive state inside the store.
	 */
	function getBreakpoints(store) {
	    // grab the current state of the store
	    var storeState = store.getState();
	
	    var responsiveStatePath = findMarker(storeState, '_responsiveState');
	
	    // if we couldn't find a responsive reducer at the root of the project
	    if (!responsiveStatePath) {
	        throw new Error('Could not find responsive state reducer. ' + 'If you are still running into trouble, please open a ticket on github.');
	    }
	
	    // return the breakpoints in the redux store
	    return getIn(storeState, responsiveStatePath).breakpoints;
	}
	
	/* harmony default export */ __webpack_exports__["a"] = (getBreakpoints);
	
	/***/ }),
	/* 11 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mediaquery__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mediaquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mediaquery__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_creators__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getBreakpoints__ = __webpack_require__(10);
	// see: https://developer.mozilla.org/en-US/docs/Web/CSS/Media_Queries/Testing_media_queries
	
	// external imports
	
	// local imports
	
	
	
	// this function adds event handlers to the window that only tirgger
	// when the responsive state changes
	/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
	    var store = _ref.store,
	        window = _ref.window,
	        calculateInitialState = _ref.calculateInitialState;
	
	    // the function to call when calculating the new responsive state
	    var refreshResponsiveState = function refreshResponsiveState() {
	        return store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions_creators__["a" /* calculateResponsiveState */])(window));
	    };
	
	    // get the object of media queries corresponding to the breakpoints in the store
	    var mediaQueries = __WEBPACK_IMPORTED_MODULE_0_mediaquery___default.a.asObject(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getBreakpoints__["a" /* default */])(store));
	
	    // for every breakpoint range
	    Object.keys(mediaQueries).forEach(function (breakpoint) {
	        // create a media query list for the breakpoint
	        var mediaQueryList = window.matchMedia(mediaQueries[breakpoint]);
	
	        /* eslint-disable no-loop-func */
	
	        // whenever any of the media query lists status changes
	        mediaQueryList.addListener(function (query) {
	            // if a new query was matched
	            if (query.matches) {
	                // recaulate the state
	                refreshResponsiveState();
	            }
	        });
	    });
	
	    // make sure we update the responsive state when the browser changes orientation
	    window.addEventListener('orientationchange', refreshResponsiveState);
	
	    // if we are supposed to calculate the initial state
	    if (calculateInitialState) {
	        // then do so
	        refreshResponsiveState();
	    }
	});
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var MQ = {
	
	  asArray: function asArray(obj) {
	    var bp = this.getBreakPoints(obj);
	    var custom = this.getCustomQueries(obj);
	
	    return this._translate(this._makeSteps(this._toSortedArray(bp)))
	      .concat(this._objToArr(custom));
	  },
	
	  asObject: function asObject(obj) {
	    return this._arrToObj(this.asArray(obj));
	  },
	
	  getBreakPoints: function getBreakPoints(obj) {
	    return Object.keys(obj).reduce(function (prev, next) {
	      if (typeof obj[next] === 'number') {
	        prev[next] = obj[next];
	      }
	      return prev;
	    }, {});
	  },
	
	  getCustomQueries: function getCustomQueries(obj) {
	    return Object.keys(obj).reduce(function (prev, next) {
	      if (typeof obj[next] === 'string') {
	        prev[next] = obj[next];
	      }
	      return prev;
	    }, {});
	  },
	
	  _toSortedArray: function _toSortedArray(obj) {
	    return Object.keys(obj).map(function (el) {
	      return [el, obj[el]];
	    }).sort(function (a, b) {
	      return a[1] - b[1];
	    });
	  },
	
	  _makeSteps: function _makeSteps(arr) {
	    return (arr[arr.length - 1][1] === Infinity)?
	      arr
	      : arr.concat([Infinity]);
	  },
	
	  _translate: function _translate(arr) {
	    return arr.map(function (el, index) {
	      return (index === 0)?
	        [el[0], 'screen and (max-width: ' + el[1] + 'px)']
	        : (index === arr.length - 1)?
	          [(el[0] || 'default'), 'screen and (min-width: ' +
	            (arr[index - 1][1] + 1) + 'px)']
	          : [el[0], 'screen and (min-width: ' + (arr[index-1][1] + 1) +
	            'px) and (max-width: ' + el[1] + 'px)'];
	    });
	  },
	
	  _objToArr: function _objToArr(obj) {
	    return Object.keys(obj).map(function (el) {
	      return [el, obj[el]];
	    });
	  },
	
	  _arrToObj: function _arrToObj(arr) {
	    return arr.reduce(function (prev, next) {
	      prev[next[0]] = next[1];
	      return prev;
	    }, {});
	  }
	};
	
	if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = MQ;
	} else {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return MQ;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  else {
	    window.MQ = MQ;
	  }
	}
	
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=index.js.map

/***/ },
/* 219 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(105);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(632);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 221 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 222 */
/***/ function(module, exports) {

	module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(483).enable();
	  window.Promise = __webpack_require__(482);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(639);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(7);


/***/ },
/* 224 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(20);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(614);
	
	var _Body = __webpack_require__(132);
	
	var _Body2 = _interopRequireDefault(_Body);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	    _inherits(About, _Component);
	
	    function About() {
	        _classCallCheck(this, About);
	
	        return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
	    }
	
	    _createClass(About, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var body = this.props.about.body;
	
	
	            var className = (0, _classnames2.default)({
	                "About": true,
	                "About--open": this.props.open
	            });
	
	            var classNameBurger = (0, _classnames2.default)({
	                "Navigation__burger": true,
	                "Navigation__burger--x": true
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'About__close' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: classNameBurger, onClick: function onClick() {
	                                return _this2.context.router.push('/' + _this2.props.language);
	                            } },
	                        _react2.default.createElement('span', null),
	                        _react2.default.createElement('span', null),
	                        _react2.default.createElement('span', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'About__inner' },
	                    _react2.default.createElement(_Body2.default, { body: body })
	                )
	            );
	        }
	    }]);
	
	    return About;
	}(_react.Component);
	
	About.contextTypes = {
	    router: _propTypes2.default.object.isRequired
	};
	
	
	function mapStateToProps(_ref) {
	    var about = _ref.about,
	        timeline = _ref.timeline;
	
	    return {
	        about: about,
	        language: timeline.language
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(About);

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(615);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Annotation = function (_Component) {
	    _inherits(Annotation, _Component);
	
	    function Annotation() {
	        _classCallCheck(this, Annotation);
	
	        return _possibleConstructorReturn(this, (Annotation.__proto__ || Object.getPrototypeOf(Annotation)).apply(this, arguments));
	    }
	
	    _createClass(Annotation, [{
	        key: 'render',
	        value: function render() {
	            var className = (0, _classnames2.default)(_defineProperty({
	                "Annotation__container": true
	            }, 'Annotation__container--' + this.props.position, true));
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Annotation' },
	                _react2.default.createElement(
	                    'div',
	                    { className: className },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'Annotation__icon' },
	                        '!'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Annotation__title' },
	                        this.props.title
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Annotation;
	}(_react.Component);
	
	exports.default = Annotation;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(616);
	
	var _Video = __webpack_require__(243);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _Timeline = __webpack_require__(242);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _Navigation = __webpack_require__(239);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Popup = __webpack_require__(240);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Splash = __webpack_require__(241);
	
	var _Splash2 = _interopRequireDefault(_Splash);
	
	var _About = __webpack_require__(225);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	    _inherits(App, _Component);
	
	    function App() {
	        _classCallCheck(this, App);
	
	        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	    }
	
	    _createClass(App, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'App' },
	                _react2.default.createElement(_About2.default, { open: this.context.router.location.pathname.split('/').pop() === "about" }),
	                _react2.default.createElement(_Timeline2.default, null),
	                _react2.default.createElement(_Video2.default, null),
	                _react2.default.createElement(_Popup2.default, null),
	                _react2.default.createElement(_Navigation2.default, null),
	                _react2.default.createElement(_Splash2.default, null),
	                this.props.children
	            );
	        }
	    }]);
	
	    return App;
	}(_react.Component);
	
	App.contextTypes = {
	    router: _propTypes2.default.object.isRequired
	};
	exports.default = App;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CountDown = function (_Component) {
	    _inherits(CountDown, _Component);
	
	    function CountDown(props) {
	        _classCallCheck(this, CountDown);
	
	        var _this = _possibleConstructorReturn(this, (CountDown.__proto__ || Object.getPrototypeOf(CountDown)).call(this, props));
	
	        _this.state = {
	            intervalId: false,
	            countDown: 8
	        };
	        return _this;
	    }
	
	    _createClass(CountDown, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.startCountdown();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps() {
	            this.startCountdown();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.state.intervalId);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'span',
	                null,
	                this.state.countDown
	            );
	        }
	    }, {
	        key: 'startCountdown',
	        value: function startCountdown() {
	            // Clear previous countdown
	            clearInterval(this.state.intervalId);
	
	            // Reset counter
	            this.setState({ countDown: 8 });
	
	            // Start new interval
	            var intervalId = setInterval(this.countDown.bind(this), 1000);
	
	            // Save interval
	            this.setState({ intervalId: intervalId });
	        }
	    }, {
	        key: 'countDown',
	        value: function countDown() {
	            if (this.props.stopCountDown) return;
	
	            if (this.state.countDown === 0) {
	                this.props.countDownFinished();
	            } else {
	                this.setState({ countDown: this.state.countDown - 1 });
	            }
	        }
	    }]);
	
	    return CountDown;
	}(_react.Component);
	
	exports.default = CountDown;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EndOfStory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(20);
	
	var _Icons = __webpack_require__(53);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	__webpack_require__(618);
	
	var _timeline = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EndOfStory = exports.EndOfStory = function (_Component) {
	    _inherits(EndOfStory, _Component);
	
	    function EndOfStory() {
	        _classCallCheck(this, EndOfStory);
	
	        return _possibleConstructorReturn(this, (EndOfStory.__proto__ || Object.getPrototypeOf(EndOfStory)).apply(this, arguments));
	    }
	
	    _createClass(EndOfStory, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'EndOfStory' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'EndOfStory__inner' },
	                    _react2.default.createElement(_Icons2.default, { type: 'endOfStoryArrow' }),
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'active', onClick: this.backToVideo.bind(this) },
	                        this.props.backButtonLabel
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'backToVideo',
	        value: function backToVideo() {
	            this.props.startDriving();
	            this.context.router.push("/");
	        }
	    }]);
	
	    return EndOfStory;
	}(_react.Component);
	
	EndOfStory.contextTypes = {
	    router: _propTypes2.default.object.isRequired
	};
	exports.default = (0, _reactRedux.connect)(null, { startDriving: _timeline.startDriving })(EndOfStory);

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(619);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Iframe = function (_Component) {
	    _inherits(Iframe, _Component);
	
	    function Iframe() {
	        _classCallCheck(this, Iframe);
	
	        return _possibleConstructorReturn(this, (Iframe.__proto__ || Object.getPrototypeOf(Iframe)).apply(this, arguments));
	    }
	
	    _createClass(Iframe, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                url = _props.url,
	                title = _props.title,
	                text = _props.text;
	
	
	            var textHTML = text ? this.buildText(text) : null;
	
	            var spacer = this.props.hideSpacer ? null : _react2.default.createElement('div', { className: 'Iframe__vertical-spacer' });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Iframe' },
	                spacer,
	                _react2.default.createElement('iframe', { src: url, width: '240', height: '135', frameBorder: '0', title: title, allowFullScreen: true }),
	                textHTML
	            );
	        }
	    }, {
	        key: 'buildText',
	        value: function buildText(text) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'Iframe__inner' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'Iframe__text' },
	                    text
	                )
	            );
	        }
	    }]);
	
	    return Iframe;
	}(_react.Component);
	
	exports.default = Iframe;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(621);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Paragraph = function (_Component) {
	    _inherits(Paragraph, _Component);
	
	    function Paragraph() {
	        _classCallCheck(this, Paragraph);
	
	        return _possibleConstructorReturn(this, (Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).apply(this, arguments));
	    }
	
	    _createClass(Paragraph, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                text = _props.text,
	                title = _props.title;
	
	
	            var titleEl = title ? this.buildTitle(title) : null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Paragraph' },
	                titleEl,
	                _react2.default.createElement(
	                    'p',
	                    { className: 'Paragraph__inner' },
	                    text
	                )
	            );
	        }
	    }, {
	        key: 'buildTitle',
	        value: function buildTitle(title) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'Paragraph__header' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    title
	                ),
	                _react2.default.createElement('div', { className: 'Paragraph__vertical-spacer' })
	            );
	        }
	    }]);
	
	    return Paragraph;
	}(_react.Component);
	
	exports.default = Paragraph;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(622);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Quote = function (_Component) {
	    _inherits(Quote, _Component);
	
	    function Quote() {
	        _classCallCheck(this, Quote);
	
	        return _possibleConstructorReturn(this, (Quote.__proto__ || Object.getPrototypeOf(Quote)).apply(this, arguments));
	    }
	
	    _createClass(Quote, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                quote = _props.quote,
	                person = _props.person;
	
	
	            var quotePlus = person ? '\u201C' + quote + '\u201D' : quote;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Quote' },
	                _react2.default.createElement('div', { className: 'Quote__vertical-spacer' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'Quote__text' },
	                    quotePlus
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'Quote__person' },
	                    person
	                ),
	                _react2.default.createElement('div', { className: 'Quote__vertical-spacer' })
	            );
	        }
	    }]);
	
	    return Quote;
	}(_react.Component);
	
	exports.default = Quote;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(207);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _Image = __webpack_require__(133);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	__webpack_require__(623);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slider = function (_Component) {
	    _inherits(Slider, _Component);
	
	    function Slider() {
	        _classCallCheck(this, Slider);
	
	        return _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
	    }
	
	    _createClass(Slider, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var images = this.props.images;
	
	
	            var settings = {
	                arrows: false,
	                dots: false,
	                infinite: true,
	                speed: 300,
	                adaptiveHeight: false,
	                slidesToShow: 1,
	                slidesToScroll: 1
	            };
	
	            var imagesHTML = this.buildImages(images);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Slider' },
	                _react2.default.createElement('div', { className: 'Slider__vertical-spacer' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'Slider__Carousel' },
	                    _react2.default.createElement(
	                        _reactSlick2.default,
	                        Object.assign({ ref: function ref(c) {
	                                return _this2.slider = c;
	                            } }, settings),
	                        imagesHTML
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Slider__ControlArrow Slider__ControlArrow--left', onClick: this.previous.bind(this) },
	                        _react2.default.createElement('span', null),
	                        _react2.default.createElement('span', null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Slider__ControlArrow Slider__ControlArrow--right', onClick: this.next.bind(this) },
	                        _react2.default.createElement('span', null),
	                        _react2.default.createElement('span', null)
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'Slider__vertical-spacer' })
	            );
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            this.slider.slickNext();
	        }
	    }, {
	        key: 'previous',
	        value: function previous() {
	            this.slider.slickPrev();
	        }
	    }, {
	        key: 'buildImages',
	        value: function buildImages(images) {
	            return images.map(function (image, index) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: index },
	                    _react2.default.createElement(_Image2.default, { image: image })
	                );
	            });
	        }
	    }]);
	
	    return Slider;
	}(_react.Component);
	
	exports.default = Slider;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(20);
	
	var _reactRouter = __webpack_require__(81);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _timeline = __webpack_require__(19);
	
	var _CountDown = __webpack_require__(228);
	
	var _CountDown2 = _interopRequireDefault(_CountDown);
	
	var _ImageSrcSet = __webpack_require__(134);
	
	var _ImageSrcSet2 = _interopRequireDefault(_ImageSrcSet);
	
	var _Body = __webpack_require__(132);
	
	var _Body2 = _interopRequireDefault(_Body);
	
	var _EndOfStory = __webpack_require__(229);
	
	var _EndOfStory2 = _interopRequireDefault(_EndOfStory);
	
	var _Icons = __webpack_require__(53);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	__webpack_require__(617);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DetailPage = function (_Component) {
	    _inherits(DetailPage, _Component);
	
	    function DetailPage() {
	        _classCallCheck(this, DetailPage);
	
	        return _possibleConstructorReturn(this, (DetailPage.__proto__ || Object.getPrototypeOf(DetailPage)).apply(this, arguments));
	    }
	
	    _createClass(DetailPage, [{
	        key: 'render',
	        value: function render() {
	            if (this.props.isDriving) return null;
	
	            var className = (0, _classnames2.default)({
	                "DetailPage__inner": true,
	                "DetailPage__inner--open": this.props.open,
	                "DetailPage__inner--menuOpen": this.props.isMenuOpen
	            });
	
	            var classNamePage = (0, _classnames2.default)({
	                "DetailPage__pageWrapper": true,
	                "DetailPage__pageWrapper--open": this.props.open
	            });
	
	            var classNameHeaderImage = (0, _classnames2.default)({
	                "DetailPage__headerImage": true,
	                "DetailPage__headerImage--open": this.props.open
	            });
	
	            var _props$story = this.props.story,
	                title = _props$story.title,
	                image = _props$story.image;
	
	
	            var header = this.buildHeader(title);
	            var preview = this.buildPreview(this.props.story);
	            var page = _react2.default.createElement(_Body2.default, { body: this.props.story.body });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'DetailPage' },
	                _react2.default.createElement(
	                    'div',
	                    { className: className },
	                    _react2.default.createElement(
	                        'div',
	                        { className: classNameHeaderImage },
	                        _react2.default.createElement(_ImageSrcSet2.default, image)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'DetailPage__body' },
	                        header,
	                        preview,
	                        _react2.default.createElement(
	                            'div',
	                            { className: classNamePage },
	                            page,
	                            _react2.default.createElement(_EndOfStory2.default, { backButtonLabel: this.props.video.terugNaarRoadMovie })
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'buildHeader',
	        value: function buildHeader() {
	            var _props$story2 = this.props.story,
	                title = _props$story2.title,
	                location = _props$story2.location,
	                readingTime = _props$story2.readingTime;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'DetailPage__header' },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'DetailPage__title' },
	                    title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'DetailPage__meta' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'DetailPage__meta__location' },
	                        _react2.default.createElement(_Icons2.default, { type: 'pin', color: 'green' }),
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            location.name
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'DetailPage__meta__readingTime' },
	                        _react2.default.createElement(_Icons2.default, { type: 'clock', color: 'green' }),
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            readingTime
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'buildPreview',
	        value: function buildPreview() {
	            var _this2 = this;
	
	            var className = (0, _classnames2.default)({
	                "DetailPage__preview": true,
	                "DetailPage__preview--open": this.props.open
	            });
	
	            var rijVerder = this.props.video.rijVerder;
	            var _props$story3 = this.props.story,
	                link = _props$story3.link,
	                excerpt = _props$story3.excerpt;
	
	
	            var countdown = this.props.open || this.props.isMenuOpen ? "8" : _react2.default.createElement(_CountDown2.default, { countDownFinished: this.props.startDriving });
	
	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'DetailPage__excerpt' },
	                    excerpt
	                ),
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { className: 'DetailPage__button', to: link.url },
	                    link.label
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'DetailPage__drive-link', onClick: function onClick() {
	                            return _this2.props.startDriving();
	                        } },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'active' },
	                        rijVerder,
	                        ' (',
	                        countdown,
	                        ' sec)'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DetailPage;
	}(_react.Component);
	
	DetailPage.contextTypes = {
	    router: _propTypes2.default.object.isRequired
	};
	
	
	function mapStateToProps(_ref) {
	    var timeline = _ref.timeline,
	        video = _ref.video;
	
	    return {
	        story: timeline.showStory,
	        open: timeline.storyIsOpen,
	        isMenuOpen: timeline.isMenuOpen,
	        isDriving: timeline.isDriving,
	        video: video
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { startDriving: _timeline.startDriving, openStory: _timeline.openStory, closeStory: _timeline.closeStory })(DetailPage);

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IsraelMap = function (_Component) {
	    _inherits(IsraelMap, _Component);
	
	    function IsraelMap() {
	        _classCallCheck(this, IsraelMap);
	
	        return _possibleConstructorReturn(this, (IsraelMap.__proto__ || Object.getPrototypeOf(IsraelMap)).apply(this, arguments));
	    }
	
	    _createClass(IsraelMap, [{
	        key: 'render',
	        value: function render() {
	            var maps = this.props.maps;
	
	
	            return _react2.default.createElement(
	                'svg',
	                { width: '100%', height: '100%', viewBox: '0 0 265 534', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                _react2.default.createElement(
	                    'defs',
	                    null,
	                    _react2.default.createElement('polygon', { id: 'path-1', points: '0 498.111 201.94 498.111 201.94 0 0 0' })
	                ),
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Mobiel', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Navigatie-A-\u2013-Israel' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'Page-1', transform: 'translate(38.000000, 4.000000)' },
	                            _react2.default.createElement(
	                                'mask',
	                                { id: 'mask-2', fill: 'white' },
	                                _react2.default.createElement('use', { xlinkHref: '#path-1' })
	                            ),
	                            _react2.default.createElement('g', { id: 'Clip-58' }),
	                            _react2.default.createElement('polyline', { id: 'Stroke-1', stroke: '#FFFFFF', strokeWidth: '1.2', mask: 'url(#mask-2)', points: '15.791 280.4279 16.89 279.4259 17.08 278.6949 20.198 276.9739 21.996 275.9659 23.173 273.3389 24.15 272.7199 25.13 272.2839 25.768 271.8939 26.175 271.0029 26.055 269.0879 25.544 266.7189 25.371 262.7289 26.393 261.2209 28.73 258.2029 29.868 257.4249 31.412 255.6399 32.663 254.5409 36.391 250.9489 39.298 247.4509 40.32 246.8089 41.549 245.9839 41.844 245.5039 44.211 244.2649 44.621 243.8759 44.777 242.9179 45.391 242.5509 45.73 241.6599 44.582 239.3839 41.495 236.6579 40.032 235.5689 38.763 234.3939' }),
	                            _react2.default.createElement('path', { d: 'M103.1494,46.6872 L124.7964,45.6042 L127.2024,49.6932 C127.2024,49.6932 130.0884,51.7382 130.9304,51.7382 C131.7724,51.7382 136.9434,50.1752 136.9434,50.1752 L138.9884,47.4092 L143.7984,47.0482 L146.8044,42.5982 L148.6094,30.0912 C148.6094,30.0912 151.9764,21.5522 152.2164,22.0332 C152.4574,22.5142 155.3434,27.3252 155.7054,27.4452 C156.0654,27.5652 159.3124,27.6862 159.3124,27.6862 L161.5974,26.8442 L161.9584,33.2182 L159.3124,51.4982 L158.3504,72.5432 L160.1544,76.6322 L159.5524,82.0442 L161.3574,88.8992 L159.4324,97.6782 L155.9454,100.4442 L154.3814,103.0902 L151.0144,103.0902 L151.3754,106.6982 L153.5404,113.9142 L149.9314,116.9202 L151.2544,121.7312 L151.1344,126.1812 L150.4134,134.5992 L150.6534,142.4162 L151.3754,150.8342 L151.8564,158.0502 L149.3314,169.5962 L147.1664,178.0142 L149.6914,186.0722 L148.4894,192.9272 L147.4064,196.1742 L149.8114,200.9842 L149.6914,206.9982 L151.4954,213.6122 L143.5574,244.7602 L142.3554,258.9512 L139.3484,266.5282 L135.2594,273.5032 L135.3794,278.6742 L140.9124,287.0932 L140.9124,296.4732 L136.8234,304.6512 L135.6214,310.9052 L135.1394,315.5952 L129.2474,321.1272 L128.5254,330.1462 L124.4364,336.1602 L122.5114,346.0212 L116.0174,357.8072 L113.4924,370.0742 L110.4854,377.4102 L111.3274,383.4232 L112.5304,389.0762 L109.0434,401.9442 L109.8844,410.3622 L110.7264,420.1032 L104.5924,428.2812 L102.6694,438.3832 L100.9854,448.8462 L94.6114,473.6212 L91.9644,482.7602 L91.4844,489.7362 L87.8764,489.1342 L82.9454,496.8322 L77.7744,484.6842 L80.6604,479.2732 L77.4134,468.9302 L69.5964,445.4792 L64.4244,423.9522 L54.6834,398.4562 L51.4364,387.6322 L43.1384,382.5822 L45.5444,372.4792 L41.2134,367.1882 L41.3354,359.3712 L33.6374,335.6792 L27.8654,324.0132 L15.2374,283.9662 L9.4644,267.9712 L25.5804,251.8552 L38.4484,234.5382 L49.7534,216.0172 L57.8104,198.6992 L66.8304,174.2862 L74.4074,148.4292 L80.0594,126.9022 L84.2684,105.0152 L86.7944,89.6212 L87.6354,79.7592 L90.7624,78.9172 L94.3704,81.4432 L99.4214,76.9932 L100.0224,67.4932 L103.1494,46.6872 Z', id: 'Stroke-93', stroke: '#FFFFFF', mask: 'url(#mask-2)' }),
	                            _react2.default.createElement('polyline', { id: 'Stroke-94', stroke: '#00FF00', strokeWidth: '2', mask: 'url(#mask-2)', points: '149.2227 133.467 148.3807 134.148 146.5317 133.196 144.3187 132.634 141.3747 132.006 136.3737 129.834 136.4097 127.257 136.6517 124.2 136.7857 123.516 136.0057 122.219 135.1357 120.831 134.7457 120.308 131.5737 119.339 129.2687 118.73 127.8997 118.689 125.1897 119.497 123.2057 119.526 120.7427 119.215 116.4667 115.832 115.8487 115.127 115.5057 114.855 114.7777 115.108 114.3747 115.416 110.7967 118.155 110.5257 118.703 109.0277 120.577 107.8677 121.63 105.8187 122.299 104.5427 123.009 104.0447 123.741 102.5387 123.655 101.8107 124.045 100.8577 125.257 99.5657 127.518 99.2027 128.591 98.9317 129.161 98.8887 129.892 98.2307 130.669 98.1877 131.307 98.2577 132.106 98.5567 132.857 97.4677 134.297 97.2427 135.096 97.2027 136.112 97.1797 136.829 97.4347 137.968 97.3687 138.812 97.2577 139.679 96.9397 139.953 96.4837 139.955 95.5297 140.757 94.5257 140.737 94.5967 141.694 94.2407 144.226 93.6747 145.573 93.9547 147.42 93.5247 148.242 93.7527 148.561 94.4847 148.695 95.7007 150.88 95.2907 151.383 95.1587 152.546 95.2977 153.549 94.6617 154.44 93.9997 154.192 93.8207 155.013 93.2297 155.358 92.0237 156.068 91.6377 156.661 89.6157 158.607 88.6597 159.249 88.3187 159.614 88.0697 160.253 88.3697 161.142 89.5607 162.962 89.6787 163.919 89.8177 164.625 90.5247 164.623 90.9817 165.01 91.4627 165.555 91.1917 166.354 91.1967 167.699 91.7497 169.773 92.0037 170.683 91.5957 171.3 91.2567 172.282 90.9177 172.967 91.7177 173.717 92.2437 174.285 92.8867 175.263 93.0987 177.315 93.1017 178.227 93.2647 179.343 93.5647 180.05 92.9517 181.078 92.4097 182.356 92.2757 183.519 92.5767 184.567 92.6247 185.821 92.1257 186.53 91.7407 187.33 91.3107 188.219 91.5887 189.245 92.0297 191.501 92.2847 192.845 95.1197 195.184 95.3747 196.506 95.5377 197.531 95.6317 198.283 95.3847 199.379 89.7347 200.606 89.5097 201.402 89.1487 202.683 88.9927 203.687 88.8817 204.781 88.9747 205.329 89.7067 206.056 90.6417 206.075 91.6007 206.346 95.4987 206.218 96.5487 206.352 97.5477 205.414 98.1387 204.591 98.6837 204.019 99.0927 203.356 99.5697 203.036 99.9337 202.897 100.7577 203.647 102.7627 204.36 104.3187 204.911 105.0947 205.114 106.9007 206.613 107.8827 207.089 109.0247 207.359 110.8017 207.329 112.1707 207.325 113.4487 207.617 114.4517 207.774 115.6617 208.317 115.9157 209.092 115.8977 210.367 115.9007 211.402 115.6777 212.763 116.4787 213.626 116.4347 214.288 116.2437 215.115 116.1897 215.794 115.0047 216.003 114.8887 215.547 113.9067 215.231 112.8817 215.417 112.0157 215.603 110.7407 215.743 110.0337 215.86 109.6457 216.066 108.9397 216.183 108.2107 216.664 107.7107 217.054 107.3717 217.488 106.8927 217.672 106.4817 217.605 105.9107 217.584 105.3437 218.156 104.8667 218.637 104.3237 219.733 103.4577 220.078 102.0007 220.767 101.7977 221.338 101.5267 222.296 101.1877 222.776 100.6407 223.12 97.1137 225.206 94.5657 226.788 93.3827 227.591 92.1317 228.552 90.9947 229.559 90.2017 231.135 90.0467 232.367 87.6827 234.382 87.3667 235.318 86.9147 236.642 87.1507 238.898 86.9307 241.247 86.9587 243.185 87.3037 243.845 87.1697 244.78 86.9017 246.264 86.2457 248.09 84.8857 250.147 83.9557 251.7 83.3877 252.386 82.9137 253.825 81.5517 255.585 80.4677 258.552 81.7587 262.675 83.2217 264.015 86.6007 265.098 88.3547 264.705 91.0197 264.057 92.3187 263.665 93.9127 263.273 95.5087 263.29 97.4937 263.602 99.8657 263.343 101.9857 263.314 104.1057 263.329 106.4317 263.526 109.6667 262.786 111.5117 262.164 111.8537 262.163 116.0247 261.625 118.8237 259.769 120.1187 258.19 121.8457 256.885 124.4167 255.189 126.5777 254.11 128.1237 252.395 130.0567 250.701 131.8267 248.597 132.9197 247.932 135.5157 247.034 138.1597 246.547 140.1197 246.335 143.0707 246.171' })
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'route-60', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '33', y: '78' },
	                                maps.route60
	                            )
	                        ),
	                        _react2.default.createElement('path', { d: 'M161.372786,102.040527 L161.372786,102.800487 L161.372786,104.638825 L161.036991,109.639351 L160.797354,111.404227 L161.08507,111.649443 L161.08507,113.316026 L161.372786,114.492696 L161.948218,115.326117 L163.674767,116.845779 L164.250452,117.973561 L164.250452,119.248008 L164.490089,123.660328 L163.531036,125.033067 L162.643595,126.454694 L162.427998,128.121536 L162.188108,128.905811 L162.475824,130.474618 L162.643595,131.45522 L162.643595,132.14146 L162.379919,132.48471 L162.044124,133.5142 L161.756408,134.494801 L160.797354,135.279076 L159.358521,135.622325 L158.207404,136.651815 L156.480855,137.387202 L155.090101,137.387202 L154.46659,137.779339 L153.987063,139.054044 L153.699347,140.071118 L153.171741,141.161911 L152.596056,142.289435 L152.260514,143.024822 L152.260514,144.397561 L152.068703,145.766679 L151.157476,147.289961 L150.581791,148.319451 L151.013491,149.545268 L151.157476,150.427577 L151.013491,150.966895 L150.342154,151.702282 L149.574658,151.702282 L149.574658,152.633737 L148.855242,153.025874 L148.27981,153.663227 L148.27981,154.496648 L148.759336,155.47725 L148.807416,156.359558 L148.519447,157.536229 L147.992094,158.075547 L148.327636,158.761787 L149.142958,159.546062 C149.142958,159.546062 149.047052,160.183414 149.047052,160.330595 C149.047052,160.477517 148.47162,161.360085 148.47162,161.360085 L147.992094,161.360085 L147.608219,160.477517 L147.128693,159.938458 L146.840977,159.840423 L146.840977,160.477517 L146.601087,161.360085 C146.601087,161.360085 146.457355,162.634789 146.601087,162.683677 C146.745071,162.732824 147.176772,163.958382 147.176772,163.958382 L147.272677,165.18394 L147.560393,166.21343 L147.848109,166.850782 L148.519447,167.831384 L148.759336,169.253011 L149.382848,169.841217 L150.38998,170.233354 L151.157476,170.233354 L152.356419,170.233354 L153.363552,170.62575 L154.274779,170.62575 C154.274779,170.62575 154.754306,171.115922 154.89829,171.115922 C155.042022,171.115922 155.953249,172.096524 155.953249,172.096524 L156.960381,173.076867 L157.583893,173.959435 L157.631972,174.792856 L157.296177,176.361405 L157.248351,178.469531 L156.960381,179.597055 L157.248351,180.920906 L157.152445,181.950396 L156.433029,182.636636 L156.049154,183.077919 L156.049154,183.76416 L156.81665,183.911341 L157.487987,184.058263 L158.015593,184.548693 L157.775703,185.725105 L156.960381,186.362457 L156.14506,186.705707 L156.097233,187.489981 L156.097233,188.17648 L157.056287,188.421437 L158.063672,188.274514 L158.830915,188.078446 L159.742142,188.421437 L160.269748,188.960755 L160.84518,190.235459 L160.65337,190.872812 L159.886127,191.314096 L158.9749,191.902301 L158.92682,192.686576 L159.070805,193.716066 L158.639104,194.206496 L158.063672,194.892736 L157.871609,195.628123 L157.152445,196.069407 L156.720745,196.559578 L156.57676,197.638214 L156.241218,198.961807 L156.289044,199.844116 L156.720745,201.167967 L157.152445,202.589594 L157.056287,203.471903 L157.152445,204.256436 L156.960381,204.893789 L156.289044,205.678063 L156.049154,206.609519 L156.14506,207.148837 L156.049154,208.325507 L156.14506,209.354997 L156.864476,210.237306 L157.775703,210.874658 L158.73501,211.757226 L159.118631,212.296544 L159.262616,212.933637 L158.878994,213.767058 L158.443751,214.306377 L157.775703,214.943729 L157.392082,215.188944 L157.392082,215.875184 L157.631972,216.316468 L157.871609,216.708605 L158.111499,217.247923 L157.200271,217.542026 L156.384949,217.542026 L155.513704,217.149889 L154.592355,216.953821 L154.130794,216.610571 L153.843078,216.46339 C153.843078,216.46339 153.459457,216.80664 153.459457,216.953821 L153.459457,217.885276 L153.843078,218.66955 C153.843078,218.66955 154.034889,219.208868 154.034889,219.356049 L154.034889,220.238358 L154.370684,220.777676 L154.370684,221.635671 L154.592355,222.346484 L154.754306,223.621189 L154.946116,224.11136 L154.802385,224.601532 L154.994196,225.336919 L154.802385,225.876237 L154.592355,226.807692 L154.034889,227.788035 L154.178874,228.768637 L154.2267,229.650946 L153.747173,230.925651 L153.267646,231.808218 L152.691961,232.641639 L151.972798,232.98463 L151.205302,233.377026 L150.677696,233.621983 L150.294075,234.602584 L149.95828,235.043868 L149.286942,235.043868 L149.047052,235.386859 L149.047052,236.024211 L149.382848,236.367461 L149.238863,236.759598 C149.238863,236.759598 148.807416,237.151735 148.759336,237.298916 C148.71151,237.445838 148.47162,237.642166 148.47162,237.642166 L148.03992,238.034303 L147.992094,238.622509 L148.231731,239.063793 L147.800283,239.701145 L147.416409,240.044136 L147.176772,240.48542 L147.176772,241.122772 L147.176772,242.00534 L147.032787,242.34833 L146.025655,242.746676 L145.833844,243.181751 L145.833844,244.064319 L145.833844,244.89774 L146.649166,245.829195 L146.889056,246.466548 L146.649166,246.907573 L146.36145,247.348857 L146.745071,247.79014 L147.128693,248.13339 L147.320503,248.623561 L147.320503,249.701939 L147.176772,250.927756 L147.224598,251.515962 L147.224598,252.202202 C147.224598,252.202202 147.128693,252.790667 146.984961,252.839554 C146.840977,252.888701 146.649166,253.084769 146.457355,253.084769 C146.265545,253.084769 145.737939,253.182804 145.593954,253.231692 C145.450223,253.280838 144.44309,253.526053 144.44309,253.526053 L143.100162,253.672975 L142.764367,254.016225 L141.997124,254.310328 L141.373613,254.653577 L140.846007,254.94768 L140.366481,255.683067 L139.838875,256.271273 L139.263443,256.859737 L139.215364,257.594865 L139.119458,258.428287 L139.119458,259.261708 C139.119458,259.261708 139.790796,260.144275 139.790796,260.291456 C139.790796,260.438378 139.838875,261.517014 139.838875,261.517014 L139.69489,262.10522 L139.071379,262.79146 L138.495947,263.13471 L137.920515,263.428813 L137.680625,264.213346 L136.193966,264.703518 L134.659227,266.51754 L132.453152,267.007712 L132.021451,267.988055 L131.302035,269.066691 L129.959107,270.390284 L128.520274,271.81217 L127.800857,272.302341 L126.506009,272.645591 L125.594781,273.920037 L124.731633,274.557389 L124.299933,275.047561 L123.484611,275.586879 L122.957005,275.930128 L122.429399,276.322266', id: 'Page-1', stroke: '#FFFFFF', strokeLinecap: 'round', strokeLinejoin: 'round', strokeDasharray: '1,5' }),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'be\xEBr-sjeva', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '90', y: '285' },
	                                maps.beersjeva
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'Jeruzalem', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '105.90332', y: '230' },
	                                maps.jeruzalem
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'tel-aviv', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '55', y: '175' },
	                                maps.telaviv
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'egypte', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#5E5E5E' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '25', y: '421' },
	                                maps.egypte
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'jordani\xEB', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#5E5E5E' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '207', y: '338' },
	                                maps.jordanie
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { fontFamily: 'Stanley', fontSize: '18', fontWeight: '800', letterSpacing: '-0.5625', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '96', y: '337' },
	                                maps.israel
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'nazareth', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '131', y: '97' },
	                                maps.nazareth
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'golan', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#5E5E5E' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '208', y: '63' },
	                                maps.golan
	                            )
	                        ),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy', fill: '#FFFFFF', cx: '161.5', cy: '102.5', r: '1.5' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy-2', fill: '#FFFFFF', cx: '109.5', cy: '176.5', r: '1.5' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy-3', fill: '#FFFFFF', cx: '125.5', cy: '273.5', r: '1.5' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy-3', fill: '#FFFFFF', cx: '153.5', cy: '219.5', r: '1.5' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy-6', fill: '#FFFFFF', cx: '58.5', cy: '267.5', r: '1.5' }),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'libanon', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#5E5E5E' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '155', y: '17' },
	                                maps.libanon
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'gaza', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '24', y: '257' },
	                                maps.gaza
	                            )
	                        ),
	                        _react2.default.createElement('polyline', { id: 'Path-3', stroke: '#00FF40', strokeWidth: '2', points: '187.294922 137.792969 188.833984 141.387695 190.139648 162.348633 185.498047 181.640625 187.962891 191.110352 185.730469 200.62793 188.148438 205.640625 187.955078 211.273438 189.743164 218.212891 181.135742 250.854492' }),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'Isra\xEBl', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '33', y: '33' },
	                                maps.israel
	                            )
	                        ),
	                        _react2.default.createElement('rect', { id: 'Rectangle-5-Copy', fill: '#00FF40', x: '15', y: '45', width: '10', height: '1' }),
	                        _react2.default.createElement('rect', { id: 'Rectangle-5-Copy-2', fill: '#FFFFFF', x: '15', y: '30', width: '10', height: '1' }),
	                        _react2.default.createElement('path', { d: 'M15.5,75.5 L27.5,75.5', id: 'Line', stroke: '#FFFFFF', strokeLinecap: 'square', strokeDasharray: '1,3' }),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'Westelijke-Jordaanoe', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '33', y: '48' },
	                                maps.westelijke,
	                                ' '
	                            ),
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '33', y: '62' },
	                                maps.jordaanoever,
	                                ' '
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return IsraelMap;
	}(_react.Component);
	
	function mapStateToProps(_ref) {
	    var maps = _ref.maps;
	
	    return {
	        maps: maps
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(IsraelMap);

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(207);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _NavigationMap = __webpack_require__(237);
	
	var _NavigationMap2 = _interopRequireDefault(_NavigationMap);
	
	var _IsraelMap = __webpack_require__(235);
	
	var _IsraelMap2 = _interopRequireDefault(_IsraelMap);
	
	var _WestbankMap = __webpack_require__(238);
	
	var _WestbankMap2 = _interopRequireDefault(_WestbankMap);
	
	__webpack_require__(625);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Maps = function (_Component) {
	    _inherits(Maps, _Component);
	
	    function Maps() {
	        _classCallCheck(this, Maps);
	
	        return _possibleConstructorReturn(this, (Maps.__proto__ || Object.getPrototypeOf(Maps)).apply(this, arguments));
	    }
	
	    _createClass(Maps, [{
	        key: 'render',
	        value: function render() {
	            var settings = {
	                arrows: false,
	                dots: true,
	                infinite: true,
	                speed: 300,
	                adaptiveHeight: false,
	                slidesToShow: 1,
	                slidesToScroll: 1
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Maps' },
	                _react2.default.createElement(
	                    _reactSlick2.default,
	                    settings,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Maps__slide' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'Maps__map' },
	                            _react2.default.createElement(_NavigationMap2.default, null)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Maps__slide' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'Maps__map' },
	                            _react2.default.createElement(_WestbankMap2.default, null)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Maps__slide' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'Maps__map' },
	                            _react2.default.createElement(_IsraelMap2.default, null)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Maps;
	}(_react.Component);
	
	exports.default = Maps;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(20);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(627);
	
	var _timeline = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavigationMap = function (_Component) {
	    _inherits(NavigationMap, _Component);
	
	    function NavigationMap() {
	        _classCallCheck(this, NavigationMap);
	
	        return _possibleConstructorReturn(this, (NavigationMap.__proto__ || Object.getPrototypeOf(NavigationMap)).apply(this, arguments));
	    }
	
	    _createClass(NavigationMap, [{
	        key: 'render',
	        value: function render() {
	            var classNameNavigationMap = (0, _classnames2.default)({
	                "NavigationMap": true,
	                "NavigationMap--open": this.props.isMenuOpen,
	                "NavigationMap--storyOpen": this.props.isStoryOpen
	            });
	
	            var _props = this.props,
	                language = _props.language,
	                maps = _props.maps;
	            var dekiloknaller = maps.dekiloknaller,
	                destandvastige = maps.destandvastige,
	                dedemonstrant = maps.dedemonstrant,
	                devrienden = maps.devrienden,
	                depuber = maps.depuber,
	                deheilige = maps.deheilige,
	                depionier = maps.depionier;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: classNameNavigationMap },
	                _react2.default.createElement(
	                    'svg',
	                    { width: '100%', height: '100%', viewBox: '0 0 296 507', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Mobiel', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'Navigatie-C-\u2013-Route-60-\u2013-Default-Kaart' },
	                            _react2.default.createElement(
	                                'text',
	                                { onClick: this.goToLink.bind(this, dekiloknaller.slug), id: 'Gush-Etzion', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: language === "nl" ? 18 : 12, y: '400' },
	                                    dekiloknaller.location,
	                                    ' '
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'text',
	                                { onClick: this.goToLink.bind(this, destandvastige.slug), id: 'Jeruzalem', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: '173', y: '347' },
	                                    destandvastige.location
	                                )
	                            ),
	                            _react2.default.createElement('path', { d: 'M158.62263,8 L158.62263,10.1500438 L158.62263,15.3509836 L157.651524,29.4982423 L156.958505,34.4913494 L157.790567,35.1851008 L157.790567,39.9001219 L158.62263,43.2291039 L160.286755,45.5869804 L165.279862,49.8863361 L166.944719,53.0770069 L166.944719,56.6826113 L167.637739,69.165745 L164.864197,73.0494354 L162.297756,77.0714369 L161.674258,81.7871899 L160.980506,84.0060233 L161.812569,88.4444221 L162.297756,91.2186957 L162.297756,93.160175 L161.535215,94.1312805 L160.564109,97.0438654 L159.732047,99.818139 L156.958505,102.036972 L152.79746,103.008078 L149.468478,105.920663 L144.475371,108.001185 L140.45337,108.001185 L138.650202,109.110602 L137.263431,112.716938 L136.431368,115.594396 L134.905554,118.680419 L133.240697,121.870358 L132.270324,123.95088 L132.270324,124.783675 L132.270324,127.834571 L131.715615,131.708016 L129.080385,136.017617 L127.415528,138.930201 L128.663987,142.398226 L129.080385,144.894414 L128.663987,146.420228 L126.722508,148.50075 L124.502943,148.50075 L124.502943,149.887521 L124.502943,151.135981 L122.42242,152.245398 L120.758295,154.048566 L120.758295,155.019671 L120.758295,156.406442 L122.145066,159.180716 L122.284109,161.676904 L121.451315,165.005886 L119.926233,166.531699 L119.926233,167.363762 L120.896607,168.473179 L123.254483,170.692012 C123.254483,170.692012 122.977129,172.49518 122.977129,172.911577 C122.977129,173.327243 121.313004,175.824162 121.313004,175.824162 L119.926233,175.824162 L118.816084,173.327243 L117.429313,171.802161 L116.597251,171.524807 L116.597251,173.327243 L115.903499,175.824162 C115.903499,175.824162 115.487834,179.430499 115.903499,179.56881 C116.319897,179.707853 117.568356,183.175146 117.568356,183.175146 L117.845711,186.642439 L118.677773,189.555024 L119.509836,191.358192 L121.451315,194.132466 L122.145066,198.154467 L123.948234,199.818592 L126.860819,200.928009 L129.080385,200.928009 L132.547678,200.928009 L135.460263,202.038158 L138.095493,202.038158 C138.095493,202.038158 139.482264,203.424928 139.898661,203.424928 C140.314327,203.424928 142.949557,206.199202 142.949557,206.199202 L145.862142,208.972744 L147.66531,211.469663 L147.804353,213.82754 L146.833248,218.265207 L146.694936,224.229419 L145.862142,227.419358 L146.694936,231.164738 L146.417582,234.077322 L144.33706,236.018802 L143.226911,237.267261 L143.226911,239.208741 L145.446477,239.625138 L147.387956,240.040803 L148.91377,241.428306 L148.220019,244.756556 L145.862142,246.559724 L143.504266,247.53083 L143.365954,249.749663 L143.365954,251.691874 L146.139496,252.384894 L149.052813,251.969229 L151.271646,251.41452 L153.906877,252.384894 L155.432691,253.910708 L157.096816,257.517044 L156.542108,259.320212 L154.323274,260.568672 L151.688044,262.232797 L151.549001,264.45163 L151.965398,267.364215 L150.716938,268.751718 L149.052813,270.693197 L148.497373,272.77372 L146.417582,274.022179 L145.169123,275.40895 L144.752725,278.460578 L143.782352,282.205225 L143.920663,284.701413 L145.169123,288.446792 L146.417582,292.468794 L146.139496,294.964981 L146.417582,297.184547 L145.862142,298.987715 L143.920663,301.206548 L143.226911,303.841779 L143.504266,305.367593 L143.226911,308.696575 L143.504266,311.60916 L145.584788,314.105347 L148.220019,315.908515 L150.994292,318.405435 L152.103709,319.931249 L152.520106,321.733685 L151.410689,324.091562 L150.151984,325.617375 L148.220019,327.420544 L147.110602,328.114295 L147.110602,330.055774 L147.804353,331.304234 L148.497373,332.413651 L149.191124,333.939465 L146.555893,334.771527 L144.198017,334.771527 L141.678412,333.66211 L139.013909,333.107402 L137.679096,332.136297 L136.847033,331.719899 C136.847033,331.719899 135.737617,332.691005 135.737617,333.107402 L135.737617,335.742633 L136.847033,337.961466 C136.847033,337.961466 137.401742,339.48728 137.401742,339.903677 L137.401742,342.399865 L138.372847,343.925679 L138.372847,346.353077 L139.013909,348.364078 L139.482264,351.970414 L140.036972,353.357185 L139.621307,354.743956 L140.176015,356.824478 L139.621307,358.350292 L139.013909,360.985522 L137.401742,363.759064 L137.818139,366.533338 L137.95645,369.029526 L136.569679,372.635862 L135.182908,375.132781 L133.518051,377.490658 L131.438261,378.461031 L129.218696,379.57118 L127.692882,380.264199 L126.583465,383.038473 L125.61236,384.286933 L123.67088,384.286933 L122.977129,385.257307 L122.977129,387.060475 L123.948234,388.03158 L123.531837,389.140997 C123.531837,389.140997 122.284109,390.250414 122.145066,390.666811 C122.006755,391.082476 121.313004,391.637916 121.313004,391.637916 L120.064544,392.747333 L119.926233,394.411458 L120.619252,395.659918 L119.371524,397.463086 L118.261376,398.43346 L117.568356,399.68192 L117.568356,401.485088 L117.568356,403.982007 L117.151959,404.952381 L114.239374,406.079361 L113.684666,407.310257 L113.684666,409.807177 L113.684666,412.165053 L113.684666,413.27447 L116.042542,414.800284 L116.736294,416.603452 L116.042542,417.85118 L115.21048,419.09964 L116.319897,420.348099 L117.429313,421.319205 L117.984022,422.705976 L117.984022,425.756872 L117.568356,429.224897 L117.706668,430.889022 L117.706668,432.830501 C117.706668,432.830501 117.429313,434.495358 117.013648,434.633669 C116.597251,434.772712 116.042542,435.327421 115.487834,435.327421 C114.933126,435.327421 113.407312,435.604775 112.990915,435.743086 C112.575249,435.882129 109.662664,436.57588 109.662664,436.57588 L105.778974,436.991546 L104.807869,437.962651 L102.589035,438.794714 L100.785867,439.765819 L99.2600531,440.597882 L97.8732821,442.678404 L96.3474682,444.342529 L94.6833431,446.007386 L94.5443001,448.087177 L94.266946,450.445053 L94.266946,452.80293 C94.266946,452.80293 96.2084252,455.299849 96.2084252,455.716246 C96.2084252,456.131912 96.3474682,459.183539 96.3474682,459.183539 L95.9310711,460.847665 L94.127903,462.789144 L92.4637779,463.760249 L90.7996528,464.592312 L90.1059014,466.811877 L85.8065457,468.198648 L81.3681469,473.330798 L74.9882689,474.717569 L73.7398092,477.491111 L71.6592869,480.542739 L67.7755965,484.287386 L63.614552,488.31012 L61.5340297,489.69689 L57.7893823,490.667996 L55.1541517,494.2736 L52.657964,496.076768 L51.4095043,497.463539 L49.0516278,498.989353 L47.5258139,499.960459 L46,501.069876', id: 'Page-1', stroke: '#FFFFFF', strokeDasharray: '1,3' }),
	                            _react2.default.createElement('circle', { style: { animationDelay: "1.1s" }, onClick: this.goToLink.bind(this, dedemonstrant.slug), id: 'Oval-Copy', fill: '#00FF40', cx: '145.5', cy: '291.5', r: '4.5' }),
	                            _react2.default.createElement('circle', { style: { animationDelay: "0.7s" }, onClick: this.goToLink.bind(this, deheilige.slug), id: 'Oval-Copy', fill: '#00FF40', cx: '131.5', cy: '379.5', r: '4.5' }),
	                            _react2.default.createElement('circle', { style: { animationDelay: "0.8s" }, onClick: this.goToLink.bind(this, depuber.slug), id: 'Oval-Copy-2', fill: '#00FF40', cx: '116', cy: '413.5', r: '4.5' }),
	                            _react2.default.createElement('circle', { style: { animationDelay: "1s" }, onClick: this.goToLink.bind(this, destandvastige.slug), id: 'Oval-Copy-3', fill: '#00FF40', cx: '150.5', cy: '325.5', r: '4.5' }),
	                            _react2.default.createElement('path', { style: { animationDelay: "0.9s" }, className: 'NavigationMap__Circle', onClick: this.goToLink.bind(this, deheilige.slug), d: 'M142,335.5 C142,333.014634 139.985366,331 137.5,331 C135.014634,331 133,333.014634 133,335.5 C133,337.985366 135.014634,340 137.5,340 C139.985366,340 142,337.985366 142,335.5 Z', id: 'Page-1', fill: '#00FF40' }),
	                            _react2.default.createElement(
	                                'text',
	                                { style: { animationDelay: "1.1s" }, onClick: this.goToLink.bind(this, dedemonstrant.slug), id: 'De-Demonstrant', fontFamily: 'Stanley', fontSize: '18', fontWeight: '800', letterSpacing: '-0.5625', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: language === "nl" ? 7 : 30, y: '296' },
	                                    dedemonstrant.label
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'text',
	                                { style: { animationDelay: "0.9s" }, onClick: this.goToLink.bind(this, deheilige.slug), id: 'De-Heilige', fontFamily: 'Stanley', fontSize: '18', fontWeight: '800', letterSpacing: '-0.5625', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: language === "nl" ? 48 : -5, y: '340' },
	                                    deheilige.label
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'text',
	                                { style: { animationDelay: "0.7s" }, onClick: this.goToLink.bind(this, dekiloknaller.slug), id: 'De-Kiloknaller', fontFamily: 'Stanley', fontSize: '18', fontWeight: '800', letterSpacing: '-0.5625', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: language === "nl" ? 5 : -1, y: '384' },
	                                    dekiloknaller.label
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'text',
	                                { style: { animationDelay: "1s" }, onClick: this.goToLink.bind(this, destandvastige.slug), id: 'De-Standvastige', fontFamily: 'Stanley', fontSize: '18', fontWeight: '800', letterSpacing: '-0.5625', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: '160', y: '331' },
	                                    destandvastige.label
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'text',
	                                { style: { animationDelay: "0.8s" }, onClick: this.goToLink.bind(this, depuber.slug), id: 'De-Puber', fontFamily: 'Stanley', fontSize: '18', fontWeight: '800', letterSpacing: '-0.5625', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: '127', y: '419' },
	                                    depuber.label
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'text',
	                                { onClick: this.goToLink.bind(this, dedemonstrant.slug), id: 'ramallah', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: language === "nl" ? 20 : 43, y: '312' },
	                                    dedemonstrant.location
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'text',
	                                { onClick: this.goToLink.bind(this, deheilige.slug), id: 'bethlehem', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: language === "nl" ? 61 : 8, y: '356' },
	                                    deheilige.location
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Map-Pin-White', transform: 'translate(' + (language === "nl" ? 8 : 31) + ', 304.000000)', fill: '#FFFFFF' },
	                                _react2.default.createElement('path', { d: 'M3.5,0 C1.56691152,0 0,1.5670388 0,3.5 C0,5.4329612 3.5,10.2333539 3.5,10.2333539 C3.5,10.2333539 7,5.43308848 7,3.50012728 C7,1.56716608 5.43308848,0 3.5,0 Z M3.5,4.45648933 C2.97179897,4.45648933 2.54351067,4.02820103 2.54351067,3.5 C2.54351067,2.97179897 2.97179897,2.54363795 3.5,2.54363795 C4.02820103,2.54363795 4.45636205,2.97192625 4.45636205,3.50012728 C4.45636205,4.0283283 4.02820103,4.45648933 3.5,4.45648933 Z', id: 'Shape' })
	                            ),
	                            _react2.default.createElement(
	                                'text',
	                                { onClick: this.goToLink.bind(this, depuber.slug), id: 'Kiryat-Arba', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: '141', y: '435' },
	                                    depuber.location
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Map-Pin-White', transform: 'translate(' + (language === "nl" ? 49 : -4) + ', 348.000000)', fill: '#FFFFFF' },
	                                _react2.default.createElement('path', { d: 'M3.5,0 C1.56691152,0 0,1.5670388 0,3.5 C0,5.4329612 3.5,10.2333539 3.5,10.2333539 C3.5,10.2333539 7,5.43308848 7,3.50012728 C7,1.56716608 5.43308848,0 3.5,0 Z M3.5,4.45648933 C2.97179897,4.45648933 2.54351067,4.02820103 2.54351067,3.5 C2.54351067,2.97179897 2.97179897,2.54363795 3.5,2.54363795 C4.02820103,2.54363795 4.45636205,2.97192625 4.45636205,3.50012728 C4.45636205,4.0283283 4.02820103,4.45648933 3.5,4.45648933 Z', id: 'Shape' })
	                            ),
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Map-Pin-White', transform: 'translate(' + (language === "nl" ? 6 : 0) + ', 392.000000)', fill: '#FFFFFF' },
	                                _react2.default.createElement('path', { d: 'M3.5,0 C1.56691152,0 0,1.5670388 0,3.5 C0,5.4329612 3.5,10.2333539 3.5,10.2333539 C3.5,10.2333539 7,5.43308848 7,3.50012728 C7,1.56716608 5.43308848,0 3.5,0 Z M3.5,4.45648933 C2.97179897,4.45648933 2.54351067,4.02820103 2.54351067,3.5 C2.54351067,2.97179897 2.97179897,2.54363795 3.5,2.54363795 C4.02820103,2.54363795 4.45636205,2.97192625 4.45636205,3.50012728 C4.45636205,4.0283283 4.02820103,4.45648933 3.5,4.45648933 Z', id: 'Shape' })
	                            ),
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Map-Pin-White', transform: 'translate(161.000000, 339.000000)', fill: '#FFFFFF' },
	                                _react2.default.createElement('path', { d: 'M3.5,0 C1.56691152,0 0,1.5670388 0,3.5 C0,5.4329612 3.5,10.2333539 3.5,10.2333539 C3.5,10.2333539 7,5.43308848 7,3.50012728 C7,1.56716608 5.43308848,0 3.5,0 Z M3.5,4.45648933 C2.97179897,4.45648933 2.54351067,4.02820103 2.54351067,3.5 C2.54351067,2.97179897 2.97179897,2.54363795 3.5,2.54363795 C4.02820103,2.54363795 4.45636205,2.97192625 4.45636205,3.50012728 C4.45636205,4.0283283 4.02820103,4.45648933 3.5,4.45648933 Z', id: 'Shape' })
	                            ),
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Map-Pin-White', transform: 'translate(128.000000, 427.000000)', fill: '#FFFFFF' },
	                                _react2.default.createElement('path', { d: 'M3.5,0 C1.56691152,0 0,1.5670388 0,3.5 C0,5.4329612 3.5,10.2333539 3.5,10.2333539 C3.5,10.2333539 7,5.43308848 7,3.50012728 C7,1.56716608 5.43308848,0 3.5,0 Z M3.5,4.45648933 C2.97179897,4.45648933 2.54351067,4.02820103 2.54351067,3.5 C2.54351067,2.97179897 2.97179897,2.54363795 3.5,2.54363795 C4.02820103,2.54363795 4.45636205,2.97192625 4.45636205,3.50012728 C4.45636205,4.0283283 4.02820103,4.45648933 3.5,4.45648933 Z', id: 'Shape' })
	                            ),
	                            _react2.default.createElement('circle', { style: { animationDelay: "1.3s" }, onClick: this.goToLink.bind(this, devrienden.slug), id: 'Oval-Copy-6', fill: '#00FF40', cx: '162.5', cy: '85.5', r: '4.5' }),
	                            _react2.default.createElement(
	                                'text',
	                                { style: { animationDelay: "1.3s" }, onClick: this.goToLink.bind(this, devrienden.slug), id: 'De-Vrienden', fontFamily: 'Stanley', fontSize: '18', fontWeight: '800', letterSpacing: '-0.5625', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: '174', y: '91' },
	                                    devrienden.label
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'text',
	                                { onClick: this.goToLink.bind(this, devrienden.slug), id: 'jenin', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: '187', y: '107' },
	                                    devrienden.location
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Map-Pin-White', transform: 'translate(175.000000, 99.000000)', fill: '#FFFFFF' },
	                                _react2.default.createElement('path', { d: 'M3.5,0 C1.56691152,0 0,1.5670388 0,3.5 C0,5.4329612 3.5,10.2333539 3.5,10.2333539 C3.5,10.2333539 7,5.43308848 7,3.50012728 C7,1.56716608 5.43308848,0 3.5,0 Z M3.5,4.45648933 C2.97179897,4.45648933 2.54351067,4.02820103 2.54351067,3.5 C2.54351067,2.97179897 2.97179897,2.54363795 3.5,2.54363795 C4.02820103,2.54363795 4.45636205,2.97192625 4.45636205,3.50012728 C4.45636205,4.0283283 4.02820103,4.45648933 3.5,4.45648933 Z', id: 'Shape' })
	                            ),
	                            _react2.default.createElement('circle', { style: { animationDelay: "1.2s" }, onClick: this.goToLink.bind(this, depionier.slug), id: 'Oval', fill: '#00FF40', cx: '150.5', cy: '269.5', r: '4.5' }),
	                            _react2.default.createElement(
	                                'text',
	                                { style: { animationDelay: "1.2s" }, onClick: this.goToLink.bind(this, depionier.slug), id: 'De-Pionier', fontFamily: 'Stanley', fontSize: '18', fontWeight: '800', letterSpacing: '-0.5625', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: '162', y: '275' },
	                                    depionier.label
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'text',
	                                { onClick: this.goToLink.bind(this, depionier.slug), id: 'amona', fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal', letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                                _react2.default.createElement(
	                                    'tspan',
	                                    { x: '175', y: '291' },
	                                    depionier.location
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'g',
	                                { id: 'Map-Pin-White', transform: 'translate(163.000000, 283.000000)', fill: '#FFFFFF' },
	                                _react2.default.createElement('path', { d: 'M3.5,0 C1.56691152,0 0,1.5670388 0,3.5 C0,5.4329612 3.5,10.2333539 3.5,10.2333539 C3.5,10.2333539 7,5.43308848 7,3.50012728 C7,1.56716608 5.43308848,0 3.5,0 Z M3.5,4.45648933 C2.97179897,4.45648933 2.54351067,4.02820103 2.54351067,3.5 C2.54351067,2.97179897 2.97179897,2.54363795 3.5,2.54363795 C4.02820103,2.54363795 4.45636205,2.97192625 4.45636205,3.50012728 C4.45636205,4.0283283 4.02820103,4.45648933 3.5,4.45648933 Z', id: 'Shape' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'goToLink',
	        value: function goToLink(slug) {
	            this.props.openMenu(false);
	            this.props.goToStoryBySlug(slug, false);
	        }
	    }]);
	
	    return NavigationMap;
	}(_react.Component);
	
	function mapStateToProps(_ref) {
	    var maps = _ref.maps,
	        timeline = _ref.timeline;
	
	    return {
	        maps: maps,
	        language: timeline.language
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { goToStoryBySlug: _timeline.goToStoryBySlug, openMenu: _timeline.openMenu })(NavigationMap);

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WestbankMap = function (_Component) {
	    _inherits(WestbankMap, _Component);
	
	    function WestbankMap() {
	        _classCallCheck(this, WestbankMap);
	
	        return _possibleConstructorReturn(this, (WestbankMap.__proto__ || Object.getPrototypeOf(WestbankMap)).apply(this, arguments));
	    }
	
	    _createClass(WestbankMap, [{
	        key: 'render',
	        value: function render() {
	            var maps = this.props.maps;
	
	
	            return _react2.default.createElement(
	                'svg',
	                { width: '100%', height: '100%', viewBox: '0 0 307 534', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'Mobiel', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	                    _react2.default.createElement(
	                        'g',
	                        { id: 'Navigatie-B-\u2013-Westbank' },
	                        _react2.default.createElement(
	                            'g',
	                            { id: 'Westbank', transform: 'translate(34.000000, 9.000000)' },
	                            _react2.default.createElement('path', {
	                                d: 'M58.6371644,301.905776 C59.0179057,301.816456 59.1755337,301.560096 59.168,301.185996 C59.3169353,300.994596 59.4670296,300.806676 59.617124,300.616436 C60.9534852,299.696556 60.5437682,297.958296 61.4130404,296.793076 C62.1855337,295.754876 61.9925553,294.173796 63.2408302,293.366436 C65.3873531,294.467276 67.5356146,295.566376 69.6821375,296.666056 C69.9933369,296.783796 70.3027978,296.900376 70.6105202,297.018696 C70.7930674,297.468196 70.8927439,298.026156 71.6067062,297.761096 C71.8072183,297.779076 72.0071509,297.798796 72.2059245,297.818516 C72.3293612,298.368356 72.6498329,298.660096 73.2339838,298.610216 C73.3690108,299.141496 73.6193612,299.538796 74.257407,299.470936 C74.7030539,299.630436 75.2559111,299.597956 75.5578383,300.024256 C76.5418544,301.416836 77.9605067,301.406396 79.4289973,301.295036 C80.1725148,301.238196 80.9206685,301.214996 81.666504,301.175556 C84.8265984,304.913656 88.8426361,306.881016 93.7418544,307.009196 C96.3143208,307.009196 98.884469,307.009196 101.456935,307.011516 C103.164765,306.988316 104.85521,307.063136 106.425695,307.850776 C106.891046,307.952856 107.405655,307.962136 107.810156,308.176736 C108.92804,308.767756 110.650358,308.539816 111.002704,310.172516 C111.280291,311.458376 111.721881,312.587636 112.617811,313.538256 C112.037137,314.440736 112.627084,315.344376 112.617811,316.246856 C112.507124,316.381416 112.396437,316.513656 112.28517,316.648216 C111.151059,316.696356 111.698701,317.573896 111.600763,318.099956 C111.475008,318.774496 111.852272,319.098716 112.525089,319.091756 L112.525089,319.093496 C112.421356,321.154236 113.020574,323.362876 111.255372,325.072136 C110.852609,325.460736 111.015453,325.978676 110.972569,326.447316 C110.809725,328.209356 111.983243,329.847276 111.450089,331.642956 C110.57734,331.877276 110.142704,331.274076 109.684307,330.713796 C109.509294,329.634416 109.27517,328.579396 108.42734,327.784796 C105.716949,327.192616 103.008876,326.671196 100.313553,327.856136 C98.298,329.389076 96.2082695,329.807256 93.8728248,328.484856 C92.8801159,327.922256 91.5628787,328.644356 91.1502642,329.924416 C90.9816253,330.444676 90.7956011,330.771216 90.2914232,330.944056 C89.4024474,331.250876 88.8211941,331.939916 88.2277709,332.625476 C87.5601698,333.395136 86.7233504,334.719856 86.667717,332.299516 C86.6619218,332.036196 86.2690108,331.995596 85.9914232,332.005456 C85.7625148,331.983996 85.535345,331.966596 85.3081752,331.943396 C84.6231887,331.778676 84.4458571,332.271096 84.2621509,332.752496 C84.1601563,332.754816 84.0616388,332.768736 83.9648598,332.799476 C82.4053854,333.215916 81.2602642,335.256936 81.2336065,337.661036 C80.9363154,337.888396 81.0296173,338.244516 80.9473261,338.542056 C80.2588625,338.542056 79.5414232,338.663856 78.8836739,338.518856 C77.3896846,338.187676 76.2949811,338.636596 75.5056819,339.916656 C73.9143342,340.730976 73.5063558,342.468076 72.5229191,343.756836 C71.4473396,344.451096 70.3566927,345.131436 70.1434313,346.558236 C70.0988086,346.862736 69.9185795,347.018176 69.6409919,347.120836 C65.7095633,348.545316 62.9696173,351.762576 59.4971644,353.883636 C57.2075013,355.283756 55.102124,356.948356 52.5087951,357.872296 C51.1260728,358.364716 49.669752,358.723156 48.359469,359.406976 C45.6919623,360.796076 43.7992668,363.116076 41.9575687,365.350236 C40.9289299,366.599556 39.5641725,368.082036 40.0938491,370.108556 C38.6427439,369.718216 38.5679865,371.171696 37.959496,371.810856 C36.7500485,373.083956 35.6199946,374.456816 34.8544555,376.073276 C32.8586065,377.095816 31.7992534,379.104356 30.8048059,380.833336 C29.7222722,382.713116 29.6260728,385.162456 29.0998733,387.362396 C29.0575687,388.728296 29.0129461,390.095936 28.970062,391.461836 C27.6122588,391.866676 28.3563558,393.027836 28.1146981,393.835776 C28.1036873,393.996436 28.0984717,394.159996 28.0822453,394.320656 C27.7675687,397.881856 28.7121779,401.519036 27.3955202,405.033836 C27.1880539,405.586576 27.2628113,406.395676 27.5154798,406.945516 C28.5649811,409.220276 28.2433504,411.334956 27.3740782,413.610296 C26.9052507,414.836416 26.1634717,416.143156 26.4978518,417.605336 C25.7734582,419.061136 24.5854528,420.332496 24.6967197,422.122956 C24.3837817,422.585796 23.458876,422.541136 23.6321509,423.407656 C23.5678248,423.677936 23.5052372,423.950536 23.4461267,424.222556 C23.3279057,424.360596 23.2096846,424.496316 23.0920431,424.634356 C22.2030674,425.692276 21.2138356,426.673056 20.6076631,427.940936 C19.410965,428.069116 19.6537817,429.592776 18.6796173,429.936716 C17.5686873,430.715656 16.9746846,431.764876 17.0106146,433.141216 C14.8212075,433.885936 14.3633908,435.869536 13.7340377,437.729596 C13.6992668,438.261456 13.6650755,438.792736 13.6314636,439.324596 C12.1380539,439.568196 13.0751294,440.774596 12.7766792,441.492636 C11.5886739,441.599936 11.8181617,442.484436 11.8181617,443.243656 C11.3620836,443.704756 10.2598464,447.014816 10.2975148,447.816956 C9.92025067,447.895836 9.6751159,448.087236 9.68902426,448.508316 C9.46707008,449.238536 9.5696442,449.979776 9.61948248,450.718696 C9.13848518,452.097356 10.4904933,452.156516 11.087973,452.757976 C11.1436065,453.055516 11.1975013,453.350736 11.2542938,453.645956 C10.8521105,454.562356 10.7843073,455.378996 11.9050889,455.840676 L11.925372,455.880696 C11.986221,456.550016 11.4455337,457.464676 12.6567197,457.659556 C13.5242534,459.215696 14.6311267,460.527076 16.3204124,461.245696 C16.4113962,461.572816 16.6455202,461.762476 16.9462884,461.886016 C16.9370162,462.715416 17.8120836,463.001356 18.026504,463.794796 C18.4750485,465.436196 19.8328518,466.377536 21.3355337,467.068896 C22.1439569,467.367596 22.7130404,468.450456 23.8025283,467.817096 C24.2331078,467.813616 24.437097,467.563056 24.5083774,467.167496 C25.1545364,467.075856 25.8018544,466.984796 26.4491725,466.895476 C27.2738221,467.531156 27.4888221,466.879236 27.7299003,466.286476 C28.2363962,466.281256 28.7637547,466.434956 29.22331,466.087536 C30.3203315,466.106096 31.548903,466.748736 32.3538491,465.414736 C32.6615714,465.377616 32.9710323,465.339336 33.2787547,465.300476 C35.1210323,465.681536 36.9436065,465.163596 38.7783504,465.176936 C38.8936739,465.176936 39.0095768,464.865476 39.1237412,464.697276 C40.6322183,464.757596 41.8300755,463.429396 43.2933504,463.633556 C44.175372,463.758836 44.5688625,463.454336 44.9855337,462.872596 C45.6728383,462.881876 46.3607224,462.933496 47.0428113,462.887096 C47.6646307,462.845336 48.4985526,463.170136 48.6845768,462.137156 C48.8080135,462.176016 48.888566,462.133676 48.924496,462.007816 C52.4693881,461.986356 56.0148598,461.964896 59.5603315,461.943436 C60.1682426,462.996136 61.1731213,462.867376 62.1530809,462.820396 C65.5160054,462.849396 68.8789299,462.880136 72.2401159,462.910296 C73.4402911,464.097556 76.5795229,464.099296 77.7959245,462.916096 C78.4287547,462.917256 79.0621644,462.920736 79.6973127,462.924796 C79.9621509,463.579616 80.5202237,463.643996 81.1350889,463.746076 C84.8607898,464.362616 88.0058167,462.775736 91.1514232,461.170296 C93.861814,461.005576 96.4696307,460.144276 99.2420296,460.182556 C100.390628,460.196476 101.753067,459.716816 102.899927,459.300956 C104.028822,458.891476 105.432987,458.887416 106.31327,457.837036 C108.035008,457.795276 109.757906,457.758156 111.480803,457.716976 C112.449752,457.725676 113.077367,456.784336 114.048633,456.797096 C115.072057,456.746636 115.662003,456.127196 116.069981,455.264156 C116.175453,455.255456 116.268755,455.214276 116.347569,455.144096 C116.902164,455.119156 116.944469,454.684156 117.034294,454.287436 C117.139765,454.272356 117.24176,454.247416 117.343755,454.213776 C118.196801,453.997436 118.234469,453.314776 118.252434,452.621676 C119.205736,452.403596 119.78583,451.731956 120.268566,450.946636 C120.479509,450.883416 120.688714,450.823096 120.897919,450.761616 C121.495399,450.880516 121.675628,450.473356 121.82804,450.027916 L121.895844,450.027916 C123.240898,449.668316 123.831423,448.513536 124.557555,447.500276 C125.369456,446.678416 126.181935,445.856556 126.993836,445.035276 C127.757057,445.128656 127.95583,444.099156 128.707461,444.167016 C131.068404,442.879996 133.048606,441.159716 134.595332,438.948176 C135.901558,438.003356 137.236181,437.092176 138.505898,436.100376 C139.214065,435.547056 139.942515,435.121336 140.764846,434.732736 C141.892003,434.203196 143.249806,433.706716 143.623013,432.224816 C144.242515,431.746316 144.828404,431.216776 145.492528,430.808456 C146.005978,430.493516 146.737326,430.454076 146.707191,429.605536 C148.760412,428.647956 150.617178,427.439816 151.910075,425.511316 C152.090884,425.466656 152.273431,425.421996 152.45424,425.377336 C153.598782,424.874476 154.716666,424.342616 155.14203,423.019056 C155.690251,422.718616 156.359011,422.972656 156.90955,422.434416 C158.510749,420.868996 160.208148,419.403336 161.867879,417.897656 C162.26021,417.781076 162.837407,417.876196 162.71397,417.163956 C162.756854,417.085076 162.810749,417.015476 162.875075,416.952256 C163.755358,416.936016 163.697987,416.317156 163.706679,415.702936 C163.724644,414.575416 163.322461,413.026816 163.901976,412.394616 C165.861895,410.253836 163.125426,408.082316 164.24331,406.059276 C164.259536,406.030276 164.105385,405.910216 164.035844,405.831916 C163.392003,405.106916 163.465601,404.249096 163.578027,403.384896 C164.425857,403.004996 164.710399,402.430216 164.586962,401.451176 C164.227084,398.619036 164.80486,396.109376 167.337919,394.346176 C168.030439,393.862456 168.725857,393.273176 168.739765,392.276736 C169.817084,391.880596 170.736774,391.248976 170.500332,389.976456 C170.276639,388.776436 170.001369,387.478976 169.344779,386.490656 C167.61145,383.871376 167.34835,379.528336 169.010399,376.945596 C169.348256,376.881216 169.599186,376.728676 169.599186,376.334856 C168.718903,375.031596 169.242784,373.977156 170.163633,372.967956 C170.280116,372.840356 170.230278,372.562536 170.258674,372.355476 C170.371679,372.136816 170.482367,371.916416 170.593054,371.696596 C171.373081,371.381076 172.61672,372.318936 172.954577,370.819056 C174.016827,370.382316 173.860938,369.469396 173.809361,368.608096 C173.716059,367.050796 173.505116,365.472036 174.828728,364.251136 C175.081396,364.195456 175.485318,364.167036 175.449388,363.882256 C175.295817,362.643376 176.14017,361.768156 176.503526,360.718936 C176.862825,360.622076 177.098687,360.421976 177.091154,360.017136 L177.10796,360.008436 C177.912326,360.028156 178.107623,359.548496 178.082124,358.851916 C178.060682,358.255676 177.992879,357.603756 178.357973,357.113656 C179.695493,355.323776 179.373863,353.380776 178.683081,351.567696 C178.041558,349.882796 178.674968,348.370156 179.159442,346.994976 C179.558148,345.865716 180.130129,344.696436 180.692259,343.593856 C181.37203,342.260436 182.397191,340.822616 183.960143,340.621936 C186.419604,340.306996 187.298148,338.409816 188.364456,336.751596 C189.528121,334.938516 189.819617,332.688116 191.411544,330.994516 C192.07393,330.290976 192.877137,329.383276 193.202245,328.420476 C193.980534,326.121936 195.407879,324.107596 195.997825,321.740616 L198.576086,321.662316 C198.790507,322.018436 199.086639,322.280016 199.485925,322.413996 C200.328539,322.749236 201.186801,322.240576 202.031154,322.466196 C202.294253,322.596696 202.557353,322.728936 202.820453,322.860016 C204.154496,323.611696 205.605022,323.246876 207.010925,323.305456 C207.871504,323.794396 208.794092,323.645336 209.404321,323.046196 C211.295278,321.189616 210.989294,318.862076 208.745992,317.142376 C208.683404,316.927196 208.621396,316.714336 208.559968,316.499736 C208.93897,315.969616 208.908836,315.426736 208.610385,314.877476 C208.646315,314.472636 208.681666,314.070116 208.719334,313.667016 C208.942447,313.459376 209.16672,313.255216 209.390412,313.049316 C209.678431,312.852696 209.743916,312.607356 209.552677,312.306916 C209.626275,311.701976 209.287838,311.379496 208.77265,311.180556 C208.726288,311.004816 208.678189,310.827916 208.631827,310.652756 C208.619078,309.721856 208.544321,308.821116 207.676787,308.223716 C207.175507,307.879776 206.96804,307.267296 207.070035,306.794596 C207.367326,305.428696 206.87358,304.121956 206.935588,302.784476 C206.966302,302.703856 206.997016,302.621496 207.023674,302.539136 C207.32734,302.446336 207.593916,302.304816 207.712137,301.980596 C207.787474,301.937676 207.860493,301.887796 207.928296,301.832696 C208.989388,301.337956 209.270453,300.822336 207.971181,300.260896 L207.932353,300.285836 C208.04304,297.884636 208.166477,295.488076 207.783418,293.094416 C207.692434,292.523116 207.607245,292.039976 206.964563,291.882216 C205.314105,289.952556 205.20052,289.846996 206.674806,288.225316 C207.636801,287.168556 207.798485,286.202276 207.348782,284.979636 C208.223849,284.213456 207.359792,283.991316 206.90893,283.787156 C206.212933,283.470476 205.565615,283.164236 205.331491,282.363836 C205.556342,281.630136 204.422811,281.680016 204.547987,280.951536 C204.732272,279.884336 203.930803,279.473116 203.156571,279.075236 C203.164105,278.810756 203.17048,278.545696 203.178013,278.282376 C204.350951,277.693096 203.838081,276.948376 203.369253,276.209456 C203.406922,276.082436 203.517609,275.892196 203.469509,275.840576 C203.303189,275.648596 203.135129,275.797656 202.988512,275.922936 C202.89521,275.870736 202.820453,275.801136 202.763081,275.709496 C203.020965,275.273336 202.865075,274.852256 202.603714,274.517596 C201.6649,273.319896 201.895547,271.925576 202.210224,270.691916 C202.430439,269.830616 202.650075,268.971636 202.793216,268.090616 C203.095143,268.027976 203.394173,267.965336 203.694941,267.902696 C203.962677,267.891676 204.371235,267.988536 204.474388,267.852816 C205.385385,266.651636 206.746086,265.505556 207.007447,264.157636 C207.513364,261.556916 206.34738,258.840776 207.05265,256.164656 C205.946356,255.168796 206.914146,254.207736 207.078728,253.221736 C207.173768,252.652176 207.125668,252.133076 207.67273,251.656896 C208.128809,251.259596 208.001895,250.683076 207.433391,250.163976 C206.88459,249.664596 205.9649,249.211036 206.121949,248.310876 C206.379253,246.852176 205.689051,246.253616 204.437299,245.908516 C203.532097,245.657956 203.977744,245.315756 204.445992,245.024016 C205.751639,244.511876 204.742704,243.160476 205.39234,242.408216 C205.889563,241.864176 206.57455,241.320136 205.395817,240.774356 C205.055642,240.353276 204.737488,239.891596 204.079739,240.104456 C203.657272,239.980916 203.231908,239.921756 202.800749,240.063276 C201.914671,239.374236 201.369348,236.377376 201.991747,234.877496 C202.356841,233.992996 202.304685,233.575976 201.371666,233.121256 C200.697111,232.791816 199.449995,232.252996 200.822286,231.148096 C201.137542,230.895796 201.174631,230.326816 200.906315,230.106416 C199.770466,229.178996 200.071235,227.974336 200.187137,226.824776 C200.271167,226.012196 200.027771,225.475116 199.285412,225.160176 C199.532286,224.078476 201.074375,225.083036 201.27141,223.923036 C202.807704,223.464836 202.319752,222.333256 202.138364,221.303756 C202.741639,221.262576 202.755547,220.784656 202.839577,220.356616 C203.489213,220.322976 203.67176,219.879276 203.734348,219.331176 C203.98296,219.218656 204.228094,219.110776 204.144065,218.751176 C203.807367,217.320896 204.13827,216.115656 205.297299,215.145896 C205.767865,214.752076 205.90579,214.137856 206.054146,213.559596 C206.937326,213.421556 206.975574,212.750496 207.175507,212.039996 C207.810655,209.793076 205.145466,208.799536 205.254415,206.774756 C205.256154,206.738796 204.765884,206.676736 204.505102,206.626276 C204.519011,206.296836 204.41238,206.024816 204.236787,205.733076 C203.317097,204.198976 203.539051,203.692056 205.247461,203.339416 C205.560399,203.275036 205.970116,203.294756 206.021693,202.911376 C206.24017,201.347116 207.371962,200.006156 207.1361,198.334016 C208.679927,197.641496 209.057191,195.976316 208.094617,194.093056 C208.361194,194.040856 208.613863,193.944576 208.579671,193.616876 C208.544321,193.265976 208.259779,193.283956 207.998418,193.303676 C207.680264,193.194636 207.362111,193.083276 207.043377,192.974236 C207.057286,192.806036 207.071774,192.636096 207.088,192.467316 C208.12707,192.565916 208.590682,191.346756 209.597299,191.367056 C209.968189,191.382716 210.523943,191.459856 210.570884,191.056756 C210.692582,189.998836 211.538674,189.313276 211.779752,188.348156 C211.804671,188.250136 211.643566,188.047716 211.521868,187.977536 C210.19304,187.211356 210.352407,185.709736 209.809981,184.558436 C210.19304,184.469116 210.714024,184.657036 210.920911,184.230736 C211.090709,183.885636 210.672879,183.744116 210.427744,183.581136 C210.447447,183.428596 210.466571,183.278376 210.486275,183.126416 C211.720642,182.236696 211.760049,181.935676 210.717501,181.297096 C210.5761,181.130636 210.43296,180.963596 210.291558,180.797136 L210.436437,180.811636 L210.291558,180.806416 C210.404563,180.664896 210.516989,180.525116 210.631154,180.385336 C211.021167,180.353436 211.275574,180.163776 211.341639,179.762416 C211.636612,179.608716 212.095008,179.585516 212.017933,179.102376 C211.962299,178.742196 211.580978,178.745676 211.312663,178.641856 C211.286005,178.337936 211.261086,178.035176 211.235588,177.730676 C211.801194,177.346136 212.184253,176.844436 212.228876,176.135676 C212.614833,176.037076 212.999631,175.942536 213.385588,175.843936 C214.272825,175.498256 214.240951,174.526176 214.706302,173.894556 C214.627488,173.130116 215.052852,172.145276 213.831235,171.876736 C212.584698,170.283476 212.589914,170.293916 214.303539,169.100276 C214.546935,168.932076 214.879577,168.564936 214.836693,168.360776 C214.482609,166.717636 215.541383,164.785656 213.863108,163.411056 C213.829496,162.658796 213.797043,161.907116 213.76517,161.153696 C214.036962,160.432176 213.702582,160.091716 213.026288,159.951936 C212.452569,159.835936 212.36796,159.491996 212.609617,159.008856 C214.053189,158.983916 214.17141,157.557116 214.607784,156.753236 C215.070817,155.901216 213.874119,155.346156 213.172906,154.840976 C213.165951,154.721496 213.103364,154.660596 212.983404,154.660596 C212.913863,154.024916 212.160493,153.729696 212.185992,153.047616 C212.174981,152.810976 212.16455,152.574916 212.153539,152.340016 C213.192609,150.890016 211.890439,150.101216 211.248916,149.125076 C211.279051,148.436036 210.948148,147.492956 211.574024,147.134516 C213.271423,146.164176 212.887205,144.576136 212.927771,143.156296 C212.987461,141.117596 212.373755,139.298716 210.638687,138.020396 C210.626518,137.929336 210.584792,137.850456 210.513512,137.789556 C210.822394,137.001916 210.996248,136.117996 211.466814,135.444616 C212.835049,133.489436 212.394617,131.153776 210.314739,129.957816 C209.302326,129.376076 208.932596,127.905776 209.776369,127.175556 C210.80327,126.284096 210.643903,125.430336 210.048162,124.488416 C209.438512,123.519816 209.515588,122.563976 209.94269,121.577976 C210.889038,121.283916 211.357286,120.823976 210.529739,119.907576 C210.463094,118.869376 209.914294,117.694876 210.783566,116.849816 C212.454307,115.220596 212.151801,113.188856 212.195264,111.205256 C212.207434,110.653676 211.811625,110.496496 211.35207,110.433856 C211.366558,109.864876 211.158512,109.300536 211.49579,108.729816 C212.09269,107.720036 211.693984,107.216596 210.578997,107.173676 C209.785062,106.573956 209.037488,105.774136 207.921922,106.018896 C206.361868,106.359356 204.868458,106.250316 203.403445,105.634356 C201.393108,104.180876 198.895399,103.896096 196.646881,103.129916 C194.724631,102.476256 192.694011,101.965856 190.741046,101.287256 C189.635911,100.347656 188.485574,99.472436 187.181086,98.821096 C185.907892,98.786876 184.634698,98.754396 183.359186,98.720756 C182.252313,97.977196 180.708485,97.518996 179.78358,98.004456 C178.670911,98.587936 177.773243,99.268276 176.463539,98.967256 C176.440358,98.962036 176.365022,99.142996 176.329671,99.241596 C175.908943,100.408556 175.312043,100.449736 174.233566,99.867996 C173.507434,99.475916 172.757542,99.064116 171.986787,98.727716 C171.01552,97.020196 168.936801,96.085236 168.633135,93.911976 C168.62734,92.925396 168.969253,91.832096 167.787043,91.216136 C167.80269,90.616416 167.817178,90.018436 167.833404,89.418716 C168.475507,89.280676 168.618647,88.831756 168.665008,88.235516 C168.822636,86.316296 169.349995,84.518876 170.376315,82.859496 C170.594792,82.506856 170.648687,81.691956 170.423256,81.490116 C169.607299,80.768596 169.771881,79.587136 169.050965,78.887076 C168.616329,78.462516 168.899712,77.504936 167.974806,77.474776 C167.153633,76.688876 167.089307,75.417516 166.187582,74.683816 C166.450682,72.664256 165.112582,70.891776 165.289914,68.884976 C165.404078,68.462736 165.264415,68.183176 164.885412,67.941896 C163.567016,67.107276 162.180817,66.468696 160.626558,66.239016 C160.168741,66.172896 159.574739,66.426936 159.312218,65.868976 C158.530453,64.213076 156.68296,63.978176 155.468296,62.908076 C155.157097,62.320536 154.784469,61.857116 154.019509,62.195256 C153.797555,62.214976 153.57734,62.234696 153.355385,62.254416 C152.83672,62.191776 152.318054,62.130876 151.799388,62.069976 C150.684981,61.338016 149.44366,61.488236 148.214509,61.556096 C148.003566,61.506216 147.794941,61.455756 147.583418,61.405876 C146.782528,61.140816 146.073782,61.137336 145.719698,62.089696 C145.501801,62.137836 145.283323,62.184816 145.065426,62.232956 C144.576895,62.073456 144.109806,62.150596 143.646194,62.341996 C141.800439,63.108176 140.017272,64.094176 137.902623,63.908576 C137.338175,63.858116 136.872825,64.169576 136.48455,64.576156 C134.794105,64.574416 133.10366,64.572676 131.412057,64.570936 C130.927003,63.702676 130.218836,63.666716 129.404617,64.037336 C129.190197,64.010076 128.977515,63.986876 128.763094,63.960776 C128.676747,63.442836 128.30296,63.240416 127.893822,62.946936 C126.609038,62.028796 125.031598,62.216716 123.665102,61.658176 C122.784819,61.183736 121.924819,60.666376 120.940803,60.421036 C120.35955,59.279016 119.565615,58.360296 118.327771,57.904416 C117.918054,57.247276 117.556437,56.536196 116.651235,56.457316 C116.19052,54.755016 114.968323,53.469736 114.174388,51.948396 C113.751922,51.136976 113.287151,50.319176 112.171005,50.351076 C112.069011,50.342376 111.966437,50.338896 111.865022,50.340636 C111.145844,49.857496 110.959819,50.319176 110.850871,50.917156 C110.656154,50.965296 110.462596,51.015756 110.267879,51.063896 C109.697057,51.108556 109.380642,51.420016 109.303566,51.980296 L109.28734,51.987256 C107.666437,53.263836 105.484563,53.693616 104.15052,55.401716 C102.773013,55.275856 103.247057,56.240976 103.250534,56.930016 C103.24358,57.642836 102.50296,57.778556 102.210884,58.260536 C102.003997,58.602156 101.315534,58.820816 101.640642,59.275536 C101.992987,59.769696 102.585251,59.461716 102.887178,59.110816 C103.318916,58.611436 103.742542,58.450196 104.264685,58.838216 C104.874914,59.289456 104.220062,59.690816 104.130817,60.104356 C104.064752,60.405376 103.833526,60.668116 103.678216,60.949416 C103.306167,60.676816 102.975264,60.305036 102.436895,60.440756 C101.980817,60.213396 101.501558,60.122336 100.993323,60.211656 C99.726504,59.280756 98.4028922,59.730256 97.9201563,61.339176 C97.7254394,61.987616 97.5017466,62.658676 96.9042668,62.854136 C96.0031213,63.147616 95.7504528,63.854636 95.4108571,64.558176 L95.4305606,64.541936 C95.2619218,64.559916 95.092124,64.577896 94.9240647,64.595876 C94.8209111,64.696216 94.7165984,64.796556 94.6128652,64.898636 C93.6543477,66.654876 91.6347385,67.131056 90.3256146,68.462736 C89.9211132,68.593236 89.5276226,68.790436 89.11269,68.843796 C87.6100081,69.035776 86.3275418,69.467296 86.0059111,71.210776 C85.9578113,71.471776 85.7729461,71.697396 85.4582695,71.718856 C84.4638221,71.790776 83.8275148,72.494316 83.2138086,73.124196 C82.3086065,74.049876 81.3495094,74.805616 80.0316927,74.982516 C79.8224879,75.016736 79.6167601,75.052696 79.4092938,75.086336 C78.7434313,75.367636 78.1824609,75.897176 77.4093881,75.920956 C76.3790108,75.565996 75.3416792,75.753916 74.3043477,75.873976 C72.8196307,75.999256 71.7388356,76.599556 71.5458571,78.235156 C69.5140782,79.099936 68.0490647,80.557476 66.8720701,82.421016 C66.4246846,83.129776 66.8523666,84.144776 66.2658976,84.495676 C64.3732022,85.623776 65.4557358,87.877076 64.2271644,89.356076 C63.5630404,90.156476 62.8079326,91.522376 63.1695499,92.914956 C63.2130135,93.760016 62.1049811,94.175296 62.3559111,95.097496 C62.3089704,95.462316 62.2626092,95.825976 62.216248,96.190796 C61.2820701,96.509796 61.2310728,97.322376 61.335965,98.060136 C61.7207628,100.698556 60.6457628,103.102656 60.2325687,105.611156 C59.8553046,105.662776 59.7689569,105.992216 59.6136469,106.255536 C58.2146981,106.840756 57.9179865,108.314536 57.3042803,109.443796 C57.1414367,109.745976 57.6908167,111.513236 58.9089569,111.348516 C60.2401024,111.168136 60.3560054,112.005656 60.5084178,112.796776 C60.6672049,113.634876 60.6080943,114.513576 60.6440243,115.374876 C59.9549811,116.115536 59.2972318,116.866056 58.4401294,117.454756 C58.0251968,117.739536 57.2440108,118.103196 57.4850889,118.879816 C58.0628652,120.750896 57.9730404,120.834996 56.000372,120.919096 C55.219186,120.950996 54.0311806,120.358816 53.8271914,121.851736 L53.462097,122.542516 C52.9416927,122.563976 52.4015849,122.506556 51.9043612,122.626616 C51.3248464,122.768136 50.6508706,122.922416 50.6589838,123.763416 C50.6004528,124.091116 50.5413423,124.417076 50.4804933,124.744776 C49.8256415,125.081176 49.787973,125.410616 50.4909245,125.734256 C50.4862884,126.053256 50.4822318,126.371676 50.4787547,126.692416 C50.1710323,126.789276 49.8024609,126.941236 49.804779,127.257916 C49.804779,127.675516 50.2318814,127.600116 50.5291725,127.628536 C50.6589838,129.599376 49.7543612,131.551076 50.4265984,133.530616 C50.4463019,134.614056 50.4642668,135.698656 50.4845499,136.782096 C49.5949946,138.051136 49.435628,139.499396 49.453593,140.990576 C47.9033908,141.622196 48.5507089,143.035076 48.536221,144.069796 C48.5257898,144.803496 49.5521105,145.415976 50.2533235,145.342316 C51.9362345,145.165416 52.5499407,146.554516 53.4319623,147.383336 C54.0601563,147.972616 54.3157224,149.223676 53.6678248,150.090196 C52.4178113,151.767556 51.8469892,153.617176 51.8162749,155.672116 C51.6684987,155.731276 51.3909111,155.786376 51.3891725,155.849016 C51.3567197,157.451556 50.9441051,158.858636 49.4912615,159.768076 C49.2287412,159.938016 48.7975822,160.059816 48.7291995,160.288916 C48.2302372,161.955836 46.9014097,162.983016 45.7904798,164.155776 C44.764159,165.238636 43.5332695,166.134156 42.9160863,167.558636 C42.5892399,167.922296 42.6709515,168.393256 42.5799677,168.818976 C42.4008976,168.963976 42.2206685,169.108976 42.0410189,169.253976 C41.7303989,169.314876 41.3351698,169.273696 41.1236469,169.452916 C39.9234717,170.476616 38.5824744,171.010216 36.9870701,170.915676 C36.5414232,170.888416 35.9937817,170.781116 35.7272049,171.355896 C33.1031617,172.728756 32.2269353,176.615336 34.0477709,178.808316 C34.0529865,178.985796 34.0587817,179.163276 34.0622588,179.340176 C32.8817871,179.785616 33.328593,180.568036 33.9028922,181.006516 C35.2120162,182.007596 35.8326765,183.620576 37.2078652,184.533496 C37.2478518,185.256756 37.51269,185.739896 38.3547251,185.596636 C38.3958706,185.792096 38.4358571,185.986976 38.4764232,186.180696 C38.4051429,186.243336 38.3744286,186.321636 38.3854394,186.416756 C37.3799811,187.856316 37.5283369,188.822596 38.8687547,189.570796 C38.9950889,189.610236 39.1202642,189.647936 39.2454394,189.687376 C39.7982965,190.738336 40.9555876,190.255196 41.7553181,190.679176 C41.5849407,191.339796 43.1380404,191.479576 42.3133908,192.227776 C41.5171375,192.952776 41.7390916,193.785076 41.7176496,194.623176 C41.3722588,194.775136 41.0233908,194.916656 40.9202372,195.344116 C40.3673801,197.596256 41.6446307,199.508516 42.0989704,201.570416 C42.1238895,201.686996 42.4739164,201.731656 42.6744286,201.808796 C43.2133774,202.957776 43.5066119,204.052236 42.0989704,204.843356 C41.9303315,204.937896 41.849779,205.186716 41.7303989,205.364196 C40.3221779,206.483016 40.755655,208.359316 39.9576631,209.735656 C39.9199946,209.802356 40.1529596,210.129476 40.3134852,210.190376 C41.4087682,210.607396 41.5246712,211.636896 41.6834582,212.539376 C41.8051563,213.223196 42.0410189,213.629196 42.6837008,213.815956 C42.4849272,215.586116 43.5297925,217.029156 44.0675822,218.579496 C44.2663558,219.148476 43.8143342,220.220896 44.9287412,220.394316 C45.0214636,222.174336 45.5349137,223.921296 45.7331078,225.621856 C46.051841,228.335676 47.012097,231.160856 45.9411536,233.950076 C45.4219084,234.078836 45.1483774,234.363616 45.3233908,234.929116 C44.8029865,235.527096 44.021221,236.098396 44.5833504,237.002616 C45.0823127,237.809396 44.9246846,238.663736 45.0539164,239.502996 C45.3929326,241.739476 44.3306819,243.806596 44.354442,245.997836 C44.5155472,247.440876 43.4167871,248.629876 43.5367466,250.063636 C43.2562615,250.136716 42.9751968,250.212116 42.6941321,250.285776 C41.637097,250.383796 40.7944825,250.969596 40.0167736,251.599476 C39.3816253,252.113356 39.3033908,252.682336 39.7612075,253.554656 C40.2810323,254.542396 40.7121914,255.563196 41.3763154,256.490036 C42.8071375,258.491616 43.395345,260.756516 43.5332695,263.223256 C43.6567062,265.437696 45.7302102,268.029716 48.5275283,268.029716 C48.9297116,268.230396 48.7958437,268.794156 49.2965445,268.998316 C51.8863962,270.054496 51.8562615,270.075956 51.8719084,272.847196 C51.875965,273.824496 51.5305741,274.967096 52.7823261,275.541296 C52.8113019,276.059236 52.8379596,276.576016 52.8669353,277.095696 C52.7469757,277.718036 52.990372,278.486536 52.4803989,278.946476 C51.6360458,279.707436 51.7380404,280.378496 52.3784043,281.171356 C52.6090512,281.456136 52.7377035,281.832556 52.8791051,282.179396 C53.5820566,283.900256 52.8843208,284.965136 51.0617466,284.979636 C48.3716388,284.999356 45.681531,285.029516 42.9914232,285.045756 C42.3690243,285.047496 41.7750216,285.044016 41.6695499,285.860076 C40.9237143,285.951716 40.1558571,285.953456 39.4407358,286.148336 C37.725372,286.617556 36.358876,288.255476 34.2963827,287.611096 C33.8941995,287.485816 33.4717332,287.792056 33.2949811,288.257216 C31.8195364,289.243216 31.6578518,291.381096 32.9513288,292.822396 C33.5522857,293.955136 32.8458571,295.296096 33.525628,296.417236 C33.1263423,297.098736 33.2660054,297.739636 33.6241456,298.398516 C34.1173127,299.309696 34.5681752,300.244656 35.0364232,301.168016 C35.4693208,302.285096 36.3339569,302.997916 37.3081213,303.609816 C37.3695499,303.685216 37.4356146,303.758296 37.5016792,303.830216 C37.5770162,304.431676 37.6946577,304.962956 38.4787412,304.453136 C38.8322453,304.542456 39.1851698,304.634096 39.5375148,304.723416 C40.3424609,305.854996 41.0848194,305.428696 41.81269,304.634096 C42.2166119,304.549996 42.6187951,304.462416 43.021558,304.375996 C43.7639164,304.943816 43.5031348,304.071496 43.7210323,303.885896 C45.2613827,303.873136 46.8956146,303.309376 48.2789164,303.572696 C50.0638221,303.914316 52.0492399,303.251956 53.6782561,304.489096 C53.8213962,304.598136 54.3012345,304.526796 54.4067062,304.380056 C54.8987143,303.703196 55.7036604,303.982176 56.3011402,303.672456 C56.8482022,303.282696 57.3935256,302.890616 57.9411671,302.499696 C58.2813423,302.430096 58.5583504,302.285096 58.6371644,301.905776',
	                                id: 'Fill-1', fillOpacity: '0.75', fill: '#2D5C39' }),
	                            _react2.default.createElement('path', {
	                                d: 'M50.484376,136.781922 L50.427004,133.531022 C51.3698747,133.117482 51.0586752,132.263142 51.069686,131.561922 C51.091128,130.233142 50.9369771,128.883482 51.9082439,127.773942 C51.9928531,127.696802 52.0763032,127.621982 52.1609124,127.546582 C52.2623275,127.571522 52.3463571,127.540782 52.4106833,127.458422 C52.5126779,127.503082 52.612934,127.550062 52.7149286,127.596462 C53.3552925,127.741462 53.9655216,127.737982 54.5948747,128.215902 C55.331438,128.774442 56.2760472,129.272082 57.3267075,129.229162 C57.5283787,129.216982 57.7306294,129.204222 57.9340391,129.193782 C58.5784596,129.322542 58.7679609,128.860282 58.8751712,128.395122 C59.0345377,127.696802 59.4743895,127.195682 59.9235135,126.687022 C61.5368827,126.548982 63.1305485,126.506062 64.5011011,127.598202 L64.5689043,127.614442 C64.2200364,129.044722 65.0249825,130.430342 64.7259528,131.858882 L64.731748,131.855402 C64.1110876,131.755062 63.7656968,132.122202 63.4852116,132.596642 C63.0696995,132.655802 62.6547668,132.714382 62.2398342,132.773542 C61.0952925,132.779342 60.5140391,133.341362 60.5435943,134.503102 C60.3367075,134.730462 60.1309798,134.956082 59.9235135,135.183442 C59.2651846,135.174742 58.8125836,135.493162 58.5176105,136.066202 C58.2655216,136.142762 58.0145916,136.219902 57.7648208,136.297042 C57.2026914,136.225122 57.2154407,136.826582 56.8984461,137.040022 C55.5788908,136.812662 54.8562358,137.981362 53.7974623,138.361262 C53.5361011,137.472702 52.7276779,137.888562 52.1800364,137.684402 C51.9140391,136.821362 51.1374892,136.918222 50.484376,136.781922',
	                                id: 'Fill-3', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M34.0626644,179.340292 C34.0568693,179.162812 34.0533922,178.985912 34.0487561,178.808432 C34.3721253,178.397212 34.1055485,178.019052 34.028473,177.600292 C33.6651173,175.590012 33.6993086,173.663252 35.5114515,172.243992 C35.8858181,172.746852 36.37319,172.881412 36.9619771,172.698712 C37.1410472,172.727132 37.3160606,172.754392 37.4951307,172.782812 C37.7773544,172.974212 38.0618962,173.165612 38.3470175,173.357592 C39.126465,174.071572 40.6308854,173.475912 41.0278531,174.968832 C41.5807102,177.046972 40.9577318,178.384452 38.9155216,179.137872 C38.852934,179.161072 38.8401846,179.317092 38.8048342,179.412212 C37.7524353,179.455132 36.7011954,179.497472 35.6511146,179.540972 C35.121438,179.474272 34.5917615,179.406412 34.0626644,179.340292',
	                                id: 'Fill-5', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M80.1510728,384.60902 C80.3301429,384.64324 80.5068949,384.67514 80.685965,384.70762 C81.0023801,385.21048 80.9287817,385.787 80.9826765,386.338 L80.9774609,386.34554 C79.9592534,386.44356 79.5246173,387.237 79.0453585,387.9765 L79.0847655,388.02696 C77.9773127,388.252 78.0723531,389.61094 77.1659919,390.05696 C76.8026361,390.23154 76.4607224,390.63986 76.7145499,391.0969 C76.9475148,391.51334 77.3960593,391.52262 77.8306954,391.36834 C78.0259919,391.43852 78.2207089,391.5087 78.4142668,391.57656 C78.655345,392.41582 79.1942938,392.9616 80.0311132,393.21448 L80.0293747,393.211 C79.9969218,395.12616 80.29769,397.13122 79.8236469,398.93038 C79.4782561,400.23712 79.7164367,401.56706 79.2389164,402.82566 C79.0708571,403.26646 79.612124,403.35926 80.0131482,403.30938 L79.9882291,403.3378 C80.0913827,403.57038 80.1528113,403.97348 80.3029057,404.00886 C81.7661806,404.3586 81.4190512,405.21932 81.1976765,406.30624 C80.9310997,407.61298 80.2548059,408.75152 79.984752,410.03506 L79.9754798,410.04086 C78.0584447,410.10466 76.1402507,410.16904 74.2232156,410.23226 C73.8529057,410.18006 73.5022992,410.15686 73.5289569,410.69742 L73.5075148,410.81748 L73.6170431,410.87664 C72.6457763,411.32266 71.3268005,410.42714 70.5670566,411.67472 C69.8368679,411.68052 68.901531,412.1509 68.860965,410.7618 C68.8406819,410.16034 68.2217601,409.80944 67.746558,409.75434 C67.1884852,409.69112 66.6622857,410.01708 66.2780674,410.55764 C65.5496173,411.58018 64.7307628,412.53776 63.9507358,413.52434 L63.1510054,413.65832 C62.6085795,413.67456 62.0887547,413.73894 61.7932022,414.28878 C60.7576092,414.34736 59.7202776,414.40652 58.6829461,414.46626 C57.9029191,414.23484 57.468283,414.54224 57.3436873,415.33046 L57.3361536,415.33452 C56.5578652,415.38266 55.8137682,415.51664 55.2771375,416.16276 C54.7619488,416.18944 54.2490782,416.21844 53.735628,416.24686 C52.7498733,415.7295 52.7747925,416.3095 52.9086604,417.00782 C52.894752,417.20096 52.8820027,417.3941 52.8680943,417.58608 C52.3117601,417.84244 52.0608302,418.27338 52.1274744,418.88586 C52.1008167,418.9891 52.0915445,419.09524 52.1008167,419.2008 C51.6679191,420.08124 51.9733235,420.69024 52.8002911,421.11132 C52.8315849,421.31664 52.8640377,421.52312 52.8964906,421.72844 C52.9451698,422.52362 52.2972722,423.04446 52.1129865,423.74742 C52.0220027,423.88778 51.9327574,424.0235 51.8411941,424.16328 C51.0217601,424.2207 51.2164771,424.87784 51.1272318,425.3662 C49.6013693,426.7698 47.6843342,428.02318 49.1261671,430.57054 C49.3330539,430.9371 49.1615175,431.23116 48.8630674,431.38486 C47.204496,432.24036 47.5232291,433.99138 46.9993477,435.36482 C46.620345,436.35488 47.0816388,436.5051 47.8842668,436.45522 C48.124186,436.54802 48.3652642,436.64082 48.6051833,436.73362 C48.5750485,437.1837 48.7767197,437.36408 49.2188895,437.26722 C49.3139299,437.31942 49.4118679,437.36582 49.512124,437.40352 C49.5839838,437.79908 49.76769,438.05196 50.2191321,437.9783 L50.2365175,437.99802 C50.2869353,438.69228 50.061504,439.321 49.7787008,439.9387 C49.6894555,439.9474 49.6054259,439.97234 49.5266119,440.017 C49.0508302,439.9851 48.6411132,440.06514 48.5101429,440.61672 C47.1030809,440.74374 47.458903,442.03656 47.0827978,442.82768 C46.3734717,444.32234 46.1816523,446.1592 44.3103989,446.84882 C42.2357358,446.27752 41.1647925,447.71882 40.0075013,448.99308 C39.7206415,449.0186 39.4326226,449.04528 39.1469218,449.07022 C37.5173261,449.03252 36.0969353,447.94212 34.4012749,448.17006 C33.9434582,448.23038 33.7197655,447.6846 33.4960728,447.32848 C33.2654259,446.96482 33.1257628,446.53388 32.5914501,446.52808 C32.4819218,445.79612 32.0548194,445.3588 31.3408571,445.1906 C31.3107224,444.75966 31.0279191,444.62162 30.6489164,444.5932 C30.6344286,444.4888 30.6060323,444.3902 30.5631482,444.2974 C30.6831078,443.54572 30.437973,442.95296 29.8028248,442.52492 C29.8005067,441.90374 29.3577574,441.641 28.892407,441.39566 C29.0442399,440.84988 28.8402507,440.67414 28.3128922,440.83712 C28.2265445,440.78376 28.1372992,440.73156 28.0497925,440.67762 C27.9958976,439.98684 28.2624744,439.13308 27.1787817,438.96488 C27.1695094,438.7816 27.1608167,438.59774 27.1538625,438.4133 C27.5346038,438.29324 27.9530135,438.08386 27.8631887,437.65988 C27.4737547,435.8062 27.9657628,433.98616 28.0069084,432.15104 C28.2161132,431.29148 27.8527574,430.36464 28.3128922,429.5335 L28.346504,429.50682 C29.7060458,428.91116 30.0821509,427.53598 30.5614097,426.37076 C30.7810458,425.83368 30.8957898,425.44508 31.4324205,425.24962 C31.8004124,425.25542 32.1689838,425.26238 32.5392938,425.26934 C34.0865984,425.48278 33.2138491,424.53042 33.1616927,423.9713 L33.9023127,423.6813 C34.5838221,423.2231 35.3777574,422.88844 35.7231482,422.0544 L35.8216658,422.07818 C37.0757358,421.6339 36.7477305,420.5145 36.8821779,419.59056 C36.9731617,419.5517 37.062407,419.50704 37.1487547,419.46064 C37.7555067,418.92298 38.919752,420.23378 39.3451159,418.64632 C39.5792399,417.7653 41.1184313,418.72636 41.7060593,417.79546 C41.9923396,417.79198 42.2786199,417.7885 42.5654798,417.78676 C44.4054394,417.88304 45.2822453,417.1099 45.2213962,415.39658 C45.1692399,413.9344 45.8009111,412.44438 44.9919084,410.99844 C44.7919757,410.63826 44.9635121,410.07972 45.2764501,409.79726 C45.9596981,409.18304 45.9098598,408.3722 46.035035,407.595 C46.1155876,407.57006 46.1961402,407.54106 46.2749542,407.50858 C47.458903,406.62466 47.3105472,405.1387 47.3511132,404.0396 C47.4160189,402.33672 48.2493612,401.84662 49.5625418,401.5137 C50.155965,401.55488 50.8681887,401.97364 51.1469353,401.01432 C51.4616119,400.94414 51.8017871,400.7568 52.0840108,400.8206 C53.9320836,401.24168 54.8193208,399.1937 56.4935391,399.14208 C56.8852911,399.12932 56.9229596,398.58702 56.9299137,398.20016 C56.9368679,397.61088 56.9496173,397.0187 56.9600485,396.42942 C57.2642938,395.9138 57.7615175,395.65106 58.2807628,395.41616 C58.3897116,395.43414 58.4969218,395.45212 58.6058706,395.46836 C58.8724474,395.44806 59.1888625,395.42486 59.1013558,395.05308 C59.049779,394.83268 58.7849407,394.82166 58.5664636,394.87386 C57.8246846,394.79498 57.0852237,394.71842 56.3451833,394.63954 C56.3469218,394.48874 56.3469218,394.34026 56.3486604,394.19004 C57.7064636,393.60656 59.1622049,394.19178 60.5397116,393.8374 C63.3833908,393.98414 66.2299677,393.91976 69.077124,393.87162 C70.1822588,393.8519 70.8139299,393.48128 70.9767736,392.37986 C71.9978787,392.35144 73.0207224,392.31954 74.0441456,392.29228 C74.7453585,392.27256 75.1765175,391.91644 75.2124474,391.2216 C75.253593,390.3893 74.5523801,390.5488 74.060372,390.44846 C73.7885795,389.78088 73.3214906,389.45492 72.5826092,389.60166 L72.597097,389.61616 C72.77269,389.17188 72.9175687,388.71194 73.1302507,388.28796 C73.5863288,387.3762 73.3336604,386.69644 72.4307763,386.3438 C71.0358841,385.79744 71.2647925,385.04054 72.0511941,384.1601 C72.4429461,383.72104 72.849186,383.29648 73.2502102,382.86496 C73.8940512,382.88468 74.2122049,382.50536 74.3715714,381.93812 C74.5234043,381.93116 74.6740782,381.92362 74.8259111,381.91782 C76.135035,382.01642 77.2123531,382.67356 78.3140108,383.31272 C78.9723396,383.69262 79.0615849,384.86654 80.1510728,384.60902',
	                                id: 'Fill-7', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M107.362249,75.068008 C108.513745,75.121948 108.503314,74.040248 108.83074,73.413848 C109.421265,72.286328 109.792735,71.046868 110.261562,69.856708 C110.561751,69.090528 110.68229,68.383508 109.760861,67.928788 C108.913031,67.510028 109.170336,66.936988 109.538907,66.326248 C109.981077,65.590808 110.413974,64.849568 110.798193,64.083388 C111.125619,63.427988 111.198637,62.455908 112.218584,62.617148 C113.209554,62.774908 114.019716,63.304448 114.288031,64.405288 C114.867546,66.786768 115.981953,68.770368 118.378826,69.763328 L118.418233,69.801028 C118.448368,70.406548 118.883004,70.454688 119.339082,70.470928 L119.308947,70.508628 C120.292384,72.214408 122.3514,72.620988 123.567802,74.043728 L123.56954,74.045468 C123.660524,76.031388 124.504877,77.745868 125.543947,79.376828 C125.818058,79.806608 126.306009,79.940588 126.828732,79.933628 C127.855053,79.917388 128.880214,79.935368 129.906535,79.926668 C130.339433,79.921448 131.05919,79.758468 130.767115,79.322888 C129.842209,77.950028 130.935753,77.053348 131.312438,75.980928 L131.318233,75.973968 C131.942371,75.921768 132.307465,75.646268 132.192721,74.957228 L132.247775,74.916048 C133.1014,75.039588 133.252074,74.618508 133.067209,73.891768 C132.856265,73.057728 132.859743,72.228328 133.272937,71.439528 C133.396953,71.425028 133.518071,71.408788 133.63977,71.392548 L133.690187,71.416328 C134.146265,72.097828 134.682896,72.624468 135.605484,72.391308 L135.573611,72.427268 C135.553327,73.331488 135.223004,74.355188 136.48229,74.761768 L136.489244,74.766988 C136.55357,75.143408 136.8045,75.327268 137.154527,75.407888 C137.979177,77.140928 139.662088,78.409968 139.873611,80.481148 C139.88578,80.612228 140.18481,80.812908 140.351131,80.814648 C141.579702,80.829148 141.560578,81.569808 141.345578,82.445608 C139.319015,83.109708 137.517883,84.171108 135.686036,85.522508 C137.052532,86.188348 137.85574,87.028188 137.440807,88.522848 C137.392128,88.702068 137.501656,88.945668 137.585686,89.135328 C138.780646,91.801008 138.64446,94.437688 137.478476,97.076688 C137.197411,97.712368 137.04384,98.403148 136.800443,99.058548 C136.317708,100.359488 135.786292,101.587928 134.256953,102.062368 C133.489675,102.300748 132.89915,102.826808 132.854527,103.800628 C132.806427,104.845788 133.757991,105.080688 134.227977,105.041248 C135.815268,104.910748 137.247249,105.807428 138.814257,105.563828 C139.234985,105.537148 139.655713,105.508148 140.07702,105.481468 C140.484999,105.467548 140.894716,105.453048 141.304433,105.438548 C141.624325,105.469288 141.946535,105.537148 142.265268,105.520908 C142.822761,105.494228 143.534985,105.882248 143.898341,105.268608 C144.236198,104.699048 143.297384,104.461248 143.304338,103.904448 C144.574055,103.739728 144.068139,102.927148 143.756939,102.384848 C143.439945,101.833268 143.139177,101.260228 143.450376,100.735908 C144.284298,99.321288 143.907034,97.500668 145.035929,96.208428 C146.183947,95.465448 147.056697,94.210328 146.225093,93.159368 C145.257883,91.940788 145.749311,91.519708 146.59888,90.880548 C150.07423,90.494268 151.308597,89.557568 150.951036,86.650608 C150.782977,85.282968 150.855996,83.884588 150.820066,82.500708 L150.860053,82.534928 C151.993584,82.067448 153.107991,81.699148 154.297155,82.461268 C154.560255,82.630048 155.029082,82.475768 155.402869,82.470548 C155.591212,82.504188 155.776656,82.540148 155.964419,82.576108 C156.172465,83.301108 156.711993,83.458288 157.377856,83.403188 L157.413206,83.418848 C157.299042,83.991888 157.144891,84.561448 157.078826,85.139708 C157.012761,85.742908 156.754877,86.453408 157.631683,86.749208 L157.633422,86.750948 C157.744109,86.960328 157.857115,87.169708 157.967802,87.379088 C158.050093,87.506108 158.132384,87.631388 158.212937,87.756668 C158.320726,88.718308 159.59392,89.183468 159.298368,90.315048 C158.928058,91.171128 158.613381,91.924548 160.085929,92.010388 C161.232209,92.078248 161.740443,92.926788 162.078301,93.987028 C162.665349,95.832588 161.851131,97.567368 161.809985,99.355508 C161.406063,99.611288 160.985336,99.846188 160.597061,100.127488 C159.434554,100.975448 158.717115,101.883148 159.926562,103.297768 C160.507815,103.978108 160.212842,104.829548 159.933516,105.601528 C159.854702,105.898488 159.470484,106.097428 159.658247,106.478488 C159.740538,106.730788 159.744015,107.071248 159.916131,107.222048 C161.455902,108.569968 160.47884,109.380808 159.318071,110.150468 C158.963988,110.383048 158.570497,110.558208 158.19729,110.761208 C157.676306,111.041928 157.461306,111.699068 157.781778,111.971088 C158.595416,112.661868 159.055551,113.804468 160.250511,114.029508 C160.493907,114.864128 161.005039,115.433108 161.859823,115.666268 L161.862142,115.668008 C161.879527,117.594188 163.228058,119.092328 164.793907,118.922388 C164.99384,118.942108 165.19609,118.961828 165.398341,118.981548 C165.426737,119.070868 165.485848,119.117268 165.57857,119.121328 C166.669796,119.716988 167.217438,120.431548 166.083327,121.500488 C165.001373,121.462788 163.569972,121.793968 164.020834,122.929028 C164.632222,124.477048 164.380713,125.567448 163.594891,126.781388 L163.57171,126.804588 C162.874554,126.779648 162.863543,127.243068 162.906427,127.742448 C162.863543,127.925148 162.81892,128.106108 162.774298,128.288808 C162.221441,128.455268 161.869096,128.768468 161.979783,129.407048 C161.301751,131.421388 160.22733,133.435148 161.981522,135.449488 C161.869096,136.118808 162.130457,136.589768 162.740106,136.874548 C162.779513,137.486448 162.820659,138.100668 162.861805,138.714888 C162.71171,139.258928 162.68853,139.872568 163.006683,140.286688 C164.340726,142.031908 163.772222,143.825848 163.335848,145.671408 C162.983503,147.155628 162.05512,147.361528 160.715282,147.332528 C157.745848,147.271628 154.885942,146.410908 151.934473,146.296068 C150.296185,146.233428 148.657896,145.861068 147.1245,146.987428 C145.115902,148.462368 142.992559,149.652528 140.34012,149.788828 C138.814257,149.867708 136.642815,149.444888 136.439406,152.071708 C136.428395,152.205688 136.126468,152.343148 135.938705,152.431308 C134.884567,152.928948 134.285349,153.815188 134.090632,154.896308 C133.807829,156.471588 132.595484,156.962268 131.359379,157.278948 C129.25574,157.817768 128.236373,157.089288 127.790726,155.025068 C127.604702,154.171308 127.245403,153.299568 126.312964,153.115128 C125.070484,152.866308 123.746292,153.188208 122.562344,152.416808 C122.175807,152.166248 121.546454,152.365188 121.296104,152.857028 C120.589675,154.240908 119.607398,153.793148 118.557317,153.385408 C117.373368,152.923728 116.250268,152.230628 114.905214,152.309508 C114.772505,152.141308 114.672249,151.922648 114.502451,151.811868 C112.68857,150.625188 110.985956,148.885188 108.585605,150.730748 C108.21008,151.019008 107.574931,150.898948 107.387168,150.311408 C106.780996,148.419448 105.727438,146.604048 106.5376,144.468488 C106.775201,143.839768 106.771724,143.003988 105.666009,143.002248 L105.648624,142.984268 C105.609217,142.717468 105.584298,142.447188 105.528664,142.183868 C105.158354,140.442128 106.256535,138.999668 106.580484,137.400608 C106.76477,136.498708 108.065201,137.302008 108.760619,136.883248 C109.106009,136.899488 109.449662,136.915728 109.794473,136.933708 C109.839096,136.960388 109.884298,137.003308 109.932977,137.010268 C110.667802,137.128588 111.306427,138.011348 112.000106,137.667408 C113.263449,137.041008 110.905403,136.716788 111.73353,135.864768 C111.98446,135.610728 111.624581,134.926908 110.919891,135.128748 L110.914675,135.127008 C110.528139,133.363808 110.974945,131.937008 112.588894,130.982908 C112.778395,130.959708 112.967896,130.938248 113.157398,130.915048 C114.327438,131.000888 114.66008,130.093188 115.081966,129.292788 C115.405915,129.287568 115.728125,129.284088 116.051495,129.278868 C117.648637,129.251608 119.283449,129.287568 119.375012,127.021508 C119.387761,126.710048 119.632896,126.565048 119.949311,126.625948 C120.809311,126.794148 121.628745,126.546488 121.651926,125.649808 C121.68264,124.577388 122.430214,123.265428 121.037061,122.438348 C120.895659,121.466268 119.924392,121.403628 119.364001,120.889748 C118.189325,119.810368 115.995861,120.243628 115.454015,118.243788 C115.924581,116.260188 114.625888,116.566428 113.459325,116.700988 C113.155659,116.704468 112.851993,116.707948 112.54543,116.711428 C112.138031,116.658068 111.925349,116.881368 111.801333,117.234008 C111.258327,117.148168 109.892991,117.665528 110.424406,116.695188 C111.182991,115.311308 110.925106,113.874068 111.397411,112.522668 C112.177438,110.290248 112.81954,107.995188 112.500807,105.569048 L112.499069,105.570788 C112.925012,105.573108 113.323718,105.385188 113.297061,104.960628 C113.213031,103.648088 113.83543,102.490408 114.0145,101.240508 C114.084042,101.177868 114.154163,101.115228 114.225443,101.054328 C114.559823,101.106528 114.894204,101.161628 115.230322,101.213828 C115.910093,101.917368 116.775888,102.062368 117.697317,102.035688 C119.226656,102.447488 119.663031,101.641288 119.83109,100.284668 C120.226319,97.087128 119.008759,94.198148 118.233947,91.222748 C118.201495,91.099208 117.88508,91.048748 117.700794,90.966968 C117.147937,89.452008 115.819109,88.768188 115.234379,89.724608 C114.250363,91.337008 112.991077,92.688988 111.765982,94.097808 C111.182991,94.767128 110.638826,95.689328 110.854985,96.750728 C109.711023,96.917188 109.052694,96.170728 108.467384,95.395848 C107.732559,94.420288 106.771724,93.884368 105.604001,93.657588 C105.515915,93.640768 105.430147,93.618148 105.346117,93.589148 C105.194284,92.801508 104.455403,92.213968 104.570147,91.335268 C104.555659,90.311568 104.349931,89.445048 103.040807,89.504208 C102.529096,89.437508 102.019123,89.369648 101.50915,89.301788 L101.504513,89.296568 C101.485969,88.865048 101.470322,88.433528 101.452357,88.000268 C102.45202,87.822788 102.621818,87.143028 102.053314,86.507348 C101.076252,85.418688 101.182303,84.099768 101.52016,83.029088 C101.922344,81.749028 102.139082,80.483468 102.279904,79.177888 L102.361036,79.103068 C103.811562,78.831048 104.223018,77.943068 103.847492,76.589928 C103.917034,76.575428 103.967451,76.534248 103.997586,76.469868 C104.260106,76.462328 104.524945,76.453628 104.788624,76.446088 C105.876953,76.643288 107.111319,77.153688 107.25446,75.306388 C107.286912,75.224028 107.322842,75.146888 107.362249,75.068008',
	                                id: 'Fill-9', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M104.446594,120.469132 C104.340543,120.592672 104.235651,120.716212 104.131918,120.841492 C102.606055,121.376832 101.087147,121.931312 99.5525916,122.434752 C99.0930364,122.586712 98.824721,122.821612 98.7615539,123.294312 C98.4741146,123.337232 98.1878342,123.378412 97.8998154,123.421332 C96.733252,123.337232 96.3652601,124.067452 96.2383464,125.048812 L96.2400849,125.046492 C94.9182116,126.171112 94.9483464,127.092732 96.3351253,128.002172 C96.3635216,128.382072 96.3936563,128.763132 96.4220526,129.142452 C96.3559879,129.402292 96.2905027,129.661552 96.224438,129.923132 C94.8301253,130.916672 94.5119717,132.400892 95.4907722,133.342232 C95.5122143,133.836392 95.5313383,134.330552 95.5527803,134.826452 C95.3476321,135.510272 95.4977264,135.995732 96.282969,136.124492 L96.2847075,136.127972 C96.2325512,136.901112 96.4330633,137.540272 96.8891415,138.228152 C98.354155,140.436792 98.317066,142.614112 95.6872278,144.652812 C95.3974704,144.876692 95.3117022,145.157412 95.2224569,145.465392 C94.4887911,145.865012 93.6925377,145.519332 92.9385889,145.660852 C91.1542628,145.409712 90.0137776,144.144152 88.7776725,143.027652 L88.6524973,142.941232 L88.4983464,142.948192 C88.2138046,142.407632 87.6493571,142.270172 87.1625647,142.017872 C87.1214191,141.763252 87.2089259,141.453532 86.8745458,141.317812 C86.6044919,139.686852 85.5225377,138.442752 84.5744515,137.252012 C83.8245593,136.310672 82.912403,137.930612 81.9336024,137.774592 C81.722659,137.742692 81.5030229,137.783872 81.2845458,137.787352 C80.6638854,137.798372 80.4743841,138.228152 80.3689124,138.736232 C79.7754892,138.784372 79.4411092,139.099892 79.3721469,139.695552 C79.3408531,139.874772 79.3084003,140.053992 79.2759474,140.232632 C78.515624,140.565552 78.4101523,141.237192 78.3887102,141.951172 C78.302942,141.977852 78.2171739,142.008592 78.1331442,142.041072 C77.7912305,141.809652 77.6788046,141.226752 77.0975512,141.357252 C76.6629151,141.031292 76.228279,140.703592 75.7936429,140.377632 C75.2709205,139.070892 73.9867156,138.075612 74.1733194,136.480612 C74.3413787,135.044532 73.7039124,134.004592 72.6045728,133.180992 C72.5877668,132.640432 72.5721199,132.098132 72.5558935,131.557572 C73.435597,131.315712 74.3106644,131.054132 75.1955836,130.837792 C75.6858531,130.717732 75.7362709,130.374372 75.7345323,129.978812 C75.7304757,129.359372 75.289465,129.328632 74.8345458,129.319932 C74.6543167,129.294992 74.47119,129.267732 74.2909609,129.242792 C73.9368774,127.868192 74.2214191,126.480832 74.2121469,125.098692 C74.9058261,125.095212 75.1428477,124.693852 75.1103949,124.058172 L75.1208261,124.051212 C76.3569313,123.163232 76.6895728,121.350152 75.895058,119.813732 L75.9025916,119.305652 C76.8877668,118.729132 77.2047615,117.672952 76.4728342,117.015812 C75.4355027,116.084912 75.0211496,115.079192 74.9545054,113.788112 C74.9330633,113.340352 74.5650714,113.175632 74.178535,113.079352 L74.175058,113.074132 C74.2498154,112.364792 73.8006914,112.160632 73.219438,112.085232 C73.0797749,111.542932 73.5341146,110.714112 72.5043167,110.603332 L72.4504218,110.524452 C72.4197075,109.838892 72.4197075,109.137092 71.540004,108.940472 C71.2809609,108.848832 71.0207588,108.754292 70.7617156,108.662652 C70.835314,108.206192 70.5669987,108.013052 70.1804623,107.914452 C70.2001658,107.572832 70.3717022,107.319952 70.6440741,107.125072 L71.5649232,107.017772 C72.1067695,107.135512 72.2319447,106.747492 72.2643976,106.368172 C72.3768235,105.087532 72.9175108,104.914112 74.2445997,104.903672 C75.7304757,104.890912 77.1189933,103.721632 78.7196132,103.537772 C78.9079555,103.516312 79.0510957,103.034332 79.1994515,102.760572 C79.5494784,102.106912 79.8305431,101.409172 80.2506914,100.809452 C80.6551927,100.230612 81.1454623,99.669172 81.87681,100.564112 C82.4331442,101.244452 83.0752466,101.145852 83.6489663,100.504952 C84.1757453,99.919732 84.9198423,99.536352 85.2449501,98.766692 L85.2252466,98.743492 C85.43619,98.757412 85.6477129,98.773652 85.8586563,98.788152 C85.8586563,98.788152 85.8569178,98.788152 85.8586563,98.788152 C86.158845,100.196972 87.0084137,99.695852 87.8156779,99.350172 C88.6449636,99.228372 88.5881712,100.590792 89.4881577,100.352412 C90.4055296,101.671912 92.0171604,100.734052 93.0145054,101.355232 C95.4461496,102.871352 97.6761226,101.004332 100.006931,101.193992 C100.645557,101.245612 101.051796,100.445792 101.303885,99.900012 C102.020745,98.338652 103.133414,97.683252 104.793724,98.021972 C105.205179,98.444212 105.621271,98.854272 106.277861,98.824112 C106.342187,99.539832 106.718292,99.788652 107.403279,99.575792 C107.809519,99.597252 108.213441,99.620452 108.619681,99.643652 C109.216581,100.524672 108.564047,101.594772 108.997524,102.457812 C109.470988,103.399732 108.959276,103.668272 108.247632,103.913612 C107.728966,103.918832 107.210301,103.940292 106.693373,103.922312 C105.988104,103.897372 105.59809,104.162432 105.679222,104.922812 C105.673427,105.041132 105.66995,105.159452 105.664735,105.279512 C105.66995,106.459232 105.675166,107.642432 105.679222,108.823892 C105.215611,109.384172 105.762673,109.894572 105.762673,110.431652 C105.727322,110.757032 105.690233,111.081252 105.653724,111.405472 C104.844142,111.507552 104.87022,112.087552 104.834869,112.712212 C104.707376,114.899972 105.339047,117.091212 104.802416,119.273172 C104.759532,119.360752 104.72708,119.452392 104.709694,119.549252 C104.235651,119.745872 103.915179,119.984252 104.446594,120.469132',
	                                id: 'Fill-11', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M89.4250485,234.0735 C89.2210593,234.03058 89.0193881,233.98766 88.816558,233.94242 C87.6598464,232.26332 85.2328383,231.91068 83.5655741,233.34502 C82.9802642,233.84788 82.8481348,233.80496 82.3399003,233.33748 C81.4260054,232.49996 80.0902237,231.8608 79.0743342,232.4785 C77.3143477,233.54744 76.3448194,232.34046 75.0635121,231.70826 C74.0551563,231.21062 73.8726092,230.66136 74.1084717,229.57502 C74.4179326,228.15866 74.7917197,226.68198 72.7060458,225.8955 C71.8101159,225.55736 70.8139299,224.37416 71.658283,222.97056 C72.1485526,222.89922 72.6382426,222.82556 73.1267736,222.7519 C73.8007493,222.90618 74.121221,222.6504 74.1299137,221.94686 C74.1368679,221.42254 74.2122049,220.89764 74.2550889,220.37332 C74.8763288,220.30314 75.4836604,220.3072 75.8846846,219.63034 C76.2016792,219.09674 76.6931078,218.65304 77.3925822,218.59736 C79.2082022,218.6136 79.3409111,218.45004 78.5475553,216.95364 C78.2711267,216.42758 78.4501968,215.91196 78.3748598,215.39808 L78.3852911,215.38764 C79.2006685,215.19914 80.179469,215.41432 80.6929191,214.4637 C81.3402372,214.48168 81.9875553,214.49966 82.6348733,214.51764 C82.9860593,215.73854 83.8982156,216.13932 85.0497116,216.12308 C87.4413693,216.09118 89.7037951,214.99034 92.1348598,215.26584 C92.3284178,215.30528 92.5213962,215.34588 92.7143747,215.38764 C93.2260863,216.23618 94.1208571,216.40438 94.4106146,215.53786 C94.79831,214.3796 95.8895364,213.05662 94.524779,211.78178 C94.546221,211.41348 94.5925822,211.0446 94.5815714,210.67572 C94.5195633,208.481 94.7177574,208.336 96.930345,208.50072 C98.2667062,208.60106 99.4523935,209.39218 100.822946,209.2611 C100.920884,209.27792 101.015925,209.30402 101.108647,209.34346 C102.016167,210.28016 102.640305,211.40246 103.813243,212.19184 C106.126086,213.74914 107.618337,213.95678 109.689523,212.26318 C110.093445,211.93258 110.531558,211.83746 110.976625,211.68202 C112.565655,211.83572 114.155844,211.93606 115.757043,211.83224 C116.099536,211.81078 116.566625,211.7319 116.69238,212.2133 C116.810022,212.66454 116.622259,213.0746 116.202111,213.28746 C115.876423,213.45218 115.49858,213.51656 115.145075,213.62618 C113.559523,213.85296 113.271504,215.29078 113.656302,216.195 C114.345345,217.8045 113.306275,217.6914 112.450911,217.94718 C112.078863,218.0191 111.856908,218.24298 111.774617,218.61128 C111.698121,218.8514 111.622784,219.09152 111.545709,219.33106 C110.635871,220.15988 110.401167,221.02466 111.408364,221.95556 C111.153957,223.00304 112.357609,223.90146 111.665668,225.05798 C111.476167,225.37466 112.162892,225.44658 112.515817,225.504 C112.576086,226.05152 112.973633,226.17506 113.427394,226.22726 C114.264792,226.26264 115.100453,226.2986 115.937272,226.3363 C116.720776,226.93254 117.519927,227.00736 118.3411,226.40764 C118.655776,226.44186 118.972191,226.47782 119.287447,226.51146 C119.330332,226.94472 119.573148,227.12916 119.999671,227.09552 C120.083121,227.1541 120.174685,227.20456 120.272623,227.24226 C120.838229,228.05136 120.565857,229.37956 121.834415,229.75192 C122.17459,230.9067 121.380655,231.78192 121.127987,232.7917 C120.283633,236.1876 118.115668,237.73098 114.763755,238.35912 C113.483027,238.59924 111.845898,238.77788 110.876949,240.06548 C110.553,240.10086 110.23079,240.13682 109.909159,240.17278 C109.598539,239.888 109.274011,239.8735 108.941949,240.12986 C108.764617,240.10666 108.587286,240.08288 108.410534,240.05968 C107.98459,239.43502 108.014725,238.37014 107.002313,238.3162 C106.315588,238.28024 105.829375,238.72974 105.793445,239.50288 C105.76273,239.61018 105.734914,239.71632 105.704199,239.82362 C105.074267,239.81434 104.765385,240.1635 104.668606,240.75104 C102.895871,240.17452 101.990668,238.48614 100.527394,237.51406 C100.370345,236.57446 99.5955337,236.26648 98.8780943,235.89934 C98.8265175,235.80654 98.7749407,235.71142 98.7227844,235.61862 C98.7691456,234.98642 98.2898868,235.01832 97.885965,234.95452 L97.8766927,234.94524 C97.1233235,233.16928 95.9967466,232.86884 94.6337278,234.07698 C94.0773935,233.90878 93.5459784,234.10946 93.0081887,234.19182 C92.2855337,233.80844 91.4017736,234.0822 90.6773801,233.50046 C90.2299946,233.1426 89.7008976,233.5544 89.4250485,234.0735',
	                                id: 'Fill-13', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M107.627088,423.813424 C107.550012,423.757744 107.464823,423.728164 107.369783,423.722364 C107.27822,423.111624 107.004689,422.738104 106.313907,422.909204 C105.791764,422.906304 105.269621,422.902824 104.747478,422.900504 C103.338098,422.852364 101.930457,422.804224 100.520497,422.755504 L100.50485,422.770004 C100.486885,422.340224 100.470659,421.908704 100.454433,421.477764 C100.336212,420.180884 100.463705,418.863704 100.896602,417.683984 C101.880039,415.007284 101.960592,415.036284 99.5138801,413.705764 C99.4652008,413.632684 99.3991361,413.600784 99.3133679,413.609484 C98.7158881,412.714544 98.0934892,411.842224 97.2207399,411.185664 C96.247155,410.393964 95.170996,409.961284 93.880996,410.050604 C92.9844865,410.111504 92.0798639,410.050604 91.1781388,410.043644 C89.9605782,408.905104 88.6439205,407.834424 88.4915081,405.981324 C88.4845539,405.917524 88.2266698,405.874024 88.0852682,405.821824 C88.0464407,405.582284 88.0087722,405.343904 87.9711038,405.104364 C88.4862925,404.483184 89.4917507,404.261044 89.4558208,403.192104 C89.4042439,401.573904 89.387438,399.953964 89.3578827,398.333444 C89.4164137,398.018504 89.4488666,397.698344 89.5363733,397.392104 C90.2503356,394.943344 90.2798908,394.918404 92.8917642,394.721204 C93.5947156,394.669004 94.254783,394.531544 94.7398369,393.960244 C95.0365485,393.933564 95.3315216,393.908044 95.6247561,393.883104 C96.3404569,394.191664 96.5624111,393.897604 96.2546887,393.267724 C96.0541765,392.857664 95.6502547,392.546204 95.3390553,392.191244 C95.0898639,391.479004 95.9573976,391.289344 96.0240418,390.723844 C96.1526941,390.591604 96.2813464,390.457044 96.4105782,390.324804 C97.4994865,390.178064 98.5014677,389.592264 98.7518181,388.627144 C99.238031,386.761864 100.238274,387.232824 101.427438,387.676524 C102.30946,388.006544 103.028058,388.844064 104.110592,388.573784 C104.495389,388.928164 104.920753,389.035464 105.405807,388.784904 C106.357371,388.840584 107.308934,389.120144 108.260497,388.788384 C108.516063,388.893944 108.755982,388.870744 108.975619,388.700804 C110.194338,388.385864 110.501481,389.872984 111.508678,389.982604 C111.549823,390.168784 111.592708,390.353224 111.635592,390.537664 C112.0314,391.649524 112.424311,392.760804 112.81954,393.870924 C114.799743,394.685244 115.626131,396.908384 117.608071,397.762724 C118.334783,398.075924 118.775794,398.949984 118.240902,399.667444 C117.513611,400.645324 118.234527,401.151664 118.777532,401.468924 C120.060578,402.213064 121.453732,402.766384 122.804001,403.396264 C122.856158,403.603904 122.870646,403.829524 122.963368,404.015704 C123.936953,405.949424 123.925942,406.132124 121.886629,406.871044 C120.651104,407.320544 120.141131,408.363964 119.46136,409.280364 C119.133354,409.721164 119.332128,410.095844 119.931346,410.143984 L119.93888,410.148624 C120.13012,411.427524 120.171265,412.542284 118.450686,412.874044 C117.952883,412.966844 117.409877,413.600784 117.400605,414.339704 L117.396549,414.342024 C115.915888,414.898824 115.084284,415.942244 115.086023,417.551744 C115.0895,418.519764 115.105726,419.475604 114.651387,420.367644 C114.565619,420.367644 114.486805,420.389104 114.413786,420.435504 C114.017977,420.501624 113.848179,420.770164 113.794864,421.139044 C113.207815,421.151224 112.615551,421.223144 112.037775,421.166304 C110.094082,420.976064 108.966926,421.694104 108.995322,423.783264 L108.966926,423.797764 C108.51954,423.801244 108.073894,423.808204 107.627088,423.813424',
	                                id: 'Fill-15', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M182.702596,254.480278 C182.899631,254.483758 183.096086,254.485498 183.293121,254.489558 C184.475332,255.212818 184.886787,254.977918 184.972555,253.529658 C185.094253,251.469498 185.385749,251.193418 187.472582,251.118598 C187.84521,251.105838 188.217259,251.039718 188.588728,250.998538 C188.882542,251.034498 189.177515,251.069878 189.471329,251.105838 C190.153997,252.149258 191.658418,252.639938 191.676383,254.107918 C191.696666,255.796298 192.350358,257.325178 192.68358,258.932358 C193.275264,261.795238 193.282798,261.791178 190.344078,261.893258 C190.243822,261.897318 190.149361,261.977938 190.050844,262.022018 C189.857286,262.011578 189.664307,262.001138 189.471329,261.990118 C188.760844,260.775018 187.585588,261.205958 186.54304,261.166518 C185.95773,261.166518 185.310412,260.871298 184.852596,261.506978 C184.174563,261.850338 183.475089,262.038258 182.699119,262.067258 C181.70583,262.104958 180.883499,262.609558 180.736302,263.633838 C180.574038,264.775858 180.636625,265.949778 180.600695,267.110358 C180.579253,267.391078 180.55955,267.674118 180.538687,267.954838 C180.241396,268.073158 180.221693,268.350978 180.135345,268.605018 C179.252164,271.200518 179.938889,273.982778 179.182623,276.604958 C179.062663,277.022558 178.678445,277.967958 179.752865,278.128618 C180.257043,278.173858 180.759482,278.216198 181.263081,278.259698 C181.722636,279.031098 182.51831,279.619798 182.36242,280.715418 C182.285925,281.265258 182.627259,281.725198 183.300075,281.732158 L183.297757,281.732158 C183.246181,282.504138 183.560857,283.049918 184.284092,283.348618 C184.898957,283.825378 185.489482,284.310258 185.816908,285.054978 C186.628229,286.906338 188.016747,287.378458 189.907704,286.496278 C190.946774,286.010818 191.96614,285.423858 192.507987,287.176618 C192.746167,287.953238 193.647892,287.491558 194.229146,287.659758 C194.517164,288.903858 194.443566,290.190878 194.874725,291.442518 C195.172016,292.307298 195.284442,293.413358 194.724051,294.269438 C193.290332,296.469378 193.064321,299.534098 190.182973,300.717298 C190.086194,300.758478 190.074024,301.005558 190.020129,301.158098 C189.844536,301.191738 189.666046,301.224218 189.488714,301.259598 C189.388458,301.278158 189.245318,301.257858 189.197218,301.317018 C187.065183,303.880618 184.518216,305.153718 181.149496,303.972258 C181.023162,303.927018 180.842353,304.020398 180.689941,304.058098 C178.381154,304.623598 178.132542,304.422918 178.157461,301.999098 C178.162677,301.515958 178.166733,301.030498 178.142973,300.547358 C178.116315,300.010278 177.880453,299.534098 177.295143,299.578758 C176.021949,299.677358 174.975345,299.156518 173.938013,298.549258 C173.895129,298.368878 173.853404,298.189658 173.81052,298.008698 C173.696356,296.870158 173.95366,295.459598 173.374146,294.655718 C172.637582,293.635498 172.664819,292.874538 173.032811,291.895498 C173.841235,291.745278 175.079078,292.262638 175.368836,291.465718 C175.645844,290.699538 174.651396,289.942058 174.064927,289.259978 C173.63203,288.755378 172.814914,288.284418 173.819792,287.450378 C174.201113,287.133698 173.982636,286.397678 173.689402,285.939478 C173.389213,285.468518 172.896625,285.764318 172.498499,285.824638 C170.961625,286.057218 169.562677,286.924318 167.93366,286.759018 C167.162326,286.678978 166.509792,286.607058 166.033431,285.815938 C165.463189,284.867058 164.416585,284.503978 163.386208,284.206438 C162.402771,283.923398 160.789402,281.206098 161.170143,280.301878 C161.451208,279.634298 161.881787,279.097218 162.809011,279.004418 C163.983687,278.884358 165.287596,278.670918 165.420305,277.045758 C165.464927,276.488958 165.901302,276.526658 166.258863,276.520858 C167.067865,276.510418 167.878027,276.544638 168.687609,276.558558 C169.934725,276.755758 171.215453,276.311478 172.476477,276.943678 C172.884456,277.147838 173.902084,276.875818 173.860938,275.856758 L173.860938,275.853278 C175.120224,274.788398 175.385062,273.486878 174.787582,271.979458 C174.770197,271.789798 174.751652,271.598398 174.733687,271.408738 C174.99331,270.839178 174.724995,270.266138 174.737744,269.693098 C174.753391,268.830638 173.760682,268.139278 174.281666,267.176478 C174.571423,267.094118 174.710507,266.888218 174.744698,266.598218 C175.476046,266.361578 175.694523,265.858718 175.49459,265.140678 C175.526464,264.955078 175.556598,264.766578 175.587313,264.580978 C176.173782,264.568218 176.442097,264.267198 176.465278,263.680238 C176.490197,263.035278 176.116989,262.849678 175.572825,262.815458 C175.585574,262.217478 175.597744,261.617758 175.610493,261.019778 C176.713889,260.548818 176.345318,259.116798 177.245305,258.515338 L177.305574,258.442258 C177.661976,258.426018 177.925075,258.253758 178.107043,257.953318 C178.645992,257.874438 179.223768,258.019438 179.709981,257.658098 C181.3361,257.194098 182.345035,256.143138 182.702596,254.480278',
	                                id: 'Fill-17', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M89.1194124,439.657458 C89.02669,439.655718 88.9403423,439.680658 88.8638464,439.732858 C86.7781725,440.239198 84.7208949,440.908518 82.5262722,440.742058 C81.9160431,440.697398 81.5138598,441.037858 81.2936442,441.598138 C81.1870135,441.583638 81.1006658,441.619598 81.0363396,441.707178 C80.7089137,441.712398 80.4208949,441.744878 80.190248,442.052858 C79.0202075,443.613638 78.6678625,443.680338 77.7076065,442.176398 C76.9600323,441.007118 75.9134286,439.813478 74.7346954,440.248478 C73.3658814,440.751338 72.237566,440.026338 71.0246415,440.282118 C70.8815013,440.314598 70.7621213,440.464818 70.6363666,440.568638 C69.6604636,441.372518 69.1162992,442.395058 69.0444394,443.671058 C68.8949245,446.379658 70.3037251,448.711838 70.8733881,451.247018 C71.2697763,453.015438 70.3697898,454.316958 68.5570674,454.340158 C67.858752,454.351178 67.1523235,454.268818 66.4800863,454.537358 C65.7771348,454.267078 65.5424313,454.691638 65.4085633,455.260618 C65.1976199,455.265838 64.984938,455.273378 64.7734151,455.279178 C64.5300189,454.401638 63.8432938,454.358718 63.1136846,454.398158 C62.4124717,453.732318 61.6718518,453.196978 60.6130782,453.390118 C60.0747089,453.488718 59.7235229,453.171458 59.4824447,452.719058 L59.4552075,449.674058 C61.0674178,448.332518 61.0923369,447.280398 59.5450323,445.865778 C59.5201132,444.792198 59.2460027,443.646118 59.5259084,442.656058 C60.0069057,440.946798 60.4948571,439.476498 59.5937116,437.616438 C59.1069191,436.614198 59.6771617,434.965258 60.5754097,433.839478 L60.5736712,433.842958 C61.5142237,433.642278 61.4696011,432.688178 61.7732668,432.082658 C62.4878086,430.672678 64.3712318,429.227898 63.791717,427.928118 C62.7538059,425.599418 64.4674313,425.069298 65.4514474,423.948738 C65.4839003,423.912778 65.4856388,423.848398 65.5012857,423.797938 C66.2407466,423.819398 66.6962453,423.382658 67.0793046,422.825858 C67.7660296,422.627498 68.250504,421.954698 69.0340081,421.982538 C69.3417305,422.003998 69.6511914,422.026038 69.9589137,422.047498 C71.9767844,421.746478 73.1085768,420.516878 73.5739272,418.590698 C74.2606523,418.497898 74.1945876,418.026358 74.0978086,417.541478 C74.1053423,417.335578 74.1122965,417.131418 74.1192507,416.927838 C74.6437116,416.667418 75.0331456,416.289838 75.1872965,415.706358 C76.5410431,415.226698 77.0081321,416.801978 78.0866092,416.963218 C80.2366092,418.504278 81.28669,420.881698 82.6618787,423.012618 C82.9104906,423.393678 83.1701132,423.701078 83.6800863,423.614078 L83.7531051,423.690638 C83.6731321,424.115198 83.8910296,424.310078 84.277566,424.377938 C84.4044798,424.714338 84.529655,425.050738 84.6583073,425.387718 C84.2416361,425.863898 84.1645606,426.204358 84.9770404,426.191598 C85.5345337,426.957778 85.7315687,428.066158 86.913779,428.244798 C87.1253019,428.463458 87.3345067,428.683278 87.5431321,428.901938 C87.6474447,429.824138 87.9209757,430.794478 88.5184555,431.395938 C89.5418787,432.432398 89.3013801,434.383518 91.0706388,434.812718 L91.0689003,434.811558 C91.0741159,435.353858 91.0799111,435.896738 91.0851267,436.438458 C90.0176604,437.258578 89.6038868,438.479478 89.1194124,439.657458',
	                                id: 'Fill-19', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M93.0356577,344.72155 C93.1996604,344.69081 93.362504,344.66123 93.5276658,344.63049 C94.2056981,344.92049 94.8333127,344.84683 95.2140539,344.18621 C96.1012911,342.64341 97.544283,341.41323 97.8323019,339.53403 C97.874027,339.24403 97.9151725,338.95403 97.954,338.66229 L97.9615337,338.65475 C98.9235283,338.49003 99.3100647,337.63801 99.8971132,337.02727 C100.090092,336.99885 100.281332,336.97391 100.476628,336.94897 C101.676224,336.95767 102.87524,336.96463 104.075415,336.97217 L104.046439,337.01335 C104.12931,337.80621 104.799809,338.15711 105.282544,337.81143 C106.268299,337.10267 106.882005,337.90829 107.597127,338.16001 C108.138973,338.35257 108.578825,338.82295 109.230199,338.62749 C109.430712,338.63851 109.631224,338.64721 109.832895,338.65823 C109.905914,338.97723 110.025873,339.44181 110.330119,339.41049 C112.220496,339.20053 113.641466,340.26251 115.156318,341.08553 L115.928811,341.31695 C115.964162,341.51937 115.998933,341.71947 116.034863,341.92015 C116.084121,342.24901 116.134539,342.57903 116.184377,342.90847 L116.159458,342.92239 C115.311628,343.25763 113.69652,343.24487 114.73559,344.73257 C115.47679,345.79049 116.077747,346.36121 113.866318,346.80897 C114.932625,347.08795 115.492437,347.23527 116.052248,347.38201 C116.155981,348.05655 114.823677,347.77061 115.214849,348.63887 C115.129081,349.08083 115.345819,349.28093 115.760752,349.32791 C116.839229,350.71527 116.669431,351.68213 115.16559,352.59273 C114.036116,353.27713 112.915334,353.65993 111.532032,353.16229 C110.745631,352.87925 109.620213,352.75919 109.376817,354.04273 C109.135159,355.30713 109.861291,355.79781 111.049296,355.82449 C111.480456,355.83319 112.101116,355.62555 112.142261,356.41319 C111.742976,356.44741 111.342531,356.48105 110.943825,356.51353 C110.112221,356.37259 109.189054,356.78207 108.443218,356.27747 C107.01935,355.31235 106.567329,356.13421 106.25555,357.34467 C106.10024,357.34293 105.942032,357.33887 105.787302,357.33539 C105.727612,356.26819 104.828205,355.78331 103.874903,355.00437 C105.878286,354.90751 105.99245,354.00387 105.391493,352.71279 C105.044943,351.96981 104.788798,351.24481 105.448865,350.46123 C105.878286,349.95083 105.690523,349.40099 105.184027,348.89813 C104.280563,348.00087 101.927154,347.61633 100.549647,348.35757 C99.8681375,348.72413 99.128097,348.92713 98.5520593,348.61335 C97.3802803,347.97767 96.1708329,348.04263 94.9422615,348.03161 C94.396938,348.02813 93.8579892,347.87733 93.9814259,347.25267 C94.1923693,346.16981 93.5433127,345.48947 93.0356577,344.72155',
	                                id: 'Fill-21', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M104.847271,264.57396 C105.124858,264.52176 105.399549,264.47188 105.677136,264.41968 C106.755613,264.45738 107.83409,264.49508 108.913147,264.53104 C109.340249,264.67082 110.003794,264.65632 109.82878,265.34362 C109.437028,266.87424 110.645896,267.37188 111.496044,268.11486 C111.540667,268.8271 111.361597,269.67564 112.477743,269.73654 L112.479481,269.73828 C112.812123,271.10998 112.508457,272.136 111.281044,273.05936 C109.798066,274.17644 109.755182,276.50166 111.28626,277.33454 C112.921651,278.22426 112.367055,278.88256 111.536611,279.79026 C111.347109,279.82796 111.155869,279.86566 110.966368,279.9051 C109.17219,279.78852 107.617352,281.24084 105.757109,280.69796 L105.750735,280.691 C105.820276,279.83666 105.318996,279.74734 104.65777,279.87262 C104.462473,279.84594 104.269495,279.81926 104.074198,279.79258 C103.736341,279.19982 103.129589,279.04032 102.575573,279.15342 C101.831476,279.30538 101.130263,279.66324 100.411085,279.93178 C99.9173383,279.90858 99.4259097,279.88538 98.9315836,279.86218 C98.538093,279.72762 98.1787938,279.75662 97.8872978,280.08954 C97.171597,280.5547 96.6598854,281.20082 96.2646563,281.94786 C95.93781,281.71296 95.4260984,281.78488 95.2922305,281.2246 C94.9659636,279.86044 94.0665566,278.76134 93.4227156,277.55088 C93.0935512,276.93492 93.0419744,276.76324 93.5959906,276.3033 C94.3725404,275.66066 95.2922305,274.71352 94.9485782,273.7542 C94.4513544,272.3593 94.7283625,271.00616 94.5730526,269.64548 L94.6246294,269.68144 C95.9070957,269.16582 94.8964218,267.94318 95.3924865,267.18396 C96.9177695,267.27734 98.008996,265.76238 99.5864353,266.04542 C99.7029178,266.162 99.8188208,266.278 99.9335647,266.39632 C99.8512736,266.88004 100.092931,267.06042 100.541476,267.04824 L100.555964,267.06216 C100.529306,267.79644 100.450492,268.56088 101.448416,268.75054 L101.450735,268.75228 C101.498834,269.05098 101.482028,269.5579 101.854656,269.46684 C102.511247,269.3056 103.145815,268.96514 103.117419,268.09862 C103.39095,267.98088 103.421664,267.72974 103.451799,267.47918 C104.909279,266.98908 104.686166,265.68698 104.847271,264.57396',
	                                id: 'Fill-23', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M127.755608,177.054802 C127.229408,177.140642 126.703788,177.223582 126.179327,177.047842 C126.103991,176.421442 126.022279,175.794462 126.221053,175.173282 C127.63391,174.461042 129.039813,173.767942 128.751794,171.759402 C128.669503,171.179402 128.488694,170.855762 127.887737,170.843002 C127.823411,170.771662 127.772993,170.692782 127.737643,170.602882 C127.719678,170.146422 127.701713,169.691702 127.683748,169.235242 C127.537131,168.101922 126.782023,168.433102 126.103991,168.574622 C124.211875,168.701642 122.321497,168.637262 120.720298,170.072762 C120.250311,170.493842 119.159085,170.225302 118.353559,170.271702 C117.926457,170.271702 117.499354,170.271702 117.072832,170.273442 C116.160675,170.191662 115.304732,170.638842 115.200419,171.406762 C115.076982,172.316202 114.379247,172.740762 114.089489,173.454742 C113.034772,173.512162 111.975999,173.571322 110.918384,173.630482 C110.709179,173.640922 110.499974,173.653682 110.29019,173.664122 C109.076106,173.621202 107.863182,173.578282 106.64678,173.535362 C105.813438,173.531882 105.350406,172.849802 104.79581,172.413062 C104.299745,172.022722 103.849462,171.764622 103.232858,171.804062 C103.174907,171.279742 103.119274,170.758902 103.06422,170.236322 L103.072912,170.217762 C104.273088,169.888902 104.037225,169.244522 103.56492,168.397722 C102.992939,167.369962 102.075567,166.422822 102.462683,165.063882 C103.890608,165.214682 105.20147,164.898002 106.486255,164.242602 C107.365958,163.793102 107.53054,163.229342 106.829907,162.658042 C106.011632,161.992202 105.75085,161.071742 105.350406,160.209282 C104.593559,158.583542 104.790015,158.071982 106.330365,157.345242 C106.591147,157.221122 106.729651,156.999562 106.739503,156.703762 C107.557198,156.643442 108.373155,156.582542 109.188532,156.519902 C109.912926,156.677082 110.013182,156.252522 109.959867,155.688762 L109.972036,155.674842 C111.041821,155.651062 112.111605,155.626122 113.181389,155.601182 C113.643842,155.798382 113.975325,156.105782 114.155554,156.599942 C114.379247,157.214162 114.79302,157.568542 115.501187,157.353942 C116.222104,157.438042 116.941282,157.523882 117.661619,157.609722 C117.626268,158.132302 117.899799,158.288322 118.372104,158.209442 C120.008654,159.016802 121.886861,159.482542 123.192508,160.773042 C124.356753,161.924342 125.769611,162.598882 127.075837,163.479902 C127.14364,163.929402 127.426443,164.061642 127.840796,163.997262 C128.671241,164.349902 129.508061,164.463002 130.361686,164.074402 C130.664193,164.119062 130.946416,163.975802 130.998573,163.725242 C131.314988,162.133722 132.474018,162.407482 133.568721,162.513042 C133.753007,163.026922 134.01205,163.438722 134.659947,163.326202 C134.7405,163.377822 134.82395,163.413202 134.915513,163.433502 C135.468371,164.468222 134.423505,165.361422 134.655891,166.369462 C134.670958,166.488942 134.684867,166.607262 134.698775,166.727322 L134.624018,166.722102 C133.411093,167.557882 133.504395,169.025862 132.957333,170.182382 C131.636619,170.436422 131.853357,171.734462 131.354395,172.548782 C130.77488,172.688562 130.357629,172.958842 130.490338,173.653682 C130.699543,174.745822 130.077144,175.473722 129.395635,176.177842 C129.196861,176.188282 128.998667,176.199302 128.802212,176.208002 C128.320635,176.145362 127.88426,176.148842 127.89643,176.818742 C127.830365,176.886602 127.784004,176.965482 127.755608,177.054802',
	                                id: 'Fill-25', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M121.94348,348.984898 C121.932469,348.886298 121.904652,348.796978 121.852496,348.712878 C121.208075,347.042478 120.620447,345.347718 119.891997,343.714438 C119.573844,343.000458 119.346674,342.165838 119.86534,341.758098 C121.138534,340.760498 120.489477,339.731578 120.189288,338.680618 C119.747119,337.143038 120.750259,335.901838 121.165771,334.593358 C121.371499,333.945498 121.849019,334.708198 122.046054,335.232518 C122.749005,337.123318 123.920205,337.372138 125.143561,335.945338 C125.551539,335.950558 125.774652,335.748138 125.819275,335.345038 C126.234787,335.209318 126.651458,335.075338 127.068709,334.940778 C127.542173,335.023138 127.744423,334.800998 127.729935,334.342798 C127.729935,334.342798 127.739208,334.331778 127.740946,334.334098 C128.38131,334.432118 128.699464,334.093978 128.840865,333.517458 C129.135838,333.484978 129.429652,333.453658 129.722887,333.421178 C130.286175,333.823698 130.862213,333.745398 131.441728,333.460038 C131.741916,333.498318 132.042685,333.535438 132.344612,333.573138 C132.640164,334.432118 133.298493,334.416458 134.011876,334.262178 C134.21065,334.294658 134.411162,334.328298 134.611094,334.362518 C134.659194,334.948318 134.97445,335.282978 135.553965,335.366498 C135.577146,335.626918 135.611337,335.880378 135.883129,336.011458 C136.010043,336.815338 136.509005,337.021238 137.239194,336.859998 C138.483992,336.942358 138.294491,337.758998 138.111364,338.573318 C136.952334,338.298978 136.090596,338.766458 135.694787,339.812198 C135.278695,340.913038 134.49693,341.245958 133.459019,341.321358 C132.325488,341.401978 131.971404,341.963998 131.983574,343.136178 C132.005016,344.965498 131.897806,346.677078 134.088951,347.463558 C134.620367,347.653218 135.020811,348.347478 135.362146,348.886298 C135.960205,349.826478 135.374895,351.346078 134.367698,351.233558 C132.037469,350.976038 130.037563,352.337878 127.793102,352.336138 C127.275596,352.242758 126.889639,352.355858 126.810245,352.955578 C126.60162,353.007778 126.392415,353.059398 126.182631,353.111018 C125.057792,353.077378 123.859356,353.383618 123.442685,351.713218 C123.258399,350.978938 122.177604,351.473098 121.462482,351.110018 C121.841485,350.465638 123.498318,349.998158 121.94348,348.984898',
	                                id: 'Fill-27', fill: '#00FF00' }),
	                            _react2.default.createElement('path', {
	                                d: 'M18.6784003,429.937354 C19.6537237,429.593414 19.4103275,428.069754 20.6070256,427.940994 C21.2010283,428.524474 21.9642493,428.556954 22.7228342,428.601614 C23.6686024,429.201334 25.2524164,428.877114 25.4842224,430.511554 C24.5042628,430.698314 23.8621604,431.176234 23.9537237,432.287514 C23.0890876,432.245174 22.2041685,431.984754 21.2978073,432.464414 C21.8083598,433.127354 22.5460822,433.007294 23.0641685,433.322234 C23.497066,433.585554 24.4098019,433.840174 23.184128,434.488034 C22.5530364,434.820954 22.7639798,436.228034 23.1308127,436.217014 C24.3234542,436.179894 25.5421739,435.612074 25.9727534,437.359614 C27.4105296,436.541234 26.9191011,437.883934 27.1532251,438.413474 C27.1624973,438.598494 27.1694515,438.780614 27.1787237,438.965054 C27.0657183,439.741674 27.0819447,440.452754 28.0497345,440.678374 C28.1389798,440.729994 28.227066,440.783934 28.3122547,440.837874 C28.3731038,441.162094 28.5660822,441.345954 28.890031,441.394674 C29.3571199,441.640014 29.8004488,441.904494 29.8021873,442.523934 C29.7685755,443.238494 29.7436563,443.948994 30.5630903,444.298154 C30.6053949,444.390954 30.6343706,444.489554 30.648279,444.591634 C30.6610283,445.046354 30.9223895,445.209334 31.3407992,445.191354 C31.2851658,445.901854 31.8090472,446.227814 32.2674434,446.598434 C32.7038181,447.500334 32.5548827,448.134274 31.4961092,448.424274 C30.317376,448.745014 29.9621334,449.908494 30.3138989,450.663654 C30.9096402,451.933274 29.8131981,452.309114 29.378562,452.461074 C28.4107722,452.799794 27.3143302,452.744114 26.3517561,453.286994 C26.0370795,453.463894 25.5242089,453.256254 25.5311631,452.776594 C25.5421739,451.913554 24.8461765,451.475074 24.5419313,450.830114 C24.1878477,450.076694 23.0844515,449.213654 23.3666752,448.801854 C24.3002736,447.445234 21.3505431,446.687754 23.0091146,445.443654 C22.831783,445.339834 22.6463383,445.247034 22.4759609,445.130454 C22.1983733,444.944274 21.6907183,444.944274 21.8425512,444.405454 C22.2615404,444.004674 22.9442089,444.476794 23.3973895,443.793554 C22.1039124,443.631734 21.8466078,442.931674 22.2024299,441.797194 C22.3722278,441.253154 22.2487911,440.619214 22.2580633,440.025294 C23.7132251,439.880294 23.9085216,438.250494 25.1712844,437.810274 C23.9409744,436.795274 23.1858666,437.944834 22.2812439,438.100274 C21.7874973,438.082294 21.4009609,437.971514 21.2114596,437.404274 C20.9698019,436.676954 20.3827534,436.373034 19.6230094,436.414214 C19.1507049,435.117914 18.5068639,434.912014 17.6804757,435.793034 C17.1815135,435.642234 17.1815135,435.182294 17.0632925,434.797754 L17.0418504,434.816894 C17.3623221,434.961894 17.6317965,434.793694 17.9151792,434.688134 C17.9968908,434.677694 18.0774434,434.666674 18.1597345,434.656234 C18.100624,434.600554 18.0415135,434.544874 17.984721,434.491514 C17.7859474,434.153374 17.5570391,433.884834 17.1096536,434.088414 C17.0777803,433.773474 17.0441685,433.456214 17.0093976,433.141274 L17.0117156,433.141274 C17.7807318,433.104154 17.7453814,432.386114 18.0617965,431.949374 C18.4964326,431.347914 18.5839394,431.865274 18.6714461,432.224874 C18.6360957,434.464834 19.8264191,435.323814 21.989748,434.389434 C20.6157183,434.138874 19.7354353,433.524654 19.6444515,432.172674 C19.9092898,431.174494 18.882969,430.733694 18.6784003,429.937354',
	                                id: 'Fill-29', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M29.0711873,416.275686 C28.9941119,414.939946 30.0314434,415.435846 30.6828181,415.294906 C30.7558369,416.544226 31.7271038,416.757086 32.6572251,416.913106 C33.2802035,417.016346 33.9350553,416.932246 34.5731011,416.932246 C34.9990445,416.948486 35.4336806,417.655506 35.8480337,416.913106 C35.8323868,417.472806 35.8167399,418.031346 35.799934,418.589886 C35.6394084,418.591626 35.3438558,418.563206 35.3374811,418.597426 C35.0042601,420.158206 33.6070499,420.201706 32.4926429,420.695286 C32.0597453,420.886686 31.5752709,421.325746 31.657562,421.964906 C31.7328989,422.564626 31.1962682,422.768206 30.9546105,423.160286 C30.8456617,423.137086 30.7343949,423.113886 30.6254461,423.088946 C29.799058,423.069226 29.2763356,423.586586 29.1285593,424.273886 C28.8758908,425.441426 28.1677237,426.076526 27.1048935,426.334626 C26.4419286,426.493546 26.4790175,426.962766 26.3973059,427.423286 C25.4955809,426.911146 25.3663491,425.847426 24.7636536,425.124746 C26.1626024,424.499506 25.5170229,423.798286 24.8407291,423.096486 L24.8320364,423.108666 C25.6543679,422.985126 26.4309178,422.841866 26.5595701,421.771766 C26.6099879,421.364606 27.0104326,421.193506 27.4074003,421.123326 C27.904624,421.182486 28.0877507,420.618146 28.5009447,420.553766 C29.4733706,420.401806 29.7185054,420.131526 29.1928854,419.103766 C28.8851631,418.504626 28.6579933,417.457146 29.6524407,416.848146 C29.9224946,416.681686 29.8529528,416.567426 29.0711873,416.275686',
	                                id: 'Fill-31', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M128.452301,65.240024 C129.979902,65.506824 131.385805,66.307224 132.982947,66.269524 L132.972516,66.258504 C132.958028,67.956164 132.94354,69.652664 132.929632,71.350324 C132.136856,71.486044 131.929389,72.030664 131.995454,72.737684 C132.064996,73.464424 132.163513,74.191164 132.248123,74.916164 L132.192489,74.957344 C131.705697,75.129024 131.380589,75.437004 131.317422,75.972344 L131.312786,75.981624 C129.545265,76.088924 129.352287,78.129364 127.811937,78.758084 C126.520778,79.284144 126.064699,79.053304 125.588918,78.048744 C125.361168,77.569084 125.423756,76.873084 125.089376,76.543644 C124.358028,75.816324 125.145009,74.202184 123.568729,74.046164 L123.568729,74.042684 C123.186249,71.613064 120.927301,71.448344 119.310454,70.508744 L119.33885,70.471044 C119.305239,69.874804 118.880454,69.810424 118.418001,69.801724 L118.380333,69.764024 C118.382071,68.929984 117.936425,68.322724 117.274619,67.927164 C116.525306,67.481724 116.262206,66.854744 115.972449,66.050864 C115.632853,65.107784 115.748756,63.877604 114.512651,63.288904 C113.860117,62.975704 113.794053,62.159064 114.087287,61.434064 L114.178271,61.344744 C116.716546,62.145144 118.614457,64.073064 120.955697,65.240024 C121.451182,65.487104 122.263082,65.329924 122.458379,65.956324 C123.176977,68.263564 125.642233,68.446264 127.084066,69.858564 C127.800926,70.435664 128.545023,70.809764 129.423567,70.171764 C129.885441,70.354464 130.35195,70.691444 131.029403,69.998344 C129.267678,70.014584 129.912098,68.199184 128.822611,67.674864 C127.643298,67.107624 127.638662,66.195864 128.452301,65.240024',
	                                id: 'Fill-33', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M114.904461,152.310204 C116.249515,152.231324 117.373194,152.924424 118.557143,153.386104 C119.608962,153.794424 120.589501,154.241604 121.29535,152.855984 C121.54628,152.363564 122.177951,152.166944 122.56217,152.417504 C123.746119,153.188904 125.071469,152.867004 126.313369,153.114084 C127.246968,153.300264 127.606267,154.172004 127.790553,155.025764 C128.237938,157.089984 129.255566,157.818464 131.359205,157.277904 C132.596469,156.961224 133.807655,156.472284 134.089879,154.895264 C134.285175,153.815884 134.884973,152.927904 135.937951,152.432004 C136.125714,152.342104 136.428221,152.204644 136.438652,152.071824 C136.642642,149.444424 138.816402,149.866664 140.339946,149.789524 C142.994704,149.653224 145.115728,148.463064 147.124906,146.988124 C148.658881,145.861764 150.295431,146.232384 151.934299,146.296764 C154.885768,146.409864 157.745674,147.272324 160.715108,147.333224 C162.054367,147.360484 162.983329,147.156324 163.335094,145.670364 C163.772049,143.826544 164.341132,142.032604 163.006509,140.287384 C162.689515,139.872104 162.710957,139.259624 162.861631,138.715584 C162.965364,138.731244 163.14965,138.726024 163.16066,138.767204 C163.648032,140.648724 165.361658,140.671924 166.765822,141.106924 C167.438639,141.316304 167.942817,141.559904 168.039596,142.313904 C168.019892,143.817264 169.382911,143.713444 170.233059,144.229064 C172.096199,145.364124 173.781429,146.810644 175.990539,147.349464 C175.812049,147.815204 175.55938,148.198004 175.536199,148.593564 C175.493315,149.338284 175.411024,150.125924 174.62752,150.313844 C173.700876,150.537724 172.749313,149.809244 172.48969,149.195024 C171.765296,147.492724 170.089919,147.832604 168.900175,147.202724 C168.26155,146.864004 167.534838,147.324524 167.152358,148.015304 C166.857385,148.545424 166.497507,149.053504 165.970148,149.315084 C165.113625,149.741384 165.099137,150.440864 165.12058,151.225024 C165.176213,153.394804 167.127439,153.384364 168.431348,153.924924 C169.259474,154.267124 170.144973,154.359924 170.275943,155.367384 C170.405755,156.379484 170.622493,157.530204 169.063019,157.907784 C170.266671,158.538244 170.266671,158.538244 170.296806,159.832804 C169.910849,159.880944 169.67093,160.081044 169.621092,160.480664 C169.415364,160.525324 169.077507,160.507344 169.023612,160.623924 C168.209394,162.374944 166.48186,163.813924 167.107736,166.069544 C166.913019,166.903584 166.23093,166.660564 165.700094,166.672744 C165.005836,166.688984 164.417628,166.767864 164.472682,167.671504 L164.486011,167.664544 C164.095997,167.655844 163.618477,167.476624 163.401739,167.926124 C163.245849,168.253244 163.655566,168.267744 163.852601,168.380844 C163.837534,168.470164 163.832898,168.561804 163.834636,168.652864 C163.601671,168.951564 163.490984,169.408024 162.961887,169.320444 C162.872062,169.304204 162.786294,169.275784 162.704003,169.236344 C162.809474,168.814104 162.581146,168.611684 162.206779,168.627924 C160.588194,168.699264 159.083774,168.301964 157.651213,167.578704 C157.593841,166.529484 156.717035,166.080564 156.087102,165.455324 C154.912426,164.291844 153.40279,163.500724 152.05252,162.675384 C150.254865,161.578024 152.00558,161.589044 152.270997,161.017744 C150.843652,160.704544 149.916429,159.904144 149.84341,158.364244 C149.827183,158.033644 149.787776,157.696664 149.315472,157.739584 C148.305377,157.831224 147.650526,157.172344 146.934825,156.630044 C145.311024,155.399864 143.713302,154.109364 141.441604,154.637164 C141.014501,154.737504 140.588558,154.571044 140.225202,154.297284 C138.291941,152.831044 138.362062,155.684644 137.104515,155.763524 C136.657129,155.790204 136.492547,156.329024 136.376644,156.753584 C136.352884,156.844644 136.369111,157.018064 136.426482,157.052284 C137.825431,157.856164 136.961375,159.198864 137.195499,160.274764 C137.631873,162.281564 137.595943,164.525004 139.94124,165.532464 C140.332992,165.700664 140.71721,165.892064 141.103747,166.076504 C142.527615,166.756844 143.543504,167.802584 144.005377,169.340164 C142.929798,169.310004 141.853059,169.279264 140.778059,169.249104 C140.01252,167.444144 139.161213,168.554264 138.553302,169.292024 C137.782547,170.229884 137.186226,170.874264 136.28624,169.468924 C136.19004,169.318704 135.793073,169.363364 135.535768,169.318704 C135.233261,169.287964 134.931334,169.259544 134.628827,169.229384 C134.623032,168.930104 134.618396,168.631404 134.61434,168.330384 C134.618396,167.795044 134.621294,167.257964 134.624771,166.723204 L134.700108,166.728424 C135.16372,166.702904 135.561846,166.601404 135.546199,166.008644 C135.383356,165.138644 136.340135,163.994884 134.914528,163.434604 C134.825283,163.413144 134.740094,163.377184 134.660701,163.327304 C134.564501,162.695104 134.194191,162.433524 133.569474,162.512404 C132.474771,162.406844 131.314003,162.133084 130.998167,163.724604 C130.947749,163.975164 130.662628,164.117844 130.360701,164.075504 C130.208868,162.369144 131.407305,160.070604 128.382817,159.614144 C128.130148,159.574704 127.931375,159.182624 127.708261,158.953524 C127.731442,158.738344 127.754623,158.525484 127.776065,158.310884 C127.835175,157.682744 127.654367,157.109704 126.924757,157.356784 C125.719367,157.765104 124.799677,157.052284 123.746119,156.862624 C122.12,156.569144 120.777264,155.320984 119.034663,155.582564 C118.733895,154.674864 117.968935,154.680084 117.217305,154.655144 C116.74558,154.639484 116.146361,154.737504 115.947588,154.218404 C115.470067,152.987064 114.502278,152.987064 113.461469,153.076384 C112.931792,153.043904 112.400957,153.010264 111.87128,152.977784 C111.177022,151.900144 110.084636,152.329924 109.141765,152.308464 C108.624838,152.298024 105.499515,151.710484 105.102547,151.364804 C105.06372,151.331164 104.995337,151.323624 104.965202,151.285924 C104.168949,150.281944 102.941536,149.061044 103.215647,148.008344 C103.825876,145.652384 102.222938,143.493624 103.058598,141.187544 C103.607399,139.674904 102.643086,138.471984 101.364677,137.265584 C102.836644,137.143784 103.97597,136.681524 104.980849,137.694784 C105.970081,138.692384 104.877116,139.469004 104.720067,140.342484 C104.684137,140.552444 104.627345,140.767044 104.532305,140.956704 C103.930768,142.175864 104.544474,142.712944 105.647871,142.983224 L105.668154,143.002944 C105.864609,143.935584 105.501253,144.818344 105.347682,145.702264 C105.066617,147.308284 106.037884,148.545424 106.345606,149.968164 C106.708962,151.636824 107.842493,152.224364 109.232749,151.247064 C109.901509,150.775524 110.401051,151.055084 111.075606,151.107284 C112.497156,151.216324 113.45973,152.521324 114.904461,152.310204',
	                                id: 'Fill-37', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M70.7407951,172.72864 C70.735,173.46756 69.6316038,173.65606 69.853558,174.50808 C69.6460916,174.54926 69.2757817,174.55274 69.2560782,174.63684 C68.9164825,176.08162 68.3137871,175.39432 67.4978302,175.01094 C65.7001752,174.16994 63.7396765,174.0638 61.7809164,174.28594 C61.3677224,174.33292 61.2483423,174.7656 61.2054582,175.15942 C60.8687601,175.05966 60.6583962,174.82882 60.530903,174.50808 C60.5488679,172.88466 60.5558221,172.9038 59.1609299,173.41942 C58.8943531,173.51802 58.3971294,173.51802 58.2557278,173.35156 C57.3719677,172.30582 56.1845418,172.0019 54.9211995,171.8337 C54.6447709,171.79774 54.3741375,171.71712 54.2628706,171.44162 C54.1075606,171.04606 54.4888814,170.89178 54.6714286,170.64818 C54.9716173,170.25088 55.411469,170.22942 55.8408895,170.25842 C56.8533019,170.32106 57.3823989,169.90694 57.2972102,168.85482 C57.2525876,168.28178 57.8048652,167.73426 57.7474933,167.39902 C57.6101482,166.6137 59.1841105,165.38178 57.2433154,165.01986 C57.2508491,164.49728 57.2554852,163.9747 57.2630189,163.45386 C57.7335849,163.43936 57.9016442,163.74328 58.0372507,164.13188 C58.1247574,164.3807 58.2986119,164.62778 58.6347305,164.54368 C58.8995687,164.4793 58.8676954,164.227 58.9227493,164.02458 C59.5115364,161.89598 60.5558221,161.1588 62.7504447,161.48418 C63.8654313,161.65064 64.7659973,161.26088 65.6103504,160.6861 C66.5584367,160.03998 66.6413073,158.72048 65.693221,158.46818 C63.6718733,157.92704 64.1383827,156.4521 64.1314286,155.11462 C64.12969,154.61872 63.9685849,153.92968 64.9815768,154.3844 C65.4283827,154.58682 66.0386119,154.07294 66.2454987,153.62518 C66.4871563,153.09912 66.006159,152.64266 65.5500809,152.5226 C64.7613612,152.31148 64.7683154,151.5453 64.3585984,151.08362 C64.0972372,150.78956 64.01031,150.36384 64.2925337,150.03962 C64.657628,149.62086 64.9294205,150.12372 65.2510512,150.19216 C68.1758625,150.8058 70.8300404,152.60148 74.1390701,151.52906 C76.0566846,150.90788 77.8456469,150.3708 79.1814286,148.81176 C79.3894744,148.5699 79.5424663,148.1668 79.9006065,148.219 C82.0111995,148.52698 83.4565094,147.18602 85.0843666,146.23018 C86.6797709,145.29406 87.057035,145.4785 87.8909569,147.15412 C88.7202426,148.82046 89.9175202,150.10574 91.7145957,150.7594 C92.6163208,151.08536 92.9188275,151.57024 92.8521833,152.6908 C92.762938,154.25912 92.1892183,155.69114 92.0298518,157.2148 C91.3842722,157.2525 91.0475741,157.57266 91.0945148,158.24198 C90.3463612,158.23328 89.59531,158.18108 88.8494744,158.22632 C88.1534771,158.26924 87.1607682,157.92704 86.9643127,158.94088 C86.7655391,159.9611 87.1804717,160.85082 88.5886927,161.4952 C87.9854178,160.37464 88.2004178,159.58874 88.8975741,159.10154 C89.6845553,158.55228 90.4147439,159.08704 91.0979919,159.52204 C91.1211725,159.6102 91.1263881,159.70126 91.1153774,159.79464 C90.9565903,159.81378 90.7989623,159.8538 90.6419137,159.8538 C90.0282075,159.85728 89.2197844,159.48666 88.8923585,160.1757 C88.5649326,160.86474 89.4365229,161.22666 89.7616307,161.733 C90.35969,162.66042 91.1084232,163.48924 91.6931536,164.42014 C91.9707412,164.86094 92.4175472,165.5465 91.3697844,165.75762 C91.4074528,164.69042 91.1692722,164.11042 89.9905391,164.86616 C89.7030997,165.0506 89.2574528,165.08424 88.9016307,165.04364 C87.6064151,164.89632 86.6583288,165.37424 85.8319407,166.37184 C85.0553908,167.3097 84.0360243,167.90246 82.7251617,167.66234 C81.505283,167.43846 81.0544205,168.38908 80.4766442,169.1396 C79.8559838,169.94116 80.9002695,170.25088 80.9883558,170.84538 C79.9921698,171.35056 79.2046092,169.93072 78.3034636,170.47998 C77.6862803,170.85756 77.0980728,170.92252 76.4721968,170.85756 C74.4166577,170.6447 72.4828167,171.03852 70.6138814,171.87256 C69.5887197,172.33076 70.3971429,172.48852 70.7407951,172.72864',
	                                id: 'Fill-39', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M97.1432008,265.340546 C97.1484164,265.125946 97.1553706,264.910766 97.1605863,264.694426 C97.5529178,264.304086 97.6549124,263.906786 96.9693464,263.845886 C96.2397372,263.781506 95.3275809,263.616786 94.7909501,263.958406 C93.5803437,264.728646 92.3477156,264.417186 91.109872,264.454306 C91.3636995,263.806446 92.5030256,263.360426 91.481341,262.410386 C91.2136051,262.161566 91.4245485,261.608246 91.7398046,261.239366 C92.2150067,260.680826 92.2532547,259.962786 91.8035512,259.461666 C91.247217,258.842226 91.070465,257.950766 90.1403437,257.560426 C89.373066,257.238526 89.0833086,256.042566 89.6935377,255.684706 C90.796934,255.038006 90.9974461,253.718506 92.0544811,253.128066 C92.9788073,252.608966 93.2847911,251.670526 92.9822844,250.768626 C92.5140364,249.368506 91.8076078,248.058286 91.9791442,246.500986 C92.0220283,246.121086 91.581597,246.097886 91.2796698,245.977826 C90.1977156,245.555586 89.5729987,244.595686 88.9563949,243.710026 C88.6237534,243.233266 88.6573652,242.394006 89.548659,242.438666 C91.0774191,242.514066 90.4144542,241.516466 90.445748,240.840186 C90.9435512,240.793786 91.4425135,240.745066 91.9397372,240.696926 C92.9701146,240.199286 94.2183895,240.049066 94.5295889,241.268226 C94.8946833,242.700246 96.0803706,242.773326 96.9496429,243.303446 C97.4207884,243.589966 97.7134434,243.797606 98.0142116,244.290026 C99.691907,247.045026 101.848861,248.987446 105.43374,248.615086 C107.1294,248.439346 108.55153,247.610526 110.076813,247.063006 C111.414912,246.583346 112.577999,246.122826 113.814104,247.147106 C114.015775,247.317046 114.257433,247.495686 114.504306,247.542666 C114.908228,247.619226 115.446597,247.771766 115.62219,247.229466 C115.794306,246.688906 115.230438,246.732986 114.92967,246.556086 C114.563416,246.343226 114.250478,246.036986 113.915519,245.773666 C113.999549,245.510926 114.08184,245.247606 114.165869,244.986026 C114.481125,245.007486 114.794063,245.030686 115.10874,245.053886 C116.045815,246.053226 116.904656,247.098386 117.264535,248.468346 C117.28192,248.537946 117.556031,248.543166 117.711341,248.577386 C117.745532,249.149846 117.65223,249.696206 118.040505,250.258226 C118.819953,251.385746 118.097298,252.205866 117.096476,252.399586 C115.834872,252.642606 115.15684,253.448806 114.423753,254.300246 C114.108497,254.342006 113.793821,254.380866 113.477985,254.422046 C112.052379,255.145306 110.375842,255.195766 109.004131,256.057066 C108.165573,256.583126 106.875573,256.928806 107.972015,258.360826 C108.193389,258.650826 108.355074,259.074806 107.832352,259.296946 C107.154319,259.583466 107.370478,260.177966 107.311947,260.686046 C107.145627,262.094866 107.564036,263.765266 105.677136,264.418926 C105.399549,264.472286 105.123699,264.522746 104.847271,264.574366 C103.553794,265.143926 103.698673,266.406006 103.451799,267.479586 C103.419346,267.728986 103.39095,267.981286 103.117419,268.099026 C102.457352,268.052626 102.160061,268.929586 101.450735,268.752686 L101.448416,268.750946 C101.478551,268.014926 101.626907,267.215106 100.555964,267.060826 L100.541476,267.046326 C100.541476,266.642066 100.359508,266.403686 99.9329852,266.394986 L99.5846968,266.044086 C99.4432951,264.921786 99.1158693,264.198526 97.8890364,265.192066 C97.7134434,265.333586 97.3952898,265.295886 97.1432008,265.340546',
	                                id: 'Fill-43', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M146.345922,188.066914 C147.962768,188.641694 148.965908,190.000054 150.185787,191.080014 C150.055396,191.849674 149.275949,191.914054 148.807121,192.309614 C148.544022,192.531754 148.213119,192.640794 148.517364,193.021854 C148.742795,193.304894 149.098617,193.383774 149.38258,193.165694 C149.803307,192.843214 150.157391,192.434894 150.558415,192.083994 C150.929884,191.762094 151.575464,191.648994 151.609655,192.148954 C151.749318,194.080354 154.33917,195.238614 153.181879,197.629954 C152.856191,198.299854 152.956447,199.135634 152.050086,199.420414 C152.73855,201.094294 151.17328,201.600634 150.434978,202.535014 C150.193321,202.843574 150.17014,203.150974 150.558415,203.317434 C150.98204,203.498394 151.656016,203.473454 151.34134,204.203674 C151.139089,204.672894 150.903226,205.234914 150.294736,205.340474 C149.66886,205.449514 149.534992,204.887494 149.248712,204.508174 C147.824844,202.612154 146.377795,200.734114 144.937701,198.849114 C144.939439,198.475014 144.753995,198.273174 144.377889,198.251714 C143.485437,197.544114 145.099385,197.327774 144.701838,196.718774 C143.830827,196.352214 143.368954,196.794174 143.036313,197.506414 C142.832903,197.503514 142.628914,197.499454 142.422606,197.495974 C142.353065,197.001814 142.206447,196.602774 141.584049,196.616694 C141.083348,196.625974 140.824305,196.853334 140.78258,197.344014 C140.004871,197.361414 139.024332,196.910754 138.797741,198.204734 L138.816865,198.189074 C134.274049,198.185014 129.732391,198.181534 125.190733,198.178054 C125.184938,197.714054 125.104965,197.313274 124.534143,197.229174 C124.040976,197.155514 123.951151,196.939174 124.158617,196.441534 C124.904453,194.662094 124.702202,192.565394 126.044358,190.959954 C126.334116,190.612534 126.17417,190.065014 125.639857,189.732094 C124.908509,189.271574 125.1351,188.729274 125.551771,188.097654 C126.24603,187.050174 127.128051,186.045614 127.621218,184.977254 C128.09758,183.952974 128.58727,183.893814 129.404965,183.906574 C130.109655,185.193594 131.349237,184.310834 132.295585,184.617074 C132.36165,184.980734 132.57607,185.180834 132.941164,185.220274 C133.98603,185.752134 135.078995,185.806074 136.203833,185.553774 C136.296555,186.151754 136.595585,186.506134 137.252175,186.428994 C137.988739,186.453934 138.72762,186.478874 139.464763,186.504394 C139.748725,187.504894 140.641178,187.318714 141.357458,187.477634 C141.451919,188.038494 141.363833,188.892254 142.21572,188.736234 C143.58917,188.483934 145.204278,189.671194 146.345922,188.066914',
	                                id: 'Fill-45', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M81.9298356,392.483738 C82.3036226,392.227958 82.7347817,392.120078 82.7116011,391.450758 C82.6310485,389.164398 83.4771402,387.114678 84.506938,385.127598 C84.5950243,384.961138 84.5237439,384.710578 84.5237439,384.498878 C85.3854825,384.556878 85.4208329,385.113098 84.995469,385.587538 C84.3232318,386.339218 84.7700377,387.275918 84.4194313,388.058338 C84.3267089,388.265978 84.3892965,388.507838 84.6576119,388.550758 C84.7885822,388.570478 85.0597951,388.471878 85.0632722,388.416198 C85.1693235,386.853678 86.480186,385.446018 85.6735013,383.772138 C85.3049299,383.005958 84.9491078,382.231078 84.5376523,381.488098 C83.8207925,380.199338 82.3465067,379.139678 84.3835013,377.501178 C85.0012642,377.005278 85.4179353,376.018698 86.3335687,375.485678 C87.8756577,374.585518 87.8588518,372.996898 86.4581644,371.778318 C85.9168976,371.307358 85.9168976,371.307358 86.8667224,370.769698 C87.1918302,370.897298 87.4925984,371.277198 87.8698625,370.870618 C88.2059811,370.508698 87.8576927,370.313818 87.6786226,370.069058 C87.3836496,369.665958 86.6505633,369.392198 87.0382588,368.761738 C87.3674232,368.222918 88.025752,368.550038 88.5368841,368.501898 C90.6335687,368.303538 92.9800243,369.277358 94.493717,366.720718 C95.4754151,365.059598 97.3785418,366.200458 98.8221132,365.845498 C99.4514663,365.961498 99.8739326,365.802578 99.8582857,365.063078 C100.058218,365.063078 100.260469,365.061338 100.460981,365.059598 C100.519512,365.261438 100.548488,365.625098 100.64121,365.641338 C102.580267,365.999778 102.623151,367.846498 103.397962,369.112638 C103.069957,369.226898 102.744849,369.341738 102.418003,369.456578 C102.129404,369.375378 101.887747,369.151498 101.546412,369.452518 C100.557181,370.322518 100.277854,371.443658 100.353191,372.679058 C100.380429,373.121018 100.509081,373.460898 99.9544852,373.720158 C98.1029353,374.588418 97.6364259,375.709558 98.2304286,377.637478 C98.2425984,377.733758 98.2408598,377.828878 98.226372,377.923418 C96.6454555,379.048038 97.2017898,381.062378 96.3574367,382.544278 C95.9587305,383.246078 95.8173288,384.170018 95.080186,384.628218 C94.1002264,385.240698 93.6725445,386.130418 93.7061563,387.170358 C93.7617898,388.823938 92.7012776,389.312878 91.4222884,389.574458 C90.7981509,389.703218 90.1276523,389.644058 89.4797547,389.622598 C88.8017224,389.599398 88.4586496,389.871418 88.494,390.566258 C87.1025849,389.171938 86.1620323,390.247838 85.1942426,391.171198 C85.4764663,390.014678 84.7862642,389.511818 83.8074636,389.098278 C83.6220189,389.538498 83.9923288,389.964798 83.7095256,390.356878 C82.9654286,391.387538 83.7025714,391.480918 84.4820189,391.526158 C84.5701051,392.211138 83.6417224,392.245358 83.6237574,392.864798 C83.4875714,393.705798 82.7382588,393.657658 82.2462507,393.589798 C81.7455499,393.517878 82.0567493,392.861318 81.9298356,392.483738',
	                                id: 'Fill-47', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M72.1968841,254.161684 C71.470752,253.982464 71.5941887,253.357804 71.5095795,252.842184 C72.3006173,252.727344 73.0719515,252.664704 71.9459542,251.732644 C70.7110081,250.708364 69.4673693,249.856344 67.738097,250.166064 C67.0954151,250.280324 66.4730162,250.140544 65.9091482,249.718304 C64.686372,248.801904 64.2065337,247.541564 64.1172884,246.077064 C64.0778814,245.400204 64.3282318,244.639824 63.6362911,244.134644 C62.5126119,243.316844 62.1376658,242.187004 62.2176388,240.853584 C64.2355094,241.170264 66.0476523,239.999824 68.0342291,240.042164 C68.519283,240.054924 68.9770997,239.771884 68.9933261,239.147224 C70.5313585,239.199424 72.3342291,238.567224 73.0678949,240.719024 C73.0754286,240.740484 73.1681509,240.731784 73.2203073,240.737004 C73.2736226,240.994524 73.2417493,241.397624 73.3930027,241.488684 C74.6737305,242.253124 74.2141752,243.148064 73.6491482,244.070264 C73.4932588,244.327784 73.1722075,244.562684 73.5367224,244.890384 C75.0370863,244.252964 77.5058194,245.436164 78.4481105,246.851944 C79.1168706,247.856504 79.2403073,249.532124 80.988124,249.571564 C80.9753747,249.779204 80.9597278,249.986844 80.9458194,250.194484 C80.009903,250.158524 79.4802264,251.010544 78.6793369,251.334764 C77.1783935,251.941444 75.361035,252.079484 74.1967898,253.445384 C73.4886226,253.567184 72.4292695,252.709944 72.1968841,254.161684',
	                                id: 'Fill-49', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M30.7265135,411.766476 C31.0238046,410.565876 29.7141011,409.695296 30.0507992,408.487156 C30.9664326,407.584676 32.1828342,406.863156 31.9730499,405.284396 C34.1844784,403.887756 33.2433464,400.541736 35.9386698,399.473376 C35.2588989,398.898596 34.3954218,399.667096 34.1827399,398.413716 C33.8929825,396.703876 35.6274704,395.187756 34.4794515,393.490676 C34.4742358,393.483716 34.772686,393.241856 34.9500175,393.148476 C36.3593976,392.411296 36.8658935,391.253036 36.5668639,389.711976 C37.9032251,389.131396 38.3824838,390.978696 39.5843976,390.779756 C39.5861361,392.914156 41.0505701,393.938436 42.6697345,394.845556 C41.9181038,396.202756 41.3820526,397.646956 40.9242358,399.124216 L40.9364057,399.122476 C40.618252,399.083036 40.0132385,399.072016 40.0532251,399.219336 C40.420058,400.568996 38.8310283,401.362436 39.130058,402.658156 C39.1422278,402.708616 39.1532385,402.776476 39.130058,402.817076 C38.2497749,404.376696 38.0353544,405.747816 39.8173625,406.952476 C39.9813652,407.066156 39.5252871,408.709296 39.7003005,409.676156 C39.737969,409.893656 39.4337237,410.019516 39.2140876,409.940636 C38.1019987,409.537536 37.4471469,409.858276 37.3086429,411.080916 C37.3005296,411.175456 37.2159205,411.275796 37.1446402,411.354676 C36.2927534,412.292536 31.7696402,412.579056 30.7265135,411.766476',
	                                id: 'Fill-51', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M147.175034,173.409154 C148.001422,172.352974 149.047446,172.422574 150.158376,172.827414 C150.013497,174.170114 150.636476,174.620774 151.936907,174.522174 C153.347446,174.413134 154.831004,174.721114 155.990034,173.573874 C155.896732,174.624834 157.131098,175.521514 156.240384,176.536514 C156.796718,177.046914 157.111395,175.716974 157.672945,176.592194 C158.43153,177.775394 159.744131,178.688314 159.32746,180.380174 C159.299063,180.467754 159.27936,180.559394 159.268349,180.652194 C158.554966,181.353994 157.761031,181.933994 158.43153,183.219274 C158.593794,183.530734 159.245168,185.071794 157.664252,185.199394 C157.637594,184.784114 157.409845,184.581694 157.002446,184.568934 L156.98622,184.552694 C156.95029,184.342154 156.987958,184.014454 156.86626,183.934994 C155.544387,183.079494 154.583551,181.699094 152.609144,181.909054 C150.256894,182.157874 147.8606,181.975174 145.484589,181.960674 C145.014023,181.957194 144.497675,182.093494 144.103605,181.685174 C143.155519,180.700334 141.842918,180.299554 140.726772,179.581514 C139.393888,178.724274 139.333619,177.680274 140.685627,176.892634 C141.37409,176.490114 141.723538,176.037134 141.492311,175.186854 C141.36192,174.703134 141.091867,174.033814 141.674858,173.702634 C142.247419,173.376674 143.059319,173.364494 143.52409,173.790214 C144.654724,174.821454 145.969643,174.384714 147.217918,174.472294 C147.583012,174.497234 148.08719,174.536674 148.127177,174.039034 C148.177015,173.396974 147.515209,173.595334 147.175034,173.409154',
	                                id: 'Fill-53', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M69.0282709,220.126356 C68.8799151,219.653656 69.2641334,218.727976 68.5414784,218.817876 C67.4734326,218.950116 68.5901577,219.992376 68.1300229,220.564836 C67.9103868,220.833376 68.114376,221.459776 68.5472736,221.409896 C69.3678666,221.314776 68.8671658,220.564836 69.0282709,220.126356 M77.3924084,218.597476 C76.692934,218.652576 76.2009259,219.095116 75.8845108,219.630456 C75.484066,220.305576 74.877314,220.303836 74.2549151,220.373436 C72.4769636,220.500456 73.4963302,221.955676 73.1277588,222.752596 C72.6380687,222.825676 72.1495377,222.899336 71.6575296,222.970676 C70.8525836,222.792036 70.635845,223.202096 70.5720984,223.932316 C70.4677857,225.110296 71.3387965,225.674056 72.0295782,226.284796 C73.5913706,227.659396 73.8057911,228.241136 72.902907,230.203276 C72.6143086,230.827936 72.6021388,231.152156 73.2245377,231.497256 C73.6875701,231.751876 74.054403,232.178176 74.5104811,232.446716 C75.9053733,233.272056 77.2011685,234.578216 79.0324353,233.293516 C79.6478801,232.863736 80.3386617,233.069056 81.0555216,233.656596 C80.2986752,234.096816 80.0123949,234.966816 79.0608315,234.977836 C78.7873005,234.979576 78.494066,235.121096 78.5531765,235.460976 C78.6354677,235.924976 78.9947668,235.821156 79.3111819,235.738216 C80.097004,235.532316 80.8428396,235.412836 81.0375566,236.515416 C80.0303598,236.533396 79.0214245,236.551376 78.0130687,236.565876 C77.2904137,236.576316 76.5996321,236.528176 76.4547534,235.600756 C76.6877183,235.251596 76.6552655,234.983056 76.1829609,234.977836 C74.5933518,234.959856 73.0025836,234.963336 71.4123949,234.972616 C71.0641065,234.974356 71.0316536,235.267836 70.9974623,235.531156 C69.815252,235.289296 69.9850499,236.877336 69.0514515,236.971876 C69.4594299,235.715016 68.2592547,235.014956 68.017597,233.984296 C68.5148208,234.002276 68.7599555,233.638616 69.031748,233.316716 C69.5075296,233.665296 69.7370175,234.371156 70.6022332,234.392616 C70.6097668,233.221596 70.9852925,231.990256 70.441128,231.055296 C70.0870445,230.446876 70.3681092,229.056036 69.3736617,229.263096 C68.4470175,229.458556 69.4182844,230.570416 69.1227318,231.229296 C69.1018693,231.275696 69.05319,231.309336 69.0172601,231.349356 C68.2482439,230.702656 68.4076105,229.750296 68.2146321,228.914516 C68.2627318,228.858836 68.309093,228.803156 68.3577722,228.748056 C69.7346995,227.888496 68.6776644,226.545796 69.0033518,225.477436 C70.1907776,224.832476 70.3733248,223.778036 69.5127453,222.405176 C68.7616941,223.241536 69.1482305,224.265236 69.0172601,225.192656 C68.8097938,225.307496 68.602907,225.421756 68.3931226,225.538336 C68.3502385,225.498896 68.3073544,225.457136 68.2667884,225.416536 C68.2250633,224.088336 68.4180418,222.869176 67.6866941,221.470796 C67.0961685,220.344436 66.8939178,218.463496 68.035562,217.084836 C68.0552655,217.475176 68.1763841,217.815056 68.6046456,217.897416 C68.6956294,217.915396 68.9030957,217.750676 68.9222197,217.643376 C69.0189987,217.124276 68.5988504,217.083096 68.2534596,216.984496 C68.8723814,215.890616 69.7509259,215.176636 71.0623679,215.328596 C71.9368558,215.428936 72.5001442,215.020616 73.0246051,214.449316 C73.3694164,214.072316 73.5270445,213.432576 74.2479609,213.604836 C74.0955485,214.394216 74.5782844,214.503256 75.1867749,214.491076 C76.2582978,214.469616 77.3292412,214.455116 78.3990256,214.437136 L78.4436482,214.481796 C78.4245243,214.784556 78.4048208,215.087316 78.3851173,215.387756 L78.375845,215.398196 C77.6850633,215.559436 77.2544838,216.293716 77.5569906,216.649836 C78.256465,217.476916 77.574376,217.972816 77.3924084,218.597476',
	                                id: 'Fill-55', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M120.229275,332.388082 C120.224059,332.203642 120.217105,332.018622 120.21131,331.834762 C122.028668,331.870142 122.77972,330.465382 123.68666,329.265942 C124.353682,328.381442 125.047941,327.364702 124.276606,326.363622 C123.726067,325.649642 122.769288,325.313242 123.493682,324.153242 C123.679706,323.852222 123.373722,323.394022 122.908951,323.372562 C121.873358,323.326162 121.745865,322.573902 121.962604,321.899362 C122.436647,320.411662 122.149787,318.633962 123.561485,317.488462 C124.048278,317.444962 124.484652,317.482662 124.539706,318.114862 C124.44003,319.339242 125.790299,319.652442 126.094544,320.597842 C126.260865,321.108242 126.194801,321.685922 126.976566,321.689982 C127.670245,321.693462 128.285111,321.634302 128.460704,320.801422 C129.7791,320.681362 129.344464,321.689982 129.453412,322.347122 C128.582402,322.928282 126.323453,322.391782 127.554342,324.700762 C127.598965,324.785442 127.29414,325.019762 127.219962,325.209422 C126.480501,327.092682 126.275353,328.540362 128.702361,329.152842 C129.737954,329.412682 129.662617,329.913802 129.401836,330.679982 C129.292887,330.998402 128.746984,331.179362 129.08658,331.664822 C129.866606,331.757622 130.752105,332.117222 131.433615,331.886962 C132.312159,331.585942 133.281108,331.777342 134.105757,331.213582 C134.447671,330.976942 135.234652,330.937502 135.40503,331.442682 C136.127685,333.611882 138.069639,334.339202 139.77573,335.361162 L139.779787,335.995102 C138.923264,336.827402 138.017482,336.039762 137.137779,336.072242 C136.719369,336.051942 136.30038,336.032802 135.884288,336.013082 C135.610178,335.880262 135.575987,335.626222 135.554544,335.366962 C135.717968,334.582222 135.352873,334.296282 134.609935,334.362402 C134.410003,334.328762 134.211809,334.296282 134.011296,334.262062 C133.657213,333.544022 133.071903,333.385102 132.344032,333.573022 C132.043844,333.535902 131.741337,333.497622 131.441148,333.460502 C130.880757,332.919362 130.308776,332.855562 129.724046,333.420482 C129.428493,333.452962 129.135259,333.485442 128.839706,333.517342 C128.17848,333.388582 127.780933,333.621162 127.739787,334.332242 L127.731094,334.342682 C127.332388,334.346162 127.101162,334.532342 127.06755,334.940662 L125.819275,335.345502 C125.600798,335.343762 125.3829,335.343762 125.162685,335.342022 C123.49542,335.817622 122.627887,334.719102 122.080245,333.510382 C121.658358,332.571942 121.067833,332.393302 120.229275,332.388082',
	                                id: 'Fill-57', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M74.7487197,263.72658 C75.2471024,262.4268 76.0022102,262.95692 76.5660782,263.5781 C77.4707008,264.57338 78.1777089,265.71946 78.4477628,267.07956 C77.750027,267.29648 77.4226011,267.78484 78.3046226,267.99248 C79.2614016,268.2181 80.3201752,268.05918 81.3291105,267.97682 C81.7440431,267.94434 81.642628,267.49658 81.6275606,267.18338 C82.2557547,267.12074 82.5414555,267.48962 82.6903908,268.03018 C80.7965364,269.09332 83.3736388,268.83754 83.0317251,269.5608 C82.2731402,270.08512 81.2468194,269.149 80.4128976,269.75742 C79.7603639,269.61242 79.2938544,270.59552 78.7914151,270.26086 C77.1867385,269.18496 76.1563612,270.2771 75.1526415,271.15232 C73.2066307,272.84766 71.2942318,270.91974 69.3719811,271.208 C69.0764286,271.25266 69.1552426,270.60132 68.974434,270.41688 C68.1665903,269.58748 67.6670485,268.39384 66.3863208,268.09456 C65.2151213,268.27378 64.3342588,267.62186 63.4278976,267.05114 C63.796469,266.41198 64.0253774,265.84126 63.9129515,264.98518 C63.6909973,263.2881 65.379124,263.38322 66.3718329,262.8473 L66.4668733,262.9459 C66.3700943,263.42556 65.7459569,263.95394 66.3758895,264.37676 C66.9658356,264.77406 67.3222372,264.219 67.6525606,263.784 C68.0530054,263.25736 68.6846765,262.97316 69.2021833,263.30608 C70.1531671,263.91972 71.3371159,263.84664 72.2446361,264.50726 C73.1046361,264.51248 73.9634771,264.53568 74.8217385,264.51596 C75.111496,264.509 75.5965499,264.61456 75.6121968,264.2045 C75.6319003,263.66568 75.0263073,263.92378 74.7487197,263.72658',
	                                id: 'Fill-59', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M101.804818,173.483916 C100.769225,172.972356 101.210815,171.858756 100.940761,171.067056 C100.45223,169.620536 99.1390499,168.385716 99.6101954,166.654416 C100.641732,166.724596 100.69215,165.936376 100.450492,165.376096 C99.5887534,163.367556 99.573686,161.263896 99.5331199,159.153276 C99.5238477,158.681156 99.4206941,158.302996 98.871314,158.231656 C98.9281065,156.389576 99.0538612,156.305476 100.62029,157.046716 C101.477392,157.450976 103.500478,156.774116 104.170977,155.855976 C104.906381,156.507316 105.772177,156.761936 106.739966,156.702776 C106.730694,157.000316 106.591611,157.221876 106.330249,157.345416 C104.789899,158.072156 104.593443,158.584296 105.34971,160.209456 C105.750735,161.070756 106.011516,161.992956 106.829212,162.658796 C107.532163,163.227776 107.367581,163.792116 106.485559,164.242776 C105.201354,164.898176 103.890492,165.215436 102.463147,165.064636 C101.078106,165.123796 101.39684,165.863296 101.785115,166.688636 C102.321745,167.823696 103.286058,168.809696 103.072796,170.218516 L103.064104,170.236496 C102.372163,170.449936 102.43591,168.734876 101.640236,169.585156 C101.122729,170.137896 101.574171,170.944096 101.912028,171.547296 C102.207001,172.073356 102.761597,171.860496 103.232163,171.803076 C103.850505,171.765376 104.301947,172.022896 104.796853,172.413236 C105.351449,172.850556 105.813322,173.532056 106.648403,173.533796 C106.812985,173.793636 107.362365,174.044196 106.646085,174.316796 C106.011516,174.556336 105.367675,174.441496 104.725573,174.395096 C104.72905,174.310996 104.725573,174.228636 104.711664,174.148596 C104.57316,173.346456 103.911934,173.598756 103.421664,173.507116 C103.046139,173.217116 103.101193,172.456736 102.366368,172.556496 C101.781637,172.633636 101.823942,173.073856 101.804818,173.483916',
	                                id: 'Fill-61', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M105.787244,357.33597 C105.943133,357.34003 106.100182,357.34177 106.256071,357.34525 C107.061018,357.95193 107.66719,356.56283 108.430991,357.10397 C109.36285,357.76575 110.108686,357.36323 110.854522,356.78671 C110.823807,358.36025 110.815694,359.94075 110.334117,361.45687 C110.146354,362.04615 110.4025,362.23581 110.89277,362.33441 C110.363093,363.86329 109.767352,362.01773 109.216233,362.36515 C109.245209,362.03861 109.273605,361.71323 109.302001,361.38727 C109.675788,361.46615 109.765034,361.23531 109.783578,360.93661 C109.822985,360.24351 109.581327,359.41295 109.013982,359.31435 C108.123268,359.15891 107.016395,358.55165 106.254333,359.69889 C104.916233,359.81895 103.944966,361.00041 102.557028,361.00041 C102.549495,361.00041 102.54254,361.38205 102.533848,361.58447 C102.478214,361.64363 102.420842,361.70047 102.362311,361.75789 C101.421179,361.56997 100.907729,360.43143 99.8060714,360.59963 C99.7863679,360.05907 100.850357,359.96395 100.394279,359.29463 C100.084818,358.84165 99.5087803,359.07655 99.0474865,359.02783 C97.5772574,358.87935 96.0710984,359.32363 94.6257884,358.77205 C94.9190229,358.32081 95.6132817,358.22975 95.6880391,357.58537 C96.7097237,356.41435 98.3769879,356.46075 99.5232682,355.58031 C101.381772,354.15003 102.728565,354.93361 104.372648,356.61503 C104.791058,357.04249 105.036193,357.63351 105.787244,357.33597',
	                                id: 'Fill-63', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M75.8194313,365.901758 C76.4580566,365.921478 77.0961024,365.942938 77.7353073,365.964398 C79.0189326,367.661478 78.2394852,369.616658 78.2997547,371.432058 C78.3443774,372.746338 76.8955903,373.057218 75.2555633,372.129798 C74.480752,371.691318 73.7835957,371.353178 72.8407251,371.591558 C71.254593,371.988858 70.0683261,373.540938 70.7556307,374.981658 C71.510159,376.570278 72.1453073,378.324198 73.6033666,379.496378 C74.3845526,380.125098 74.9889865,380.819938 74.8261429,381.916718 C74.67431,381.924258 74.5224771,381.929478 74.3700647,381.936438 C73.5564259,381.714878 73.1785822,382.021118 73.2487035,382.865598 C72.8499973,383.297118 72.4437574,383.721678 72.0520054,384.158998 C71.2656038,385.041178 71.0361159,385.796918 72.4292695,386.342118 C73.3344717,386.697078 73.5854016,387.375098 73.1287439,388.286858 C72.916062,388.712578 72.7711833,389.172518 72.5961698,389.616798 C69.5287978,389.620858 66.4573693,389.692198 63.3917358,389.597078 C62.1463585,389.557638 61.0412237,389.163818 60.3759407,387.761958 C59.5257925,385.972078 55.2512911,385.501118 53.5197008,386.770158 C52.6608598,387.400038 51.9399434,388.175498 51.082841,388.814658 C49.6091348,389.915498 48.2322075,389.983938 46.7150377,389.072178 C46.1714528,388.743318 45.5594852,388.913258 44.9799704,388.861058 C45.0396604,387.527638 43.6407116,387.627978 42.9980296,386.999258 C42.0737035,386.093298 41.8268302,384.505838 40.3119784,384.287178 C40.2667763,383.700218 41.094903,383.716458 40.9714663,383.433418 C40.0575714,381.313518 42.5135553,379.779998 41.8928949,377.617178 C41.6819515,376.885218 42.3599838,375.396938 43.0519245,375.010658 C44.5151995,374.192278 44.3059946,373.034018 44.3059946,371.831098 C44.3042561,370.937898 44.2468841,370.241318 45.513124,369.999458 C47.0389865,369.707718 47.0697008,367.746158 48.1678814,366.968958 C49.7279353,365.864638 51.0596604,364.001098 53.4443639,364.840358 C53.6500916,364.914018 54.1328275,364.798018 54.1635418,364.684338 C54.5089326,363.357878 55.6604286,363.531878 56.6050377,363.290018 C57.8144852,362.980298 58.7764798,361.870758 59.1595391,361.077898 C60.1806442,358.959738 61.9464259,359.462598 63.5632722,359.018898 C66.056345,358.335078 67.9310755,359.641818 69.8649164,360.602878 C70.5012237,360.920138 72.3724771,360.123218 71.8480162,362.092898 C73.0933935,361.557558 73.132221,363.218678 74.0380027,363.295818 C74.9090135,363.368898 75.0770728,364.044018 74.7473288,364.557898 C73.6671132,366.242218 75.0249164,365.814758 75.8194313,365.901758',
	                                id: 'Fill-65', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M57.8686119,421.115032 C57.6756334,421.127212 57.4809164,421.139972 57.2873585,421.152152 C55.7655526,420.896372 54.3434232,421.410252 52.8963747,421.729252 C52.8639218,421.523352 52.8320485,421.317452 52.7995957,421.111552 C52.7978571,420.390032 52.9931536,419.595432 52.1001213,419.201032 C52.0914286,419.094312 52.1001213,418.988172 52.1273585,418.884352 C52.851752,418.725432 53.1722237,418.335092 52.8673989,417.586312 C52.8824663,417.393172 52.8963747,417.201772 52.9068059,417.008632 C53.3663612,416.952952 53.7639084,416.831152 53.7349326,416.245352 C54.2483827,416.219252 54.7618329,416.190252 55.275283,416.163572 C56.1178976,416.270292 57.0462803,416.594512 57.3377763,415.334172 L57.3429919,415.328952 C57.9497439,415.287772 58.4359569,415.062152 58.6845687,414.464172 C59.7201617,414.405592 60.7574933,414.346432 61.7948248,414.289012 C62.3604313,414.323232 63.012965,414.545372 63.1508895,413.659132 C63.4174663,413.613892 63.6857817,413.569232 63.9523585,413.524572 C64.2595013,413.689292 64.7607817,413.532112 64.8946496,413.956092 C65.0453235,414.432272 64.5678032,414.532032 64.285,414.730972 C63.7304043,415.123052 63.1508895,415.490192 62.8234636,416.120652 C61.725283,416.147332 60.6253639,416.152552 59.5266038,416.208232 C59.1302156,416.227952 58.4307412,416.122392 58.9389757,416.931492 C58.9152156,417.103172 58.8943531,417.274852 58.870593,417.445372 C58.5292588,417.737112 58.2910782,418.081052 58.2876011,418.551432 C57.5719003,418.961492 56.9906469,419.405772 57.8726685,420.214292 C57.8709299,420.515312 57.8709299,420.814012 57.8686119,421.115032',
	                                id: 'Fill-67', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M150.81966,82.50036 C149.989216,83.1807 149.406803,83.62614 148.819755,82.08856 C148.43148,81.0666 147.454997,80.15194 146.188757,79.8834 C145.798744,79.7993 145.43365,79.6862 145.424377,79.19958 C145.369323,76.08092 145.022194,72.96052 145.623151,69.85056 C145.789472,68.98984 146.30466,68.7967 147.020361,68.89878 C149.206291,69.2085 151.327315,69.3013 153.560186,68.8199 C154.661844,68.58326 155.702652,70.08894 155.951264,71.23502 C156.24276,72.58294 157.206493,73.49064 158.071129,73.8717 C160.022356,74.73474 160.251264,76.59132 160.772248,78.068 C161.304822,79.57716 159.78997,77.79424 159.41966,78.68918 C159.291008,79.14216 159.974256,79.2135 160.247787,79.54642 C160.598394,79.97098 161.156466,80.43614 160.848744,80.93784 C160.134782,82.10828 160.660981,82.81936 161.526776,83.50144 C161.989809,83.86452 161.831022,84.38362 161.866372,84.85458 C161.931278,85.67992 160.961749,86.26166 161.669916,87.40368 C162.066884,88.04458 160.600132,88.42796 159.700146,88.31486 C159.166992,88.24874 158.816965,87.66178 158.21427,87.75806 C158.131399,87.63104 158.051426,87.50576 157.967396,87.37874 C158.117491,87.2697 158.413043,87.12296 158.394499,87.05626 C158.291345,86.65722 157.904809,86.82542 157.633016,86.7506 L157.633016,86.74886 C157.699081,85.9734 157.559418,85.10862 158.02303,84.46598 C158.72772,83.4939 158.078084,83.49564 157.414539,83.42082 L157.376871,83.40284 C157.171143,82.67436 156.688407,82.42148 155.964013,82.57576 C155.777989,82.5398 155.589647,82.50558 155.401884,82.4702 C154.90524,81.44824 153.633205,81.79682 152.956911,81.09154 C152.373919,81.74114 150.864283,81.0434 150.860806,82.53632 L150.81966,82.50036 Z',
	                                id: 'Fill-69', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M102.086057,132.621118 L99.8485499,132.519038 C99.7448167,131.111958 99.3223504,129.690378 100.456461,128.417858 C100.737526,128.102338 100.83952,127.638918 101.349493,127.699818 C102.867822,127.880778 104.470181,127.232338 105.918968,128.175998 C106.299709,128.424818 106.749412,128.385378 107.149857,128.140038 C107.332404,128.027518 107.529439,127.764198 107.677216,127.793198 C109.859668,128.210218 111.610962,126.284038 113.792836,126.693518 C114.254709,126.781678 114.849871,126.815318 115.130935,126.330438 C116.018173,124.808518 118.062121,124.339878 118.559925,122.458358 C118.73204,121.806438 119.291272,121.693918 119.865571,121.978118 C120.246892,122.164878 120.552296,122.520998 121.03735,122.438638 C122.430504,123.265718 121.681191,124.577678 121.652795,125.650098 C121.627876,126.546778 120.810181,126.793858 119.947863,126.627398 C119.633186,126.564758 119.388051,126.709758 119.375302,127.021218 C119.284318,129.287858 117.648927,129.251898 116.052364,129.278578 C115.728415,129.284378 115.406205,129.287858 115.082836,129.293078 C114.039709,129.357458 113.48917,130.005318 113.157687,130.917078 C112.968186,130.938538 112.778685,130.959998 112.587445,130.983198 C111.176326,130.698418 110.398038,131.444878 109.925733,132.651278 C109.507323,133.723698 108.915059,133.827518 108.140827,132.941278 C108.107216,132.900098 108.076501,132.855438 108.04231,132.814258 C105.85638,130.093478 104.572175,130.052298 102.086057,132.621118',
	                                id: 'Fill-71', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M74.2506846,139.662086 C73.8554555,140.896906 73.0823827,140.225846 72.6448491,139.839566 C71.8752534,139.159226 71.2673423,138.627366 70.1691617,139.304226 C69.6951186,139.595966 68.9637709,139.506066 69.222814,138.464386 C69.380442,137.828706 69.1011159,137.128646 68.6606846,136.670446 C67.3985013,135.356746 68.381938,134.438606 69.3497278,133.989106 C70.610752,133.403306 71.1601321,132.610446 70.9260081,131.357646 C70.5858329,129.542246 71.3623827,128.498246 73.0163181,127.881126 C73.3761968,128.376446 73.0632588,129.563706 74.2900916,129.243546 C74.4726388,129.268486 74.6528679,129.293426 74.8359946,129.320106 C74.6696739,130.670346 73.0064663,130.494606 72.5550243,131.557746 C72.5712507,132.098306 72.5874771,132.639446 72.603124,133.181746 C73.0221132,134.658426 73.4689191,136.131626 73.2962237,137.699946 C73.2150916,138.205126 73.2006038,138.672026 73.9035553,138.702766 C74.0206173,139.022926 74.1347817,139.341926 74.2506846,139.662086',
	                                id: 'Fill-73', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M69.0242722,420.152174 C69.6663747,420.169574 70.3067385,420.189294 70.948841,420.209594 C71.1800674,421.125994 69.9845283,421.270994 69.9578706,422.048194 C69.6501482,422.024994 69.3430054,422.004694 69.0335445,421.983234 C69.0242722,421.275634 68.5913747,421.058134 67.9921563,421.195594 C67.1269407,421.392794 67.2515364,422.205374 67.08,422.826554 C66.6969407,423.383354 66.239124,423.820094 65.5008221,423.796894 C65.2875606,423.802114 64.9815768,423.716274 64.8743666,423.825314 C63.0286119,425.708574 61.4048113,424.625714 59.8430189,423.523134 C60.4063073,422.164194 61.4760916,421.246054 62.5047305,420.260634 C63.0158625,419.772854 63.445283,419.424854 64.149973,419.506054 C64.3539623,419.521714 64.5562129,419.537954 64.7602022,419.555934 C65.1357278,420.561654 65.9974663,420.099974 66.6615903,420.152174 C67.4445148,420.214234 68.2355526,420.157394 69.0242722,420.152174',
	                                id: 'Fill-75', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M110.919137,173.630018 C111.976173,173.570858 113.033208,173.513438 114.090822,173.454278 C114.936914,173.699618 115.559313,173.266938 115.750553,172.561078 C115.997426,171.649898 116.627358,171.030458 117.072426,170.272978 C117.499528,170.272978 117.92779,170.271238 118.353154,170.271238 C118.569313,171.236358 117.249757,171.621478 117.475189,172.593558 C117.763208,173.830698 117.546469,175.282438 119.276321,175.803278 C119.930593,175.999898 120.551253,176.632098 120.211658,177.600698 C119.945081,178.355858 119.800202,178.939338 118.8469,178.128498 C117.895337,177.321138 116.525364,177.468458 115.596402,177.876198 C113.633005,178.739238 111.486482,179.157998 109.656375,180.371938 C108.486914,181.148558 108.668881,183.660538 110.255593,184.424978 C112.615377,185.561778 114.595,187.269298 116.873652,188.481498 C117.909825,189.033078 119.189973,189.320758 120.455054,188.898518 C120.930256,188.740758 121.447763,188.697838 121.748531,189.218678 C122.018005,189.687898 121.984394,190.221498 121.540485,190.534698 C120.948801,190.951718 120.951698,191.508518 120.953437,192.108238 C120.955175,192.432458 120.939528,192.895878 120.576173,192.906898 C118.376334,192.976498 119.18128,194.409098 119.331954,195.550538 C116.523046,195.574318 113.712978,195.595778 110.905229,195.620718 C108.243518,196.343978 105.475755,196.612518 102.830849,197.317798 C101.20473,197.751058 99.7327628,198.911058 98.3164286,199.920838 C97.4216577,200.558258 96.5471698,200.964258 95.499407,200.761838 C94.4452695,200.558258 93.6976954,201.325598 92.764097,201.453198 C91.9394474,200.180098 90.4976146,201.012398 89.4550674,200.482858 C88.7892049,199.446398 87.737965,200.047858 86.8704313,199.874438 C86.6003774,198.404718 87.1277358,197.394938 88.9184367,196.952398 C87.8289488,196.392118 87.1242588,196.603238 86.3338005,197.049258 C86.5928437,195.925218 86.0904043,194.465938 88.0601752,194.417798 C88.7266173,194.399818 89.1560377,193.528078 89.2719407,193.046678 C89.7836523,190.901838 91.3274798,189.589878 92.8121968,188.212958 C93.2613208,187.794198 93.7301482,187.554078 93.1378841,186.832558 C92.7136792,186.316938 92.7136792,185.692278 93.4403908,185.192898 C94.4273046,184.514298 95.227035,183.422158 96.298558,183.039358 C97.3677628,182.654238 97.2304178,182.056258 97.2460647,181.327778 C97.2593935,180.781998 97.101186,180.362658 96.4556065,180.342938 C95.6692049,180.322058 94.7831267,180.078458 94.5061186,181.215258 C94.4684501,181.368958 94.3699326,181.508158 94.3003908,181.653738 C94.0819137,181.627058 93.8640162,181.598058 93.6438005,181.569638 C93.0127089,180.307558 93.3007278,178.815798 92.3648113,177.554298 C91.5227763,176.415758 93.3024663,177.101318 93.4542992,176.331658 C92.5189623,176.166938 91.7371968,175.747598 92.0878032,174.537718 C92.6116846,174.513938 93.1378841,174.488998 93.6640836,174.464058 C94.6782345,174.050518 95.6993396,173.656698 96.7030593,173.214738 C97.0391779,173.066258 97.3411051,172.722318 97.6992453,173.067998 C98.0029111,173.361478 97.8904852,173.765738 97.8203639,174.134618 C97.7600943,174.453618 97.0930728,174.750578 97.6076819,175.060298 C98.6757278,175.704678 98.859434,176.146638 97.0299057,176.655298 C98.5969137,176.279458 99.6342453,176.666318 100.690121,176.916878 C100.947426,176.907598 101.202992,176.900638 101.459137,176.891938 C101.517668,177.197598 101.55186,177.571698 101.932601,177.593158 C102.345795,177.616938 102.374771,177.251538 102.394474,176.934858 C102.648881,176.929058 102.900391,176.923838 103.153059,176.918618 C103.145526,177.453958 103.410364,177.683058 103.94004,177.691758 C104.498113,177.699298 104.678342,177.365798 104.749623,176.898898 C105.057925,176.798558 105.365647,176.699958 105.674528,176.597878 C105.825202,177.981758 106.644057,178.556538 107.984474,178.737498 C110.400472,179.066938 112.234057,178.291478 113.645175,176.281198 C114.156887,175.549238 113.84221,175.501098 113.262695,175.412938 C112.709838,175.373498 112.156981,175.334058 111.604704,175.296938 C111.483005,174.958218 111.447075,174.544678 110.942318,174.539458 L110.857129,174.446078 C110.876253,174.174058 110.897695,173.902038 110.919137,173.630018',
	                                id: 'Fill-77', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M132.610783,244.93719 C132.19585,244.96561 131.7786,244.99287 131.364247,245.02129 C128.511295,244.74753 126.230325,245.55315 124.906713,248.32265 C124.511484,249.14567 123.402292,249.50063 123.334489,250.61945 C123.325796,250.77663 122.685433,251.02197 122.349314,251.00399 C121.82891,250.97731 121.923371,250.46169 121.928586,250.10557 C121.944813,249.02967 122.009139,247.96421 121.284745,247.02635 C121.095244,246.78101 120.830406,246.30831 121.325891,246.03977 C122.028842,245.65697 122.105918,245.33507 121.335163,244.95169 C121.121902,244.84613 121.007737,244.53467 121.277212,244.46623 C122.561996,244.14027 122.048546,243.20067 121.90019,242.51337 C121.492212,240.61213 123.103842,240.08607 124.093074,239.17663 C125.032468,238.31185 125.90174,237.56539 126.24829,236.17223 C126.586147,234.80865 127.906861,233.84875 128.4574,232.48111 C128.740204,231.77931 128.936659,231.11521 128.491592,230.49403 C127.636228,229.30329 127.054974,228.28307 129.21077,227.96059 C129.546888,227.91071 129.668586,227.53139 129.763047,227.21413 C130.507144,227.21413 131.251241,227.21587 131.995338,227.21819 C133.006592,228.80217 135.089947,229.39841 136.665648,228.54233 C137.419018,228.13459 138.079085,227.88229 138.826659,228.67863 C139.627549,229.53239 140.958694,228.87177 141.947346,229.65593 C142.591767,230.16633 143.153317,230.47779 143.046106,231.36577 C142.980042,231.91503 143.360783,232.24331 143.62736,232.64409 C143.921174,233.08257 144.209193,233.47639 143.536376,233.99723 C142.752872,234.60623 143.452346,234.79763 143.990716,234.92813 L143.990716,236.56083 C143.990716,238.54617 142.36112,240.03039 142.318236,242.00297 C142.316497,242.05517 142.310702,242.14623 142.284044,242.15725 C140.627791,242.76915 141.096619,243.87057 141.28612,245.21501 C141.479098,246.58961 139.976416,247.16961 138.826659,246.30135 C137.903492,245.60303 137.123465,245.34725 136.130756,246.28511 C135.662508,246.72939 134.646619,247.24849 134.830325,245.66219 C134.911457,244.98533 134.635608,244.34617 133.923964,244.11881 C133.233182,243.89725 132.782319,244.23539 132.610783,244.93719',
	                                id: 'Fill-79', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M126.851275,205.179698 C128.060722,205.168678 128.688337,204.658858 128.73296,203.349798 C128.775844,202.118458 129.175129,201.591818 130.684186,202.192118 C132.186868,202.787778 133.941639,202.490818 135.592677,202.447898 C136.891369,202.446158 138.191801,202.514018 139.485278,202.422958 C141.792326,202.259978 143.076531,203.674018 144.266275,205.319478 C144.484752,205.621658 144.366531,205.800878 144.207164,206.021278 C143.922623,206.411618 143.636342,206.803118 143.344846,207.189978 C142.481369,208.326778 141.778418,209.178798 143.604469,210.384038 C145.479199,211.622338 145.305345,214.459698 143.652569,215.990318 C143.38773,216.233918 142.928175,216.595838 142.709698,216.511738 C141.289887,215.951458 140.341801,217.333018 139.012394,217.356798 C138.401005,217.367238 137.61924,217.746558 136.879199,217.725098 C135.426356,217.680438 134.114914,216.867858 132.619765,216.921798 C132.320736,216.932238 131.881464,216.438078 131.715143,216.080218 C131.117084,214.805378 130.943809,213.351898 129.936612,212.238298 C129.646854,211.915818 130.587987,211.915818 130.471504,211.328858 C129.432434,211.291158 128.670951,210.970998 128.632704,209.671218 C128.620534,209.160818 128.042757,208.654478 127.495116,208.389418 C125.810466,207.574518 125.653418,206.837338 126.851275,205.179698',
	                                id: 'Fill-81', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M49.4934057,440.62716 C49.8955889,440.63238 50.1262358,440.43402 50.190562,440.03962 C50.3997668,439.70148 50.6078127,439.36508 50.8146995,439.02462 C52.5248477,439.42424 52.8059124,439.93928 52.750279,442.58176 C52.7949016,445.77408 49.5200633,448.34116 46.5361415,447.46014 C45.9601038,447.2902 45.7624892,446.9393 46.2730418,446.59014 C46.7401307,446.26998 46.713473,445.75262 46.9661415,445.43188 C48.058527,444.04104 47.8371523,442.21868 48.6490526,440.75998 C48.9312763,440.71474 49.212341,440.67182 49.4934057,440.62716',
	                                id: 'Fill-83', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M132.9826,251.818774 C133.839702,251.818774 134.696225,251.817034 135.553327,251.815294 C136.417384,251.718434 137.071656,251.937094 137.536427,252.778094 C138.074796,253.753654 138.808462,254.621914 139.366535,255.588774 C139.896212,256.510974 139.948368,257.316594 139.248894,258.390754 C138.438152,259.638334 137.840673,261.120814 137.346926,262.534854 C136.544298,264.833394 135.74109,267.149914 135.38353,269.607954 C135.196926,270.894974 135.845982,272.044534 135.565497,273.275874 C135.56202,273.820494 135.556225,274.364534 135.553327,274.908574 C135.055524,275.356334 135.642573,275.780314 135.581724,276.218794 C135.221845,276.654374 134.755336,276.482114 134.309689,276.446154 C133.844918,275.648074 133.384783,275.630094 132.9345,276.457174 C132.633732,276.458914 132.333543,276.458914 132.032775,276.458914 C131.805605,275.853974 131.562788,275.832514 131.303166,276.440934 C130.12791,276.451954 128.952654,276.460654 127.776239,276.469354 C127.13008,274.806494 126.459001,273.195254 124.337977,272.931934 C123.547519,272.835654 121.034163,270.037734 121.019675,269.298234 C121.004028,268.352834 121.71915,267.692214 122.300403,267.162674 C123.488408,266.077494 124.361158,264.672734 125.74388,263.798674 C125.997708,263.637434 126.176778,263.411814 126.117667,263.140374 C125.858044,261.953114 126.661832,261.175914 127.310888,260.479914 C128.999015,258.657554 129.704284,256.258674 131.114823,254.280294 C131.599877,253.601694 131.528597,252.746194 130.494743,252.529854 C129.630686,252.350634 129.732681,251.775854 129.729204,251.188894 C129.943624,251.181354 130.158624,251.174394 130.373044,251.165694 C130.979217,252.439954 132.120861,251.566474 132.9826,251.818774',
	                                id: 'Fill-85', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M65.7763814,110.311476 C65.9734164,110.323656 66.17219,110.336416 66.3703841,110.349176 C67.1718531,111.120576 67.2037264,110.331196 67.3862736,109.846316 C67.9229043,109.838776 68.459535,109.831816 68.9961658,109.826596 C69.3827022,111.306756 70.6309771,112.346696 71.0117183,113.895296 C71.1282008,114.361036 71.6862736,114.937556 71.5628369,115.542496 C71.3037938,116.797616 72.346341,117.694296 72.3086725,118.931436 C72.2605728,120.589076 71.860128,121.863336 70.2768935,122.601096 C70.1267992,122.671276 70.0746429,122.951996 69.9761253,123.136436 C69.6521765,123.241996 69.3270687,123.349296 69.0013814,123.457176 C68.2236725,123.664236 67.4558154,123.947276 66.6653571,124.058636 C66.0568666,124.140996 65.5045889,123.955976 66.055128,123.145136 C66.560465,122.402736 66.7905323,121.503736 67.1359232,120.709136 C67.6041712,119.631496 67.8748046,118.216876 66.6317453,117.162436 C66.0041307,116.629416 65.6975674,115.896876 65.7334973,115.005416 C65.7960849,113.442316 65.7671092,111.876316 65.7763814,110.311476',
	                                id: 'Fill-87', fill: '#22B573' }),
	                            _react2.default.createElement('path', {
	                                d: 'M90.4323612,89.98033 C89.8899353,89.98033 89.350407,89.98207 88.8079811,89.98207 C87.5289919,88.59297 85.8176846,87.97875 84.0982642,87.39933 C83.1414852,87.07685 82.6622264,86.74219 83.5210674,85.74691 C84.093628,85.08281 84.30631,83.99415 84.9808652,83.56263 C86.1271456,82.83067 87.4756765,83.39965 88.6312291,83.83117 C90.795717,84.63505 92.9364447,84.38101 95.0974555,83.99763 C95.3049218,83.96167 95.4608113,83.63281 95.6393019,83.43735 C96.0687224,83.45185 96.4998814,83.46635 96.9293019,83.48027 C96.9739245,85.05381 96.8736685,86.65055 97.1025768,88.19741 C97.3743693,90.03601 96.2564852,89.27331 95.7378194,88.93517 C93.8827925,87.72471 92.301876,88.47117 90.716903,89.43107 C90.5662291,89.52213 90.523345,89.79241 90.4323612,89.98033',
	                                id: 'Fill-89', fill: '#22B573' })
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'nazareth',
	                                fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal',
	                                letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '176', y: '25' },
	                                maps.nazareth
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'jeruzalem',
	                                fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal',
	                                letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '76', y: '330' },
	                                maps.jeruzalem
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'area-a',
	                                fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal',
	                                letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '33', y: '33' },
	                                maps.areaa
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'area-b',
	                                fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal',
	                                letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '33', y: '48' },
	                                maps.areab
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'area-c',
	                                fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal',
	                                letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '33', y: '63' },
	                                maps.areac
	                            )
	                        ),
	                        _react2.default.createElement('path', {
	                            d: 'M168.62263,8 L168.62263,10.1500438 L168.62263,15.3509836 L167.651524,29.4982423 L166.958505,34.4913494 L167.790567,35.1851008 L167.790567,39.9001219 L168.62263,43.2291039 L170.286755,45.5869804 L175.279862,49.8863361 L176.944719,53.0770069 L176.944719,56.6826113 L177.637739,69.165745 L174.864197,73.0494354 L172.297756,77.0714369 L171.674258,81.7871899 L170.980506,84.0060233 L171.812569,88.4444221 L172.297756,91.2186957 L172.297756,93.160175 L171.535215,94.1312805 L170.564109,97.0438654 L169.732047,99.818139 L166.958505,102.036972 L162.79746,103.008078 L159.468478,105.920663 L154.475371,108.001185 L150.45337,108.001185 L148.650202,109.110602 L147.263431,112.716938 L146.431368,115.594396 L144.905554,118.680419 L143.240697,121.870358 L142.270324,123.95088 L142.270324,127.834571 L141.715615,131.708016 L139.080385,136.017617 L137.415528,138.930201 L138.663987,142.398226 L139.080385,144.894414 L138.663987,146.420228 L136.722508,148.50075 L134.502943,148.50075 L134.502943,151.135981 L132.42242,152.245398 L130.758295,154.048566 L130.758295,156.406442 L132.145066,159.180716 L132.284109,161.676904 L131.451315,165.005886 L129.926233,166.531699 L130.896607,168.473179 L133.254483,170.692012 C133.254483,170.692012 132.977129,172.49518 132.977129,172.911577 C132.977129,173.327243 131.313004,175.824162 131.313004,175.824162 L129.926233,175.824162 L128.816084,173.327243 L127.429313,171.802161 L126.597251,171.524807 L126.597251,173.327243 L125.903499,175.824162 C125.903499,175.824162 125.487834,179.430499 125.903499,179.56881 C126.319897,179.707853 127.568356,183.175146 127.568356,183.175146 L127.845711,186.642439 L128.677773,189.555024 L129.509836,191.358192 L131.451315,194.132466 L132.145066,198.154467 L133.948234,199.818592 L136.860819,200.928009 L139.080385,200.928009 L142.547678,200.928009 L145.460263,202.038158 L148.095493,202.038158 C148.095493,202.038158 149.482264,203.424928 149.898661,203.424928 C150.314327,203.424928 152.949557,206.199202 152.949557,206.199202 L155.862142,208.972744 L157.66531,211.469663 L157.804353,213.82754 L156.833248,218.265207 L156.694936,224.229419 L155.862142,227.419358 L156.694936,231.164738 L156.417582,234.077322 L154.33706,236.018802 L153.226911,237.267261 L153.226911,239.208741 L155.446477,239.625138 L157.387956,240.040803 L158.91377,241.428306 L158.220019,244.756556 L155.862142,246.559724 L153.504266,247.53083 L153.365954,249.749663 L153.365954,251.691874 L156.139496,252.384894 L159.052813,251.969229 L161.271646,251.41452 L163.906877,252.384894 L165.432691,253.910708 L167.096816,257.517044 L166.542108,259.320212 L164.323274,260.568672 L161.688044,262.232797 L161.549001,264.45163 L161.965398,267.364215 L160.716938,268.751718 L159.052813,270.693197 L158.497373,272.77372 L156.417582,274.022179 L155.169123,275.40895 L154.752725,278.460578 L153.782352,282.205225 L153.920663,284.701413 L155.169123,288.446792 L156.417582,292.468794 L156.139496,294.964981 L156.417582,297.184547 L155.862142,298.987715 L153.920663,301.206548 L153.226911,303.841779 L153.504266,305.367593 L153.226911,308.696575 L153.504266,311.60916 L155.584788,314.105347 L158.220019,315.908515 L160.994292,318.405435 L162.103709,319.931249 L162.520106,321.733685 L161.410689,324.091562 L160.151984,325.617375 L158.220019,327.420544 L157.110602,328.114295 L157.110602,330.055774 L157.804353,331.304234 L158.497373,332.413651 L159.191124,333.939465 L156.555893,334.771527 L154.198017,334.771527 L151.678412,333.66211 L149.013909,333.107402 L147.679096,332.136297 L146.847033,331.719899 C146.847033,331.719899 145.737617,332.691005 145.737617,333.107402 L145.737617,335.742633 L146.847033,337.961466 C146.847033,337.961466 147.401742,339.48728 147.401742,339.903677 L147.401742,342.399865 L148.372847,343.925679 L148.372847,346.353077 L149.013909,348.364078 L149.482264,351.970414 L150.036972,353.357185 L149.621307,354.743956 L150.176015,356.824478 L149.621307,358.350292 L149.013909,360.985522 L147.401742,363.759064 L147.818139,366.533338 L147.95645,369.029526 L146.569679,372.635862 L145.182908,375.132781 L143.518051,377.490658 L141.438261,378.461031 L139.218696,379.57118 L137.692882,380.264199 L136.583465,383.038473 L135.61236,384.286933 L133.67088,384.286933 L132.977129,385.257307 L132.977129,387.060475 L133.948234,388.03158 L133.531837,389.140997 C133.531837,389.140997 132.284109,390.250414 132.145066,390.666811 C132.006755,391.082476 131.313004,391.637916 131.313004,391.637916 L130.064544,392.747333 L129.926233,394.411458 L130.619252,395.659918 L129.371524,397.463086 L128.261376,398.43346 L127.568356,399.68192 L127.568356,401.485088 L127.568356,403.982007 L127.151959,404.952381 L124.239374,406.079361 L123.684666,407.310257 L123.684666,409.807177 L123.684666,412.165053 L126.042542,414.800284 L126.736294,416.603452 L126.042542,417.85118 L125.21048,419.09964 L126.319897,420.348099 L127.429313,421.319205 L127.984022,422.705976 L127.984022,425.756872 L127.568356,429.224897 L127.706668,430.889022 L127.706668,432.830501 C127.706668,432.830501 127.429313,434.495358 127.013648,434.633669 C126.597251,434.772712 126.042542,435.327421 125.487834,435.327421 C124.933126,435.327421 123.407312,435.604775 122.990915,435.743086 C122.575249,435.882129 119.662664,436.57588 119.662664,436.57588 L115.778974,436.991546 L114.807869,437.962651 L112.589035,438.794714 L110.785867,439.765819 L109.260053,440.597882 L107.873282,442.678404 L106.347468,444.342529 L104.683343,446.007386 L104.5443,448.087177 L104.266946,450.445053 L104.266946,452.80293 C104.266946,452.80293 106.208425,455.299849 106.208425,455.716246 C106.208425,456.131912 106.347468,459.183539 106.347468,459.183539 L105.931071,460.847665 L104.127903,462.789144 L102.463778,463.760249 L100.799653,464.592312 L100.105901,466.811877 L95.8065457,468.198648 L91.3681469,473.330798 L84.9882689,474.717569 L83.7398092,477.491111 L81.6592869,480.542739 L77.7755965,484.287386 L73.614552,488.31012 L71.5340297,489.69689 L67.7893823,490.667996 L65.1541517,494.2736 L62.657964,496.076768 L61.4095043,497.463539 L59.0516278,498.989353 L57.5258139,499.960459 L56,501.069876',
	                            id: 'Page-1', stroke: '#FFFFFF', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round',
	                            strokeDasharray: '1,6' }),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'be\xEBr-sjeva',
	                                fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal',
	                                letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '21', y: '513' },
	                                maps.beersjeva
	                            )
	                        ),
	                        _react2.default.createElement('rect', { id: 'Rectangle-5', fill: '#2D5C39', x: '15', y: '55', width: '12', height: '9' }),
	                        _react2.default.createElement('rect', { id: 'Rectangle-5-Copy', fill: '#22B573', x: '15', y: '40', width: '12', height: '9' }),
	                        _react2.default.createElement('rect', { id: 'Rectangle-5-Copy-2', fill: '#00FF40', x: '15', y: '25', width: '12', height: '9' }),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'Westelijke-Jordaanoe',
	                                fontFamily: 'Stanley', fontSize: '18', fontWeight: '800',
	                                letterSpacing: '-0.5625', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '192', y: '225' },
	                                maps.westelijke
	                            ),
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '192', y: '245' },
	                                maps.jordaanoever
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'Jenin',
	                                fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal',
	                                letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '174.555989', y: '112' },
	                                maps.jenin
	                            )
	                        ),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy', fill: '#FFFFFF', cx: '169.5', cy: '100.5', r: '3.5' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy', fill: '#FFFFFF', cx: '162.5', cy: '322.5', r: '3.5' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy', fill: '#FFFFFF', cx: '146.5', cy: '332.5', r: '3.5' }),
	                        _react2.default.createElement('circle', { id: 'Oval-Copy', fill: '#FFFFFF', cx: '112.5', cy: '411.5', r: '3.5' }),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'hebron',
	                                fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal',
	                                letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '86.0771482', y: '403' },
	                                maps.hebron
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'text',
	                            { id: 'ramallah',
	                                fontFamily: 'Roboto-Regular, Roboto', fontSize: '10', fontWeight: 'normal',
	                                letterSpacing: '0.833333373', fill: '#FFFFFF' },
	                            _react2.default.createElement(
	                                'tspan',
	                                { x: '185.700521', y: '324' },
	                                maps.ramallah
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WestbankMap;
	}(_react.Component);
	
	function mapStateToProps(_ref) {
	    var maps = _ref.maps;
	
	    return {
	        maps: maps
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(WestbankMap);

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(20);
	
	var _reactRouter = __webpack_require__(81);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Maps = __webpack_require__(236);
	
	var _Maps2 = _interopRequireDefault(_Maps);
	
	__webpack_require__(626);
	
	var _timeline = __webpack_require__(19);
	
	var _Icons = __webpack_require__(53);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navigation = function (_Component) {
	    _inherits(Navigation, _Component);
	
	    function Navigation() {
	        _classCallCheck(this, Navigation);
	
	        return _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).apply(this, arguments));
	    }
	
	    _createClass(Navigation, [{
	        key: 'render',
	        value: function render() {
	            var classNameNavigation = (0, _classnames2.default)({
	                "Navigation": true,
	                "Navigation--open": this.props.isMenuOpen,
	                "Navigation--storyOpen": this.props.isStoryOpen
	            });
	
	            var classNameBurger = (0, _classnames2.default)({
	                "Navigation__burger": true,
	                "Navigation__burger--x": this.props.isMenuOpen || this.props.isStoryOpen,
	                "Navigation__burger--storyOpen": this.props.isStoryOpen
	            });
	
	            var classNameToolbar = (0, _classnames2.default)({
	                "Navigation__toolbar": true,
	                "Navigation__toolbar--storyOpen": this.props.isStoryOpen
	            });
	
	            var classNameOverlay = (0, _classnames2.default)({
	                "Navigation__overlay": true,
	                "Navigation__overlay--storyStarted": this.props.tripStarted
	            });
	
	            var colorIcons = this.props.isStoryOpen;
	
	            var audioToggleIcon = this.buildAudioToggle();
	            var fullScreenIcon = this.buildFullScreenToggle();
	
	            var logo = this.props.tripStarted || this.props.isMenuOpen ? _react2.default.createElement(
	                'div',
	                { className: 'Navigation__logo', onClick: this.showMenu.bind(this) },
	                _react2.default.createElement(_Icons2.default, { type: 'logo', flipColor: colorIcons })
	            ) : null;
	
	            var maps = this.props.isMenuOpen ? _react2.default.createElement(_Maps2.default, null) : null;
	
	            var linkAbout = this.props.language ? '/' + this.props.language + '/pagina/about' : "/pagina/about";
	
	            return _react2.default.createElement(
	                'div',
	                { className: classNameNavigation },
	                _react2.default.createElement(
	                    'div',
	                    { className: classNameToolbar },
	                    fullScreenIcon,
	                    audioToggleIcon,
	                    logo,
	                    _react2.default.createElement(
	                        'div',
	                        { className: classNameBurger, onClick: this.showMenu.bind(this) },
	                        _react2.default.createElement('span', null),
	                        _react2.default.createElement('span', null),
	                        _react2.default.createElement('span', null)
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'Navigation__background' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: classNameOverlay },
	                    maps,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Navigation__footer' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'Navigation__footer__about' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { className: 'Navigation__footer__about__link', to: linkAbout },
	                                'About'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'Navigation__footer__language' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/nl', className: (0, _classnames2.default)({ "active": this.props.language === "nl" }) },
	                                'NL'
	                            ),
	                            '/',
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/', className: (0, _classnames2.default)({ "active": this.props.language !== "nl" }) },
	                                'ENG'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'buildAudioToggle',
	        value: function buildAudioToggle() {
	            var _this2 = this;
	
	            var classNameAudioToggle = (0, _classnames2.default)({
	                "Navigation__audioToggle": true,
	                "Navigation__audioToggle--active": this.props.audioMuted
	            });
	
	            return this.props.isStoryOpen ? null : _react2.default.createElement(
	                'div',
	                { className: classNameAudioToggle, onClick: function onClick() {
	                        return _this2.props.muteAudio(!_this2.props.audioMuted);
	                    } },
	                _react2.default.createElement(_Icons2.default, { type: 'audio', flipColor: this.props.audioMuted })
	            );
	        }
	    }, {
	        key: 'buildFullScreenToggle',
	        value: function buildFullScreenToggle() {
	            var _this3 = this;
	
	            return this.props.tripStarted && !this.props.isStoryOpen && window.chrome ? _react2.default.createElement(
	                'div',
	                { className: 'Navigation__fullScreenToggle', onClick: function onClick() {
	                        return _this3.toggleFullScreen();
	                    } },
	                _react2.default.createElement(_Icons2.default, { type: 'fullscreen', flipColor: this.props.audioMuted })
	            ) : null;
	        }
	    }, {
	        key: 'toggleFullScreen',
	        value: function toggleFullScreen() {
	            if (window.chrome && !document.webkitIsFullScreen) {
	                document.body.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
	            } else {
	                document.webkitCancelFullScreen();
	            }
	        }
	    }, {
	        key: 'showMenu',
	        value: function showMenu() {
	            if (this.props.isStoryOpen) {
	
	                // Close detail
	                this.context.router.push('/' + this.props.language);
	                this.props.startDriving();
	            } else {
	
	                // Open or close menu
	                if (this.props.isMenuOpen) {
	                    this.props.openMenu(false);
	                    if (this.props.tripStarted) this.props.startDriving();
	                } else {
	                    this.props.openMenu(true);
	                    this.props.pauseDriving();
	                }
	            }
	        }
	    }]);
	
	    return Navigation;
	}(_react.Component);
	
	Navigation.contextTypes = {
	    router: _propTypes2.default.object.isRequired
	};
	
	
	function mapStateToProps(_ref) {
	    var timeline = _ref.timeline;
	
	    return {
	        isMenuOpen: timeline.isMenuOpen,
	        isStoryOpen: timeline.storyIsOpen,
	        tripStarted: timeline.tripStarted,
	        audioMuted: timeline.audioMuted,
	        language: timeline.language
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { openMenu: _timeline.openMenu, closeStory: _timeline.closeStory, muteAudio: _timeline.muteAudio, startDriving: _timeline.startDriving, pauseDriving: _timeline.pauseDriving })(Navigation);

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(20);
	
	var _timeline = __webpack_require__(19);
	
	var _Annotation = __webpack_require__(226);
	
	var _Annotation2 = _interopRequireDefault(_Annotation);
	
	var _DetailPage = __webpack_require__(234);
	
	var _DetailPage2 = _interopRequireDefault(_DetailPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Popup = function (_Component) {
	    _inherits(Popup, _Component);
	
	    function Popup() {
	        _classCallCheck(this, Popup);
	
	        return _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).apply(this, arguments));
	    }
	
	    _createClass(Popup, [{
	        key: 'render',
	        value: function render() {
	            switch (this.props.story.type) {
	                case "story":
	                    return _react2.default.createElement(_DetailPage2.default, { preview: true });
	                case "annotation":
	                    return _react2.default.createElement(_Annotation2.default, this.props.story);
	                default:
	                    return null;
	            }
	        }
	    }]);
	
	    return Popup;
	}(_react.Component);
	
	function mapStateToProps(_ref) {
	    var timeline = _ref.timeline;
	
	    return {
	        story: timeline.showStory
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { startDriving: _timeline.startDriving })(Popup);

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(20);
	
	var _timeline = __webpack_require__(19);
	
	__webpack_require__(628);
	
	var _Icons = __webpack_require__(53);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Splash = function (_Component) {
	    _inherits(Splash, _Component);
	
	    function Splash() {
	        _classCallCheck(this, Splash);
	
	        return _possibleConstructorReturn(this, (Splash.__proto__ || Object.getPrototypeOf(Splash)).apply(this, arguments));
	    }
	
	    _createClass(Splash, [{
	        key: 'render',
	        value: function render() {
	            if (this.props.tripStarted) return null;
	
	            var video = this.props.video;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Splash' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'Splash__logo' },
	                    _react2.default.createElement(_Icons2.default, { type: 'logo-big' })
	                ),
	                _react2.default.createElement('div', { className: 'Splash__spacer Splash__spacer--logo' }),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'Splash__excerpt' },
	                    video.introText
	                ),
	                _react2.default.createElement('div', { className: 'Splash__spacer Splash__spacer--button' }),
	                _react2.default.createElement(
	                    'div',
	                    { onClick: this.startTrip.bind(this), className: 'Splash__button' },
	                    video.startRoute
	                )
	            );
	        }
	    }, {
	        key: 'startTrip',
	        value: function startTrip() {
	            this.goFullScreen();
	            this.props.startTrip();
	        }
	    }, {
	        key: 'goFullScreen',
	        value: function goFullScreen() {
	            if (window.chrome && /Android/.test(navigator.userAgent) && !document.webkitFullScreen) {
	                document.body.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
	            }
	        }
	    }]);
	
	    return Splash;
	}(_react.Component);
	
	function mapStateToProps(_ref) {
	    var timeline = _ref.timeline,
	        video = _ref.video;
	
	    return {
	        video: video,
	        tripStarted: timeline.tripStarted
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { startTrip: _timeline.startTrip })(Splash);

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(20);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(629);
	
	var _timeline = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Timeline = function (_Component) {
	    _inherits(Timeline, _Component);
	
	    function Timeline(props) {
	        _classCallCheck(this, Timeline);
	
	        var _this = _possibleConstructorReturn(this, (Timeline.__proto__ || Object.getPrototypeOf(Timeline)).call(this, props));
	
	        _this.state = {
	            controllerHeight: 0
	        };
	        return _this;
	    }
	
	    _createClass(Timeline, [{
	        key: 'render',
	        value: function render() {
	            if (!this.props.timeline.currentTime || !this.props.timeline.tripStarted) return null;
	
	            var stories = this.buildStoryDots();
	            var currentPositionPercentage = this.currentPositionPercentage();
	
	            var youAreHere = this.state.controllerHeight ? null : _react2.default.createElement('div', { className: 'Map__timeline__youAreHere', style: { height: currentPositionPercentage + '%' } });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Map' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'Map__timeline', onMouseLeave: this.onControllerMouseOut.bind(this) },
	                    _react2.default.createElement('div', { className: 'Map__timeline__line' }),
	                    youAreHere,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Map__timeline__controller', onClick: this.onControllerClick.bind(this), onMouseOver: this.onControllerHover, onMouseMove: this.onControllerMouseMove.bind(this) },
	                        _react2.default.createElement('div', { className: 'Map__timeline__controller__line', style: { height: this.state.controllerHeight + '%' } })
	                    ),
	                    stories
	                )
	            );
	        }
	    }, {
	        key: 'buildStoryDots',
	        value: function buildStoryDots() {
	            var _this2 = this;
	
	            return this.props.timeline.data.filter(function (item) {
	                return item.type === "story";
	            }).map(function (story, index) {
	                // Calculate percentage from top
	                var percentage = story.time / _this2.props.timeline.videoDuration * 100;
	
	                // Set classes
	                var activeStory = _this2.props.timeline.showStory;
	                var className = (0, _classnames2.default)({
	                    "Map__dot": true,
	                    "Map__dot--visited": _this2.props.timeline.currentTimePerSecond >= story.time,
	                    "Map__dot--active": activeStory && story.time === activeStory.time // Active class
	                });
	
	                return _react2.default.createElement('div', { key: index, className: className, style: { top: percentage + '%' }, onClick: _this2.goToStory.bind(_this2, story) });
	            });
	        }
	    }, {
	        key: 'currentPositionPercentage',
	        value: function currentPositionPercentage() {
	            return this.props.timeline.currentTimePerSecond / this.props.timeline.videoDuration * 100;
	        }
	    }, {
	        key: 'onControllerMouseMove',
	        value: function onControllerMouseMove(e) {
	            this.setState({ controllerHeight: this.calculateControllerPercentage(e) });
	        }
	    }, {
	        key: 'onControllerClick',
	        value: function onControllerClick(e) {
	            var time = this.calculateControllerVideoTime(e);
	
	            if (time) {
	                this.props.setSeekVideo(time);
	
	                if (this.props.timeline.showStory) {
	                    this.context.router.push("/");
	                    this.props.startDriving();
	                }
	            }
	        }
	    }, {
	        key: 'calculateControllerVideoTime',
	        value: function calculateControllerVideoTime(e) {
	            var percentage = this.calculateControllerPercentage(e);
	
	            return percentage ? this.props.timeline.videoDuration / 100 * percentage : 0;
	        }
	    }, {
	        key: 'calculateControllerPercentage',
	        value: function calculateControllerPercentage(e) {
	            var clientY = e.clientY;
	
	            var _e$target$getBounding = e.target.getBoundingClientRect(),
	                top = _e$target$getBounding.top,
	                height = _e$target$getBounding.height;
	
	            var Y = height - (clientY - top);
	
	            return Y / height * 100;
	        }
	    }, {
	        key: 'onControllerMouseOut',
	        value: function onControllerMouseOut() {
	            this.setState({ controllerHeight: 0 });
	        }
	    }, {
	        key: 'goToStory',
	        value: function goToStory(story) {
	            if (this.props.timeline.storyIsOpen) {
	                this.context.router.push(story.link.url);
	            } else {
	                this.props.goToStory(story);
	            }
	        }
	    }]);
	
	    return Timeline;
	}(_react.Component);
	
	Timeline.contextTypes = {
	    router: _propTypes2.default.object.isRequired
	};
	
	
	function mapStateToProps(_ref) {
	    var timeline = _ref.timeline;
	
	    return { timeline: timeline };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { goToStory: _timeline.goToStory, setSeekVideo: _timeline.setSeekVideo, startDriving: _timeline.startDriving })(Timeline);

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(20);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dashjs = __webpack_require__(301);
	
	var _timeline = __webpack_require__(19);
	
	var _Icons = __webpack_require__(53);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	__webpack_require__(630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Video = function (_Component) {
	    _inherits(Video, _Component);
	
	    function Video(props) {
	        _classCallCheck(this, Video);
	
	        var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));
	
	        _this.state = {
	            loading: true
	        };
	        return _this;
	    }
	
	    _createClass(Video, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.isDriving !== nextProps.isDriving) {
	                nextProps.isDriving ? this.play() : this.pause();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.props.seekVideo) {
	                this.seek(this.props.seekVideo);
	                this.props.isDriving ? this.play() : this.pause();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.isDriving ? this.play() : this.pause();
	
	            this.setCurrentTime(this.props.currentTime);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var className = (0, _classnames2.default)({
	                "Video__container": true,
	                "Video__container--playing": this.props.isDriving
	            });
	
	            var playButton = !this.props.tripStarted || this.props.isDriving || this.props.isMenuOpen || this.props.story.type === "story" ? null : _react2.default.createElement(
	                'div',
	                { className: 'Video__playButton', onClick: this.props.startDriving },
	                _react2.default.createElement(_Icons2.default, { type: 'play' })
	            );
	
	            var loader = this.props.tripStarted && this.state.loading && this.props.isDriving ? _react2.default.createElement('div', { className: 'signal' }) : null;
	
	            var videos = this.props.video.videos;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Video' },
	                playButton,
	                loader,
	                _react2.default.createElement(
	                    'div',
	                    { className: className },
	                    _react2.default.createElement(
	                        'video',
	                        { preload: 'auto', name: this.props.videoName, ref: 'video',
	                            onTimeUpdate: function onTimeUpdate() {
	                                _this2.onTimeUpdate();
	                            },
	                            onCanPlay: function onCanPlay() {
	                                _this2.onCanPlay();
	                            },
	                            onEnded: function onEnded() {
	                                _this2.onEnded();
	                            },
	                            onClick: function onClick() {
	                                return _this2.onClickVideo();
	                            },
	                            onWaiting: function onWaiting() {
	                                return _this2.onWaiting();
	                            },
	                            onPlaying: function onPlaying() {
	                                return _this2.onPlaying();
	                            },
	                            onSeeking: function onSeeking() {
	                                return _this2.onSeeking();
	                            },
	                            onSeeked: function onSeeked() {
	                                return _this2.onSeeked();
	                            },
	                            playsInline: true,
	                            muted: this.props.audioMuted,
	                            key: videos.id
	                        },
	                        _react2.default.createElement('source', { src: videos.dash.src, type: videos.dash.type }),
	                        _react2.default.createElement('source', { src: videos.mobile.src, type: videos.mobile.type }),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Download deze video:',
	                            _react2.default.createElement(
	                                'a',
	                                { href: videos.mobile.src },
	                                'HD'
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { href: videos.desktop.src },
	                                'SD'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'onWaiting',
	        value: function onWaiting() {
	            this.setState({ loading: true });
	        }
	    }, {
	        key: 'onPlaying',
	        value: function onPlaying() {
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'onSeeking',
	        value: function onSeeking() {
	            this.setState({ loading: true });
	        }
	    }, {
	        key: 'onSeeked',
	        value: function onSeeked() {
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'onClickVideo',
	        value: function onClickVideo() {
	            if (!this.props.tripStarted) return false;
	
	            if (this.props.isDriving) {
	                this.props.pauseDriving();
	            } else {
	                this.props.startDriving();
	            }
	
	            if (this.props.isStoryOpen) this.context.router.push("/");
	        }
	
	        /**
	         * Set video to certain time
	         * @param time
	         */
	
	    }, {
	        key: 'setCurrentTime',
	        value: function setCurrentTime(time) {
	            if (time) this.refs.video.currentTime = time;
	        }
	
	        /**
	         * Update the current time
	         */
	
	    }, {
	        key: 'onTimeUpdate',
	        value: function onTimeUpdate() {
	            this.props.updateCurrentTime(this.refs.video.currentTime);
	        }
	
	        /**
	         * Set the video duration time
	         */
	
	    }, {
	        key: 'onCanPlay',
	        value: function onCanPlay() {
	            this.props.setVideoDuration(this.refs.video.duration);
	        }
	
	        /**
	         * Restart
	         */
	
	    }, {
	        key: 'onEnded',
	        value: function onEnded() {
	            this.props.startOver();
	        }
	
	        /**
	         * Pause video
	         */
	
	    }, {
	        key: 'pause',
	        value: function pause() {
	            this.refs.video.pause();
	        }
	
	        /**
	         * Play video
	         */
	
	    }, {
	        key: 'play',
	        value: function play() {
	            this.refs.video.play();
	        }
	
	        /**
	         * Seek moment in video
	         */
	
	    }, {
	        key: 'seek',
	        value: function seek(time) {
	            this.setCurrentTime(time);
	            this.props.setSeekVideo(false);
	        }
	
	        /**
	         * Start driving for the first time
	         */
	
	    }, {
	        key: 'start',
	        value: function start() {
	            this.props.startDriving();
	        }
	    }]);
	
	    return Video;
	}(_react.Component);
	
	Video.contextTypes = {
	    router: _propTypes2.default.object.isRequired
	};
	
	
	function mapStateToProps(_ref) {
	    var video = _ref.video,
	        timeline = _ref.timeline,
	        responsive = _ref.responsive;
	
	    return {
	        video: video,
	        responsive: responsive,
	        isDriving: timeline.isDriving,
	        story: timeline.showStory,
	        isStoryOpen: timeline.storyIsOpen,
	        currentTime: timeline.currentTime,
	        seekVideo: timeline.seekVideo,
	        tripStarted: timeline.tripStarted,
	        isMenuOpen: timeline.isMenuOpen,
	        audioMuted: timeline.audioMuted
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { updateCurrentTime: _timeline.updateCurrentTime, setVideoDuration: _timeline.setVideoDuration, setSeekVideo: _timeline.setSeekVideo, startDriving: _timeline.startDriving, pauseDriving: _timeline.pauseDriving, startOver: _timeline.startOver, closeStory: _timeline.closeStory, openMenu: _timeline.openMenu })(Video);

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "about/";
	
	exports.default = [{
	    type: "Paragraph",
	    title: "About",
	    text: "The Holy Road is an interactive web documentary about one of the holiest and most controversial roads in the world: Route 60, the road that stretches through the occupied West Bank. Join journalist Derk Walters, photographer Dirk-Jan Visser and producer Edmée van Rijn on their journey from south to north; past watchtowers and checkpoints, settlements and refugee camps, and dive into the stories of various individuals who live in this controversial area. What does the occupation look like? What can you actually feel of the continuous conflict and the related restrictions? But most of all: how do people live here?"
	}, {
	    type: "Paragraph",
	    text: "The Holy Road is a production by Prospektor. "
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "DerkWalters-EdmeeVanRijn-DirkJanVisser__mobile.jpg",
	        tablet: imageFolder + "DerkWalters-EdmeeVanRijn-DirkJanVisser.jpg",
	        desktop: imageFolder + "DerkWalters-EdmeeVanRijn-DirkJanVisser.jpg",
	        text: "Derk Walters, Edmée van Rijn and Dirk-Jan Visser"
	    }
	}, {
	    type: "Quote",
	    quote: "Derk Walters: 'For a long time, it has been a frustration to me that the occupation was so difficult to describe in individual news articles, partly because of the impenetrable and bureaucratic situation that Israel has created. With this interactive documentary, we would like to offer people the experience to feel and see what the occupation implies to Palestinians as well as to Jewish settlers.'"
	}, {
	    type: "Paragraph",
	    title: "Research",
	    text: "Derk Walters, Dirk-Jan Visser."
	}, {
	    type: "Paragraph",
	    title: "Camera & photography",
	    text: "Dirk-Jan Visser, Edmée van Rijn "
	}, {
	    type: "Paragraph",
	    title: "Texts",
	    text: "Derk Walters"
	}, {
	    type: "Paragraph",
	    title: "translation",
	    text: "Dvora Friedman, Hussam Taha, Riam Némmire, Edmée van Rijn, Magd Sora, Alice Coster, Anne Mai Baan, Rosanna Stek, Diana Ader, Cecily Layzell."
	}, {
	    type: "Paragraph",
	    title: "Online concept",
	    text: "Dirk-Jan Visser, Eefje Blankevoort, Martijn van Tol, Hamid Sallali"
	}, {
	    type: "Paragraph",
	    title: "Online director and final editing",
	    text: "Eefje Blankevoort (Prospektor)"
	}, {
	    type: "Paragraph",
	    title: "video editing",
	    text: "Eefje Blankevoort (Prospektor)"
	}, {
	    type: "Paragraph",
	    title: "Design",
	    text: "Hamid Sallali"
	}, {
	    type: "Paragraph",
	    title: "Development",
	    text: "Vincent Kranendonk (Studio Rabota), Joost Baaij (Scrollytelling)"
	}, {
	    type: "Paragraph",
	    title: "Music",
	    text: "Oliver Lyu"
	}, {
	    type: "Paragraph",
	    title: "Audio correction",
	    text: "Björn Warning"
	}, {
	    type: "Paragraph",
	    title: "Production",
	    text: "Edmée van Rijn in Israel and Palestine, Laura Verduijn voor Prospektor"
	}, {
	    type: "Paragraph",
	    text: "©Prospektor"
	}, {
	    type: "Paragraph",
	    title: "Background",
	    text: "June 2017 was the 50th anniversary of the occupation of the West Bank by Israel. The end is nowhere in sight: the illegal Jewish settlements have continued to expand, with ever increasing pace. Even though the Israeli government does not consider these settlements as obstacles for peace, the Palestinians suffer under the increasing restrictions. In The Holy Road, we intend to explore what daily life on the West Bank looks like after fifty years of occupation – the daily life of Palestinians as well as of Jewish settlers."
	}, {
	    type: "Paragraph",
	    title: "Support",
	    text: "The Holy Road is made possible by the generous support of different private donors and the IIC (Stichting Internationale Informatie en Communicatie)"
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "logos__mobile.jpg",
	        tablet: imageFolder + "logos.jpg",
	        desktop: imageFolder + "logos.jpg"
	    }
	}];

/***/ },
/* 245 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    dekiloknaller: {
	        label: "The Discounter",
	        slug: "dekiloknaller",
	        location: "Gush Etzion"
	    },
	    destandvastige: {
	        label: "The Perseverer",
	        slug: "destandvastige",
	        location: "Jerusalem"
	    },
	    dedemonstrant: {
	        label: "The Protester",
	        slug: "dedemonstrant",
	        location: "Ramallah"
	    },
	    devrienden: {
	        label: "Friends",
	        slug: "devrienden",
	        location: "Jenin"
	    },
	    depuber: {
	        label: "The Teenager",
	        slug: "depuber",
	        location: "Kiryat Arba"
	    },
	    deheilige: {
	        label: "The Holy Rachel",
	        slug: "deheilige",
	        location: "Bethlehem"
	    },
	    depionier: {
	        label: "The Pioneer",
	        slug: "depionier",
	        location: "Amona"
	    },
	    nazareth: "nazareth",
	    golan: "syria",
	    libanon: "lebanon",
	    gaza: "gaza",
	    israel: "Israel",
	    westelijke: "West",
	    jordaanoever: "Bank",
	    jordanie: "jordan",
	    egypte: "egypt",
	    telaviv: "tel aviv",
	    jeruzalem: "Jerusalem",
	    beersjeva: "beer sheva",
	    route60: "route 60",
	    areaa: "areaa",
	    areab: "areab",
	    areac: "areac",
	    jenin: "Jenin",
	    hebron: "hebron",
	    ramallah: "ramallah"
	};

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "about/";
	
	exports.default = [{
	    type: "Paragraph",
	    title: "About",
	    text: "The Holy Road is een webdocumentaire over de heiligste en meest omstreden weg ter wereld: route 60, door de door Israël bezette Westelijke Jordaanoever. Reis samen met journalist Derk Walters en fotograaf Dirk-Jan Visser van zuid naar noord; langs wachttorens en checkpoints, nederzettingen en vluchtelingenkampen, en duik in de verhalen van verschillende mensen die in dit omstreden gebied leven. Hoe ziet de bezetting eruit? Wat merk je van de voortdurende strijd en de restricties? Maar vooral: hoe leven mensen hier?"
	}, {
	    type: "Paragraph",
	    text: "The Holy Road is een productie van Prospektor."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "DerkWalters-EdmeeVanRijn-DirkJanVisser__mobile.jpg",
	        tablet: imageFolder + "DerkWalters-EdmeeVanRijn-DirkJanVisser.jpg",
	        desktop: imageFolder + "DerkWalters-EdmeeVanRijn-DirkJanVisser.jpg",
	        text: "Derk Walters, Edmée van Rijn en Dirk-Jan Visser"
	    }
	}, {
	    type: "Quote",
	    quote: "“Al langer frustreert het me dat de bezetting in individuele krantenartikelen zo lastig te beschrijven is, deels ook doordat Israël er bewust een ondoordringbare, bureaucratische situatie van heeft gemaakt. Met deze interactieve productie willen we mensen laten ervaren wat de bezetting inhoudt, zowel voor Palestijnen als voor Joodse kolonisten.”"
	}, {
	    type: "Paragraph",
	    title: "Research",
	    text: "Dirk-Jan Visser, Derk Walters"
	}, {
	    type: "Paragraph",
	    title: "Camera & fotografie",
	    text: "Dirk-Jan Visser, Edmée van Rijn"
	}, {
	    type: "Paragraph",
	    title: "Teksten",
	    text: "Derk Walters"
	}, {
	    type: "Paragraph",
	    title: "Tolk / vertalingen",
	    text: "Dvora Friedman, Hussam Taha, Riam Némmire, Edmée van Rijn"
	}, {
	    type: "Paragraph",
	    title: "Online concept",
	    text: "Dirk-Jan Visser, Eefje Blankevoort, Martijn van Tol, Hamid Sallali"
	}, {
	    type: "Paragraph",
	    title: "Online regie en eindredactie",
	    text: "Eefje Blankevoort (Prospektor)"
	}, {
	    type: "Paragraph",
	    title: "Montage video's",
	    text: "Eefje Blankevoort (Prospektor)"
	}, {
	    type: "Paragraph",
	    title: "Vormgeving",
	    text: "Hamid Sallali"
	}, {
	    type: "Paragraph",
	    title: "Development",
	    text: "Vincent Kranendonk (Studio Rabota), Joost Baaij (Scrollytelling)"
	}, {
	    type: "Paragraph",
	    title: "Muziek",
	    text: "Oliver Lyu"
	}, {
	    type: "Paragraph",
	    title: "Audio correctie",
	    text: "Björn Warning"
	}, {
	    type: "Paragraph",
	    title: "Productie",
	    text: "Edmée van Rijn in Israël en de bezette Westelijke Jordaanoever, Laura Verduijn voor Prospektor"
	}, {
	    type: "Paragraph",
	    text: "©Prospektor"
	}, {
	    type: "Paragraph",
	    title: "Achtergrond",
	    text: "De Israëlische bezetting van de Westelijke Jordaanoever duurt in juni 2017 een halve eeuw. Een einde is allerminst in zicht: nog altijd worden de illegale Joodse nederzettingen uitgebreid, dit jaar zelfs in een verhoogd tempo. Ook al beschouwt de Israëlische regering de nederzettingen niet als een obstakel voor vrede, de Palestijnen op de Westelijke Jordaanoever lijden onder toenemende restricties. In The Holy Road onderzoeken wij hoe het dagelijks leven na vijftig jaar militaire overheersing op de Westelijke Jordaanoever eruitziet – zowel voor Palestijnen als voor Joodse kolonisten."
	}, {
	    type: "Paragraph",
	    title: "Met dank aan",
	    text: "The Holy Road is mede mogelijk gemaakt door een financiële bijdrage van verschillende private donoren en de Stichting Internationale Informatie en Communicatie (IIC)."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "logos__mobile.jpg",
	        tablet: imageFolder + "logos.jpg",
	        desktop: imageFolder + "logos.jpg"
	    }
	}];

/***/ },
/* 247 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    dekiloknaller: {
	        label: "De Kiloknaller",
	        slug: "dekiloknaller",
	        location: "Gush Etzion"
	    },
	    destandvastige: {
	        label: "De Standvastige",
	        slug: "destandvastige",
	        location: "Jeruzalem"
	    },
	    dedemonstrant: {
	        label: "De Demonstrant",
	        slug: "dedemonstrant",
	        location: "ramallah"
	    },
	    devrienden: {
	        label: "De Vrienden",
	        slug: "devrienden",
	        location: "jenin"
	    },
	    depuber: {
	        label: "De Puber",
	        slug: "depuber",
	        location: "Kiryat Arba"
	    },
	    deheilige: {
	        label: "De Heilige",
	        slug: "deheilige",
	        location: "bethlehem"
	    },
	    depionier: {
	        label: "De Pionier",
	        slug: "depionier",
	        location: "amona"
	    },
	    nazareth: "nazareth",
	    golan: "golan",
	    libanon: "libanon",
	    gaza: "gaza",
	    israel: "Israël",
	    westelijke: "Westelijke",
	    jordaanoever: "Jordaanoever",
	    jordanie: "jordanië",
	    egypte: "egypte",
	    telaviv: "tel aviv",
	    jeruzalem: "Jeruzalem",
	    beersjeva: "beër sjeva",
	    route60: "route 60",
	    areaa: "areaa",
	    areab: "areab",
	    areac: "areac",
	    jenin: "Jenin",
	    hebron: "hebron",
	    ramallah: "ramallah"
	};

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "depuber/";
	
	var title = "Holy Road - De Puber";
	var description = "Emuna is veertien. Ze had een dansvoorstelling, samen met haar vriendin Hallel. Vlak voor het optreden werd Hallel doodgestoken. In haar eigen slaapkamer.";
	var featuredImage = imageFolder + "depuber/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "depuber" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Paragraph",
	    text: "Zoals alle dertienjarige meisjes had Hallel Yaffe Ariel roze kussens op haar hoogslaper in haar slaapkamer. Op de foto die het Israëlische leger heeft vrijgegeven, is haar bed besmeurd met bloed. Aan de plas op de grond te zien, moet haar Palestijnse moordenaar flink op haar ingestoken hebben voordat ze het leven liet. Drie vriendinnen van Hallel vertellen over hun leven. Hoe zien hun slaapkamers eruit? Hoe heeft de dood van hun vriendin hun levens beïnvloed? En hoe is het eigenlijk om op te groeien in een omstreden nederzetting?"
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "00__mobile.jpg",
	        tablet: imageFolder + "00__tablet.jpg",
	        desktop: imageFolder + "00.jpg",
	        alt: "",
	        text: "Overal bij de familie Ariel in huis hangen foto’s van Hallel en de rest van het gezin"
	    }
	}, {
	    type: "Paragraph",
	    text: "Emuna danste met Hallel. Heichal was een goede vriendin, geen best friend forever, maar toch. En Noam zat pas twee jaar bij haar in de klas, maar praat nog veel over haar. Hallel Yaffe Ariel was dertien jaar. Ze woonde met haar ouders en twee kleine zusjes in een huis aan de rand van Kiryat Arba, een Joodse nederzetting op de door Israël bezette Westelijke Jordaanoever. Haar vader heeft een wijngaard aan huis."
	}, {
	    type: "Paragraph",
	    text: "Waarschijnlijk doordat het ietwat afgelegen is, koos Mohammad Nasser Tra’ayra, een Palestijnse jongen van zeventien, op 30 juni 2016 juist het huis van Hallel uit voor zijn plan om een Joodse kolonist om het leven te brengen. Tra’ayra kwam uit Bani Na’im, een stadje op zes kilometer ten oosten van de nederzetting. Het tienermeisje was alleen thuis. Ze had geen schijn van kans."
	}, {
	    type: "Iframe",
	    url: "https://player.vimeo.com/video/209452055",
	    text: "Reuters-nieuwsvideo over de dood van Hallel"
	}, {
	    type: "Quote",
	    quote: "De avond voor haar dood hebben we nog samen een dansvoorstelling opgevoerd. En vier dagen na haar dood hebben we weer gedanst, om haar te herdenken.",
	    person: "Emuna Yeshurun (14), vriendin van Hallel"
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "01.jpg",
	        tablet: imageFolder + "01.jpg",
	        desktop: imageFolder + "01.jpg",
	        alt: "",
	        text: "Emuna op bed in haar slaapkamer"
	    }
	}, {
	    type: "Paragraph",
	    text: "Emuna, Heichal en Noam zijn nu allemaal veertien. Hoe ingrijpend ook, de dood van hun vriendin is niet het enige trauma dat zij in hun leven hebben meegemaakt. Maar de drie meiden zijn ook gewoon tieners. Emuna draagt een muts, doet aan hiphopdans en is fan van de boyband Big Time Rush. Ze gaat graag met vriendinnen shoppen in het Malha-winkelcentrum in Jeruzalem. Noam, die in een zwaarbewaakt wijkje midden tussen de Palestijnen woont, racet liever keihard de heuvel af in een kruiwagen die aan een fiets is vastgebonden. Al moet ze dan wel oppassen, ‘voor Arabieren en straathonden’. En Heichal schrijft liedjes. Over haar gevoelens."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow1/02__mobile.jpg",
	        tablet: imageFolder + "slideshow1/02.jpg",
	        desktop: imageFolder + "slideshow1/02.jpg",
	        alt: "",
	        text: "Emuna Yeshurun (14): ‘Ik doe aan hiphop, ballet en moderne dans. Ik kende Hallel erg goed. We zaten bij elkaar in de klas. De avond voor haar dood hebben we nog samen een dansvoorstelling opgevoerd. En vier dagen na haar dood hebben we weer gedanst, om haar te herdenken.’"
	    }, {
	        mobile: imageFolder + "slideshow1/03__mobile.jpg",
	        tablet: imageFolder + "slideshow1/03.jpg",
	        desktop: imageFolder + "slideshow1/03.jpg",
	        alt: "",
	        text: "‘Ik ben fan van Big Time Rush. Dat is een boyband. Best oud hoor, ze bestaan al niet eens meer.’"
	    }, {
	        mobile: imageFolder + "slideshow1/04__mobile.jpg",
	        tablet: imageFolder + "slideshow1/04.jpg",
	        desktop: imageFolder + "slideshow1/04.jpg",
	        alt: "",
	        text: "‘Ik wil later gevechtspiloot worden.’"
	    }, {
	        mobile: imageFolder + "slideshow1/05__mobile.jpg",
	        tablet: imageFolder + "slideshow1/05.jpg",
	        desktop: imageFolder + "slideshow1/05.jpg",
	        alt: "",
	        text: "‘Mijn boodschap aan de wereld is: er zijn hier twee volkeren, maar wij zijn degenen die worden vermoord. Het is niet normaal om de begrafenis van een leeftijdsgenootje te moeten bijwonen.’"
	    }, {
	        mobile: imageFolder + "slideshow1/06__mobile.jpg",
	        tablet: imageFolder + "slideshow1/06.jpg",
	        desktop: imageFolder + "slideshow1/06.jpg",
	        alt: "",
	        text: "‘Mijn meest waardevolle bezitting? M’n telefoon. En een briefje van Hallel.’"
	    }, {
	        mobile: imageFolder + "slideshow1/07__mobile.jpg",
	        tablet: imageFolder + "slideshow1/07.jpg",
	        desktop: imageFolder + "slideshow1/07.jpg",
	        alt: "",
	        text: "‘Wij bestuderen op school het joodse leven. Ik vraag me weleens af wat hun eigenlijk geleerd wordt. Waarschijnlijk hoe je Joden moet haten.’"
	    }, {
	        mobile: imageFolder + "slideshow1/08__mobile.jpg",
	        tablet: imageFolder + "slideshow1/08.jpg",
	        desktop: imageFolder + "slideshow1/08.jpg",
	        alt: "",
	        text: "‘Hallel had nog geen leven, ze was nog niet getrouwd, ze had nog geen kinderen kunnen krijgen. Daar denk ik aan als ik in bed lig. Dan stel ik me voor hoe de steekpartij in z’n werk ging.’"
	    }, {
	        mobile: imageFolder + "slideshow1/09__mobile.jpg",
	        tablet: imageFolder + "slideshow1/09.jpg",
	        desktop: imageFolder + "slideshow1/09.jpg",
	        alt: "",
	        text: "‘Ik zou niemand kunnen neersteken, al geeft iemand mij een mes en het lichaam van een Arabier. Hoe konden ze het dan doen bij Hallel?’"
	    }]
	}, {
	    type: "Paragraph",
	    text: "Zoals bijna alle kolonisten van Kiryat Arba zijn Emuna, Heichal en Noam orthodox-joods. Allemaal komen ze uit grote gezinnen – thuis zijn ze respectievelijk met zeven, zes en negen kinderen. Kiryat Arba ligt vlak naast Hebron, waar de Grot van de Patriarchen is. En dat is een van de heiligste plaatsen in het jodendom. Emuna (haar naam betekent ‘geloof’ in het Hebreeuws) gaat elke zaterdag te voet naar de Grot om te bidden."
	}, {
	    type: "Quote",
	    quote: "Mijn liedjes gaan over alles, hoe ik me voel. Ik heb niet direct over Hallel geschreven, maar een van de liedjes is wel somber.",
	    person: "Heichal Kornstam (14), vriendin van Hallel"
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "10__mobile.jpg",
	        tablet: imageFolder + "10.jpg",
	        desktop: imageFolder + "10.jpg",
	        alt: "",
	        text: "Heichal op bed in haar slaapkamer"
	    }
	}, {
	    type: "Paragraph",
	    text: "Als een rode draad door hun levens lopen ‘de Arabieren’. Kiryat Arba is een dorp, zoals alle Joodse nederzettingen illegaal volgens het internationaal recht, dat diep op de Westelijke Jordaanoever ligt. Ze worden aan alle kanten door Palestijnen omringd. En die Palestijnen hebben het meer dan eens op hen gemunt."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow2/11__mobile.jpg",
	        tablet: imageFolder + "slideshow2/11.jpg",
	        desktop: imageFolder + "slideshow2/11.jpg",
	        alt: "",
	        text: "Heichal Kornstam (14): ‘Hallel was heel vriendelijk, ze lachte veel. Heel attent en zorgzaam. We spraken elkaar veel op school. Hebben veel gelachen. Ik zat naast haar bij Engels. Daar was ze goed in.’"
	    }, {
	        mobile: imageFolder + "slideshow2/12__mobile.jpg",
	        tablet: imageFolder + "slideshow2/12.jpg",
	        desktop: imageFolder + "slideshow2/12.jpg",
	        alt: "",
	        text: "‘Soms gaan we naar Jeruzalem. Om te bowlen, of vrienden te ontmoeten. Ik lees niet meer zo veel, ik maak liever muziek. Ik schrijf liedjes en ik zing. Ik hou van Twenty One Pilots, Bastille.’"
	    }, {
	        mobile: imageFolder + "slideshow2/13__mobile.jpg",
	        tablet: imageFolder + "slideshow2/13.jpg",
	        desktop: imageFolder + "slideshow2/13.jpg",
	        alt: "",
	        text: "'Mijn liedjes gaan over alles, hoe ik me voel. Ik heb niet direct over Hallel geschreven, maar een van de liedjes is wel somber.’"
	    }, {
	        mobile: imageFolder + "slideshow2/14__mobile.jpg",
	        tablet: imageFolder + "slideshow2/14.jpg",
	        desktop: imageFolder + "slideshow2/14.jpg",
	        alt: "",
	        text: "'Het ligt aan de Arabieren wat er zal gebeuren. Zij zijn degenen die de aanslagen plegen. De overheid laat het hun toe om hier te leven, en zij plegen aanslagen. Israël stuurt hen niet weg, zeer teleurstellend.’"
	    }]
	}, {
	    type: "Paragraph",
	    text: "Sommige Joden worden kolonist omdat het zo weids en goedkoop wonen is in een nederzetting. In Kiryat Arba is dat anders. Hier gaat het om de ideologie. Dit land, vinden ze in Kiryat Arba, is van ons. Dat de internationale gemeenschap er anders over denkt, interesseert hen niets. Zij hebben de Thora. En daar staat het. ‘Judea’, zoals zij het zuiden van de Westelijke Jordaanoever noemen, is het hartland van het Joodse volk. "
	}, {
	    type: "Paragraph",
	    text: "Deze ideologie heeft zo haar fanatieke kanten. Zo richtte de kolonist Baruch Goldstein uit Kiryat Arba in 1994 een bloedbad aan in de Ibrahimi-moskee, zoals moslims de Grot van de Patriarchen noemen. Hierbij kwamen 29 gelovigen om het leven en raakten er 125 gewond. Goldstein ligt begraven in het Kahane-park in Kiryat Arba, genoemd naar de leider van de extreemrechtse, terroristische organisatie Kach. Het graf is een klein bedevaartsoord voor religieuze nationalisten."
	}, {
	    type: "Quote",
	    quote: "We zijn verplicht om met de bus naar school te gaan. De ruiten van de bus zijn kogelwerend, en er rijden bewapende beveiligers mee.",
	    person: "Noam Sarah Richie (14), vriendin van Hallel"
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "15__mobile.jpg",
	        tablet: imageFolder + "15.jpg",
	        desktop: imageFolder + "15.jpg",
	        alt: "",
	        text: "Noam op bed in haar slaapkamer"
	    }
	}, {
	    type: "Paragraph",
	    text: "De ouders van de meiden weten natuurlijk waar ze aan beginnen. Voor de familie van Heichal was Kiryat Arba zelfs een stapje terug in intensiteit: zij woonden aanvankelijk in een Joodse nederzetting in de Gazastrook. Ook Hallel was religieus, zegt haar moeder Rina. De familie Ariel is erg begaan met de beweging die een Derde Joodse Tempel wil bouwen op de Tempelberg/Haram al-Sharif in Oost-Jeruzalem, waar nu twee islamitische gebedshuizen staan."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow3/16__mobile.jpg",
	        tablet: imageFolder + "slideshow3/16.jpg",
	        desktop: imageFolder + "slideshow3/16.jpg",
	        alt: "",
	        text: "Noam Sarah Richi (14): ‘Het is gevaarlijk om de heuvel af te lopen naar de rest van het dorp. Zelfs te gevaarlijk om naar school te lopen. Er staat een hek om het dorp, maar in dit wijkje wonen we vlak naast de Arabieren.’"
	    }, {
	        mobile: imageFolder + "slideshow3/17__mobile.jpg",
	        tablet: imageFolder + "slideshow3/17.jpg",
	        desktop: imageFolder + "slideshow3/17.jpg",
	        alt: "",
	        text: "‘We zijn verplicht om met de bus naar school te gaan. De ruiten van de bus zijn kogelwerend, en er rijden bewapende beveiligers mee.’"
	    }, {
	        mobile: imageFolder + "slideshow3/18__mobile.jpg",
	        tablet: imageFolder + "slideshow3/18.jpg",
	        desktop: imageFolder + "slideshow3/18.jpg",
	        alt: "",
	        text: "Heeft Noam weleens contact met Arabieren? Ze lacht. ‘Nee. Hooguit dat we elkaar uitschelden.’"
	    }, {
	        mobile: imageFolder + "slideshow3/19__mobile.jpg",
	        tablet: imageFolder + "slideshow3/19.jpg",
	        desktop: imageFolder + "slideshow3/19.jpg",
	        alt: "",
	        text: "‘Ik denk weleens aan Arabische meisjes van mijn eigen leeftijd. Maar ik wil geen contact. Het interesseert me niet zo, ook niet welke muziek ze luisteren. Dat hoor ik wel als ze weer eens een luide bruiloft hebben.’"
	    }, {
	        mobile: imageFolder + "slideshow3/20__mobile.jpg",
	        tablet: imageFolder + "slideshow3/20.jpg",
	        desktop: imageFolder + "slideshow3/20.jpg",
	        alt: "",
	        text: "‘Mijn zus van achttien doet aan taekwondo, mixed martial arts, boksen en krav maga. Ze heeft het mij ook een beetje geleerd. En er is een zelfverdedigingscursus voor vrouwen. Maar dat helpt niet bij een steekpartij, het is vooral voor je zelfvertrouwen.’"
	    }, {
	        mobile: imageFolder + "slideshow3/21__mobile.jpg",
	        tablet: imageFolder + "slideshow3/21.jpg",
	        desktop: imageFolder + "slideshow3/21.jpg",
	        alt: "",
	        text: "‘Als iemand mij wil neersteken, gooi ik mijn telefoon naar hem denk ik.’"
	    }, {
	        mobile: imageFolder + "slideshow3/22__mobile.jpg",
	        tablet: imageFolder + "slideshow3/22.jpg",
	        desktop: imageFolder + "slideshow3/22.jpg",
	        alt: "",
	        text: "‘Een vriendin begon een keer ineens heel hard te schreeuwen, omdat ze zich een voorstelling maakte van de steekpartij.’"
	    }, {
	        mobile: imageFolder + "slideshow3/23__mobile.jpg",
	        tablet: imageFolder + "slideshow3/23.jpg",
	        desktop: imageFolder + "slideshow3/23.jpg",
	        alt: "",
	        text: "‘Soms is het heel gezellig met de meiden, maar dan denk ik ineens: wat als deze vriendin ook doodgaat?’"
	    }]
	}, {
	    type: "Paragraph",
	    text: "De meeste vriendinnen van Hallel zien zichzelf wel in Kiryat Arba blijven. De introverte Heichal noemt het ‘teleurstellend’ dat de Israëlische regering de Palestijnen niet wegstuurt. En danseres Emuna vindt dat het haar opdracht is om ook later in Kiryat Arba te blijven wonen: ‘We moeten groeien, anders wordt het hier Arabisch. Alle dorpen om ons heen zijn Arabisch. Als wij groeien, dan slokken we ze op. Dat is de beste manier om terreuraanslagen te voorkomen.’"
	}];

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "dekiloknaller/";
	
	var title = "Holy Road - De Kiloknaller";
	var description = "Zowel kolonisten als Palestijnen kopen hun kip bij Rami Levy, de goedkoopste supermarkt in de omgeving. Maar de prijsvechter staat wel in een nederzetting. De Joden hier dragen wapens, de Palestijnen niet.";
	var featuredImage = imageFolder + "dekiloknaller/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "dekiloknaller" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Iframe",
	    hideSpacer: true,
	    url: "https://player.vimeo.com/video/216162876"
	}, {
	    type: "Paragraph",
	    text: "Op de bezette Westelijke Jordaanoever is het Israëlisch-Palestijnse conflict overal zichtbaar. Maar bij supermarkt Rami Levy in de illegale Joodse nederzettingen van Gush Etzion vechten ze een heel andere strijd uit: een permanente prijzenoorlog. Op het hoogtepunt van deze strijd kostte een kilo kip minder dan één shekel (24 eurocent)."
	}, {
	    type: "Paragraph",
	    text: "Ook al staat deze supermarkt naast een rotonde waar talloze aanslagen zijn gepleegd – kip is kip. In hun dorpen rondom deze nederzettingen kunnen Palestijnen goedkoop naar de kapper en een broodje falafel is ook niet duur, maar tegen de kiloknallers van Rami Levy kan niemand op."
	}, {
	    type: "Paragraph",
	    text: "Op 19 november 2015 opende Mohammed Abdel Basset al-Kharoub bij de rotonde het vuur op stilstaande auto’s voor de rotonde terwijl zijn dorpsgenoten honderd meter verderop een kilo kip kochten te midden van gewapende Israëlische kolonisten. Die ook hun kip bij Rami Levy halen. Want die laat je niet zomaar liggen voor die prijs."
	}, {
	    type: "Paragraph",
	    text: "Anders dan op veel andere plaatsen op de Westelijke Jordaanoever wonen Joden en Arabieren hier kriskras door elkaar heen. Sommige Palestijnen komen tot de conclusie dat je maar beter kunt proberen om samen te leven met de Joodse bezetters in plaats van hen te bestrijden. Schoorvoetend doen ze hun boodschappen bij de Joden, en ook de werknemers van Rami Levy zijn Palestijnen. Maar laat het hun dorpsgenoten niet horen."
	}];

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "deheilige/";
	
	var title = "Holy Road - De Heilige";
	var description = "Het graf van de oermoeder Rachel ligt in Bethlehem, maar je kunt er alleen vanuit Israël naartoe. Is dit bijbels hartland, of de essentie van koloniale logica?";
	var featuredImage = imageFolder + "deheilige/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "deheilige" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Paragraph",
	    text: "Rachel en Jacob waren verliefd op elkaar. Ze trouwden nadat Jacob veertien jaar had moeten werken voor zijn oom - haar vader. Ze kregen twee kinderen. Rachel stierf in het kraambed toen ze beviel van haar tweede zoon, Benjamin. Ze werd begraven in een eenvoudige tombe vlakbij Bethlehem. Eeuwenlang werd de tombe beheerd door moslims en was het een bedevaartsoord voor christenen, joden en moslims. Route 60 loopt langs heiligdommen en onheilsplekken. Een van die heiligdommen is het Graf van Rachel, al sinds de vierde eeuw na Christus een pelgrimsoord voor joden, christenen en moslims."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "30__mobile.jpg",
	        tablet: imageFolder + "30.jpg",
	        desktop: imageFolder + "30.jpg",
	        alt: "",
	        text: "Graf van Rachel gefotografeerd tussen 1898 en 1946 door een fotograaf van de American Colony"
	    }
	}, {
	    type: "Paragraph",
	    text: "Een stoet kamelen trekt voorbij aan een stenen gebouwtje, tegen de achtergrond van de ongerepte heuvels van Judea. Op deze foto uit 1898 staat de graftombe van oermoeder Rachel, belangrijk voor alle monotheïstische religies, in een omgeving die millennialang onveranderd is gebleven: het bijbelse hartland tussen Jeruzalem en Bethlehem. Alleen het gebouwtje zelf is in de loop der eeuwen wat uitgebreid. Het monument is verbeeld in talloze schilderijen en bezongen in gedichten, zoals in Nicholas Michells gedicht Rachel’s Tomb. Het beeld dat oprijst uit deze culturele uitingen, vooral van Joodse zijde, is dat van een geromantiseerd verlangen."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow1/01__mobile.jpg",
	        tablet: imageFolder + "slideshow1/01.jpg",
	        desktop: imageFolder + "slideshow1/01.jpg",
	        alt: "",
	        text: "Het graf van Rachel geschilderd door de Britse kunstenaar Samuel Lawson Booth in 1900"
	    }, {
	        mobile: imageFolder + "slideshow1/02__mobile.jpg",
	        tablet: imageFolder + "slideshow1/02.jpg",
	        desktop: imageFolder + "slideshow1/02.jpg",
	        alt: "",
	        text: "Rachels tombe gefotografeerd door een fotograaf van de American Colony tussen 1898 en 1914"
	    }, {
	        mobile: imageFolder + "slideshow1/03__mobile.jpg",
	        tablet: imageFolder + "slideshow1/03.jpg",
	        desktop: imageFolder + "slideshow1/03.jpg",
	        alt: "",
	        text: "Postzegels waar het graf van Rachel op staat gebruikt in Palestina onder Brits mandaat tussen 1927 en 1942"
	    }, {
	        mobile: imageFolder + "slideshow1/04__mobile.jpg",
	        tablet: imageFolder + "slideshow1/04.jpg",
	        desktop: imageFolder + "slideshow1/04.jpg",
	        alt: "",
	        text: "Het graf van Rachel in de jaren 30"
	    }, {
	        mobile: imageFolder + "slideshow1/05__mobile.jpg",
	        tablet: imageFolder + "slideshow1/05.jpg",
	        desktop: imageFolder + "slideshow1/05.jpg",
	        alt: "",
	        text: "Een oude kleurenfoto van graf van Rachel. Foto: Matson Photoservice, jaartal onbekend."
	    }, {
	        mobile: imageFolder + "slideshow1/06__mobile.jpg",
	        tablet: imageFolder + "slideshow1/06.jpg",
	        desktop: imageFolder + "slideshow1/06.jpg",
	        alt: "",
	        text: "Een fotograaf van de American Colony fotografeert Britse militairen van een Schots regiment die passanten controleren op route 60 voor Rachels graf in de jaren 40"
	    }, {
	        mobile: imageFolder + "slideshow1/07__mobile.jpg",
	        tablet: imageFolder + "slideshow1/07.jpg",
	        desktop: imageFolder + "slideshow1/07.jpg",
	        alt: "",
	        text: "Een halve Palestijnse pond met een afbeelding van Rachels graf. Deze munteenheid, in 1927 geïntroduceerd door de Britten werd tot 1950 in de Westelijke Jordaanoever gebruikt."
	    }, {
	        mobile: imageFolder + "slideshow1/08__mobile.jpg",
	        tablet: imageFolder + "slideshow1/08.jpg",
	        desktop: imageFolder + "slideshow1/08.jpg",
	        alt: "",
	        text: "Joodse vrouwen voor het graf van Rachel in 1967. Foto: Yosef Tamir"
	    }, {
	        mobile: imageFolder + "slideshow1/09__mobile.jpg",
	        tablet: imageFolder + "slideshow1/09.jpg",
	        desktop: imageFolder + "slideshow1/09.jpg",
	        alt: "",
	        text: "Het graf van Rachel in 1978"
	    }, {
	        mobile: imageFolder + "slideshow1/26__mobile.jpg",
	        tablet: imageFolder + "slideshow1/26.jpg",
	        desktop: imageFolder + "slideshow1/26.jpg",
	        alt: "",
	        text: "De tegenwoordige ingang van het Graf van Rachel"
	    }]
	}, {
	    type: "Paragraph",
	    text: "Tot diep in de negentiende eeuw waren er weinig Joden in dit gebied, destijds deel van het Ottomaanse Rijk, en het was slechts weinigen gegeven om ernaartoe te reizen. De grote Joodse immigratiegolven naar Palestina van eind negentiende en begin twintigste eeuw maakten het Graf van Rachel toegankelijk voor grote groepen joodse gelovigen. Tijdens de Arabisch-Israëlische oorlog van 1948 viel het monument toe aan Jordanië. Negentien jaar lang konden Joden het niet bezoeken, wat het verlangen weer verhevigde. Deze begeerte werd ingelost in 1967, toen de Israëlische bezetting van de Westelijke Jordaanoever begon."
	}, {
	    type: "Paragraph",
	    text: "En nu ziet het Graf van Rachel er zo uit:"
	}, {
	    type: "Iframe",
	    url: "https://player.vimeo.com/video/214016315",
	    text: "Aankomst bij Rachels Tombe vanaf Route 60."
	}, {
	    type: "Paragraph",
	    text: "Wie de Israëlische bezetting van de Westelijke Jordaanoever wil begrijpen, moet kijken naar het Graf van Rachel. Religieuze belangen, militaire macht en esthetische misvorming zijn hier samengebald op luttele vierkante meters. De fortificatie van deze heilige plek vormt, volgens sommigen, de essentie van koloniale logica. Nog altijd bezoeken gelovigen het graf. Maar de religieuze ervaring heeft onmiskenbaar een machtspolitieke factor gekregen. Joden bezitten nu het exclusieve gebruiksrecht op deze heilige plaats; het Graf van Rachel, dat midden in het Palestijnse Bethlehem ligt, is een synagoge geworden. Een metershoge muur met militaire wachtposten moet deze exclusiviteit garanderen."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "28__mobile.jpg",
	        tablet: imageFolder + "28.jpg",
	        desktop: imageFolder + "28.jpg",
	        alt: "",
	        text: "Naast Rachels graf binnen de muur is het leger altijd aanwezig. De blauwe poort wordt gebruikt door het leger als uitvalsbasis naar Aida vluchtelingenkamp."
	    }
	}, {
	    type: "Paragraph",
	    text: "Na de Zesdaagse oorlog in 1967 kwam de tombe in beheer van het Israëlische rabbinaat. Vanuit rechts-nationalistische en ultra-orthodoxe hoek kwam fel verzet toen de tombe tijdens de Oslo-akkoorden eind jaren negentig werd toegewezen aan de Palestijnse Autoriteit."
	}, {
	    type: "Paragraph",
	    text: "Daarom besloot Israël de grenzen iets te verleggen, precies om het monument heen. Zo kwam een heilige plaats midden in een Palestijnse stad toch onder Israëlisch gezag te staan. Er werd een Joodse nederzetting gesticht en in 2001 werd de tombe opnieuw geannexeerd door Israël. Rond de tombe verscheen een acht meter hoge muur die oude weg van Hebron via Bethlehem naar Jeruzalem blokkeert. Voor Palestijnen is het onmogelijk om deze bedevaartsplek te zien. Rachels graf is alleen nog toegankelijk voor Joodse bedevaarders en toeristen."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "01__mobile.jpg",
	        tablet: imageFolder + "01.jpg",
	        desktop: imageFolder + "01.jpg",
	        alt: "",
	        text: "Een overzicht van de muur rond Rachels graf, gezien vanuit Bethlehem."
	    }
	}, {
	    type: "Paragraph",
	    text: "De muur loopt niet op de Groene Lijn, de grens tussen Israël en de Westelijke Jordaanoever, maar is voor het grootste deel kilometers diep in Palestijns gebied gebouwd. De route van de muur volgt de uitstulping van de grens rond het Graf van Rachel. Van bovenaf gezien steekt het Israëlische grondgebied hier als een arm met een gebalde vuist de stad Bethlehem in. Vanuit Bethlehem is het graf niet meer te bereiken. Eeuwenlang zijn Jeruzalem en Bethlehem twin cities geweest, als Boeda en Pest, als Hoogezand en Sappemeer. In Bethlehem werd Jezus geboren, in Jeruzalem stierf hij. Pas in 2004 zijn de chirurgen van de Israëlische regering erin geslaagd deze Siamese tweeling van elkaar te scheiden."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "27__mobile.jpg",
	        tablet: imageFolder + "27.jpg",
	        desktop: imageFolder + "27.jpg",
	        alt: "",
	        text: "Rondom het Graf van Rachel (bij de Davidsster) doet zich een ingewikkelde grenssituatie voor. Het hele gebied op dit kaartje behoort tot de door Israël bezette Westelijke Jordaanoever. Boven de dikke paarse streep ligt Oost-Jeruzalem, eronder Bethlehem. De groene lijn is de grens tussen het door Israël gecontroleerde Area C (boven) en het Palestijnse Area A (onder). En dan is er nog de rode lijn: de afscheidingsmuur die zich om het grafmonument heen slingert."
	    }
	}, {
	    type: "Paragraph",
	    text: "De muur moet garanderen dat gelovige joden vanuit Jeruzalem ongelimiteerd het graf van de oermoeder kunnen bereiken. Vanuit Beitar Illit, een ultraorthodoxe nederzetting op de Westelijke Jordaanoever, gaat er zelfs een speciale buslijn naar deze heilige plek. Het is dan ook druk bezocht. Het grafmonument, een gebouw uit het Ottomaanse tijdperk, kent gescheiden ingangen voor mannen en vrouwen. Beide seksen komen uiteindelijk uit aan weerszijden van dezelfde rustplaats: een betonnen structuur, met dik plastic beschermd tegen de handpalmen, voorhoofden en lippen van biddende orthodoxe joden."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow2/15__mobile.jpg",
	        tablet: imageFolder + "slideshow2/15.jpg",
	        desktop: imageFolder + "slideshow2/15.jpg",
	        alt: "",
	        text: "Biddende mannen bij de tombe van Rachel"
	    }, {
	        mobile: imageFolder + "slideshow2/16__mobile.jpg",
	        tablet: imageFolder + "slideshow2/16.jpg",
	        desktop: imageFolder + "slideshow2/16.jpg",
	        alt: "",
	        text: "Een Orthodoxe Jood staat te bidden bij de tombe van Rachel"
	    }, {
	        mobile: imageFolder + "slideshow2/17__mobile.jpg",
	        tablet: imageFolder + "slideshow2/17.jpg",
	        desktop: imageFolder + "slideshow2/17.jpg",
	        alt: "",
	        text: "Een speciale Thora rol bij de mannen ingang van het graf van Rachel"
	    }, {
	        mobile: imageFolder + "slideshow2/18__mobile.jpg",
	        tablet: imageFolder + "slideshow2/18.jpg",
	        desktop: imageFolder + "slideshow2/18.jpg",
	        alt: "",
	        text: "Orthodoxe Joden in het mannendeel van het graf van Rachel"
	    }, {
	        mobile: imageFolder + "slideshow2/19__mobile.jpg",
	        tablet: imageFolder + "slideshow2/19.jpg",
	        desktop: imageFolder + "slideshow2/19.jpg",
	        alt: "",
	        text: "Joodse mannen bidden en studeren de Thora bij het graf van Rachel"
	    }, {
	        mobile: imageFolder + "slideshow2/20__mobile.jpg",
	        tablet: imageFolder + "slideshow2/20.jpg",
	        desktop: imageFolder + "slideshow2/20.jpg",
	        alt: "",
	        text: "Biddende vrouwen bij de tombe van Rachel"
	    }, {
	        mobile: imageFolder + "slideshow2/21__mobile.jpg",
	        tablet: imageFolder + "slideshow2/21.jpg",
	        desktop: imageFolder + "slideshow2/21.jpg",
	        alt: "",
	        text: "Vrouwen kussen de graftombe van Rachel"
	    }, {
	        mobile: imageFolder + "slideshow2/22__mobile.jpg",
	        tablet: imageFolder + "slideshow2/22.jpg",
	        desktop: imageFolder + "slideshow2/22.jpg",
	        alt: "",
	        text: "Een Joodse vrouw bid bij de graftombe van Rachel"
	    }, {
	        mobile: imageFolder + "slideshow2/23__mobile.jpg",
	        tablet: imageFolder + "slideshow2/23.jpg",
	        desktop: imageFolder + "slideshow2/23.jpg",
	        alt: "",
	        text: "Een Joodse vrouw met gebedenboek bij de tombe van Rachel"
	    }, {
	        mobile: imageFolder + "slideshow2/24__mobile.jpg",
	        tablet: imageFolder + "slideshow2/24.jpg",
	        desktop: imageFolder + "slideshow2/24.jpg",
	        alt: "",
	        text: "Biddende vrouwen bij de tombe van Rachel met op de achtergrond het gordijn dat gemaakt is van de trouwjurk van Nava Applebaum, een Amerikaans-Israëlische vrouw van twintig die op 9 september 2003, één dag voor haar bruiloft, omkwam bij een zelfmoordaanslag in West-Jeruzalem."
	    }, {
	        mobile: imageFolder + "slideshow2/25__mobile.jpg",
	        tablet: imageFolder + "slideshow2/25.jpg",
	        desktop: imageFolder + "slideshow2/25.jpg",
	        alt: "",
	        text: "De manneningang van het graf van Rachel waar vroeger route 60 liep."
	    }]
	}, {
	    type: "Paragraph",
	    text: "Rachels graf geldt als een symbool van de terugkeer van de Joden naar Zion, hun oude thuisland. Joodse vrouwen bidden er voor vruchtbaarheid en een geslaagde geboorte, een verwijzing naar het leven van Rachel, die lang geen kinderen kon krijgen maar wier gebeden uiteindelijk verhoord werden. Een opvallend relikwie is het gordijn dat gedrapeerd is over de Thora-ark, de kast waarin de vijf Thorarollen bewaard worden. Dit gordijn is gemaakt van de trouwjurk van Nava Applebaum, een Amerikaans-Israëlische vrouw van twintig die op 9 september 2003, één dag voor haar bruiloft, omkwam bij een zelfmoordaanslag in West-Jeruzalem."
	}, {
	    type: "Paragraph",
	    text: "Opmerkelijk genoeg verwijzen de joodse gelovigen naar de bijbelse matriarch alsof ze hun eigen moeder is. Zo zegt de twintigjarige Joodse toeriste Shiffy Klein uit New York, die Rachels graf bezoekt op haar huwelijksreis: ‘Bij je moeder kun je eerlijk zijn, jezelf zijn, je hart laten spreken.’ Dat is ook de reden dat Klein deze tombe prefereert boven de acht kilometer noordelijker gelegen Klaagmuur, zegt ze. ‘Er zijn zo veel mensen daar. Het voelt niet zo intiem als hier.’"
	}, {
	    type: "Paragraph",
	    text: "Geheel volgens de traditie heeft ook Klein voor vruchtbaarheid gebeden. ‘Ik zei tegen Rachel: help me alstublieft om ook een moeder te worden.’ Dat het monument door muren is omgeven, vindt Klein geen probleem. ‘We bidden ook voor een tijd waarin muren niet nodig zijn. Maar als je binnen bent, als je bij haar bent, voel je je veilig.’"
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "14__mobile.jpg",
	        tablet: imageFolder + "14.jpg",
	        desktop: imageFolder + "14.jpg",
	        alt: "",
	        text: "Binnen de muur vlakbij het graf van Rachel is een muurschildering van het graf aangebracht met een bijbeltekst van Genesis 35 vers 16 -20 waarin de dood van Rachel en haar begrafenis wordt beschreven."
	    }
	}, {
	    type: "Paragraph",
	    text: "De veiligheid van de orthodoxe joden in de tombe heeft een prijs - voor de Palestijnen aan de andere kant. Er is een checkpoint tussen Jeruzalem en Bethlehem. Sommige Palestijnen mogen hier doorheen, bijvoorbeeld wie een Israëlische ID-kaart heeft, of wie een vergunning heeft om aan de Israëlische kant te werken. Voor veel andere Palestijnen is de muur de feitelijke grens. Bij het graf van de oermoeder begint voor hen de andere kant, Israël – ook al is er geen land ter wereld dat dit bezette gebied tot Israël rekent."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow3/02__mobile.jpg",
	        tablet: imageFolder + "slideshow3/02.jpg",
	        desktop: imageFolder + "slideshow3/02.jpg",
	        alt: "",
	        text: "Overal waar je in dit deel van Bethlehem loopt zie je de muur rond het graf van Rachel boven de huizen uitkomen"
	    }, {
	        mobile: imageFolder + "slideshow3/03__mobile.jpg",
	        tablet: imageFolder + "slideshow3/03.jpg",
	        desktop: imageFolder + "slideshow3/03.jpg",
	        alt: "",
	        text: "Achter de muur loopt de weg die naar het graf van Rachel leidt."
	    }, {
	        mobile: imageFolder + "slideshow3/04__mobile.jpg",
	        tablet: imageFolder + "slideshow3/04.jpg",
	        desktop: imageFolder + "slideshow3/04.jpg",
	        alt: "",
	        text: "Aan de andere kant van de muur kun je de ingang van het graf van Rachel zien."
	    }, {
	        mobile: imageFolder + "slideshow3/05__mobile.jpg",
	        tablet: imageFolder + "slideshow3/05.jpg",
	        desktop: imageFolder + "slideshow3/05.jpg",
	        alt: "",
	        text: "Door de blauwe poort komt het leger met zekere regelmaat om een inval te doen in het Aida vluchtelingenkamp."
	    }, {
	        mobile: imageFolder + "slideshow3/06__mobile.jpg",
	        tablet: imageFolder + "slideshow3/06.jpg",
	        desktop: imageFolder + "slideshow3/06.jpg",
	        alt: "",
	        text: "In het midden van de foto is de koepel van het graf van Rachel te zien, gefotografeerd vanaf de begraafplaats tussen Rachels graf en Aida vluchtelingenkamp"
	    }, {
	        mobile: imageFolder + "slideshow3/07__mobile.jpg",
	        tablet: imageFolder + "slideshow3/07.jpg",
	        desktop: imageFolder + "slideshow3/07.jpg",
	        alt: "",
	        text: "Het graf van Rachel, door het hoge hek kun je net niet meer de koepel zien."
	    }, {
	        mobile: imageFolder + "slideshow3/08__mobile.jpg",
	        tablet: imageFolder + "slideshow3/08.jpg",
	        desktop: imageFolder + "slideshow3/08.jpg",
	        alt: "",
	        text: "Hier achter de muur, naast het graf van Rachel  wonen Joodse kolonisten."
	    }, {
	        mobile: imageFolder + "slideshow3/09__mobile.jpg",
	        tablet: imageFolder + "slideshow3/09.jpg",
	        desktop: imageFolder + "slideshow3/09.jpg",
	        alt: "",
	        text: "De speeltuin van Wi’am"
	    }, {
	        mobile: imageFolder + "slideshow3/10__mobile.jpg",
	        tablet: imageFolder + "slideshow3/10.jpg",
	        desktop: imageFolder + "slideshow3/10.jpg",
	        alt: "",
	        text: "De muur over het land van Wi’am waardoor Nicola een kwart van zijn land kwijt raakte."
	    }, {
	        mobile: imageFolder + "slideshow3/11__mobile.jpg",
	        tablet: imageFolder + "slideshow3/11.jpg",
	        desktop: imageFolder + "slideshow3/11.jpg",
	        alt: "",
	        text: "Als je hier door de poort zou gaan zit je op de oude route 60 die langs het graf van Rachel loopt."
	    }, {
	        mobile: imageFolder + "slideshow3/12__mobile.jpg",
	        tablet: imageFolder + "slideshow3/12.jpg",
	        desktop: imageFolder + "slideshow3/12.jpg",
	        alt: "",
	        text: "Voordat de muur bestond was dit benzinestation, recht tegenover het graf van Rachel één van de drukste stations van Bethlehem."
	    }, {
	        mobile: imageFolder + "slideshow3/13__mobile.jpg",
	        tablet: imageFolder + "slideshow3/13.jpg",
	        desktop: imageFolder + "slideshow3/13.jpg",
	        alt: "",
	        text: "De muur in de richting van checkpoint 300 waar Palestijnen van de Westelijke Jordaanoever met een vergunning naar Jerusalem mogen."
	    }]
	}, {
	    type: "Paragraph",
	    text: "De Palestijnse christen Usama Nicola uit Bethlehem zegt dat ook hij en zijn geloofsgenoten een ‘emotionele connectie’ met Rachel voelen. ‘Wij zouden in staat willen zijn om te genieten van de heilige plaatsen in deze omgeving, in het bijzonder van het Graf van Rachel.’"
	}, {
	    type: "Paragraph",
	    text: "Nicola werkt als projectcoördinator bij ‘Wi’am: The Palestinian Conflict Transformation Center’. Wi’am, zegt Nicola, investeert in zaken als conflictbemiddeling, vrouwenrechten, en traumaverwerking bij kinderen. Bij het ommuren van het Graf van Rachel raakte Wi’am een kwart van zijn land kwijt; in de eigenlijke tuin van het centrum, direct naast het monument, wonen nu joodse kolonisten. Enkele keren per jaar stroomt er vanuit de richting van het Graf van Rachel rioolwater onder de muur door, zo het overgebleven stuk tuin van Wi’am in."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "riool__mobile.jpg",
	        tablet: imageFolder + "riool.jpg",
	        desktop: imageFolder + "riool.jpg",
	        alt: "",
	        text: "Via een tunneltje onder de afscheidingsmuur loopt er enkele keren per jaar rioolwater van het Graf van Rachel naar de tuin van Wi'am: The Palestinian Conflict Transformation Center. Foto: Usama Nicola"
	    }
	}, {
	    type: "Paragraph",
	    text: "De muur, zegt hij, is een ‘lelijk beeld dat de natuurlijke en door de mens gemaakte schoonheid van het land ontsiert’. Het grootste probleem is dat de muur de Palestijnen  toegang ontzegt tot Jeruzalem en de rest van ‘historisch Palestina’, zoals Nicola het hele land tussen de Jordaan-rivier en de Middellandse Zee noemt."
	}, {
	    type: "Paragraph",
	    text: "Zo is het Graf van Rachel niet alleen meer het symbool van vruchtbaarheid, maar ook van de bezetting van de Westelijke Jordaanoever. Het bijbelse hartland is verworden tot het hart van de bezetting."
	}];

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "destandvastige/";
	
	var title = "Holy Road - De Standvastige";
	var description = "De Palestijnse familie Sub Laban woont in de moslimwijk van de Oude Stad in Jeruzalem. Ooit woonden hier Joden. Daarom wordt hun huis onteigend.";
	var featuredImage = imageFolder + "destandvastige/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "destandvastige" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Iframe",
	    hideSpacer: true,
	    url: "https://player.vimeo.com/video/216162913"
	}, {
	    type: "Paragraph",
	    text: "In de slaapkamermuur is de stopverf nog goed zichtbaar. De Palestijnse Nora Sub Laban wijst naar zeven plekken op de muur: hier boorden haar buren telkens een gat. 'Om te kijken wat erachter zat, zeiden ze. Maar waarom deden ze het dan zeven keer?' De buren van Nora Sub Laban, in de moslimwijk van de Oude Stad in bezet Oost-Jeruzalem, zijn Joodse kolonisten. Vroeger was de kamer naast de slaapkamer ook van de familie Sub Laban, maar stapje voor stapje wordt het huis verder door de buren overgenomen."
	}, {
	    type: "Paragraph",
	    text: "Absurd? Niet in Jeruzalem. Nora Sub Laban kan naar de politie stappen, maar die zal niets voor haar doen. Zelfs de Israëlische rechter geeft de Joodse buren gelijk, en soldaten kijken toe als er weer eens een ruimte wordt overgenomen. Een juridische strijd van enkele decennia levert de familie vooralsnog niets op. Dit is het gevolg van een Israëlische wet die bepaalt dat Joden rechtmatig alle huizen van Palestijnen kunnen claimen waarin ooit een Jood heeft gewoond. In het geval van de familie Sub Laban gaat het om een Joodse huurder in de jaren dertig van de twintigste eeuw."
	}, {
	    type: "Paragraph",
	    text: "Tijdens de Arabisch-Israëlische Oorlog van 1948 werd de Oude Stad van Jeruzalem veroverd door Jordanië, en sindsdien is het huis in familiebezit. Nora en haar man mogen er nog blijven wonen, heeft de rechter geoordeeld – maar na deze generatie is het afgelopen. Dan moeten ze het afstaan aan de kolonisten. In diezelfde oorlog zijn er ook honderden Palestijnse huizen in het tegenwoordige West-Jeruzalem in Joodse handen gekomen. Een paar honderd meter van het huis van Nora Sub Laban, even buiten de Oude Stad in de wijk Musrara, staan van oorsprong Arabische mansions waar nu Joden wonen. Maar andersom geldt de wet niet. Geen Palestijn kan een huis terugeisen dat ooit door zijn familie bewoond is geweest. De Israëlische wet is expliciet gericht op het verjoodsen van zowel Israël als de gebieden onder zijn controle, zoals bezet Oost-Jeruzalem."
	}];

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "dedemonstrant/";
	
	var title = "Holy Road - De Demonstrant";
	var description = "Zijn strijd naam is Tito. Hij trekt er elke week op uit om tegen het Israëlische leger te demonstreren. Het is David tegen Goliath, zegt hij. Maar hij kan niet anders.";
	var featuredImage = imageFolder + "dedemonstrant/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "dedemonstrant" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Iframe",
	    hideSpacer: true,
	    url: "https://player.vimeo.com/video/214048257",
	    text: "Hoe ziet het leven van een Palestijnse demonstrant eruit? Kijk hier een dag uit het leven van Tito.  "
	}, {
	    type: "Paragraph",
	    text: "Vraag aan Tito waar hij vandaan komt, en hij zegt: uit Salama. Maar Salama staat niet meer op de kaart. Het was een dorp even buiten Jaffa, het eeuwenoude Arabische havenstadje dat tegenwoordig door het leven gaat als stadsdeel van Tel Aviv, in Israël. Salama werd in 1948 etnisch gezuiverd door zionistische milities, en letterlijk van de kaart geveegd. Alleen de 'Shalma Road' in Tel Aviv herinnert nog aan de vroegere Arabische bewoning. De ongeveer zevenduizend inwoners van Salama ontvluchtten hun huizen, en belandden in kampen. Ze kwamen onder meer terecht in het Am'ari-vluchtelingenkamp bij Ramallah, op de Westelijke Jordaanoever. Zo ook de familie van Tito."
	}, {
	    type: "Paragraph",
	    text: "Bijna zeventig jaar later woont Tito hier nog steeds. Het is hem verboden om ook maar een dag in Tel Aviv te zijn. Ook hij strijdt, net als zijn voorvaderen, tegen de Joden – niet meer tegen zionistische milities, maar tegen het Israëlische leger. Volgens het internationaal recht hebben alle Palestijnse vluchtelingen van 1948 en hun nakomelingen – inmiddels zijn dat er zo'n vijf miljoen – het recht om terug te keren naar waar ze vandaan komen, in het tegenwoordige Israël. Maar niet alleen weigert Israël dat pertinent, ook het tegenwoordige leefgebied van Tito en zijn familie, de Westelijke Jordaanoever, wordt bezet en gekoloniseerd."
	}, {
	    type: "Paragraph",
	    text: "Tegenover de Israëlische soldaten, met hun M16's en hun traangasgranaten, kunnen Tito en consorten alleen stenen en molotovcocktails plaatsen. Israël bestraft deze vorm van verzet steeds zwaarder. Palestijnse stenengooiers lopen het risico dat ze tot twintig jaar in de gevangenis belanden. Tito is inmiddels 32. Vrienden vragen hem wanneer hij eens ophoudt, en een gezinnetje sticht. Maar het verzet zit hem in het bloed, zegt hij. Hij moet strijden voor zijn land. Hij kan niet anders."
	}];

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "depionier/";
	
	var title = "Holy Road - De Pionier";
	var description = "De Joodse buitenpost Amona was gebouwd op het land van Palestijnse boeren. De Palestijnen stapten naar de rechter, en wonnen. Met dank aan een Joodse Israëliër.";
	var featuredImage = imageFolder + "depionier/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "depionier" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Iframe",
	    hideSpacer: true,
	    url: "https://player.vimeo.com/video/216161527"
	}, {
	    type: "Paragraph",
	    text: "Eli Greenberg woonde op een heuvel op de Westelijke Jordaanoever. Goed, misschien was het land waarop zijn huis stond wettelijk in het bezit van een Palestijn, maar wie maalt daarom? Het belangrijkste is, vindt Greenberg, dat dit gebied drieduizend jaar geleden door God aan de Joden is beloofd. Geen wet die dat kan veranderen."
	}, {
	    type: "Paragraph",
	    text: "Volgens het internationaal recht houdt Israël de Westelijke Jordaanoever bezet. Maar een groeiend aantal Joodse kolonisten trekt zich hier helemaal niks van aan. Zij luisteren niet naar de wetgever, maar alleen naar God. Een deel van hen keert om die reden zelfs de Israëlische staat de rug toe. Israël, vinden zij, zou een theocratie moeten worden, met de Thora als grondwet."
	}, {
	    type: "Paragraph",
	    text: "De Palestijnen van de Westelijke Jordaanoever beschouwen zichzelf als de inheemse bewoners van dit land die bedreigd worden door uitheemse Joodse kolonisten die hun het leven zuur maken. Op hun beurt beweren de kolonisten: wij zijn de echte inheemsen, wij zaten hier duizenden jaren geleden al."
	}, {
	    type: "Paragraph",
	    text: "Seculiere Israëliërs moeten niets hebben van hun fanatieke landgenoten. Toch moeten zij met lede ogen aanzien hoe de extremisten meer en meer invloed krijgen op het Israëlische regeringsbeleid. Wel hebben linkse activisten wat succesjes geboekt bij het Israëlische hooggerechtshof. Hierdoor raakte kolonist Greenberg bijvoorbeeld zijn land kwijt."
	}, {
	    type: "Paragraph",
	    text: "De toekomst van de vredesbeweging ziet er donker uit. De hele Israëlische politiek schuift naar rechts op, en met hen ook hun electoraat. Het is gemeengoed geworden in Israël om te beweren dat 'alle Arabieren terroristen' zijn, of dat ze worden geboren om Joden te haten. De vredesactivisten worden zélf flink gedemoniseerd in de Israëlische samenleving."
	}];

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "devrienden/";
	
	var title = "Holy Road - De Vrienden";
	var description = "Dit verhaal, een reportage waar we trots op waren, staat er niet meer. De reden hiervoor is vrij onaangenaam: de jongens trekken hun medewerking in, uit angst voor bedreigingen.";
	var featuredImage = imageFolder + "devrienden/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "devrienden" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "djv201703101027.jpg",
	        tablet: imageFolder + "djv201703101027.jpg",
	        desktop: imageFolder + "djv201703101027.jpg",
	        alt: "",
	        text: "Het Jenin-vluchtelingenkamp in 2017."
	    }
	}, {
	    type: "Paragraph",
	    text: "Hier stond een verhaal over hoop. Een onvervalst feelgoodverhaal, over Palestijnse jongens die groot werden in een oorlogssituatie en desondanks goed terecht waren gekomen. Het waren de vijf jongens van het Jenin-vluchtelingenkamp, vastgelegd door fotograaf Dirk-Jan Visser op het hoogtepunt van de Tweede Intifada en opnieuw bezocht in 2017. De ‘toen-en-nu’-foto’s van het vijftal ontlokten de nodige emoties bij iedereen die ze bekeek."
	}, {
	    type: "Paragraph",
	    text: "The Holy Road beoogt een inkijkje te bieden in het dagelijks leven op de Westelijke Jordaanoever, zowel voor Palestijnen als voor Joodse kolonisten. Wat je ook van hun politieke opvattingen vindt, ook de kolonisten ervaren in hun levens menselijke tragedies waar wij verslag van wilden doen. Zie het verhaal over de dertienjarige Hallel Yaffe Ariel, die in haar eigen slaapkamer doodgestoken werd door een Palestijnse jongen."
	}, {
	    type: "Paragraph",
	    text: "Naar ons idee zijn we tegenover iedereen duidelijk geweest over onze bedoelingen met The Holy Road. Niettemin bleek begin 2018, toen de Engelse vertaling van de documentaire verscheen, dat onze contactpersoon voor het vluchtelingenkamp in Jenin hevig geschrokken was van het gegeven dat er ook Joodse kolonisten in figureren. Dit naakte feit is voor sommige Palestijnen onacceptabel; het ‘samenwerken’ met de bezetter in één productie zou bijdragen aan ‘normalisatie’ van de bezetting. Deze groep is van mening dat de al meer dan vijftig jaar durende militaire onderdrukking van Palestijnen op de Westelijke Jordaanoever allesbehalve normaal is, en dat er in geen geval gedaan mag worden alsof dit wel het geval is."
	}, {
	    type: "Paragraph",
	    text: "De contactpersoon bracht de documentaire nog eens bij de jongens onder de aandacht en gezamenlijk eisten ze dat we hun verhaal eruit zouden schrappen. Hun argumenten: zowel de contactpersoon als de jongens kunnen gezien worden als verraders of collaborateurs, omdat ze met hun deelname aan onze documentaire de bezetting zouden normaliseren."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "161223000063660057.jpg",
	        tablet: imageFolder + "161223000063660057.jpg",
	        desktop: imageFolder + "161223000063660057.jpg",
	        alt: "",
	        text: "Het Jenin-vluchtelingenkamp in 2002."
	    }
	}, {
	    type: "Paragraph",
	    text: "Journalistiek gezien zijn dit voor ons geen valide argumenten. Wij hebben geen pro-Palestijnse of anti-Israëlische propagandafilm gemaakt; wij laten simpelweg de realiteit zien voor beide bevolkingsgroepen. Waar we wel gevoelig voor zijn, is het argument dat de jongens bedreigd zouden kunnen worden. Daarom besluiten we tot dit nieuwe verhaal, om de lastige vragen te onderzoeken rondom normalisatie, de boycotbeweging tegen Israël en interne Palestijnse druk op mensen om zich aan deze normen te conformeren. Het is bepaald geen geïsoleerd incident dat de jongens groepsdruk ervaren om niet aan normalisatie mee te werken; zo schrapt de gemeente Ramallah de vertoning van de voor een Oscar genomineerde, Libanese film The Insult met als argument dat regisseur Ziad Doueiri voor de opnames van een eerdere film enkele weken in Tel Aviv geweest is."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow1/01Jenin.jpg",
	        tablet: imageFolder + "slideshow1/01Jenin.jpg",
	        desktop: imageFolder + "slideshow1/01Jenin.jpg",
	        alt: "",
	        text: "Het Jenin-vluchtelingenkamp, een paar dagen na operatie ‘Beschermend Schild’."
	    }, {
	        mobile: imageFolder + "slideshow1/02Jenin.jpg",
	        tablet: imageFolder + "slideshow1/02Jenin.jpg",
	        desktop: imageFolder + "slideshow1/02Jenin.jpg",
	        alt: "",
	        text: "Overal zitten mensen reddeloos op de puinhopen van hun huis."
	    }, {
	        mobile: imageFolder + "slideshow1/03Jenin.jpg",
	        tablet: imageFolder + "slideshow1/03Jenin.jpg",
	        desktop: imageFolder + "slideshow1/03Jenin.jpg",
	        alt: "",
	        text: "In een cirkel rond het platgewalste deel van het kamp zijn alle huizen zwaar beschadigd."
	    }, {
	        mobile: imageFolder + "slideshow1/04Jenin.jpg",
	        tablet: imageFolder + "slideshow1/04Jenin.jpg",
	        desktop: imageFolder + "slideshow1/04Jenin.jpg",
	        alt: "",
	        text: "Hulporganisaties hebben water en voedsel voor de getroffenen gebracht."
	    }, {
	        mobile: imageFolder + "slideshow1/05Jenin.jpg",
	        tablet: imageFolder + "slideshow1/05Jenin.jpg",
	        desktop: imageFolder + "slideshow1/05Jenin.jpg",
	        alt: "",
	        text: "Een oude man zit in gedachten verzonken bij zijn vernielde huis."
	    }, {
	        mobile: imageFolder + "slideshow1/06Jenin.jpg",
	        tablet: imageFolder + "slideshow1/06Jenin.jpg",
	        desktop: imageFolder + "slideshow1/06Jenin.jpg",
	        alt: "",
	        text: "Hele families brengen de dagen door op de ruïnes van hun huizen."
	    }, {
	        mobile: imageFolder + "slideshow1/07Jenin.jpg",
	        tablet: imageFolder + "slideshow1/07Jenin.jpg",
	        desktop: imageFolder + "slideshow1/07Jenin.jpg",
	        alt: "",
	        text: "Een jongen klimt op het dak van zijn beschadigde huis."
	    }, {
	        mobile: imageFolder + "slideshow1/08Jenin.jpg",
	        tablet: imageFolder + "slideshow1/08Jenin.jpg",
	        desktop: imageFolder + "slideshow1/08Jenin.jpg",
	        alt: "",
	        text: "Oude vrouwen overzien de komst van journalisten en hulpverleners naar het vernielde Jenin-vluchtelingenkamp."
	    }]
	}, {
	    type: "Paragraph",
	    text: "De oproep tot een culturele boycot van Israël is onderdeel van de BDS-beweging, waarbij de afkorting staat voor ‘boycot, desinvesteren en sancties’. Deze beweging werd in 2004 opgericht door Palestijnse activisten. In de decennia daarvoor hadden twee bloedige intifada’s het leven gekost aan duizenden mensen, zonder dat de Palestijnen er in politieke zin iets mee opschoten. Tijd voor geweldloos verzet, vonden ze. Hiermee hopen ze een einde te maken aan de Israëlische bezetting en aan de discriminatie van Palestijnen. Bovendien willen ze dat Israël het recht op terugkeer van Palestijnse vluchtelingen erkent. De tactieken van de activisten weerspiegelen de boycot van het Zuid-Afrikaanse apartheidsregime. Daar heeft de boycot eraan bijgedragen om het regime tot een einde te brengen. Diverse internationale notabelen hebben zich achter de BDS-beweging geschaard. Bekend zijn onder anderen de in maart 2018 overleden wetenschapper Stephen Hawking, schrijver Naomi Klein en de Zuid-Afrikaanse aartsbisschop Desmond Tutu."
	}, {
	    type: "Paragraph",
	    text: "Er zijn uiteenlopende ideeën binnen de beweging over wie en wat er precies geboycot moeten worden. Sommigen zeggen: we zijn tegen de bezetting, dus we kopen geen producten die gemaakt zijn in illegale Joodse nederzettingen op de Westelijke Jordaanoever. Anderen kopen helemaal geen Israëlische producten meer: om de bezetting te beëindigen, vinden zij, moet de druk op héél Israël worden opgevoerd. Deze tweede groep wil bijvoorbeeld ook de Israëlische universiteiten boycotten. Nee, zeggen anderen weer: de Israëlische academici vormen juist een groep mensen die we hard nodig hebben voor het verzet van binnenuit."
	}, {
	    type: "Paragraph",
	    text: "De bekendste acties van BDS-activisten zijn het verstoren van optredens en de oproepen aan artiesten om niet in Israël op te treden. Zolang de militaire bezetting van Palestijns gebied voortduurt, vinden zij, zouden artiesten Israël moeten mijden. Het gaat om niet de minste namen: van Radiohead tot Britney Spears. Af en toe boeken de activisten succes, zoals in 2017, wanneer de Nieuw-Zeelandse zangeres Lorde besluit om haar geplande optreden in Tel Aviv af te zeggen. Iedere artiest die de Palestijnse druk negeert, wordt – onder de hashtag #BDSFail – dan weer luidkeels bejubeld door pro-Israëlische activisten op de sociale media. Optreden in Israël is een statement geworden."
	}, {
	    type: "Paragraph",
	    text: "Een beproefde BDS-methode is ook om bedrijven en overheden die zich inlaten met illegale nederzettingen onder druk te zetten. Ook Nederlandse bedrijven zijn hier gevoelig voor. Zo besloot pensioenfonds PGGM in 2014 om niet meer te beleggen in vijf Israëlische banken die de bouw van Joodse nederzettingen financieren, en verbrak waterbedrijf Vitens een jaar eerder de samenwerking met een Israëlische firma die de nederzettingen van water voorziet."
	}, {
	    type: "Paragraph",
	    text: "De economische schade van de BDS-beweging valt mee. Begin 2015 concludeert een rapport van de Knesset, het Israëlische parlement, dat de export naar Europa sinds 2005 juist is verdubbeld, van jaarlijks 7 naar 14 miljard euro. Zelfs als Europa alle producten uit nederzettingen zou boycotten, zou dit Israël jaarlijks hooguit 90 miljoen euro kosten. Toch gaan de politici en de kranten in Israël, behalve de meest linkse, fel tegen BDS tekeer. Premier Netanyahu noemt de beweging ‘antisemitisch’, en oppositieleider Herzog vergelijkt een boycot zelfs met ‘een nieuwe intifada’."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow4/ToenEnNu01.jpg",
	        tablet: imageFolder + "slideshow4/ToenEnNu01.jpg",
	        desktop: imageFolder + "slideshow4/ToenEnNu01.jpg",
	        alt: "",
	        text: "Toen in 2002 en nu in 2017."
	    }, {
	        mobile: imageFolder + "slideshow4/ToenEnNu02.jpg",
	        tablet: imageFolder + "slideshow4/ToenEnNu02.jpg",
	        desktop: imageFolder + "slideshow4/ToenEnNu02.jpg",
	        alt: "",
	        text: "Toen in 2002 en nu in 2017."
	    }, {
	        mobile: imageFolder + "slideshow4/ToenEnNu03.jpg",
	        tablet: imageFolder + "slideshow4/ToenEnNu03.jpg",
	        desktop: imageFolder + "slideshow4/ToenEnNu03.jpg",
	        alt: "",
	        text: "Toen in 2002 en nu in 2017."
	    }, {
	        mobile: imageFolder + "slideshow4/ToenEnNu04.jpg",
	        tablet: imageFolder + "slideshow4/ToenEnNu04.jpg",
	        desktop: imageFolder + "slideshow4/ToenEnNu04.jpg",
	        alt: "",
	        text: "Toen in 2002 en nu in 2017."
	    }, {
	        mobile: imageFolder + "slideshow4/ToenEnNu05.jpg",
	        tablet: imageFolder + "slideshow4/ToenEnNu05.jpg",
	        desktop: imageFolder + "slideshow4/ToenEnNu05.jpg",
	        alt: "",
	        text: "Toen in 2002 en nu in 2017."
	    }]
	}, {
	    type: "Paragraph",
	    text: "Deze grote woorden komen deels voort uit Israëls vrees voor aantasting van zijn positie. Ook al keert het grootste deel van de internationale gemeenschap zich tegen de al decennia durende bezetting, tot nu toe komt Israël er aardig mee weg. Zelfs tegen het voortdurend uitbreiden van Joodse nederzettingen op de Westelijke Jordaanoever treedt de internationale gemeenschap nauwelijks op. Maar als de BDS-beweging erin zou slagen om de illegaliteit van de bezetting in de hoofden en harten van het westerse publiek te planten, heeft Israël een probleem. Een ander argument om hard tegen de BDS-beweging op te treden, is de binnenlandse politiek: Israëlische kiezers stemmen op politici die laten zien dat ze zich tot het uiterste inspannen om voor hun land op te komen."
	}, {
	    type: "Paragraph",
	    text: "Israël spendeert veel geld – in 2016 is het 30 miljoen euro – om internationaal tegen BDS te lobbyen. In december 2017 maakte de Israëlische regering bekend dat er nog eens 62,5 miljoen euro uitgetrokken wordt om BDS tegen te gaan, onder meer door druk op artiesten te pareren, publieke campagnes, het uitnodigen van opiniemakers voor ‘solidariteitsbezoekjes’ aan Israël, grotere zichtbaarheid en meer coördinatie tussen pro-Israëlische groeperingen wereldwijd. De nieuwe miljoenen worden gezamenlijk opgebracht door Israël en enkele Joodse weldoeners. En hun  lobbywerk lukt aardig. Zo heeft de Britse regering bepaald dat overheidsinstanties – zoals gemeenten en zorginstellingen – niet langer mogen oproepen tot een boycot van Israël. Ook in Frankrijk, Canada en de Verenigde Staten boekt de anti-BDS-lobby successen."
	}, {
	    type: "Paragraph",
	    text: "Volgens Fred Grünfeld, gepensioneerd hoofddocent internationale betrekkingen aan de Universiteit Maastricht en emeritus hoogleraar oorzaken van mensenrechtenschendingen aan de Universiteit Utrecht, is het uitzonderlijk dat landen zo actief zijn in het bestrijden van een boycotbeweging tegen een ander land. Eén voorbeeld kan hij zich herinneren: in de jaren zeventig werden er in de VS twee wetten aangenomen die de boycot van Israël door de Arabische Liga moesten tegengaan. De felheid van de anti-BDS-beweging in deze westerse landen, zegt Grünfeld, kan te maken hebben met de vrees dat boycots van Israël kunnen bijdragen aan antisemitisme. Zo wijst hij op Frankrijk, waar de afgelopen jaren enkele antisemitische incidenten hebben plaatsgehad. Het land treedt relatief streng op tegen mensen en organisaties die een Israël-boycot bepleiten."
	}, {
	    type: "Paragraph",
	    text: "Israël kan de steun van westerse bondgenoten goed gebruiken. Maar kritiek is er ook. Zo bestempelt de Britse Labour-partij het wettelijk tegengaan van BDS als een ‘aanval op de democratie’. Want valt het niet, zo redeneert de partij, onder de vrijheid van meningsuiting om op te roepen tot een boycot van een land dat een ander volk onderdrukt? Amnesty International vindt dat het overheidsinstanties vrij moet staan om ethisch verantwoord te investeren – en dat ze dus ook de keuze moeten hebben om hun reserves níét in Israël aan te wenden. Roger Waters, frontman van Pink Floyd en een voornaam BDS-activist, noemt het op Radio Canada ‘gevaarlijk’ dat de Verenigde Staten en Canada ‘een niet-gewelddadige vorm van protest tegen een buitenlandse mogendheid’ strafbaar stellen. ‘Ik vind het een zeer verontrustende gedachte dat er van een gewone mensenrechtenorganisatie waar ik onderdeel van ben een illegale organisatie gemaakt kan worden, en dat ik opgesloten kan worden voor mijn aandeel erin.’"
	}, {
	    type: "Paragraph",
	    text: "Paradoxaal genoeg vaart de BDS-beweging wel bij Israëlisch verzet. Zelf incasseren de initiatiefnemers van de beweging niets liever dan een stevige aanval van premier Netanyahu: aandacht gegarandeerd. Evenmin was de beweging ongelukkig met een conferentie die in Israël gehouden werd om BDS te bestrijden, georganiseerd door de brede publiekskrant Yedioth Ahronoth (‘Laatste Nieuws’) en bijgewoond door tal van politici, van links tot rechts. Hoogtepunt was een optreden van de Joods-Amerikaanse comédienne Roseanne Barr, die de BDS-beweging ‘fascistisch’ noemde."
	}, {
	    type: "Paragraph",
	    text: "Niet voor niets waarschuwt president Jay Sanderson van de Jewish Federation of Greater Los Angeles dat Israël terughoudender moet zijn met het bestrijden van BDS. Hoe meer geld er naar het bestrijden van BDS gaat, zei Sanderson tegen de krant Haaretz (‘Het Land’), ‘en hoe meer mensen dit het grootste onderwerp aller tijden maken, hoe meer we de andere kant van brandstof voorzien’."
	}, {
	    type: "Paragraph",
	    text: "Voor succes van de BDS-beweging is het volgens de Nederlandse hoogleraar Grünfeld van belang om Israël daar te raken waar het land het internationaal recht schendt: de illegale nederzettingen op de Westelijke Jordaanoever. ‘Je moet dus op zoek naar maatregelen die specifiek de kolonisten treffen. Als je heel Israël raakt, versterk je alleen maar de nationalistische tegenbeweging. En je kweekt er geen sympathie mee.’"
	}, {
	    type: "Paragraph",
	    text: "Met deze boodschap hoeft Grünfeld niet bij de Palestijnse hardliners aan te komen. Binnen Palestina spreekt het bijna vanzelf om een boycot aan te hangen van alles wat Israëlisch is. De BDS-beweging is er zo dominant dat elke afwijking van de norm, reëel of imaginair, tot intimidatie en bedreigingen kan leiden."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow5/01djv201703101044.jpg",
	        tablet: imageFolder + "slideshow5/01djv201703101044.jpg",
	        desktop: imageFolder + "slideshow5/01djv201703101044.jpg",
	        alt: "",
	        text: "Het nieuwbouwgedeelte van het Jenin-vluchtelingenkamp, dat gebouwd is na 2002."
	    }, {
	        mobile: imageFolder + "slideshow5/02djv201703101083.jpg",
	        tablet: imageFolder + "slideshow5/02djv201703101083.jpg",
	        desktop: imageFolder + "slideshow5/02djv201703101083.jpg",
	        alt: "",
	        text: "Op de nieuwe huizen is overal al graffiti gespoten, die verwijst naar martelaren en hun brigades."
	    }, {
	        mobile: imageFolder + "slideshow5/03djv201703101136.jpg",
	        tablet: imageFolder + "slideshow5/03djv201703101136.jpg",
	        desktop: imageFolder + "slideshow5/03djv201703101136.jpg",
	        alt: "",
	        text: "Straatbeeld van het nieuwbouwgedeelte van het Jenin-vluchtelingenkamp."
	    }, {
	        mobile: imageFolder + "slideshow5/04djv201703101194.jpg",
	        tablet: imageFolder + "slideshow5/04djv201703101194.jpg",
	        desktop: imageFolder + "slideshow5/04djv201703101194.jpg",
	        alt: "",
	        text: "Martelarenposters van Fatah, Hamas en de Islamitische Jihad. In het zwart staat geschreven: 'Brigade Mohammed Asama'."
	    }, {
	        mobile: imageFolder + "slideshow5/05djv201703100986.jpg",
	        tablet: imageFolder + "slideshow5/05djv201703100986.jpg",
	        desktop: imageFolder + "slideshow5/05djv201703100986.jpg",
	        alt: "",
	        text: "Het Jenin-vluchtelingenkamp in 2017."
	    }, {
	        mobile: imageFolder + "slideshow5/06djv201703101007.jpg",
	        tablet: imageFolder + "slideshow5/06djv201703101007.jpg",
	        desktop: imageFolder + "slideshow5/06djv201703101007.jpg",
	        alt: "",
	        text: "De herdenkingssteen voor Ahmad Hassen, die als martelaar is omgekomen."
	    }, {
	        mobile: imageFolder + "slideshow5/07djv201703101227.jpg",
	        tablet: imageFolder + "slideshow5/07djv201703101227.jpg",
	        desktop: imageFolder + "slideshow5/07djv201703101227.jpg",
	        alt: "",
	        text: "Straatbeeld van het nieuwbouwgedeelte van het Jenin-vluchtelingenkamp. "
	    }, {
	        mobile: imageFolder + "slideshow5/08djv201703100999.jpg",
	        tablet: imageFolder + "slideshow5/08djv201703100999.jpg",
	        desktop: imageFolder + "slideshow5/08djv201703100999.jpg",
	        alt: "",
	        text: "Muur waarop staat dat alle gevangenen helden zijn, aangevuld met namen."
	    }, {
	        mobile: imageFolder + "slideshow5/09djv201703101055.jpg",
	        tablet: imageFolder + "slideshow5/09djv201703101055.jpg",
	        desktop: imageFolder + "slideshow5/09djv201703101055.jpg",
	        alt: "",
	        text: "Straatbeeld in het nieuwbouwgedeelte van het Jenin-vluchtelingenkamp. 'Mogen de martelaren voor altijd in de hemel zijn',  staat er links op de muur geschreven."
	    }, {
	        mobile: imageFolder + "slideshow5/10djv201703101049.jpg",
	        tablet: imageFolder + "slideshow5/10djv201703101049.jpg",
	        desktop: imageFolder + "slideshow5/10djv201703101049.jpg",
	        alt: "",
	        text: "Muurschildering met een sleutel en de zee, wat het verlangen naar terugkeer van de vluchtelingen in Jenin naar het huidige Israël symboliseert. Op de posters worden martelaren herdacht en mensen gefeliciteerd die zijn vrijgekomen uit Israëlische gevangenschap."
	    }]
	}, {
	    type: "Paragraph",
	    text: "Is het echt zo dat de jongens in Jenin aan normalisatie hebben gedaan door mee te werken aan een journalistieke productie waarin ook Joodse kolonisten figureren? Je zou ook kunnen beweren dat de door hen ervaren intimidatie de persvrijheid in Palestina bedreigt. Nu is het daarmee toch al niet zo best gesteld: op de ranglijst van landen met de hoogste persvrijheid, opgesteld door de ngo Verslaggevers Zonder Grenzen, staat Palestina 135ste, vlak achter Algerije. Vrije toegang tot informatie is voor Palestijnse verslaggevers niet gegarandeerd. Vooral Fatah-aanhangers in de Gazastrook en Hamas-fans op de Westelijke Jordaanoever staan geregeld onder druk of worden zelfs mishandeld."
	}, {
	    type: "Paragraph",
	    text: "Israël doet het net iets beter: dat land staat gedeeld 91ste, samen met Nicaragua. De ngo wijst onder meer op militaire censuur en aanvallen door Israëlische ordetroepen op Palestijnse en buitenlandse journalisten, vooral tijdens demonstraties."
	}, {
	    type: "Paragraph",
	    text: "Als makers van de documentaire hebben we zelf meer te lijden gehad van de Israëliërs: verslaggever Derk Walters kreeg in 2017 geen nieuwe perskaart plus de daaraan gekoppelde verblijfsvergunning meer, waardoor hij gedwongen was om zijn verblijf in de regio te beëindigen. Dat we begin 2018 wegens Palestijnse druk gedwongen zijn om een verhaal uit The Holy Road te schrappen, komt als een even late als onaangename verrassing."
	}];

/***/ },
/* 255 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * Positions of Annotations are defined in Annotations.scss
	 */
	exports.default = [{
	    type: "annotation",
	    position: "center-top",
	    time: 83,
	    showTime: 3,
	    title: "Observatietoren"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 117,
	    showTime: 3,
	    title: "Checkpoint"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 146,
	    showTime: 4,
	    title: "Meitar checkpoint, begin van de Westelijke Jordaanoever"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 163,
	    showTime: 3,
	    title: "Observatietoren"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 171,
	    showTime: 4,
	    title: "Begin van de bezette Westelijke Jordaanoever / gebied C"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 177,
	    showTime: 3,
	    title: "Afscheidingsmuur"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 188,
	    showTime: 3,
	    title: "Groene Lijn"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 211,
	    showTime: 4,
	    title: "Militaire weg langs afscheidingsmuur"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 224,
	    showTime: 2,
	    title: "Afslag naar de nederzetting Carmel"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 235,
	    showTime: 3,
	    title: "Militaire kilometermarkering aan beide kanten van de weg"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 252,
	    showTime: 4,
	    title: "Nederzetting Shim’a"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 266,
	    showTime: 16,
	    title: "De buitenpost Mitzpe Eshtamoa "
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 294,
	    showTime: 12,
	    title: "Earthmound"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 380,
	    showTime: 18,
	    title: "Nederzetting Otniel"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 404,
	    showTime: 2,
	    title: "Kolonist met wapen"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 409,
	    showTime: 3,
	    title: "Wegblokkade, ingang naar gebied A "
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 418,
	    showTime: 10,
	    title: "Wegblokkade, ingang naar gebied A"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 434,
	    showTime: 10,
	    title: "Legerbasis"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 459,
	    showTime: 5,
	    title: "Ingang naar gebied A bij het Palestijnse dorp Al Hijra"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 469,
	    showTime: 3,
	    title: "Earthmound"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 483,
	    showTime: 3,
	    title: "Al Fawwar checkpoint"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 487,
	    showTime: 3,
	    title: "Ribbels tegen explosieven en snelheid"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 493,
	    showTime: 2,
	    title: "Observatietoren"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 501,
	    showTime: 5,
	    title: "Al Fawwar vluchtelingenkamp"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 509,
	    showTime: 2,
	    title: "Ingang naar gebied A"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 513,
	    showTime: 2,
	    title: "Militaire controle bij tijdelijk checkpoint"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 518,
	    showTime: 6,
	    title: "Al Fawwar vluchtelingenkamp"
	}, {
	    type: "annotation",
	    position: "bottom-left",
	    time: 535,
	    showTime: 2,
	    title: "Legerjeep"
	}, {
	    type: "annotation",
	    position: "bottom-left",
	    time: 539,
	    showTime: 4,
	    title: "Hier rechtdoor gaat de voormalige route 60 Hebron in"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 546,
	    showTime: 3,
	    title: "Nederzetting Haggai"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 551,
	    showTime: 2,
	    title: "Observatietoren"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 554,
	    showTime: 2,
	    title: "Israëlische politie"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 573,
	    showTime: 3,
	    title: "Ingang naar gebied A met wegversperring"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 579,
	    showTime: 4,
	    title: "Militaire basis"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 585,
	    showTime: 2,
	    title: "Hebron"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 589,
	    showTime: 3,
	    title: "Observatietoren"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 596,
	    showTime: 2,
	    title: "Ingang naar gebied A met checkpoint"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 602,
	    showTime: 4,
	    title: "Legerbasis"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 609,
	    showTime: 3,
	    title: "Afslag Grot van de Patriarchen"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 613,
	    showTime: 3,
	    title: "Ingang naar gebied A, open wegafsluiting"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 632,
	    showTime: 5,
	    title: "Afslag naar nederzetting Kiryat Arba"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 638,
	    showTime: 20,
	    title: "Nederzetting Kiryat Arba"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 669,
	    showTime: 3,
	    title: "Legerjeep"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 675,
	    showTime: 3,
	    title: "Afslag naar de Palestijnse dorpen Sa’ir en Beit Einun"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 680,
	    showTime: 5,
	    title: " Ras al Joura checkpoint "
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 686,
	    showTime: 2,
	    title: "Ingang naar gebied A"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 692,
	    showTime: 3,
	    title: "Observatietoren"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 699,
	    showTime: 4,
	    title: "Hek ter bescherming van stenengooiers"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 714,
	    showTime: 3,
	    title: "Open wegafsluiting naar Al Arrub vluchtelingenkamp"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 720,
	    showTime: 3,
	    title: "Israëlische pantserwagens met observatietoren"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 725,
	    showTime: 3,
	    title: "Lichte pantserwagens met soldaten"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 759,
	    showTime: 4,
	    title: "Rami Levy supermarkt"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 797,
	    showTime: 4,
	    title: "Gush Etzion checkpoint"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 803,
	    showTime: 5,
	    title: "Beveiligde bushalte"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 822,
	    showTime: 3,
	    title: "Soldaten controleren een Palestijnse auto"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 826,
	    showTime: 2,
	    title: "Militaire toren"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 831,
	    showTime: 2,
	    title: "Soldaten"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 837,
	    showTime: 4,
	    title: "Nederzetting Efrat"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 848,
	    showTime: 4,
	    title: "Bethlehem"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 854,
	    showTime: 4,
	    title: "Afslag naar de voormalige route 60 door Bethlehem"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 867,
	    showTime: 3,
	    title: "Open wegafsluiting met ingang naar gebied A"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 872,
	    showTime: 3,
	    title: "De voormalige route 60 door Bethlehem"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 880,
	    showTime: 6,
	    title: "Afscheidingsmuur"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 890,
	    showTime: 4,
	    title: "Hierachter liggen de Palestijnse plaatsen Al Khadr en Bethlehem"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 896,
	    showTime: 2,
	    title: "Wegversperring"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 902,
	    showTime: 3,
	    title: "Observatietoren"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 910,
	    showTime: 2,
	    title: "Militaire pantserwagen"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 916,
	    showTime: 3,
	    title: "Afscheidingsmuur"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 922,
	    showTime: 3,
	    title: "Soldaten"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 928,
	    showTime: 3,
	    title: "Tunnel checkpoint"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 931,
	    showTime: 2,
	    title: "Ribbels in de weg tegen snelheid en explosieven"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 937,
	    showTime: 6,
	    title: "Vanaf hier mogen auto’s met Palestijnse kentekens niet verder over route 60"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 976,
	    showTime: 5,
	    title: "Tunnels onder het Palestijnse dorp Beit Jala"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 982,
	    showTime: 2,
	    title: "Afscheidingsmuur aan beide kanten van de weg"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 987,
	    showTime: 2,
	    title: "De nederzetting Gilo"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 991,
	    showTime: 2,
	    title: "Jeruzalem"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1012,
	    showTime: 4,
	    title: "Dit is weer de voormalige route 60 richting Bethlehem"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1030,
	    showTime: 4,
	    title: "Afscheidingsmuur met daarachter Bethlehem"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1038,
	    showTime: 3,
	    title: "Ingang naar het graf van Rachel"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1051,
	    showTime: 5,
	    title: "Begin van de gemeentegrens van Jeruzalem, volgens Israël"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1138,
	    showTime: 3,
	    title: "Groene Lijn"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1158,
	    showTime: 4,
	    title: "De Dormitio-abdij, de plek waar Maria is overleden"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1165,
	    showTime: 5,
	    title: "Hier achter de berg staat de Klaagmuur en de Al Aqsa Moskee"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1176,
	    showTime: 4,
	    title: "De muur rond de oude stad, gebouwd door de Ottomanen"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1182,
	    showTime: 3,
	    title: "Toren van David"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1208,
	    showTime: 5,
	    title: "De Rotskoepel"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1223,
	    showTime: 12,
	    title: "De poort naar Damascus"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1254,
	    showTime: 6,
	    title: "De Groene Lijn"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1277,
	    showTime: 2,
	    title: "De Groene Lijn"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1280,
	    showTime: 2,
	    title: "Oost-Jeruzalem"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1283,
	    showTime: 2,
	    title: "West-Jeruzalem"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1315,
	    showTime: 4,
	    title: "Joodse wijk French Hill"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1325,
	    showTime: 2,
	    title: "Shuafat vluchtelingenkamp"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 1333,
	    showTime: 3,
	    title: "De Palestijnse wijk Beit Hanina"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1348,
	    showTime: 5,
	    title: "Kolonistenbus"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1376,
	    showTime: 2,
	    title: "De nederzetting Pisgat Ze’ev"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1381,
	    showTime: 5,
	    title: "Al Ram"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1392,
	    showTime: 6,
	    title: "Afscheidingsmuur met daarachter het Palestijnse dorp Al Ram"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1423,
	    showTime: 4,
	    title: "Qalandia checkpoint"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1431,
	    showTime: 4,
	    title: "Route 60 gaat gebied A in"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1438,
	    showTime: 6,
	    title: "Het is verboden voor Israëlische staatsburgers om verder te gaan"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1469,
	    showTime: 4,
	    title: "Auto’s en mensen onderweg naar Jeruzalem worden gecontroleerd"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1479,
	    showTime: 3,
	    title: "Afscheidingsmuur"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1511,
	    showTime: 3,
	    title: "Al Ram"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1516,
	    showTime: 6,
	    title: "Waarschuwing van routeplanner Waze voor ‘gevaarlijk’ gebied"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1535,
	    showTime: 3,
	    title: "Al Ram"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1604,
	    showTime: 3,
	    title: "Jaba checkpoint"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1608,
	    showTime: 2,
	    title: "Observatietoren"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1612,
	    showTime: 4,
	    title: "Ribbels in de weg tegen snelheid en explosieven"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1620,
	    showTime: 4,
	    title: "Nederzetting Psagot"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1633,
	    showTime: 5,
	    title: "Het Palestijnse dorp Burqa"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 1650,
	    showTime: 2,
	    title: "Burqa"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1680,
	    showTime: 3,
	    title: "Observatietoren"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1693,
	    showTime: 5,
	    title: "Nederzetting Ofra"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1698,
	    showTime: 5,
	    title: "Buitenpost Amona"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1706,
	    showTime: 3,
	    title: "Hek rond nederzetting Ofra"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1725,
	    showTime: 5,
	    title: "Toegangshek tot nederzetting Ofra"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1736,
	    showTime: 3,
	    title: "Bushalte beveiligd door soldaten"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1741,
	    showTime: 2,
	    title: "Observatietoren"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1747,
	    showTime: 4,
	    title: "Militaire basis"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1757,
	    showTime: 4,
	    title: "Nederzetting Shilo"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1761,
	    showTime: 4,
	    title: "Nederzetting Shilo"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1775,
	    showTime: 3,
	    title: "Kolonistenbus met daarachter een Palestijnse taxibus"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1786,
	    showTime: 4,
	    title: "Observatieballon met camera"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1792,
	    showTime: 2,
	    title: "Nederzetting Rechelim South"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1796,
	    showTime: 3,
	    title: "Tappuah checkpoint"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1803,
	    showTime: 3,
	    title: "Militaire toren"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1811,
	    showTime: 2,
	    title: "Militaire toren"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1818,
	    showTime: 2,
	    title: "Soldaten bij een bushalte"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1825,
	    showTime: 4,
	    title: "Het Palestijnse dorp Huwwara "
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1832,
	    showTime: 2,
	    title: "Rotonde gesponsord door USAID"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1853,
	    showTime: 2,
	    title: "Nederzetting Yitzhar"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1856,
	    showTime: 6,
	    title: "Militaire basis"
	}, {
	    type: "annotation",
	    position: "bottom-left",
	    time: 1889,
	    showTime: 2,
	    title: "Militaire kilometermarkering"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1897,
	    showTime: 3,
	    title: "Militaire wachttoren"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1907,
	    showTime: 3,
	    title: "Sarra-Jit checkpoint, ingang naar gebied A"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1912,
	    showTime: 2,
	    title: "Militaire wachttoren"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1916,
	    showTime: 2,
	    title: "Militaire patrouille"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1919,
	    showTime: 1,
	    title: "Militair pantservoertuig"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1929,
	    showTime: 4,
	    title: "Route 60 gaat verder in gebied A"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1935,
	    showTime: 4,
	    title: "Verboden toegang voor Israëlische staatsburgers"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1943,
	    showTime: 3,
	    title: "Het Palestijnse dorp Deir Sharaf"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1954,
	    showTime: 3,
	    title: "Nederzetting Shavei Shomron"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1958,
	    showTime: 3,
	    title: "Muur rond nederzetting Shavei Shomron"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1963,
	    showTime: 2,
	    title: "Shavei Shomron checkpoint"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1968,
	    showTime: 1,
	    title: "Militaire jeep"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1980,
	    showTime: 10,
	    title: "De Palestijnse stad Jenin"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 2018,
	    showTime: 4,
	    title: "Palestijnse agent"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 2033,
	    showTime: 5,
	    title: "Palestijnse veiligheidstroepen"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 2046,
	    showTime: 2,
	    title: "Palestijnse politie"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 2084,
	    showTime: 4,
	    title: "Onderweg naar de grens met Israël"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 2117,
	    showTime: 6,
	    title: "Al Jalama checkpoint"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 2130,
	    showTime: 12,
	    title: "De grens met Israël op de Groene Lijn"
	}];

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _story = __webpack_require__(248);
	
	var _story2 = _interopRequireDefault(_story);
	
	var _story3 = __webpack_require__(249);
	
	var _story4 = _interopRequireDefault(_story3);
	
	var _story5 = __webpack_require__(250);
	
	var _story6 = _interopRequireDefault(_story5);
	
	var _story7 = __webpack_require__(251);
	
	var _story8 = _interopRequireDefault(_story7);
	
	var _story9 = __webpack_require__(252);
	
	var _story10 = _interopRequireDefault(_story9);
	
	var _story11 = __webpack_require__(253);
	
	var _story12 = _interopRequireDefault(_story11);
	
	var _story13 = __webpack_require__(254);
	
	var _story14 = _interopRequireDefault(_story13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER;
	var storyUrl = '/nl' + _constants2.default.STORY_URL;
	
	exports.default = [{
	    type: "story",
	    time: 668,
	    title: "De Puber",
	    link: {
	        url: storyUrl + 'depuber',
	        label: "Bekijk verhaal"
	    },
	    location: {
	        name: "Gush Etzion"
	    },
	    readingTime: "Leestijd: 6 min",
	    excerpt: "Emuna is veertien. Ze had een dansvoorstelling, samen met haar vriendin Hallel. Vlak voor het optreden werd Hallel doodgestoken. In haar eigen slaapkamer.",
	    body: _story2.default,
	    image: {
	        mobile: imageFolder + 'depuber/omslag__mobile.jpg',
	        tablet: imageFolder + 'depuber/omslag.jpg',
	        desktop: imageFolder + 'depuber/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 797,
	    title: "De Kiloknaller",
	    link: {
	        url: storyUrl + 'dekiloknaller',
	        label: "Bekijk video"
	    },
	    location: {
	        name: "Gush Etzion"
	    },
	    readingTime: "Kijktijd: 6 min ",
	    excerpt: "Zowel kolonisten als Palestijnen kopen hun kip bij Rami Levy, de goedkoopste supermarkt in de omgeving. Maar de prijsvechter staat wel in een nederzetting. De Joden hier dragen wapens, de Palestijnen niet.",
	    body: _story4.default,
	    image: {
	        mobile: imageFolder + 'dekiloknaller/omslag__mobile.jpg',
	        tablet: imageFolder + 'dekiloknaller/omslag.jpg',
	        desktop: imageFolder + 'dekiloknaller/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 1039,
	    title: "De Heilige",
	    link: {
	        url: storyUrl + 'deheilige',
	        label: "Bekijk verhaal"
	    },
	    location: {
	        name: "Bethlehem"
	    },
	    readingTime: "Leestijd: 7 min",
	    excerpt: "Het graf van de oermoeder Rachel ligt in Bethlehem, maar je kunt er alleen vanuit Israël naartoe. Is dit bijbels hartland, of de essentie van koloniale logica?",
	    body: _story6.default,
	    image: {
	        mobile: imageFolder + 'deheilige/omslag__mobile.jpg',
	        tablet: imageFolder + 'deheilige/omslag.jpg',
	        desktop: imageFolder + 'deheilige/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 1243,
	    title: "De Standvastige",
	    link: {
	        url: storyUrl + 'destandvastige',
	        label: "Bekijk video"
	    },
	    location: {
	        name: "Jeruzalem"
	    },
	    readingTime: "Kijktijd 5 min",
	    excerpt: "De Palestijnse familie Sub Laban woont in de moslimwijk van de Oude Stad in Jeruzalem. Ooit woonden hier Joden. Daarom wordt hun huis onteigend.",
	    body: _story8.default,
	    image: {
	        mobile: imageFolder + 'destandvastige/omslag__mobile.jpg',
	        tablet: imageFolder + 'destandvastige/omslag.jpg',
	        desktop: imageFolder + 'destandvastige/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 1511,
	    title: "De Demonstrant",
	    link: {
	        url: storyUrl + 'dedemonstrant',
	        label: "Bekijk video"
	    },
	    location: {
	        name: "Ramallah"
	    },
	    readingTime: "Kijktijd: 8 min ",
	    excerpt: "Zijn strijd naam is Tito. Hij trekt er elke week op uit om tegen het Israëlische leger te demonstreren. Het is David tegen Goliath, zegt hij. Maar hij kan niet anders.",
	    body: _story10.default,
	    image: {
	        mobile: imageFolder + 'dedemonstrant/omslag__mobile.jpg',
	        tablet: imageFolder + 'dedemonstrant/omslag.jpg',
	        desktop: imageFolder + 'dedemonstrant/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 1733,
	    title: "De Pionier",
	    link: {
	        url: storyUrl + 'depionier',
	        label: "Bekijk video"
	    },
	    location: {
	        name: "Amona"
	    },
	    readingTime: "Kijktijd: 10 min",
	    excerpt: "De Joodse buitenpost Amona was gebouwd op het land van Palestijnse boeren. De Palestijnen stapten naar de rechter, en wonnen. Met dank aan een Joodse Israëliër.",
	    body: _story12.default,
	    image: {
	        mobile: imageFolder + 'depionier/omslag__mobile.jpg',
	        tablet: imageFolder + 'depionier/omslag.jpg',
	        desktop: imageFolder + 'depionier/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 2013,
	    title: "De Vrienden",
	    link: {
	        url: storyUrl + 'devrienden',
	        label: "Bekijk verhaal"
	    },
	    location: {
	        name: "Jenin"
	    },
	    readingTime: "Leestijd: 7 min",
	    excerpt: "Deze jongens waren rond de tien toen het Israëlische leger in 2002 hun vluchtelingenkamp deels verwoestte. Ze zijn nog steeds vrienden.",
	    body: _story14.default,
	    image: {
	        mobile: imageFolder + 'devrienden/omslag__mobile.jpg',
	        tablet: imageFolder + 'devrienden/omslag.jpg',
	        desktop: imageFolder + 'devrienden/omslag.jpg',
	        alt: ""
	    }
	}];

/***/ },
/* 257 */
[642, 255, 256],
/* 258 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    videoName: "The Holy Road",
	    videos: {
	        id: "VideoNL",
	        mobile: {
	            src: "https://output.scrollytelling.io/theholyroad/videos/the-holy-road_web.mp4",
	            type: "video/mp4"
	        },
	        desktop: {
	            src: "https://output.scrollytelling.io/theholyroad/videos/De_WegTOTAAL_AUDIO_8MEI_PICTURELOCK_CC_titelloos__AUDIO_1_kleur_(RES_1280_22).mp4",
	            type: "video/mp4"
	        },
	        dash: {
	            src: "https://output.scrollytelling.io/v1/main/pageflow/video_files/000/002/320/dash/manifest.mpd",
	            type: "application/dash+xml"
	        },
	        hls: {
	            src: "https://output.scrollytelling.io/v1/main/pageflow/video_files/000/002/320/hls-fullhd.m3u8",
	            type: "application/x-mpegURL"
	        }
	    },
	    introText: "The Holy Road is een interactieve webdocumentaire over de mensen die leven aan de ‘heiligste’, maar ook meest beladen weg door Israel en Palestina: Route 60.",
	    startRoute: "Start route",
	    rijVerder: "Rij verder",
	    terugNaarRoadMovie: "TERUG NAAR ROADMOVIE"
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "depuber/";
	
	var title = "Holy Road - The Teenager";
	var description = "Emuna is fourteen years old. She had a dance performance, together with her friend Hallel but just before the performance, Hallel was stabbed to death. In her very own bedroom.";
	var featuredImage = imageFolder + "depuber/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "depuber" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Paragraph",
	    text: "Hallel Yaffe Ariel had pink pillows on her bunk bed, just like every other thirteen-year-old girl. The released photo by the Israeli army shows a bed besmeared with blood. Her Palestinian murderer evidently must have stabbed her excessively before she died, as the pool of blood on the floor suggests. Three friends of Hallel tell us about their lives. What do their bedrooms look like? How has Hallel’s death influenced their lives? And how does it feel to grow up in a contentious settlement?"
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "00__mobile.jpg",
	        tablet: imageFolder + "00__tablet.jpg",
	        desktop: imageFolder + "00.jpg",
	        alt: "",
	        text: "The Ariel family has placed photos of Hallel and the rest of her family throughout the house"
	    }
	}, {
	    type: "Paragraph",
	    text: "Emuna danced with Hallel. Heichal was a good friend of Hallel, not a ‘best friend forever’, but still a friend. Noam had been in Hallel’s class for only two years, but still speaks a lot about her. Hallel Yaffe Ariel was thirteen years old. She lived with her parents and two little sisters in a house near the border of Kiryat Arba, a Jewish settlement situated in the West Bank, which is occupied by Israel. Her father owns a vineyard at home."
	}, {
	    type: "Paragraph",
	    text: "The house is located quite remotely, which is probably part of the reason why Mohammed Nasser Tra’ayra, a seventeen-year-old Palestinian boy, chose Hallel’s house on 30 June 2016 to realize his plan to murder a Jewish colonist. Tra’ayra was from Bani Na’im, a small town only six kilometers to the east of the settlement. The teenage girl was home alone. She did not stand a chance."
	}, {
	    type: "Iframe",
	    url: "https://player.vimeo.com/video/209452055",
	    text: "Reuters’ news video reporting the death of Hallel."
	}, {
	    type: "Quote",
	    quote: "We had just danced together at a performance, the night before her death. Four days after her death, we danced again – to commemorate her.",
	    person: "Emuna Yeshurun (14), friend of Hallel."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "01.jpg",
	        tablet: imageFolder + "01.jpg",
	        desktop: imageFolder + "01.jpg",
	        alt: "",
	        text: "Emuna on her bed in her room."
	    }
	}, {
	    type: "Paragraph",
	    text: "Emuna, Heichal and Noam are fourteen years old now. Although the murder undoubtedly was a shock, the death of their friend is definitely not the only trauma they have experienced in their young lives. Still, the three girls behave like usual teenagers. Emuna wears a beanie, practices hip hop dance and is a fan of the boy band Big Time Rush. She likes to go shopping with friends in the Malha-shopping center in Jerusalem. Noam, who lives amidst Palestinians in a small but heavily-guarded neighborhood, prefers to race downhill in a wheelbarrow tied to a bicycle. In doing so, however, she needs to beware of ‘Arabians and stray dogs’. Heichel, on the other hand, likes to write lyrics. About her feelings. "
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow1/02__mobile.jpg",
	        tablet: imageFolder + "slideshow1/02.jpg",
	        desktop: imageFolder + "slideshow1/02.jpg",
	        alt: "",
	        text: "Emuna Yeshurun (14): ‘I practice hip hop, ballet and modern dance. I knew Hallel very well. We were in class together. Just the evening before her death we had a dance performance together. Four days after her death, we danced again – to commemorate her.’"
	    }, {
	        mobile: imageFolder + "slideshow1/03__mobile.jpg",
	        tablet: imageFolder + "slideshow1/03.jpg",
	        desktop: imageFolder + "slideshow1/03.jpg",
	        alt: "",
	        text: "‘I am a fan of Big Time Rush. That is a boyband. It is quite old, they do not even exist anymore.’"
	    }, {
	        mobile: imageFolder + "slideshow1/04__mobile.jpg",
	        tablet: imageFolder + "slideshow1/04.jpg",
	        desktop: imageFolder + "slideshow1/04.jpg",
	        alt: "",
	        text: "‘I want to become a fighter pilot.’"
	    }, {
	        mobile: imageFolder + "slideshow1/05__mobile.jpg",
	        tablet: imageFolder + "slideshow1/05.jpg",
	        desktop: imageFolder + "slideshow1/05.jpg",
	        alt: "",
	        text: "‘My message to the world is: there are two peoples here, but we are the ones being killed. It is not normal to attend the funeral of another teenager.’"
	    }, {
	        mobile: imageFolder + "slideshow1/06__mobile.jpg",
	        tablet: imageFolder + "slideshow1/06.jpg",
	        desktop: imageFolder + "slideshow1/06.jpg",
	        alt: "",
	        text: "‘My most valuable possession? My mobile phone. And a note from Hallel’"
	    }, {
	        mobile: imageFolder + "slideshow1/07__mobile.jpg",
	        tablet: imageFolder + "slideshow1/07.jpg",
	        desktop: imageFolder + "slideshow1/07.jpg",
	        alt: "",
	        text: "‘At school we study the Jewish life. Sometimes I wonder what they learn at school. Probably how to hate Jews’"
	    }, {
	        mobile: imageFolder + "slideshow1/08__mobile.jpg",
	        tablet: imageFolder + "slideshow1/08.jpg",
	        desktop: imageFolder + "slideshow1/08.jpg",
	        alt: "",
	        text: "‘Hallel did not have a life yet, she was not married, did not have children yet. I think about that when I am lying in bed. Then I imagine how the stabbing must have taken place’"
	    }, {
	        mobile: imageFolder + "slideshow1/09__mobile.jpg",
	        tablet: imageFolder + "slideshow1/09.jpg",
	        desktop: imageFolder + "slideshow1/09.jpg",
	        alt: "",
	        text: "‘I would not be able to stab someone, even if somebody gave me a knife and the body of an Arab. How could he do that to Hallel?’"
	    }]
	}, {
	    type: "Paragraph",
	    text: " Emuna, Heichal and Noam are Orthodox Jews, just like most of the colonists of Kiryat Arba. These girls grow up in big families and at home, there are respectively around seven, six and nine children. Kiryat Arba is situated very close to Hebron, the place where The Cave of the Patriarchs is located. This is, in fact, considered one of the holiest places in Judaism. Emuna (her name translates as ‘religion’ in Hebrew) goes to The Cave on foot every Saturday to pray."
	}, {
	    type: "Quote",
	    quote: "My songs are basically about everything, and about how I feel. I did not write about Hallel specifically, but, actually, one of the songs is quite sad.",
	    person: "Heichal Kornstam (14), friend of Hallel"
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "10__mobile.jpg",
	        tablet: imageFolder + "10.jpg",
	        desktop: imageFolder + "10.jpg",
	        alt: "",
	        text: "Heichal on her bed in her room"
	    }
	}, {
	    type: "Paragraph",
	    text: "The common thread in their lives is the ‘Arab’ situation. Kiryat Arba, situated far into the West Bank, is just like all other Jewish settlements considered ‘illegal’ by the international law. These settlements are surrounded by the Palestinians – and are often targeted by the Palestinians. "
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow2/11__mobile.jpg",
	        tablet: imageFolder + "slideshow2/11.jpg",
	        desktop: imageFolder + "slideshow2/11.jpg",
	        alt: "",
	        text: "Heichal Kornstam (14): ‘Hallel was a very friendly girl, she liked to laugh a lot. She was also very thoughtful and caring. We used to talk a lot with each other at school. We sat next to each other in English class. She was very good at English’"
	    }, {
	        mobile: imageFolder + "slideshow2/12__mobile.jpg",
	        tablet: imageFolder + "slideshow2/12.jpg",
	        desktop: imageFolder + "slideshow2/12.jpg",
	        alt: "",
	        text: "‘Sometimes we go to Jerusalem. To go bowling or to meet friends. I do not read that much anymore, I prefer making music. I write songs and I sing. I like Twenty One Pilots and Bastille.’"
	    }, {
	        mobile: imageFolder + "slideshow2/13__mobile.jpg",
	        tablet: imageFolder + "slideshow2/13.jpg",
	        desktop: imageFolder + "slideshow2/13.jpg",
	        alt: "",
	        text: "'My songs are basically about everything, and about how I feel. I did not write about Hallel specifically, but, actually, one of the songs is quite sad.’"
	    }, {
	        mobile: imageFolder + "slideshow2/14__mobile.jpg",
	        tablet: imageFolder + "slideshow2/14.jpg",
	        desktop: imageFolder + "slideshow2/14.jpg",
	        alt: "",
	        text: "'It depends on the Arabs what is going to happen. They are the ones committing attacks. The government allows them to live here and they commit attacks. It is very disappointing that Israel does not send them away.’"
	    }]
	}, {
	    type: "Paragraph",
	    text: "There are various reasons for Jews to choose a colonist life. Some decide to become a colonist merely because the settlements offer a spacious and cheap living. In Kiryat Arba, however, the situation is different. Ideology plays a very important role. In Kiryat Arba, they believe that ‘this land is ours, it belongs to us’. The international community is critical about this situation, but the citizens of Kiryat Arba are not interested in hearing these opinions. They follow the Torah, where it is clearly stated that ‘Judea’, as they tend to call the southern parts of the West Bank, is the biblical heartland of the Jewish people."
	}, {
	    type: "Paragraph",
	    text: "This ideology, however, has its fanatic sides. For instance, the colonist Baruch Goldstein from Kiryat Arba committed a massacre in the Ibrahimi Mosque, which is also called ‘the Cave of the Patriarchs’, in 1994. In this act, twenty-nine Muslims were killed and 125 were injured. Goldstein’s own grave is located in the Kahane-Park in Kiryat Arba, which was named after the leader of the extreme-right, terroristic organization Kach. The grave has become a small pilgrimage destination for religious nationalists."
	}, {
	    type: "Quote",
	    quote: "We are obliged to go to school by bus. The windows of the bus are bullet proof, and there are always armed guards that go with us.",
	    person: "Noam Sarah Richie (14), friend of Hallel"
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "15__mobile.jpg",
	        tablet: imageFolder + "15.jpg",
	        desktop: imageFolder + "15.jpg",
	        alt: "",
	        text: "Noam on her bed in her room."
	    }
	}, {
	    type: "Paragraph",
	    text: "The parents of the girls are well aware of what they are doing. Kiryat Arba, in fact, was actually a step back to a calmer environment for the family of Heichal, as they used to live in a Jewish settlement in the Gaza Strip. According to her mother Rina, Hallel was very religious as well. Likewise, the Ariel family is very concerned with the current movement that intends to erect a Third Jewish Temple on the Temple Mountain Haram al-Sharif in the eastern part of Jerusalem, a location at which there are now two mosques."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow3/16__mobile.jpg",
	        tablet: imageFolder + "slideshow3/16.jpg",
	        desktop: imageFolder + "slideshow3/16.jpg",
	        alt: "",
	        text: "Noam Sarah Richi (14): ‘It is dangerous to walk to the village down the hill. It is even too dangerous to walk to school. There is a fence surrounding the village, but in this particular neighborhood we live very close to the Arabs.’"
	    }, {
	        mobile: imageFolder + "slideshow3/17__mobile.jpg",
	        tablet: imageFolder + "slideshow3/17.jpg",
	        desktop: imageFolder + "slideshow3/17.jpg",
	        alt: "",
	        text: "‘We are obliged to go to school by bus. The windows of the bus are bullet proof, and there are always armed guards that go with us.’"
	    }, {
	        mobile: imageFolder + "slideshow3/18__mobile.jpg",
	        tablet: imageFolder + "slideshow3/18.jpg",
	        desktop: imageFolder + "slideshow3/18.jpg",
	        alt: "",
	        text: "Does Noam have any contact with Arabs? She laughs: 'No. At most we insult each other.’"
	    }, {
	        mobile: imageFolder + "slideshow3/19__mobile.jpg",
	        tablet: imageFolder + "slideshow3/19.jpg",
	        desktop: imageFolder + "slideshow3/19.jpg",
	        alt: "",
	        text: "‘Sometimes I think about Arab girls of my own age. But I do not want any contact. They do not really interest me, not even what type of music they listen to. I can hear their music anyways when they have another loud wedding’"
	    }, {
	        mobile: imageFolder + "slideshow3/20__mobile.jpg",
	        tablet: imageFolder + "slideshow3/20.jpg",
	        desktop: imageFolder + "slideshow3/20.jpg",
	        alt: "",
	        text: "‘My eighteen-year-old sister practices taekwondo, mixed martial arts, boxing, and krav maga. She has also taught me a little bit. And there is a self-defense training for women, but that would not help if you are stabbed. It is mostly for your self-confidence.’"
	    }, {
	        mobile: imageFolder + "slideshow3/21__mobile.jpg",
	        tablet: imageFolder + "slideshow3/21.jpg",
	        desktop: imageFolder + "slideshow3/21.jpg",
	        alt: "",
	        text: "‘If somebody tried to stab me, I would through my phone at him, I think.’"
	    }, {
	        mobile: imageFolder + "slideshow3/22__mobile.jpg",
	        tablet: imageFolder + "slideshow3/22.jpg",
	        desktop: imageFolder + "slideshow3/22.jpg",
	        alt: "",
	        text: "‘A friend of mine once started screaming really loudly because she imagined the stabbing.’"
	    }, {
	        mobile: imageFolder + "slideshow3/23__mobile.jpg",
	        tablet: imageFolder + "slideshow3/23.jpg",
	        desktop: imageFolder + "slideshow3/23.jpg",
	        alt: "",
	        text: "‘Sometimes I am having a great time with my friends, but then I suddenly think: what if this friend dies too?’"
	    }]
	}, {
	    type: "Paragraph",
	    text: "Most of Hallel’s friends would like to stay in Kiryat Arba in the future. The introvert Heichal, however, thinks that it is ‘a great disappointment’ that the Israeli government is not undertaking any further actions concerning the deporting of Palestinians. Also, dancer Emuna believes that it is her duty to stay in Kiryat Arba: ‘we must grow – otherwise, Kiryat Arba will become Arab. All surrounding villages are Arab. If we grow, we will swallow them up. This, I believe, is our best solution to prevent new terrorist attacks.’"
	}];

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "dekiloknaller/";
	
	var title = "Holy Road - The Discounter";
	var description = "Both settlers and Palestinians buy their chicken at Rami Levy, the cheapest supermarket in the area. But the low-priced grocery store is located in a settlement. The Jews are allowed weapons, the Palestinians are not.";
	var featuredImage = imageFolder + "dekiloknaller/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "dekiloknaller" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Iframe",
	    hideSpacer: true,
	    url: "https://player.vimeo.com/video/248452827"
	}, {
	    type: "Paragraph",
	    text: "The Israeli – Palestinian conflict is visible throughout the entire occupied West Bank, but at the Rami Levy supermarket, in the illegal Jewish settlement Gush Etzion, a different struggle is being fought; a permanent war over the lowest prices. At the height of the struggle, a kilo of chicken cost less than a shekel (24 eurocent)."
	}, {
	    type: "Paragraph",
	    text: "Even though this supermarket is located next to a roundabout where there have been multiple attacks, one has to realize that chicken is chicken. In their villages surrounding these settlements Palestinians can go to the hairdresser for a fair price and a falafel sandwich is not expensive either, but no one can beat prize butcher Rami Levy."
	}, {
	    type: "Paragraph",
	    text: "On 19 November 2015 Mohammed Abdel Basset al-Kharoub opened fire on cars at the roundabout while his fellow villagers were buying kilos of chicken amid armed Israeli settlers some 100 meters down the street. The settlers were also buying their chicken at Rami Levy. You can't miss a good bargain."
	}, {
	    type: "Paragraph",
	    text: "Unlike most other places in the occupied West Bank, Jews and Arabs live among each other here. Some Palestinians have come to the conclusion that it might be worth trying to live together with the Jewish occupiers rather than to fight them. Reluctantly they do their shopping at the settlements, and even the employees at Rami Levy are Palestinians. But don't talk about it with your fellow villagers."
	}];

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "deheilige/";
	
	var title = "Holy Road - The holy Rachel";
	var description = "The tomb of the matriarch Rachel lies in Bethlehem, but can only be reached from Israel. Is this biblical heartland, or the essence of colonial logic?";
	var featuredImage = imageFolder + "deheilige/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "deheilige" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Paragraph",
	    text: "Rachel and Jacob fell in love. Jacob had to work for fourteen years for his uncle - her father- to marry her. They had two children. Rachel died in childbirth when giving birth to her second son, Benjamin. She was buried in a humble tomb close to Bethlehem.  Route 60 runs along sanctuaries and ill-fated places. Since the fourth century AC, Rachel’s Tomb has been a place of pilgrimage for Jews, Christians and Muslims."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "30__mobile.jpg",
	        tablet: imageFolder + "30.jpg",
	        desktop: imageFolder + "30.jpg",
	        alt: "",
	        text: "Rachel’s Tomb, photographed somewhere between 1898 and 1946 by a photographer of the American Colony."
	    }
	}, {
	    type: "Paragraph",
	    text: "A camel caravan passes by a small stone building and in the background the unspoiled hills of Judea. This photograph from 1898 shows Rachel’s Tomb, important to all three Abrahamic religions, with its surrounding landscape that for centuries had remained untouched: the biblical heartland, situated between Jerusalem and Bethlehem. When this photograph was taken, only the building itself had been slightly expanded. The monument has been depicted in multiple paintings and sung about in poetry, such as in Nicholas Michel’s poem “Rachel’s Tomb”. The resulting picture of these cultural expressions, especially from the Jewish side, is that of a romanticized longing. "
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow1/01__mobile.jpg",
	        tablet: imageFolder + "slideshow1/01.jpg",
	        desktop: imageFolder + "slideshow1/01.jpg",
	        alt: "",
	        text: "Rachel’s Tomb, painted by the British artist Samuel Lawson Booth in 1900."
	    }, {
	        mobile: imageFolder + "slideshow1/02__mobile.jpg",
	        tablet: imageFolder + "slideshow1/02.jpg",
	        desktop: imageFolder + "slideshow1/02.jpg",
	        alt: "",
	        text: "Rachel’s Tomb photographed by a photographer of the American Colony somewhere between 1898 and 1914."
	    }, {
	        mobile: imageFolder + "slideshow1/03__mobile.jpg",
	        tablet: imageFolder + "slideshow1/03.jpg",
	        desktop: imageFolder + "slideshow1/03.jpg",
	        alt: "",
	        text: "These stamps depicting Rachel’s Tomb circulated in Palestine between 1927 and 1942 under the British mandate."
	    }, {
	        mobile: imageFolder + "slideshow1/04__mobile.jpg",
	        tablet: imageFolder + "slideshow1/04.jpg",
	        desktop: imageFolder + "slideshow1/04.jpg",
	        alt: "",
	        text: "Rachel’s Tomb in the 1930s (Photo by Matson Photoservice)."
	    }, {
	        mobile: imageFolder + "slideshow1/05__mobile.jpg",
	        tablet: imageFolder + "slideshow1/05.jpg",
	        desktop: imageFolder + "slideshow1/05.jpg",
	        alt: "",
	        text: "An old color photograph of Rachel’s Tomb, photographed by a photographer of the American Colony (year unknown)."
	    }, {
	        mobile: imageFolder + "slideshow1/06__mobile.jpg",
	        tablet: imageFolder + "slideshow1/06.jpg",
	        desktop: imageFolder + "slideshow1/06.jpg",
	        alt: "",
	        text: "British soldiers of a Scottish regiment controlling travelers on Route 60 in front of Rachel’s Tomb in the 1940s (Photo: American Colony)."
	    }, {
	        mobile: imageFolder + "slideshow1/07__mobile.jpg",
	        tablet: imageFolder + "slideshow1/07.jpg",
	        desktop: imageFolder + "slideshow1/07.jpg",
	        alt: "",
	        text: "Half of a Palestinian Pound with a depiction of Rachel’s Tomb. This currency, introduced in 1927 by the British, was used in the West Bank until 1950."
	    }, {
	        mobile: imageFolder + "slideshow1/08__mobile.jpg",
	        tablet: imageFolder + "slideshow1/08.jpg",
	        desktop: imageFolder + "slideshow1/08.jpg",
	        alt: "",
	        text: "Jewish women in front of Rachel’s Tomb in 1967 (Photo by Yosef Tamir)."
	    }, {
	        mobile: imageFolder + "slideshow1/09__mobile.jpg",
	        tablet: imageFolder + "slideshow1/09.jpg",
	        desktop: imageFolder + "slideshow1/09.jpg",
	        alt: "",
	        text: "Rachel’s Tomb in 1978."
	    }, {
	        mobile: imageFolder + "slideshow1/26__mobile.jpg",
	        tablet: imageFolder + "slideshow1/26.jpg",
	        desktop: imageFolder + "slideshow1/26.jpg",
	        alt: "",
	        text: "The present entry to Rachel’s Tomb."
	    }]
	}, {
	    type: "Paragraph",
	    text: "Until deep into the nineteenth century there were not many Jews living in this territory, as only few people could travel to it under the Ottoman Empire rule.  At the end of the nineteenth and beginning of the twentieth century there were great Jewish immigration waves towards Palestine which consequently led to an increase of Jewish visitors to the grave. During the Arab-Israeli war of 1948 the monument became Jordanian property. For nineteen years the Jews could not visit it, which increased their desire towards it. This desire was fulfilled in 1967 when the Israeli occupation of the West Bank begun."
	}, {
	    type: "Paragraph",
	    text: "Nowadays Rachel’s Tomb looks like this:"
	}, {
	    type: "Iframe",
	    url: "https://player.vimeo.com/video/214016315",
	    text: "On arrival at Rachel’s Tomb coming from Route 60."
	}, {
	    type: "Paragraph",
	    text: "Those who wish to understand the Israeli occupation of the West Bank need to study Rachel’s Tomb. Religious interests, military power, and aesthetic manipulation are all visible in these few square meters. The fortification of this holy place represents, according to some, the essence of colonial logic. Still nowadays believers visit the grave. However, the religious experience has unmistakably acquired a power-political connotation. Jews now have the exclusive right to use this holy place and Rachel’s Tomb, lying at the center of Palestinian Bethlehem, has become a synagogue. A meters-high wall with military guard posts ensures its exclusivity."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "28__mobile.jpg",
	        tablet: imageFolder + "28.jpg",
	        desktop: imageFolder + "28.jpg",
	        alt: "",
	        text: "The military is always present inside the walls next to Rachel’s grave. The army uses the blue gate to access the Aida refugee camp."
	    }
	}, {
	    type: "Paragraph",
	    text: "After the Six-Day War in 1967 the grave fell into the hands of the Israeli rabbinate. However, during the Oslo Accords at the end of the 90s, the tomb was assigned to the Palestinian Authority, decision which caused great protests from right-wing nationalists and the ultra-orthodox Jewish side."
	}, {
	    type: "Paragraph",
	    text: "Following this decision, Israel slightly pushed the boundaries so as to include the monument. As such, a holy place in the center of a Palestinian city came under Israeli authority. A settlement was founded and in 2001 the grave was re-annexed to Israel. An eight-meter high wall was built around the tomb, blocking the old road from Hebron through Bethlehem to Jerusalem. It is impossible for Palestinians to visit this place of pilgrimage, as Rachel’s Tomb is now only accessible for Jewish pilgrims and tourists."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "01__mobile.jpg",
	        tablet: imageFolder + "01.jpg",
	        desktop: imageFolder + "01.jpg",
	        alt: "",
	        text: "A view of the wall surrounding Rachel’s Tomb, as seen from Bethlehem."
	    }
	}, {
	    type: "Paragraph",
	    text: "The wall does not run along the Green Line, the border between Israel and the West Bank, but instead was for the most part it has been built kilometers deep into Palestinian territory. The wall also traces the bulge that Rachel's Tomb forms. Seen from above, the Israeli territory protrudes like an arm with a clenched fist into the city of Bethlehem. The grave can no longer be accessed from this city. For centuries Jerusalem and Bethlehem have been twin cities, intrinsically linked through Jesus’ birth in Bethlehem and violent death in Jerusalem. It was not until 2004 that the surgeons of the Israeli government succeeded in separating these Siamese twins from each other. "
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "27__mobile.jpg",
	        tablet: imageFolder + "27.jpg",
	        desktop: imageFolder + "27.jpg",
	        alt: "",
	        text: "A complicated border situation arises around Rachel's Tomb (at the Star of David). The entire area on this map belongs to the West Bank occupied by Israel. Above the thick purple line lies East Jerusalem, beneath it is Bethlehem. The blue line is the boundary between the Israel-controlled Area C (above) and the Palestinian Area A (below). And then there is the red line: the separation wall that is wrapped around the monument."
	    }
	}, {
	    type: "Paragraph",
	    text: "The wall must guarantee that Jews can reach the matriarch´s grave from Jerusalem without obstacles. From Beitar Illit, an ultra-orthodox settlement in the West Bank, there is even a special bus line to this holy place. As such, it is well-visited. The funerary monument, a building from the Ottoman era, has separate entrances for men and women that lead to either side of the resting place: a concrete structure, protected with thick plastic to protect it against the palms, foreheads and lips of praying orthodox Jews."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow2/15__mobile.jpg",
	        tablet: imageFolder + "slideshow2/15.jpg",
	        desktop: imageFolder + "slideshow2/15.jpg",
	        alt: "",
	        text: "Praying men at Rachel’s Tomb."
	    }, {
	        mobile: imageFolder + "slideshow2/16__mobile.jpg",
	        tablet: imageFolder + "slideshow2/16.jpg",
	        desktop: imageFolder + "slideshow2/16.jpg",
	        alt: "",
	        text: "Orthodox Jew praying at Rachel’s Tomb."
	    }, {
	        mobile: imageFolder + "slideshow2/17__mobile.jpg",
	        tablet: imageFolder + "slideshow2/17.jpg",
	        desktop: imageFolder + "slideshow2/17.jpg",
	        alt: "",
	        text: "A special Torah scroll at the men’s entrance of Rachel’s Tomb."
	    }, {
	        mobile: imageFolder + "slideshow2/18__mobile.jpg",
	        tablet: imageFolder + "slideshow2/18.jpg",
	        desktop: imageFolder + "slideshow2/18.jpg",
	        alt: "",
	        text: "Orthodox Jewish men at the men’s side of Rachel’s Tomb."
	    }, {
	        mobile: imageFolder + "slideshow2/19__mobile.jpg",
	        tablet: imageFolder + "slideshow2/19.jpg",
	        desktop: imageFolder + "slideshow2/19.jpg",
	        alt: "",
	        text: "Jewish men praying and studying the Torah at Rachel’s Tomb."
	    }, {
	        mobile: imageFolder + "slideshow2/20__mobile.jpg",
	        tablet: imageFolder + "slideshow2/20.jpg",
	        desktop: imageFolder + "slideshow2/20.jpg",
	        alt: "",
	        text: "Praying women at Rachel’s Tomb."
	    }, {
	        mobile: imageFolder + "slideshow2/21__mobile.jpg",
	        tablet: imageFolder + "slideshow2/21.jpg",
	        desktop: imageFolder + "slideshow2/21.jpg",
	        alt: "",
	        text: "Women kissing Rachel’s Tomb."
	    }, {
	        mobile: imageFolder + "slideshow2/22__mobile.jpg",
	        tablet: imageFolder + "slideshow2/22.jpg",
	        desktop: imageFolder + "slideshow2/22.jpg",
	        alt: "",
	        text: "Praying woman at Rachel’s Tomb."
	    }, {
	        mobile: imageFolder + "slideshow2/23__mobile.jpg",
	        tablet: imageFolder + "slideshow2/23.jpg",
	        desktop: imageFolder + "slideshow2/23.jpg",
	        alt: "",
	        text: "Jewish woman with prayer book at Rachel’s Tomb."
	    }, {
	        mobile: imageFolder + "slideshow2/24__mobile.jpg",
	        tablet: imageFolder + "slideshow2/24.jpg",
	        desktop: imageFolder + "slideshow2/24.jpg",
	        alt: "",
	        text: "Praying women at Rachel’s Tomb. In the background the curtain made from the wedding dress of Nava Applebaum, a twenty-year-old American-Israeli woman who died in a suicide attack in West Jerusalem on 9 September 2003, a day before her wedding."
	    }, {
	        mobile: imageFolder + "slideshow2/25__mobile.jpg",
	        tablet: imageFolder + "slideshow2/25.jpg",
	        desktop: imageFolder + "slideshow2/25.jpg",
	        alt: "",
	        text: "The men’s entrance of Rachel’s Tomb, where Route 60 used to be. "
	    }]
	}, {
	    type: "Paragraph",
	    text: "Rachel’s Tomb is a symbol for the return of the Jews to Zion, their past homeland. At the tomb, Jewish women pray for fertility and safe delivery, a reference to Rachel, who remained infertile for a long time but whose prayers for a child were finally answered. A striking relic is the curtain draped over the Torah ark, the cabinet in which the five Torah scrolls are stored. This curtain is made from the wedding dress of Nava Applebaum, an American-Israeli woman aged twenty years when she died in a suicide attack in West Jerusalem,on 9 September 2003, one day before her wedding,."
	}, {
	    type: "Paragraph",
	    text: "Surprisingly enough, the Jewish believers refer to the biblical matriarch as if she were their own mother. As Jewish tourist Shiffy Klein (20) from New York explains, who visits Rachel’s Tomb on her honeymoon explains: ‘With your mother you can be honest, be yourself, let your heart speak’. For this same reason Klein prefers this tomb over the Wailing Wall, eight kilometers to the north: ‘There are so many people there, it does not feel as intimate as here’."
	}, {
	    type: "Paragraph",
	    text: "In accordance with the tradition, Klein has also prayed for fertility. ‘I said to Rachel: please help me to become a mother’. The fact that the monument is surrounded by walls is not a problem for her. ‘We also pray for a time in which walls will no longer be necessary. But when you are inside, with her, you feel safe’."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "14__mobile.jpg",
	        tablet: imageFolder + "14.jpg",
	        desktop: imageFolder + "14.jpg",
	        alt: "",
	        text: "Inside the enclosure and near Rachel's Tomb is a mural of the grave with a Bible passage from Genesis 35 verses 16-20 in which Rachel’s death and burial are described.  "
	    }
	}, {
	    type: "Paragraph",
	    text: "The safety of the orthodox Jews at the tomb has a price, paid by the Palestinians at the other side. There is a checkpoint between Jerusalem and Bethlehem. Some Palestinians may pass, for example those who have an Israeli ID card, or who have a permit to work at the Israeli side. For many other Palestinians the wall is an actual border. For them the other side, Israel, starts at the grave of the matriarch, even when there is no country in the world that recognizes this occupied area as Israeli territory."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow3/02__mobile.jpg",
	        tablet: imageFolder + "slideshow3/02.jpg",
	        desktop: imageFolder + "slideshow3/02.jpg",
	        alt: "",
	        text: "The wall surrounding Rachel’s Tomb rising above the houses."
	    }, {
	        mobile: imageFolder + "slideshow3/03__mobile.jpg",
	        tablet: imageFolder + "slideshow3/03.jpg",
	        desktop: imageFolder + "slideshow3/03.jpg",
	        alt: "",
	        text: "Behind the wall is the road that leads to Rachel’s Tomb."
	    }, {
	        mobile: imageFolder + "slideshow3/04__mobile.jpg",
	        tablet: imageFolder + "slideshow3/04.jpg",
	        desktop: imageFolder + "slideshow3/04.jpg",
	        alt: "",
	        text: "The entrance to Rachel’s Tomb is visible from the other side of the wall."
	    }, {
	        mobile: imageFolder + "slideshow3/05__mobile.jpg",
	        tablet: imageFolder + "slideshow3/05.jpg",
	        desktop: imageFolder + "slideshow3/05.jpg",
	        alt: "",
	        text: "The military regularly uses the blue gate to raid the Aida refugee camp."
	    }, {
	        mobile: imageFolder + "slideshow3/06__mobile.jpg",
	        tablet: imageFolder + "slideshow3/06.jpg",
	        desktop: imageFolder + "slideshow3/06.jpg",
	        alt: "",
	        text: "The dome of Rachel’s Tomb is visible in the center of this photograph, taken from the cemetery in between Rachel’s grave and the Aida refugee camp."
	    }, {
	        mobile: imageFolder + "slideshow3/07__mobile.jpg",
	        tablet: imageFolder + "slideshow3/07.jpg",
	        desktop: imageFolder + "slideshow3/07.jpg",
	        alt: "",
	        text: "Due to the high wall the dome of Rachel’s Tomb is not visible from this point."
	    }, {
	        mobile: imageFolder + "slideshow3/08__mobile.jpg",
	        tablet: imageFolder + "slideshow3/08.jpg",
	        desktop: imageFolder + "slideshow3/08.jpg",
	        alt: "",
	        text: "Jewish settlers live here, next to Rachel’s Tomb but on the Palestinian side of the wall."
	    }, {
	        mobile: imageFolder + "slideshow3/09__mobile.jpg",
	        tablet: imageFolder + "slideshow3/09.jpg",
	        desktop: imageFolder + "slideshow3/09.jpg",
	        alt: "",
	        text: "The playground of the Wi’am organization."
	    }, {
	        mobile: imageFolder + "slideshow3/10__mobile.jpg",
	        tablet: imageFolder + "slideshow3/10.jpg",
	        desktop: imageFolder + "slideshow3/10.jpg",
	        alt: "",
	        text: "The wall passing over the land of the Wi’am organization due to which Nicola lost a quarter of its land."
	    }, {
	        mobile: imageFolder + "slideshow3/11__mobile.jpg",
	        tablet: imageFolder + "slideshow3/11.jpg",
	        desktop: imageFolder + "slideshow3/11.jpg",
	        alt: "",
	        text: "The blue gate is built on the old Route 60 which runs next to Rachel’s Tomb."
	    }, {
	        mobile: imageFolder + "slideshow3/12__mobile.jpg",
	        tablet: imageFolder + "slideshow3/12.jpg",
	        desktop: imageFolder + "slideshow3/12.jpg",
	        alt: "",
	        text: "Before the wall was built this gas station, right in front of Rachel’s Tomb, was one of the busiest gas stations of Bethlehem."
	    }, {
	        mobile: imageFolder + "slideshow3/13__mobile.jpg",
	        tablet: imageFolder + "slideshow3/13.jpg",
	        desktop: imageFolder + "slideshow3/13.jpg",
	        alt: "",
	        text: "The wall in direction of checkpoint 300, where Palestinians from the West Bank possessing a permit can travel to Jerusalem."
	    }]
	}, {
	    type: "Paragraph",
	    text: "According to Usama Nicola, a Palestinian Christian from Bethlehem, he and his fellow believers also feel ‘emotionally connected’ to Rachel. ‘We would like to be able to enjoy the holy places in this area, especially Rachel’s Tomb’."
	}, {
	    type: "Paragraph",
	    text: "Nicola works as a project coordinator at ‘Wi’am: The Palestinian Conflict Transformation Center’. Wi’am, says Nicola, invests in issues such as conflict mediation, women’s rights, and trauma counselling for children. When Rachel’s Tomb was walled, Wi’am lost a quarter of its land; Jewish settlers now live in the garden of the center, right next to the monument. A few times a year, sewage water coming from Rachel’s Tomb and going through a tunnel underneath the separation wall, flows into the garden of the Wi’am organization."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "riool__mobile.jpg",
	        tablet: imageFolder + "riool.jpg",
	        desktop: imageFolder + "riool.jpg",
	        alt: "",
	        text: "A few times a year, sewage water, coming from Rachel’s Tomb and going through a tunnel underneath the separation wall, flows into the garden of Wi’am: The Palestinian Conflict Transformation Center. Foto: Usama Nicola."
	    }
	}, {
	    type: "Paragraph",
	    text: "‘The wall’, he says, ‘is an ugly creation that disrupts the natural and man-made beauty of this country’. However, the biggest problem is that the wall denies Palestinians the access to Jerusalem and the rest of ‘historical Palestine’, as Nicola calls the entire country between the river Jordan and the Mediterranean sea."
	}, {
	    type: "Paragraph",
	    text: "Thus, Rachel’s Tomb is no longer only the symbol of fertility, but also of the occupation of the West Bank. The biblical heartland has become the heart of the occupation."
	}];

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "destandvastige/";
	
	var title = "Holy Road - The Perseverer";
	var description = "The Palestinian Sub Laban family lives in the Muslim quarter of the Old City of Jerusalem. In the old days, Jews used to live here. For that reason their house is now being expropriated.";
	var featuredImage = imageFolder + "destandvastige/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "destandvastige" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Iframe",
	    hideSpacer: true,
	    url: "https://player.vimeo.com/video/248454229"
	}, {
	    type: "Paragraph",
	    text: "The putty in the bedroom wall is still visible. Palestinian Nora Sub Laban points at seven spots on the wall: places where her neighbors drilled holes. “To check what was behind the wall, they said. But why would they drill seven times?” Nora Sub Laban’s neighbors in the Muslim Quarter of the Old City of Jerusalem, are Jewish settlers. The room next to the bedroom used to be part of the Sub Laban family’s house, but step by step the house is taken over by the neighbors."
	}, {
	    type: "Paragraph",
	    text: "Absurd? Not in Jerusalem. Nora Sub Laban could go to the police, but they will not do anything for her. Even the Israeli judge approves of the Jewish neighbors, and the soldiers will only stand back and watch when yet another space is taken over. The legal battle of the family has gone on for decades but leads nowhere. This is the result of an Israeli law, which states that Jews can legitimately claim any Palestinian house where a Jew has ever lived. In the case of the Sub Laban family, it refers to a Jewish tenant in the 1930s."
	}, {
	    type: "Paragraph",
	    text: "During the Arab-Israeli war of 1948 the Old City of Jerusalem was conquered by Jordan and since then the house is the property of the Sub Laban family. The judge has ruled that Nora and her husband are allowed to stay there – but they are the last generation. After them, the house will be released to settlers. During that same war, hundreds of Palestinian houses in what is now West Jerusalem were taken over by Jewish people. A few hundred meters from Nora Sub Laban’s house, just outside the Old City in the Musrara area, Arab mansions are now inhabited by Jews. The law is a one-way street and does not apply to these cases. No Palestinian could claim a house that was ever inhabited by his or her family. The Israeli law explicitly aims at enhancing Jewish presence in both Israel and the territories under its control, such as occupied East Jerusalem."
	}];

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "dedemonstrant/";
	
	var title = "Holy Road - The Protester";
	var description = "His ‘nom de guerre’ is Tito. Every week, he sets out to protest against the Israeli army. It’s David versus Goliath, he says. But he has no choice.";
	var featuredImage = imageFolder + "dedemonstrant/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "dedemonstrant" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Iframe",
	    hideSpacer: true,
	    url: "https://player.vimeo.com/video/248500680",
	    text: "What does life look like? See here a day in the life of Tito, a Palestinian protester."
	}, {
	    type: "Paragraph",
	    text: "If you ask Tito where he originates from, he answers: I am from Salama. Salama, however, no longer exists on the map. It was a village just outside Jaffa, the ancient Arabian harbor town now one of the suburbs Tel Aviv, Israel. Salama was ethnically cleansed by Zionist militias and literally wiped off the map. Only the ‘Shalma Road’ is a reminder of the former Arabian occupancy. About 7,000 inhabitants had to flee their houses and ended up in camps. They were placed among others, in the al Am’ari refugee camp near Ramallah, in the West Bank. The family of Tito was placed there as well."
	}, {
	    type: "Paragraph",
	    text: "Almost seventy years later, Tito still lives here. He is prohibited from staying in Tel-Aviv, even if it is only one day. As with his ancestors, he too strives to fight against the Jews – though not so much the Zionist militias, but against the Israeli army. According to international law, Palestinian refugees from around 1948 and their descendants – the estimated amount is 5 million – retain the right to return to where they originated, in present day Israel. However this now not only applies to Israel but to Tito and his family in the West Bank as this is now an occupied and colonized area."
	}, {
	    type: "Paragraph",
	    text: "Tito and his fellow protestors, with their stones and Molotov cocktails, do not stand much of a chance against the Israeli army, who carry M16’s and tear gas bombs. Israel is punishing these forms of resistance more severely these days. Palestinian stone-throwers risk a prison sentence of twenty years if they get caught. Tito is now thirty-two. Friends keep asking him when he will stop protesting and start a family. The resistance is in my blood, is Tito’s response. He has to strive for his country. There is no alternative for him."
	}];

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "depionier/";
	
	var title = "Holy Road - De Pioneer";
	var description = "The Jewish outpost Amona was built on the land of Palestinian farmers. The Palestinians initiated a lawsuit and won, thanks to a Jewish Israeli activist.";
	var featuredImage = imageFolder + "depionier/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "depionier" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Iframe",
	    hideSpacer: true,
	    url: "https://player.vimeo.com/video/248453349"
	}, {
	    type: "Paragraph",
	    text: "Eli Greenberg lived on a hill in the West Bank. All right, maybe the land on which his house was built legally belonged to a Palestinian, but why would that matter? The most important thing, according to Greenberg, is that three thousand years ago God promised this land to the Jews. There is no law that could change that."
	}, {
	    type: "Paragraph",
	    text: "According to international law Israel is occupying the West Bank. However, an increasing number of Jewish settlers do not care about this. They do not listen to the legislator, but only to God. For that reason, some of them even turn their backs on the state of Israel altogether, as they believe that Israel should be a theocracy, with the Torah as its constitution."
	}, {
	    type: "Paragraph",
	    text: "The Palestinians of the West Bank consider themselves the native inhabitants of this land and feel threatened by foreign Jewish settlers who make their lives miserable. Likewise, the settlers claim to be the native inhabitants, indicating they were already living there thousands of years ago."
	}, {
	    type: "Paragraph",
	    text: "Secular Israelis do not identify with their fanatic compatriots. However, unwillingly they have to witness how extremists gain more and more influence on the Israeli government policy. Some leftist activists have booked small successes at the Israeli Supreme Court, which is how settler Greenberg lost his land, for example."
	}, {
	    type: "Paragraph",
	    text: "Nevertheless, the future of the peace movement looks dark. The entire scope of Israeli politics is shifting to the right, and with them their electorate. It has become commonplace in Israel to claim that ‘all Arabs are terrorists’, or that they were born to hate Jews. The peace activists are being demonized themselves within Israeli society."
	}];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER + "devrienden/";
	
	var title = "Holy Road - Friends";
	var description = "This story, a piece of reporting of which we were extremely proud, is no longer available. The reason for this is that the boys have withdrawn their cooperation out of fear of threats.";
	var featuredImage = imageFolder + "devrienden/omslag.jpg";
	
	exports.default = [{
	    type: "Meta",
	    title: title,
	    meta: [{ "property": "og:title", "content": title }, { "property": "og:url", "content": "" + _constants2.default.DOMAIN + _constants2.default.STORY_URL + "devrienden" }, { "property": "description", "content": "" }, { "property": "og:description", "content": description }, { "property": "og:image", "content": featuredImage }, { "property": "twitter:card", "content": "summary_large_image" }, { "property": "twitter:title", "content": title }, { "property": "twitter:description", "content": description }, { "property": "twitter:image", "content": featuredImage }]
	}, {
	    type: "Quote",
	    quote: description
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "djv201703101027.jpg",
	        tablet: imageFolder + "djv201703101027.jpg",
	        desktop: imageFolder + "djv201703101027.jpg",
	        alt: "",
	        text: "Jenin Refugee in 2017"
	    }
	}, {
	    type: "Paragraph",
	    text: "This page originally contained a story of hope; a genuine feel-good story about five Palestinian boys who had made good despite growing up surrounded by violence in the Jenin refugee camp in the West Bank. Dirk-Jan Visser first photographed the boys during the height of the Second Intifada (uprising) in the early 2000s and again in 2017. The ‘then and now’ photos of the five elicited the necessary emotions from everyone who saw them."
	}, {
	    type: "Paragraph",
	    text: "The Holy Road aims to offer a glimpse into daily life in the West Bank, for both Palestinians and the Jewish settlers. Whatever you may think of their political views, the settlers also experience human tragedy, which we also wanted to report. See, for example, the story of 13-year old Hallel Yaffe Ariel, who was stabbed to death in her own bedroom by a Palestinian."
	}, {
	    type: "Paragraph",
	    text: "We believe we were always totally clear about what we wanted to achieve with The Holy Road. Nevertheless, at the beginning of 2018, when the English translation of the documentary appeared, our contact person for the Jenin refugee camp was apparently shocked that Jewish settlers were also featured. This is unacceptable for some Palestinians; ‘collaborating’ with the occupier on a production could contribute to the ‘normalisation’ of the occupation. This group believes that the 50-year military repression of Palestinians in the West Bank is anything but normal and that acting as if it were should be avoided at all costs."
	}, {
	    type: "Paragraph",
	    text: "The contact person showed the boys the documentary and they demanded that we remove their story. Their argument was that both the contact person and the boys could be seen as traitors or collaborators because their participation was normalising the occupation."
	}, {
	    type: "Image",
	    image: {
	        mobile: imageFolder + "161223000063660057.jpg",
	        tablet: imageFolder + "161223000063660057.jpg",
	        desktop: imageFolder + "161223000063660057.jpg",
	        alt: "",
	        text: "Jenin refugee camp in 2002."
	    }
	}, {
	    type: "Paragraph",
	    text: "From a journalistic standpoint, we do not regard this as a valid argument. We have not made a pro-Palestinian or anti-Israeli propaganda film; we are simply showing the reality for both groups. What does worry us is the argument that the boys could be threatened. That’s why we decided to tell this new story addressing the difficult questions surrounding normalisation, the boycott movement against Israel and the internal Palestinian pressure on people to conform to these norms. The pressure applied on the boys not to collaborate with normalisation is far from being an isolated incident: the municipality of Ramallah cancelled the screening of the Oscar-nominated Lebanese film The Insult due to the fact that director Ziad Doueiri had spent a few weeks in Tel Aviv while shooting a previous film."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow1/01Jenin.jpg",
	        tablet: imageFolder + "slideshow1/01Jenin.jpg",
	        desktop: imageFolder + "slideshow1/01Jenin.jpg",
	        alt: "",
	        text: "The Jenin refugee camp, a few days after operation 'Defensive Shield'."
	    }, {
	        mobile: imageFolder + "slideshow1/02Jenin.jpg",
	        tablet: imageFolder + "slideshow1/02Jenin.jpg",
	        desktop: imageFolder + "slideshow1/02Jenin.jpg",
	        alt: "",
	        text: "Everywhere people are sitting helplessly on the ruins of their house."
	    }, {
	        mobile: imageFolder + "slideshow1/03Jenin.jpg",
	        tablet: imageFolder + "slideshow1/03Jenin.jpg",
	        desktop: imageFolder + "slideshow1/03Jenin.jpg",
	        alt: "",
	        text: "In a circle around the flattened part of the camp all the houses are badly damaged."
	    }, {
	        mobile: imageFolder + "slideshow1/04Jenin.jpg",
	        tablet: imageFolder + "slideshow1/04Jenin.jpg",
	        desktop: imageFolder + "slideshow1/04Jenin.jpg",
	        alt: "",
	        text: "Aid organizations have brought water and food for the victims."
	    }, {
	        mobile: imageFolder + "slideshow1/05Jenin.jpg",
	        tablet: imageFolder + "slideshow1/05Jenin.jpg",
	        desktop: imageFolder + "slideshow1/05Jenin.jpg",
	        alt: "",
	        text: "An old man is lost in thought by his ruined house."
	    }, {
	        mobile: imageFolder + "slideshow1/06Jenin.jpg",
	        tablet: imageFolder + "slideshow1/06Jenin.jpg",
	        desktop: imageFolder + "slideshow1/06Jenin.jpg",
	        alt: "",
	        text: "Whole families spend days on the ruins of their houses."
	    }, {
	        mobile: imageFolder + "slideshow1/07Jenin.jpg",
	        tablet: imageFolder + "slideshow1/07Jenin.jpg",
	        desktop: imageFolder + "slideshow1/07Jenin.jpg",
	        alt: "",
	        text: "A boy climbs on the roof of his damaged house."
	    }, {
	        mobile: imageFolder + "slideshow1/08Jenin.jpg",
	        tablet: imageFolder + "slideshow1/08Jenin.jpg",
	        desktop: imageFolder + "slideshow1/08Jenin.jpg",
	        alt: "",
	        text: "Old women oversee the arrival of journalists and aid workers to the destroyed Jenin refugee camp."
	    }]
	}, {
	    type: "Paragraph",
	    text: "The call for a cultural boycott of Israel is part of the Boycott, Divestment and Sanctions (BDS) movement that was founded by Palestinian activists in 2004. In the previous decades, two bloody intifadas had claimed thousands of lives, without the Palestinians making any political progress. The time had come for non-violent resistance, the activists believed, hoping to bring an end to the Israeli occupation and discrimination against Palestinians. They also want Israel to recognise Palestinian refugees’ right of return. The activists’ tactics reflect the boycott of the South African apartheid regime, which contributed to the regime’s eventual collapse. A number of high-profile figures support the BDS movement, including scientist Stephen Hawking, who died in March 2018, writer Naomi Klein and archbishop Desmond Tutu."
	}, {
	    type: "Paragraph",
	    text: "There are varying ideas within the movement as to exactly who and what should be boycotted. Some say they are against the occupation, so they do not buy products made in the illegal Jewish settlements in the West Bank. Others do not buy any Israeli products because they believe that in order to end the occupation, pressure should be exerted on the whole of Israel. This second group also wants to boycott Israeli universities while others disagree, arguing that Israeli academics are just the people they need for resistance on the inside."
	}, {
	    type: "Paragraph",
	    text: "BDS activists are best known for disrupting performances and calling on artists not to perform in Israel. They believe that as long as the military occupation of Palestinian territory continues, artists should avoid Israel. Big names such as Radiohead and Britney Spears have been targeted. Occasionally the activists achieve a victory, as when New Zealand singer Lorde cancelled her show in Tel Aviv in 2017. Every artist who ignores the Palestinian pressure is loudly applauded on social media under the hashtag #BDSFail by pro-Israeli activists. Performing in Israel has become a statement."
	}, {
	    type: "Paragraph",
	    text: "A proven BDS method is to pressurise businesses and governments that have dealings with the illegal settlements. Several Dutch businesses have given in to the pressure. In 2014, pension fund PGGM decided to stop investing in five Israeli banks that funded the building of Jewish settlements, and water company Vitens ended its collaboration with the Israeli firm providing the settlements with water."
	}, {
	    type: "Paragraph",
	    text: "The economic damage caused by the BDS movement is minimal, however. A 2015 report published by the Knesset, the Israeli parliament, concluded that exports to Europe have actually doubled since 2005, from 7 to 14 billion euros. Even if Europe boycotted all products from the settlements, it would only cost Israel a maximum of 90 million euros annually. In spite of this, Israeli politicians and newspapers, with the exception of the most left-wing, strongly criticise the BDS movement. Prime Minister Benjamin Netanyahu calls the movement ‘anti-Semitic’ and opposition leader Isaac Herzog has even compared the boycott to ‘a new intifada’."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow4/ToenEnNu01.jpg",
	        tablet: imageFolder + "slideshow4/ToenEnNu01.jpg",
	        desktop: imageFolder + "slideshow4/ToenEnNu01.jpg",
	        alt: "",
	        text: "Same place in 2002 and in 2017."
	    }, {
	        mobile: imageFolder + "slideshow4/ToenEnNu02.jpg",
	        tablet: imageFolder + "slideshow4/ToenEnNu02.jpg",
	        desktop: imageFolder + "slideshow4/ToenEnNu02.jpg",
	        alt: "",
	        text: "Same place in 2002 and in 2017."
	    }, {
	        mobile: imageFolder + "slideshow4/ToenEnNu03.jpg",
	        tablet: imageFolder + "slideshow4/ToenEnNu03.jpg",
	        desktop: imageFolder + "slideshow4/ToenEnNu03.jpg",
	        alt: "",
	        text: "Same place in 2002 and in 2017."
	    }, {
	        mobile: imageFolder + "slideshow4/ToenEnNu04.jpg",
	        tablet: imageFolder + "slideshow4/ToenEnNu04.jpg",
	        desktop: imageFolder + "slideshow4/ToenEnNu04.jpg",
	        alt: "",
	        text: "Same place in 2002 and in 2017."
	    }, {
	        mobile: imageFolder + "slideshow4/ToenEnNu05.jpg",
	        tablet: imageFolder + "slideshow4/ToenEnNu05.jpg",
	        desktop: imageFolder + "slideshow4/ToenEnNu05.jpg",
	        alt: "",
	        text: "Same place in 2002 and in 2017."
	    }]
	}, {
	    type: "Paragraph",
	    text: "These strong terms originate partially from Israel’s fear that its position will be jeopardised. Even though most of the international community is against the decades-long occupation, Israel has so far mostly managed to get away with it. Even the continual expansion of the Jewish settlements in the West Bank provokes barely any response from the international community. However, if the BDS movement manages to sensitise the Western public to the illegality of the occupation, Israel will have a problem. Another reason to come down hard on the BDS movement is internal politics: Israelis vote for politicians who demonstrate that they will go to any lengths to defend their country."
	}, {
	    type: "Paragraph",
	    text: "Israel spends huge sums of money – 30 million euros in 2016 alone – to lobby internationally against BDS. In December 2017, the Israeli government announced that another 62.5 million euros would be made available to combat BDS by countering the pressure applied to artists, organising public campaigns, inviting opinion-makers to make ‘solidarity visits’ to Israel and increasing visibility and coordination between pro-Israel groups worldwide. This money will be raised jointly by Israel and a number of Jewish benefactors. Their efforts seems to have worked: the British government has announced that government agencies, including local councils and care facilities, may no longer call for a boycott of Israel. The anti-BDS lobby has also made gains in France, Canada and the United States."
	}, {
	    type: "Paragraph",
	    text: "According to Fred Grünfeld, a retired senior lecturer of international relations at Maastricht University and emeritus professor of the causes of human rights violations at Utrecht University, it is exceptional that countries are so active in combating a boycott movement against another country. He can only remember one other example of this when the US passed two laws against the Arab League’s boycott of Israel in the 1970s. The ferocity of the anti-BDS movement in these Western countries, says Grünfeld, could be due to the fear that boycotts of Israel may contribute to anti-Semitism. He points to France, where a number of anti-Semitic incidents have taken place in the last few years, with the country taking fairly strong action against people and organisations who advocate a boycott of Israel."
	}, {
	    type: "Paragraph",
	    text: "Israel can certainly use the support of its Western allies, although it is by no means unanimous. The British Labour Party has described the legal thwarting of BDS as an ‘attack on democracy’. Does the call to boycott a country that supresses another people not fall, the party argues, under freedom of speech? Amnesty International believes that government institutions should be free to invest ethically and that they should therefore also have the choice not to divert funds to Israel. Roger Waters, the frontman of Pink Floyd and a prominent BDS activist, said on Radio Canada that it was ‘dangerous’ that the United States and Canada have made ‘a non-violent form of protest against a foreign power’ punishable. ‘I find it a very disturbing thought that a normal human rights organisation, of which I am part, can be turned into an illegal organisation and that I can be imprisoned for my part in it.’"
	}, {
	    type: "Paragraph",
	    text: "Paradoxically, the BDS movement benefits from Israeli resistance. Every attack by Prime Minister Netanyahu is a guarantee of publicity. The movement was also far from unhappy with the conference in Israel on how to combat BDS, organised by the widely read daily Yedioth Ahronoth and attended by numerous politicians from both the left and right. The highlight was an appearance by Jewish-American comedienne Roseanne Barr, whom the BDS movement called ‘fascist’."
	}, {
	    type: "Paragraph",
	    text: "It is with good reason that Jay Sanderson, president of the Jewish Federation of Greater Los Angeles, warns that Israel should be more cautious in its dealings with BDS. ‘The more money that goes into the fight against BDS,’ Sanderson said in an interview with Haaretz, ‘and the more people make this the big issue of all time, the more fuel we’re giving the other side.’"
	}, {
	    type: "Paragraph",
	    text: "According to Fred Grünfeld, the success of the BDS movement depends on hitting Israel hardest where it violates international rights: the illegal settlements in the West Bank. ‘You need to look for measures that specifically target the settlers. If you hit Israel as a whole you will only strengthen the nationalistic counter-movement. And you won’t cultivate any sympathy.’"
	}, {
	    type: "Paragraph",
	    text: "Palestinian hardliners will fervently disagree with this particular message from Grünfeld. Within Palestine, it is more or less self-evident that everything Israeli should be boycotted. The BDS movement is so dominant here that any deviation from the norm, real or imagined, can lead to intimidation and threats."
	}, {
	    type: "Slider",
	    images: [{
	        mobile: imageFolder + "slideshow5/01djv201703101044.jpg",
	        tablet: imageFolder + "slideshow5/01djv201703101044.jpg",
	        desktop: imageFolder + "slideshow5/01djv201703101044.jpg",
	        alt: "",
	        text: "The reconstructed part of the Jenin refugee camp, built after 2002."
	    }, {
	        mobile: imageFolder + "slideshow5/02djv201703101083.jpg",
	        tablet: imageFolder + "slideshow5/02djv201703101083.jpg",
	        desktop: imageFolder + "slideshow5/02djv201703101083.jpg",
	        alt: "",
	        text: "Graffiti covers the new houses, referring to martyrs and their brigades."
	    }, {
	        mobile: imageFolder + "slideshow5/03djv201703101136.jpg",
	        tablet: imageFolder + "slideshow5/03djv201703101136.jpg",
	        desktop: imageFolder + "slideshow5/03djv201703101136.jpg",
	        alt: "",
	        text: "Street view of the new part of the Jenin refugee camp."
	    }, {
	        mobile: imageFolder + "slideshow5/04djv201703101194.jpg",
	        tablet: imageFolder + "slideshow5/04djv201703101194.jpg",
	        desktop: imageFolder + "slideshow5/04djv201703101194.jpg",
	        alt: "",
	        text: "Martyr posters of Fatah, Hamas and Islamic Jihad. Written in black it says: 'Brigade Mohammed Asama'."
	    }, {
	        mobile: imageFolder + "slideshow5/05djv201703100986.jpg",
	        tablet: imageFolder + "slideshow5/05djv201703100986.jpg",
	        desktop: imageFolder + "slideshow5/05djv201703100986.jpg",
	        alt: "",
	        text: "The Jenin refugee camp in 2017."
	    }, {
	        mobile: imageFolder + "slideshow5/06djv201703101007.jpg",
	        tablet: imageFolder + "slideshow5/06djv201703101007.jpg",
	        desktop: imageFolder + "slideshow5/06djv201703101007.jpg",
	        alt: "",
	        text: "The memorial stone for Ahmad Hassen, who died as a martyr."
	    }, {
	        mobile: imageFolder + "slideshow5/07djv201703101227.jpg",
	        tablet: imageFolder + "slideshow5/07djv201703101227.jpg",
	        desktop: imageFolder + "slideshow5/07djv201703101227.jpg",
	        alt: "",
	        text: "Street view of the new part of the Jenin refugee camp."
	    }, {
	        mobile: imageFolder + "slideshow5/08djv201703100999.jpg",
	        tablet: imageFolder + "slideshow5/08djv201703100999.jpg",
	        desktop: imageFolder + "slideshow5/08djv201703100999.jpg",
	        alt: "",
	        text: "Wall proclaiming that all prisoners are heroes, accompanied with names."
	    }, {
	        mobile: imageFolder + "slideshow5/09djv201703101055.jpg",
	        tablet: imageFolder + "slideshow5/09djv201703101055.jpg",
	        desktop: imageFolder + "slideshow5/09djv201703101055.jpg",
	        alt: "",
	        text: "Street view in the new part of the Jenin refugee camp. 'May the martyrs be forever in heaven,' is written on the wall on the left."
	    }, {
	        mobile: imageFolder + "slideshow5/10djv201703101049.jpg",
	        tablet: imageFolder + "slideshow5/10djv201703101049.jpg",
	        desktop: imageFolder + "slideshow5/10djv201703101049.jpg",
	        alt: "",
	        text: "Mural with a key and the sea, symbolizing the desire for the return of the refugees in Jenin to present Israel. On the posters, martyrs are commemorated and people are congratulated who have been released from Israeli captivity."
	    }]
	}, {
	    type: "Paragraph",
	    text: "Is it really the case that the boys in Jenin contributed to normalisation by collaborating with a journalistic production that also included Jewish settlers? You could also argue that the intimidation they experienced threatens press freedom in Palestine, which is already woefully lacking. Palestine ranks 135th, just behind Algeria, in the 2017 World Press Freedom Index compiled by the NGO Reporters Without Borders. Free access to information is not guaranteed to Palestinian reporters. Primarily Fatah supporters in the Gaza Strip and Hamas supporters in the West Bank are regularly intimidated or even physically abused."
	}, {
	    type: "Paragraph",
	    text: "Israel does only marginally better, sharing the 91st place with Nicaragua. Reporters Without Borders attributes this ranking in part to military censorship and attacks by Israeli security forces on Palestinian and foreign journalists, mainly during demonstrations."
	}, {
	    type: "Paragraph",
	    text: "As the makers of this documentary, we have more often fallen prey to Israeli restrictions: in 2017, reporter Derk Walters was refused a new press card, with its related residence permit, forcing him to end his stay in the region. That we were forced to remove a story from The Holy Road due to Palestinian pressure in 2018 is both a late and equally unpleasant surprise."
	}];

/***/ },
/* 266 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * Positions of Annotations are defined in Annotations.scss
	 */
	exports.default = [{
	    type: "annotation",
	    position: "center-top",
	    time: 83,
	    showTime: 3,
	    title: "Watch tower"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 117,
	    showTime: 3,
	    title: "Checkpoint"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 146,
	    showTime: 4,
	    title: "Meitar checkpoint, entrance to the West Bank"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 163,
	    showTime: 3,
	    title: "Observation tower"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 171,
	    showTime: 4,
	    title: "Entrance to the West Bank / Area C"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 177,
	    showTime: 3,
	    title: "Separation wall"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 188,
	    showTime: 3,
	    title: "Green Line"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 211,
	    showTime: 4,
	    title: "Military road along the separation wall"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 224,
	    showTime: 2,
	    title: "Exit to Carmel settlement"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 235,
	    showTime: 3,
	    title: "Military distance markers on both sides of the road"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 252,
	    showTime: 4,
	    title: "Shim'a settlement"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 266,
	    showTime: 16,
	    title: "Mitzpe Eshtamoa outpost"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 294,
	    showTime: 12,
	    title: "Earthmound"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 380,
	    showTime: 18,
	    title: "Otniel settlement"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 404,
	    showTime: 2,
	    title: "Settler with weapon"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 409,
	    showTime: 3,
	    title: "Military presence at the entrance to Area A"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 418,
	    showTime: 10,
	    title: "Roadblock, entrance to Area A"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 434,
	    showTime: 10,
	    title: "Military Base"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 459,
	    showTime: 5,
	    title: "Entrance to Area A, at the Palestinian village Al Hijra"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 469,
	    showTime: 3,
	    title: "Earthmound"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 483,
	    showTime: 3,
	    title: "Al Fawwar checkpoint"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 487,
	    showTime: 3,
	    title: "Rumble strips against speed and explosives"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 493,
	    showTime: 2,
	    title: "Observation tower"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 501,
	    showTime: 5,
	    title: "Al Fawwar refugee camp"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 509,
	    showTime: 2,
	    title: "Entrance to area A"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 513,
	    showTime: 2,
	    title: "Military control at a partial checkpoint"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 518,
	    showTime: 6,
	    title: "Al Fawwar refugee camp"
	}, {
	    type: "annotation",
	    position: "bottom-left",
	    time: 535,
	    showTime: 2,
	    title: "Army jeep"
	}, {
	    type: "annotation",
	    position: "bottom-left",
	    time: 539,
	    showTime: 4,
	    title: "Straight ahead former route 60 enters Hebron"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 546,
	    showTime: 3,
	    title: "Haggai settlement"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 551,
	    showTime: 2,
	    title: "Observation tower"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 554,
	    showTime: 2,
	    title: "Israeli police"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 573,
	    showTime: 3,
	    title: "Entrance to area A with a roadblock"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 579,
	    showTime: 4,
	    title: "Military base"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 585,
	    showTime: 2,
	    title: "Hebron"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 589,
	    showTime: 3,
	    title: "Observation tower"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 596,
	    showTime: 2,
	    title: "Entrance to area A with a checkpoint"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 602,
	    showTime: 4,
	    title: "Military base"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 609,
	    showTime: 3,
	    title: "Exit to the Cave of the Patriarchs"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 613,
	    showTime: 3,
	    title: "Entrance to Area A, open road gate"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 632,
	    showTime: 5,
	    title: "Exit to Kiryat Arba settlement"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 638,
	    showTime: 20,
	    title: "Kiryat Arba settlement"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 669,
	    showTime: 3,
	    title: "Army jeep"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 675,
	    showTime: 3,
	    title: "Exit to the Palestinian villages Sa’ir and Beit Einun"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 680,
	    showTime: 5,
	    title: "Ras al Joura checkpoint"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 686,
	    showTime: 2,
	    title: "Entrance to Area A"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 692,
	    showTime: 3,
	    title: "Observation tower"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 699,
	    showTime: 4,
	    title: "Fence to prevent stone throwers"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 714,
	    showTime: 3,
	    title: "Open road gate to Al Arrub refugee camp"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 720,
	    showTime: 3,
	    title: "Israeli armored cars with observation tower"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 725,
	    showTime: 3,
	    title: "Light armored cars with soldiers"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 759,
	    showTime: 4,
	    title: "Rami Levy supermarket"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 797,
	    showTime: 4,
	    title: "Gush Etzion checkpoint"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 803,
	    showTime: 5,
	    title: "Secured bus stop"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 822,
	    showTime: 3,
	    title: "Soldiers are checking a Palestinian car"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 826,
	    showTime: 2,
	    title: "Military tower"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 831,
	    showTime: 2,
	    title: "Soldiers"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 837,
	    showTime: 4,
	    title: "Efrat settlement"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 848,
	    showTime: 4,
	    title: "Bethlehem"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 854,
	    showTime: 4,
	    title: "Exit to the former route 60 through Bethlehem"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 867,
	    showTime: 3,
	    title: "Open roadblock to the entrance of Area A"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 872,
	    showTime: 3,
	    title: "Former route 60 through Bethlehem"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 880,
	    showTime: 6,
	    title: "Separation wall"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 890,
	    showTime: 4,
	    title: "Behind the wall, the Palestinian villages Al Khadr en Bethlehem"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 896,
	    showTime: 2,
	    title: "Roadblock"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 902,
	    showTime: 3,
	    title: "Observation tower"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 910,
	    showTime: 2,
	    title: "Military armored car"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 916,
	    showTime: 3,
	    title: "Separation wall"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 922,
	    showTime: 3,
	    title: "Soldiers"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 928,
	    showTime: 3,
	    title: "Tunnel checkpoint"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 931,
	    showTime: 2,
	    title: "Rumble strips against speed and explosives"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 937,
	    showTime: 6,
	    title: "From here on, cars with Palestinian plates are not allowed to continue on route 60"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 976,
	    showTime: 5,
	    title: "Tunnels underneath the Palestinian village Beit Jala"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 982,
	    showTime: 2,
	    title: "Separation wall on both sides of the road"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 987,
	    showTime: 2,
	    title: "Gilo settlement"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 991,
	    showTime: 2,
	    title: "Jerusalem"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1012,
	    showTime: 4,
	    title: "This is again the former route 60 towards Bethlehem"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1030,
	    showTime: 4,
	    title: "Separation wall with Bethlehem behind it"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1038,
	    showTime: 3,
	    title: "Entrance to Rachel's tomb"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1051,
	    showTime: 5,
	    title: "Beginning of the municipal border of Jerusalem, according to Israel"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1138,
	    showTime: 3,
	    title: "Green Line"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1158,
	    showTime: 4,
	    title: "the Church of the Dormition, the place where Mary died"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1165,
	    showTime: 5,
	    title: "Behind this mountain you find the Wailing Wall and the Al Aqsa Mosque"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1176,
	    showTime: 4,
	    title: "The wall around the Old City, built by the Ottomans"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1182,
	    showTime: 3,
	    title: "Tower of David"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1208,
	    showTime: 5,
	    title: "The Dome of the Rock"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1223,
	    showTime: 12,
	    title: "Damascus Gate"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1254,
	    showTime: 6,
	    title: "The Green Line"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1277,
	    showTime: 2,
	    title: "The Green Line"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1280,
	    showTime: 2,
	    title: "East-Jerusalem"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1283,
	    showTime: 2,
	    title: "West-Jerusalem"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1315,
	    showTime: 4,
	    title: "The Jewish neighborhood French Hill"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1325,
	    showTime: 2,
	    title: "Shuafat refugee camp"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 1333,
	    showTime: 3,
	    title: "The Palestinian neighborhood Beit Hanina"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1348,
	    showTime: 5,
	    title: "Settler bus"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1376,
	    showTime: 2,
	    title: "Pisgat Ze'ev settlement"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1381,
	    showTime: 5,
	    title: "Al Ram"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1392,
	    showTime: 6,
	    title: "The Separation wall with the Palestinian village Al Ram behind it"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1423,
	    showTime: 4,
	    title: "Qalandia checkpoint"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1431,
	    showTime: 4,
	    title: "Route 60 enters Area A"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1438,
	    showTime: 6,
	    title: "It is forbidden for Israeli citizens to enter"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1469,
	    showTime: 4,
	    title: "Cars and people on the way to Jerusalem are checked"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1479,
	    showTime: 3,
	    title: "Separation wall"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1511,
	    showTime: 3,
	    title: "Al Ram"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1516,
	    showTime: 6,
	    title: "Warning from route planner Waze for 'dangerous' area"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1535,
	    showTime: 3,
	    title: "Al Ram"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1604,
	    showTime: 3,
	    title: "Jaba checkpoint"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1608,
	    showTime: 2,
	    title: "Observation tower"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1612,
	    showTime: 4,
	    title: "Rumble strips against speed and explosives"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1620,
	    showTime: 4,
	    title: "Psagot settlement"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1633,
	    showTime: 5,
	    title: "The Palestinian village Burqa"
	}, {
	    type: "annotation",
	    position: "top-left",
	    time: 1650,
	    showTime: 2,
	    title: "Burqa"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1680,
	    showTime: 3,
	    title: "Observation tower"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1693,
	    showTime: 5,
	    title: "Ofra settlement"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1698,
	    showTime: 5,
	    title: "Amona outpost"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1706,
	    showTime: 3,
	    title: "Fence around Ofra settlement"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1725,
	    showTime: 5,
	    title: "Entrance to Ofra settlement"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1736,
	    showTime: 3,
	    title: "Secured bus stop with soldiers guarding"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1741,
	    showTime: 2,
	    title: "Observation tower"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1747,
	    showTime: 4,
	    title: "Military base"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1757,
	    showTime: 4,
	    title: "Shilo settlement"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1761,
	    showTime: 4,
	    title: "Shilo settlement"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1775,
	    showTime: 3,
	    title: "A settler bus followed by a Palestinian taxi bus"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1786,
	    showTime: 4,
	    title: "Observation balloon with camera"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1792,
	    showTime: 2,
	    title: "Rechelim South settlement"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1796,
	    showTime: 3,
	    title: "Tappuah checkpoint"
	}, {
	    type: "annotation",
	    position: "top-right",
	    time: 1803,
	    showTime: 3,
	    title: "Military tower"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1811,
	    showTime: 2,
	    title: "Military tower"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1818,
	    showTime: 2,
	    title: "Guarding soldiers at a bus stop"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1825,
	    showTime: 4,
	    title: "The Palestinian village Huwwara"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1832,
	    showTime: 2,
	    title: "Roundabout sponsored by USAID"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1853,
	    showTime: 2,
	    title: "Yitzhar settlement"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1856,
	    showTime: 6,
	    title: "Military base"
	}, {
	    type: "annotation",
	    position: "bottom-left",
	    time: 1889,
	    showTime: 2,
	    title: "Military distance markers"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1897,
	    showTime: 3,
	    title: "Military watchtower"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1907,
	    showTime: 3,
	    title: "Sarra-Jit checkpoint, entrance to Area A"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1912,
	    showTime: 2,
	    title: "Military watchtower"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1916,
	    showTime: 2,
	    title: "Military patrol"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1919,
	    showTime: 1,
	    title: "Military armored vehicle"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1929,
	    showTime: 4,
	    title: "Route 60 continues in area A"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1935,
	    showTime: 4,
	    title: "Entry forbidden for Israeli citizens"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 1943,
	    showTime: 3,
	    title: "The Palestinian village Deir Sharaf"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1954,
	    showTime: 3,
	    title: "Shavei Shomron settlement"
	}, {
	    type: "annotation",
	    position: "center-left",
	    time: 1958,
	    showTime: 3,
	    title: "Wall around Shavei Shomron settlement"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 1963,
	    showTime: 2,
	    title: "Shavei Shomron checkpoint"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 1968,
	    showTime: 1,
	    title: "Military jeep"
	}, {
	    type: "annotation",
	    position: "center-top",
	    time: 1980,
	    showTime: 10,
	    title: "The Palestinian city Jenin"
	}, {
	    type: "annotation",
	    position: "center-right",
	    time: 2018,
	    showTime: 4,
	    title: "Palestinian officer"
	}, {
	    type: "annotation",
	    position: "center-bottom",
	    time: 2033,
	    showTime: 5,
	    title: "Palestinian security forces"
	}, {
	    type: "annotation",
	    position: "bottom-right",
	    time: 2046,
	    showTime: 2,
	    title: "Palestinian police"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 2084,
	    showTime: 4,
	    title: "On the way to the border with Israel"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 2117,
	    showTime: 6,
	    title: "Al Jalama checkpoint"
	}, {
	    type: "annotation",
	    position: "center-center",
	    time: 2130,
	    showTime: 12,
	    title: "The border with Israel on the Green Line"
	}];

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _constants = __webpack_require__(14);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _story = __webpack_require__(259);
	
	var _story2 = _interopRequireDefault(_story);
	
	var _story3 = __webpack_require__(260);
	
	var _story4 = _interopRequireDefault(_story3);
	
	var _story5 = __webpack_require__(261);
	
	var _story6 = _interopRequireDefault(_story5);
	
	var _story7 = __webpack_require__(262);
	
	var _story8 = _interopRequireDefault(_story7);
	
	var _story9 = __webpack_require__(263);
	
	var _story10 = _interopRequireDefault(_story9);
	
	var _story11 = __webpack_require__(264);
	
	var _story12 = _interopRequireDefault(_story11);
	
	var _story13 = __webpack_require__(265);
	
	var _story14 = _interopRequireDefault(_story13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageFolder = _constants2.default.IMAGE_FOLDER;
	
	exports.default = [{
	    type: "story",
	    time: 668,
	    title: "The Teenager",
	    link: {
	        url: _constants2.default.STORY_URL + 'depuber',
	        label: "Read Story"
	    },
	    location: {
	        name: "Gush Etzion"
	    },
	    readingTime: "Time to read: 6 min",
	    excerpt: "Emuna is fourteen years old. She had a dance performance, together with her friend Hallel but just before the performance, Hallel was stabbed to death. In her very own bedroom. ",
	    body: _story2.default,
	    image: {
	        mobile: imageFolder + 'depuber/omslag__mobile.jpg',
	        tablet: imageFolder + 'depuber/omslag.jpg',
	        desktop: imageFolder + 'depuber/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 797,
	    title: "The Discounter",
	    link: {
	        url: _constants2.default.STORY_URL + 'dekiloknaller',
	        label: "Watch Video"
	    },
	    location: {
	        name: "Gush Etzion"
	    },
	    readingTime: "Time to watch: 6 min ",
	    excerpt: "Both settlers and Palestinians buy their chicken at Rami Levy, the cheapest supermarket in the area. But the low-priced grocery store is located in a settlement. The Jews are allowed weapons, the Palestinians are not.",
	    body: _story4.default,
	    image: {
	        mobile: imageFolder + 'dekiloknaller/omslag__mobile.jpg',
	        tablet: imageFolder + 'dekiloknaller/omslag.jpg',
	        desktop: imageFolder + 'dekiloknaller/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 1039,
	    title: "The Holy Rachel",
	    link: {
	        url: _constants2.default.STORY_URL + 'deheilige',
	        label: "Read Story"
	    },
	    location: {
	        name: "Bethlehem"
	    },
	    readingTime: "Time to read: 7 min",
	    excerpt: "The tomb of the matriarch Rachel lies in Bethlehem, but can only be reached from Israel. Is this biblical heartland, or the essence of colonial logic?",
	    body: _story6.default,
	    image: {
	        mobile: imageFolder + 'deheilige/omslag__mobile.jpg',
	        tablet: imageFolder + 'deheilige/omslag.jpg',
	        desktop: imageFolder + 'deheilige/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 1243,
	    title: "The Perseverer",
	    link: {
	        url: _constants2.default.STORY_URL + 'destandvastige',
	        label: "Watch Video"
	    },
	    location: {
	        name: "Jerusalem"
	    },
	    readingTime: "Time to watch: 5 min",
	    excerpt: "The Palestinian Sub Laban family lives in the Muslim quarter of the Old City of Jerusalem. In the old days, Jews used to live here. For that reason their house is now being expropriated.",
	    body: _story8.default,
	    image: {
	        mobile: imageFolder + 'destandvastige/omslag__mobile.jpg',
	        tablet: imageFolder + 'destandvastige/omslag.jpg',
	        desktop: imageFolder + 'destandvastige/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 1511,
	    title: "The Protester",
	    link: {
	        url: _constants2.default.STORY_URL + 'dedemonstrant',
	        label: "Watch Video"
	    },
	    location: {
	        name: "Ramallah"
	    },
	    readingTime: "Time to Watch: 8 min ",
	    excerpt: "His ‘nom de guerre’ is Tito. Every week, he sets out to protest against the Israeli army. It’s David versus Goliath, he says. But he has no choice.",
	    body: _story10.default,
	    image: {
	        mobile: imageFolder + 'dedemonstrant/omslag__mobile.jpg',
	        tablet: imageFolder + 'dedemonstrant/omslag.jpg',
	        desktop: imageFolder + 'dedemonstrant/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 1733,
	    title: "The Pioneer",
	    link: {
	        url: _constants2.default.STORY_URL + 'depionier',
	        label: "Watch Video"
	    },
	    location: {
	        name: "Amona"
	    },
	    readingTime: "Time to watch: 10 min",
	    excerpt: "The Jewish outpost Amona was built on the land of Palestinian farmers. The Palestinians initiated a lawsuit and won, thanks to a Jewish Israeli activist.",
	    body: _story12.default,
	    image: {
	        mobile: imageFolder + 'depionier/omslag__mobile.jpg',
	        tablet: imageFolder + 'depionier/omslag.jpg',
	        desktop: imageFolder + 'depionier/omslag.jpg',
	        alt: ""
	    }
	}, {
	    type: "story",
	    time: 2013,
	    title: "Friends",
	    link: {
	        url: _constants2.default.STORY_URL + 'devrienden',
	        label: "Read Story"
	    },
	    location: {
	        name: "Jenin"
	    },
	    readingTime: "Time to read: 7 min",
	    excerpt: "These boys were around ten years old when the Israeli army destroyed a part of their refugee camp in 2002. They are still friends.",
	    body: _story14.default,
	    image: {
	        mobile: imageFolder + 'devrienden/omslag__mobile.jpg',
	        tablet: imageFolder + 'devrienden/omslag.jpg',
	        desktop: imageFolder + 'devrienden/omslag.jpg',
	        alt: ""
	    }
	}];

/***/ },
/* 268 */
[642, 266, 267],
/* 269 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    videoName: "The Holy Road",
	    videos: {
	        id: "VideoEN",
	        mobile: {
	            src: "https://output.scrollytelling.io/theholyroad/videos/De_Weg_Eng28dec_(RES_12802).mp4",
	            type: "video/mp4"
	        },
	        desktop: {
	            src: "https://output.scrollytelling.io/theholyroad/videos/De_Weg_Eng28dec_(MP4_2).mp4",
	            type: "video/mp4"
	        },
	        dash: {
	            src: "https://output.scrollytelling.io/v1/main/pageflow/video_files/000/002/319/dash/manifest.mpd",
	            type: "application/dash+xml"
	        },
	        hls: {
	            src: "https://output.scrollytelling.io/v1/main/pageflow/video_files/000/002/319/hls-fullhd.m3u8",
	            type: "application/x-mpegURL"
	        }
	    },
	    introText: "The Holy Road is an interactive web documentary about people living along side the holiest but also most controversial road through Israel and Palestine: Route 60.",
	    startRoute: "Start your journey",
	    rijVerder: "continue driving",
	    terugNaarRoadMovie: "BACK TO ROADMOVIE"
	};

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(75);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(20);
	
	var _redux = __webpack_require__(130);
	
	var _reduxResponsive = __webpack_require__(218);
	
	var _reduxThunk = __webpack_require__(604);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reactRouter = __webpack_require__(81);
	
	var _routes = __webpack_require__(271);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	__webpack_require__(631);
	
	var _reducers = __webpack_require__(273);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _redux.createStore)(_reducers2.default, (0, _redux.compose)(_reduxResponsive.responsiveStoreEnhancer, (0, _redux.applyMiddleware)(_reduxThunk2.default)));
	
	// Store
	
	
	_reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    (0, _routes2.default)(_reactRouter.browserHistory, store)
	), document.getElementById('root'));

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(81);
	
	var _App = __webpack_require__(227);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _timeline = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function routes(history, store) {
	
	    function loadStory(store, nextState) {
	        store.dispatch((0, _timeline.goToStoryBySlug)(nextState.params.slug));
	
	        document.body.scrollTop = document.documentElement.scrollTop = 0;
	    }
	
	    function loadLanguage(store, nextState) {
	        store.dispatch((0, _timeline.setLanguage)(nextState.params.language));
	    }
	
	    return _react2.default.createElement(
	        _reactRouter.Router,
	        Object.assign({ history: history }, store),
	        _react2.default.createElement(_reactRouter.Route, { path: '/(:language/)pagina/about', component: _App2.default, onEnter: function onEnter(nextState) {
	                loadLanguage(store, nextState);
	            } }),
	        _react2.default.createElement(_reactRouter.Route, { path: '/(:language/)artikel/:slug',
	            component: _App2.default, onEnter: function onEnter(nextState) {
	                loadStory(store, nextState);
	                loadLanguage(store, nextState);
	            } }),
	        _react2.default.createElement(_reactRouter.Route, { path: '/(:language)',
	            component: _App2.default, onEnter: function onEnter(nextState) {
	                loadStory(store, nextState);
	                loadLanguage(store, nextState);
	            } })
	    );
	}

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	
	
	    switch (action.type) {
	
	        case _timeline.SET_LANGUAGE:
	            // Make language en / nl
	            var language = action.payload;
	
	            // NL
	            if (language === "nl") {
	                return Object.assign({}, state, {
	                    body: _about4.default
	                });
	            }
	
	            // EN
	            return Object.assign({}, state, {
	                body: _about2.default
	            });
	
	        default:
	
	            return state;
	
	    }
	};
	
	var _timeline = __webpack_require__(19);
	
	var _about = __webpack_require__(244);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _about3 = __webpack_require__(246);
	
	var _about4 = _interopRequireDefault(_about3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = {
	    body: _about2.default
	};

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(130);
	
	var _reduxResponsive = __webpack_require__(218);
	
	var _timeline = __webpack_require__(275);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _video = __webpack_require__(276);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _about = __webpack_require__(272);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _maps = __webpack_require__(274);
	
	var _maps2 = _interopRequireDefault(_maps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	    timeline: _timeline2.default,
	    video: _video2.default,
	    about: _about2.default,
	    maps: _maps2.default,
	    responsive: (0, _reduxResponsive.createResponsiveStateReducer)({
	        mobile: 650,
	        tablet: 750,
	        desktop: 1200
	    })
	});
	
	exports.default = rootReducer;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _maps2.default;
	    var action = arguments[1];
	
	
	    switch (action.type) {
	
	        case _timeline.SET_LANGUAGE:
	            // Make language en / nl
	            var language = action.payload;
	
	            // NL
	            if (language === "nl") {
	                return _maps4.default;
	            }
	
	            // EN
	            return _maps2.default;
	
	        default:
	
	            return state;
	
	    }
	};
	
	var _timeline = __webpack_require__(19);
	
	var _maps = __webpack_require__(245);
	
	var _maps2 = _interopRequireDefault(_maps);
	
	var _maps3 = __webpack_require__(247);
	
	var _maps4 = _interopRequireDefault(_maps3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _timeline = __webpack_require__(19);
	
	var _timeline2 = __webpack_require__(268);
	
	var _timeline3 = _interopRequireDefault(_timeline2);
	
	var _timeline4 = __webpack_require__(257);
	
	var _timeline5 = _interopRequireDefault(_timeline4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = {
	    data: _timeline3.default,
	    showStory: false,
	    storyIsOpen: false,
	    isDriving: false,
	    currentTime: 0,
	    currentTimePerSecond: 0,
	    videoDuration: 0,
	    seekVideo: false,
	    isMenuOpen: false,
	    tripStarted: false,
	    audioMuted: false
	};
	
	function timelineReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	
	
	    switch (action.type) {
	        case _timeline.UPDATE_CURRENT_TIME:
	            {
	                var currentTime = parseInt(action.payload, 10);
	
	                return Object.assign({}, state, {
	                    currentTimePerSecond: currentTime,
	                    currentTime: action.payload
	                });
	            }
	
	        case _timeline.FIND_STORY:
	            {
	                var _currentTime = parseInt(action.payload, 10);
	
	                // Call only once per second
	                if (_currentTime === state.currentTimePerSecond) return state;
	
	                // Find story
	                var story = state.data.find(function (item) {
	                    return item.time === _currentTime;
	                });
	
	                // Show story
	                if (story && story.type === "story" && story.time !== state.showStory.time) {
	                    return Object.assign({}, state, {
	                        showStory: story,
	                        isDriving: false
	                    });
	                }
	
	                // Show annotation
	                if (story && story.type === "annotation") {
	                    return Object.assign({}, state, {
	                        showStory: story
	                    });
	                }
	
	                // Hide annotations after X amount of seconds (showTime)
	                if (state.showStory.type === "annotation" && _currentTime - state.showStory.time > state.showStory.showTime) return Object.assign({}, state, {
	                    showStory: false
	                });
	
	                // Hide story after X amount of seconds
	                if (state.showStory.type === "story" && _currentTime - state.showStory.time > 1) {
	                    return Object.assign({}, state, {
	                        showStory: false
	                    });
	                }
	
	                return state;
	            }
	
	        case _timeline.START_DRIVING:
	            return Object.assign({}, state, {
	                isDriving: true
	            });
	
	        case _timeline.PAUSE_DRIVING:
	            return Object.assign({}, state, {
	                isDriving: false
	            });
	
	        case _timeline.START_TRIP:
	            return Object.assign({}, state, {
	                tripStarted: true,
	                isDriving: true
	            });
	
	        case _timeline.START_OVER:
	            return Object.assign({}, state, {
	                seekVideo: 0,
	                isDriving: false,
	                tripStarted: false
	            });
	
	        case _timeline.SET_VIDEO_DURATION:
	            return Object.assign({}, state, {
	                videoDuration: action.payload
	            });
	
	        case _timeline.SEEK_VIDEO:
	            return Object.assign({}, state, {
	                seekVideo: action.payload
	            });
	
	        case _timeline.GO_TO_STORY:
	            return Object.assign({}, state, {
	                showStory: action.payload,
	                isDriving: false
	            });
	
	        case _timeline.OPEN_STORY:
	            return Object.assign({}, state, {
	                storyIsOpen: action.payload
	            });
	
	        case _timeline.OPEN_MENU:
	            return Object.assign({}, state, {
	                isMenuOpen: action.payload
	            });
	
	        case _timeline.MUTE_AUDIO:
	            return Object.assign({}, state, {
	                audioMuted: action.payload
	            });
	
	        case _timeline.SET_LANGUAGE:
	            // Make language en / nl
	            var language = action.payload;
	            var showStory = state.showStory;
	
	
	            var timelineTranslation = language === "nl" ? _timeline5.default : _timeline3.default;
	
	            var showStoryTranslation = showStory && showStory.type === "story" ? timelineTranslation.find(function (story) {
	                return story.type === "story" && showStory.link.url.split('/').pop() === story.link.url.split('/').pop(); // TODO: add slug or id in data, instead of pop
	            }) : false;
	
	            return Object.assign({}, state, {
	                data: timelineTranslation,
	                language: language === "nl" ? "nl" : "",
	                showStory: showStoryTranslation
	            });
	
	        default:
	
	            return state;
	    }
	}
	
	exports.default = timelineReducer;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _video2.default;
	    var action = arguments[1];
	
	
	    switch (action.type) {
	
	        case _timeline.SET_LANGUAGE:
	            // Make language en / nl
	            var language = action.payload;
	
	            // NL
	            if (language === "nl") {
	                return _video4.default;
	            }
	
	            // EN
	            return _video2.default;
	
	        default:
	
	            return state;
	
	    }
	};
	
	var _timeline = __webpack_require__(19);
	
	var _video = __webpack_require__(269);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _video3 = __webpack_require__(258);
	
	var _video4 = _interopRequireDefault(_video3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 277 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 278 */
/***/ function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".About{position:absolute;left:0;top:0;width:100%;pointer-events:none;z-index:100;color:#000;background-color:#fff;z-index:999;display:none}.About--open{display:block}.About__close span{background-color:#000}.About__inner{width:100%;margin:0 auto;color:#000;padding-bottom:40px;max-width:1000px}", ""]);
	
	// exports


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".Annotation{display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end;-ms-flex-pack:center;justify-content:center;position:fixed;left:0;top:0;width:100%;height:100%;z-index:50;color:#000;pointer-events:none}@media (min-width:900px){.Annotation{-ms-flex-align:center;align-items:center;position:absolute}}.Annotation__container{margin:30px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;background-color:#fff;border-radius:5px}@media (min-width:900px){.Annotation__container{position:absolute;background-color:transparent;color:#fff;width:30%;max-width:400px}.Annotation__container--bottom-right{right:18%;bottom:10%}.Annotation__container--bottom-left{bottom:10%;left:11%}.Annotation__container--center-right{top:45%;right:13%}.Annotation__container--center-left{top:47%;left:13%}.Annotation__container--top-left{top:15%;left:12%}.Annotation__container--top-right{top:11%;right:13%}.Annotation__container--center-top{left:39%;top:13%}.Annotation__container--center-bottom{left:41%;bottom:13%}}.Annotation__title{position:relative;padding:10px 5px;font-size:14px;line-height:14px}@media (min-width:900px){.Annotation__title{font-size:18px;line-height:18px;margin-left:10px;text-shadow:1px 1px 2px #000}}.Annotation__icon{width:20px;height:20px;-ms-flex:none;flex:none;margin-left:5px;background-color:#00ff40;color:#000;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}", ""]);
	
	// exports


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".container,body,html{margin:0;padding:0;font-family:Roboto,sans-serif}#root,body,html{height:100%}body{background-color:#000;color:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}body:-webkit-full-screen{width:100%;overflow-y:auto;position:relative;-webkit-overflow-scrolling:touch}h1,h2,h3,h4,h5,h6{margin:0;font-family:Stanley,serif;font-weight:400}h1{font-size:40px}a{text-decoration:none}a.active{border-bottom:1px solid #00ff40;padding-bottom:5px}p{margin:0;letter-spacing:.5px;line-height:24px;font-size:16px}.App{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:100%}", ""]);
	
	// exports


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".DetailPage{letter-spacing:.8px;font-family:PT Serif,serif;font-size:18px;line-height:26px;position:absolute;left:0;top:0;width:100%;height:100%;padding:0;margin:0;z-index:40;color:#000;pointer-events:none}.DetailPage__inner{width:90vw;background-color:#fff;top:-100%;margin:0 auto;-ms-transform:translateY(-50%);transform:translateY(-50%);animation:slideInDown .3s 1;animation-delay:.3s;animation-fill-mode:forwards;animation-timing-function:ease-out;max-width:500px;position:relative;pointer-events:all;max-height:85%;min-height:200px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}@media (max-height:600px),(max-width:649px){.DetailPage__inner{transition:top .4s}}@media (max-height:440px){.DetailPage__inner{padding-top:10px}}.DetailPage__inner--open{width:100%;min-height:calc(100% - 50px);max-width:1000px;pointer-events:all;max-height:none;-ms-transform:translateY(0);transform:translateY(0);font-family:PT Serif,serif;top:100%;animation:slideInOpen .2s 1;animation-delay:.3s;animation-fill-mode:forwards}@media (min-width:900px){.DetailPage__inner--open{animation-delay:0s;margin-top:40px;margin-bottom:80px}}@media (max-height:440px){.DetailPage__inner--open{padding-top:0}}.DetailPage__inner--menuOpen{opacity:.5}.DetailPage__preview{text-align:center;font-family:Roboto,sans-serif;font-size:14px}@media (max-height:600px),(max-width:649px){.DetailPage__preview{font-size:12px}}.DetailPage__preview p{font-size:16px;margin:0 20px}@media (max-height:600px),(max-width:649px){.DetailPage__preview p{font-size:12px;line-height:18px}}@media (max-height:440px){.DetailPage__preview p{display:none}}.DetailPage__preview--open{display:none}.DetailPage__headerImage{overflow:hidden;line-height:0}@media (max-height:440px){.DetailPage__headerImage{display:none}}.DetailPage__headerImage--open{overflow:inherit}@media (max-height:440px){.DetailPage__headerImage--open{display:block}}.DetailPage__headerImage img{width:100%;height:auto}.DetailPage__body{margin:40px 0}@media (max-height:600px),(max-width:649px){.DetailPage__body{margin:20px 0}}.DetailPage__pageWrapper{display:none}.DetailPage__pageWrapper--open{display:block}.DetailPage__meta{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;margin-bottom:15px;font-size:14px}@media (max-height:600px),(max-width:649px){.DetailPage__meta{font-size:12px}}.DetailPage__meta__location{margin-right:10px}.DetailPage__meta__location svg{margin-bottom:-2px}.DetailPage__meta__readingTime{margin-left:10px}.DetailPage__meta label{margin-left:7px;font-family:Roboto,sans-serif}.DetailPage__meta svg{-ms-transform:scale(1.3);transform:scale(1.3)}.DetailPage__back-button{width:30px;height:30px;border-radius:50%;position:fixed;left:20px;top:20px;background-color:#00ff40;display:inline-block;pointer-events:all}.DetailPage__title{margin-bottom:10px;display:block;text-align:center}.DetailPage__excerpt{max-width:450px;margin:0 auto}.DetailPage__button{text-transform:uppercase;border:1px solid #393939;color:#393939;background-color:#fff;padding:18px 20px;transition:all .2s;display:inline-block;letter-spacing:.8px;border-radius:6px;font-size:14px;line-height:14px;cursor:pointer;margin-top:20px;margin-bottom:8px;pointer-events:all}.DetailPage__button:hover{background-color:#000;color:#fff}@media (max-height:600px),(max-width:649px){.DetailPage__button{font-size:12px}}@media (max-height:440px){.DetailPage__button{margin-top:10px}}.DetailPage__drive-link{text-transform:uppercase;text-align:center;padding:10px;cursor:pointer;pointer-events:all}@keyframes slideInDown{0%{top:-100%}to{top:50%}}@keyframes slideInOpen{0%{top:110vh}to{top:50px}}", ""]);
	
	// exports


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".EndOfStory{line-height:0}.EndOfStory,.EndOfStory__inner{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:100%;font-family:Roboto,sans-serif}.EndOfStory__inner{margin-top:20px;text-align:center;padding:40px 0;max-width:700px;margin:0 auto;letter-spacing:.5px;line-height:24px;font-size:16px;color:#393939;font-size:14px;line-height:19px}@media (max-width:740px){.EndOfStory__inner{margin-left:20px;margin-right:20px}}@media (max-height:600px),(max-width:649px){.EndOfStory__inner{font-size:12px;line-height:17px}}@media (min-width:900px){.EndOfStory__inner{font-size:14px}}.EndOfStory__inner a{margin-top:20px}.EndOfStory__inner a:hover{cursor:pointer}", ""]);
	
	// exports


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".Iframe{margin:20px 0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.Iframe__vertical-spacer{width:1px;height:40px;background-color:#00ff40;margin:10px 0}.Iframe iframe{width:100%;height:567px}@media (min-width:650px) and (max-width:899px){.Iframe iframe{height:450px}}@media (max-height:600px),(max-width:649px){.Iframe iframe{height:350px}}.Iframe__inner{margin-top:20px;width:100%}.Iframe__text{max-width:700px;margin:0 auto;letter-spacing:.5px;line-height:24px;font-size:16px;color:#393939;font-family:Roboto,sans-serif;font-size:14px;line-height:19px}@media (max-width:740px){.Iframe__text{margin-left:20px;margin-right:20px}}@media (max-height:600px),(max-width:649px){.Iframe__text{font-size:12px;line-height:17px}}", ""]);
	
	// exports


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".Image{line-height:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.Image img,.Image picture{width:100%}.Image__inner{margin-top:20px;width:100%}.Image__text{max-width:700px;margin:0 auto;letter-spacing:.5px;line-height:24px;font-size:16px;color:#393939;font-family:Roboto,sans-serif;font-size:14px;line-height:19px;text-align:left}@media (max-width:740px){.Image__text{margin-left:20px;margin-right:20px}}@media (max-height:600px),(max-width:649px){.Image__text{font-size:12px;line-height:17px}}", ""]);
	
	// exports


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".Paragraph{margin:20px 0;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;color:#393939}.Paragraph p{font-size:18px;line-height:28px}@media (max-height:600px),(max-width:649px){.Paragraph,.Paragraph p{font-size:16px}.Paragraph p{line-height:24px}}.Paragraph__header{margin-top:40px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column}.Paragraph h3{font-size:16px;text-transform:uppercase;font-family:Roboto,sans-serif}.Paragraph__inner{max-width:700px;margin:0 auto}@media (max-width:740px){.Paragraph__inner{margin-left:20px;margin-right:20px}}.Paragraph__vertical-spacer{width:1px;height:40px;background-color:#00ff40;margin:10px 0;margin-top:5px}", ""]);
	
	// exports


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".Quote{text-align:center;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column}.Quote__vertical-spacer{width:1px;height:40px;background-color:#00ff40;margin:10px 0}.Quote__text{max-width:500px;text-align:center;font-family:PT Serif,serif;font-size:22px;line-height:30px;max-width:700px;margin:0 auto}@media (max-width:740px){.Quote__text{margin-left:20px;margin-right:20px}}.Quote__person{margin-top:10px;letter-spacing:.5px;line-height:24px;font-size:16px;color:#393939;font-family:Roboto,sans-serif;font-size:14px;line-height:19px}@media (max-height:600px),(max-width:649px){.Quote__person{font-size:12px;line-height:17px}}.Quote__person:empty{display:none}", ""]);
	
	// exports


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".Slider{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;letter-spacing:.5px;line-height:24px;font-size:16px;color:#393939;font-family:Roboto,sans-serif;font-size:14px;line-height:19px}@media (max-height:600px),(max-width:649px){.Slider{font-size:12px;line-height:17px}}.Slider__Carousel{width:100%;min-height:0;min-width:0}.Slider img,.Slider picture{width:100%}.Slider__vertical-spacer{width:1px;height:40px;background-color:#00ff40;margin:10px 0}.Slider__ControlArrow{display:block;padding-left:20px;position:absolute;z-index:10;cursor:pointer;top:calc(50% - 70px);height:100px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}@media (max-height:600px),(max-width:649px){.Slider__ControlArrow{-ms-transform:scale(.7);transform:scale(.7)}}.Slider__ControlArrow span{width:60px;height:2px;background-color:#00ff40;display:block;transition:all .2s;margin-top:70px}.Slider__ControlArrow span:first-child{-ms-transform:rotate(45deg);transform:rotate(45deg)}.Slider__ControlArrow span:last-child{-ms-transform:rotate(-45deg);transform:rotate(-45deg);margin-top:-44px}.Slider__ControlArrow:hover>span{background-color:#00ff40}.Slider__ControlArrow--right{right:0;margin-left:0;padding-right:20px;padding-left:0}.Slider__ControlArrow--right span:first-child{-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.Slider__ControlArrow--right span:last-child{-ms-transform:rotate(45deg);transform:rotate(45deg);margin-top:-44px}", ""]);
	
	// exports


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, "picture{line-height:0}", ""]);
	
	// exports


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".Maps{height:100%;width:100%}.Maps text[font-family=Stanley]{font-family:Stanley,serif;font-weight:400}.Maps text[font-family=\"Roboto-Regular, Roboto\"]{font-family:Roboto,sans-serif;text-transform:uppercase}.Maps .slick-list,.Maps .slick-slider,.Maps .slick-track{height:100%;width:100%}.Maps .slick-dots{position:fixed;bottom:20px;z-index:9;pointer-events:none}.Maps .slick-dots li{pointer-events:all}.Maps .slick-dots li button:before{color:#fff;font-size:20px}.Maps .slick-dots li.slick-active button:before{color:#fff}.Maps__slide{height:100%;width:100%}.Maps__map{height:calc(100% - 90px);margin-bottom:40px;margin-top:50px;margin-right:8px;background-size:contain;background-position:50%;background-repeat:no-repeat}.Maps__map--westbank{background-image:url(\"/svg/mapWestbank.svg\")}.Maps__map--israel{background-image:url(\"/svg/mapIsrael.svg\")}", ""]);
	
	// exports


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".Navigation{width:100vw;height:100%;position:fixed;left:0;top:0;z-index:99;pointer-events:none}.Navigation a{color:#fff}.Navigation__toolbar{height:50px;background-size:180px;position:fixed;z-index:99;width:100vw;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;pointer-events:all}.Navigation__toolbar--storyOpen{background-color:#fff}.Navigation__audioToggle,.Navigation__fullScreenToggle,.Navigation__social{-ms-flex-item-align:start;align-self:flex-start;position:absolute;left:0;height:50px;width:50px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;pointer-events:all}.Navigation__audioToggle,.Navigation__fullScreenToggle{transition:all .2s}.Navigation__audioToggle:hover,.Navigation__fullScreenToggle:hover{cursor:pointer}.Navigation__audioToggle:hover>svg>g,.Navigation__fullScreenToggle:hover>svg>g{fill:#00ff40}.Navigation__audioToggle:hover>svg>g>g,.Navigation__fullScreenToggle:hover>svg>g>g{stroke:#00ff40}.Navigation__fullScreenToggle{left:30px;display:none}@media (max-height:600px),(max-width:649px){.Navigation__fullScreenToggle{display:-ms-flexbox;display:flex}}.Navigation__logo{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;pointer-events:all;cursor:pointer}.Navigation--open .Navigation__background{transition:opacity .3s linear 0s;opacity:.5;pointer-events:all}.Navigation--open .Navigation__overlay{transition:opacity .3s linear .4s;opacity:1;pointer-events:all}.Navigation__background{width:100vw;height:100%;background-color:#000;opacity:0;transition:opacity .2s;pointer-events:none}.Navigation__overlay{width:100vw;height:100%;position:absolute;top:0;display:-ms-flexbox;display:flex;transition:opacity .1s linear 0s;pointer-events:none}.Navigation__overlay--storyStarted{opacity:0}.Navigation__footer{-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;position:fixed;bottom:0;left:0;width:100%}.Navigation__footer__about{-ms-flex:1;flex:1;padding:20px;pointer-events:all}.Navigation__footer__about__link:hover{color:#00ff40;cursor:pointer}.Navigation__footer__language{-ms-flex:1;flex:1;text-align:right;padding:20px;pointer-events:all}.Navigation__footer__language a{margin:0 5px}.Navigation__burger{height:30px;width:40px;position:fixed;right:15px;top:10px;z-index:30;pointer-events:all;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around;-ms-flex-direction:column;flex-direction:column;cursor:pointer}.Navigation__burger:hover{opacity:1}.Navigation__burger span{display:block;height:1px;background-color:#fff;width:100%;transition:all .2s}.Navigation__burger--storyOpen span{background-color:#000}.Navigation__burger--x span{display:none}.Navigation__burger--x span:first-child{display:block;-ms-transform:rotate(45deg);transform:rotate(45deg)}.Navigation__burger--x span:last-child{display:block;-ms-transform:rotate(-45deg);transform:rotate(-45deg);margin-top:-30px}", ""]);
	
	// exports


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".NavigationMap{width:100%;height:100%;display:-ms-flexbox;display:flex;pointer-events:all}.NavigationMap text{transition:all .2s}.NavigationMap text:hover{fill:#00ff40;cursor:pointer}.NavigationMap__Circle,.NavigationMap circle{-ms-transform-origin:center;transform-origin:center;transition:all .2s}.NavigationMap__Circle:hover,.NavigationMap circle:hover{cursor:pointer;-ms-transform:scale(1.4);transform:scale(1.4)}", ""]);
	
	// exports


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".Splash{position:fixed;left:0;top:0;width:100vw;pointer-events:none;height:100%;z-index:30;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}@media (max-height:600px),(max-width:649px){.Splash{height:calc(100% - 25px)}}.Splash__logo{width:170px;height:140px;background-image:url(\"/svg/logo-splash.svg\");background-position:50%;background-repeat:no-repeat;background-size:contain;margin-bottom:15px}@media (max-height:600px),(max-width:649px){.Splash__logo{width:110px;height:80px}}@media (max-height:440px){.Splash__logo{height:60px}}.Splash__excerpt{width:80%;max-width:600px;font-family:PT Serif,serif;margin:10px 0;text-align:center}@media (min-width:900px){.Splash__excerpt{font-size:20px;line-height:28px}}.Splash__spacer{width:1px;height:40px;background-color:#00ff40}.Splash__button{pointer-events:all;text-transform:uppercase;border:1px solid #393939;color:#393939;background-color:#fff;padding:18px 20px;transition:all .2s;display:inline-block;letter-spacing:.8px;border-radius:6px;font-size:14px;line-height:14px;cursor:pointer;border-color:#00ff40;background-color:transparent;color:#fff}.Splash__button:hover{background-color:#000;color:#fff}@media (max-height:600px),(max-width:649px){.Splash__button{font-size:12px}}.Splash__button:hover{background-color:#00ff40;color:#000}", ""]);
	
	// exports


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".Map__timeline{position:fixed;right:0;top:60px;height:calc(100% - 80px);width:70px;z-index:20;-ms-transform:rotate(180deg);transform:rotate(180deg)}@media (min-width:900px){.Map__timeline{z-index:60}}.Map__timeline__line{border-left:1px dashed #fff;height:100%;right:35px;position:absolute}.Map__timeline__youAreHere{background-color:#00ff40;width:4px;right:33px;position:absolute}.Map__timeline__controller{height:100%;width:70px;right:0;position:absolute}.Map__timeline__controller__line{background-color:#00ff40;width:4px;margin:0 auto;pointer-events:none}.Map__dot{background-color:#fff;width:20px;height:20px;border-radius:50%;position:absolute;left:25px;transition:all .2s;cursor:pointer}@media (max-height:600px),(max-width:649px){.Map__dot{-ms-transform:scale(.8);transform:scale(.8)}}@media (max-height:440px){.Map__dot{-ms-transform:scale(.6);transform:scale(.6)}}.Map__dot:hover{-ms-transform:scale(1.5);transform:scale(1.5)}@media (max-height:600px),(max-width:649px){.Map__dot:hover{-ms-transform:scale(1);transform:scale(1)}}.Map__dot--active,.Map__dot--visited{background-color:#00ff40}.Map__dot--active{-ms-transform:scale(1.5);transform:scale(1.5)}@media (max-height:600px),(max-width:649px){.Map__dot--active{-ms-transform:scale(1);transform:scale(1)}}.Map__dot--you{border:5px solid #00ff40;left:20px;margin-top:-5px;background-color:transparent;-ms-transform:scale(.7);transform:scale(.7)}", ""]);
	
	// exports


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".Video{width:100vw;height:100%;overflow:hidden;display:-ms-flexbox;display:flex;position:fixed;bottom:0;top:0;left:0;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.Video__playButton{position:fixed;top:50%;left:50%;background-color:#00ff40;width:30px;height:30px;margin-left:-23px;margin-top:-23px;border-radius:50%;transition:all .2s;z-index:400;padding:15px;opacity:0;animation:fadeIn ease-in 1;animation-fill-mode:forwards;animation-duration:.3s;animation-delay:.2s}.Video__playButton svg{margin-left:2px}.Video__playButton:hover{cursor:pointer;-ms-transform:scale(1.2);transform:scale(1.2)}.Video video{min-width:100vw;min-height:100%;left:0;bottom:0}@media (max-height:440px){.Video video{width:100%}}.Video__container{transition:.2s;opacity:.25;position:relative}.Video__container--playing{opacity:1}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.signal{border:5px solid #00ff40;border-radius:70px;height:70px;width:70px;left:50%;margin:-35px 0 0 -35px;opacity:0;position:fixed;top:50%;z-index:999;animation:pulsate 1s ease-out;animation-iteration-count:infinite}@keyframes pulsate{0%{transform:scale(.1);opacity:0}50%{opacity:1}to{transform:scale(1.2);opacity:0}}", ""]);
	
	// exports


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	exports.i(__webpack_require__(298), "");
	exports.i(__webpack_require__(297), "");
	
	// module
	exports.push([module.id, "@font-face{font-family:Stanley;src:url(" + __webpack_require__(461) + ") format(\"woff\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@keyframes pulsate{0%{transform:scale(.1);opacity:0}50%{opacity:1}to{transform:scale(1.2);opacity:0}}body{margin:0}.bodyLoader{overflow:hidden}.loading{background-color:#000;width:100%;height:100%;position:fixed;z-index:99;top:0;left:0;transition:all .2s;opacity:1}.doneLoading{opacity:0;pointer-events:none}.signal{border:5px solid #00ff40;border-radius:70px;height:70px;width:70px;left:50%;margin:-35px 0 0 -35px;opacity:0;position:absolute;top:50%;animation:pulsate 1s ease-out;animation-iteration-count:infinite}", ""]);
	
	// exports


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".slick-loading .slick-list{background:#fff url(" + __webpack_require__(635) + ") 50% no-repeat}@font-face{font-family:slick;font-weight:400;font-style:normal;src:url(" + __webpack_require__(222) + ");src:url(" + __webpack_require__(222) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(460) + ") format(\"woff\"),url(" + __webpack_require__(636) + ") format(\"truetype\"),url(" + __webpack_require__(462) + "#slick) format(\"svg\")}.slick-next,.slick-prev{font-size:0;line-height:0;position:absolute;top:50%;display:block;width:20px;height:20px;padding:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer;border:none}.slick-next,.slick-next:focus,.slick-next:hover,.slick-prev,.slick-prev:focus,.slick-prev:hover{color:transparent;outline:none;background:transparent}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-family:slick;font-size:20px;line-height:1;opacity:.75;color:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-prev{left:-25px}[dir=rtl] .slick-prev{right:-25px;left:auto}.slick-prev:before{content:\"\\2190\"}[dir=rtl] .slick-prev:before{content:\"\\2192\"}.slick-next{right:-25px}[dir=rtl] .slick-next{right:auto;left:-25px}.slick-next:before{content:\"\\2192\"}[dir=rtl] .slick-next:before{content:\"\\2190\"}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{position:absolute;bottom:-25px;display:block;width:100%;padding:0;margin:0;list-style:none;text-align:center}.slick-dots li{position:relative;display:inline-block;margin:0 5px;padding:0}.slick-dots li,.slick-dots li button{width:20px;height:20px;cursor:pointer}.slick-dots li button{font-size:0;line-height:0;display:block;padding:5px;color:transparent;border:0;outline:none;background:transparent}.slick-dots li button:focus,.slick-dots li button:hover{outline:none}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{font-family:slick;font-size:6px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:\"\\2022\";text-align:center;opacity:.25;color:#000;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-dots li.slick-active button:before{opacity:.75;color:#000}", ""]);
	
	// exports


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(12)();
	// imports
	
	
	// module
	exports.push([module.id, ".slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-list,.slick-slider{position:relative;display:block}.slick-list{overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:none}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.slick-track{position:relative;top:0;left:0;display:block;margin-left:auto;margin-right:auto}.slick-track:after,.slick-track:before{display:table;content:\"\"}.slick-track:after{clear:both}.slick-loading .slick-track{visibility:hidden}.slick-slide{display:none;float:left;height:100%;min-height:1px}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-loading .slick-slide{visibility:hidden}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}.slick-arrow.slick-hidden{display:none}", ""]);
	
	// exports


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/* $Date: 2007-06-12 18:02:31 $ */ // from: http://bannister.us/weblog/2007/06/09/simple-base64-encodedecode-javascript/
	// Handles encode/decode of ASCII and Unicode strings.
	'use strict';var UTF8={};UTF8.encode = function(s){var u=[];for(var i=0;i < s.length;++i) {var c=s.charCodeAt(i);if(c < 0x80){u.push(c);}else if(c < 0x800){u.push(0xC0 | c >> 6);u.push(0x80 | 63 & c);}else if(c < 0x10000){u.push(0xE0 | c >> 12);u.push(0x80 | 63 & c >> 6);u.push(0x80 | 63 & c);}else {u.push(0xF0 | c >> 18);u.push(0x80 | 63 & c >> 12);u.push(0x80 | 63 & c >> 6);u.push(0x80 | 63 & c);}}return u;};UTF8.decode = function(u){var a=[];var i=0;while(i < u.length) {var v=u[i++];if(v < 0x80){ // no need to mask byte
	}else if(v < 0xE0){v = (31 & v) << 6;v |= 63 & u[i++];}else if(v < 0xF0){v = (15 & v) << 12;v |= (63 & u[i++]) << 6;v |= 63 & u[i++];}else {v = (7 & v) << 18;v |= (63 & u[i++]) << 12;v |= (63 & u[i++]) << 6;v |= 63 & u[i++];}a.push(String.fromCharCode(v));}return a.join('');};var BASE64={};(function(T){var encodeArray=function encodeArray(u){var i=0;var a=[];var n=0 | u.length / 3;while(0 < n--) {var v=(u[i] << 16) + (u[i + 1] << 8) + u[i + 2];i += 3;a.push(T.charAt(63 & v >> 18));a.push(T.charAt(63 & v >> 12));a.push(T.charAt(63 & v >> 6));a.push(T.charAt(63 & v));}if(2 == u.length - i){var v=(u[i] << 16) + (u[i + 1] << 8);a.push(T.charAt(63 & v >> 18));a.push(T.charAt(63 & v >> 12));a.push(T.charAt(63 & v >> 6));a.push('=');}else if(1 == u.length - i){var v=u[i] << 16;a.push(T.charAt(63 & v >> 18));a.push(T.charAt(63 & v >> 12));a.push('==');}return a.join('');};var R=(function(){var a=[];for(var i=0;i < T.length;++i) {a[T.charCodeAt(i)] = i;}a['='.charCodeAt(0)] = 0;return a;})();var decodeArray=function decodeArray(s){var i=0;var u=[];var n=0 | s.length / 4;while(0 < n--) {var v=(R[s.charCodeAt(i)] << 18) + (R[s.charCodeAt(i + 1)] << 12) + (R[s.charCodeAt(i + 2)] << 6) + R[s.charCodeAt(i + 3)];u.push(255 & v >> 16);u.push(255 & v >> 8);u.push(255 & v);i += 4;}if(u){if('=' == s.charAt(i - 2)){u.pop();u.pop();}else if('=' == s.charAt(i - 1)){u.pop();}}return u;};var ASCII={};ASCII.encode = function(s){var u=[];for(var i=0;i < s.length;++i) {u.push(s.charCodeAt(i));}return u;};ASCII.decode = function(u){for(var i=0;i < s.length;++i) {a[i] = String.fromCharCode(a[i]);}return a.join('');};BASE64.decodeArray = function(s){var u=decodeArray(s);return new Uint8Array(u);};BASE64.encodeASCII = function(s){var u=ASCII.encode(s);return encodeArray(u);};BASE64.decodeASCII = function(s){var a=decodeArray(s);return ASCII.decode(a);};BASE64.encode = function(s){var u=UTF8.encode(s);return encodeArray(u);};BASE64.decode = function(s){var u=decodeArray(s);return UTF8.decode(u);};})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"); /*The following polyfills are not used in dash.js but have caused multiplayer integration issues.
	 Therefore commenting them out.
	if (undefined === btoa) {
	    var btoa = BASE64.encode;
	}
	if (undefined === atob) {
	    var atob = BASE64.decode;
	}
	*/if(true){exports.decode = BASE64.decode;exports.decodeArray = BASE64.decodeArray;exports.encode = BASE64.encode;exports.encodeASCII = BASE64.encodeASCII;}
	//# sourceMappingURL=base64.js.map


/***/ },
/* 300 */
/***/ function(module, exports) {

	/*
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * author Digital Primates
	 * copyright dash-if 2012
	 */ /*
	 * var parent,
	 *     child,
	 *     properties = [
	                    {
	                        name: 'profiles',
	                        merge: false
	                    }
	                ];
	 *
	 * parent = {};
	 * parent.name = "ParentNode";
	 * parent.isRoor = false;
	 * parent.isArray = false;
	 * parent.children = [];
	 * parent.properties = properties;
	 *
	 * child = {};
	 * child.name = "ChildNode";
	 * child.isRoor = false;
	 * child.isArray = true;
	 * child.children = null;
	 * child.properties = properties;
	 * parent.children.push(child);
	 *
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function ObjectIron(map){var lookup,len,i; // create a list of top level items to search for
	lookup = [];for(i = 0,len = map.length;i < len;i += 1) {if(map[i].isRoot){lookup.push("root");}else {lookup.push(map[i].name);}}var mergeValues=function mergeValues(parentItem,childItem){var name,parentValue,childValue;if(parentItem === null || childItem === null){return;}for(name in parentItem) {if(parentItem.hasOwnProperty(name)){if(!childItem.hasOwnProperty(name)){childItem[name] = parentItem[name];}}}},mapProperties=function mapProperties(properties,parent,child){var i,len,property,parentValue,childValue;if(properties === null || properties.length === 0){return;}for(i = 0,len = properties.length;i < len;i += 1) {property = properties[i];if(parent.hasOwnProperty(property.name)){if(child.hasOwnProperty(property.name)){ // check to see if we should merge
	if(property.merge){parentValue = parent[property.name];childValue = child[property.name]; // complex objects; merge properties
	if(typeof parentValue === 'object' && typeof childValue === 'object'){mergeValues(parentValue,childValue);} // simple objects; merge them together
	else {if(property.mergeFunction != null){child[property.name] = property.mergeFunction(parentValue,childValue);}else {child[property.name] = parentValue + childValue;}}}}else { // just add the property
	child[property.name] = parent[property.name];}}}},mapItem=function mapItem(obj,node){var item=obj,i,len,v,len2,array,childItem,childNode,property;if(item.children === null || item.children.length === 0){return;}for(i = 0,len = item.children.length;i < len;i += 1) {childItem = item.children[i];if(node.hasOwnProperty(childItem.name)){if(childItem.isArray){array = node[childItem.name + "_asArray"];for(v = 0,len2 = array.length;v < len2;v += 1) {childNode = array[v];mapProperties(item.properties,node,childNode);mapItem(childItem,childNode);}}else {childNode = node[childItem.name];mapProperties(item.properties,node,childNode);mapItem(childItem,childNode);}}}},performMapping=function performMapping(source){var i,len,pi,pp,item,node,array;if(source === null){return source;}if(typeof source !== 'object'){return source;} // first look to see if anything cares about the root node
	for(i = 0,len = lookup.length;i < len;i += 1) {if(lookup[i] === "root"){item = map[i];node = source;mapItem(item,node);}} // iterate over the objects and look for any of the items we care about
	for(pp in source) {if(source.hasOwnProperty(pp) && pp != "__children"){pi = lookup.indexOf(pp);if(pi !== -1){item = map[pi];if(item.isArray){array = source[pp + "_asArray"];for(i = 0,len = array.length;i < len;i += 1) {node = array[i];mapItem(item,node);}}else {node = source[pp];mapItem(item,node);}} // now check this to see if he has any of the properties we care about
	performMapping(source[pp]);}}return source;};return {run:performMapping};}exports['default'] = ObjectIron;module.exports = exports['default'];
	//# sourceMappingURL=objectiron.js.map


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _index_mediaplayerOnly=__webpack_require__(302);var _srcStreamingMetricsMetricsReporting=__webpack_require__(348);var _srcStreamingMetricsMetricsReporting2=_interopRequireDefault(_srcStreamingMetricsMetricsReporting);var _srcStreamingProtectionProtection=__webpack_require__(373);var _srcStreamingProtectionProtection2=_interopRequireDefault(_srcStreamingProtectionProtection);var _srcStreamingMediaPlayerFactory=__webpack_require__(333);var _srcStreamingMediaPlayerFactory2=_interopRequireDefault(_srcStreamingMediaPlayerFactory);dashjs.Protection = _srcStreamingProtectionProtection2['default'];dashjs.MetricsReporting = _srcStreamingMetricsMetricsReporting2['default'];dashjs.MediaPlayerFactory = _srcStreamingMediaPlayerFactory2['default'];exports['default'] = dashjs;exports.MediaPlayer = _index_mediaplayerOnly.MediaPlayer;exports.Protection = _srcStreamingProtectionProtection2['default'];exports.MetricsReporting = _srcStreamingMetricsMetricsReporting2['default'];exports.MediaPlayerFactory = _srcStreamingMediaPlayerFactory2['default'];
	//# sourceMappingURL=index.js.map


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _srcStreamingMediaPlayer=__webpack_require__(143);var _srcStreamingMediaPlayer2=_interopRequireDefault(_srcStreamingMediaPlayer);var _srcCoreFactoryMaker=__webpack_require__(1);var _srcCoreFactoryMaker2=_interopRequireDefault(_srcCoreFactoryMaker);var _srcCoreVersion=__webpack_require__(138); // Shove both of these into the global scope
	var context=typeof window !== 'undefined' && window || global;var dashjs=context.dashjs;if(!dashjs){dashjs = context.dashjs = {};}dashjs.MediaPlayer = _srcStreamingMediaPlayer2['default'];dashjs.FactoryMaker = _srcCoreFactoryMaker2['default'];dashjs.Version = (0,_srcCoreVersion.getVersionString)();exports['default'] = dashjs;exports.MediaPlayer = _srcStreamingMediaPlayer2['default'];exports.FactoryMaker = _srcCoreFactoryMaker2['default'];
	//# sourceMappingURL=index_mediaplayerOnly.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _EventsBase2=__webpack_require__(62);var _EventsBase3=_interopRequireDefault(_EventsBase2); /**
	 * These are internal events that should not be needed at the player level.
	 * If you find and event in here that you would like access to from MediaPlayer level
	 * please add an issue at https://github.com/Dash-Industry-Forum/dash.js/issues/new
	 * @class
	 * @ignore
	 */var CoreEvents=(function(_EventsBase){_inherits(CoreEvents,_EventsBase);function CoreEvents(){_classCallCheck(this,CoreEvents);_get(Object.getPrototypeOf(CoreEvents.prototype),'constructor',this).call(this);this.BUFFERING_COMPLETED = 'bufferingCompleted';this.BUFFER_CLEARED = 'bufferCleared';this.BUFFER_LEVEL_UPDATED = 'bufferLevelUpdated';this.BYTES_APPENDED = 'bytesAppended';this.BYTES_APPENDED_END_FRAGMENT = 'bytesAppendedEndFragment';this.CHECK_FOR_EXISTENCE_COMPLETED = 'checkForExistenceCompleted';this.CURRENT_TRACK_CHANGED = 'currentTrackChanged';this.DATA_UPDATE_COMPLETED = 'dataUpdateCompleted';this.DATA_UPDATE_STARTED = 'dataUpdateStarted';this.INITIALIZATION_LOADED = 'initializationLoaded';this.INIT_FRAGMENT_LOADED = 'initFragmentLoaded';this.INIT_REQUESTED = 'initRequested';this.INTERNAL_MANIFEST_LOADED = 'internalManifestLoaded';this.LIVE_EDGE_SEARCH_COMPLETED = 'liveEdgeSearchCompleted';this.LOADING_COMPLETED = 'loadingCompleted';this.LOADING_PROGRESS = 'loadingProgress';this.LOADING_DATA_PROGRESS = 'loadingDataProgress';this.LOADING_ABANDONED = 'loadingAborted';this.MANIFEST_UPDATED = 'manifestUpdated';this.MEDIA_FRAGMENT_LOADED = 'mediaFragmentLoaded';this.QUOTA_EXCEEDED = 'quotaExceeded';this.REPRESENTATION_UPDATED = 'representationUpdated';this.SEGMENTS_LOADED = 'segmentsLoaded';this.SERVICE_LOCATION_BLACKLIST_ADD = 'serviceLocationBlacklistAdd';this.SERVICE_LOCATION_BLACKLIST_CHANGED = 'serviceLocationBlacklistChanged';this.SOURCEBUFFER_REMOVE_COMPLETED = 'sourceBufferRemoveCompleted';this.STREAMS_COMPOSED = 'streamsComposed';this.STREAM_BUFFERING_COMPLETED = 'streamBufferingCompleted';this.STREAM_COMPLETED = 'streamCompleted';this.TEXT_TRACKS_QUEUE_INITIALIZED = 'textTracksQueueInitialized';this.TIMED_TEXT_REQUESTED = 'timedTextRequested';this.TIME_SYNCHRONIZATION_COMPLETED = 'timeSynchronizationComplete';this.URL_RESOLUTION_FAILED = 'urlResolutionFailed';this.VIDEO_CHUNK_RECEIVED = 'videoChunkReceived';this.WALLCLOCK_TIME_UPDATED = 'wallclockTimeUpdated';this.XLINK_ELEMENT_LOADED = 'xlinkElementLoaded';this.XLINK_READY = 'xlinkReady';}return CoreEvents;})(_EventsBase3['default']);exports['default'] = CoreEvents;module.exports = exports['default'];
	//# sourceMappingURL=CoreEvents.js.map


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _streamingConstantsConstants=__webpack_require__(8);var _streamingConstantsConstants2=_interopRequireDefault(_streamingConstantsConstants);var _streamingVoRepresentationInfo=__webpack_require__(424);var _streamingVoRepresentationInfo2=_interopRequireDefault(_streamingVoRepresentationInfo);var _streamingVoMediaInfo=__webpack_require__(422);var _streamingVoMediaInfo2=_interopRequireDefault(_streamingVoMediaInfo);var _streamingVoStreamInfo=__webpack_require__(425);var _streamingVoStreamInfo2=_interopRequireDefault(_streamingVoStreamInfo);var _streamingVoManifestInfo=__webpack_require__(421);var _streamingVoManifestInfo2=_interopRequireDefault(_streamingVoManifestInfo);var _voEvent=__webpack_require__(141);var _voEvent2=_interopRequireDefault(_voEvent);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _externalsCea608Parser=__webpack_require__(136);var _externalsCea608Parser2=_interopRequireDefault(_externalsCea608Parser);function DashAdapter(){var instance=undefined,dashManifestModel=undefined,voPeriods=undefined,voAdaptations=undefined;function setup(){reset();}function setConfig(config){if(!config)return;if(config.dashManifestModel){dashManifestModel = config.dashManifestModel;}}function getRepresentationForRepresentationInfo(representationInfo,representationController){return representationController && representationInfo?representationController.getRepresentationForQuality(representationInfo.quality):null;}function getAdaptationForMediaInfo(mediaInfo){if(!mediaInfo || !mediaInfo.streamInfo || mediaInfo.streamInfo.id === undefined || !voAdaptations[mediaInfo.streamInfo.id])return null;return voAdaptations[mediaInfo.streamInfo.id][mediaInfo.index];}function getPeriodForStreamInfo(streamInfo,voPeriodsArray){var ln=voPeriodsArray.length;for(var i=0;i < ln;i++) {var voPeriod=voPeriodsArray[i];if(streamInfo.id === voPeriod.id)return voPeriod;}return null;}function convertRepresentationToRepresentationInfo(voRepresentation){var representationInfo=new _streamingVoRepresentationInfo2['default']();var realAdaptation=voRepresentation.adaptation.period.mpd.manifest.Period_asArray[voRepresentation.adaptation.period.index].AdaptationSet_asArray[voRepresentation.adaptation.index];var realRepresentation=dashManifestModel.getRepresentationFor(voRepresentation.index,realAdaptation);representationInfo.id = voRepresentation.id;representationInfo.quality = voRepresentation.index;representationInfo.bandwidth = dashManifestModel.getBandwidth(realRepresentation);representationInfo.DVRWindow = voRepresentation.segmentAvailabilityRange;representationInfo.fragmentDuration = voRepresentation.segmentDuration || (voRepresentation.segments && voRepresentation.segments.length > 0?voRepresentation.segments[0].duration:NaN);representationInfo.MSETimeOffset = voRepresentation.MSETimeOffset;representationInfo.useCalculatedLiveEdgeTime = voRepresentation.useCalculatedLiveEdgeTime;representationInfo.mediaInfo = convertAdaptationToMediaInfo(voRepresentation.adaptation);return representationInfo;}function convertAdaptationToMediaInfo(adaptation){var mediaInfo=new _streamingVoMediaInfo2['default']();var realAdaptation=adaptation.period.mpd.manifest.Period_asArray[adaptation.period.index].AdaptationSet_asArray[adaptation.index];var viewpoint=undefined;mediaInfo.id = adaptation.id;mediaInfo.index = adaptation.index;mediaInfo.type = adaptation.type;mediaInfo.streamInfo = convertPeriodToStreamInfo(adaptation.period);mediaInfo.representationCount = dashManifestModel.getRepresentationCount(realAdaptation);mediaInfo.lang = dashManifestModel.getLanguageForAdaptation(realAdaptation);viewpoint = dashManifestModel.getViewpointForAdaptation(realAdaptation);mediaInfo.viewpoint = viewpoint?viewpoint.value:undefined;mediaInfo.accessibility = dashManifestModel.getAccessibilityForAdaptation(realAdaptation).map(function(accessibility){var accessibilityValue=accessibility.value;var accessibilityData=accessibilityValue;if(accessibility.schemeIdUri && accessibility.schemeIdUri.search('cea-608') >= 0 && typeof _externalsCea608Parser2['default'] !== 'undefined'){if(accessibilityValue){accessibilityData = 'cea-608:' + accessibilityValue;}else {accessibilityData = 'cea-608';}mediaInfo.embeddedCaptions = true;}return accessibilityData;});mediaInfo.audioChannelConfiguration = dashManifestModel.getAudioChannelConfigurationForAdaptation(realAdaptation).map(function(audioChannelConfiguration){return audioChannelConfiguration.value;});mediaInfo.roles = dashManifestModel.getRolesForAdaptation(realAdaptation).map(function(role){return role.value;});mediaInfo.codec = dashManifestModel.getCodec(realAdaptation);mediaInfo.mimeType = dashManifestModel.getMimeType(realAdaptation);mediaInfo.contentProtection = dashManifestModel.getContentProtectionData(realAdaptation);mediaInfo.bitrateList = dashManifestModel.getBitrateListForAdaptation(realAdaptation);if(mediaInfo.contentProtection){mediaInfo.contentProtection.forEach(function(item){item.KID = dashManifestModel.getKID(item);});}mediaInfo.isText = dashManifestModel.getIsTextTrack(mediaInfo.mimeType);return mediaInfo;}function convertVideoInfoToEmbeddedTextInfo(mediaInfo,channel,lang){mediaInfo.id = channel; // CC1, CC2, CC3, or CC4
	mediaInfo.index = 100 + parseInt(channel.substring(2,3));mediaInfo.type = _streamingConstantsConstants2['default'].EMBEDDED_TEXT;mediaInfo.codec = 'cea-608-in-SEI';mediaInfo.isText = true;mediaInfo.isEmbedded = true;mediaInfo.lang = channel + ' ' + lang;mediaInfo.roles = ['caption'];}function convertVideoInfoToThumbnailInfo(mediaInfo){mediaInfo.type = _streamingConstantsConstants2['default'].IMAGE;}function convertPeriodToStreamInfo(period){var streamInfo=new _streamingVoStreamInfo2['default']();var THRESHOLD=1;streamInfo.id = period.id;streamInfo.index = period.index;streamInfo.start = period.start;streamInfo.duration = period.duration;streamInfo.manifestInfo = convertMpdToManifestInfo(period.mpd);streamInfo.isLast = period.mpd.manifest.Period_asArray.length === 1 || Math.abs(streamInfo.start + streamInfo.duration - streamInfo.manifestInfo.duration) < THRESHOLD;return streamInfo;}function convertMpdToManifestInfo(mpd){var manifestInfo=new _streamingVoManifestInfo2['default']();manifestInfo.DVRWindowSize = mpd.timeShiftBufferDepth;manifestInfo.loadedTime = mpd.manifest.loadedTime;manifestInfo.availableFrom = mpd.availabilityStartTime;manifestInfo.minBufferTime = mpd.manifest.minBufferTime;manifestInfo.maxFragmentDuration = mpd.maxSegmentDuration;manifestInfo.duration = dashManifestModel.getDuration(mpd.manifest);manifestInfo.isDynamic = dashManifestModel.getIsDynamic(mpd.manifest);return manifestInfo;}function getMediaInfoForType(streamInfo,type){if(voPeriods.length === 0){return null;}var manifest=voPeriods[0].mpd.manifest;var realAdaptation=dashManifestModel.getAdaptationForType(manifest,streamInfo.index,type,streamInfo);if(!realAdaptation)return null;var selectedVoPeriod=getPeriodForStreamInfo(streamInfo,voPeriods);var periodId=selectedVoPeriod.id;var idx=dashManifestModel.getIndexForAdaptation(realAdaptation,manifest,streamInfo.index);voAdaptations[periodId] = voAdaptations[periodId] || dashManifestModel.getAdaptationsForPeriod(selectedVoPeriod);return convertAdaptationToMediaInfo(voAdaptations[periodId][idx]);}function getAllMediaInfoForType(streamInfo,type,externalManifest){var voLocalPeriods=voPeriods;var manifest=externalManifest;var mediaArr=[];var data=undefined,media=undefined,idx=undefined,i=undefined,j=undefined,ln=undefined;if(manifest){checkSetConfigCall();var mpd=dashManifestModel.getMpd(manifest);voLocalPeriods = dashManifestModel.getRegularPeriods(mpd);}else {if(voPeriods.length > 0){manifest = voPeriods[0].mpd.manifest;}else {return mediaArr;}}var selectedVoPeriod=getPeriodForStreamInfo(streamInfo,voLocalPeriods);var periodId=selectedVoPeriod.id;var adaptationsForType=dashManifestModel.getAdaptationsForType(manifest,streamInfo.index,type !== _streamingConstantsConstants2['default'].EMBEDDED_TEXT?type:_streamingConstantsConstants2['default'].VIDEO);if(!adaptationsForType)return mediaArr;voAdaptations[periodId] = voAdaptations[periodId] || dashManifestModel.getAdaptationsForPeriod(selectedVoPeriod);for(i = 0,ln = adaptationsForType.length;i < ln;i++) {data = adaptationsForType[i];idx = dashManifestModel.getIndexForAdaptation(data,manifest,streamInfo.index);media = convertAdaptationToMediaInfo(voAdaptations[periodId][idx]);if(type === _streamingConstantsConstants2['default'].EMBEDDED_TEXT){var accessibilityLength=media.accessibility.length;for(j = 0;j < accessibilityLength;j++) {if(!media){continue;}var accessibility=media.accessibility[j];if(accessibility.indexOf('cea-608:') === 0){var value=accessibility.substring(8);var parts=value.split(';');if(parts[0].substring(0,2) === 'CC'){for(j = 0;j < parts.length;j++) {if(!media){media = convertAdaptationToMediaInfo.call(this,voAdaptations[periodId][idx]);}convertVideoInfoToEmbeddedTextInfo(media,parts[j].substring(0,3),parts[j].substring(4));mediaArr.push(media);media = null;}}else {for(j = 0;j < parts.length;j++) { // Only languages for CC1, CC2, ...
	if(!media){media = convertAdaptationToMediaInfo.call(this,voAdaptations[periodId][idx]);}convertVideoInfoToEmbeddedTextInfo(media,'CC' + (j + 1),parts[j]);mediaArr.push(media);media = null;}}}else if(accessibility.indexOf('cea-608') === 0){ // Nothing known. We interpret it as CC1=eng
	convertVideoInfoToEmbeddedTextInfo(media,_streamingConstantsConstants2['default'].CC1,'eng');mediaArr.push(media);media = null;}}}else if(type === _streamingConstantsConstants2['default'].IMAGE){convertVideoInfoToThumbnailInfo(media);mediaArr.push(media);media = null;}else if(media){mediaArr.push(media);}}return mediaArr;}function checkSetConfigCall(){if(!dashManifestModel || !dashManifestModel.hasOwnProperty('getMpd') || !dashManifestModel.hasOwnProperty('getRegularPeriods')){throw new Error('setConfig function has to be called previously');}}function updatePeriods(newManifest){if(!newManifest)return null;checkSetConfigCall();var mpd=dashManifestModel.getMpd(newManifest);voPeriods = dashManifestModel.getRegularPeriods(mpd);voAdaptations = {};}function getStreamsInfo(externalManifest,maxStreamsInfo){var streams=[];var voLocalPeriods=voPeriods; //if manifest is defined, getStreamsInfo is for an outside manifest, not the current one
	if(externalManifest){checkSetConfigCall();var mpd=dashManifestModel.getMpd(externalManifest);voLocalPeriods = dashManifestModel.getRegularPeriods(mpd);}if(!maxStreamsInfo){maxStreamsInfo = voLocalPeriods.length;}for(var i=0;i < maxStreamsInfo;i++) {streams.push(convertPeriodToStreamInfo(voLocalPeriods[i]));}return streams;}function checkStreamProcessor(streamProcessor){if(!streamProcessor || !streamProcessor.hasOwnProperty('getRepresentationController') || !streamProcessor.hasOwnProperty('getIndexHandler') || !streamProcessor.hasOwnProperty('getMediaInfo') || !streamProcessor.hasOwnProperty('getType') || !streamProcessor.hasOwnProperty('getStreamInfo')){throw new Error('streamProcessor parameter is missing or malformed!');}}function checkRepresentationController(representationController){if(!representationController || !representationController.hasOwnProperty('getRepresentationForQuality') || !representationController.hasOwnProperty('getCurrentRepresentation')){throw new Error('representationController parameter is missing or malformed!');}}function checkQuality(quality){var isInt=quality !== null && !isNaN(quality) && quality % 1 === 0;if(!isInt){throw new Error('quality argument is not an integer');}}function getInitRequest(streamProcessor,quality){var representationController=undefined,representation=undefined,indexHandler=undefined;checkStreamProcessor(streamProcessor);checkQuality(quality);representationController = streamProcessor.getRepresentationController();indexHandler = streamProcessor.getIndexHandler();representation = representationController?representationController.getRepresentationForQuality(quality):null;return indexHandler?indexHandler.getInitRequest(representation):null;}function getNextFragmentRequest(streamProcessor,representationInfo){var representationController=undefined,representation=undefined,indexHandler=undefined;checkStreamProcessor(streamProcessor);representationController = streamProcessor.getRepresentationController();representation = getRepresentationForRepresentationInfo(representationInfo,representationController);indexHandler = streamProcessor.getIndexHandler();return indexHandler?indexHandler.getNextSegmentRequest(representation):null;}function getFragmentRequestForTime(streamProcessor,representationInfo,time,options){var representationController=undefined,representation=undefined,indexHandler=undefined;checkStreamProcessor(streamProcessor);representationController = streamProcessor.getRepresentationController();representation = getRepresentationForRepresentationInfo(representationInfo,representationController);indexHandler = streamProcessor.getIndexHandler();return indexHandler?indexHandler.getSegmentRequestForTime(representation,time,options):null;}function generateFragmentRequestForTime(streamProcessor,representationInfo,time){var representationController=undefined,representation=undefined,indexHandler=undefined;checkStreamProcessor(streamProcessor);representationController = streamProcessor.getRepresentationController();representation = getRepresentationForRepresentationInfo(representationInfo,representationController);indexHandler = streamProcessor.getIndexHandler();return indexHandler?indexHandler.generateSegmentRequestForTime(representation,time):null;}function getIndexHandlerTime(streamProcessor){checkStreamProcessor(streamProcessor);var indexHandler=streamProcessor.getIndexHandler();if(indexHandler){return indexHandler.getCurrentTime();}return NaN;}function setIndexHandlerTime(streamProcessor,value){checkStreamProcessor(streamProcessor);var indexHandler=streamProcessor.getIndexHandler();if(indexHandler){indexHandler.setCurrentTime(value);}}function updateData(streamProcessor){checkStreamProcessor(streamProcessor);var selectedVoPeriod=getPeriodForStreamInfo(streamProcessor.getStreamInfo(),voPeriods);var mediaInfo=streamProcessor.getMediaInfo();var voAdaptation=getAdaptationForMediaInfo(mediaInfo);var type=streamProcessor.getType();var id=undefined,realAdaptation=undefined;id = mediaInfo?mediaInfo.id:null;if(voPeriods.length > 0){realAdaptation = id?dashManifestModel.getAdaptationForId(id,voPeriods[0].mpd.manifest,selectedVoPeriod.index):dashManifestModel.getAdaptationForIndex(mediaInfo.index,voPeriods[0].mpd.manifest,selectedVoPeriod.index);streamProcessor.getRepresentationController().updateData(realAdaptation,voAdaptation,type);}}function getRepresentationInfoForQuality(representationController,quality){checkRepresentationController(representationController);checkQuality(quality);var voRepresentation=representationController.getRepresentationForQuality(quality);return voRepresentation?convertRepresentationToRepresentationInfo(voRepresentation):null;}function getCurrentRepresentationInfo(representationController){checkRepresentationController(representationController);var voRepresentation=representationController.getCurrentRepresentation();return voRepresentation?convertRepresentationToRepresentationInfo(voRepresentation):null;}function getEvent(eventBox,eventStreams,startTime){if(!eventBox || !eventStreams){return null;}var event=new _voEvent2['default']();var schemeIdUri=eventBox.scheme_id_uri;var value=eventBox.value;var timescale=eventBox.timescale;var presentationTimeDelta=eventBox.presentation_time_delta;var duration=eventBox.event_duration;var id=eventBox.id;var messageData=eventBox.message_data;var presentationTime=startTime * timescale + presentationTimeDelta;if(!eventStreams[schemeIdUri])return null;event.eventStream = eventStreams[schemeIdUri];event.eventStream.value = value;event.eventStream.timescale = timescale;event.duration = duration;event.id = id;event.presentationTime = presentationTime;event.messageData = messageData;event.presentationTimeDelta = presentationTimeDelta;return event;}function getEventsFor(info,streamProcessor){var events=[];if(voPeriods.length === 0){return events;}var manifest=voPeriods[0].mpd.manifest;if(info instanceof _streamingVoStreamInfo2['default']){events = dashManifestModel.getEventsForPeriod(getPeriodForStreamInfo(info,voPeriods));}else if(info instanceof _streamingVoMediaInfo2['default']){events = dashManifestModel.getEventStreamForAdaptationSet(manifest,getAdaptationForMediaInfo(info));}else if(info instanceof _streamingVoRepresentationInfo2['default']){events = dashManifestModel.getEventStreamForRepresentation(manifest,getRepresentationForRepresentationInfo(info,streamProcessor.getRepresentationController()));}return events;}function reset(){voPeriods = [];voAdaptations = {};}instance = {convertDataToRepresentationInfo:convertRepresentationToRepresentationInfo,getDataForMedia:getAdaptationForMediaInfo,getStreamsInfo:getStreamsInfo,getMediaInfoForType:getMediaInfoForType,getAllMediaInfoForType:getAllMediaInfoForType,getCurrentRepresentationInfo:getCurrentRepresentationInfo,getRepresentationInfoForQuality:getRepresentationInfoForQuality,updateData:updateData,getInitRequest:getInitRequest,getNextFragmentRequest:getNextFragmentRequest,getFragmentRequestForTime:getFragmentRequestForTime,generateFragmentRequestForTime:generateFragmentRequestForTime,getIndexHandlerTime:getIndexHandlerTime,setIndexHandlerTime:setIndexHandlerTime,getEventsFor:getEventsFor,getEvent:getEvent,setConfig:setConfig,updatePeriods:updatePeriods,reset:reset};setup();return instance;}DashAdapter.__dashjs_factory_name = 'DashAdapter';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(DashAdapter);module.exports = exports['default'];
	//# sourceMappingURL=DashAdapter.js.map


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _streamingConstantsConstants=__webpack_require__(8);var _streamingConstantsConstants2=_interopRequireDefault(_streamingConstantsConstants);var _constantsDashConstants=__webpack_require__(25);var _constantsDashConstants2=_interopRequireDefault(_constantsDashConstants);var _streamingVoFragmentRequest=__webpack_require__(37);var _streamingVoFragmentRequest2=_interopRequireDefault(_streamingVoFragmentRequest);var _streamingVoDashJSError=__webpack_require__(31);var _streamingVoDashJSError2=_interopRequireDefault(_streamingVoDashJSError);var _streamingVoMetricsHTTPRequest=__webpack_require__(16);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _streamingUtilsURLUtils=__webpack_require__(30);var _streamingUtilsURLUtils2=_interopRequireDefault(_streamingUtilsURLUtils);var _voRepresentation=__webpack_require__(85);var _voRepresentation2=_interopRequireDefault(_voRepresentation);var _utilsSegmentsUtils=__webpack_require__(40);var _utilsSegmentsGetter=__webpack_require__(322);var _utilsSegmentsGetter2=_interopRequireDefault(_utilsSegmentsGetter);var _SegmentBaseLoader=__webpack_require__(307);var _SegmentBaseLoader2=_interopRequireDefault(_SegmentBaseLoader);var _WebmSegmentBaseLoader=__webpack_require__(308);var _WebmSegmentBaseLoader2=_interopRequireDefault(_WebmSegmentBaseLoader);var SEGMENTS_UNAVAILABLE_ERROR_CODE=1;function DashHandler(config){config = config || {};var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var urlUtils=(0,_streamingUtilsURLUtils2['default'])(context).getInstance();var segmentBaseLoader=undefined;var timelineConverter=config.timelineConverter;var dashMetrics=config.dashMetrics;var metricsModel=config.metricsModel;var mediaPlayerModel=config.mediaPlayerModel;var errHandler=config.errHandler;var baseURLController=config.baseURLController;var instance=undefined,log=undefined,index=undefined,requestedTime=undefined,currentTime=undefined,earliestTime=undefined,streamProcessor=undefined,segmentsGetter=undefined;function setup(){log = (0,_coreDebug2['default'])(context).getInstance().log.bind(instance);resetInitialSettings();segmentBaseLoader = isWebM(config.mimeType)?(0,_WebmSegmentBaseLoader2['default'])(context).getInstance():(0,_SegmentBaseLoader2['default'])(context).getInstance();segmentBaseLoader.setConfig({baseURLController:baseURLController,metricsModel:metricsModel,mediaPlayerModel:mediaPlayerModel,errHandler:errHandler});eventBus.on(_coreEventsEvents2['default'].INITIALIZATION_LOADED,onInitializationLoaded,instance);eventBus.on(_coreEventsEvents2['default'].SEGMENTS_LOADED,onSegmentsLoaded,instance);}function isWebM(mimeType){var type=mimeType.split('/')[1];return 'webm' === type.toLowerCase();}function initialize(StreamProcessor){streamProcessor = StreamProcessor;var isDynamic=streamProcessor?streamProcessor.getStreamInfo().manifestInfo.isDynamic:null;segmentBaseLoader.initialize();segmentsGetter = (0,_utilsSegmentsGetter2['default'])(context).create(config,isDynamic);}function getStreamProcessor(){return streamProcessor;}function setCurrentTime(value){currentTime = value;}function getCurrentTime(){return currentTime;}function getEarliestTime(){return earliestTime;}function resetInitialSettings(){index = -1;currentTime = 0;earliestTime = NaN;requestedTime = null;streamProcessor = null;segmentsGetter = null;}function reset(){resetInitialSettings();eventBus.off(_coreEventsEvents2['default'].INITIALIZATION_LOADED,onInitializationLoaded,instance);eventBus.off(_coreEventsEvents2['default'].SEGMENTS_LOADED,onSegmentsLoaded,instance);}function setRequestUrl(request,destination,representation){var baseURL=baseURLController.resolve(representation.path);var url=undefined,serviceLocation=undefined;if(!baseURL || destination === baseURL.url || !urlUtils.isRelative(destination)){url = destination;}else {url = baseURL.url;serviceLocation = baseURL.serviceLocation;if(destination){url = urlUtils.resolve(destination,url);}}if(urlUtils.isRelative(url)){return false;}request.url = url;request.serviceLocation = serviceLocation;return true;}function generateInitRequest(representation,mediaType){var request=new _streamingVoFragmentRequest2['default']();var period=representation.adaptation.period;var presentationStartTime=period.start;var isDynamic=streamProcessor?streamProcessor.getStreamInfo().manifestInfo.isDynamic:null;request.mediaType = mediaType;request.type = _streamingVoMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE;request.range = representation.range;request.availabilityStartTime = timelineConverter.calcAvailabilityStartTimeFromPresentationTime(presentationStartTime,period.mpd,isDynamic);request.availabilityEndTime = timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationStartTime + period.duration,period.mpd,isDynamic);request.quality = representation.index;request.mediaInfo = streamProcessor?streamProcessor.getMediaInfo():null;request.representationId = representation.id;if(setRequestUrl(request,representation.initialization,representation)){return request;}}function getInitRequest(representation){var type=streamProcessor?streamProcessor.getType():null;if(!representation)return null;var request=generateInitRequest(representation,type);return request;}function isMediaFinished(representation){var isFinished=false;var isDynamic=streamProcessor?streamProcessor.getStreamInfo().manifestInfo.isDynamic:null;if(!isDynamic && index === representation.availableSegmentsNumber){isFinished = true;}else {var seg=(0,_utilsSegmentsUtils.getSegmentByIndex)(index,representation);if(seg){var time=parseFloat((seg.presentationStartTime - representation.adaptation.period.start).toFixed(5));var duration=representation.adaptation.period.duration;log(representation.segmentInfoType + ': ' + time + ' / ' + duration);isFinished = representation.segmentInfoType === _constantsDashConstants2['default'].SEGMENT_TIMELINE && isDynamic?false:time >= duration;}else {log('isMediaFinished - no segment found');}}return isFinished;}function updateSegments(voRepresentation){segmentsGetter.getSegments(voRepresentation,requestedTime,index,onSegmentListUpdated);}function onSegmentListUpdated(voRepresentation,segments){var isDynamic=streamProcessor?streamProcessor.getStreamInfo().manifestInfo.isDynamic:null;voRepresentation.segments = segments;if(segments && segments.length > 0){earliestTime = isNaN(earliestTime)?segments[0].presentationStartTime:Math.min(segments[0].presentationStartTime,earliestTime);if(isDynamic && isNaN(timelineConverter.getExpectedLiveEdge())){var lastSegment=segments[segments.length - 1];var liveEdge=lastSegment.presentationStartTime;var metrics=metricsModel.getMetricsFor(_streamingConstantsConstants2['default'].STREAM); // the last segment is the Expected, not calculated, live edge.
	timelineConverter.setExpectedLiveEdge(liveEdge);metricsModel.updateManifestUpdateInfo(dashMetrics.getCurrentManifestUpdate(metrics),{presentationStartTime:liveEdge});}}}function updateSegmentList(voRepresentation){if(!voRepresentation){throw new Error('no representation');}voRepresentation.segments = null;updateSegments(voRepresentation);}function updateRepresentation(voRepresentation,keepIdx){var hasInitialization=_voRepresentation2['default'].hasInitialization(voRepresentation);var hasSegments=_voRepresentation2['default'].hasSegments(voRepresentation);var type=streamProcessor?streamProcessor.getType():null;var isDynamic=streamProcessor?streamProcessor.getStreamInfo().manifestInfo.isDynamic:null;var error=undefined;if(!voRepresentation.segmentDuration && !voRepresentation.segments){updateSegmentList(voRepresentation);}voRepresentation.segmentAvailabilityRange = timelineConverter.calcSegmentAvailabilityRange(voRepresentation,isDynamic);if(voRepresentation.segmentAvailabilityRange.end < voRepresentation.segmentAvailabilityRange.start && !voRepresentation.useCalculatedLiveEdgeTime){error = new _streamingVoDashJSError2['default'](SEGMENTS_UNAVAILABLE_ERROR_CODE,'no segments are available yet',{availabilityDelay:voRepresentation.segmentAvailabilityRange.start - voRepresentation.segmentAvailabilityRange.end});eventBus.trigger(_coreEventsEvents2['default'].REPRESENTATION_UPDATED,{sender:this,representation:voRepresentation,error:error});return;}if(!keepIdx)index = -1;if(voRepresentation.segmentDuration){updateSegmentList(voRepresentation);}if(!hasInitialization){segmentBaseLoader.loadInitialization(voRepresentation);}if(!hasSegments){segmentBaseLoader.loadSegments(voRepresentation,type,voRepresentation.indexRange);}if(hasInitialization && hasSegments){eventBus.trigger(_coreEventsEvents2['default'].REPRESENTATION_UPDATED,{sender:this,representation:voRepresentation});}}function getIndexForSegments(time,representation,timeThreshold){var segments=representation.segments;var ln=segments?segments.length:null;var idx=-1;var epsilon=undefined,frag=undefined,ft=undefined,fd=undefined,i=undefined;if(segments && ln > 0){ // In case timeThreshold is not provided, let's use the default value set in MediaPlayerModel
	timeThreshold = timeThreshold === undefined || timeThreshold === null?mediaPlayerModel.getSegmentOverlapToleranceTime():timeThreshold;for(i = 0;i < ln;i++) {frag = segments[i];ft = frag.presentationStartTime;fd = frag.duration; // In case timeThreshold is null, set epsilon to half the fragment duration
	epsilon = timeThreshold === undefined || timeThreshold === null?fd / 2:timeThreshold;if(time + epsilon >= ft && time - epsilon < ft + fd){idx = frag.availabilityIdx;break;}}}return idx;}function getRequestForSegment(segment){if(segment === null || segment === undefined){return null;}var request=new _streamingVoFragmentRequest2['default']();var representation=segment.representation;var bandwidth=representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].bandwidth;var url=segment.media;var type=streamProcessor?streamProcessor.getType():null;url = (0,_utilsSegmentsUtils.replaceTokenForTemplate)(url,'Number',segment.replacementNumber);url = (0,_utilsSegmentsUtils.replaceTokenForTemplate)(url,'Time',segment.replacementTime);url = (0,_utilsSegmentsUtils.replaceTokenForTemplate)(url,'Bandwidth',bandwidth);url = (0,_utilsSegmentsUtils.replaceIDForTemplate)(url,representation.id);url = (0,_utilsSegmentsUtils.unescapeDollarsInTemplate)(url);request.mediaType = type;request.type = _streamingVoMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE;request.range = segment.mediaRange;request.startTime = segment.presentationStartTime;request.duration = segment.duration;request.timescale = representation.timescale;request.availabilityStartTime = segment.availabilityStartTime;request.availabilityEndTime = segment.availabilityEndTime;request.wallStartTime = segment.wallStartTime;request.quality = representation.index;request.index = segment.availabilityIdx;request.mediaInfo = streamProcessor.getMediaInfo();request.adaptationIndex = representation.adaptation.index;request.representationId = representation.id;if(setRequestUrl(request,url,representation)){return request;}}function getSegmentRequestForTime(representation,time,options){var request=undefined,segment=undefined,finished=undefined;var type=streamProcessor?streamProcessor.getType():null;var isDynamic=streamProcessor?streamProcessor.getStreamInfo().manifestInfo.isDynamic:null;var idx=index;var keepIdx=options?options.keepIdx:false;var timeThreshold=options?options.timeThreshold:null;var ignoreIsFinished=options && options.ignoreIsFinished?true:false;if(!representation){return null;}if(requestedTime !== time){ // When playing at live edge with 0 delay we may loop back with same time and index until it is available. Reduces verboseness of logs.
	requestedTime = time;log('Getting the request for ' + type + ' time : ' + time);}updateSegments(representation);index = getIndexForSegments(time,representation,timeThreshold); //Index may be -1 if getSegments needs to update again.  So after getSegments is called and updated then try to get index again.
	if(index < 0){updateSegments(representation);index = getIndexForSegments(time,representation,timeThreshold);}if(index > 0){log('Index for ' + type + ' time ' + time + ' is ' + index);}finished = !ignoreIsFinished?isMediaFinished(representation):false;if(finished){request = new _streamingVoFragmentRequest2['default']();request.action = _streamingVoFragmentRequest2['default'].ACTION_COMPLETE;request.index = index;request.mediaType = type;request.mediaInfo = streamProcessor.getMediaInfo();log('Signal complete in getSegmentRequestForTime -',type);}else {segment = (0,_utilsSegmentsUtils.getSegmentByIndex)(index,representation);request = getRequestForSegment(segment);}if(keepIdx && idx >= 0){index = representation.segmentInfoType === _constantsDashConstants2['default'].SEGMENT_TIMELINE && isDynamic?index:idx;}return request;}function generateSegmentRequestForTime(representation,time){var step=(representation.segmentAvailabilityRange.end - representation.segmentAvailabilityRange.start) / 2;representation.segments = null;representation.segmentAvailabilityRange = {start:time - step,end:time + step};return getSegmentRequestForTime(representation,time,{keepIdx:false,ignoreIsFinished:true});}function getNextSegmentRequest(representation){var request=undefined,segment=undefined,finished=undefined;var type=streamProcessor?streamProcessor.getType():null;var isDynamic=streamProcessor?streamProcessor.getStreamInfo().manifestInfo.isDynamic:null;if(!representation || index === -1){return null;}requestedTime = null;index++;log('Getting the next request at index: ' + index + ', type: ' + type); // check that there is a segment in this index. If none, update segments and wait for next time loop is called
	var seg=(0,_utilsSegmentsUtils.getSegmentByIndex)(index,representation);if(!seg && isDynamic){log('No segment found at index: ' + index + '. Wait for next loop');updateSegments(representation);index--;return null;}finished = isMediaFinished(representation);if(finished){request = new _streamingVoFragmentRequest2['default']();request.action = _streamingVoFragmentRequest2['default'].ACTION_COMPLETE;request.index = index;request.mediaType = type;request.mediaInfo = streamProcessor.getMediaInfo();log('Signal complete -',type);}else {updateSegments(representation);segment = (0,_utilsSegmentsUtils.getSegmentByIndex)(index,representation);request = getRequestForSegment(segment);if(!segment && isDynamic){ /*
	                 Sometimes when playing dynamic streams with 0 fragment delay at live edge we ask for
	                 an index before it is available so we decrement index back and send null request
	                 which triggers the validate loop to rerun and the next time the segment should be
	                 available.
	                 */index--;}}return request;}function onInitializationLoaded(e){var representation=e.representation;if(!representation.segments)return;eventBus.trigger(_coreEventsEvents2['default'].REPRESENTATION_UPDATED,{sender:this,representation:representation});}function onSegmentsLoaded(e){var type=streamProcessor?streamProcessor.getType():null;var isDynamic=streamProcessor?streamProcessor.getStreamInfo().manifestInfo.isDynamic:null;if(e.error || type !== e.mediaType)return;var fragments=e.segments;var representation=e.representation;var segments=[];var count=0;var i=undefined,len=undefined,s=undefined,seg=undefined;for(i = 0,len = fragments.length;i < len;i++) {s = fragments[i];seg = (0,_utilsSegmentsUtils.getTimeBasedSegment)(timelineConverter,isDynamic,representation,s.startTime,s.duration,s.timescale,s.media,s.mediaRange,count);segments.push(seg);seg = null;count++;}representation.segmentAvailabilityRange = {start:segments[0].presentationStartTime,end:segments[len - 1].presentationStartTime};representation.availableSegmentsNumber = len;onSegmentListUpdated(representation,segments);if(!_voRepresentation2['default'].hasInitialization(representation))return;eventBus.trigger(_coreEventsEvents2['default'].REPRESENTATION_UPDATED,{sender:this,representation:representation});}instance = {initialize:initialize,getStreamProcessor:getStreamProcessor,getInitRequest:getInitRequest,getSegmentRequestForTime:getSegmentRequestForTime,getNextSegmentRequest:getNextSegmentRequest,generateSegmentRequestForTime:generateSegmentRequestForTime,updateRepresentation:updateRepresentation,updateSegmentList:updateSegmentList,setCurrentTime:setCurrentTime,getCurrentTime:getCurrentTime,getEarliestTime:getEarliestTime,reset:reset};setup();return instance;}DashHandler.__dashjs_factory_name = 'DashHandler';var factory=_coreFactoryMaker2['default'].getClassFactory(DashHandler);factory.SEGMENTS_UNAVAILABLE_ERROR_CODE = SEGMENTS_UNAVAILABLE_ERROR_CODE;_coreFactoryMaker2['default'].updateClassFactory(DashHandler.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=DashHandler.js.map


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _streamingVoMetricsHTTPRequest=__webpack_require__(16);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _streamingConstantsMetricsConstants=__webpack_require__(41);var _streamingConstantsMetricsConstants2=_interopRequireDefault(_streamingConstantsMetricsConstants);var _utilsRound10=__webpack_require__(321);var _utilsRound102=_interopRequireDefault(_utilsRound10); /**
	 * @module DashMetrics
	 * @param {object} config configuration passed to DashMetrics
	 */function DashMetrics(config){config = config || {};var instance=undefined;var dashManifestModel=config.dashManifestModel;var manifestModel=config.manifestModel;function getBandwidthForRepresentation(representationId,periodId){var representation=undefined;var manifest=manifestModel.getValue();var period=manifest.Period_asArray[periodId];representation = findRepresentation(period,representationId);if(representation === null){return null;}return representation.bandwidth;} /**
	     *
	     * @param {string} representationId
	     * @param {number} periodIdx
	     * @returns {*}
	     */function getIndexForRepresentation(representationId,periodIdx){var representationIndex=undefined;var manifest=manifestModel.getValue();var period=manifest.Period_asArray[periodIdx];representationIndex = findRepresentationIndex(period,representationId);return representationIndex;} /**
	     * This method returns the current max index based on what is defined in the MPD.
	     *
	     * @param {string} bufferType - String 'audio' or 'video',
	     * @param {number} periodIdx - Make sure this is the period index not id
	     * @return {number}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getMaxIndexForBufferType(bufferType,periodIdx){var maxIndex=undefined;var manifest=manifestModel.getValue();if(!manifest){return -1;}var period=manifest.Period_asArray[periodIdx];maxIndex = findMaxBufferIndex(period,bufferType);return maxIndex;} /**
	     * @param {MetricsList} metrics
	     * @returns {*}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getCurrentRepresentationSwitch(metrics){return getCurrent(metrics,_streamingConstantsMetricsConstants2['default'].TRACK_SWITCH);} /**
	     * @param {MetricsList} metrics
	     * @returns {*}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getLatestBufferLevelVO(metrics){return getCurrent(metrics,_streamingConstantsMetricsConstants2['default'].BUFFER_LEVEL);} /**
	     * @param {MetricsList} metrics
	     * @returns {number}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getCurrentBufferLevel(metrics){var vo=getLatestBufferLevelVO(metrics);if(vo){return _utilsRound102['default'].round10(vo.level / 1000,-3);}return 0;} /**
	     * @param {MetricsList} metrics
	     * @returns {null|*|vo}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getRequestsQueue(metrics){return metrics?metrics.RequestsQueue:null;} /**
	     * @param {MetricsList} metrics
	     * @returns {*}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getCurrentHttpRequest(metrics){if(!metrics){return null;}var httpList=metrics.HttpList;var currentHttpList=null;var httpListLength=undefined,httpListLastIndex=undefined;if(!httpList || httpList.length <= 0){return null;}httpListLength = httpList.length;httpListLastIndex = httpListLength - 1;while(httpListLastIndex >= 0) {if(httpList[httpListLastIndex].responsecode){currentHttpList = httpList[httpListLastIndex];break;}httpListLastIndex--;}return currentHttpList;} /**
	     * @param {MetricsList} metrics
	     * @returns {*}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getHttpRequests(metrics){if(!metrics){return [];}return !!metrics.HttpList?metrics.HttpList:[];} /**
	     * @param {MetricsList} metrics
	     * @param {string} metricName
	     * @returns {*}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getCurrent(metrics,metricName){if(!metrics){return null;}var list=metrics[metricName];if(!list){return null;}var length=list.length;if(length <= 0){return null;}return list[length - 1];} /**
	     * @param {MetricsList} metrics
	     * @returns {*}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getCurrentDroppedFrames(metrics){return getCurrent(metrics,_streamingConstantsMetricsConstants2['default'].DROPPED_FRAMES);} /**
	     * @param {MetricsList} metrics
	     * @returns {*}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getCurrentSchedulingInfo(metrics){return getCurrent(metrics,_streamingConstantsMetricsConstants2['default'].SCHEDULING_INFO);} /**
	     * @param {MetricsList} metrics
	     * @returns {*}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getCurrentManifestUpdate(metrics){return getCurrent(metrics,_streamingConstantsMetricsConstants2['default'].MANIFEST_UPDATE);} /**
	     * @param {MetricsList} metrics
	     * @returns {*}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getCurrentDVRInfo(metrics){return getCurrent(metrics,_streamingConstantsMetricsConstants2['default'].DVR_INFO);} /**
	     * @param {MetricsList} metrics
	     * @param {string} id
	     * @returns {*}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getLatestMPDRequestHeaderValueByID(metrics,id){var headers={};var httpRequestList=undefined,httpRequest=undefined,i=undefined;httpRequestList = getHttpRequests(metrics);for(i = httpRequestList.length - 1;i >= 0;i--) {httpRequest = httpRequestList[i];if(httpRequest.type === _streamingVoMetricsHTTPRequest.HTTPRequest.MPD_TYPE){headers = parseResponseHeaders(httpRequest._responseHeaders);break;}}return headers[id] === undefined?null:headers[id];} /**
	     * @param {MetricsList} metrics
	     * @param {string} id
	     * @returns {*}
	     * @memberof module:DashMetrics
	     * @instance
	     */function getLatestFragmentRequestHeaderValueByID(metrics,id){var headers={};var httpRequest=getCurrentHttpRequest(metrics);if(httpRequest){headers = parseResponseHeaders(httpRequest._responseHeaders);}return headers[id] === undefined?null:headers[id];}function parseResponseHeaders(headerStr){var headers={};if(!headerStr){return headers;} // Trim headerStr to fix a MS Edge bug with xhr.getAllResponseHeaders method
	// which send a string starting with a "\n" character
	var headerPairs=headerStr.trim().split('\r\n');for(var i=0,ilen=headerPairs.length;i < ilen;i++) {var headerPair=headerPairs[i];var index=headerPair.indexOf(': ');if(index > 0){headers[headerPair.substring(0,index)] = headerPair.substring(index + 2);}}return headers;}function findRepresentationIndex(period,representationId){var index=findRepresentation(period,representationId,true);if(index !== null){return index;}return -1;}function findRepresentation(period,representationId,returnIndex){var adaptationSet=undefined,adaptationSetArray=undefined,representation=undefined,representationArray=undefined,adaptationSetArrayIndex=undefined,representationArrayIndex=undefined;if(period){adaptationSetArray = period.AdaptationSet_asArray;for(adaptationSetArrayIndex = 0;adaptationSetArrayIndex < adaptationSetArray.length;adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {adaptationSet = adaptationSetArray[adaptationSetArrayIndex];representationArray = adaptationSet.Representation_asArray;for(representationArrayIndex = 0;representationArrayIndex < representationArray.length;representationArrayIndex = representationArrayIndex + 1) {representation = representationArray[representationArrayIndex];if(representationId === representation.id){if(returnIndex){return representationArrayIndex;}else {return representation;}}}}}return null;}function adaptationIsType(adaptation,bufferType){return dashManifestModel.getIsTypeOf(adaptation,bufferType);}function findMaxBufferIndex(period,bufferType){var adaptationSet=undefined,adaptationSetArray=undefined,representationArray=undefined,adaptationSetArrayIndex=undefined;if(!period || !bufferType)return -1;adaptationSetArray = period.AdaptationSet_asArray;for(adaptationSetArrayIndex = 0;adaptationSetArrayIndex < adaptationSetArray.length;adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {adaptationSet = adaptationSetArray[adaptationSetArrayIndex];representationArray = adaptationSet.Representation_asArray;if(adaptationIsType(adaptationSet,bufferType)){return representationArray.length;}}return -1;}instance = {getBandwidthForRepresentation:getBandwidthForRepresentation,getIndexForRepresentation:getIndexForRepresentation,getMaxIndexForBufferType:getMaxIndexForBufferType,getCurrentRepresentationSwitch:getCurrentRepresentationSwitch,getLatestBufferLevelVO:getLatestBufferLevelVO,getCurrentBufferLevel:getCurrentBufferLevel,getCurrentHttpRequest:getCurrentHttpRequest,getHttpRequests:getHttpRequests,getCurrentDroppedFrames:getCurrentDroppedFrames,getCurrentSchedulingInfo:getCurrentSchedulingInfo,getCurrentDVRInfo:getCurrentDVRInfo,getCurrentManifestUpdate:getCurrentManifestUpdate,getLatestFragmentRequestHeaderValueByID:getLatestFragmentRequestHeaderValueByID,getLatestMPDRequestHeaderValueByID:getLatestMPDRequestHeaderValueByID,getRequestsQueue:getRequestsQueue};return instance;}DashMetrics.__dashjs_factory_name = 'DashMetrics';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(DashMetrics);module.exports = exports['default'];
	//# sourceMappingURL=DashMetrics.js.map


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _streamingUtilsRequestModifier=__webpack_require__(69);var _streamingUtilsRequestModifier2=_interopRequireDefault(_streamingUtilsRequestModifier);var _voSegment=__webpack_require__(86);var _voSegment2=_interopRequireDefault(_voSegment);var _streamingVoDashJSError=__webpack_require__(31);var _streamingVoDashJSError2=_interopRequireDefault(_streamingVoDashJSError);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _streamingUtilsBoxParser=__webpack_require__(68);var _streamingUtilsBoxParser2=_interopRequireDefault(_streamingUtilsBoxParser);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _streamingVoMetricsHTTPRequest=__webpack_require__(16);var _streamingVoFragmentRequest=__webpack_require__(37);var _streamingVoFragmentRequest2=_interopRequireDefault(_streamingVoFragmentRequest);var _streamingNetHTTPLoader=__webpack_require__(55);var _streamingNetHTTPLoader2=_interopRequireDefault(_streamingNetHTTPLoader);function SegmentBaseLoader(){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,errHandler=undefined,boxParser=undefined,requestModifier=undefined,metricsModel=undefined,mediaPlayerModel=undefined,httpLoader=undefined,baseURLController=undefined;function initialize(){boxParser = (0,_streamingUtilsBoxParser2['default'])(context).getInstance();requestModifier = (0,_streamingUtilsRequestModifier2['default'])(context).getInstance();httpLoader = (0,_streamingNetHTTPLoader2['default'])(context).create({errHandler:errHandler,metricsModel:metricsModel,mediaPlayerModel:mediaPlayerModel,requestModifier:requestModifier});}function setConfig(config){if(config.baseURLController){baseURLController = config.baseURLController;}if(config.metricsModel){metricsModel = config.metricsModel;}if(config.mediaPlayerModel){mediaPlayerModel = config.mediaPlayerModel;}if(config.errHandler){errHandler = config.errHandler;}}function checkSetConfigCall(){if(!baseURLController || !baseURLController.hasOwnProperty('resolve')){throw new Error('setConfig function has to be called previously');}}function loadInitialization(representation,loadingInfo){checkSetConfigCall();var initRange=null;var isoFile=null;var baseUrl=baseURLController.resolve(representation.path);var info=loadingInfo || {init:true,url:baseUrl?baseUrl.url:undefined,range:{start:0,end:1500},searching:false,bytesLoaded:0,bytesToLoad:1500};log('Start searching for initialization.');var request=getFragmentRequest(info);var onload=function onload(response){info.bytesLoaded = info.range.end;isoFile = boxParser.parse(response);initRange = findInitRange(isoFile);if(initRange){representation.range = initRange; // note that we don't explicitly set rep.initialization as this
	// will be computed when all BaseURLs are resolved later
	eventBus.trigger(_coreEventsEvents2['default'].INITIALIZATION_LOADED,{representation:representation});}else {info.range.end = info.bytesLoaded + info.bytesToLoad;loadInitialization(representation,info);}};var onerror=function onerror(){eventBus.trigger(_coreEventsEvents2['default'].INITIALIZATION_LOADED,{representation:representation});};httpLoader.load({request:request,success:onload,error:onerror});log('Perform init search: ' + info.url);}function loadSegments(representation,type,range,loadingInfo,callback){checkSetConfigCall();if(range && (range.start === undefined || range.end === undefined)){var parts=range?range.toString().split('-'):null;range = parts?{start:parseFloat(parts[0]),end:parseFloat(parts[1])}:null;}callback = !callback?onLoaded:callback;var isoFile=null;var sidx=null;var hasRange=!!range;var baseUrl=baseURLController.resolve(representation.path);var info={init:false,url:baseUrl?baseUrl.url:undefined,range:hasRange?range:{start:0,end:1500},searching:!hasRange,bytesLoaded:loadingInfo?loadingInfo.bytesLoaded:0,bytesToLoad:1500};var request=getFragmentRequest(info);var onload=function onload(response){var extraBytes=info.bytesToLoad;var loadedLength=response.byteLength;info.bytesLoaded = info.range.end - info.range.start;isoFile = boxParser.parse(response);sidx = isoFile.getBox('sidx');if(!sidx || !sidx.isComplete){if(sidx){info.range.start = sidx.offset || info.range.start;info.range.end = info.range.start + (sidx.size || extraBytes);}else if(loadedLength < info.bytesLoaded){ // if we have reached a search limit or if we have reached the end of the file we have to stop trying to find sidx
	callback(null,representation,type);return;}else {var lastBox=isoFile.getLastBox();if(lastBox && lastBox.size){info.range.start = lastBox.offset + lastBox.size;info.range.end = info.range.start + extraBytes;}else {info.range.end += extraBytes;}}loadSegments(representation,type,info.range,info,callback);}else {var ref=sidx.references;var loadMultiSidx=undefined,segments=undefined;if(ref !== null && ref !== undefined && ref.length > 0){loadMultiSidx = ref[0].reference_type === 1;}if(loadMultiSidx){(function(){log('Initiate multiple SIDX load.');info.range.end = info.range.start + sidx.size;var j=undefined,len=undefined,ss=undefined,se=undefined,r=undefined;var segs=[];var count=0;var offset=(sidx.offset || info.range.start) + sidx.size;var tmpCallback=function tmpCallback(result){if(result){segs = segs.concat(result);count++;if(count >= len){callback(segs,representation,type);}}else {callback(null,representation,type);}};for(j = 0,len = ref.length;j < len;j++) {ss = offset;se = offset + ref[j].referenced_size - 1;offset = offset + ref[j].referenced_size;r = {start:ss,end:se};loadSegments(representation,null,r,info,tmpCallback);}})();}else {log('Parsing segments from SIDX.');segments = getSegmentsForSidx(sidx,info);callback(segments,representation,type);}}};var onerror=function onerror(){callback(null,representation,type);};httpLoader.load({request:request,success:onload,error:onerror});log('Perform SIDX load: ' + info.url);}function reset(){httpLoader.abort();httpLoader = null;errHandler = null;boxParser = null;requestModifier = null;}function getSegmentsForSidx(sidx,info){var refs=sidx.references;var len=refs.length;var timescale=sidx.timescale;var time=sidx.earliest_presentation_time;var start=info.range.start + sidx.offset + sidx.first_offset + sidx.size;var segments=[];var segment=undefined,end=undefined,duration=undefined,size=undefined;for(var i=0;i < len;i++) {duration = refs[i].subsegment_duration;size = refs[i].referenced_size;segment = new _voSegment2['default'](); // note that we don't explicitly set segment.media as this will be
	// computed when all BaseURLs are resolved later
	segment.duration = duration;segment.startTime = time;segment.timescale = timescale;end = start + size - 1;segment.mediaRange = start + '-' + end;segments.push(segment);time += duration;start += size;}return segments;}function findInitRange(isoFile){var ftyp=isoFile.getBox('ftyp');var moov=isoFile.getBox('moov');var initRange=null;var start=undefined,end=undefined;log('Searching for initialization.');if(moov && moov.isComplete){start = ftyp?ftyp.offset:moov.offset;end = moov.offset + moov.size - 1;initRange = start + '-' + end;log('Found the initialization.  Range: ' + initRange);}return initRange;}function getFragmentRequest(info){if(!info.url){return;}var request=new _streamingVoFragmentRequest2['default']();request.type = info.init?_streamingVoMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE:_streamingVoMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE;request.url = info.url;request.range = info.range.start + '-' + info.range.end;return request;}function onLoaded(segments,representation,type){if(segments){eventBus.trigger(_coreEventsEvents2['default'].SEGMENTS_LOADED,{segments:segments,representation:representation,mediaType:type});}else {eventBus.trigger(_coreEventsEvents2['default'].SEGMENTS_LOADED,{segments:null,representation:representation,mediaType:type,error:new _streamingVoDashJSError2['default'](null,'error loading segments',null)});}}instance = {setConfig:setConfig,initialize:initialize,loadInitialization:loadInitialization,loadSegments:loadSegments,reset:reset};return instance;}SegmentBaseLoader.__dashjs_factory_name = 'SegmentBaseLoader';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(SegmentBaseLoader);module.exports = exports['default'];
	//# sourceMappingURL=SegmentBaseLoader.js.map


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _streamingUtilsEBMLParser=__webpack_require__(410);var _streamingUtilsEBMLParser2=_interopRequireDefault(_streamingUtilsEBMLParser);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _streamingUtilsRequestModifier=__webpack_require__(69);var _streamingUtilsRequestModifier2=_interopRequireDefault(_streamingUtilsRequestModifier);var _voSegment=__webpack_require__(86);var _voSegment2=_interopRequireDefault(_voSegment);var _streamingVoMetricsHTTPRequest=__webpack_require__(16);var _streamingVoFragmentRequest=__webpack_require__(37);var _streamingVoFragmentRequest2=_interopRequireDefault(_streamingVoFragmentRequest);var _streamingNetHTTPLoader=__webpack_require__(55);var _streamingNetHTTPLoader2=_interopRequireDefault(_streamingNetHTTPLoader);function WebmSegmentBaseLoader(){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,WebM=undefined,errHandler=undefined,requestModifier=undefined,metricsModel=undefined,mediaPlayerModel=undefined,httpLoader=undefined,baseURLController=undefined;function setup(){WebM = {EBML:{tag:0x1A45DFA3,required:true},Segment:{tag:0x18538067,required:true,SeekHead:{tag:0x114D9B74,required:true},Info:{tag:0x1549A966,required:true,TimecodeScale:{tag:0x2AD7B1,required:true,parse:'getMatroskaUint'},Duration:{tag:0x4489,required:true,parse:'getMatroskaFloat'}},Tracks:{tag:0x1654AE6B,required:true},Cues:{tag:0x1C53BB6B,required:true,CuePoint:{tag:0xBB,required:true,CueTime:{tag:0xB3,required:true,parse:'getMatroskaUint'},CueTrackPositions:{tag:0xB7,required:true,CueTrack:{tag:0xF7,required:true,parse:'getMatroskaUint'},CueClusterPosition:{tag:0xF1,required:true,parse:'getMatroskaUint'}}}}},Void:{tag:0xEC,required:true}};}function initialize(){requestModifier = (0,_streamingUtilsRequestModifier2['default'])(context).getInstance();httpLoader = (0,_streamingNetHTTPLoader2['default'])(context).create({errHandler:errHandler,metricsModel:metricsModel,mediaPlayerModel:mediaPlayerModel,requestModifier:requestModifier});}function setConfig(config){if(!config.baseURLController || !config.metricsModel || !config.mediaPlayerModel || !config.errHandler){throw new Error('Missing config parameter(s)');}baseURLController = config.baseURLController;metricsModel = config.metricsModel;mediaPlayerModel = config.mediaPlayerModel;errHandler = config.errHandler;}function parseCues(ab){var cues=[];var cue=undefined;var cueTrack=undefined;var ebmlParser=(0,_streamingUtilsEBMLParser2['default'])(context).create({data:ab});ebmlParser.consumeTagAndSize(WebM.Segment.Cues);while(ebmlParser.moreData() && ebmlParser.consumeTagAndSize(WebM.Segment.Cues.CuePoint,true)) {cue = {};cue.CueTime = ebmlParser.parseTag(WebM.Segment.Cues.CuePoint.CueTime);cue.CueTracks = [];while(ebmlParser.moreData() && ebmlParser.consumeTag(WebM.Segment.Cues.CuePoint.CueTrackPositions,true)) {var cueTrackPositionSize=ebmlParser.getMatroskaCodedNum();var startPos=ebmlParser.getPos();cueTrack = {};cueTrack.Track = ebmlParser.parseTag(WebM.Segment.Cues.CuePoint.CueTrackPositions.CueTrack);if(cueTrack.Track === 0){throw new Error('Cue track cannot be 0');}cueTrack.ClusterPosition = ebmlParser.parseTag(WebM.Segment.Cues.CuePoint.CueTrackPositions.CueClusterPosition);cue.CueTracks.push(cueTrack); // we're not interested any other elements - skip remaining bytes
	ebmlParser.setPos(startPos + cueTrackPositionSize);}if(cue.CueTracks.length === 0){throw new Error('Mandatory cuetrack not found');}cues.push(cue);}if(cues.length === 0){throw new Error('mandatory cuepoint not found');}return cues;}function parseSegments(data,segmentStart,segmentEnd,segmentDuration){var duration=undefined;var parsed=undefined;var segments=undefined;var segment=undefined;var i=undefined;var len=undefined;var start=undefined;var end=undefined;parsed = parseCues(data);segments = []; // we are assuming one cue track per cue point
	// both duration and media range require the i + 1 segment
	// the final segment has to use global segment parameters
	for(i = 0,len = parsed.length;i < len;i += 1) {segment = new _voSegment2['default']();duration = 0;if(i < parsed.length - 1){duration = parsed[i + 1].CueTime - parsed[i].CueTime;}else {duration = segmentDuration - parsed[i].CueTime;} // note that we don't explicitly set segment.media as this will be
	// computed when all BaseURLs are resolved later
	segment.duration = duration;segment.startTime = parsed[i].CueTime;segment.timescale = 1000; // hardcoded for ms
	start = parsed[i].CueTracks[0].ClusterPosition + segmentStart;if(i < parsed.length - 1){end = parsed[i + 1].CueTracks[0].ClusterPosition + segmentStart - 1;}else {end = segmentEnd - 1;}segment.mediaRange = start + '-' + end;segments.push(segment);}log('Parsed cues: ' + segments.length + ' cues.');return segments;}function parseEbmlHeader(data,media,theRange,callback){var ebmlParser=(0,_streamingUtilsEBMLParser2['default'])(context).create({data:data});var duration=undefined;var segments=undefined;var parts=theRange.split('-');var request=null;var info={url:media,range:{start:parseFloat(parts[0]),end:parseFloat(parts[1])},request:request};var segmentEnd=undefined;var segmentStart=undefined;log('Parse EBML header: ' + info.url); // skip over the header itself
	ebmlParser.skipOverElement(WebM.EBML);ebmlParser.consumeTag(WebM.Segment); // segments start here
	segmentEnd = ebmlParser.getMatroskaCodedNum();segmentEnd += ebmlParser.getPos();segmentStart = ebmlParser.getPos(); // skip over any top level elements to get to the segment info
	while(ebmlParser.moreData() && !ebmlParser.consumeTagAndSize(WebM.Segment.Info,true)) {if(!(ebmlParser.skipOverElement(WebM.Segment.SeekHead,true) || ebmlParser.skipOverElement(WebM.Segment.Tracks,true) || ebmlParser.skipOverElement(WebM.Segment.Cues,true) || ebmlParser.skipOverElement(WebM.Void,true))){throw new Error('no valid top level element found');}} // we only need one thing in segment info, duration
	while(duration === undefined) {var infoTag=ebmlParser.getMatroskaCodedNum(true);var infoElementSize=ebmlParser.getMatroskaCodedNum();switch(infoTag){case WebM.Segment.Info.Duration.tag:duration = ebmlParser[WebM.Segment.Info.Duration.parse](infoElementSize);break;default:ebmlParser.setPos(ebmlParser.getPos() + infoElementSize);break;}} // once we have what we need from segment info, we jump right to the
	// cues
	request = getFragmentRequest(info);var onload=function onload(response){segments = parseSegments(response,segmentStart,segmentEnd,duration);callback(segments);};var onloadend=function onloadend(){log('Download Error: Cues ' + info.url);callback(null);};httpLoader.load({request:request,success:onload,error:onloadend});log('Perform cues load: ' + info.url + ' bytes=' + info.range.start + '-' + info.range.end);}function checkSetConfigCall(){if(!baseURLController || !baseURLController.hasOwnProperty('resolve')){throw new Error('setConfig function has to be called previously');}}function loadInitialization(representation,loadingInfo){checkSetConfigCall();var request=null;var baseUrl=baseURLController.resolve(representation.path);var media=baseUrl?baseUrl.url:undefined;var initRange=representation.range.split('-');var info=loadingInfo || {range:{start:parseFloat(initRange[0]),end:parseFloat(initRange[1])},request:request,url:media,init:true};log('Start loading initialization.');request = getFragmentRequest(info);var onload=function onload(){ // note that we don't explicitly set rep.initialization as this
	// will be computed when all BaseURLs are resolved later
	eventBus.trigger(_coreEventsEvents2['default'].INITIALIZATION_LOADED,{representation:representation});};var onloadend=function onloadend(){eventBus.trigger(_coreEventsEvents2['default'].INITIALIZATION_LOADED,{representation:representation});};httpLoader.load({request:request,success:onload,error:onloadend});log('Perform init load: ' + info.url);}function loadSegments(representation,type,theRange,callback){checkSetConfigCall();var request=null;var baseUrl=baseURLController.resolve(representation.path);var media=baseUrl?baseUrl.url:undefined;var bytesToLoad=8192;var info={bytesLoaded:0,bytesToLoad:bytesToLoad,range:{start:0,end:bytesToLoad},request:request,url:media,init:false};callback = !callback?onLoaded:callback;request = getFragmentRequest(info); // first load the header, but preserve the manifest range so we can
	// load the cues after parsing the header
	// NOTE: we expect segment info to appear in the first 8192 bytes
	log('Parsing ebml header');var onload=function onload(response){parseEbmlHeader(response,media,theRange,function(segments){callback(segments,representation,type);});};var onloadend=function onloadend(){callback(null,representation,type);};httpLoader.load({request:request,success:onload,error:onloadend});}function onLoaded(segments,representation,type){if(segments){eventBus.trigger(_coreEventsEvents2['default'].SEGMENTS_LOADED,{segments:segments,representation:representation,mediaType:type});}else {eventBus.trigger(_coreEventsEvents2['default'].SEGMENTS_LOADED,{segments:null,representation:representation,mediaType:type,error:new Error(null,'error loading segments',null)});}}function getFragmentRequest(info){var request=new _streamingVoFragmentRequest2['default']();request.type = info.init?_streamingVoMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE:_streamingVoMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE;request.url = info.url;request.range = info.range.start + '-' + info.range.end;return request;}function reset(){errHandler = null;requestModifier = null;log = null;}instance = {setConfig:setConfig,initialize:initialize,loadInitialization:loadInitialization,loadSegments:loadSegments,reset:reset};setup();return instance;}WebmSegmentBaseLoader.__dashjs_factory_name = 'WebmSegmentBaseLoader';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(WebmSegmentBaseLoader);module.exports = exports['default'];
	//# sourceMappingURL=WebmSegmentBaseLoader.js.map


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _streamingConstantsConstants=__webpack_require__(8);var _streamingConstantsConstants2=_interopRequireDefault(_streamingConstantsConstants);var _constantsDashConstants=__webpack_require__(25);var _constantsDashConstants2=_interopRequireDefault(_constantsDashConstants);var _streamingVoDashJSError=__webpack_require__(31);var _streamingVoDashJSError2=_interopRequireDefault(_streamingVoDashJSError);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _voRepresentation=__webpack_require__(85);var _voRepresentation2=_interopRequireDefault(_voRepresentation);function RepresentationController(){var SEGMENTS_UPDATE_FAILED_ERROR_CODE=1;var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,realAdaptation=undefined,realAdaptationIndex=undefined,updating=undefined,voAvailableRepresentations=undefined,currentVoRepresentation=undefined,abrController=undefined,indexHandler=undefined,playbackController=undefined,metricsModel=undefined,domStorage=undefined,timelineConverter=undefined,dashManifestModel=undefined,dashMetrics=undefined,streamProcessor=undefined,manifestModel=undefined;function setup(){resetInitialSettings();eventBus.on(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED,onQualityChanged,instance);eventBus.on(_coreEventsEvents2['default'].REPRESENTATION_UPDATED,onRepresentationUpdated,instance);eventBus.on(_coreEventsEvents2['default'].WALLCLOCK_TIME_UPDATED,onWallclockTimeUpdated,instance);eventBus.on(_coreEventsEvents2['default'].BUFFER_LEVEL_UPDATED,onBufferLevelUpdated,instance);eventBus.on(_coreEventsEvents2['default'].MANIFEST_VALIDITY_CHANGED,onManifestValidityChanged,instance);}function setConfig(config){ // allow the abrController created in setup to be overidden
	if(config.abrController){abrController = config.abrController;}if(config.domStorage){domStorage = config.domStorage;}if(config.metricsModel){metricsModel = config.metricsModel;}if(config.dashMetrics){dashMetrics = config.dashMetrics;}if(config.dashManifestModel){dashManifestModel = config.dashManifestModel;}if(config.playbackController){playbackController = config.playbackController;}if(config.timelineConverter){timelineConverter = config.timelineConverter;}if(config.manifestModel){manifestModel = config.manifestModel;}if(config.streamProcessor){streamProcessor = config.streamProcessor;}}function initialize(){indexHandler = streamProcessor.getIndexHandler();}function getStreamProcessor(){return streamProcessor;}function getData(){return realAdaptation;}function getDataIndex(){return realAdaptationIndex;}function isUpdating(){return updating;}function getCurrentRepresentation(){return currentVoRepresentation;}function resetInitialSettings(){realAdaptation = null;realAdaptationIndex = -1;updating = true;voAvailableRepresentations = [];abrController = null;playbackController = null;metricsModel = null;domStorage = null;timelineConverter = null;dashManifestModel = null;dashMetrics = null;}function reset(){eventBus.off(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED,onQualityChanged,instance);eventBus.off(_coreEventsEvents2['default'].REPRESENTATION_UPDATED,onRepresentationUpdated,instance);eventBus.off(_coreEventsEvents2['default'].WALLCLOCK_TIME_UPDATED,onWallclockTimeUpdated,instance);eventBus.off(_coreEventsEvents2['default'].BUFFER_LEVEL_UPDATED,onBufferLevelUpdated,instance);eventBus.off(_coreEventsEvents2['default'].MANIFEST_VALIDITY_CHANGED,onManifestValidityChanged,instance);resetInitialSettings();}function updateData(newRealAdaptation,voAdaptation,type){var streamInfo=streamProcessor.getStreamInfo();var maxQuality=abrController.getTopQualityIndexFor(type,streamInfo.id);var minIdx=abrController.getMinAllowedIndexFor(type);var quality=undefined,averageThroughput=undefined;var bitrate=null;updating = true;eventBus.trigger(_coreEventsEvents2['default'].DATA_UPDATE_STARTED,{sender:this});voAvailableRepresentations = updateRepresentations(voAdaptation);if((realAdaptation === null || realAdaptation.id != newRealAdaptation.id) && type !== _streamingConstantsConstants2['default'].FRAGMENTED_TEXT){averageThroughput = abrController.getThroughputHistory().getAverageThroughput(type);bitrate = averageThroughput || abrController.getInitialBitrateFor(type,streamInfo);quality = abrController.getQualityForBitrate(streamProcessor.getMediaInfo(),bitrate);}else {quality = abrController.getQualityFor(type,streamInfo);}if(minIdx !== undefined && quality < minIdx){quality = minIdx;}if(quality > maxQuality){quality = maxQuality;}currentVoRepresentation = getRepresentationForQuality(quality);realAdaptation = newRealAdaptation;if(type !== _streamingConstantsConstants2['default'].VIDEO && type !== _streamingConstantsConstants2['default'].AUDIO && type !== _streamingConstantsConstants2['default'].FRAGMENTED_TEXT){updating = false;eventBus.trigger(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,{sender:this,data:realAdaptation,currentRepresentation:currentVoRepresentation});return;}for(var i=0;i < voAvailableRepresentations.length;i++) {indexHandler.updateRepresentation(voAvailableRepresentations[i],true);}}function addRepresentationSwitch(){var now=new Date();var currentRepresentation=getCurrentRepresentation();var currentVideoTimeMs=playbackController.getTime() * 1000;metricsModel.addRepresentationSwitch(currentRepresentation.adaptation.type,now,currentVideoTimeMs,currentRepresentation.id);}function addDVRMetric(){var streamInfo=streamProcessor.getStreamInfo();var manifestInfo=streamInfo?streamInfo.manifestInfo:null;var isDynamic=manifestInfo?manifestInfo.isDynamic:null;var range=timelineConverter.calcSegmentAvailabilityRange(currentVoRepresentation,isDynamic);metricsModel.addDVRInfo(streamProcessor.getType(),playbackController.getTime(),manifestInfo,range);}function getRepresentationForQuality(quality){return voAvailableRepresentations[quality];}function getQualityForRepresentation(voRepresentation){return voAvailableRepresentations.indexOf(voRepresentation);}function isAllRepresentationsUpdated(){for(var i=0,ln=voAvailableRepresentations.length;i < ln;i++) {var segmentInfoType=voAvailableRepresentations[i].segmentInfoType;if(voAvailableRepresentations[i].segmentAvailabilityRange === null || !_voRepresentation2['default'].hasInitialization(voAvailableRepresentations[i]) || (segmentInfoType === _constantsDashConstants2['default'].SEGMENT_BASE || segmentInfoType === _constantsDashConstants2['default'].BASE_URL) && !voAvailableRepresentations[i].segments){return false;}}return true;}function updateRepresentations(voAdaptation){var voReps=undefined;realAdaptationIndex = dashManifestModel.getIndexForAdaptation(realAdaptation,voAdaptation.period.mpd.manifest,voAdaptation.period.index);voReps = dashManifestModel.getRepresentationsForAdaptation(voAdaptation);return voReps;}function updateAvailabilityWindow(isDynamic){var voRepresentation=undefined;for(var i=0,ln=voAvailableRepresentations.length;i < ln;i++) {voRepresentation = voAvailableRepresentations[i];voRepresentation.segmentAvailabilityRange = timelineConverter.calcSegmentAvailabilityRange(voRepresentation,isDynamic);}}function resetAvailabilityWindow(){voAvailableRepresentations.forEach(function(rep){rep.segmentAvailabilityRange = null;});}function postponeUpdate(postponeTimePeriod){var delay=postponeTimePeriod;var update=function update(){if(isUpdating())return;updating = true;eventBus.trigger(_coreEventsEvents2['default'].DATA_UPDATE_STARTED,{sender:instance}); // clear the segmentAvailabilityRange for all reps.
	// this ensures all are updated before the live edge search starts
	resetAvailabilityWindow();for(var i=0;i < voAvailableRepresentations.length;i++) {indexHandler.updateRepresentation(voAvailableRepresentations[i],true);}};updating = false;eventBus.trigger(_coreEventsEvents2['default'].AST_IN_FUTURE,{delay:delay});setTimeout(update,delay);}function onRepresentationUpdated(e){if(e.sender.getStreamProcessor() !== streamProcessor || !isUpdating())return;var r=e.representation;var streamMetrics=metricsModel.getMetricsFor(_streamingConstantsConstants2['default'].STREAM);var metrics=metricsModel.getMetricsFor(getCurrentRepresentation().adaptation.type);var manifestUpdateInfo=dashMetrics.getCurrentManifestUpdate(streamMetrics);var alreadyAdded=false;var postponeTimePeriod=0;var repInfo=undefined,err=undefined,repSwitch=undefined;if(r.adaptation.period.mpd.manifest.type === _constantsDashConstants2['default'].DYNAMIC && !r.adaptation.period.mpd.manifest.ignorePostponeTimePeriod){var segmentAvailabilityTimePeriod=r.segmentAvailabilityRange.end - r.segmentAvailabilityRange.start; // We must put things to sleep unless till e.g. the startTime calculation in ScheduleController.onLiveEdgeSearchCompleted fall after the segmentAvailabilityRange.start
	var liveDelay=playbackController.computeLiveDelay(currentVoRepresentation.segmentDuration,streamProcessor.getStreamInfo().manifestInfo.DVRWindowSize);postponeTimePeriod = (liveDelay - segmentAvailabilityTimePeriod) * 1000;}if(postponeTimePeriod > 0){addDVRMetric();postponeUpdate(postponeTimePeriod);err = new _streamingVoDashJSError2['default'](SEGMENTS_UPDATE_FAILED_ERROR_CODE,'Segments update failed',null);eventBus.trigger(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,{sender:this,data:realAdaptation,currentRepresentation:currentVoRepresentation,error:err});return;}if(manifestUpdateInfo){for(var i=0;i < manifestUpdateInfo.representationInfo.length;i++) {repInfo = manifestUpdateInfo.representationInfo[i];if(repInfo.index === r.index && repInfo.mediaType === streamProcessor.getType()){alreadyAdded = true;break;}}if(!alreadyAdded){metricsModel.addManifestUpdateRepresentationInfo(manifestUpdateInfo,r.id,r.index,r.adaptation.period.index,streamProcessor.getType(),r.presentationTimeOffset,r.startNumber,r.segmentInfoType);}}if(isAllRepresentationsUpdated()){updating = false;abrController.setPlaybackQuality(streamProcessor.getType(),streamProcessor.getStreamInfo(),getQualityForRepresentation(currentVoRepresentation));metricsModel.updateManifestUpdateInfo(manifestUpdateInfo,{latency:currentVoRepresentation.segmentAvailabilityRange.end - playbackController.getTime()});repSwitch = dashMetrics.getCurrentRepresentationSwitch(metrics);if(!repSwitch){addRepresentationSwitch();}eventBus.trigger(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,{sender:this,data:realAdaptation,currentRepresentation:currentVoRepresentation});}}function onWallclockTimeUpdated(e){if(e.isDynamic){updateAvailabilityWindow(e.isDynamic);}}function onBufferLevelUpdated(e){if(e.sender.getStreamProcessor() !== streamProcessor)return;var manifest=manifestModel.getValue();if(!manifest.doNotUpdateDVRWindowOnBufferUpdated){addDVRMetric();}}function onQualityChanged(e){if(e.mediaType !== streamProcessor.getType() || streamProcessor.getStreamInfo().id !== e.streamInfo.id)return;if(e.oldQuality !== e.newQuality){currentVoRepresentation = getRepresentationForQuality(e.newQuality);var bitrate=abrController.getThroughputHistory().getAverageThroughput(e.mediaType);if(!isNaN(bitrate)){domStorage.setSavedBitrateSettings(e.mediaType,bitrate);}addRepresentationSwitch();}}function onManifestValidityChanged(e){if(e.newDuration){var representation=getCurrentRepresentation();if(representation && representation.adaptation.period){var period=representation.adaptation.period;period.duration = e.newDuration;}}}instance = {initialize:initialize,setConfig:setConfig,getData:getData,getDataIndex:getDataIndex,isUpdating:isUpdating,updateData:updateData,getStreamProcessor:getStreamProcessor,getCurrentRepresentation:getCurrentRepresentation,getRepresentationForQuality:getRepresentationForQuality,reset:reset};setup();return instance;}RepresentationController.__dashjs_factory_name = 'RepresentationController';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(RepresentationController);module.exports = exports['default'];
	//# sourceMappingURL=RepresentationController.js.map


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _streamingConstantsConstants=__webpack_require__(8);var _streamingConstantsConstants2=_interopRequireDefault(_streamingConstantsConstants);var _constantsDashConstants=__webpack_require__(25);var _constantsDashConstants2=_interopRequireDefault(_constantsDashConstants);var _voRepresentation=__webpack_require__(85);var _voRepresentation2=_interopRequireDefault(_voRepresentation);var _voAdaptationSet=__webpack_require__(326);var _voAdaptationSet2=_interopRequireDefault(_voAdaptationSet);var _voPeriod=__webpack_require__(329);var _voPeriod2=_interopRequireDefault(_voPeriod);var _voMpd=__webpack_require__(328);var _voMpd2=_interopRequireDefault(_voMpd);var _voUTCTiming=__webpack_require__(142);var _voUTCTiming2=_interopRequireDefault(_voUTCTiming);var _voEvent=__webpack_require__(141);var _voEvent2=_interopRequireDefault(_voEvent);var _voBaseURL=__webpack_require__(140);var _voBaseURL2=_interopRequireDefault(_voBaseURL);var _voEventStream=__webpack_require__(327);var _voEventStream2=_interopRequireDefault(_voEventStream);var _streamingUtilsObjectUtils=__webpack_require__(153);var _streamingUtilsObjectUtils2=_interopRequireDefault(_streamingUtilsObjectUtils);var _streamingUtilsURLUtils=__webpack_require__(30);var _streamingUtilsURLUtils2=_interopRequireDefault(_streamingUtilsURLUtils);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function DashManifestModel(config){config = config || {};var instance=undefined;var context=this.context;var urlUtils=(0,_streamingUtilsURLUtils2['default'])(context).getInstance();var mediaController=config.mediaController;var timelineConverter=config.timelineConverter;var adapter=config.adapter;var PROFILE_DVB='urn:dvb:dash:profile:dvb-dash:2014';var isInteger=Number.isInteger || function(value){return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;};function getIsTypeOf(adaptation,type){var i=undefined,len=undefined,representation=undefined,col=undefined,mimeTypeRegEx=undefined,codecs=undefined;var result=false;var found=false;if(!adaptation){throw new Error('adaptation is not defined');}if(!type){throw new Error('type is not defined');}if(adaptation.hasOwnProperty('ContentComponent_asArray')){col = adaptation.ContentComponent_asArray;}mimeTypeRegEx = type !== _streamingConstantsConstants2['default'].TEXT?new RegExp(type):new RegExp('(vtt|ttml)');if(adaptation.Representation_asArray && adaptation.Representation_asArray.length && adaptation.Representation_asArray.length > 0 && adaptation.Representation_asArray[0].hasOwnProperty(_constantsDashConstants2['default'].CODECS)){ // Just check the start of the codecs string
	codecs = adaptation.Representation_asArray[0].codecs;if(codecs.search(_streamingConstantsConstants2['default'].STPP) === 0 || codecs.search(_streamingConstantsConstants2['default'].WVTT) === 0){return type === _streamingConstantsConstants2['default'].FRAGMENTED_TEXT;}}if(col){if(col.length > 1){return type === _streamingConstantsConstants2['default'].MUXED;}else if(col[0] && col[0].contentType === type){result = true;found = true;}}if(adaptation.hasOwnProperty(_constantsDashConstants2['default'].MIME_TYPE)){result = mimeTypeRegEx.test(adaptation.mimeType);found = true;} // couldn't find on adaptationset, so check a representation
	if(!found){i = 0;len = adaptation.Representation_asArray && adaptation.Representation_asArray.length?adaptation.Representation_asArray.length:0;while(!found && i < len) {representation = adaptation.Representation_asArray[i];if(representation.hasOwnProperty(_constantsDashConstants2['default'].MIME_TYPE)){result = mimeTypeRegEx.test(representation.mimeType);found = true;}i++;}}return result;}function getIsAudio(adaptation){return getIsTypeOf(adaptation,_streamingConstantsConstants2['default'].AUDIO);}function getIsVideo(adaptation){return getIsTypeOf(adaptation,_streamingConstantsConstants2['default'].VIDEO);}function getIsFragmentedText(adaptation){return getIsTypeOf(adaptation,_streamingConstantsConstants2['default'].FRAGMENTED_TEXT);}function getIsText(adaptation){return getIsTypeOf(adaptation,_streamingConstantsConstants2['default'].TEXT);}function getIsMuxed(adaptation){return getIsTypeOf(adaptation,_streamingConstantsConstants2['default'].MUXED);}function getIsImage(adaptation){return getIsTypeOf(adaptation,_streamingConstantsConstants2['default'].IMAGE);}function getIsTextTrack(type){return type === 'text/vtt' || type === 'application/ttml+xml';}function getLanguageForAdaptation(adaptation){var lang='';if(adaptation && adaptation.hasOwnProperty(_constantsDashConstants2['default'].LANG)){ //Filter out any other characters not allowed according to RFC5646
	lang = adaptation.lang.replace(/[^A-Za-z0-9-]/g,'');}return lang;}function getViewpointForAdaptation(adaptation){return adaptation && adaptation.hasOwnProperty(_constantsDashConstants2['default'].VIEWPOINT)?adaptation.Viewpoint:null;}function getRolesForAdaptation(adaptation){return adaptation && adaptation.hasOwnProperty(_constantsDashConstants2['default'].ROLE_ASARRAY)?adaptation.Role_asArray:[];}function getAccessibilityForAdaptation(adaptation){return adaptation && adaptation.hasOwnProperty(_constantsDashConstants2['default'].ACCESSIBILITY_ASARRAY)?adaptation.Accessibility_asArray:[];}function getAudioChannelConfigurationForAdaptation(adaptation){return adaptation && adaptation.hasOwnProperty(_constantsDashConstants2['default'].AUDIOCHANNELCONFIGURATION_ASARRAY)?adaptation.AudioChannelConfiguration_asArray:[];}function getIsMain(adaptation){return getRolesForAdaptation(adaptation).filter(function(role){return role.value === _constantsDashConstants2['default'].MAIN;})[0];}function getRepresentationSortFunction(){return function(a,b){return a.bandwidth - b.bandwidth;};}function processAdaptation(realAdaptation){if(realAdaptation && realAdaptation.Representation_asArray !== undefined && realAdaptation.Representation_asArray !== null){realAdaptation.Representation_asArray.sort(getRepresentationSortFunction());}return realAdaptation;}function getAdaptationForId(id,manifest,periodIndex){var realAdaptations=manifest && manifest.Period_asArray && isInteger(periodIndex)?manifest.Period_asArray[periodIndex]?manifest.Period_asArray[periodIndex].AdaptationSet_asArray:[]:[];var i=undefined,len=undefined;for(i = 0,len = realAdaptations.length;i < len;i++) {if(realAdaptations[i].hasOwnProperty(_constantsDashConstants2['default'].ID) && realAdaptations[i].id === id){return realAdaptations[i];}}return null;}function getAdaptationForIndex(index,manifest,periodIndex){var realAdaptations=manifest && manifest.Period_asArray && isInteger(periodIndex)?manifest.Period_asArray[periodIndex]?manifest.Period_asArray[periodIndex].AdaptationSet_asArray:null:null;if(realAdaptations && isInteger(index)){return realAdaptations[index];}else {return null;}}function getIndexForAdaptation(realAdaptation,manifest,periodIndex){var realAdaptations=manifest && manifest.Period_asArray && isInteger(periodIndex)?manifest.Period_asArray[periodIndex]?manifest.Period_asArray[periodIndex].AdaptationSet_asArray:[]:[];var len=realAdaptations.length;if(realAdaptation){for(var i=0;i < len;i++) {var objectUtils=(0,_streamingUtilsObjectUtils2['default'])(context).getInstance();if(objectUtils.areEqual(realAdaptations[i],realAdaptation)){return i;}}}return -1;}function getAdaptationsForType(manifest,periodIndex,type){var realAdaptationSet=manifest && manifest.Period_asArray && isInteger(periodIndex)?manifest.Period_asArray[periodIndex]?manifest.Period_asArray[periodIndex].AdaptationSet_asArray:[]:[];var i=undefined,len=undefined;var adaptations=[];for(i = 0,len = realAdaptationSet.length;i < len;i++) {if(getIsTypeOf(realAdaptationSet[i],type)){adaptations.push(processAdaptation(realAdaptationSet[i]));}}return adaptations;}function getAdaptationForType(manifest,periodIndex,type,streamInfo){var adaptations=getAdaptationsForType(manifest,periodIndex,type);if(!adaptations || adaptations.length === 0)return null;if(adaptations.length > 1 && streamInfo){var currentTrack=mediaController.getCurrentTrackFor(type,streamInfo);var allMediaInfoForType=adapter.getAllMediaInfoForType(streamInfo,type);if(currentTrack){for(var i=0,ln=adaptations.length;i < ln;i++) {if(mediaController.isTracksEqual(currentTrack,allMediaInfoForType[i])){return adaptations[i];}}}for(var i=0,ln=adaptations.length;i < ln;i++) {if(getIsMain(adaptations[i])){return adaptations[i];}}}return adaptations[0];}function getCodec(adaptation,representationId,addResolutionInfo){if(adaptation && adaptation.Representation_asArray && adaptation.Representation_asArray.length > 0){var representation=isInteger(representationId) && representationId >= 0 && representationId < adaptation.Representation_asArray.length?adaptation.Representation_asArray[representationId]:adaptation.Representation_asArray[0];var codec=representation.mimeType + ';codecs="' + representation.codecs + '"';if(addResolutionInfo && representation.width !== undefined){codec += ';width="' + representation.width + '";height="' + representation.height + '"';}return codec;}return null;}function getMimeType(adaptation){return adaptation && adaptation.Representation_asArray && adaptation.Representation_asArray.length > 0?adaptation.Representation_asArray[0].mimeType:null;}function getKID(adaptation){if(!adaptation || !adaptation.hasOwnProperty(_constantsDashConstants2['default'].CENC_DEFAULT_KID)){return null;}return adaptation[_constantsDashConstants2['default'].CENC_DEFAULT_KID];}function getContentProtectionData(adaptation){if(!adaptation || !adaptation.hasOwnProperty(_constantsDashConstants2['default'].CONTENTPROTECTION_ASARRAY) || adaptation.ContentProtection_asArray.length === 0){return null;}return adaptation.ContentProtection_asArray;}function getIsDynamic(manifest){var isDynamic=false;if(manifest && manifest.hasOwnProperty('type')){isDynamic = manifest.type === _constantsDashConstants2['default'].DYNAMIC;}return isDynamic;}function hasProfile(manifest,profile){var has=false;if(manifest && manifest.profiles && manifest.profiles.length > 0){has = manifest.profiles.indexOf(profile) !== -1;}return has;}function getIsDVB(manifest){return hasProfile(manifest,PROFILE_DVB);}function getDuration(manifest){var mpdDuration=undefined; //@mediaPresentationDuration specifies the duration of the entire Media Presentation.
	//If the attribute is not present, the duration of the Media Presentation is unknown.
	if(manifest && manifest.hasOwnProperty(_constantsDashConstants2['default'].MEDIA_PRESENTATION_DURATION)){mpdDuration = manifest.mediaPresentationDuration;}else {mpdDuration = Number.MAX_SAFE_INTEGER || Number.MAX_VALUE;}return mpdDuration;}function getBandwidth(representation){return representation && representation.bandwidth?representation.bandwidth:NaN;}function getManifestUpdatePeriod(manifest){var latencyOfLastUpdate=arguments.length <= 1 || arguments[1] === undefined?0:arguments[1];var delay=NaN;if(manifest && manifest.hasOwnProperty(_constantsDashConstants2['default'].MINIMUM_UPDATE_PERIOD)){delay = manifest.minimumUpdatePeriod;}return isNaN(delay)?delay:Math.max(delay - latencyOfLastUpdate,1);}function getRepresentationCount(adaptation){return adaptation && adaptation.Representation_asArray && adaptation.Representation_asArray.length?adaptation.Representation_asArray.length:0;}function getBitrateListForAdaptation(realAdaptation){if(!realAdaptation || !realAdaptation.Representation_asArray || !realAdaptation.Representation_asArray.length)return null;var processedRealAdaptation=processAdaptation(realAdaptation);var realRepresentations=processedRealAdaptation.Representation_asArray;return realRepresentations.map(function(realRepresentation){return {bandwidth:realRepresentation.bandwidth,width:realRepresentation.width || 0,height:realRepresentation.height || 0,scanType:realRepresentation.scanType || null};});}function getEssentialPropertiesForRepresentation(realRepresentation){if(!realRepresentation || !realRepresentation.EssentialProperty_asArray || !realRepresentation.EssentialProperty_asArray.length)return null;return realRepresentation.EssentialProperty_asArray.map(function(prop){return {schemeIdUri:prop.schemeIdUri,value:prop.value};});}function getRepresentationFor(index,adaptation){return adaptation && adaptation.Representation_asArray && adaptation.Representation_asArray.length > 0 && isInteger(index)?adaptation.Representation_asArray[index]:null;}function getRealAdaptationFor(voAdaptation){if(voAdaptation && voAdaptation.period && isInteger(voAdaptation.period.index)){var periodArray=voAdaptation.period.mpd.manifest.Period_asArray[voAdaptation.period.index];if(periodArray && periodArray.AdaptationSet_asArray && isInteger(voAdaptation.index)){return processAdaptation(periodArray.AdaptationSet_asArray[voAdaptation.index]);}}}function isLastRepeatAttributeValid(segmentTimeline){var s=segmentTimeline.S_asArray[segmentTimeline.S_asArray.length - 1];return !s.hasOwnProperty('r') || s.r >= 0;}function getUseCalculatedLiveEdgeTimeForAdaptation(voAdaptation){var realRepresentation=getRealAdaptationFor(voAdaptation).Representation_asArray[0];var segmentInfo=undefined;if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].SEGMENT_LIST)){segmentInfo = realRepresentation.SegmentList;return segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].SEGMENT_TIMELINE)?isLastRepeatAttributeValid(segmentInfo.SegmentTimeline):true;}else if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].SEGMENT_TEMPLATE)){segmentInfo = realRepresentation.SegmentTemplate;if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].SEGMENT_TIMELINE)){return isLastRepeatAttributeValid(segmentInfo.SegmentTimeline);}}return false;}function getRepresentationsForAdaptation(voAdaptation){var voRepresentations=[];var processedRealAdaptation=getRealAdaptationFor(voAdaptation);var segmentInfo=undefined;var baseUrl=undefined; // TODO: TO BE REMOVED. We should get just the baseUrl elements that affects to the representations
	// that we are processing. Making it works properly will require much further changes and given
	// parsing base Urls parameters is needed for our ultra low latency examples, we will
	// keep this "tricky" code until the real (and good) solution comes
	if(voAdaptation && voAdaptation.period && isInteger(voAdaptation.period.index)){var baseUrls=getBaseURLsFromElement(voAdaptation.period.mpd.manifest);if(baseUrls){baseUrl = baseUrls[0];}}if(processedRealAdaptation && processedRealAdaptation.Representation_asArray){for(var i=0,len=processedRealAdaptation.Representation_asArray.length;i < len;++i) {var realRepresentation=processedRealAdaptation.Representation_asArray[i];var voRepresentation=new _voRepresentation2['default']();voRepresentation.index = i;voRepresentation.adaptation = voAdaptation;if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].ID)){voRepresentation.id = realRepresentation.id;}if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].CODECS)){voRepresentation.codecs = realRepresentation.codecs;}if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].CODEC_PRIVATE_DATA)){voRepresentation.codecPrivateData = realRepresentation.codecPrivateData;}if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].BANDWITH)){voRepresentation.bandwidth = realRepresentation.bandwidth;}if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].WIDTH)){voRepresentation.width = realRepresentation.width;}if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].HEIGHT)){voRepresentation.height = realRepresentation.height;}if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].SCAN_TYPE)){voRepresentation.scanType = realRepresentation.scanType;}if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].MAX_PLAYOUT_RATE)){voRepresentation.maxPlayoutRate = realRepresentation.maxPlayoutRate;}if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].SEGMENT_BASE)){segmentInfo = realRepresentation.SegmentBase;voRepresentation.segmentInfoType = _constantsDashConstants2['default'].SEGMENT_BASE;}else if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].SEGMENT_LIST)){segmentInfo = realRepresentation.SegmentList;if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].SEGMENT_TIMELINE)){voRepresentation.segmentInfoType = _constantsDashConstants2['default'].SEGMENT_TIMELINE;voRepresentation.useCalculatedLiveEdgeTime = isLastRepeatAttributeValid(segmentInfo.SegmentTimeline);}else {voRepresentation.segmentInfoType = _constantsDashConstants2['default'].SEGMENT_LIST;voRepresentation.useCalculatedLiveEdgeTime = true;}}else if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].SEGMENT_TEMPLATE)){segmentInfo = realRepresentation.SegmentTemplate;if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].SEGMENT_TIMELINE)){voRepresentation.segmentInfoType = _constantsDashConstants2['default'].SEGMENT_TIMELINE;voRepresentation.useCalculatedLiveEdgeTime = isLastRepeatAttributeValid(segmentInfo.SegmentTimeline);}else {voRepresentation.segmentInfoType = _constantsDashConstants2['default'].SEGMENT_TEMPLATE;}if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].INITIALIZATION_MINUS)){voRepresentation.initialization = segmentInfo.initialization.split('$Bandwidth$').join(realRepresentation.bandwidth).split('$RepresentationID$').join(realRepresentation.id);}}else {voRepresentation.segmentInfoType = _constantsDashConstants2['default'].BASE_URL;}voRepresentation.essentialProperties = getEssentialPropertiesForRepresentation(realRepresentation);if(segmentInfo){if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].INITIALIZATION)){var initialization=segmentInfo.Initialization;if(initialization.hasOwnProperty(_constantsDashConstants2['default'].SOURCE_URL)){voRepresentation.initialization = initialization.sourceURL;}else if(initialization.hasOwnProperty(_constantsDashConstants2['default'].RANGE)){voRepresentation.range = initialization.range; // initialization source url will be determined from
	// BaseURL when resolved at load time.
	}}else if(realRepresentation.hasOwnProperty(_constantsDashConstants2['default'].MIME_TYPE) && getIsTextTrack(realRepresentation.mimeType)){voRepresentation.range = 0;}if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].TIMESCALE)){voRepresentation.timescale = segmentInfo.timescale;}if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].DURATION)){ // TODO according to the spec @maxSegmentDuration specifies the maximum duration of any Segment in any Representation in the Media Presentation
	// It is also said that for a SegmentTimeline any @d value shall not exceed the value of MPD@maxSegmentDuration, but nothing is said about
	// SegmentTemplate @duration attribute. We need to find out if @maxSegmentDuration should be used instead of calculated duration if the the duration
	// exceeds @maxSegmentDuration
	//representation.segmentDuration = Math.min(segmentInfo.duration / representation.timescale, adaptation.period.mpd.maxSegmentDuration);
	voRepresentation.segmentDuration = segmentInfo.duration / voRepresentation.timescale;}if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].MEDIA)){voRepresentation.media = segmentInfo.media;}if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].START_NUMBER)){voRepresentation.startNumber = segmentInfo.startNumber;}if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].INDEX_RANGE)){voRepresentation.indexRange = segmentInfo.indexRange;}if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].PRESENTATION_TIME_OFFSET)){voRepresentation.presentationTimeOffset = segmentInfo.presentationTimeOffset / voRepresentation.timescale;}if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].AVAILABILITY_TIME_OFFSET)){voRepresentation.availabilityTimeOffset = segmentInfo.availabilityTimeOffset;}else if(baseUrl && baseUrl.availabilityTimeOffset !== undefined){voRepresentation.availabilityTimeOffset = baseUrl.availabilityTimeOffset;}if(segmentInfo.hasOwnProperty(_constantsDashConstants2['default'].AVAILABILITY_TIME_COMPLETE)){voRepresentation.availabilityTimeComplete = segmentInfo.availabilityTimeComplete !== 'false';}else if(baseUrl && baseUrl.availabilityTimeComplete !== undefined){voRepresentation.availabilityTimeComplete = baseUrl.availabilityTimeComplete;}}voRepresentation.MSETimeOffset = timelineConverter.calcMSETimeOffset(voRepresentation);voRepresentation.path = [voAdaptation.period.index,voAdaptation.index,i];voRepresentations.push(voRepresentation);}}return voRepresentations;}function getAdaptationsForPeriod(voPeriod){var realPeriod=voPeriod && isInteger(voPeriod.index)?voPeriod.mpd.manifest.Period_asArray[voPeriod.index]:null;var voAdaptations=[];var voAdaptationSet=undefined,realAdaptationSet=undefined,i=undefined;if(realPeriod && realPeriod.AdaptationSet_asArray){for(i = 0;i < realPeriod.AdaptationSet_asArray.length;i++) {realAdaptationSet = realPeriod.AdaptationSet_asArray[i];voAdaptationSet = new _voAdaptationSet2['default']();if(realAdaptationSet.hasOwnProperty(_constantsDashConstants2['default'].ID)){voAdaptationSet.id = realAdaptationSet.id;}voAdaptationSet.index = i;voAdaptationSet.period = voPeriod;if(getIsMuxed(realAdaptationSet)){voAdaptationSet.type = _streamingConstantsConstants2['default'].MUXED;}else if(getIsAudio(realAdaptationSet)){voAdaptationSet.type = _streamingConstantsConstants2['default'].AUDIO;}else if(getIsVideo(realAdaptationSet)){voAdaptationSet.type = _streamingConstantsConstants2['default'].VIDEO;}else if(getIsFragmentedText(realAdaptationSet)){voAdaptationSet.type = _streamingConstantsConstants2['default'].FRAGMENTED_TEXT;}else if(getIsImage(realAdaptationSet)){voAdaptationSet.type = _streamingConstantsConstants2['default'].IMAGE;}else {voAdaptationSet.type = _streamingConstantsConstants2['default'].TEXT;}voAdaptations.push(voAdaptationSet);}}return voAdaptations;}function getRegularPeriods(mpd){var isDynamic=mpd?getIsDynamic(mpd.manifest):false;var voPeriods=[];var realPeriod1=null;var realPeriod=null;var voPeriod1=null;var voPeriod=null;var len=undefined,i=undefined;for(i = 0,len = mpd && mpd.manifest && mpd.manifest.Period_asArray?mpd.manifest.Period_asArray.length:0;i < len;i++) {realPeriod = mpd.manifest.Period_asArray[i]; // If the attribute @start is present in the Period, then the
	// Period is a regular Period and the PeriodStart is equal
	// to the value of this attribute.
	if(realPeriod.hasOwnProperty(_constantsDashConstants2['default'].START)){voPeriod = new _voPeriod2['default']();voPeriod.start = realPeriod.start;} // If the @start attribute is absent, but the previous Period
	// element contains a @duration attribute then then this new
	// Period is also a regular Period. The start time of the new
	// Period PeriodStart is the sum of the start time of the previous
	// Period PeriodStart and the value of the attribute @duration
	// of the previous Period.
	else if(realPeriod1 !== null && realPeriod.hasOwnProperty(_constantsDashConstants2['default'].DURATION) && voPeriod1 !== null){voPeriod = new _voPeriod2['default']();voPeriod.start = parseFloat((voPeriod1.start + voPeriod1.duration).toFixed(5));voPeriod.duration = realPeriod.duration;} // If (i) @start attribute is absent, and (ii) the Period element
	// is the first in the MPD, and (iii) the MPD@type is 'static',
	// then the PeriodStart time shall be set to zero.
	else if(i === 0 && !isDynamic){voPeriod = new _voPeriod2['default']();voPeriod.start = 0;} // The Period extends until the PeriodStart of the next Period.
	// The difference between the PeriodStart time of a Period and
	// the PeriodStart time of the following Period.
	if(voPeriod1 !== null && isNaN(voPeriod1.duration)){voPeriod1.duration = parseFloat((voPeriod.start - voPeriod1.start).toFixed(5));}if(voPeriod !== null){voPeriod.id = getPeriodId(realPeriod,i);}if(voPeriod !== null && realPeriod.hasOwnProperty(_constantsDashConstants2['default'].DURATION)){voPeriod.duration = realPeriod.duration;}if(voPeriod !== null){voPeriod.index = i;voPeriod.mpd = mpd;voPeriods.push(voPeriod);realPeriod1 = realPeriod;voPeriod1 = voPeriod;}realPeriod = null;voPeriod = null;}if(voPeriods.length === 0){return voPeriods;} // The last Period extends until the end of the Media Presentation.
	// The difference between the PeriodStart time of the last Period
	// and the mpd duration
	if(voPeriod1 !== null && isNaN(voPeriod1.duration)){voPeriod1.duration = parseFloat((getEndTimeForLastPeriod(voPeriod1) - voPeriod1.start).toFixed(5));}return voPeriods;}function getPeriodId(realPeriod,i){if(!realPeriod){throw new Error('Period cannot be null or undefined');}var id=_voPeriod2['default'].DEFAULT_ID + '_' + i;if(realPeriod.hasOwnProperty(_constantsDashConstants2['default'].ID) && realPeriod.id.length > 0 && realPeriod.id !== '__proto__'){id = realPeriod.id;}return id;}function getMpd(manifest){var mpd=new _voMpd2['default']();if(manifest){mpd.manifest = manifest;if(manifest.hasOwnProperty(_constantsDashConstants2['default'].AVAILABILITY_START_TIME)){mpd.availabilityStartTime = new Date(manifest.availabilityStartTime.getTime());}else {mpd.availabilityStartTime = new Date(manifest.loadedTime.getTime());}if(manifest.hasOwnProperty(_constantsDashConstants2['default'].AVAILABILITY_END_TIME)){mpd.availabilityEndTime = new Date(manifest.availabilityEndTime.getTime());}if(manifest.hasOwnProperty(_constantsDashConstants2['default'].MINIMUM_UPDATE_PERIOD)){mpd.minimumUpdatePeriod = manifest.minimumUpdatePeriod;}if(manifest.hasOwnProperty(_constantsDashConstants2['default'].MEDIA_PRESENTATION_DURATION)){mpd.mediaPresentationDuration = manifest.mediaPresentationDuration;}if(manifest.hasOwnProperty(_streamingConstantsConstants2['default'].SUGGESTED_PRESENTATION_DELAY)){mpd.suggestedPresentationDelay = manifest.suggestedPresentationDelay;}if(manifest.hasOwnProperty(_constantsDashConstants2['default'].TIMESHIFT_BUFFER_DEPTH)){mpd.timeShiftBufferDepth = manifest.timeShiftBufferDepth;}if(manifest.hasOwnProperty(_constantsDashConstants2['default'].MAX_SEGMENT_DURATION)){mpd.maxSegmentDuration = manifest.maxSegmentDuration;}}return mpd;}function getEndTimeForLastPeriod(voPeriod){var isDynamic=getIsDynamic(voPeriod.mpd.manifest);var periodEnd=undefined;if(voPeriod.mpd.manifest.mediaPresentationDuration){periodEnd = voPeriod.mpd.manifest.mediaPresentationDuration;}else if(voPeriod.duration){periodEnd = voPeriod.duration;}else if(isDynamic){periodEnd = Number.POSITIVE_INFINITY;}else {throw new Error('Must have @mediaPresentationDuratio on MPD or an explicit @duration on the last period.');}return periodEnd;}function getEventsForPeriod(period){var manifest=period && period.mpd && period.mpd.manifest?period.mpd.manifest:null;var periodArray=manifest?manifest.Period_asArray:null;var eventStreams=periodArray && period && isInteger(period.index)?periodArray[period.index].EventStream_asArray:null;var events=[];var i=undefined,j=undefined;if(eventStreams){for(i = 0;i < eventStreams.length;i++) {var eventStream=new _voEventStream2['default']();eventStream.period = period;eventStream.timescale = 1;if(eventStreams[i].hasOwnProperty(_streamingConstantsConstants2['default'].SCHEME_ID_URI)){eventStream.schemeIdUri = eventStreams[i].schemeIdUri;}else {throw new Error('Invalid EventStream. SchemeIdUri has to be set');}if(eventStreams[i].hasOwnProperty(_constantsDashConstants2['default'].TIMESCALE)){eventStream.timescale = eventStreams[i].timescale;}if(eventStreams[i].hasOwnProperty(_constantsDashConstants2['default'].VALUE)){eventStream.value = eventStreams[i].value;}for(j = 0;j < eventStreams[i].Event_asArray.length;j++) {var _event=new _voEvent2['default']();_event.presentationTime = 0;_event.eventStream = eventStream;if(eventStreams[i].Event_asArray[j].hasOwnProperty(_constantsDashConstants2['default'].PRESENTATION_TIME)){_event.presentationTime = eventStreams[i].Event_asArray[j].presentationTime;}if(eventStreams[i].Event_asArray[j].hasOwnProperty(_constantsDashConstants2['default'].DURATION)){_event.duration = eventStreams[i].Event_asArray[j].duration;}if(eventStreams[i].Event_asArray[j].hasOwnProperty(_constantsDashConstants2['default'].ID)){_event.id = eventStreams[i].Event_asArray[j].id;}events.push(_event);}}}return events;}function getEventStreams(inbandStreams,representation){var eventStreams=[];var i=undefined;if(!inbandStreams)return eventStreams;for(i = 0;i < inbandStreams.length;i++) {var eventStream=new _voEventStream2['default']();eventStream.timescale = 1;eventStream.representation = representation;if(inbandStreams[i].hasOwnProperty(_streamingConstantsConstants2['default'].SCHEME_ID_URI)){eventStream.schemeIdUri = inbandStreams[i].schemeIdUri;}else {throw new Error('Invalid EventStream. SchemeIdUri has to be set');}if(inbandStreams[i].hasOwnProperty(_constantsDashConstants2['default'].TIMESCALE)){eventStream.timescale = inbandStreams[i].timescale;}if(inbandStreams[i].hasOwnProperty(_constantsDashConstants2['default'].VALUE)){eventStream.value = inbandStreams[i].value;}eventStreams.push(eventStream);}return eventStreams;}function getEventStreamForAdaptationSet(manifest,adaptation){var inbandStreams=undefined,periodArray=undefined,adaptationArray=undefined;if(manifest && manifest.Period_asArray && adaptation && adaptation.period && isInteger(adaptation.period.index)){periodArray = manifest.Period_asArray[adaptation.period.index];if(periodArray && periodArray.AdaptationSet_asArray && isInteger(adaptation.index)){adaptationArray = periodArray.AdaptationSet_asArray[adaptation.index];if(adaptationArray){inbandStreams = adaptationArray.InbandEventStream_asArray;}}}return getEventStreams(inbandStreams,null);}function getEventStreamForRepresentation(manifest,representation){var inbandStreams=undefined,periodArray=undefined,adaptationArray=undefined,representationArray=undefined;if(manifest && manifest.Period_asArray && representation && representation.adaptation && representation.adaptation.period && isInteger(representation.adaptation.period.index)){periodArray = manifest.Period_asArray[representation.adaptation.period.index];if(periodArray && periodArray.AdaptationSet_asArray && isInteger(representation.adaptation.index)){adaptationArray = periodArray.AdaptationSet_asArray[representation.adaptation.index];if(adaptationArray && adaptationArray.Representation_asArray && isInteger(representation.index)){representationArray = adaptationArray.Representation_asArray[representation.index];if(representationArray){inbandStreams = representationArray.InbandEventStream_asArray;}}}}return getEventStreams(inbandStreams,representation);}function getUTCTimingSources(manifest){var isDynamic=getIsDynamic(manifest);var hasAST=manifest?manifest.hasOwnProperty(_constantsDashConstants2['default'].AVAILABILITY_START_TIME):false;var utcTimingsArray=manifest?manifest.UTCTiming_asArray:null;var utcTimingEntries=[]; // do not bother synchronizing the clock unless MPD is live,
	// or it is static and has availabilityStartTime attribute
	if(isDynamic || hasAST){if(utcTimingsArray){ // the order is important here - 23009-1 states that the order
	// in the manifest "indicates relative preference, first having
	// the highest, and the last the lowest priority".
	utcTimingsArray.forEach(function(utcTiming){var entry=new _voUTCTiming2['default']();if(utcTiming.hasOwnProperty(_streamingConstantsConstants2['default'].SCHEME_ID_URI)){entry.schemeIdUri = utcTiming.schemeIdUri;}else { // entries of type DescriptorType with no schemeIdUri
	// are meaningless. let's just ignore this entry and
	// move on.
	return;} // this is (incorrectly) interpreted as a number - schema
	// defines it as a string
	if(utcTiming.hasOwnProperty(_constantsDashConstants2['default'].VALUE)){entry.value = utcTiming.value.toString();}else { // without a value, there's not a lot we can do with
	// this entry. let's just ignore this one and move on
	return;} // we're not interested in the optional id or any other
	// attributes which might be attached to the entry
	utcTimingEntries.push(entry);});}}return utcTimingEntries;}function getBaseURLsFromElement(node){var baseUrls=[]; // if node.BaseURL_asArray and node.baseUri are undefined entries
	// will be [undefined] which entries.some will just skip
	var entries=node.BaseURL_asArray || [node.baseUri];var earlyReturn=false;entries.some(function(entry){if(entry){var baseUrl=new _voBaseURL2['default']();var text=entry.__text || entry;if(urlUtils.isRelative(text)){ // it doesn't really make sense to have relative and
	// absolute URLs at the same level, or multiple
	// relative URLs at the same level, so assume we are
	// done from this level of the MPD
	earlyReturn = true; // deal with the specific case where the MPD@BaseURL
	// is specified and is relative. when no MPD@BaseURL
	// entries exist, that case is handled by the
	// [node.baseUri] in the entries definition.
	if(node.baseUri){text = urlUtils.resolve(text,node.baseUri);}}baseUrl.url = text; // serviceLocation is optional, but we need it in order
	// to blacklist correctly. if it's not available, use
	// anything unique since there's no relationship to any
	// other BaseURL and, in theory, the url should be
	// unique so use this instead.
	if(entry.hasOwnProperty(_constantsDashConstants2['default'].SERVICE_LOCATION) && entry.serviceLocation.length){baseUrl.serviceLocation = entry.serviceLocation;}else {baseUrl.serviceLocation = text;}if(entry.hasOwnProperty(_constantsDashConstants2['default'].DVB_PRIORITY)){baseUrl.dvb_priority = entry[_constantsDashConstants2['default'].DVB_PRIORITY];}if(entry.hasOwnProperty(_constantsDashConstants2['default'].DVB_WEIGHT)){baseUrl.dvb_weight = entry[_constantsDashConstants2['default'].DVB_WEIGHT];}if(entry.hasOwnProperty(_constantsDashConstants2['default'].AVAILABILITY_TIME_OFFSET)){baseUrl.availabilityTimeOffset = entry[_constantsDashConstants2['default'].AVAILABILITY_TIME_OFFSET];}if(entry.hasOwnProperty(_constantsDashConstants2['default'].AVAILABILITY_TIME_COMPLETE)){baseUrl.availabilityTimeComplete = entry[_constantsDashConstants2['default'].AVAILABILITY_TIME_COMPLETE] !== 'false';} /* NOTE: byteRange currently unused
	                 */baseUrls.push(baseUrl);return earlyReturn;}});return baseUrls;}function getLocation(manifest){if(manifest && manifest.hasOwnProperty(_streamingConstantsConstants2['default'].LOCATION)){ // for now, do not support multiple Locations -
	// just set Location to the first Location.
	manifest.Location = manifest.Location_asArray[0];return manifest.Location;} // may well be undefined
	return undefined;}instance = {getIsTypeOf:getIsTypeOf,getIsAudio:getIsAudio,getIsVideo:getIsVideo,getIsText:getIsText,getIsMuxed:getIsMuxed,getIsTextTrack:getIsTextTrack,getIsFragmentedText:getIsFragmentedText,getIsImage:getIsImage,getIsMain:getIsMain,getLanguageForAdaptation:getLanguageForAdaptation,getViewpointForAdaptation:getViewpointForAdaptation,getRolesForAdaptation:getRolesForAdaptation,getAccessibilityForAdaptation:getAccessibilityForAdaptation,getAudioChannelConfigurationForAdaptation:getAudioChannelConfigurationForAdaptation,getAdaptationForIndex:getAdaptationForIndex,getIndexForAdaptation:getIndexForAdaptation,getAdaptationForId:getAdaptationForId,getAdaptationsForType:getAdaptationsForType,getAdaptationForType:getAdaptationForType,getCodec:getCodec,getMimeType:getMimeType,getKID:getKID,getContentProtectionData:getContentProtectionData,getIsDynamic:getIsDynamic,getIsDVB:getIsDVB,getDuration:getDuration,getBandwidth:getBandwidth,getManifestUpdatePeriod:getManifestUpdatePeriod,getRepresentationCount:getRepresentationCount,getBitrateListForAdaptation:getBitrateListForAdaptation,getRepresentationFor:getRepresentationFor,getRepresentationsForAdaptation:getRepresentationsForAdaptation,getAdaptationsForPeriod:getAdaptationsForPeriod,getRegularPeriods:getRegularPeriods,getMpd:getMpd,getEventsForPeriod:getEventsForPeriod,getEventStreamForAdaptationSet:getEventStreamForAdaptationSet,getEventStreamForRepresentation:getEventStreamForRepresentation,getUTCTimingSources:getUTCTimingSources,getBaseURLsFromElement:getBaseURLsFromElement,getRepresentationSortFunction:getRepresentationSortFunction,getLocation:getLocation,getUseCalculatedLiveEdgeTimeForAdaptation:getUseCalculatedLiveEdgeTimeForAdaptation};return instance;}DashManifestModel.__dashjs_factory_name = 'DashManifestModel';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(DashManifestModel);module.exports = exports['default'];
	//# sourceMappingURL=DashManifestModel.js.map


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _externalsObjectiron=__webpack_require__(300);var _externalsObjectiron2=_interopRequireDefault(_externalsObjectiron);var _externalsXml2json=__webpack_require__(137);var _externalsXml2json2=_interopRequireDefault(_externalsXml2json);var _matchersStringMatcher=__webpack_require__(318);var _matchersStringMatcher2=_interopRequireDefault(_matchersStringMatcher);var _matchersDurationMatcher=__webpack_require__(316);var _matchersDurationMatcher2=_interopRequireDefault(_matchersDurationMatcher);var _matchersDateTimeMatcher=__webpack_require__(315);var _matchersDateTimeMatcher2=_interopRequireDefault(_matchersDateTimeMatcher);var _matchersNumericMatcher=__webpack_require__(317);var _matchersNumericMatcher2=_interopRequireDefault(_matchersNumericMatcher);var _mapsRepresentationBaseValuesMap=__webpack_require__(313);var _mapsRepresentationBaseValuesMap2=_interopRequireDefault(_mapsRepresentationBaseValuesMap);var _mapsSegmentValuesMap=__webpack_require__(314);var _mapsSegmentValuesMap2=_interopRequireDefault(_mapsSegmentValuesMap);function DashParser(config){config = config || {};var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var errorHandler=config.errorHandler;var instance=undefined,matchers=undefined,converter=undefined,objectIron=undefined;function setup(){matchers = [new _matchersDurationMatcher2['default'](),new _matchersDateTimeMatcher2['default'](),new _matchersNumericMatcher2['default'](),new _matchersStringMatcher2['default']() // last in list to take precedence over NumericMatcher
	];converter = new _externalsXml2json2['default']({escapeMode:false,attributePrefix:'',arrayAccessForm:'property',emptyNodeForm:'object',stripWhitespaces:false,enableToStringFunc:false,ignoreRoot:true,matchers:matchers});objectIron = new _externalsObjectiron2['default']([new _mapsRepresentationBaseValuesMap2['default'](),new _mapsSegmentValuesMap2['default']()]);}function checkConfig(){if(!errorHandler || !errorHandler.hasOwnProperty('manifestError')){throw new Error('Missing config parameter(s)');}}function getMatchers(){return matchers;}function getIron(){return objectIron;}function parse(data){var manifest=undefined;checkConfig();try{var startTime=window.performance.now();manifest = converter.xml_str2json(data);if(!manifest){throw new Error('parser error');}var jsonTime=window.performance.now();objectIron.run(manifest);var ironedTime=window.performance.now();log('Parsing complete: ( xml2json: ' + (jsonTime - startTime).toPrecision(3) + 'ms, objectiron: ' + (ironedTime - jsonTime).toPrecision(3) + 'ms, total: ' + ((ironedTime - startTime) / 1000).toPrecision(3) + 's)');}catch(err) {errorHandler.manifestError('parsing the manifest failed','parse',data,err);return null;}return manifest;}instance = {parse:parse,getMatchers:getMatchers,getIron:getIron};setup();return instance;}DashParser.__dashjs_factory_name = 'DashParser';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(DashParser);module.exports = exports['default'];
	//# sourceMappingURL=DashParser.js.map


/***/ },
/* 312 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc a property belonging to a MapNode
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var CommonProperty=(function(){function CommonProperty(name,merge){_classCallCheck(this,CommonProperty);var getDefaultMergeForName=function getDefaultMergeForName(n){return n && n.length && n.charAt(0) === n.charAt(0).toUpperCase();};this._name = name;this._merge = merge !== undefined?merge:getDefaultMergeForName(name);}_createClass(CommonProperty,[{key:"name",get:function get(){return this._name;}},{key:"merge",get:function get(){return this._merge;}}]);return CommonProperty;})();exports["default"] = CommonProperty;module.exports = exports["default"];
	//# sourceMappingURL=CommonProperty.js.map


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc a RepresentationBaseValuesMap type for input to objectiron
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _MapNode2=__webpack_require__(139);var _MapNode3=_interopRequireDefault(_MapNode2);var _constantsDashConstants=__webpack_require__(25);var _constantsDashConstants2=_interopRequireDefault(_constantsDashConstants);var RepresentationBaseValuesMap=(function(_MapNode){_inherits(RepresentationBaseValuesMap,_MapNode);function RepresentationBaseValuesMap(){_classCallCheck(this,RepresentationBaseValuesMap);var commonProperties=[_constantsDashConstants2['default'].PROFILES,_constantsDashConstants2['default'].WIDTH,_constantsDashConstants2['default'].HEIGHT,_constantsDashConstants2['default'].SAR,_constantsDashConstants2['default'].FRAMERATE,_constantsDashConstants2['default'].AUDIO_SAMPLING_RATE,_constantsDashConstants2['default'].MIME_TYPE,_constantsDashConstants2['default'].SEGMENT_PROFILES,_constantsDashConstants2['default'].CODECS,_constantsDashConstants2['default'].MAXIMUM_SAP_PERIOD,_constantsDashConstants2['default'].START_WITH_SAP,_constantsDashConstants2['default'].MAX_PLAYOUT_RATE,_constantsDashConstants2['default'].CODING_DEPENDENCY,_constantsDashConstants2['default'].SCAN_TYPE,_constantsDashConstants2['default'].FRAME_PACKING,_constantsDashConstants2['default'].AUDIO_CHANNEL_CONFIGURATION,_constantsDashConstants2['default'].CONTENT_PROTECTION,_constantsDashConstants2['default'].ESSENTIAL_PROPERTY,_constantsDashConstants2['default'].SUPPLEMENTAL_PROPERTY,_constantsDashConstants2['default'].INBAND_EVENT_STREAM];_get(Object.getPrototypeOf(RepresentationBaseValuesMap.prototype),'constructor',this).call(this,_constantsDashConstants2['default'].ADAPTATION_SET,commonProperties,[new _MapNode3['default'](_constantsDashConstants2['default'].REPRESENTATION,commonProperties,[new _MapNode3['default'](_constantsDashConstants2['default'].SUB_REPRESENTATION,commonProperties)])]);}return RepresentationBaseValuesMap;})(_MapNode3['default']);exports['default'] = RepresentationBaseValuesMap;module.exports = exports['default'];
	//# sourceMappingURL=RepresentationBaseValuesMap.js.map


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc a SegmentValuesMap type for input to objectiron
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _MapNode2=__webpack_require__(139);var _MapNode3=_interopRequireDefault(_MapNode2);var _constantsDashConstants=__webpack_require__(25);var _constantsDashConstants2=_interopRequireDefault(_constantsDashConstants);var SegmentValuesMap=(function(_MapNode){_inherits(SegmentValuesMap,_MapNode);function SegmentValuesMap(){_classCallCheck(this,SegmentValuesMap);var commonProperties=[_constantsDashConstants2['default'].SEGMENT_BASE,_constantsDashConstants2['default'].SEGMENT_TEMPLATE,_constantsDashConstants2['default'].SEGMENT_LIST];_get(Object.getPrototypeOf(SegmentValuesMap.prototype),'constructor',this).call(this,_constantsDashConstants2['default'].PERIOD,commonProperties,[new _MapNode3['default'](_constantsDashConstants2['default'].ADAPTATION_SET,commonProperties,[new _MapNode3['default'](_constantsDashConstants2['default'].REPRESENTATION,commonProperties)])]);}return SegmentValuesMap;})(_MapNode3['default']);exports['default'] = SegmentValuesMap;module.exports = exports['default'];
	//# sourceMappingURL=SegmentValuesMap.js.map


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc matches and converts xs:datetime to Date
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _BaseMatcher2=__webpack_require__(63);var _BaseMatcher3=_interopRequireDefault(_BaseMatcher2);var SECONDS_IN_MIN=60;var MINUTES_IN_HOUR=60;var MILLISECONDS_IN_SECONDS=1000;var datetimeRegex=/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})(?::?)([0-9]{2}))?/;var DateTimeMatcher=(function(_BaseMatcher){_inherits(DateTimeMatcher,_BaseMatcher);function DateTimeMatcher(){_classCallCheck(this,DateTimeMatcher);_get(Object.getPrototypeOf(DateTimeMatcher.prototype),'constructor',this).call(this,function(attr){return datetimeRegex.test(attr.value);},function(str){var match=datetimeRegex.exec(str);var utcDate=undefined; // If the string does not contain a timezone offset different browsers can interpret it either
	// as UTC or as a local time so we have to parse the string manually to normalize the given date value for
	// all browsers
	utcDate = Date.UTC(parseInt(match[1],10),parseInt(match[2],10) - 1, // months start from zero
	parseInt(match[3],10),parseInt(match[4],10),parseInt(match[5],10),match[6] && parseInt(match[6],10) || 0,match[7] && parseFloat(match[7]) * MILLISECONDS_IN_SECONDS || 0); // If the date has timezone offset take it into account as well
	if(match[9] && match[10]){var timezoneOffset=parseInt(match[9],10) * MINUTES_IN_HOUR + parseInt(match[10],10);utcDate += (match[8] === '+'?-1:+1) * timezoneOffset * SECONDS_IN_MIN * MILLISECONDS_IN_SECONDS;}return new Date(utcDate);});}return DateTimeMatcher;})(_BaseMatcher3['default']);exports['default'] = DateTimeMatcher;module.exports = exports['default'];
	//# sourceMappingURL=DateTimeMatcher.js.map


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc matches and converts xs:duration to seconds
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _BaseMatcher2=__webpack_require__(63);var _BaseMatcher3=_interopRequireDefault(_BaseMatcher2);var _streamingConstantsConstants=__webpack_require__(8);var _streamingConstantsConstants2=_interopRequireDefault(_streamingConstantsConstants);var _constantsDashConstants=__webpack_require__(25);var _constantsDashConstants2=_interopRequireDefault(_constantsDashConstants);var durationRegex=/^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?T?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*)S)?/;var SECONDS_IN_YEAR=365 * 24 * 60 * 60;var SECONDS_IN_MONTH=30 * 24 * 60 * 60;var SECONDS_IN_DAY=24 * 60 * 60;var SECONDS_IN_HOUR=60 * 60;var SECONDS_IN_MIN=60;var DurationMatcher=(function(_BaseMatcher){_inherits(DurationMatcher,_BaseMatcher);function DurationMatcher(){_classCallCheck(this,DurationMatcher);_get(Object.getPrototypeOf(DurationMatcher.prototype),'constructor',this).call(this,function(attr){var attributeList=[_constantsDashConstants2['default'].MIN_BUFFER_TIME,_constantsDashConstants2['default'].MEDIA_PRESENTATION_DURATION,_constantsDashConstants2['default'].MINIMUM_UPDATE_PERIOD,_constantsDashConstants2['default'].TIMESHIFT_BUFFER_DEPTH,_constantsDashConstants2['default'].MAX_SEGMENT_DURATION,_constantsDashConstants2['default'].MAX_SUBSEGMENT_DURATION,_streamingConstantsConstants2['default'].SUGGESTED_PRESENTATION_DELAY,_constantsDashConstants2['default'].START,_streamingConstantsConstants2['default'].START_TIME,_constantsDashConstants2['default'].DURATION];var len=attributeList.length;for(var i=0;i < len;i++) {if(attr.nodeName === attributeList[i]){return durationRegex.test(attr.value);}}return false;},function(str){ //str = "P10Y10M10DT10H10M10.1S";
	var match=durationRegex.exec(str);var result=parseFloat(match[2] || 0) * SECONDS_IN_YEAR + parseFloat(match[4] || 0) * SECONDS_IN_MONTH + parseFloat(match[6] || 0) * SECONDS_IN_DAY + parseFloat(match[8] || 0) * SECONDS_IN_HOUR + parseFloat(match[10] || 0) * SECONDS_IN_MIN + parseFloat(match[12] || 0);if(match[1] !== undefined){result = -result;}return result;});}return DurationMatcher;})(_BaseMatcher3['default']);exports['default'] = DurationMatcher;module.exports = exports['default'];
	//# sourceMappingURL=DurationMatcher.js.map


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc Matches and converts xs:numeric to float
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _BaseMatcher2=__webpack_require__(63);var _BaseMatcher3=_interopRequireDefault(_BaseMatcher2);var numericRegex=/^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/;var NumericMatcher=(function(_BaseMatcher){_inherits(NumericMatcher,_BaseMatcher);function NumericMatcher(){_classCallCheck(this,NumericMatcher);_get(Object.getPrototypeOf(NumericMatcher.prototype),'constructor',this).call(this,function(attr){return numericRegex.test(attr.value);},function(str){return parseFloat(str);});}return NumericMatcher;})(_BaseMatcher3['default']);exports['default'] = NumericMatcher;module.exports = exports['default'];
	//# sourceMappingURL=NumericMatcher.js.map


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc Matches and converts xs:string to string, but only for specific attributes on specific nodes
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key] = value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _BaseMatcher2=__webpack_require__(63);var _BaseMatcher3=_interopRequireDefault(_BaseMatcher2);var _constantsDashConstants=__webpack_require__(25);var _constantsDashConstants2=_interopRequireDefault(_constantsDashConstants);var StringMatcher=(function(_BaseMatcher){_inherits(StringMatcher,_BaseMatcher);function StringMatcher(){_classCallCheck(this,StringMatcher);_get(Object.getPrototypeOf(StringMatcher.prototype),'constructor',this).call(this,function(attr,nodeName){var _stringAttrsInElements;var stringAttrsInElements=(_stringAttrsInElements = {},_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].MPD,[_constantsDashConstants2['default'].ID,_constantsDashConstants2['default'].PROFILES]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].PERIOD,[_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].BASE_URL,[_constantsDashConstants2['default'].SERVICE_LOCATION,_constantsDashConstants2['default'].BYTE_RANGE]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].SEGMENT_BASE,[_constantsDashConstants2['default'].INDEX_RANGE]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].INITIALIZATION,[_constantsDashConstants2['default'].RANGE]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].REPRESENTATION_INDEX,[_constantsDashConstants2['default'].RANGE]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].SEGMENT_LIST,[_constantsDashConstants2['default'].INDEX_RANGE]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].BITSTREAM_SWITCHING,[_constantsDashConstants2['default'].RANGE]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].SEGMENT_URL,[_constantsDashConstants2['default'].MEDIA_RANGE,_constantsDashConstants2['default'].INDEX_RANGE]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].SEGMENT_TEMPLATE,[_constantsDashConstants2['default'].INDEX_RANGE,_constantsDashConstants2['default'].MEDIA,_constantsDashConstants2['default'].INDEX,_constantsDashConstants2['default'].INITIALIZATION_MINUS,_constantsDashConstants2['default'].BITSTREAM_SWITCHING_MINUS]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].ASSET_IDENTIFIER,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].EVENT_STREAM,[_constantsDashConstants2['default'].VALUE]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].ADAPTATION_SET,[_constantsDashConstants2['default'].PROFILES,_constantsDashConstants2['default'].MIME_TYPE,_constantsDashConstants2['default'].SEGMENT_PROFILES,_constantsDashConstants2['default'].CODECS,_constantsDashConstants2['default'].CONTENT_TYPE]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].FRAME_PACKING,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].AUDIO_CHANNEL_CONFIGURATION,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].CONTENT_PROTECTION,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].ESSENTIAL_PROPERTY,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].SUPPLEMENTAL_PROPERTY,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].INBAND_EVENT_STREAM,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].ACCESSIBILITY,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].ROLE,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].RATING,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].VIEWPOINT,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].CONTENT_COMPONENT,[_constantsDashConstants2['default'].CONTENT_TYPE]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].REPRESENTATION,[_constantsDashConstants2['default'].ID,_constantsDashConstants2['default'].DEPENDENCY_ID,_constantsDashConstants2['default'].MEDIA_STREAM_STRUCTURE_ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].SUBSET,[_constantsDashConstants2['default'].ID]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].METRICS,[_constantsDashConstants2['default'].METRICS_MINUS]),_defineProperty(_stringAttrsInElements,_constantsDashConstants2['default'].REPORTING,[_constantsDashConstants2['default'].VALUE,_constantsDashConstants2['default'].ID]),_stringAttrsInElements);if(stringAttrsInElements.hasOwnProperty(nodeName)){var attrNames=stringAttrsInElements[nodeName];if(attrNames !== undefined){return attrNames.indexOf(attr.name) >= 0;}else {return false;}}return false;},function(str){return String(str);});}return StringMatcher;})(_BaseMatcher3['default']);exports['default'] = StringMatcher;module.exports = exports['default'];
	//# sourceMappingURL=StringMatcher.js.map


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function FragmentedTextBoxParser(){var instance=undefined,boxParser=undefined;function setConfig(config){if(!config)return;if(config.boxParser){boxParser = config.boxParser;}}function getSamplesInfo(ab){if(!boxParser){throw new Error('boxParser is undefined');}if(!ab || ab.byteLength === 0){return {sampleList:[],lastSequenceNumber:NaN,totalDuration:NaN,numSequences:NaN};}var isoFile=boxParser.parse(ab); // zero or more moofs
	var moofBoxes=isoFile.getBoxes('moof'); // exactly one mfhd per moof
	var mfhdBoxes=isoFile.getBoxes('mfhd');var sampleDuration=undefined,sampleCompositionTimeOffset=undefined,sampleCount=undefined,sampleSize=undefined,sampleDts=undefined,sampleList=undefined,sample=undefined,i=undefined,j=undefined,k=undefined,l=undefined,m=undefined,n=undefined,dataOffset=undefined,lastSequenceNumber=undefined,numSequences=undefined,totalDuration=undefined;numSequences = isoFile.getBoxes('moof').length;lastSequenceNumber = mfhdBoxes[mfhdBoxes.length - 1].sequence_number;sampleCount = 0;sampleList = [];var subsIndex=-1;var nextSubsSample=-1;for(l = 0;l < moofBoxes.length;l++) {var moofBox=moofBoxes[l]; // zero or more trafs per moof
	var trafBoxes=moofBox.getChildBoxes('traf');for(j = 0;j < trafBoxes.length;j++) {var trafBox=trafBoxes[j]; // exactly one tfhd per traf
	var tfhdBox=trafBox.getChildBox('tfhd'); // zero or one tfdt per traf
	var tfdtBox=trafBox.getChildBox('tfdt');sampleDts = tfdtBox.baseMediaDecodeTime; // zero or more truns per traf
	var trunBoxes=trafBox.getChildBoxes('trun'); // zero or more subs per traf
	var subsBoxes=trafBox.getChildBoxes('subs');for(k = 0;k < trunBoxes.length;k++) {var trunBox=trunBoxes[k];sampleCount = trunBox.sample_count;dataOffset = (tfhdBox.base_data_offset || 0) + (trunBox.data_offset || 0);for(i = 0;i < sampleCount;i++) {sample = trunBox.samples[i];sampleDuration = sample.sample_duration !== undefined?sample.sample_duration:tfhdBox.default_sample_duration;sampleSize = sample.sample_size !== undefined?sample.sample_size:tfhdBox.default_sample_size;sampleCompositionTimeOffset = sample.sample_composition_time_offset !== undefined?sample.sample_composition_time_offset:0;var sampleData={'dts':sampleDts,'cts':sampleDts + sampleCompositionTimeOffset,'duration':sampleDuration,'offset':moofBox.offset + dataOffset,'size':sampleSize,'subSizes':[sampleSize]};if(subsBoxes){for(m = 0;m < subsBoxes.length;m++) {var subsBox=subsBoxes[m];if(subsIndex < subsBox.entry_count && i > nextSubsSample){subsIndex++;nextSubsSample += subsBox.entries[subsIndex].sample_delta;}if(i == nextSubsSample){sampleData.subSizes = [];var entry=subsBox.entries[subsIndex];for(n = 0;n < entry.subsample_count;n++) {sampleData.subSizes.push(entry.subsamples[n].subsample_size);}}}}sampleList.push(sampleData);dataOffset += sampleSize;sampleDts += sampleDuration;}}totalDuration = sampleDts - tfdtBox.baseMediaDecodeTime;}}return {sampleList:sampleList,lastSequenceNumber:lastSequenceNumber,totalDuration:totalDuration,numSequences:numSequences};}function getMediaTimescaleFromMoov(ab){if(!boxParser){throw new Error('boxParser is undefined');}var isoFile=boxParser.parse(ab);var mdhdBox=isoFile?isoFile.getBox('mdhd'):undefined;return mdhdBox?mdhdBox.timescale:NaN;}instance = {getSamplesInfo:getSamplesInfo,getMediaTimescaleFromMoov:getMediaTimescaleFromMoov,setConfig:setConfig};return instance;}FragmentedTextBoxParser.__dashjs_factory_name = 'FragmentedTextBoxParser';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(FragmentedTextBoxParser);module.exports = exports['default'];
	//# sourceMappingURL=FragmentedTextBoxParser.js.map


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _SegmentsUtils=__webpack_require__(40);function ListSegmentsGetter(config,isDynamic){config = config || {};var timelineConverter=config.timelineConverter;var instance=undefined;function getSegmentsFromList(representation,requestedTime,index,availabilityUpperLimit){var list=representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentList;var len=list.SegmentURL_asArray.length;var segments=[];var periodSegIdx=undefined,seg=undefined,s=undefined,range=undefined,startIdx=undefined,endIdx=undefined,start=undefined;start = representation.startNumber;range = (0,_SegmentsUtils.decideSegmentListRangeForTemplate)(timelineConverter,isDynamic,representation,requestedTime,index,availabilityUpperLimit);startIdx = Math.max(range.start,0);endIdx = Math.min(range.end,list.SegmentURL_asArray.length - 1);for(periodSegIdx = startIdx;periodSegIdx <= endIdx;periodSegIdx++) {s = list.SegmentURL_asArray[periodSegIdx];seg = (0,_SegmentsUtils.getIndexBasedSegment)(timelineConverter,isDynamic,representation,periodSegIdx);seg.replacementTime = (start + periodSegIdx - 1) * representation.segmentDuration;seg.media = s.media?s.media:'';seg.mediaRange = s.mediaRange;seg.index = s.index;seg.indexRange = s.indexRange;segments.push(seg);seg = null;}representation.availableSegmentsNumber = len;return segments;}instance = {getSegments:getSegmentsFromList};return instance;}ListSegmentsGetter.__dashjs_factory_name = 'ListSegmentsGetter';var factory=_coreFactoryMaker2['default'].getClassFactory(ListSegmentsGetter);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=ListSegmentsGetter.js.map


/***/ },
/* 321 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * Static methods for rounding decimals
	 *
	 * Modified version of the CC0-licenced example at:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
	 *
	 * @export
	 * @class Round10
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var Round10=(function(){function Round10(){_classCallCheck(this,Round10);} /**
	 * Decimal adjustment of a number.
	 *
	 * @param {String}  type  The type of adjustment.
	 * @param {Number}  value The number.
	 * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
	 * @returns {Number} The adjusted value.
	 */_createClass(Round10,null,[{key:'round10', /**
	    * Decimal round.
	    *
	    * @param {Number}  value The number.
	    * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
	    * @returns {Number} The adjusted value.
	    */value:function round10(value,exp){return _decimalAdjust('round',value,exp);}}]);return Round10;})();exports['default'] = Round10;function _decimalAdjust(type,value,exp){ // If the exp is undefined or zero...
	if(typeof exp === 'undefined' || +exp === 0){return Math[type](value);}value = +value;exp = +exp; // If the value is not a number or the exp is not an integer...
	if(value === null || isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)){return NaN;} // Shift
	value = value.toString().split('e');value = Math[type](+(value[0] + 'e' + (value[1]?+value[1] - exp:-exp))); // Shift back
	value = value.toString().split('e');return +(value[0] + 'e' + (value[1]?+value[1] + exp:exp));}module.exports = exports['default'];
	//# sourceMappingURL=Round10.js.map


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsDashConstants=__webpack_require__(25);var _constantsDashConstants2=_interopRequireDefault(_constantsDashConstants);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _TimelineSegmentsGetter=__webpack_require__(325);var _TimelineSegmentsGetter2=_interopRequireDefault(_TimelineSegmentsGetter);var _TemplateSegmentsGetter=__webpack_require__(323);var _TemplateSegmentsGetter2=_interopRequireDefault(_TemplateSegmentsGetter);var _ListSegmentsGetter=__webpack_require__(320);var _ListSegmentsGetter2=_interopRequireDefault(_ListSegmentsGetter);function SegmentsGetter(config,isDynamic){var context=this.context;var instance=undefined,timelineSegmentsGetter=undefined,templateSegmentsGetter=undefined,listSegmentsGetter=undefined;function setup(){timelineSegmentsGetter = (0,_TimelineSegmentsGetter2['default'])(context).create(config,isDynamic);templateSegmentsGetter = (0,_TemplateSegmentsGetter2['default'])(context).create(config,isDynamic);listSegmentsGetter = (0,_ListSegmentsGetter2['default'])(context).create(config,isDynamic);} // availabilityUpperLimit parameter is not used directly by any dash.js function, but it is needed as a helper
	// for other developments that extend dash.js, and provide their own transport layers (ex: P2P transport)
	function getSegments(representation,requestedTime,index,onSegmentListUpdatedCallback,availabilityUpperLimit){var segments=undefined;var type=representation.segmentInfoType; // Already figure out the segments.
	if(type === _constantsDashConstants2['default'].SEGMENT_BASE || type === _constantsDashConstants2['default'].BASE_URL || !isSegmentListUpdateRequired(representation,index)){segments = representation.segments;}else {if(type === _constantsDashConstants2['default'].SEGMENT_TIMELINE){segments = timelineSegmentsGetter.getSegments(representation,requestedTime,index,availabilityUpperLimit);}else if(type === _constantsDashConstants2['default'].SEGMENT_TEMPLATE){segments = templateSegmentsGetter.getSegments(representation,requestedTime,index,availabilityUpperLimit);}else if(type === _constantsDashConstants2['default'].SEGMENT_LIST){segments = listSegmentsGetter.getSegments(representation,requestedTime,index,availabilityUpperLimit);}if(onSegmentListUpdatedCallback){onSegmentListUpdatedCallback(representation,segments);}}}function isSegmentListUpdateRequired(representation,index){var segments=representation.segments;var updateRequired=false;var upperIdx=undefined,lowerIdx=undefined;if(!segments || segments.length === 0){updateRequired = true;}else {lowerIdx = segments[0].availabilityIdx;upperIdx = segments[segments.length - 1].availabilityIdx;updateRequired = index < lowerIdx || index > upperIdx;}return updateRequired;}instance = {getSegments:getSegments};setup();return instance;}SegmentsGetter.__dashjs_factory_name = 'SegmentsGetter';var factory=_coreFactoryMaker2['default'].getClassFactory(SegmentsGetter);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=SegmentsGetter.js.map


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _SegmentsUtils=__webpack_require__(40);function TemplateSegmentsGetter(config,isDynamic){var timelineConverter=config.timelineConverter;var instance=undefined;function getSegmentsFromTemplate(representation,requestedTime,index,availabilityUpperLimit){var template=representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentTemplate;var duration=representation.segmentDuration;var availabilityWindow=representation.segmentAvailabilityRange;var segments=[];var url=null;var seg=null;var segmentRange=undefined,periodSegIdx=undefined,startIdx=undefined,endIdx=undefined,start=undefined;start = representation.startNumber;if(isNaN(duration) && !isDynamic){segmentRange = {start:start,end:start};}else {segmentRange = (0,_SegmentsUtils.decideSegmentListRangeForTemplate)(timelineConverter,isDynamic,representation,requestedTime,index,availabilityUpperLimit);}startIdx = segmentRange.start;endIdx = segmentRange.end;for(periodSegIdx = startIdx;periodSegIdx <= endIdx;periodSegIdx++) {seg = (0,_SegmentsUtils.getIndexBasedSegment)(timelineConverter,isDynamic,representation,periodSegIdx);seg.replacementTime = (start + periodSegIdx - 1) * representation.segmentDuration;url = template.media;url = (0,_SegmentsUtils.replaceTokenForTemplate)(url,'Number',seg.replacementNumber);url = (0,_SegmentsUtils.replaceTokenForTemplate)(url,'Time',seg.replacementTime);seg.media = url;segments.push(seg);seg = null;}if(isNaN(duration)){representation.availableSegmentsNumber = 1;}else {representation.availableSegmentsNumber = Math.ceil((availabilityWindow.end - availabilityWindow.start) / duration);}return segments;}instance = {getSegments:getSegmentsFromTemplate};return instance;}TemplateSegmentsGetter.__dashjs_factory_name = 'TemplateSegmentsGetter';var factory=_coreFactoryMaker2['default'].getClassFactory(TemplateSegmentsGetter);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=TemplateSegmentsGetter.js.map


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function TimelineConverter(){var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,clientServerTimeShift=undefined,isClientServerTimeSyncCompleted=undefined,expectedLiveEdge=undefined;function initialize(){resetInitialSettings();eventBus.on(_coreEventsEvents2['default'].TIME_SYNCHRONIZATION_COMPLETED,onTimeSyncComplete,this);}function isTimeSyncCompleted(){return isClientServerTimeSyncCompleted;}function setTimeSyncCompleted(value){isClientServerTimeSyncCompleted = value;}function getClientTimeOffset(){return clientServerTimeShift;}function setClientTimeOffset(value){clientServerTimeShift = value;}function getExpectedLiveEdge(){return expectedLiveEdge;}function setExpectedLiveEdge(value){expectedLiveEdge = value;}function calcAvailabilityTimeFromPresentationTime(presentationTime,mpd,isDynamic,calculateEnd){var availabilityTime=NaN;if(calculateEnd){ //@timeShiftBufferDepth specifies the duration of the time shifting buffer that is guaranteed
	// to be available for a Media Presentation with type 'dynamic'.
	// When not present, the value is infinite.
	if(isDynamic && mpd.timeShiftBufferDepth != Number.POSITIVE_INFINITY){availabilityTime = new Date(mpd.availabilityStartTime.getTime() + (presentationTime + mpd.timeShiftBufferDepth) * 1000);}else {availabilityTime = mpd.availabilityEndTime;}}else {if(isDynamic){availabilityTime = new Date(mpd.availabilityStartTime.getTime() + (presentationTime - clientServerTimeShift) * 1000);}else { // in static mpd, all segments are available at the same time
	availabilityTime = mpd.availabilityStartTime;}}return availabilityTime;}function calcAvailabilityStartTimeFromPresentationTime(presentationTime,mpd,isDynamic){return calcAvailabilityTimeFromPresentationTime.call(this,presentationTime,mpd,isDynamic);}function calcAvailabilityEndTimeFromPresentationTime(presentationTime,mpd,isDynamic){return calcAvailabilityTimeFromPresentationTime.call(this,presentationTime,mpd,isDynamic,true);}function calcPresentationTimeFromWallTime(wallTime,period){return (wallTime.getTime() - period.mpd.availabilityStartTime.getTime() + clientServerTimeShift * 1000) / 1000;}function calcPresentationTimeFromMediaTime(mediaTime,representation){var periodStart=representation.adaptation.period.start;var presentationOffset=representation.presentationTimeOffset;return mediaTime + (periodStart - presentationOffset);}function calcMediaTimeFromPresentationTime(presentationTime,representation){var periodStart=representation.adaptation.period.start;var presentationOffset=representation.presentationTimeOffset;return presentationTime - periodStart + presentationOffset;}function calcWallTimeForSegment(segment,isDynamic){var suggestedPresentationDelay=undefined,displayStartTime=undefined,wallTime=undefined;if(isDynamic){suggestedPresentationDelay = segment.representation.adaptation.period.mpd.suggestedPresentationDelay;displayStartTime = segment.presentationStartTime + suggestedPresentationDelay;wallTime = new Date(segment.availabilityStartTime.getTime() + displayStartTime * 1000);}return wallTime;}function calcSegmentAvailabilityRange(voRepresentation,isDynamic){ // Static Range Finder
	var voPeriod=voRepresentation.adaptation.period;var range={start:voPeriod.start,end:voPeriod.start + voPeriod.duration};if(!isDynamic)return range;if(!isClientServerTimeSyncCompleted && voRepresentation.segmentAvailabilityRange){return voRepresentation.segmentAvailabilityRange;} // Dynamic Range Finder
	var d=voRepresentation.segmentDuration || (voRepresentation.segments && voRepresentation.segments.length?voRepresentation.segments[voRepresentation.segments.length - 1].duration:0);var now=calcPresentationTimeFromWallTime(new Date(),voPeriod);var periodEnd=voPeriod.start + voPeriod.duration;range.start = Math.max(now - voPeriod.mpd.timeShiftBufferDepth,voPeriod.start);var endOffset=voRepresentation.availabilityTimeOffset !== undefined && voRepresentation.availabilityTimeOffset < d?d - voRepresentation.availabilityTimeOffset:d;range.end = now >= periodEnd && now - endOffset < periodEnd?periodEnd:now - endOffset;return range;}function calcPeriodRelativeTimeFromMpdRelativeTime(representation,mpdRelativeTime){var periodStartTime=representation.adaptation.period.start;return mpdRelativeTime - periodStartTime;} /*
	    * We need to figure out if we want to timesync for segmentTimeine where useCalculatedLiveEdge = true
	    * seems we figure out client offset based on logic in liveEdgeFinder getLiveEdge timelineConverter.setClientTimeOffset(liveEdge - representationInfo.DVRWindow.end);
	    * FYI StreamController's onManifestUpdated entry point to timeSync
	    * */function onTimeSyncComplete(e){if(isClientServerTimeSyncCompleted)return;if(e.offset !== undefined){setClientTimeOffset(e.offset / 1000);isClientServerTimeSyncCompleted = true;}}function calcMSETimeOffset(representation){ // The MSEOffset is offset from AST for media. It is Period@start - presentationTimeOffset
	var presentationOffset=representation.presentationTimeOffset;var periodStart=representation.adaptation.period.start;return periodStart - presentationOffset;}function resetInitialSettings(){clientServerTimeShift = 0;isClientServerTimeSyncCompleted = false;expectedLiveEdge = NaN;}function reset(){eventBus.off(_coreEventsEvents2['default'].TIME_SYNCHRONIZATION_COMPLETED,onTimeSyncComplete,this);resetInitialSettings();}instance = {initialize:initialize,isTimeSyncCompleted:isTimeSyncCompleted,setTimeSyncCompleted:setTimeSyncCompleted,getClientTimeOffset:getClientTimeOffset,setClientTimeOffset:setClientTimeOffset,getExpectedLiveEdge:getExpectedLiveEdge,setExpectedLiveEdge:setExpectedLiveEdge,calcAvailabilityStartTimeFromPresentationTime:calcAvailabilityStartTimeFromPresentationTime,calcAvailabilityEndTimeFromPresentationTime:calcAvailabilityEndTimeFromPresentationTime,calcPresentationTimeFromWallTime:calcPresentationTimeFromWallTime,calcPresentationTimeFromMediaTime:calcPresentationTimeFromMediaTime,calcPeriodRelativeTimeFromMpdRelativeTime:calcPeriodRelativeTimeFromMpdRelativeTime,calcMediaTimeFromPresentationTime:calcMediaTimeFromPresentationTime,calcSegmentAvailabilityRange:calcSegmentAvailabilityRange,calcWallTimeForSegment:calcWallTimeForSegment,calcMSETimeOffset:calcMSETimeOffset,reset:reset};return instance;}TimelineConverter.__dashjs_factory_name = 'TimelineConverter';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(TimelineConverter);module.exports = exports['default'];
	//# sourceMappingURL=TimelineConverter.js.map


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _SegmentsUtils=__webpack_require__(40);function TimelineSegmentsGetter(config,isDynamic){config = config || {};var timelineConverter=config.timelineConverter;var instance=undefined;function checkConfig(){if(!timelineConverter || !timelineConverter.hasOwnProperty('calcMediaTimeFromPresentationTime') || !timelineConverter.hasOwnProperty('calcSegmentAvailabilityRange') || !timelineConverter.hasOwnProperty('calcMediaTimeFromPresentationTime')){throw new Error('Missing config parameter(s)');}}function getSegmentsFromTimeline(representation,requestedTime,index,availabilityUpperLimit){checkConfig();if(!representation){throw new Error('no representation');}if(requestedTime === undefined){requestedTime = null;}var base=representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentTemplate || representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentList;var timeline=base.SegmentTimeline;var list=base.SegmentURL_asArray;var isAvailableSegmentNumberCalculated=representation.availableSegmentsNumber > 0;var maxSegmentsAhead=undefined;if(availabilityUpperLimit){maxSegmentsAhead = availabilityUpperLimit;}else {maxSegmentsAhead = index > -1 || requestedTime !== null?10:Infinity;}var time=0;var scaledTime=0;var availabilityIdx=-1;var segments=[];var requiredMediaTime=null;var fragments=undefined,frag=undefined,i=undefined,len=undefined,j=undefined,repeat=undefined,repeatEndTime=undefined,nextFrag=undefined,hasEnoughSegments=undefined,startIdx=undefined,fTimescale=undefined;var createSegment=function createSegment(s,i){var media=base.media;var mediaRange=s.mediaRange;if(list){media = list[i].media || '';mediaRange = list[i].mediaRange;}return (0,_SegmentsUtils.getTimeBasedSegment)(timelineConverter,isDynamic,representation,time,s.d,fTimescale,media,mediaRange,availabilityIdx,s.tManifest);};fTimescale = representation.timescale;fragments = timeline.S_asArray;startIdx = index;if(requestedTime !== null){requiredMediaTime = timelineConverter.calcMediaTimeFromPresentationTime(requestedTime,representation);}for(i = 0,len = fragments.length;i < len;i++) {frag = fragments[i];repeat = 0;if(frag.hasOwnProperty('r')){repeat = frag.r;} // For a repeated S element, t belongs only to the first segment
	if(frag.hasOwnProperty('t')){time = frag.t;scaledTime = time / fTimescale;} // This is a special case: "A negative value of the @r attribute of the S element indicates that the duration indicated in @d attribute repeats until the start of the next S element, the end of the Period or until the
	// next MPD update."
	if(repeat < 0){nextFrag = fragments[i + 1];if(nextFrag && nextFrag.hasOwnProperty('t')){repeatEndTime = nextFrag.t / fTimescale;}else {var availabilityEnd=representation.segmentAvailabilityRange?representation.segmentAvailabilityRange.end:timelineConverter.calcSegmentAvailabilityRange(representation,isDynamic).end;repeatEndTime = timelineConverter.calcMediaTimeFromPresentationTime(availabilityEnd,representation);representation.segmentDuration = frag.d / fTimescale;}repeat = Math.ceil((repeatEndTime - scaledTime) / (frag.d / fTimescale)) - 1;} // if we have enough segments in the list, but we have not calculated the total number of the segments yet we
	// should continue the loop and calc the number. Once it is calculated, we can break the loop.
	if(hasEnoughSegments){if(isAvailableSegmentNumberCalculated)break;availabilityIdx += repeat + 1;continue;}for(j = 0;j <= repeat;j++) {availabilityIdx++;if(segments.length > maxSegmentsAhead){hasEnoughSegments = true;if(isAvailableSegmentNumberCalculated)break;continue;}if(requiredMediaTime !== null){ // In some cases when requiredMediaTime = actual end time of the last segment
	// it is possible that this time a bit exceeds the declared end time of the last segment.
	// in this case we still need to include the last segment in the segment list. to do this we
	// use a correction factor = 1.5. This number is used because the largest possible deviation is
	// is 50% of segment duration.
	if(scaledTime >= requiredMediaTime - frag.d / fTimescale * 1.5){segments.push(createSegment(frag,availabilityIdx));}}else if(availabilityIdx >= startIdx){segments.push(createSegment(frag,availabilityIdx));}time += frag.d;scaledTime = time / fTimescale;}}if(!isAvailableSegmentNumberCalculated){representation.availableSegmentsNumber = availabilityIdx + 1;}return segments;}instance = {getSegments:getSegmentsFromTimeline};return instance;}TimelineSegmentsGetter.__dashjs_factory_name = 'TimelineSegmentsGetter';var factory=_coreFactoryMaker2['default'].getClassFactory(TimelineSegmentsGetter);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=TimelineSegmentsGetter.js.map


/***/ },
/* 326 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var AdaptationSet=function AdaptationSet(){_classCallCheck(this,AdaptationSet);this.period = null;this.index = -1;this.type = null;};exports["default"] = AdaptationSet;module.exports = exports["default"];
	//# sourceMappingURL=AdaptationSet.js.map


/***/ },
/* 327 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var EventStream=function EventStream(){_classCallCheck(this,EventStream);this.adaptionSet = null;this.representation = null;this.period = null;this.timescale = 1;this.value = '';this.schemeIdUri = '';};exports['default'] = EventStream;module.exports = exports['default'];
	//# sourceMappingURL=EventStream.js.map


/***/ },
/* 328 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Mpd=function Mpd(){_classCallCheck(this,Mpd);this.manifest = null;this.suggestedPresentationDelay = 0;this.availabilityStartTime = null;this.availabilityEndTime = Number.POSITIVE_INFINITY;this.timeShiftBufferDepth = Number.POSITIVE_INFINITY;this.maxSegmentDuration = Number.POSITIVE_INFINITY;this.minimumUpdatePeriod = NaN;this.mediaPresentationDuration = NaN;};exports["default"] = Mpd;module.exports = exports["default"];
	//# sourceMappingURL=Mpd.js.map


/***/ },
/* 329 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var Period=function Period(){_classCallCheck(this,Period);this.id = null;this.index = -1;this.duration = NaN;this.start = NaN;this.mpd = null;};Period.DEFAULT_ID = 'defaultId';exports['default'] = Period;module.exports = exports['default'];
	//# sourceMappingURL=Period.js.map


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _netHTTPLoader=__webpack_require__(55);var _netHTTPLoader2=_interopRequireDefault(_netHTTPLoader);var _voHeadRequest=__webpack_require__(418);var _voHeadRequest2=_interopRequireDefault(_voHeadRequest);var _voDashJSError=__webpack_require__(31);var _voDashJSError2=_interopRequireDefault(_voDashJSError);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var FRAGMENT_LOADER_ERROR_LOADING_FAILURE=1;var FRAGMENT_LOADER_ERROR_NULL_REQUEST=2;var FRAGMENT_LOADER_MESSAGE_NULL_REQUEST='request is null';function FragmentLoader(config){config = config || {};var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,httpLoader=undefined;function setup(){httpLoader = (0,_netHTTPLoader2['default'])(context).create({errHandler:config.errHandler,metricsModel:config.metricsModel,mediaPlayerModel:config.mediaPlayerModel,requestModifier:config.requestModifier,useFetch:config.mediaPlayerModel.getLowLatencyEnabled()});}function checkForExistence(request){var report=function report(success){eventBus.trigger(_coreEventsEvents2['default'].CHECK_FOR_EXISTENCE_COMPLETED,{request:request,exists:success});};if(request){var headRequest=new _voHeadRequest2['default'](request.url);httpLoader.load({request:headRequest,success:function success(){report(true);},error:function error(){report(false);}});}else {report(false);}}function load(request){var report=function report(data,error){eventBus.trigger(_coreEventsEvents2['default'].LOADING_COMPLETED,{request:request,response:data || null,error:error || null,sender:instance});};if(request){httpLoader.load({request:request,progress:function progress(data){eventBus.trigger(_coreEventsEvents2['default'].LOADING_PROGRESS,{request:request});if(data){eventBus.trigger(_coreEventsEvents2['default'].LOADING_DATA_PROGRESS,{request:request,response:data || null,error:null,sender:instance});}},success:function success(data){report(data);},error:function error(request,statusText,errorText){report(undefined,new _voDashJSError2['default'](FRAGMENT_LOADER_ERROR_LOADING_FAILURE,errorText,statusText));},abort:function abort(request){if(request){eventBus.trigger(_coreEventsEvents2['default'].LOADING_ABANDONED,{request:request,mediaType:request.mediaType,sender:instance});}}});}else {report(undefined,new _voDashJSError2['default'](FRAGMENT_LOADER_ERROR_NULL_REQUEST,FRAGMENT_LOADER_MESSAGE_NULL_REQUEST));}}function abort(){if(httpLoader){httpLoader.abort();}}function reset(){if(httpLoader){httpLoader.abort();httpLoader = null;}}instance = {checkForExistence:checkForExistence,load:load,abort:abort,reset:reset};setup();return instance;}FragmentLoader.__dashjs_factory_name = 'FragmentLoader';var factory=_coreFactoryMaker2['default'].getClassFactory(FragmentLoader);factory.FRAGMENT_LOADER_ERROR_LOADING_FAILURE = FRAGMENT_LOADER_ERROR_LOADING_FAILURE;factory.FRAGMENT_LOADER_ERROR_NULL_REQUEST = FRAGMENT_LOADER_ERROR_NULL_REQUEST;_coreFactoryMaker2['default'].updateClassFactory(FragmentLoader.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=FragmentLoader.js.map


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _controllersXlinkController=__webpack_require__(347);var _controllersXlinkController2=_interopRequireDefault(_controllersXlinkController);var _netHTTPLoader=__webpack_require__(55);var _netHTTPLoader2=_interopRequireDefault(_netHTTPLoader);var _utilsURLUtils=__webpack_require__(30);var _utilsURLUtils2=_interopRequireDefault(_utilsURLUtils);var _voTextRequest=__webpack_require__(155);var _voTextRequest2=_interopRequireDefault(_voTextRequest);var _voDashJSError=__webpack_require__(31);var _voDashJSError2=_interopRequireDefault(_voDashJSError);var _voMetricsHTTPRequest=__webpack_require__(16);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _dashParserDashParser=__webpack_require__(311);var _dashParserDashParser2=_interopRequireDefault(_dashParserDashParser);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var MANIFEST_LOADER_ERROR_PARSING_FAILURE=1;var MANIFEST_LOADER_ERROR_LOADING_FAILURE=2;var MANIFEST_LOADER_MESSAGE_PARSING_FAILURE='parsing failed';function ManifestLoader(config){config = config || {};var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var urlUtils=(0,_utilsURLUtils2['default'])(context).getInstance();var debug=(0,_coreDebug2['default'])(context).getInstance();var log=debug.log;var instance=undefined,httpLoader=undefined,xlinkController=undefined,parser=undefined;var mssHandler=config.mssHandler;var errHandler=config.errHandler;function setup(){eventBus.on(_coreEventsEvents2['default'].XLINK_READY,onXlinkReady,instance);httpLoader = (0,_netHTTPLoader2['default'])(context).create({errHandler:errHandler,metricsModel:config.metricsModel,mediaPlayerModel:config.mediaPlayerModel,requestModifier:config.requestModifier});xlinkController = (0,_controllersXlinkController2['default'])(context).create({errHandler:errHandler,metricsModel:config.metricsModel,mediaPlayerModel:config.mediaPlayerModel,requestModifier:config.requestModifier});parser = null;}function onXlinkReady(event){eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED,{manifest:event.manifest});}function createParser(data){var parser=null; // Analyze manifest content to detect protocol and select appropriate parser
	if(data.indexOf('SmoothStreamingMedia') > -1){ //do some business to transform it into a Dash Manifest
	if(mssHandler){parser = mssHandler.createMssParser();mssHandler.registerEvents();}else {errHandler.manifestError('manifest type unsupported','createParser');}return parser;}else if(data.indexOf('MPD') > -1){return (0,_dashParserDashParser2['default'])(context).create({errorHandler:errHandler});}else {return parser;}}function load(url){var request=new _voTextRequest2['default'](url,_voMetricsHTTPRequest.HTTPRequest.MPD_TYPE);httpLoader.load({request:request,success:function success(data,textStatus,responseURL){var actualUrl=undefined,baseUri=undefined; // Handle redirects for the MPD - as per RFC3986 Section 5.1.3
	// also handily resolves relative MPD URLs to absolute
	if(responseURL && responseURL !== url){baseUri = urlUtils.parseBaseUrl(responseURL);actualUrl = responseURL;}else { // usually this case will be caught and resolved by
	// responseURL above but it is not available for IE11 and Edge/12 and Edge/13
	// baseUri must be absolute for BaseURL resolution later
	if(urlUtils.isRelative(url)){url = urlUtils.resolve(url,window.location.href);}baseUri = urlUtils.parseBaseUrl(url);} // Create parser according to manifest type
	if(parser === null){parser = createParser(data);}if(parser === null){eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED,{manifest:null,error:new _voDashJSError2['default'](MANIFEST_LOADER_ERROR_PARSING_FAILURE,'Failed detecting manifest type: ' + url)});return;} // init xlinkcontroller with matchers and iron object from created parser
	xlinkController.setMatchers(parser.getMatchers());xlinkController.setIron(parser.getIron());var manifest=parser.parse(data);if(manifest){manifest.url = actualUrl || url; // URL from which the MPD was originally retrieved (MPD updates will not change this value)
	if(!manifest.originalUrl){manifest.originalUrl = manifest.url;} // In the following, we only use the first Location entry even if many are available
	// Compare with ManifestUpdater/DashManifestModel
	if(manifest.hasOwnProperty(_constantsConstants2['default'].LOCATION)){baseUri = urlUtils.parseBaseUrl(manifest.Location_asArray[0]);log('BaseURI set by Location to: ' + baseUri);}manifest.baseUri = baseUri;manifest.loadedTime = new Date();xlinkController.resolveManifestOnLoad(manifest);}else {eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED,{manifest:null,error:new _voDashJSError2['default'](MANIFEST_LOADER_ERROR_PARSING_FAILURE,MANIFEST_LOADER_MESSAGE_PARSING_FAILURE)});}},error:function error(request,statusText,errorText){eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED,{manifest:null,error:new _voDashJSError2['default'](MANIFEST_LOADER_ERROR_LOADING_FAILURE,'Failed loading manifest: ' + url + ', ' + errorText)});}});}function reset(){eventBus.off(_coreEventsEvents2['default'].XLINK_READY,onXlinkReady,instance);if(xlinkController){xlinkController.reset();xlinkController = null;}if(httpLoader){httpLoader.abort();httpLoader = null;}if(mssHandler){mssHandler.reset();}}instance = {load:load,reset:reset};setup();return instance;}ManifestLoader.__dashjs_factory_name = 'ManifestLoader';var factory=_coreFactoryMaker2['default'].getClassFactory(ManifestLoader);factory.MANIFEST_LOADER_ERROR_PARSING_FAILURE = MANIFEST_LOADER_ERROR_PARSING_FAILURE;factory.MANIFEST_LOADER_ERROR_LOADING_FAILURE = MANIFEST_LOADER_ERROR_LOADING_FAILURE;_coreFactoryMaker2['default'].updateClassFactory(ManifestLoader.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=ManifestLoader.js.map


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);function ManifestUpdater(){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,refreshDelay=undefined,refreshTimer=undefined,isPaused=undefined,isUpdating=undefined,manifestLoader=undefined,manifestModel=undefined,dashManifestModel=undefined,mediaPlayerModel=undefined;function setConfig(config){if(!config)return;if(config.manifestModel){manifestModel = config.manifestModel;}if(config.dashManifestModel){dashManifestModel = config.dashManifestModel;}if(config.mediaPlayerModel){mediaPlayerModel = config.mediaPlayerModel;}if(config.manifestLoader){manifestLoader = config.manifestLoader;}}function initialize(){resetInitialSettings();eventBus.on(_coreEventsEvents2['default'].STREAMS_COMPOSED,onStreamsComposed,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_STARTED,onPlaybackStarted,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_PAUSED,onPlaybackPaused,this);eventBus.on(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED,onManifestLoaded,this);}function setManifest(manifest){update(manifest);}function resetInitialSettings(){refreshDelay = NaN;isUpdating = false;isPaused = true;stopManifestRefreshTimer();}function reset(){eventBus.off(_coreEventsEvents2['default'].PLAYBACK_STARTED,onPlaybackStarted,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_PAUSED,onPlaybackPaused,this);eventBus.off(_coreEventsEvents2['default'].STREAMS_COMPOSED,onStreamsComposed,this);eventBus.off(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED,onManifestLoaded,this);resetInitialSettings();}function stopManifestRefreshTimer(){if(refreshTimer !== null){clearInterval(refreshTimer);refreshTimer = null;}}function startManifestRefreshTimer(delay){stopManifestRefreshTimer();if(isNaN(delay) && !isNaN(refreshDelay)){delay = refreshDelay * 1000;}if(!isNaN(delay)){log('Refresh manifest in ' + delay + ' milliseconds.');refreshTimer = setTimeout(onRefreshTimer,delay);}}function refreshManifest(){isUpdating = true;var manifest=manifestModel.getValue();var url=manifest.url;var location=dashManifestModel.getLocation(manifest);if(location){url = location;}manifestLoader.load(url);}function update(manifest){manifestModel.setValue(manifest);var date=new Date();var latencyOfLastUpdate=(date.getTime() - manifest.loadedTime.getTime()) / 1000;refreshDelay = dashManifestModel.getManifestUpdatePeriod(manifest,latencyOfLastUpdate); // setTimeout uses a 32 bit number to store the delay. Any number greater than it
	// will cause event associated with setTimeout to trigger immediately
	if(refreshDelay * 1000 > 0x7FFFFFFF){refreshDelay = 0x7FFFFFFF / 1000;}eventBus.trigger(_coreEventsEvents2['default'].MANIFEST_UPDATED,{manifest:manifest});log('Manifest has been refreshed at ' + date + '[' + date.getTime() / 1000 + '] ');if(!isPaused){startManifestRefreshTimer();}}function onRefreshTimer(){if(isPaused && !mediaPlayerModel.getScheduleWhilePaused()){return;}if(isUpdating){startManifestRefreshTimer(mediaPlayerModel.getManifestUpdateRetryInterval());return;}refreshManifest();}function onManifestLoaded(e){if(!e.error){update(e.manifest);}}function onPlaybackStarted() /*e*/{isPaused = false;startManifestRefreshTimer();}function onPlaybackPaused() /*e*/{isPaused = true;stopManifestRefreshTimer();}function onStreamsComposed() /*e*/{ // When streams are ready we can consider manifest update completed. Resolve the update promise.
	isUpdating = false;}instance = {initialize:initialize,setManifest:setManifest,refreshManifest:refreshManifest,setConfig:setConfig,reset:reset};return instance;}ManifestUpdater.__dashjs_factory_name = 'ManifestUpdater';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ManifestUpdater);module.exports = exports['default'];
	//# sourceMappingURL=ManifestUpdater.js.map


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _MediaPlayer=__webpack_require__(143);var _MediaPlayer2=_interopRequireDefault(_MediaPlayer);function MediaPlayerFactory(){ /**
	     * mime-type identifier for any source content to be accepted as a dash manifest by the create() method.
	     * @type {string}
	     */var SUPPORTED_MIME_TYPE='application/dash+xml'; /**
	     *  A new MediaPlayer is instantiated for the supplied videoElement and optional source and context.  If no context is provided,
	     *  a default DashContext is used. If no source is provided, the videoElement is interrogated to extract the first source whose
	     *  type is application/dash+xml.
	     * The autoplay property of the videoElement is preserved. Any preload attribute is ignored. This method should be called after the page onLoad event is dispatched.
	     * @param {HTMLMediaElement} video
	     * @param {HTMLSourceElement} source
	     * @param {Object} context
	     * @returns {MediaPlayer|null}
	     */function create(video,source,context){if(!video || video.nodeName !== 'VIDEO')return null;if(video._dashjs_player)return video._dashjs_player;var player=undefined;var videoID=video.id || video.name || 'video element';source = source || [].slice.call(video.querySelectorAll('source')).filter(function(s){return s.type == SUPPORTED_MIME_TYPE;})[0];if(!source && video.src){source = document.createElement('source');source.src = video.src;}else if(!source && !video.src){return null;}context = context || {};player = (0,_MediaPlayer2['default'])(context).create();player.initialize(video,source.src,video.autoplay);player.getDebug().log('Converted ' + videoID + ' to dash.js player and added content: ' + source.src); // Store a reference to the player on the video element so it can be gotten at for debugging and so we know its
	// already been setup.
	video._dashjs_player = player;return player;} /**
	     * Searches the provided scope for all instances of the indicated selector. If no scope is provided, document is used. If no selector is
	     * specified, [data-dashjs-player] is used. The declarative setup also looks for source elements with the type attribute set to 'application/dash+xml'.
	     * It then looks for those video elements which have a source element defined with a type matching 'application/dash+xml'.
	     * A new MediaPlayer is instantiated for each matching video element and the appropriate source is assigned.
	     * The autoplay property of the video element is preserved. Any preload attribute is ignored. This method should be called after the page onLoad event is dispatched.
	     * Returns an array holding all the MediaPlayer instances that were added by this method.
	     * @param {string} selector - CSS selector
	     * @param {Object} scope
	     * @returns {Array} an array of MediaPlayer objects
	     */function createAll(selector,scope){var aPlayers=[];selector = selector || '[data-dashjs-player]';scope = scope || document;var videos=scope.querySelectorAll(selector);for(var i=0;i < videos.length;i++) {var player=create(videos[i],null);aPlayers.push(player);}var sources=scope.querySelectorAll('source[type="' + SUPPORTED_MIME_TYPE + '"]');for(var i=0;i < sources.length;i++) {var video=findVideo(sources[i]);var player=create(video,null);aPlayers.push(player);}return aPlayers;}function findVideo(_x){var _again=true;_function: while(_again) {var el=_x;_again = false;if(el.nodeName.toLowerCase() === 'video'){return el;}else {_x = el.parentNode;_again = true;continue _function;}}}return {create:create,createAll:createAll};}var instance=MediaPlayerFactory();var loadInterval=undefined;function loadHandler(){window.removeEventListener('load',loadHandler);instance.createAll();}function loadIntervalHandler(){if(window.dashjs){window.clearInterval(loadInterval);instance.createAll();}}var avoidAutoCreate=typeof window !== 'undefined' && window && window.dashjs && window.dashjs.skipAutoCreate;if(!avoidAutoCreate && typeof window !== 'undefined' && window && window.addEventListener){if(window.document.readyState === 'complete'){if(window.dashjs){instance.createAll();}else { // If loaded asynchronously, window.readyState may be 'complete' even if dashjs hasn't loaded yet
	loadInterval = window.setInterval(loadIntervalHandler,500);}}else {window.addEventListener('load',loadHandler);}}exports['default'] = instance;module.exports = exports['default'];
	//# sourceMappingURL=MediaPlayerFactory.js.map


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker); /**
	 * This is a sink that is used to temporarily hold onto media chunks before a video element is added.
	 * The discharge() function is used to get the chunks out of the PreBuffer for adding to a real SourceBuffer.
	 *
	 * @class PreBufferSink
	 * @implements FragmentSink
	 */function PreBufferSink(onAppendedCallback){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var chunks=[];var outstandingInit=undefined;var onAppended=onAppendedCallback;function reset(){chunks = [];outstandingInit = null;onAppended = null;}function append(chunk){if(chunk.segmentType !== 'InitializationSegment'){ //Init segments are stored in the initCache.
	chunks.push(chunk);chunks.sort(function(a,b){return a.start - b.start;});outstandingInit = null;}else { //We need to hold an init chunk for when a corresponding media segment is being downloaded when the discharge happens.
	outstandingInit = chunk;}log('PreBufferSink appended chunk s: ' + chunk.start + '; e: ' + chunk.end);if(onAppended){onAppended({chunk:chunk});}}function remove(start,end){chunks = chunks.filter(function(a){return !((isNaN(end) || a.start < end) && (isNaN(start) || a.end > start));}); //The opposite of the getChunks predicate.
	} //Nothing async, nothing to abort.
	function abort(){}function getAllBufferRanges(){var ranges=[];for(var i=0;i < chunks.length;i++) {var chunk=chunks[i];if(ranges.length === 0 || chunk.start > ranges[ranges.length - 1].end){ranges.push({start:chunk.start,end:chunk.end});}else {ranges[ranges.length - 1].end = chunk.end;}} //Implements TimeRanges interface. So acts just like sourceBuffer.buffered.
	var timeranges={start:function start(n){return ranges[n].start;},end:function end(n){return ranges[n].end;}};Object.defineProperty(timeranges,'length',{get:function get(){return ranges.length;}});return timeranges;} /**
	     * Return the all chunks in the buffer the lie between times start and end.
	     * Because a chunk cannot be split, this returns the full chunk if any part of its time lies in the requested range.
	     * Chunks are removed from the buffer when they are discharged.
	     * @function PreBufferSink#discharge
	     * @param {?Number} start The start time from which to discharge from the buffer. If NaN, it is regarded as unbounded.
	     * @param {?Number} end The end time from which to discharge from the buffer. If NaN, it is regarded as unbounded.
	     * @returns {Array} The set of chunks from the buffer within the time ranges.
	     */function discharge(start,end){var result=getChunksAt(start,end);if(outstandingInit){result.push(outstandingInit);outstandingInit = null;}remove(start,end);return result;}function getChunksAt(start,end){return chunks.filter(function(a){return (isNaN(end) || a.start < end) && (isNaN(start) || a.end > start);});}var instance={getAllBufferRanges:getAllBufferRanges,append:append,remove:remove,abort:abort,discharge:discharge,reset:reset};return instance;}PreBufferSink.__dashjs_factory_name = 'PreBufferSink';var factory=_coreFactoryMaker2['default'].getClassFactory(PreBufferSink);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=PreBufferSink.js.map


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _StreamProcessor=__webpack_require__(336);var _StreamProcessor2=_interopRequireDefault(_StreamProcessor);var _controllersEventController=__webpack_require__(340);var _controllersEventController2=_interopRequireDefault(_controllersEventController);var _controllersFragmentController=__webpack_require__(341);var _controllersFragmentController2=_interopRequireDefault(_controllersFragmentController);var _thumbnailThumbnailController=__webpack_require__(405);var _thumbnailThumbnailController2=_interopRequireDefault(_thumbnailThumbnailController);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function Stream(config){var DATA_UPDATE_FAILED_ERROR_CODE=1;config = config || {};var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var manifestModel=config.manifestModel;var dashManifestModel=config.dashManifestModel;var mediaPlayerModel=config.mediaPlayerModel;var manifestUpdater=config.manifestUpdater;var adapter=config.adapter;var capabilities=config.capabilities;var errHandler=config.errHandler;var timelineConverter=config.timelineConverter;var metricsModel=config.metricsModel;var abrController=config.abrController;var playbackController=config.playbackController;var mediaController=config.mediaController;var textController=config.textController;var instance=undefined,streamProcessors=undefined,isStreamActivated=undefined,isMediaInitialized=undefined,streamInfo=undefined,updateError=undefined,isUpdating=undefined,protectionController=undefined,fragmentController=undefined,thumbnailController=undefined,eventController=undefined,trackChangedEvent=undefined;function setup(){resetInitialSettings();fragmentController = (0,_controllersFragmentController2['default'])(context).create({mediaPlayerModel:mediaPlayerModel,metricsModel:metricsModel,errHandler:errHandler});eventBus.on(_coreEventsEvents2['default'].BUFFERING_COMPLETED,onBufferingCompleted,instance);eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,onDataUpdateCompleted,instance);}function initialize(StreamInfo,ProtectionController){streamInfo = StreamInfo;protectionController = ProtectionController;if(protectionController){eventBus.on(_coreEventsEvents2['default'].KEY_ERROR,onProtectionError,instance);eventBus.on(_coreEventsEvents2['default'].SERVER_CERTIFICATE_UPDATED,onProtectionError,instance);eventBus.on(_coreEventsEvents2['default'].LICENSE_REQUEST_COMPLETE,onProtectionError,instance);eventBus.on(_coreEventsEvents2['default'].KEY_SYSTEM_SELECTED,onProtectionError,instance);eventBus.on(_coreEventsEvents2['default'].KEY_SESSION_CREATED,onProtectionError,instance);eventBus.on(_coreEventsEvents2['default'].KEY_STATUSES_CHANGED,onProtectionError,instance);}} /**
	     * Activates Stream by re-initializing some of its components
	     * @param {MediaSource} mediaSource
	     * @memberof Stream#
	     */function activate(mediaSource){if(!isStreamActivated){eventBus.on(_coreEventsEvents2['default'].CURRENT_TRACK_CHANGED,onCurrentTrackChanged,instance);initializeMedia(mediaSource);isStreamActivated = true;}} /**
	     * Partially resets some of the Stream elements
	     * @memberof Stream#
	     */function deactivate(){var ln=streamProcessors?streamProcessors.length:0;for(var i=0;i < ln;i++) {var fragmentModel=streamProcessors[i].getFragmentModel();fragmentModel.removeExecutedRequestsBeforeTime(getStartTime() + getDuration());streamProcessors[i].reset();}streamProcessors = [];isStreamActivated = false;isMediaInitialized = false;eventBus.off(_coreEventsEvents2['default'].CURRENT_TRACK_CHANGED,onCurrentTrackChanged,instance);}function setMediaSource(mediaSource){for(var i=0;i < streamProcessors.length;) {if(isMediaSupported(streamProcessors[i].getMediaInfo())){streamProcessors[i].setMediaSource(mediaSource);i++;}else {streamProcessors[i].reset();streamProcessors.splice(i,1);}}for(var i=0;i < streamProcessors.length;i++) { //Adding of new tracks to a stream processor isn't guaranteed by the spec after the METADATA_LOADED state
	//so do this after the buffers are created above.
	streamProcessors[i].dischargePreBuffer();}if(streamProcessors.length === 0){var msg='No streams to play.';errHandler.manifestError(msg,'nostreams',manifestModel.getValue());log(msg);}}function resetInitialSettings(){deactivate();streamInfo = null;updateError = {};isUpdating = false;}function reset(){if(playbackController){playbackController.pause();}if(fragmentController){fragmentController.reset();fragmentController = null;}resetInitialSettings();log = null;eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,onDataUpdateCompleted,instance);eventBus.off(_coreEventsEvents2['default'].BUFFERING_COMPLETED,onBufferingCompleted,instance);eventBus.off(_coreEventsEvents2['default'].KEY_ERROR,onProtectionError,instance);eventBus.off(_coreEventsEvents2['default'].SERVER_CERTIFICATE_UPDATED,onProtectionError,instance);eventBus.off(_coreEventsEvents2['default'].LICENSE_REQUEST_COMPLETE,onProtectionError,instance);eventBus.off(_coreEventsEvents2['default'].KEY_SYSTEM_SELECTED,onProtectionError,instance);eventBus.off(_coreEventsEvents2['default'].KEY_SESSION_CREATED,onProtectionError,instance);eventBus.off(_coreEventsEvents2['default'].KEY_STATUSES_CHANGED,onProtectionError,instance);}function getDuration(){return streamInfo?streamInfo.duration:NaN;}function getStartTime(){return streamInfo?streamInfo.start:NaN;}function getId(){return streamInfo?streamInfo.id:NaN;}function getStreamInfo(){return streamInfo;}function getEventController(){return eventController;}function getFragmentController(){return fragmentController;}function getThumbnailController(){return thumbnailController;}function checkConfig(){if(!abrController || !abrController.hasOwnProperty('getBitrateList') || !adapter || !adapter.hasOwnProperty('getAllMediaInfoForType') || !adapter.hasOwnProperty('getEventsFor')){throw new Error('Missing config parameter(s)');}} /**
	     * @param {string} type
	     * @returns {Array}
	     * @memberof Stream#
	     */function getBitrateListFor(type){checkConfig();if(type === _constantsConstants2['default'].IMAGE){if(!thumbnailController){return [];}return thumbnailController.getBitrateList();}var mediaInfo=getMediaInfo(type);return abrController.getBitrateList(mediaInfo);}function startEventController(){if(eventController){eventController.start();}}function stopEventController(){if(eventController){eventController.stop();}}function onProtectionError(event){if(event.error){errHandler.mediaKeySessionError(event.error);log(event.error);reset();}}function getMimeTypeOrType(mediaInfo){return mediaInfo.type === _constantsConstants2['default'].TEXT?mediaInfo.mimeType:mediaInfo.type;}function isMediaSupported(mediaInfo){var type=mediaInfo.type;var codec=undefined,msg=undefined;if(type === _constantsConstants2['default'].MUXED && mediaInfo){msg = 'Multiplexed representations are intentionally not supported, as they are not compliant with the DASH-AVC/264 guidelines';log(msg);errHandler.manifestError(msg,'multiplexedrep',manifestModel.getValue());return false;}if(type === _constantsConstants2['default'].TEXT || type === _constantsConstants2['default'].FRAGMENTED_TEXT || type === _constantsConstants2['default'].EMBEDDED_TEXT || type === _constantsConstants2['default'].IMAGE){return true;}codec = mediaInfo.codec;log(type + ' codec: ' + codec);if(!!mediaInfo.contentProtection && !capabilities.supportsEncryptedMedia()){errHandler.capabilityError('encryptedmedia');}else if(!capabilities.supportsCodec(codec)){msg = type + 'Codec (' + codec + ') is not supported.';log(msg);return false;}return true;}function onCurrentTrackChanged(e){if(e.newMediaInfo.streamInfo.id !== streamInfo.id)return;var processor=getProcessorForMediaInfo(e.oldMediaInfo);if(!processor)return;var currentTime=playbackController.getTime();log('Stream -  Process track changed at current time ' + currentTime);var mediaInfo=e.newMediaInfo;var manifest=manifestModel.getValue();log('Stream -  Update stream controller');if(manifest.refreshManifestOnSwitchTrack){log('Stream -  Refreshing manifest for switch track');trackChangedEvent = e;manifestUpdater.refreshManifest();}else {processor.updateMediaInfo(mediaInfo);if(mediaInfo.type !== _constantsConstants2['default'].FRAGMENTED_TEXT){abrController.updateTopQualityIndex(mediaInfo);processor.switchTrackAsked();processor.getFragmentModel().abortRequests();}}}function createStreamProcessor(mediaInfo,allMediaForType,mediaSource,optionalSettings){var streamProcessor=(0,_StreamProcessor2['default'])(context).create({type:getMimeTypeOrType(mediaInfo),mimeType:mediaInfo.mimeType,timelineConverter:timelineConverter,adapter:adapter,manifestModel:manifestModel,dashManifestModel:dashManifestModel,mediaPlayerModel:mediaPlayerModel,metricsModel:metricsModel,dashMetrics:config.dashMetrics,baseURLController:config.baseURLController,stream:instance,abrController:abrController,domStorage:config.domStorage,playbackController:playbackController,mediaController:mediaController,streamController:config.streamController,textController:textController,errHandler:errHandler});streamProcessor.initialize(mediaSource);abrController.updateTopQualityIndex(mediaInfo);if(optionalSettings){streamProcessor.setBuffer(optionalSettings.buffer);streamProcessor.getIndexHandler().setCurrentTime(optionalSettings.currentTime);streamProcessors[optionalSettings.replaceIdx] = streamProcessor;}else {streamProcessors.push(streamProcessor);}if(optionalSettings && optionalSettings.ignoreMediaInfo){return;}if(mediaInfo.type === _constantsConstants2['default'].TEXT || mediaInfo.type === _constantsConstants2['default'].FRAGMENTED_TEXT){var idx=undefined;for(var i=0;i < allMediaForType.length;i++) {if(allMediaForType[i].index === mediaInfo.index){idx = i;}streamProcessor.updateMediaInfo(allMediaForType[i]); //creates text tracks for all adaptations in one stream processor
	}if(mediaInfo.type === _constantsConstants2['default'].FRAGMENTED_TEXT){streamProcessor.updateMediaInfo(allMediaForType[idx]); //sets the initial media info
	}}else {streamProcessor.updateMediaInfo(mediaInfo);}}function initializeMediaForType(type,mediaSource){var allMediaForType=adapter.getAllMediaInfoForType(streamInfo,type);var mediaInfo=null;var initialMediaInfo=undefined;if(!allMediaForType || allMediaForType.length === 0){log('No ' + type + ' data.');return;}for(var i=0,ln=allMediaForType.length;i < ln;i++) {mediaInfo = allMediaForType[i];if(type === _constantsConstants2['default'].EMBEDDED_TEXT){textController.addEmbeddedTrack(mediaInfo);}else {if(!isMediaSupported(mediaInfo))continue;mediaController.addTrack(mediaInfo);}}if(type === _constantsConstants2['default'].EMBEDDED_TEXT || mediaController.getTracksFor(type,streamInfo).length === 0){return;}if(type === _constantsConstants2['default'].IMAGE){thumbnailController = (0,_thumbnailThumbnailController2['default'])(context).create({dashManifestModel:dashManifestModel,adapter:adapter,baseURLController:config.baseURLController,stream:instance});return;}mediaController.checkInitialMediaSettingsForType(type,streamInfo);initialMediaInfo = mediaController.getCurrentTrackFor(type,streamInfo); // TODO : How to tell index handler live/duration?
	// TODO : Pass to controller and then pass to each method on handler?
	createStreamProcessor(initialMediaInfo,allMediaForType,mediaSource);}function initializeMedia(mediaSource){checkConfig();var events=undefined; //if initializeMedia is called from a switch period, eventController could have been already created.
	if(!eventController){eventController = (0,_controllersEventController2['default'])(context).create();eventController.setConfig({manifestModel:manifestModel,manifestUpdater:manifestUpdater,playbackController:playbackController});events = adapter.getEventsFor(streamInfo);eventController.addInlineEvents(events);}isUpdating = true;filterCodecs(_constantsConstants2['default'].VIDEO);filterCodecs(_constantsConstants2['default'].AUDIO);initializeMediaForType(_constantsConstants2['default'].VIDEO,mediaSource);initializeMediaForType(_constantsConstants2['default'].AUDIO,mediaSource);initializeMediaForType(_constantsConstants2['default'].TEXT,mediaSource);initializeMediaForType(_constantsConstants2['default'].FRAGMENTED_TEXT,mediaSource);initializeMediaForType(_constantsConstants2['default'].EMBEDDED_TEXT,mediaSource);initializeMediaForType(_constantsConstants2['default'].MUXED,mediaSource);initializeMediaForType(_constantsConstants2['default'].IMAGE,mediaSource);createBuffers(); //TODO. Consider initialization of TextSourceBuffer here if embeddedText, but no sideloadedText.
	isMediaInitialized = true;isUpdating = false;if(streamProcessors.length === 0){var msg='No streams to play.';errHandler.manifestError(msg,'nostreams',manifestModel.getValue());log(msg);}else { //log("Playback initialized!");
	checkIfInitializationCompleted();}}function filterCodecs(type){var realAdaptation=dashManifestModel.getAdaptationForType(manifestModel.getValue(),streamInfo.index,type,streamInfo);if(!realAdaptation || !Array.isArray(realAdaptation.Representation_asArray))return null; // Filter codecs that are not supported
	realAdaptation.Representation_asArray = realAdaptation.Representation_asArray.filter(function(_,i){ // keep at least codec from lowest representation
	if(i === 0)return true;var codec=dashManifestModel.getCodec(realAdaptation,i,true);if(!capabilities.supportsCodec(codec)){log('[Stream] codec not supported: ' + codec);return false;}return true;});}function checkIfInitializationCompleted(){var ln=streamProcessors.length;var hasError=!!updateError.audio || !!updateError.video;var error=hasError?new Error(DATA_UPDATE_FAILED_ERROR_CODE,'Data update failed',null):null;for(var i=0;i < ln;i++) {if(streamProcessors[i].isUpdating() || isUpdating){return;}}if(!isMediaInitialized){return;}if(protectionController){ // Need to check if streamProcessors exists because streamProcessors
	// could be cleared in case an error is detected while initializing DRM keysystem
	for(var i=0;i < ln && streamProcessors[i];i++) {if(streamProcessors[i].getType() === _constantsConstants2['default'].AUDIO || streamProcessors[i].getType() === _constantsConstants2['default'].VIDEO || streamProcessors[i].getType() === _constantsConstants2['default'].FRAGMENTED_TEXT){protectionController.initializeForMedia(streamProcessors[i].getMediaInfo());}}}eventBus.trigger(_coreEventsEvents2['default'].STREAM_INITIALIZED,{streamInfo:streamInfo,error:error});}function getMediaInfo(type){var ln=streamProcessors.length;var mediaCtrl=null;for(var i=0;i < ln;i++) {mediaCtrl = streamProcessors[i];if(mediaCtrl.getType() === type){return mediaCtrl.getMediaInfo();}}return null;}function createBuffers(){for(var i=0,ln=streamProcessors.length;i < ln;i++) {streamProcessors[i].createBuffer();}}function onBufferingCompleted(e){if(e.streamInfo !== streamInfo){return;}var processors=getProcessors();var ln=processors.length;if(ln === 0){log('[Stream] onBufferingCompleted - can\'t trigger STREAM_BUFFERING_COMPLETED because no streamProcessor is defined');return;} // if there is at least one buffer controller that has not completed buffering yet do nothing
	for(var i=0;i < ln;i++) { //if audio or video buffer is not buffering completed state, do not send STREAM_BUFFERING_COMPLETED
	if(!processors[i].isBufferingCompleted() && (processors[i].getType() === _constantsConstants2['default'].AUDIO || processors[i].getType() === _constantsConstants2['default'].VIDEO)){log('[Stream] onBufferingCompleted - can\'t trigger STREAM_BUFFERING_COMPLETED because streamProcessor ' + processors[i].getType() + ' is not buffering completed');return;}}log('[Stream] onBufferingCompleted - trigger STREAM_BUFFERING_COMPLETED');eventBus.trigger(_coreEventsEvents2['default'].STREAM_BUFFERING_COMPLETED,{streamInfo:streamInfo});}function onDataUpdateCompleted(e){var sp=e.sender.getStreamProcessor();if(sp.getStreamInfo() !== streamInfo){return;}updateError[sp.getType()] = e.error;checkIfInitializationCompleted();}function getProcessorForMediaInfo(mediaInfo){if(!mediaInfo){return false;}var processors=getProcessors();return processors.filter(function(processor){return processor.getType() === mediaInfo.type;})[0];}function getProcessors(){var ln=streamProcessors.length;var arr=[];var type=undefined,controller=undefined;for(var i=0;i < ln;i++) {controller = streamProcessors[i];type = controller.getType();if(type === _constantsConstants2['default'].AUDIO || type === _constantsConstants2['default'].VIDEO || type === _constantsConstants2['default'].FRAGMENTED_TEXT){arr.push(controller);}}return arr;}function updateData(updatedStreamInfo){log('Manifest updated... updating data system wide.');isStreamActivated = false;isUpdating = true;streamInfo = updatedStreamInfo;if(eventController){var events=adapter.getEventsFor(streamInfo);eventController.addInlineEvents(events);}filterCodecs(_constantsConstants2['default'].VIDEO);filterCodecs(_constantsConstants2['default'].AUDIO);for(var i=0,ln=streamProcessors.length;i < ln;i++) {var streamProcessor=streamProcessors[i];var mediaInfo=adapter.getMediaInfoForType(streamInfo,streamProcessor.getType());abrController.updateTopQualityIndex(mediaInfo);streamProcessor.updateMediaInfo(mediaInfo);}if(trackChangedEvent){var mediaInfo=trackChangedEvent.newMediaInfo;if(mediaInfo.type !== 'fragmentedText'){var processor=getProcessorForMediaInfo(trackChangedEvent.oldMediaInfo);if(!processor)return;processor.switchTrackAsked();trackChangedEvent = undefined;}}isUpdating = false;checkIfInitializationCompleted();}instance = {initialize:initialize,activate:activate,deactivate:deactivate,getDuration:getDuration,getStartTime:getStartTime,getId:getId,getStreamInfo:getStreamInfo,getFragmentController:getFragmentController,getThumbnailController:getThumbnailController,getEventController:getEventController,getBitrateListFor:getBitrateListFor,startEventController:startEventController,stopEventController:stopEventController,updateData:updateData,reset:reset,getProcessors:getProcessors,setMediaSource:setMediaSource};setup();return instance;}Stream.__dashjs_factory_name = 'Stream';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(Stream);module.exports = exports['default'];
	//# sourceMappingURL=Stream.js.map


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _utilsLiveEdgeFinder=__webpack_require__(412);var _utilsLiveEdgeFinder2=_interopRequireDefault(_utilsLiveEdgeFinder);var _controllersBufferController=__webpack_require__(36);var _controllersBufferController2=_interopRequireDefault(_controllersBufferController);var _textTextBufferController=__webpack_require__(403);var _textTextBufferController2=_interopRequireDefault(_textTextBufferController);var _controllersScheduleController=__webpack_require__(344);var _controllersScheduleController2=_interopRequireDefault(_controllersScheduleController);var _dashControllersRepresentationController=__webpack_require__(309);var _dashControllersRepresentationController2=_interopRequireDefault(_dashControllersRepresentationController);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _dashDashHandler=__webpack_require__(305);var _dashDashHandler2=_interopRequireDefault(_dashDashHandler);function StreamProcessor(config){config = config || {};var context=this.context;var indexHandler=undefined;var type=config.type;var errHandler=config.errHandler;var mimeType=config.mimeType;var timelineConverter=config.timelineConverter;var adapter=config.adapter;var manifestModel=config.manifestModel;var mediaPlayerModel=config.mediaPlayerModel;var stream=config.stream;var abrController=config.abrController;var playbackController=config.playbackController;var streamController=config.streamController;var mediaController=config.mediaController;var textController=config.textController;var domStorage=config.domStorage;var metricsModel=config.metricsModel;var dashMetrics=config.dashMetrics;var dashManifestModel=config.dashManifestModel;var instance=undefined,mediaInfo=undefined,mediaInfoArr=undefined,bufferController=undefined,scheduleController=undefined,liveEdgeFinder=undefined,representationController=undefined,fragmentModel=undefined,spExternalControllers=undefined;function setup(){if(playbackController && playbackController.getIsDynamic()){liveEdgeFinder = (0,_utilsLiveEdgeFinder2['default'])(context).create({timelineConverter:timelineConverter,streamProcessor:instance});}resetInitialSettings();}function initialize(mediaSource){indexHandler = (0,_dashDashHandler2['default'])(context).create({mimeType:mimeType,timelineConverter:timelineConverter,dashMetrics:dashMetrics,metricsModel:metricsModel,mediaPlayerModel:mediaPlayerModel,baseURLController:config.baseURLController,errHandler:errHandler}); // initialize controllers
	indexHandler.initialize(instance);abrController.registerStreamType(type,instance);fragmentModel = stream.getFragmentController().getModel(type);fragmentModel.setStreamProcessor(instance);bufferController = createBufferControllerForType(type);scheduleController = (0,_controllersScheduleController2['default'])(context).create({type:type,metricsModel:metricsModel,adapter:adapter,dashMetrics:dashMetrics,dashManifestModel:dashManifestModel,timelineConverter:timelineConverter,mediaPlayerModel:mediaPlayerModel,abrController:abrController,playbackController:playbackController,streamController:streamController,textController:textController,streamProcessor:instance,mediaController:mediaController});representationController = (0,_dashControllersRepresentationController2['default'])(context).create();representationController.setConfig({abrController:abrController,domStorage:domStorage,metricsModel:metricsModel,dashMetrics:dashMetrics,dashManifestModel:dashManifestModel,manifestModel:manifestModel,playbackController:playbackController,timelineConverter:timelineConverter,streamProcessor:instance});bufferController.initialize(mediaSource);scheduleController.initialize();representationController.initialize();}function registerExternalController(controller){spExternalControllers.push(controller);}function unregisterExternalController(controller){var index=spExternalControllers.indexOf(controller);if(index !== -1){spExternalControllers.splice(index,1);}}function getExternalControllers(){return spExternalControllers;}function unregisterAllExternalController(){spExternalControllers = [];}function resetInitialSettings(){mediaInfoArr = [];mediaInfo = null;unregisterAllExternalController();}function reset(errored){indexHandler.reset();if(bufferController){bufferController.reset(errored);bufferController = null;}if(scheduleController){scheduleController.reset();scheduleController = null;}if(representationController){representationController.reset();representationController = null;}if(abrController){abrController.unRegisterStreamType(type);}spExternalControllers.forEach(function(controller){controller.reset();});resetInitialSettings();type = null;stream = null;if(liveEdgeFinder){liveEdgeFinder.reset();liveEdgeFinder = null;}}function isUpdating(){return representationController?representationController.isUpdating():false;}function getType(){return type;}function getRepresentationController(){return representationController;}function getIndexHandler(){return indexHandler;}function getFragmentController(){return stream?stream.getFragmentController():null;}function getBuffer(){return bufferController.getBuffer();}function setBuffer(buffer){bufferController.setBuffer(buffer);}function getBufferController(){return bufferController;}function getFragmentModel(){return fragmentModel;}function getLiveEdgeFinder(){return liveEdgeFinder;}function getStreamInfo(){return stream?stream.getStreamInfo():null;}function getEventController(){return stream?stream.getEventController():null;}function updateMediaInfo(newMediaInfo){if(newMediaInfo !== mediaInfo && (!newMediaInfo || !mediaInfo || newMediaInfo.type === mediaInfo.type)){mediaInfo = newMediaInfo;}if(mediaInfoArr.indexOf(newMediaInfo) === -1){mediaInfoArr.push(newMediaInfo);}adapter.updateData(this);}function getMediaInfoArr(){return mediaInfoArr;}function getMediaInfo(){return mediaInfo;}function getMediaSource(){return bufferController.getMediaSource();}function setMediaSource(mediaSource){bufferController.setMediaSource(mediaSource,getMediaInfo());}function dischargePreBuffer(){bufferController.dischargePreBuffer();}function getScheduleController(){return scheduleController;}function getCurrentRepresentationInfo(){return adapter.getCurrentRepresentationInfo(representationController);}function getRepresentationInfoForQuality(quality){return adapter.getRepresentationInfoForQuality(representationController,quality);}function isBufferingCompleted(){if(bufferController){return bufferController.getIsBufferingCompleted();}return false;}function getBufferLevel(){return bufferController.getBufferLevel();}function switchInitData(representationId,bufferResetEnabled){if(bufferController){bufferController.switchInitData(getStreamInfo().id,representationId,bufferResetEnabled);}}function createBuffer(){return bufferController.getBuffer() || bufferController.createBuffer(mediaInfo);}function switchTrackAsked(){scheduleController.switchTrackAsked();}function createBufferControllerForType(type){var controller=null;if(type === _constantsConstants2['default'].VIDEO || type === _constantsConstants2['default'].AUDIO){controller = (0,_controllersBufferController2['default'])(context).create({type:type,metricsModel:metricsModel,mediaPlayerModel:mediaPlayerModel,manifestModel:manifestModel,errHandler:errHandler,streamController:streamController,mediaController:mediaController,adapter:adapter,textController:textController,abrController:abrController,playbackController:playbackController,streamProcessor:instance});}else {controller = (0,_textTextBufferController2['default'])(context).create({type:type,metricsModel:metricsModel,mediaPlayerModel:mediaPlayerModel,manifestModel:manifestModel,errHandler:errHandler,streamController:streamController,mediaController:mediaController,adapter:adapter,textController:textController,abrController:abrController,playbackController:playbackController,streamProcessor:instance});}return controller;}instance = {initialize:initialize,isUpdating:isUpdating,getType:getType,getBufferController:getBufferController,getFragmentModel:getFragmentModel,getScheduleController:getScheduleController,getLiveEdgeFinder:getLiveEdgeFinder,getEventController:getEventController,getFragmentController:getFragmentController,getRepresentationController:getRepresentationController,getIndexHandler:getIndexHandler,getCurrentRepresentationInfo:getCurrentRepresentationInfo,getRepresentationInfoForQuality:getRepresentationInfoForQuality,getBufferLevel:getBufferLevel,switchInitData:switchInitData,isBufferingCompleted:isBufferingCompleted,createBuffer:createBuffer,getStreamInfo:getStreamInfo,updateMediaInfo:updateMediaInfo,switchTrackAsked:switchTrackAsked,getMediaInfoArr:getMediaInfoArr,getMediaInfo:getMediaInfo,getMediaSource:getMediaSource,setMediaSource:setMediaSource,dischargePreBuffer:dischargePreBuffer,getBuffer:getBuffer,setBuffer:setBuffer,registerExternalController:registerExternalController,unregisterExternalController:unregisterExternalController,getExternalControllers:getExternalControllers,unregisterAllExternalController:unregisterAllExternalController,reset:reset};setup();return instance;}StreamProcessor.__dashjs_factory_name = 'StreamProcessor';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(StreamProcessor);module.exports = exports['default'];
	//# sourceMappingURL=StreamProcessor.js.map


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _voDashJSError=__webpack_require__(31);var _voDashJSError2=_interopRequireDefault(_voDashJSError);var _netHTTPLoader=__webpack_require__(55);var _netHTTPLoader2=_interopRequireDefault(_netHTTPLoader);var _voMetricsHTTPRequest=__webpack_require__(16);var _voTextRequest=__webpack_require__(155);var _voTextRequest2=_interopRequireDefault(_voTextRequest);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var XLINK_LOADER_ERROR_LOADING_FAILURE=1;function XlinkLoader(config){config = config || {};var RESOLVE_TO_ZERO='urn:mpeg:dash:resolve-to-zero:2013';var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var httpLoader=(0,_netHTTPLoader2['default'])(context).create({errHandler:config.errHandler,metricsModel:config.metricsModel,mediaPlayerModel:config.mediaPlayerModel,requestModifier:config.requestModifier});var instance=undefined;function load(url,element,resolveObject){var report=function report(content,resolveToZero){element.resolved = true;element.resolvedContent = content?content:null;eventBus.trigger(_coreEventsEvents2['default'].XLINK_ELEMENT_LOADED,{element:element,resolveObject:resolveObject,error:content || resolveToZero?null:new _voDashJSError2['default'](XLINK_LOADER_ERROR_LOADING_FAILURE,'Failed loading Xlink element: ' + url)});};if(url === RESOLVE_TO_ZERO){report(null,true);}else {var request=new _voTextRequest2['default'](url,_voMetricsHTTPRequest.HTTPRequest.XLINK_TYPE);httpLoader.load({request:request,success:function success(data){report(data);},error:function error(){report(null);}});}}function reset(){if(httpLoader){httpLoader.abort();httpLoader = null;}}instance = {load:load,reset:reset};return instance;}XlinkLoader.__dashjs_factory_name = 'XlinkLoader';var factory=_coreFactoryMaker2['default'].getClassFactory(XlinkLoader);factory.XLINK_LOADER_ERROR_LOADING_FAILURE = XLINK_LOADER_ERROR_LOADING_FAILURE;_coreFactoryMaker2['default'].updateClassFactory(XlinkLoader.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=XlinkLoader.js.map


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _modelsBaseURLTreeModel=__webpack_require__(367);var _modelsBaseURLTreeModel2=_interopRequireDefault(_modelsBaseURLTreeModel);var _utilsBaseURLSelector=__webpack_require__(407);var _utilsBaseURLSelector2=_interopRequireDefault(_utilsBaseURLSelector);var _utilsURLUtils=__webpack_require__(30);var _utilsURLUtils2=_interopRequireDefault(_utilsURLUtils);var _dashVoBaseURL=__webpack_require__(140);var _dashVoBaseURL2=_interopRequireDefault(_dashVoBaseURL);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);function BaseURLController(){var instance=undefined;var dashManifestModel=undefined;var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var urlUtils=(0,_utilsURLUtils2['default'])(context).getInstance();var baseURLTreeModel=undefined,baseURLSelector=undefined;function onBlackListChanged(e){baseURLTreeModel.invalidateSelectedIndexes(e.entry);}function setup(){baseURLTreeModel = (0,_modelsBaseURLTreeModel2['default'])(context).create();baseURLSelector = (0,_utilsBaseURLSelector2['default'])(context).create();eventBus.on(_coreEventsEvents2['default'].SERVICE_LOCATION_BLACKLIST_CHANGED,onBlackListChanged,instance);}function setConfig(config){if(config.baseURLTreeModel){baseURLTreeModel = config.baseURLTreeModel;}if(config.baseURLSelector){baseURLSelector = config.baseURLSelector;}if(config.dashManifestModel){dashManifestModel = config.dashManifestModel;}}function update(manifest){baseURLTreeModel.update(manifest);baseURLSelector.chooseSelectorFromManifest(manifest);}function resolve(path){var baseUrls=baseURLTreeModel.getForPath(path);var baseUrl=baseUrls.reduce(function(p,c){var b=baseURLSelector.select(c);if(b){if(!urlUtils.isRelative(b.url)){p.url = b.url;p.serviceLocation = b.serviceLocation;}else {p.url = urlUtils.resolve(b.url,p.url);}p.availabilityTimeOffset = b.availabilityTimeOffset;p.availabilityTimeComplete = b.availabilityTimeComplete;}else {return new _dashVoBaseURL2['default']();}return p;},new _dashVoBaseURL2['default']());if(!urlUtils.isRelative(baseUrl.url)){return baseUrl;}}function reset(){baseURLTreeModel.reset();baseURLSelector.reset();}function initialize(data){ // report config to baseURLTreeModel and baseURLSelector
	baseURLTreeModel.setConfig({dashManifestModel:dashManifestModel});baseURLSelector.setConfig({dashManifestModel:dashManifestModel});update(data);}instance = {reset:reset,initialize:initialize,resolve:resolve,setConfig:setConfig};setup();return instance;}BaseURLController.__dashjs_factory_name = 'BaseURLController';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(BaseURLController);module.exports = exports['default'];
	//# sourceMappingURL=BaseURLController.js.map


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);function BlackListController(config){config = config || {};var blacklist=[];var eventBus=(0,_coreEventBus2['default'])(this.context).getInstance();var updateEventName=config.updateEventName;var addBlacklistEventName=config.addBlacklistEventName;function contains(query){if(!blacklist.length || !query || !query.length){return false;}return blacklist.indexOf(query) !== -1;}function add(entry){if(blacklist.indexOf(entry) !== -1){return;}blacklist.push(entry);eventBus.trigger(updateEventName,{entry:entry});}function onAddBlackList(e){add(e.entry);}function setup(){if(addBlacklistEventName){eventBus.on(addBlacklistEventName,onAddBlackList,this);}}function reset(){blacklist = [];}setup();return {add:add,contains:contains,reset:reset};}BlackListController.__dashjs_factory_name = 'BlackListController';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(BlackListController);module.exports = exports['default'];
	//# sourceMappingURL=BlacklistController.js.map


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);function EventController(){var MPD_RELOAD_SCHEME='urn:mpeg:dash:event:2012';var MPD_RELOAD_VALUE=1;var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,inlineEvents=undefined, // Holds all Inline Events not triggered yet
	inbandEvents=undefined, // Holds all Inband Events not triggered yet
	activeEvents=undefined, // Holds all Events currently running
	eventInterval=undefined, // variable holding the setInterval
	refreshDelay=undefined, // refreshTime for the setInterval
	presentationTimeThreshold=undefined,manifestModel=undefined,manifestUpdater=undefined,playbackController=undefined,isStarted=undefined;function setup(){resetInitialSettings();}function resetInitialSettings(){isStarted = false;inlineEvents = {};inbandEvents = {};activeEvents = {};eventInterval = null;refreshDelay = 100;presentationTimeThreshold = refreshDelay / 1000;}function checkSetConfigCall(){if(!manifestModel || !manifestUpdater || !playbackController){throw new Error('setConfig function has to be called previously');}}function stop(){if(eventInterval !== null && isStarted){clearInterval(eventInterval);eventInterval = null;isStarted = false;}}function start(){checkSetConfigCall();log('Start Event Controller');if(!isStarted && !isNaN(refreshDelay)){isStarted = true;eventInterval = setInterval(onEventTimer,refreshDelay);}} /**
	     * Add events to the eventList. Events that are not in the mpd anymore but not triggered yet will still be deleted
	     * @param {Array.<Object>} values
	     */function addInlineEvents(values){checkSetConfigCall();inlineEvents = {};if(values){for(var i=0;i < values.length;i++) {var event=values[i];inlineEvents[event.id] = event;log('Add inline event with id ' + event.id);}}log('Added ' + values.length + ' inline events');} /**
	     * i.e. processing of any one event message box with the same id is sufficient
	     * @param {Array.<Object>} values
	     */function addInbandEvents(values){checkSetConfigCall();for(var i=0;i < values.length;i++) {var event=values[i];if(!(event.id in inbandEvents)){if(event.eventStream.schemeIdUri === MPD_RELOAD_SCHEME && inbandEvents[event.id] === undefined){handleManifestReloadEvent(event);}inbandEvents[event.id] = event;log('Add inband event with id ' + event.id);}else {log('Repeated event with id ' + event.id);}}}function handleManifestReloadEvent(event){if(event.eventStream.value == MPD_RELOAD_VALUE){var timescale=event.eventStream.timescale || 1;var validUntil=event.presentationTime / timescale;var newDuration=undefined;if(event.presentationTime == 0xFFFFFFFF){ //0xFF... means remaining duration unknown
	newDuration = NaN;}else {newDuration = (event.presentationTime + event.duration) / timescale;}log('Manifest validity changed: Valid until: ' + validUntil + '; remaining duration: ' + newDuration);eventBus.trigger(_coreEventsEvents2['default'].MANIFEST_VALIDITY_CHANGED,{id:event.id,validUntil:validUntil,newDuration:newDuration,newManifestValidAfter:NaN //event.message_data - this is an arraybuffer with a timestring in it, but not used yet
	});}} /**
	     * Remove events which are over from the list
	     */function removeEvents(){if(activeEvents){var currentVideoTime=playbackController.getTime();var eventIds=Object.keys(activeEvents);for(var i=0;i < eventIds.length;i++) {var eventId=eventIds[i];var curr=activeEvents[eventId];if(curr !== null && (curr.duration + curr.presentationTime) / curr.eventStream.timescale < currentVideoTime){log('Remove Event ' + eventId + ' at time ' + currentVideoTime);curr = null;delete activeEvents[eventId];}}}} /**
	     * Iterate through the eventList and trigger/remove the events
	     */function onEventTimer(){triggerEvents(inbandEvents);triggerEvents(inlineEvents);removeEvents();}function refreshManifest(){checkSetConfigCall();manifestUpdater.refreshManifest();}function triggerEvents(events){var currentVideoTime=playbackController.getTime();var presentationTime; /* == Trigger events that are ready == */if(events){var eventIds=Object.keys(events);for(var i=0;i < eventIds.length;i++) {var eventId=eventIds[i];var curr=events[eventId];if(curr !== undefined){presentationTime = curr.presentationTime / curr.eventStream.timescale;if(presentationTime === 0 || presentationTime <= currentVideoTime && presentationTime + presentationTimeThreshold > currentVideoTime){log('Start Event ' + eventId + ' at ' + currentVideoTime);if(curr.duration > 0){activeEvents[eventId] = curr;}if(curr.eventStream.schemeIdUri == MPD_RELOAD_SCHEME && curr.eventStream.value == MPD_RELOAD_VALUE){if(curr.duration !== 0 || curr.presentationTimeDelta !== 0){ //If both are set to zero, it indicates the media is over at this point. Don't reload the manifest.
	refreshManifest();}}else {eventBus.trigger(curr.eventStream.schemeIdUri,{event:curr});}delete events[eventId];}}}}}function setConfig(config){if(!config)return;if(config.manifestModel){manifestModel = config.manifestModel;}if(config.manifestUpdater){manifestUpdater = config.manifestUpdater;}if(config.playbackController){playbackController = config.playbackController;}}function reset(){stop();resetInitialSettings();}instance = {addInlineEvents:addInlineEvents,addInbandEvents:addInbandEvents,stop:stop,start:start,setConfig:setConfig,reset:reset};setup();return instance;}EventController.__dashjs_factory_name = 'EventController';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(EventController);module.exports = exports['default'];
	//# sourceMappingURL=EventController.js.map


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _voMetricsHTTPRequest=__webpack_require__(16);var _voDataChunk=__webpack_require__(417);var _voDataChunk2=_interopRequireDefault(_voDataChunk);var _modelsFragmentModel=__webpack_require__(66);var _modelsFragmentModel2=_interopRequireDefault(_modelsFragmentModel);var _FragmentLoader=__webpack_require__(330);var _FragmentLoader2=_interopRequireDefault(_FragmentLoader);var _utilsRequestModifier=__webpack_require__(69);var _utilsRequestModifier2=_interopRequireDefault(_utilsRequestModifier);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);function FragmentController(config){config = config || {};var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var errHandler=config.errHandler;var mediaPlayerModel=config.mediaPlayerModel;var metricsModel=config.metricsModel;var instance=undefined,fragmentModels=undefined;function setup(){resetInitialSettings();eventBus.on(_coreEventsEvents2['default'].FRAGMENT_LOADING_COMPLETED,onFragmentLoadingCompleted,instance);eventBus.on(_coreEventsEvents2['default'].FRAGMENT_LOADING_PROGRESS,onFragmentLoadingCompleted,instance);}function getModel(type){var model=fragmentModels[type];if(!model){model = (0,_modelsFragmentModel2['default'])(context).create({metricsModel:metricsModel,fragmentLoader:(0,_FragmentLoader2['default'])(context).create({metricsModel:metricsModel,mediaPlayerModel:mediaPlayerModel,errHandler:errHandler,requestModifier:(0,_utilsRequestModifier2['default'])(context).getInstance()})});fragmentModels[type] = model;}return model;}function isInitializationRequest(request){return request && request.type && request.type === _voMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE;}function resetInitialSettings(){for(var model in fragmentModels) {fragmentModels[model].reset();}fragmentModels = {};}function reset(){eventBus.off(_coreEventsEvents2['default'].FRAGMENT_LOADING_COMPLETED,onFragmentLoadingCompleted,this);eventBus.off(_coreEventsEvents2['default'].FRAGMENT_LOADING_PROGRESS,onFragmentLoadingCompleted,this);resetInitialSettings();}function createDataChunk(bytes,request,streamId,endFragment){var chunk=new _voDataChunk2['default']();chunk.streamId = streamId;chunk.mediaInfo = request.mediaInfo;chunk.segmentType = request.type;chunk.start = request.startTime;chunk.duration = request.duration;chunk.end = chunk.start + chunk.duration;chunk.bytes = bytes;chunk.index = request.index;chunk.quality = request.quality;chunk.representationId = request.representationId;chunk.endFragment = endFragment;return chunk;}function onFragmentLoadingCompleted(e){if(fragmentModels[e.request.mediaType] !== e.sender){return;}var request=e.request;var bytes=e.response;var isInit=isInitializationRequest(request);var streamInfo=request.mediaInfo.streamInfo;if(e.error){if(e.request.mediaType === _constantsConstants2['default'].AUDIO || e.request.mediaType === _constantsConstants2['default'].VIDEO || e.request.mediaType === _constantsConstants2['default'].FRAGMENTED_TEXT){ // add service location to blacklist controller - only for audio or video. text should not set errors
	eventBus.trigger(_coreEventsEvents2['default'].SERVICE_LOCATION_BLACKLIST_ADD,{entry:e.request.serviceLocation});}}if(!bytes || !streamInfo){log('No ' + request.mediaType + ' bytes to push or stream is inactive.');return;}var chunk=createDataChunk(bytes,request,streamInfo.id,e.type !== _coreEventsEvents2['default'].FRAGMENT_LOADING_PROGRESS);eventBus.trigger(isInit?_coreEventsEvents2['default'].INIT_FRAGMENT_LOADED:_coreEventsEvents2['default'].MEDIA_FRAGMENT_LOADED,{chunk:chunk,fragmentModel:e.sender});}instance = {getModel:getModel,isInitializationRequest:isInitializationRequest,reset:reset};setup();return instance;}FragmentController.__dashjs_factory_name = 'FragmentController';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(FragmentController);module.exports = exports['default'];
	//# sourceMappingURL=FragmentController.js.map


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function MediaSourceController(){var instance=undefined;function createMediaSource(){var hasWebKit=('WebKitMediaSource' in window);var hasMediaSource=('MediaSource' in window);if(hasMediaSource){return new MediaSource();}else if(hasWebKit){return new WebKitMediaSource();}return null;}function attachMediaSource(source,videoModel){var objectURL=window.URL.createObjectURL(source);videoModel.setSource(objectURL);return objectURL;}function detachMediaSource(videoModel){videoModel.setSource(null);}function setDuration(source,value){if(source.duration != value)source.duration = value;return source.duration;}function setSeekable(source,start,end){if(source && typeof source.setLiveSeekableRange === 'function' && typeof source.clearLiveSeekableRange === 'function' && source.readyState === 'open' && start >= 0 && start < end){source.clearLiveSeekableRange();source.setLiveSeekableRange(start,end);}}function signalEndOfStream(source){var buffers=source.sourceBuffers;var ln=buffers.length;if(source.readyState !== 'open'){return;}for(var i=0;i < ln;i++) {if(buffers[i].updating){return;}if(buffers[i].buffered.length === 0){return;}}source.endOfStream();}instance = {createMediaSource:createMediaSource,attachMediaSource:attachMediaSource,detachMediaSource:detachMediaSource,setDuration:setDuration,setSeekable:setSeekable,signalEndOfStream:signalEndOfStream};return instance;}MediaSourceController.__dashjs_factory_name = 'MediaSourceController';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(MediaSourceController);module.exports = exports['default'];
	//# sourceMappingURL=MediaSourceController.js.map


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _BufferController=__webpack_require__(36);var _BufferController2=_interopRequireDefault(_BufferController);var _modelsURIQueryAndFragmentModel=__webpack_require__(150);var _modelsURIQueryAndFragmentModel2=_interopRequireDefault(_modelsURIQueryAndFragmentModel);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var LIVE_UPDATE_PLAYBACK_TIME_INTERVAL_MS=500;function PlaybackController(){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,streamController=undefined,metricsModel=undefined,dashMetrics=undefined,manifestModel=undefined,dashManifestModel=undefined,adapter=undefined,videoModel=undefined,currentTime=undefined,liveStartTime=undefined,wallclockTimeIntervalId=undefined,commonEarliestTime=undefined,liveDelay=undefined,bufferedRange=undefined,streamInfo=undefined,isDynamic=undefined,mediaPlayerModel=undefined,playOnceInitialized=undefined,lastLivePlaybackTime=undefined,availabilityStartTime=undefined;function setup(){reset();}function initialize(StreamInfo){streamInfo = StreamInfo;addAllListeners();isDynamic = streamInfo.manifestInfo.isDynamic;liveStartTime = streamInfo.start;eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,onDataUpdateCompleted,this);eventBus.on(_coreEventsEvents2['default'].BYTES_APPENDED_END_FRAGMENT,onBytesAppended,this);eventBus.on(_coreEventsEvents2['default'].BUFFER_LEVEL_STATE_CHANGED,onBufferLevelStateChanged,this);eventBus.on(_coreEventsEvents2['default'].PERIOD_SWITCH_STARTED,onPeriodSwitchStarted,this);if(playOnceInitialized){playOnceInitialized = false;play();}}function onPeriodSwitchStarted(e){if(!isDynamic && e.fromStreamInfo && commonEarliestTime[e.fromStreamInfo.id] !== undefined){delete bufferedRange[e.fromStreamInfo.id];delete commonEarliestTime[e.fromStreamInfo.id];}}function getTimeToStreamEnd(){var startTime=getStreamStartTime(true);var offset=isDynamic?startTime - streamInfo.start:0;return parseFloat((startTime + (streamInfo.duration - offset) - getTime()).toFixed(5));}function play(){if(streamInfo && videoModel && videoModel.getElement()){videoModel.play();}else {playOnceInitialized = true;}}function isPaused(){return streamInfo && videoModel?videoModel.isPaused():null;}function pause(){if(streamInfo && videoModel){videoModel.pause();}}function isSeeking(){return streamInfo && videoModel?videoModel.isSeeking():null;}function seek(time){if(streamInfo && videoModel){eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_SEEK_ASKED);log('Requesting seek to time: ' + time);videoModel.setCurrentTime(time);}}function getTime(){return streamInfo && videoModel?videoModel.getTime():null;}function getPlaybackRate(){return streamInfo && videoModel?videoModel.getPlaybackRate():null;}function getPlayedRanges(){return streamInfo && videoModel?videoModel.getPlayedRanges():null;}function getEnded(){return streamInfo && videoModel?videoModel.getEnded():null;}function getIsDynamic(){return isDynamic;}function getStreamController(){return streamController;}function setLiveStartTime(value){liveStartTime = value;}function getLiveStartTime(){return liveStartTime;} /**
	     * Computes the desirable delay for the live edge to avoid a risk of getting 404 when playing at the bleeding edge
	     * @param {number} fragmentDuration - seconds?
	     * @param {number} dvrWindowSize - seconds?
	     * @returns {number} object
	     * @memberof PlaybackController#
	     */function computeLiveDelay(fragmentDuration,dvrWindowSize){var mpd=dashManifestModel.getMpd(manifestModel.getValue());var delay=undefined;var ret=undefined;var END_OF_PLAYLIST_PADDING=10;if(mediaPlayerModel.getUseSuggestedPresentationDelay() && mpd.hasOwnProperty(_constantsConstants2['default'].SUGGESTED_PRESENTATION_DELAY)){delay = mpd.suggestedPresentationDelay;}else if(mediaPlayerModel.getLowLatencyEnabled()){delay = 0;}else if(mediaPlayerModel.getLiveDelay()){delay = mediaPlayerModel.getLiveDelay(); // If set by user, this value takes precedence
	}else if(!isNaN(fragmentDuration)){delay = fragmentDuration * mediaPlayerModel.getLiveDelayFragmentCount();}else {delay = streamInfo.manifestInfo.minBufferTime * 2;}if(mpd.availabilityStartTime){availabilityStartTime = mpd.availabilityStartTime.getTime();}if(dvrWindowSize > 0){ // cap target latency to:
	// - dvrWindowSize / 2 for short playlists
	// - dvrWindowSize - END_OF_PLAYLIST_PADDING for longer playlists
	var targetDelayCapping=Math.max(dvrWindowSize - END_OF_PLAYLIST_PADDING,dvrWindowSize / 2);ret = Math.min(delay,targetDelayCapping);}else {ret = delay;}liveDelay = ret;return ret;}function getLiveDelay(){return liveDelay;}function getCurrentLiveLatency(){if(!isDynamic || isNaN(availabilityStartTime)){return NaN;}var currentTime=getTime();if(isNaN(currentTime) || currentTime === 0){return 0;}return (Math.round(new Date().getTime() - (currentTime * 1000 + availabilityStartTime)) / 1000).toFixed(3);}function reset(){currentTime = 0;liveStartTime = NaN;wallclockTimeIntervalId = null;playOnceInitialized = false;commonEarliestTime = {};liveDelay = 0;availabilityStartTime = 0;bufferedRange = {};if(videoModel){eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,onDataUpdateCompleted,this);eventBus.off(_coreEventsEvents2['default'].BUFFER_LEVEL_STATE_CHANGED,onBufferLevelStateChanged,this);eventBus.off(_coreEventsEvents2['default'].BYTES_APPENDED_END_FRAGMENT,onBytesAppended,this);eventBus.off(_coreEventsEvents2['default'].PERIOD_SWITCH_STARTED,onPeriodSwitchStarted,this);stopUpdatingWallclockTime();removeAllListeners();}videoModel = null;streamInfo = null;isDynamic = null;}function setConfig(config){if(!config)return;if(config.streamController){streamController = config.streamController;}if(config.metricsModel){metricsModel = config.metricsModel;}if(config.dashMetrics){dashMetrics = config.dashMetrics;}if(config.manifestModel){manifestModel = config.manifestModel;}if(config.dashManifestModel){dashManifestModel = config.dashManifestModel;}if(config.mediaPlayerModel){mediaPlayerModel = config.mediaPlayerModel;}if(config.adapter){adapter = config.adapter;}if(config.videoModel){videoModel = config.videoModel;}}function getStartTimeFromUriParameters(){var fragData=(0,_modelsURIQueryAndFragmentModel2['default'])(context).getInstance().getURIFragmentData();var uriParameters=undefined;if(fragData){uriParameters = {};var r=parseInt(fragData.r,10);if(r >= 0 && streamInfo && r < streamInfo.manifestInfo.DVRWindowSize && fragData.t === null){fragData.t = Math.floor(Date.now() / 1000) - streamInfo.manifestInfo.DVRWindowSize + r;}uriParameters.fragS = parseInt(fragData.s,10);uriParameters.fragT = parseInt(fragData.t,10);}return uriParameters;} /**
	     * @param {boolean} ignoreStartOffset - ignore URL fragment start offset if true
	     * @param {number} liveEdge - liveEdge value
	     * @returns {number} object
	     * @memberof PlaybackController#
	     */function getStreamStartTime(ignoreStartOffset,liveEdge){var presentationStartTime=undefined;var startTimeOffset=NaN;var uriParameters=getStartTimeFromUriParameters();if(uriParameters){if(!ignoreStartOffset){startTimeOffset = !isNaN(uriParameters.fragS)?uriParameters.fragS:uriParameters.fragT;}else {startTimeOffset = streamInfo.start;}}else { // handle case where no media fragments are parsed from the manifest URL
	startTimeOffset = 0;}if(isDynamic){if(!isNaN(startTimeOffset)){presentationStartTime = startTimeOffset - streamInfo.manifestInfo.availableFrom.getTime() / 1000;if(presentationStartTime > liveStartTime || presentationStartTime < (!isNaN(liveEdge)?liveEdge - streamInfo.manifestInfo.DVRWindowSize:NaN)){presentationStartTime = null;}}presentationStartTime = presentationStartTime || liveStartTime;}else {if(!isNaN(startTimeOffset) && startTimeOffset < Math.max(streamInfo.manifestInfo.duration,streamInfo.duration) && startTimeOffset >= 0){presentationStartTime = startTimeOffset;}else {var earliestTime=commonEarliestTime[streamInfo.id]; //set by ready bufferStart after first onBytesAppended
	presentationStartTime = earliestTime !== undefined?Math.max(earliestTime.audio !== undefined?earliestTime.audio:0,earliestTime.video !== undefined?earliestTime.video:0,streamInfo.start):streamInfo.start;}}return presentationStartTime;}function getActualPresentationTime(currentTime){var metrics=metricsModel.getReadOnlyMetricsFor(_constantsConstants2['default'].VIDEO) || metricsModel.getReadOnlyMetricsFor(_constantsConstants2['default'].AUDIO);var DVRMetrics=dashMetrics.getCurrentDVRInfo(metrics);var DVRWindow=DVRMetrics?DVRMetrics.range:null;var actualTime=undefined;if(!DVRWindow)return NaN;if(currentTime > DVRWindow.end){actualTime = Math.max(DVRWindow.end - streamInfo.manifestInfo.minBufferTime * 2,DVRWindow.start);}else if(currentTime + 0.250 < DVRWindow.start){ // Checking currentTime plus 250ms as the 'timeupdate' is fired with a frequency between 4Hz and 66Hz
	// https://developer.mozilla.org/en-US/docs/Web/Events/timeupdate
	// http://w3c.github.io/html/single-page.html#offsets-into-the-media-resource
	actualTime = DVRWindow.start;}else {return currentTime;}return actualTime;}function startUpdatingWallclockTime(){if(wallclockTimeIntervalId !== null)return;var tick=function tick(){onWallclockTime();};wallclockTimeIntervalId = setInterval(tick,mediaPlayerModel.getWallclockTimeUpdateInterval());}function stopUpdatingWallclockTime(){clearInterval(wallclockTimeIntervalId);wallclockTimeIntervalId = null;}function updateCurrentTime(){if(isPaused() || !isDynamic || videoModel.getReadyState() === 0)return;var currentTime=getTime();var actualTime=getActualPresentationTime(currentTime);var timeChanged=!isNaN(actualTime) && actualTime !== currentTime;if(timeChanged){seek(actualTime);}}function onDataUpdateCompleted(e){if(e.error)return;var representationInfo=adapter.convertDataToRepresentationInfo(e.currentRepresentation);var info=representationInfo.mediaInfo.streamInfo;if(streamInfo.id !== info.id)return;streamInfo = info;updateCurrentTime();}function onCanPlay(){eventBus.trigger(_coreEventsEvents2['default'].CAN_PLAY);}function onPlaybackStart(){log('Native video element event: play');updateCurrentTime();startUpdatingWallclockTime();eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_STARTED,{startTime:getTime()});}function onPlaybackWaiting(){log('Native video element event: waiting');eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_WAITING,{playingTime:getTime()});}function onPlaybackPlaying(){log('Native video element event: playing');eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_PLAYING,{playingTime:getTime()});}function onPlaybackPaused(){log('Native video element event: pause');eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_PAUSED,{ended:getEnded()});}function onPlaybackSeeking(){var seekTime=getTime();log('Seeking to: ' + seekTime);startUpdatingWallclockTime();eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_SEEKING,{seekTime:seekTime});}function onPlaybackSeeked(){log('Native video element event: seeked');eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_SEEKED);}function onPlaybackTimeUpdated(){var time=getTime();currentTime = time;eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED,{timeToEnd:getTimeToStreamEnd(),time:time});}function updateLivePlaybackTime(){var now=Date.now();if(!lastLivePlaybackTime || now > lastLivePlaybackTime + LIVE_UPDATE_PLAYBACK_TIME_INTERVAL_MS){lastLivePlaybackTime = now;onPlaybackTimeUpdated();}}function onPlaybackProgress(){eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_PROGRESS);}function onPlaybackRateChanged(){var rate=getPlaybackRate();log('Native video element event: ratechange: ',rate);eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_RATE_CHANGED,{playbackRate:rate});}function onPlaybackMetaDataLoaded(){log('Native video element event: loadedmetadata');eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_METADATA_LOADED);startUpdatingWallclockTime();}function onPlaybackEnded(){log('Native video element event: ended');pause();stopUpdatingWallclockTime();eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_ENDED);}function onPlaybackError(event){var target=event.target || event.srcElement;eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_ERROR,{error:target.error});}function onWallclockTime(){eventBus.trigger(_coreEventsEvents2['default'].WALLCLOCK_TIME_UPDATED,{isDynamic:isDynamic,time:new Date()}); // Updates playback time for paused dynamic streams
	// (video element doesn't call timeupdate when the playback is paused)
	if(getIsDynamic() && isPaused()){updateLivePlaybackTime();}}function checkTimeInRanges(time,ranges){if(ranges && ranges.length > 0){for(var i=0,len=ranges.length;i < len;i++) {if(time >= ranges.start(i) && time < ranges.end(i)){return true;}}}return false;}function onBytesAppended(e){var earliestTime=undefined,initialStartTime=undefined;var ranges=e.bufferedRanges;if(!ranges || !ranges.length)return;if(commonEarliestTime[streamInfo.id] && commonEarliestTime[streamInfo.id].started === true){ //stream has already been started.
	return;}var type=e.sender.getType();if(bufferedRange[streamInfo.id] === undefined){bufferedRange[streamInfo.id] = [];}bufferedRange[streamInfo.id][type] = ranges;if(commonEarliestTime[streamInfo.id] === undefined){commonEarliestTime[streamInfo.id] = [];commonEarliestTime[streamInfo.id].started = false;}if(commonEarliestTime[streamInfo.id][type] === undefined){commonEarliestTime[streamInfo.id][type] = Math.max(ranges.start(0),streamInfo.start);}var hasVideoTrack=streamController.isVideoTrackPresent();var hasAudioTrack=streamController.isAudioTrackPresent();initialStartTime = getStreamStartTime(false);if(hasAudioTrack && hasVideoTrack){ //current stream has audio and video contents
	if(!isNaN(commonEarliestTime[streamInfo.id].audio) && !isNaN(commonEarliestTime[streamInfo.id].video)){if(commonEarliestTime[streamInfo.id].audio < commonEarliestTime[streamInfo.id].video){ // common earliest is video time
	// check buffered audio range has video time, if ok, we seek, otherwise, we wait some other data
	earliestTime = commonEarliestTime[streamInfo.id].video > initialStartTime?commonEarliestTime[streamInfo.id].video:initialStartTime;ranges = bufferedRange[streamInfo.id].audio;}else { // common earliest is audio time
	// check buffered video range has audio time, if ok, we seek, otherwise, we wait some other data
	earliestTime = commonEarliestTime[streamInfo.id].audio > initialStartTime?commonEarliestTime[streamInfo.id].audio:initialStartTime;ranges = bufferedRange[streamInfo.id].video;}if(checkTimeInRanges(earliestTime,ranges)){if(!isSeeking()){seek(earliestTime);}commonEarliestTime[streamInfo.id].started = true;}}}else { //current stream has only audio or only video content
	if(commonEarliestTime[streamInfo.id][type]){earliestTime = commonEarliestTime[streamInfo.id][type] > initialStartTime?commonEarliestTime[streamInfo.id][type]:initialStartTime;if(!isSeeking()){seek(earliestTime);}commonEarliestTime[streamInfo.id].started = true;}}}function onBufferLevelStateChanged(e){ // do not stall playback when get an event from Stream that is not active
	if(e.streamInfo.id !== streamInfo.id)return;videoModel.setStallState(e.mediaType,e.state === _BufferController2['default'].BUFFER_EMPTY);}function addAllListeners(){videoModel.addEventListener('canplay',onCanPlay);videoModel.addEventListener('play',onPlaybackStart);videoModel.addEventListener('waiting',onPlaybackWaiting);videoModel.addEventListener('playing',onPlaybackPlaying);videoModel.addEventListener('pause',onPlaybackPaused);videoModel.addEventListener('error',onPlaybackError);videoModel.addEventListener('seeking',onPlaybackSeeking);videoModel.addEventListener('seeked',onPlaybackSeeked);videoModel.addEventListener('timeupdate',onPlaybackTimeUpdated);videoModel.addEventListener('progress',onPlaybackProgress);videoModel.addEventListener('ratechange',onPlaybackRateChanged);videoModel.addEventListener('loadedmetadata',onPlaybackMetaDataLoaded);videoModel.addEventListener('ended',onPlaybackEnded);}function removeAllListeners(){videoModel.removeEventListener('canplay',onCanPlay);videoModel.removeEventListener('play',onPlaybackStart);videoModel.removeEventListener('waiting',onPlaybackWaiting);videoModel.removeEventListener('playing',onPlaybackPlaying);videoModel.removeEventListener('pause',onPlaybackPaused);videoModel.removeEventListener('error',onPlaybackError);videoModel.removeEventListener('seeking',onPlaybackSeeking);videoModel.removeEventListener('seeked',onPlaybackSeeked);videoModel.removeEventListener('timeupdate',onPlaybackTimeUpdated);videoModel.removeEventListener('progress',onPlaybackProgress);videoModel.removeEventListener('ratechange',onPlaybackRateChanged);videoModel.removeEventListener('loadedmetadata',onPlaybackMetaDataLoaded);videoModel.removeEventListener('ended',onPlaybackEnded);}instance = {initialize:initialize,setConfig:setConfig,getStartTimeFromUriParameters:getStartTimeFromUriParameters,getStreamStartTime:getStreamStartTime,getTimeToStreamEnd:getTimeToStreamEnd,getTime:getTime,getPlaybackRate:getPlaybackRate,getPlayedRanges:getPlayedRanges,getEnded:getEnded,getIsDynamic:getIsDynamic,getStreamController:getStreamController,setLiveStartTime:setLiveStartTime,getLiveStartTime:getLiveStartTime,computeLiveDelay:computeLiveDelay,getLiveDelay:getLiveDelay,getCurrentLiveLatency:getCurrentLiveLatency,play:play,isPaused:isPaused,pause:pause,isSeeking:isSeeking,seek:seek,reset:reset};setup();return instance;}PlaybackController.__dashjs_factory_name = 'PlaybackController';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(PlaybackController);module.exports = exports['default'];
	//# sourceMappingURL=PlaybackController.js.map


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _voMetricsPlayList=__webpack_require__(156);var _AbrController=__webpack_require__(64);var _AbrController2=_interopRequireDefault(_AbrController);var _BufferController=__webpack_require__(36);var _BufferController2=_interopRequireDefault(_BufferController);var _rulesSchedulingBufferLevelRule=__webpack_require__(399);var _rulesSchedulingBufferLevelRule2=_interopRequireDefault(_rulesSchedulingBufferLevelRule);var _rulesSchedulingNextFragmentRequestRule=__webpack_require__(400);var _rulesSchedulingNextFragmentRequestRule2=_interopRequireDefault(_rulesSchedulingNextFragmentRequestRule);var _modelsFragmentModel=__webpack_require__(66);var _modelsFragmentModel2=_interopRequireDefault(_modelsFragmentModel);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _MediaController=__webpack_require__(87);var _MediaController2=_interopRequireDefault(_MediaController);function ScheduleController(config){config = config || {};var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var metricsModel=config.metricsModel;var adapter=config.adapter;var dashMetrics=config.dashMetrics;var dashManifestModel=config.dashManifestModel;var timelineConverter=config.timelineConverter;var mediaPlayerModel=config.mediaPlayerModel;var abrController=config.abrController;var playbackController=config.playbackController;var streamController=config.streamController;var textController=config.textController;var type=config.type;var streamProcessor=config.streamProcessor;var mediaController=config.mediaController;var instance=undefined,log=undefined,fragmentModel=undefined,currentRepresentationInfo=undefined,initialRequest=undefined,isStopped=undefined,playListMetrics=undefined,playListTraceMetrics=undefined,playListTraceMetricsClosed=undefined,isFragmentProcessingInProgress=undefined,timeToLoadDelay=undefined,scheduleTimeout=undefined,seekTarget=undefined,bufferLevelRule=undefined,nextFragmentRequestRule=undefined,scheduleWhilePaused=undefined,lastFragmentRequest=undefined,topQualityIndex=undefined,lastInitQuality=undefined,replaceRequestArray=undefined,switchTrack=undefined,bufferResetInProgress=undefined,mediaRequest=undefined;function setup(){log = (0,_coreDebug2['default'])(context).getInstance().log.bind(instance);resetInitialSettings();}function initialize(){fragmentModel = streamProcessor.getFragmentModel();scheduleWhilePaused = mediaPlayerModel.getScheduleWhilePaused();bufferLevelRule = (0,_rulesSchedulingBufferLevelRule2['default'])(context).create({abrController:abrController,dashMetrics:dashMetrics,metricsModel:metricsModel,mediaPlayerModel:mediaPlayerModel,textController:textController});nextFragmentRequestRule = (0,_rulesSchedulingNextFragmentRequestRule2['default'])(context).create({adapter:adapter,textController:textController});if(dashManifestModel.getIsTextTrack(type)){eventBus.on(_coreEventsEvents2['default'].TIMED_TEXT_REQUESTED,onTimedTextRequested,this);} //eventBus.on(Events.LIVE_EDGE_SEARCH_COMPLETED, onLiveEdgeSearchCompleted, this);
	eventBus.on(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED,onQualityChanged,this);eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_STARTED,onDataUpdateStarted,this);eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,onDataUpdateCompleted,this);eventBus.on(_coreEventsEvents2['default'].FRAGMENT_LOADING_COMPLETED,onFragmentLoadingCompleted,this);eventBus.on(_coreEventsEvents2['default'].STREAM_COMPLETED,onStreamCompleted,this);eventBus.on(_coreEventsEvents2['default'].STREAM_INITIALIZED,onStreamInitialized,this);eventBus.on(_coreEventsEvents2['default'].BUFFER_LEVEL_STATE_CHANGED,onBufferLevelStateChanged,this);eventBus.on(_coreEventsEvents2['default'].BUFFER_CLEARED,onBufferCleared,this);eventBus.on(_coreEventsEvents2['default'].BYTES_APPENDED_END_FRAGMENT,onBytesAppended,this);eventBus.on(_coreEventsEvents2['default'].INIT_REQUESTED,onInitRequested,this);eventBus.on(_coreEventsEvents2['default'].QUOTA_EXCEEDED,onQuotaExceeded,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_SEEKING,onPlaybackSeeking,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_STARTED,onPlaybackStarted,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_RATE_CHANGED,onPlaybackRateChanged,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED,onPlaybackTimeUpdated,this);eventBus.on(_coreEventsEvents2['default'].URL_RESOLUTION_FAILED,onURLResolutionFailed,this);eventBus.on(_coreEventsEvents2['default'].FRAGMENT_LOADING_ABANDONED,onFragmentLoadingAbandoned,this);}function isStarted(){return isStopped === false;}function start(){if(!currentRepresentationInfo || streamProcessor.isBufferingCompleted()){log('[ScheduleController][',type,'] start denied');return;}log('[ScheduleController][',type,'] start');addPlaylistTraceMetrics();isStopped = false;if(initialRequest){initialRequest = false;}startScheduleTimer(0);}function stop(){if(isStopped){return;}log('[ScheduleController][',type,'] stop');isStopped = true;clearTimeout(scheduleTimeout);}function hasTopQualityChanged(type,id){topQualityIndex[id] = topQualityIndex[id] || {};var newTopQualityIndex=abrController.getTopQualityIndexFor(type,id);if(topQualityIndex[id][type] != newTopQualityIndex){log('Top quality ' + type + ' index has changed from ' + topQualityIndex[id][type] + ' to ' + newTopQualityIndex);topQualityIndex[id][type] = newTopQualityIndex;return true;}return false;}function schedule(){if(isStopped || isFragmentProcessingInProgress || !streamProcessor.getBufferController() || playbackController.isPaused() && !scheduleWhilePaused){log('[ScheduleController][',type,'] - schedule stop!');return;}validateExecutedFragmentRequest();var isReplacement=replaceRequestArray.length > 0;var streamInfo=streamProcessor.getStreamInfo();if(bufferResetInProgress || isNaN(lastInitQuality) || switchTrack || isReplacement || hasTopQualityChanged(currentRepresentationInfo.mediaInfo.type,streamInfo.id) || bufferLevelRule.execute(streamProcessor,type,streamController.isVideoTrackPresent())){var getNextFragment=function getNextFragment(){var fragmentController=streamProcessor.getFragmentController();if(currentRepresentationInfo.quality !== lastInitQuality){log('ScheduleController - ' + type + ' - quality has changed, get init request for representationid = ' + currentRepresentationInfo.id);lastInitQuality = currentRepresentationInfo.quality;streamProcessor.switchInitData(currentRepresentationInfo.id);}else if(switchTrack){log('ScheduleController - ' + type + ' - switch track has been asked, get init request for ' + type + ' with representationid = ' + currentRepresentationInfo.id);bufferResetInProgress = mediaController.getSwitchMode(type) === _MediaController2['default'].TRACK_SWITCH_MODE_ALWAYS_REPLACE?true:false;streamProcessor.switchInitData(currentRepresentationInfo.id,bufferResetInProgress);lastInitQuality = currentRepresentationInfo.quality;switchTrack = false;}else {var replacement=replaceRequestArray.shift();if(fragmentController.isInitializationRequest(replacement)){ // To be sure the specific init segment had not already been loaded.
	streamProcessor.switchInitData(replacement.representationId);}else {var request=undefined; // Don't schedule next fragments while pruning to avoid buffer inconsistencies
	if(!streamProcessor.getBufferController().getIsPruningInProgress()){request = nextFragmentRequestRule.execute(streamProcessor,replacement);if(!request && streamInfo.manifestInfo && streamInfo.manifestInfo.isDynamic){log('getNextFragment - ' + type + ' - Playing at the bleeding live edge and frag is not available yet');}}if(request){log('ScheduleController - ' + type + ' - getNextFragment - request is ' + request.url);fragmentModel.executeRequest(request);}else { // Use case - Playing at the bleeding live edge and frag is not available yet. Cycle back around.
	setFragmentProcessState(false);startScheduleTimer(500);}}}};setFragmentProcessState(true);if(!isReplacement && !switchTrack){abrController.checkPlaybackQuality(type);}getNextFragment();}else {startScheduleTimer(500);}}function validateExecutedFragmentRequest(){ // Validate that the fragment request executed and appended into the source buffer is as
	// good of quality as the current quality and is the correct media track.
	var safeBufferLevel=currentRepresentationInfo.fragmentDuration * 1.5;var request=fragmentModel.getRequests({state:_modelsFragmentModel2['default'].FRAGMENT_MODEL_EXECUTED,time:playbackController.getTime() + safeBufferLevel,threshold:0})[0];if(request && replaceRequestArray.indexOf(request) === -1 && !dashManifestModel.getIsTextTrack(type)){var fastSwitchModeEnabled=mediaPlayerModel.getFastSwitchEnabled();var bufferLevel=streamProcessor.getBufferLevel();var abandonmentState=abrController.getAbandonmentStateFor(type);if(fastSwitchModeEnabled && request.quality < currentRepresentationInfo.quality && bufferLevel >= safeBufferLevel && abandonmentState !== _AbrController2['default'].ABANDON_LOAD){replaceRequest(request);log('Reloading outdated fragment at index: ',request.index);}else if(request.quality > currentRepresentationInfo.quality){ // The buffer has better quality it in then what we would request so set append point to end of buffer!!
	setSeekTarget(playbackController.getTime() + streamProcessor.getBufferLevel());}}}function startScheduleTimer(value){clearTimeout(scheduleTimeout);scheduleTimeout = setTimeout(schedule,value);}function onInitRequested(e){if(!e.sender || e.sender.getStreamProcessor() !== streamProcessor){return;}getInitRequest(currentRepresentationInfo.quality);}function setFragmentProcessState(state){if(isFragmentProcessingInProgress !== state){isFragmentProcessingInProgress = state;}else {log('[ScheduleController][',type,'] isFragmentProcessingInProgress is already equal to',state);}}function getInitRequest(quality){var request=adapter.getInitRequest(streamProcessor,quality);if(request){setFragmentProcessState(true);fragmentModel.executeRequest(request);}}function switchTrackAsked(){switchTrack = true;}function replaceRequest(request){replaceRequestArray.push(request);}function onQualityChanged(e){if(type !== e.mediaType || streamProcessor.getStreamInfo().id !== e.streamInfo.id){return;}currentRepresentationInfo = streamProcessor.getRepresentationInfoForQuality(e.newQuality);if(currentRepresentationInfo === null || currentRepresentationInfo === undefined){throw new Error('Unexpected error! - currentRepresentationInfo is null or undefined');}clearPlayListTraceMetrics(new Date(),_voMetricsPlayList.PlayListTrace.REPRESENTATION_SWITCH_STOP_REASON);addPlaylistTraceMetrics();}function completeQualityChange(trigger){if(playbackController && fragmentModel){var item=fragmentModel.getRequests({state:_modelsFragmentModel2['default'].FRAGMENT_MODEL_EXECUTED,time:playbackController.getTime(),threshold:0})[0];if(item && playbackController.getTime() >= item.startTime){if((!lastFragmentRequest.mediaInfo || item.mediaInfo.type === lastFragmentRequest.mediaInfo.type && item.mediaInfo.id !== lastFragmentRequest.mediaInfo.id) && trigger){eventBus.trigger(_coreEventsEvents2['default'].TRACK_CHANGE_RENDERED,{mediaType:type,oldMediaInfo:lastFragmentRequest.mediaInfo,newMediaInfo:item.mediaInfo});}if((item.quality !== lastFragmentRequest.quality || item.adaptationIndex !== lastFragmentRequest.adaptationIndex) && trigger){eventBus.trigger(_coreEventsEvents2['default'].QUALITY_CHANGE_RENDERED,{mediaType:type,oldQuality:lastFragmentRequest.quality,newQuality:item.quality});}lastFragmentRequest = {mediaInfo:item.mediaInfo,quality:item.quality,adaptationIndex:item.adaptationIndex};}}}function onDataUpdateCompleted(e){if(e.error || e.sender.getStreamProcessor() !== streamProcessor){return;}currentRepresentationInfo = adapter.convertDataToRepresentationInfo(e.currentRepresentation);}function onStreamInitialized(e){if(e.error || streamProcessor.getStreamInfo().id !== e.streamInfo.id){return;}currentRepresentationInfo = streamProcessor.getCurrentRepresentationInfo();if(initialRequest){if(playbackController.getIsDynamic()){timelineConverter.setTimeSyncCompleted(true);setLiveEdgeSeekTarget();}else {seekTarget = playbackController.getStreamStartTime(false);streamProcessor.getBufferController().setSeekStartTime(seekTarget);}}if(isStopped){start();}}function setLiveEdgeSeekTarget(){var liveEdgeFinder=streamProcessor.getLiveEdgeFinder();if(liveEdgeFinder){var liveEdge=liveEdgeFinder.getLiveEdge();var dvrWindowSize=currentRepresentationInfo.mediaInfo.streamInfo.manifestInfo.DVRWindowSize / 2;var startTime=liveEdge - playbackController.computeLiveDelay(currentRepresentationInfo.fragmentDuration,dvrWindowSize);var request=adapter.getFragmentRequestForTime(streamProcessor,currentRepresentationInfo,startTime,{ignoreIsFinished:true}); // When low latency mode is selected but browser doesn't support fetch
	// start at the beginning of the segment to avoid consuming the whole buffer
	if(mediaPlayerModel.getLowLatencyEnabled()){var liveStartTime=request.duration < mediaPlayerModel.getLiveDelay()?request.startTime:request.startTime + request.duration - mediaPlayerModel.getLiveDelay();playbackController.setLiveStartTime(liveStartTime);}else {playbackController.setLiveStartTime(request.startTime);}seekTarget = playbackController.getStreamStartTime(false,liveEdge); //special use case for multi period stream. If the startTime is out of the current period, send a seek command.
	//in onPlaybackSeeking callback (StreamController), the detection of switch stream is done.
	if(seekTarget > currentRepresentationInfo.mediaInfo.streamInfo.start + currentRepresentationInfo.mediaInfo.streamInfo.duration){playbackController.seek(seekTarget);}var manifestUpdateInfo=dashMetrics.getCurrentManifestUpdate(metricsModel.getMetricsFor(_constantsConstants2['default'].STREAM));metricsModel.updateManifestUpdateInfo(manifestUpdateInfo,{currentTime:seekTarget,presentationStartTime:liveEdge,latency:liveEdge - seekTarget,clientTimeOffset:timelineConverter.getClientTimeOffset()});}}function onStreamCompleted(e){if(e.fragmentModel !== fragmentModel){return;}stop();setFragmentProcessState(false);log('[ScheduleController] Stream is complete');}function onFragmentLoadingCompleted(e){if(e.sender !== fragmentModel){return;}log('[ScheduleController][',type,'] - onFragmentLoadingCompleted');if(dashManifestModel.getIsTextTrack(type)){setFragmentProcessState(false);}if(e.error && e.request.serviceLocation && !isStopped){replaceRequest(e.request);setFragmentProcessState(false);startScheduleTimer(0);}if(bufferResetInProgress){mediaRequest = e.request;}}function onPlaybackTimeUpdated(){completeQualityChange(true);}function onBytesAppended(e){if(e.sender.getStreamProcessor() !== streamProcessor){return;}if(bufferResetInProgress && !isNaN(e.startTime)){bufferResetInProgress = false;fragmentModel.addExecutedRequest(mediaRequest);}setFragmentProcessState(false);startScheduleTimer(0);}function onFragmentLoadingAbandoned(e){if(e.streamProcessor !== streamProcessor){return;}log('[ScheduleController][onFragmentLoadingAbandoned] for ' + type + ', request: ' + e.request.url + ' has been aborted');if(!playbackController.isSeeking() && !switchTrack){log('[ScheduleController][onFragmentLoadingAbandoned] for ' + type + ', request: ' + e.request.url + ' has to be downloaded again, origin is not seeking process or switch track call');replaceRequest(e.request);}setFragmentProcessState(false);startScheduleTimer(0);}function onDataUpdateStarted(e){if(e.sender.getStreamProcessor() !== streamProcessor){return;}stop();}function onBufferCleared(e){if(e.sender.getStreamProcessor() !== streamProcessor){return;}streamProcessor.getFragmentModel().syncExecutedRequestsWithBufferedRange(streamProcessor.getBufferController().getBuffer().getAllBufferRanges(),streamProcessor.getStreamInfo().duration);if(e.hasEnoughSpaceToAppend && isStopped){start();}}function onBufferLevelStateChanged(e){if(e.sender.getStreamProcessor() === streamProcessor && e.state === _BufferController2['default'].BUFFER_EMPTY && !playbackController.isSeeking()){log('[ScheduleController][',type,'] - Buffer is empty! Stalling!');clearPlayListTraceMetrics(new Date(),_voMetricsPlayList.PlayListTrace.REBUFFERING_REASON);}}function onQuotaExceeded(e){if(e.sender.getStreamProcessor() !== streamProcessor){return;}stop();setFragmentProcessState(false);}function onURLResolutionFailed(){fragmentModel.abortRequests();stop();}function onTimedTextRequested(e){if(e.sender.getStreamProcessor() !== streamProcessor){return;}getInitRequest(e.index);}function onPlaybackStarted(){if(isStopped || !scheduleWhilePaused){start();}}function onPlaybackSeeking(e){seekTarget = e.seekTime;setTimeToLoadDelay(0);if(isStopped){start();}var manifestUpdateInfo=dashMetrics.getCurrentManifestUpdate(metricsModel.getMetricsFor(_constantsConstants2['default'].STREAM));var latency=currentRepresentationInfo.DVRWindow && playbackController?currentRepresentationInfo.DVRWindow.end - playbackController.getTime():NaN;metricsModel.updateManifestUpdateInfo(manifestUpdateInfo,{latency:latency}); //if, during the seek command, the scheduleController is waiting : stop waiting, request chunk as soon as possible
	if(!isFragmentProcessingInProgress){startScheduleTimer(0);}else {log('[ScheduleController][onPlaybackSeeking] for ' + type + ', call fragmentModel.abortRequests in order to seek quicker');fragmentModel.abortRequests();}}function onPlaybackRateChanged(e){if(playListTraceMetrics){playListTraceMetrics.playbackspeed = e.playbackRate.toString();}}function getSeekTarget(){return seekTarget;}function setSeekTarget(value){seekTarget = value;}function setTimeToLoadDelay(value){timeToLoadDelay = value;}function getTimeToLoadDelay(){return timeToLoadDelay;}function getBufferTarget(){return bufferLevelRule.getBufferTarget(streamProcessor,type,streamController.isVideoTrackPresent());}function getType(){return type;}function setPlayList(playList){playListMetrics = playList;}function finalisePlayList(time,reason){clearPlayListTraceMetrics(time,reason);playListMetrics = null;}function clearPlayListTraceMetrics(endTime,stopreason){if(playListMetrics && playListTraceMetricsClosed === false){var startTime=playListTraceMetrics.start;var duration=endTime.getTime() - startTime.getTime();playListTraceMetrics.duration = duration;playListTraceMetrics.stopreason = stopreason;playListMetrics.trace.push(playListTraceMetrics);playListTraceMetricsClosed = true;}}function addPlaylistTraceMetrics(){if(playListMetrics && playListTraceMetricsClosed === true && currentRepresentationInfo){playListTraceMetricsClosed = false;playListTraceMetrics = new _voMetricsPlayList.PlayListTrace();playListTraceMetrics.representationid = currentRepresentationInfo.id;playListTraceMetrics.start = new Date();playListTraceMetrics.mstart = playbackController.getTime() * 1000;playListTraceMetrics.playbackspeed = playbackController.getPlaybackRate().toString();}}function resetInitialSettings(){isFragmentProcessingInProgress = false;timeToLoadDelay = 0;seekTarget = NaN;playListMetrics = null;playListTraceMetrics = null;playListTraceMetricsClosed = true;initialRequest = true;lastInitQuality = NaN;lastFragmentRequest = {mediaInfo:undefined,quality:NaN,adaptationIndex:NaN};topQualityIndex = {};replaceRequestArray = [];isStopped = true;switchTrack = false;bufferResetInProgress = false;mediaRequest = null;}function reset(){ //eventBus.off(Events.LIVE_EDGE_SEARCH_COMPLETED, onLiveEdgeSearchCompleted, this);
	eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_STARTED,onDataUpdateStarted,this);eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,onDataUpdateCompleted,this);eventBus.off(_coreEventsEvents2['default'].BUFFER_LEVEL_STATE_CHANGED,onBufferLevelStateChanged,this);eventBus.off(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED,onQualityChanged,this);eventBus.off(_coreEventsEvents2['default'].FRAGMENT_LOADING_COMPLETED,onFragmentLoadingCompleted,this);eventBus.off(_coreEventsEvents2['default'].STREAM_COMPLETED,onStreamCompleted,this);eventBus.off(_coreEventsEvents2['default'].STREAM_INITIALIZED,onStreamInitialized,this);eventBus.off(_coreEventsEvents2['default'].QUOTA_EXCEEDED,onQuotaExceeded,this);eventBus.off(_coreEventsEvents2['default'].BYTES_APPENDED_END_FRAGMENT,onBytesAppended,this);eventBus.off(_coreEventsEvents2['default'].BUFFER_CLEARED,onBufferCleared,this);eventBus.off(_coreEventsEvents2['default'].INIT_REQUESTED,onInitRequested,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_RATE_CHANGED,onPlaybackRateChanged,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_SEEKING,onPlaybackSeeking,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_STARTED,onPlaybackStarted,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED,onPlaybackTimeUpdated,this);eventBus.off(_coreEventsEvents2['default'].URL_RESOLUTION_FAILED,onURLResolutionFailed,this);eventBus.off(_coreEventsEvents2['default'].FRAGMENT_LOADING_ABANDONED,onFragmentLoadingAbandoned,this);if(dashManifestModel.getIsTextTrack(type)){eventBus.off(_coreEventsEvents2['default'].TIMED_TEXT_REQUESTED,onTimedTextRequested,this);}stop();completeQualityChange(false);resetInitialSettings();}instance = {initialize:initialize,getType:getType,getSeekTarget:getSeekTarget,setSeekTarget:setSeekTarget,setTimeToLoadDelay:setTimeToLoadDelay,getTimeToLoadDelay:getTimeToLoadDelay,replaceRequest:replaceRequest,switchTrackAsked:switchTrackAsked,isStarted:isStarted,start:start,stop:stop,reset:reset,setPlayList:setPlayList,getBufferTarget:getBufferTarget,finalisePlayList:finalisePlayList};setup();return instance;}ScheduleController.__dashjs_factory_name = 'ScheduleController';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ScheduleController);module.exports = exports['default'];
	//# sourceMappingURL=ScheduleController.js.map


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _constantsMetricsConstants=__webpack_require__(41);var _constantsMetricsConstants2=_interopRequireDefault(_constantsMetricsConstants);var _Stream=__webpack_require__(335);var _Stream2=_interopRequireDefault(_Stream);var _ManifestUpdater=__webpack_require__(332);var _ManifestUpdater2=_interopRequireDefault(_ManifestUpdater);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _modelsMediaPlayerModel=__webpack_require__(149);var _modelsMediaPlayerModel2=_interopRequireDefault(_modelsMediaPlayerModel);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _voMetricsPlayList=__webpack_require__(156);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _utilsInitCache=__webpack_require__(97);var _utilsInitCache2=_interopRequireDefault(_utilsInitCache);var _utilsURLUtils=__webpack_require__(30);var _utilsURLUtils2=_interopRequireDefault(_utilsURLUtils);var _MediaPlayerEvents=__webpack_require__(144);var _MediaPlayerEvents2=_interopRequireDefault(_MediaPlayerEvents);var _TimeSyncController=__webpack_require__(346);var _TimeSyncController2=_interopRequireDefault(_TimeSyncController);var _BaseURLController=__webpack_require__(338);var _BaseURLController2=_interopRequireDefault(_BaseURLController);var _MediaSourceController=__webpack_require__(342);var _MediaSourceController2=_interopRequireDefault(_MediaSourceController);function StreamController(){ // Check whether there is a gap every 40 wallClockUpdateEvent times
	var STALL_THRESHOLD_TO_CHECK_GAPS=40;var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,capabilities=undefined,manifestUpdater=undefined,manifestLoader=undefined,manifestModel=undefined,dashManifestModel=undefined,adapter=undefined,metricsModel=undefined,dashMetrics=undefined,mediaSourceController=undefined,timeSyncController=undefined,baseURLController=undefined,domStorage=undefined,abrController=undefined,mediaController=undefined,textController=undefined,initCache=undefined,urlUtils=undefined,errHandler=undefined,timelineConverter=undefined,streams=undefined,activeStream=undefined,protectionController=undefined,protectionData=undefined,autoPlay=undefined,isStreamSwitchingInProgress=undefined,hasMediaError=undefined,hasInitialisationError=undefined,mediaSource=undefined,videoModel=undefined,playbackController=undefined,mediaPlayerModel=undefined,isPaused=undefined,initialPlayback=undefined,playListMetrics=undefined,videoTrackDetected=undefined,audioTrackDetected=undefined,isStreamBufferingCompleted=undefined,playbackEndedTimerId=undefined,wallclockTicked=undefined,lastPlaybackTime=undefined;function setup(){timeSyncController = (0,_TimeSyncController2['default'])(context).getInstance();baseURLController = (0,_BaseURLController2['default'])(context).getInstance();mediaSourceController = (0,_MediaSourceController2['default'])(context).getInstance();initCache = (0,_utilsInitCache2['default'])(context).getInstance();urlUtils = (0,_utilsURLUtils2['default'])(context).getInstance();resetInitialSettings();}function initialize(autoPl,protData){checkSetConfigCall();autoPlay = autoPl;protectionData = protData;timelineConverter.initialize();manifestUpdater = (0,_ManifestUpdater2['default'])(context).create();manifestUpdater.setConfig({manifestModel:manifestModel,dashManifestModel:dashManifestModel,mediaPlayerModel:mediaPlayerModel,manifestLoader:manifestLoader});manifestUpdater.initialize();baseURLController.setConfig({dashManifestModel:dashManifestModel});eventBus.on(_coreEventsEvents2['default'].TIME_SYNCHRONIZATION_COMPLETED,onTimeSyncCompleted,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_SEEKING,onPlaybackSeeking,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED,onPlaybackTimeUpdated,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_ENDED,onEnded,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_ERROR,onPlaybackError,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_STARTED,onPlaybackStarted,this);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_PAUSED,onPlaybackPaused,this);eventBus.on(_coreEventsEvents2['default'].MANIFEST_UPDATED,onManifestUpdated,this);eventBus.on(_coreEventsEvents2['default'].STREAM_BUFFERING_COMPLETED,onStreamBufferingCompleted,this);eventBus.on(_coreEventsEvents2['default'].MANIFEST_VALIDITY_CHANGED,onManifestValidityChanged,this);eventBus.on(_coreEventsEvents2['default'].WALLCLOCK_TIME_UPDATED,onWallclockTimeUpdated,this);eventBus.on(_MediaPlayerEvents2['default'].METRIC_ADDED,onMetricAdded,this);} /*
	     * Called when current playback position is changed.
	     * Used to determine the time current stream is finished and we should switch to the next stream.
	     */function onPlaybackTimeUpdated() /*e*/{if(isVideoTrackPresent()){var playbackQuality=videoModel.getPlaybackQuality();if(playbackQuality){metricsModel.addDroppedFrames(_constantsConstants2['default'].VIDEO,playbackQuality);}}}function onWallclockTimeUpdated() /*e*/{if(!mediaPlayerModel.getJumpGaps() || !activeStream || activeStream.getProcessors().length === 0 || playbackController.isSeeking() || isPaused || isStreamSwitchingInProgress || hasMediaError || hasInitialisationError){return;}wallclockTicked++;if(wallclockTicked >= STALL_THRESHOLD_TO_CHECK_GAPS){var currentTime=playbackController.getTime();if(lastPlaybackTime === currentTime){jumpGap(currentTime);}else {lastPlaybackTime = currentTime;}wallclockTicked = 0;}}function jumpGap(time){var streamProcessors=activeStream.getProcessors();var smallGapLimit=mediaPlayerModel.getSmallGapLimit();var seekToPosition=undefined; // Find out what is the right time position to jump to taking
	// into account state of buffer
	for(var i=0;i < streamProcessors.length;i++) {var mediaBuffer=streamProcessors[i].getBuffer();var ranges=mediaBuffer.getAllBufferRanges();var nextRangeStartTime=undefined;if(!ranges || ranges.length <= 1)continue; // Get the range just after current time position
	for(var j=0;j < ranges.length;j++) {if(time < ranges.start(j)){nextRangeStartTime = ranges.start(j);break;}}if(nextRangeStartTime > 0){var gap=nextRangeStartTime - time;if(gap > 0 && gap <= smallGapLimit){if(seekToPosition === undefined || nextRangeStartTime > seekToPosition){seekToPosition = nextRangeStartTime;}}}}var timeToStreamEnd=playbackController.getTimeToStreamEnd();if(seekToPosition === undefined && !isNaN(timeToStreamEnd) && timeToStreamEnd < smallGapLimit){seekToPosition = time + timeToStreamEnd;} // If there is a safe position to jump to, do the seeking
	if(seekToPosition > 0){if(!isNaN(timeToStreamEnd) && seekToPosition >= time + timeToStreamEnd){log('Jumping media gap (discontinuity) at time ',time,'. Jumping to end of the stream');eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_ENDED);}else {log('Jumping media gap (discontinuity) at time ',time,'. Jumping to time position',seekToPosition);playbackController.seek(seekToPosition);}}}function onPlaybackSeeking(e){var seekingStream=getStreamForTime(e.seekTime); //if end period has been detected, stop timer and reset isStreamBufferingCompleted
	if(playbackEndedTimerId){stopEndPeriodTimer();isStreamBufferingCompleted = false;}if(seekingStream && seekingStream !== activeStream){flushPlaylistMetrics(_voMetricsPlayList.PlayListTrace.END_OF_PERIOD_STOP_REASON);switchStream(activeStream,seekingStream,e.seekTime);}else {flushPlaylistMetrics(_voMetricsPlayList.PlayListTrace.USER_REQUEST_STOP_REASON);}addPlaylistMetrics(_voMetricsPlayList.PlayList.SEEK_START_REASON);}function onPlaybackStarted() /*e*/{log('[StreamController][onPlaybackStarted]');if(initialPlayback){initialPlayback = false;addPlaylistMetrics(_voMetricsPlayList.PlayList.INITIAL_PLAYOUT_START_REASON);}else {if(isPaused){isPaused = false;addPlaylistMetrics(_voMetricsPlayList.PlayList.RESUME_FROM_PAUSE_START_REASON);toggleEndPeriodTimer();}}}function onPlaybackPaused(e){log('[StreamController][onPlaybackPaused]');if(!e.ended){isPaused = true;flushPlaylistMetrics(_voMetricsPlayList.PlayListTrace.USER_REQUEST_STOP_REASON);toggleEndPeriodTimer();}}function stopEndPeriodTimer(){log('[StreamController][toggleEndPeriodTimer] stop end period timer.');clearTimeout(playbackEndedTimerId);playbackEndedTimerId = undefined;}function toggleEndPeriodTimer(){ //stream buffering completed has not been detected, nothing to do....
	if(isStreamBufferingCompleted){ //stream buffering completed has been detected, if end period timer is running, stop it, otherwise start it....
	if(playbackEndedTimerId){stopEndPeriodTimer();}else {var timeToEnd=playbackController.getTimeToStreamEnd();var delayPlaybackEnded=timeToEnd > 0?timeToEnd * 1000:0;log('[StreamController][toggleEndPeriodTimer] start-up of timer to notify PLAYBACK_ENDED event. It will be triggered in ' + delayPlaybackEnded + ' milliseconds');playbackEndedTimerId = setTimeout(function(){eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_ENDED);},delayPlaybackEnded);}}}function onStreamBufferingCompleted(){var isLast=getActiveStreamInfo().isLast;if(mediaSource && isLast){log('[StreamController][onStreamBufferingCompleted] calls signalEndOfStream of mediaSourceController.');mediaSourceController.signalEndOfStream(mediaSource);}else if(mediaSource && playbackEndedTimerId === undefined){ //send PLAYBACK_ENDED in order to switch to a new period, wait until the end of playing
	log('[StreamController][onStreamBufferingCompleted] end of period detected');isStreamBufferingCompleted = true;if(isPaused === false){toggleEndPeriodTimer();}}}function getStreamForTime(time){var duration=0;var stream=null;var ln=streams.length;if(ln > 0){duration += streams[0].getStartTime();}for(var i=0;i < ln;i++) {stream = streams[i];duration = parseFloat((duration + stream.getDuration()).toFixed(5));if(time < duration){return stream;}}return null;} /**
	     * Returns a playhead time, in seconds, converted to be relative
	     * to the start of an identified stream/period or null if no such stream
	     * @param {number} time
	     * @param {string} id
	     * @returns {number|null}
	     */function getTimeRelativeToStreamId(time,id){var stream=null;var baseStart=0;var streamStart=0;var streamDur=null;var ln=streams.length;for(var i=0;i < ln;i++) {stream = streams[i];streamStart = stream.getStartTime();streamDur = stream.getDuration(); // use start time, if not undefined or NaN or similar
	if(Number.isFinite(streamStart)){baseStart = streamStart;}if(stream.getId() === id){return time - baseStart;}else { // use duration if not undefined or NaN or similar
	if(Number.isFinite(streamDur)){baseStart += streamDur;}}}return null;}function getActiveStreamProcessors(){return activeStream?activeStream.getProcessors():[];}function onEnded(){var nextStream=getNextStream();if(nextStream){audioTrackDetected = undefined;videoTrackDetected = undefined;switchStream(activeStream,nextStream,NaN);}else {log('StreamController no next stream found');}flushPlaylistMetrics(nextStream?_voMetricsPlayList.PlayListTrace.END_OF_PERIOD_STOP_REASON:_voMetricsPlayList.PlayListTrace.END_OF_CONTENT_STOP_REASON);playbackEndedTimerId = undefined;isStreamBufferingCompleted = false;}function getNextStream(){if(activeStream){var _ret=(function(){var start=activeStream.getStreamInfo().start;var duration=activeStream.getStreamInfo().duration;return {v:streams.filter(function(stream){return stream.getStreamInfo().start === parseFloat((start + duration).toFixed(5));})[0]};})();if(typeof _ret === 'object')return _ret.v;}}function switchStream(oldStream,newStream,seekTime){if(isStreamSwitchingInProgress || !newStream || oldStream === newStream)return;isStreamSwitchingInProgress = true;eventBus.trigger(_coreEventsEvents2['default'].PERIOD_SWITCH_STARTED,{fromStreamInfo:oldStream?oldStream.getStreamInfo():null,toStreamInfo:newStream.getStreamInfo()});if(oldStream){oldStream.stopEventController();oldStream.deactivate();}activeStream = newStream;playbackController.initialize(activeStream.getStreamInfo());if(videoModel.getElement()){ //TODO detect if we should close jump to activateStream.
	openMediaSource(seekTime,oldStream,false);}else {preloadStream(seekTime);}}function preloadStream(seekTime){activateStream(seekTime);}function switchToVideoElement(seekTime){playbackController.initialize(activeStream.getStreamInfo());openMediaSource(seekTime,null,true);}function openMediaSource(seekTime,oldStream,streamActivated){var sourceUrl=undefined;function onMediaSourceOpen(){log('MediaSource is open!');window.URL.revokeObjectURL(sourceUrl);mediaSource.removeEventListener('sourceopen',onMediaSourceOpen);mediaSource.removeEventListener('webkitsourceopen',onMediaSourceOpen);setMediaDuration();if(!oldStream){eventBus.trigger(_coreEventsEvents2['default'].SOURCE_INITIALIZED);}if(streamActivated){activeStream.setMediaSource(mediaSource);}else {activateStream(seekTime);}}if(!mediaSource){mediaSource = mediaSourceController.createMediaSource();}else {mediaSourceController.detachMediaSource(videoModel);}mediaSource.addEventListener('sourceopen',onMediaSourceOpen,false);mediaSource.addEventListener('webkitsourceopen',onMediaSourceOpen,false);sourceUrl = mediaSourceController.attachMediaSource(mediaSource,videoModel);log('MediaSource attached to element.  Waiting on open...');}function activateStream(seekTime){activeStream.activate(mediaSource);audioTrackDetected = checkTrackPresence(_constantsConstants2['default'].AUDIO);videoTrackDetected = checkTrackPresence(_constantsConstants2['default'].VIDEO);if(!initialPlayback){if(!isNaN(seekTime)){playbackController.seek(seekTime); //we only need to call seek here, IndexHandlerTime was set from seeking event
	}else {(function(){var startTime=playbackController.getStreamStartTime(true);activeStream.getProcessors().forEach(function(p){adapter.setIndexHandlerTime(p,startTime);});})();}}activeStream.startEventController();if(autoPlay || !initialPlayback){playbackController.play();}isStreamSwitchingInProgress = false;eventBus.trigger(_coreEventsEvents2['default'].PERIOD_SWITCH_COMPLETED,{toStreamInfo:activeStream.getStreamInfo()});}function setMediaDuration(){var manifestDuration=activeStream.getStreamInfo().manifestInfo.duration;var mediaDuration=mediaSourceController.setDuration(mediaSource,manifestDuration);log('Duration successfully set to: ' + mediaDuration);}function getComposedStream(streamInfo){for(var i=0,ln=streams.length;i < ln;i++) {if(streams[i].getId() === streamInfo.id){return streams[i];}}return null;}function composeStreams(){try{var streamsInfo=adapter.getStreamsInfo();if(streamsInfo.length === 0){throw new Error('There are no streams');}var manifestUpdateInfo=dashMetrics.getCurrentManifestUpdate(metricsModel.getMetricsFor(_constantsConstants2['default'].STREAM));metricsModel.updateManifestUpdateInfo(manifestUpdateInfo,{currentTime:playbackController.getTime(),buffered:videoModel.getBufferRange(),presentationStartTime:streamsInfo[0].start,clientTimeOffset:timelineConverter.getClientTimeOffset()});for(var i=0,ln=streamsInfo.length;i < ln;i++) { // If the Stream object does not exist we probably loaded the manifest the first time or it was
	// introduced in the updated manifest, so we need to create a new Stream and perform all the initialization operations
	var streamInfo=streamsInfo[i];var stream=getComposedStream(streamInfo);if(!stream){stream = (0,_Stream2['default'])(context).create({manifestModel:manifestModel,dashManifestModel:dashManifestModel,mediaPlayerModel:mediaPlayerModel,metricsModel:metricsModel,dashMetrics:dashMetrics,manifestUpdater:manifestUpdater,adapter:adapter,timelineConverter:timelineConverter,capabilities:capabilities,errHandler:errHandler,baseURLController:baseURLController,domStorage:domStorage,abrController:abrController,playbackController:playbackController,mediaController:mediaController,textController:textController,videoModel:videoModel,streamController:instance});streams.push(stream);stream.initialize(streamInfo,protectionController);}else {stream.updateData(streamInfo);}metricsModel.addManifestUpdateStreamInfo(manifestUpdateInfo,streamInfo.id,streamInfo.index,streamInfo.start,streamInfo.duration);}if(!activeStream){ // we need to figure out what the correct starting period is
	var startTimeFormUriParameters=playbackController.getStartTimeFromUriParameters();var initialStream=null;if(startTimeFormUriParameters){var initialTime=!isNaN(startTimeFormUriParameters.fragS)?startTimeFormUriParameters.fragS:startTimeFormUriParameters.fragT;initialStream = getStreamForTime(initialTime);}switchStream(null,initialStream !== null?initialStream:streams[0],NaN);}eventBus.trigger(_coreEventsEvents2['default'].STREAMS_COMPOSED);}catch(e) {errHandler.manifestError(e.message,'nostreamscomposed',manifestModel.getValue());hasInitialisationError = true;reset();}}function onTimeSyncCompleted() /*e*/{var manifest=manifestModel.getValue(); //TODO check if we can move this to initialize??
	if(protectionController){eventBus.trigger(_coreEventsEvents2['default'].PROTECTION_CREATED,{controller:protectionController,manifest:manifest});protectionController.setMediaElement(videoModel.getElement());if(protectionData){protectionController.setProtectionData(protectionData);}}composeStreams();}function onManifestUpdated(e){if(!e.error){(function(){ //Since streams are not composed yet , need to manually look up useCalculatedLiveEdgeTime to detect if stream
	//is SegmentTimeline to avoid using time source
	var manifest=e.manifest;adapter.updatePeriods(manifest);var streamInfo=adapter.getStreamsInfo(undefined,1)[0];var mediaInfo=adapter.getMediaInfoForType(streamInfo,_constantsConstants2['default'].VIDEO) || adapter.getMediaInfoForType(streamInfo,_constantsConstants2['default'].AUDIO);var useCalculatedLiveEdgeTime=undefined;if(mediaInfo){useCalculatedLiveEdgeTime = dashManifestModel.getUseCalculatedLiveEdgeTimeForAdaptation(adapter.getDataForMedia(mediaInfo));if(useCalculatedLiveEdgeTime){log('SegmentTimeline detected using calculated Live Edge Time');mediaPlayerModel.setUseManifestDateHeaderTimeSource(false);}}var manifestUTCTimingSources=dashManifestModel.getUTCTimingSources(e.manifest);var allUTCTimingSources=!dashManifestModel.getIsDynamic(manifest) || useCalculatedLiveEdgeTime?manifestUTCTimingSources:manifestUTCTimingSources.concat(mediaPlayerModel.getUTCTimingSources());var isHTTPS=urlUtils.isHTTPS(e.manifest.url); //If https is detected on manifest then lets apply that protocol to only the default time source(s). In the future we may find the need to apply this to more then just default so left code at this level instead of in MediaPlayer.
	allUTCTimingSources.forEach(function(item){if(item.value.replace(/.*?:\/\//g,'') === _modelsMediaPlayerModel2['default'].DEFAULT_UTC_TIMING_SOURCE.value.replace(/.*?:\/\//g,'')){item.value = item.value.replace(isHTTPS?new RegExp(/^(http:)?\/\//i):new RegExp(/^(https:)?\/\//i),isHTTPS?'https://':'http://');log('Matching default timing source protocol to manifest protocol: ',item.value);}});baseURLController.initialize(manifest);timeSyncController.setConfig({metricsModel:metricsModel,dashMetrics:dashMetrics,baseURLController:baseURLController});timeSyncController.initialize(allUTCTimingSources,mediaPlayerModel.getUseManifestDateHeaderTimeSource());})();}else {hasInitialisationError = true;reset();}}function isAudioTrackPresent(){return audioTrackDetected;}function isVideoTrackPresent(){return videoTrackDetected;}function checkTrackPresence(type){var isDetected=false;if(activeStream){activeStream.getProcessors().forEach(function(p){if(p.getMediaInfo().type === type){isDetected = true;}});}return isDetected;}function flushPlaylistMetrics(reason,time){time = time || new Date();if(playListMetrics){if(activeStream){activeStream.getProcessors().forEach(function(p){var ctrlr=p.getScheduleController();if(ctrlr){ctrlr.finalisePlayList(time,reason);}});}metricsModel.addPlayList(playListMetrics);playListMetrics = null;}}function addPlaylistMetrics(startReason){playListMetrics = new _voMetricsPlayList.PlayList();playListMetrics.start = new Date();playListMetrics.mstart = playbackController.getTime() * 1000;playListMetrics.starttype = startReason;if(activeStream){activeStream.getProcessors().forEach(function(p){var ctrlr=p.getScheduleController();if(ctrlr){ctrlr.setPlayList(playListMetrics);}});}}function onPlaybackError(e){if(!e.error)return;var msg='';switch(e.error.code){case 1:msg = 'MEDIA_ERR_ABORTED';break;case 2:msg = 'MEDIA_ERR_NETWORK';break;case 3:msg = 'MEDIA_ERR_DECODE';break;case 4:msg = 'MEDIA_ERR_SRC_NOT_SUPPORTED';break;case 5:msg = 'MEDIA_ERR_ENCRYPTED';break;default:msg = 'UNKNOWN';break;}hasMediaError = true;if(e.error.message){msg += ' (' + e.error.message + ')';}if(e.error.msExtendedCode){msg += ' (0x' + (e.error.msExtendedCode >>> 0).toString(16).toUpperCase() + ')';}log('Video Element Error: ' + msg);if(e.error){log(e.error);}errHandler.mediaSourceError(msg);reset();}function getActiveStreamInfo(){return activeStream?activeStream.getStreamInfo():null;}function getStreamById(id){return streams.filter(function(item){return item.getId() === id;})[0];}function checkSetConfigCall(){if(!manifestLoader || !manifestLoader.hasOwnProperty('load') || !timelineConverter || !timelineConverter.hasOwnProperty('initialize') || !timelineConverter.hasOwnProperty('reset') || !timelineConverter.hasOwnProperty('getClientTimeOffset')){throw new Error('setConfig function has to be called previously');}}function checkInitializeCall(){if(!manifestUpdater || !manifestUpdater.hasOwnProperty('setManifest')){throw new Error('initialize function has to be called previously');}}function load(url){checkSetConfigCall();manifestLoader.load(url);}function loadWithManifest(manifest){checkInitializeCall();manifestUpdater.setManifest(manifest);}function onManifestValidityChanged(e){if(!isNaN(e.newDuration)){setMediaDuration(e.newDuration);}}function setConfig(config){if(!config)return;if(config.capabilities){capabilities = config.capabilities;}if(config.manifestLoader){manifestLoader = config.manifestLoader;}if(config.manifestModel){manifestModel = config.manifestModel;}if(config.dashManifestModel){dashManifestModel = config.dashManifestModel;}if(config.mediaPlayerModel){mediaPlayerModel = config.mediaPlayerModel;}if(config.protectionController){protectionController = config.protectionController;}if(config.adapter){adapter = config.adapter;}if(config.metricsModel){metricsModel = config.metricsModel;}if(config.dashMetrics){dashMetrics = config.dashMetrics;}if(config.errHandler){errHandler = config.errHandler;}if(config.timelineConverter){timelineConverter = config.timelineConverter;}if(config.videoModel){videoModel = config.videoModel;}if(config.playbackController){playbackController = config.playbackController;}if(config.domStorage){domStorage = config.domStorage;}if(config.abrController){abrController = config.abrController;}if(config.mediaController){mediaController = config.mediaController;}if(config.textController){textController = config.textController;}}function setProtectionData(protData){protectionData = protData;}function resetInitialSettings(){streams = [];protectionController = null;isStreamSwitchingInProgress = false;activeStream = null;hasMediaError = false;hasInitialisationError = false;videoTrackDetected = undefined;audioTrackDetected = undefined;initialPlayback = true;isPaused = false;autoPlay = true;playListMetrics = null;playbackEndedTimerId = undefined;isStreamBufferingCompleted = false;wallclockTicked = 0;}function reset(){checkSetConfigCall();timeSyncController.reset();flushPlaylistMetrics(hasMediaError || hasInitialisationError?_voMetricsPlayList.PlayListTrace.FAILURE_STOP_REASON:_voMetricsPlayList.PlayListTrace.USER_REQUEST_STOP_REASON);for(var i=0,ln=streams?streams.length:0;i < ln;i++) {var stream=streams[i];stream.reset(hasMediaError);}eventBus.off(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED,onPlaybackTimeUpdated,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_SEEKING,onPlaybackSeeking,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_ERROR,onPlaybackError,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_STARTED,onPlaybackStarted,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_PAUSED,onPlaybackPaused,this);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_ENDED,onEnded,this);eventBus.off(_coreEventsEvents2['default'].MANIFEST_UPDATED,onManifestUpdated,this);eventBus.off(_coreEventsEvents2['default'].STREAM_BUFFERING_COMPLETED,onStreamBufferingCompleted,this);eventBus.off(_MediaPlayerEvents2['default'].METRIC_ADDED,onMetricAdded,this);eventBus.off(_coreEventsEvents2['default'].MANIFEST_VALIDITY_CHANGED,onManifestValidityChanged,this);baseURLController.reset();manifestUpdater.reset();metricsModel.clearAllCurrentMetrics();manifestModel.setValue(null);manifestLoader.reset();timelineConverter.reset();initCache.reset();if(mediaSource){mediaSourceController.detachMediaSource(videoModel);mediaSource = null;}videoModel = null;if(protectionController){protectionController.setMediaElement(null);protectionController = null;protectionData = null;if(manifestModel.getValue()){eventBus.trigger(_coreEventsEvents2['default'].PROTECTION_DESTROYED,{data:manifestModel.getValue().url});}}eventBus.trigger(_coreEventsEvents2['default'].STREAM_TEARDOWN_COMPLETE);resetInitialSettings();}function onMetricAdded(e){if(e.metric === _constantsMetricsConstants2['default'].DVR_INFO){ //Match media type? How can DVR window be different for media types?
	//Should we normalize and union the two?
	if(e.mediaType === _constantsConstants2['default'].AUDIO){mediaSourceController.setSeekable(mediaSource,e.value.range.start,e.value.range.end);}}}instance = {initialize:initialize,getActiveStreamInfo:getActiveStreamInfo,isVideoTrackPresent:isVideoTrackPresent,isAudioTrackPresent:isAudioTrackPresent,switchToVideoElement:switchToVideoElement,getStreamById:getStreamById,getStreamForTime:getStreamForTime,getTimeRelativeToStreamId:getTimeRelativeToStreamId,load:load,loadWithManifest:loadWithManifest,getActiveStreamProcessors:getActiveStreamProcessors,setConfig:setConfig,setProtectionData:setProtectionData,reset:reset};setup();return instance;}StreamController.__dashjs_factory_name = 'StreamController';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(StreamController);module.exports = exports['default'];
	//# sourceMappingURL=StreamController.js.map


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _voDashJSError=__webpack_require__(31);var _voDashJSError2=_interopRequireDefault(_voDashJSError);var _voMetricsHTTPRequest=__webpack_require__(16);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _utilsURLUtils=__webpack_require__(30);var _utilsURLUtils2=_interopRequireDefault(_utilsURLUtils);var TIME_SYNC_FAILED_ERROR_CODE=1;var HTTP_TIMEOUT_MS=5000;function TimeSyncController(){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var urlUtils=(0,_utilsURLUtils2['default'])(context).getInstance();var instance=undefined,offsetToDeviceTimeMs=undefined,isSynchronizing=undefined,isInitialised=undefined,useManifestDateHeaderTimeSource=undefined,handlers=undefined,metricsModel=undefined,dashMetrics=undefined,baseURLController=undefined;function initialize(timingSources,useManifestDateHeader){useManifestDateHeaderTimeSource = useManifestDateHeader;offsetToDeviceTimeMs = 0;isSynchronizing = false;isInitialised = false; // a list of known schemeIdUris and a method to call with @value
	handlers = {'urn:mpeg:dash:utc:http-head:2014':httpHeadHandler,'urn:mpeg:dash:utc:http-xsdate:2014':httpHandler.bind(null,xsdatetimeDecoder),'urn:mpeg:dash:utc:http-iso:2014':httpHandler.bind(null,iso8601Decoder),'urn:mpeg:dash:utc:direct:2014':directHandler, // some specs referencing early ISO23009-1 drafts incorrectly use
	// 2012 in the URI, rather than 2014. support these for now.
	'urn:mpeg:dash:utc:http-head:2012':httpHeadHandler,'urn:mpeg:dash:utc:http-xsdate:2012':httpHandler.bind(null,xsdatetimeDecoder),'urn:mpeg:dash:utc:http-iso:2012':httpHandler.bind(null,iso8601Decoder),'urn:mpeg:dash:utc:direct:2012':directHandler, // it isn't clear how the data returned would be formatted, and
	// no public examples available so http-ntp not supported for now.
	// presumably you would do an arraybuffer type xhr and decode the
	// binary data returned but I would want to see a sample first.
	'urn:mpeg:dash:utc:http-ntp:2014':notSupportedHandler, // not clear how this would be supported in javascript (in browser)
	'urn:mpeg:dash:utc:ntp:2014':notSupportedHandler,'urn:mpeg:dash:utc:sntp:2014':notSupportedHandler};if(!getIsSynchronizing()){attemptSync(timingSources);setIsInitialised(true);}}function setConfig(config){if(!config)return;if(config.metricsModel){metricsModel = config.metricsModel;}if(config.dashMetrics){dashMetrics = config.dashMetrics;}if(config.baseURLController){baseURLController = config.baseURLController;}}function getOffsetToDeviceTimeMs(){return getOffsetMs();}function setIsSynchronizing(value){isSynchronizing = value;}function getIsSynchronizing(){return isSynchronizing;}function setIsInitialised(value){isInitialised = value;}function setOffsetMs(value){offsetToDeviceTimeMs = value;}function getOffsetMs(){return offsetToDeviceTimeMs;} // takes xsdatetime and returns milliseconds since UNIX epoch
	// may not be necessary as xsdatetime is very similar to ISO 8601
	// which is natively understood by javascript Date parser
	function alternateXsdatetimeDecoder(xsdatetimeStr){ // taken from DashParser - should probably refactor both uses
	var SECONDS_IN_MIN=60;var MINUTES_IN_HOUR=60;var MILLISECONDS_IN_SECONDS=1000;var datetimeRegex=/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+\-])([0-9]{2})([0-9]{2}))?/;var utcDate=undefined,timezoneOffset=undefined;var match=datetimeRegex.exec(xsdatetimeStr); // If the string does not contain a timezone offset different browsers can interpret it either
	// as UTC or as a local time so we have to parse the string manually to normalize the given date value for
	// all browsers
	utcDate = Date.UTC(parseInt(match[1],10),parseInt(match[2],10) - 1, // months start from zero
	parseInt(match[3],10),parseInt(match[4],10),parseInt(match[5],10),match[6] && (parseInt(match[6],10) || 0),match[7] && parseFloat(match[7]) * MILLISECONDS_IN_SECONDS || 0); // If the date has timezone offset take it into account as well
	if(match[9] && match[10]){timezoneOffset = parseInt(match[9],10) * MINUTES_IN_HOUR + parseInt(match[10],10);utcDate += (match[8] === '+'?-1:+1) * timezoneOffset * SECONDS_IN_MIN * MILLISECONDS_IN_SECONDS;}return new Date(utcDate).getTime();} // try to use the built in parser, since xsdate is a constrained ISO8601
	// which is supported natively by Date.parse. if that fails, try a
	// regex-based version used elsewhere in this application.
	function xsdatetimeDecoder(xsdatetimeStr){var parsedDate=Date.parse(xsdatetimeStr);if(isNaN(parsedDate)){parsedDate = alternateXsdatetimeDecoder(xsdatetimeStr);}return parsedDate;} // takes ISO 8601 timestamp and returns milliseconds since UNIX epoch
	function iso8601Decoder(isoStr){return Date.parse(isoStr);} // takes RFC 1123 timestamp (which is same as ISO8601) and returns
	// milliseconds since UNIX epoch
	function rfc1123Decoder(dateStr){return Date.parse(dateStr);}function notSupportedHandler(url,onSuccessCB,onFailureCB){onFailureCB();}function directHandler(xsdatetimeStr,onSuccessCB,onFailureCB){var time=xsdatetimeDecoder(xsdatetimeStr);if(!isNaN(time)){onSuccessCB(time);return;}onFailureCB();}function httpHandler(decoder,url,onSuccessCB,onFailureCB,isHeadRequest){var oncomplete=undefined,onload=undefined;var complete=false;var req=new XMLHttpRequest();var verb=isHeadRequest?_voMetricsHTTPRequest.HTTPRequest.HEAD:_voMetricsHTTPRequest.HTTPRequest.GET;var urls=url.match(/\S+/g); // according to ISO 23009-1, url could be a white-space
	// separated list of URLs. just handle one at a time.
	url = urls.shift();oncomplete = function(){if(complete){return;} // we only want to pass through here once per xhr,
	// regardless of whether the load was successful.
	complete = true; // if there are more urls to try, call self.
	if(urls.length){httpHandler(decoder,urls.join(' '),onSuccessCB,onFailureCB,isHeadRequest);}else {onFailureCB();}};onload = function(){var time=undefined,result=undefined;if(req.status === 200){time = isHeadRequest?req.getResponseHeader('Date'):req.response;result = decoder(time); // decoder returns NaN if non-standard input
	if(!isNaN(result)){onSuccessCB(result);complete = true;}}};if(urlUtils.isRelative(url)){ // passing no path to resolve will return just MPD BaseURL/baseUri
	var baseUrl=baseURLController.resolve();if(baseUrl){url = urlUtils.resolve(url,baseUrl.url);}}req.open(verb,url);req.timeout = HTTP_TIMEOUT_MS || 0;req.onload = onload;req.onloadend = oncomplete;req.send();}function httpHeadHandler(url,onSuccessCB,onFailureCB){httpHandler(rfc1123Decoder,url,onSuccessCB,onFailureCB,true);}function checkForDateHeader(){var metrics=metricsModel.getReadOnlyMetricsFor(_constantsConstants2['default'].STREAM);var dateHeaderValue=dashMetrics.getLatestMPDRequestHeaderValueByID(metrics,'Date');var dateHeaderTime=dateHeaderValue !== null?new Date(dateHeaderValue).getTime():Number.NaN;if(!isNaN(dateHeaderTime)){setOffsetMs(dateHeaderTime - new Date().getTime());completeTimeSyncSequence(false,dateHeaderTime / 1000,offsetToDeviceTimeMs);}else {completeTimeSyncSequence(true);}}function completeTimeSyncSequence(failed,time,offset){setIsSynchronizing(false);eventBus.trigger(_coreEventsEvents2['default'].TIME_SYNCHRONIZATION_COMPLETED,{time:time,offset:offset,error:failed?new _voDashJSError2['default'](TIME_SYNC_FAILED_ERROR_CODE):null});}function attemptSync(sources,sourceIndex){ // if called with no sourceIndex, use zero (highest priority)
	var index=sourceIndex || 0; // the sources should be ordered in priority from the manifest.
	// try each in turn, from the top, until either something
	// sensible happens, or we run out of sources to try.
	var source=sources[index]; // callback to emit event to listeners
	var onComplete=function onComplete(time,offset){var failed=!time || !offset;if(failed && useManifestDateHeaderTimeSource){ //Before falling back to binary search , check if date header exists on MPD. if so, use for a time source.
	checkForDateHeader();}else {completeTimeSyncSequence(failed,time,offset);}};setIsSynchronizing(true);if(source){ // check if there is a handler for this @schemeIdUri
	if(handlers.hasOwnProperty(source.schemeIdUri)){ // if so, call it with its @value
	handlers[source.schemeIdUri](source.value,function(serverTime){ // the timing source returned something useful
	var deviceTime=new Date().getTime();var offset=serverTime - deviceTime;setOffsetMs(offset);log('Local time:      ' + new Date(deviceTime));log('Server time:     ' + new Date(serverTime));log('Difference (ms): ' + offset);onComplete(serverTime,offset);},function(){ // the timing source was probably uncontactable
	// or returned something we can't use - try again
	// with the remaining sources
	attemptSync(sources,index + 1);});}else { // an unknown schemeIdUri must have been found
	// try again with the remaining sources
	attemptSync(sources,index + 1);}}else { // no valid time source could be found, just use device time
	setOffsetMs(0);onComplete();}}function reset(){setIsInitialised(false);setIsSynchronizing(false);}instance = {initialize:initialize,getOffsetToDeviceTimeMs:getOffsetToDeviceTimeMs,setConfig:setConfig,reset:reset};return instance;}TimeSyncController.__dashjs_factory_name = 'TimeSyncController';var factory=_coreFactoryMaker2['default'].getSingletonFactory(TimeSyncController);factory.TIME_SYNC_FAILED_ERROR_CODE = TIME_SYNC_FAILED_ERROR_CODE;factory.HTTP_TIMEOUT_MS = HTTP_TIMEOUT_MS;_coreFactoryMaker2['default'].updateSingletonFactory(TimeSyncController.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=TimeSyncController.js.map


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _XlinkLoader=__webpack_require__(337);var _XlinkLoader2=_interopRequireDefault(_XlinkLoader);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _externalsXml2json=__webpack_require__(137);var _externalsXml2json2=_interopRequireDefault(_externalsXml2json);var _utilsURLUtils=__webpack_require__(30);var _utilsURLUtils2=_interopRequireDefault(_utilsURLUtils);var RESOLVE_TYPE_ONLOAD='onLoad';var RESOLVE_TYPE_ONACTUATE='onActuate';var ELEMENT_TYPE_PERIOD='Period';var ELEMENT_TYPE_ADAPTATIONSET='AdaptationSet';var ELEMENT_TYPE_EVENTSTREAM='EventStream';var RESOLVE_TO_ZERO='urn:mpeg:dash:resolve-to-zero:2013';function XlinkController(config){config = config || {};var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var urlUtils=(0,_utilsURLUtils2['default'])(context).getInstance();var instance=undefined,matchers=undefined,iron=undefined,manifest=undefined,converter=undefined,xlinkLoader=undefined;function setup(){eventBus.on(_coreEventsEvents2['default'].XLINK_ELEMENT_LOADED,onXlinkElementLoaded,instance);xlinkLoader = (0,_XlinkLoader2['default'])(context).create({errHandler:config.errHandler,metricsModel:config.metricsModel,mediaPlayerModel:config.mediaPlayerModel,requestModifier:config.requestModifier});}function setMatchers(value){if(value){matchers = value;}}function setIron(value){if(value){iron = value;}} /**
	     * <p>Triggers the resolution of the xlink.onLoad attributes in the manifest file </p>
	     * @param {Object} mpd - the manifest
	     */function resolveManifestOnLoad(mpd){var elements=undefined; // First resolve all periods, so unnecessary requests inside onLoad Periods with Default content are avoided
	converter = new _externalsXml2json2['default']({escapeMode:false,attributePrefix:'',arrayAccessForm:'property',emptyNodeForm:'object',stripWhitespaces:false,enableToStringFunc:false,ignoreRoot:true,matchers:matchers});manifest = mpd;elements = getElementsToResolve(manifest.Period_asArray,manifest,ELEMENT_TYPE_PERIOD,RESOLVE_TYPE_ONLOAD);resolve(elements,ELEMENT_TYPE_PERIOD,RESOLVE_TYPE_ONLOAD);}function reset(){eventBus.off(_coreEventsEvents2['default'].XLINK_ELEMENT_LOADED,onXlinkElementLoaded,instance);if(xlinkLoader){xlinkLoader.reset();xlinkLoader = null;}}function resolve(elements,type,resolveType){var resolveObject={};var element=undefined,url=undefined;resolveObject.elements = elements;resolveObject.type = type;resolveObject.resolveType = resolveType; // If nothing to resolve, directly call allElementsLoaded
	if(resolveObject.elements.length === 0){onXlinkAllElementsLoaded(resolveObject);}for(var i=0;i < resolveObject.elements.length;i++) {element = resolveObject.elements[i];if(urlUtils.isHTTPURL(element.url)){url = element.url;}else {url = element.originalContent.BaseURL + element.url;}xlinkLoader.load(url,element,resolveObject);}}function onXlinkElementLoaded(event){var element=undefined,resolveObject=undefined;var openingTag='<response>';var closingTag='</response>';var mergedContent='';element = event.element;resolveObject = event.resolveObject; // if the element resolved into content parse the content
	if(element.resolvedContent){var index=0; // we add a parent elements so the converter is able to parse multiple elements of the same type which are not wrapped inside a container
	if(element.resolvedContent.indexOf('<?xml') === 0){index = element.resolvedContent.indexOf('?>') + 2; //find the closing position of the xml declaration, if it exists.
	}mergedContent = element.resolvedContent.substr(0,index) + openingTag + element.resolvedContent.substr(index) + closingTag;element.resolvedContent = converter.xml_str2json(mergedContent);}if(isResolvingFinished(resolveObject)){onXlinkAllElementsLoaded(resolveObject);}} // We got to wait till all elements of the current queue are resolved before merging back
	function onXlinkAllElementsLoaded(resolveObject){var elements=[];var i=undefined,obj=undefined;mergeElementsBack(resolveObject);if(resolveObject.resolveType === RESOLVE_TYPE_ONACTUATE){eventBus.trigger(_coreEventsEvents2['default'].XLINK_READY,{manifest:manifest});}if(resolveObject.resolveType === RESOLVE_TYPE_ONLOAD){switch(resolveObject.type){ // Start resolving the other elements. We can do Adaptation Set and EventStream in parallel
	case ELEMENT_TYPE_PERIOD:for(i = 0;i < manifest[ELEMENT_TYPE_PERIOD + '_asArray'].length;i++) {obj = manifest[ELEMENT_TYPE_PERIOD + '_asArray'][i];if(obj.hasOwnProperty(ELEMENT_TYPE_ADAPTATIONSET + '_asArray')){elements = elements.concat(getElementsToResolve(obj[ELEMENT_TYPE_ADAPTATIONSET + '_asArray'],obj,ELEMENT_TYPE_ADAPTATIONSET,RESOLVE_TYPE_ONLOAD));}if(obj.hasOwnProperty(ELEMENT_TYPE_EVENTSTREAM + '_asArray')){elements = elements.concat(getElementsToResolve(obj[ELEMENT_TYPE_EVENTSTREAM + '_asArray'],obj,ELEMENT_TYPE_EVENTSTREAM,RESOLVE_TYPE_ONLOAD));}}resolve(elements,ELEMENT_TYPE_ADAPTATIONSET,RESOLVE_TYPE_ONLOAD);break;case ELEMENT_TYPE_ADAPTATIONSET: // TODO: Resolve SegmentList here
	eventBus.trigger(_coreEventsEvents2['default'].XLINK_READY,{manifest:manifest});break;}}} // Returns the elements with the specific resolve Type
	function getElementsToResolve(elements,parentElement,type,resolveType){var toResolve=[];var element=undefined,i=undefined,xlinkObject=undefined; // first remove all the resolve-to-zero elements
	for(i = elements.length - 1;i >= 0;i--) {element = elements[i];if(element.hasOwnProperty('xlink:href') && element['xlink:href'] === RESOLVE_TO_ZERO){elements.splice(i,1);}} // now get the elements with the right resolve type
	for(i = 0;i < elements.length;i++) {element = elements[i];if(element.hasOwnProperty('xlink:href') && element.hasOwnProperty('xlink:actuate') && element['xlink:actuate'] === resolveType){xlinkObject = createXlinkObject(element['xlink:href'],parentElement,type,i,resolveType,element);toResolve.push(xlinkObject);}}return toResolve;}function mergeElementsBack(resolveObject){var resolvedElements=[];var element=undefined,type=undefined,obj=undefined,i=undefined,j=undefined,k=undefined; // Start merging back from the end because of index shifting. Note that the elements with the same parent have to be ordered by index ascending
	for(i = resolveObject.elements.length - 1;i >= 0;i--) {element = resolveObject.elements[i];type = element.type + '_asArray'; // Element couldn't be resolved or is TODO Inappropriate target: Remove all Xlink attributes
	if(!element.resolvedContent || isInappropriateTarget()){delete element.originalContent['xlink:actuate'];delete element.originalContent['xlink:href'];resolvedElements.push(element.originalContent);} // Element was successfully resolved
	else if(element.resolvedContent){for(j = 0;j < element.resolvedContent[type].length;j++) { //TODO Contains another Xlink attribute with xlink:actuate set to onload. Remove all xLink attributes
	obj = element.resolvedContent[type][j];resolvedElements.push(obj);}} // Replace the old elements in the parent with the resolved ones
	element.parentElement[type].splice(element.index,1);for(k = 0;k < resolvedElements.length;k++) {element.parentElement[type].splice(element.index + k,0,resolvedElements[k]);}resolvedElements = [];}if(resolveObject.elements.length > 0){iron.run(manifest);}}function createXlinkObject(url,parentElement,type,index,resolveType,originalContent){return {url:url,parentElement:parentElement,type:type,index:index,resolveType:resolveType,originalContent:originalContent,resolvedContent:null,resolved:false};} // Check if all pending requests are finished
	function isResolvingFinished(elementsToResolve){var i=undefined,obj=undefined;for(i = 0;i < elementsToResolve.elements.length;i++) {obj = elementsToResolve.elements[i];if(obj.resolved === false){return false;}}return true;} // TODO : Do some syntax check here if the target is valid or not
	function isInappropriateTarget(){return false;}instance = {resolveManifestOnLoad:resolveManifestOnLoad,setMatchers:setMatchers,setIron:setIron,reset:reset};setup();return instance;}XlinkController.__dashjs_factory_name = 'XlinkController';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(XlinkController);module.exports = exports['default'];
	//# sourceMappingURL=XlinkController.js.map


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _utilsDVBErrorsTranslator=__webpack_require__(359);var _utilsDVBErrorsTranslator2=_interopRequireDefault(_utilsDVBErrorsTranslator);var _MetricsReportingEvents=__webpack_require__(65);var _MetricsReportingEvents2=_interopRequireDefault(_MetricsReportingEvents);var _controllersMetricsCollectionController=__webpack_require__(349);var _controllersMetricsCollectionController2=_interopRequireDefault(_controllersMetricsCollectionController);var _metricsMetricsHandlerFactory=__webpack_require__(146);var _metricsMetricsHandlerFactory2=_interopRequireDefault(_metricsMetricsHandlerFactory);var _reportingReportingFactory=__webpack_require__(147);var _reportingReportingFactory2=_interopRequireDefault(_reportingReportingFactory);function MetricsReporting(){var context=this.context;var instance=undefined;var dvbErrorsTranslator=undefined; /**
	     * Create a MetricsCollectionController, and a DVBErrorsTranslator
	     * @param {Object} config - dependancies from owner
	     * @return {MetricsCollectionController} Metrics Collection Controller
	     */function createMetricsReporting(config){dvbErrorsTranslator = (0,_utilsDVBErrorsTranslator2['default'])(context).getInstance({eventBus:config.eventBus,metricsModel:config.metricsModel,metricsConstants:config.metricsConstants,events:config.events});return (0,_controllersMetricsCollectionController2['default'])(context).create(config);} /**
	     * Get the ReportingFactory to allow new reporters to be registered
	     * @return {ReportingFactory} Reporting Factory
	     */function getReportingFactory(){return (0,_reportingReportingFactory2['default'])(context).getInstance();} /**
	     * Get the MetricsHandlerFactory to allow new handlers to be registered
	     * @return {MetricsHandlerFactory} Metrics Handler Factory
	     */function getMetricsHandlerFactory(){return (0,_metricsMetricsHandlerFactory2['default'])(context).getInstance();}instance = {createMetricsReporting:createMetricsReporting,getReportingFactory:getReportingFactory,getMetricsHandlerFactory:getMetricsHandlerFactory};return instance;}MetricsReporting.__dashjs_factory_name = 'MetricsReporting';var factory=dashjs.FactoryMaker.getClassFactory(MetricsReporting); /* jshint ignore:line */factory.events = _MetricsReportingEvents2['default'];dashjs.FactoryMaker.updateClassFactory(MetricsReporting.__dashjs_factory_name,factory); /* jshint ignore:line */exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=MetricsReporting.js.map


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _MetricsController=__webpack_require__(350);var _MetricsController2=_interopRequireDefault(_MetricsController);var _utilsManifestParsing=__webpack_require__(360);var _utilsManifestParsing2=_interopRequireDefault(_utilsManifestParsing);var _MetricsReportingEvents=__webpack_require__(65);var _MetricsReportingEvents2=_interopRequireDefault(_MetricsReportingEvents);function MetricsCollectionController(config){config = config || {};var metricsControllers={};var context=this.context;var eventBus=config.eventBus;var events=config.events;function update(e){if(e.error){return;} // start by assuming all existing controllers need removing
	var controllersToRemove=Object.keys(metricsControllers);var metrics=(0,_utilsManifestParsing2['default'])(context).getInstance({dashManifestModel:config.dashManifestModel,constants:config.constants}).getMetrics(e.manifest);metrics.forEach(function(m){var key=JSON.stringify(m);if(!metricsControllers.hasOwnProperty(key)){try{var controller=(0,_MetricsController2['default'])(context).create(config);controller.initialize(m);metricsControllers[key] = controller;}catch(e) { // fail quietly
	}}else { // we still need this controller - delete from removal list
	controllersToRemove.splice(key,1);}}); // now remove the unwanted controllers
	controllersToRemove.forEach(function(c){metricsControllers[c].reset();delete metricsControllers[c];});eventBus.trigger(_MetricsReportingEvents2['default'].METRICS_INITIALISATION_COMPLETE);}function resetMetricsControllers(){Object.keys(metricsControllers).forEach(function(key){metricsControllers[key].reset();});metricsControllers = {};}function setup(){eventBus.on(events.MANIFEST_UPDATED,update);eventBus.on(events.STREAM_TEARDOWN_COMPLETE,resetMetricsControllers);}function reset(){eventBus.off(events.MANIFEST_UPDATED,update);eventBus.off(events.STREAM_TEARDOWN_COMPLETE,resetMetricsControllers);}setup();return {reset:reset};}MetricsCollectionController.__dashjs_factory_name = 'MetricsCollectionController';exports['default'] = dashjs.FactoryMaker.getClassFactory(MetricsCollectionController); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=MetricsCollectionController.js.map


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _RangeController=__webpack_require__(352);var _RangeController2=_interopRequireDefault(_RangeController);var _ReportingController=__webpack_require__(353);var _ReportingController2=_interopRequireDefault(_ReportingController);var _MetricsHandlersController=__webpack_require__(351);var _MetricsHandlersController2=_interopRequireDefault(_MetricsHandlersController);function MetricsController(config){config = config || {};var metricsHandlersController=undefined,reportingController=undefined,rangeController=undefined,instance=undefined;var context=this.context;function initialize(metricsEntry){try{rangeController = (0,_RangeController2['default'])(context).create({mediaElement:config.mediaElement});rangeController.initialize(metricsEntry.Range);reportingController = (0,_ReportingController2['default'])(context).create({log:config.log,metricsConstants:config.metricsConstants});reportingController.initialize(metricsEntry.Reporting,rangeController);metricsHandlersController = (0,_MetricsHandlersController2['default'])(context).create({log:config.log,eventBus:config.eventBus,metricsConstants:config.metricsConstants,events:config.events});metricsHandlersController.initialize(metricsEntry.metrics,reportingController);}catch(e) {reset();throw e;}}function reset(){if(metricsHandlersController){metricsHandlersController.reset();}if(reportingController){reportingController.reset();}if(rangeController){rangeController.reset();}}instance = {initialize:initialize,reset:reset};return instance;}MetricsController.__dashjs_factory_name = 'MetricsController';exports['default'] = dashjs.FactoryMaker.getClassFactory(MetricsController); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=MetricsController.js.map


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _metricsMetricsHandlerFactory=__webpack_require__(146);var _metricsMetricsHandlerFactory2=_interopRequireDefault(_metricsMetricsHandlerFactory);function MetricsHandlersController(config){config = config || {};var handlers=[];var instance=undefined;var context=this.context;var eventBus=config.eventBus;var Events=config.events;var metricsHandlerFactory=(0,_metricsMetricsHandlerFactory2['default'])(context).getInstance({log:config.log,eventBus:config.eventBus,metricsConstants:config.metricsConstants});function handle(e){handlers.forEach(function(handler){handler.handleNewMetric(e.metric,e.value,e.mediaType);});}function initialize(metrics,reportingController){metrics.split(',').forEach(function(m,midx,ms){var handler=undefined; // there is a bug in ISO23009-1 where the metrics attribute
	// is a comma-separated list but HttpList key can contain a
	// comma enclosed by ().
	if(m.indexOf('(') !== -1 && m.indexOf(')') === -1){var nextm=ms[midx + 1];if(nextm && nextm.indexOf('(') === -1 && nextm.indexOf(')') !== -1){m += ',' + nextm; // delete the next metric so forEach does not visit.
	delete ms[midx + 1];}}handler = metricsHandlerFactory.create(m,reportingController);if(handler){handlers.push(handler);}});eventBus.on(Events.METRIC_ADDED,handle,instance);eventBus.on(Events.METRIC_UPDATED,handle,instance);}function reset(){eventBus.off(Events.METRIC_ADDED,handle,instance);eventBus.off(Events.METRIC_UPDATED,handle,instance);handlers.forEach(function(handler){return handler.reset();});handlers = [];}instance = {initialize:initialize,reset:reset};return instance;}MetricsHandlersController.__dashjs_factory_name = 'MetricsHandlersController';exports['default'] = dashjs.FactoryMaker.getClassFactory(MetricsHandlersController); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=MetricsHandlersController.js.map


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _utilsCustomTimeRanges=__webpack_require__(151);var _utilsCustomTimeRanges2=_interopRequireDefault(_utilsCustomTimeRanges);function RangeController(config){config = config || {};var useWallClockTime=false;var context=this.context;var instance=undefined,ranges=undefined;var mediaElement=config.mediaElement;function initialize(rs){if(rs && rs.length){rs.forEach(function(r){var start=r.starttime;var end=start + r.duration;ranges.add(start,end);});useWallClockTime = !!rs[0]._useWallClockTime;}}function reset(){ranges.clear();}function setup(){ranges = (0,_utilsCustomTimeRanges2['default'])(context).create();}function isEnabled(){var numRanges=ranges.length;var time=undefined;if(!numRanges){return true;} // When not present, DASH Metrics reporting is requested
	// for the whole duration of the content.
	time = useWallClockTime?new Date().getTime() / 1000:mediaElement.currentTime;for(var i=0;i < numRanges;i += 1) {var start=ranges.start(i);var end=ranges.end(i);if(start <= time && time < end){return true;}}return false;}instance = {initialize:initialize,reset:reset,isEnabled:isEnabled};setup();return instance;}RangeController.__dashjs_factory_name = 'RangeController';exports['default'] = dashjs.FactoryMaker.getClassFactory(RangeController); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=RangeController.js.map


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _reportingReportingFactory=__webpack_require__(147);var _reportingReportingFactory2=_interopRequireDefault(_reportingReportingFactory);function ReportingController(config){var reporters=[];var instance=undefined;var reportingFactory=(0,_reportingReportingFactory2['default'])(this.context).getInstance(config);function initialize(reporting,rangeController){ // "if multiple Reporting elements are present, it is expected that
	// the client processes one of the recognized reporting schemes."
	// to ignore this, and support multiple Reporting per Metric,
	// simply change the 'some' below to 'forEach'
	reporting.some(function(r){var reporter=reportingFactory.create(r,rangeController);if(reporter){reporters.push(reporter);return true;}});}function reset(){reporters.forEach(function(r){return r.reset();});reporters = [];}function report(type,vos){reporters.forEach(function(r){return r.report(type,vos);});}instance = {initialize:initialize,reset:reset,report:report};return instance;}ReportingController.__dashjs_factory_name = 'ReportingController';exports['default'] = dashjs.FactoryMaker.getClassFactory(ReportingController); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=ReportingController.js.map


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _utilsHandlerHelpers=__webpack_require__(148);var _utilsHandlerHelpers2=_interopRequireDefault(_utilsHandlerHelpers);function BufferLevelHandler(config){config = config || {};var instance=undefined,reportingController=undefined,n=undefined,name=undefined,interval=undefined,lastReportedTime=undefined;var context=this.context;var handlerHelpers=(0,_utilsHandlerHelpers2['default'])(context).getInstance();var storedVOs=[];var metricsConstants=config.metricsConstants;function getLowestBufferLevelVO(){try{return Object.keys(storedVOs).map(function(key){return storedVOs[key];}).reduce(function(a,b){return a.level < b.level?a:b;});}catch(e) {return;}}function intervalCallback(){var vo=getLowestBufferLevelVO();if(vo){if(lastReportedTime !== vo.t){lastReportedTime = vo.t;reportingController.report(name,vo);}}}function initialize(basename,rc,n_ms){if(rc){ // this will throw if n is invalid, to be
	// caught by the initialize caller.
	n = handlerHelpers.validateN(n_ms);reportingController = rc;name = handlerHelpers.reconstructFullMetricName(basename,n_ms);interval = setInterval(intervalCallback,n);}}function reset(){clearInterval(interval);interval = null;n = 0;reportingController = null;lastReportedTime = null;}function handleNewMetric(metric,vo,type){if(metric === metricsConstants.BUFFER_LEVEL){storedVOs[type] = vo;}}instance = {initialize:initialize,reset:reset,handleNewMetric:handleNewMetric};return instance;}BufferLevelHandler.__dashjs_factory_name = 'BufferLevelHandler';exports['default'] = dashjs.FactoryMaker.getClassFactory(BufferLevelHandler); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=BufferLevelHandler.js.map


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _MetricsReportingEvents=__webpack_require__(65);var _MetricsReportingEvents2=_interopRequireDefault(_MetricsReportingEvents);function DVBErrorsHandler(config){config = config || {};var instance=undefined,reportingController=undefined;var eventBus=config.eventBus;var metricsConstants=config.metricsConstants;function onInitialisationComplete(){ // we only want to report this once per call to initialize
	eventBus.off(_MetricsReportingEvents2['default'].METRICS_INITIALISATION_COMPLETE,onInitialisationComplete,this); // Note: A Player becoming a reporting Player is itself
	// something which is recorded by the DVBErrors metric.
	eventBus.trigger(_MetricsReportingEvents2['default'].BECAME_REPORTING_PLAYER);}function initialize(unused,rc){if(rc){reportingController = rc;eventBus.on(_MetricsReportingEvents2['default'].METRICS_INITIALISATION_COMPLETE,onInitialisationComplete,this);}}function reset(){reportingController = null;}function handleNewMetric(metric,vo){ // simply pass metric straight through
	if(metric === metricsConstants.DVB_ERRORS){if(reportingController){reportingController.report(metric,vo);}}}instance = {initialize:initialize,reset:reset,handleNewMetric:handleNewMetric};return instance;}exports['default'] = dashjs.FactoryMaker.getClassFactory(DVBErrorsHandler); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=DVBErrorsHandler.js.map


/***/ },
/* 356 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function GenericMetricHandler(){var instance=undefined,metricName=undefined,reportingController=undefined;function initialize(name,rc){metricName = name;reportingController = rc;}function reset(){reportingController = null;metricName = undefined;}function handleNewMetric(metric,vo){ // simply pass metric straight through
	if(metric === metricName){if(reportingController){reportingController.report(metricName,vo);}}}instance = {initialize:initialize,reset:reset,handleNewMetric:handleNewMetric};return instance;}GenericMetricHandler.__dashjs_factory_name = 'GenericMetricHandler';exports['default'] = dashjs.FactoryMaker.getClassFactory(GenericMetricHandler); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=GenericMetricHandler.js.map


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _utilsHandlerHelpers=__webpack_require__(148);var _utilsHandlerHelpers2=_interopRequireDefault(_utilsHandlerHelpers);function HttpListHandler(config){config = config || {};var instance=undefined,reportingController=undefined,n=undefined,type=undefined,name=undefined,interval=undefined;var storedVos=[];var handlerHelpers=(0,_utilsHandlerHelpers2['default'])(this.context).getInstance();var metricsConstants=config.metricsConstants;function intervalCallback(){var vos=storedVos;if(vos.length){if(reportingController){reportingController.report(name,vos);}}storedVos = [];}function initialize(basename,rc,n_ms,requestType){if(rc){ // this will throw if n is invalid, to be
	// caught by the initialize caller.
	n = handlerHelpers.validateN(n_ms);reportingController = rc;if(requestType && requestType.length){type = requestType;}name = handlerHelpers.reconstructFullMetricName(basename,n_ms,requestType);interval = setInterval(intervalCallback,n);}}function reset(){clearInterval(interval);interval = null;n = null;type = null;storedVos = [];reportingController = null;}function handleNewMetric(metric,vo){if(metric === metricsConstants.HTTP_REQUEST){if(!type || type === vo.type){storedVos.push(vo);}}}instance = {initialize:initialize,reset:reset,handleNewMetric:handleNewMetric};return instance;}HttpListHandler.__dashjs_factory_name = 'HttpListHandler';exports['default'] = dashjs.FactoryMaker.getClassFactory(HttpListHandler); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=HttpListHandler.js.map


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _utilsMetricSerialiser=__webpack_require__(361);var _utilsMetricSerialiser2=_interopRequireDefault(_utilsMetricSerialiser);var _utilsRNG=__webpack_require__(362);var _utilsRNG2=_interopRequireDefault(_utilsRNG);function DVBReporting(config){config = config || {};var instance=undefined;var context=this.context;var metricSerialiser=(0,_utilsMetricSerialiser2['default'])(context).getInstance();var randomNumberGenerator=(0,_utilsRNG2['default'])(context).getInstance();var USE_DRAFT_DVB_SPEC=true;var isReportingPlayer=false;var reportingPlayerStatusDecided=false;var reportingUrl=null;var rangeController=null;var allowPendingRequestsToCompleteOnReset=true;var pendingRequests=[];var metricsConstants=config.metricsConstants;function doGetRequest(url,successCB,failureCB){var req=new XMLHttpRequest();var oncomplete=function oncomplete(){var reqIndex=pendingRequests.indexOf(req);if(reqIndex === -1){return;}else {pendingRequests.splice(reqIndex,1);}if(req.status >= 200 && req.status < 300){if(successCB){successCB();}}else {if(failureCB){failureCB();}}};pendingRequests.push(req);try{req.open('GET',url);req.onloadend = oncomplete;req.onerror = oncomplete;req.send();}catch(e) {req.onerror();}}function report(type,vos){if(!Array.isArray(vos)){vos = [vos];} // If the Player is not a reporting Player, then the Player shall
	// not report any errors.
	// ... In addition to any time restrictions specified by a Range
	// element within the Metrics element.
	if(isReportingPlayer && rangeController.isEnabled()){ // This reporting mechanism operates by creating one HTTP GET
	// request for every entry in the top level list of the metric.
	vos.forEach(function(vo){var url=metricSerialiser.serialise(vo); // this has been proposed for errata
	if(USE_DRAFT_DVB_SPEC && type !== metricsConstants.DVB_ERRORS){url = 'metricname=' + type + '&' + url;} // Take the value of the @reportingUrl attribute, append a
	// question mark ('?') character and then append the string
	// created in the previous step.
	url = reportingUrl + '?' + url; // Make an HTTP GET request to the URL contained within the
	// string created in the previous step.
	doGetRequest(url,null,function(){ // If the Player is unable to make the report, for
	// example because the @reportingUrl is invalid, the
	// host cannot be reached, or an HTTP status code other
	// than one in the 200 series is received, the Player
	// shall cease being a reporting Player for the
	// duration of the MPD.
	isReportingPlayer = false;});});}}function initialize(entry,rc){var probability=undefined;rangeController = rc;reportingUrl = entry['dvb:reportingUrl']; // If a required attribute is missing, the Reporting descriptor may
	// be ignored by the Player
	if(!reportingUrl){throw new Error('required parameter missing (dvb:reportingUrl)');} // A Player's status, as a reporting Player or not, shall remain
	// static for the duration of the MPD, regardless of MPD updates.
	// (i.e. only calling reset (or failure) changes this state)
	if(!reportingPlayerStatusDecided){ // NOTE: DVB spec has a typo where it incorrectly references the
	// priority attribute, which should be probability
	probability = entry['dvb:probability'] || entry['dvb:priority'] || 0; // If the @priority attribute is set to 1000, it shall be a reporting Player.
	// If the @priority attribute is missing, the Player shall not be a reporting Player.
	// For any other value of the @probability attribute, it shall decide at random whether to be a
	// reporting Player, such that the probability of being one is @probability/1000.
	if(probability && (probability === 1000 || probability / 1000 >= randomNumberGenerator.random())){isReportingPlayer = true;}reportingPlayerStatusDecided = true;}}function reset(){if(!allowPendingRequestsToCompleteOnReset){pendingRequests.forEach(function(req){return req.abort();});pendingRequests = [];}reportingPlayerStatusDecided = false;isReportingPlayer = false;reportingUrl = null;rangeController = null;}instance = {report:report,initialize:initialize,reset:reset};return instance;}DVBReporting.__dashjs_factory_name = 'DVBReporting';exports['default'] = dashjs.FactoryMaker.getClassFactory(DVBReporting); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=DVBReporting.js.map


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _voDVBErrors=__webpack_require__(363);var _voDVBErrors2=_interopRequireDefault(_voDVBErrors);var _MetricsReportingEvents=__webpack_require__(65);var _MetricsReportingEvents2=_interopRequireDefault(_MetricsReportingEvents);function DVBErrorsTranslator(config){config = config || {};var instance=undefined;var eventBus=config.eventBus;var metricModel=config.metricsModel;var mpd=undefined;var metricsConstants=config.metricsConstants; //MediaPlayerEvents have been added to Events in MediaPlayer class
	var Events=config.events;function report(vo){var o=new _voDVBErrors2['default']();if(!mpd){return;}for(var key in vo) {if(vo.hasOwnProperty(key)){o[key] = vo[key];}}if(!o.mpdurl){o.mpdurl = mpd.originalUrl || mpd.url;}if(!o.terror){o.terror = new Date();}metricModel.addDVBErrors(o);}function onManifestUpdate(e){if(e.error){return;}mpd = e.manifest;}function onServiceLocationChanged(e){report({errorcode:_voDVBErrors2['default'].BASE_URL_CHANGED,servicelocation:e.entry});}function onBecameReporter(){report({errorcode:_voDVBErrors2['default'].BECAME_REPORTER});}function handleHttpMetric(vo){if(vo.responsecode === 0 ||  // connection failure - unknown
	vo.responsecode >= 400 ||  // HTTP error status code
	vo.responsecode < 100 ||  // unknown status codes
	vo.responsecode >= 600){ // unknown status codes
	report({errorcode:vo.responsecode || _voDVBErrors2['default'].CONNECTION_ERROR,url:vo.url,terror:vo.tresponse,servicelocation:vo._serviceLocation});}}function onMetricEvent(e){switch(e.metric){case metricsConstants.HTTP_REQUEST:handleHttpMetric(e.value);break;default:break;}}function onPlaybackError(e){var reason=e.error?e.error.code:0;var errorcode=undefined;switch(reason){case MediaError.MEDIA_ERR_NETWORK:errorcode = _voDVBErrors2['default'].CONNECTION_ERROR;break;case MediaError.MEDIA_ERR_DECODE:errorcode = _voDVBErrors2['default'].CORRUPT_MEDIA_OTHER;break;default:return;}report({errorcode:errorcode});}function initialise(){eventBus.on(Events.MANIFEST_UPDATED,onManifestUpdate,instance);eventBus.on(Events.SERVICE_LOCATION_BLACKLIST_CHANGED,onServiceLocationChanged,instance);eventBus.on(Events.METRIC_ADDED,onMetricEvent,instance);eventBus.on(Events.METRIC_UPDATED,onMetricEvent,instance);eventBus.on(Events.PLAYBACK_ERROR,onPlaybackError,instance);eventBus.on(_MetricsReportingEvents2['default'].BECAME_REPORTING_PLAYER,onBecameReporter,instance);}function reset(){eventBus.off(Events.MANIFEST_UPDATED,onManifestUpdate,instance);eventBus.off(Events.SERVICE_LOCATION_BLACKLIST_CHANGED,onServiceLocationChanged,instance);eventBus.off(Events.METRIC_ADDED,onMetricEvent,instance);eventBus.off(Events.METRIC_UPDATED,onMetricEvent,instance);eventBus.off(Events.PLAYBACK_ERROR,onPlaybackError,instance);eventBus.off(_MetricsReportingEvents2['default'].BECAME_REPORTING_PLAYER,onBecameReporter,instance);}instance = {initialise:initialise,reset:reset};initialise();return instance;}DVBErrorsTranslator.__dashjs_factory_name = 'DVBErrorsTranslator';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(DVBErrorsTranslator); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=DVBErrorsTranslator.js.map


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _voMetrics=__webpack_require__(364);var _voMetrics2=_interopRequireDefault(_voMetrics);var _voRange=__webpack_require__(365);var _voRange2=_interopRequireDefault(_voRange);var _voReporting=__webpack_require__(366);var _voReporting2=_interopRequireDefault(_voReporting);function ManifestParsing(config){config = config || {};var instance=undefined;var dashManifestModel=config.dashManifestModel;var constants=config.constants;function getMetricsRangeStartTime(manifest,dynamic,range){var mpd=dashManifestModel.getMpd(manifest);var voPeriods;var presentationStartTime=0;var reportingStartTime;if(dynamic){ // For services with MPD@type='dynamic', the start time is
	// indicated in wall clock time by adding the value of this
	// attribute to the value of the MPD@availabilityStartTime
	// attribute.
	presentationStartTime = mpd.availabilityStartTime.getTime() / 1000;}else { // For services with MPD@type='static', the start time is indicated
	// in Media Presentation time and is relative to the PeriodStart
	// time of the first Period in this MPD.
	voPeriods = this.getRegularPeriods(mpd);if(voPeriods.length){presentationStartTime = voPeriods[0].start;}} // When not present, DASH Metrics collection is
	// requested from the beginning of content
	// consumption.
	reportingStartTime = presentationStartTime;if(range && range.hasOwnProperty(constants.START_TIME)){reportingStartTime += range.starttime;}return reportingStartTime;}function getMetrics(manifest){var metrics=[];if(manifest.Metrics_asArray){manifest.Metrics_asArray.forEach(function(metric){var metricEntry=new _voMetrics2['default']();var isDynamic=dashManifestModel.getIsDynamic(manifest);if(metric.hasOwnProperty('metrics')){metricEntry.metrics = metric.metrics;}else { //console.log("Invalid Metrics. metrics must be set. Ignoring.");
	return;}if(metric.Range_asArray){metric.Range_asArray.forEach(function(range){var rangeEntry=new _voRange2['default']();rangeEntry.starttime = getMetricsRangeStartTime(manifest,isDynamic,range);if(range.hasOwnProperty('duration')){rangeEntry.duration = range.duration;}else { // if not present, the value is identical to the
	// Media Presentation duration.
	rangeEntry.duration = dashManifestModel.getDuration(manifest);}rangeEntry._useWallClockTime = isDynamic;metricEntry.Range.push(rangeEntry);});}if(metric.Reporting_asArray){metric.Reporting_asArray.forEach(function(reporting){var reportingEntry=new _voReporting2['default']();if(reporting.hasOwnProperty(constants.SCHEME_ID_URI)){reportingEntry.schemeIdUri = reporting.schemeIdUri;}else { // Invalid Reporting. schemeIdUri must be set. Ignore.
	return;}for(var prop in reporting) {if(reporting.hasOwnProperty(prop)){reportingEntry[prop] = reporting[prop];}}metricEntry.Reporting.push(reportingEntry);});}else { // Invalid Metrics. At least one reporting must be present. Ignore
	return;}metrics.push(metricEntry);});}return metrics;}instance = {getMetrics:getMetrics};return instance;}ManifestParsing.__dashjs_factory_name = 'ManifestParsing';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(ManifestParsing); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=ManifestParsing.js.map


/***/ },
/* 361 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function MetricSerialiser(){ // For each entry in the top level list within the metric (in the case
	// of the DVBErrors metric each entry corresponds to an "error event"
	// described in clause 10.8.4) the Player shall:
	function serialise(metric){var pairs=[];var obj=[];var key=undefined,value=undefined; // Take each (key, value) pair from the metric entry and create a
	// string consisting of the name of the key, followed by an equals
	// ('=') character, followed by the string representation of the
	// value. The string representation of the value is created based
	// on the type of the value following the instructions in Table 22.
	for(key in metric) {if(metric.hasOwnProperty(key) && key.indexOf('_') !== 0){value = metric[key]; // we want to ensure that keys still end up in the report
	// even if there is no value
	if(value === undefined || value === null){value = '';} // DVB A168 10.12.4 Table 22
	if(Array.isArray(value)){ // if trace or similar is null, do not include in output
	if(!value.length){continue;}obj = [];value.forEach(function(v){var isBuiltIn=Object.prototype.toString.call(v).slice(8,-1) !== 'Object';obj.push(isBuiltIn?v:serialise(v));});value = obj.map(encodeURIComponent).join(',');}else if(typeof value === 'string'){value = encodeURIComponent(value);}else if(value instanceof Date){value = value.toISOString();}else if(typeof value === 'number'){value = Math.round(value);}pairs.push(key + '=' + value);}} // Concatenate the strings created in the previous step with an
	// ampersand ('&') character between each one.
	return pairs.join('&');}return {serialise:serialise};}MetricSerialiser.__dashjs_factory_name = 'MetricSerialiser';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(MetricSerialiser); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=MetricSerialiser.js.map


/***/ },
/* 362 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function RNG(){ // check whether secure random numbers are available. if not, revert to
	// using Math.random
	var crypto=window.crypto || window.msCrypto; // could just as easily use any other array type by changing line below
	var ArrayType=Uint32Array;var MAX_VALUE=Math.pow(2,ArrayType.BYTES_PER_ELEMENT * 8) - 1; // currently there is only one client for this code, and that only uses
	// a single random number per initialisation. may want to increase this
	// number if more consumers in the future
	var NUM_RANDOM_NUMBERS=10;var randomNumbers=undefined,index=undefined,instance=undefined;function initialise(){if(crypto){if(!randomNumbers){randomNumbers = new ArrayType(NUM_RANDOM_NUMBERS);}crypto.getRandomValues(randomNumbers);index = 0;}}function rand(min,max){var r=undefined;if(!min){min = 0;}if(!max){max = 1;}if(crypto){if(index === randomNumbers.length){initialise();}r = randomNumbers[index] / MAX_VALUE;index += 1;}else {r = Math.random();}return r * (max - min) + min;}instance = {random:rand};initialise();return instance;}RNG.__dashjs_factory_name = 'RNG';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(RNG); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=RNG.js.map


/***/ },
/* 363 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var DVBErrors=function DVBErrors(){_classCallCheck(this,DVBErrors);this.mpdurl = null; // String - Absolute URL from which the MPD was originally
	// retrieved (MPD updates will not change this value).
	this.errorcode = null; // String - The value of errorcode depends upon the type
	// of error being reported. For an error listed in the
	// ErrorType column below the value is as described in the
	// Value column.
	//
	// ErrorType                                            Value
	// ---------                                            -----
	// HTTP error status code                               HTTP status code
	// Unknown HTTP status code                             HTTP status code
	// SSL connection failed                                "SSL" followed by SSL alert value
	// DNS resolution failed                                "C00"
	// Host unreachable                                     "C01"
	// Connection refused                                   "C02"
	// Connection error – Not otherwise specified           "C03"
	// Corrupt media – ISO BMFF container cannot be parsed  "M00"
	// Corrupt media – Not otherwise specified              "M01"
	// Changing Base URL in use due to errors               "F00"
	// Becoming an error reporting Player                   "S00"
	this.terror = null; // Real-Time - Date and time at which error occurred in UTC,
	// formatted as a combined date and time according to ISO 8601.
	this.url = null; // String - Absolute URL from which data was being requested
	// when this error occurred. If the error report is in relation
	// to corrupt media or changing BaseURL, this may be a null
	// string if the URL from which the media was obtained or
	// which led to the change of BaseURL is no longer known.
	this.ipaddress = null; // String - IP Address which the host name in "url" resolved to.
	// If the error report is in relation to corrupt media or
	// changing BaseURL, this may be a null string if the URL
	// from which the media was obtained or which led to the
	// change of BaseURL is no longer known.
	this.servicelocation = null; // String - The value of the serviceLocation field in the
	// BaseURL being used. In the event of this report indicating
	// a change of BaseURL this is the value from the BaseURL
	// being moved from.
	};DVBErrors.SSL_CONNECTION_FAILED_PREFIX = 'SSL';DVBErrors.DNS_RESOLUTION_FAILED = 'C00';DVBErrors.HOST_UNREACHABLE = 'C01';DVBErrors.CONNECTION_REFUSED = 'C02';DVBErrors.CONNECTION_ERROR = 'C03';DVBErrors.CORRUPT_MEDIA_ISOBMFF = 'M00';DVBErrors.CORRUPT_MEDIA_OTHER = 'M01';DVBErrors.BASE_URL_CHANGED = 'F00';DVBErrors.BECAME_REPORTER = 'S00';exports['default'] = DVBErrors;module.exports = exports['default'];
	//# sourceMappingURL=DVBErrors.js.map


/***/ },
/* 364 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var Metrics=function Metrics(){_classCallCheck(this,Metrics);this.metrics = '';this.Range = [];this.Reporting = [];};exports['default'] = Metrics;module.exports = exports['default'];
	//# sourceMappingURL=Metrics.js.map


/***/ },
/* 365 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Range=function Range(){_classCallCheck(this,Range); // as defined in ISO23009-1
	this.starttime = 0;this.duration = Infinity; // for internal use
	this._useWallClockTime = false;};exports["default"] = Range;module.exports = exports["default"];
	//# sourceMappingURL=Range.js.map


/***/ },
/* 366 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var Reporting=function Reporting(){_classCallCheck(this,Reporting); // Reporting is a DescriptorType and doesn't have any additional fields
	this.schemeIdUri = '';this.value = '';};exports['default'] = Reporting;module.exports = exports['default'];
	//# sourceMappingURL=Reporting.js.map


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var _utilsObjectUtils=__webpack_require__(153);var _utilsObjectUtils2=_interopRequireDefault(_utilsObjectUtils);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var DEFAULT_INDEX=NaN;var Node=function Node(_baseUrls,_selectedIdx){_classCallCheck(this,Node);this.data = {baseUrls:_baseUrls || null,selectedIdx:_selectedIdx || DEFAULT_INDEX};this.children = [];};function BaseURLTreeModel(){var instance=undefined;var root=undefined;var dashManifestModel=undefined;var context=this.context;var objectUtils=(0,_utilsObjectUtils2['default'])(context).getInstance();function setup(){reset();}function setConfig(config){if(config.dashManifestModel){dashManifestModel = config.dashManifestModel;}}function updateChildData(node,index,element){var baseUrls=dashManifestModel.getBaseURLsFromElement(element);if(!node[index]){node[index] = new Node(baseUrls);}else {if(!objectUtils.areEqual(baseUrls,node[index].data.baseUrls)){node[index].data.baseUrls = baseUrls;node[index].data.selectedIdx = DEFAULT_INDEX;}}}function getBaseURLCollectionsFromManifest(manifest){var baseUrls=dashManifestModel.getBaseURLsFromElement(manifest);if(!objectUtils.areEqual(baseUrls,root.data.baseUrls)){root.data.baseUrls = baseUrls;root.data.selectedIdx = DEFAULT_INDEX;}if(manifest.Period_asArray){manifest.Period_asArray.forEach(function(p,pi){updateChildData(root.children,pi,p);if(p.AdaptationSet_asArray){p.AdaptationSet_asArray.forEach(function(a,ai){updateChildData(root.children[pi].children,ai,a);if(a.Representation_asArray){a.Representation_asArray.sort(dashManifestModel.getRepresentationSortFunction()).forEach(function(r,ri){updateChildData(root.children[pi].children[ai].children,ri,r);});}});}});}}function walk(callback,node){var target=node || root;callback(target.data);if(target.children){target.children.forEach(function(child){return walk(callback,child);});}}function invalidateSelectedIndexes(serviceLocation){walk(function(data){if(!isNaN(data.selectedIdx)){if(serviceLocation === data.baseUrls[data.selectedIdx].serviceLocation){data.selectedIdx = DEFAULT_INDEX;}}});}function update(manifest){getBaseURLCollectionsFromManifest(manifest);}function reset(){root = new Node();}function getForPath(path){var target=root;var nodes=[target.data];if(path){path.forEach(function(p){target = target.children[p];if(target){nodes.push(target.data);}});}return nodes.filter(function(n){return n.baseUrls.length;});}instance = {reset:reset,update:update,getForPath:getForPath,invalidateSelectedIndexes:invalidateSelectedIndexes,setConfig:setConfig};setup();return instance;}BaseURLTreeModel.__dashjs_factory_name = 'BaseURLTreeModel';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(BaseURLTreeModel);module.exports = exports['default'];
	//# sourceMappingURL=BaseURLTreeModel.js.map


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function ManifestModel(){var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,manifest=undefined;function getValue(){return manifest;}function setValue(value){manifest = value;if(value){eventBus.trigger(_coreEventsEvents2['default'].MANIFEST_LOADED,{data:value});}}instance = {getValue:getValue,setValue:setValue};return instance;}ManifestModel.__dashjs_factory_name = 'ManifestModel';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(ManifestModel);module.exports = exports['default'];
	//# sourceMappingURL=ManifestModel.js.map


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _constantsMetricsConstants=__webpack_require__(41);var _constantsMetricsConstants2=_interopRequireDefault(_constantsMetricsConstants);var _voMetricsList=__webpack_require__(423);var _voMetricsList2=_interopRequireDefault(_voMetricsList);var _voMetricsTCPConnection=__webpack_require__(438);var _voMetricsTCPConnection2=_interopRequireDefault(_voMetricsTCPConnection);var _voMetricsHTTPRequest=__webpack_require__(16);var _voMetricsRepresentationSwitch=__webpack_require__(435);var _voMetricsRepresentationSwitch2=_interopRequireDefault(_voMetricsRepresentationSwitch);var _voMetricsBufferLevel=__webpack_require__(430);var _voMetricsBufferLevel2=_interopRequireDefault(_voMetricsBufferLevel);var _voMetricsBufferState=__webpack_require__(431);var _voMetricsBufferState2=_interopRequireDefault(_voMetricsBufferState);var _voMetricsDVRInfo=__webpack_require__(432);var _voMetricsDVRInfo2=_interopRequireDefault(_voMetricsDVRInfo);var _voMetricsDroppedFrames=__webpack_require__(433);var _voMetricsDroppedFrames2=_interopRequireDefault(_voMetricsDroppedFrames);var _voMetricsManifestUpdate=__webpack_require__(434);var _voMetricsSchedulingInfo=__webpack_require__(437);var _voMetricsSchedulingInfo2=_interopRequireDefault(_voMetricsSchedulingInfo);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _voMetricsRequestsQueue=__webpack_require__(436);var _voMetricsRequestsQueue2=_interopRequireDefault(_voMetricsRequestsQueue);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function MetricsModel(){var MAXIMUM_LIST_DEPTH=1000;var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,adapter=undefined,streamMetrics=undefined;function setup(){streamMetrics = {};}function setConfig(config){if(!config)return;if(config.adapter){adapter = config.adapter;}}function metricsChanged(){eventBus.trigger(_coreEventsEvents2['default'].METRICS_CHANGED);}function metricChanged(mediaType){eventBus.trigger(_coreEventsEvents2['default'].METRIC_CHANGED,{mediaType:mediaType});metricsChanged();}function metricUpdated(mediaType,metricType,vo){eventBus.trigger(_coreEventsEvents2['default'].METRIC_UPDATED,{mediaType:mediaType,metric:metricType,value:vo});metricChanged(mediaType);}function metricAdded(mediaType,metricType,vo){eventBus.trigger(_coreEventsEvents2['default'].METRIC_ADDED,{mediaType:mediaType,metric:metricType,value:vo});metricChanged(mediaType);}function clearCurrentMetricsForType(type){delete streamMetrics[type];metricChanged(type);}function clearAllCurrentMetrics(){streamMetrics = {};metricsChanged();}function getReadOnlyMetricsFor(type){if(streamMetrics.hasOwnProperty(type)){return streamMetrics[type];}return null;}function getMetricsFor(type){var metrics=undefined;if(streamMetrics.hasOwnProperty(type)){metrics = streamMetrics[type];}else {metrics = new _voMetricsList2['default']();streamMetrics[type] = metrics;}return metrics;}function pushMetrics(type,list,value){var metrics=getMetricsFor(type);metrics[list].push(value);if(metrics[list].length > MAXIMUM_LIST_DEPTH){metrics[list].shift();}}function addTcpConnection(mediaType,tcpid,dest,topen,tclose,tconnect){var vo=new _voMetricsTCPConnection2['default']();vo.tcpid = tcpid;vo.dest = dest;vo.topen = topen;vo.tclose = tclose;vo.tconnect = tconnect;pushAndNotify(mediaType,_constantsMetricsConstants2['default'].TCP_CONNECTION,vo);return vo;}function appendHttpTrace(httpRequest,s,d,b){var vo=new _voMetricsHTTPRequest.HTTPRequestTrace();vo.s = s;vo.d = d;vo.b = b;httpRequest.trace.push(vo);if(!httpRequest.interval){httpRequest.interval = 0;}httpRequest.interval += d;return vo;}function addHttpRequest(mediaType,tcpid,type,url,actualurl,serviceLocation,range,trequest,tresponse,tfinish,responsecode,mediaduration,responseHeaders,traces){var vo=new _voMetricsHTTPRequest.HTTPRequest(); // ISO 23009-1 D.4.3 NOTE 2:
	// All entries for a given object will have the same URL and range
	// and so can easily be correlated. If there were redirects or
	// failures there will be one entry for each redirect/failure.
	// The redirect-to URL or alternative url (where multiple have been
	// provided in the MPD) will appear as the actualurl of the next
	// entry with the same url value.
	if(actualurl && actualurl !== url){ // given the above, add an entry for the original request
	addHttpRequest(mediaType,null,type,url,null,null,range,trequest,null, // unknown
	null, // unknown
	null, // unknown, probably a 302
	mediaduration,null,null);vo.actualurl = actualurl;}vo.tcpid = tcpid;vo.type = type;vo.url = url;vo.range = range;vo.trequest = trequest;vo.tresponse = tresponse;vo.responsecode = responsecode;vo._tfinish = tfinish;vo._stream = mediaType;vo._mediaduration = mediaduration;vo._responseHeaders = responseHeaders;vo._serviceLocation = serviceLocation;if(traces){traces.forEach(function(trace){appendHttpTrace(vo,trace.s,trace.d,trace.b);});}else { // The interval and trace shall be absent for redirect and failure records.
	delete vo.interval;delete vo.trace;}pushAndNotify(mediaType,_constantsMetricsConstants2['default'].HTTP_REQUEST,vo);return vo;}function addRepresentationSwitch(mediaType,t,mt,to,lto){var vo=new _voMetricsRepresentationSwitch2['default']();vo.t = t;vo.mt = mt;vo.to = to;if(lto){vo.lto = lto;}else {delete vo.lto;}pushAndNotify(mediaType,_constantsMetricsConstants2['default'].TRACK_SWITCH,vo);return vo;}function pushAndNotify(mediaType,metricType,metricObject){pushMetrics(mediaType,metricType,metricObject);metricAdded(mediaType,metricType,metricObject);}function addBufferLevel(mediaType,t,level){var vo=new _voMetricsBufferLevel2['default']();vo.t = t;vo.level = level;pushAndNotify(mediaType,_constantsMetricsConstants2['default'].BUFFER_LEVEL,vo);return vo;}function addBufferState(mediaType,state,target){var vo=new _voMetricsBufferState2['default']();vo.target = target;vo.state = state;pushAndNotify(mediaType,_constantsMetricsConstants2['default'].BUFFER_STATE,vo);return vo;}function addDVRInfo(mediaType,currentTime,mpd,range){var vo=new _voMetricsDVRInfo2['default']();vo.time = currentTime;vo.range = range;vo.manifestInfo = mpd;pushAndNotify(mediaType,_constantsMetricsConstants2['default'].DVR_INFO,vo);return vo;}function addDroppedFrames(mediaType,quality){var vo=new _voMetricsDroppedFrames2['default']();var list=getMetricsFor(mediaType).DroppedFrames;vo.time = quality.creationTime;vo.droppedFrames = quality.droppedVideoFrames;if(list.length > 0 && list[list.length - 1] == vo){return list[list.length - 1];}pushAndNotify(mediaType,_constantsMetricsConstants2['default'].DROPPED_FRAMES,vo);return vo;}function addSchedulingInfo(mediaType,t,type,startTime,availabilityStartTime,duration,quality,range,state){var vo=new _voMetricsSchedulingInfo2['default']();vo.mediaType = mediaType;vo.t = t;vo.type = type;vo.startTime = startTime;vo.availabilityStartTime = availabilityStartTime;vo.duration = duration;vo.quality = quality;vo.range = range;vo.state = state;pushAndNotify(mediaType,_constantsMetricsConstants2['default'].SCHEDULING_INFO,vo);return vo;}function addRequestsQueue(mediaType,loadingRequests,executedRequests){var vo=new _voMetricsRequestsQueue2['default']();vo.loadingRequests = loadingRequests;vo.executedRequests = executedRequests;getMetricsFor(mediaType).RequestsQueue = vo;metricAdded(mediaType,_constantsMetricsConstants2['default'].REQUESTS_QUEUE,vo);}function addManifestUpdate(mediaType,type,requestTime,fetchTime,availabilityStartTime,presentationStartTime,clientTimeOffset,currentTime,buffered,latency){var vo=new _voMetricsManifestUpdate.ManifestUpdate();vo.mediaType = mediaType;vo.type = type;vo.requestTime = requestTime; // when this manifest update was requested
	vo.fetchTime = fetchTime; // when this manifest update was received
	vo.availabilityStartTime = availabilityStartTime;vo.presentationStartTime = presentationStartTime; // the seek point (liveEdge for dynamic, Stream[0].startTime for static)
	vo.clientTimeOffset = clientTimeOffset; // the calculated difference between the server and client wall clock time
	vo.currentTime = currentTime; // actual element.currentTime
	vo.buffered = buffered; // actual element.ranges
	vo.latency = latency; // (static is fixed value of zero. dynamic should be ((Now-@availabilityStartTime) - currentTime)
	pushMetrics(_constantsConstants2['default'].STREAM,_constantsMetricsConstants2['default'].MANIFEST_UPDATE,vo);metricAdded(mediaType,_constantsMetricsConstants2['default'].MANIFEST_UPDATE,vo);return vo;}function updateManifestUpdateInfo(manifestUpdate,updatedFields){if(manifestUpdate){for(var field in updatedFields) {manifestUpdate[field] = updatedFields[field];}metricUpdated(manifestUpdate.mediaType,_constantsMetricsConstants2['default'].MANIFEST_UPDATE,manifestUpdate);}}function addManifestUpdateStreamInfo(manifestUpdate,id,index,start,duration){if(manifestUpdate){var vo=new _voMetricsManifestUpdate.ManifestUpdateStreamInfo();vo.id = id;vo.index = index;vo.start = start;vo.duration = duration;manifestUpdate.streamInfo.push(vo);metricUpdated(manifestUpdate.mediaType,_constantsMetricsConstants2['default'].MANIFEST_UPDATE_STREAM_INFO,manifestUpdate);return vo;}return null;}function addManifestUpdateRepresentationInfo(manifestUpdate,id,index,streamIndex,mediaType,presentationTimeOffset,startNumber,fragmentInfoType){if(manifestUpdate){var vo=new _voMetricsManifestUpdate.ManifestUpdateRepresentationInfo();vo.id = id;vo.index = index;vo.streamIndex = streamIndex;vo.mediaType = mediaType;vo.startNumber = startNumber;vo.fragmentInfoType = fragmentInfoType;vo.presentationTimeOffset = presentationTimeOffset;manifestUpdate.representationInfo.push(vo);metricUpdated(manifestUpdate.mediaType,_constantsMetricsConstants2['default'].MANIFEST_UPDATE_TRACK_INFO,manifestUpdate);return vo;}return null;}function addPlayList(vo){var type=_constantsConstants2['default'].STREAM;if(vo.trace && Array.isArray(vo.trace)){vo.trace.forEach(function(trace){if(trace.hasOwnProperty('subreplevel') && !trace.subreplevel){delete trace.subreplevel;}});}else {delete vo.trace;}pushAndNotify(type,_constantsMetricsConstants2['default'].PLAY_LIST,vo);return vo;}function addDVBErrors(vo){var type=_constantsConstants2['default'].STREAM;pushAndNotify(type,_constantsMetricsConstants2['default'].DVB_ERRORS,vo);return vo;}instance = {clearCurrentMetricsForType:clearCurrentMetricsForType,clearAllCurrentMetrics:clearAllCurrentMetrics,getReadOnlyMetricsFor:getReadOnlyMetricsFor,getMetricsFor:getMetricsFor,addTcpConnection:addTcpConnection,addHttpRequest:addHttpRequest,addRepresentationSwitch:addRepresentationSwitch,addBufferLevel:addBufferLevel,addBufferState:addBufferState,addDVRInfo:addDVRInfo,addDroppedFrames:addDroppedFrames,addSchedulingInfo:addSchedulingInfo,addRequestsQueue:addRequestsQueue,addManifestUpdate:addManifestUpdate,updateManifestUpdateInfo:updateManifestUpdateInfo,addManifestUpdateStreamInfo:addManifestUpdateStreamInfo,addManifestUpdateRepresentationInfo:addManifestUpdateRepresentationInfo,addPlayList:addPlayList,addDVBErrors:addDVBErrors,setConfig:setConfig};setup();return instance;}MetricsModel.__dashjs_factory_name = 'MetricsModel';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(MetricsModel);module.exports = exports['default'];
	//# sourceMappingURL=MetricsModel.js.map


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);function VideoModel(){var instance=undefined,element=undefined,TTMLRenderingDiv=undefined,videoContainer=undefined,previousPlaybackRate=undefined;var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var stalledStreams=[];function initialize(){eventBus.on(_coreEventsEvents2['default'].PLAYBACK_PLAYING,onPlaying,this);}function reset(){eventBus.off(_coreEventsEvents2['default'].PLAYBACK_PLAYING,onPlaying,this);}function onPlaybackCanPlay(){if(element){element.playbackRate = previousPlaybackRate || 1;element.removeEventListener('canplay',onPlaybackCanPlay);}}function setPlaybackRate(value){if(!element)return;if(element.readyState <= 2 && value > 0){ // If media element hasn't loaded enough data to play yet, wait until it has
	element.addEventListener('canplay',onPlaybackCanPlay);}else {element.playbackRate = value;}} //TODO Move the DVR window calculations from MediaPlayer to Here.
	function setCurrentTime(currentTime){if(element){ //_currentTime = currentTime;
	// We don't set the same currentTime because it can cause firing unexpected Pause event in IE11
	// providing playbackRate property equals to zero.
	if(element.currentTime == currentTime)return; // TODO Despite the fact that MediaSource 'open' event has been fired IE11 cannot set videoElement.currentTime
	// immediately (it throws InvalidStateError). It seems that this is related to videoElement.readyState property
	// Initially it is 0, but soon after 'open' event it goes to 1 and setting currentTime is allowed. Chrome allows to
	// set currentTime even if readyState = 0.
	// setTimeout is used to workaround InvalidStateError in IE11
	try{element.currentTime = currentTime;}catch(e) {if(element.readyState === 0 && e.code === e.INVALID_STATE_ERR){setTimeout(function(){element.currentTime = currentTime;},400);}}}}function getElement(){return element;}function setElement(value){element = value; // Workaround to force Firefox to fire the canplay event.
	element.preload = 'auto';}function setSource(source){if(element){if(source){element.src = source;}else {element.removeAttribute('src');element.load();}}}function getSource(){return element?element.src:null;}function getVideoContainer(){return videoContainer;}function setVideoContainer(value){videoContainer = value;}function getTTMLRenderingDiv(){return TTMLRenderingDiv;}function setTTMLRenderingDiv(div){TTMLRenderingDiv = div; // The styling will allow the captions to match the video window size and position.
	TTMLRenderingDiv.style.position = 'absolute';TTMLRenderingDiv.style.display = 'flex';TTMLRenderingDiv.style.overflow = 'hidden';TTMLRenderingDiv.style.pointerEvents = 'none';TTMLRenderingDiv.style.top = 0;TTMLRenderingDiv.style.left = 0;}function setStallState(type,state){stallStream(type,state);}function isStalled(){return stalledStreams.length > 0;}function addStalledStream(type){var event=undefined;if(type === null || element.seeking || stalledStreams.indexOf(type) !== -1){return;}stalledStreams.push(type);if(element && stalledStreams.length === 1){ // Halt playback until nothing is stalled.
	event = document.createEvent('Event');event.initEvent('waiting',true,false);previousPlaybackRate = element.playbackRate;setPlaybackRate(0);element.dispatchEvent(event);}}function removeStalledStream(type){var index=stalledStreams.indexOf(type);var event=undefined;if(type === null){return;}if(index !== -1){stalledStreams.splice(index,1);} // If nothing is stalled resume playback.
	if(element && isStalled() === false && element.playbackRate === 0){setPlaybackRate(previousPlaybackRate || 1);if(!element.paused){event = document.createEvent('Event');event.initEvent('playing',true,false);element.dispatchEvent(event);}}}function stallStream(type,isStalled){if(isStalled){addStalledStream(type);}else {removeStalledStream(type);}} //Calling play on the element will emit playing - even if the stream is stalled. If the stream is stalled, emit a waiting event.
	function onPlaying(){if(element && isStalled() && element.playbackRate === 0){var _event=document.createEvent('Event');_event.initEvent('waiting',true,false);element.dispatchEvent(_event);}}function getPlaybackQuality(){if(!element){return null;}var hasWebKit='webkitDroppedFrameCount' in element && 'webkitDecodedFrameCount' in element;var hasQuality=('getVideoPlaybackQuality' in element);var result=null;if(hasQuality){result = element.getVideoPlaybackQuality();}else if(hasWebKit){result = {droppedVideoFrames:element.webkitDroppedFrameCount,totalVideoFrames:element.webkitDroppedFrameCount + element.webkitDecodedFrameCount,creationTime:new Date()};}return result;}function play(){if(element){element.autoplay = true;var p=element.play();if(p && typeof Promise !== 'undefined' && p instanceof Promise){p['catch'](function(e){if(e.name === 'NotAllowedError'){eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_NOT_ALLOWED);}log('Caught pending play exception - continuing (' + e + ')');});}}}function isPaused(){return element?element.paused:null;}function pause(){if(element){element.pause();element.autoplay = false;}}function isSeeking(){return element?element.seeking:null;}function getTime(){return element?element.currentTime:null;}function getPlaybackRate(){return element?element.playbackRate:null;}function getPlayedRanges(){return element?element.played:null;}function getEnded(){return element?element.ended:null;}function addEventListener(eventName,eventCallBack){if(element){element.addEventListener(eventName,eventCallBack);}}function removeEventListener(eventName,eventCallBack){if(element){element.removeEventListener(eventName,eventCallBack);}}function getReadyState(){return element?element.readyState:NaN;}function getBufferRange(){return element?element.buffered:null;}function getClientWidth(){return element?element.clientWidth:NaN;}function getClientHeight(){return element?element.clientHeight:NaN;}function getVideoWidth(){return element?element.videoWidth:NaN;}function getVideoHeight(){return element?element.videoHeight:NaN;}function getVideoRelativeOffsetTop(){return element && element.parentNode?element.getBoundingClientRect().top - element.parentNode.getBoundingClientRect().top:NaN;}function getVideoRelativeOffsetLeft(){return element && element.parentNode?element.getBoundingClientRect().left - element.parentNode.getBoundingClientRect().left:NaN;}function getTextTracks(){return element?element.textTracks:[];}function getTextTrack(kind,label,lang,isTTML,isEmbedded){if(element){for(var i=0;i < element.textTracks.length;i++) { //label parameter could be a number (due to adaptationSet), but label, the attribute of textTrack, is a string => to modify...
	//label could also be undefined (due to adaptationSet)
	if(element.textTracks[i].kind === kind && (label?element.textTracks[i].label == label:true) && element.textTracks[i].language === lang && element.textTracks[i].isTTML === isTTML && element.textTracks[i].isEmbedded === isEmbedded){return element.textTracks[i];}}}return null;}function addTextTrack(kind,label,lang){if(element){return element.addTextTrack(kind,label,lang);}return null;}function appendChild(childElement){if(element){element.appendChild(childElement); //in Chrome, we need to differenciate textTrack with same lang, kind and label but different format (vtt, ttml, etc...)
	if(childElement.isTTML !== undefined){element.textTracks[element.textTracks.length - 1].isTTML = childElement.isTTML;element.textTracks[element.textTracks.length - 1].isEmbedded = childElement.isEmbedded;}}}function removeChild(childElement){if(element){element.removeChild(childElement);}}instance = {initialize:initialize,setCurrentTime:setCurrentTime,play:play,isPaused:isPaused,pause:pause,isSeeking:isSeeking,getTime:getTime,getPlaybackRate:getPlaybackRate,getPlayedRanges:getPlayedRanges,getEnded:getEnded,setStallState:setStallState,getElement:getElement,setElement:setElement,setSource:setSource,getSource:getSource,getVideoContainer:getVideoContainer,setVideoContainer:setVideoContainer,getTTMLRenderingDiv:getTTMLRenderingDiv,setTTMLRenderingDiv:setTTMLRenderingDiv,getPlaybackQuality:getPlaybackQuality,addEventListener:addEventListener,removeEventListener:removeEventListener,getReadyState:getReadyState,getBufferRange:getBufferRange,getClientWidth:getClientWidth,getClientHeight:getClientHeight,getTextTracks:getTextTracks,getTextTrack:getTextTrack,addTextTrack:addTextTrack,appendChild:appendChild,removeChild:removeChild,getVideoWidth:getVideoWidth,getVideoHeight:getVideoHeight,getVideoRelativeOffsetTop:getVideoRelativeOffsetTop,getVideoRelativeOffsetLeft:getVideoRelativeOffsetLeft,reset:reset};return instance;}VideoModel.__dashjs_factory_name = 'VideoModel';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(VideoModel);module.exports = exports['default'];
	//# sourceMappingURL=VideoModel.js.map


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _utilsBoxParser=__webpack_require__(68);var _utilsBoxParser2=_interopRequireDefault(_utilsBoxParser); /**
	* @module FetchLoader
	* @description Manages download of resources via HTTP using fetch.
	* @param {Object} cfg - dependencies from parent
	*/function FetchLoader(cfg){cfg = cfg || {};var requestModifier=cfg.requestModifier;var instance=undefined;function load(httpRequest){ // Variables will be used in the callback functions
	var firstProgress=true; /*jshint ignore:line*/var needFailureReport=true; /*jshint ignore:line*/var requestStartTime=new Date();var lastTraceTime=requestStartTime; /*jshint ignore:line*/var lastTraceReceivedCount=0; /*jshint ignore:line*/var request=httpRequest.request;var headers=new Headers(); /*jshint ignore:line*/if(request.range){headers.append('Range','bytes=' + request.range);}if(!request.requestStartDate){request.requestStartDate = requestStartTime;}if(requestModifier){ // modifyRequestHeader expects a XMLHttpRequest object so,
	// to keep backward compatibility, we should expose a setRequestHeader method
	// TODO: Remove RequestModifier dependency on XMLHttpRequest object and define
	// a more generic way to intercept/modify requests
	requestModifier.modifyRequestHeader({setRequestHeader:function setRequestHeader(header,value){headers.append(header,value);}});}var abortController=undefined;if(typeof window.AbortController === 'function'){abortController = new AbortController(); /*jshint ignore:line*/httpRequest.abortController = abortController;}var reqOptions={method:httpRequest.method,headers:headers,credentials:httpRequest.withCredentials?'include':undefined,signal:abortController?abortController.signal:undefined};fetch(httpRequest.url,reqOptions).then(function(response){if(!httpRequest.response){httpRequest.response = {};}httpRequest.response.status = response.status;httpRequest.response.statusText = response.statusText;httpRequest.response.responseURL = response.url;if(!response.ok){httpRequest.onerror();}var responseHeaders='';var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=response.headers.keys()[Symbol.iterator](),_step;!(_iteratorNormalCompletion = (_step = _iterator.next()).done);_iteratorNormalCompletion = true) {var key=_step.value;responseHeaders += key + ': ' + response.headers.get(key) + '\n';}}catch(err) {_didIteratorError = true;_iteratorError = err;}finally {try{if(!_iteratorNormalCompletion && _iterator['return']){_iterator['return']();}}finally {if(_didIteratorError){throw _iteratorError;}}}httpRequest.response.responseHeaders = responseHeaders;if(!response.body){ // Fetch returning a ReadableStream response body is not currently supported by all browsers.
	// Browser compatibility: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
	// If it is not supported, returning the whole segment when it's ready (as xhr)
	return response.arrayBuffer().then(function(buffer){httpRequest.response.response = buffer;var event={loaded:buffer.byteLength,total:buffer.byteLength};httpRequest.progress(event);httpRequest.onload();httpRequest.onend();return;});}var totalBytes=parseInt(response.headers.get('Content-Length'),10);var bytesReceived=0;var signaledFirstByte=false;var remaining=new Uint8Array();var offset=0;httpRequest.reader = response.body.getReader();var processResult=function processResult(_ref){var value=_ref.value;var done=_ref.done;if(done){if(remaining){ // If there is pending data, call progress so network metrics
	// are correctly generated
	// Same structure as https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequestEventTarget/onprogress
	httpRequest.progress({loaded:bytesReceived,total:isNaN(totalBytes)?bytesReceived:totalBytes,lengthComputable:true});httpRequest.response.response = remaining.buffer;}httpRequest.onload();httpRequest.onend();return;}if(value && value.length > 0){remaining = concatTypedArray(remaining,value);bytesReceived += value.length;var boxesInfo=(0,_utilsBoxParser2['default'])().getInstance().findLastTopIsoBoxCompleted(['moov','mdat'],remaining,offset);if(boxesInfo.found){var end=boxesInfo.lastCompletedOffset + boxesInfo.size; // If we are going to pass full buffer, avoid copying it and pass
	// complete buffer. Otherwise clone the part of the buffer that is completed
	// and adjust remaining buffer. A clone is needed because ArrayBuffer of a typed-array
	// keeps a reference to the original data
	var data=undefined;if(end === remaining.length){data = remaining;remaining = new Uint8Array();}else {data = new Uint8Array(remaining.subarray(0,end));remaining = remaining.subarray(end);} // Announce progress but don't track traces. Throughput measures are quite unstable
	// when they are based in small amount of data
	httpRequest.progress({data:data.buffer,lengthComputable:false,noTrace:true});offset = 0;}else {offset = boxesInfo.lastCompletedOffset; // Call progress so it generates traces that will be later used to know when the first byte
	// were received
	if(!signaledFirstByte){httpRequest.progress({lengthComputable:false,noTrace:true});signaledFirstByte = true;}}}read(httpRequest,processResult);};read(httpRequest,processResult);})['catch'](function(e){if(httpRequest.onerror){httpRequest.onerror(e);}});}function read(httpRequest,processResult){httpRequest.reader.read().then(processResult)['catch'](function(){ // don't do nothing. Manage this error in fetch method promise
	});}function concatTypedArray(remaining,data){if(remaining.length === 0){return data;}var result=new Uint8Array(remaining.length + data.length);result.set(remaining);result.set(data,remaining.length);return result;}function abort(request){if(request.abortController){ // For firefox and edge
	request.abortController.abort();}else if(request.reader){ // For Chrome
	try{request.reader.cancel();}catch(e) { // throw exceptions (TypeError) when reader was previously closed,
	// for example, because a network issue
	}}}instance = {load:load,abort:abort};return instance;}FetchLoader.__dashjs_factory_name = 'FetchLoader';var factory=_coreFactoryMaker2['default'].getClassFactory(FetchLoader);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=FetchLoader.js.map


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker); /**
	 * @module XHRLoader
	 * @description Manages download of resources via HTTP.
	 * @param {Object} cfg - dependencies from parent
	 */function XHRLoader(cfg){cfg = cfg || {};var requestModifier=cfg.requestModifier;var instance=undefined;function load(httpRequest){ // Variables will be used in the callback functions
	var firstProgress=true; /*jshint ignore:line*/var needFailureReport=true; /*jshint ignore:line*/var requestStartTime=new Date();var lastTraceTime=requestStartTime; /*jshint ignore:line*/var lastTraceReceivedCount=0; /*jshint ignore:line*/var request=httpRequest.request;var xhr=new XMLHttpRequest();xhr.open(httpRequest.method,httpRequest.url,true);if(request.responseType){xhr.responseType = request.responseType;}if(request.range){xhr.setRequestHeader('Range','bytes=' + request.range);}if(!request.requestStartDate){request.requestStartDate = requestStartTime;}if(requestModifier){xhr = requestModifier.modifyRequestHeader(xhr);}xhr.withCredentials = httpRequest.withCredentials;xhr.onload = httpRequest.onload;xhr.onloadend = httpRequest.onend;xhr.onerror = httpRequest.onerror;xhr.onprogress = httpRequest.progress;xhr.onabort = httpRequest.onabort;xhr.send();httpRequest.response = xhr;}function abort(request){request.response.abort();}instance = {load:load,abort:abort};return instance;}XHRLoader.__dashjs_factory_name = 'XHRLoader';var factory=_coreFactoryMaker2['default'].getClassFactory(XHRLoader);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=XHRLoader.js.map


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _controllersProtectionController=__webpack_require__(375);var _controllersProtectionController2=_interopRequireDefault(_controllersProtectionController);var _controllersProtectionKeyController=__webpack_require__(67);var _controllersProtectionKeyController2=_interopRequireDefault(_controllersProtectionKeyController);var _ProtectionEvents=__webpack_require__(374);var _ProtectionEvents2=_interopRequireDefault(_ProtectionEvents);var _modelsProtectionModel_21Jan2015=__webpack_require__(381);var _modelsProtectionModel_21Jan20152=_interopRequireDefault(_modelsProtectionModel_21Jan2015);var _modelsProtectionModel_3Feb2014=__webpack_require__(382);var _modelsProtectionModel_3Feb20142=_interopRequireDefault(_modelsProtectionModel_3Feb2014);var _modelsProtectionModel_01b=__webpack_require__(380);var _modelsProtectionModel_01b2=_interopRequireDefault(_modelsProtectionModel_01b);var APIS_ProtectionModel_01b=[ // Un-prefixed as per spec
	{ // Video Element
	generateKeyRequest:'generateKeyRequest',addKey:'addKey',cancelKeyRequest:'cancelKeyRequest', // Events
	needkey:'needkey',keyerror:'keyerror',keyadded:'keyadded',keymessage:'keymessage'}, // Webkit-prefixed (early Chrome versions and Chrome with EME disabled in chrome://flags)
	{ // Video Element
	generateKeyRequest:'webkitGenerateKeyRequest',addKey:'webkitAddKey',cancelKeyRequest:'webkitCancelKeyRequest', // Events
	needkey:'webkitneedkey',keyerror:'webkitkeyerror',keyadded:'webkitkeyadded',keymessage:'webkitkeymessage'}];var APIS_ProtectionModel_3Feb2014=[ // Un-prefixed as per spec
	// Chrome 38-39 (and some earlier versions) with chrome://flags -- Enable Encrypted Media Extensions
	{ // Video Element
	setMediaKeys:'setMediaKeys', // MediaKeys
	MediaKeys:'MediaKeys', // MediaKeySession
	release:'close', // Events
	needkey:'needkey',error:'keyerror',message:'keymessage',ready:'keyadded',close:'keyclose'}, // MS-prefixed (IE11, Windows 8.1)
	{ // Video Element
	setMediaKeys:'msSetMediaKeys', // MediaKeys
	MediaKeys:'MSMediaKeys', // MediaKeySession
	release:'close', // Events
	needkey:'msneedkey',error:'mskeyerror',message:'mskeymessage',ready:'mskeyadded',close:'mskeyclose'}];function Protection(){var instance=undefined;var context=this.context; /**
	     * Create a ProtectionController and associated ProtectionModel for use with
	     * a single piece of content.
	     *
	     * @param {Object} config
	     * @return {ProtectionController} protection controller
	     *
	     */function createProtectionSystem(config){var controller=null;var protectionKeyController=(0,_controllersProtectionKeyController2['default'])(context).getInstance();protectionKeyController.setConfig({log:config.log,BASE64:config.BASE64});protectionKeyController.initialize();var protectionModel=getProtectionModel(config);if(!controller && protectionModel){ //TODO add ability to set external controller if still needed at all?
	controller = (0,_controllersProtectionController2['default'])(context).create({protectionModel:protectionModel,protectionKeyController:protectionKeyController,eventBus:config.eventBus,log:config.log,events:config.events,BASE64:config.BASE64,constants:config.constants});config.capabilities.setEncryptedMediaSupported(true);}return controller;}function getProtectionModel(config){var log=config.log;var eventBus=config.eventBus;var errHandler=config.errHandler;var videoElement=config.videoModel?config.videoModel.getElement():null;if((!videoElement || videoElement.onencrypted !== undefined) && (!videoElement || videoElement.mediaKeys !== undefined)){log('EME detected on this user agent! (ProtectionModel_21Jan2015)');return (0,_modelsProtectionModel_21Jan20152['default'])(context).create({log:log,eventBus:eventBus,events:config.events});}else if(getAPI(videoElement,APIS_ProtectionModel_3Feb2014)){log('EME detected on this user agent! (ProtectionModel_3Feb2014)');return (0,_modelsProtectionModel_3Feb20142['default'])(context).create({log:log,eventBus:eventBus,events:config.events,api:getAPI(videoElement,APIS_ProtectionModel_3Feb2014)});}else if(getAPI(videoElement,APIS_ProtectionModel_01b)){log('EME detected on this user agent! (ProtectionModel_01b)');return (0,_modelsProtectionModel_01b2['default'])(context).create({log:log,eventBus:eventBus,errHandler:errHandler,events:config.events,api:getAPI(videoElement,APIS_ProtectionModel_01b)});}else {log('No supported version of EME detected on this user agent! - Attempts to play encrypted content will fail!');return null;}}function getAPI(videoElement,apis){for(var i=0;i < apis.length;i++) {var api=apis[i]; // detect if api is supported by browser
	// check only first function in api -> should be fine
	if(typeof videoElement[api[Object.keys(api)[0]]] !== 'function'){continue;}return api;}return null;}instance = {createProtectionSystem:createProtectionSystem};return instance;}Protection.__dashjs_factory_name = 'Protection';var factory=dashjs.FactoryMaker.getClassFactory(Protection); /* jshint ignore:line */factory.events = _ProtectionEvents2['default'];dashjs.FactoryMaker.updateClassFactory(Protection.__dashjs_factory_name,factory); /* jshint ignore:line */exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=Protection.js.map


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _coreEventsEventsBase=__webpack_require__(62);var _coreEventsEventsBase2=_interopRequireDefault(_coreEventsEventsBase); /**
	 * @class
	 *
	 */var ProtectionEvents=(function(_EventsBase){_inherits(ProtectionEvents,_EventsBase); /**
	     * @description Public facing external events to be used when including protection package.
	     * All public events will be aggregated into the MediaPlayerEvents Class and can be accessed
	     * via MediaPlayer.events.  public_ is the prefix that we use to move event names to MediaPlayerEvents.
	     */function ProtectionEvents(){_classCallCheck(this,ProtectionEvents);_get(Object.getPrototypeOf(ProtectionEvents.prototype),'constructor',this).call(this); /**
	         * Event ID for events delivered when the protection set receives
	         * a key message from the CDM
	         *
	         * @ignore
	         */this.INTERNAL_KEY_MESSAGE = 'internalKeyMessage'; /**
	         * Event ID for events delivered when a key system selection procedure
	         * completes
	         * @ignore
	         */this.INTERNAL_KEY_SYSTEM_SELECTED = 'internalKeySystemSelected'; /**
	         * Event ID for events delivered when the status of one decryption keys has changed
	         * @ignore
	         */this.INTERNAL_KEY_STATUS_CHANGED = 'internalkeyStatusChanged'; /**
	         * Event ID for events delivered when a new key has been added
	         *
	         * @constant
	         * @deprecated The latest versions of the EME specification no longer
	         * use this event.  {@MediaPlayer.models.protectionModel.eventList.KEY_STATUSES_CHANGED}
	         * is preferred.
	         * @event ProtectionEvents#KEY_ADDED
	         */this.KEY_ADDED = 'public_keyAdded'; /**
	         * Event ID for events delivered when an error is encountered by the CDM
	         * while processing a license server response message
	         * @event ProtectionEvents#KEY_ERROR
	         */this.KEY_ERROR = 'public_keyError'; /**
	         * Event ID for events delivered when the protection set receives
	         * a key message from the CDM
	         * @event ProtectionEvents#KEY_MESSAGE
	         */this.KEY_MESSAGE = 'public_keyMessage'; /**
	         * Event ID for events delivered when a key session close
	         * process has completed
	         * @event ProtectionEvents#KEY_SESSION_CLOSED
	         */this.KEY_SESSION_CLOSED = 'public_keySessionClosed'; /**
	         * Event ID for events delivered when a new key sessions creation
	         * process has completed
	         * @event ProtectionEvents#KEY_SESSION_CREATED
	         */this.KEY_SESSION_CREATED = 'public_keySessionCreated'; /**
	         * Event ID for events delivered when a key session removal
	         * process has completed
	         * @event ProtectionEvents#KEY_SESSION_REMOVED
	         */this.KEY_SESSION_REMOVED = 'public_keySessionRemoved'; /**
	         * Event ID for events delivered when the status of one or more
	         * decryption keys has changed
	         * @event ProtectionEvents#KEY_STATUSES_CHANGED
	         */this.KEY_STATUSES_CHANGED = 'public_keyStatusesChanged'; /**
	         * Event ID for events delivered when a key system access procedure
	         * has completed
	         * @ignore
	         */this.KEY_SYSTEM_ACCESS_COMPLETE = 'public_keySystemAccessComplete'; /**
	         * Event ID for events delivered when a key system selection procedure
	         * completes
	         * @event ProtectionEvents#KEY_SYSTEM_SELECTED
	         */this.KEY_SYSTEM_SELECTED = 'public_keySystemSelected'; /**
	         * Event ID for events delivered when a license request procedure
	         * has completed
	         * @event ProtectionEvents#LICENSE_REQUEST_COMPLETE
	         */this.LICENSE_REQUEST_COMPLETE = 'public_licenseRequestComplete'; /**
	         * Event ID for needkey/encrypted events
	         * @ignore
	         */this.NEED_KEY = 'needkey'; /**
	         * Event ID for events delivered when the Protection system is detected and created.
	         * @event ProtectionEvents#PROTECTION_CREATED
	         */this.PROTECTION_CREATED = 'public_protectioncreated'; /**
	         * Event ID for events delivered when the Protection system is destroyed.
	         * @event ProtectionEvents#PROTECTION_DESTROYED
	         */this.PROTECTION_DESTROYED = 'public_protectiondestroyed'; /**
	         * Event ID for events delivered when a new server certificate has
	         * been delivered to the CDM
	         * @ignore
	         */this.SERVER_CERTIFICATE_UPDATED = 'serverCertificateUpdated'; /**
	         * Event ID for events delivered when the process of shutting down
	         * a protection set has completed
	         * @ignore
	         */this.TEARDOWN_COMPLETE = 'protectionTeardownComplete'; /**
	         * Event ID for events delivered when a HTMLMediaElement has been
	         * associated with the protection set
	         * @ignore
	         */this.VIDEO_ELEMENT_SELECTED = 'videoElementSelected';}return ProtectionEvents;})(_coreEventsEventsBase2['default']);var protectionEvents=new ProtectionEvents();exports['default'] = protectionEvents;module.exports = exports['default'];
	//# sourceMappingURL=ProtectionEvents.js.map


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _CommonEncryption=__webpack_require__(42);var _CommonEncryption2=_interopRequireDefault(_CommonEncryption);var _voMediaCapability=__webpack_require__(387);var _voMediaCapability2=_interopRequireDefault(_voMediaCapability);var _voKeySystemConfiguration=__webpack_require__(93);var _voKeySystemConfiguration2=_interopRequireDefault(_voKeySystemConfiguration); /**
	 * @module ProtectionController
	 * @description Provides access to media protection information and functionality.  Each
	 * ProtectionController manages a single {@link MediaPlayer.models.ProtectionModel}
	 * which encapsulates a set of protection information (EME APIs, selected key system,
	 * key sessions).  The APIs of ProtectionController mostly align with the latest EME
	 * APIs.  Key system selection is mostly automated when combined with app-overrideable
	 * functionality provided in {@link ProtectionKeyController}.
	 * @todo ProtectionController does almost all of its tasks automatically after init() is
	 * called.  Applications might want more control over this process and want to go through
	 * each step manually (key system selection, session creation, session maintenance).
	 * @param {Object} config
	 */function ProtectionController(config){config = config || {};var protectionKeyController=config.protectionKeyController;var protectionModel=config.protectionModel;var eventBus=config.eventBus;var events=config.events;var log=config.log;var BASE64=config.BASE64;var constants=config.constants;var instance=undefined,pendingNeedKeyData=undefined,mediaInfoArr=undefined,protDataSet=undefined,sessionType=undefined,robustnessLevel=undefined,keySystem=undefined;function setup(){pendingNeedKeyData = [];mediaInfoArr = [];sessionType = 'temporary';robustnessLevel = '';}function checkConfig(){if(!eventBus || !eventBus.hasOwnProperty('on') || !protectionKeyController || !protectionKeyController.hasOwnProperty('getSupportedKeySystemsFromContentProtection')){throw new Error('Missing config parameter(s)');}} /**
	     * Initialize this protection system with a given audio
	     * or video stream information.
	     *
	     * @param {StreamInfo} [mediaInfo] Media information
	     * @memberof module:ProtectionController
	     * @instance
	     * @todo This API will change when we have better support for allowing applications
	     * to select different adaptation sets for playback.  Right now it is clunky for
	     * applications to create {@link StreamInfo} with the right information,
	     */function initializeForMedia(mediaInfo){ // Not checking here if a session for similar KS/KID combination is already created
	// because still don't know which keysystem will be selected.
	// Once Keysystem is selected and before creating the session, we will do that check
	// so we create the strictly necessary DRM sessions
	if(!mediaInfo){throw new Error('mediaInfo can not be null or undefined');}checkConfig();eventBus.on(events.INTERNAL_KEY_MESSAGE,onKeyMessage,this);eventBus.on(events.INTERNAL_KEY_STATUS_CHANGED,onKeyStatusChanged,this);mediaInfoArr.push(mediaInfo); // ContentProtection elements are specified at the AdaptationSet level, so the CP for audio
	// and video will be the same.  Just use one valid MediaInfo object
	var supportedKS=protectionKeyController.getSupportedKeySystemsFromContentProtection(mediaInfo.contentProtection);if(supportedKS && supportedKS.length > 0){selectKeySystem(supportedKS,true);}} /**
	     * Returns a set of supported key systems and CENC initialization data
	     * from the given array of ContentProtection elements.  Only
	     * key systems that are supported by this player will be returned.
	     * Key systems are returned in priority order (highest first).
	     *
	     * @param {Array.<Object>} cps - array of content protection elements parsed
	     * from the manifest
	     * @returns {Array.<Object>} array of objects indicating which supported key
	     * systems were found.  Empty array is returned if no
	     * supported key systems were found
	     * @memberof module:ProtectionKeyController
	     * @instance
	     */function getSupportedKeySystemsFromContentProtection(cps){return protectionKeyController.getSupportedKeySystemsFromContentProtection(cps);} /**
	     * Create a new key session associated with the given initialization data from
	     * the MPD or from the PSSH box in the media
	     *
	     * @param {ArrayBuffer} initData the initialization data
	     * @param {Uint8Array} cdmData the custom data to provide to licenser
	     * @memberof module:ProtectionController
	     * @instance
	     * @fires ProtectionController#KeySessionCreated
	     * @todo In older versions of the EME spec, there was a one-to-one relationship between
	     * initialization data and key sessions.  That is no longer true in the latest APIs.  This
	     * API will need to modified (and a new "generateRequest(keySession, initData)" API created)
	     * to come up to speed with the latest EME standard
	     */function createKeySession(initData,cdmData){var initDataForKS=_CommonEncryption2['default'].getPSSHForKeySystem(keySystem,initData);var protData=getProtData(keySystem);if(initDataForKS){ // Check for duplicate initData
	var currentInitData=protectionModel.getAllInitData();for(var i=0;i < currentInitData.length;i++) {if(protectionKeyController.initDataEquals(initDataForKS,currentInitData[i])){log('DRM: Ignoring initData because we have already seen it!');return;}}try{protectionModel.createKeySession(initDataForKS,protData,getSessionType(keySystem),cdmData);}catch(error) {eventBus.trigger(events.KEY_SESSION_CREATED,{data:null,error:'Error creating key session! ' + error.message});}}else if(initData){protectionModel.createKeySession(initData,protData,getSessionType(keySystem),cdmData);}else {eventBus.trigger(events.KEY_SESSION_CREATED,{data:null,error:'Selected key system is ' + keySystem.systemString + '.  needkey/encrypted event contains no initData corresponding to that key system!'});}} /**
	     * Loads a key session with the given session ID from persistent storage.  This
	     * essentially creates a new key session
	     *
	     * @param {string} sessionID
	     * @param {string} initData
	     * @memberof module:ProtectionController
	     * @instance
	     * @fires ProtectionController#KeySessionCreated
	     */function loadKeySession(sessionID,initData){protectionModel.loadKeySession(sessionID,initData,getSessionType(keySystem));} /**
	     * Removes the given key session from persistent storage and closes the session
	     * as if {@link ProtectionController#closeKeySession}
	     * was called
	     *
	     * @param {SessionToken} sessionToken the session
	     * token
	     * @memberof module:ProtectionController
	     * @instance
	     * @fires ProtectionController#KeySessionRemoved
	     * @fires ProtectionController#KeySessionClosed
	     */function removeKeySession(sessionToken){protectionModel.removeKeySession(sessionToken);} /**
	     * Closes the key session and releases all associated decryption keys.  These
	     * keys will no longer be available for decrypting media
	     *
	     * @param {SessionToken} sessionToken the session
	     * token
	     * @memberof module:ProtectionController
	     * @instance
	     * @fires ProtectionController#KeySessionClosed
	     */function closeKeySession(sessionToken){protectionModel.closeKeySession(sessionToken);} /**
	     * Sets a server certificate for use by the CDM when signing key messages
	     * intended for a particular license server.  This will fire
	     * an error event if a key system has not yet been selected.
	     *
	     * @param {ArrayBuffer} serverCertificate a CDM-specific license server
	     * certificate
	     * @memberof module:ProtectionController
	     * @instance
	     * @fires ProtectionController#ServerCertificateUpdated
	     */function setServerCertificate(serverCertificate){protectionModel.setServerCertificate(serverCertificate);} /**
	     * Associate this protection system with the given HTMLMediaElement.  This
	     * causes the system to register for needkey/encrypted events from the given
	     * element and provides a destination for setting of MediaKeys
	     *
	     * @param {HTMLMediaElement} element the media element to which the protection
	     * system should be associated
	     * @memberof module:ProtectionController
	     * @instance
	     */function setMediaElement(element){if(element){protectionModel.setMediaElement(element);eventBus.on(events.NEED_KEY,onNeedKey,this);}else if(element === null){protectionModel.setMediaElement(element);eventBus.off(events.NEED_KEY,onNeedKey,this);}} /**
	     * Sets the session type to use when creating key sessions.  Either "temporary" or
	     * "persistent-license".  Default is "temporary".
	     *
	     * @param {string} value the session type
	     * @memberof module:ProtectionController
	     * @instance
	     */function setSessionType(value){sessionType = value;} /**
	     * Sets the robustness level for video and audio capabilities. Optional to remove Chrome warnings.
	     * Possible values are SW_SECURE_CRYPTO, SW_SECURE_DECODE, HW_SECURE_CRYPTO, HW_SECURE_CRYPTO, HW_SECURE_DECODE, HW_SECURE_ALL.
	     *
	     * @param {string} level the robustness level
	     * @memberof module:ProtectionController
	     * @instance
	     */function setRobustnessLevel(level){robustnessLevel = level;} /**
	     * Attach KeySystem-specific data to use for license acquisition with EME
	     *
	     * @param {Object} data an object containing property names corresponding to
	     * key system name strings (e.g. "org.w3.clearkey") and associated values
	     * being instances of {@link ProtectionData}
	     * @memberof module:ProtectionController
	     * @instance
	     */function setProtectionData(data){protDataSet = data;protectionKeyController.setProtectionData(data);} /**
	     * Destroys all protection data associated with this protection set.  This includes
	     * deleting all key sessions.  In the case of persistent key sessions, the sessions
	     * will simply be unloaded and not deleted.  Additionally, if this protection set is
	     * associated with a HTMLMediaElement, it will be detached from that element.
	     *
	     * @memberof module:ProtectionController
	     * @instance
	     */function reset(){eventBus.off(events.INTERNAL_KEY_MESSAGE,onKeyMessage,this);eventBus.off(events.INTERNAL_KEY_STATUS_CHANGED,onKeyStatusChanged,this);setMediaElement(null);keySystem = undefined; //TODO-Refactor look at why undefined is needed for this. refactor
	if(protectionModel){protectionModel.reset();protectionModel = null;}mediaInfoArr = [];} ///////////////
	// Private
	///////////////
	function getProtData(keySystem){var protData=null;if(keySystem){var keySystemString=keySystem.systemString;if(protDataSet){protData = keySystemString in protDataSet?protDataSet[keySystemString]:null;}}return protData;}function getKeySystemConfiguration(keySystem){var protData=getProtData(keySystem);var audioCapabilities=[];var videoCapabilities=[];var audioRobustness=protData && protData.audioRobustness && protData.audioRobustness.length > 0?protData.audioRobustness:robustnessLevel;var videoRobustness=protData && protData.videoRobustness && protData.videoRobustness.length > 0?protData.videoRobustness:robustnessLevel;var ksSessionType=getSessionType(keySystem);mediaInfoArr.forEach(function(media){if(media.type === constants.AUDIO){audioCapabilities.push(new _voMediaCapability2['default'](media.codec,audioRobustness));}else if(media.type === constants.VIDEO){videoCapabilities.push(new _voMediaCapability2['default'](media.codec,videoRobustness));}});return new _voKeySystemConfiguration2['default'](audioCapabilities,videoCapabilities,'optional',ksSessionType === 'temporary'?'optional':'required',[ksSessionType]);}function getSessionType(keySystem){var protData=getProtData(keySystem);var ksSessionType=protData && protData.sessionType?protData.sessionType:sessionType;return ksSessionType;}function selectKeySystem(supportedKS,fromManifest){var self=this;var requestedKeySystems=[];var ksIdx=undefined;if(keySystem){ // We have a key system
	for(ksIdx = 0;ksIdx < supportedKS.length;ksIdx++) {if(keySystem === supportedKS[ksIdx].ks){var _ret=(function(){requestedKeySystems.push({ks:supportedKS[ksIdx].ks,configs:[getKeySystemConfiguration(keySystem)]}); // Ensure that we would be granted key system access using the key
	// system and codec information
	var onKeySystemAccessComplete=function onKeySystemAccessComplete(event){eventBus.off(events.KEY_SYSTEM_ACCESS_COMPLETE,onKeySystemAccessComplete,self);if(event.error){if(!fromManifest){eventBus.trigger(events.KEY_SYSTEM_SELECTED,{error:'DRM: KeySystem Access Denied! -- ' + event.error});}}else {log('DRM: KeySystem Access Granted');eventBus.trigger(events.KEY_SYSTEM_SELECTED,{data:event.data});if(supportedKS[ksIdx].sessionId){ // Load MediaKeySession with sessionId
	loadKeySession(supportedKS[ksIdx].sessionId,supportedKS[ksIdx].initData);}else if(supportedKS[ksIdx].initData){ // Create new MediaKeySession with initData
	createKeySession(supportedKS[ksIdx].initData,supportedKS[ksIdx].cdmData);}}};eventBus.on(events.KEY_SYSTEM_ACCESS_COMPLETE,onKeySystemAccessComplete,self);protectionModel.requestKeySystemAccess(requestedKeySystems);return 'break';})();if(_ret === 'break')break;}}}else if(keySystem === undefined){var onKeySystemSelected;(function(){ // First time through, so we need to select a key system
	keySystem = null;pendingNeedKeyData.push(supportedKS); // Add all key systems to our request list since we have yet to select a key system
	for(var i=0;i < supportedKS.length;i++) {requestedKeySystems.push({ks:supportedKS[i].ks,configs:[getKeySystemConfiguration(supportedKS[i].ks)]});}var keySystemAccess=undefined;var onKeySystemAccessComplete=function onKeySystemAccessComplete(event){eventBus.off(events.KEY_SYSTEM_ACCESS_COMPLETE,onKeySystemAccessComplete,self);if(event.error){keySystem = undefined;eventBus.off(events.INTERNAL_KEY_SYSTEM_SELECTED,onKeySystemSelected,self);if(!fromManifest){eventBus.trigger(events.KEY_SYSTEM_SELECTED,{data:null,error:'DRM: KeySystem Access Denied! -- ' + event.error});}}else {keySystemAccess = event.data;log('DRM: KeySystem Access Granted (' + keySystemAccess.keySystem.systemString + ')!  Selecting key system...');protectionModel.selectKeySystem(keySystemAccess);}};onKeySystemSelected = function onKeySystemSelected(event){eventBus.off(events.INTERNAL_KEY_SYSTEM_SELECTED,onKeySystemSelected,self);eventBus.off(events.KEY_SYSTEM_ACCESS_COMPLETE,onKeySystemAccessComplete,self);if(!event.error){keySystem = protectionModel.getKeySystem();eventBus.trigger(events.KEY_SYSTEM_SELECTED,{data:keySystemAccess}); // Set server certificate from protData
	var protData=getProtData(keySystem);if(protData && protData.serverCertificate && protData.serverCertificate.length > 0){protectionModel.setServerCertificate(BASE64.decodeArray(protData.serverCertificate).buffer);}for(var i=0;i < pendingNeedKeyData.length;i++) {for(ksIdx = 0;ksIdx < pendingNeedKeyData[i].length;ksIdx++) {if(keySystem === pendingNeedKeyData[i][ksIdx].ks){ // For Clearkey: if parameters for generating init data was provided by the user, use them for generating
	// initData and overwrite possible initData indicated in encrypted event (EME)
	if(protectionKeyController.isClearKey(keySystem) && protData && protData.hasOwnProperty('clearkeys')){var initData={kids:Object.keys(protData.clearkeys)};pendingNeedKeyData[i][ksIdx].initData = new TextEncoder().encode(JSON.stringify(initData));}if(pendingNeedKeyData[i][ksIdx].sessionId){ // Load MediaKeySession with sessionId
	loadKeySession(pendingNeedKeyData[i][ksIdx].sessionId,pendingNeedKeyData[i][ksIdx].initData);}else if(pendingNeedKeyData[i][ksIdx].initData !== null){ // Create new MediaKeySession with initData
	createKeySession(pendingNeedKeyData[i][ksIdx].initData,pendingNeedKeyData[i][ksIdx].cdmData);}break;}}}}else {keySystem = undefined;if(!fromManifest){eventBus.trigger(events.KEY_SYSTEM_SELECTED,{data:null,error:'DRM: Error selecting key system! -- ' + event.error});}}};eventBus.on(events.INTERNAL_KEY_SYSTEM_SELECTED,onKeySystemSelected,self);eventBus.on(events.KEY_SYSTEM_ACCESS_COMPLETE,onKeySystemAccessComplete,self);protectionModel.requestKeySystemAccess(requestedKeySystems);})();}else { // We are in the process of selecting a key system, so just save the data
	pendingNeedKeyData.push(supportedKS);}}function sendLicenseRequestCompleteEvent(data,error){eventBus.trigger(events.LICENSE_REQUEST_COMPLETE,{data:data,error:error});}function onKeyStatusChanged(e){if(e.error){eventBus.trigger(events.KEY_STATUSES_CHANGED,{data:null,error:'DRM: KeyStatusChange error! -- ' + e.error});}else {log('DRM: key status = ' + e.status);}}function onKeyMessage(e){log('DRM: onKeyMessage');if(e.error){log(e.error);return;} // Dispatch event to applications indicating we received a key message
	var keyMessage=e.data;eventBus.trigger(events.KEY_MESSAGE,{data:keyMessage});var messageType=keyMessage.messageType?keyMessage.messageType:'license-request';var message=keyMessage.message;var sessionToken=keyMessage.sessionToken;var protData=getProtData(keySystem);var keySystemString=keySystem?keySystem.systemString:null;var licenseServerData=protectionKeyController.getLicenseServer(keySystem,protData,messageType);var eventData={sessionToken:sessionToken,messageType:messageType}; // Ensure message from CDM is not empty
	if(!message || message.byteLength === 0){sendLicenseRequestCompleteEvent(eventData,'DRM: Empty key message from CDM');return;} // Message not destined for license server
	if(!licenseServerData){log('DRM: License server request not required for this message (type = ' + e.data.messageType + ').  Session ID = ' + sessionToken.getSessionID());sendLicenseRequestCompleteEvent(eventData);return;} // Perform any special handling for ClearKey
	if(protectionKeyController.isClearKey(keySystem)){var clearkeys=protectionKeyController.processClearKeyLicenseRequest(keySystem,protData,message);if(clearkeys){log('DRM: ClearKey license request handled by application!');sendLicenseRequestCompleteEvent(eventData);protectionModel.updateKeySession(sessionToken,clearkeys);return;}} // All remaining key system scenarios require a request to a remote license server
	var xhr=new XMLHttpRequest(); // Determine license server URL
	var url=null;if(protData && protData.serverURL){var serverURL=protData.serverURL;if(typeof serverURL === 'string' && serverURL !== ''){url = serverURL;}else if(typeof serverURL === 'object' && serverURL.hasOwnProperty(messageType)){url = serverURL[messageType];}}else if(protData && protData.laURL && protData.laURL !== ''){ // TODO: Deprecated!
	url = protData.laURL;}else {url = keySystem.getLicenseServerURLFromInitData(_CommonEncryption2['default'].getPSSHData(sessionToken.initData));if(!url){url = e.data.laURL;}} // Possibly update or override the URL based on the message
	url = licenseServerData.getServerURLFromMessage(url,message,messageType); // Ensure valid license server URL
	if(!url){sendLicenseRequestCompleteEvent(eventData,'DRM: No license server URL specified!');return;}var reportError=function reportError(xhr,eventData,keySystemString,messageType){var errorMsg=xhr.response?licenseServerData.getErrorResponse(xhr.response,keySystemString,messageType):'NONE';sendLicenseRequestCompleteEvent(eventData,'DRM: ' + keySystemString + ' update, XHR complete. status is "' + xhr.statusText + '" (' + xhr.status + '), readyState is ' + xhr.readyState + '.  Response is ' + errorMsg);};xhr.open(licenseServerData.getHTTPMethod(messageType),url,true);xhr.responseType = licenseServerData.getResponseType(keySystemString,messageType);xhr.onload = function(){if(this.status == 200){var licenseMessage=licenseServerData.getLicenseMessage(this.response,keySystemString,messageType);if(licenseMessage !== null){sendLicenseRequestCompleteEvent(eventData);protectionModel.updateKeySession(sessionToken,licenseMessage);}else {reportError(this,eventData,keySystemString,messageType);}}else {reportError(this,eventData,keySystemString,messageType);}};xhr.onabort = function(){sendLicenseRequestCompleteEvent(eventData,'DRM: ' + keySystemString + ' update, XHR aborted. status is "' + this.statusText + '" (' + this.status + '), readyState is ' + this.readyState);};xhr.onerror = function(){sendLicenseRequestCompleteEvent(eventData,'DRM: ' + keySystemString + ' update, XHR error. status is "' + this.statusText + '" (' + this.status + '), readyState is ' + this.readyState);}; // Set optional XMLHttpRequest headers from protection data and message
	var updateHeaders=function updateHeaders(headers){if(headers){for(var key in headers) {if('authorization' === key.toLowerCase()){xhr.withCredentials = true;}xhr.setRequestHeader(key,headers[key]);}}};if(protData){updateHeaders(protData.httpRequestHeaders);}updateHeaders(keySystem.getRequestHeadersFromMessage(message)); // Overwrite withCredentials property from protData if present
	if(protData && typeof protData.withCredentials == 'boolean'){xhr.withCredentials = protData.withCredentials;}xhr.send(keySystem.getLicenseRequestFromMessage(message));}function onNeedKey(event){log('DRM: onNeedKey'); // Ignore non-cenc initData
	if(event.key.initDataType !== 'cenc'){log('DRM:  Only \'cenc\' initData is supported!  Ignoring initData of type: ' + event.key.initDataType);return;} // Some browsers return initData as Uint8Array (IE), some as ArrayBuffer (Chrome).
	// Convert to ArrayBuffer
	var abInitData=event.key.initData;if(ArrayBuffer.isView(abInitData)){abInitData = abInitData.buffer;} // If key system has already been selected and initData already seen, then do nothing
	if(keySystem){var initDataForKS=_CommonEncryption2['default'].getPSSHForKeySystem(keySystem,abInitData);if(initDataForKS){ // Check for duplicate initData
	var currentInitData=protectionModel.getAllInitData();for(var i=0;i < currentInitData.length;i++) {if(protectionKeyController.initDataEquals(initDataForKS,currentInitData[i])){log('DRM: Ignoring initData because we have already seen it!');return;}}}}log('DRM: initData:',String.fromCharCode.apply(null,new Uint8Array(abInitData)));var supportedKS=protectionKeyController.getSupportedKeySystems(abInitData,protDataSet);if(supportedKS.length === 0){log('DRM: Received needkey event with initData, but we don\'t support any of the key systems!');return;}selectKeySystem(supportedKS,false);}function getKeySystems(){return protectionKeyController?protectionKeyController.getKeySystems():[];}instance = {initializeForMedia:initializeForMedia,createKeySession:createKeySession,loadKeySession:loadKeySession,removeKeySession:removeKeySession,closeKeySession:closeKeySession,setServerCertificate:setServerCertificate,setMediaElement:setMediaElement,setSessionType:setSessionType,setRobustnessLevel:setRobustnessLevel,setProtectionData:setProtectionData,getSupportedKeySystemsFromContentProtection:getSupportedKeySystemsFromContentProtection,getKeySystems:getKeySystems,reset:reset};setup();return instance;}ProtectionController.__dashjs_factory_name = 'ProtectionController';exports['default'] = dashjs.FactoryMaker.getClassFactory(ProtectionController); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=ProtectionController.js.map


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _voKeyPair=__webpack_require__(91);var _voKeyPair2=_interopRequireDefault(_voKeyPair);var _voClearKeyKeySet=__webpack_require__(88);var _voClearKeyKeySet2=_interopRequireDefault(_voClearKeyKeySet);var _CommonEncryption=__webpack_require__(42);var _CommonEncryption2=_interopRequireDefault(_CommonEncryption);var _constantsProtectionConstants=__webpack_require__(35);var _constantsProtectionConstants2=_interopRequireDefault(_constantsProtectionConstants);var uuid='e2719d58-a985-b3c9-781a-b030af78d30e';var systemString=_constantsProtectionConstants2['default'].CLEARKEY_KEYSTEM_STRING;var schemeIdURI='urn:uuid:' + uuid;function KeySystemClearKey(config){config = config || {};var instance=undefined;var BASE64=config.BASE64; /**
	     * Returns desired clearkeys (as specified in the CDM message) from protection data
	     *
	     * @param {ProtectionData} protectionData the protection data
	     * @param {ArrayBuffer} message the ClearKey CDM message
	     * @returns {ClearKeyKeySet} the key set or null if none found
	     * @throws {Error} if a keyID specified in the CDM message was not found in the
	     * protection data
	     * @memberof KeySystemClearKey
	     */function getClearKeysFromProtectionData(protectionData,message){var clearkeySet=null;if(protectionData){ // ClearKey is the only system that does not require a license server URL, so we
	// handle it here when keys are specified in protection data
	var jsonMsg=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(message)));var keyPairs=[];for(var i=0;i < jsonMsg.kids.length;i++) {var clearkeyID=jsonMsg.kids[i];var clearkey=protectionData.clearkeys && protectionData.clearkeys.hasOwnProperty(clearkeyID)?protectionData.clearkeys[clearkeyID]:null;if(!clearkey){throw new Error('DRM: ClearKey keyID (' + clearkeyID + ') is not known!');} // KeyIDs from CDM are not base64 padded.  Keys may or may not be padded
	keyPairs.push(new _voKeyPair2['default'](clearkeyID,clearkey));}clearkeySet = new _voClearKeyKeySet2['default'](keyPairs);}return clearkeySet;}function getInitData(cp){return _CommonEncryption2['default'].parseInitDataFromContentProtection(cp,BASE64);}function getRequestHeadersFromMessage() /*message*/{return null;}function getLicenseRequestFromMessage(message){return new Uint8Array(message);}function getLicenseServerURLFromInitData() /*initData*/{return null;}function getCDMData(){return null;}function getSessionId() /*cp*/{return null;}instance = {uuid:uuid,schemeIdURI:schemeIdURI,systemString:systemString,getInitData:getInitData,getRequestHeadersFromMessage:getRequestHeadersFromMessage,getLicenseRequestFromMessage:getLicenseRequestFromMessage,getLicenseServerURLFromInitData:getLicenseServerURLFromInitData,getCDMData:getCDMData,getSessionId:getSessionId,getClearKeysFromProtectionData:getClearKeysFromProtectionData};return instance;}KeySystemClearKey.__dashjs_factory_name = 'KeySystemClearKey';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(KeySystemClearKey); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=KeySystemClearKey.js.map


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * Microsoft PlayReady DRM
	 *
	 * @class
	 * @implements KeySystem
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _CommonEncryption=__webpack_require__(42);var _CommonEncryption2=_interopRequireDefault(_CommonEncryption);var _constantsProtectionConstants=__webpack_require__(35);var _constantsProtectionConstants2=_interopRequireDefault(_constantsProtectionConstants);var uuid='9a04f079-9840-4286-ab92-e65be0885f95';var systemString=_constantsProtectionConstants2['default'].PLAYREADY_KEYSTEM_STRING;var schemeIdURI='urn:uuid:' + uuid;var PRCDMData='<PlayReadyCDMData type="LicenseAcquisition"><LicenseAcquisition version="1.0" Proactive="false"><CustomData encoding="base64encoded">%CUSTOMDATA%</CustomData></LicenseAcquisition></PlayReadyCDMData>';var protData=undefined;function KeySystemPlayReady(config){config = config || {};var instance=undefined;var messageFormat='utf16';var BASE64=config.BASE64;function checkConfig(){if(!BASE64 || !BASE64.hasOwnProperty('decodeArray') || !BASE64.hasOwnProperty('decodeArray')){throw new Error('Missing config parameter(s)');}}function getRequestHeadersFromMessage(message){var msg=undefined,xmlDoc=undefined;var headers={};var parser=new DOMParser();var dataview=messageFormat === 'utf16'?new Uint16Array(message):new Uint8Array(message);msg = String.fromCharCode.apply(null,dataview);xmlDoc = parser.parseFromString(msg,'application/xml');var headerNameList=xmlDoc.getElementsByTagName('name');var headerValueList=xmlDoc.getElementsByTagName('value');for(var i=0;i < headerNameList.length;i++) {headers[headerNameList[i].childNodes[0].nodeValue] = headerValueList[i].childNodes[0].nodeValue;} // some versions of the PlayReady CDM return 'Content' instead of 'Content-Type'.
	// this is NOT w3c conform and license servers may reject the request!
	// -> rename it to proper w3c definition!
	if(headers.hasOwnProperty('Content')){headers['Content-Type'] = headers.Content;delete headers.Content;}return headers;}function getLicenseRequestFromMessage(message){var msg=undefined,xmlDoc=undefined;var licenseRequest=null;var parser=new DOMParser();var dataview=messageFormat === 'utf16'?new Uint16Array(message):new Uint8Array(message);checkConfig();msg = String.fromCharCode.apply(null,dataview);xmlDoc = parser.parseFromString(msg,'application/xml');if(xmlDoc.getElementsByTagName('Challenge')[0]){var Challenge=xmlDoc.getElementsByTagName('Challenge')[0].childNodes[0].nodeValue;if(Challenge){licenseRequest = BASE64.decode(Challenge);}}return licenseRequest;}function getLicenseServerURLFromInitData(initData){if(initData){var data=new DataView(initData);var numRecords=data.getUint16(4,true);var offset=6;var parser=new DOMParser();for(var i=0;i < numRecords;i++) { // Parse the PlayReady Record header
	var recordType=data.getUint16(offset,true);offset += 2;var recordLength=data.getUint16(offset,true);offset += 2;if(recordType !== 0x0001){offset += recordLength;continue;}var recordData=initData.slice(offset,offset + recordLength);var record=String.fromCharCode.apply(null,new Uint16Array(recordData));var xmlDoc=parser.parseFromString(record,'application/xml'); // First try <LA_URL>
	if(xmlDoc.getElementsByTagName('LA_URL')[0]){var laurl=xmlDoc.getElementsByTagName('LA_URL')[0].childNodes[0].nodeValue;if(laurl){return laurl;}} // Optionally, try <LUI_URL>
	if(xmlDoc.getElementsByTagName('LUI_URL')[0]){var luiurl=xmlDoc.getElementsByTagName('LUI_URL')[0].childNodes[0].nodeValue;if(luiurl){return luiurl;}}}}return null;}function getInitData(cpData){ // * desc@ getInitData
	// *   generate PSSH data from PROHeader defined in MPD file
	// *   PSSH format:
	// *   size (4)
	// *   box type(PSSH) (8)
	// *   Protection SystemID (16)
	// *   protection system data size (4) - length of decoded PROHeader
	// *   decoded PROHeader data from MPD file
	var PSSHBoxType=new Uint8Array([0x70,0x73,0x73,0x68,0x00,0x00,0x00,0x00]); //'PSSH' 8 bytes
	var playreadySystemID=new Uint8Array([0x9a,0x04,0xf0,0x79,0x98,0x40,0x42,0x86,0xab,0x92,0xe6,0x5b,0xe0,0x88,0x5f,0x95]);var byteCursor=0;var uint8arraydecodedPROHeader=null;var PROSize=undefined,PSSHSize=undefined,PSSHBoxBuffer=undefined,PSSHBox=undefined,PSSHData=undefined;checkConfig(); // Handle common encryption PSSH
	if('pssh' in cpData){return _CommonEncryption2['default'].parseInitDataFromContentProtection(cpData,BASE64);} // Handle native MS PlayReady ContentProtection elements
	if('pro' in cpData){uint8arraydecodedPROHeader = BASE64.decodeArray(cpData.pro.__text);}else if('prheader' in cpData){uint8arraydecodedPROHeader = BASE64.decodeArray(cpData.prheader.__text);}else {return null;}PROSize = uint8arraydecodedPROHeader.length;PSSHSize = 0x4 + PSSHBoxType.length + playreadySystemID.length + 0x4 + PROSize;PSSHBoxBuffer = new ArrayBuffer(PSSHSize);PSSHBox = new Uint8Array(PSSHBoxBuffer);PSSHData = new DataView(PSSHBoxBuffer);PSSHData.setUint32(byteCursor,PSSHSize);byteCursor += 0x4;PSSHBox.set(PSSHBoxType,byteCursor);byteCursor += PSSHBoxType.length;PSSHBox.set(playreadySystemID,byteCursor);byteCursor += playreadySystemID.length;PSSHData.setUint32(byteCursor,PROSize);byteCursor += 0x4;PSSHBox.set(uint8arraydecodedPROHeader,byteCursor);byteCursor += PROSize;return PSSHBox.buffer;} /**
	     * It seems that some PlayReady implementations return their XML-based CDM
	     * messages using UTF16, while others return them as UTF8.  Use this function
	     * to modify the message format to expect when parsing CDM messages.
	     *
	     * @param {string} format the expected message format.  Either "utf8" or "utf16".
	     * @throws {Error} Specified message format is not one of "utf8" or "utf16"
	     */function setPlayReadyMessageFormat(format){if(format !== 'utf8' && format !== 'utf16'){throw new Error('Illegal PlayReady message format! -- ' + format);}messageFormat = format;} /**
	     * Initialize the Key system with protection data
	     * @param {Object} protectionData the protection data
	     */function init(protectionData){if(protectionData){protData = protectionData;}} /**
	     * Get Playready Custom data
	     */function getCDMData(){var customData=undefined,cdmData=undefined,cdmDataBytes=undefined,i=undefined;checkConfig();if(protData && protData.cdmData){ // Convert custom data into multibyte string
	customData = [];for(i = 0;i < protData.cdmData.length;++i) {customData.push(protData.cdmData.charCodeAt(i));customData.push(0);}customData = String.fromCharCode.apply(null,customData); // Encode in Base 64 the custom data string
	customData = BASE64.encode(customData); // Initialize CDM data with Base 64 encoded custom data
	// (see https://msdn.microsoft.com/en-us/library/dn457361.aspx)
	cdmData = PRCDMData.replace('%CUSTOMDATA%',customData); // Convert CDM data into multibyte characters
	cdmDataBytes = [];for(i = 0;i < cdmData.length;++i) {cdmDataBytes.push(cdmData.charCodeAt(i));cdmDataBytes.push(0);}return new Uint8Array(cdmDataBytes).buffer;}return null;}function getSessionId() /*cp*/{return null;}instance = {uuid:uuid,schemeIdURI:schemeIdURI,systemString:systemString,getInitData:getInitData,getRequestHeadersFromMessage:getRequestHeadersFromMessage,getLicenseRequestFromMessage:getLicenseRequestFromMessage,getLicenseServerURLFromInitData:getLicenseServerURLFromInitData,getCDMData:getCDMData,getSessionId:getSessionId,setPlayReadyMessageFormat:setPlayReadyMessageFormat,init:init};return instance;}KeySystemPlayReady.__dashjs_factory_name = 'KeySystemPlayReady';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(KeySystemPlayReady); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=KeySystemPlayReady.js.map


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _voKeyPair=__webpack_require__(91);var _voKeyPair2=_interopRequireDefault(_voKeyPair);var _voClearKeyKeySet=__webpack_require__(88);var _voClearKeyKeySet2=_interopRequireDefault(_voClearKeyKeySet);var _CommonEncryption=__webpack_require__(42);var _CommonEncryption2=_interopRequireDefault(_CommonEncryption);var _constantsProtectionConstants=__webpack_require__(35);var _constantsProtectionConstants2=_interopRequireDefault(_constantsProtectionConstants);var uuid='1077efec-c0b2-4d02-ace3-3c1e52e2fb4b';var systemString=_constantsProtectionConstants2['default'].CLEARKEY_KEYSTEM_STRING;var schemeIdURI='urn:uuid:' + uuid;function KeySystemW3CClearKey(config){var instance=undefined;var BASE64=config.BASE64;var log=config.log; /**
	     * Returns desired clearkeys (as specified in the CDM message) from protection data
	     *
	     * @param {ProtectionData} protectionData the protection data
	     * @param {ArrayBuffer} message the ClearKey CDM message
	     * @returns {ClearKeyKeySet} the key set or null if none found
	     * @throws {Error} if a keyID specified in the CDM message was not found in the
	     * protection data
	     * @memberof KeySystemClearKey
	     */function getClearKeysFromProtectionData(protectionData,message){var clearkeySet=null;if(protectionData){ // ClearKey is the only system that does not require a license server URL, so we
	// handle it here when keys are specified in protection data
	var jsonMsg=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(message)));var keyPairs=[];for(var i=0;i < jsonMsg.kids.length;i++) {var clearkeyID=jsonMsg.kids[i];var clearkey=protectionData.clearkeys && protectionData.clearkeys.hasOwnProperty(clearkeyID)?protectionData.clearkeys[clearkeyID]:null;if(!clearkey){throw new Error('DRM: ClearKey keyID (' + clearkeyID + ') is not known!');} // KeyIDs from CDM are not base64 padded.  Keys may or may not be padded
	keyPairs.push(new _voKeyPair2['default'](clearkeyID,clearkey));}clearkeySet = new _voClearKeyKeySet2['default'](keyPairs);log('Warning: ClearKey schemeIdURI is using W3C Common PSSH systemID (1077efec-c0b2-4d02-ace3-3c1e52e2fb4b) in Content Protection. See DASH-IF IOP v4.1 section 7.6.2.4');}return clearkeySet;}function getInitData(cp){return _CommonEncryption2['default'].parseInitDataFromContentProtection(cp,BASE64);}function getRequestHeadersFromMessage() /*message*/{return null;}function getLicenseRequestFromMessage(message){return new Uint8Array(message);}function getLicenseServerURLFromInitData() /*initData*/{return null;}function getCDMData(){return null;}function getSessionId() /*cp*/{return null;}instance = {uuid:uuid,schemeIdURI:schemeIdURI,systemString:systemString,getInitData:getInitData,getRequestHeadersFromMessage:getRequestHeadersFromMessage,getLicenseRequestFromMessage:getLicenseRequestFromMessage,getLicenseServerURLFromInitData:getLicenseServerURLFromInitData,getCDMData:getCDMData,getSessionId:getSessionId,getClearKeysFromProtectionData:getClearKeysFromProtectionData};return instance;}KeySystemW3CClearKey.__dashjs_factory_name = 'KeySystemW3CClearKey';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(KeySystemW3CClearKey); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=KeySystemW3CClearKey.js.map


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * Google Widevine DRM
	 *
	 * @class
	 * @implements MediaPlayer.dependencies.protection.KeySystem
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _CommonEncryption=__webpack_require__(42);var _CommonEncryption2=_interopRequireDefault(_CommonEncryption);var _constantsProtectionConstants=__webpack_require__(35);var _constantsProtectionConstants2=_interopRequireDefault(_constantsProtectionConstants);var uuid='edef8ba9-79d6-4ace-a3c8-27dcd51d21ed';var systemString=_constantsProtectionConstants2['default'].WIDEVINE_KEYSTEM_STRING;var schemeIdURI='urn:uuid:' + uuid;function KeySystemWidevine(config){config = config || {};var instance=undefined;var protData=null;var BASE64=config.BASE64;function init(protectionData){if(protectionData){protData = protectionData;}}function getInitData(cp){return _CommonEncryption2['default'].parseInitDataFromContentProtection(cp,BASE64);}function getRequestHeadersFromMessage() /*message*/{return null;}function getLicenseRequestFromMessage(message){return new Uint8Array(message);}function getLicenseServerURLFromInitData() /*initData*/{return null;}function getCDMData(){return null;}function getSessionId(cp){ // Get sessionId from protectionData or from manifest
	if(protData && protData.sessionId){return protData.sessionId;}else if(cp && cp.sessionId){return cp.sessionId;}return null;}instance = {uuid:uuid,schemeIdURI:schemeIdURI,systemString:systemString,init:init,getInitData:getInitData,getRequestHeadersFromMessage:getRequestHeadersFromMessage,getLicenseRequestFromMessage:getLicenseRequestFromMessage,getLicenseServerURLFromInitData:getLicenseServerURLFromInitData,getCDMData:getCDMData,getSessionId:getSessionId};return instance;}KeySystemWidevine.__dashjs_factory_name = 'KeySystemWidevine';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(KeySystemWidevine); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=KeySystemWidevine.js.map


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * Initial implementation of EME
	 *
	 * Implemented by Google Chrome prior to v36
	 *
	 * @implements ProtectionModel
	 * @class
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _controllersProtectionKeyController=__webpack_require__(67);var _controllersProtectionKeyController2=_interopRequireDefault(_controllersProtectionKeyController);var _voNeedKey=__webpack_require__(94);var _voNeedKey2=_interopRequireDefault(_voNeedKey);var _voKeyError=__webpack_require__(89);var _voKeyError2=_interopRequireDefault(_voKeyError);var _voKeyMessage=__webpack_require__(90);var _voKeyMessage2=_interopRequireDefault(_voKeyMessage);var _voKeySystemConfiguration=__webpack_require__(93);var _voKeySystemConfiguration2=_interopRequireDefault(_voKeySystemConfiguration);var _voKeySystemAccess=__webpack_require__(92);var _voKeySystemAccess2=_interopRequireDefault(_voKeySystemAccess);function ProtectionModel_01b(config){config = config || {};var context=this.context;var eventBus=config.eventBus; //Need to pass in here so we can use same instance since this is optional module
	var events=config.events;var log=config.log;var api=config.api;var errHandler=config.errHandler;var instance=undefined,videoElement=undefined,keySystem=undefined,protectionKeyController=undefined, // With this version of the EME APIs, sessionIDs are not assigned to
	// sessions until the first key message is received.  We are assuming
	// that in the case of multiple sessions, key messages will be received
	// in the order that generateKeyRequest() is called.
	// Holding spot for newly-created sessions until we determine whether or
	// not the CDM supports sessionIDs
	pendingSessions=undefined, // List of sessions that have been initialized.  Only the first position will
	// be used in the case that the CDM does not support sessionIDs
	sessions=undefined, // Not all CDMs support the notion of sessionIDs.  Without sessionIDs
	// there is no way for us to differentiate between sessions, therefore
	// we must only allow a single session.  Once we receive the first key
	// message we can set this flag to determine if more sessions are allowed
	moreSessionsAllowed=undefined, // This is our main event handler for all desired HTMLMediaElement events
	// related to EME.  These events are translated into our API-independent
	// versions of the same events
	eventHandler=undefined;function setup(){videoElement = null;keySystem = null;pendingSessions = [];sessions = [];protectionKeyController = (0,_controllersProtectionKeyController2['default'])(context).getInstance();eventHandler = createEventHandler();}function reset(){if(videoElement){removeEventListeners();}for(var i=0;i < sessions.length;i++) {closeKeySession(sessions[i]);}eventBus.trigger(events.TEARDOWN_COMPLETE);}function getKeySystem(){return keySystem;}function getAllInitData(){var retVal=[];for(var i=0;i < pendingSessions.length;i++) {retVal.push(pendingSessions[i].initData);}for(var i=0;i < sessions.length;i++) {retVal.push(sessions[i].initData);}return retVal;}function requestKeySystemAccess(ksConfigurations){var ve=videoElement;if(!ve){ // Must have a video element to do this capability tests
	ve = document.createElement('video');} // Try key systems in order, first one with supported key system configuration
	// is used
	var found=false;for(var ksIdx=0;ksIdx < ksConfigurations.length;ksIdx++) {var systemString=ksConfigurations[ksIdx].ks.systemString;var configs=ksConfigurations[ksIdx].configs;var supportedAudio=null;var supportedVideo=null; // Try key system configs in order, first one with supported audio/video
	// is used
	for(var configIdx=0;configIdx < configs.length;configIdx++) { //let audios = configs[configIdx].audioCapabilities;
	var videos=configs[configIdx].videoCapabilities; // Look for supported video container/codecs
	if(videos && videos.length !== 0){supportedVideo = []; // Indicates that we have a requested video config
	for(var videoIdx=0;videoIdx < videos.length;videoIdx++) {if(ve.canPlayType(videos[videoIdx].contentType,systemString) !== ''){supportedVideo.push(videos[videoIdx]);}}} // No supported audio or video in this configuration OR we have
	// requested audio or video configuration that is not supported
	if(!supportedAudio && !supportedVideo || supportedAudio && supportedAudio.length === 0 || supportedVideo && supportedVideo.length === 0){continue;} // This configuration is supported
	found = true;var ksConfig=new _voKeySystemConfiguration2['default'](supportedAudio,supportedVideo);var ks=protectionKeyController.getKeySystemBySystemString(systemString);eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE,{data:new _voKeySystemAccess2['default'](ks,ksConfig)});break;}}if(!found){eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE,{error:'Key system access denied! -- No valid audio/video content configurations detected!'});}}function selectKeySystem(keySystemAccess){keySystem = keySystemAccess.keySystem;eventBus.trigger(events.INTERNAL_KEY_SYSTEM_SELECTED);}function setMediaElement(mediaElement){if(videoElement === mediaElement){return;} // Replacing the previous element
	if(videoElement){removeEventListeners();}videoElement = mediaElement; // Only if we are not detaching from the existing element
	if(videoElement){videoElement.addEventListener(api.keyerror,eventHandler);videoElement.addEventListener(api.needkey,eventHandler);videoElement.addEventListener(api.keymessage,eventHandler);videoElement.addEventListener(api.keyadded,eventHandler);eventBus.trigger(events.VIDEO_ELEMENT_SELECTED);}}function createKeySession(initData /*, protData, keySystemType */){if(!keySystem){throw new Error('Can not create sessions until you have selected a key system');} // Determine if creating a new session is allowed
	if(moreSessionsAllowed || sessions.length === 0){var newSession={ // Implements SessionToken
	sessionID:null,initData:initData,getSessionID:function getSessionID(){return this.sessionID;},getExpirationTime:function getExpirationTime(){return NaN;},getSessionType:function getSessionType(){return 'temporary';}};pendingSessions.push(newSession); // Send our request to the CDM
	videoElement[api.generateKeyRequest](keySystem.systemString,new Uint8Array(initData));return newSession;}else {throw new Error('Multiple sessions not allowed!');}}function updateKeySession(sessionToken,message){var sessionID=sessionToken.sessionID;if(!protectionKeyController.isClearKey(keySystem)){ // Send our request to the CDM
	videoElement[api.addKey](keySystem.systemString,new Uint8Array(message),new Uint8Array(sessionToken.initData),sessionID);}else { // For clearkey, message is a ClearKeyKeySet
	for(var i=0;i < message.keyPairs.length;i++) {videoElement[api.addKey](keySystem.systemString,message.keyPairs[i].key,message.keyPairs[i].keyID,sessionID);}}}function closeKeySession(sessionToken){ // Send our request to the CDM
	videoElement[api.cancelKeyRequest](keySystem.systemString,sessionToken.sessionID);}function setServerCertificate() /*serverCertificate*/{ /* Not supported */}function loadKeySession() /*sessionID*/{ /* Not supported */}function removeKeySession() /*sessionToken*/{ /* Not supported */}function createEventHandler(){return {handleEvent:function handleEvent(event){var sessionToken=null;switch(event.type){case api.needkey:var initData=ArrayBuffer.isView(event.initData)?event.initData.buffer:event.initData;eventBus.trigger(events.NEED_KEY,{key:new _voNeedKey2['default'](initData,'cenc')});break;case api.keyerror:sessionToken = findSessionByID(sessions,event.sessionId);if(!sessionToken){sessionToken = findSessionByID(pendingSessions,event.sessionId);}if(sessionToken){var msg='';switch(event.errorCode.code){case 1:msg += 'MEDIA_KEYERR_UNKNOWN - An unspecified error occurred. This value is used for errors that don\'t match any of the other codes.';break;case 2:msg += 'MEDIA_KEYERR_CLIENT - The Key System could not be installed or updated.';break;case 3:msg += 'MEDIA_KEYERR_SERVICE - The message passed into update indicated an error from the license service.';break;case 4:msg += 'MEDIA_KEYERR_OUTPUT - There is no available output device with the required characteristics for the content protection system.';break;case 5:msg += 'MEDIA_KEYERR_HARDWARECHANGE - A hardware configuration change caused a content protection error.';break;case 6:msg += 'MEDIA_KEYERR_DOMAIN - An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.';break;}msg += '  System Code = ' + event.systemCode; // TODO: Build error string based on key error
	eventBus.trigger(events.KEY_ERROR,{data:new _voKeyError2['default'](sessionToken,msg)});}else {log('No session token found for key error');}break;case api.keyadded:sessionToken = findSessionByID(sessions,event.sessionId);if(!sessionToken){sessionToken = findSessionByID(pendingSessions,event.sessionId);}if(sessionToken){log('DRM: Key added.');eventBus.trigger(events.KEY_ADDED,{data:sessionToken}); //TODO not sure anything is using sessionToken? why there?
	}else {log('No session token found for key added');}break;case api.keymessage: // If this CDM does not support session IDs, we will be limited
	// to a single session
	moreSessionsAllowed = event.sessionId !== null && event.sessionId !== undefined; // SessionIDs supported
	if(moreSessionsAllowed){ // Attempt to find an uninitialized token with this sessionID
	sessionToken = findSessionByID(sessions,event.sessionId);if(!sessionToken && pendingSessions.length > 0){ // This is the first message for our latest session, so set the
	// sessionID and add it to our list
	sessionToken = pendingSessions.shift();sessions.push(sessionToken);sessionToken.sessionID = event.sessionId;}}else if(pendingSessions.length > 0){ // SessionIDs not supported
	sessionToken = pendingSessions.shift();sessions.push(sessionToken);if(pendingSessions.length !== 0){errHandler.mediaKeyMessageError('Multiple key sessions were creates with a user-agent that does not support sessionIDs!! Unpredictable behavior ahead!');}}if(sessionToken){var message=ArrayBuffer.isView(event.message)?event.message.buffer:event.message; // For ClearKey, the spec mandates that you pass this message to the
	// addKey method, so we always save it to the token since there is no
	// way to tell which key system is in use
	sessionToken.keyMessage = message;eventBus.trigger(events.INTERNAL_KEY_MESSAGE,{data:new _voKeyMessage2['default'](sessionToken,message,event.defaultURL)});}else {log('No session token found for key message');}break;}}};} /**
	     * Helper function to retrieve the stored session token based on a given
	     * sessionID value
	     *
	     * @param {Array} sessionArray - the array of sessions to search
	     * @param {*} sessionID - the sessionID to search for
	     * @returns {*} the session token with the given sessionID
	     */function findSessionByID(sessionArray,sessionID){if(!sessionID || !sessionArray){return null;}else {var len=sessionArray.length;for(var i=0;i < len;i++) {if(sessionArray[i].sessionID == sessionID){return sessionArray[i];}}return null;}}function removeEventListeners(){videoElement.removeEventListener(api.keyerror,eventHandler);videoElement.removeEventListener(api.needkey,eventHandler);videoElement.removeEventListener(api.keymessage,eventHandler);videoElement.removeEventListener(api.keyadded,eventHandler);}instance = {getAllInitData:getAllInitData,requestKeySystemAccess:requestKeySystemAccess,getKeySystem:getKeySystem,selectKeySystem:selectKeySystem,setMediaElement:setMediaElement,createKeySession:createKeySession,updateKeySession:updateKeySession,closeKeySession:closeKeySession,setServerCertificate:setServerCertificate,loadKeySession:loadKeySession,removeKeySession:removeKeySession,reset:reset};setup();return instance;}ProtectionModel_01b.__dashjs_factory_name = 'ProtectionModel_01b';exports['default'] = dashjs.FactoryMaker.getClassFactory(ProtectionModel_01b); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=ProtectionModel_01b.js.map


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * Most recent EME implementation
	 *
	 * Implemented by Google Chrome v36+ (Windows, OSX, Linux)
	 *
	 * @implements ProtectionModel
	 * @class
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _controllersProtectionKeyController=__webpack_require__(67);var _controllersProtectionKeyController2=_interopRequireDefault(_controllersProtectionKeyController);var _voNeedKey=__webpack_require__(94);var _voNeedKey2=_interopRequireDefault(_voNeedKey);var _voKeyError=__webpack_require__(89);var _voKeyError2=_interopRequireDefault(_voKeyError);var _voKeyMessage=__webpack_require__(90);var _voKeyMessage2=_interopRequireDefault(_voKeyMessage);var _voKeySystemAccess=__webpack_require__(92);var _voKeySystemAccess2=_interopRequireDefault(_voKeySystemAccess);var _constantsProtectionConstants=__webpack_require__(35);var _constantsProtectionConstants2=_interopRequireDefault(_constantsProtectionConstants);function ProtectionModel_21Jan2015(config){config = config || {};var context=this.context;var eventBus=config.eventBus; //Need to pass in here so we can use same instance since this is optional module
	var events=config.events;var log=config.log;var instance=undefined,keySystem=undefined,videoElement=undefined,mediaKeys=undefined,sessions=undefined,eventHandler=undefined,protectionKeyController=undefined;function setup(){keySystem = null;videoElement = null;mediaKeys = null;sessions = [];protectionKeyController = (0,_controllersProtectionKeyController2['default'])(context).getInstance();eventHandler = createEventHandler();}function reset(){var numSessions=sessions.length;var session=undefined;if(numSessions !== 0){(function(){ // Called when we are done closing a session.  Success or fail
	var done=function done(session){removeSession(session);if(sessions.length === 0){if(videoElement){videoElement.removeEventListener('encrypted',eventHandler);videoElement.setMediaKeys(null).then(function(){eventBus.trigger(events.TEARDOWN_COMPLETE);});}else {eventBus.trigger(events.TEARDOWN_COMPLETE);}}};for(var i=0;i < numSessions;i++) {session = sessions[i];(function(s){ // Override closed promise resolver
	session.session.closed.then(function(){done(s);}); // Close the session and handle errors, otherwise promise
	// resolver above will be called
	closeKeySessionInternal(session)['catch'](function(){done(s);});})(session);}})();}else {eventBus.trigger(events.TEARDOWN_COMPLETE);}}function getKeySystem(){return keySystem;}function getAllInitData(){var retVal=[];for(var i=0;i < sessions.length;i++) {if(sessions[i].initData){retVal.push(sessions[i].initData);}}return retVal;}function requestKeySystemAccess(ksConfigurations){requestKeySystemAccessInternal(ksConfigurations,0);}function selectKeySystem(keySystemAccess){keySystemAccess.mksa.createMediaKeys().then(function(mkeys){keySystem = keySystemAccess.keySystem;mediaKeys = mkeys;if(videoElement){videoElement.setMediaKeys(mediaKeys).then(function(){eventBus.trigger(events.INTERNAL_KEY_SYSTEM_SELECTED);});}else {eventBus.trigger(events.INTERNAL_KEY_SYSTEM_SELECTED);}})['catch'](function(){eventBus.trigger(events.INTERNAL_KEY_SYSTEM_SELECTED,{error:'Error selecting keys system (' + keySystemAccess.keySystem.systemString + ')! Could not create MediaKeys -- TODO'});});}function setMediaElement(mediaElement){if(videoElement === mediaElement)return; // Replacing the previous element
	if(videoElement){videoElement.removeEventListener('encrypted',eventHandler);if(videoElement.setMediaKeys){videoElement.setMediaKeys(null);}}videoElement = mediaElement; // Only if we are not detaching from the existing element
	if(videoElement){videoElement.addEventListener('encrypted',eventHandler);if(videoElement.setMediaKeys && mediaKeys){videoElement.setMediaKeys(mediaKeys);}}}function setServerCertificate(serverCertificate){if(!keySystem || !mediaKeys){throw new Error('Can not set server certificate until you have selected a key system');}mediaKeys.setServerCertificate(serverCertificate).then(function(){log('DRM: License server certificate successfully updated.');eventBus.trigger(events.SERVER_CERTIFICATE_UPDATED);})['catch'](function(error){eventBus.trigger(events.SERVER_CERTIFICATE_UPDATED,{error:'Error updating server certificate -- ' + error.name});});}function createKeySession(initData,protData,sessionType){if(!keySystem || !mediaKeys){throw new Error('Can not create sessions until you have selected a key system');}var session=mediaKeys.createSession(sessionType);var sessionToken=createSessionToken(session,initData,sessionType);var ks=this.getKeySystem(); // Generate initial key request.
	// keyids type is used for clearkey when keys are provided directly in the protection data and then request to a license server is not needed
	var dataType=ks.systemString === _constantsProtectionConstants2['default'].CLEARKEY_KEYSTEM_STRING && protData && protData.clearkeys?'keyids':'cenc';session.generateRequest(dataType,initData).then(function(){log('DRM: Session created.  SessionID = ' + sessionToken.getSessionID());eventBus.trigger(events.KEY_SESSION_CREATED,{data:sessionToken});})['catch'](function(error){ // TODO: Better error string
	removeSession(sessionToken);eventBus.trigger(events.KEY_SESSION_CREATED,{data:null,error:'Error generating key request -- ' + error.name});});}function updateKeySession(sessionToken,message){var session=sessionToken.session; // Send our request to the key session
	if(protectionKeyController.isClearKey(keySystem)){message = message.toJWK();}session.update(message)['catch'](function(error){eventBus.trigger(events.KEY_ERROR,{data:new _voKeyError2['default'](sessionToken,'Error sending update() message! ' + error.name)});});}function loadKeySession(sessionID,initData,sessionType){if(!keySystem || !mediaKeys){throw new Error('Can not load sessions until you have selected a key system');} // Check if session Id is not already loaded or loading
	for(var i=0;i < sessions.length;i++) {if(sessionID === sessions[i].sessionId){log('DRM: Ignoring session ID because we have already seen it!');return;}}var session=mediaKeys.createSession(sessionType);var sessionToken=createSessionToken(session,initData,sessionType,sessionID); // Load persisted session data into our newly created session object
	session.load(sessionID).then(function(success){if(success){log('DRM: Session loaded.  SessionID = ' + sessionToken.getSessionID());eventBus.trigger(events.KEY_SESSION_CREATED,{data:sessionToken});}else {removeSession(sessionToken);eventBus.trigger(events.KEY_SESSION_CREATED,{data:null,error:'Could not load session! Invalid Session ID (' + sessionID + ')'});}})['catch'](function(error){removeSession(sessionToken);eventBus.trigger(events.KEY_SESSION_CREATED,{data:null,error:'Could not load session (' + sessionID + ')! ' + error.name});});}function removeKeySession(sessionToken){var session=sessionToken.session;session.remove().then(function(){log('DRM: Session removed.  SessionID = ' + sessionToken.getSessionID());eventBus.trigger(events.KEY_SESSION_REMOVED,{data:sessionToken.getSessionID()});},function(error){eventBus.trigger(events.KEY_SESSION_REMOVED,{data:null,error:'Error removing session (' + sessionToken.getSessionID() + '). ' + error.name});});}function closeKeySession(sessionToken){ // Send our request to the key session
	closeKeySessionInternal(sessionToken)['catch'](function(error){removeSession(sessionToken);eventBus.trigger(events.KEY_SESSION_CLOSED,{data:null,error:'Error closing session (' + sessionToken.getSessionID() + ') ' + error.name});});}function requestKeySystemAccessInternal(ksConfigurations,idx){if(navigator.requestMediaKeySystemAccess === undefined || typeof navigator.requestMediaKeySystemAccess !== 'function'){eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE,{error:'Insecure origins are not allowed'});return;}(function(i){var keySystem=ksConfigurations[i].ks;var configs=ksConfigurations[i].configs;navigator.requestMediaKeySystemAccess(keySystem.systemString,configs).then(function(mediaKeySystemAccess){ // Chrome 40 does not currently implement MediaKeySystemAccess.getConfiguration()
	var configuration=typeof mediaKeySystemAccess.getConfiguration === 'function'?mediaKeySystemAccess.getConfiguration():null;var keySystemAccess=new _voKeySystemAccess2['default'](keySystem,configuration);keySystemAccess.mksa = mediaKeySystemAccess;eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE,{data:keySystemAccess});})['catch'](function(error){if(++i < ksConfigurations.length){requestKeySystemAccessInternal(ksConfigurations,i);}else {eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE,{error:'Key system access denied! ' + error.message});}});})(idx);}function closeKeySessionInternal(sessionToken){var session=sessionToken.session; // Remove event listeners
	session.removeEventListener('keystatuseschange',sessionToken);session.removeEventListener('message',sessionToken); // Send our request to the key session
	return session.close();} // This is our main event handler for all desired HTMLMediaElement events
	// related to EME.  These events are translated into our API-independent
	// versions of the same events
	function createEventHandler(){return {handleEvent:function handleEvent(event){switch(event.type){case 'encrypted':if(event.initData){var initData=ArrayBuffer.isView(event.initData)?event.initData.buffer:event.initData;eventBus.trigger(events.NEED_KEY,{key:new _voNeedKey2['default'](initData,event.initDataType)});}break;}}};}function removeSession(token){ // Remove from our session list
	for(var i=0;i < sessions.length;i++) {if(sessions[i] === token){sessions.splice(i,1);break;}}} // Function to create our session token objects which manage the EME
	// MediaKeySession and session-specific event handler
	function createSessionToken(session,initData,sessionType,sessionID){var token={ // Implements SessionToken
	session:session,initData:initData,sessionId:sessionID, // This is our main event handler for all desired MediaKeySession events
	// These events are translated into our API-independent versions of the
	// same events
	handleEvent:function handleEvent(event){switch(event.type){case 'keystatuseschange':eventBus.trigger(events.KEY_STATUSES_CHANGED,{data:this});event.target.keyStatuses.forEach(function(){ // Edge and Chrome implement different version of keystatues, param are not on same order
	var status=undefined,keyId=undefined;if(arguments && arguments.length > 0){if(arguments[0]){if(typeof arguments[0] === 'string'){status = arguments[0];}else {keyId = arguments[0];}}if(arguments[1]){if(typeof arguments[1] === 'string'){status = arguments[1];}else {keyId = arguments[1];}}}switch(status){case 'expired':eventBus.trigger(events.INTERNAL_KEY_STATUS_CHANGED,{error:'License has expired'});break;default:eventBus.trigger(events.INTERNAL_KEY_STATUS_CHANGED,{status:status,keyId:keyId});break;}});break;case 'message':var message=ArrayBuffer.isView(event.message)?event.message.buffer:event.message;eventBus.trigger(events.INTERNAL_KEY_MESSAGE,{data:new _voKeyMessage2['default'](this,message,undefined,event.messageType)});break;}},getSessionID:function getSessionID(){return session.sessionId;},getExpirationTime:function getExpirationTime(){return session.expiration;},getKeyStatuses:function getKeyStatuses(){return session.keyStatuses;},getSessionType:function getSessionType(){return sessionType;}}; // Add all event listeners
	session.addEventListener('keystatuseschange',token);session.addEventListener('message',token); // Register callback for session closed Promise
	session.closed.then(function(){removeSession(token);log('DRM: Session closed.  SessionID = ' + token.getSessionID());eventBus.trigger(events.KEY_SESSION_CLOSED,{data:token.getSessionID()});}); // Add to our session list
	sessions.push(token);return token;}instance = {getAllInitData:getAllInitData,requestKeySystemAccess:requestKeySystemAccess,getKeySystem:getKeySystem,selectKeySystem:selectKeySystem,setMediaElement:setMediaElement,setServerCertificate:setServerCertificate,createKeySession:createKeySession,updateKeySession:updateKeySession,loadKeySession:loadKeySession,removeKeySession:removeKeySession,closeKeySession:closeKeySession,reset:reset};setup();return instance;}ProtectionModel_21Jan2015.__dashjs_factory_name = 'ProtectionModel_21Jan2015';exports['default'] = dashjs.FactoryMaker.getClassFactory(ProtectionModel_21Jan2015); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=ProtectionModel_21Jan2015.js.map


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * Implementation of the EME APIs as of the 3 Feb 2014 state of the specification.
	 *
	 * Implemented by Internet Explorer 11 (Windows 8.1)
	 *
	 * @implements ProtectionModel
	 * @class
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _controllersProtectionKeyController=__webpack_require__(67);var _controllersProtectionKeyController2=_interopRequireDefault(_controllersProtectionKeyController);var _voNeedKey=__webpack_require__(94);var _voNeedKey2=_interopRequireDefault(_voNeedKey);var _voKeyError=__webpack_require__(89);var _voKeyError2=_interopRequireDefault(_voKeyError);var _voKeyMessage=__webpack_require__(90);var _voKeyMessage2=_interopRequireDefault(_voKeyMessage);var _voKeySystemConfiguration=__webpack_require__(93);var _voKeySystemConfiguration2=_interopRequireDefault(_voKeySystemConfiguration);var _voKeySystemAccess=__webpack_require__(92);var _voKeySystemAccess2=_interopRequireDefault(_voKeySystemAccess);function ProtectionModel_3Feb2014(config){config = config || {};var context=this.context;var eventBus=config.eventBus; //Need to pass in here so we can use same instance since this is optional module
	var events=config.events;var log=config.log;var api=config.api;var instance=undefined,videoElement=undefined,keySystem=undefined,mediaKeys=undefined,keySystemAccess=undefined,sessions=undefined,eventHandler=undefined,protectionKeyController=undefined;function setup(){videoElement = null;keySystem = null;mediaKeys = null;keySystemAccess = null;sessions = [];protectionKeyController = (0,_controllersProtectionKeyController2['default'])(context).getInstance();eventHandler = createEventHandler();}function reset(){try{for(var i=0;i < sessions.length;i++) {closeKeySession(sessions[i]);}if(videoElement){videoElement.removeEventListener(api.needkey,eventHandler);}eventBus.trigger(events.TEARDOWN_COMPLETE);}catch(error) {eventBus.trigger(events.TEARDOWN_COMPLETE,{error:'Error tearing down key sessions and MediaKeys! -- ' + error.message});}}function getKeySystem(){return keySystem;}function getAllInitData(){var retVal=[];for(var i=0;i < sessions.length;i++) {retVal.push(sessions[i].initData);}return retVal;}function requestKeySystemAccess(ksConfigurations){ // Try key systems in order, first one with supported key system configuration
	// is used
	var found=false;for(var ksIdx=0;ksIdx < ksConfigurations.length;ksIdx++) {var systemString=ksConfigurations[ksIdx].ks.systemString;var configs=ksConfigurations[ksIdx].configs;var supportedAudio=null;var supportedVideo=null; // Try key system configs in order, first one with supported audio/video
	// is used
	for(var configIdx=0;configIdx < configs.length;configIdx++) {var audios=configs[configIdx].audioCapabilities;var videos=configs[configIdx].videoCapabilities; // Look for supported audio container/codecs
	if(audios && audios.length !== 0){supportedAudio = []; // Indicates that we have a requested audio config
	for(var audioIdx=0;audioIdx < audios.length;audioIdx++) {if(window[api.MediaKeys].isTypeSupported(systemString,audios[audioIdx].contentType)){supportedAudio.push(audios[audioIdx]);}}} // Look for supported video container/codecs
	if(videos && videos.length !== 0){supportedVideo = []; // Indicates that we have a requested video config
	for(var videoIdx=0;videoIdx < videos.length;videoIdx++) {if(window[api.MediaKeys].isTypeSupported(systemString,videos[videoIdx].contentType)){supportedVideo.push(videos[videoIdx]);}}} // No supported audio or video in this configuration OR we have
	// requested audio or video configuration that is not supported
	if(!supportedAudio && !supportedVideo || supportedAudio && supportedAudio.length === 0 || supportedVideo && supportedVideo.length === 0){continue;} // This configuration is supported
	found = true;var ksConfig=new _voKeySystemConfiguration2['default'](supportedAudio,supportedVideo);var ks=protectionKeyController.getKeySystemBySystemString(systemString);eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE,{data:new _voKeySystemAccess2['default'](ks,ksConfig)});break;}}if(!found){eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE,{error:'Key system access denied! -- No valid audio/video content configurations detected!'});}}function selectKeySystem(ksAccess){try{mediaKeys = ksAccess.mediaKeys = new window[api.MediaKeys](ksAccess.keySystem.systemString);keySystem = ksAccess.keySystem;keySystemAccess = ksAccess;if(videoElement){setMediaKeys();}eventBus.trigger(events.INTERNAL_KEY_SYSTEM_SELECTED);}catch(error) {eventBus.trigger(events.INTERNAL_KEY_SYSTEM_SELECTED,{error:'Error selecting keys system (' + keySystem.systemString + ')! Could not create MediaKeys -- TODO'});}}function setMediaElement(mediaElement){if(videoElement === mediaElement)return; // Replacing the previous element
	if(videoElement){videoElement.removeEventListener(api.needkey,eventHandler);}videoElement = mediaElement; // Only if we are not detaching from the existing element
	if(videoElement){videoElement.addEventListener(api.needkey,eventHandler);if(mediaKeys){setMediaKeys();}}}function createKeySession(initData,protData,sessionType,cdmData){if(!keySystem || !mediaKeys || !keySystemAccess){throw new Error('Can not create sessions until you have selected a key system');} // Use the first video capability for the contentType.
	// TODO:  Not sure if there is a way to concatenate all capability data into a RFC6386-compatible format
	// If player is trying to playback Audio only stream - don't error out.
	var capabilities=null;if(keySystemAccess.ksConfiguration.videoCapabilities !== null && keySystemAccess.ksConfiguration.videoCapabilities.length > 0)capabilities = keySystemAccess.ksConfiguration.videoCapabilities[0];if(capabilities === null && keySystemAccess.ksConfiguration.audioCapabilities !== null && keySystemAccess.ksConfiguration.audioCapabilities.length > 0)capabilities = keySystemAccess.ksConfiguration.audioCapabilities[0];if(capabilities === null)throw new Error('Can not create sessions for unknown content types.');var contentType=capabilities.contentType;var session=mediaKeys.createSession(contentType,new Uint8Array(initData),cdmData?new Uint8Array(cdmData):null);var sessionToken=createSessionToken(session,initData); // Add all event listeners
	session.addEventListener(api.error,sessionToken);session.addEventListener(api.message,sessionToken);session.addEventListener(api.ready,sessionToken);session.addEventListener(api.close,sessionToken); // Add to our session list
	sessions.push(sessionToken);log('DRM: Session created.  SessionID = ' + sessionToken.getSessionID());eventBus.trigger(events.KEY_SESSION_CREATED,{data:sessionToken});}function updateKeySession(sessionToken,message){var session=sessionToken.session;if(!protectionKeyController.isClearKey(keySystem)){ // Send our request to the key session
	session.update(new Uint8Array(message));}else { // For clearkey, message is a ClearKeyKeySet
	session.update(new Uint8Array(message.toJWK()));}} /**
	     * Close the given session and release all associated keys.  Following
	     * this call, the sessionToken becomes invalid
	     *
	     * @param {Object} sessionToken - the session token
	     */function closeKeySession(sessionToken){var session=sessionToken.session; // Remove event listeners
	session.removeEventListener(api.error,sessionToken);session.removeEventListener(api.message,sessionToken);session.removeEventListener(api.ready,sessionToken);session.removeEventListener(api.close,sessionToken); // Remove from our session list
	for(var i=0;i < sessions.length;i++) {if(sessions[i] === sessionToken){sessions.splice(i,1);break;}} // Send our request to the key session
	session[api.release]();}function setServerCertificate() /*serverCertificate*/{ /* Not supported */}function loadKeySession() /*sessionID*/{ /* Not supported */}function removeKeySession() /*sessionToken*/{ /* Not supported */}function createEventHandler(){return {handleEvent:function handleEvent(event){switch(event.type){case api.needkey:if(event.initData){var initData=ArrayBuffer.isView(event.initData)?event.initData.buffer:event.initData;eventBus.trigger(events.NEED_KEY,{key:new _voNeedKey2['default'](initData,'cenc')});}break;}}};} // IE11 does not let you set MediaKeys until it has entered a certain
	// readyState, so we need this logic to ensure we don't set the keys
	// too early
	function setMediaKeys(){var boundDoSetKeys=null;var doSetKeys=function doSetKeys(){videoElement.removeEventListener('loadedmetadata',boundDoSetKeys);videoElement[api.setMediaKeys](mediaKeys);eventBus.trigger(events.VIDEO_ELEMENT_SELECTED);};if(videoElement.readyState >= 1){doSetKeys();}else {boundDoSetKeys = doSetKeys.bind(this);videoElement.addEventListener('loadedmetadata',boundDoSetKeys);}} // Function to create our session token objects which manage the EME
	// MediaKeySession and session-specific event handler
	function createSessionToken(keySession,initData){return { // Implements SessionToken
	session:keySession,initData:initData,getSessionID:function getSessionID(){return this.session.sessionId;},getExpirationTime:function getExpirationTime(){return NaN;},getSessionType:function getSessionType(){return 'temporary';}, // This is our main event handler for all desired MediaKeySession events
	// These events are translated into our API-independent versions of the
	// same events
	handleEvent:function handleEvent(event){switch(event.type){case api.error:var errorStr='KeyError'; // TODO: Make better string from event
	eventBus.trigger(events.KEY_ERROR,{data:new _voKeyError2['default'](this,errorStr)});break;case api.message:var message=ArrayBuffer.isView(event.message)?event.message.buffer:event.message;eventBus.trigger(events.INTERNAL_KEY_MESSAGE,{data:new _voKeyMessage2['default'](this,message,event.destinationURL)});break;case api.ready:log('DRM: Key added.');eventBus.trigger(events.KEY_ADDED);break;case api.close:log('DRM: Session closed.  SessionID = ' + this.getSessionID());eventBus.trigger(events.KEY_SESSION_CLOSED,{data:this.getSessionID()});break;}}};}instance = {getAllInitData:getAllInitData,requestKeySystemAccess:requestKeySystemAccess,getKeySystem:getKeySystem,selectKeySystem:selectKeySystem,setMediaElement:setMediaElement,createKeySession:createKeySession,updateKeySession:updateKeySession,closeKeySession:closeKeySession,setServerCertificate:setServerCertificate,loadKeySession:loadKeySession,removeKeySession:removeKeySession,reset:reset};setup();return instance;}ProtectionModel_3Feb2014.__dashjs_factory_name = 'ProtectionModel_3Feb2014';exports['default'] = dashjs.FactoryMaker.getClassFactory(ProtectionModel_3Feb2014); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=ProtectionModel_3Feb2014.js.map


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * CableLabs ClearKey license server implementation
	 *
	 * For testing purposes and evaluating potential uses for ClearKey, we have developed
	 * a dirt-simple API for requesting ClearKey licenses from a remote server.
	 *
	 * @implements LicenseServer
	 * @class
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _voKeyPair=__webpack_require__(91);var _voKeyPair2=_interopRequireDefault(_voKeyPair);var _voClearKeyKeySet=__webpack_require__(88);var _voClearKeyKeySet2=_interopRequireDefault(_voClearKeyKeySet);function ClearKey(){var instance=undefined;function getServerURLFromMessage(url,message /*, messageType*/){ // Build ClearKey server query string
	var jsonMsg=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(message)));url += '/?';for(var i=0;i < jsonMsg.kids.length;i++) {url += jsonMsg.kids[i] + '&';}url = url.substring(0,url.length - 1);return url;}function getHTTPMethod() /*messageType*/{return 'GET';}function getResponseType() /*keySystemStr*/{return 'json';}function getLicenseMessage(serverResponse /*, keySystemStr, messageType*/){if(!serverResponse.hasOwnProperty('keys')){return null;}var keyPairs=[];for(var i=0;i < serverResponse.keys.length;i++) {var keypair=serverResponse.keys[i];var keyid=keypair.kid.replace(/=/g,'');var key=keypair.k.replace(/=/g,'');keyPairs.push(new _voKeyPair2['default'](keyid,key));}return new _voClearKeyKeySet2['default'](keyPairs);}function getErrorResponse(serverResponse /*, keySystemStr, messageType*/){return String.fromCharCode.apply(null,new Uint8Array(serverResponse));}instance = {getServerURLFromMessage:getServerURLFromMessage,getHTTPMethod:getHTTPMethod,getResponseType:getResponseType,getLicenseMessage:getLicenseMessage,getErrorResponse:getErrorResponse};return instance;}ClearKey.__dashjs_factory_name = 'ClearKey';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(ClearKey); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=ClearKey.js.map


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * CastLabs DRMToday License Server implementation
	 *
	 * @implements LicenseServer
	 * @class
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsProtectionConstants=__webpack_require__(35);var _constantsProtectionConstants2=_interopRequireDefault(_constantsProtectionConstants);function DRMToday(config){config = config || {};var BASE64=config.BASE64;var keySystems={};keySystems[_constantsProtectionConstants2['default'].WIDEVINE_KEYSTEM_STRING] = {responseType:'json',getLicenseMessage:function getLicenseMessage(response){return BASE64.decodeArray(response.license);},getErrorResponse:function getErrorResponse(response){return response;}};keySystems[_constantsProtectionConstants2['default'].PLAYREADY_KEYSTEM_STRING] = {responseType:'arraybuffer',getLicenseMessage:function getLicenseMessage(response){return response;},getErrorResponse:function getErrorResponse(response){return String.fromCharCode.apply(null,new Uint8Array(response));}};var instance=undefined;function checkConfig(){if(!BASE64 || !BASE64.hasOwnProperty('decodeArray')){throw new Error('Missing config parameter(s)');}}function getServerURLFromMessage(url /*, message, messageType*/){return url;}function getHTTPMethod() /*messageType*/{return 'POST';}function getResponseType(keySystemStr /*, messageType*/){return keySystems[keySystemStr].responseType;}function getLicenseMessage(serverResponse,keySystemStr /*, messageType*/){checkConfig();return keySystems[keySystemStr].getLicenseMessage(serverResponse);}function getErrorResponse(serverResponse,keySystemStr /*, messageType*/){return keySystems[keySystemStr].getErrorResponse(serverResponse);}instance = {getServerURLFromMessage:getServerURLFromMessage,getHTTPMethod:getHTTPMethod,getResponseType:getResponseType,getLicenseMessage:getLicenseMessage,getErrorResponse:getErrorResponse};return instance;}DRMToday.__dashjs_factory_name = 'DRMToday';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(DRMToday); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=DRMToday.js.map


/***/ },
/* 385 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /* global escape: true */ /**
	 * Microsoft PlayReady Test License Server
	 *
	 * For testing content that uses the PlayReady test server at
	 *
	 * @implements LicenseServer
	 * @class
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function PlayReady(){var instance=undefined;var soap='http://schemas.xmlsoap.org/soap/envelope/';function uintToString(arrayBuffer){var encodedString=String.fromCharCode.apply(null,new Uint8Array(arrayBuffer));var decodedString=decodeURIComponent(escape(encodedString));return decodedString;}function parseServerResponse(serverResponse){if(window.DOMParser){var stringResponse=uintToString(serverResponse);var parser=new window.DOMParser();var xmlDoc=parser.parseFromString(stringResponse,'text/xml');var envelope=xmlDoc?xmlDoc.getElementsByTagNameNS(soap,'Envelope')[0]:null;var body=envelope?envelope.getElementsByTagNameNS(soap,'Body')[0]:null;var fault=body?body.getElementsByTagNameNS(soap,'Fault')[0]:null;if(fault){return null;}}return serverResponse;}function parseErrorResponse(serverResponse){var faultstring='';var statusCode='';var message='';var idStart=-1;var idEnd=-1;if(window.DOMParser){var stringResponse=uintToString(serverResponse);var parser=new window.DOMParser();var xmlDoc=parser.parseFromString(stringResponse,'text/xml');var envelope=xmlDoc?xmlDoc.getElementsByTagNameNS(soap,'Envelope')[0]:null;var body=envelope?envelope.getElementsByTagNameNS(soap,'Body')[0]:null;var fault=body?body.getElementsByTagNameNS(soap,'Fault')[0]:null;var detail=fault?fault.getElementsByTagName('detail')[0]:null;var exception=detail?detail.getElementsByTagName('Exception')[0]:null;var node=null;if(fault === null){return stringResponse;}node = fault.getElementsByTagName('faultstring')[0].firstChild;faultstring = node?node.nodeValue:null;if(exception !== null){node = exception.getElementsByTagName('StatusCode')[0];statusCode = node?node.firstChild.nodeValue:null;node = exception.getElementsByTagName('Message')[0];message = node?node.firstChild.nodeValue:null;idStart = message?message.lastIndexOf('[') + 1:-1;idEnd = message?message.indexOf(']'):-1;message = message?message.substring(idStart,idEnd):'';}}var errorString='code: ' + statusCode + ', name: ' + faultstring;if(message){errorString += ', message: ' + message;}return errorString;}function getServerURLFromMessage(url /*, message, messageType*/){return url;}function getHTTPMethod() /*messageType*/{return 'POST';}function getResponseType() /*keySystemStr, messageType*/{return 'arraybuffer';}function getLicenseMessage(serverResponse /*, keySystemStr, messageType*/){return parseServerResponse.call(this,serverResponse);}function getErrorResponse(serverResponse /*, keySystemStr, messageType*/){return parseErrorResponse.call(this,serverResponse);}instance = {getServerURLFromMessage:getServerURLFromMessage,getHTTPMethod:getHTTPMethod,getResponseType:getResponseType,getLicenseMessage:getLicenseMessage,getErrorResponse:getErrorResponse};return instance;}PlayReady.__dashjs_factory_name = 'PlayReady';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(PlayReady); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=PlayReady.js.map


/***/ },
/* 386 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function Widevine(){var instance=undefined;function getServerURLFromMessage(url /*, message, messageType*/){return url;}function getHTTPMethod() /*messageType*/{return 'POST';}function getResponseType() /*keySystemStr, messageType*/{return 'arraybuffer';}function getLicenseMessage(serverResponse /*, keySystemStr, messageType*/){return serverResponse;}function getErrorResponse(serverResponse /*, keySystemStr, messageType*/){return String.fromCharCode.apply(null,new Uint8Array(serverResponse));}instance = {getServerURLFromMessage:getServerURLFromMessage,getHTTPMethod:getHTTPMethod,getResponseType:getResponseType,getLicenseMessage:getLicenseMessage,getErrorResponse:getErrorResponse};return instance;}Widevine.__dashjs_factory_name = 'Widevine';exports['default'] = dashjs.FactoryMaker.getSingletonFactory(Widevine); /* jshint ignore:line */module.exports = exports['default'];
	//# sourceMappingURL=Widevine.js.map


/***/ },
/* 387 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc A media capability
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var MediaCapability= /**
	     * @param {string} contentType MIME type and codecs (RFC6386)
	     * @param {string} robustness
	     * @class
	     * @ignore
	     */function MediaCapability(contentType,robustness){_classCallCheck(this,MediaCapability);this.contentType = contentType;this.robustness = robustness;};exports["default"] = MediaCapability;module.exports = exports["default"];
	//# sourceMappingURL=MediaCapability.js.map


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function DroppedFramesHistory(){var values=[];var lastDroppedFrames=0;var lastTotalFrames=0;function push(index,playbackQuality){var intervalDroppedFrames=playbackQuality.droppedVideoFrames - lastDroppedFrames;lastDroppedFrames = playbackQuality.droppedVideoFrames;var intervalTotalFrames=playbackQuality.totalVideoFrames - lastTotalFrames;lastTotalFrames = playbackQuality.totalVideoFrames;if(!isNaN(index)){if(!values[index]){values[index] = {droppedVideoFrames:intervalDroppedFrames,totalVideoFrames:intervalTotalFrames};}else {values[index].droppedVideoFrames += intervalDroppedFrames;values[index].totalVideoFrames += intervalTotalFrames;}}}function getDroppedFrameHistory(){return values;}function reset(playbackQuality){values = [];lastDroppedFrames = playbackQuality.droppedVideoFrames;lastTotalFrames = playbackQuality.totalVideoFrames;}return {push:push,getFrameHistory:getDroppedFrameHistory,reset:reset};}DroppedFramesHistory.__dashjs_factory_name = 'DroppedFramesHistory';var factory=_coreFactoryMaker2['default'].getClassFactory(DroppedFramesHistory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=DroppedFramesHistory.js.map


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function RulesContext(config){config = config || {};var instance=undefined;var abrController=config.abrController;var streamProcessor=config.streamProcessor;var representationInfo=config.streamProcessor.getCurrentRepresentationInfo();var switchHistory=config.switchHistory;var droppedFramesHistory=config.droppedFramesHistory;var currentRequest=config.currentRequest;var bufferOccupancyABR=config.useBufferOccupancyABR;function getMediaType(){return representationInfo.mediaInfo.type;}function getStreamInfo(){return representationInfo.mediaInfo.streamInfo;}function getMediaInfo(){return representationInfo.mediaInfo;}function getRepresentationInfo(){return representationInfo;}function getStreamProcessor(){return streamProcessor;}function getAbrController(){return abrController;}function getSwitchHistory(){return switchHistory;}function getDroppedFramesHistory(){return droppedFramesHistory;}function getCurrentRequest(){return currentRequest;}function useBufferOccupancyABR(){return bufferOccupancyABR;}instance = {getMediaType:getMediaType,getMediaInfo:getMediaInfo,getDroppedFramesHistory:getDroppedFramesHistory,getCurrentRequest:getCurrentRequest,getSwitchHistory:getSwitchHistory,getStreamInfo:getStreamInfo,getStreamProcessor:getStreamProcessor,getAbrController:getAbrController,getRepresentationInfo:getRepresentationInfo,useBufferOccupancyABR:useBufferOccupancyABR};return instance;}RulesContext.__dashjs_factory_name = 'RulesContext';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(RulesContext);module.exports = exports['default'];
	//# sourceMappingURL=RulesContext.js.map


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _SwitchRequest=__webpack_require__(27);var _SwitchRequest2=_interopRequireDefault(_SwitchRequest);var SWITCH_REQUEST_HISTORY_DEPTH=8; // must be > SwitchHistoryRule SAMPLE_SIZE to enable rule
	function SwitchRequestHistory(){var switchRequests=[]; // running total
	var srHistory=[]; // history of each switch
	function push(switchRequest){if(switchRequest.newValue === _SwitchRequest2['default'].NO_CHANGE){switchRequest.newValue = switchRequest.oldValue;}if(!switchRequests[switchRequest.oldValue]){switchRequests[switchRequest.oldValue] = {noDrops:0,drops:0,dropSize:0};} // Set switch details
	var indexDiff=switchRequest.newValue - switchRequest.oldValue;var drop=indexDiff < 0?1:0;var dropSize=drop?-indexDiff:0;var noDrop=drop?0:1; // Update running totals
	switchRequests[switchRequest.oldValue].drops += drop;switchRequests[switchRequest.oldValue].dropSize += dropSize;switchRequests[switchRequest.oldValue].noDrops += noDrop; // Save to history
	srHistory.push({idx:switchRequest.oldValue,noDrop:noDrop,drop:drop,dropSize:dropSize}); // Shift earliest switch off srHistory and readjust to keep depth of running totals constant
	if(srHistory.length > SWITCH_REQUEST_HISTORY_DEPTH){var srHistoryFirst=srHistory.shift();switchRequests[srHistoryFirst.idx].drops -= srHistoryFirst.drop;switchRequests[srHistoryFirst.idx].dropSize -= srHistoryFirst.dropSize;switchRequests[srHistoryFirst.idx].noDrops -= srHistoryFirst.noDrop;}}function getSwitchRequests(){return switchRequests;}function reset(){switchRequests = [];srHistory = [];}return {push:push,getSwitchRequests:getSwitchRequests,reset:reset};}SwitchRequestHistory.__dashjs_factory_name = 'SwitchRequestHistory';var factory=_coreFactoryMaker2['default'].getClassFactory(SwitchRequestHistory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=SwitchRequestHistory.js.map


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2017, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker); // throughput generally stored in kbit/s
	// latency generally stored in ms
	function ThroughputHistory(config){config = config || {}; // sliding window constants
	var MAX_MEASUREMENTS_TO_KEEP=20;var AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_LIVE=3;var AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_VOD=4;var AVERAGE_LATENCY_SAMPLE_AMOUNT=4;var THROUGHPUT_DECREASE_SCALE=1.3;var THROUGHPUT_INCREASE_SCALE=1.3; // EWMA constants
	var EWMA_THROUGHPUT_SLOW_HALF_LIFE_SECONDS=8;var EWMA_THROUGHPUT_FAST_HALF_LIFE_SECONDS=3;var EWMA_LATENCY_SLOW_HALF_LIFE_COUNT=2;var EWMA_LATENCY_FAST_HALF_LIFE_COUNT=1;var mediaPlayerModel=config.mediaPlayerModel;var throughputDict=undefined,latencyDict=undefined,ewmaThroughputDict=undefined,ewmaLatencyDict=undefined,ewmaHalfLife=undefined;function setup(){ewmaHalfLife = {throughputHalfLife:{fast:EWMA_THROUGHPUT_FAST_HALF_LIFE_SECONDS,slow:EWMA_THROUGHPUT_SLOW_HALF_LIFE_SECONDS},latencyHalfLife:{fast:EWMA_LATENCY_FAST_HALF_LIFE_COUNT,slow:EWMA_LATENCY_SLOW_HALF_LIFE_COUNT}};reset();}function isCachedResponse(mediaType,latencyMs,downloadTimeMs){if(mediaType === _constantsConstants2['default'].VIDEO){return downloadTimeMs < mediaPlayerModel.getCacheLoadThresholdForType(_constantsConstants2['default'].VIDEO);}else if(mediaType === _constantsConstants2['default'].AUDIO){return downloadTimeMs < mediaPlayerModel.getCacheLoadThresholdForType(_constantsConstants2['default'].AUDIO);}}function push(mediaType,httpRequest,useDeadTimeLatency){if(!httpRequest.trace || !httpRequest.trace.length){return;}var latencyTimeInMilliseconds=httpRequest.tresponse.getTime() - httpRequest.trequest.getTime() || 1;var downloadTimeInMilliseconds=httpRequest._tfinish.getTime() - httpRequest.tresponse.getTime() || 1; //Make sure never 0 we divide by this value. Avoid infinity!
	var downloadBytes=httpRequest.trace.reduce(function(a,b){return a + b.b[0];},0);var throughputMeasureTime=useDeadTimeLatency?downloadTimeInMilliseconds:latencyTimeInMilliseconds + downloadTimeInMilliseconds;var throughput=Math.round(8 * downloadBytes / throughputMeasureTime); // bits/ms = kbits/s
	checkSettingsForMediaType(mediaType);if(isCachedResponse(mediaType,latencyTimeInMilliseconds,downloadTimeInMilliseconds)){if(throughputDict[mediaType].length > 0 && !throughputDict[mediaType].hasCachedEntries){ // already have some entries which are not cached entries
	// prevent cached fragment loads from skewing the average values
	return;}else { // have no entries || have cached entries
	// no uncached entries yet, rely on cached entries because ABR rules need something to go by
	throughputDict[mediaType].hasCachedEntries = true;}}else if(throughputDict[mediaType] && throughputDict[mediaType].hasCachedEntries){ // if we are here then we have some entries already, but they are cached, and now we have a new uncached entry
	clearSettingsForMediaType(mediaType);}throughputDict[mediaType].push(throughput);if(throughputDict[mediaType].length > MAX_MEASUREMENTS_TO_KEEP){throughputDict[mediaType].shift();}latencyDict[mediaType].push(latencyTimeInMilliseconds);if(latencyDict[mediaType].length > MAX_MEASUREMENTS_TO_KEEP){latencyDict[mediaType].shift();}updateEwmaEstimate(ewmaThroughputDict[mediaType],throughput,0.001 * downloadTimeInMilliseconds,ewmaHalfLife.throughputHalfLife);updateEwmaEstimate(ewmaLatencyDict[mediaType],latencyTimeInMilliseconds,1,ewmaHalfLife.latencyHalfLife);}function updateEwmaEstimate(ewmaObj,value,weight,halfLife){ // Note about startup:
	// Estimates start at 0, so early values are underestimated.
	// This effect is countered in getAverageEwma() by dividing the estimates by:
	//     1 - Math.pow(0.5, ewmaObj.totalWeight / halfLife)
	var fastAlpha=Math.pow(0.5,weight / halfLife.fast);ewmaObj.fastEstimate = (1 - fastAlpha) * value + fastAlpha * ewmaObj.fastEstimate;var slowAlpha=Math.pow(0.5,weight / halfLife.slow);ewmaObj.slowEstimate = (1 - slowAlpha) * value + slowAlpha * ewmaObj.slowEstimate;ewmaObj.totalWeight += weight;}function getSampleSize(isThroughput,mediaType,isLive){var arr=undefined;var sampleSize=undefined;if(isThroughput){arr = throughputDict[mediaType];sampleSize = isLive?AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_LIVE:AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_VOD;}else {arr = latencyDict[mediaType];sampleSize = AVERAGE_LATENCY_SAMPLE_AMOUNT;}if(!arr){sampleSize = 0;}else if(sampleSize >= arr.length){sampleSize = arr.length;}else if(isThroughput){ // if throughput samples vary a lot, average over a wider sample
	for(var i=1;i < sampleSize;++i) {var ratio=arr[i] / arr[i - 1];if(ratio >= THROUGHPUT_INCREASE_SCALE || ratio <= 1 / THROUGHPUT_DECREASE_SCALE){sampleSize += 1;if(sampleSize === arr.length){ // cannot increase sampleSize beyond arr.length
	break;}}}}return sampleSize;}function getAverage(isThroughput,mediaType,isDynamic){ // only two moving average methods defined at the moment
	return mediaPlayerModel.getMovingAverageMethod() !== _constantsConstants2['default'].MOVING_AVERAGE_SLIDING_WINDOW?getAverageEwma(isThroughput,mediaType):getAverageSlidingWindow(isThroughput,mediaType,isDynamic);}function getAverageSlidingWindow(isThroughput,mediaType,isDynamic){var sampleSize=getSampleSize(isThroughput,mediaType,isDynamic);var dict=isThroughput?throughputDict:latencyDict;var arr=dict[mediaType];if(sampleSize === 0 || !arr || arr.length === 0){return NaN;}arr = arr.slice(-sampleSize); // still works if sampleSize too large
	// arr.length >= 1
	return arr.reduce(function(total,elem){return total + elem;}) / arr.length;}function getAverageEwma(isThroughput,mediaType){var halfLife=isThroughput?ewmaHalfLife.throughputHalfLife:ewmaHalfLife.latencyHalfLife;var ewmaObj=isThroughput?ewmaThroughputDict[mediaType]:ewmaLatencyDict[mediaType];if(!ewmaObj || ewmaObj.totalWeight <= 0){return NaN;} // to correct for startup, divide by zero factor = 1 - Math.pow(0.5, ewmaObj.totalWeight / halfLife)
	var fastEstimate=ewmaObj.fastEstimate / (1 - Math.pow(0.5,ewmaObj.totalWeight / halfLife.fast));var slowEstimate=ewmaObj.slowEstimate / (1 - Math.pow(0.5,ewmaObj.totalWeight / halfLife.slow));return isThroughput?Math.min(fastEstimate,slowEstimate):Math.max(fastEstimate,slowEstimate);}function getAverageThroughput(mediaType,isDynamic){return getAverage(true,mediaType,isDynamic);}function getSafeAverageThroughput(mediaType,isDynamic){var average=getAverageThroughput(mediaType,isDynamic);if(!isNaN(average)){average *= mediaPlayerModel.getBandwidthSafetyFactor();}return average;}function getAverageLatency(mediaType){return getAverage(false,mediaType);}function checkSettingsForMediaType(mediaType){throughputDict[mediaType] = throughputDict[mediaType] || [];latencyDict[mediaType] = latencyDict[mediaType] || [];ewmaThroughputDict[mediaType] = ewmaThroughputDict[mediaType] || {fastEstimate:0,slowEstimate:0,totalWeight:0};ewmaLatencyDict[mediaType] = ewmaLatencyDict[mediaType] || {fastEstimate:0,slowEstimate:0,totalWeight:0};}function clearSettingsForMediaType(mediaType){delete throughputDict[mediaType];delete latencyDict[mediaType];delete ewmaThroughputDict[mediaType];delete ewmaLatencyDict[mediaType];checkSettingsForMediaType(mediaType);}function reset(){throughputDict = {};latencyDict = {};ewmaThroughputDict = {};ewmaLatencyDict = {};}var instance={push:push,getAverageThroughput:getAverageThroughput,getSafeAverageThroughput:getSafeAverageThroughput,getAverageLatency:getAverageLatency,reset:reset};setup();return instance;}ThroughputHistory.__dashjs_factory_name = 'ThroughputHistory';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ThroughputHistory);module.exports = exports['default'];
	//# sourceMappingURL=ThroughputHistory.js.map


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _ThroughputRule=__webpack_require__(398);var _ThroughputRule2=_interopRequireDefault(_ThroughputRule);var _InsufficientBufferRule=__webpack_require__(396);var _InsufficientBufferRule2=_interopRequireDefault(_InsufficientBufferRule);var _AbandonRequestsRule=__webpack_require__(393);var _AbandonRequestsRule2=_interopRequireDefault(_AbandonRequestsRule);var _DroppedFramesRule=__webpack_require__(395);var _DroppedFramesRule2=_interopRequireDefault(_DroppedFramesRule);var _SwitchHistoryRule=__webpack_require__(397);var _SwitchHistoryRule2=_interopRequireDefault(_SwitchHistoryRule);var _BolaRule=__webpack_require__(394);var _BolaRule2=_interopRequireDefault(_BolaRule);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _SwitchRequest=__webpack_require__(27);var _SwitchRequest2=_interopRequireDefault(_SwitchRequest);var QUALITY_SWITCH_RULES='qualitySwitchRules';var ABANDON_FRAGMENT_RULES='abandonFragmentRules';function ABRRulesCollection(config){config = config || {};var context=this.context;var mediaPlayerModel=config.mediaPlayerModel;var metricsModel=config.metricsModel;var dashMetrics=config.dashMetrics;var instance=undefined,qualitySwitchRules=undefined,abandonFragmentRules=undefined;function initialize(){qualitySwitchRules = [];abandonFragmentRules = [];if(mediaPlayerModel.getUseDefaultABRRules()){ // Only one of BolaRule and ThroughputRule will give a switchRequest.quality !== SwitchRequest.NO_CHANGE.
	// This is controlled by useBufferOccupancyABR mechanism in AbrController.
	qualitySwitchRules.push((0,_BolaRule2['default'])(context).create({metricsModel:metricsModel,dashMetrics:dashMetrics,mediaPlayerModel:mediaPlayerModel}));qualitySwitchRules.push((0,_ThroughputRule2['default'])(context).create({metricsModel:metricsModel,dashMetrics:dashMetrics}));qualitySwitchRules.push((0,_InsufficientBufferRule2['default'])(context).create({metricsModel:metricsModel,dashMetrics:dashMetrics}));qualitySwitchRules.push((0,_SwitchHistoryRule2['default'])(context).create());qualitySwitchRules.push((0,_DroppedFramesRule2['default'])(context).create());abandonFragmentRules.push((0,_AbandonRequestsRule2['default'])(context).create({metricsModel:metricsModel,dashMetrics:dashMetrics,mediaPlayerModel:mediaPlayerModel}));} // add custom ABR rules if any
	var customRules=mediaPlayerModel.getABRCustomRules();customRules.forEach(function(rule){if(rule.type === QUALITY_SWITCH_RULES){qualitySwitchRules.push(rule.rule(context).create());}if(rule.type === ABANDON_FRAGMENT_RULES){abandonFragmentRules.push(rule.rule(context).create());}});}function getActiveRules(srArray){return srArray.filter(function(sr){return sr.quality > _SwitchRequest2['default'].NO_CHANGE;});}function getMinSwitchRequest(srArray){var values={};var i=undefined,len=undefined,req=undefined,newQuality=undefined,quality=undefined;if(srArray.length === 0){return;}values[_SwitchRequest2['default'].PRIORITY.STRONG] = _SwitchRequest2['default'].NO_CHANGE;values[_SwitchRequest2['default'].PRIORITY.WEAK] = _SwitchRequest2['default'].NO_CHANGE;values[_SwitchRequest2['default'].PRIORITY.DEFAULT] = _SwitchRequest2['default'].NO_CHANGE;for(i = 0,len = srArray.length;i < len;i += 1) {req = srArray[i];if(req.quality !== _SwitchRequest2['default'].NO_CHANGE){values[req.priority] = values[req.priority] > _SwitchRequest2['default'].NO_CHANGE?Math.min(values[req.priority],req.quality):req.quality;}}if(values[_SwitchRequest2['default'].PRIORITY.WEAK] !== _SwitchRequest2['default'].NO_CHANGE){newQuality = values[_SwitchRequest2['default'].PRIORITY.WEAK];}if(values[_SwitchRequest2['default'].PRIORITY.DEFAULT] !== _SwitchRequest2['default'].NO_CHANGE){newQuality = values[_SwitchRequest2['default'].PRIORITY.DEFAULT];}if(values[_SwitchRequest2['default'].PRIORITY.STRONG] !== _SwitchRequest2['default'].NO_CHANGE){newQuality = values[_SwitchRequest2['default'].PRIORITY.STRONG];}if(newQuality !== _SwitchRequest2['default'].NO_CHANGE){quality = newQuality;}return (0,_SwitchRequest2['default'])(context).create(quality);}function getMaxQuality(rulesContext){var switchRequestArray=qualitySwitchRules.map(function(rule){return rule.getMaxIndex(rulesContext);});var activeRules=getActiveRules(switchRequestArray);var maxQuality=getMinSwitchRequest(activeRules);return maxQuality || (0,_SwitchRequest2['default'])(context).create();}function shouldAbandonFragment(rulesContext){var abandonRequestArray=abandonFragmentRules.map(function(rule){return rule.shouldAbandon(rulesContext);});var activeRules=getActiveRules(abandonRequestArray);var shouldAbandon=getMinSwitchRequest(activeRules);return shouldAbandon || (0,_SwitchRequest2['default'])(context).create();}function reset(){[qualitySwitchRules,abandonFragmentRules].forEach(function(rules){if(rules && rules.length){rules.forEach(function(rule){return rule.reset && rule.reset();});}});qualitySwitchRules = [];abandonFragmentRules = [];}instance = {initialize:initialize,reset:reset,getMaxQuality:getMaxQuality,shouldAbandonFragment:shouldAbandonFragment};return instance;}ABRRulesCollection.__dashjs_factory_name = 'ABRRulesCollection';var factory=_coreFactoryMaker2['default'].getClassFactory(ABRRulesCollection);factory.QUALITY_SWITCH_RULES = QUALITY_SWITCH_RULES;factory.ABANDON_FRAGMENT_RULES = ABANDON_FRAGMENT_RULES;_coreFactoryMaker2['default'].updateSingletonFactory(ABRRulesCollection.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=ABRRulesCollection.js.map


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _SwitchRequest=__webpack_require__(27);var _SwitchRequest2=_interopRequireDefault(_SwitchRequest);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);function AbandonRequestsRule(config){config = config || {};var ABANDON_MULTIPLIER=1.8;var GRACE_TIME_THRESHOLD=500;var MIN_LENGTH_TO_AVERAGE=5;var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var mediaPlayerModel=config.mediaPlayerModel;var metricsModel=config.metricsModel;var dashMetrics=config.dashMetrics;var fragmentDict=undefined,abandonDict=undefined,throughputArray=undefined;function setup(){reset();}function setFragmentRequestDict(type,id){fragmentDict[type] = fragmentDict[type] || {};fragmentDict[type][id] = fragmentDict[type][id] || {};}function storeLastRequestThroughputByType(type,throughput){throughputArray[type] = throughputArray[type] || [];throughputArray[type].push(throughput);}function shouldAbandon(rulesContext){var switchRequest=(0,_SwitchRequest2['default'])(context).create(_SwitchRequest2['default'].NO_CHANGE,{name:AbandonRequestsRule.__dashjs_factory_name});if(!rulesContext || !rulesContext.hasOwnProperty('getMediaInfo') || !rulesContext.hasOwnProperty('getMediaType') || !rulesContext.hasOwnProperty('getCurrentRequest') || !rulesContext.hasOwnProperty('getRepresentationInfo') || !rulesContext.hasOwnProperty('getAbrController')){return switchRequest;}var mediaInfo=rulesContext.getMediaInfo();var mediaType=rulesContext.getMediaType();var req=rulesContext.getCurrentRequest();if(!isNaN(req.index)){setFragmentRequestDict(mediaType,req.index);var stableBufferTime=mediaPlayerModel.getStableBufferTime();var bufferLevel=dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(mediaType));if(bufferLevel > stableBufferTime){return switchRequest;}var fragmentInfo=fragmentDict[mediaType][req.index];if(fragmentInfo === null || req.firstByteDate === null || abandonDict.hasOwnProperty(fragmentInfo.id)){return switchRequest;} //setup some init info based on first progress event
	if(fragmentInfo.firstByteTime === undefined){throughputArray[mediaType] = [];fragmentInfo.firstByteTime = req.firstByteDate.getTime();fragmentInfo.segmentDuration = req.duration;fragmentInfo.bytesTotal = req.bytesTotal;fragmentInfo.id = req.index;}fragmentInfo.bytesLoaded = req.bytesLoaded;fragmentInfo.elapsedTime = new Date().getTime() - fragmentInfo.firstByteTime;if(fragmentInfo.bytesLoaded > 0 && fragmentInfo.elapsedTime > 0){storeLastRequestThroughputByType(mediaType,Math.round(fragmentInfo.bytesLoaded * 8 / fragmentInfo.elapsedTime));}if(throughputArray[mediaType].length >= MIN_LENGTH_TO_AVERAGE && fragmentInfo.elapsedTime > GRACE_TIME_THRESHOLD && fragmentInfo.bytesLoaded < fragmentInfo.bytesTotal){var totalSampledValue=throughputArray[mediaType].reduce(function(a,b){return a + b;},0);fragmentInfo.measuredBandwidthInKbps = Math.round(totalSampledValue / throughputArray[mediaType].length);fragmentInfo.estimatedTimeOfDownload = +(fragmentInfo.bytesTotal * 8 / fragmentInfo.measuredBandwidthInKbps / 1000).toFixed(2);if(fragmentInfo.estimatedTimeOfDownload < fragmentInfo.segmentDuration * ABANDON_MULTIPLIER || rulesContext.getRepresentationInfo().quality === 0){return switchRequest;}else if(!abandonDict.hasOwnProperty(fragmentInfo.id)){var abrController=rulesContext.getAbrController();var bytesRemaining=fragmentInfo.bytesTotal - fragmentInfo.bytesLoaded;var bitrateList=abrController.getBitrateList(mediaInfo);var newQuality=abrController.getQualityForBitrate(mediaInfo,fragmentInfo.measuredBandwidthInKbps * mediaPlayerModel.getBandwidthSafetyFactor());var estimateOtherBytesTotal=fragmentInfo.bytesTotal * bitrateList[newQuality].bitrate / bitrateList[abrController.getQualityFor(mediaType,mediaInfo.streamInfo)].bitrate;if(bytesRemaining > estimateOtherBytesTotal){switchRequest.quality = newQuality;switchRequest.reason.throughput = fragmentInfo.measuredBandwidthInKbps;switchRequest.reason.fragmentID = fragmentInfo.id;abandonDict[fragmentInfo.id] = fragmentInfo;log('AbandonRequestsRule ( ',mediaType,'frag id',fragmentInfo.id,') is asking to abandon and switch to quality to ',newQuality,' measured bandwidth was',fragmentInfo.measuredBandwidthInKbps);delete fragmentDict[mediaType][fragmentInfo.id];}}}else if(fragmentInfo.bytesLoaded === fragmentInfo.bytesTotal){delete fragmentDict[mediaType][fragmentInfo.id];}}return switchRequest;}function reset(){fragmentDict = {};abandonDict = {};throughputArray = [];}var instance={shouldAbandon:shouldAbandon,reset:reset};setup();return instance;}AbandonRequestsRule.__dashjs_factory_name = 'AbandonRequestsRule';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(AbandonRequestsRule);module.exports = exports['default'];
	//# sourceMappingURL=AbandonRequestsRule.js.map


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2016, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ // For a description of the BOLA adaptive bitrate (ABR) algorithm, see http://arxiv.org/abs/1601.06748
	'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsMetricsConstants=__webpack_require__(41);var _constantsMetricsConstants2=_interopRequireDefault(_constantsMetricsConstants);var _SwitchRequest=__webpack_require__(27);var _SwitchRequest2=_interopRequireDefault(_SwitchRequest);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _voMetricsHTTPRequest=__webpack_require__(16);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug); // BOLA_STATE_ONE_BITRATE   : If there is only one bitrate (or initialization failed), always return NO_CHANGE.
	// BOLA_STATE_STARTUP       : Set placeholder buffer such that we download fragments at most recently measured throughput.
	// BOLA_STATE_STEADY        : Buffer primed, we switch to steady operation.
	// TODO: add BOLA_STATE_SEEK and tune BOLA behavior on seeking
	var BOLA_STATE_ONE_BITRATE=0;var BOLA_STATE_STARTUP=1;var BOLA_STATE_STEADY=2;var MINIMUM_BUFFER_S=10; // BOLA should never add artificial delays if buffer is less than MINIMUM_BUFFER_S.
	var MINIMUM_BUFFER_PER_BITRATE_LEVEL_S=2; // E.g. if there are 5 bitrates, BOLA switches to top bitrate at buffer = 10 + 5 * 2 = 20s.
	// If Schedule Controller does not allow buffer to reach that level, it can be achieved through the placeholder buffer level.
	var PLACEHOLDER_BUFFER_DECAY=0.99; // Make sure placeholder buffer does not stick around too long.
	function BolaRule(config){config = config || {};var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var dashMetrics=config.dashMetrics;var metricsModel=config.metricsModel;var mediaPlayerModel=config.mediaPlayerModel;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var instance=undefined,bolaStateDict=undefined;function setup(){resetInitialSettings();eventBus.on(_coreEventsEvents2['default'].BUFFER_EMPTY,onBufferEmpty,instance);eventBus.on(_coreEventsEvents2['default'].PLAYBACK_SEEKING,onPlaybackSeeking,instance);eventBus.on(_coreEventsEvents2['default'].PERIOD_SWITCH_STARTED,onPeriodSwitchStarted,instance);eventBus.on(_coreEventsEvents2['default'].MEDIA_FRAGMENT_LOADED,onMediaFragmentLoaded,instance);eventBus.on(_coreEventsEvents2['default'].METRIC_ADDED,onMetricAdded,instance);eventBus.on(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED,onQualityChangeRequested,instance);eventBus.on(_coreEventsEvents2['default'].FRAGMENT_LOADING_ABANDONED,onFragmentLoadingAbandoned,instance);}function utilitiesFromBitrates(bitrates){return bitrates.map(function(b){return Math.log(b);}); // no need to worry about offset, utilities will be offset (uniformly) anyway later
	} // NOTE: in live streaming, the real buffer level can drop below minimumBufferS, but bola should not stick to lowest bitrate by using a placeholder buffer level
	function calculateBolaParameters(stableBufferTime,bitrates,utilities){var highestUtilityIndex=utilities.reduce(function(highestIndex,u,uIndex){return u > utilities[highestIndex]?uIndex:highestIndex;},0);if(highestUtilityIndex === 0){ // if highestUtilityIndex === 0, then always use lowest bitrate
	return null;}var bufferTime=Math.max(stableBufferTime,MINIMUM_BUFFER_S + MINIMUM_BUFFER_PER_BITRATE_LEVEL_S * bitrates.length); // TODO: Investigate if following can be better if utilities are not the default Math.log utilities.
	// If using Math.log utilities, we can choose Vp and gp to always prefer bitrates[0] at minimumBufferS and bitrates[max] at bufferTarget.
	// (Vp * (utility + gp) - bufferLevel) / bitrate has the maxima described when:
	// Vp * (utilities[0] + gp - 1) === minimumBufferS and Vp * (utilities[max] + gp - 1) === bufferTarget
	// giving:
	var gp=(utilities[highestUtilityIndex] - 1) / (bufferTime / MINIMUM_BUFFER_S - 1);var Vp=MINIMUM_BUFFER_S / gp; // note that expressions for gp and Vp assume utilities[0] === 1, which is true because of normalization
	return {gp:gp,Vp:Vp};}function getInitialBolaState(rulesContext){var initialState={};var mediaInfo=rulesContext.getMediaInfo();var bitrates=mediaInfo.bitrateList.map(function(b){return b.bandwidth;});var utilities=utilitiesFromBitrates(bitrates);utilities = utilities.map(function(u){return u - utilities[0] + 1;}); // normalize
	var stableBufferTime=mediaPlayerModel.getStableBufferTime();var params=calculateBolaParameters(stableBufferTime,bitrates,utilities);if(!params){ // only happens when there is only one bitrate level
	initialState.state = BOLA_STATE_ONE_BITRATE;}else {initialState.state = BOLA_STATE_STARTUP;initialState.bitrates = bitrates;initialState.utilities = utilities;initialState.stableBufferTime = stableBufferTime;initialState.Vp = params.Vp;initialState.gp = params.gp;initialState.lastQuality = 0;clearBolaStateOnSeek(initialState);}return initialState;}function clearBolaStateOnSeek(bolaState){bolaState.placeholderBuffer = 0;bolaState.mostAdvancedSegmentStart = NaN;bolaState.lastSegmentWasReplacement = false;bolaState.lastSegmentStart = NaN;bolaState.lastSegmentDurationS = NaN;bolaState.lastSegmentRequestTimeMs = NaN;bolaState.lastSegmentFinishTimeMs = NaN;} // If the buffer target is changed (can this happen mid-stream?), then adjust BOLA parameters accordingly.
	function checkBolaStateStableBufferTime(bolaState,mediaType){var stableBufferTime=mediaPlayerModel.getStableBufferTime();if(bolaState.stableBufferTime !== stableBufferTime){var params=calculateBolaParameters(stableBufferTime,bolaState.bitrates,bolaState.utilities);if(params.Vp !== bolaState.Vp || params.gp !== bolaState.gp){ // correct placeholder buffer using two criteria:
	// 1. do not change effective buffer level at effectiveBufferLevel === MINIMUM_BUFFER_S ( === Vp * gp )
	// 2. scale placeholder buffer by Vp subject to offset indicated in 1.
	var bufferLevel=dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(mediaType));var effectiveBufferLevel=bufferLevel + bolaState.placeholderBuffer;effectiveBufferLevel -= MINIMUM_BUFFER_S;effectiveBufferLevel *= params.Vp / bolaState.Vp;effectiveBufferLevel += MINIMUM_BUFFER_S;bolaState.stableBufferTime = stableBufferTime;bolaState.Vp = params.Vp;bolaState.gp = params.gp;bolaState.placeholderBuffer = Math.max(0,effectiveBufferLevel - bufferLevel);}}}function getBolaState(rulesContext){var mediaType=rulesContext.getMediaType();var bolaState=bolaStateDict[mediaType];if(!bolaState){bolaState = getInitialBolaState(rulesContext);bolaStateDict[mediaType] = bolaState;}else if(bolaState.state !== BOLA_STATE_ONE_BITRATE){checkBolaStateStableBufferTime(bolaState,mediaType);}return bolaState;} // The core idea of BOLA.
	function getQualityFromBufferLevel(bolaState,bufferLevel){var bitrateCount=bolaState.bitrates.length;var quality=NaN;var score=NaN;for(var i=0;i < bitrateCount;++i) {var s=(bolaState.Vp * (bolaState.utilities[i] + bolaState.gp) - bufferLevel) / bolaState.bitrates[i];if(isNaN(score) || s >= score){score = s;quality = i;}}return quality;} // maximum buffer level which prefers to download at quality rather than wait
	function maxBufferLevelForQuality(bolaState,quality){return bolaState.Vp * (bolaState.utilities[quality] + bolaState.gp);} // the minimum buffer level that would cause BOLA to choose quality rather than a lower bitrate
	function minBufferLevelForQuality(bolaState,quality){var qBitrate=bolaState.bitrates[quality];var qUtility=bolaState.utilities[quality];var min=0;for(var i=quality - 1;i >= 0;--i) { // for each bitrate less than bitrates[quality], BOLA should prefer quality (unless other bitrate has higher utility)
	if(bolaState.utilities[i] < bolaState.utilities[quality]){var iBitrate=bolaState.bitrates[i];var iUtility=bolaState.utilities[i];var level=bolaState.Vp * (bolaState.gp + (qBitrate * iUtility - iBitrate * qUtility) / (qBitrate - iBitrate));min = Math.max(min,level); // we want min to be small but at least level(i) for all i
	}}return min;} /*
	     * The placeholder buffer increases the effective buffer that is used to calculate the bitrate.
	     * There are two main reasons we might want to increase the placeholder buffer:
	     *
	     * 1. When a segment finishes downloading, we would expect to get a call on getMaxIndex() regarding the quality for
	     *    the next segment. However, there might be a delay before the next call. E.g. when streaming live content, the
	     *    next segment might not be available yet. If the call to getMaxIndex() does happens after a delay, we don't
	     *    want the delay to change the BOLA decision - we only want to factor download time to decide on bitrate level.
	     *
	     * 2. It is possible to get a call to getMaxIndex() without having a segment download. The buffer target in dash.js
	     *    is different for top-quality segments and lower-quality segments. If getMaxIndex() returns a lower-than-top
	     *    quality, then the buffer controller might decide not to download a segment. When dash.js is ready for the next
	     *    segment, getMaxIndex() will be called again. We don't want this extra delay to factor in the bitrate decision.
	     */function updatePlaceholderBuffer(bolaState,mediaType){var nowMs=Date.now();if(!isNaN(bolaState.lastSegmentFinishTimeMs)){ // compensate for non-bandwidth-derived delays, e.g., live streaming availability, buffer controller
	var delay=0.001 * (nowMs - bolaState.lastSegmentFinishTimeMs);bolaState.placeholderBuffer += Math.max(0,delay);}else if(!isNaN(bolaState.lastCallTimeMs)){ // no download after last call, compensate for delay between calls
	var delay=0.001 * (nowMs - bolaState.lastCallTimeMs);bolaState.placeholderBuffer += Math.max(0,delay);}bolaState.lastCallTimeMs = nowMs;bolaState.lastSegmentStart = NaN;bolaState.lastSegmentRequestTimeMs = NaN;bolaState.lastSegmentFinishTimeMs = NaN;checkBolaStateStableBufferTime(bolaState,mediaType);}function onBufferEmpty(){ // if we rebuffer, we don't want the placeholder buffer to artificially raise BOLA quality
	for(var mediaType in bolaStateDict) {if(bolaStateDict.hasOwnProperty(mediaType) && bolaStateDict[mediaType].state === BOLA_STATE_STEADY){bolaStateDict[mediaType].placeholderBuffer = 0;}}}function onPlaybackSeeking(){ // TODO: 1. Verify what happens if we seek mid-fragment.
	// TODO: 2. If e.g. we have 10s fragments and seek, we might want to download the first fragment at a lower quality to restart playback quickly.
	for(var mediaType in bolaStateDict) {if(bolaStateDict.hasOwnProperty(mediaType)){var bolaState=bolaStateDict[mediaType];if(bolaState.state !== BOLA_STATE_ONE_BITRATE){bolaState.state = BOLA_STATE_STARTUP; // TODO: BOLA_STATE_SEEK?
	clearBolaStateOnSeek(bolaState);}}}}function onPeriodSwitchStarted(){ // TODO: does this have to be handled here?
	}function onMediaFragmentLoaded(e){if(e && e.chunk && e.chunk.mediaInfo){var bolaState=bolaStateDict[e.chunk.mediaInfo.type];if(bolaState && bolaState.state !== BOLA_STATE_ONE_BITRATE){var start=e.chunk.start;if(isNaN(bolaState.mostAdvancedSegmentStart) || start > bolaState.mostAdvancedSegmentStart){bolaState.mostAdvancedSegmentStart = start;bolaState.lastSegmentWasReplacement = false;}else {bolaState.lastSegmentWasReplacement = true;}bolaState.lastSegmentStart = start;bolaState.lastSegmentDurationS = e.chunk.duration;bolaState.lastQuality = e.chunk.quality;checkNewSegment(bolaState,e.chunk.mediaInfo.type);}}}function onMetricAdded(e){if(e && e.metric === _constantsMetricsConstants2['default'].HTTP_REQUEST && e.value && e.value.type === _voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE && e.value.trace && e.value.trace.length){var bolaState=bolaStateDict[e.mediaType];if(bolaState && bolaState.state !== BOLA_STATE_ONE_BITRATE){bolaState.lastSegmentRequestTimeMs = e.value.trequest.getTime();bolaState.lastSegmentFinishTimeMs = e.value._tfinish.getTime();checkNewSegment(bolaState,e.mediaType);}}} /*
	     * When a new segment is downloaded, we get two notifications: onMediaFragmentLoaded() and onMetricAdded(). It is
	     * possible that the quality for the downloaded segment was lower (not higher) than the quality indicated by BOLA.
	     * This might happen because of other rules such as the DroppedFramesRule. When this happens, we trim the
	     * placeholder buffer to make BOLA more stable. This mechanism also avoids inflating the buffer when BOLA itself
	     * decides not to increase the quality to avoid oscillations.
	     *
	     * We should also check for replacement segments (fast switching). In this case, a segment is downloaded but does
	     * not grow the actual buffer. Fast switching might cause the buffer to deplete, causing BOLA to drop the bitrate.
	     * We avoid this by growing the placeholder buffer.
	     */function checkNewSegment(bolaState,mediaType){if(!isNaN(bolaState.lastSegmentStart) && !isNaN(bolaState.lastSegmentRequestTimeMs) && !isNaN(bolaState.placeholderBuffer)){bolaState.placeholderBuffer *= PLACEHOLDER_BUFFER_DECAY; // Find what maximum buffer corresponding to last segment was, and ensure placeholder is not relatively larger.
	if(!isNaN(bolaState.lastSegmentFinishTimeMs)){var bufferLevel=dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(mediaType));var bufferAtLastSegmentRequest=bufferLevel + 0.001 * (bolaState.lastSegmentFinishTimeMs - bolaState.lastSegmentRequestTimeMs); // estimate
	var maxEffectiveBufferForLastSegment=maxBufferLevelForQuality(bolaState,bolaState.lastQuality);var maxPlaceholderBuffer=Math.max(0,maxEffectiveBufferForLastSegment - bufferAtLastSegmentRequest);bolaState.placeholderBuffer = Math.min(maxPlaceholderBuffer,bolaState.placeholderBuffer);} // then see if we should grow placeholder buffer
	if(bolaState.lastSegmentWasReplacement && !isNaN(bolaState.lastSegmentDurationS)){ // compensate for segments that were downloaded but did not grow the buffer
	bolaState.placeholderBuffer += bolaState.lastSegmentDurationS;}bolaState.lastSegmentStart = NaN;bolaState.lastSegmentRequestTimeMs = NaN;}}function onQualityChangeRequested(e){ // Useful to store change requests when abandoning a download.
	if(e){var bolaState=bolaStateDict[e.mediaType];if(bolaState && bolaState.state !== BOLA_STATE_ONE_BITRATE){bolaState.abrQuality = e.newQuality;}}}function onFragmentLoadingAbandoned(e){if(e){var bolaState=bolaStateDict[e.mediaType];if(bolaState && bolaState.state !== BOLA_STATE_ONE_BITRATE){ // deflate placeholderBuffer - note that we want to be conservative when abandoning
	var bufferLevel=dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(e.mediaType));var wantEffectiveBufferLevel=undefined;if(bolaState.abrQuality > 0){ // deflate to point where BOLA just chooses newQuality over newQuality-1
	wantEffectiveBufferLevel = minBufferLevelForQuality(bolaState,bolaState.abrQuality);}else {wantEffectiveBufferLevel = MINIMUM_BUFFER_S;}var maxPlaceholderBuffer=Math.max(0,wantEffectiveBufferLevel - bufferLevel);bolaState.placeholderBuffer = Math.min(bolaState.placeholderBuffer,maxPlaceholderBuffer);}}}function getMaxIndex(rulesContext){var mediaInfo=rulesContext.getMediaInfo();var mediaType=rulesContext.getMediaType();var metrics=metricsModel.getReadOnlyMetricsFor(mediaType);var streamProcessor=rulesContext.getStreamProcessor();var streamInfo=rulesContext.getStreamInfo();var abrController=rulesContext.getAbrController();var throughputHistory=abrController.getThroughputHistory();var streamId=streamInfo?streamInfo.id:null;var isDynamic=streamInfo && streamInfo.manifestInfo && streamInfo.manifestInfo.isDynamic;var useBufferOccupancyABR=rulesContext.useBufferOccupancyABR();var switchRequest=(0,_SwitchRequest2['default'])(context).create();switchRequest.reason = switchRequest.reason || {};if(!useBufferOccupancyABR){return switchRequest;}streamProcessor.getScheduleController().setTimeToLoadDelay(0);var bolaState=getBolaState(rulesContext);if(bolaState.state === BOLA_STATE_ONE_BITRATE){ // shouldn't even have been called
	return switchRequest;}var bufferLevel=dashMetrics.getCurrentBufferLevel(metrics);var throughput=throughputHistory.getAverageThroughput(mediaType,isDynamic);var safeThroughput=throughputHistory.getSafeAverageThroughput(mediaType,isDynamic);var latency=throughputHistory.getAverageLatency(mediaType);var quality=undefined;switchRequest.reason.state = bolaState.state;switchRequest.reason.throughput = throughput;switchRequest.reason.latency = latency;if(isNaN(throughput)){ // isNaN(throughput) === isNaN(safeThroughput) === isNaN(latency)
	// still starting up - not enough information
	return switchRequest;}switch(bolaState.state){case BOLA_STATE_STARTUP:quality = abrController.getQualityForBitrate(mediaInfo,safeThroughput,latency);switchRequest.quality = quality;switchRequest.reason.throughput = safeThroughput;bolaState.placeholderBuffer = Math.max(0,minBufferLevelForQuality(bolaState,quality) - bufferLevel);bolaState.lastQuality = quality;if(!isNaN(bolaState.lastSegmentDurationS) && bufferLevel >= bolaState.lastSegmentDurationS){bolaState.state = BOLA_STATE_STEADY;}break; // BOLA_STATE_STARTUP
	case BOLA_STATE_STEADY: // NB: The placeholder buffer is added to bufferLevel to come up with a bitrate.
	//     This might lead BOLA to be too optimistic and to choose a bitrate that would lead to rebuffering -
	//     if the real buffer bufferLevel runs out, the placeholder buffer cannot prevent rebuffering.
	//     However, the InsufficientBufferRule takes care of this scenario.
	updatePlaceholderBuffer(bolaState,mediaType);quality = getQualityFromBufferLevel(bolaState,bufferLevel + bolaState.placeholderBuffer); // we want to avoid oscillations
	// We implement the "BOLA-O" variant: when network bandwidth lies between two encoded bitrate levels, stick to the lowest level.
	var qualityForThroughput=abrController.getQualityForBitrate(mediaInfo,safeThroughput,latency);if(quality > bolaState.lastQuality && quality > qualityForThroughput){ // only intervene if we are trying to *increase* quality to an *unsustainable* level
	// we are only avoid oscillations - do not drop below last quality
	quality = Math.max(qualityForThroughput,bolaState.lastQuality);} // We do not want to overfill buffer with low quality chunks.
	// Note that there will be no delay if buffer level is below MINIMUM_BUFFER_S, probably even with some margin higher than MINIMUM_BUFFER_S.
	var delayS=Math.max(0,bufferLevel + bolaState.placeholderBuffer - maxBufferLevelForQuality(bolaState,quality)); // First reduce placeholder buffer, then tell schedule controller to pause.
	if(delayS <= bolaState.placeholderBuffer){bolaState.placeholderBuffer -= delayS;delayS = 0;}else {delayS -= bolaState.placeholderBuffer;bolaState.placeholderBuffer = 0;if(quality < abrController.getTopQualityIndexFor(mediaType,streamId)){ // At top quality, allow schedule controller to decide how far to fill buffer.
	streamProcessor.getScheduleController().setTimeToLoadDelay(1000 * delayS);}else {delayS = 0;}}switchRequest.quality = quality;switchRequest.reason.throughput = throughput;switchRequest.reason.latency = latency;switchRequest.reason.bufferLevel = bufferLevel;switchRequest.reason.placeholderBuffer = bolaState.placeholderBuffer;switchRequest.reason.delay = delayS;bolaState.lastQuality = quality; // keep bolaState.state === BOLA_STATE_STEADY
	break; // BOLA_STATE_STEADY
	default:log('BOLA ABR rule invoked in bad state.'); // should not arrive here, try to recover
	switchRequest.quality = abrController.getQualityForBitrate(mediaInfo,safeThroughput,latency);switchRequest.reason.state = bolaState.state;switchRequest.reason.throughput = safeThroughput;switchRequest.reason.latency = latency;bolaState.state = BOLA_STATE_STARTUP;clearBolaStateOnSeek(bolaState);}return switchRequest;}function resetInitialSettings(){bolaStateDict = {};}function reset(){resetInitialSettings();eventBus.off(_coreEventsEvents2['default'].BUFFER_EMPTY,onBufferEmpty,instance);eventBus.off(_coreEventsEvents2['default'].PLAYBACK_SEEKING,onPlaybackSeeking,instance);eventBus.off(_coreEventsEvents2['default'].PERIOD_SWITCH_STARTED,onPeriodSwitchStarted,instance);eventBus.off(_coreEventsEvents2['default'].MEDIA_FRAGMENT_LOADED,onMediaFragmentLoaded,instance);eventBus.off(_coreEventsEvents2['default'].METRIC_ADDED,onMetricAdded,instance);eventBus.off(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED,onQualityChangeRequested,instance);eventBus.off(_coreEventsEvents2['default'].FRAGMENT_LOADING_ABANDONED,onFragmentLoadingAbandoned,instance);}instance = {getMaxIndex:getMaxIndex,reset:reset};setup();return instance;}BolaRule.__dashjs_factory_name = 'BolaRule';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(BolaRule);module.exports = exports['default'];
	//# sourceMappingURL=BolaRule.js.map


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _SwitchRequest=__webpack_require__(27);var _SwitchRequest2=_interopRequireDefault(_SwitchRequest);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);function DroppedFramesRule(){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var DROPPED_PERCENTAGE_FORBID=0.15;var GOOD_SAMPLE_SIZE=375; //Don't apply the rule until this many frames have been rendered(and counted under those indices).
	function getMaxIndex(rulesContext){var droppedFramesHistory=rulesContext.getDroppedFramesHistory();if(droppedFramesHistory){var dfh=droppedFramesHistory.getFrameHistory();var droppedFrames=0;var totalFrames=0;var maxIndex=_SwitchRequest2['default'].NO_CHANGE;for(var i=1;i < dfh.length;i++) { //No point in measuring dropped frames for the zeroeth index.
	if(dfh[i]){droppedFrames = dfh[i].droppedVideoFrames;totalFrames = dfh[i].totalVideoFrames;if(totalFrames > GOOD_SAMPLE_SIZE && droppedFrames / totalFrames > DROPPED_PERCENTAGE_FORBID){maxIndex = i - 1;log('DroppedFramesRule, index: ' + maxIndex + ' Dropped Frames: ' + droppedFrames + ' Total Frames: ' + totalFrames);break;}}}return (0,_SwitchRequest2['default'])(context).create(maxIndex,{droppedFrames:droppedFrames});}return (0,_SwitchRequest2['default'])(context).create();}return {getMaxIndex:getMaxIndex};}DroppedFramesRule.__dashjs_factory_name = 'DroppedFramesRule';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(DroppedFramesRule);module.exports = exports['default'];
	//# sourceMappingURL=DroppedFramesRule.js.map


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _controllersBufferController=__webpack_require__(36);var _controllersBufferController2=_interopRequireDefault(_controllersBufferController);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _SwitchRequest=__webpack_require__(27);var _SwitchRequest2=_interopRequireDefault(_SwitchRequest);function InsufficientBufferRule(config){config = config || {};var INSUFFICIENT_BUFFER_SAFETY_FACTOR=0.5;var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var metricsModel=config.metricsModel;var dashMetrics=config.dashMetrics;var instance=undefined,bufferStateDict=undefined;function setup(){resetInitialSettings();eventBus.on(_coreEventsEvents2['default'].PLAYBACK_SEEKING,onPlaybackSeeking,instance);}function checkConfig(){if(!metricsModel || !metricsModel.hasOwnProperty('getReadOnlyMetricsFor') || !dashMetrics || !dashMetrics.hasOwnProperty('getCurrentBufferLevel')){throw new Error('Missing config parameter(s)');}} /*
	     * InsufficientBufferRule does not kick in before the first BUFFER_LOADED event happens. This is reset at every seek.
	     *
	     * If a BUFFER_EMPTY event happens, then InsufficientBufferRule returns switchRequest.quality=0 until BUFFER_LOADED happens.
	     *
	     * Otherwise InsufficientBufferRule gives a maximum bitrate depending on throughput and bufferLevel such that
	     * a whole fragment can be downloaded before the buffer runs out, subject to a conservative safety factor of 0.5.
	     * If the bufferLevel is low, then InsufficientBufferRule avoids rebuffering risk.
	     * If the bufferLevel is high, then InsufficientBufferRule give a high MaxIndex allowing other rules to take over.
	     */function getMaxIndex(rulesContext){var switchRequest=(0,_SwitchRequest2['default'])(context).create();if(!rulesContext || !rulesContext.hasOwnProperty('getMediaType')){return switchRequest;}checkConfig();var mediaType=rulesContext.getMediaType();var metrics=metricsModel.getReadOnlyMetricsFor(mediaType);var lastBufferStateVO=metrics.BufferState.length > 0?metrics.BufferState[metrics.BufferState.length - 1]:null;var representationInfo=rulesContext.getRepresentationInfo();var fragmentDuration=representationInfo.fragmentDuration; // Don't ask for a bitrate change if there is not info about buffer state or if fragmentDuration is not defined
	if(!lastBufferStateVO || !wasFirstBufferLoadedEventTriggered(mediaType,lastBufferStateVO) || !fragmentDuration){return switchRequest;}if(lastBufferStateVO.state === _controllersBufferController2['default'].BUFFER_EMPTY){log('Switch to index 0; buffer is empty.');switchRequest.quality = 0;switchRequest.reason = 'InsufficientBufferRule: Buffer is empty';}else {var mediaInfo=rulesContext.getMediaInfo();var abrController=rulesContext.getAbrController();var throughputHistory=abrController.getThroughputHistory();var bufferLevel=dashMetrics.getCurrentBufferLevel(metrics);var throughput=throughputHistory.getAverageThroughput(mediaType);var latency=throughputHistory.getAverageLatency(mediaType);var bitrate=throughput * (bufferLevel / fragmentDuration) * INSUFFICIENT_BUFFER_SAFETY_FACTOR;switchRequest.quality = abrController.getQualityForBitrate(mediaInfo,bitrate,latency);switchRequest.reason = 'InsufficientBufferRule: being conservative to avoid immediate rebuffering';}return switchRequest;}function wasFirstBufferLoadedEventTriggered(mediaType,currentBufferState){bufferStateDict[mediaType] = bufferStateDict[mediaType] || {};var wasTriggered=false;if(bufferStateDict[mediaType].firstBufferLoadedEvent){wasTriggered = true;}else if(currentBufferState && currentBufferState.state === _controllersBufferController2['default'].BUFFER_LOADED){bufferStateDict[mediaType].firstBufferLoadedEvent = true;wasTriggered = true;}return wasTriggered;}function resetInitialSettings(){bufferStateDict = {};}function onPlaybackSeeking(){resetInitialSettings();}function reset(){resetInitialSettings();eventBus.off(_coreEventsEvents2['default'].PLAYBACK_SEEKING,onPlaybackSeeking,instance);}instance = {getMaxIndex:getMaxIndex,reset:reset};setup();return instance;}InsufficientBufferRule.__dashjs_factory_name = 'InsufficientBufferRule';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(InsufficientBufferRule);module.exports = exports['default'];
	//# sourceMappingURL=InsufficientBufferRule.js.map


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _SwitchRequest=__webpack_require__(27);var _SwitchRequest2=_interopRequireDefault(_SwitchRequest);function SwitchHistoryRule(){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log; //MAX_SWITCH is the number of drops made. It doesn't consider the size of the drop.
	var MAX_SWITCH=0.075; //Before this number of switch requests(no switch or actual), don't apply the rule.
	//must be < SwitchRequestHistory SWITCH_REQUEST_HISTORY_DEPTH to enable rule
	var SAMPLE_SIZE=6;function getMaxIndex(rulesContext){var switchRequestHistory=rulesContext?rulesContext.getSwitchHistory():null;var switchRequests=switchRequestHistory?switchRequestHistory.getSwitchRequests():[];var drops=0;var noDrops=0;var dropSize=0;var switchRequest=(0,_SwitchRequest2['default'])(context).create();for(var i=0;i < switchRequests.length;i++) {if(switchRequests[i] !== undefined){drops += switchRequests[i].drops;noDrops += switchRequests[i].noDrops;dropSize += switchRequests[i].dropSize;if(drops + noDrops >= SAMPLE_SIZE && drops / noDrops > MAX_SWITCH){switchRequest.quality = i > 0 && switchRequests[i].drops > 0?i - 1:i;switchRequest.reason = {index:switchRequest.quality,drops:drops,noDrops:noDrops,dropSize:dropSize};log('Switch history rule index: ' + switchRequest.quality + ' samples: ' + (drops + noDrops) + ' drops: ' + drops);break;}}}return switchRequest;}return {getMaxIndex:getMaxIndex};}SwitchHistoryRule.__dashjs_factory_name = 'SwitchHistoryRule';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(SwitchHistoryRule);module.exports = exports['default'];
	//# sourceMappingURL=SwitchHistoryRule.js.map


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _controllersBufferController=__webpack_require__(36);var _controllersBufferController2=_interopRequireDefault(_controllersBufferController);var _controllersAbrController=__webpack_require__(64);var _controllersAbrController2=_interopRequireDefault(_controllersAbrController);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _SwitchRequest=__webpack_require__(27);var _SwitchRequest2=_interopRequireDefault(_SwitchRequest);function ThroughputRule(config){config = config || {};var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var metricsModel=config.metricsModel;function checkConfig(){if(!metricsModel || !metricsModel.hasOwnProperty('getReadOnlyMetricsFor')){throw new Error('Missing config parameter(s)');}}function getMaxIndex(rulesContext){var switchRequest=(0,_SwitchRequest2['default'])(context).create();if(!rulesContext || !rulesContext.hasOwnProperty('getMediaInfo') || !rulesContext.hasOwnProperty('getMediaType') || !rulesContext.hasOwnProperty('useBufferOccupancyABR') || !rulesContext.hasOwnProperty('getAbrController') || !rulesContext.hasOwnProperty('getStreamProcessor')){return switchRequest;}checkConfig();var mediaInfo=rulesContext.getMediaInfo();var mediaType=rulesContext.getMediaType();var metrics=metricsModel.getReadOnlyMetricsFor(mediaType);var streamProcessor=rulesContext.getStreamProcessor();var abrController=rulesContext.getAbrController();var streamInfo=rulesContext.getStreamInfo();var isDynamic=streamInfo && streamInfo.manifestInfo?streamInfo.manifestInfo.isDynamic:null;var throughputHistory=abrController.getThroughputHistory();var throughput=throughputHistory.getSafeAverageThroughput(mediaType,isDynamic);var latency=throughputHistory.getAverageLatency(mediaType);var bufferStateVO=metrics.BufferState.length > 0?metrics.BufferState[metrics.BufferState.length - 1]:null;var useBufferOccupancyABR=rulesContext.useBufferOccupancyABR();if(!metrics || isNaN(throughput) || !bufferStateVO || useBufferOccupancyABR){return switchRequest;}if(abrController.getAbandonmentStateFor(mediaType) !== _controllersAbrController2['default'].ABANDON_LOAD){if(bufferStateVO.state === _controllersBufferController2['default'].BUFFER_LOADED || isDynamic){switchRequest.quality = abrController.getQualityForBitrate(mediaInfo,throughput,latency);streamProcessor.getScheduleController().setTimeToLoadDelay(0);log('ThroughputRule requesting switch to index: ',switchRequest.quality,'type: ',mediaType,'Average throughput',Math.round(throughput),'kbps');switchRequest.reason = {throughput:throughput,latency:latency};}}return switchRequest;}function reset(){ // no persistent information to reset
	}var instance={getMaxIndex:getMaxIndex,reset:reset};return instance;}ThroughputRule.__dashjs_factory_name = 'ThroughputRule';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ThroughputRule);module.exports = exports['default'];
	//# sourceMappingURL=ThroughputRule.js.map


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function BufferLevelRule(config){config = config || {};var dashMetrics=config.dashMetrics;var metricsModel=config.metricsModel;var mediaPlayerModel=config.mediaPlayerModel;var textController=config.textController;var abrController=config.abrController;function setup(){}function execute(streamProcessor,type,videoTrackPresent){var bufferLevel=dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(type));return bufferLevel < getBufferTarget(streamProcessor,type,videoTrackPresent);}function getBufferTarget(streamProcessor,type,videoTrackPresent){var bufferTarget=NaN;var representationInfo=streamProcessor.getCurrentRepresentationInfo();if(type === _constantsConstants2['default'].FRAGMENTED_TEXT){bufferTarget = textController.getAllTracksAreDisabled()?0:representationInfo.fragmentDuration;}else if(type === _constantsConstants2['default'].AUDIO && videoTrackPresent){var videoBufferLevel=dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(_constantsConstants2['default'].VIDEO));if(isNaN(representationInfo.fragmentDuration)){bufferTarget = videoBufferLevel;}else {bufferTarget = Math.max(videoBufferLevel,representationInfo.fragmentDuration);} // console.log('videoBufferLevel  - ' + videoBufferLevel + ' target : ' + bufferTarget);
	}else {var streamInfo=representationInfo.mediaInfo.streamInfo;if(abrController.isPlayingAtTopQuality(streamInfo)){var isLongFormContent=streamInfo.manifestInfo.duration >= mediaPlayerModel.getLongFormContentDurationThreshold();bufferTarget = isLongFormContent?mediaPlayerModel.getBufferTimeAtTopQualityLongForm():mediaPlayerModel.getBufferTimeAtTopQuality();}else {bufferTarget = mediaPlayerModel.getStableBufferTime();}}return bufferTarget;}var instance={execute:execute,getBufferTarget:getBufferTarget};setup();return instance;}BufferLevelRule.__dashjs_factory_name = 'BufferLevelRule';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(BufferLevelRule);module.exports = exports['default'];
	//# sourceMappingURL=BufferLevelRule.js.map


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _streamingVoFragmentRequest=__webpack_require__(37);var _streamingVoFragmentRequest2=_interopRequireDefault(_streamingVoFragmentRequest);function NextFragmentRequestRule(config){config = config || {};var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var adapter=config.adapter;var textController=config.textController;function execute(streamProcessor,requestToReplace){var representationInfo=streamProcessor.getCurrentRepresentationInfo();var mediaInfo=representationInfo.mediaInfo;var mediaType=mediaInfo.type;var scheduleController=streamProcessor.getScheduleController();var seekTarget=scheduleController.getSeekTarget();var hasSeekTarget=!isNaN(seekTarget);var bufferController=streamProcessor.getBufferController();var time=hasSeekTarget?seekTarget:adapter.getIndexHandlerTime(streamProcessor);if(isNaN(time) || mediaType === _constantsConstants2['default'].FRAGMENTED_TEXT && textController.getAllTracksAreDisabled()){return null;}if(hasSeekTarget){scheduleController.setSeekTarget(NaN);} /**
	         * This is critical for IE/Safari/EDGE
	         * */if(bufferController){var range=bufferController.getRangeAt(time);if(range !== null && !hasSeekTarget){log('Prior to making a request for time, NextFragmentRequestRule is aligning index handler\'s currentTime with bufferedRange.end for',mediaType,'.',time,'was changed to',range.end);time = range.end;}}var request=undefined;if(requestToReplace){time = requestToReplace.startTime + requestToReplace.duration / 2;request = adapter.getFragmentRequestForTime(streamProcessor,representationInfo,time,{timeThreshold:0,ignoreIsFinished:true});}else {request = adapter.getFragmentRequestForTime(streamProcessor,representationInfo,time,{keepIdx:!hasSeekTarget}); // Then, check if this request was downloaded or not
	while(request && request.action !== _streamingVoFragmentRequest2['default'].ACTION_COMPLETE && streamProcessor.getFragmentModel().isFragmentLoaded(request)) { // loop until we found not loaded fragment, or no fragment
	request = adapter.getNextFragmentRequest(streamProcessor,representationInfo);}if(request){if(!isNaN(request.startTime + request.duration)){adapter.setIndexHandlerTime(streamProcessor,request.startTime + request.duration);}request.delayLoadingTime = new Date().getTime() + scheduleController.getTimeToLoadDelay();scheduleController.setTimeToLoadDelay(0);}}return request;}var instance={execute:execute};return instance;}NextFragmentRequestRule.__dashjs_factory_name = 'NextFragmentRequestRule';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(NextFragmentRequestRule);module.exports = exports['default'];
	//# sourceMappingURL=NextFragmentRequestRule.js.map


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function EmbeddedTextHtmlRender(){var captionId=0;var instance=undefined; /* HTML Rendering functions */function checkIndent(chars){var line='';for(var c=0;c < chars.length;++c) {var uc=chars[c];line += uc.uchar;}var l=line.length;var ll=line.replace(/^\s+/,'').length;return l - ll;}function getRegionProperties(region){return 'left: ' + region.x * 3.125 + '%; top: ' + region.y1 * 6.66 + '%; width: ' + (100 - region.x * 3.125) + '%; height: ' + Math.max(region.y2 - 1 - region.y1,1) * 6.66 + '%; align-items: flex-start; overflow: visible; -webkit-writing-mode: horizontal-tb;';}function createRGB(color){if(color === 'red'){return 'rgb(255, 0, 0)';}else if(color === 'green'){return 'rgb(0, 255, 0)';}else if(color === 'blue'){return 'rgb(0, 0, 255)';}else if(color === 'cyan'){return 'rgb(0, 255, 255)';}else if(color === 'magenta'){return 'rgb(255, 0, 255)';}else if(color === 'yellow'){return 'rgb(255, 255, 0)';}else if(color === 'white'){return 'rgb(255, 255, 255)';}else if(color === 'black'){return 'rgb(0, 0, 0)';}return color;}function getStyle(videoElement,style){var fontSize=videoElement.videoHeight / 15.0;if(style){return 'font-size: ' + fontSize + 'px; font-family: Menlo, Consolas, \'Cutive Mono\', monospace; color: ' + (style.foreground?createRGB(style.foreground):'rgb(255, 255, 255)') + '; font-style: ' + (style.italics?'italic':'normal') + '; text-decoration: ' + (style.underline?'underline':'none') + '; white-space: pre; background-color: ' + (style.background?createRGB(style.background):'transparent') + ';';}else {return 'font-size: ' + fontSize + 'px; font-family: Menlo, Consolas, \'Cutive Mono\', monospace; justify-content: flex-start; text-align: left; color: rgb(255, 255, 255); font-style: normal; white-space: pre; line-height: normal; font-weight: normal; text-decoration: none; width: 100%; display: flex;';}}function ltrim(s){var trimmed=s.replace(/^\s+/g,'');return trimmed;}function rtrim(s){var trimmed=s.replace(/\s+$/g,'');return trimmed;}function createHTMLCaptionsFromScreen(videoElement,startTime,endTime,captionScreen){var currRegion=null;var existingRegion=null;var lastRowHasText=false;var lastRowIndentL=-1;var currP={start:startTime,end:endTime,spans:[]};var currentStyle='style_cea608_white_black';var seenRegions={};var styleStates={};var regions=[];var r=undefined,s=undefined;for(r = 0;r < 15;++r) {var row=captionScreen.rows[r];var line='';var prevPenState=null;if(false === row.isEmpty()){ /* Row is not empty */ /* Get indentation of this row */var rowIndent=checkIndent(row.chars); /* Create a new region is there is none */if(currRegion === null){currRegion = {x:rowIndent,y1:r,y2:r + 1,p:[]};} /* Check if indentation has changed and we had text of last row */if(rowIndent !== lastRowIndentL && lastRowHasText){currRegion.p.push(currP);currP = {start:startTime,end:endTime,spans:[]};currRegion.y2 = r;currRegion.name = 'region_' + currRegion.x + '_' + currRegion.y1 + '_' + currRegion.y2;if(false === seenRegions.hasOwnProperty(currRegion.name)){regions.push(currRegion);seenRegions[currRegion.name] = currRegion;}else {existingRegion = seenRegions[currRegion.name];existingRegion.p.contat(currRegion.p);}currRegion = {x:rowIndent,y1:r,y2:r + 1,p:[]};}for(var c=0;c < row.chars.length;++c) {var uc=row.chars[c];var currPenState=uc.penState;if(prevPenState === null || !currPenState.equals(prevPenState)){if(line.trim().length > 0){currP.spans.push({name:currentStyle,line:line,row:r});line = '';}var currPenStateString='style_cea608_' + currPenState.foreground + '_' + currPenState.background;if(currPenState.underline){currPenStateString += '_underline';}if(currPenState.italics){currPenStateString += '_italics';}if(!styleStates.hasOwnProperty(currPenStateString)){styleStates[currPenStateString] = JSON.parse(JSON.stringify(currPenState));}prevPenState = currPenState;currentStyle = currPenStateString;}line += uc.uchar;}if(line.trim().length > 0){currP.spans.push({name:currentStyle,line:line,row:r});}lastRowHasText = true;lastRowIndentL = rowIndent;}else { /* Row is empty */lastRowHasText = false;lastRowIndentL = -1;if(currRegion){currRegion.p.push(currP);currP = {start:startTime,end:endTime,spans:[]};currRegion.y2 = r;currRegion.name = 'region_' + currRegion.x + '_' + currRegion.y1 + '_' + currRegion.y2;if(false === seenRegions.hasOwnProperty(currRegion.name)){regions.push(currRegion);seenRegions[currRegion.name] = currRegion;}else {existingRegion = seenRegions[currRegion.name];existingRegion.p.contat(currRegion.p);}currRegion = null;}}}if(currRegion){currRegion.p.push(currP);currRegion.y2 = r + 1;currRegion.name = 'region_' + currRegion.x + '_' + currRegion.y1 + '_' + currRegion.y2;if(false === seenRegions.hasOwnProperty(currRegion.name)){regions.push(currRegion);seenRegions[currRegion.name] = currRegion;}else {existingRegion = seenRegions[currRegion.name];existingRegion.p.contat(currRegion.p);}currRegion = null;} //log(styleStates);
	//log(regions);
	var captionsArray=[]; /* Loop thru regions */for(r = 0;r < regions.length;++r) {var region=regions[r];var cueID='sub_cea608_' + captionId++;var finalDiv=document.createElement('div');finalDiv.id = cueID;var cueRegionProperties=getRegionProperties(region);finalDiv.style.cssText = 'position: absolute; margin: 0; display: flex; box-sizing: border-box; pointer-events: none;' + cueRegionProperties;var bodyDiv=document.createElement('div');bodyDiv.className = 'paragraph bodyStyle';bodyDiv.style.cssText = getStyle(videoElement);var cueUniWrapper=document.createElement('div');cueUniWrapper.className = 'cueUniWrapper';cueUniWrapper.style.cssText = 'unicode-bidi: normal; direction: ltr;';for(var p=0;p < region.p.length;++p) {var ptag=region.p[p];var lastSpanRow=0;for(s = 0;s < ptag.spans.length;++s) {var span=ptag.spans[s];if(span.line.length > 0){if(s !== 0 && lastSpanRow != span.row){var brElement=document.createElement('br');brElement.className = 'lineBreak';cueUniWrapper.appendChild(brElement);}var sameRow=false;if(lastSpanRow === span.row){sameRow = true;}lastSpanRow = span.row;var spanStyle=styleStates[span.name];var spanElement=document.createElement('span');spanElement.className = 'spanPadding ' + span.name + ' customSpanColor';spanElement.style.cssText = getStyle(videoElement,spanStyle); /* If this is not the first span, and it's on the same
	                         * row as the last one */if(s !== 0 && sameRow){ /* and it's the last span on this row */if(s === ptag.spans.length - 1){ /* trim only the right side */spanElement.textContent = rtrim(span.line);}else { /* don't trim at all */spanElement.textContent = span.line;}}else { /* if there is more than 1 span and this isn't the last span */if(ptag.spans.length > 1 && s < ptag.spans.length - 1){ /* Check if next text is on same row */if(span.row === ptag.spans[s + 1].row){ /* Next element on same row, trim start */spanElement.textContent = ltrim(span.line);}else { /* Different rows, trim both */spanElement.textContent = span.line.trim();}}else {spanElement.textContent = span.line.trim();}}cueUniWrapper.appendChild(spanElement);}}}bodyDiv.appendChild(cueUniWrapper);finalDiv.appendChild(bodyDiv);var fontSize={'bodyStyle':['%',90]};for(s in styleStates) {if(styleStates.hasOwnProperty(s)){fontSize[s] = ['%',90];}}captionsArray.push({type:'html',start:startTime,end:endTime,cueHTMLElement:finalDiv,cueID:cueID,cellResolution:[32,15],isFromCEA608:true,regions:regions,regionID:region.name,videoHeight:videoElement.videoHeight,videoWidth:videoElement.videoWidth,fontSize:fontSize,lineHeight:{},linePadding:{}});}return captionsArray;}instance = {createHTMLCaptionsFromScreen:createHTMLCaptionsFromScreen};return instance;}EmbeddedTextHtmlRender.__dashjs_factory_name = 'EmbeddedTextHtmlRender';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(EmbeddedTextHtmlRender);module.exports = exports['default'];
	//# sourceMappingURL=EmbeddedTextHtmlRender.js.map


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _utilsInitCache=__webpack_require__(97);var _utilsInitCache2=_interopRequireDefault(_utilsInitCache);var _SourceBufferSink=__webpack_require__(145);var _SourceBufferSink2=_interopRequireDefault(_SourceBufferSink);var _streamingTextTextController=__webpack_require__(95);var _streamingTextTextController2=_interopRequireDefault(_streamingTextTextController);var BUFFER_CONTROLLER_TYPE='NotFragmentedTextBufferController';function NotFragmentedTextBufferController(config){config = config || {};var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var textController=(0,_streamingTextTextController2['default'])(context).getInstance();var errHandler=config.errHandler;var type=config.type;var streamProcessor=config.streamProcessor;var instance=undefined,isBufferingCompleted=undefined,initialized=undefined,mediaSource=undefined,buffer=undefined,representationController=undefined,initCache=undefined;function setup(){initialized = false;mediaSource = null;representationController = null;isBufferingCompleted = false;eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,onDataUpdateCompleted,instance);eventBus.on(_coreEventsEvents2['default'].INIT_FRAGMENT_LOADED,onInitFragmentLoaded,instance);}function getBufferControllerType(){return BUFFER_CONTROLLER_TYPE;}function initialize(source){setMediaSource(source);representationController = streamProcessor.getRepresentationController();initCache = (0,_utilsInitCache2['default'])(context).getInstance();} /**
	     * @param {MediaInfo }mediaInfo
	     * @memberof BufferController#
	     */function createBuffer(mediaInfo){try{buffer = (0,_SourceBufferSink2['default'])(context).create(mediaSource,mediaInfo);if(!initialized){var textBuffer=buffer.getBuffer();if(textBuffer.hasOwnProperty(_constantsConstants2['default'].INITIALIZE)){textBuffer.initialize(type,streamProcessor);}initialized = true;}}catch(e) {if(mediaInfo.isText || mediaInfo.codec.indexOf('codecs="stpp') !== -1 || mediaInfo.codec.indexOf('codecs="wvtt') !== -1){try{buffer = textController.getTextSourceBuffer();}catch(e) {errHandler.mediaSourceError('Error creating ' + type + ' source buffer.');}}else {errHandler.mediaSourceError('Error creating ' + type + ' source buffer.');}}}function getType(){return type;}function getBuffer(){return buffer;}function setMediaSource(value){mediaSource = value;}function getMediaSource(){return mediaSource;}function getStreamProcessor(){return streamProcessor;}function getIsPruningInProgress(){return false;}function dischargePreBuffer(){}function setSeekStartTime(){ //Unused - TODO Remove need for stub function
	}function getBufferLevel(){return 0;}function getIsBufferingCompleted(){return isBufferingCompleted;}function reset(errored){eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED,onDataUpdateCompleted,instance);eventBus.off(_coreEventsEvents2['default'].INIT_FRAGMENT_LOADED,onInitFragmentLoaded,instance);if(!errored && buffer){buffer.abort();buffer.reset();buffer = null;}}function onDataUpdateCompleted(e){if(e.sender.getStreamProcessor() !== streamProcessor){return;}eventBus.trigger(_coreEventsEvents2['default'].TIMED_TEXT_REQUESTED,{index:0,sender:e.sender}); //TODO make index dynamic if referring to MP?
	}function onInitFragmentLoaded(e){if(e.fragmentModel !== streamProcessor.getFragmentModel() || !e.chunk.bytes){return;}initCache.save(e.chunk);buffer.append(e.chunk);}function switchInitData(streamId,representationId){var chunk=initCache.extract(streamId,representationId);if(chunk){buffer.append(chunk);}else {eventBus.trigger(_coreEventsEvents2['default'].INIT_REQUESTED,{sender:instance});}}function getRangeAt(){return null;}instance = {getBufferControllerType:getBufferControllerType,initialize:initialize,createBuffer:createBuffer,getType:getType,getStreamProcessor:getStreamProcessor,setSeekStartTime:setSeekStartTime,getBuffer:getBuffer,getBufferLevel:getBufferLevel,setMediaSource:setMediaSource,getMediaSource:getMediaSource,getIsBufferingCompleted:getIsBufferingCompleted,getIsPruningInProgress:getIsPruningInProgress,dischargePreBuffer:dischargePreBuffer,switchInitData:switchInitData,getRangeAt:getRangeAt,reset:reset};setup();return instance;}NotFragmentedTextBufferController.__dashjs_factory_name = BUFFER_CONTROLLER_TYPE;exports['default'] = _coreFactoryMaker2['default'].getClassFactory(NotFragmentedTextBufferController);module.exports = exports['default'];
	//# sourceMappingURL=NotFragmentedTextBufferController.js.map


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _controllersBufferController=__webpack_require__(36);var _controllersBufferController2=_interopRequireDefault(_controllersBufferController);var _NotFragmentedTextBufferController=__webpack_require__(402);var _NotFragmentedTextBufferController2=_interopRequireDefault(_NotFragmentedTextBufferController);function TextBufferController(config){config = config || {};var context=this.context;var _BufferControllerImpl=undefined;var instance=undefined;function setup(){ // according to text type, we create corresponding buffer controller
	if(config.type === _constantsConstants2['default'].FRAGMENTED_TEXT){ // in this case, internal buffer ocntroller is a classical BufferController object
	_BufferControllerImpl = (0,_controllersBufferController2['default'])(context).create({type:config.type,metricsModel:config.metricsModel,mediaPlayerModel:config.mediaPlayerModel,manifestModel:config.manifestModel,errHandler:config.errHandler,streamController:config.streamController,mediaController:config.mediaController,adapter:config.adapter,textController:config.textController,abrController:config.abrController,playbackController:config.playbackController,streamProcessor:config.streamProcessor});}else { // in this case, internal buffer controller is a not fragmented text controller object
	_BufferControllerImpl = (0,_NotFragmentedTextBufferController2['default'])(context).create({type:config.type,errHandler:config.errHandler,streamProcessor:config.streamProcessor});}}function getBufferControllerType(){return _BufferControllerImpl.getBufferControllerType();}function initialize(source,StreamProcessor){return _BufferControllerImpl.initialize(source,StreamProcessor);} /**
	     * @param {MediaInfo }mediaInfo
	     * @returns {Object} SourceBuffer object
	     * @memberof BufferController#
	     */function createBuffer(mediaInfo){return _BufferControllerImpl.createBuffer(mediaInfo);}function getType(){return _BufferControllerImpl.getType();}function getBuffer(){return _BufferControllerImpl.getBuffer();}function setBuffer(value){_BufferControllerImpl.setBuffer(value);}function getMediaSource(){return _BufferControllerImpl.getMediaSource();}function setMediaSource(value){_BufferControllerImpl.setMediaSource(value);}function getStreamProcessor(){_BufferControllerImpl.getStreamProcessor();}function setSeekStartTime(value){_BufferControllerImpl.setSeekStartTime(value);}function getBufferLevel(){return _BufferControllerImpl.getBufferLevel();}function reset(errored){_BufferControllerImpl.reset(errored);}function getIsBufferingCompleted(){return _BufferControllerImpl.getIsBufferingCompleted();}function switchInitData(streamId,representationId){_BufferControllerImpl.switchInitData(streamId,representationId);}function getIsPruningInProgress(){return _BufferControllerImpl.getIsPruningInProgress();}function dischargePreBuffer(){return _BufferControllerImpl.dischargePreBuffer();}function getRangeAt(time){return _BufferControllerImpl.getRangeAt(time);}instance = {getBufferControllerType:getBufferControllerType,initialize:initialize,createBuffer:createBuffer,getType:getType,getStreamProcessor:getStreamProcessor,setSeekStartTime:setSeekStartTime,getBuffer:getBuffer,setBuffer:setBuffer,getBufferLevel:getBufferLevel,setMediaSource:setMediaSource,getMediaSource:getMediaSource,getIsBufferingCompleted:getIsBufferingCompleted,getIsPruningInProgress:getIsPruningInProgress,dischargePreBuffer:dischargePreBuffer,switchInitData:switchInitData,getRangeAt:getRangeAt,reset:reset};setup();return instance;}TextBufferController.__dashjs_factory_name = 'TextBufferController';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(TextBufferController);module.exports = exports['default'];
	//# sourceMappingURL=TextBufferController.js.map


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _voMetricsHTTPRequest=__webpack_require__(16);var _voTextTrackInfo=__webpack_require__(426);var _voTextTrackInfo2=_interopRequireDefault(_voTextTrackInfo);var _dashUtilsFragmentedTextBoxParser=__webpack_require__(319);var _dashUtilsFragmentedTextBoxParser2=_interopRequireDefault(_dashUtilsFragmentedTextBoxParser);var _utilsBoxParser=__webpack_require__(68);var _utilsBoxParser2=_interopRequireDefault(_utilsBoxParser);var _utilsCustomTimeRanges=__webpack_require__(151);var _utilsCustomTimeRanges2=_interopRequireDefault(_utilsCustomTimeRanges);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _TextTracks=__webpack_require__(96);var _TextTracks2=_interopRequireDefault(_TextTracks);var _EmbeddedTextHtmlRender=__webpack_require__(401);var _EmbeddedTextHtmlRender2=_interopRequireDefault(_EmbeddedTextHtmlRender);var _codemIsoboxer=__webpack_require__(84);var _codemIsoboxer2=_interopRequireDefault(_codemIsoboxer);var _externalsCea608Parser=__webpack_require__(136);var _externalsCea608Parser2=_interopRequireDefault(_externalsCea608Parser);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);function TextSourceBuffer(){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var embeddedInitialized=false;var instance=undefined,boxParser=undefined,errHandler=undefined,dashManifestModel=undefined,manifestModel=undefined,mediaController=undefined,parser=undefined,vttParser=undefined,ttmlParser=undefined,fragmentedTextBoxParser=undefined,mediaInfos=undefined,textTracks=undefined,isFragmented=undefined,fragmentModel=undefined,initializationSegmentReceived=undefined,timescale=undefined,fragmentedTracks=undefined,videoModel=undefined,streamController=undefined,firstSubtitleStart=undefined,currFragmentedTrackIdx=undefined,embeddedTracks=undefined,embeddedInitializationSegmentReceived=undefined,embeddedTimescale=undefined,embeddedLastSequenceNumber=undefined,embeddedSequenceNumbers=undefined,embeddedCea608FieldParsers=undefined,embeddedTextHtmlRender=undefined,mseTimeOffset=undefined;function initialize(type,streamProcessor){parser = null;fragmentModel = null;initializationSegmentReceived = false;timescale = NaN;fragmentedTracks = [];firstSubtitleStart = null;if(!embeddedInitialized){initEmbedded();}mediaInfos = streamProcessor.getMediaInfoArr();textTracks.setConfig({videoModel:videoModel});textTracks.initialize();isFragmented = !dashManifestModel.getIsTextTrack(type);boxParser = (0,_utilsBoxParser2['default'])(context).getInstance();fragmentedTextBoxParser = (0,_dashUtilsFragmentedTextBoxParser2['default'])(context).getInstance();fragmentedTextBoxParser.setConfig({boxParser:boxParser});if(isFragmented){fragmentModel = streamProcessor.getFragmentModel();this.buffered = (0,_utilsCustomTimeRanges2['default'])(context).create();fragmentedTracks = mediaController.getTracksFor(_constantsConstants2['default'].FRAGMENTED_TEXT,streamController.getActiveStreamInfo());var currFragTrack=mediaController.getCurrentTrackFor(_constantsConstants2['default'].FRAGMENTED_TEXT,streamController.getActiveStreamInfo());for(var i=0;i < fragmentedTracks.length;i++) {if(fragmentedTracks[i] === currFragTrack){currFragmentedTrackIdx = i;break;}}}}function abort(){textTracks.deleteAllTextTracks();parser = null;fragmentedTextBoxParser = null;mediaInfos = null;textTracks = null;isFragmented = false;fragmentModel = null;initializationSegmentReceived = false;timescale = NaN;fragmentedTracks = [];videoModel = null;streamController = null;embeddedInitialized = false;embeddedTracks = null;}function onVideoChunkReceived(e){var chunk=e.chunk;if(chunk.mediaInfo.embeddedCaptions){append(chunk.bytes,chunk);}}function initEmbedded(){embeddedTracks = [];mediaInfos = [];textTracks = (0,_TextTracks2['default'])(context).getInstance();textTracks.setConfig({videoModel:videoModel});textTracks.initialize();boxParser = (0,_utilsBoxParser2['default'])(context).getInstance();fragmentedTextBoxParser = (0,_dashUtilsFragmentedTextBoxParser2['default'])(context).getInstance();fragmentedTextBoxParser.setConfig({boxParser:boxParser});isFragmented = false;currFragmentedTrackIdx = null;embeddedInitializationSegmentReceived = false;embeddedTimescale = 0;embeddedCea608FieldParsers = [];embeddedSequenceNumbers = [];embeddedLastSequenceNumber = null;embeddedInitialized = true;embeddedTextHtmlRender = (0,_EmbeddedTextHtmlRender2['default'])(context).getInstance();var streamProcessors=streamController.getActiveStreamProcessors();for(var i in streamProcessors) {if(streamProcessors[i].getType() === 'video'){mseTimeOffset = streamProcessors[i].getCurrentRepresentationInfo().MSETimeOffset;break;}}eventBus.on(_coreEventsEvents2['default'].VIDEO_CHUNK_RECEIVED,onVideoChunkReceived,this);}function resetEmbedded(){eventBus.off(_coreEventsEvents2['default'].VIDEO_CHUNK_RECEIVED,onVideoChunkReceived,this);if(textTracks){textTracks.deleteAllTextTracks();}embeddedInitialized = false;embeddedTracks = [];embeddedCea608FieldParsers = [null,null];embeddedSequenceNumbers = [];embeddedLastSequenceNumber = null;}function addEmbeddedTrack(mediaInfo){if(!embeddedInitialized){initEmbedded();}if(mediaInfo.id === _constantsConstants2['default'].CC1 || mediaInfo.id === _constantsConstants2['default'].CC3){embeddedTracks.push(mediaInfo);}else {log('Warning: Embedded track ' + mediaInfo.id + ' not supported!');}}function setConfig(config){if(!config){return;}if(config.errHandler){errHandler = config.errHandler;}if(config.dashManifestModel){dashManifestModel = config.dashManifestModel;}if(config.manifestModel){manifestModel = config.manifestModel;}if(config.mediaController){mediaController = config.mediaController;}if(config.videoModel){videoModel = config.videoModel;}if(config.streamController){streamController = config.streamController;}if(config.textTracks){textTracks = config.textTracks;}if(config.vttParser){vttParser = config.vttParser;}if(config.ttmlParser){ttmlParser = config.ttmlParser;}}function getConfig(){var config={errHandler:errHandler,dashManifestModel:dashManifestModel,mediaController:mediaController,videoModel:videoModel,fragmentModel:fragmentModel,streamController:streamController,textTracks:textTracks,isFragmented:isFragmented,embeddedTracks:embeddedTracks,fragmentedTracks:fragmentedTracks};return config;}function setCurrentFragmentedTrackIdx(idx){currFragmentedTrackIdx = idx;}function append(bytes,chunk){var result=undefined,sampleList=undefined,i=undefined,j=undefined,k=undefined,samplesInfo=undefined,ccContent=undefined;var mediaInfo=chunk.mediaInfo;var mediaType=mediaInfo.type;var mimeType=mediaInfo.mimeType;var codecType=mediaInfo.codec || mimeType;if(!codecType){log('No text type defined');return;}function createTextTrackFromMediaInfo(captionData,mediaInfo){var textTrackInfo=new _voTextTrackInfo2['default']();var trackKindMap={subtitle:'subtitles',caption:'captions'}; //Dash Spec has no "s" on end of KIND but HTML needs plural.
	var getKind=function getKind(){var kind=mediaInfo.roles.length > 0?trackKindMap[mediaInfo.roles[0]]:trackKindMap.caption;kind = kind === trackKindMap.caption || kind === trackKindMap.subtitle?kind:trackKindMap.caption;return kind;};var checkTTML=function checkTTML(){var ttml=false;if(mediaInfo.codec && mediaInfo.codec.search(_constantsConstants2['default'].STPP) >= 0){ttml = true;}if(mediaInfo.mimeType && mediaInfo.mimeType.search(_constantsConstants2['default'].TTML) >= 0){ttml = true;}return ttml;};textTrackInfo.captionData = captionData;textTrackInfo.lang = mediaInfo.lang;textTrackInfo.label = mediaInfo.id; // AdaptationSet id (an unsigned int)
	textTrackInfo.index = mediaInfo.index; // AdaptationSet index in manifest
	textTrackInfo.isTTML = checkTTML();textTrackInfo.defaultTrack = getIsDefault(mediaInfo);textTrackInfo.isFragmented = isFragmented;textTrackInfo.isEmbedded = mediaInfo.isEmbedded?true:false;textTrackInfo.kind = getKind();textTrackInfo.roles = mediaInfo.roles;var totalNrTracks=(mediaInfos?mediaInfos.length:0) + embeddedTracks.length;textTracks.addTextTrack(textTrackInfo,totalNrTracks);}if(mediaType === _constantsConstants2['default'].FRAGMENTED_TEXT){if(!initializationSegmentReceived){initializationSegmentReceived = true;for(i = 0;i < mediaInfos.length;i++) {createTextTrackFromMediaInfo(null,mediaInfos[i]);}timescale = fragmentedTextBoxParser.getMediaTimescaleFromMoov(bytes);}else {samplesInfo = fragmentedTextBoxParser.getSamplesInfo(bytes);sampleList = samplesInfo.sampleList;if(!firstSubtitleStart && sampleList.length > 0){firstSubtitleStart = sampleList[0].cts - chunk.start * timescale;}if(codecType.search(_constantsConstants2['default'].STPP) >= 0){parser = parser !== null?parser:getParser(codecType);for(i = 0;i < sampleList.length;i++) {var sample=sampleList[i];var sampleStart=sample.cts;var sampleRelStart=sampleStart - firstSubtitleStart;this.buffered.add(sampleRelStart / timescale,(sampleRelStart + sample.duration) / timescale);var dataView=new DataView(bytes,sample.offset,sample.subSizes[0]);ccContent = _codemIsoboxer2['default'].Utils.dataViewToString(dataView,_constantsConstants2['default'].UTF8);var images=[];var subOffset=sample.offset + sample.subSizes[0];for(j = 1;j < sample.subSizes.length;j++) {var inData=new Uint8Array(bytes,subOffset,sample.subSizes[j]);var raw=String.fromCharCode.apply(null,inData);images.push(raw);subOffset += sample.subSizes[j];}try{ // Only used for Miscrosoft Smooth Streaming support - caption time is relative to sample time. In this case, we apply an offset.
	var manifest=manifestModel.getValue();var offsetTime=manifest.ttmlTimeIsRelative?sampleStart / timescale:0;result = parser.parse(ccContent,offsetTime,sampleStart / timescale,(sampleStart + sample.duration) / timescale,images);textTracks.addCaptions(currFragmentedTrackIdx,firstSubtitleStart / timescale,result);}catch(e) {fragmentModel.removeExecutedRequestsBeforeTime();this.remove();log('TTML parser error: ' + e.message);}}}else { // WebVTT case
	var captionArray=[];for(i = 0;i < sampleList.length;i++) {var sample=sampleList[i];sample.cts -= firstSubtitleStart;this.buffered.add(sample.cts / timescale,(sample.cts + sample.duration) / timescale);var sampleData=bytes.slice(sample.offset,sample.offset + sample.size); // There are boxes inside the sampleData, so we need a ISOBoxer to get at it.
	var sampleBoxes=_codemIsoboxer2['default'].parseBuffer(sampleData);for(j = 0;j < sampleBoxes.boxes.length;j++) {var box1=sampleBoxes.boxes[j];log('VTT box1: ' + box1.type);if(box1.type === 'vtte'){continue; //Empty box
	}if(box1.type === 'vttc'){log('VTT vttc boxes.length = ' + box1.boxes.length);for(k = 0;k < box1.boxes.length;k++) {var box2=box1.boxes[k];log('VTT box2: ' + box2.type);if(box2.type === 'payl'){var cue_text=box2.cue_text;log('VTT cue_text = ' + cue_text);var start_time=sample.cts / timescale;var end_time=(sample.cts + sample.duration) / timescale;captionArray.push({start:start_time,end:end_time,data:cue_text,styles:{}});log('VTT ' + start_time + '-' + end_time + ' : ' + cue_text);}}}}}if(captionArray.length > 0){textTracks.addCaptions(currFragmentedTrackIdx,0,captionArray);}}}}else if(mediaType === _constantsConstants2['default'].TEXT){var dataView=new DataView(bytes,0,bytes.byteLength);ccContent = _codemIsoboxer2['default'].Utils.dataViewToString(dataView,_constantsConstants2['default'].UTF8);try{result = getParser(codecType).parse(ccContent,0);createTextTrackFromMediaInfo(result,mediaInfo);}catch(e) {errHandler.timedTextError(e,'parse',ccContent);}}else if(mediaType === _constantsConstants2['default'].VIDEO){ //embedded text
	if(chunk.segmentType === _voMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE){if(embeddedTimescale === 0){embeddedTimescale = fragmentedTextBoxParser.getMediaTimescaleFromMoov(bytes);for(i = 0;i < embeddedTracks.length;i++) {createTextTrackFromMediaInfo(null,embeddedTracks[i]);}}}else { // MediaSegment
	if(embeddedTimescale === 0){log('CEA-608: No timescale for embeddedTextTrack yet');return;}var makeCueAdderForIndex=function makeCueAdderForIndex(self,trackIndex){function newCue(startTime,endTime,captionScreen){var captionsArray=null;if(videoModel.getTTMLRenderingDiv()){captionsArray = embeddedTextHtmlRender.createHTMLCaptionsFromScreen(videoModel.getElement(),startTime,endTime,captionScreen);}else {var text=captionScreen.getDisplayText(); //log("CEA text: " + startTime + "-" + endTime + "  '" + text + "'");
	captionsArray = [{start:startTime,end:endTime,data:text,styles:{}}];}if(captionsArray){textTracks.addCaptions(trackIndex,0,captionsArray);}}return newCue;};samplesInfo = fragmentedTextBoxParser.getSamplesInfo(bytes);var sequenceNumber=samplesInfo.lastSequenceNumber;if(!embeddedCea608FieldParsers[0] && !embeddedCea608FieldParsers[1]){ // Time to setup the CEA-608 parsing
	var field=undefined,handler=undefined,trackIdx=undefined;for(i = 0;i < embeddedTracks.length;i++) {if(embeddedTracks[i].id === _constantsConstants2['default'].CC1){field = 0;trackIdx = textTracks.getTrackIdxForId(_constantsConstants2['default'].CC1);}else if(embeddedTracks[i].id === _constantsConstants2['default'].CC3){field = 1;trackIdx = textTracks.getTrackIdxForId(_constantsConstants2['default'].CC3);}if(trackIdx === -1){log('CEA-608: data before track is ready.');return;}handler = makeCueAdderForIndex(this,trackIdx);embeddedCea608FieldParsers[i] = new _externalsCea608Parser2['default'].Cea608Parser(i,{'newCue':handler},null);}}if(embeddedTimescale && embeddedSequenceNumbers.indexOf(sequenceNumber) == -1){if(embeddedLastSequenceNumber !== null && sequenceNumber !== embeddedLastSequenceNumber + samplesInfo.numSequences){for(i = 0;i < embeddedCea608FieldParsers.length;i++) {if(embeddedCea608FieldParsers[i]){embeddedCea608FieldParsers[i].reset();}}}var allCcData=extractCea608Data(bytes,samplesInfo.sampleList);for(var fieldNr=0;fieldNr < embeddedCea608FieldParsers.length;fieldNr++) {var ccData=allCcData.fields[fieldNr];var fieldParser=embeddedCea608FieldParsers[fieldNr];if(fieldParser){ /*if (ccData.length > 0 ) {
	                                log("CEA-608 adding Data to field " + fieldNr + " " + ccData.length + "bytes");
	                            }*/for(i = 0;i < ccData.length;i++) {fieldParser.addData(ccData[i][0] / embeddedTimescale,ccData[i][1]);}}}embeddedLastSequenceNumber = sequenceNumber;embeddedSequenceNumbers.push(sequenceNumber);}}}} /**
	     * Extract CEA-608 data from a buffer of data.
	     * @param {ArrayBuffer} data
	     * @param {Array} samples cue information
	     * @returns {Object|null} ccData corresponding to one segment.
	     */function extractCea608Data(data,samples){if(samples.length === 0){return null;}var allCcData={splits:[],fields:[[],[]]};var raw=new DataView(data);for(var i=0;i < samples.length;i++) {var sample=samples[i];var cea608Ranges=_externalsCea608Parser2['default'].findCea608Nalus(raw,sample.offset,sample.size);var lastSampleTime=null;var idx=0;for(var j=0;j < cea608Ranges.length;j++) {var ccData=_externalsCea608Parser2['default'].extractCea608DataFromRange(raw,cea608Ranges[j]);for(var k=0;k < 2;k++) {if(ccData[k].length > 0){if(sample.cts !== lastSampleTime){idx = 0;}else {idx += 1;}allCcData.fields[k].push([sample.cts + mseTimeOffset * embeddedTimescale,ccData[k],idx]);lastSampleTime = sample.cts;}}}} // Sort by sampleTime ascending order
	// If two packets have the same sampleTime, use them in the order
	// they were received
	allCcData.fields.forEach(function sortField(field){field.sort(function(a,b){if(a[0] === b[0]){return a[2] - b[2];}return a[0] - b[0];});});return allCcData;}function getIsDefault(mediaInfo){ //TODO How to tag default. currently same order as listed in manifest.
	// Is there a way to mark a text adaptation set as the default one? DASHIF meeting talk about using role which is being used for track KIND
	// Eg subtitles etc. You can have multiple role tags per adaptation Not defined in the spec yet.
	var isDefault=false;if(embeddedTracks.length > 1 && mediaInfo.isEmbedded){isDefault = mediaInfo.id && mediaInfo.id === _constantsConstants2['default'].CC1; // CC1 if both CC1 and CC3 exist
	}else if(embeddedTracks.length === 1){if(mediaInfo.id && mediaInfo.id.substring(0,2) === 'CC'){ // Either CC1 or CC3
	isDefault = true;}}else if(embeddedTracks.length === 0){isDefault = mediaInfo.index === mediaInfos[0].index;}return isDefault;}function getParser(codecType){var parser=undefined;if(codecType.search(_constantsConstants2['default'].VTT) >= 0){parser = vttParser;}else if(codecType.search(_constantsConstants2['default'].TTML) >= 0 || codecType.search(_constantsConstants2['default'].STPP) >= 0){parser = ttmlParser;}return parser;}function remove(start,end){ //if start and end are not defined, remove all
	if(start === undefined && start === end){start = this.buffered.start(0);end = this.buffered.end(this.buffered.length - 1);}this.buffered.remove(start,end);}instance = {initialize:initialize,append:append,abort:abort,addEmbeddedTrack:addEmbeddedTrack,resetEmbedded:resetEmbedded,setConfig:setConfig,getConfig:getConfig,setCurrentFragmentedTrackIdx:setCurrentFragmentedTrackIdx,remove:remove};return instance;}TextSourceBuffer.__dashjs_factory_name = 'TextSourceBuffer';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(TextSourceBuffer);module.exports = exports['default'];
	//# sourceMappingURL=TextSourceBuffer.js.map


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _voThumbnail=__webpack_require__(427);var _voThumbnail2=_interopRequireDefault(_voThumbnail);var _ThumbnailTracks=__webpack_require__(406);var _ThumbnailTracks2=_interopRequireDefault(_ThumbnailTracks);var _voBitrateInfo=__webpack_require__(154);var _voBitrateInfo2=_interopRequireDefault(_voBitrateInfo);var _dashUtilsSegmentsUtils=__webpack_require__(40);function ThumbnailController(config){var context=this.context;var instance=undefined;var thumbnailTracks=undefined;function setup(){reset();thumbnailTracks = (0,_ThumbnailTracks2['default'])(context).create({dashManifestModel:config.dashManifestModel,adapter:config.adapter,baseURLController:config.baseURLController,stream:config.stream});}function getThumbnail(time){var track=thumbnailTracks.getCurrentTrack();if(!track || track.segmentDuration <= 0){return null;} // Calculate index of the sprite given a time
	var seq=Math.floor(time / track.segmentDuration);var offset=time % track.segmentDuration;var thumbIndex=Math.floor(offset * track.tilesHor * track.tilesVert / track.segmentDuration); // Create and return the thumbnail
	var thumbnail=new _voThumbnail2['default']();thumbnail.url = buildUrlFromTemplate(track,seq);thumbnail.width = Math.floor(track.widthPerTile);thumbnail.height = Math.floor(track.heightPerTile);thumbnail.x = Math.floor(thumbIndex % track.tilesHor) * track.widthPerTile;thumbnail.y = Math.floor(thumbIndex / track.tilesHor) * track.heightPerTile;return thumbnail;}function buildUrlFromTemplate(track,seq){var seqIdx=seq + track.startNumber;var url=(0,_dashUtilsSegmentsUtils.replaceTokenForTemplate)(track.templateUrl,'Number',seqIdx);url = (0,_dashUtilsSegmentsUtils.replaceTokenForTemplate)(url,'Time',(seqIdx - 1) * track.segmentDuration);url = (0,_dashUtilsSegmentsUtils.replaceTokenForTemplate)(url,'Bandwidth',track.bandwidth);return (0,_dashUtilsSegmentsUtils.unescapeDollarsInTemplate)(url);}function setTrackByIndex(index){thumbnailTracks.setTrackByIndex(index);}function getCurrentTrackIndex(){return thumbnailTracks.getCurrentTrackIndex();}function getBitrateList(){var tracks=thumbnailTracks.getTracks();if(!tracks || tracks.length === 0){return [];}var i=0;return tracks.map(function(t){var bitrateInfo=new _voBitrateInfo2['default']();bitrateInfo.mediaType = _constantsConstants2['default'].IMAGE;bitrateInfo.qualityIndex = i++;bitrateInfo.bitrate = t.bitrate;bitrateInfo.width = t.width;bitrateInfo.height = t.height;return bitrateInfo;});}function reset(){if(thumbnailTracks){thumbnailTracks.reset();}}instance = {get:getThumbnail,setTrackByIndex:setTrackByIndex,getCurrentTrackIndex:getCurrentTrackIndex,getBitrateList:getBitrateList,reset:reset};setup();return instance;}ThumbnailController.__dashjs_factory_name = 'ThumbnailController';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ThumbnailController);module.exports = exports['default'];
	//# sourceMappingURL=ThumbnailController.js.map


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _constantsConstants=__webpack_require__(8);var _constantsConstants2=_interopRequireDefault(_constantsConstants);var _dashConstantsDashConstants=__webpack_require__(25);var _dashConstantsDashConstants2=_interopRequireDefault(_dashConstantsDashConstants);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _voThumbnailTrackInfo=__webpack_require__(428);var _voThumbnailTrackInfo2=_interopRequireDefault(_voThumbnailTrackInfo);var _streamingUtilsURLUtils=__webpack_require__(30);var _streamingUtilsURLUtils2=_interopRequireDefault(_streamingUtilsURLUtils);var _dashUtilsSegmentsUtils=__webpack_require__(40);var THUMBNAILS_SCHEME_ID_URI='http://dashif.org/thumbnail_tile';function ThumbnailTracks(config){var context=this.context;var dashManifestModel=config.dashManifestModel;var adapter=config.adapter;var baseURLController=config.baseURLController;var stream=config.stream;var urlUtils=(0,_streamingUtilsURLUtils2['default'])(context).getInstance();var instance=undefined,tracks=undefined,currentTrackIndex=undefined;function initialize(){reset(); // parse representation and create tracks
	addTracks();}function addTracks(){if(!stream || !dashManifestModel || !adapter){return;}var streamInfo=stream?stream.getStreamInfo():null;if(!streamInfo){return;} // Extract thumbnail tracks
	var mediaInfo=adapter.getMediaInfoForType(streamInfo,_constantsConstants2['default'].IMAGE);if(!mediaInfo){return;}var voAdaptation=adapter.getDataForMedia(mediaInfo);if(!voAdaptation){return;}var voReps=dashManifestModel.getRepresentationsForAdaptation(voAdaptation);if(voReps && voReps.length > 0){voReps.forEach(function(rep){if(rep.segmentInfoType === _dashConstantsDashConstants2['default'].SEGMENT_TEMPLATE && rep.segmentDuration > 0 && rep.media)createTrack(rep);});}if(tracks.length > 0){ // Sort bitrates and select the lowest bitrate rendition
	tracks.sort(function(a,b){return a.bitrate - b.bitrate;});currentTrackIndex = tracks.length - 1;}}function createTrack(representation){var track=new _voThumbnailTrackInfo2['default']();track.id = representation.id;track.bitrate = representation.bandwidth;track.width = representation.width;track.height = representation.height;track.tilesHor = 1;track.tilesVert = 1;track.startNumber = representation.startNumber;track.segmentDuration = representation.segmentDuration;track.timescale = representation.timescale;track.templateUrl = buildTemplateUrl(representation);if(representation.essentialProperties){representation.essentialProperties.forEach(function(p){if(p.schemeIdUri === THUMBNAILS_SCHEME_ID_URI && p.value){var vars=p.value.split('x');if(vars.length === 2 && !isNaN(vars[0]) && !isNaN(vars[1])){track.tilesHor = parseInt(vars[0],10);track.tilesVert = parseInt(vars[1],10);}}});}if(track.tilesHor > 0 && track.tilesVert > 0){ // Precalculate width and heigth per tile for perf reasons
	track.widthPerTile = track.width / track.tilesHor;track.heightPerTile = track.height / track.tilesVert;tracks.push(track);}}function buildTemplateUrl(representation){var templateUrl=urlUtils.isRelative(representation.media)?urlUtils.resolve(representation.media,baseURLController.resolve(representation.path).url):representation.media;if(!templateUrl){return '';}return (0,_dashUtilsSegmentsUtils.replaceIDForTemplate)(templateUrl,representation.id);}function getTracks(){return tracks;}function getCurrentTrackIndex(){return currentTrackIndex;}function getCurrentTrack(){if(currentTrackIndex < 0){return null;}return tracks[currentTrackIndex];}function setTrackByIndex(index){if(!tracks || tracks.length === 0){return;} // select highest bitrate in case selected index is higher than bitrate list length
	if(index >= tracks.length){index = tracks.length - 1;}currentTrackIndex = index;}function reset(){tracks = [];currentTrackIndex = -1;}instance = {initialize:initialize,getTracks:getTracks,reset:reset,setTrackByIndex:setTrackByIndex,getCurrentTrack:getCurrentTrack,getCurrentTrackIndex:getCurrentTrackIndex};initialize();return instance;}ThumbnailTracks.__dashjs_factory_name = 'ThumbnailTracks';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ThumbnailTracks);module.exports = exports['default'];
	//# sourceMappingURL=ThumbnailTracks.js.map


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _controllersBlacklistController=__webpack_require__(339);var _controllersBlacklistController2=_interopRequireDefault(_controllersBlacklistController);var _baseUrlResolutionDVBSelector=__webpack_require__(416);var _baseUrlResolutionDVBSelector2=_interopRequireDefault(_baseUrlResolutionDVBSelector);var _baseUrlResolutionBasicSelector=__webpack_require__(415);var _baseUrlResolutionBasicSelector2=_interopRequireDefault(_baseUrlResolutionBasicSelector);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE=1;var URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE='Failed to resolve a valid URL';function BaseURLSelector(){var context=this.context;var eventBus=(0,_coreEventBus2['default'])(context).getInstance();var dashManifestModel=undefined;var instance=undefined,serviceLocationBlacklistController=undefined,basicSelector=undefined,dvbSelector=undefined,selector=undefined;function setup(){serviceLocationBlacklistController = (0,_controllersBlacklistController2['default'])(context).create({updateEventName:_coreEventsEvents2['default'].SERVICE_LOCATION_BLACKLIST_CHANGED,addBlacklistEventName:_coreEventsEvents2['default'].SERVICE_LOCATION_BLACKLIST_ADD});basicSelector = (0,_baseUrlResolutionBasicSelector2['default'])(context).create({blacklistController:serviceLocationBlacklistController});dvbSelector = (0,_baseUrlResolutionDVBSelector2['default'])(context).create({blacklistController:serviceLocationBlacklistController});selector = basicSelector;}function setConfig(config){if(config.selector){selector = config.selector;}if(config.dashManifestModel){dashManifestModel = config.dashManifestModel;}}function checkConfig(){if(!dashManifestModel || !dashManifestModel.hasOwnProperty('getIsDVB')){throw new Error('Missing config parameter(s)');}}function chooseSelectorFromManifest(manifest){checkConfig();if(dashManifestModel.getIsDVB(manifest)){selector = dvbSelector;}else {selector = basicSelector;}}function select(data){var baseUrls=data.baseUrls;var selectedIdx=data.selectedIdx; // Once a random selection has been carried out amongst a group of BaseURLs with the same
	// @priority attribute value, then that choice should be re-used if the selection needs to be made again
	// unless the blacklist has been modified or the available BaseURLs have changed.
	if(!isNaN(selectedIdx)){return baseUrls[selectedIdx];}var selectedBaseUrl=selector.select(baseUrls);if(!selectedBaseUrl){eventBus.trigger(_coreEventsEvents2['default'].URL_RESOLUTION_FAILED,{error:new Error(URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE,URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE)});if(selector === basicSelector){reset();}return;}data.selectedIdx = baseUrls.indexOf(selectedBaseUrl);return selectedBaseUrl;}function reset(){serviceLocationBlacklistController.reset();}instance = {chooseSelectorFromManifest:chooseSelectorFromManifest,select:select,reset:reset,setConfig:setConfig};setup();return instance;}BaseURLSelector.__dashjs_factory_name = 'BaseURLSelector';var factory=_coreFactoryMaker2['default'].getClassFactory(BaseURLSelector);factory.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE = URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE;factory.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE = URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE;_coreFactoryMaker2['default'].updateClassFactory(BaseURLSelector.__dashjs_factory_name,factory);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=BaseURLSelector.js.map


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function Capabilities(){var instance=undefined,encryptedMediaSupported=undefined;function setup(){encryptedMediaSupported = false;}function supportsMediaSource(){var hasWebKit=('WebKitMediaSource' in window);var hasMediaSource=('MediaSource' in window);return hasWebKit || hasMediaSource;} /**
	     * Returns whether Encrypted Media Extensions are supported on this
	     * user agent
	     *
	     * @return {boolean} true if EME is supported, false otherwise
	     */function supportsEncryptedMedia(){return encryptedMediaSupported;}function setEncryptedMediaSupported(value){encryptedMediaSupported = value;}function supportsCodec(codec){if('MediaSource' in window && MediaSource.isTypeSupported(codec)){return true;}if('WebKitMediaSource' in window && WebKitMediaSource.isTypeSupported(codec)){return true;}return false;}instance = {supportsMediaSource:supportsMediaSource,supportsEncryptedMedia:supportsEncryptedMedia,supportsCodec:supportsCodec,setEncryptedMediaSupported:setEncryptedMediaSupported};setup();return instance;}Capabilities.__dashjs_factory_name = 'Capabilities';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(Capabilities);module.exports = exports['default'];
	//# sourceMappingURL=Capabilities.js.map


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var legacyKeysAndReplacements=[{oldKey:'dashjs_vbitrate',newKey:'dashjs_video_bitrate'},{oldKey:'dashjs_abitrate',newKey:'dashjs_audio_bitrate'},{oldKey:'dashjs_vsettings',newKey:'dashjs_video_settings'},{oldKey:'dashjs_asettings',newKey:'dashjs_audio_settings'}];var LOCAL_STORAGE_BITRATE_KEY_TEMPLATE='dashjs_?_bitrate';var LOCAL_STORAGE_SETTINGS_KEY_TEMPLATE='dashjs_?_settings';var STORAGE_TYPE_LOCAL='localStorage';var STORAGE_TYPE_SESSION='sessionStorage';var LAST_BITRATE='LastBitrate';var LAST_MEDIA_SETTINGS='LastMediaSettings';function DOMStorage(config){config = config || {};var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var mediaPlayerModel=config.mediaPlayerModel;var instance=undefined,supported=undefined; //type can be local, session
	function isSupported(type){if(supported !== undefined)return supported;supported = false;var testKey='1';var testValue='1';var storage=undefined;try{if(typeof window !== 'undefined'){storage = window[type];}}catch(error) {log('Warning: DOMStorage access denied: ' + error.message);return supported;}if(!storage || type !== STORAGE_TYPE_LOCAL && type !== STORAGE_TYPE_SESSION){return supported;} /* When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage is available, but trying to call setItem throws an exception.
	         http://stackoverflow.com/questions/14555347/html5-localstorage-error-with-safari-quota-exceeded-err-dom-exception-22-an
	
	         Check if the storage can be used
	         */try{storage.setItem(testKey,testValue);storage.removeItem(testKey);supported = true;}catch(error) {log('Warning: DOMStorage is supported, but cannot be used: ' + error.message);}return supported;}function translateLegacyKeys(){if(isSupported(STORAGE_TYPE_LOCAL)){legacyKeysAndReplacements.forEach(function(entry){var value=localStorage.getItem(entry.oldKey);if(value){localStorage.removeItem(entry.oldKey);try{localStorage.setItem(entry.newKey,value);}catch(e) {log(e.message);}}});}}function setup(){translateLegacyKeys();} // Return current epoch time, ms, rounded to the nearest 10m to avoid fingerprinting user
	function getTimestamp(){var ten_minutes_ms=60 * 1000 * 10;return Math.round(new Date().getTime() / ten_minutes_ms) * ten_minutes_ms;}function canStore(storageType,key){return isSupported(storageType) && mediaPlayerModel['get' + key + 'CachingInfo']().enabled;}function checkConfig(){if(!mediaPlayerModel || !mediaPlayerModel.hasOwnProperty('getLastMediaSettingsCachingInfo')){throw new Error('Missing config parameter(s)');}}function getSavedMediaSettings(type){checkConfig(); //Checks local storage to see if there is valid, non-expired media settings
	if(!canStore(STORAGE_TYPE_LOCAL,LAST_MEDIA_SETTINGS))return null;var settings=null;var key=LOCAL_STORAGE_SETTINGS_KEY_TEMPLATE.replace(/\?/,type);try{var obj=JSON.parse(localStorage.getItem(key)) || {};var isExpired=new Date().getTime() - parseInt(obj.timestamp,10) >= mediaPlayerModel.getLastMediaSettingsCachingInfo().ttl || false;settings = obj.settings;if(isExpired){localStorage.removeItem(key);settings = null;}}catch(e) {return null;}return settings;}function getSavedBitrateSettings(type){var savedBitrate=NaN;checkConfig(); //Checks local storage to see if there is valid, non-expired bit rate
	//hinting from the last play session to use as a starting bit rate.
	if(canStore(STORAGE_TYPE_LOCAL,LAST_BITRATE)){var key=LOCAL_STORAGE_BITRATE_KEY_TEMPLATE.replace(/\?/,type);try{var obj=JSON.parse(localStorage.getItem(key)) || {};var isExpired=new Date().getTime() - parseInt(obj.timestamp,10) >= mediaPlayerModel.getLastMediaSettingsCachingInfo().ttl || false;var bitrate=parseFloat(obj.bitrate);if(!isNaN(bitrate) && !isExpired){savedBitrate = bitrate;log('Last saved bitrate for ' + type + ' was ' + bitrate);}else if(isExpired){localStorage.removeItem(key);}}catch(e) {return null;}}return savedBitrate;}function setSavedMediaSettings(type,value){if(canStore(STORAGE_TYPE_LOCAL,LAST_MEDIA_SETTINGS)){var key=LOCAL_STORAGE_SETTINGS_KEY_TEMPLATE.replace(/\?/,type);try{localStorage.setItem(key,JSON.stringify({settings:value,timestamp:getTimestamp()}));}catch(e) {log(e.message);}}}function setSavedBitrateSettings(type,bitrate){if(canStore(STORAGE_TYPE_LOCAL,LAST_BITRATE) && bitrate){var key=LOCAL_STORAGE_BITRATE_KEY_TEMPLATE.replace(/\?/,type);try{localStorage.setItem(key,JSON.stringify({bitrate:bitrate.toFixed(3),timestamp:getTimestamp()}));}catch(e) {log(e.message);}}}instance = {getSavedBitrateSettings:getSavedBitrateSettings,setSavedBitrateSettings:setSavedBitrateSettings,getSavedMediaSettings:getSavedMediaSettings,setSavedMediaSettings:setSavedMediaSettings};setup();return instance;}DOMStorage.__dashjs_factory_name = 'DOMStorage';var factory=_coreFactoryMaker2['default'].getSingletonFactory(DOMStorage);exports['default'] = factory;module.exports = exports['default'];
	//# sourceMappingURL=DOMStorage.js.map


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker); /**
	 * Creates an instance of an EBMLParser class which implements a large subset
	 * of the functionality required to parse Matroska EBML
	 *
	 * @param {Object} config object with data member which is the buffer to parse
	 */function EBMLParser(config){config = config || {};var instance=undefined;var data=new DataView(config.data);var pos=0;function getPos(){return pos;}function setPos(value){pos = value;} /**
	     * Consumes an EBML tag from the data stream.
	     *
	     * @param {Object} tag to parse, A tag is an object with at least a {number} tag and
	     * {boolean} required flag.
	     * @param {boolean} test whether or not the function should throw if a required
	     * tag is not found
	     * @return {boolean} whether or not the tag was found
	     * @throws will throw an exception if a required tag is not found and test
	     * param is false or undefined, or if the stream is malformed.
	     * @memberof EBMLParser
	     */function consumeTag(tag,test){var found=true;var bytesConsumed=0;var p1=undefined,p2=undefined;if(test === undefined){test = false;}if(tag.tag > 0xFFFFFF){if(data.getUint32(pos) !== tag.tag){found = false;}bytesConsumed = 4;}else if(tag.tag > 0xFFFF){ // 3 bytes
	p1 = data.getUint16(pos);p2 = data.getUint8(pos + 2); // shift p1 over a byte and add p2
	if(p1 * 256 + p2 !== tag.tag){found = false;}bytesConsumed = 3;}else if(tag.tag > 0xFF){if(data.getUint16(pos) !== tag.tag){found = false;}bytesConsumed = 2;}else {if(data.getUint8(pos) !== tag.tag){found = false;}bytesConsumed = 1;}if(!found && tag.required && !test){throw new Error('required tag not found');}if(found){pos += bytesConsumed;}return found;} /**
	     * Consumes an EBML tag from the data stream.   If the tag is found then this
	     * function will also remove the size field which follows the tag from the
	     * data stream.
	     *
	     * @param {Object} tag to parse, A tag is an object with at least a {number} tag and
	     * {boolean} required flag.
	     * @param {boolean} test whether or not the function should throw if a required
	     * tag is not found
	     * @return {boolean} whether or not the tag was found
	     * @throws will throw an exception if a required tag is not found and test
	     * param is false or undefined, or if the stream is malformedata.
	     * @memberof EBMLParser
	     */function consumeTagAndSize(tag,test){var found=consumeTag(tag,test);if(found){getMatroskaCodedNum();}return found;} /**
	     * Consumes an EBML tag from the data stream.   If the tag is found then this
	     * function will also remove the size field which follows the tag from the
	     * data stream.  It will use the value of the size field to parse a binary
	     * field, using a parser defined in the tag itself
	     *
	     * @param {Object} tag to parse, A tag is an object with at least a {number} tag,
	     * {boolean} required flag, and a parse function which takes a size parameter
	     * @return {boolean} whether or not the tag was found
	     * @throws will throw an exception if a required tag is not found,
	     * or if the stream is malformed
	     * @memberof EBMLParser
	     */function parseTag(tag){var size=undefined;consumeTag(tag);size = getMatroskaCodedNum();return instance[tag.parse](size);} /**
	     * Consumes an EBML tag from the data stream.   If the tag is found then this
	     * function will also remove the size field which follows the tag from the
	     * data stream.  It will use the value of the size field to skip over the
	     * entire section of EBML encapsulated by the tag.
	     *
	     * @param {Object} tag to parse, A tag is an object with at least a {number} tag, and
	     * {boolean} required flag
	     * @param {boolean} test a flag to indicate if an exception should be thrown
	     * if a required tag is not found
	     * @return {boolean} whether or not the tag was found
	     * @throws will throw an exception if a required tag is not found and test is
	     * false or undefined or if the stream is malformed
	     * @memberof EBMLParser
	     */function skipOverElement(tag,test){var found=consumeTag(tag,test);var headerSize=undefined;if(found){headerSize = getMatroskaCodedNum();pos += headerSize;}return found;} /**
	     * Returns and consumes a number encoded according to the Matroska EBML
	     * specification from the bitstream.
	     *
	     * @param {boolean} retainMSB whether or not to retain the Most Significant Bit (the
	     * first 1). this is usually true when reading Tag IDs.
	     * @return {number} the decoded number
	     * @throws will throw an exception if the bit stream is malformed or there is
	     * not enough data
	     * @memberof EBMLParser
	     */function getMatroskaCodedNum(retainMSB){var bytesUsed=1;var mask=0x80;var maxBytes=8;var extraBytes=-1;var num=0;var ch=data.getUint8(pos);var i=0;for(i = 0;i < maxBytes;i += 1) {if((ch & mask) === mask){num = retainMSB === undefined?ch & ~mask:ch;extraBytes = i;break;}mask >>= 1;}for(i = 0;i < extraBytes;i += 1,bytesUsed += 1) {num = num << 8 | 0xff & data.getUint8(pos + bytesUsed);}pos += bytesUsed;return num;} /**
	     * Returns and consumes a float from the bitstream.
	     *
	     * @param {number} size 4 or 8 byte floats are supported
	     * @return {number} the decoded number
	     * @throws will throw an exception if the bit stream is malformed or there is
	     * not enough data
	     * @memberof EBMLParser
	     */function getMatroskaFloat(size){var outFloat=undefined;switch(size){case 4:outFloat = data.getFloat32(pos);pos += 4;break;case 8:outFloat = data.getFloat64(pos);pos += 8;break;}return outFloat;} /**
	     * Consumes and returns an unsigned int from the bitstream.
	     *
	     * @param {number} size 1 to 8 bytes
	     * @return {number} the decoded number
	     * @throws will throw an exception if the bit stream is malformed or there is
	     * not enough data
	     * @memberof EBMLParser
	     */function getMatroskaUint(size){var val=0;for(var i=0;i < size;i += 1) {val <<= 8;val |= data.getUint8(pos + i) & 0xff;}pos += size;return val;} /**
	     * Tests whether there is more data in the bitstream for parsing
	     *
	     * @return {boolean} whether there is more data to parse
	     * @memberof EBMLParser
	     */function moreData(){return pos < data.byteLength;}instance = {getPos:getPos,setPos:setPos,consumeTag:consumeTag,consumeTagAndSize:consumeTagAndSize,parseTag:parseTag,skipOverElement:skipOverElement,getMatroskaCodedNum:getMatroskaCodedNum,getMatroskaFloat:getMatroskaFloat,getMatroskaUint:getMatroskaUint,moreData:moreData};return instance;}EBMLParser.__dashjs_factory_name = 'EBMLParser';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(EBMLParser);module.exports = exports['default'];
	//# sourceMappingURL=EBMLParser.js.map


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _voIsoBox=__webpack_require__(419);var _voIsoBox2=_interopRequireDefault(_voIsoBox);var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function IsoFile(){var instance=undefined,parsedIsoFile=undefined; /**
	    * @param {string} type
	    * @returns {IsoBox|null}
	    * @memberof IsoFile#
	    */function getBox(type){if(!type || !parsedIsoFile || !parsedIsoFile.boxes || parsedIsoFile.boxes.length === 0 || typeof parsedIsoFile.fetch !== 'function')return null;return convertToDashIsoBox(parsedIsoFile.fetch(type));} /**
	    * @param {string} type
	    * @returns {Array|null} array of {@link IsoBox}
	    * @memberof IsoFile#
	    */function getBoxes(type){var boxes=[];if(!type || !parsedIsoFile || typeof parsedIsoFile.fetchAll !== 'function'){return boxes;}var boxData=parsedIsoFile.fetchAll(type);var box=undefined;for(var i=0,ln=boxData.length;i < ln;i++) {box = convertToDashIsoBox(boxData[i]);if(box){boxes.push(box);}}return boxes;} /**
	    * @param {string} value
	    * @memberof IsoFile#
	    */function setData(value){parsedIsoFile = value;} /**
	    * @returns {IsoBox|null}
	    * @memberof IsoFile#
	    */function getLastBox(){if(!parsedIsoFile || !parsedIsoFile.boxes || !parsedIsoFile.boxes.length)return null;var type=parsedIsoFile.boxes[parsedIsoFile.boxes.length - 1].type;var boxes=getBoxes(type);return boxes.length > 0?boxes[boxes.length - 1]:null;}function convertToDashIsoBox(boxData){if(!boxData)return null;var box=new _voIsoBox2['default'](boxData);if(boxData.hasOwnProperty('_incomplete')){box.isComplete = !boxData._incomplete;}return box;}instance = {getBox:getBox,getBoxes:getBoxes,setData:setData,getLastBox:getLastBox};return instance;}IsoFile.__dashjs_factory_name = 'IsoFile';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(IsoFile);module.exports = exports['default'];
	//# sourceMappingURL=IsoFile.js.map


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker); /**
	 * @param {Object} config
	 * @returns {{initialize: initialize, getLiveEdge: getLiveEdge, reset: reset}|*}
	 * @constructor
	 */function LiveEdgeFinder(config){config = config || {};var instance=undefined;var timelineConverter=config.timelineConverter;var streamProcessor=config.streamProcessor;function checkConfig(){if(!timelineConverter || !timelineConverter.hasOwnProperty('getExpectedLiveEdge') || !streamProcessor || !streamProcessor.hasOwnProperty('getCurrentRepresentationInfo')){throw new Error('Missing config parameter(s)');}}function getLiveEdge(){checkConfig();var representationInfo=streamProcessor.getCurrentRepresentationInfo();var liveEdge=representationInfo.DVRWindow.end;if(representationInfo.useCalculatedLiveEdgeTime){liveEdge = timelineConverter.getExpectedLiveEdge();timelineConverter.setClientTimeOffset(liveEdge - representationInfo.DVRWindow.end);}return liveEdge;}function reset(){timelineConverter = null;streamProcessor = null;}instance = {getLiveEdge:getLiveEdge,reset:reset};return instance;}LiveEdgeFinder.__dashjs_factory_name = 'LiveEdgeFinder';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(LiveEdgeFinder);module.exports = exports['default'];
	//# sourceMappingURL=LiveEdgeFinder.js.map


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var _coreEventBus=__webpack_require__(4);var _coreEventBus2=_interopRequireDefault(_coreEventBus);var _coreEventsEvents=__webpack_require__(5);var _coreEventsEvents2=_interopRequireDefault(_coreEventsEvents);var _imsc=__webpack_require__(165);function TTMLParser(){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var eventBus=(0,_coreEventBus2['default'])(context).getInstance(); /*
	     * This TTML parser follows "EBU-TT-D SUBTITLING DISTRIBUTION FORMAT - tech3380" spec - https://tech.ebu.ch/docs/tech/tech3380.pdf.
	     * */var instance=undefined;var cueCounter=0; // Used to give every cue a unique ID.
	function getCueID(){var id='cue_TTML_' + cueCounter;cueCounter++;return id;} /**
	     * Parse the raw data and process it to return the HTML element representing the cue.
	     * Return the region to be processed and controlled (hide/show) by the caption controller.
	     * @param {string} data - raw data received from the TextSourceBuffer
	     * @param {number} offsetTime - offset time to apply to cue time
	     * @param {integer} startTimeSegment - startTime for the current segment
	     * @param {integer} endTimeSegment - endTime for the current segment
	     * @param {Array} images - images array referenced by subs MP4 box
	     */function parse(data,offsetTime,startTimeSegment,endTimeSegment,images){var i=undefined;var errorMsg='';var captionArray=[];var startTime=undefined,endTime=undefined;var content={};var embeddedImages={};var currentImageId='';var accumulated_image_data='';var metadataHandler={onOpenTag:function onOpenTag(ns,name,attrs){if(name === 'image' && ns === 'http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt'){if(!attrs[' imagetype'] || attrs[' imagetype'].value !== 'PNG'){log('Warning: smpte-tt imagetype != PNG. Discarded');return;}currentImageId = attrs['http://www.w3.org/XML/1998/namespace id'].value;}},onCloseTag:function onCloseTag(){if(currentImageId){embeddedImages[currentImageId] = accumulated_image_data.trim();}accumulated_image_data = '';currentImageId = '';},onText:function onText(contents){if(currentImageId){accumulated_image_data = accumulated_image_data + contents;}}};if(!data){errorMsg = 'no ttml data to parse';throw new Error(errorMsg);}content.data = data;eventBus.trigger(_coreEventsEvents2['default'].TTML_TO_PARSE,content);var imsc1doc=(0,_imsc.fromXML)(content.data,function(msg){errorMsg = msg;},metadataHandler);eventBus.trigger(_coreEventsEvents2['default'].TTML_PARSED,{ttmlString:content.data,ttmlDoc:imsc1doc});var mediaTimeEvents=imsc1doc.getMediaTimeEvents();for(i = 0;i < mediaTimeEvents.length;i++) {var isd=(0,_imsc.generateISD)(imsc1doc,mediaTimeEvents[i],function(error){errorMsg = error;});if(isd.contents.some(function(topLevelContents){return topLevelContents.contents.length;})){ //be sure that mediaTimeEvents values are in the mp4 segment time ranges.
	startTime = mediaTimeEvents[i] + offsetTime < startTimeSegment?startTimeSegment:mediaTimeEvents[i] + offsetTime;endTime = mediaTimeEvents[i + 1] + offsetTime > endTimeSegment?endTimeSegment:mediaTimeEvents[i + 1] + offsetTime;if(startTime < endTime){captionArray.push({start:startTime,end:endTime,type:'html',cueID:getCueID(),isd:isd,images:images,embeddedImages:embeddedImages});}}}if(errorMsg !== ''){log(errorMsg);throw new Error(errorMsg);}return captionArray;}function setup(){}instance = {parse:parse};setup();return instance;}TTMLParser.__dashjs_factory_name = 'TTMLParser';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(TTMLParser);module.exports = exports['default'];
	//# sourceMappingURL=TTMLParser.js.map


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);var _coreDebug=__webpack_require__(6);var _coreDebug2=_interopRequireDefault(_coreDebug);var WEBVTT='WEBVTT';function VTTParser(){var context=this.context;var log=(0,_coreDebug2['default'])(context).getInstance().log;var instance=undefined,regExNewLine=undefined,regExToken=undefined,regExWhiteSpace=undefined,regExWhiteSpaceWordBoundary=undefined;function setup(){regExNewLine = /(?:\r\n|\r|\n)/gm;regExToken = /-->/;regExWhiteSpace = /(^[\s]+|[\s]+$)/g;regExWhiteSpaceWordBoundary = /\s\b/g;}function parse(data){var captionArray=[];var len=undefined,lastStartTime=undefined;if(!data){return captionArray;}data = data.split(regExNewLine);len = data.length;lastStartTime = -1;for(var i=0;i < len;i++) {var item=data[i];if(item.length > 0 && item !== WEBVTT){if(item.match(regExToken)){var attributes=parseItemAttributes(item);var cuePoints=attributes.cuePoints;var styles=attributes.styles;var text=getSublines(data,i + 1);var startTime=convertCuePointTimes(cuePoints[0].replace(regExWhiteSpace,''));var endTime=convertCuePointTimes(cuePoints[1].replace(regExWhiteSpace,''));if(!isNaN(startTime) && !isNaN(endTime) && startTime >= lastStartTime && endTime > startTime){if(text !== ''){lastStartTime = startTime; //TODO Make VO external so other parsers can use.
	captionArray.push({start:startTime,end:endTime,data:text,styles:styles});}else {log('Skipping cue due to empty/malformed cue text');}}else {log('Skipping cue due to incorrect cue timing');}}}}return captionArray;}function convertCuePointTimes(time){var timeArray=time.split(':');var len=timeArray.length - 1;time = parseInt(timeArray[len - 1],10) * 60 + parseFloat(timeArray[len]);if(len === 2){time += parseInt(timeArray[0],10) * 3600;}return time;}function parseItemAttributes(data){var vttCuePoints=data.split(regExToken);var arr=vttCuePoints[1].split(regExWhiteSpaceWordBoundary);arr.shift(); //remove first array index it is empty...
	vttCuePoints[1] = arr[0];arr.shift();return {cuePoints:vttCuePoints,styles:getCaptionStyles(arr)};}function getCaptionStyles(arr){var styleObject={};arr.forEach(function(element){if(element.split(/:/).length > 1){var val=element.split(/:/)[1];if(val && val.search(/%/) != -1){val = parseInt(val.replace(/%/,''),10);}if(element.match(/align/) || element.match(/A/)){styleObject.align = val;}if(element.match(/line/) || element.match(/L/)){styleObject.line = val;}if(element.match(/position/) || element.match(/P/)){styleObject.position = val;}if(element.match(/size/) || element.match(/S/)){styleObject.size = val;}}});return styleObject;} /*
	    * VTT can have multiple lines to display per cuepoint.
	    */function getSublines(data,idx){var i=idx;var subline='';var lineData='';var lineCount=undefined;while(data[i] !== '' && i < data.length) {i++;}lineCount = i - idx;if(lineCount > 1){for(var j=0;j < lineCount;j++) {lineData = data[idx + j];if(!lineData.match(regExToken)){subline += lineData;if(j !== lineCount - 1){subline += '\n';}}else { // caption text should not have '-->' in it
	subline = '';break;}}}else {lineData = data[idx];if(!lineData.match(regExToken))subline = lineData;}return subline;}instance = {parse:parse};setup();return instance;}VTTParser.__dashjs_factory_name = 'VTTParser';exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(VTTParser);module.exports = exports['default'];
	//# sourceMappingURL=VTTParser.js.map


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function BasicSelector(config){config = config || {};var instance=undefined;var blacklistController=config.blacklistController;function select(baseUrls){var index=0;var selectedBaseUrl=undefined;if(baseUrls && baseUrls.some(function(baseUrl,idx){index = idx;return !blacklistController.contains(baseUrl.serviceLocation);})){selectedBaseUrl = baseUrls[index];}return selectedBaseUrl;}instance = {select:select};return instance;}BasicSelector.__dashjs_factory_name = 'BasicSelector';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(BasicSelector);module.exports = exports['default'];
	//# sourceMappingURL=BasicSelector.js.map


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}var _coreFactoryMaker=__webpack_require__(1);var _coreFactoryMaker2=_interopRequireDefault(_coreFactoryMaker);function DVBSelector(config){config = config || {};var instance=undefined;var blacklistController=config.blacklistController;function getNonBlacklistedBaseUrls(urls){var removedPriorities=[];var samePrioritiesFilter=function samePrioritiesFilter(el){if(removedPriorities.length){if(el.dvb_priority && removedPriorities.indexOf(el.dvb_priority) !== -1){return false;}}return true;};var serviceLocationFilter=function serviceLocationFilter(baseUrl){if(blacklistController.contains(baseUrl.serviceLocation)){ // whenever a BaseURL is removed from the available list of
	// BaseURLs, any other BaseURL with the same @priority
	// value as the BaseURL being removed shall also be removed
	if(baseUrl.dvb_priority){removedPriorities.push(baseUrl.dvb_priority);} // all URLs in the list which have a @serviceLocation
	// attribute matching an entry in the blacklist shall be
	// removed from the available list of BaseURLs
	return false;}return true;};return urls.filter(serviceLocationFilter).filter(samePrioritiesFilter);}function selectByWeight(availableUrls){var prioritySorter=function prioritySorter(a,b){var diff=a.dvb_priority - b.dvb_priority;return isNaN(diff)?0:diff;};var topPriorityFilter=function topPriorityFilter(baseUrl,idx,arr){return !idx || arr[0].dvb_priority && baseUrl.dvb_priority && arr[0].dvb_priority === baseUrl.dvb_priority;};var totalWeight=0;var cumulWeights=[];var idx=0;var rn=undefined,urls=undefined; // It shall begin by taking the set of resolved BaseURLs present or inherited at the current
	// position in the MPD, resolved and filtered as described in 10.8.2.1, that have the lowest
	// @priority attribute value.
	urls = availableUrls.sort(prioritySorter).filter(topPriorityFilter);if(urls.length){if(urls.length > 1){ // If there is more than one BaseURL with this lowest @priority attribute value then the Player
	// shall select one of them at random such that the probability of each BaseURL being chosen
	// is proportional to the value of its @weight attribute. The method described in RFC 2782
	// [26] or picking from a number of weighted entries is suitable for this, but there may be other
	// algorithms which achieve the same effect.
	// add all the weights together, storing the accumulated weight per entry
	urls.forEach(function(baseUrl){totalWeight += baseUrl.dvb_weight;cumulWeights.push(totalWeight);}); // pick a random number between zero and totalWeight
	rn = Math.floor(Math.random() * (totalWeight - 1)); // select the index for the range rn falls within
	cumulWeights.every(function(limit,index){idx = index;if(rn < limit){return false;}return true;});}return urls[idx];}}function select(baseUrls){return baseUrls && selectByWeight(getNonBlacklistedBaseUrls(baseUrls));}instance = {select:select};return instance;}DVBSelector.__dashjs_factory_name = 'DVBSelector';exports['default'] = _coreFactoryMaker2['default'].getClassFactory(DVBSelector);module.exports = exports['default'];
	//# sourceMappingURL=DVBSelector.js.map


/***/ },
/* 417 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DataChunk= //Represents a data structure that keep all the necessary info about a single init/media segment
	function DataChunk(){_classCallCheck(this,DataChunk);this.streamId = null;this.mediaInfo = null;this.segmentType = null;this.quality = NaN;this.index = NaN;this.bytes = null;this.start = NaN;this.end = NaN;this.duration = NaN;this.representationId = null;this.endFragment = null;};exports["default"] = DataChunk;module.exports = exports["default"];
	//# sourceMappingURL=DataChunk.js.map


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _get=function get(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if('value' in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}function _inherits(subClass,superClass){if(typeof superClass !== 'function' && superClass !== null){throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__ = superClass;}var _FragmentRequest2=__webpack_require__(37);var _FragmentRequest3=_interopRequireDefault(_FragmentRequest2);var HeadRequest=(function(_FragmentRequest){_inherits(HeadRequest,_FragmentRequest);function HeadRequest(url){_classCallCheck(this,HeadRequest);_get(Object.getPrototypeOf(HeadRequest.prototype),'constructor',this).call(this);this.url = url || null;this.checkForExistenceOnly = true;}return HeadRequest;})(_FragmentRequest3['default']);exports['default'] = HeadRequest;module.exports = exports['default'];
	//# sourceMappingURL=HeadRequest.js.map


/***/ },
/* 419 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if('value' in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var IsoBox=(function(){function IsoBox(boxData){_classCallCheck(this,IsoBox);this.offset = boxData._offset;this.type = boxData.type;this.size = boxData.size;this.boxes = [];if(boxData.boxes){for(var i=0;i < boxData.boxes.length;i++) {this.boxes.push(new IsoBox(boxData.boxes[i]));}}this.isComplete = true;switch(boxData.type){case 'sidx':this.timescale = boxData.timescale;this.earliest_presentation_time = boxData.earliest_presentation_time;this.first_offset = boxData.first_offset;this.references = boxData.references;if(boxData.references){this.references = [];for(var i=0;i < boxData.references.length;i++) {var reference={reference_type:boxData.references[i].reference_type,referenced_size:boxData.references[i].referenced_size,subsegment_duration:boxData.references[i].subsegment_duration};this.references.push(reference);}}break;case 'emsg':this.id = boxData.id;this.value = boxData.value;this.timescale = boxData.timescale;this.scheme_id_uri = boxData.scheme_id_uri;this.presentation_time_delta = boxData.presentation_time_delta;this.event_duration = boxData.event_duration;this.message_data = boxData.message_data;break;case 'mdhd':this.timescale = boxData.timescale;break;case 'mfhd':this.sequence_number = boxData.sequence_number;break;case 'subs':this.entry_count = boxData.entry_count;this.entries = boxData.entries;break;case 'tfhd':this.base_data_offset = boxData.base_data_offset;this.sample_description_index = boxData.sample_description_index;this.default_sample_duration = boxData.default_sample_duration;this.default_sample_size = boxData.default_sample_size;this.default_sample_flags = boxData.default_sample_flags;this.flags = boxData.flags;break;case 'tfdt':this.version = boxData.version;this.baseMediaDecodeTime = boxData.baseMediaDecodeTime;this.flags = boxData.flags;break;case 'trun':this.sample_count = boxData.sample_count;this.first_sample_flags = boxData.first_sample_flags;this.data_offset = boxData.data_offset;this.flags = boxData.flags;this.samples = boxData.samples;if(boxData.samples){this.samples = [];for(var i=0,ln=boxData.samples.length;i < ln;i++) {var sample={sample_size:boxData.samples[i].sample_size,sample_duration:boxData.samples[i].sample_duration,sample_composition_time_offset:boxData.samples[i].sample_composition_time_offset};this.samples.push(sample);}}break;}}_createClass(IsoBox,[{key:'getChildBox',value:function getChildBox(type){for(var i=0;i < this.boxes.length;i++) {if(this.boxes[i].type === type){return this.boxes[i];}}}},{key:'getChildBoxes',value:function getChildBoxes(type){var boxes=[];for(var i=0;i < this.boxes.length;i++) {if(this.boxes[i].type === type){boxes.push(this.boxes[i]);}}return boxes;}}]);return IsoBox;})();exports['default'] = IsoBox;module.exports = exports['default'];
	//# sourceMappingURL=IsoBox.js.map


/***/ },
/* 420 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var IsoBoxSearchInfo=function IsoBoxSearchInfo(lastCompletedOffset,found,size){_classCallCheck(this,IsoBoxSearchInfo);this.lastCompletedOffset = lastCompletedOffset;this.found = found;this.size = size;};exports["default"] = IsoBoxSearchInfo;module.exports = exports["default"];
	//# sourceMappingURL=IsoBoxSearchInfo.js.map


/***/ },
/* 421 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ManifestInfo=function ManifestInfo(){_classCallCheck(this,ManifestInfo);this.DVRWindowSize = NaN;this.loadedTime = null;this.availableFrom = null;this.minBufferTime = NaN;this.duration = NaN;this.isDynamic = false;this.maxFragmentDuration = null;};exports["default"] = ManifestInfo;module.exports = exports["default"];
	//# sourceMappingURL=ManifestInfo.js.map


/***/ },
/* 422 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var MediaInfo=function MediaInfo(){_classCallCheck(this,MediaInfo);this.id = null;this.index = null;this.type = null;this.streamInfo = null;this.representationCount = 0;this.lang = null;this.viewpoint = null;this.accessibility = null;this.audioChannelConfiguration = null;this.roles = null;this.codec = null;this.mimeType = null;this.contentProtection = null;this.isText = false;this.KID = null;this.bitrateList = null;};exports["default"] = MediaInfo;module.exports = exports["default"];
	//# sourceMappingURL=MediaInfo.js.map


/***/ },
/* 423 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var MetricsList=function MetricsList(){_classCallCheck(this,MetricsList);this.TcpList = [];this.HttpList = [];this.RepSwitchList = [];this.BufferLevel = [];this.BufferState = [];this.PlayList = [];this.DroppedFrames = [];this.SchedulingInfo = [];this.DVRInfo = [];this.ManifestUpdate = [];this.RequestsQueue = null;this.DVBErrors = [];};exports["default"] = MetricsList;module.exports = exports["default"];
	//# sourceMappingURL=MetricsList.js.map


/***/ },
/* 424 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var RepresentationInfo=function RepresentationInfo(){_classCallCheck(this,RepresentationInfo);this.id = null;this.quality = null;this.DVRWindow = null;this.fragmentDuration = null;this.mediaInfo = null;this.MSETimeOffset = null;};exports["default"] = RepresentationInfo;module.exports = exports["default"];
	//# sourceMappingURL=RepresentationInfo.js.map


/***/ },
/* 425 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var StreamInfo=function StreamInfo(){_classCallCheck(this,StreamInfo);this.id = null;this.index = null;this.start = NaN;this.duration = NaN;this.manifestInfo = null;this.isLast = true;};exports["default"] = StreamInfo;module.exports = exports["default"];
	//# sourceMappingURL=StreamInfo.js.map


/***/ },
/* 426 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var TextTrackInfo=function TextTrackInfo(){_classCallCheck(this,TextTrackInfo);this.captionData = null;this.label = null;this.lang = null;this.defaultTrack = false;this.kind = null;this.isFragmented = false;this.isEmbedded = false;};exports["default"] = TextTrackInfo;module.exports = exports["default"];
	//# sourceMappingURL=TextTrackInfo.js.map


/***/ },
/* 427 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Thumbnail=function Thumbnail(){_classCallCheck(this,Thumbnail);this.url = null;this.width = null;this.height = null;this.x = null;this.y = null;};exports["default"] = Thumbnail;module.exports = exports["default"];
	//# sourceMappingURL=Thumbnail.js.map


/***/ },
/* 428 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var ThumbnailTrackInfo=function ThumbnailTrackInfo(){_classCallCheck(this,ThumbnailTrackInfo);this.bitrate = 0;this.width = 0;this.height = 0;this.tilesHor = 0;this.tilesVert = 0;this.widthPerTile = 0;this.heightPerTile = 0;this.startNumber = 0;this.segmentDuration = 0;this.timescale = 0;this.templateUrl = '';this.id = '';};exports['default'] = ThumbnailTrackInfo;module.exports = exports['default'];
	//# sourceMappingURL=ThumbnailTrackInfo.js.map


/***/ },
/* 429 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 * @ignore
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var URIFragmentData=function URIFragmentData(){_classCallCheck(this,URIFragmentData);this.t = null;this.xywh = null;this.track = null;this.id = null;this.s = null;this.r = null;};exports["default"] = URIFragmentData; /*
	    From Spec http://www.w3.org/TR/media-frags/
	
	    temporal (t)     - This dimension denotes a specific time range in the original media, such as "starting at second 10, continuing until second 20";
	    spatial  (xywh)  - this dimension denotes a specific range of pixels in the original media, such as "a rectangle with size (100,100) with its top-left at coordinate (10,10)";
	                       Media fragments support also addressing the media along two additional dimensions (in the advanced version defined in Media Fragments 1.0 URI (advanced)):
	    track    (track) - this dimension denotes one or more tracks in the original media, such as "the english audio and the video track";
	    id       (id)    - this dimension denotes a named temporal fragment within the original media, such as "chapter 2", and can be seen as a convenient way of specifying a temporal fragment.
	
	
	    ## Note
	    Akamai is purposing to add #s=X to the ISO standard.
	        - (X) Value would be a start time to seek to at startup instead of starting at 0 or live edge
	        - Allows for seeking back before the start time unlike a temporal clipping.
	*/module.exports = exports["default"];
	//# sourceMappingURL=URIFragmentData.js.map


/***/ },
/* 430 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var BufferLevel= /**
	     * @description This Object holds reference to the current buffer level and the time it was recorded.
	     */function BufferLevel(){_classCallCheck(this,BufferLevel); /**
	         * Real-Time | Time of the measurement of the buffer level.
	         * @public
	         */this.t = null; /**
	         * Level of the buffer in milliseconds. Indicates the playout duration for which
	         * media data of all active media components is available starting from the
	         * current playout time.
	         * @public
	         */this.level = null;};exports["default"] = BufferLevel;module.exports = exports["default"];
	//# sourceMappingURL=BufferLevel.js.map


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function');}}var _controllersBufferController=__webpack_require__(36);var _controllersBufferController2=_interopRequireDefault(_controllersBufferController); /**
	 * @class
	 */var BufferState= /**
	     * @description This Object holds reference to the current buffer state of the video element.
	     */function BufferState(){_classCallCheck(this,BufferState); /**
	         * The Buffer Level Target determined by the BufferLevelRule.
	         * @public
	         */this.target = null; /**
	         * Current buffer state. Will be BufferController.BUFFER_EMPTY or BufferController.BUFFER_LOADED.
	         * @public
	         */this.state = _controllersBufferController2['default'].BUFFER_EMPTY;};exports['default'] = BufferState;module.exports = exports['default'];
	//# sourceMappingURL=BufferState.js.map


/***/ },
/* 432 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DVRInfo= /**
	     * @description This Object holds reference to DVR availability window information.
	     */function DVRInfo(){_classCallCheck(this,DVRInfo); /**
	         * The current time of the video element when this was created.
	         * @public
	         */this.time = null; /**
	         * The current Segment Availability Range as an object with start and end properties.
	         * It's delta defined by the timeShiftBufferDepth MPD attribute.
	         * @public
	         */this.range = null; /**
	         * Reference to the internal ManifestInfo.js VO.
	         * @public
	         */this.manifestInfo = null;};exports["default"] = DVRInfo;module.exports = exports["default"];
	//# sourceMappingURL=DVRInfo.js.map


/***/ },
/* 433 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DroppedFrames= /**
	     * @description This Object holds reference to DroppedFrames count and the time it was recorded.
	     */function DroppedFrames(){_classCallCheck(this,DroppedFrames); /**
	         * Real-Time | Time of the measurement of the dropped frames.
	         * @public
	         */this.time = null; /**
	         * Number of dropped frames
	         * @public
	         */this.droppedFrames = null;};exports["default"] = DroppedFrames;module.exports = exports["default"];
	//# sourceMappingURL=DroppedFrames.js.map


/***/ },
/* 434 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @classdesc This Object holds reference to the manifest update information.
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ManifestUpdate= /**
	     * @class
	     */function ManifestUpdate(){_classCallCheck(this,ManifestUpdate); /**
	         * Media Type Video | Audio | FragmentedText
	         * @public
	         */this.mediaType = null; /**
	         * MPD Type static | dynamic
	         * @public
	         */this.type = null; /**
	         * When this manifest update was requested
	         * @public
	         */this.requestTime = null; /**
	         * When this manifest update was received
	         * @public
	         */this.fetchTime = null; /**
	         * Calculated Availability Start time of the stream.
	         * @public
	         */this.availabilityStartTime = null; /**
	         * the seek point (liveEdge for dynamic, Stream[0].startTime for static)
	         * @public
	         */this.presentationStartTime = 0; /**
	         * The calculated difference between the server and client wall clock time
	         * @public
	         */this.clientTimeOffset = 0; /**
	         * Actual element.currentTime
	         * @public
	         */this.currentTime = null; /**
	         * Actual element.ranges
	         * @public
	         */this.buffered = null; /**
	         * Static is fixed value of zero. dynamic should be ((Now-@availabilityStartTime) - elementCurrentTime)
	         * @public
	         */this.latency = 0; /**
	         * Array holding list of StreamInfo VO Objects
	         * @public
	         */this.streamInfo = []; /**
	         * Array holding list of RepresentationInfo VO Objects
	         * @public
	         */this.representationInfo = [];} /**
	 * @classdesc This Object holds reference to the current period's stream information when the manifest was updated.
	 */;var ManifestUpdateStreamInfo= /**
	     * @class
	     */function ManifestUpdateStreamInfo(){_classCallCheck(this,ManifestUpdateStreamInfo); /**
	         * Stream@id
	         * @public
	         */this.id = null; /**
	         * Period Index
	         * @public
	         */this.index = null; /**
	         * Stream@start
	         * @public
	         */this.start = null; /**
	         * Stream@duration
	         * @public
	         */this.duration = null;} /**
	 * @classdesc This Object holds reference to the current representation's info when the manifest was updated.
	 */;var ManifestUpdateRepresentationInfo= /**
	     * @class
	     */function ManifestUpdateRepresentationInfo(){_classCallCheck(this,ManifestUpdateRepresentationInfo); /**
	         * Track@id
	         * @public
	         */this.id = null; /**
	         * Representation Index
	         * @public
	         */this.index = null; /**
	         * Media Type Video | Audio | FragmentedText
	         * @public
	         */this.mediaType = null; /**
	         * Which representation
	         * @public
	         */this.streamIndex = null; /**
	         * Holds reference to @presentationTimeOffset
	         * @public
	         */this.presentationTimeOffset = null; /**
	         * Holds reference to @startNumber
	         * @public
	         */this.startNumber = null; /**
	         * list|template|timeline
	         * @public
	         */this.fragmentInfoType = null;};exports.ManifestUpdate = ManifestUpdate;exports.ManifestUpdateStreamInfo = ManifestUpdateStreamInfo;exports.ManifestUpdateRepresentationInfo = ManifestUpdateRepresentationInfo;
	//# sourceMappingURL=ManifestUpdate.js.map


/***/ },
/* 435 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var RepresentationSwitch= /**
	     * @description This Object holds reference to the info at quality switch between two representations.
	     */function RepresentationSwitch(){_classCallCheck(this,RepresentationSwitch); /**
	         * Time of the switch event.
	         * @public
	         */this.t = null; /**
	         * The media presentation time of the earliest access unit
	         * (out of all media content components) played out from
	         * the Representation.
	         *
	         * @public
	         */this.mt = null; /**
	         * Value of Representation@id identifying the switch-to Representation.
	         * @public
	         */this.to = null; /**
	         * If not present, this metrics concerns the Representation as a whole.
	         * If present, lto indicates the value of SubRepresentation@level within
	         * Representation identifying the switch-to level of the Representation.
	         *
	         * @public
	         */this.lto = null;};exports["default"] = RepresentationSwitch;module.exports = exports["default"];
	//# sourceMappingURL=RepresentationSwitch.js.map


/***/ },
/* 436 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var RequestsQueue= /**
	     * @description This Object holds reference to Fragment Model's request queues
	     */function RequestsQueue(){_classCallCheck(this,RequestsQueue); /**
	         * Array of all of the requests that have begun to load
	         * This request may not make it into the executed queue if it is abandon due to ABR rules for example.
	         * @public
	         */this.loadingRequests = []; /**
	         * Array of the The requests that have completed
	         * @public
	         */this.executedRequests = [];};exports["default"] = RequestsQueue;module.exports = exports["default"];
	//# sourceMappingURL=RequestsQueue.js.map


/***/ },
/* 437 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var SchedulingInfo= /**
	     * @description This Object holds reference to the index handling of the current fragment being loaded or executed.
	     */function SchedulingInfo(){_classCallCheck(this,SchedulingInfo); /**
	         * Type of stream Audio | Video | FragmentedText
	         * @public
	         */this.mediaType = null; /**
	         * Time of the scheduling event.
	         * @public
	         */this.t = null; /**
	         * Type of fragment (initialization | media)
	         * @public
	         */this.type = null; /**
	         * Presentation start time of fragment
	         * @public
	         */this.startTime = null; /**
	         * Availability start time of fragment
	         * @public
	         */this.availabilityStartTime = null; /**
	         * Duration of fragment
	         * @public
	         */this.duration = null; /**
	         * Bit Rate Quality of fragment
	         * @public
	         */this.quality = null; /**
	         * Range of fragment
	         * @public
	         */this.range = null; /**
	         * Current state of fragment
	         * @public
	         */this.state = null;};exports["default"] = SchedulingInfo;module.exports = exports["default"];
	//# sourceMappingURL=SchedulingInfo.js.map


/***/ },
/* 438 */
/***/ function(module, exports) {

	/**
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2013, Dash Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  * Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  * Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */ /**
	 * @class
	 */"use strict";Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var TCPConnection= /**
	     * @description This Object holds reference to the current tcp connection
	     */function TCPConnection(){_classCallCheck(this,TCPConnection); /**
	         * Identifier of the TCP connection on which the HTTP request was sent.
	         * @public
	         */this.tcpid = null; /**
	         * IP Address of the interface over which the client is receiving the TCP data.
	         * @public
	         */this.dest = null; /**
	         * Real-Time | The time at which the connection was opened (sending time of the initial SYN or connect socket operation).
	         * @public
	         */this.topen = null; /**
	         * Real-Time | The time at which the connection was closed (sending or reception time of FIN or RST or close socket operation).
	         * @public
	         */this.tclose = null; /**
	         * Connect time in ms (time from sending the initial SYN to receiving the ACK or completion of the connect socket operation).
	         * @public
	         */this.tconnect = null;};exports["default"] = TCPConnection;module.exports = exports["default"];
	//# sourceMappingURL=TCPConnection.js.map


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(441);
	var isArguments = __webpack_require__(440);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 440 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 441 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(444);
	var each = __webpack_require__(157).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(442);
	var Util = __webpack_require__(157);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 444 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(443);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 447 */
/***/ function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	module.exports = function equal(a, b) {
	  if (a === b) return true;
	
	  var arrA = isArray(a)
	    , arrB = isArray(b)
	    , i
	    , length
	    , key;
	
	  if (arrA && arrB) {
	    length = a.length;
	    if (length != b.length) return false;
	    for (i = 0; i < length; i++)
	      if (!equal(a[i], b[i])) return false;
	    return true;
	  }
	
	  if (arrA != arrB) return false;
	
	  var dateA = a instanceof Date
	    , dateB = b instanceof Date;
	  if (dateA != dateB) return false;
	  if (dateA && dateB) return a.getTime() == b.getTime();
	
	  var regexpA = a instanceof RegExp
	    , regexpB = b instanceof RegExp;
	  if (regexpA != regexpB) return false;
	  if (regexpA && regexpB) return a.toString() == b.toString();
	
	  if (a instanceof Object && b instanceof Object) {
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = 0; i < length; i++)
	      if (!hasProp.call(b, keys[i])) return false;
	
	    for (i = 0; i < length; i++) {
	      key = keys[i];
	      if (!equal(a[key], b[key])) return false;
	    }
	
	    return true;
	  }
	
	  return false;
	};


/***/ },
/* 448 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(448);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(458);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	var createArrayFromMixed = __webpack_require__(451);
	var getMarkupWrap = __webpack_require__(453);
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 454 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 455 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(455);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 457 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(457);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 459 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "public/fonts/slick.woff";

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "public/fonts/Stanley-Poster.woff";

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/slick.f97e3bbf.svg";

/***/ },
/* 463 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(100);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(43);
	
	var _DOMUtils = __webpack_require__(72);
	
	var _DOMStateStorage = __webpack_require__(161);
	
	var _PathUtils = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(100);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(43);
	
	var _PathUtils = __webpack_require__(32);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(101);
	
	var _BrowserProtocol = __webpack_require__(100);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(465);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(72);
	
	var _createHistory = __webpack_require__(102);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(101);
	
	var _DOMUtils = __webpack_require__(72);
	
	var _HashProtocol = __webpack_require__(464);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(102);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(34);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(43);
	
	var _PathUtils = __webpack_require__(32);
	
	var _createHistory = __webpack_require__(102);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 469 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	/* 
	 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *
	 * * Redistributions of source code must retain the above copyright notice, this
	 *   list of conditions and the following disclaimer.
	 * * Redistributions in binary form must reproduce the above copyright notice,
	 *   this list of conditions and the following disclaimer in the documentation
	 *   and/or other materials provided with the distribution.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
	 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
	 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
	 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 * POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/**
	 * @module imscDoc
	 */
	
	;
	(function (imscDoc, sax, imscNames, imscStyles, imscUtils) {
	
	
	    /**
	     * Allows a client to provide callbacks to handle children of the <metadata> element
	     * @typedef {Object} MetadataHandler
	     * @property {?OpenTagCallBack} onOpenTag
	     * @property {?CloseTagCallBack} onCloseTag
	     * @property {?TextCallBack} onText
	     */
	
	    /**
	     * Called when the opening tag of an element node is encountered.
	     * @callback OpenTagCallBack
	     * @param {string} ns Namespace URI of the element
	     * @param {string} name Local name of the element
	     * @param {Object[]} attributes List of attributes, each consisting of a
	     *                              `uri`, `name` and `value`
	     */
	
	    /**
	     * Called when the closing tag of an element node is encountered.
	     * @callback CloseTagCallBack
	     */
	
	    /**
	     * Called when a text node is encountered.
	     * @callback TextCallBack
	     * @param {string} contents Contents of the text node
	     */
	
	    /**
	     * Parses an IMSC1 document into an opaque in-memory representation that exposes
	     * a single method <pre>getMediaTimeEvents()</pre> that returns a list of time
	     * offsets (in seconds) of the ISD, i.e. the points in time where the visual
	     * representation of the document change. `metadataHandler` allows the caller to
	     * be called back when nodes are present in <metadata> elements. 
	     * 
	     * @param {string} xmlstring XML document
	     * @param {?module:imscUtils.ErrorHandler} errorHandler Error callback
	     * @param {?MetadataHandler} metadataHandler Callback for <Metadata> elements
	     * @returns {Object} Opaque in-memory representation of an IMSC1 document
	     */
	
	    imscDoc.fromXML = function (xmlstring, errorHandler, metadataHandler) {
	        var p = sax.parser(true, {xmlns: true});
	        var estack = [];
	        var xmllangstack = [];
	        var xmlspacestack = [];
	        var metadata_depth = 0;
	        var doc = null;
	
	        p.onclosetag = function (node) {
	
	            if (estack[0] instanceof Styling) {
	
	                /* flatten chained referential styling */
	
	                for (var sid in estack[0].styles) {
	
	                    mergeChainedStyles(estack[0], estack[0].styles[sid], errorHandler);
	
	                }
	
	            } else if (estack[0] instanceof P || estack[0] instanceof Span) {
	
	                /* merge anonymous spans */
	
	                if (estack[0].contents.length > 1) {
	
	                    var cs = [estack[0].contents[0]];
	
	                    var c;
	
	                    for (c = 1; c < estack[0].contents.length; c++) {
	
	                        if (estack[0].contents[c] instanceof AnonymousSpan &&
	                            cs[cs.length - 1] instanceof AnonymousSpan) {
	
	                            cs[cs.length - 1].text += estack[0].contents[c].text;
	
	                        } else {
	
	                            cs.push(estack[0].contents[c]);
	
	                        }
	
	                    }
	
	                    estack[0].contents = cs;
	
	                }
	
	                // remove redundant nested anonymous spans (9.3.3(1)(c))
	
	                if (estack[0] instanceof Span &&
	                    estack[0].contents.length === 1 &&
	                    estack[0].contents[0] instanceof AnonymousSpan &&
	                    estack[0].text === null) {
	
	                    estack[0].text = estack[0].contents[0].text;
	                    delete estack[0].contents;
	
	                }
	
	            } else if (estack[0] instanceof ForeignElement) {
	
	                if (estack[0].node.uri === imscNames.ns_tt &&
	                    estack[0].node.local === 'metadata') {
	
	                    /* leave the metadata element */
	
	                    metadata_depth--;
	
	                } else if (metadata_depth > 0 &&
	                    metadataHandler &&
	                    'onCloseTag' in metadataHandler) {
	
	                    /* end of child of metadata element */
	
	                    metadataHandler.onCloseTag();
	
	                }
	
	            }
	
	            // TODO: delete stylerefs?
	
	            // maintain the xml:space stack
	
	            xmlspacestack.shift();
	
	            // maintain the xml:lang stack
	
	            xmllangstack.shift();
	
	            // prepare for the next element
	
	            estack.shift();
	        };
	
	        p.ontext = function (str) {
	
	            if (estack[0] === undefined) {
	
	                /* ignoring text outside of elements */
	
	            } else if (estack[0] instanceof Span || estack[0] instanceof P) {
	
	                /* create an anonymous span */
	                
	                var s = new AnonymousSpan();
	              
	                s.initFromText(doc, estack[0], str, xmlspacestack[0], errorHandler);
	
	                estack[0].contents.push(s);
	
	            } else if (estack[0] instanceof ForeignElement &&
	                metadata_depth > 0 &&
	                metadataHandler &&
	                'onText' in metadataHandler) {
	
	                /* text node within a child of metadata element */
	
	                metadataHandler.onText(str);
	
	            }
	
	        };
	
	
	        p.onopentag = function (node) {
	
	            // maintain the xml:space stack
	
	            var xmlspace = node.attributes["xml:space"];
	
	            if (xmlspace) {
	
	                xmlspacestack.unshift(xmlspace.value);
	
	            } else {
	
	                if (xmlspacestack.length === 0) {
	
	                    xmlspacestack.unshift("default");
	
	                } else {
	
	                    xmlspacestack.unshift(xmlspacestack[0]);
	
	                }
	
	            }
	
	            /* maintain the xml:lang stack */
	
	
	            var xmllang = node.attributes["xml:lang"];
	
	            if (xmllang) {
	
	                xmllangstack.unshift(xmllang.value);
	
	            } else {
	
	                if (xmllangstack.length === 0) {
	
	                    xmllangstack.unshift("");
	
	                } else {
	
	                    xmllangstack.unshift(xmllangstack[0]);
	
	                }
	
	            }
	
	
	            /* process the element */
	
	            if (node.uri === imscNames.ns_tt) {
	
	                if (node.local === 'tt') {
	
	                    if (doc !== null) {
	
	                        reportFatal("Two <tt> elements at (" + this.line + "," + this.column + ")");
	
	                    }
	
	                    doc = new TT();
	
	                    doc.initFromNode(node, errorHandler);
	
	                    estack.unshift(doc);
	
	                } else if (node.local === 'head') {
	
	                    if (!(estack[0] instanceof TT)) {
	                        reportFatal("Parent of <head> element is not <tt> at (" + this.line + "," + this.column + ")");
	                    }
	
	                    if (doc.head !== null) {
	                        reportFatal("Second <head> element at (" + this.line + "," + this.column + ")");
	                    }
	
	                    doc.head = new Head();
	
	                    estack.unshift(doc.head);
	
	                } else if (node.local === 'styling') {
	
	                    if (!(estack[0] instanceof Head)) {
	                        reportFatal("Parent of <styling> element is not <head> at (" + this.line + "," + this.column + ")");
	                    }
	
	                    if (doc.head.styling !== null) {
	                        reportFatal("Second <styling> element at (" + this.line + "," + this.column + ")");
	                    }
	
	                    doc.head.styling = new Styling();
	
	                    estack.unshift(doc.head.styling);
	
	                } else if (node.local === 'style') {
	
	                    var s;
	
	                    if (estack[0] instanceof Styling) {
	
	                        s = new Style();
	
	                        s.initFromNode(node, errorHandler);
	
	                        /* ignore <style> element missing @id */
	
	                        if (!s.id) {
	
	                            reportError("<style> element missing @id attribute");
	
	                        } else {
	
	                            doc.head.styling.styles[s.id] = s;
	
	                        }
	
	                        estack.unshift(s);
	
	                    } else if (estack[0] instanceof Region) {
	
	                        /* nested styles can be merged with specified styles
	                         * immediately, with lower priority
	                         * (see 8.4.4.2(3) at TTML1 )
	                         */
	
	                        s = new Style();
	
	                        s.initFromNode(node, errorHandler);
	
	                        mergeStylesIfNotPresent(s.styleAttrs, estack[0].styleAttrs);
	
	                        estack.unshift(s);
	
	                    } else {
	
	                        reportFatal(errorHandler, "Parent of <style> element is not <styling> or <region> at (" + this.line + "," + this.column + ")");
	
	                    }
	
	                } else if (node.local === 'layout') {
	
	                    if (!(estack[0] instanceof Head)) {
	
	                        reportFatal(errorHandler, "Parent of <layout> element is not <head> at " + this.line + "," + this.column + ")");
	
	                    }
	
	                    if (doc.head.layout !== null) {
	
	                        reportFatal(errorHandler, "Second <layout> element at " + this.line + "," + this.column + ")");
	
	                    }
	
	                    doc.head.layout = new Layout();
	
	                    estack.unshift(doc.head.layout);
	
	                } else if (node.local === 'region') {
	
	                    if (!(estack[0] instanceof Layout)) {
	                        reportFatal(errorHandler, "Parent of <region> element is not <layout> at " + this.line + "," + this.column + ")");
	                    }
	
	                    var r = new Region();
	
	                    r.initFromNode(doc, node, errorHandler);
	
	                    if (!r.id || r.id in doc.head.layout.regions) {
	
	                        reportError(errorHandler, "Ignoring <region> with duplicate or missing @id at " + this.line + "," + this.column + ")");
	
	                    } else {
	
	                        doc.head.layout.regions[r.id] = r;
	
	                        doc._registerEvent(r);
	
	                    }
	
	                    estack.unshift(r);
	
	                } else if (node.local === 'body') {
	
	                    if (!(estack[0] instanceof TT)) {
	
	                        reportFatal(errorHandler, "Parent of <body> element is not <tt> at " + this.line + "," + this.column + ")");
	
	                    }
	
	                    if (doc.body !== null) {
	
	                        reportFatal(errorHandler, "Second <body> element at " + this.line + "," + this.column + ")");
	
	                    }
	
	                    var b = new Body();
	
	                    b.initFromNode(doc, node, errorHandler);
	
	                    doc._registerEvent(b);
	
	                    doc.body = b;
	
	                    estack.unshift(b);
	
	                } else if (node.local === 'div') {
	
	                    if (!(estack[0] instanceof Div || estack[0] instanceof Body)) {
	
	                        reportFatal(errorHandler, "Parent of <div> element is not <body> or <div> at " + this.line + "," + this.column + ")");
	
	                    }
	
	                    var d = new Div();
	
	                    d.initFromNode(doc, estack[0], node, errorHandler);
	
	                    doc._registerEvent(d);
	
	                    estack[0].contents.push(d);
	
	                    estack.unshift(d);
	
	                } else if (node.local === 'p') {
	
	                    if (!(estack[0] instanceof Div)) {
	
	                        reportFatal(errorHandler, "Parent of <p> element is not <div> at " + this.line + "," + this.column + ")");
	
	                    }
	
	                    var p = new P();
	
	                    p.initFromNode(doc, estack[0], node, errorHandler);
	
	                    doc._registerEvent(p);
	
	                    estack[0].contents.push(p);
	
	                    estack.unshift(p);
	
	                } else if (node.local === 'span') {
	
	                    if (!(estack[0] instanceof Span || estack[0] instanceof P)) {
	
	                        reportFatal(errorHandler, "Parent of <span> element is not <span> or <p> at " + this.line + "," + this.column + ")");
	
	                    }
	
	                    var ns = new Span();
	
	                    ns.initFromNode(doc, estack[0], node, xmlspacestack[0], errorHandler);
	
	                    doc._registerEvent(ns);
	
	                    estack[0].contents.push(ns);
	
	                    estack.unshift(ns);
	
	                } else if (node.local === 'br') {
	
	                    if (!(estack[0] instanceof Span || estack[0] instanceof P)) {
	
	                        reportFatal(errorHandler, "Parent of <br> element is not <span> or <p> at " + this.line + "," + this.column + ")");
	
	                    }
	
	                    var nb = new Br();
	
	                    nb.initFromNode(doc, estack[0], node, errorHandler);
	
	                    doc._registerEvent(nb);
	
	                    estack[0].contents.push(nb);
	
	                    estack.unshift(nb);
	
	                } else if (node.local === 'set') {
	
	                    if (!(estack[0] instanceof Span ||
	                        estack[0] instanceof P ||
	                        estack[0] instanceof Div ||
	                        estack[0] instanceof Body ||
	                        estack[0] instanceof Region ||
	                        estack[0] instanceof Br)) {
	
	                        reportFatal(errorHandler, "Parent of <set> element is not a content element or a region at " + this.line + "," + this.column + ")");
	
	                    }
	
	                    var st = new Set();
	
	                    st.initFromNode(doc, estack[0], node, errorHandler);
	
	                    doc._registerEvent(st);
	
	                    estack[0].sets.push(st);
	
	                    estack.unshift(st);
	
	                } else {
	
	                    /* element in the TT namespace, but not a content element */
	
	                    estack.unshift(new ForeignElement(node));
	                }
	
	            } else {
	
	                /* ignore elements not in the TTML namespace unless in metadata element */
	
	                estack.unshift(new ForeignElement(node));
	
	            }
	
	            /* handle metadata callbacks */
	
	            if (estack[0] instanceof ForeignElement) {
	
	                if (node.uri === imscNames.ns_tt &&
	                    node.local === 'metadata') {
	
	                    /* enter the metadata element */
	
	                    metadata_depth++;
	
	                } else if (
	                    metadata_depth > 0 &&
	                    metadataHandler &&
	                    'onOpenTag' in metadataHandler
	                    ) {
	
	                    /* start of child of metadata element */
	
	                    var attrs = [];
	
	                    for (var a in node.attributes) {
	                        attrs[node.attributes[a].uri + " " + node.attributes[a].local] =
	                            {
	                                uri: node.attributes[a].uri,
	                                local: node.attributes[a].local,
	                                value: node.attributes[a].value
	                            };
	                    }
	
	                    metadataHandler.onOpenTag(node.uri, node.local, attrs);
	
	                }
	
	            }
	
	        };
	
	        // parse the document
	
	        p.write(xmlstring).close();
	
	        // all referential styling has been flatten, so delete the styling elements if there is a head
	        // otherwise create an empty head
	
	        if (doc.head !== null) {
	            delete doc.head.styling;
	        } else {
	            doc.head = new Head();
	        }
	
	        // create default region if no regions specified
	
	        if (doc.head.layout === null) {
	
	            doc.head.layout = new Layout();
	
	        }
	
	        var hasRegions = false;
	
	        /* AFAIK the only way to determine whether an object has members */
	
	        for (var i in doc.head.layout.regions) {
	
	            hasRegions = true;
	
	            break;
	
	        }
	
	        if (!hasRegions) {
	
	            var dr = Region.createDefaultRegion();
	
	            doc.head.layout.regions[dr.id] = dr;
	
	        }
	
	        return doc;
	    };
	
	    function ForeignElement(node) {
	        this.node = node;
	    }
	
	    function TT() {
	        this.events = [];
	        this.head = null;
	        this.body = null;
	    }
	
	    TT.prototype.initFromNode = function (node, errorHandler) {
	
	        /* compute cell resolution */
	
	        this.cellResolution = extractCellResolution(node, errorHandler);
	
	        /* extract frame rate and tick rate */
	
	        var frtr = extractFrameAndTickRate(node, errorHandler);
	
	        this.effectiveFrameRate = frtr.effectiveFrameRate;
	
	        this.tickRate = frtr.tickRate;
	
	        /* extract aspect ratio */
	
	        this.aspectRatio = extractAspectRatio(node, errorHandler);
	
	        /* check timebase */
	
	        var attr = findAttribute(node, imscNames.ns_ttp, "timeBase");
	
	        if (attr !== null && attr !== "media") {
	
	            reportFatal(errorHandler, "Unsupported time base");
	
	        }
	
	        /* retrieve extent */
	
	        var e = extractExtent(node, errorHandler);
	
	        if (e === null) {
	
	            /* TODO: remove once unit tests are ready */
	
	            this.pxDimensions = {'h': 480, 'w': 640};
	
	        } else {
	
	            if (e.h.unit !== "px" || e.w.unit !== "px") {
	                reportFatal(errorHandler, "Extent on TT must be in px or absent");
	            }
	
	            this.pxDimensions = {'h': e.h.value, 'w': e.w.value};
	        }
	
	    };
	
	    /* register a temporal events */
	    TT.prototype._registerEvent = function (elem) {
	
	        /* skip if begin is not < then end */
	
	        if (elem.end <= elem.begin) return;
	
	        /* index the begin time of the event */
	
	        var b_i = indexOf(this.events, elem.begin);
	
	        if (!b_i.found) {
	            this.events.splice(b_i.index, 0, elem.begin);
	        }
	
	        /* index the end time of the event */
	
	        if (elem.end !== Number.POSITIVE_INFINITY) {
	
	            var e_i = indexOf(this.events, elem.end);
	
	            if (!e_i.found) {
	                this.events.splice(e_i.index, 0, elem.end);
	            }
	
	        }
	
	    };
	
	
	    /*
	     * Retrieves the range of ISD times covered by the document
	     * 
	     * @returns {Array} Array of two elements: min_begin_time and max_begin_time
	     * 
	     */
	    TT.prototype.getMediaTimeRange = function () {
	
	        return [this.events[0], this.events[this.events.length - 1]];
	    };
	
	    /*
	     * Returns list of ISD begin times  
	     * 
	     * @returns {Array}
	     */
	    TT.prototype.getMediaTimeEvents = function () {
	
	        return this.events;
	    };
	
	    /*
	     * Represents a TTML Head element
	     */
	
	    function Head() {
	        this.styling = null;
	        this.layout = null;
	    }
	
	    /*
	     * Represents a TTML Styling element
	     */
	
	    function Styling() {
	        this.styles = {};
	    }
	
	    /*
	     * Represents a TTML Style element
	     */
	
	    function Style() {
	        this.id = null;
	        this.styleAttrs = null;
	        this.styleRefs = null;
	    }
	
	    Style.prototype.initFromNode = function (node, errorHandler) {
	        this.id = elementGetXMLID(node);
	        this.styleAttrs = elementGetStyles(node, errorHandler);
	        this.styleRefs = elementGetStyleRefs(node);
	    };
	
	    /*
	     * Represents a TTML Layout element
	     * 
	     */
	
	    function Layout() {
	        this.regions = {};
	    }
	
	    /*
	     * Represents a TTML Content element
	     * 
	     */
	
	    function ContentElement(kind) {
	        this.kind = kind;
	        this.begin = null;
	        this.end = null;
	        this.styleAttrs = null;
	        this.regionID = null;
	        this.sets = null;
	        this.timeContainer = null;
	    }
	
	    ContentElement.prototype.initFromNode = function (doc, parent, node, errorHandler) {
	
	        var t = processTiming(doc, parent, node, errorHandler);
	        this.begin = t.begin;
	        this.end = t.end;
	
	        this.styleAttrs = elementGetStyles(node, errorHandler);
	
	        if (doc.head !== null && doc.head.styling !== null) {
	            mergeReferencedStyles(doc.head.styling, elementGetStyleRefs(node), this.styleAttrs, errorHandler);
	        }
	
	        this.regionID = elementGetRegionID(node);
	
	        this.sets = [];
	
	        this.timeContainer = elementGetTimeContainer(node, errorHandler);
	
	    };
	
	    /*
	     * Represents a TTML body element
	     */
	
	    function Body() {
	        ContentElement.call(this, 'body');
	    }
	
	    Body.prototype.initFromNode = function (doc, node, errorHandler) {
	        ContentElement.prototype.initFromNode.call(this, doc, null, node, errorHandler);
	        this.contents = [];
	    };
	
	    /*
	     * Represents a TTML div element
	     */
	
	    function Div() {
	        ContentElement.call(this, 'div');
	    }
	
	    Div.prototype.initFromNode = function (doc, parent, node, errorHandler) {
	        ContentElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
	        this.contents = [];
	    };
	
	    /*
	     * Represents a TTML p element
	     */
	
	    function P() {
	        ContentElement.call(this, 'p');
	    }
	
	    P.prototype.initFromNode = function (doc, parent, node, errorHandler) {
	        ContentElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
	        this.contents = [];
	    };
	
	    /*
	     * Represents a TTML span element
	     */
	
	    function Span() {
	        ContentElement.call(this, 'span');
	        this.space = null;
	    }
	
	    Span.prototype.initFromNode = function (doc, parent, node, xmlspace, errorHandler) {
	        ContentElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
	        this.space = xmlspace;
	        this.contents = [];
	    };
	    
	    /*
	     * Represents a TTML anonymous span element
	     */
	    
	    function AnonymousSpan() {
	        ContentElement.call(this, 'span');
	        this.space = null;
	        this.text = null;
	    }
	    
	    AnonymousSpan.prototype.initFromText = function (doc, parent, text, xmlspace, errorHandler) {
	        ContentElement.prototype.initFromNode.call(this, doc, parent, null, errorHandler);
	        this.text = text;
	        this.space = xmlspace;
	    };
	
	    /*
	     * Represents a TTML br element
	     */
	
	    function Br() {
	        ContentElement.call(this, 'br');
	    }
	
	    Br.prototype.initFromNode = function (doc, parent, node, errorHandler) {
	        ContentElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
	    };
	
	    /*
	     * Represents a TTML Region element
	     * 
	     */
	
	    function Region() {
	        this.id = null;
	        this.begin = null;
	        this.end = null;
	        this.styleAttrs = null;
	        this.sets = null;
	    }
	
	    Region.createDefaultRegion = function () {
	        var r = new Region();
	
	        r.id = '';
	        r.begin = 0;
	        r.end = Number.POSITIVE_INFINITY;
	        r.styleAttrs = {};
	        r.sets = [];
	
	        return r;
	    };
	
	    Region.prototype.initFromNode = function (doc, node, errorHandler) {
	
	        this.id = elementGetXMLID(node);
	
	        var t = processTiming(doc, null, node, errorHandler);
	        this.begin = t.begin;
	        this.end = t.end;
	
	        this.styleAttrs = elementGetStyles(node, errorHandler);
	
	        this.sets = [];
	
	        /* immediately merge referenced styles */
	
	        if (doc.head !== null && doc.head.styling !== null) {
	            mergeReferencedStyles(doc.head.styling, elementGetStyleRefs(node), this.styleAttrs, errorHandler);
	        }
	
	    };
	
	    /*
	     * Represents a TTML Set element
	     * 
	     */
	
	    function Set() {
	        this.begin = null;
	        this.end = null;
	        this.qname = null;
	        this.value = null;
	    }
	
	    Set.prototype.initFromNode = function (doc, parent, node, errorHandler) {
	
	        var t = processTiming(doc, parent, node, errorHandler);
	
	        this.begin = t.begin;
	        this.end = t.end;
	
	        var styles = elementGetStyles(node, errorHandler);
	
	        for (var qname in styles) {
	
	            if (this.qname) {
	
	                reportError(errorHandler, "More than one style specified on set");
	                break;
	
	            }
	
	            this.qname = qname;
	            this.value = styles[qname];
	
	        }
	
	    };
	
	    /*
	     * Utility functions
	     * 
	     */
	
	
	    function elementGetXMLID(node) {
	        return node && 'xml:id' in node.attributes ? node.attributes['xml:id'].value || null : null;
	    }
	
	    function elementGetRegionID(node) {
	        return node && 'region' in node.attributes ? node.attributes.region.value : '';
	    }
	
	    function elementGetTimeContainer(node, errorHandler) {
	
	        var tc = node && 'timeContainer' in node.attributes ? node.attributes.timeContainer.value : null;
	
	        if ((!tc) || tc === "par") {
	
	            return "par";
	
	        } else if (tc === "seq") {
	
	            return "seq";
	
	        } else {
	
	            reportError(errorHandler, "Illegal value of timeContainer (assuming 'par')");
	
	            return "par";
	
	        }
	
	    }
	
	    function elementGetStyleRefs(node) {
	
	        return node && 'style' in node.attributes ? node.attributes.style.value.split(" ") : [];
	
	    }
	
	    function elementGetStyles(node, errorHandler) {
	
	        var s = {};
	
	        if (node !== null) {
	
	            for (var i in node.attributes) {
	
	                var qname = node.attributes[i].uri + " " + node.attributes[i].local;
	
	                var sa = imscStyles.byQName[qname];
	
	                if (sa !== undefined) {
	
	                    var val = sa.parse(node.attributes[i].value);
	
	                    if (val !== null) {
	
	                        s[qname] = val;
	
	                        /* TODO: consider refactoring errorHandler into parse and compute routines */
	
	                        if (sa === imscStyles.byName.zIndex) {
	                            reportWarning(errorHandler, "zIndex attribute present but not used by IMSC1 since regions do not overlap");
	                        }
	
	                    } else {
	
	                        reportError(errorHandler, "Cannot parse styling attribute " + qname + " --> " + node.attributes[i].value);
	
	                    }
	
	                }
	
	            }
	
	        }
	
	        return s;
	    }
	
	    function findAttribute(node, ns, name) {
	        for (var i in node.attributes) {
	
	            if (node.attributes[i].uri === ns &&
	                node.attributes[i].local === name) {
	
	                return node.attributes[i].value;
	            }
	        }
	
	        return null;
	    }
	
	    function extractAspectRatio(node, errorHandler) {
	
	        var ar = findAttribute(node, imscNames.ns_ittp, "aspectRatio");
	
	        var rslt = null;
	
	        if (ar !== null) {
	
	            var ASPECT_RATIO_RE = /(\d+) (\d+)/;
	
	            var m = ASPECT_RATIO_RE.exec(ar);
	
	            if (m !== null) {
	
	                var w = parseInt(m[1]);
	
	                var h = parseInt(m[2]);
	
	                if (w !== 0 && h !== 0) {
	
	                    rslt = w / h;
	
	                } else {
	
	                    reportError(errorHandler, "Illegal aspectRatio values (ignoring)");
	                }
	
	            } else {
	
	                reportError(errorHandler, "Malformed aspectRatio attribute (ignoring)");
	            }
	
	        }
	
	        return rslt;
	
	    }
	
	    /*
	     * Returns the cellResolution attribute from a node
	     * 
	     */
	    function extractCellResolution(node, errorHandler) {
	
	        var cr = findAttribute(node, imscNames.ns_ttp, "cellResolution");
	
	        // initial value
	
	        var h = 15;
	        var w = 32;
	
	        if (cr !== null) {
	
	            var CELL_RESOLUTION_RE = /(\d+) (\d+)/;
	
	            var m = CELL_RESOLUTION_RE.exec(cr);
	
	            if (m !== null) {
	
	                w = parseInt(m[1]);
	
	                h = parseInt(m[2]);
	
	            } else {
	
	                reportWarning(errorHandler, "Malformed cellResolution value (using initial value instead)");
	
	            }
	
	        }
	
	        return {'w': w, 'h': h};
	
	    }
	
	
	    function extractFrameAndTickRate(node, errorHandler) {
	
	        // subFrameRate is ignored per IMSC1 specification
	
	        // extract frame rate
	
	        var fps_attr = findAttribute(node, imscNames.ns_ttp, "frameRate");
	
	        // initial value
	
	        var fps = 30;
	
	        // match variable
	
	        var m;
	
	        if (fps_attr !== null) {
	
	            var FRAME_RATE_RE = /(\d+)/;
	
	            m = FRAME_RATE_RE.exec(fps_attr);
	
	            if (m !== null) {
	
	                fps = parseInt(m[1]);
	
	            } else {
	
	                reportWarning(errorHandler, "Malformed frame rate attribute (using initial value instead)");
	            }
	
	        }
	
	        // extract frame rate multiplier
	
	        var frm_attr = findAttribute(node, imscNames.ns_ttp, "frameRateMultiplier");
	
	        // initial value
	
	        var frm = 1;
	
	        if (frm_attr !== null) {
	
	            var FRAME_RATE_MULT_RE = /(\d+) (\d+)/;
	
	            m = FRAME_RATE_MULT_RE.exec(frm_attr);
	
	            if (m !== null) {
	
	                frm = parseInt(m[1]) / parseInt(m[2]);
	
	            } else {
	
	                reportWarning(errorHandler, "Malformed frame rate multiplier attribute (using initial value instead)");
	            }
	
	        }
	
	        var efps = frm * fps;
	
	        // extract tick rate
	
	        var tr = 1;
	
	        var trattr = findAttribute(node, imscNames.ns_ttp, "tickRate");
	
	        if (trattr === null) {
	
	            if (fps_attr !== null) tr = efps;
	
	        } else {
	
	            var TICK_RATE_RE = /(\d+)/;
	
	            m = TICK_RATE_RE.exec(trattr);
	
	            if (m !== null) {
	
	                tr = parseInt(m[1]);
	
	            } else {
	
	                reportWarning(errorHandler, "Malformed tick rate attribute (using initial value instead)");
	            }
	
	        }
	
	        return {effectiveFrameRate: efps, tickRate: tr};
	
	    }
	
	    function extractExtent(node, errorHandler) {
	
	        var attr = findAttribute(node, imscNames.ns_tts, "extent");
	
	        if (attr === null) return null;
	
	        var s = attr.split(" ");
	
	        if (s.length !== 2) {
	
	            reportWarning(errorHandler, "Malformed extent (ignoring)");
	
	            return null;
	        }
	
	        var w = imscUtils.parseLength(s[0]);
	
	        var h = imscUtils.parseLength(s[1]);
	
	        if (!h || !w) {
	
	            reportWarning(errorHandler, "Malformed extent values (ignoring)");
	
	            return null;
	        }
	
	        return {'h': h, 'w': w};
	
	    }
	
	    function parseTimeExpression(tickRate, effectiveFrameRate, str) {
	
	        var CLOCK_TIME_FRACTION_RE = /^(\d{2,}):(\d\d):(\d\d(?:\.\d+)?)$/;
	        var CLOCK_TIME_FRAMES_RE = /^(\d{2,}):(\d\d):(\d\d)\:(\d{2,})$/;
	        var OFFSET_FRAME_RE = /^(\d+(?:\.\d+)?)f$/;
	        var OFFSET_TICK_RE = /^(\d+(?:\.\d+)?)t$/;
	        var OFFSET_MS_RE = /^(\d+(?:\.\d+)?)ms$/;
	        var OFFSET_S_RE = /^(\d+(?:\.\d+)?)s$/;
	        var OFFSET_H_RE = /^(\d+(?:\.\d+)?)h$/;
	        var OFFSET_M_RE = /^(\d+(?:\.\d+)?)m$/;
	        var m;
	        var r = null;
	        if ((m = OFFSET_FRAME_RE.exec(str)) !== null) {
	
	            if (effectiveFrameRate !== null) {
	
	                r = parseFloat(m[1]) / effectiveFrameRate;
	            }
	
	        } else if ((m = OFFSET_TICK_RE.exec(str)) !== null) {
	
	            if (tickRate !== null) {
	
	                r = parseFloat(m[1]) / tickRate;
	            }
	
	        } else if ((m = OFFSET_MS_RE.exec(str)) !== null) {
	
	            r = parseFloat(m[1]) / 1000.0;
	
	        } else if ((m = OFFSET_S_RE.exec(str)) !== null) {
	
	            r = parseFloat(m[1]);
	
	        } else if ((m = OFFSET_H_RE.exec(str)) !== null) {
	
	            r = parseFloat(m[1]) * 3600.0;
	
	        } else if ((m = OFFSET_M_RE.exec(str)) !== null) {
	
	            r = parseFloat(m[1]) * 60.0;
	
	        } else if ((m = CLOCK_TIME_FRACTION_RE.exec(str)) !== null) {
	
	            r = parseInt(m[1]) * 3600 +
	                parseInt(m[2]) * 60 +
	                parseFloat(m[3]);
	
	        } else if ((m = CLOCK_TIME_FRAMES_RE.exec(str)) !== null) {
	
	            /* this assumes that HH:MM:SS is a clock-time-with-fraction */
	
	            if (effectiveFrameRate !== null) {
	
	                r = parseInt(m[1]) * 3600 +
	                    parseInt(m[2]) * 60 +
	                    parseInt(m[3]) +
	                    (m[4] === null ? 0 : parseInt(m[4]) / effectiveFrameRate);
	            }
	
	        }
	
	        return r;
	    }
	
	    function processTiming(doc, parent, node, errorHandler) {
	
	        /* Q: what does this do <div b=1 e=3><p b=1 e=5> ?*/
	        /* Q: are children clipped by parent time interval? */
	
	        var isseq = parent && parent.timeContainer === "seq";
	
	        /* retrieve begin value */
	
	        var b = 0;
	
	        if (node && 'begin' in node.attributes) {
	
	            b = parseTimeExpression(doc.tickRate, doc.effectiveFrameRate, node.attributes.begin.value);
	
	            if (b === null) {
	
	                reportWarning(errorHandler, "Malformed begin value " + node.attributes.begin.value + " (using 0)");
	
	                b = 0;
	
	            }
	
	        }
	
	        /* retrieve dur value */
	
	        /* NOTE: end is not meaningful on seq container children and dur is equal to 0 if not specified */
	
	        var d = isseq ? 0 : null;
	
	        if (node && 'dur' in node.attributes) {
	
	            d = parseTimeExpression(doc.tickRate, doc.effectiveFrameRate, node.attributes.dur.value);
	
	            if (d === null) {
	
	                reportWarning(errorHandler, "Malformed dur value " + node.attributes.dur.value + " (ignoring)");
	
	            }
	
	        }
	
	        /* retrieve end value */
	
	        var e = null;
	
	        if (node && 'end' in node.attributes) {
	
	            e = parseTimeExpression(doc.tickRate, doc.effectiveFrameRate, node.attributes.end.value);
	
	            if (e === null) {
	
	                reportWarning(errorHandler, "Malformed end value (ignoring)");
	
	            }
	
	        }
	
	        /* compute starting offset */
	
	        var start_off = 0;
	
	        if (parent) {
	
	            if (isseq && 'contents' in parent && parent.contents.length > 0) {
	
	                /*
	                 * if seq time container, offset from the previous sibling end
	                 */
	
	                start_off = parent.contents[parent.contents.length - 1].end;
	
	
	            } else {
	
	                /* 
	                 * retrieve parent begin. Assume 0 if no parent.
	                 * 
	                 */
	
	                start_off = parent.begin || 0;
	
	            }
	
	        }
	
	        /* offset begin per time container semantics */
	
	        b += start_off;
	
	        /* set end */
	
	        if (d !== null) {
	
	            // use dur if specified
	
	            e = b + d;
	
	        } else {
	
	            /* retrieve parent end, or +infinity if none */
	
	            var parent_e = (parent && 'end' in parent) ? parent.end : Number.POSITIVE_INFINITY;
	
	            e = (e !== null) ? e + start_off : parent_e;
	
	        }
	
	        return {begin: b, end: e};
	
	    }
	
	
	
	    function mergeChainedStyles(styling, style, errorHandler) {
	
	        while (style.styleRefs.length > 0) {
	
	            var sref = style.styleRefs.pop();
	
	            if (!(sref in styling.styles)) {
	                reportError(errorHandler, "Non-existant style id referenced");
	                continue;
	            }
	
	            mergeChainedStyles(styling, styling.styles[sref], errorHandler);
	
	            mergeStylesIfNotPresent(styling.styles[sref].styleAttrs, style.styleAttrs);
	
	        }
	
	    }
	
	    function mergeReferencedStyles(styling, stylerefs, styleattrs, errorHandler) {
	
	        for (var i = stylerefs.length - 1; i >= 0; i--) {
	
	            var sref = stylerefs[i];
	
	            if (!(sref in styling.styles)) {
	                reportError(errorHandler, "Non-existant style id referenced");
	                continue;
	            }
	
	            mergeStylesIfNotPresent(styling.styles[sref].styleAttrs, styleattrs);
	
	        }
	
	    }
	
	    function mergeStylesIfNotPresent(from_styles, into_styles) {
	
	        for (var sname in from_styles) {
	
	            if (sname in into_styles)
	                continue;
	
	            into_styles[sname] = from_styles[sname];
	
	        }
	
	    }
	
	    /* TODO: validate style format at parsing */
	
	
	    /*
	     * ERROR HANDLING UTILITY FUNCTIONS
	     * 
	     */
	
	    function reportInfo(errorHandler, msg) {
	
	        if (errorHandler && errorHandler.info && errorHandler.info(msg))
	            throw msg;
	
	    }
	
	    function reportWarning(errorHandler, msg) {
	
	        if (errorHandler && errorHandler.warn && errorHandler.warn(msg))
	            throw msg;
	
	    }
	
	    function reportError(errorHandler, msg) {
	
	        if (errorHandler && errorHandler.error && errorHandler.error(msg))
	            throw msg;
	
	    }
	
	    function reportFatal(errorHandler, msg) {
	
	        if (errorHandler && errorHandler.fatal)
	            errorHandler.fatal(msg);
	
	        throw msg;
	
	    }
	
	    /*
	     * Binary search utility function
	     * 
	     * @typedef {Object} BinarySearchResult
	     * @property {boolean} found Was an exact match found?
	     * @property {number} index Position of the exact match or insert position
	     * 
	     * @returns {BinarySearchResult}
	     */
	
	    function indexOf(arr, searchval) {
	
	        var min = 0;
	        var max = arr.length - 1;
	        var cur;
	
	        while (min <= max) {
	
	            cur = Math.floor((min + max) / 2);
	
	            var curval = arr[cur];
	
	            if (curval < searchval) {
	
	                min = cur + 1;
	
	            } else if (curval > searchval) {
	
	                max = cur - 1;
	
	            } else {
	
	                return {found: true, index: cur};
	
	            }
	
	        }
	
	        return {found: false, index: min};
	    }
	
	
	})( false ? this.imscDoc = {} : exports,
	    typeof sax === 'undefined' ? __webpack_require__(608) : sax,
	    typeof imscNames === 'undefined' ? __webpack_require__(73) : imscNames,
	    typeof imscStyles === 'undefined' ? __webpack_require__(104) : imscStyles,
	    typeof imscUtils === 'undefined' ? __webpack_require__(166) : imscUtils);


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/* 
	 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *
	 * * Redistributions of source code must retain the above copyright notice, this
	 *   list of conditions and the following disclaimer.
	 * * Redistributions in binary form must reproduce the above copyright notice,
	 *   this list of conditions and the following disclaimer in the documentation
	 *   and/or other materials provided with the distribution.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
	 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
	 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
	 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 * POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/**
	 * @module imscHTML
	 */
	
	;
	(function (imscHTML, imscNames, imscStyles) {
	
	    /**
	     * Function that maps <pre>smpte:background</pre> URIs to URLs resolving to image resource
	     * @callback IMGResolver
	     * @param {string} <pre>smpte:background</pre> URI
	     * @return {string} PNG resource URL
	     */
	
	
	    /**
	     * Renders an ISD object (returned by <pre>generateISD()</pre>) into a 
	     * parent element, that must be attached to the DOM. The ISD will be rendered
	     * into a child <pre>div</pre>
	     * with heigh and width equal to the clientHeight and clientWidth of the element,
	     * unless explicitly specified otherwise by the caller. Images URIs specified 
	     * by <pre>smpte:background</pre> attributes are mapped to image resource URLs
	     * by an <pre>imgResolver</pre> function. The latter takes the value of <code>smpte:background</code>
	     * attribute and an <code>img</code> DOM element as input, and is expected to
	     * set the <code>src</code> attribute of the <code>img</code> to the absolute URI of the image.
	     * <pre>displayForcedOnlyMode</pre> sets the (boolean)
	     * value of the IMSC1 displayForcedOnlyMode parameter. The function returns
	     * an opaque object that should passed in <code>previousISDState</code> when this function
	     * is called for the next ISD, otherwise <code>previousISDState</code> should be set to 
	     * <code>null</code>.
	     * 
	     * @param {Object} isd ISD to be rendered
	     * @param {Object} element Element into which the ISD is rendered
	     * @param {?IMGResolver} imgResolver Resolve <pre>smpte:background</pre> URIs into URLs.
	     * @param {?number} eheight Height (in pixel) of the child <div>div</div> or null 
	     *                  to use clientHeight of the parent element
	     * @param {?number} ewidth Width (in pixel) of the child <div>div</div> or null
	     *                  to use clientWidth of the parent element
	     * @param {?boolean} displayForcedOnlyMode Value of the IMSC1 displayForcedOnlyMode parameter,
	     *                   or false if null         
	     * @param {?module:imscUtils.ErrorHandler} errorHandler Error callback
	     * @param {Object} previousISDState State saved during processing of the previous ISD, or null if initial call
	     * @param {?boolean} enableRollUp Enables roll-up animations (see CEA 708)
	     * @return {Object} ISD state to be provided when this funtion is called for the next ISD
	     */
	
	    imscHTML.render = function (    isd,
	                                    element,
	                                    imgResolver,
	                                    eheight,
	                                    ewidth,
	                                    displayForcedOnlyMode,
	                                    errorHandler,
	                                    previousISDState,
	                                    enableRollUp
	                                ) {
	
	        /* maintain aspect ratio if specified */
	
	        var height = eheight || element.clientHeight;
	        var width = ewidth || element.clientWidth;
	
	        if (isd.aspectRatio !== null) {
	
	            var twidth = height * isd.aspectRatio;
	
	            if (twidth > width) {
	
	                height = Math.round(width / isd.aspectRatio);
	
	            } else {
	
	                width = twidth;
	
	            }
	
	        }
	
	        var rootcontainer = document.createElement("div");
	
	        rootcontainer.style.position = "relative";
	        rootcontainer.style.width = width + "px";
	        rootcontainer.style.height = height + "px";
	        rootcontainer.style.margin = "auto";
	        rootcontainer.style.top = 0;
	        rootcontainer.style.bottom = 0;
	        rootcontainer.style.left = 0;
	        rootcontainer.style.right = 0;
	        rootcontainer.style.zIndex = 0;
	
	        var context = {
	            h: height,
	            w: width,
	            regionH: null,
	            regionW: null,
	            imgResolver: imgResolver,
	            displayForcedOnlyMode: displayForcedOnlyMode || false,
	            isd: isd,
	            errorHandler: errorHandler,
	            previousISDState: previousISDState,
	            enableRollUp : enableRollUp || false,
	            currentISDState: {}
	        };
	
	        element.appendChild(rootcontainer);
	
	        for (var i in isd.contents) {
	
	            processElement(context, rootcontainer, isd.contents[i]);
	
	        }
	
	        return context.currentISDState;
	
	    };
	
	    function processElement(context, dom_parent, isd_element) {
	
	        var e;
	
	        if (isd_element.kind === 'region') {
	
	            e = document.createElement("div");
	            e.style.position = "absolute";
	
	        } else if (isd_element.kind === 'body') {
	
	            e = document.createElement("div");
	
	        } else if (isd_element.kind === 'div') {
	
	            e = document.createElement("div");
	
	        } else if (isd_element.kind === 'p') {
	
	            e = document.createElement("p");
	
	        } else if (isd_element.kind === 'span') {
	
	            e = document.createElement("span");
	
	            //e.textContent = isd_element.text;
	
	        } else if (isd_element.kind === 'br') {
	
	            e = document.createElement("br");
	
	        }
	
	        if (!e) {
	
	            reportError(context.errorHandler, "Error processing ISD element kind: " + isd_element.kind);
	
	            return;
	
	        }
	
	        /* override UA default margin */
	
	        e.style.margin = "0";
	
	        /* tranform TTML styles to CSS styles */
	
	        for (var i in STYLING_MAP_DEFS) {
	
	            var sm = STYLING_MAP_DEFS[i];
	
	            var attr = isd_element.styleAttrs[sm.qname];
	
	            if (attr !== undefined && sm.map !== null) {
	
	                sm.map(context, e, isd_element, attr);
	
	            }
	
	        }
	
	        var proc_e = e;
	
	
	        // handle multiRowAlign and linePadding
	
	        var mra = isd_element.styleAttrs[imscStyles.byName.multiRowAlign.qname];
	
	        if (mra && mra !== "auto") {
	
	            var s = document.createElement("span");
	
	            s.style.display = "inline-block";
	
	            s.style.textAlign = mra;
	
	            e.appendChild(s);
	
	            proc_e = s;
	
	            context.mra = mra;
	
	        }
	
	        var lp = isd_element.styleAttrs[imscStyles.byName.linePadding.qname];
	
	        if (lp && lp > 0) {
	
	            context.lp = lp;
	
	        }
	
	        // wrap characters in spans to find the line wrap locations
	
	        if (isd_element.kind === "span" && isd_element.text) {
	
	            if (context.lp || context.mra) {
	
	                for (var j = 0; j < isd_element.text.length; j++) {
	
	                    var span = document.createElement("span");
	
	                    span.textContent = isd_element.text.charAt(j);
	
	                    e.appendChild(span);
	
	                }
	
	            } else {
	                e.textContent = isd_element.text;
	            }
	        }
	
	
	        dom_parent.appendChild(e);
	
	        for (var k in isd_element.contents) {
	
	            processElement(context, proc_e, isd_element.contents[k]);
	
	        }
	
	        // handle linePadding and multiRowAlign
	
	        if ((context.lp || context.mra) && isd_element.kind === "p") {
	
	            var elist = [];
	
	            constructElementList(proc_e, elist, "red");
	
	            /* TODO: linePadding only supported for horizontal scripts */
	
	            processLinePaddingAndMultiRowAlign(elist, context.lp * context.h);
	
	            /* TODO: clean-up the spans ? */
	
	            if (context.lp)
	                delete context.lp;
	            if (context.mra)
	                delete context.mra;
	
	        }
	
	        /* region processing */
	
	        if (isd_element.kind === "region") {
	
	            /* build line list */
	
	            var linelist = [];
	
	            constructLineList(proc_e, linelist);
	
	            /* perform roll up if needed */
	            
	            var wdir = isd_element.styleAttrs[imscStyles.byName.writingMode.qname];
	
	            if ((wdir === "lrtb" || wdir === "lr" || wdir === "rltb" || wdir === "rl") &&
	                context.enableRollUp && 
	                isd_element.contents.length > 0 &&
	                isd_element.styleAttrs[imscStyles.byName.displayAlign.qname] === 'after') {
	
	                /* horrible hack, perhaps default region id should be underscore everywhere? */
	
	                var rid = isd_element.id === '' ? '_' : isd_element.id;
	
	                var rb = new RegionPBuffer(rid, linelist);
	
	                context.currentISDState[rb.id] = rb;
	
	                if (context.previousISDState &&
	                    rb.id in context.previousISDState &&
	                    context.previousISDState[rb.id].plist.length > 0 &&
	                    rb.plist.length > 1 &&
	                    rb.plist[rb.plist.length - 2].text ===
	                    context.previousISDState[rb.id].plist[context.previousISDState[rb.id].plist.length - 1].text) {
	
	                    var body_elem = e.firstElementChild;
	
	                    body_elem.style.bottom = "-" + rb.plist[rb.plist.length - 1].height + "px";
	                    body_elem.style.transition = "transform 0.4s";
	                    body_elem.style.position = "relative";
	                    body_elem.style.transform = "translateY(-" + rb.plist[rb.plist.length - 1].height + "px)";
	
	                }
	
	            }
	
	        }
	    }
	
	
	    function RegionPBuffer(id, lineList) {
	
	        this.id = id;
	
	        this.plist = lineList;
	
	    }
	
	    function pruneEmptySpans(element) {
	
	        var child = element.firstChild;
	
	        while (child) {
	
	            var nchild = child.nextSibling;
	
	            if (child.nodeType === Node.ELEMENT_NODE &&
	                child.localName === 'span') {
	
	                pruneEmptySpans(child);
	
	                if (child.childElementCount === 0 &&
	                    child.textContent.length === 0) {
	
	                    element.removeChild(child);
	
	                }
	            }
	
	            child = nchild;
	        }
	
	    }
	
	    function constructElementList(element, elist, bgcolor) {
	
	        if (element.childElementCount === 0) {
	
	            elist.push({
	                "element": element,
	                "bgcolor": bgcolor}
	            );
	
	        } else {
	
	            var newbgcolor = element.style.backgroundColor || bgcolor;
	
	            var child = element.firstChild;
	
	            while (child) {
	
	                if (child.nodeType === Node.ELEMENT_NODE) {
	
	                    constructElementList(child, elist, newbgcolor);
	
	                }
	
	                child = child.nextSibling;
	            }
	        }
	
	    }
	
	
	    function constructLineList(element, llist) {
	
	        if (element.childElementCount === 0 && element.localName === 'span') {
	
	            var r = element.getBoundingClientRect();
	
	            if (llist.length === 0 ||
	                (!isSameLine(r.top, r.height, llist[llist.length - 1].top, llist[llist.length - 1].height))
	                ) {
	
	                llist.push({
	                    top: r.top,
	                    height: r.height,
	                    text: element.textContent
	                });
	
	            } else {
	
	                if (r.top < llist[llist.length - 1].top) {
	                    llist[llist.length - 1].top = r.top;
	                }
	
	                if (r.height > llist[llist.length - 1].height) {
	                    llist[llist.length - 1].height = r.height;
	                }
	
	                llist[llist.length - 1].text += element.textContent;
	
	            }
	
	        } else {
	
	
	            var child = element.firstChild;
	
	            while (child) {
	
	                if (child.nodeType === Node.ELEMENT_NODE) {
	
	                    constructLineList(child, llist);
	
	                }
	
	                child = child.nextSibling;
	            }
	        }
	
	    }
	    
	    function isSameLine(top1, height1, top2, height2) {
	
	        return (((top1 + height1) < (top2 + height2)) && (top1 > top2)) || (((top2 + height2) <= (top1 + height1)) && (top2 >= top1));
	
	    }
	
	    function processLinePaddingAndMultiRowAlign(elist, lp) {
	
	        var line_head = null;
	
	        var lookingForHead = true;
	
	        var foundBR = false;
	
	        for (var i = 0; i <= elist.length; i++) {
	
	            /* skip <br> since they apparently have a different box top than
	             * the rest of the line 
	             */
	
	            if (i !== elist.length && elist[i].element.localName === "br") {
	                foundBR = true;
	                continue;
	            }
	
	            /* detect new line */
	
	            if (line_head === null ||
	                i === elist.length ||
	                (!isSameLine(elist[i].element.getBoundingClientRect().top,
	                    elist[i].element.getBoundingClientRect().height,
	                    elist[line_head].element.getBoundingClientRect().top,
	                    elist[line_head].element.getBoundingClientRect().height))
	                ) {
	
	                /* apply right padding to previous line (if applicable and unless this is the first line) */
	
	                if (lp && (!lookingForHead)) {
	
	                    for (; --i >= 0; ) {
	
	                        if (elist[i].element.getBoundingClientRect().width !== 0) {
	
	                            addRightPadding(elist[i].element, elist[i].color, lp);
	
	                            if (elist[i].element.getBoundingClientRect().width !== 0 &&
	                                isSameLine(elist[i].element.getBoundingClientRect().top,
	                                    elist[i].element.getBoundingClientRect().height,
	                                    elist[line_head].element.getBoundingClientRect().top,
	                                    elist[line_head].element.getBoundingClientRect().height))
	                                break;
	
	                            removeRightPadding(elist[i].element);
	
	                        }
	
	                    }
	
	                    lookingForHead = true;
	
	                    continue;
	
	                }
	
	                /* explicit <br> unless already present */
	
	                if (i !== elist.length && line_head !== null && (!foundBR)) {
	
	                    var br = document.createElement("br");
	
	                    elist[i].element.parentElement.insertBefore(br, elist[i].element);
	
	                    elist.splice(i, 0, {"element": br});
	
	                    foundBR = true;
	
	                    continue;
	
	                }
	
	                /* apply left padding to current line (if applicable) */
	
	                if (i !== elist.length && lp) {
	
	                    /* find first non-zero */
	
	                    for (; i < elist.length; i++) {
	
	                        if (elist[i].element.getBoundingClientRect().width !== 0) {
	                            addLeftPadding(elist[i].element, elist[i].color, lp);
	                            break;
	                        }
	
	                    }
	
	                }
	
	                lookingForHead = false;
	
	                foundBR = false;
	
	                line_head = i;
	
	            }
	
	        }
	
	    }
	
	    function addLeftPadding(e, c, lp) {
	        e.style.paddingLeft = lp + "px";
	        e.style.backgroundColor = c;
	    }
	
	    function addRightPadding(e, c, lp) {
	        e.style.paddingRight = lp + "px";
	        e.style.backgroundColor = c;
	
	    }
	
	    function removeRightPadding(e) {
	        e.style.paddingRight = null;
	    }
	
	
	    function HTMLStylingMapDefintion(qName, mapFunc) {
	        this.qname = qName;
	        this.map = mapFunc;
	    }
	
	    var STYLING_MAP_DEFS = [
	
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling backgroundColor",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.backgroundColor = "rgba(" +
	                    attr[0].toString() + "," +
	                    attr[1].toString() + "," +
	                    attr[2].toString() + "," +
	                    (attr[3] / 255).toString() +
	                    ")";
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling color",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.color = "rgba(" +
	                    attr[0].toString() + "," +
	                    attr[1].toString() + "," +
	                    attr[2].toString() + "," +
	                    (attr[3] / 255).toString() +
	                    ")";
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling direction",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.direction = attr;
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling display",
	            function (context, dom_element, isd_element, attr) {}
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling displayAlign",
	            function (context, dom_element, isd_element, attr) {
	
	                /* see https://css-tricks.com/snippets/css/a-guide-to-flexbox/ */
	
	                /* TODO: is this affected by writing direction? */
	
	                dom_element.style.display = "flex";
	                dom_element.style.flexDirection = "column";
	
	
	                if (attr === "before") {
	
	                    dom_element.style.justifyContent = "flex-start";
	
	                } else if (attr === "center") {
	
	                    dom_element.style.justifyContent = "center";
	
	                } else if (attr === "after") {
	
	                    dom_element.style.justifyContent = "flex-end";
	                }
	
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling extent",
	            function (context, dom_element, isd_element, attr) {
	                /* TODO: this is super ugly */
	
	                context.regionH = (attr.h * context.h);
	                context.regionW = (attr.w * context.w);
	
	                /* 
	                 * CSS height/width are measured against the content rectangle,
	                 * whereas TTML height/width include padding
	                 */
	
	                var hdelta = 0;
	                var wdelta = 0;
	
	                var p = isd_element.styleAttrs["http://www.w3.org/ns/ttml#styling padding"];
	
	                if (!p) {
	
	                    /* error */
	
	                } else {
	
	                    hdelta = (p[0] + p[2]) * context.h;
	                    wdelta = (p[1] + p[3]) * context.w;
	
	                }
	
	                dom_element.style.height = (context.regionH - hdelta) + "px";
	                dom_element.style.width = (context.regionW - wdelta) + "px";
	
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling fontFamily",
	            function (context, dom_element, isd_element, attr) {
	
	                var rslt = [];
	
	                /* per IMSC1 */
	
	                for (var i in attr) {
	
	                    if (attr[i] === "monospaceSerif") {
	
	                        rslt.push("Courier New");
	                        rslt.push('"Liberation Mono"');
	                        rslt.push("Courier");
	                        rslt.push("monospace");
	
	                    } else if (attr[i] === "proportionalSansSerif") {
	
	                        rslt.push("Arial");
	                        rslt.push("Helvetica");
	                        rslt.push('"Liberation Sans"');
	                        rslt.push("sans-serif");
	
	                    } else if (attr[i] === "monospace") {
	
	                        rslt.push("monospace");
	
	                    } else if (attr[i] === "sansSerif") {
	
	                        rslt.push("sans-serif");
	
	                    } else if (attr[i] === "serif") {
	
	                        rslt.push("serif");
	
	                    } else if (attr[i] === "monospaceSansSerif") {
	
	                        rslt.push("Consolas");
	                        rslt.push("monospace");
	
	                    } else if (attr[i] === "proportionalSerif") {
	
	                        rslt.push("serif");
	
	                    } else {
	
	                        rslt.push(attr[i]);
	
	                    }
	
	                }
	
	                dom_element.style.fontFamily = rslt.join(",");
	            }
	        ),
	
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling fontSize",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.fontSize = (attr * context.h) + "px";
	            }
	        ),
	
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling fontStyle",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.fontStyle = attr;
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling fontWeight",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.fontWeight = attr;
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling lineHeight",
	            function (context, dom_element, isd_element, attr) {
	                if (attr === "normal") {
	
	                    dom_element.style.lineHeight = "normal";
	
	                } else {
	
	                    dom_element.style.lineHeight = (attr * context.h) + "px";
	                }
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling opacity",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.opacity = attr;
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling origin",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.top = (attr.h * context.h) + "px";
	                dom_element.style.left = (attr.w * context.w) + "px";
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling overflow",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.overflow = attr;
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling padding",
	            function (context, dom_element, isd_element, attr) {
	
	                /* attr: top,left,bottom,right*/
	
	                /* style: top right bottom left*/
	
	                var rslt = [];
	
	                rslt[0] = (attr[0] * context.h) + "px";
	                rslt[1] = (attr[3] * context.w) + "px";
	                rslt[2] = (attr[2] * context.h) + "px";
	                rslt[3] = (attr[1] * context.w) + "px";
	
	                dom_element.style.padding = rslt.join(" ");
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling showBackground",
	            null
	            ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling textAlign",
	            function (context, dom_element, isd_element, attr) {
	
	                var ta;
	                var dir = isd_element.styleAttrs[imscStyles.byName.direction.qname];
	
	                /* handle UAs that do not understand start or end */
	
	                if (attr === "start") {
	
	                    ta = (dir === "rtl") ? "right" : "left";
	
	                } else if (attr === "end") {
	
	                    ta = (dir === "rtl") ? "left" : "right";
	
	                } else {
	
	                    ta = attr;
	
	                }
	
	                dom_element.style.textAlign = ta;
	
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling textDecoration",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.textDecoration = attr.join(" ").replace("lineThrough", "line-through");
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling textOutline",
	            function (context, dom_element, isd_element, attr) {
	
	                if (attr === "none") {
	
	                    dom_element.style.textShadow = "";
	
	                } else {
	
	                    dom_element.style.textShadow = "rgba(" +
	                        attr.color[0].toString() + "," +
	                        attr.color[1].toString() + "," +
	                        attr.color[2].toString() + "," +
	                        (attr.color[3] / 255).toString() +
	                        ")" + " 0px 0px " +
	                        (attr.thickness * context.h) + "px";
	
	                }
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling unicodeBidi",
	            function (context, dom_element, isd_element, attr) {
	
	                var ub;
	
	                if (attr === 'bidiOverride') {
	                    ub = "bidi-override";
	                } else {
	                    ub = attr;
	                }
	
	                dom_element.style.unicodeBidi = ub;
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling visibility",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.visibility = attr;
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling wrapOption",
	            function (context, dom_element, isd_element, attr) {
	
	                if (attr === "wrap") {
	
	                    if (isd_element.space === "preserve") {
	                        dom_element.style.whiteSpace = "pre-wrap";
	                    } else {
	                        dom_element.style.whiteSpace = "normal";
	                    }
	
	                } else {
	
	                    if (isd_element.space === "preserve") {
	
	                        dom_element.style.whiteSpace = "pre";
	
	                    } else {
	                        dom_element.style.whiteSpace = "noWrap";
	                    }
	
	                }
	
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling writingMode",
	            function (context, dom_element, isd_element, attr) {
	                if (attr === "lrtb" || attr === "lr") {
	
	                    dom_element.style.writingMode = "horizontal-tb";
	
	                } else if (attr === "rltb" || attr === "rl") {
	
	                    dom_element.style.writingMode = "horizontal-tb";
	
	                } else if (attr === "tblr") {
	
	                    dom_element.style.writingMode = "vertical-lr";
	
	                } else if (attr === "tbrl" || attr === "tb") {
	
	                    dom_element.style.writingMode = "vertical-rl";
	
	                }
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml#styling zIndex",
	            function (context, dom_element, isd_element, attr) {
	                dom_element.style.zIndex = attr;
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt backgroundImage",
	            function (context, dom_element, isd_element, attr) {
	
	                if (context.imgResolver !== null && attr !== null) {
	
	                    var img = document.createElement("img");
	
	                    var uri = context.imgResolver(attr, img);
	
	                    if (uri) img.src = uri;
	
	                    img.height = context.regionH;
	                    img.width = context.regionW;
	
	                    dom_element.appendChild(img);
	                }
	            }
	        ),
	        new HTMLStylingMapDefintion(
	            "http://www.w3.org/ns/ttml/profile/imsc1#styling forcedDisplay",
	            function (context, dom_element, isd_element, attr) {
	
	                if (context.displayForcedOnlyMode && attr === false) {
	                    dom_element.style.visibility = "hidden";
	                }
	
	            }
	        )
	    ];
	
	    var STYLMAP_BY_QNAME = {};
	
	    for (var i in STYLING_MAP_DEFS) {
	
	        STYLMAP_BY_QNAME[STYLING_MAP_DEFS[i].qname] = STYLING_MAP_DEFS[i];
	    }
	
	    function reportError(errorHandler, msg) {
	
	        if (errorHandler && errorHandler.error && errorHandler.error(msg))
	            throw msg;
	
	    }
	
	})( false ? this.imscHTML = {} : exports,
	    typeof imscNames === 'undefined' ? __webpack_require__(73) : imscNames,
	    typeof imscStyles === 'undefined' ? __webpack_require__(104) : imscStyles);

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	/* 
	 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *
	 * * Redistributions of source code must retain the above copyright notice, this
	 *   list of conditions and the following disclaimer.
	 * * Redistributions in binary form must reproduce the above copyright notice,
	 *   this list of conditions and the following disclaimer in the documentation
	 *   and/or other materials provided with the distribution.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
	 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
	 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
	 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
	 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
	 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 * POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/**
	 * @module imscISD
	 */
	
	
	;
	(function (imscISD, imscNames, imscStyles) { // wrapper for non-node envs
	
	    /** 
	     * Creates a canonical representation of an IMSC1 document returned by <pre>imscDoc.fromXML()</pre>
	     * at a given absolute offset in seconds. This offset does not have to be one of the values returned
	     * by <pre>getMediaTimeEvents()</pre>.
	     * 
	     * @param {Object} tt IMSC1 document
	     * @param {number} offset Absolute offset (in seconds)
	     * @param {?module:imscUtils.ErrorHandler} errorHandler Error callback
	     * @returns {Object} Opaque in-memory representation of an ISD
	     */
	
	    imscISD.generateISD = function (tt, offset, errorHandler) {
	
	        /* TODO check for tt and offset validity */
	
	        /* create the ISD object from the IMSC1 doc */
	
	        var isd = new ISD(tt);
	
	        /* process regions */
	
	        for (var r in tt.head.layout.regions) {
	
	            /* post-order traversal of the body tree per [construct intermediate document] */
	
	            var c = isdProcessContentElement(tt, offset, tt.head.layout.regions[r], tt.body, null, '', tt.head.layout.regions[r], errorHandler);
	
	            if (c !== null) {
	
	                /* add the region to the ISD */
	
	                isd.contents.push(c.element);
	            }
	
	
	        }
	
	        return isd;
	    };
	
	    function isdProcessContentElement(doc, offset, region, body, parent, inherited_region_id, elem, errorHandler) {
	
	        /* prune if temporally inactive */
	
	        if (offset < elem.begin || offset >= elem.end) return null;
	
	        /* 
	         * set the associated region as specified by the regionID attribute, or the 
	         * inherited associated region otherwise
	         */
	
	        var associated_region_id = 'regionID' in elem && elem.regionID !== '' ? elem.regionID : inherited_region_id;
	
	        /* prune the element if either:
	         * - the element is not terminal and the associated region is neither the default
	         *   region nor the parent region (this allows children to be associated with a 
	         *   region later on)
	         * - the element is terminal and the associated region is not the parent region
	         */
	        
	        /* TODO: improve detection of terminal elements since <region> has no contents */
	
	        if (parent !== null /* are we in the region element */ &&
	            associated_region_id !== region.id &&
	                (
	                    (! ('contents' in elem)) ||
	                    ('contents' in elem && elem.contents.length === 0) ||
	                    associated_region_id !== ''
	                )
	             )
	            return null;
	
	        /* create an ISD element, including applying specified styles */
	
	        var isd_element = new ISDContentElement(elem);
	
	        /* apply set (animation) styling */
	
	        for (var i in elem.sets) {
	
	            if (offset < elem.sets[i].begin || offset >= elem.sets[i].end)
	                continue;
	
	            isd_element.styleAttrs[elem.sets[i].qname] = elem.sets[i].value;
	
	        }
	
	        /* 
	         * keep track of specified styling attributes so that we
	         * can compute them later
	         */
	
	        var spec_attr = {};
	
	        for (var qname in isd_element.styleAttrs) {
	
	            spec_attr[qname] = true;
	
	            /* special rule for tts:writingMode (section 7.29.1 of XSL)
	             * direction is set consistently with writingMode only
	             * if writingMode sets inline-direction to LTR or RTL  
	             */
	
	            if (qname === imscStyles.byName.writingMode.qname &&
	                !(imscStyles.byName.direction.qname in isd_element.styleAttrs)) {
	
	                var wm = isd_element.styleAttrs[qname];
	
	                if (wm === "lrtb" || wm === "lr") {
	
	                    isd_element.styleAttrs[imscStyles.byName.direction.qname] = "ltr";
	
	                } else if (wm === "rltb" || wm === "rl") {
	
	                    isd_element.styleAttrs[imscStyles.byName.direction.qname] = "rtl";
	
	                }
	
	            }
	        }
	
	        /* inherited styling */
	
	        if (parent !== null) {
	
	            for (var j in imscStyles.all) {
	
	                var sa = imscStyles.all[j];
	
	                /* textDecoration has special inheritance rules */
	
	                if (sa.qname === imscStyles.byName.textDecoration.qname) {
	
	                    /* handle both textDecoration inheritance and specification */
	
	                    var ps = parent.styleAttrs[sa.qname];
	                    var es = isd_element.styleAttrs[sa.qname];
	                    var outs = [];
	
	                    if (es === undefined) {
	
	                        outs = ps;
	
	                    } else if (es.indexOf("none") === -1) {
	
	                        if ((es.indexOf("noUnderline") === -1 &&
	                            ps.indexOf("underline") !== -1) ||
	                            es.indexOf("underline") !== -1) {
	
	                            outs.push("underline");
	
	                        }
	
	                        if ((es.indexOf("noLineThrough") === -1 &&
	                            ps.indexOf("lineThrough") !== -1) ||
	                            es.indexOf("lineThrough") !== -1) {
	
	                            outs.push("lineThrough");
	
	                        }
	
	                        if ((es.indexOf("noOverline") === -1 &&
	                            ps.indexOf("overline") !== -1) ||
	                            es.indexOf("overline") !== -1) {
	
	                            outs.push("overline");
	
	                        }
	
	                    } else {
	
	                        outs.push("none");
	
	                    }
	
	                    isd_element.styleAttrs[sa.qname] = outs;
	
	                } else if (sa.inherit &&
	                    (sa.qname in parent.styleAttrs) &&
	                    !(sa.qname in isd_element.styleAttrs)) {
	
	                    isd_element.styleAttrs[sa.qname] = parent.styleAttrs[sa.qname];
	
	                }
	
	            }
	
	        }
	
	        /* initial value styling */
	
	        for (var k in imscStyles.all) {
	
	            var ivs = imscStyles.all[k];
	
	            /* skip if value is already specified */
	
	            if (ivs.qname in isd_element.styleAttrs) continue;
	
	            /* apply initial value to elements other than region only if non-inherited */
	
	            if (isd_element.kind === 'region' || (ivs.inherit === false && ivs.initial !== null)) {
	
	                isd_element.styleAttrs[ivs.qname] = ivs.parse(ivs.initial);
	
	                /* keep track of the style as specified */
	
	                spec_attr[ivs.qname] = true;
	
	            }
	
	        }
	
	        /* compute styles (only for non-inherited styles) */
	        /* TODO: get rid of spec_attr */
	
	        for (var z in imscStyles.all) {
	
	            var cs = imscStyles.all[z];
	
	            if (!(cs.qname in spec_attr)) continue;
	
	            if (cs.compute !== null) {
	
	                var cstyle = cs.compute(
	                    /*doc, parent, element, attr*/
	                    doc,
	                    parent,
	                    isd_element,
	                    isd_element.styleAttrs[cs.qname]
	                    );
	
	                if (cstyle !== null) {
	                    isd_element.styleAttrs[cs.qname] = cstyle;
	                } else {
	                    reportError(errorHandler, "Style '" + cs.qname + "' on element '" + isd_element.kind + "' cannot be computed");
	                }
	            }
	
	        }
	
	        /* prune if tts:display is none */
	
	        if (isd_element.styleAttrs[imscStyles.byName.display.qname] === "none")
	            return null;
	
	        /* process contents of the element */
	
	        var contents;
	
	        if (parent === null) {
	
	            /* we are processing the region */
	
	            if (body === null) {
	
	                /* if there is no body, still process the region but with empty content */
	
	                contents = [];
	
	            } else {
	
	                /*use the body element as contents */
	
	                contents = [body];
	
	            }
	
	        } else if ('contents' in elem) {
	
	            contents = elem.contents;
	
	        }
	
	        for (var x in contents) {
	
	            var c = isdProcessContentElement(doc, offset, region, body, isd_element, associated_region_id, contents[x]);
	
	            /* 
	             * keep child element only if they are non-null and their region match 
	             * the region of this element
	             */
	
	            if (c !== null) {
	
	                isd_element.contents.push(c.element);
	
	            }
	
	        }
	
	        /* compute used value of lineHeight="normal" */
	
	        /*        if (isd_element.styleAttrs[imscStyles.byName.lineHeight.qname] === "normal"  ) {
	         
	         isd_element.styleAttrs[imscStyles.byName.lineHeight.qname] =
	         isd_element.styleAttrs[imscStyles.byName.fontSize.qname] * 1.2;
	         
	         }
	         */
	
	        /* remove styles that are not applicable */
	
	        for (var qnameb in isd_element.styleAttrs) {
	            var da = imscStyles.byQName[qnameb];
	
	            if (da.applies.indexOf(isd_element.kind) === -1) {
	                delete isd_element.styleAttrs[qnameb];
	            }
	        }
	
	        /* collapse white space if space is "default" */
	
	        if (isd_element.kind === 'span' && isd_element.text && isd_element.space === "default") {
	
	            var trimmedspan = isd_element.text.replace(/\s+/g, ' ');
	
	            isd_element.text = trimmedspan;
	
	        }
	
	        /* trim whitespace around explicit line breaks */
	
	        if (isd_element.kind === 'p') {
	
	            var elist = [];
	
	            constructSpanList(isd_element, elist);
	
	            var l = 0;
	
	            var state = "after_br";
	            var br_pos = 0;
	
	            while (true) {
	
	                if (state === "after_br") {
	
	                    if (l >= elist.length || elist[l].kind === "br") {
	
	                        state = "before_br";
	                        br_pos = l;
	                        l--;
	
	                    } else {
	
	                        if (elist[l].space !== "preserve") {
	
	                            elist[l].text = elist[l].text.replace(/^\s+/g, '');
	
	                        }
	
	                        if (elist[l].text.length > 0) {
	
	                            state = "looking_br";
	                            l++;
	
	                        } else {
	
	                            elist.splice(l, 1);
	
	                        }
	
	                    }
	
	                } else if (state === "before_br") {
	
	                    if (l < 0 || elist[l].kind === "br") {
	
	                        state = "after_br";
	                        l = br_pos + 1;
	
	                        if (l >= elist.length) break;
	
	                    } else {
	
	                        if (elist[l].space !== "preserve") {
	
	                            elist[l].text = elist[l].text.replace(/\s+$/g, '');
	
	                        }
	
	                        if (elist[l].text.length > 0) {
	
	                            state = "after_br";
	                            l = br_pos + 1;
	
	                            if (l >= elist.length) break;
	
	                        } else {
	
	                            elist.splice(l, 1);
	                            l--;
	
	                        }
	
	                    }
	
	                } else {
	
	                    if (l >= elist.length || elist[l].kind === "br") {
	
	                        state = "before_br";
	                        br_pos = l;
	                        l--;
	
	                    } else {
	
	                        l++;
	
	                    }
	
	                }
	
	            }
	            
	            pruneEmptySpans(isd_element);
	
	        }
	
	        /* keep element if:
	         * * contains a background image
	         * * <br/>
	         * * if there are children
	         * * if <span> and has text
	         * * if region and showBackground = always
	         */
	
	        if ((isd_element.kind === 'div' && imscStyles.byName.backgroundImage.qname in isd_element.styleAttrs) ||
	            isd_element.kind === 'br' ||
	            ('contents' in isd_element && isd_element.contents.length > 0) ||
	            (isd_element.kind === 'span' && isd_element.text !== null) ||
	            (isd_element.kind === 'region' &&
	                isd_element.styleAttrs[imscStyles.byName.showBackground.qname] === 'always')) {
	
	            return {
	                region_id: associated_region_id,
	                element: isd_element
	            };
	        }
	
	        return null;
	    }
	
	    function constructSpanList(element, elist) {
	
	        if ('contents' in element) {
	
	            for (var i in element.contents) {
	                constructSpanList(element.contents[i], elist);
	            }
	
	        } else {
	
	            elist.push(element);
	
	        }
	
	    }
	
	    function pruneEmptySpans(element) {
	
	        if (element.kind === 'br') {
	            
	            return false;
	            
	        } else if ('text' in element) {
	            
	            return  element.text.length === 0;
	            
	        } else if ('contents' in element) {
	            
	            var i = element.contents.length;
	
	            while (i--) {
	                
	                if (pruneEmptySpans(element.contents[i])) {
	                    element.contents.splice(i, 1);
	                }
	                
	            }
	            
	            return element.contents.length === 0;
	
	        }
	    }
	
	    function ISD(tt) {
	        this.contents = [];
	        this.aspectRatio = tt.aspectRatio;
	    }
	
	    function ISDContentElement(ttelem) {
	
	        /* assume the element is a region if it does not have a kind */
	
	        this.kind = ttelem.kind || 'region';
	        
	        /* copy id */
	        
	        if (ttelem.id) {
	            this.id = ttelem.id;
	        }
	
	        /* deep copy of style attributes */
	        this.styleAttrs = {};
	
	        for (var sname in ttelem.styleAttrs) {
	
	            this.styleAttrs[sname] =
	                ttelem.styleAttrs[sname];
	        }
	
	        /* TODO: clean this! */
	
	        if ('text' in ttelem) {
	
	            this.text = ttelem.text;
	
	        } else if (ttelem.kind !== 'br') {
	            
	            this.contents = [];
	        }
	
	        if ('space' in ttelem) {
	
	            this.space = ttelem.space;
	        }
	    }
	
	
	    /*
	     * ERROR HANDLING UTILITY FUNCTIONS
	     * 
	     */
	
	    function reportInfo(errorHandler, msg) {
	
	        if (errorHandler && errorHandler.info && errorHandler.info(msg))
	            throw msg;
	
	    }
	
	    function reportWarning(errorHandler, msg) {
	
	        if (errorHandler && errorHandler.warn && errorHandler.warn(msg))
	            throw msg;
	
	    }
	
	    function reportError(errorHandler, msg) {
	
	        if (errorHandler && errorHandler.error && errorHandler.error(msg))
	            throw msg;
	
	    }
	
	    function reportFatal(errorHandler, msg) {
	
	        if (errorHandler && errorHandler.fatal)
	            errorHandler.fatal(msg);
	
	        throw msg;
	
	    }
	
	
	})( false ? this.imscISD = {} : exports,
	    typeof imscNames === 'undefined' ? __webpack_require__(73) : imscNames,
	    typeof imscStyles === 'undefined' ? __webpack_require__(104) : imscStyles
	    );


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(613);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(168),
	    getRawTag = __webpack_require__(477),
	    objectToString = __webpack_require__(478);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 475 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(479);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(168);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 478 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 479 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(475);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 481 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(169);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(169);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(21);
	var invariant = __webpack_require__(3);
	var ReactPropTypesSecret = __webpack_require__(171);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(21);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(9);
	var assign = __webpack_require__(7);
	
	var ReactPropTypesSecret = __webpack_require__(171);
	var checkPropTypes = __webpack_require__(484);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(612);
	var objectAssign = __webpack_require__(7);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 488 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(11);
	
	var focusNode = __webpack_require__(159);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(57);
	var ExecutionEnvironment = __webpack_require__(18);
	var FallbackCompositionState = __webpack_require__(496);
	var SyntheticCompositionEvent = __webpack_require__(533);
	var SyntheticInputEvent = __webpack_require__(536);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(172);
	var ExecutionEnvironment = __webpack_require__(18);
	var ReactInstrumentation = __webpack_require__(23);
	
	var camelizeStyleName = __webpack_require__(449);
	var dangerousStyleValue = __webpack_require__(542);
	var hyphenateStyleName = __webpack_require__(456);
	var memoizeStringOnly = __webpack_require__(459);
	var warning = __webpack_require__(9);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(56);
	var EventPropagators = __webpack_require__(57);
	var ExecutionEnvironment = __webpack_require__(18);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(26);
	var SyntheticEvent = __webpack_require__(28);
	
	var inputValueTracking = __webpack_require__(188);
	var getEventTarget = __webpack_require__(118);
	var isEventSupported = __webpack_require__(119);
	var isTextInputElement = __webpack_require__(190);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var DOMLazyTree = __webpack_require__(46);
	var ExecutionEnvironment = __webpack_require__(18);
	
	var createNodesFromMarkup = __webpack_require__(452);
	var emptyFunction = __webpack_require__(21);
	var invariant = __webpack_require__(3);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 494 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(11);
	var SyntheticMouseEvent = __webpack_require__(77);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(38);
	
	var getTextContentAccessor = __webpack_require__(187);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(47);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(48);
	
	var instantiateReactComponent = __webpack_require__(189);
	var KeyEscapeUtils = __webpack_require__(110);
	var shouldUpdateReactComponent = __webpack_require__(120);
	var traverseAllChildren = __webpack_require__(192);
	var warning = __webpack_require__(9);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(210);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(106);
	var ReactDOMIDOperations = __webpack_require__(506);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10),
	    _assign = __webpack_require__(7);
	
	var React = __webpack_require__(51);
	var ReactComponentEnvironment = __webpack_require__(112);
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactErrorUtils = __webpack_require__(113);
	var ReactInstanceMap = __webpack_require__(58);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactNodeTypes = __webpack_require__(182);
	var ReactReconciler = __webpack_require__(48);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(70);
	var invariant = __webpack_require__(3);
	var shallowEqual = __webpack_require__(99);
	var shouldUpdateReactComponent = __webpack_require__(120);
	var warning = __webpack_require__(9);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDefaultInjection = __webpack_require__(514);
	var ReactMount = __webpack_require__(181);
	var ReactReconciler = __webpack_require__(48);
	var ReactUpdates = __webpack_require__(26);
	var ReactVersion = __webpack_require__(527);
	
	var findDOMNode = __webpack_require__(543);
	var getHostComponentFromComposite = __webpack_require__(186);
	var renderSubtreeIntoContainer = __webpack_require__(550);
	var warning = __webpack_require__(9);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10),
	    _assign = __webpack_require__(7);
	
	var AutoFocusUtils = __webpack_require__(489);
	var CSSPropertyOperations = __webpack_require__(491);
	var DOMLazyTree = __webpack_require__(46);
	var DOMNamespaces = __webpack_require__(107);
	var DOMProperty = __webpack_require__(47);
	var DOMPropertyOperations = __webpack_require__(174);
	var EventPluginHub = __webpack_require__(56);
	var EventPluginRegistry = __webpack_require__(108);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactDOMComponentFlags = __webpack_require__(175);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMInput = __webpack_require__(507);
	var ReactDOMOption = __webpack_require__(508);
	var ReactDOMSelect = __webpack_require__(176);
	var ReactDOMTextarea = __webpack_require__(511);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactMultiChild = __webpack_require__(520);
	var ReactServerRenderingTransaction = __webpack_require__(525);
	
	var emptyFunction = __webpack_require__(21);
	var escapeTextContentForBrowser = __webpack_require__(79);
	var invariant = __webpack_require__(3);
	var isEventSupported = __webpack_require__(119);
	var shallowEqual = __webpack_require__(99);
	var inputValueTracking = __webpack_require__(188);
	var validateDOMNesting = __webpack_require__(121);
	var warning = __webpack_require__(9);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(121);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var DOMLazyTree = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(11);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 505 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(106);
	var ReactDOMComponentTree = __webpack_require__(11);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10),
	    _assign = __webpack_require__(7);
	
	var DOMPropertyOperations = __webpack_require__(174);
	var LinkedValueUtils = __webpack_require__(111);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(26);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(9);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var React = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMSelect = __webpack_require__(176);
	
	var warning = __webpack_require__(9);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	var getNodeForCharacterOffset = __webpack_require__(547);
	var getTextContentAccessor = __webpack_require__(187);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10),
	    _assign = __webpack_require__(7);
	
	var DOMChildrenOperations = __webpack_require__(106);
	var DOMLazyTree = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(11);
	
	var escapeTextContentForBrowser = __webpack_require__(79);
	var invariant = __webpack_require__(3);
	var validateDOMNesting = __webpack_require__(121);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10),
	    _assign = __webpack_require__(7);
	
	var LinkedValueUtils = __webpack_require__(111);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(26);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(9);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactUpdates = __webpack_require__(26);
	var Transaction = __webpack_require__(78);
	
	var emptyFunction = __webpack_require__(21);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(488);
	var BeforeInputEventPlugin = __webpack_require__(490);
	var ChangeEventPlugin = __webpack_require__(492);
	var DefaultEventPluginOrder = __webpack_require__(494);
	var EnterLeaveEventPlugin = __webpack_require__(495);
	var HTMLDOMPropertyConfig = __webpack_require__(497);
	var ReactComponentBrowserEnvironment = __webpack_require__(499);
	var ReactDOMComponent = __webpack_require__(502);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMEmptyComponent = __webpack_require__(504);
	var ReactDOMTreeTraversal = __webpack_require__(512);
	var ReactDOMTextComponent = __webpack_require__(510);
	var ReactDefaultBatchingStrategy = __webpack_require__(513);
	var ReactEventListener = __webpack_require__(517);
	var ReactInjection = __webpack_require__(518);
	var ReactReconcileTransaction = __webpack_require__(523);
	var SVGDOMPropertyConfig = __webpack_require__(528);
	var SelectEventPlugin = __webpack_require__(529);
	var SimpleEventPlugin = __webpack_require__(530);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 515 */
211,
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(56);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventListener = __webpack_require__(158);
	var ExecutionEnvironment = __webpack_require__(18);
	var PooledClass = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(26);
	
	var getEventTarget = __webpack_require__(118);
	var getUnboundedScrollPosition = __webpack_require__(454);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(47);
	var EventPluginHub = __webpack_require__(56);
	var EventPluginUtils = __webpack_require__(109);
	var ReactComponentEnvironment = __webpack_require__(112);
	var ReactEmptyComponent = __webpack_require__(177);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactHostComponent = __webpack_require__(179);
	var ReactUpdates = __webpack_require__(26);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(541);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var ReactComponentEnvironment = __webpack_require__(112);
	var ReactInstanceMap = __webpack_require__(58);
	var ReactInstrumentation = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactReconciler = __webpack_require__(48);
	var ReactChildReconciler = __webpack_require__(498);
	
	var emptyFunction = __webpack_require__(21);
	var flattenChildren = __webpack_require__(544);
	var invariant = __webpack_require__(3);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 522 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(173);
	var PooledClass = __webpack_require__(38);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactInputSelection = __webpack_require__(180);
	var ReactInstrumentation = __webpack_require__(23);
	var Transaction = __webpack_require__(78);
	var ReactUpdateQueue = __webpack_require__(114);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(521);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(38);
	var Transaction = __webpack_require__(78);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactServerUpdateQueue = __webpack_require__(526);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(114);
	
	var warning = __webpack_require__(9);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 527 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 528 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(57);
	var ExecutionEnvironment = __webpack_require__(18);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInputSelection = __webpack_require__(180);
	var SyntheticEvent = __webpack_require__(28);
	
	var getActiveElement = __webpack_require__(160);
	var isTextInputElement = __webpack_require__(190);
	var shallowEqual = __webpack_require__(99);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var EventListener = __webpack_require__(158);
	var EventPropagators = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(11);
	var SyntheticAnimationEvent = __webpack_require__(531);
	var SyntheticClipboardEvent = __webpack_require__(532);
	var SyntheticEvent = __webpack_require__(28);
	var SyntheticFocusEvent = __webpack_require__(535);
	var SyntheticKeyboardEvent = __webpack_require__(537);
	var SyntheticMouseEvent = __webpack_require__(77);
	var SyntheticDragEvent = __webpack_require__(534);
	var SyntheticTouchEvent = __webpack_require__(538);
	var SyntheticTransitionEvent = __webpack_require__(539);
	var SyntheticUIEvent = __webpack_require__(59);
	var SyntheticWheelEvent = __webpack_require__(540);
	
	var emptyFunction = __webpack_require__(21);
	var getEventCharCode = __webpack_require__(116);
	var invariant = __webpack_require__(3);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(77);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(59);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(59);
	
	var getEventCharCode = __webpack_require__(116);
	var getEventKey = __webpack_require__(545);
	var getEventModifierState = __webpack_require__(117);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(59);
	
	var getEventModifierState = __webpack_require__(117);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(77);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 541 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(172);
	var warning = __webpack_require__(9);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInstanceMap = __webpack_require__(58);
	
	var getHostComponentFromComposite = __webpack_require__(186);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(9);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(110);
	var traverseAllChildren = __webpack_require__(192);
	var warning = __webpack_require__(9);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(210);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(116);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 546 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 547 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(79);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(181);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(578);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(439);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(552);
	
	var _HelmetConstants = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(196);
	
	var _warning = __webpack_require__(122);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(194);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(561);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(555);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(556);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(557);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(558);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(130);
	
	var _wrapMapToProps = __webpack_require__(195);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(195);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(197);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(559);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(122);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 560 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 561 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(198);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(13);
	
	var _routerWarning = __webpack_require__(50);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(200);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(13);
	
	var _routerWarning = __webpack_require__(50);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(33);
	
	var _InternalPropTypes = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(13);
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(33);
	
	var _InternalPropTypes = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(13);
	
	var _createTransitionManager2 = __webpack_require__(204);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(60);
	
	var _RouterContext = __webpack_require__(126);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(33);
	
	var _RouterUtils = __webpack_require__(201);
	
	var _routerWarning = __webpack_require__(50);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	
	  /**
	   * A <Router> is a high-level API for automatically setting up
	   * a router that renders a <RouterContext> with all the props
	   * it needs each time the URL changes.
	   */
	};var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(123);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(126);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(50);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(466);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(203);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(49);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(123);
	
	var _PromiseUtils = __webpack_require__(199);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(49);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(467);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(203);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(49);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(71);
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(202);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(204);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(33);
	
	var _RouterUtils = __webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(123);
	
	var _PromiseUtils = __webpack_require__(199);
	
	var _PatternUtils = __webpack_require__(49);
	
	var _routerWarning = __webpack_require__(50);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(17);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(164);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(124);
	
	var _PropTypes = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(446));
	var shallowEqual = _interopDefault(__webpack_require__(610));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(127);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ },
/* 581 */
/***/ function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(583);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(127);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(581);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(206);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(585);
	
	var _dots = __webpack_require__(580);
	
	var _arrows = __webpack_require__(579);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    typeof slide === 'number' && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(208);
	
	var _helpers = __webpack_require__(127);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(75);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = parseInt(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.animating) {
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(582);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(473);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(206);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(278);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(445);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	
	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        null,
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slickClasses = getSlideClasses((0, _objectAssign2.default)({ index: index }, spec));
	    var cssClasses;
	
	    if (child.props.className) {
	      cssClasses = (0, _classnames2.default)(slickClasses, child.props.className);
	    } else {
	      cssClasses = slickClasses;
	    }
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: cssClasses,
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ },
/* 586 */
110,
/* 587 */
[643, 61],
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(587);
	var ReactElement = __webpack_require__(52);
	
	var emptyFunction = __webpack_require__(21);
	var traverseAllChildren = __webpack_require__(597);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(52);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(52),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(170);
	
	module.exports = factory(isValidElement);

/***/ },
/* 591 */
527,
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(209),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(52),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(212);
	var factory = __webpack_require__(135);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 593 */
546,
/* 594 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(61);
	
	var ReactElement = __webpack_require__(52);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(61);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var REACT_ELEMENT_TYPE = __webpack_require__(211);
	
	var getIteratorFn = __webpack_require__(593);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(586);
	var warning = __webpack_require__(9);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(39);


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(215);
	
	/*<replacement>*/
	var util = __webpack_require__(54);
	util.inherits = __webpack_require__(44);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(82).Buffer;
	var util = __webpack_require__(641);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(129).PassThrough


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(129).Transform


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(128);


/***/ },
/* 604 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(219);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 606 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(220);
	
	var _isPlainObject = __webpack_require__(105);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(221);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {;(function (sax) { // wrapper for non-node envs
	  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
	  sax.SAXParser = SAXParser
	  sax.SAXStream = SAXStream
	  sax.createStream = createStream
	
	  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
	  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
	  // since that's the earliest that a buffer overrun could occur.  This way, checks are
	  // as rare as required, but as often as necessary to ensure never crossing this bound.
	  // Furthermore, buffers are only tested at most once per write(), so passing a very
	  // large string into write() might have undesirable effects, but this is manageable by
	  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
	  // edge case, result in creating at most one complete copy of the string passed in.
	  // Set to Infinity to have unlimited buffers.
	  sax.MAX_BUFFER_LENGTH = 64 * 1024
	
	  var buffers = [
	    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
	    'procInstName', 'procInstBody', 'entity', 'attribName',
	    'attribValue', 'cdata', 'script'
	  ]
	
	  sax.EVENTS = [
	    'text',
	    'processinginstruction',
	    'sgmldeclaration',
	    'doctype',
	    'comment',
	    'opentagstart',
	    'attribute',
	    'opentag',
	    'closetag',
	    'opencdata',
	    'cdata',
	    'closecdata',
	    'error',
	    'end',
	    'ready',
	    'script',
	    'opennamespace',
	    'closenamespace'
	  ]
	
	  function SAXParser (strict, opt) {
	    if (!(this instanceof SAXParser)) {
	      return new SAXParser(strict, opt)
	    }
	
	    var parser = this
	    clearBuffers(parser)
	    parser.q = parser.c = ''
	    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
	    parser.opt = opt || {}
	    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
	    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase'
	    parser.tags = []
	    parser.closed = parser.closedRoot = parser.sawRoot = false
	    parser.tag = parser.error = null
	    parser.strict = !!strict
	    parser.noscript = !!(strict || parser.opt.noscript)
	    parser.state = S.BEGIN
	    parser.strictEntities = parser.opt.strictEntities
	    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES)
	    parser.attribList = []
	
	    // namespaces form a prototype chain.
	    // it always points at the current tag,
	    // which protos to its parent tag.
	    if (parser.opt.xmlns) {
	      parser.ns = Object.create(rootNS)
	    }
	
	    // mostly just for error reporting
	    parser.trackPosition = parser.opt.position !== false
	    if (parser.trackPosition) {
	      parser.position = parser.line = parser.column = 0
	    }
	    emit(parser, 'onready')
	  }
	
	  if (!Object.create) {
	    Object.create = function (o) {
	      function F () {}
	      F.prototype = o
	      var newf = new F()
	      return newf
	    }
	  }
	
	  if (!Object.keys) {
	    Object.keys = function (o) {
	      var a = []
	      for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
	      return a
	    }
	  }
	
	  function checkBufferLength (parser) {
	    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
	    var maxActual = 0
	    for (var i = 0, l = buffers.length; i < l; i++) {
	      var len = parser[buffers[i]].length
	      if (len > maxAllowed) {
	        // Text/cdata nodes can get big, and since they're buffered,
	        // we can get here under normal conditions.
	        // Avoid issues by emitting the text node now,
	        // so at least it won't get any bigger.
	        switch (buffers[i]) {
	          case 'textNode':
	            closeText(parser)
	            break
	
	          case 'cdata':
	            emitNode(parser, 'oncdata', parser.cdata)
	            parser.cdata = ''
	            break
	
	          case 'script':
	            emitNode(parser, 'onscript', parser.script)
	            parser.script = ''
	            break
	
	          default:
	            error(parser, 'Max buffer length exceeded: ' + buffers[i])
	        }
	      }
	      maxActual = Math.max(maxActual, len)
	    }
	    // schedule the next check for the earliest possible buffer overrun.
	    var m = sax.MAX_BUFFER_LENGTH - maxActual
	    parser.bufferCheckPosition = m + parser.position
	  }
	
	  function clearBuffers (parser) {
	    for (var i = 0, l = buffers.length; i < l; i++) {
	      parser[buffers[i]] = ''
	    }
	  }
	
	  function flushBuffers (parser) {
	    closeText(parser)
	    if (parser.cdata !== '') {
	      emitNode(parser, 'oncdata', parser.cdata)
	      parser.cdata = ''
	    }
	    if (parser.script !== '') {
	      emitNode(parser, 'onscript', parser.script)
	      parser.script = ''
	    }
	  }
	
	  SAXParser.prototype = {
	    end: function () { end(this) },
	    write: write,
	    resume: function () { this.error = null; return this },
	    close: function () { return this.write(null) },
	    flush: function () { flushBuffers(this) }
	  }
	
	  var Stream
	  try {
	    Stream = __webpack_require__(611).Stream
	  } catch (ex) {
	    Stream = function () {}
	  }
	
	  var streamWraps = sax.EVENTS.filter(function (ev) {
	    return ev !== 'error' && ev !== 'end'
	  })
	
	  function createStream (strict, opt) {
	    return new SAXStream(strict, opt)
	  }
	
	  function SAXStream (strict, opt) {
	    if (!(this instanceof SAXStream)) {
	      return new SAXStream(strict, opt)
	    }
	
	    Stream.apply(this)
	
	    this._parser = new SAXParser(strict, opt)
	    this.writable = true
	    this.readable = true
	
	    var me = this
	
	    this._parser.onend = function () {
	      me.emit('end')
	    }
	
	    this._parser.onerror = function (er) {
	      me.emit('error', er)
	
	      // if didn't throw, then means error was handled.
	      // go ahead and clear error, so we can write again.
	      me._parser.error = null
	    }
	
	    this._decoder = null
	
	    streamWraps.forEach(function (ev) {
	      Object.defineProperty(me, 'on' + ev, {
	        get: function () {
	          return me._parser['on' + ev]
	        },
	        set: function (h) {
	          if (!h) {
	            me.removeAllListeners(ev)
	            me._parser['on' + ev] = h
	            return h
	          }
	          me.on(ev, h)
	        },
	        enumerable: true,
	        configurable: false
	      })
	    })
	  }
	
	  SAXStream.prototype = Object.create(Stream.prototype, {
	    constructor: {
	      value: SAXStream
	    }
	  })
	
	  SAXStream.prototype.write = function (data) {
	    if (typeof Buffer === 'function' &&
	      typeof Buffer.isBuffer === 'function' &&
	      Buffer.isBuffer(data)) {
	      if (!this._decoder) {
	        var SD = __webpack_require__(131).StringDecoder
	        this._decoder = new SD('utf8')
	      }
	      data = this._decoder.write(data)
	    }
	
	    this._parser.write(data.toString())
	    this.emit('data', data)
	    return true
	  }
	
	  SAXStream.prototype.end = function (chunk) {
	    if (chunk && chunk.length) {
	      this.write(chunk)
	    }
	    this._parser.end()
	    return true
	  }
	
	  SAXStream.prototype.on = function (ev, handler) {
	    var me = this
	    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
	      me._parser['on' + ev] = function () {
	        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments)
	        args.splice(0, 0, ev)
	        me.emit.apply(me, args)
	      }
	    }
	
	    return Stream.prototype.on.call(me, ev, handler)
	  }
	
	  // character classes and tokens
	  var whitespace = '\r\n\t '
	
	  // this really needs to be replaced with character classes.
	  // XML allows all manner of ridiculous numbers and digits.
	  var number = '0124356789'
	  var letter = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
	
	  // (Letter | "_" | ":")
	  var quote = '\'"'
	  var attribEnd = whitespace + '>'
	  var CDATA = '[CDATA['
	  var DOCTYPE = 'DOCTYPE'
	  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'
	  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'
	  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }
	
	  // turn all the string character sets into character class objects.
	  whitespace = charClass(whitespace)
	  number = charClass(number)
	  letter = charClass(letter)
	
	  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
	  // This implementation works on strings, a single character at a time
	  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
	  // without a significant breaking change to either this  parser, or the
	  // JavaScript language.  Implementation of an emoji-capable xml parser
	  // is left as an exercise for the reader.
	  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
	
	  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/
	
	  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
	  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/
	
	  quote = charClass(quote)
	  attribEnd = charClass(attribEnd)
	
	  function charClass (str) {
	    return str.split('').reduce(function (s, c) {
	      s[c] = true
	      return s
	    }, {})
	  }
	
	  function isRegExp (c) {
	    return Object.prototype.toString.call(c) === '[object RegExp]'
	  }
	
	  function is (charclass, c) {
	    return isRegExp(charclass) ? !!c.match(charclass) : charclass[c]
	  }
	
	  function not (charclass, c) {
	    return !is(charclass, c)
	  }
	
	  var S = 0
	  sax.STATE = {
	    BEGIN: S++, // leading byte order mark or whitespace
	    BEGIN_WHITESPACE: S++, // leading whitespace
	    TEXT: S++, // general stuff
	    TEXT_ENTITY: S++, // &amp and such.
	    OPEN_WAKA: S++, // <
	    SGML_DECL: S++, // <!BLARG
	    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
	    DOCTYPE: S++, // <!DOCTYPE
	    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
	    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
	    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
	    COMMENT_STARTING: S++, // <!-
	    COMMENT: S++, // <!--
	    COMMENT_ENDING: S++, // <!-- blah -
	    COMMENT_ENDED: S++, // <!-- blah --
	    CDATA: S++, // <![CDATA[ something
	    CDATA_ENDING: S++, // ]
	    CDATA_ENDING_2: S++, // ]]
	    PROC_INST: S++, // <?hi
	    PROC_INST_BODY: S++, // <?hi there
	    PROC_INST_ENDING: S++, // <?hi "there" ?
	    OPEN_TAG: S++, // <strong
	    OPEN_TAG_SLASH: S++, // <strong /
	    ATTRIB: S++, // <a
	    ATTRIB_NAME: S++, // <a foo
	    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
	    ATTRIB_VALUE: S++, // <a foo=
	    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
	    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
	    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
	    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
	    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
	    CLOSE_TAG: S++, // </a
	    CLOSE_TAG_SAW_WHITE: S++, // </a   >
	    SCRIPT: S++, // <script> ...
	    SCRIPT_ENDING: S++ // <script> ... <
	  }
	
	  sax.XML_ENTITIES = {
	    'amp': '&',
	    'gt': '>',
	    'lt': '<',
	    'quot': '"',
	    'apos': "'"
	  }
	
	  sax.ENTITIES = {
	    'amp': '&',
	    'gt': '>',
	    'lt': '<',
	    'quot': '"',
	    'apos': "'",
	    'AElig': 198,
	    'Aacute': 193,
	    'Acirc': 194,
	    'Agrave': 192,
	    'Aring': 197,
	    'Atilde': 195,
	    'Auml': 196,
	    'Ccedil': 199,
	    'ETH': 208,
	    'Eacute': 201,
	    'Ecirc': 202,
	    'Egrave': 200,
	    'Euml': 203,
	    'Iacute': 205,
	    'Icirc': 206,
	    'Igrave': 204,
	    'Iuml': 207,
	    'Ntilde': 209,
	    'Oacute': 211,
	    'Ocirc': 212,
	    'Ograve': 210,
	    'Oslash': 216,
	    'Otilde': 213,
	    'Ouml': 214,
	    'THORN': 222,
	    'Uacute': 218,
	    'Ucirc': 219,
	    'Ugrave': 217,
	    'Uuml': 220,
	    'Yacute': 221,
	    'aacute': 225,
	    'acirc': 226,
	    'aelig': 230,
	    'agrave': 224,
	    'aring': 229,
	    'atilde': 227,
	    'auml': 228,
	    'ccedil': 231,
	    'eacute': 233,
	    'ecirc': 234,
	    'egrave': 232,
	    'eth': 240,
	    'euml': 235,
	    'iacute': 237,
	    'icirc': 238,
	    'igrave': 236,
	    'iuml': 239,
	    'ntilde': 241,
	    'oacute': 243,
	    'ocirc': 244,
	    'ograve': 242,
	    'oslash': 248,
	    'otilde': 245,
	    'ouml': 246,
	    'szlig': 223,
	    'thorn': 254,
	    'uacute': 250,
	    'ucirc': 251,
	    'ugrave': 249,
	    'uuml': 252,
	    'yacute': 253,
	    'yuml': 255,
	    'copy': 169,
	    'reg': 174,
	    'nbsp': 160,
	    'iexcl': 161,
	    'cent': 162,
	    'pound': 163,
	    'curren': 164,
	    'yen': 165,
	    'brvbar': 166,
	    'sect': 167,
	    'uml': 168,
	    'ordf': 170,
	    'laquo': 171,
	    'not': 172,
	    'shy': 173,
	    'macr': 175,
	    'deg': 176,
	    'plusmn': 177,
	    'sup1': 185,
	    'sup2': 178,
	    'sup3': 179,
	    'acute': 180,
	    'micro': 181,
	    'para': 182,
	    'middot': 183,
	    'cedil': 184,
	    'ordm': 186,
	    'raquo': 187,
	    'frac14': 188,
	    'frac12': 189,
	    'frac34': 190,
	    'iquest': 191,
	    'times': 215,
	    'divide': 247,
	    'OElig': 338,
	    'oelig': 339,
	    'Scaron': 352,
	    'scaron': 353,
	    'Yuml': 376,
	    'fnof': 402,
	    'circ': 710,
	    'tilde': 732,
	    'Alpha': 913,
	    'Beta': 914,
	    'Gamma': 915,
	    'Delta': 916,
	    'Epsilon': 917,
	    'Zeta': 918,
	    'Eta': 919,
	    'Theta': 920,
	    'Iota': 921,
	    'Kappa': 922,
	    'Lambda': 923,
	    'Mu': 924,
	    'Nu': 925,
	    'Xi': 926,
	    'Omicron': 927,
	    'Pi': 928,
	    'Rho': 929,
	    'Sigma': 931,
	    'Tau': 932,
	    'Upsilon': 933,
	    'Phi': 934,
	    'Chi': 935,
	    'Psi': 936,
	    'Omega': 937,
	    'alpha': 945,
	    'beta': 946,
	    'gamma': 947,
	    'delta': 948,
	    'epsilon': 949,
	    'zeta': 950,
	    'eta': 951,
	    'theta': 952,
	    'iota': 953,
	    'kappa': 954,
	    'lambda': 955,
	    'mu': 956,
	    'nu': 957,
	    'xi': 958,
	    'omicron': 959,
	    'pi': 960,
	    'rho': 961,
	    'sigmaf': 962,
	    'sigma': 963,
	    'tau': 964,
	    'upsilon': 965,
	    'phi': 966,
	    'chi': 967,
	    'psi': 968,
	    'omega': 969,
	    'thetasym': 977,
	    'upsih': 978,
	    'piv': 982,
	    'ensp': 8194,
	    'emsp': 8195,
	    'thinsp': 8201,
	    'zwnj': 8204,
	    'zwj': 8205,
	    'lrm': 8206,
	    'rlm': 8207,
	    'ndash': 8211,
	    'mdash': 8212,
	    'lsquo': 8216,
	    'rsquo': 8217,
	    'sbquo': 8218,
	    'ldquo': 8220,
	    'rdquo': 8221,
	    'bdquo': 8222,
	    'dagger': 8224,
	    'Dagger': 8225,
	    'bull': 8226,
	    'hellip': 8230,
	    'permil': 8240,
	    'prime': 8242,
	    'Prime': 8243,
	    'lsaquo': 8249,
	    'rsaquo': 8250,
	    'oline': 8254,
	    'frasl': 8260,
	    'euro': 8364,
	    'image': 8465,
	    'weierp': 8472,
	    'real': 8476,
	    'trade': 8482,
	    'alefsym': 8501,
	    'larr': 8592,
	    'uarr': 8593,
	    'rarr': 8594,
	    'darr': 8595,
	    'harr': 8596,
	    'crarr': 8629,
	    'lArr': 8656,
	    'uArr': 8657,
	    'rArr': 8658,
	    'dArr': 8659,
	    'hArr': 8660,
	    'forall': 8704,
	    'part': 8706,
	    'exist': 8707,
	    'empty': 8709,
	    'nabla': 8711,
	    'isin': 8712,
	    'notin': 8713,
	    'ni': 8715,
	    'prod': 8719,
	    'sum': 8721,
	    'minus': 8722,
	    'lowast': 8727,
	    'radic': 8730,
	    'prop': 8733,
	    'infin': 8734,
	    'ang': 8736,
	    'and': 8743,
	    'or': 8744,
	    'cap': 8745,
	    'cup': 8746,
	    'int': 8747,
	    'there4': 8756,
	    'sim': 8764,
	    'cong': 8773,
	    'asymp': 8776,
	    'ne': 8800,
	    'equiv': 8801,
	    'le': 8804,
	    'ge': 8805,
	    'sub': 8834,
	    'sup': 8835,
	    'nsub': 8836,
	    'sube': 8838,
	    'supe': 8839,
	    'oplus': 8853,
	    'otimes': 8855,
	    'perp': 8869,
	    'sdot': 8901,
	    'lceil': 8968,
	    'rceil': 8969,
	    'lfloor': 8970,
	    'rfloor': 8971,
	    'lang': 9001,
	    'rang': 9002,
	    'loz': 9674,
	    'spades': 9824,
	    'clubs': 9827,
	    'hearts': 9829,
	    'diams': 9830
	  }
	
	  Object.keys(sax.ENTITIES).forEach(function (key) {
	    var e = sax.ENTITIES[key]
	    var s = typeof e === 'number' ? String.fromCharCode(e) : e
	    sax.ENTITIES[key] = s
	  })
	
	  for (var s in sax.STATE) {
	    sax.STATE[sax.STATE[s]] = s
	  }
	
	  // shorthand
	  S = sax.STATE
	
	  function emit (parser, event, data) {
	    parser[event] && parser[event](data)
	  }
	
	  function emitNode (parser, nodeType, data) {
	    if (parser.textNode) closeText(parser)
	    emit(parser, nodeType, data)
	  }
	
	  function closeText (parser) {
	    parser.textNode = textopts(parser.opt, parser.textNode)
	    if (parser.textNode) emit(parser, 'ontext', parser.textNode)
	    parser.textNode = ''
	  }
	
	  function textopts (opt, text) {
	    if (opt.trim) text = text.trim()
	    if (opt.normalize) text = text.replace(/\s+/g, ' ')
	    return text
	  }
	
	  function error (parser, er) {
	    closeText(parser)
	    if (parser.trackPosition) {
	      er += '\nLine: ' + parser.line +
	        '\nColumn: ' + parser.column +
	        '\nChar: ' + parser.c
	    }
	    er = new Error(er)
	    parser.error = er
	    emit(parser, 'onerror', er)
	    return parser
	  }
	
	  function end (parser) {
	    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag')
	    if ((parser.state !== S.BEGIN) &&
	      (parser.state !== S.BEGIN_WHITESPACE) &&
	      (parser.state !== S.TEXT)) {
	      error(parser, 'Unexpected end')
	    }
	    closeText(parser)
	    parser.c = ''
	    parser.closed = true
	    emit(parser, 'onend')
	    SAXParser.call(parser, parser.strict, parser.opt)
	    return parser
	  }
	
	  function strictFail (parser, message) {
	    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
	      throw new Error('bad call to strictFail')
	    }
	    if (parser.strict) {
	      error(parser, message)
	    }
	  }
	
	  function newTag (parser) {
	    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
	    var parent = parser.tags[parser.tags.length - 1] || parser
	    var tag = parser.tag = { name: parser.tagName, attributes: {} }
	
	    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
	    if (parser.opt.xmlns) {
	      tag.ns = parent.ns
	    }
	    parser.attribList.length = 0
	    emitNode(parser, 'onopentagstart', tag)
	  }
	
	  function qname (name, attribute) {
	    var i = name.indexOf(':')
	    var qualName = i < 0 ? [ '', name ] : name.split(':')
	    var prefix = qualName[0]
	    var local = qualName[1]
	
	    // <x "xmlns"="http://foo">
	    if (attribute && name === 'xmlns') {
	      prefix = 'xmlns'
	      local = ''
	    }
	
	    return { prefix: prefix, local: local }
	  }
	
	  function attrib (parser) {
	    if (!parser.strict) {
	      parser.attribName = parser.attribName[parser.looseCase]()
	    }
	
	    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
	      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
	      parser.attribName = parser.attribValue = ''
	      return
	    }
	
	    if (parser.opt.xmlns) {
	      var qn = qname(parser.attribName, true)
	      var prefix = qn.prefix
	      var local = qn.local
	
	      if (prefix === 'xmlns') {
	        // namespace binding attribute. push the binding into scope
	        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
	          strictFail(parser,
	            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
	            'Actual: ' + parser.attribValue)
	        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
	          strictFail(parser,
	            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
	            'Actual: ' + parser.attribValue)
	        } else {
	          var tag = parser.tag
	          var parent = parser.tags[parser.tags.length - 1] || parser
	          if (tag.ns === parent.ns) {
	            tag.ns = Object.create(parent.ns)
	          }
	          tag.ns[local] = parser.attribValue
	        }
	      }
	
	      // defer onattribute events until all attributes have been seen
	      // so any new bindings can take effect. preserve attribute order
	      // so deferred events can be emitted in document order
	      parser.attribList.push([parser.attribName, parser.attribValue])
	    } else {
	      // in non-xmlns mode, we can emit the event right away
	      parser.tag.attributes[parser.attribName] = parser.attribValue
	      emitNode(parser, 'onattribute', {
	        name: parser.attribName,
	        value: parser.attribValue
	      })
	    }
	
	    parser.attribName = parser.attribValue = ''
	  }
	
	  function openTag (parser, selfClosing) {
	    if (parser.opt.xmlns) {
	      // emit namespace binding events
	      var tag = parser.tag
	
	      // add namespace info to tag
	      var qn = qname(parser.tagName)
	      tag.prefix = qn.prefix
	      tag.local = qn.local
	      tag.uri = tag.ns[qn.prefix] || ''
	
	      if (tag.prefix && !tag.uri) {
	        strictFail(parser, 'Unbound namespace prefix: ' +
	          JSON.stringify(parser.tagName))
	        tag.uri = qn.prefix
	      }
	
	      var parent = parser.tags[parser.tags.length - 1] || parser
	      if (tag.ns && parent.ns !== tag.ns) {
	        Object.keys(tag.ns).forEach(function (p) {
	          emitNode(parser, 'onopennamespace', {
	            prefix: p,
	            uri: tag.ns[p]
	          })
	        })
	      }
	
	      // handle deferred onattribute events
	      // Note: do not apply default ns to attributes:
	      //   http://www.w3.org/TR/REC-xml-names/#defaulting
	      for (var i = 0, l = parser.attribList.length; i < l; i++) {
	        var nv = parser.attribList[i]
	        var name = nv[0]
	        var value = nv[1]
	        var qualName = qname(name, true)
	        var prefix = qualName.prefix
	        var local = qualName.local
	        var uri = prefix === '' ? '' : (tag.ns[prefix] || '')
	        var a = {
	          name: name,
	          value: value,
	          prefix: prefix,
	          local: local,
	          uri: uri
	        }
	
	        // if there's any attributes with an undefined namespace,
	        // then fail on them now.
	        if (prefix && prefix !== 'xmlns' && !uri) {
	          strictFail(parser, 'Unbound namespace prefix: ' +
	            JSON.stringify(prefix))
	          a.uri = prefix
	        }
	        parser.tag.attributes[name] = a
	        emitNode(parser, 'onattribute', a)
	      }
	      parser.attribList.length = 0
	    }
	
	    parser.tag.isSelfClosing = !!selfClosing
	
	    // process the tag
	    parser.sawRoot = true
	    parser.tags.push(parser.tag)
	    emitNode(parser, 'onopentag', parser.tag)
	    if (!selfClosing) {
	      // special case for <script> in non-strict mode.
	      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
	        parser.state = S.SCRIPT
	      } else {
	        parser.state = S.TEXT
	      }
	      parser.tag = null
	      parser.tagName = ''
	    }
	    parser.attribName = parser.attribValue = ''
	    parser.attribList.length = 0
	  }
	
	  function closeTag (parser) {
	    if (!parser.tagName) {
	      strictFail(parser, 'Weird empty close tag.')
	      parser.textNode += '</>'
	      parser.state = S.TEXT
	      return
	    }
	
	    if (parser.script) {
	      if (parser.tagName !== 'script') {
	        parser.script += '</' + parser.tagName + '>'
	        parser.tagName = ''
	        parser.state = S.SCRIPT
	        return
	      }
	      emitNode(parser, 'onscript', parser.script)
	      parser.script = ''
	    }
	
	    // first make sure that the closing tag actually exists.
	    // <a><b></c></b></a> will close everything, otherwise.
	    var t = parser.tags.length
	    var tagName = parser.tagName
	    if (!parser.strict) {
	      tagName = tagName[parser.looseCase]()
	    }
	    var closeTo = tagName
	    while (t--) {
	      var close = parser.tags[t]
	      if (close.name !== closeTo) {
	        // fail the first time in strict mode
	        strictFail(parser, 'Unexpected close tag')
	      } else {
	        break
	      }
	    }
	
	    // didn't find it.  we already failed for strict, so just abort.
	    if (t < 0) {
	      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName)
	      parser.textNode += '</' + parser.tagName + '>'
	      parser.state = S.TEXT
	      return
	    }
	    parser.tagName = tagName
	    var s = parser.tags.length
	    while (s-- > t) {
	      var tag = parser.tag = parser.tags.pop()
	      parser.tagName = parser.tag.name
	      emitNode(parser, 'onclosetag', parser.tagName)
	
	      var x = {}
	      for (var i in tag.ns) {
	        x[i] = tag.ns[i]
	      }
	
	      var parent = parser.tags[parser.tags.length - 1] || parser
	      if (parser.opt.xmlns && tag.ns !== parent.ns) {
	        // remove namespace bindings introduced by tag
	        Object.keys(tag.ns).forEach(function (p) {
	          var n = tag.ns[p]
	          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n })
	        })
	      }
	    }
	    if (t === 0) parser.closedRoot = true
	    parser.tagName = parser.attribValue = parser.attribName = ''
	    parser.attribList.length = 0
	    parser.state = S.TEXT
	  }
	
	  function parseEntity (parser) {
	    var entity = parser.entity
	    var entityLC = entity.toLowerCase()
	    var num
	    var numStr = ''
	
	    if (parser.ENTITIES[entity]) {
	      return parser.ENTITIES[entity]
	    }
	    if (parser.ENTITIES[entityLC]) {
	      return parser.ENTITIES[entityLC]
	    }
	    entity = entityLC
	    if (entity.charAt(0) === '#') {
	      if (entity.charAt(1) === 'x') {
	        entity = entity.slice(2)
	        num = parseInt(entity, 16)
	        numStr = num.toString(16)
	      } else {
	        entity = entity.slice(1)
	        num = parseInt(entity, 10)
	        numStr = num.toString(10)
	      }
	    }
	    entity = entity.replace(/^0+/, '')
	    if (numStr.toLowerCase() !== entity) {
	      strictFail(parser, 'Invalid character entity')
	      return '&' + parser.entity + ';'
	    }
	
	    return String.fromCodePoint(num)
	  }
	
	  function beginWhiteSpace (parser, c) {
	    if (c === '<') {
	      parser.state = S.OPEN_WAKA
	      parser.startTagPosition = parser.position
	    } else if (not(whitespace, c)) {
	      // have to process this as a text node.
	      // weird, but happens.
	      strictFail(parser, 'Non-whitespace before first tag.')
	      parser.textNode = c
	      parser.state = S.TEXT
	    }
	  }
	
	  function charAt (chunk, i) {
	    var result = ''
	    if (i < chunk.length) {
	      result = chunk.charAt(i)
	    }
	    return result
	  }
	
	  function write (chunk) {
	    var parser = this
	    if (this.error) {
	      throw this.error
	    }
	    if (parser.closed) {
	      return error(parser,
	        'Cannot write after close. Assign an onready handler.')
	    }
	    if (chunk === null) {
	      return end(parser)
	    }
	    if (typeof chunk === 'object') {
	      chunk = chunk.toString()
	    }
	    var i = 0
	    var c = ''
	    while (true) {
	      c = charAt(chunk, i++)
	      parser.c = c
	      if (!c) {
	        break
	      }
	      if (parser.trackPosition) {
	        parser.position++
	        if (c === '\n') {
	          parser.line++
	          parser.column = 0
	        } else {
	          parser.column++
	        }
	      }
	      switch (parser.state) {
	        case S.BEGIN:
	          parser.state = S.BEGIN_WHITESPACE
	          if (c === '\uFEFF') {
	            continue
	          }
	          beginWhiteSpace(parser, c)
	          continue
	
	        case S.BEGIN_WHITESPACE:
	          beginWhiteSpace(parser, c)
	          continue
	
	        case S.TEXT:
	          if (parser.sawRoot && !parser.closedRoot) {
	            var starti = i - 1
	            while (c && c !== '<' && c !== '&') {
	              c = charAt(chunk, i++)
	              if (c && parser.trackPosition) {
	                parser.position++
	                if (c === '\n') {
	                  parser.line++
	                  parser.column = 0
	                } else {
	                  parser.column++
	                }
	              }
	            }
	            parser.textNode += chunk.substring(starti, i - 1)
	          }
	          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
	            parser.state = S.OPEN_WAKA
	            parser.startTagPosition = parser.position
	          } else {
	            if (not(whitespace, c) && (!parser.sawRoot || parser.closedRoot)) {
	              strictFail(parser, 'Text data outside of root node.')
	            }
	            if (c === '&') {
	              parser.state = S.TEXT_ENTITY
	            } else {
	              parser.textNode += c
	            }
	          }
	          continue
	
	        case S.SCRIPT:
	          // only non-strict
	          if (c === '<') {
	            parser.state = S.SCRIPT_ENDING
	          } else {
	            parser.script += c
	          }
	          continue
	
	        case S.SCRIPT_ENDING:
	          if (c === '/') {
	            parser.state = S.CLOSE_TAG
	          } else {
	            parser.script += '<' + c
	            parser.state = S.SCRIPT
	          }
	          continue
	
	        case S.OPEN_WAKA:
	          // either a /, ?, !, or text is coming next.
	          if (c === '!') {
	            parser.state = S.SGML_DECL
	            parser.sgmlDecl = ''
	          } else if (is(whitespace, c)) {
	            // wait for it...
	          } else if (is(nameStart, c)) {
	            parser.state = S.OPEN_TAG
	            parser.tagName = c
	          } else if (c === '/') {
	            parser.state = S.CLOSE_TAG
	            parser.tagName = ''
	          } else if (c === '?') {
	            parser.state = S.PROC_INST
	            parser.procInstName = parser.procInstBody = ''
	          } else {
	            strictFail(parser, 'Unencoded <')
	            // if there was some whitespace, then add that in.
	            if (parser.startTagPosition + 1 < parser.position) {
	              var pad = parser.position - parser.startTagPosition
	              c = new Array(pad).join(' ') + c
	            }
	            parser.textNode += '<' + c
	            parser.state = S.TEXT
	          }
	          continue
	
	        case S.SGML_DECL:
	          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
	            emitNode(parser, 'onopencdata')
	            parser.state = S.CDATA
	            parser.sgmlDecl = ''
	            parser.cdata = ''
	          } else if (parser.sgmlDecl + c === '--') {
	            parser.state = S.COMMENT
	            parser.comment = ''
	            parser.sgmlDecl = ''
	          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
	            parser.state = S.DOCTYPE
	            if (parser.doctype || parser.sawRoot) {
	              strictFail(parser,
	                'Inappropriately located doctype declaration')
	            }
	            parser.doctype = ''
	            parser.sgmlDecl = ''
	          } else if (c === '>') {
	            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl)
	            parser.sgmlDecl = ''
	            parser.state = S.TEXT
	          } else if (is(quote, c)) {
	            parser.state = S.SGML_DECL_QUOTED
	            parser.sgmlDecl += c
	          } else {
	            parser.sgmlDecl += c
	          }
	          continue
	
	        case S.SGML_DECL_QUOTED:
	          if (c === parser.q) {
	            parser.state = S.SGML_DECL
	            parser.q = ''
	          }
	          parser.sgmlDecl += c
	          continue
	
	        case S.DOCTYPE:
	          if (c === '>') {
	            parser.state = S.TEXT
	            emitNode(parser, 'ondoctype', parser.doctype)
	            parser.doctype = true // just remember that we saw it.
	          } else {
	            parser.doctype += c
	            if (c === '[') {
	              parser.state = S.DOCTYPE_DTD
	            } else if (is(quote, c)) {
	              parser.state = S.DOCTYPE_QUOTED
	              parser.q = c
	            }
	          }
	          continue
	
	        case S.DOCTYPE_QUOTED:
	          parser.doctype += c
	          if (c === parser.q) {
	            parser.q = ''
	            parser.state = S.DOCTYPE
	          }
	          continue
	
	        case S.DOCTYPE_DTD:
	          parser.doctype += c
	          if (c === ']') {
	            parser.state = S.DOCTYPE
	          } else if (is(quote, c)) {
	            parser.state = S.DOCTYPE_DTD_QUOTED
	            parser.q = c
	          }
	          continue
	
	        case S.DOCTYPE_DTD_QUOTED:
	          parser.doctype += c
	          if (c === parser.q) {
	            parser.state = S.DOCTYPE_DTD
	            parser.q = ''
	          }
	          continue
	
	        case S.COMMENT:
	          if (c === '-') {
	            parser.state = S.COMMENT_ENDING
	          } else {
	            parser.comment += c
	          }
	          continue
	
	        case S.COMMENT_ENDING:
	          if (c === '-') {
	            parser.state = S.COMMENT_ENDED
	            parser.comment = textopts(parser.opt, parser.comment)
	            if (parser.comment) {
	              emitNode(parser, 'oncomment', parser.comment)
	            }
	            parser.comment = ''
	          } else {
	            parser.comment += '-' + c
	            parser.state = S.COMMENT
	          }
	          continue
	
	        case S.COMMENT_ENDED:
	          if (c !== '>') {
	            strictFail(parser, 'Malformed comment')
	            // allow <!-- blah -- bloo --> in non-strict mode,
	            // which is a comment of " blah -- bloo "
	            parser.comment += '--' + c
	            parser.state = S.COMMENT
	          } else {
	            parser.state = S.TEXT
	          }
	          continue
	
	        case S.CDATA:
	          if (c === ']') {
	            parser.state = S.CDATA_ENDING
	          } else {
	            parser.cdata += c
	          }
	          continue
	
	        case S.CDATA_ENDING:
	          if (c === ']') {
	            parser.state = S.CDATA_ENDING_2
	          } else {
	            parser.cdata += ']' + c
	            parser.state = S.CDATA
	          }
	          continue
	
	        case S.CDATA_ENDING_2:
	          if (c === '>') {
	            if (parser.cdata) {
	              emitNode(parser, 'oncdata', parser.cdata)
	            }
	            emitNode(parser, 'onclosecdata')
	            parser.cdata = ''
	            parser.state = S.TEXT
	          } else if (c === ']') {
	            parser.cdata += ']'
	          } else {
	            parser.cdata += ']]' + c
	            parser.state = S.CDATA
	          }
	          continue
	
	        case S.PROC_INST:
	          if (c === '?') {
	            parser.state = S.PROC_INST_ENDING
	          } else if (is(whitespace, c)) {
	            parser.state = S.PROC_INST_BODY
	          } else {
	            parser.procInstName += c
	          }
	          continue
	
	        case S.PROC_INST_BODY:
	          if (!parser.procInstBody && is(whitespace, c)) {
	            continue
	          } else if (c === '?') {
	            parser.state = S.PROC_INST_ENDING
	          } else {
	            parser.procInstBody += c
	          }
	          continue
	
	        case S.PROC_INST_ENDING:
	          if (c === '>') {
	            emitNode(parser, 'onprocessinginstruction', {
	              name: parser.procInstName,
	              body: parser.procInstBody
	            })
	            parser.procInstName = parser.procInstBody = ''
	            parser.state = S.TEXT
	          } else {
	            parser.procInstBody += '?' + c
	            parser.state = S.PROC_INST_BODY
	          }
	          continue
	
	        case S.OPEN_TAG:
	          if (is(nameBody, c)) {
	            parser.tagName += c
	          } else {
	            newTag(parser)
	            if (c === '>') {
	              openTag(parser)
	            } else if (c === '/') {
	              parser.state = S.OPEN_TAG_SLASH
	            } else {
	              if (not(whitespace, c)) {
	                strictFail(parser, 'Invalid character in tag name')
	              }
	              parser.state = S.ATTRIB
	            }
	          }
	          continue
	
	        case S.OPEN_TAG_SLASH:
	          if (c === '>') {
	            openTag(parser, true)
	            closeTag(parser)
	          } else {
	            strictFail(parser, 'Forward-slash in opening tag not followed by >')
	            parser.state = S.ATTRIB
	          }
	          continue
	
	        case S.ATTRIB:
	          // haven't read the attribute name yet.
	          if (is(whitespace, c)) {
	            continue
	          } else if (c === '>') {
	            openTag(parser)
	          } else if (c === '/') {
	            parser.state = S.OPEN_TAG_SLASH
	          } else if (is(nameStart, c)) {
	            parser.attribName = c
	            parser.attribValue = ''
	            parser.state = S.ATTRIB_NAME
	          } else {
	            strictFail(parser, 'Invalid attribute name')
	          }
	          continue
	
	        case S.ATTRIB_NAME:
	          if (c === '=') {
	            parser.state = S.ATTRIB_VALUE
	          } else if (c === '>') {
	            strictFail(parser, 'Attribute without value')
	            parser.attribValue = parser.attribName
	            attrib(parser)
	            openTag(parser)
	          } else if (is(whitespace, c)) {
	            parser.state = S.ATTRIB_NAME_SAW_WHITE
	          } else if (is(nameBody, c)) {
	            parser.attribName += c
	          } else {
	            strictFail(parser, 'Invalid attribute name')
	          }
	          continue
	
	        case S.ATTRIB_NAME_SAW_WHITE:
	          if (c === '=') {
	            parser.state = S.ATTRIB_VALUE
	          } else if (is(whitespace, c)) {
	            continue
	          } else {
	            strictFail(parser, 'Attribute without value')
	            parser.tag.attributes[parser.attribName] = ''
	            parser.attribValue = ''
	            emitNode(parser, 'onattribute', {
	              name: parser.attribName,
	              value: ''
	            })
	            parser.attribName = ''
	            if (c === '>') {
	              openTag(parser)
	            } else if (is(nameStart, c)) {
	              parser.attribName = c
	              parser.state = S.ATTRIB_NAME
	            } else {
	              strictFail(parser, 'Invalid attribute name')
	              parser.state = S.ATTRIB
	            }
	          }
	          continue
	
	        case S.ATTRIB_VALUE:
	          if (is(whitespace, c)) {
	            continue
	          } else if (is(quote, c)) {
	            parser.q = c
	            parser.state = S.ATTRIB_VALUE_QUOTED
	          } else {
	            strictFail(parser, 'Unquoted attribute value')
	            parser.state = S.ATTRIB_VALUE_UNQUOTED
	            parser.attribValue = c
	          }
	          continue
	
	        case S.ATTRIB_VALUE_QUOTED:
	          if (c !== parser.q) {
	            if (c === '&') {
	              parser.state = S.ATTRIB_VALUE_ENTITY_Q
	            } else {
	              parser.attribValue += c
	            }
	            continue
	          }
	          attrib(parser)
	          parser.q = ''
	          parser.state = S.ATTRIB_VALUE_CLOSED
	          continue
	
	        case S.ATTRIB_VALUE_CLOSED:
	          if (is(whitespace, c)) {
	            parser.state = S.ATTRIB
	          } else if (c === '>') {
	            openTag(parser)
	          } else if (c === '/') {
	            parser.state = S.OPEN_TAG_SLASH
	          } else if (is(nameStart, c)) {
	            strictFail(parser, 'No whitespace between attributes')
	            parser.attribName = c
	            parser.attribValue = ''
	            parser.state = S.ATTRIB_NAME
	          } else {
	            strictFail(parser, 'Invalid attribute name')
	          }
	          continue
	
	        case S.ATTRIB_VALUE_UNQUOTED:
	          if (not(attribEnd, c)) {
	            if (c === '&') {
	              parser.state = S.ATTRIB_VALUE_ENTITY_U
	            } else {
	              parser.attribValue += c
	            }
	            continue
	          }
	          attrib(parser)
	          if (c === '>') {
	            openTag(parser)
	          } else {
	            parser.state = S.ATTRIB
	          }
	          continue
	
	        case S.CLOSE_TAG:
	          if (!parser.tagName) {
	            if (is(whitespace, c)) {
	              continue
	            } else if (not(nameStart, c)) {
	              if (parser.script) {
	                parser.script += '</' + c
	                parser.state = S.SCRIPT
	              } else {
	                strictFail(parser, 'Invalid tagname in closing tag.')
	              }
	            } else {
	              parser.tagName = c
	            }
	          } else if (c === '>') {
	            closeTag(parser)
	          } else if (is(nameBody, c)) {
	            parser.tagName += c
	          } else if (parser.script) {
	            parser.script += '</' + parser.tagName
	            parser.tagName = ''
	            parser.state = S.SCRIPT
	          } else {
	            if (not(whitespace, c)) {
	              strictFail(parser, 'Invalid tagname in closing tag')
	            }
	            parser.state = S.CLOSE_TAG_SAW_WHITE
	          }
	          continue
	
	        case S.CLOSE_TAG_SAW_WHITE:
	          if (is(whitespace, c)) {
	            continue
	          }
	          if (c === '>') {
	            closeTag(parser)
	          } else {
	            strictFail(parser, 'Invalid characters in closing tag')
	          }
	          continue
	
	        case S.TEXT_ENTITY:
	        case S.ATTRIB_VALUE_ENTITY_Q:
	        case S.ATTRIB_VALUE_ENTITY_U:
	          var returnState
	          var buffer
	          switch (parser.state) {
	            case S.TEXT_ENTITY:
	              returnState = S.TEXT
	              buffer = 'textNode'
	              break
	
	            case S.ATTRIB_VALUE_ENTITY_Q:
	              returnState = S.ATTRIB_VALUE_QUOTED
	              buffer = 'attribValue'
	              break
	
	            case S.ATTRIB_VALUE_ENTITY_U:
	              returnState = S.ATTRIB_VALUE_UNQUOTED
	              buffer = 'attribValue'
	              break
	          }
	
	          if (c === ';') {
	            parser[buffer] += parseEntity(parser)
	            parser.entity = ''
	            parser.state = returnState
	          } else if (is(parser.entity.length ? entityBody : entityStart, c)) {
	            parser.entity += c
	          } else {
	            strictFail(parser, 'Invalid character in entity name')
	            parser[buffer] += '&' + parser.entity + c
	            parser.entity = ''
	            parser.state = returnState
	          }
	
	          continue
	
	        default:
	          throw new Error(parser, 'Unknown state: ' + parser.state)
	      }
	    } // while
	
	    if (parser.position >= parser.bufferCheckPosition) {
	      checkBufferLength(parser)
	    }
	    return parser
	  }
	
	  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
	  if (!String.fromCodePoint) {
	    (function () {
	      var stringFromCharCode = String.fromCharCode
	      var floor = Math.floor
	      var fromCodePoint = function () {
	        var MAX_SIZE = 0x4000
	        var codeUnits = []
	        var highSurrogate
	        var lowSurrogate
	        var index = -1
	        var length = arguments.length
	        if (!length) {
	          return ''
	        }
	        var result = ''
	        while (++index < length) {
	          var codePoint = Number(arguments[index])
	          if (
	            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
	            codePoint < 0 || // not a valid Unicode code point
	            codePoint > 0x10FFFF || // not a valid Unicode code point
	            floor(codePoint) !== codePoint // not an integer
	          ) {
	            throw RangeError('Invalid code point: ' + codePoint)
	          }
	          if (codePoint <= 0xFFFF) { // BMP code point
	            codeUnits.push(codePoint)
	          } else { // Astral code point; split in surrogate halves
	            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	            codePoint -= 0x10000
	            highSurrogate = (codePoint >> 10) + 0xD800
	            lowSurrogate = (codePoint % 0x400) + 0xDC00
	            codeUnits.push(highSurrogate, lowSurrogate)
	          }
	          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
	            result += stringFromCharCode.apply(null, codeUnits)
	            codeUnits.length = 0
	          }
	        }
	        return result
	      }
	      if (Object.defineProperty) {
	        Object.defineProperty(String, 'fromCodePoint', {
	          value: fromCodePoint,
	          configurable: true,
	          writable: true
	        })
	      } else {
	        String.fromCodePoint = fromCodePoint
	      }
	    }())
	  }
	})( false ? this.sax = {} : exports)
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83).Buffer))

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(45)))

/***/ },
/* 610 */
/***/ function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(98).EventEmitter;
	var inherits = __webpack_require__(44);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(129);
	Stream.Writable = __webpack_require__(603);
	Stream.Duplex = __webpack_require__(598);
	Stream.Transform = __webpack_require__(602);
	Stream.PassThrough = __webpack_require__(601);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 612 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 613 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(279);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./About.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./About.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(280);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./Annotation.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./Annotation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(281);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./App.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./App.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(282);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./DetailPage.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./DetailPage.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(283);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./EndOfStory.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./EndOfStory.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(284);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Iframe.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Iframe.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(285);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Image.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Image.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(286);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Paragraph.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Paragraph.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(287);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Quote.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Quote.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(288);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Slider.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Slider.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(289);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./ImageSrcSet.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./ImageSrcSet.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(290);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Maps.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./Maps.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(291);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./Navigation.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./Navigation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(292);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./NavigationMap.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js!./NavigationMap.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(293);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./Splash.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./Splash.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(294);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./Timeline.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./Timeline.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(295);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./Video.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./Video.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(296);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/sass-loader/index.js!./index.scss", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/sass-loader/index.js!./index.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(633);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(638)(module)))

/***/ },
/* 633 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(609);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 635 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhIAAgAPUAAP///wAAAPr6+sTExOjo6PDw8NDQ0H5+fpqamvb29ubm5vz8/JKSkoaGhuLi4ri4uKCgoOzs7K6urtzc3D4+PlZWVmBgYHx8fKioqO7u7kpKSmxsbAwMDAAAAM7OzsjIyNjY2CwsLF5eXh4eHkxMTLCwsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH+GkNyZWF0ZWQgd2l0aCBhamF4bG9hZC5pbmZvACH5BAAKAAAAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAIAAgAAAG/0CAcEgkFjgcR3HJJE4SxEGnMygKmkwJxRKdVocFBRRLfFAoj6GUOhQoFAVysULRjNdfQFghLxrODEJ4Qm5ifUUXZwQAgwBvEXIGBkUEZxuMXgAJb1dECWMABAcHDEpDEGcTBQMDBQtvcW0RbwuECKMHELEJF5NFCxm1AAt7cH4NuAOdcsURy0QCD7gYfcWgTQUQB6Zkr66HoeDCSwIF5ucFz3IC7O0CC6zx8YuHhW/3CvLyfPX4+OXozKnDssBdu3G/xIHTpGAgOUPrZimAJCfDPYfDin2TQ+xeBnWbHi37SC4YIYkQhdy7FvLdpwWvjA0JyU/ISyIx4xS6sgfkNS4me2rtVKkgw0JCb8YMZdjwqMQ2nIY8BbcUQNVCP7G4MQq1KRivR7tiDEuEFrggACH5BAAKAAEALAAAAAAgACAAAAb/QIBwSCQmNBpCcckkEgREA4ViKA6azM8BEZ1Wh6LOBls0HA5fgJQ6HHQ6InKRcWhA1d5hqMMpyIkOZw9Ca18Qbwd/RRhnfoUABRwdI3IESkQFZxB4bAdvV0YJQwkDAx9+bWcECQYGCQ5vFEQCEQoKC0ILHqUDBncCGA5LBiHCAAsFtgqoQwS8Aw64f8m2EXdFCxO8INPKomQCBgPMWAvL0n/ff+jYAu7vAuxy8O/myvfX8/f7/Arq+v0W0HMnr9zAeE0KJlQkJIGCfE0E+PtDq9qfDMogDkGmrIBCbNQUZIDosNq1kUsEZJBW0dY/b0ZsLViQIMFMW+RKKgjFzp4fNokPIdki+Y8JNVxA79jKwHAI0G9JGw5tCqDWTiFRhVhtmhVA16cMJTJ1OnVIMo1cy1KVI5NhEAAh+QQACgACACwAAAAAIAAgAAAG/0CAcEgkChqNQnHJJCYWRMfh4CgamkzFwBOdVocNCgNbJAwGhKGUOjRQKA1y8XOGAtZfgIWiSciJBWcTQnhCD28Qf0UgZwJ3XgAJGhQVcgKORmdXhRBvV0QMY0ILCgoRmIRnCQIODgIEbxtEJSMdHZ8AGaUKBXYLIEpFExZpAG62HRRFArsKfn8FIsgjiUwJu8FkJLYcB9lMCwUKqFgGHSJ5cnZ/uEULl/CX63/x8KTNu+RkzPj9zc/0/Cl4V0/APDIE6x0csrBJwybX9DFhBhCLgAilIvzRVUriKHGlev0JtyuDvmsZUZlcIiCDnYu7KsZ0UmrBggRP7n1DqcDJEzciOgHwcwTyZEUmIKEMFVIqgyIjpZ4tjdTxqRCMPYVMBYDV6tavUZ8yczpkKwBxHsVWtaqo5tMgACH5BAAKAAMALAAAAAAgACAAAAb/QIBwSCQuBgNBcck0FgvIQtHRZCYUGSJ0IB2WDo9qUaBQKIXbLsBxOJTExUh5mB4iDo0zXEhWJNBRQgZtA3tPZQsAdQINBwxwAnpCC2VSdQNtVEQSEkOUChGSVwoLCwUFpm0QRAMVFBQTQxllCqh0kkIECF0TG68UG2O0foYJDb8VYVa0alUXrxoQf1WmZnsTFA0EhgCJhrFMC5Hjkd57W0jpDsPDuFUDHfHyHRzstNN78PPxHOLk5dwcpBuoaYk5OAfhXHG3hAy+KgLkgNozqwzDbgWYJQyXsUwGXKNA6fnYMIO3iPeIpBwyqlSCBKUqEQk5E6YRmX2UdAT5kEnHKkQ5hXjkNqTPtKAARl1sIrGoxSFNuSEFMNWoVCxEpiqyRlQY165wEHELAgAh+QQACgAEACwAAAAAIAAgAAAG/0CAcEgsKhSLonJJTBIFR0GxwFwmFJlnlAgaTKpFqEIqFJMBhcEABC5GjkPz0KN2tsvHBH4sJKgdd1NHSXILah9tAmdCC0dUcg5qVEQfiIxHEYtXSACKnWoGXAwHBwRDGUcKBXYFi0IJHmQEEKQHEGGpCnp3AiW1DKFWqZNgGKQNA65FCwV8bQQHJcRtds9MC4rZitVgCQbf4AYEubnKTAYU6eoUGuSpu3fo6+ka2NrbgQAE4eCmS9xVAOW7Yq7IgA4Hpi0R8EZBhDshOnTgcOtfM0cAlTigILFDiAFFNjk8k0GZgAxOBozouIHIOyKbFixIkECmIyIHOEiEWbPJTTQ5FxcVOMCgzUVCWwAcyZJvzy45ADYVZNIwTlIAVfNB7XRVDLxEWLQ4E9JsKq+rTdsMyhcEACH5BAAKAAUALAAAAAAgACAAAAb/QIBwSCwqFIuicklMEgVHQVHKVCYUmWeUWFAkqtOtEKqgAsgFcDFyHJLNmbZa6x2Lyd8595h8C48RagJmQgtHaX5XZUYKQ4YKEYSKfVKPaUMZHwMDeQBxh04ABYSFGU4JBpsDBmFHdXMLIKofBEyKCpdgspsOoUsLXaRLCQMgwky+YJ1FC4POg8lVAg7U1Q5drtnHSw4H3t8HDdnZy2Dd4N4Nzc/QeqLW1bnM7rXuV9tEBhQQ5UoCbJDmWKBAQcMDZNhwRVNCYANBChZYEbkVCZOwASEcCDFQ4SEDIq6WTVqQIMECBx06iCACQQPBiSabHDqzRUTKARMhSFCDrc+WNQIcOoRw5+ZIHj8ADqSEQBQAwKKLhIzowEEeGKQ0owIYkPKjHihZoBKi0KFE01b4zg7h4y4IACH5BAAKAAYALAAAAAAgACAAAAb/QIBwSCwqFIuicklMEgVHQVHKVCYUmWeUWFAkqtOtEKqgAsgFcDFyHJLNmbZa6x2Lyd8595h8C48RagJmQgtHaX5XZUUJeQCGChGEin1SkGlubEhDcYdOAAWEhRlOC12HYUd1eqeRokOKCphgrY5MpotqhgWfunqPt4PCg71gpgXIyWSqqq9MBQPR0tHMzM5L0NPSC8PCxVUCyeLX38+/AFfXRA4HA+pjmoFqCAcHDQa3rbxzBRD1BwgcMFIlidMrAxYICHHA4N8DIqpsUWJ3wAEBChQaEBnQoB6RRr0uARjQocMAAA0w4nMz4IOaU0lImkSngYKFc3ZWyTwJAALGK4fnNA3ZOaQCBQ22wPgRQlSIAYwSfkHJMrQkTyEbKFzFydQq15ccOAjUEwQAIfkEAAoABwAsAAAAACAAIAAABv9AgHBILCoUi6JySUwSBUdBUcpUJhSZZ5RYUCSq060QqqACyAVwMXIcks2ZtlrrHYvJ3zn3mHwLjxFqAmZCC0dpfldlRQl5AIYKEYSKfVKQaW5sSENxh04ABYSFGU4LXYdhR3V6p5GiQ4oKmGCtjkymi2qGBZ+6eo+3g8KDvYLDxKrJuXNkys6qr0zNygvHxL/V1sVD29K/AFfRRQUDDt1PmoFqHgPtBLetvMwG7QMes0KxkkIFIQNKDhBgKvCh3gQiqmxt6NDBAAEIEAgUOHCgBBEH9Yg06uWAIQUABihQMACgBEUHTRwoUEOBIcqQI880OIDgm5ABDA8IgUkSwAAyij1/jejAARPPIQwONBCnBAJDCEOOCnFA8cOvEh1CEJEqBMIBEDaLcA3LJIEGDe/0BAEAIfkEAAoACAAsAAAAACAAIAAABv9AgHBILCoUi6JySUwSBUdBUcpUJhSZZ5RYUCSq060QqqACyAVwMXIcks2ZtlrrHYvJ3zn3mHwLjxFqAmZCC0dpfldlRQl5AIYKEYSKfVKQaW5sSENxh04ABYSFGU4LXYdhR3V6p5GiQ4oKmGCtjkymi2qGBZ+6eo+3g8KDvYLDxKrJuXNkys6qr0zNygvHxL/V1sVDDti/BQccA8yrYBAjHR0jc53LRQYU6R0UBnO4RxmiG/IjJUIJFuoVKeCBigBN5QCk43BgFgMKFCYUGDAgFEUQRGIRYbCh2xACEDcAcHDgQDcQFGf9s7VkA0QCI0t2W0DRw68h8ChAEELSJE8xijBvVqCgIU9PjwA+UNzG5AHEB9xkDpk4QMGvARQsEDlKxMCALDeLcA0rqEEDlWCCAAAh+QQACgAJACwAAAAAIAAgAAAG/0CAcEgsKhSLonJJTBIFR0FRylQmFJlnlFhQJKrTrRCqoALIBXAxchySzZm2Wusdi8nfOfeYfAuPEWoCZkILR2l+V2VFCXkAhgoRhIp9UpBpbmxIQ3GHTgAFhIUZTgtdh2FHdXqnkaJDigqYYK2OTKaLaoYFn7p6j0wOA8PEAw6/Z4PKUhwdzs8dEL9kqqrN0M7SetTVCsLFw8d6C8vKvUQEv+dVCRAaBnNQtkwPFRQUFXOduUoTG/cUNkyYg+tIBlEMAFYYMAaBuCekxmhaJeSeBgiOHhw4QECAAwcCLhGJRUQCg3RDCmyUVmBYmlOiGqmBsPGlyz9YkAlxsJEhqCubABS9AsPgQAMqLQfM0oTMwEZ4QpLOwvMLxAEEXIBG5aczqtaut4YNXRIEACH5BAAKAAoALAAAAAAgACAAAAb/QIBwSCwqFIuicklMEgVHQVHKVCYUmWeUWFAkqtOtEKqgAsgFcDFyHJLNmbZa6x2Lyd8595h8C48RahAQRQtHaX5XZUUJeQAGHR0jA0SKfVKGCmlubEhCBSGRHSQOQwVmQwsZTgtdh0UQHKIHm2quChGophuiJHO3jkwOFB2UaoYFTnMGegDKRQQG0tMGBM1nAtnaABoU3t8UD81kR+UK3eDe4nrk5grR1NLWegva9s9czfhVAgMNpWqgBGNigMGBAwzmxBGjhACEgwcgzAPTqlwGXQ8gMgAhZIGHWm5WjelUZ8jBBgPMTBgwIMGCRgsygVSkgMiHByD7DWDmx5WuMkZqDLCU4gfAq2sACrAEWFSRLjUfWDopCqDTNQIsJ1LF0yzDAA90UHV5eo0qUjB8mgUBACH5BAAKAAsALAAAAAAgACAAAAb/QIBwSCwqFIuickk0FIiCo6A4ZSoZnRBUSiwoEtYipNOBDKOKKgD9DBNHHU4brc4c3cUBeSOk949geEQUZA5rXABHEW4PD0UOZBSHaQAJiEMJgQATFBQVBkQHZKACUwtHbX0RR0mVFp0UFwRCBSQDSgsZrQteqEUPGrAQmmG9ChFqRAkMsBd4xsRLBBsUoG6nBa14E4IA2kUFDuLjDql4peilAA0H7e4H1udH8/Ps7+3xbmj0qOTj5mEWpEP3DUq3glYWOBgAcEmUaNI+DBjwAY+dS0USGJg4wABEXMYyJNvE8UOGISKVCNClah4xjg60WUKyINOCUwrMzVRARMGENWQ4n/jpNTKTm15J/CTK2e0MoD+UKmHEs4onVDVVmyqdpAbNR4cKTjqNSots07EjzzJh1S0IADsAAAAAAAAAAAA="

/***/ },
/* 636 */
/***/ function(module, exports) {

	module.exports = "data:application/x-font-ttf;base64,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"

/***/ },
/* 637 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 638 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 639 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 640 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 641 */
640,
/* 642 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _timelineAnnotations = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _timelineAnnotations2 = _interopRequireDefault(_timelineAnnotations);
	
	var _timelineStories = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _timelineStories2 = _interopRequireDefault(_timelineStories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeline = _timelineStories2.default.concat(_timelineAnnotations2.default);
	
	exports.default = timeline;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.283805f2.js